export let sim_results = [
    678787,
    869679,
    968879,
    898888,
    977798,
    978879,
    789888,
    787887,
    998688,
    987887,
    887778,
    788968,
    877898,
    798778,
    876888,
    999988,
    788979,
    899879,
    889689,
    888677,
    977989,
    787787,
    779797,
    878786,
    877878,
    889987,
    976887,
    777777,
    688789,
    777788,
    967998,
    789798,
    788898,
    898797,
    888879,
    878987,
    887779,
    787877,
    789988,
    799767,
    888888,
    878889,
    897868,
    888897,
    679879,
    889687,
    788966,
    988897,
    778878,
    879877,
    898667,
    878898,
    779777,
    988777,
    787989,
    877797,
    786779,
    687787,
    888878,
    688787,
    897788,
    879888,
    898988,
    899888,
    887797,
    868786,
    898798,
    768978,
    787778,
    978787,
    878788,
    867898,
    777787,
    887878,
    778877,
    987788,
    887879,
    897876,
    988878,
    797997,
    888678,
    789787,
    789779,
    988788,
    888878,
    979989,
    888889,
    878879,
    888788,
    866688,
    678887,
    888777,
    888887,
    988689,
    989797,
    888879,
    968778,
    868897,
    898988,
    798797,
    777989,
    878998,
    868798,
    789888,
    898778,
    888777,
    879879,
    887979,
    768797,
    889878,
    977788,
    776898,
    679779,
    888776,
    887778,
    886887,
    687787,
    779688,
    888986,
    788787,
    878888,
    886868,
    989897,
    878878,
    887978,
    888899,
    988879,
    767796,
    789879,
    879867,
    778887,
    797889,
    887889,
    977788,
    997887,
    779898,
    868989,
    867688,
    786797,
    899888,
    789777,
    877988,
    887798,
    797987,
    997877,
    987776,
    878879,
    777999,
    897778,
    678987,
    877997,
    788877,
    878987,
    878978,
    788979,
    777997,
    888867,
    687879,
    877887,
    879898,
    777977,
    997889,
    998899,
    889887,
    777888,
    888777,
    779898,
    788877,
    978787,
    688797,
    777879,
    887998,
    889887,
    878888,
    977797,
    888887,
    989777,
    998887,
    988677,
    996777,
    878777,
    887778,
    768998,
    778877,
    998787,
    888889,
    767988,
    879878,
    789777,
    798888,
    778977,
    768877,
    996689,
    788777,
    978787,
    697887,
    799668,
    768887,
    788778,
    888876,
    886878,
    888987,
    989988,
    888888,
    878876,
    786988,
    778799,
    888887,
    897778,
    778898,
    787879,
    979888,
    996886,
    887988,
    967868,
    988888,
    798889,
    776999,
    678777,
    797887,
    678798,
    668777,
    876886,
    787989,
    788987,
    989987,
    989877,
    788988,
    688788,
    998899,
    779879,
    878877,
    798987,
    878899,
    887677,
    968896,
    789978,
    877788,
    888888,
    887677,
    768767,
    887796,
    688988,
    888978,
    977888,
    788779,
    988889,
    869787,
    786887,
    798899,
    966889,
    696988,
    878788,
    888879,
    788878,
    979787,
    889976,
    867887,
    787689,
    888788,
    778899,
    968788,
    789787,
    799699,
    779989,
    988778,
    878888,
    776889,
    797798,
    798899,
    798887,
    998988,
    789779,
    866786,
    877779,
    999877,
    787887,
    998798,
    897689,
    998777,
    888767,
    768868,
    999789,
    788989,
    877777,
    878888,
    868888,
    898898,
    887777,
    979889,
    887878,
    898778,
    899877,
    788798,
    797796,
    787878,
    789779,
    797766,
    788878,
    787787,
    879779,
    788798,
    789988,
    979898,
    678687,
    788788,
    777877,
    698789,
    788778,
    777678,
    887887,
    778878,
    778887,
    787678,
    778789,
    878788,
    969887,
    788877,
    978789,
    678887,
    788887,
    998778,
    889788,
    767786,
    987799,
    878978,
    898898,
    979787,
    978978,
    798887,
    778877,
    777988,
    777798,
    778767,
    867977,
    997998,
    966878,
    668898,
    789987,
    898887,
    878977,
    997889,
    688889,
    777889,
    789779,
    887888,
    988798,
    769999,
    878789,
    688987,
    886778,
    788789,
    788988,
    888978,
    978787,
    777689,
    978788,
    768787,
    878888,
    978888,
    687768,
    797797,
    897798,
    978888,
    887899,
    787777,
    788799,
    978988,
    777887,
    888966,
    887888,
    777887,
    987796,
    899887,
    878997,
    777786,
    778897,
    877778,
    678797,
    978788,
    788877,
    787697,
    778889,
    879678,
    778977,
    787778,
    798887,
    968988,
    788989,
    898887,
    887997,
    976987,
    898897,
    788868,
    888889,
    866997,
    798888,
    698969,
    789889,
    778778,
    797987,
    998878,
    788889,
    888879,
    798868,
    787897,
    889788,
    877878,
    877779,
    978978,
    788878,
    998889,
    899888,
    878887,
    887997,
    888899,
    787888,
    899988,
    878897,
    998988,
    889987,
    989977,
    989788,
    877877,
    888789,
    697988,
    888788,
    998988,
    877877,
    887789,
    878887,
    987889,
    788888,
    797997,
    979688,
    786777,
    777988,
    788889,
    788978,
    776677,
    887769,
    777998,
    877787,
    888888,
    777887,
    867899,
    876777,
    898777,
    687799,
    787968,
    986898,
    877798,
    696988,
    798987,
    779788,
    798989,
    897897,
    688688,
    789788,
    869888,
    878887,
    898878,
    778887,
    798777,
    889887,
    889896,
    776887,
    877898,
    777778,
    887787,
    988887,
    987977,
    887888,
    767897,
    788888,
    878989,
    888788,
    687798,
    878868,
    777879,
    788987,
    788797,
    796787,
    797888,
    669769,
    789777,
    877779,
    988889,
    967796,
    787787,
    978888,
    887787,
    977988,
    679887,
    788887,
    888778,
    767877,
    986688,
    777778,
    778898,
    997788,
    799778,
    997788,
    777899,
    776788,
    768876,
    879898,
    979769,
    888898,
    799878,
    788889,
    898889,
    678779,
    897898,
    798779,
    889989,
    889896,
    877799,
    987979,
    888988,
    879877,
    986987,
    796869,
    879868,
    888987,
    877888,
    788987,
    899876,
    679989,
    788889,
    879878,
    777688,
    799887,
    979898,
    878999,
    789788,
    877899,
    879878,
    799778,
    888788,
    799677,
    697888,
    788688,
    989897,
    888978,
    888788,
    878967,
    799988,
    786878,
    678876,
    779788,
    899998,
    898878,
    789989,
    788877,
    989778,
    797877,
    767978,
    979888,
    888678,
    888688,
    976998,
    968798,
    999868,
    778787,
    889777,
    788788,
    798789,
    878898,
    898887,
    888796,
    978797,
    868888,
    897788,
    877878,
    788777,
    777986,
    778767,
    678788,
    989987,
    788788,
    778889,
    878898,
    997787,
    888789,
    999977,
    787988,
    986988,
    878888,
    778868,
    899677,
    898778,
    888888,
    786888,
    889886,
    688996,
    888889,
    778778,
    897898,
    777786,
    888687,
    669798,
    797977,
    787878,
    788978,
    799776,
    796787,
    877668,
    788998,
    687788,
    799979,
    889968,
    897888,
    879887,
    868888,
    876888,
    879889,
    967788,
    797887,
    899868,
    988787,
    787997,
    779997,
    978889,
    898888,
    888798,
    966788,
    886779,
    797878,
    986786,
    798886,
    779899,
    778868,
    789896,
    977889,
    678797,
    677897,
    887768,
    788887,
    988978,
    889969,
    777969,
    978777,
    669788,
    987888,
    798888,
    769987,
    968988,
    788988,
    778788,
    789988,
    877879,
    788889,
    778868,
    799787,
    899787,
    689886,
    886897,
    787789,
    979878,
    889889,
    989788,
    888778,
    677778,
    767787,
    999977,
    777967,
    777789,
    777889,
    788798,
    886786,
    767887,
    778779,
    897769,
    989997,
    787877,
    877688,
    896789,
    889779,
    899886,
    788877,
    887969,
    777798,
    888888,
    788778,
    877879,
    888688,
    878688,
    877778,
    988776,
    869897,
    787988,
    789998,
    799877,
    988688,
    987788,
    879788,
    879866,
    877788,
    767779,
    886998,
    787987,
    776777,
    888898,
    777887,
    889868,
    887777,
    777997,
    776897,
    878877,
    898977,
    898896,
    878887,
    798987,
    987766,
    798879,
    777877,
    978966,
    988978,
    778889,
    879997,
    988688,
    888998,
    768888,
    678886,
    788878,
    877879,
    778877,
    677787,
    788887,
    968798,
    788687,
    877978,
    789798,
    967888,
    887878,
    869887,
    779977,
    788968,
    897779,
    988997,
    878778,
    788978,
    887979,
    988787,
    799888,
    778978,
    898879,
    877887,
    788998,
    788966,
    988797,
    869779,
    777887,
    886878,
    888779,
    878977,
    788677,
    878988,
    989787,
    887786,
    898879,
    998868,
    778788,
    878789,
    889877,
    779777,
    889777,
    877976,
    977779,
    888877,
    698779,
    788887,
    878697,
    886878,
    888798,
    787999,
    778779,
    778977,
    888797,
    898677,
    968888,
    777897,
    887897,
    888877,
    688879,
    999868,
    887788,
    797878,
    787897,
    689896,
    888897,
    989998,
    988876,
    987687,
    777888,
    988867,
    967876,
    779998,
    779877,
    798767,
    687887,
    789789,
    997998,
    997978,
    876787,
    778878,
    788888,
    898769,
    688899,
    889898,
    797776,
    777889,
    777676,
    878868,
    769978,
    778897,
    868878,
    988997,
    977887,
    787898,
    879878,
    877978,
    878899,
    887799,
    788677,
    888778,
    998899,
    988888,
    989888,
    998889,
    888989,
    787889,
    989877,
    777778,
    788768,
    878798,
    987889,
    887886,
    879988,
    889787,
    768878,
    778886,
    787887,
    788879,
    977898,
    686687,
    967977,
    786787,
    877768,
    788988,
    986888,
    987987,
    988978,
    978868,
    698889,
    799777,
    788897,
    778777,
    888897,
    789697,
    878887,
    868889,
    887879,
    679867,
    796889,
    787999,
    888889,
    788677,
    977797,
    798987,
    768888,
    678889,
    677888,
    667799,
    977968,
    678878,
    887777,
    899987,
    887887,
    879978,
    778989,
    898897,
    797888,
    897978,
    777898,
    768787,
    978898,
    997888,
    888977,
    879867,
    876787,
    978988,
    779878,
    778798,
    777688,
    788787,
    977887,
    997788,
    779889,
    897988,
    876867,
    876788,
    797899,
    789887,
    779778,
    788878,
    788888,
    867888,
    987899,
    978878,
    989698,
    788898,
    876799,
    987878,
    787888,
    898787,
    888978,
    877998,
    887867,
    886967,
    986787,
    988877,
    979776,
    898878,
    989988,
    898989,
    886889,
    988887,
    786787,
    877988,
    889888,
    887788,
    987677,
    778896,
    788788,
    897778,
    697988,
    886897,
    977977,
    997887,
    777897,
    798797,
    797879,
    888778,
    866877,
    787988,
    787769,
    768787,
    687988,
    789889,
    787789,
    888778,
    778787,
    879897,
    978787,
    899888,
    888779,
    687777,
    889688,
    897777,
    798787,
    978898,
    877778,
    888898,
    888798,
    888969,
    767798,
    688778,
    798787,
    797688,
    988899,
    788798,
    788988,
    879878,
    888899,
    878788,
    797978,
    979798,
    888897,
    988798,
    978888,
    977899,
    978798,
    767897,
    788797,
    876878,
    878879,
    869877,
    877777,
    997899,
    897888,
    787698,
    988888,
    978988,
    967988,
    868867,
    687887,
    967889,
    798889,
    787867,
    778888,
    988987,
    787886,
    899888,
    769898,
    888689,
    868977,
    877777,
    789887,
    988778,
    989788,
    978798,
    897778,
    789988,
    788989,
    788887,
    878878,
    987886,
    867766,
    687877,
    788778,
    877879,
    978898,
    887879,
    968799,
    689988,
    887797,
    897778,
    887778,
    976886,
    779887,
    888789,
    888878,
    788998,
    888799,
    776888,
    887898,
    786679,
    888777,
    787987,
    779869,
    988788,
    799868,
    788897,
    779886,
    778797,
    796877,
    689789,
    986789,
    777777,
    898897,
    899887,
    898979,
    978977,
    779777,
    778798,
    878886,
    997786,
    888888,
    778978,
    778887,
    887777,
    777779,
    778787,
    879888,
    989979,
    688978,
    998788,
    788866,
    978878,
    888878,
    779878,
    887678,
    887776,
    689888,
    897768,
    869978,
    887898,
    787888,
    868878,
    798979,
    778887,
    888877,
    898778,
    788787,
    768999,
    787787,
    978898,
    887779,
    979798,
    987888,
    778878,
    778888,
    669879,
    789788,
    888789,
    786899,
    798977,
    787798,
    978778,
    888987,
    878898,
    698879,
    779778,
    878778,
    888986,
    877987,
    998898,
    798888,
    988788,
    899777,
    888998,
    898788,
    888778,
    688878,
    887778,
    898788,
    878689,
    697868,
    978897,
    889978,
    878697,
    787787,
    778879,
    767878,
    787888,
    688897,
    878779,
    778889,
    868687,
    887788,
    868878,
    978799,
    678987,
    888898,
    878878,
    886999,
    697777,
    797889,
    878798,
    888896,
    978767,
    698789,
    888887,
    868767,
    868888,
    768878,
    786898,
    877697,
    889888,
    887788,
    786988,
    678897,
    896878,
    889869,
    878798,
    679688,
    777677,
    897989,
    787798,
    888878,
    888787,
    897978,
    997897,
    678788,
    897998,
    788886,
    788777,
    886899,
    799889,
    779787,
    987798,
    878788,
    788777,
    878779,
    688778,
    886887,
    887787,
    888779,
    878898,
    898889,
    877788,
    778968,
    979788,
    897887,
    887779,
    877779,
    887777,
    778978,
    887878,
    779877,
    887798,
    888788,
    799887,
    978977,
    888886,
    789768,
    889978,
    999867,
    878876,
    988886,
    788877,
    889789,
    988988,
    777868,
    869877,
    788789,
    787776,
    777988,
    797979,
    678997,
    788797,
    778878,
    887989,
    888796,
    888987,
    969889,
    889878,
    868878,
    787887,
    788886,
    668678,
    889879,
    888777,
    779887,
    677789,
    898779,
    778697,
    888898,
    887887,
    996776,
    887899,
    898878,
    877888,
    888699,
    987877,
    799988,
    978666,
    778787,
    876778,
    887889,
    878777,
    878978,
    879988,
    697886,
    697776,
    787868,
    776878,
    797899,
    789888,
    777866,
    777797,
    878976,
    779979,
    889867,
    777788,
    897969,
    789768,
    887878,
    787878,
    997688,
    787879,
    887779,
    897877,
    878987,
    788877,
    896777,
    877778,
    988768,
    978777,
    888898,
    887988,
    888797,
    977788,
    887878,
    868798,
    886977,
    777987,
    987997,
    877889,
    878889,
    998988,
    778797,
    879787,
    887988,
    789778,
    789898,
    977897,
    887978,
    978977,
    787767,
    889877,
    778789,
    766778,
    799788,
    788978,
    977878,
    989777,
    879777,
    898889,
    786899,
    899798,
    887779,
    877987,
    888888,
    888989,
    768797,
    887887,
    997897,
    879978,
    788679,
    986867,
    879688,
    988778,
    897977,
    789977,
    787997,
    777778,
    887877,
    777887,
    888997,
    988898,
    989889,
    898888,
    798878,
    978878,
    889778,
    797797,
    779787,
    877767,
    797788,
    787967,
    878869,
    778979,
    778868,
    787887,
    797876,
    877798,
    877797,
    886888,
    988797,
    788898,
    798877,
    887789,
    878897,
    778778,
    787889,
    879877,
    899788,
    887779,
    698977,
    778997,
    898788,
    687997,
    987867,
    888989,
    877876,
    997697,
    798968,
    788877,
    687889,
    689978,
    887688,
    698788,
    887877,
    778789,
    887879,
    887877,
    687798,
    687788,
    888787,
    787897,
    888878,
    788787,
    878687,
    999878,
    786978,
    888878,
    988898,
    788679,
    788886,
    978997,
    677788,
    979997,
    877777,
    987887,
    788869,
    789867,
    987678,
    797889,
    897988,
    897888,
    798887,
    787967,
    997888,
    988898,
    888877,
    778796,
    789797,
    887868,
    989988,
    889788,
    688887,
    768888,
    787877,
    997877,
    688677,
    887888,
    788888,
    889889,
    988987,
    876877,
    978788,
    878887,
    979887,
    779788,
    777889,
    688788,
    798888,
    877788,
    897899,
    798788,
    778886,
    868778,
    787779,
    777888,
    888797,
    989688,
    778877,
    787888,
    977798,
    878779,
    779968,
    877887,
    788778,
    798798,
    878897,
    769877,
    889998,
    888787,
    987868,
    977778,
    878769,
    987879,
    879996,
    788877,
    697977,
    977787,
    679888,
    687777,
    876987,
    887887,
    887888,
    897877,
    878777,
    878988,
    778788,
    798798,
    988667,
    787887,
    886978,
    869989,
    988696,
    886786,
    778888,
    688888,
    778967,
    978887,
    978978,
    887777,
    899889,
    999988,
    789988,
    888888,
    777788,
    778777,
    878977,
    977877,
    997788,
    778898,
    788977,
    797988,
    887888,
    998786,
    899679,
    898886,
    887786,
    978788,
    889898,
    776888,
    698788,
    887867,
    778778,
    877779,
    999778,
    978888,
    898888,
    778798,
    878898,
    897698,
    798788,
    989898,
    887898,
    886777,
    878787,
    998788,
    877888,
    689778,
    878798,
    899889,
    988987,
    679788,
    888776,
    698887,
    778798,
    888787,
    988888,
    789999,
    688899,
    869888,
    888897,
    889877,
    779779,
    888888,
    887978,
    887878,
    988898,
    689777,
    787887,
    789989,
    897888,
    887889,
    977887,
    888877,
    697688,
    799877,
    897979,
    868976,
    896877,
    879877,
    887898,
    878687,
    898779,
    888987,
    878787,
    887989,
    687778,
    787668,
    998879,
    986888,
    978797,
    678788,
    887899,
    767989,
    866788,
    787867,
    788778,
    899987,
    786898,
    898998,
    887988,
    887797,
    787799,
    878968,
    876878,
    778987,
    678988,
    878777,
    878998,
    886878,
    899776,
    888788,
    889888,
    788788,
    898989,
    979977,
    876899,
    888999,
    987778,
    889877,
    887889,
    687889,
    768896,
    888887,
    879987,
    778887,
    988888,
    997868,
    878777,
    777998,
    978879,
    879778,
    898777,
    778776,
    988777,
    899788,
    878889,
    798789,
    788877,
    897878,
    876878,
    878887,
    768888,
    979687,
    688679,
    888888,
    779868,
    889788,
    888679,
    887888,
    888787,
    877978,
    788878,
    879878,
    779777,
    777996,
    878888,
    868779,
    678799,
    776888,
    978878,
    988778,
    787879,
    877889,
    987987,
    999969,
    778798,
    889787,
    788878,
    787898,
    877997,
    887987,
    789798,
    889878,
    998788,
    776777,
    799877,
    787797,
    678777,
    866778,
    879798,
    889779,
    878887,
    888687,
    786897,
    786868,
    788977,
    988786,
    777899,
    778887,
    799897,
    888777,
    978868,
    877896,
    898788,
    868867,
    868888,
    888988,
    878988,
    898899,
    799698,
    879778,
    878867,
    778977,
    688978,
    888988,
    778679,
    878887,
    877978,
    889698,
    889886,
    988788,
    887786,
    987899,
    987768,
    878877,
    788778,
    769697,
    897877,
    887777,
    877888,
    788968,
    876877,
    777897,
    899788,
    889768,
    787898,
    898888,
    698777,
    897778,
    678788,
    977987,
    688788,
    778798,
    878788,
    988879,
    977878,
    788998,
    796887,
    888888,
    679889,
    988799,
    899888,
    978879,
    678889,
    778887,
    767897,
    778778,
    978798,
    879998,
    897787,
    886887,
    887878,
    888676,
    977897,
    889768,
    886887,
    687877,
    988879,
    888888,
    898898,
    789879,
    889779,
    877888,
    978776,
    699879,
    979676,
    977789,
    689789,
    878898,
    997989,
    977997,
    877897,
    887987,
    788978,
    697878,
    979876,
    778798,
    688889,
    878879,
    879876,
    777888,
    878898,
    698788,
    888788,
    897989,
    886889,
    878898,
    778977,
    887778,
    878787,
    878888,
    888689,
    798968,
    777797,
    888998,
    787986,
    888878,
    978767,
    788787,
    878798,
    678879,
    897787,
    788989,
    896777,
    878967,
    889899,
    898899,
    887877,
    889868,
    786778,
    989888,
    798988,
    988887,
    899966,
    779888,
    979989,
    879878,
    877777,
    878897,
    787989,
    778687,
    979877,
    789688,
    788989,
    778986,
    888998,
    878889,
    889778,
    778888,
    888988,
    787879,
    779988,
    968778,
    779887,
    778887,
    878887,
    787977,
    898889,
    768887,
    897889,
    688899,
    786798,
    788888,
    879888,
    888997,
    877876,
    889889,
    889689,
    778768,
    677899,
    887878,
    788878,
    797878,
    769778,
    988797,
    897887,
    887797,
    788789,
    888887,
    988879,
    878788,
    898777,
    878689,
    877978,
    968788,
    777897,
    887787,
    888998,
    787888,
    887887,
    998788,
    687788,
    777878,
    797788,
    778788,
    799876,
    778789,
    787788,
    778887,
    777878,
    899989,
    787897,
    979778,
    777778,
    898988,
    988667,
    967988,
    999889,
    777878,
    877797,
    897677,
    799888,
    667887,
    979888,
    697999,
    888878,
    877897,
    877968,
    878888,
    776798,
    886887,
    797879,
    979889,
    677689,
    868797,
    888787,
    788789,
    869888,
    789978,
    767789,
    887778,
    797788,
    886977,
    887787,
    888769,
    678879,
    879989,
    887877,
    876996,
    988888,
    887887,
    778689,
    788887,
    878977,
    697877,
    898678,
    979779,
    888897,
    978878,
    687878,
    777997,
    777987,
    888889,
    978898,
    787878,
    688988,
    777888,
    898877,
    889899,
    968789,
    898878,
    988868,
    867878,
    877676,
    998877,
    767878,
    877888,
    869778,
    898879,
    888968,
    898977,
    888987,
    786698,
    688688,
    978877,
    688888,
    877997,
    788697,
    878688,
    878778,
    987988,
    679788,
    969768,
    888877,
    879988,
    988788,
    788787,
    999898,
    687897,
    878788,
    799877,
    688968,
    988888,
    877788,
    778798,
    798976,
    698887,
    798898,
    876797,
    877777,
    897787,
    788768,
    897989,
    689897,
    878778,
    688798,
    888878,
    788879,
    797778,
    878878,
    799999,
    798879,
    899768,
    889878,
    888989,
    877979,
    677888,
    778888,
    778989,
    888897,
    898977,
    888887,
    788777,
    976787,
    989787,
    789788,
    899689,
    888969,
    888887,
    797978,
    777778,
    777877,
    787989,
    887878,
    977879,
    878777,
    979888,
    879877,
    779899,
    687796,
    998888,
    878888,
    888797,
    878777,
    998987,
    897779,
    797778,
    887888,
    898887,
    888987,
    787788,
    889989,
    678997,
    897788,
    798998,
    897778,
    986877,
    686789,
    889778,
    988787,
    799879,
    968767,
    968897,
    878989,
    886788,
    989979,
    989788,
    788879,
    877788,
    889889,
    798888,
    787778,
    867877,
    967788,
    998987,
    898786,
    878888,
    897778,
    887879,
    888888,
    887869,
    889988,
    768987,
    787987,
    887877,
    878878,
    778887,
    979697,
    886789,
    898768,
    787876,
    879878,
    897888,
    797889,
    877898,
    866778,
    978889,
    688898,
    889987,
    788796,
    898978,
    788877,
    879887,
    988888,
    778987,
    889887,
    899889,
    689888,
    787778,
    888887,
    898786,
    977787,
    887966,
    978768,
    779978,
    988789,
    879977,
    778888,
    878888,
    787999,
    788887,
    979787,
    887678,
    889899,
    879789,
    798888,
    768888,
    779877,
    778776,
    878898,
    977688,
    997997,
    877988,
    778887,
    797888,
    978797,
    877878,
    887877,
    888678,
    768886,
    789887,
    787777,
    979987,
    978788,
    887999,
    777978,
    797986,
    897988,
    678997,
    888787,
    786798,
    887977,
    876796,
    698777,
    888897,
    988986,
    777787,
    886896,
    768967,
    669787,
    896887,
    988889,
    897769,
    879888,
    878898,
    788879,
    988797,
    988898,
    787899,
    788878,
    989978,
    878778,
    778887,
    778987,
    977899,
    888867,
    878898,
    697888,
    789889,
    787887,
    997879,
    777778,
    987686,
    979678,
    898877,
    969789,
    788787,
    878687,
    787797,
    898778,
    678779,
    899788,
    867987,
    788797,
    878888,
    878896,
    979787,
    788869,
    777889,
    878898,
    978777,
    787888,
    968889,
    889978,
    887798,
    769798,
    987878,
    977897,
    887798,
    888778,
    987899,
    887987,
    778778,
    777798,
    967897,
    886798,
    887799,
    878779,
    988899,
    876878,
    788778,
    887779,
    778998,
    886878,
    998797,
    979789,
    778978,
    889996,
    798788,
    898989,
    977777,
    787886,
    789889,
    767788,
    877786,
    898889,
    779779,
    888789,
    798887,
    768977,
    699777,
    788878,
    878987,
    667867,
    797887,
    986877,
    978799,
    888788,
    777898,
    897866,
    778777,
    799878,
    888888,
    888988,
    778789,
    889977,
    878788,
    878898,
    889769,
    888899,
    878869,
    779786,
    897889,
    878976,
    969878,
    776967,
    778779,
    786877,
    778886,
    788988,
    787878,
    797977,
    979898,
    789877,
    887787,
    877898,
    886888,
    867977,
    788897,
    689887,
    777898,
    787789,
    987897,
    888798,
    798888,
    899797,
    888878,
    878988,
    896778,
    878987,
    888777,
    886888,
    877888,
    878997,
    789987,
    899897,
    789978,
    978877,
    877977,
    879888,
    799889,
    999889,
    888879,
    879888,
    987897,
    778888,
    789977,
    789877,
    897877,
    877797,
    877869,
    898798,
    689988,
    878689,
    968888,
    888887,
    778878,
    989788,
    687799,
    899678,
    869878,
    766789,
    899799,
    888786,
    799788,
    898887,
    889898,
    877888,
    879986,
    897877,
    778797,
    876997,
    776787,
    869797,
    778788,
    799868,
    876888,
    977987,
    976877,
    667687,
    988798,
    787888,
    998899,
    987878,
    879787,
    798888,
    677997,
    796789,
    887788,
    878877,
    997977,
    778789,
    888889,
    998977,
    879688,
    978789,
    889998,
    778687,
    788876,
    889898,
    888778,
    978766,
    888888,
    696879,
    887888,
    766778,
    777888,
    889797,
    879778,
    987877,
    989788,
    787788,
    888678,
    888698,
    687779,
    977888,
    798977,
    877897,
    888779,
    778987,
    789778,
    877889,
    698888,
    867896,
    868887,
    677877,
    798887,
    897877,
    897889,
    878688,
    777787,
    787897,
    788788,
    798677,
    797998,
    777788,
    878776,
    896768,
    897777,
    998778,
    876697,
    788778,
    789789,
    789879,
    777887,
    697778,
    999878,
    687998,
    877798,
    888996,
    899868,
    899898,
    677888,
    879976,
    779678,
    678968,
    977989,
    778888,
    898778,
    786779,
    776787,
    998787,
    886878,
    877889,
    777978,
    979788,
    888778,
    878797,
    868888,
    877768,
    877978,
    978777,
    788787,
    778877,
    887989,
    887788,
    897768,
    878887,
    897887,
    776897,
    866897,
    887869,
    979898,
    887788,
    889878,
    878786,
    887878,
    879997,
    877798,
    878687,
    878888,
    986787,
    786788,
    878776,
    896978,
    889887,
    889799,
    887869,
    797788,
    787988,
    787989,
    889878,
    669788,
    687996,
    698878,
    787899,
    888888,
    978867,
    887687,
    978898,
    868987,
    778888,
    888787,
    777788,
    899879,
    968677,
    878777,
    777787,
    888887,
    997979,
    998767,
    788879,
    786887,
    878987,
    677779,
    789788,
    789796,
    997889,
    766869,
    878888,
    798787,
    779878,
    988887,
    878888,
    897979,
    888886,
    777888,
    788678,
    789688,
    886889,
    888887,
    897898,
    679989,
    786988,
    769788,
    878798,
    779888,
    998778,
    767977,
    877889,
    878888,
    667877,
    778788,
    888686,
    987867,
    978987,
    878677,
    768978,
    887886,
    778978,
    867989,
    888687,
    776799,
    788767,
    977977,
    886888,
    788788,
    988988,
    898767,
    889778,
    868878,
    787868,
    786879,
    688888,
    779689,
    669788,
    889877,
    889768,
    887768,
    987869,
    778877,
    877877,
    987797,
    778977,
    897779,
    799778,
    779668,
    968898,
    678989,
    896778,
    698777,
    869878,
    898778,
    898788,
    778687,
    977887,
    787877,
    889868,
    878989,
    868877,
    878987,
    886768,
    998898,
    787879,
    866868,
    878777,
    887787,
    899687,
    879878,
    878689,
    877798,
    897889,
    898778,
    799997,
    888779,
    897887,
    899887,
    898887,
    867987,
    799788,
    777988,
    888779,
    888777,
    887978,
    897979,
    797889,
    788898,
    799788,
    878787,
    977888,
    688987,
    779679,
    889988,
    887978,
    977777,
    888878,
    777798,
    876677,
    787967,
    888788,
    899788,
    887877,
    888886,
    868887,
    767897,
    897998,
    888899,
    987887,
    777978,
    788678,
    877988,
    788878,
    889789,
    688788,
    998789,
    889778,
    889878,
    888877,
    986778,
    898987,
    987879,
    876997,
    877997,
    777768,
    967889,
    877879,
    677779,
    878898,
    887887,
    887879,
    687969,
    678988,
    887898,
    888988,
    788889,
    686878,
    987978,
    888779,
    898677,
    877879,
    798777,
    788989,
    889968,
    877888,
    888789,
    887987,
    777888,
    888788,
    898887,
    878889,
    678988,
    876988,
    797878,
    879878,
    887889,
    788779,
    667898,
    888777,
    787988,
    888677,
    798899,
    787777,
    878897,
    988888,
    987777,
    778788,
    886798,
    987898,
    689797,
    887898,
    787889,
    699788,
    976888,
    887888,
    999988,
    896879,
    788997,
    788788,
    987688,
    687769,
    787888,
    678779,
    877878,
    987876,
    798977,
    878877,
    777886,
    997889,
    686876,
    868889,
    887887,
    796778,
    788868,
    787688,
    997779,
    798878,
    889777,
    888787,
    979788,
    888888,
    789878,
    898878,
    867778,
    897787,
    767889,
    887778,
    888889,
    978889,
    988878,
    878797,
    877788,
    797687,
    877888,
    897888,
    877777,
    887888,
    978777,
    978989,
    896787,
    889868,
    887778,
    878879,
    788896,
    997888,
    777877,
    778887,
    978669,
    786687,
    888888,
    888798,
    798997,
    878878,
    877887,
    798989,
    887788,
    987969,
    788878,
    887798,
    886887,
    776787,
    797887,
    887797,
    968888,
    767989,
    797678,
    877797,
    899998,
    876778,
    787778,
    878877,
    778979,
    888887,
    787779,
    788998,
    897887,
    777889,
    788789,
    999976,
    778888,
    966889,
    678988,
    778987,
    887988,
    799787,
    877877,
    799879,
    877879,
    976888,
    986767,
    898987,
    889887,
    788897,
    998798,
    988868,
    878878,
    888898,
    689898,
    868888,
    779887,
    788888,
    676886,
    887998,
    997879,
    787877,
    878897,
    889867,
    877977,
    787787,
    869697,
    677878,
    887888,
    896878,
    976898,
    887876,
    878879,
    877786,
    877988,
    877777,
    997797,
    789779,
    987899,
    878898,
    778787,
    986867,
    878978,
    888789,
    786788,
    787897,
    968778,
    988897,
    778887,
    789687,
    878888,
    998887,
    878778,
    897876,
    888788,
    799896,
    778987,
    877778,
    788889,
    978888,
    988878,
    787899,
    979797,
    888868,
    888897,
    978877,
    788797,
    867996,
    897879,
    898869,
    899887,
    778688,
    887788,
    887788,
    987868,
    967979,
    788787,
    688788,
    897788,
    887897,
    689769,
    878989,
    887877,
    777788,
    878879,
    988687,
    787898,
    898898,
    867988,
    787879,
    897887,
    988887,
    788888,
    986877,
    888697,
    987998,
    977978,
    789789,
    799797,
    878678,
    778866,
    777779,
    988768,
    989767,
    787879,
    969888,
    897788,
    888967,
    899877,
    897687,
    897977,
    776978,
    976888,
    788788,
    777888,
    988999,
    966877,
    878889,
    877697,
    789786,
    868978,
    887688,
    787799,
    778797,
    878787,
    888887,
    697788,
    877889,
    889888,
    878988,
    979878,
    788799,
    788876,
    889798,
    888878,
    888797,
    877886,
    887788,
    887788,
    877977,
    788878,
    777977,
    979787,
    889988,
    977779,
    788798,
    887697,
    888898,
    778967,
    987877,
    786988,
    888977,
    787779,
    889888,
    899879,
    886888,
    798897,
    777968,
    779976,
    898689,
    788887,
    876877,
    867898,
    696897,
    899779,
    799998,
    896888,
    888888,
    887798,
    878886,
    789778,
    987889,
    986879,
    689887,
    677769,
    899977,
    787798,
    999789,
    778899,
    998888,
    878988,
    987869,
    887866,
    888777,
    979878,
    797888,
    878979,
    787888,
    987677,
    898988,
    887876,
    787977,
    766968,
    688888,
    876787,
    887888,
    877988,
    789889,
    868887,
    887876,
    788887,
    787998,
    679779,
    997878,
    879787,
    876977,
    879869,
    778977,
    869887,
    878678,
    666987,
    887798,
    787899,
    798878,
    788999,
    777688,
    896987,
    868978,
    789898,
    889889,
    788888,
    878987,
    887888,
    877876,
    678899,
    767787,
    889887,
    697887,
    998779,
    977777,
    877888,
    888889,
    899879,
    776789,
    878887,
    879798,
    787987,
    788788,
    799998,
    887877,
    887897,
    887867,
    798978,
    898887,
    788788,
    889978,
    877988,
    987878,
    888888,
    878877,
    968797,
    788977,
    777877,
    678879,
    989888,
    787987,
    889998,
    898787,
    877887,
    979868,
    799879,
    977878,
    786788,
    888878,
    898887,
    899797,
    779877,
    897879,
    898767,
    788789,
    797887,
    888988,
    796969,
    987999,
    777897,
    767779,
    769878,
    998867,
    778887,
    678699,
    797799,
    788898,
    787888,
    789877,
    788888,
    879887,
    799886,
    978887,
    798789,
    889986,
    887867,
    878788,
    877669,
    987886,
    778788,
    778887,
    979878,
    988769,
    787886,
    878968,
    979768,
    989786,
    788787,
    877787,
    899798,
    888997,
    899986,
    987978,
    767888,
    769888,
    799988,
    878899,
    977888,
    997879,
    687898,
    788887,
    678777,
    898878,
    769798,
    999768,
    877977,
    789789,
    887798,
    888688,
    687878,
    879988,
    789789,
    788779,
    888998,
    897889,
    866798,
    797777,
    979977,
    887887,
    789777,
    787887,
    677899,
    977787,
    998899,
    789878,
    777877,
    888887,
    779779,
    789977,
    889789,
    878788,
    779887,
    888997,
    787897,
    977877,
    778889,
    878796,
    887778,
    888897,
    889889,
    887788,
    886879,
    878779,
    988677,
    897777,
    888987,
    779878,
    787679,
    798797,
    878899,
    879778,
    889888,
    888888,
    676997,
    898876,
    978879,
    977889,
    978887,
    898778,
    898776,
    889878,
    788898,
    776788,
    877887,
    788898,
    867798,
    778878,
    788879,
    788988,
    777777,
    778879,
    877977,
    889789,
    988688,
    979877,
    687977,
    787989,
    779788,
    997888,
    677778,
    688989,
    888788,
    768768,
    787677,
    998679,
    689989,
    889877,
    887777,
    868978,
    788688,
    879888,
    878777,
    887776,
    788778,
    877788,
    779888,
    796797,
    889787,
    977887,
    867998,
    798898,
    989977,
    967977,
    887789,
    776796,
    988787,
    868986,
    797978,
    889889,
    878888,
    888998,
    978787,
    878887,
    977887,
    867788,
    798777,
    876699,
    887876,
    788888,
    877878,
    887888,
    897889,
    768888,
    888899,
    997878,
    876988,
    777876,
    978898,
    778887,
    789786,
    878887,
    888898,
    677998,
    898669,
    887789,
    978699,
    888689,
    868887,
    876889,
    877887,
    779887,
    799777,
    988788,
    899988,
    868767,
    988788,
    779888,
    978877,
    898968,
    898777,
    788667,
    877878,
    787887,
    786879,
    888976,
    888797,
    987878,
    988877,
    777887,
    786899,
    798778,
    789887,
    988788,
    889967,
    977886,
    867896,
    777878,
    878787,
    899868,
    778879,
    987878,
    999978,
    876787,
    877978,
    779768,
    787879,
    889787,
    887789,
    889788,
    667898,
    989896,
    797898,
    987777,
    868978,
    878888,
    888777,
    787677,
    879977,
    878797,
    878677,
    868876,
    898687,
    787887,
    987776,
    779768,
    887878,
    897787,
    977789,
    678996,
    797688,
    897987,
    988898,
    898787,
    989877,
    778978,
    778878,
    787777,
    988767,
    878677,
    888789,
    797889,
    677887,
    997977,
    877876,
    896898,
    977988,
    788977,
    687886,
    988776,
    788788,
    987898,
    998787,
    788678,
    789878,
    697887,
    799889,
    778779,
    868887,
    878989,
    987898,
    797768,
    869787,
    879887,
    896688,
    978887,
    978888,
    879887,
    787988,
    787787,
    887889,
    687998,
    898676,
    888979,
    789676,
    897978,
    888887,
    898779,
    786878,
    888988,
    887888,
    788888,
    898978,
    889788,
    787878,
    996787,
    877888,
    887878,
    777788,
    888999,
    978787,
    887788,
    888877,
    988987,
    878778,
    887887,
    978978,
    998779,
    788887,
    988878,
    687978,
    978778,
    888989,
    889689,
    788789,
    878788,
    888798,
    779687,
    878887,
    869768,
    878777,
    888877,
    979877,
    779787,
    886676,
    887779,
    887878,
    779789,
    988897,
    787977,
    689987,
    687988,
    868889,
    788687,
    777787,
    898877,
    787787,
    888788,
    798778,
    887787,
    897797,
    978777,
    886878,
    888878,
    987798,
    887888,
    887897,
    878886,
    798979,
    997876,
    878888,
    968879,
    988978,
    778778,
    798997,
    786988,
    997888,
    888979,
    879779,
    876879,
    877787,
    976689,
    878889,
    878788,
    977888,
    877777,
    778768,
    776877,
    697988,
    787978,
    878879,
    877689,
    887889,
    997779,
    978787,
    799998,
    987899,
    787977,
    868797,
    797789,
    887778,
    678888,
    789898,
    888688,
    777897,
    887877,
    777789,
    789879,
    787888,
    996789,
    888779,
    988997,
    788887,
    898978,
    787888,
    878788,
    788786,
    979889,
    797787,
    878888,
    877876,
    897888,
    887787,
    898989,
    777786,
    788879,
    877899,
    789988,
    998979,
    878897,
    987787,
    879799,
    777888,
    976788,
    897779,
    878868,
    797789,
    986767,
    778696,
    977879,
    897898,
    898787,
    877789,
    789888,
    867887,
    878868,
    987978,
    888977,
    989787,
    888878,
    897878,
    788768,
    888878,
    788876,
    888877,
    797898,
    987778,
    889777,
    699687,
    989879,
    899978,
    789897,
    887878,
    889889,
    888898,
    769889,
    889878,
    888889,
    899777,
    787678,
    889787,
    798877,
    989787,
    887898,
    777879,
    867767,
    897988,
    788897,
    787788,
    889988,
    989988,
    888888,
    888799,
    887788,
    889688,
    788777,
    987698,
    797798,
    868898,
    768677,
    797998,
    887778,
    888887,
    877778,
    888789,
    787979,
    779778,
    987786,
    877787,
    788777,
    977777,
    878797,
    788978,
    878888,
    978997,
    897997,
    778777,
    787687,
    888998,
    889788,
    877978,
    788987,
    788787,
    868979,
    788977,
    687989,
    668777,
    996887,
    987888,
    797778,
    879888,
    787887,
    878878,
    796878,
    769778,
    898778,
    888878,
    877879,
    788876,
    777878,
    889899,
    978887,
    897778,
    887877,
    777878,
    787786,
    886977,
    679978,
    789878,
    888767,
    877979,
    897778,
    878778,
    988787,
    876768,
    888868,
    888998,
    777889,
    786887,
    787687,
    898998,
    989888,
    887898,
    877899,
    977978,
    897797,
    776899,
    788888,
    788988,
    888678,
    687787,
    976879,
    787789,
    787797,
    988778,
    989987,
    886788,
    879998,
    687789,
    768997,
    887978,
    876977,
    888988,
    988688,
    899776,
    777979,
    897898,
    898879,
    887888,
    878888,
    779688,
    798789,
    977798,
    877768,
    988777,
    789686,
    898798,
    878777,
    777869,
    779778,
    888988,
    897899,
    797698,
    777679,
    998988,
    777886,
    787997,
    898869,
    989988,
    778869,
    976789,
    688878,
    898788,
    888876,
    788887,
    886877,
    888978,
    877779,
    887787,
    988887,
    776876,
    778799,
    689888,
    768987,
    778868,
    868699,
    787768,
    878878,
    997778,
    888879,
    988778,
    897788,
    888787,
    897788,
    967686,
    787879,
    989788,
    898989,
    787888,
    879987,
    866788,
    999798,
    998899,
    678986,
    888879,
    778887,
    787778,
    776889,
    897978,
    777768,
    789797,
    778878,
    878989,
    878988,
    878768,
    687798,
    896888,
    798788,
    977787,
    888789,
    977876,
    889887,
    878787,
    787898,
    897779,
    987988,
    988898,
    767797,
    898998,
    688887,
    678897,
    787789,
    779889,
    996878,
    979788,
    897967,
    789786,
    998878,
    688977,
    879787,
    787787,
    698779,
    897887,
    869987,
    998887,
    778898,
    698888,
    899888,
    977889,
    978788,
    989978,
    798879,
    999998,
    777786,
    788967,
    888767,
    689979,
    777779,
    887769,
    898898,
    877988,
    867879,
    688877,
    696878,
    887898,
    876888,
    788797,
    688677,
    898888,
    777978,
    677788,
    986799,
    697777,
    797897,
    778689,
    889868,
    878798,
    888988,
    868897,
    888868,
    987899,
    988876,
    888777,
    889896,
    977879,
    887989,
    998679,
    987877,
    767888,
    897797,
    887988,
    888689,
    879677,
    978777,
    988679,
    788889,
    887778,
    767797,
    788777,
    878678,
    877889,
    778898,
    778878,
    887787,
    777878,
    687697,
    987979,
    889778,
    988988,
    879888,
    788786,
    977888,
    788887,
    878987,
    877888,
    778997,
    868979,
    878798,
    887999,
    978887,
    888888,
    878788,
    798798,
    867886,
    978798,
    789896,
    887889,
    889899,
    877787,
    996886,
    789767,
    888788,
    778897,
    796899,
    987998,
    789978,
    787976,
    888796,
    887788,
    779888,
    979988,
    789877,
    977999,
    879988,
    988888,
    888887,
    877778,
    787888,
    687898,
    998878,
    878886,
    877787,
    877997,
    878889,
    778877,
    966878,
    787887,
    887887,
    997898,
    787977,
    889899,
    987888,
    787887,
    988788,
    878877,
    778688,
    797887,
    988868,
    889889,
    687769,
    878889,
    988986,
    878788,
    678986,
    777889,
    789868,
    889889,
    689878,
    978887,
    788878,
    778998,
    979888,
    869787,
    787888,
    888898,
    788786,
    867877,
    888778,
    978778,
    797877,
    988786,
    877789,
    788787,
    999868,
    778778,
    988869,
    698799,
    887877,
    788787,
    869878,
    788989,
    799997,
    788769,
    877789,
    877898,
    796887,
    979879,
    898878,
    888889,
    788999,
    869778,
    897686,
    798677,
    788886,
    987678,
    989899,
    989999,
    788798,
    789799,
    789997,
    679798,
    687898,
    897879,
    699788,
    988778,
    988787,
    888778,
    778878,
    677887,
    867878,
    988787,
    779687,
    876898,
    989778,
    877888,
    689968,
    978988,
    798878,
    778879,
    887888,
    787888,
    867897,
    987788,
    879998,
    788799,
    988988,
    887977,
    778798,
    678898,
    698987,
    797898,
    998896,
    997777,
    688677,
    878986,
    897769,
    999887,
    887788,
    887777,
    888798,
    988887,
    887897,
    788888,
    978887,
    788867,
    898787,
    797789,
    788789,
    789877,
    788868,
    789888,
    796979,
    878779,
    787877,
    697878,
    787897,
    978898,
    987678,
    778798,
    877788,
    898887,
    977897,
    787888,
    788688,
    789876,
    889989,
    879778,
    777878,
    997687,
    887787,
    788689,
    876767,
    688888,
    979898,
    798877,
    978877,
    978878,
    888866,
    987987,
    778986,
    798698,
    778777,
    988976,
    688979,
    886786,
    887887,
    988697,
    789777,
    888978,
    888888,
    877778,
    888888,
    888779,
    978878,
    777967,
    879988,
    686889,
    877778,
    789777,
    787777,
    896988,
    787888,
    977988,
    878789,
    878798,
    898789,
    998999,
    868878,
    788979,
    787898,
    896867,
    877897,
    698888,
    799798,
    888889,
    978889,
    767778,
    778778,
    879867,
    789978,
    798898,
    877988,
    879786,
    868899,
    777878,
    897887,
    788897,
    796879,
    889868,
    788888,
    878876,
    876899,
    988779,
    887776,
    888898,
    888788,
    997769,
    888887,
    678789,
    776989,
    878879,
    997698,
    798879,
    988888,
    798788,
    767898,
    778778,
    888979,
    778678,
    878879,
    777778,
    788886,
    877988,
    788788,
    769998,
    877788,
    798878,
    888779,
    787779,
    778776,
    888887,
    798889,
    777777,
    887966,
    788987,
    879777,
    888678,
    877897,
    888778,
    877889,
    798899,
    988888,
    888878,
    788777,
    897898,
    987889,
    898978,
    698777,
    798877,
    776878,
    777987,
    978878,
    888879,
    899678,
    878787,
    798899,
    778787,
    888799,
    689776,
    999988,
    998977,
    797787,
    888877,
    898897,
    887888,
    898688,
    788789,
    679867,
    888888,
    899788,
    898777,
    778877,
    887778,
    887989,
    887799,
    789998,
    888797,
    988689,
    877787,
    887788,
    796787,
    988987,
    878797,
    897677,
    777876,
    888888,
    778789,
    868877,
    789878,
    797887,
    787799,
    897898,
    888887,
    796878,
    897978,
    889987,
    778698,
    899767,
    878878,
    888897,
    888777,
    988789,
    978687,
    777998,
    888797,
    789888,
    797979,
    888878,
    977777,
    978878,
    998676,
    998887,
    879878,
    788689,
    788977,
    778988,
    768888,
    798888,
    688899,
    778677,
    779778,
    788898,
    889977,
    768876,
    897989,
    988777,
    977788,
    788787,
    697878,
    877889,
    889779,
    889988,
    789788,
    877897,
    887976,
    776778,
    889887,
    779887,
    878978,
    888788,
    999897,
    878888,
    977878,
    788877,
    887889,
    986867,
    886977,
    777886,
    687688,
    988978,
    776788,
    798778,
    698876,
    888798,
    867888,
    876878,
    988888,
    789778,
    878788,
    998879,
    789888,
    878878,
    788889,
    778778,
    887778,
    878987,
    789779,
    887897,
    888887,
    986897,
    888889,
    998897,
    776697,
    787787,
    966889,
    778888,
    778798,
    697878,
    869977,
    779987,
    677797,
    878687,
    888888,
    878788,
    768877,
    888897,
    779889,
    988887,
    898878,
    786977,
    786777,
    889887,
    878786,
    978887,
    977778,
    777869,
    987789,
    688777,
    878787,
    777987,
    889899,
    798888,
    777779,
    787879,
    798787,
    888788,
    778778,
    997676,
    989777,
    787878,
    887878,
    897686,
    778787,
    898989,
    799869,
    988797,
    888777,
    787887,
    698878,
    988978,
    787777,
    977898,
    888798,
    787878,
    777677,
    878798,
    887888,
    887789,
    888787,
    998797,
    978689,
    888778,
    988868,
    878878,
    878777,
    978997,
    689778,
    978777,
    788979,
    897887,
    869996,
    798887,
    877878,
    878788,
    869898,
    888797,
    877887,
    887877,
    888786,
    787798,
    689877,
    798787,
    898899,
    786898,
    878877,
    779988,
    877878,
    877786,
    898777,
    778899,
    787879,
    878887,
    887887,
    878988,
    977777,
    898987,
    988888,
    988878,
    999777,
    788889,
    777897,
    997797,
    898979,
    887889,
    888878,
    888788,
    788889,
    888878,
    887898,
    788767,
    986788,
    888878,
    888989,
    977976,
    788878,
    787887,
    777888,
    897888,
    778998,
    977878,
    789986,
    977877,
    788798,
    788788,
    867978,
    868878,
    897798,
    889877,
    987978,
    897878,
    797987,
    798877,
    868878,
    788987,
    898896,
    788787,
    877878,
    678889,
    768987,
    778768,
    967899,
    798987,
    887988,
    888776,
    978769,
    987887,
    697888,
    787887,
    999898,
    778889,
    778788,
    789777,
    877989,
    989798,
    876777,
    988888,
    898788,
    987698,
    779797,
    877787,
    878797,
    796978,
    879988,
    789788,
    788877,
    989888,
    787878,
    889887,
    978887,
    899888,
    976899,
    879888,
    688899,
    868888,
    898877,
    888897,
    887789,
    777787,
    988789,
    899878,
    878788,
    979988,
    898888,
    888779,
    989899,
    788888,
    688779,
    978799,
    878778,
    989778,
    777777,
    888978,
    897978,
    878798,
    978898,
    868788,
    997878,
    967678,
    799889,
    887979,
    797798,
    988888,
    698876,
    688876,
    788988,
    688687,
    689778,
    778687,
    799887,
    779878,
    987889,
    896998,
    877887,
    879888,
    977888,
    999878,
    777868,
    899868,
    767887,
    887997,
    978787,
    887678,
    778887,
    888766,
    778898,
    789878,
    798778,
    889687,
    877978,
    798779,
    788987,
    888887,
    898777,
    787669,
    786778,
    879778,
    997896,
    797686,
    889889,
    879977,
    889777,
    879977,
    886886,
    778998,
    997888,
    797888,
    787877,
    869797,
    788777,
    879987,
    877988,
    877898,
    888898,
    877878,
    888888,
    889887,
    788789,
    777777,
    999769,
    887887,
    899777,
    798989,
    879778,
    887896,
    877788,
    778778,
    778797,
    778787,
    887888,
    887997,
    788868,
    886999,
    898688,
    987897,
    888997,
    988776,
    687888,
    767778,
    868897,
    788789,
    888988,
    998888,
    687878,
    879889,
    898976,
    878778,
    977989,
    888787,
    799988,
    878779,
    868789,
    878878,
    988996,
    898889,
    897779,
    868988,
    879789,
    778988,
    677888,
    788887,
    897878,
    787777,
    977978,
    777986,
    886866,
    978968,
    898887,
    977888,
    776987,
    977868,
    888789,
    968887,
    878778,
    677788,
    888769,
    797886,
    989887,
    877787,
    898896,
    779897,
    778879,
    877978,
    788887,
    799976,
    768889,
    789988,
    779877,
    988887,
    977877,
    678879,
    899898,
    889889,
    868988,
    887979,
    877997,
    877688,
    798688,
    878767,
    798787,
    888879,
    768988,
    888889,
    798986,
    787877,
    769699,
    896876,
    887779,
    997988,
    778978,
    697676,
    897976,
    879788,
    896899,
    798888,
    786787,
    798899,
    778787,
    877777,
    788877,
    768789,
    789787,
    877876,
    987788,
    868887,
    788786,
    898969,
    977887,
    889977,
    897886,
    878877,
    899869,
    678876,
    888768,
    888787,
    787889,
    878879,
    797888,
    889878,
    788867,
    766988,
    889788,
    677799,
    677878,
    787777,
    667787,
    889988,
    988787,
    777879,
    887887,
    968897,
    878797,
    987768,
    988779,
    977779,
    877779,
    879988,
    699877,
    988988,
    787779,
    779798,
    887887,
    877886,
    888778,
    787888,
    876878,
    776887,
    886996,
    887777,
    798977,
    676989,
    998697,
    777888,
    877866,
    898797,
    877988,
    867998,
    867897,
    778687,
    898967,
    788778,
    989888,
    778978,
    797898,
    779887,
    887896,
    688877,
    779869,
    889778,
    788998,
    998896,
    797986,
    877798,
    877779,
    977988,
    977899,
    877678,
    878886,
    798779,
    788798,
    788889,
    777887,
    798699,
    886889,
    799887,
    877887,
    999887,
    789797,
    779898,
    979688,
    777988,
    887799,
    788779,
    997797,
    998698,
    888868,
    899877,
    878878,
    876777,
    977997,
    788888,
    888776,
    866889,
    889788,
    976878,
    787796,
    867777,
    798888,
    988877,
    777888,
    998899,
    787877,
    798679,
    868878,
    987777,
    798887,
    968987,
    799888,
    966879,
    679797,
    888777,
    778888,
    878777,
    997877,
    886977,
    888888,
    799899,
    787777,
    898778,
    878777,
    897788,
    988877,
    998888,
    689879,
    778867,
    878899,
    889977,
    877888,
    866998,
    787887,
    787989,
    987788,
    898889,
    888767,
    888987,
    788688,
    979778,
    877797,
    978887,
    887777,
    798897,
    987688,
    988889,
    997998,
    788796,
    887897,
    797987,
    878777,
    786887,
    989788,
    988988,
    788988,
    699888,
    877789,
    786778,
    976997,
    987898,
    798899,
    998877,
    789978,
    987787,
    779787,
    878887,
    876898,
    778778,
    988888,
    997877,
    788687,
    889888,
    786879,
    689887,
    777898,
    888787,
    798888,
    877868,
    978869,
    678898,
    978897,
    678797,
    789789,
    788677,
    889778,
    978877,
    878988,
    677969,
    887788,
    887798,
    988687,
    769887,
    676878,
    776888,
    877988,
    867878,
    787887,
    979878,
    887787,
    789778,
    888988,
    888977,
    988789,
    876988,
    788987,
    887787,
    877997,
    677868,
    968878,
    788778,
    769888,
    768788,
    887978,
    779888,
    889897,
    887888,
    787998,
    878878,
    889768,
    888888,
    879898,
    869987,
    787687,
    789978,
    777778,
    886787,
    878779,
    977887,
    887887,
    778787,
    888887,
    887896,
    889887,
    778997,
    787788,
    978789,
    977887,
    788788,
    898678,
    799867,
    888878,
    897867,
    986997,
    778978,
    898787,
    786889,
    777868,
    977797,
    788677,
    777887,
    877897,
    877678,
    877878,
    889878,
    987888,
    989877,
    878688,
    888899,
    688899,
    888879,
    698787,
    777868,
    798789,
    788787,
    889697,
    786787,
    987778,
    788777,
    778799,
    888869,
    879888,
    798989,
    888789,
    878778,
    879799,
    977888,
    897778,
    788879,
    897788,
    987878,
    768879,
    889898,
    786788,
    679989,
    789978,
    989978,
    879777,
    977778,
    878888,
    877669,
    898977,
    988787,
    787779,
    797789,
    879777,
    687887,
    879776,
    898888,
    978798,
    976767,
    989898,
    889778,
    978777,
    776888,
    879977,
    776888,
    887878,
    989788,
    887668,
    877877,
    899678,
    889887,
    988777,
    889888,
    777887,
    798788,
    978698,
    889687,
    767898,
    878876,
    687987,
    888878,
    989886,
    878888,
    998988,
    789988,
    877877,
    888797,
    777697,
    789799,
    876888,
    788798,
    898778,
    788998,
    799777,
    887768,
    887977,
    798778,
    997887,
    779798,
    898688,
    879888,
    998798,
    798788,
    887977,
    777788,
    877988,
    979797,
    778788,
    776779,
    888778,
    989888,
    888778,
    876988,
    788888,
    888898,
    878898,
    867988,
    777978,
    898888,
    787878,
    877889,
    778888,
    989988,
    788886,
    677767,
    887789,
    988687,
    887788,
    898786,
    887778,
    777797,
    778788,
    767888,
    878868,
    987897,
    899789,
    887788,
    786688,
    888887,
    767878,
    877877,
    879887,
    887978,
    689977,
    767887,
    888698,
    788867,
    877868,
    889987,
    877888,
    689899,
    876787,
    877798,
    877987,
    778778,
    989988,
    778788,
    979787,
    877777,
    799798,
    978898,
    987679,
    978887,
    787879,
    789888,
    667787,
    788889,
    977788,
    778898,
    677877,
    787787,
    877779,
    889679,
    998789,
    998886,
    888777,
    877968,
    878868,
    979988,
    788887,
    777799,
    778698,
    878678,
    878796,
    897799,
    888776,
    786889,
    887887,
    779978,
    998988,
    878876,
    888888,
    978787,
    889989,
    988997,
    799798,
    988787,
    678777,
    999899,
    767677,
    778679,
    878779,
    877888,
    878988,
    799778,
    787867,
    868677,
    889777,
    878789,
    797897,
    768798,
    876978,
    788879,
    878788,
    877869,
    788889,
    788888,
    797788,
    788988,
    878998,
    889878,
    897877,
    877868,
    788887,
    799788,
    978887,
    887898,
    987978,
    689989,
    779988,
    876778,
    778798,
    997979,
    887888,
    997868,
    887778,
    789997,
    878888,
    788868,
    897889,
    786878,
    786888,
    777868,
    688898,
    997988,
    878788,
    887798,
    787778,
    797888,
    879988,
    788869,
    878896,
    867777,
    788898,
    698888,
    887987,
    877889,
    988789,
    988887,
    679978,
    888988,
    798997,
    879987,
    978678,
    887988,
    898979,
    886989,
    889878,
    788867,
    987787,
    978899,
    879778,
    779698,
    889887,
    769889,
    896788,
    779868,
    979868,
    686788,
    888888,
    778788,
    878888,
    898778,
    777799,
    888778,
    988788,
    888778,
    787887,
    776787,
    779878,
    869899,
    879888,
    669888,
    888887,
    678897,
    979999,
    778878,
    688797,
    867788,
    887787,
    678777,
    898888,
    878687,
    779778,
    788678,
    999889,
    898797,
    978879,
    877767,
    888986,
    898789,
    788878,
    978776,
    788989,
    779877,
    797878,
    777798,
    787679,
    788777,
    898787,
    779787,
    787777,
    888777,
    898977,
    977797,
    899886,
    779879,
    877767,
    878989,
    688979,
    888987,
    888899,
    888877,
    787796,
    688888,
    877888,
    988879,
    879787,
    988888,
    887996,
    887799,
    788897,
    798878,
    779779,
    678798,
    987987,
    879888,
    899779,
    878988,
    887976,
    898788,
    787889,
    798999,
    997788,
    777688,
    768778,
    798786,
    968777,
    876779,
    888867,
    889898,
    769797,
    899968,
    877787,
    877797,
    797769,
    769998,
    997888,
    787877,
    698787,
    797878,
    787878,
    787998,
    799777,
    787787,
    677888,
    787989,
    877887,
    689678,
    878788,
    786688,
    898977,
    798787,
    888878,
    787787,
    688887,
    888897,
    798889,
    667989,
    877787,
    787778,
    778968,
    798999,
    878779,
    778987,
    888688,
    979798,
    797877,
    769897,
    988668,
    899888,
    778789,
    688999,
    878877,
    787997,
    888888,
    768887,
    787978,
    678998,
    978978,
    788997,
    777898,
    887888,
    798888,
    797897,
    988877,
    878987,
    766889,
    898689,
    668887,
    977867,
    788787,
    898888,
    687987,
    879777,
    798787,
    777786,
    779886,
    898879,
    888778,
    888879,
    868687,
    877888,
    878798,
    998988,
    768989,
    769868,
    987776,
    778787,
    986989,
    878778,
    877889,
    867777,
    978788,
    887887,
    787766,
    878886,
    877869,
    877998,
    888998,
    688798,
    887987,
    786977,
    898799,
    887877,
    778887,
    867896,
    988869,
    769678,
    877976,
    878998,
    787889,
    967988,
    877886,
    887788,
    887988,
    978767,
    898779,
    888877,
    887788,
    888888,
    978789,
    888887,
    878878,
    978899,
    887887,
    787796,
    767888,
    779978,
    778999,
    887879,
    877977,
    887899,
    679997,
    887867,
    896898,
    988777,
    797767,
    888879,
    878878,
    888786,
    787998,
    999877,
    798689,
    997979,
    988897,
    888868,
    977888,
    987979,
    898787,
    999676,
    978797,
    788878,
    777787,
    889798,
    788787,
    998888,
    887888,
    789978,
    887987,
    888887,
    797879,
    799887,
    778877,
    878777,
    889969,
    789898,
    878868,
    888878,
    766779,
    878888,
    788897,
    877888,
    989778,
    878778,
    887988,
    977789,
    798778,
    887877,
    768878,
    888878,
    989787,
    997777,
    887977,
    877779,
    889777,
    989688,
    767989,
    967788,
    788877,
    868998,
    798767,
    887668,
    678687,
    897897,
    789888,
    677867,
    989988,
    887979,
    778699,
    788689,
    887877,
    888878,
    798788,
    977778,
    789797,
    988868,
    878896,
    988977,
    888788,
    987887,
    987879,
    878877,
    788977,
    778889,
    778987,
    897777,
    889866,
    799879,
    788788,
    788898,
    987896,
    777797,
    888877,
    887676,
    688779,
    888697,
    876888,
    789677,
    678998,
    888868,
    767776,
    899778,
    987988,
    979797,
    697987,
    898779,
    878967,
    777897,
    867879,
    878777,
    977987,
    986798,
    978878,
    988888,
    687877,
    888967,
    988778,
    998877,
    777788,
    888778,
    989878,
    799887,
    779776,
    789797,
    888897,
    688789,
    869986,
    789878,
    888878,
    977878,
    898888,
    686877,
    877987,
    997869,
    878787,
    887787,
    887788,
    898778,
    789879,
    998888,
    798887,
    999888,
    887878,
    978978,
    879978,
    789897,
    788798,
    877888,
    788978,
    999887,
    966887,
    988787,
    687778,
    778999,
    686789,
    798887,
    988889,
    878898,
    888677,
    978788,
    877978,
    887988,
    877787,
    777988,
    776888,
    977988,
    779999,
    889897,
    877889,
    869888,
    876878,
    878886,
    889977,
    798888,
    787877,
    989888,
    878777,
    899867,
    787789,
    978769,
    779887,
    788777,
    677677,
    878888,
    776867,
    896786,
    888878,
    788878,
    887978,
    887878,
    899789,
    878787,
    979887,
    779787,
    777678,
    886977,
    788989,
    877888,
    778889,
    796877,
    779798,
    788987,
    878998,
    788888,
    898888,
    888868,
    789798,
    878797,
    878888,
    777887,
    898786,
    788897,
    896877,
    878698,
    899788,
    887989,
    687788,
    777788,
    788889,
    987878,
    987988,
    897989,
    778876,
    877888,
    777687,
    787888,
    978787,
    978876,
    876778,
    767988,
    988777,
    797787,
    988888,
    997678,
    997688,
    987888,
    777867,
    886967,
    897877,
    877898,
    878879,
    979987,
    877698,
    897898,
    997788,
    887988,
    877989,
    787889,
    777788,
    978879,
    887989,
    797878,
    898768,
    787789,
    878778,
    799778,
    899687,
    789878,
    888788,
    797988,
    799787,
    899888,
    779888,
    988767,
    868868,
    777896,
    878879,
    898997,
    677897,
    977887,
    788877,
    799787,
    887688,
    779888,
    887898,
    998887,
    797877,
    896897,
    678787,
    888689,
    987689,
    789888,
    877999,
    677877,
    987888,
    688786,
    877688,
    787888,
    789797,
    788886,
    977789,
    988797,
    887779,
    798678,
    678877,
    777968,
    768797,
    888877,
    787778,
    889778,
    889898,
    877787,
    789798,
    888778,
    888687,
    877987,
    798787,
    687979,
    788788,
    979898,
    978787,
    888888,
    778797,
    877777,
    876778,
    887787,
    798777,
    999698,
    877878,
    898887,
    788878,
    878868,
    797987,
    897779,
    779898,
    789779,
    797879,
    896977,
    677787,
    889887,
    989888,
    788988,
    978889,
    789889,
    898868,
    768979,
    988978,
    789878,
    988876,
    889998,
    777867,
    688977,
    779977,
    998878,
    877878,
    778798,
    888899,
    878887,
    678678,
    879798,
    888878,
    878778,
    887768,
    988879,
    787889,
    778887,
    899966,
    898888,
    998677,
    698777,
    878899,
    787889,
    778888,
    868767,
    687777,
    887878,
    789877,
    769888,
    868899,
    977688,
    688788,
    798886,
    787778,
    767798,
    968989,
    789869,
    988778,
    978987,
    988888,
    878879,
    889768,
    896887,
    896888,
    697987,
    687788,
    688779,
    798797,
    898879,
    887888,
    787777,
    977869,
    779987,
    898788,
    798988,
    888777,
    778698,
    789687,
    868787,
    779899,
    977888,
    888788,
    777689,
    889776,
    988788,
    777867,
    977879,
    989878,
    877888,
    997877,
    999897,
    977877,
    988799,
    987899,
    877787,
    789976,
    877787,
    888997,
    787797,
    987886,
    997877,
    988888,
    788868,
    768888,
    898798,
    798878,
    777888,
    978777,
    787898,
    878789,
    978789,
    797778,
    887787,
    786787,
    798898,
    797966,
    888977,
    678889,
    877788,
    886688,
    788898,
    678879,
    987678,
    878999,
    878778,
    789989,
    878887,
    977887,
    789798,
    977798,
    978787,
    798777,
    769888,
    887787,
    888798,
    678987,
    977778,
    777786,
    878789,
    977889,
    888778,
    798786,
    697877,
    968886,
    878789,
    788979,
    788788,
    877989,
    978888,
    878987,
    677878,
    888888,
    977777,
    878778,
    767798,
    979786,
    797888,
    777868,
    878877,
    788778,
    788779,
    778887,
    786776,
    876797,
    788888,
    788989,
    779987,
    787978,
    986989,
    888768,
    868897,
    878767,
    897989,
    888988,
    986688,
    769768,
    879789,
    887777,
    989777,
    789778,
    777777,
    798989,
    876767,
    979777,
    888888,
    978888,
    997987,
    989797,
    877788,
    987788,
    786778,
    788987,
    798678,
    887889,
    989887,
    887889,
    799796,
    888798,
    988688,
    977879,
    888896,
    778967,
    887888,
    887796,
    997878,
    888879,
    798778,
    999888,
    878879,
    987877,
    877986,
    877888,
    686997,
    676777,
    878878,
    768898,
    778887,
    998787,
    888988,
    897878,
    997977,
    899778,
    887878,
    869989,
    699987,
    768989,
    877987,
    887787,
    687878,
    878776,
    897968,
    899877,
    798687,
    877888,
    788788,
    978876,
    988889,
    878887,
    977878,
    778998,
    877878,
    887887,
    778889,
    889778,
    797988,
    688669,
    887889,
    888888,
    888978,
    987888,
    889887,
    899786,
    799778,
    887878,
    977987,
    778887,
    876886,
    878778,
    789789,
    788868,
    999798,
    868887,
    889888,
    899878,
    899886,
    797979,
    687786,
    779888,
    988887,
    787698,
    677886,
    988787,
    796778,
    788767,
    866998,
    787777,
    999899,
    888887,
    788888,
    899787,
    799888,
    878777,
    877777,
    978996,
    888989,
    868799,
    868779,
    888687,
    797888,
    988788,
    888696,
    986977,
    779778,
    889688,
    889798,
    878787,
    876888,
    867778,
    988699,
    887776,
    778878,
    687889,
    978788,
    779889,
    896778,
    898789,
    888989,
    868798,
    869889,
    897777,
    987878,
    899777,
    968988,
    996778,
    888697,
    887787,
    788888,
    898979,
    889788,
    899768,
    987877,
    879898,
    988689,
    778688,
    688987,
    878778,
    878888,
    878878,
    779779,
    887788,
    769788,
    987877,
    878887,
    788769,
    767878,
    888788,
    788788,
    876788,
    779979,
    878879,
    777798,
    779877,
    877777,
    889678,
    788778,
    788768,
    879988,
    789788,
    996788,
    797898,
    888877,
    998899,
    888888,
    978879,
    888778,
    776987,
    788887,
    899988,
    877988,
    768788,
    977887,
    799778,
    988889,
    866898,
    877788,
    986889,
    688887,
    898887,
    988998,
    887888,
    797877,
    897789,
    887877,
    777786,
    868777,
    898969,
    799767,
    777979,
    888888,
    779987,
    887888,
    898898,
    778776,
    897867,
    889797,
    899878,
    788777,
    996988,
    888879,
    887979,
    797878,
    797777,
    887978,
    879987,
    887787,
    877789,
    988688,
    799777,
    876787,
    899868,
    769787,
    787878,
    797878,
    977798,
    989878,
    879789,
    888887,
    798778,
    867869,
    878899,
    776787,
    868887,
    799888,
    986978,
    888778,
    879868,
    987887,
    997688,
    967768,
    888778,
    888898,
    889978,
    888987,
    978878,
    797787,
    788888,
    899798,
    787788,
    887688,
    888999,
    879888,
    886878,
    878798,
    898998,
    897889,
    888879,
    886978,
    978899,
    887978,
    797679,
    788677,
    769788,
    689898,
    977897,
    997799,
    987999,
    877898,
    688877,
    889776,
    788788,
    888868,
    899787,
    878889,
    888797,
    979888,
    878888,
    877687,
    778976,
    888878,
    788887,
    676789,
    789988,
    777777,
    888897,
    788798,
    878679,
    777898,
    878889,
    897696,
    899997,
    887887,
    989877,
    789687,
    787886,
    887887,
    968787,
    677878,
    777897,
    888887,
    887898,
    787777,
    977877,
    889987,
    988877,
    868887,
    877787,
    877787,
    889777,
    888889,
    868978,
    776788,
    779877,
    888797,
    787789,
    877976,
    799888,
    889987,
    799899,
    898688,
    987698,
    898797,
    889878,
    787698,
    887888,
    977787,
    678778,
    787989,
    788998,
    788889,
    879888,
    778897,
    787778,
    899878,
    688888,
    797976,
    898889,
    778898,
    787978,
    998888,
    986977,
    787888,
    688879,
    789689,
    866887,
    879798,
    668877,
    877798,
    788987,
    778887,
    887878,
    888788,
    978879,
    978878,
    898777,
    878888,
    897798,
    789778,
    897778,
    968698,
    867888,
    686868,
    898977,
    866988,
    797878,
    878988,
    798978,
    879996,
    787878,
    889978,
    787797,
    798897,
    787878,
    968778,
    688979,
    798788,
    978979,
    899877,
    878778,
    987777,
    888897,
    778878,
    977769,
    877878,
    977877,
    798877,
    888776,
    997699,
    789886,
    888978,
    999778,
    977878,
    899789,
    987996,
    896889,
    867778,
    988889,
    777887,
    879769,
    788787,
    898788,
    887788,
    988886,
    778879,
    877877,
    888888,
    998888,
    777886,
    889987,
    697897,
    888878,
    888887,
    877897,
    797888,
    989879,
    886888,
    979878,
    879789,
    788787,
    979888,
    878797,
    677778,
    888789,
    877787,
    899888,
    887686,
    787987,
    888898,
    886988,
    799888,
    779789,
    878788,
    877867,
    789787,
    878798,
    789987,
    989888,
    799878,
    888788,
    879879,
    979678,
    798988,
    787988,
    877987,
    896879,
    788987,
    767677,
    887778,
    877888,
    798866,
    896886,
    777877,
    798778,
    887888,
    776778,
    777889,
    887878,
    987776,
    888677,
    987998,
    979787,
    688878,
    898789,
    889987,
    798768,
    888688,
    888677,
    987788,
    898967,
    979867,
    987778,
    887878,
    798988,
    779778,
    777788,
    887787,
    888889,
    779878,
    898698,
    878887,
    688898,
    898889,
    877897,
    898789,
    989888,
    777887,
    968878,
    779887,
    897798,
    778879,
    877979,
    878988,
    986777,
    787978,
    798788,
    679788,
    889888,
    989988,
    878789,
    989677,
    879868,
    879989,
    788667,
    978978,
    677676,
    787997,
    877868,
    889878,
    789997,
    888898,
    878868,
    788687,
    778677,
    877877,
    868986,
    677876,
    788777,
    976798,
    789777,
    788778,
    788788,
    988988,
    699977,
    698877,
    878787,
    987887,
    977777,
    889867,
    897688,
    789787,
    787888,
    878777,
    766879,
    987877,
    789788,
    899978,
    878789,
    888868,
    889788,
    977787,
    989968,
    777997,
    888769,
    888987,
    867878,
    888778,
    986887,
    877989,
    887697,
    777978,
    766787,
    788878,
    777687,
    887778,
    778878,
    978877,
    879977,
    788887,
    888887,
    798999,
    889878,
    896779,
    889767,
    789887,
    878876,
    878999,
    987867,
    988689,
    888886,
    877868,
    899887,
    988877,
    798787,
    876769,
    878778,
    878879,
    888798,
    689777,
    888878,
    998778,
    889978,
    897799,
    888986,
    686888,
    999997,
    989897,
    787879,
    887978,
    799979,
    878777,
    988777,
    898778,
    897787,
    888788,
    888699,
    869886,
    887998,
    977797,
    678798,
    778898,
    877879,
    897788,
    896989,
    787678,
    976887,
    888888,
    889786,
    898676,
    879779,
    987887,
    788897,
    776889,
    879698,
    868798,
    779789,
    897797,
    878988,
    989777,
    778786,
    967888,
    989888,
    888888,
    878878,
    879878,
    698897,
    988978,
    899797,
    777887,
    879788,
    797878,
    888888,
    777867,
    997888,
    978698,
    989666,
    878697,
    896877,
    888877,
    888888,
    876988,
    687878,
    898898,
    989868,
    767878,
    878989,
    778887,
    878767,
    879899,
    978876,
    787978,
    799788,
    878888,
    877778,
    789769,
    878888,
    899897,
    689888,
    787776,
    796887,
    698778,
    898887,
    879878,
    877778,
    898778,
    888798,
    778778,
    997778,
    897787,
    887879,
    887878,
    678878,
    787899,
    877888,
    788786,
    887779,
    888697,
    998878,
    986798,
    778888,
    689877,
    787788,
    898988,
    787977,
    888897,
    986978,
    778679,
    777788,
    788887,
    978787,
    767878,
    697998,
    878987,
    888888,
    889687,
    987989,
    888989,
    877788,
    997978,
    897987,
    787976,
    998888,
    788987,
    788877,
    898877,
    879998,
    798898,
    998697,
    888878,
    778968,
    798797,
    989887,
    689798,
    877776,
    897786,
    879788,
    877868,
    867877,
    988989,
    998767,
    998777,
    789888,
    987877,
    878878,
    777888,
    888887,
    989688,
    878879,
    878988,
    897878,
    788889,
    889867,
    898887,
    998878,
    868878,
    877678,
    898688,
    987877,
    887788,
    987887,
    778889,
    789888,
    878988,
    787879,
    787776,
    887878,
    777988,
    787788,
    778978,
    878887,
    888989,
    877988,
    889877,
    887878,
    887687,
    897998,
    977778,
    778877,
    778779,
    769687,
    998796,
    777998,
    899878,
    778787,
    979888,
    789967,
    869867,
    778898,
    867998,
    969777,
    778787,
    798878,
    777779,
    877778,
    878777,
    778788,
    677796,
    987978,
    878687,
    987899,
    888897,
    688967,
    887777,
    798767,
    887797,
    787777,
    778787,
    989999,
    898677,
    968779,
    987689,
    898677,
    888786,
    797788,
    797978,
    878877,
    876887,
    887789,
    899769,
    878987,
    889987,
    787889,
    866978,
    677978,
    977878,
    878787,
    886788,
    868878,
    889787,
    998978,
    876697,
    989888,
    789868,
    798788,
    877778,
    987988,
    987798,
    977878,
    888878,
    676799,
    887997,
    988778,
    768778,
    889878,
    796888,
    798887,
    888767,
    887987,
    889677,
    787899,
    889879,
    879878,
    786867,
    888977,
    877787,
    988877,
    887668,
    998778,
    788879,
    877988,
    978798,
    787786,
    797977,
    878978,
    677688,
    997977,
    788877,
    888899,
    788877,
    789887,
    988868,
    976888,
    778889,
    888898,
    778899,
    889679,
    878888,
    688787,
    868888,
    887688,
    797886,
    897878,
    689867,
    888879,
    878787,
    987798,
    788889,
    778799,
    797987,
    896787,
    767978,
    987988,
    978968,
    787877,
    897878,
    778777,
    877787,
    777978,
    898787,
    888978,
    878979,
    798977,
    778988,
    888878,
    678868,
    978888,
    988788,
    788988,
    788978,
    889878,
    899778,
    888688,
    898978,
    787998,
    888888,
    888978,
    669898,
    778787,
    878868,
    877887,
    878877,
    887799,
    777997,
    868768,
    898897,
    979878,
    778898,
    897886,
    889998,
    878769,
    977978,
    767779,
    998888,
    788779,
    798897,
    788887,
    778789,
    789987,
    996778,
    999798,
    888899,
    886699,
    878889,
    876798,
    998878,
    989778,
    988688,
    888888,
    789776,
    888887,
    798778,
    879779,
    789897,
    777877,
    887887,
    788878,
    778878,
    897878,
    876897,
    867776,
    967887,
    798999,
    777777,
    887867,
    788787,
    788889,
    797977,
    867878,
    977689,
    877988,
    999678,
    977798,
    799989,
    878887,
    977999,
    898877,
    887887,
    787888,
    777779,
    878898,
    897888,
    788667,
    788887,
    897887,
    998687,
    877788,
    999666,
    788888,
    788979,
    889887,
    787887,
    877878,
    879886,
    887978,
    998999,
    888887,
    888878,
    779768,
    779897,
    888787,
    799886,
    687888,
    986888,
    788988,
    889899,
    969877,
    897887,
    979797,
    799787,
    987887,
    976797,
    887897,
    888897,
    877878,
    899888,
    898898,
    887897,
    887769,
    798788,
    887769,
    988879,
    697688,
    878867,
    888869,
    997989,
    977888,
    778799,
    768888,
    968978,
    976887,
    789988,
    898788,
    779768,
    888688,
    979897,
    898989,
    878798,
    799867,
    798888,
    888879,
    777778,
    687887,
    769776,
    798788,
    777868,
    898778,
    877798,
    987797,
    787798,
    888887,
    898877,
    777999,
    778777,
    888778,
    887779,
    899788,
    897776,
    888988,
    687878,
    798787,
    887987,
    787689,
    798787,
    699878,
    777988,
    788786,
    886878,
    978888,
    887798,
    887899,
    777867,
    877967,
    887787,
    888887,
    768776,
    789869,
    977766,
    877977,
    878878,
    898878,
    788778,
    769978,
    878878,
    777888,
    797796,
    778988,
    868886,
    888878,
    978999,
    878798,
    888887,
    787898,
    977777,
    879889,
    677899,
    777788,
    888776,
    897897,
    778779,
    878989,
    789878,
    798887,
    998787,
    878696,
    988968,
    797877,
    887987,
    779878,
    897989,
    677767,
    888796,
    778887,
    867777,
    878788,
    788878,
    688779,
    778866,
    879986,
    878897,
    787998,
    877767,
    977778,
    788997,
    998789,
    799988,
    978886,
    878878,
    968679,
    888887,
    688797,
    888797,
    887786,
    887996,
    878787,
    868967,
    878879,
    796788,
    686988,
    898898,
    769888,
    788997,
    998888,
    898868,
    879778,
    796787,
    879988,
    767877,
    997878,
    786977,
    799898,
    878887,
    798888,
    879788,
    987786,
    979888,
    786989,
    887888,
    776899,
    988888,
    989887,
    897778,
    988799,
    779888,
    779869,
    767987,
    787898,
    687798,
    888788,
    787886,
    796687,
    977778,
    888877,
    898788,
    898887,
    889688,
    878788,
    899878,
    897889,
    978877,
    878787,
    886888,
    798777,
    878798,
    688788,
    888998,
    877887,
    877869,
    876888,
    886897,
    789896,
    788988,
    877978,
    978987,
    978877,
    887798,
    767888,
    888877,
    979988,
    889878,
    788688,
    968778,
    889779,
    887967,
    998667,
    898888,
    886888,
    988998,
    878778,
    779889,
    876799,
    878788,
    977988,
    777768,
    887886,
    787888,
    867879,
    779787,
    778888,
    867888,
    786888,
    977888,
    888879,
    878988,
    798786,
    788678,
    878798,
    977986,
    886988,
    787877,
    879888,
    997876,
    877789,
    978998,
    877787,
    978788,
    798869,
    778787,
    887987,
    769789,
    789888,
    879979,
    887889,
    798897,
    987689,
    998979,
    878777,
    778898,
    888888,
    878998,
    969897,
    798889,
    777777,
    778977,
    778789,
    788788,
    987778,
    888887,
    777998,
    889886,
    888778,
    789977,
    888968,
    777687,
    888786,
    899688,
    888889,
    689877,
    978877,
    878888,
    998888,
    888769,
    778877,
    878687,
    897888,
    876987,
    887779,
    778877,
    978797,
    779667,
    988888,
    878778,
    877889,
    777899,
    777887,
    677898,
    789777,
    987887,
    887889,
    778977,
    878788,
    778787,
    777888,
    988799,
    778899,
    978897,
    787797,
    897797,
    879788,
    987778,
    877788,
    787888,
    878878,
    988796,
    898786,
    999888,
    779979,
    888868,
    978888,
    868778,
    977789,
    777786,
    877979,
    987887,
    899988,
    878788,
    797887,
    988887,
    987787,
    987888,
    778776,
    889789,
    798887,
    879777,
    798889,
    887879,
    778767,
    888899,
    878788,
    787768,
    888979,
    787788,
    787779,
    867779,
    798888,
    787979,
    679998,
    779887,
    788898,
    998798,
    887686,
    788988,
    988867,
    778997,
    789969,
    899898,
    799797,
    897788,
    689878,
    988778,
    897886,
    887789,
    688886,
    878878,
    798888,
    978787,
    988967,
    779799,
    778967,
    988877,
    887698,
    988897,
    777988,
    898997,
    988896,
    797997,
    877979,
    778787,
    887797,
    997888,
    978788,
    698888,
    997877,
    886778,
    989887,
    676787,
    869798,
    978877,
    988788,
    876888,
    998878,
    777878,
    887899,
    788999,
    987799,
    878878,
    787778,
    787877,
    877988,
    887899,
    897898,
    677887,
    877787,
    786799,
    687787,
    777879,
    879997,
    987898,
    878777,
    987877,
    877778,
    698977,
    878777,
    889888,
    788979,
    888687,
    879889,
    889889,
    798896,
    877797,
    988878,
    889689,
    887878,
    788888,
    788889,
    889787,
    897987,
    888988,
    789877,
    888766,
    977979,
    897989,
    889898,
    888678,
    777788,
    968889,
    878887,
    877687,
    899897,
    879877,
    869798,
    876887,
    778868,
    788776,
    787776,
    979977,
    777696,
    777877,
    987977,
    797996,
    887888,
    979888,
    777896,
    869878,
    887997,
    887868,
    977788,
    777667,
    777998,
    986888,
    768878,
    798878,
    976787,
    987879,
    787777,
    877888,
    888899,
    787898,
    888796,
    997899,
    889898,
    689778,
    677787,
    897898,
    887897,
    989786,
    879987,
    789788,
    779776,
    868979,
    879896,
    787788,
    778678,
    687998,
    779787,
    898878,
    888986,
    896768,
    887877,
    878788,
    778776,
    888777,
    878787,
    997768,
    997778,
    788987,
    888787,
    777898,
    877867,
    787798,
    789879,
    789887,
    678779,
    887987,
    878787,
    889976,
    886779,
    877788,
    879888,
    899788,
    898788,
    788877,
    867988,
    987887,
    887788,
    887978,
    868798,
    789878,
    878899,
    788868,
    978987,
    777887,
    866789,
    887978,
    898987,
    979888,
    866767,
    978798,
    788877,
    987999,
    897678,
    877888,
    788887,
    876977,
    668887,
    799796,
    988879,
    899778,
    796789,
    899888,
    878688,
    898878,
    989978,
    797979,
    788988,
    788897,
    987799,
    877998,
    888869,
    777877,
    687967,
    677677,
    896898,
    799898,
    899988,
    878987,
    786988,
    987878,
    777867,
    878988,
    788777,
    778688,
    997788,
    789879,
    888997,
    798889,
    789977,
    867776,
    999877,
    798867,
    788878,
    788978,
    887788,
    777889,
    667989,
    778979,
    788887,
    887797,
    898878,
    787888,
    787888,
    888878,
    788978,
    977986,
    777897,
    889788,
    876976,
    779797,
    999799,
    886986,
    999878,
    877888,
    878799,
    997788,
    877888,
    978878,
    987797,
    987999,
    877897,
    787789,
    988788,
    997888,
    869898,
    996879,
    789988,
    987898,
    978998,
    877878,
    988897,
    878789,
    988777,
    788788,
    879879,
    998888,
    779888,
    788977,
    897876,
    787788,
    877778,
    886779,
    786988,
    889688,
    898797,
    797899,
    889986,
    888879,
    689898,
    787788,
    767777,
    888877,
    798769,
    888777,
    788987,
    779988,
    789998,
    988888,
    899887,
    887787,
    787798,
    978788,
    998788,
    888888,
    678877,
    688879,
    678789,
    888779,
    987797,
    898868,
    788867,
    889689,
    987888,
    869888,
    877978,
    986788,
    867867,
    788779,
    988886,
    687797,
    888987,
    968779,
    978797,
    988778,
    869889,
    888998,
    898786,
    998688,
    787897,
    897879,
    787978,
    867988,
    888779,
    797889,
    887778,
    978899,
    887898,
    787779,
    888897,
    878878,
    977878,
    879988,
    778897,
    799788,
    888879,
    988779,
    879889,
    997989,
    778879,
    688889,
    797788,
    779786,
    987877,
    887876,
    767898,
    777879,
    989778,
    878877,
    788879,
    787798,
    879777,
    797877,
    868896,
    887887,
    887867,
    888987,
    878998,
    987777,
    698868,
    878897,
    977778,
    777988,
    788989,
    877788,
    786878,
    789787,
    898978,
    877787,
    977976,
    977898,
    876878,
    777798,
    988977,
    686888,
    987887,
    987878,
    988779,
    887788,
    787888,
    777897,
    787878,
    897888,
    978798,
    698787,
    678778,
    898687,
    887879,
    888777,
    886977,
    788788,
    999779,
    877788,
    989799,
    978789,
    877898,
    887788,
    986788,
    797997,
    898887,
    887888,
    799787,
    697898,
    898789,
    778888,
    777978,
    997989,
    879889,
    898688,
    777887,
    889697,
    877876,
    778879,
    888998,
    887888,
    798897,
    977778,
    669889,
    799889,
    977886,
    788777,
    798788,
    986679,
    798787,
    998798,
    887898,
    878888,
    889789,
    897887,
    878897,
    878789,
    788879,
    878998,
    797787,
    978798,
    987799,
    788787,
    886877,
    779868,
    989889,
    767977,
    687787,
    897777,
    988988,
    997989,
    896697,
    798788,
    877778,
    789887,
    896889,
    887796,
    888788,
    879677,
    897889,
    788977,
    898998,
    779788,
    788788,
    777887,
    888798,
    987898,
    978988,
    877778,
    968777,
    888998,
    899888,
    887889,
    887877,
    868898,
    987798,
    889978,
    687779,
    777888,
    877689,
    878888,
    988878,
    778878,
    897778,
    788878,
    777888,
    888788,
    877988,
    788897,
    889897,
    877978,
    799888,
    778888,
    867896,
    687877,
    898896,
    869778,
    887878,
    997767,
    789877,
    968887,
    868779,
    887688,
    888898,
    888969,
    789979,
    878799,
    877888,
    879998,
    798879,
    788898,
    766889,
    988777,
    777878,
    986797,
    679888,
    897878,
    879878,
    997687,
    989796,
    887777,
    889777,
    788888,
    996978,
    888888,
    778988,
    889788,
    889787,
    877788,
    788797,
    798998,
    887967,
    779798,
    797877,
    878887,
    798878,
    798888,
    878886,
    789878,
    987976,
    777898,
    787768,
    897798,
    887878,
    798878,
    787788,
    889697,
    678779,
    799998,
    789888,
    899797,
    867876,
    889878,
    878999,
    889778,
    787988,
    877977,
    889978,
    789978,
    888788,
    998999,
    997876,
    877788,
    788687,
    899997,
    789978,
    787987,
    998896,
    889998,
    888968,
    879789,
    778888,
    868789,
    899889,
    787886,
    767887,
    899788,
    798797,
    897888,
    879777,
    767777,
    787898,
    988788,
    898797,
    688777,
    988988,
    778987,
    789888,
    878978,
    777788,
    887887,
    799687,
    767898,
    677778,
    989988,
    879788,
    796876,
    888888,
    888786,
    988978,
    777799,
    778977,
    988877,
    897978,
    788676,
    778889,
    888887,
    989878,
    989897,
    868998,
    988798,
    897888,
    796767,
    978788,
    978897,
    687787,
    877898,
    888978,
    989877,
    976867,
    897887,
    776987,
    878968,
    787899,
    988787,
    897877,
    789876,
    779887,
    788779,
    876888,
    996888,
    789899,
    888997,
    997978,
    887789,
    798689,
    687869,
    777787,
    887889,
    798979,
    778988,
    787769,
    998778,
    879889,
    867888,
    879878,
    779898,
    899888,
    987987,
    979786,
    679799,
    787887,
    788879,
    768797,
    877978,
    979788,
    888796,
    878977,
    987987,
    888978,
    877887,
    769868,
    788877,
    888789,
    987668,
    877889,
    889877,
    889767,
    877968,
    888979,
    777887,
    789788,
    787788,
    877888,
    798879,
    778898,
    888888,
    889888,
    898888,
    688778,
    988777,
    988777,
    779798,
    777878,
    797887,
    796778,
    789888,
    888779,
    898877,
    778788,
    787667,
    787788,
    887887,
    788877,
    888879,
    887887,
    879788,
    876879,
    878689,
    786888,
    898876,
    877869,
    898787,
    877788,
    888889,
    687787,
    989869,
    878876,
    887878,
    679697,
    977777,
    787789,
    778989,
    787877,
    869878,
    977797,
    787888,
    888789,
    798968,
    998889,
    789798,
    989988,
    876998,
    889677,
    887769,
    879877,
    777877,
    787987,
    887887,
    878679,
    887986,
    988779,
    788887,
    787888,
    698787,
    687887,
    996787,
    888787,
    878888,
    788887,
    687878,
    878887,
    977887,
    877778,
    869897,
    989877,
    886878,
    766779,
    877778,
    877988,
    788976,
    789789,
    688788,
    889777,
    778887,
    788779,
    877988,
    897688,
    887899,
    888787,
    977887,
    778898,
    899887,
    897798,
    888888,
    897877,
    898887,
    889778,
    797896,
    778898,
    888868,
    996877,
    878889,
    798678,
    878777,
    887787,
    689999,
    788869,
    788777,
    988888,
    978778,
    786878,
    987899,
    788787,
    889789,
    897898,
    788898,
    897778,
    777679,
    888978,
    887887,
    887898,
    887887,
    986897,
    988887,
    898798,
    879889,
    987778,
    887787,
    888876,
    888887,
    798778,
    998878,
    799878,
    788789,
    699688,
    988778,
    887988,
    778898,
    978888,
    898677,
    768967,
    789778,
    688888,
    979988,
    886879,
    788879,
    977788,
    779778,
    789877,
    797788,
    978878,
    789888,
    998888,
    796896,
    877867,
    889899,
    977997,
    888799,
    787979,
    878788,
    978988,
    878888,
    777886,
    887888,
    778678,
    898877,
    767778,
    886878,
    896697,
    887787,
    867788,
    786899,
    777777,
    888897,
    796786,
    887987,
    997878,
    978788,
    899788,
    777788,
    866677,
    888878,
    777867,
    989888,
    878789,
    898988,
    878777,
    888888,
    787879,
    687896,
    889888,
    888777,
    998897,
    786876,
    988887,
    768976,
    767689,
    879776,
    887798,
    788888,
    796888,
    988898,
    977779,
    878779,
    889777,
    887978,
    897778,
    776798,
    989778,
    777898,
    976878,
    777977,
    788799,
    778887,
    778877,
    997887,
    867877,
    799879,
    787968,
    977988,
    779888,
    878789,
    888789,
    788777,
    998999,
    887877,
    798897,
    896797,
    877987,
    796878,
    888988,
    888797,
    887878,
    768997,
    798777,
    877797,
    978998,
    789776,
    768979,
    688786,
    977879,
    979887,
    787798,
    887679,
    778697,
    989788,
    799876,
    778777,
    888979,
    878978,
    777877,
    789688,
    789879,
    688987,
    778877,
    778779,
    877798,
    889787,
    877889,
    898887,
    888867,
    878789,
    988889,
    878877,
    888779,
    878878,
    978878,
    889778,
    798989,
    669898,
    877888,
    878677,
    878876,
    868887,
    789889,
    977787,
    977796,
    996887,
    778888,
    867989,
    799997,
    887798,
    889787,
    878868,
    888776,
    777787,
    798997,
    778898,
    989788,
    878988,
    886688,
    887878,
    787877,
    899989,
    888779,
    777797,
    877878,
    886789,
    886768,
    898777,
    799968,
    778786,
    778787,
    789698,
    888787,
    879887,
    787879,
    997988,
    789888,
    778987,
    777869,
    777778,
    987989,
    798977,
    979789,
    786999,
    779888,
    788887,
    967977,
    798786,
    788878,
    888897,
    787797,
    889779,
    987869,
    768978,
    889887,
    898878,
    788887,
    788786,
    798888,
    987778,
    887879,
    778688,
    789768,
    968887,
    996978,
    777899,
    788787,
    887898,
    968688,
    879879,
    887877,
    979787,
    687987,
    888879,
    976898,
    777886,
    977888,
    879989,
    678777,
    778788,
    777887,
    897788,
    797789,
    898687,
    799887,
    798777,
    777886,
    788987,
    777777,
    988967,
    777778,
    988998,
    687776,
    787778,
    888677,
    779778,
    798988,
    989778,
    876988,
    798988,
    687988,
    878777,
    887669,
    888896,
    999898,
    988887,
    677687,
    999879,
    967887,
    787867,
    777888,
    889799,
    778888,
    787879,
    779999,
    778887,
    688897,
    797989,
    887977,
    989697,
    977989,
    788787,
    989899,
    878899,
    778887,
    777899,
    887889,
    887696,
    879977,
    786988,
    869778,
    977798,
    788789,
    779698,
    877888,
    977897,
    967889,
    877978,
    878878,
    798777,
    987787,
    888988,
    888987,
    788878,
    767777,
    888767,
    887868,
    898788,
    888887,
    888688,
    897798,
    787878,
    788778,
    887879,
    887889,
    888687,
    877887,
    979776,
    788789,
    666977,
    868988,
    878879,
    978988,
    866887,
    987889,
    878988,
    888798,
    998978,
    988988,
    978878,
    678986,
    879888,
    779776,
    897778,
    898898,
    787978,
    989898,
    787787,
    788667,
    779688,
    799767,
    878878,
    887887,
    887888,
    877888,
    787867,
    789898,
    878997,
    897768,
    998789,
    977787,
    787798,
    769787,
    778798,
    778879,
    888777,
    867779,
    987977,
    786879,
    789878,
    778887,
    787998,
    988878,
    787877,
    789788,
    876899,
    787876,
    769878,
    888688,
    769988,
    778888,
    878788,
    688788,
    888786,
    899888,
    796878,
    697677,
    897789,
    888678,
    977889,
    877777,
    979778,
    778688,
    787787,
    889887,
    888789,
    887898,
    899798,
    777778,
    888788,
    697888,
    988779,
    787998,
    887898,
    878799,
    688886,
    688887,
    897697,
    887796,
    868788,
    887798,
    898787,
    887877,
    987786,
    787878,
    879889,
    877888,
    677797,
    887888,
    977788,
    768878,
    867887,
    989998,
    877778,
    898788,
    788898,
    877899,
    878789,
    979778,
    877887,
    878769,
    797967,
    777867,
    787797,
    888766,
    798796,
    988798,
    898968,
    999878,
    768778,
    889988,
    799798,
    898699,
    997798,
    779887,
    888787,
    767697,
    878898,
    768789,
    877877,
    878789,
    777988,
    887897,
    879888,
    888777,
    878798,
    978877,
    779888,
    779978,
    689898,
    787978,
    787678,
    979888,
    889798,
    978887,
    997888,
    778997,
    977798,
    797987,
    986879,
    878778,
    889778,
    777899,
    988877,
    887799,
    788677,
    877767,
    798798,
    878898,
    887778,
    878877,
    877888,
    778788,
    888788,
    879888,
    889788,
    798988,
    887887,
    888878,
    887777,
    887897,
    888787,
    788878,
    897889,
    787778,
    769787,
    967787,
    876779,
    988788,
    998677,
    769967,
    778989,
    777778,
    889878,
    888789,
    778888,
    887888,
    888798,
    776888,
    787968,
    789978,
    897678,
    888798,
    888787,
    878688,
    778888,
    767687,
    878986,
    898898,
    779777,
    768899,
    977899,
    779977,
    988889,
    788878,
    689887,
    987688,
    788897,
    988878,
    888977,
    977787,
    878879,
    988896,
    677878,
    677876,
    988868,
    877898,
    889987,
    788688,
    899888,
    978899,
    889887,
    899779,
    867989,
    786888,
    687888,
    878777,
    988798,
    779877,
    887888,
    688787,
    988877,
    888798,
    898888,
    889997,
    877887,
    988786,
    897798,
    889888,
    997887,
    987878,
    897778,
    987787,
    989878,
    978688,
    786878,
    778998,
    778879,
    797988,
    779988,
    878798,
    977778,
    889667,
    878886,
    878787,
    868868,
    878997,
    987978,
    888888,
    799788,
    876988,
    868898,
    867787,
    787878,
    787788,
    888787,
    889778,
    777887,
    888788,
    879979,
    887978,
    777897,
    789778,
    797897,
    877777,
    778777,
    868688,
    989987,
    978789,
    989778,
    898898,
    977867,
    898898,
    878899,
    867776,
    689898,
    888978,
    776989,
    887779,
    887688,
    877788,
    878798,
    899879,
    968877,
    887887,
    767989,
    868788,
    877898,
    899886,
    787787,
    988998,
    668898,
    797897,
    778889,
    989987,
    786768,
    867897,
    879878,
    777777,
    889776,
    797868,
    678877,
    797988,
    798987,
    898797,
    888687,
    999789,
    779788,
    797686,
    867786,
    788896,
    899797,
    987988,
    887786,
    787877,
    778879,
    979788,
    878778,
    877866,
    798878,
    988889,
    888687,
    797968,
    778878,
    888997,
    888877,
    888789,
    899769,
    798887,
    778788,
    788879,
    678777,
    778779,
    887897,
    787777,
    977787,
    888877,
    898897,
    886887,
    988878,
    686778,
    778889,
    989677,
    789978,
    889887,
    867678,
    878676,
    969777,
    988888,
    897698,
    889888,
    788888,
    878766,
    988767,
    898787,
    778789,
    787987,
    998777,
    886899,
    887988,
    888788,
    987797,
    778888,
    878888,
    978778,
    779989,
    778998,
    778698,
    789797,
    888978,
    978788,
    997877,
    787988,
    798777,
    788777,
    889877,
    787889,
    877787,
    978789,
    976989,
    878798,
    889697,
    867799,
    789869,
    887677,
    787779,
    889989,
    898987,
    878888,
    787897,
    887777,
    769879,
    688666,
    897679,
    778988,
    787797,
    688888,
    777978,
    879767,
    888997,
    778787,
    998788,
    989869,
    878778,
    869896,
    798977,
    689877,
    876776,
    899877,
    797998,
    798769,
    998877,
    786868,
    889677,
    687899,
    778788,
    889688,
    998879,
    879888,
    887878,
    767788,
    898877,
    887977,
    887788,
    888887,
    778887,
    988669,
    877878,
    999968,
    789887,
    898778,
    787797,
    888796,
    997887,
    789888,
    986876,
    778887,
    788789,
    888887,
    788786,
    897888,
    667687,
    698867,
    887888,
    686998,
    798879,
    768878,
    888888,
    789788,
    877978,
    797898,
    778699,
    777878,
    688788,
    788888,
    888878,
    878779,
    878888,
    887879,
    787899,
    778989,
    888689,
    977889,
    788787,
    798699,
    788897,
    777798,
    889988,
    788788,
    887886,
    977969,
    988998,
    968898,
    778977,
    868988,
    889978,
    899788,
    697889,
    978786,
    797997,
    798888,
    777887,
    989788,
    879987,
    787898,
    788988,
    978678,
    699898,
    697887,
    788667,
    669798,
    878897,
    878987,
    867767,
    779867,
    778898,
    868869,
    787988,
    889698,
    787977,
    788789,
    678888,
    778888,
    998888,
    998996,
    878787,
    888898,
    778889,
    878789,
    877898,
    888697,
    878898,
    978888,
    877877,
    867779,
    799787,
    678767,
    679888,
    887889,
    898888,
    987988,
    988779,
    988888,
    889987,
    778877,
    687779,
    978897,
    879878,
    889797,
    879889,
    879779,
    897888,
    789878,
    789887,
    786887,
    887879,
    979889,
    886889,
    698877,
    879897,
    887878,
    888878,
    787789,
    777787,
    988878,
    989988,
    987778,
    787798,
    878788,
    878868,
    897778,
    889797,
    788788,
    898776,
    898897,
    888799,
    788778,
    679879,
    788888,
    788789,
    698788,
    876989,
    877688,
    967787,
    779977,
    777887,
    997898,
    778889,
    787787,
    789776,
    877897,
    789777,
    677878,
    679868,
    778789,
    888888,
    878887,
    687777,
    868888,
    786898,
    788788,
    889789,
    997779,
    878788,
    876779,
    897899,
    797867,
    879889,
    897888,
    788888,
    887677,
    987868,
    797978,
    788777,
    888787,
    888788,
    887778,
    888887,
    797889,
    889987,
    888878,
    999788,
    878887,
    679777,
    776887,
    998677,
    988877,
    788978,
    889788,
    898788,
    977878,
    897888,
    696877,
    686797,
    887988,
    899889,
    778688,
    987889,
    686989,
    977786,
    879898,
    878888,
    878977,
    778888,
    887776,
    777887,
    798777,
    768887,
    876988,
    877678,
    897968,
    788898,
    879788,
    879878,
    778676,
    888888,
    878789,
    879778,
    787897,
    888789,
    798887,
    997888,
    688979,
    688797,
    888796,
    888997,
    898679,
    889788,
    977866,
    987877,
    887877,
    788889,
    888788,
    777698,
    969878,
    887889,
    788866,
    886997,
    998788,
    898887,
    878988,
    988777,
    877998,
    788778,
    688867,
    778887,
    777777,
    888898,
    788986,
    987968,
    678788,
    889798,
    888989,
    887797,
    976698,
    787878,
    877877,
    886877,
    788967,
    987886,
    698787,
    787786,
    877888,
    788878,
    767796,
    688877,
    878978,
    787777,
    878797,
    899797,
    897787,
    788778,
    889988,
    899768,
    686897,
    777888,
    788897,
    778876,
    777879,
    998887,
    899777,
    888886,
    689977,
    687887,
    999788,
    888778,
    877789,
    878978,
    777769,
    777778,
    776977,
    798688,
    988868,
    878777,
    879897,
    986987,
    898888,
    786779,
    998779,
    977868,
    988867,
    877877,
    898789,
    879878,
    779887,
    777878,
    887797,
    887797,
    877988,
    787897,
    899788,
    888767,
    988888,
    878767,
    977798,
    676778,
    777988,
    789897,
    786788,
    889678,
    788787,
    787879,
    777787,
    799888,
    988888,
    797898,
    899988,
    687878,
    788888,
    898888,
    888878,
    877698,
    779798,
    897678,
    978978,
    997787,
    787777,
    888977,
    786887,
    977778,
    787987,
    878988,
    887787,
    887977,
    978778,
    799888,
    898877,
    789698,
    898989,
    878777,
    999987,
    888989,
    878888,
    887988,
    789888,
    897879,
    977888,
    777878,
    878688,
    888888,
    978888,
    798878,
    678988,
    897969,
    877887,
    776777,
    879888,
    788878,
    788888,
    897898,
    979987,
    898769,
    778897,
    979997,
    879987,
    978898,
    867898,
    797779,
    988987,
    768877,
    978877,
    787798,
    888678,
    778777,
    697778,
    877867,
    877798,
    777786,
    879967,
    789788,
    888886,
    698898,
    798798,
    887889,
    787898,
    888988,
    987879,
    888787,
    886878,
    687778,
    776889,
    798889,
    867877,
    988698,
    776988,
    986788,
    998879,
    877887,
    987888,
    878899,
    876899,
    778878,
    787798,
    978778,
    869778,
    878788,
    778797,
    898898,
    977988,
    788878,
    878777,
    877777,
    888778,
    797878,
    768897,
    879879,
    777899,
    988887,
    898988,
    878679,
    879898,
    987878,
    888889,
    988888,
    888978,
    868888,
    988987,
    998887,
    778986,
    878877,
    889978,
    896688,
    778777,
    978767,
    778787,
    867888,
    778897,
    878867,
    878777,
    878688,
    788787,
    778888,
    798998,
    778879,
    889679,
    987786,
    987877,
    766676,
    887799,
    899988,
    899899,
    897767,
    889797,
    978878,
    897787,
    989967,
    988878,
    888997,
    777978,
    988788,
    787678,
    888879,
    789897,
    887877,
    978886,
    998978,
    889998,
    997997,
    788887,
    877878,
    798987,
    788797,
    798696,
    898868,
    776888,
    887978,
    777888,
    978768,
    778897,
    688876,
    896987,
    767886,
    789798,
    887898,
    897898,
    887777,
    778888,
    987877,
    669797,
    787898,
    879668,
    676888,
    987868,
    887879,
    998879,
    788889,
    978777,
    687777,
    799776,
    878877,
    876779,
    886879,
    797997,
    898788,
    897877,
    788789,
    777978,
    788977,
    768797,
    789787,
    678797,
    778787,
    878777,
    879777,
    788989,
    898798,
    878779,
    878877,
    787686,
    997986,
    778897,
    798878,
    888878,
    878978,
    877777,
    897888,
    687879,
    669687,
    767878,
    988788,
    788777,
    677988,
    699787,
    688977,
    788877,
    886688,
    876876,
    899798,
    988788,
    898678,
    777889,
    877988,
    798786,
    687998,
    978797,
    698879,
    668969,
    796867,
    888789,
    788887,
    778888,
    889879,
    868877,
    788787,
    768796,
    877898,
    677788,
    788887,
    978887,
    788867,
    997867,
    886997,
    887998,
    898988,
    878878,
    998888,
    887689,
    788887,
    877886,
    768779,
    878787,
    889697,
    766878,
    778699,
    678878,
    897878,
    799879,
    777987,
    986877,
    888978,
    888898,
    788896,
    987887,
    879888,
    888878,
    788798,
    686897,
    888899,
    876689,
    797886,
    998997,
    789876,
    988898,
    887887,
    887888,
    899889,
    678799,
    777787,
    998889,
    978688,
    788778,
    897677,
    899778,
    779988,
    777988,
    898777,
    868987,
    788889,
    787788,
    798898,
    888797,
    668787,
    878679,
    897888,
    898998,
    889887,
    887877,
    989878,
    978987,
    897776,
    997987,
    778888,
    797777,
    978697,
    888887,
    697878,
    878897,
    878777,
    888888,
    778898,
    788988,
    898787,
    868877,
    888788,
    977977,
    888697,
    988878,
    979888,
    879778,
    777886,
    776687,
    988877,
    879986,
    777888,
    897688,
    979888,
    868788,
    888887,
    787678,
    887977,
    778887,
    699778,
    778787,
    787968,
    877887,
    988799,
    788788,
    787798,
    898888,
    969978,
    788989,
    989788,
    886779,
    796799,
    799878,
    788679,
    787888,
    799877,
    879998,
    788988,
    878876,
    799888,
    989969,
    799878,
    866888,
    878779,
    778777,
    887898,
    878699,
    788788,
    888799,
    778977,
    779898,
    798888,
    788897,
    877877,
    898888,
    776888,
    879788,
    787878,
    887889,
    877897,
    886777,
    779877,
    797889,
    868698,
    898876,
    888889,
    898788,
    896789,
    996798,
    678887,
    888788,
    688787,
    777887,
    888878,
    897877,
    676797,
    979898,
    788888,
    987777,
    887979,
    996787,
    887789,
    779887,
    788988,
    887677,
    878788,
    879899,
    886879,
    677679,
    779878,
    787889,
    798887,
    867876,
    697878,
    878897,
    768988,
    788977,
    779878,
    877887,
    867887,
    889987,
    989778,
    789888,
    879887,
    888879,
    988677,
    999779,
    889778,
    778988,
    679777,
    788788,
    878979,
    779898,
    788887,
    788877,
    788788,
    968898,
    768788,
    888897,
    697678,
    999899,
    987779,
    796779,
    867897,
    989888,
    798889,
    778987,
    887867,
    898887,
    788888,
    778899,
    888799,
    897879,
    877897,
    678788,
    998877,
    679877,
    877887,
    898887,
    977989,
    787887,
    777698,
    987888,
    899787,
    887978,
    698787,
    987899,
    768898,
    888797,
    877986,
    878788,
    888778,
    878789,
    788887,
    688987,
    977879,
    878778,
    977888,
    787877,
    889878,
    788978,
    697887,
    778778,
    888768,
    778688,
    788777,
    877789,
    888789,
    876878,
    788768,
    778878,
    797977,
    876987,
    878678,
    788777,
    767778,
    888988,
    798889,
    777788,
    868788,
    786889,
    989788,
    897778,
    798988,
    798787,
    898887,
    696987,
    788898,
    988897,
    778798,
    778687,
    888778,
    886679,
    789986,
    878897,
    898697,
    778886,
    887888,
    786778,
    778888,
    898977,
    789787,
    788779,
    888879,
    788888,
    778987,
    777787,
    788887,
    888887,
    778787,
    778878,
    688888,
    988789,
    977788,
    778978,
    877888,
    877998,
    876787,
    968987,
    977887,
    787877,
    896787,
    896887,
    778877,
    787877,
    678899,
    879776,
    787879,
    687867,
    778998,
    698887,
    888876,
    787977,
    876778,
    788797,
    679867,
    878887,
    978798,
    778988,
    998899,
    887779,
    988988,
    768877,
    978998,
    889786,
    879867,
    887866,
    997898,
    976768,
    778887,
    988867,
    967877,
    788878,
    889789,
    878878,
    887787,
    778897,
    888878,
    878778,
    976797,
    778897,
    979988,
    897988,
    979798,
    898978,
    989778,
    788799,
    668968,
    887789,
    779888,
    797778,
    987888,
    869889,
    797888,
    677798,
    878978,
    999879,
    898877,
    987788,
    677899,
    878787,
    878988,
    789789,
    898888,
    887789,
    988887,
    787888,
    697786,
    768978,
    889788,
    787788,
    689887,
    877988,
    987999,
    898889,
    887786,
    777896,
    988776,
    798898,
    878789,
    968786,
    698888,
    877978,
    779878,
    879896,
    778897,
    788767,
    986879,
    889888,
    989987,
    889788,
    689878,
    878768,
    987897,
    888888,
    877978,
    978888,
    777988,
    989878,
    889998,
    677779,
    997879,
    888878,
    988778,
    868979,
    779977,
    997889,
    779787,
    887877,
    788888,
    988897,
    888787,
    898788,
    789888,
    888887,
    768987,
    889989,
    878877,
    899877,
    989887,
    988988,
    789977,
    687996,
    786866,
    898787,
    689777,
    877878,
    877897,
    877979,
    978787,
    787777,
    977788,
    788888,
    678887,
    876888,
    767788,
    787799,
    887698,
    888787,
    877788,
    778978,
    877776,
    678867,
    688878,
    887697,
    999878,
    699778,
    889797,
    878789,
    878678,
    868667,
    978888,
    798997,
    698788,
    788868,
    779997,
    779889,
    977687,
    788998,
    978766,
    877698,
    789989,
    888878,
    789788,
    798987,
    798788,
    787788,
    979979,
    788997,
    967777,
    878878,
    879678,
    878888,
    897887,
    867779,
    879897,
    878889,
    898678,
    878878,
    878887,
    887889,
    888789,
    898788,
    786898,
    977888,
    978869,
    888897,
    799878,
    799788,
    778689,
    886798,
    896977,
    677778,
    987878,
    897879,
    669888,
    888787,
    777788,
    889967,
    977887,
    877888,
    779689,
    988888,
    879888,
    788777,
    889767,
    889797,
    787797,
    889877,
    888887,
    789788,
    688879,
    787678,
    699879,
    787787,
    998888,
    979787,
    878878,
    888798,
    867987,
    988869,
    877788,
    998978,
    788788,
    988878,
    788797,
    977787,
    796988,
    887878,
    887987,
    899969,
    777887,
    779778,
    988688,
    989898,
    799988,
    876798,
    988779,
    797878,
    676686,
    978788,
    788797,
    777977,
    878689,
    879897,
    897878,
    788788,
    697987,
    887797,
    999798,
    789899,
    687677,
    977888,
    877679,
    777788,
    778789,
    988989,
    778877,
    877788,
    868789,
    888677,
    777888,
    977899,
    888989,
    887797,
    797878,
    687987,
    779986,
    779788,
    789787,
    978877,
    778878,
    786888,
    897988,
    899897,
    687798,
    977887,
    897878,
    997788,
    888789,
    688878,
    787877,
    879898,
    876988,
    889887,
    877798,
    877868,
    789698,
    797988,
    888887,
    888878,
    887788,
    778777,
    769889,
    988897,
    898869,
    788868,
    979888,
    678888,
    777898,
    989788,
    787997,
    999888,
    977778,
    888979,
    977778,
    687788,
    869877,
    888899,
    778887,
    879888,
    888788,
    798878,
    888878,
    789799,
    798787,
    788898,
    899877,
    876667,
    789787,
    888897,
    978887,
    768787,
    877899,
    898888,
    788977,
    887887,
    887777,
    788689,
    877889,
    777987,
    888888,
    888889,
    988878,
    788788,
    798777,
    779878,
    778887,
    886887,
    788987,
    887998,
    876788,
    877788,
    887877,
    778978,
    888988,
    787777,
    899888,
    888888,
    797688,
    768989,
    878987,
    778879,
    987699,
    887888,
    887797,
    888788,
    877786,
    778988,
    798898,
    968887,
    878876,
    788787,
    888787,
    896978,
    898878,
    677778,
    878788,
    888888,
    768987,
    876997,
    797777,
    887898,
    689789,
    977699,
    878979,
    888777,
    887779,
    887788,
    988778,
    777789,
    697898,
    777878,
    888777,
    888887,
    887797,
    787888,
    998786,
    779987,
    879788,
    978779,
    887777,
    787667,
    878787,
    668897,
    776868,
    876797,
    988797,
    988787,
    678789,
    878877,
    898778,
    978897,
    789897,
    977988,
    998897,
    977898,
    889868,
    988788,
    877796,
    797798,
    788897,
    987787,
    686887,
    768888,
    877986,
    877778,
    696788,
    888799,
    878767,
    887987,
    877766,
    788887,
    766989,
    977687,
    778986,
    878877,
    887877,
    797887,
    888777,
    777679,
    889887,
    877877,
    776788,
    989797,
    898888,
    878777,
    888877,
    998869,
    897877,
    789776,
    698888,
    767688,
    989796,
    777878,
    879887,
    787779,
    878888,
    876888,
    786878,
    787877,
    997987,
    878878,
    777898,
    987878,
    878778,
    887789,
    878778,
    767887,
    878997,
    877798,
    876777,
    889878,
    888687,
    887878,
    787987,
    878787,
    989979,
    789788,
    886787,
    878679,
    687887,
    788977,
    878878,
    987899,
    886878,
    779898,
    988997,
    876798,
    978777,
    787998,
    987767,
    897888,
    998889,
    888778,
    886797,
    899888,
    778777,
    978998,
    788787,
    898897,
    788999,
    788878,
    888978,
    788679,
    977878,
    887678,
    888888,
    778888,
    877888,
    877888,
    878788,
    888878,
    888888,
    678987,
    697898,
    888878,
    788887,
    778969,
    889688,
    988888,
    787878,
    688868,
    899889,
    787788,
    788889,
    778877,
    787978,
    778877,
    767989,
    778878,
    777788,
    988777,
    879889,
    777787,
    779867,
    878887,
    899778,
    887698,
    888888,
    777886,
    777799,
    788878,
    988787,
    888997,
    788998,
    788697,
    989967,
    989877,
    897877,
    879868,
    988887,
    788878,
    888789,
    698989,
    687979,
    887998,
    978797,
    887778,
    978877,
    797888,
    788799,
    788988,
    789788,
    899987,
    888889,
    678988,
    799897,
    888878,
    878697,
    888777,
    877988,
    989978,
    988777,
    896697,
    768887,
    889787,
    978788,
    797789,
    988777,
    789889,
    888899,
    879878,
    888888,
    889889,
    887898,
    688897,
    799798,
    888797,
    887888,
    868789,
    768876,
    998888,
    787897,
    887888,
    878869,
    878867,
    886899,
    787977,
    888987,
    888879,
    779687,
    998788,
    688888,
    878677,
    798887,
    788876,
    778997,
    978988,
    897788,
    788798,
    788878,
    988977,
    888677,
    877778,
    987898,
    889787,
    878988,
    899887,
    898978,
    888886,
    679679,
    878878,
    898997,
    769889,
    798697,
    888979,
    789879,
    898787,
    889968,
    788977,
    898877,
    778767,
    698786,
    989787,
    969788,
    997878,
    787998,
    897788,
    888978,
    668777,
    897877,
    978898,
    879887,
    999797,
    878877,
    888896,
    878879,
    889897,
    887789,
    787888,
    889888,
    788777,
    868778,
    888787,
    879888,
    799969,
    787998,
    878798,
    787788,
    787887,
    988977,
    899787,
    889788,
    898977,
    977987,
    687887,
    878789,
    787778,
    768879,
    789889,
    878787,
    687877,
    899898,
    879679,
    899889,
    898787,
    897787,
    898788,
    897799,
    988679,
    979779,
    767779,
    888997,
    868988,
    887797,
    878767,
    887869,
    788679,
    777888,
    787797,
    788888,
    799877,
    878789,
    787987,
    896998,
    868967,
    879889,
    779878,
    878687,
    987878,
    788777,
    987888,
    887997,
    997788,
    886987,
    888777,
    968978,
    989898,
    978997,
    768888,
    796979,
    898897,
    997979,
    789999,
    988987,
    776889,
    878986,
    778899,
    888879,
    887877,
    789788,
    897689,
    889898,
    977788,
    777887,
    867878,
    687998,
    887776,
    788779,
    796988,
    787988,
    898788,
    778777,
    798979,
    687988,
    978677,
    988987,
    978797,
    877977,
    897798,
    776788,
    769797,
    887788,
    768977,
    687888,
    876998,
    976776,
    988996,
    789886,
    977899,
    887886,
    987867,
    797688,
    869879,
    987798,
    897898,
    787998,
    887788,
    776889,
    778897,
    987889,
    979877,
    997887,
    877887,
    789888,
    887899,
    979787,
    778987,
    789788,
    779888,
    987799,
    888878,
    888878,
    987798,
    867688,
    788779,
    988867,
    799999,
    999888,
    789788,
    888888,
    689988,
    879979,
    889788,
    799987,
    887886,
    776787,
    778787,
    877876,
    886878,
    888889,
    886778,
    888889,
    889797,
    767787,
    687889,
    678788,
    889998,
    797776,
    897888,
    977777,
    788779,
    888979,
    799888,
    878898,
    788789,
    877897,
    787877,
    998978,
    677877,
    878886,
    788788,
    877877,
    988777,
    888888,
    887879,
    868878,
    798779,
    878878,
    986888,
    897878,
    778786,
    788988,
    888868,
    778988,
    897788,
    879888,
    888889,
    879776,
    769799,
    879788,
    898877,
    797878,
    977998,
    898967,
    787989,
    687887,
    779788,
    978698,
    988787,
    698867,
    778788,
    887978,
    778887,
    777878,
    978889,
    766787,
    968768,
    899898,
    889989,
    778678,
    778878,
    889799,
    776798,
    879878,
    789767,
    766778,
    987988,
    889787,
    897777,
    888898,
    987989,
    798878,
    978869,
    877897,
    899777,
    889977,
    767888,
    887687,
    787899,
    989978,
    978778,
    866878,
    778999,
    677878,
    887798,
    778889,
    876779,
    977788,
    898878,
    877879,
    777789,
    988888,
    887989,
    988888,
    778998,
    896787,
    799787,
    778787,
    898689,
    888898,
    869799,
    788988,
    786787,
    886697,
    898988,
    898687,
    987778,
    699987,
    877889,
    797678,
    876988,
    887888,
    886887,
    869787,
    889777,
    987877,
    788889,
    887876,
    688888,
    797788,
    786788,
    789778,
    977889,
    987897,
    797988,
    778777,
    798877,
    888699,
    788777,
    968886,
    877888,
    987777,
    789789,
    788978,
    987778,
    987878,
    878797,
    779877,
    889887,
    877878,
    866776,
    778999,
    887779,
    869777,
    877869,
    898878,
    778888,
    976679,
    799789,
    768879,
    887797,
    878887,
    888788,
    798767,
    877779,
    988976,
    797987,
    788878,
    798877,
    878877,
    877987,
    877868,
    887899,
    768889,
    787799,
    898778,
    797877,
    779876,
    998798,
    788888,
    797788,
    678789,
    887789,
    788989,
    787887,
    789678,
    897778,
    788888,
    989786,
    777888,
    989878,
    788988,
    988999,
    797787,
    877897,
    789887,
    777878,
    688777,
    798779,
    787989,
    686797,
    978898,
    778787,
    788797,
    887887,
    788898,
    788879,
    888977,
    898878,
    776888,
    787888,
    976888,
    887998,
    987798,
    687788,
    787888,
    778887,
    899987,
    766778,
    897888,
    788878,
    788797,
    888986,
    788988,
    888877,
    888799,
    778969,
    786799,
    778879,
    897878,
    888988,
    998897,
    889797,
    789879,
    978888,
    787779,
    888778,
    888877,
    888799,
    878888,
    968788,
    978887,
    988978,
    869788,
    886797,
    769769,
    896887,
    979888,
    787779,
    888897,
    767889,
    898888,
    879896,
    778789,
    967877,
    986678,
    778677,
    887778,
    767697,
    778889,
    788878,
    877776,
    777798,
    799867,
    878987,
    988778,
    788978,
    779888,
    988788,
    778968,
    778779,
    877789,
    889878,
    897869,
    887899,
    778897,
    887887,
    887869,
    778878,
    887778,
    786799,
    786788,
    877988,
    979977,
    997798,
    898798,
    878899,
    778887,
    868787,
    899787,
    778677,
    777879,
    869887,
    768868,
    788797,
    788879,
    977889,
    878987,
    888877,
    997697,
    799988,
    799979,
    878898,
    788897,
    777899,
    777778,
    978987,
    788988,
    888889,
    888978,
    798977,
    898897,
    888888,
    977899,
    697787,
    978877,
    777788,
    688888,
    987877,
    888977,
    886797,
    977898,
    778798,
    679978,
    888797,
    898877,
    877786,
    878788,
    789867,
    886777,
    968896,
    977879,
    889796,
    988779,
    988877,
    879787,
    878797,
    887877,
    877877,
    888889,
    898968,
    899989,
    878799,
    888888,
    879897,
    899867,
    768898,
    899789,
    877788,
    898899,
    897888,
    887877,
    798687,
    887777,
    877888,
    887869,
    977768,
    998978,
    767989,
    788878,
    898887,
    988899,
    786777,
    879888,
    788889,
    887877,
    798988,
    777888,
    897988,
    889779,
    898887,
    778777,
    767989,
    888967,
    787898,
    697988,
    879697,
    778688,
    877987,
    687977,
    888888,
    688767,
    787979,
    888887,
    898878,
    888987,
    788698,
    978889,
    797876,
    887877,
    768798,
    768869,
    788677,
    998889,
    979879,
    988878,
    788968,
    998987,
    888787,
    878989,
    987889,
    878886,
    878877,
    998897,
    878876,
    888889,
    798788,
    778878,
    786879,
    678978,
    777878,
    877988,
    777989,
    878897,
    888968,
    787888,
    987778,
    778887,
    887799,
    889977,
    888989,
    876898,
    886787,
    977879,
    888878,
    989787,
    887988,
    879877,
    787977,
    879788,
    788879,
    999867,
    787888,
    798787,
    899778,
    788687,
    867897,
    997788,
    768787,
    879789,
    686887,
    989787,
    978789,
    877876,
    799889,
    869898,
    877679,
    978887,
    888878,
    987777,
    798878,
    887979,
    787879,
    888788,
    878879,
    677887,
    778889,
    778887,
    777778,
    778988,
    876967,
    878777,
    697787,
    778987,
    979898,
    788888,
    898997,
    988778,
    778676,
    997877,
    898788,
    877788,
    878887,
    888887,
    787788,
    887977,
    777887,
    977798,
    797888,
    898889,
    788888,
    778877,
    886888,
    767887,
    898877,
    798678,
    878888,
    786788,
    788987,
    888877,
    786897,
    898788,
    997786,
    878878,
    987988,
    868987,
    997788,
    878977,
    778887,
    688878,
    776797,
    787888,
    997878,
    788689,
    977878,
    789677,
    889988,
    898777,
    887778,
    779987,
    778679,
    998998,
    777778,
    878878,
    778689,
    787878,
    879889,
    687977,
    877897,
    888978,
    996888,
    777768,
    889878,
    889877,
    878977,
    887777,
    989778,
    878777,
    878698,
    687877,
    876667,
    889979,
    889789,
    679988,
    878778,
    876998,
    887789,
    886888,
    888888,
    977678,
    997888,
    677796,
    868788,
    877796,
    889877,
    777888,
    688778,
    797987,
    888788,
    889788,
    778798,
    878789,
    777888,
    878778,
    789779,
    888898,
    877677,
    889778,
    878888,
    788988,
    979898,
    789877,
    888998,
    978788,
    877877,
    869787,
    988778,
    888888,
    888887,
    968698,
    888888,
    888888,
    978988,
    777887,
    888789,
    877888,
    989897,
    888889,
    889898,
    688797,
    677887,
    889878,
    977998,
    879778,
    897887,
    787878,
    799888,
    987787,
    768889,
    988889,
    987887,
    888887,
    798789,
    987878,
    797799,
    768788,
    788888,
    688787,
    887877,
    778888,
    898977,
    877878,
    878869,
    888878,
    697968,
    878798,
    888888,
    879887,
    779789,
    798878,
    897787,
    779888,
    977878,
    787987,
    797989,
    798978,
    887887,
    788886,
    777787,
    778898,
    899898,
    788767,
    888889,
    879777,
    988998,
    888779,
    888987,
    968898,
    988777,
    888887,
    878797,
    788798,
    788868,
    987878,
    878788,
    879888,
    988698,
    878776,
    877889,
    689799,
    979788,
    778987,
    777767,
    988876,
    777788,
    898878,
    787789,
    778988,
    767999,
    988969,
    878786,
    788668,
    777877,
    879878,
    899889,
    877687,
    898797,
    777798,
    878977,
    869898,
    678888,
    997879,
    777888,
    886789,
    879788,
    887979,
    977879,
    998798,
    687788,
    778987,
    798878,
    777898,
    897889,
    879677,
    978888,
    678866,
    878778,
    877677,
    897869,
    879897,
    677787,
    777998,
    988778,
    887789,
    778878,
    888898,
    977777,
    988899,
    978869,
    897877,
    887678,
    887698,
    767979,
    877788,
    776767,
    788878,
    887897,
    867789,
    987789,
    778768,
    788988,
    998989,
    999778,
    789877,
    787678,
    667787,
    777877,
    988878,
    788878,
    787977,
    978796,
    789987,
    879698,
    887876,
    788779,
    987889,
    997986,
    988779,
    998877,
    998888,
    778877,
    877867,
    878788,
    877888,
    766976,
    788887,
    778767,
    877878,
    898987,
    887898,
    877788,
    887889,
    988779,
    777979,
    778789,
    887887,
    988988,
    797998,
    789977,
    777867,
    998969,
    787876,
    697888,
    877977,
    798788,
    889687,
    898788,
    667977,
    687868,
    798678,
    779787,
    888777,
    888888,
    688897,
    887888,
    868988,
    788787,
    888988,
    877787,
    888776,
    877798,
    878889,
    889788,
    987688,
    889988,
    787789,
    778887,
    978679,
    789888,
    777787,
    976898,
    689787,
    778979,
    886876,
    887968,
    887878,
    786788,
    788887,
    789988,
    677786,
    889788,
    788788,
    988999,
    798877,
    977777,
    887678,
    888999,
    988787,
    879778,
    897789,
    767696,
    788788,
    977888,
    987778,
    788767,
    779787,
    787778,
    888696,
    779786,
    888787,
    987888,
    887977,
    796979,
    778899,
    998777,
    668888,
    979898,
    688878,
    788897,
    788788,
    878799,
    787899,
    778977,
    888677,
    977787,
    988787,
    988896,
    887787,
    897687,
    986788,
    789998,
    887788,
    897987,
    879787,
    869779,
    877988,
    677989,
    886986,
    778877,
    687898,
    998996,
    889979,
    798777,
    878888,
    968988,
    888878,
    877988,
    888879,
    799997,
    778897,
    896976,
    887888,
    898899,
    989887,
    787897,
    886887,
    888978,
    777778,
    998777,
    778898,
    777878,
    899978,
    987987,
    998796,
    896878,
    788799,
    797789,
    886677,
    868887,
    898987,
    789888,
    898778,
    688797,
    979997,
    789877,
    879877,
    987979,
    989778,
    788787,
    688888,
    979876,
    979789,
    698798,
    888777,
    897899,
    787889,
    989767,
    878778,
    987879,
    886886,
    887868,
    786868,
    878796,
    697898,
    777779,
    966797,
    777779,
    899898,
    897798,
    898878,
    978779,
    778778,
    887778,
    787978,
    898777,
    688986,
    777899,
    887887,
    778879,
    786987,
    787788,
    687889,
    696987,
    899897,
    878787,
    789987,
    897887,
    897887,
    767798,
    798969,
    799777,
    897787,
    887988,
    768978,
    878778,
    998788,
    898868,
    787896,
    687789,
    888889,
    776787,
    988777,
    967888,
    976778,
    988889,
    779897,
    888789,
    778998,
    878999,
    789798,
    779898,
    879998,
    889878,
    879879,
    988888,
    979798,
    887798,
    787787,
    777889,
    988996,
    976889,
    798788,
    879698,
    798797,
    878867,
    889988,
    988899,
    878677,
    786879,
    787887,
    788887,
    888769,
    697889,
    978797,
    799798,
    789889,
    877887,
    988899,
    787799,
    779889,
    888787,
    878778,
    888897,
    879988,
    878787,
    988887,
    777897,
    898888,
    869988,
    987877,
    988778,
    788769,
    977678,
    969798,
    877897,
    796888,
    697677,
    778897,
    867788,
    968867,
    887977,
    779688,
    898777,
    988778,
    898699,
    877798,
    887879,
    787997,
    888898,
    787878,
    879899,
    797778,
    778767,
    898787,
    788988,
    886778,
    977977,
    977679,
    888989,
    878879,
    898776,
    798789,
    798987,
    787896,
    978789,
    677778,
    879987,
    898888,
    888788,
    788987,
    897787,
    878787,
    887989,
    798978,
    987889,
    878988,
    877787,
    888988,
    876988,
    778788,
    896877,
    777777,
    787989,
    787779,
    767999,
    988789,
    878797,
    999968,
    768787,
    768997,
    788888,
    697888,
    979687,
    888768,
    899899,
    888778,
    997898,
    779898,
    697898,
    889888,
    788787,
    779687,
    887967,
    999897,
    979778,
    767778,
    899688,
    988889,
    877987,
    878978,
    898887,
    687888,
    879778,
    778887,
    876788,
    787787,
    798878,
    877888,
    867878,
    789888,
    887899,
    787779,
    899878,
    988897,
    767898,
    788798,
    898779,
    888878,
    869799,
    789878,
    877788,
    798868,
    676799,
    876789,
    777998,
    887689,
    988988,
    788997,
    988898,
    786877,
    786788,
    768789,
    989786,
    878879,
    876677,
    799768,
    978699,
    888678,
    788777,
    787979,
    889687,
    898988,
    787778,
    898688,
    679878,
    788986,
    889879,
    897877,
    887778,
    967777,
    887888,
    896879,
    779799,
    779777,
    888778,
    887868,
    868888,
    886798,
    879787,
    879887,
    778878,
    798897,
    997878,
    988877,
    788988,
    777787,
    979997,
    896787,
    897789,
    888989,
    988778,
    898886,
    789777,
    798887,
    777968,
    797978,
    886988,
    789778,
    886789,
    788688,
    878879,
    887796,
    777767,
    788888,
    787797,
    996889,
    877988,
    889678,
    997888,
    778898,
    788797,
    779788,
    877776,
    888796,
    897788,
    677878,
    888988,
    877788,
    698777,
    878888,
    886688,
    889977,
    897778,
    878877,
    789789,
    876879,
    977977,
    788888,
    788788,
    878886,
    777999,
    888798,
    878888,
    998767,
    889789,
    889888,
    887688,
    889788,
    898887,
    877988,
    887988,
    798777,
    868779,
    897899,
    968788,
    889788,
    778978,
    778888,
    799698,
    897878,
    887798,
    788689,
    988888,
    877886,
    978768,
    787767,
    867889,
    798788,
    889767,
    789986,
    779978,
    887876,
    688887,
    797767,
    997988,
    779999,
    877878,
    787677,
    788998,
    876988,
    886986,
    878788,
    899888,
    777987,
    778787,
    977868,
    887797,
    877987,
    878889,
    987978,
    798778,
    988786,
    779897,
    788877,
    787877,
    667987,
    779787,
    897797,
    879688,
    877888,
    987788,
    787879,
    888888,
    988786,
    887787,
    977687,
    889789,
    688979,
    896878,
    887988,
    878787,
    688788,
    788797,
    788898,
    777797,
    789878,
    799898,
    788867,
    888888,
    968788,
    778897,
    788998,
    887788,
    877779,
    778787,
    976787,
    778988,
    877879,
    879877,
    988778,
    786779,
    977878,
    887788,
    776888,
    777789,
    876997,
    787988,
    887876,
    888898,
    987868,
    888987,
    788897,
    888897,
    898988,
    987768,
    968787,
    878898,
    787678,
    889988,
    988878,
    787978,
    998789,
    887889,
    889889,
    887888,
    888787,
    887887,
    897798,
    898988,
    799788,
    887779,
    879867,
    888978,
    777787,
    997878,
    788888,
    988787,
    967987,
    886878,
    668888,
    888768,
    788888,
    886799,
    787787,
    988867,
    767787,
    788869,
    888798,
    877778,
    878887,
    688888,
    877787,
    797697,
    888799,
    787888,
    668977,
    877878,
    786777,
    878787,
    887878,
    978869,
    869897,
    787888,
    878798,
    899897,
    777797,
    779787,
    788787,
    788878,
    887888,
    798888,
    799788,
    798787,
    978788,
    769778,
    878977,
    677988,
    697786,
    788898,
    788887,
    687888,
    788697,
    788888,
    797988,
    779898,
    888788,
    787877,
    868998,
    999989,
    697987,
    878878,
    867897,
    699767,
    798888,
    879978,
    789978,
    886697,
    768789,
    769986,
    777878,
    767788,
    798778,
    879787,
    888888,
    778768,
    888877,
    778887,
    979989,
    788888,
    788988,
    688788,
    787988,
    888668,
    888799,
    878879,
    886778,
    689888,
    777787,
    788787,
    777698,
    786787,
    876978,
    779798,
    797789,
    886898,
    798888,
    788987,
    876988,
    888868,
    897888,
    878889,
    788888,
    999888,
    787787,
    787787,
    998779,
    788878,
    689988,
    798989,
    798778,
    777786,
    987768,
    876898,
    688788,
    768898,
    997978,
    688697,
    786978,
    988877,
    878779,
    967988,
    889889,
    878879,
    798887,
    788877,
    966977,
    777886,
    698886,
    887689,
    778799,
    968778,
    778888,
    777698,
    888968,
    986978,
    686878,
    898698,
    888897,
    888988,
    899777,
    887798,
    988878,
    887878,
    777899,
    798887,
    778977,
    888898,
    786979,
    879997,
    669789,
    877886,
    888886,
    797978,
    978988,
    898978,
    788987,
    877888,
    788888,
    888979,
    877878,
    688889,
    988788,
    678888,
    898777,
    687797,
    888788,
    977879,
    789789,
    799878,
    888787,
    787876,
    898767,
    798788,
    788798,
    878887,
    889978,
    987878,
    988978,
    879778,
    899997,
    868888,
    879888,
    869888,
    886899,
    997878,
    887987,
    888779,
    879878,
    778887,
    788788,
    997787,
    887969,
    979889,
    767868,
    767778,
    978998,
    977788,
    896978,
    886888,
    898876,
    799788,
    979896,
    878688,
    787788,
    779977,
    988787,
    779989,
    797878,
    988788,
    778888,
    986878,
    678787,
    977778,
    889688,
    888679,
    887978,
    889898,
    888776,
    868777,
    889779,
    887888,
    888779,
    876988,
    887877,
    767879,
    768887,
    887998,
    887789,
    798878,
    778889,
    879878,
    797989,
    978896,
    898899,
    688987,
    798977,
    988788,
    898967,
    879778,
    888898,
    877779,
    888878,
    688988,
    999887,
    878899,
    778879,
    777978,
    988787,
    788698,
    987988,
    768898,
    988887,
    686697,
    867988,
    888678,
    898787,
    889889,
    897797,
    988878,
    898777,
    788988,
    889788,
    887877,
    869886,
    888788,
    777786,
    788989,
    688777,
    796998,
    797888,
    999898,
    878678,
    797977,
    967879,
    887779,
    796978,
    888889,
    898897,
    787886,
    787888,
    688987,
    777879,
    897799,
    778876,
    898888,
    789787,
    789889,
    877877,
    887787,
    879888,
    878787,
    787697,
    797887,
    887787,
    787979,
    977799,
    777878,
    888888,
    888889,
    878879,
    879788,
    986879,
    899789,
    678988,
    897977,
    687778,
    987899,
    988968,
    886777,
    998777,
    686899,
    889799,
    988878,
    788998,
    887997,
    788789,
    887877,
    988799,
    687878,
    888777,
    766978,
    797899,
    778998,
    777778,
    977888,
    878788,
    787876,
    886899,
    967988,
    798797,
    899689,
    887878,
    887887,
    889889,
    888888,
    889788,
    878889,
    689887,
    879898,
    798676,
    889777,
    889978,
    688787,
    787878,
    887897,
    797677,
    687678,
    999778,
    777788,
    787676,
    788779,
    877788,
    888897,
    878897,
    788877,
    876997,
    886799,
    898778,
    888888,
    887799,
    986698,
    987888,
    977877,
    889799,
    888689,
    789788,
    878697,
    788888,
    788877,
    977778,
    887797,
    886888,
    998877,
    969787,
    898898,
    769888,
    868987,
    796789,
    888778,
    887797,
    778799,
    889787,
    777779,
    677887,
    987889,
    868978,
    867879,
    887887,
    798678,
    769988,
    778887,
    897888,
    777988,
    779977,
    877788,
    788989,
    889797,
    688877,
    787888,
    978788,
    869998,
    797997,
    997688,
    899989,
    888769,
    777877,
    799789,
    799787,
    778898,
    678988,
    786897,
    877796,
    889877,
    679999,
    888798,
    697887,
    978887,
    899999,
    688988,
    889899,
    798896,
    887979,
    789978,
    879887,
    788998,
    988768,
    797688,
    798778,
    999767,
    798778,
    887799,
    777977,
    978888,
    777899,
    777977,
    688797,
    887888,
    787978,
    978878,
    887888,
    978667,
    797788,
    877988,
    878777,
    877889,
    977888,
    868888,
    796888,
    777888,
    778878,
    789896,
    877986,
    788978,
    878978,
    798798,
    887688,
    786897,
    889688,
    779896,
    878778,
    886688,
    787897,
    898789,
    988789,
    889987,
    879877,
    777996,
    688687,
    778797,
    699797,
    897787,
    777788,
    768789,
    888797,
    776788,
    997886,
    678888,
    998987,
    869877,
    897887,
    777869,
    799687,
    899887,
    878788,
    897888,
    787687,
    877879,
    978698,
    779989,
    797788,
    787878,
    987889,
    789889,
    788897,
    888887,
    689988,
    686688,
    789998,
    677988,
    878898,
    899896,
    679888,
    989898,
    999699,
    786888,
    688779,
    796988,
    799898,
    988788,
    778898,
    897888,
    687799,
    786888,
    779677,
    798786,
    787988,
    878876,
    778978,
    898899,
    797787,
    898887,
    788876,
    897978,
    879887,
    688979,
    978888,
    767787,
    888888,
    788978,
    676877,
    877797,
    868799,
    888787,
    867878,
    787887,
    889887,
    878969,
    878786,
    778868,
    878689,
    976787,
    877879,
    976989,
    778799,
    868878,
    869887,
    887789,
    868887,
    877987,
    887777,
    798887,
    689778,
    979789,
    879987,
    888888,
    779987,
    789688,
    897877,
    998888,
    886889,
    888988,
    887778,
    788897,
    797898,
    977878,
    988787,
    877879,
    788898,
    988687,
    998788,
    886988,
    887776,
    969968,
    899986,
    997867,
    877878,
    989978,
    898797,
    877779,
    777776,
    798887,
    777988,
    887786,
    768877,
    787987,
    879687,
    887878,
    888898,
    778877,
    887788,
    988997,
    988787,
    888888,
    978787,
    997786,
    978998,
    889879,
    888866,
    878779,
    897788,
    787989,
    877797,
    869899,
    897778,
    877788,
    787969,
    787988,
    887888,
    979877,
    987988,
    699799,
    899779,
    798688,
    877769,
    888888,
    997778,
    878887,
    879876,
    886879,
    789887,
    786888,
    787979,
    787896,
    877978,
    966767,
    888987,
    878988,
    889889,
    778789,
    898878,
    688989,
    898987,
    868897,
    788897,
    888888,
    887978,
    697787,
    887779,
    798777,
    777879,
    878887,
    888989,
    977778,
    896967,
    997667,
    687898,
    886888,
    788798,
    987798,
    797767,
    978679,
    987886,
    778788,
    878888,
    788888,
    989789,
    897787,
    788998,
    888699,
    798877,
    868777,
    786978,
    887778,
    788789,
    769687,
    797778,
    878988,
    886889,
    887887,
    879987,
    899787,
    768888,
    888879,
    799889,
    689887,
    778797,
    777787,
    678779,
    978798,
    787998,
    988787,
    886788,
    888789,
    878899,
    788897,
    797878,
    788888,
    688976,
    888688,
    888877,
    878869,
    788887,
    887788,
    768787,
    699889,
    787789,
    889977,
    678977,
    887988,
    987787,
    888798,
    968988,
    787789,
    876898,
    989788,
    698987,
    777898,
    887998,
    797986,
    797878,
    877899,
    997877,
    889999,
    789679,
    878888,
    887787,
    888789,
    688789,
    988888,
    868898,
    898768,
    977778,
    888889,
    878987,
    886798,
    898779,
    787777,
    798778,
    877978,
    888886,
    887889,
    878886,
    887788,
    998677,
    779878,
    977778,
    889887,
    798777,
    696888,
    777989,
    987887,
    699876,
    879977,
    977887,
    887767,
    677799,
    779988,
    988867,
    887887,
    898878,
    797788,
    887779,
    879887,
    989787,
    977679,
    777867,
    888798,
    899877,
    788878,
    878988,
    887887,
    889877,
    897778,
    768878,
    986877,
    688886,
    796797,
    788888,
    767788,
    797889,
    888798,
    789789,
    877878,
    789987,
    877887,
    888778,
    899678,
    976987,
    979877,
    877876,
    786989,
    879978,
    779987,
    977897,
    788869,
    787888,
    798888,
    798987,
    877778,
    998879,
    888988,
    787878,
    887887,
    987968,
    888789,
    788868,
    878879,
    777877,
    678887,
    879888,
    778767,
    787988,
    679887,
    977877,
    777897,
    887888,
    888889,
    978898,
    787687,
    878687,
    697878,
    767887,
    877778,
    778787,
    789888,
    888889,
    887798,
    787898,
    788988,
    799867,
    987799,
    888787,
    796889,
    999987,
    899977,
    889679,
    979998,
    799878,
    888687,
    888977,
    878777,
    778886,
    899798,
    969888,
    887789,
    887887,
    868899,
    967987,
    788778,
    787788,
    779888,
    787999,
    998878,
    699887,
    698888,
    789977,
    888778,
    978797,
    987879,
    779777,
    888977,
    887787,
    877788,
    798779,
    788777,
    797887,
    778868,
    678888,
    887987,
    998888,
    988897,
    786988,
    978877,
    877778,
    887776,
    998898,
    978788,
    777867,
    889778,
    889687,
    879987,
    778767,
    787988,
    786977,
    788877,
    888896,
    888886,
    777799,
    899878,
    787887,
    687998,
    779977,
    888887,
    687869,
    788988,
    898787,
    788889,
    888878,
    989687,
    977877,
    777888,
    988698,
    798888,
    788897,
    797877,
    678796,
    997978,
    867879,
    788888,
    878887,
    999688,
    879887,
    797896,
    977978,
    888987,
    798889,
    778978,
    879977,
    999988,
    878878,
    777898,
    898778,
    898987,
    897779,
    777998,
    887678,
    889887,
    988887,
    988887,
    779688,
    788788,
    898778,
    887978,
    998877,
    878869,
    768887,
    878797,
    898989,
    888798,
    688888,
    878968,
    879978,
    788877,
    877789,
    898787,
    688877,
    888899,
    899889,
    798878,
    996678,
    779687,
    776877,
    889787,
    769777,
    778878,
    787777,
    888998,
    887788,
    797878,
    898887,
    898978,
    897898,
    889688,
    988988,
    987898,
    888786,
    899899,
    998898,
    988796,
    999778,
    788886,
    879889,
    897888,
    788787,
    978979,
    987788,
    789898,
    788887,
    977886,
    779888,
    789977,
    778889,
    889989,
    988797,
    979989,
    888788,
    988777,
    979888,
    898778,
    978697,
    887897,
    887688,
    778768,
    887888,
    889979,
    776997,
    777878,
    788789,
    867877,
    798878,
    887688,
    697887,
    887779,
    898877,
    868888,
    988896,
    779887,
    897878,
    987988,
    789767,
    869998,
    977899,
    888978,
    787767,
    779888,
    889987,
    797786,
    998787,
    787888,
    696798,
    987878,
    788786,
    778898,
    899787,
    887787,
    688767,
    898779,
    877879,
    787988,
    888897,
    797968,
    788977,
    688777,
    888997,
    869987,
    898889,
    668798,
    899877,
    997887,
    789888,
    997888,
    898988,
    787879,
    788779,
    988788,
    787798,
    988687,
    799888,
    878889,
    788799,
    679777,
    789788,
    899788,
    888978,
    896888,
    776779,
    868977,
    878889,
    878878,
    777977,
    779889,
    787988,
    998877,
    987668,
    887878,
    967788,
    779677,
    787998,
    788788,
    687887,
    889887,
    896777,
    998888,
    877768,
    988887,
    887887,
    886886,
    777988,
    778877,
    888778,
    897988,
    879786,
    787869,
    777679,
    768987,
    889987,
    787888,
    878777,
    798888,
    899877,
    988977,
    787887,
    878877,
    887787,
    786767,
    899888,
    879677,
    688887,
    979966,
    778888,
    989978,
    797987,
    878876,
    767778,
    678877,
    679988,
    987867,
    878788,
    778688,
    879888,
    877788,
    888678,
    788888,
    869878,
    868787,
    978877,
    988988,
    797989,
    788789,
    788799,
    877997,
    977987,
    879897,
    886778,
    888977,
    998677,
    887798,
    796887,
    897878,
    678987,
    777688,
    898888,
    898798,
    869888,
    879788,
    878966,
    977788,
    978898,
    888989,
    789887,
    698788,
    787878,
    897887,
    798888,
    778789,
    799886,
    866988,
    788789,
    989799,
    778888,
    966879,
    788989,
    877989,
    778997,
    786878,
    888878,
    889876,
    888788,
    988977,
    788798,
    898679,
    888888,
    888867,
    777877,
    787877,
    878788,
    787879,
    989787,
    978788,
    777886,
    897879,
    978788,
    889877,
    788876,
    797887,
    998789,
    787977,
    979777,
    787888,
    797797,
    776889,
    888878,
    879878,
    678779,
    988687,
    976889,
    777788,
    889787,
    677978,
    796777,
    978897,
    888986,
    878888,
    878997,
    878888,
    887778,
    898777,
    886878,
    778878,
    698977,
    999877,
    796998,
    889997,
    879869,
    887888,
    886877,
    867877,
    799787,
    878987,
    797888,
    887878,
    687878,
    898896,
    979888,
    987778,
    787868,
    777888,
    797998,
    999987,
    987887,
    897898,
    867979,
    887886,
    987678,
    778687,
    977978,
    798987,
    779897,
    888898,
    787998,
    898879,
    887889,
    878769,
    879788,
    769887,
    888889,
    978989,
    887787,
    867878,
    889868,
    768887,
    697867,
    977977,
    978699,
    888688,
    897878,
    798789,
    877886,
    687788,
    878878,
    668887,
    798897,
    686899,
    888779,
    698887,
    988898,
    886977,
    787778,
    978777,
    888978,
    698678,
    796799,
    888888,
    878886,
    778777,
    797987,
    887878,
    788788,
    787988,
    787877,
    977898,
    777878,
    988679,
    898777,
    888999,
    988877,
    677986,
    776968,
    877678,
    898898,
    788877,
    878988,
    788778,
    897878,
    897988,
    889888,
    887889,
    979787,
    797788,
    788896,
    878898,
    887878,
    989888,
    888879,
    978888,
    988869,
    787967,
    888778,
    778788,
    888887,
    778897,
    988798,
    888977,
    877788,
    688768,
    878787,
    798888,
    888689,
    999977,
    789679,
    679778,
    888778,
    888688,
    778989,
    786778,
    999778,
    899776,
    778897,
    987798,
    997777,
    797987,
    688867,
    787797,
    698979,
    769887,
    989768,
    978878,
    978897,
    789777,
    988887,
    889889,
    978888,
    889797,
    987899,
    978798,
    988898,
    978878,
    988777,
    978777,
    877777,
    878899,
    799897,
    898887,
    777887,
    888988,
    798798,
    778778,
    897898,
    888788,
    897886,
    777787,
    778988,
    888888,
    999987,
    798889,
    979798,
    977797,
    896798,
    879987,
    889889,
    877778,
    787898,
    879867,
    778788,
    668889,
    888777,
    789888,
    767887,
    888888,
    999997,
    889768,
    778788,
    979789,
    787899,
    777789,
    797878,
    778778,
    888867,
    897878,
    688767,
    886787,
    879988,
    998888,
    889788,
    778888,
    889996,
    987999,
    888778,
    788868,
    788887,
    788987,
    778978,
    877878,
    788787,
    788877,
    979977,
    689888,
    777789,
    787768,
    888888,
    787898,
    668787,
    887778,
    988786,
    976688,
    778788,
    878878,
    877789,
    886768,
    886888,
    979789,
    688896,
    988999,
    987899,
    989778,
    779777,
    897787,
    876888,
    778877,
    889678,
    869867,
    788779,
    978689,
    768777,
    866898,
    778789,
    799877,
    797888,
    768868,
    678789,
    798789,
    888788,
    886798,
    898877,
    788867,
    798898,
    988988,
    788899,
    787879,
    777888,
    988799,
    778788,
    888768,
    799888,
    788878,
    797898,
    798888,
    789789,
    787799,
    668878,
    878887,
    777887,
    877967,
    788888,
    779777,
    877869,
    797889,
    777768,
    789788,
    889987,
    777877,
    878787,
    798798,
    778888,
    778998,
    888878,
    889789,
    897897,
    897767,
    888988,
    887998,
    878887,
    797886,
    897879,
    888869,
    878778,
    888887,
    778898,
    879877,
    888888,
    878788,
    788788,
    688877,
    887798,
    798978,
    887976,
    988899,
    788888,
    779787,
    888976,
    779788,
    776898,
    988788,
    687898,
    976897,
    978768,
    889898,
    789987,
    978996,
    787668,
    886888,
    789688,
    888788,
    898979,
    977887,
    878797,
    869787,
    798986,
    887887,
    797978,
    896887,
    888787,
    969987,
    799687,
    887788,
    997768,
    979898,
    979788,
    988786,
    889887,
    777898,
    888777,
    887897,
    986888,
    897978,
    997898,
    878878,
    988787,
    788787,
    887879,
    689789,
    777888,
    787879,
    799988,
    898798,
    977788,
    987788,
    699888,
    667778,
    996887,
    877999,
    977886,
    888988,
    798897,
    787688,
    897877,
    998778,
    996998,
    898688,
    889778,
    987886,
    877888,
    998788,
    879787,
    978896,
    879979,
    677889,
    789966,
    978888,
    889797,
    798688,
    777898,
    787876,
    888888,
    888899,
    677769,
    878886,
    787898,
    787878,
    899687,
    778888,
    699878,
    768777,
    888879,
    786986,
    887868,
    789978,
    688987,
    879669,
    889768,
    987887,
    789997,
    988977,
    888898,
    988877,
    887897,
    977779,
    796878,
    987797,
    777787,
    898888,
    779888,
    778789,
    797776,
    878678,
    799687,
    777978,
    888877,
    878877,
    888677,
    889898,
    977888,
    879988,
    989778,
    978798,
    888788,
    989879,
    889978,
    769889,
    988778,
    788779,
    889778,
    799877,
    778789,
    977879,
    776779,
    987768,
    888888,
    786789,
    788887,
    988966,
    887688,
    768888,
    988687,
    788878,
    887768,
    878868,
    778977,
    779888,
    768889,
    978887,
    887897,
    778989,
    796679,
    988998,
    798898,
    879986,
    798887,
    899888,
    778777,
    776968,
    787877,
    889896,
    979777,
    777779,
    998698,
    878697,
    998877,
    867879,
    778898,
    789879,
    887887,
    679888,
    789777,
    889986,
    696888,
    778897,
    877787,
    867876,
    887977,
    778979,
    887878,
    888897,
    996789,
    998887,
    867988,
    769978,
    788668,
    787866,
    887888,
    988887,
    797988,
    978779,
    889888,
    789867,
    878777,
    899779,
    788796,
    678788,
    789799,
    879878,
    687987,
    877769,
    789999,
    678878,
    877888,
    878878,
    888668,
    989977,
    796887,
    979887,
    868888,
    886887,
    779789,
    789898,
    797788,
    879888,
    988798,
    886878,
    977698,
    898976,
    978879,
    678789,
    798977,
    887978,
    779978,
    788779,
    788798,
    867879,
    898896,
    789787,
    886777,
    988877,
    977977,
    878777,
    877989,
    898666,
    887767,
    888788,
    797878,
    879777,
    789877,
    778888,
    778778,
    998868,
    899698,
    877787,
    877998,
    798777,
    687877,
    879999,
    888788,
    988778,
    788687,
    887879,
    897977,
    676779,
    688778,
    878787,
    878777,
    879689,
    988877,
    878978,
    888997,
    889878,
    788878,
    888897,
    877777,
    787888,
    889778,
    798978,
    878987,
    888797,
    978877,
    799776,
    878777,
    788878,
    778677,
    877687,
    877988,
    787897,
    988787,
    777867,
    878898,
    877677,
    768789,
    878778,
    988878,
    799797,
    797997,
    886877,
    779987,
    788767,
    878779,
    987788,
    977978,
    977878,
    778889,
    788987,
    896988,
    868778,
    678899,
    788978,
    789787,
    769887,
    878989,
    878887,
    868798,
    887888,
    989788,
    789778,
    878778,
    897878,
    876897,
    979789,
    889788,
    979677,
    878767,
    898887,
    889888,
    789877,
    898778,
    889989,
    788777,
    976787,
    878789,
    887987,
    988987,
    686878,
    888877,
    688678,
    977868,
    788999,
    987968,
    888986,
    888888,
    689798,
    977899,
    887898,
    777788,
    989996,
    767888,
    777878,
    968678,
    989876,
    776686,
    878787,
    887798,
    866877,
    978987,
    777988,
    889888,
    779789,
    887967,
    888788,
    897798,
    877996,
    987777,
    866798,
    969988,
    888879,
    787777,
    899998,
    779888,
    997987,
    897888,
    779978,
    877677,
    878788,
    898898,
    869987,
    887798,
    899976,
    879787,
    988788,
    997678,
    679877,
    977878,
    687877,
    778878,
    896779,
    797878,
    867677,
    869976,
    988777,
    868778,
    988787,
    977977,
    969877,
    799779,
    768868,
    798878,
    777998,
    889979,
    888998,
    987878,
    899887,
    879777,
    696889,
    879889,
    878777,
    688888,
    776788,
    799978,
    978878,
    788878,
    678898,
    769679,
    888777,
    887878,
    978987,
    778777,
    789887,
    987888,
    778776,
    788988,
    777979,
    797886,
    789897,
    799778,
    788978,
    988788,
    867878,
    997777,
    896788,
    888789,
    989879,
    778878,
    979777,
    888797,
    886778,
    887777,
    788797,
    766897,
    778887,
    997878,
    778977,
    988798,
    788979,
    679986,
    978888,
    897997,
    989988,
    787868,
    888687,
    878878,
    787876,
    878769,
    878768,
    887687,
    778687,
    877777,
    879798,
    798889,
    888968,
    879986,
    899888,
    896788,
    788877,
    787778,
    999987,
    778879,
    777989,
    788897,
    789789,
    789797,
    996779,
    997777,
    886787,
    798778,
    996876,
    997877,
    798787,
    999867,
    799888,
    797887,
    988787,
    777777,
    877986,
    887778,
    789778,
    878799,
    786889,
    799996,
    669878,
    887678,
    987888,
    778977,
    777778,
    779777,
    878889,
    888696,
    799688,
    887797,
    979886,
    688879,
    777888,
    889888,
    877997,
    996879,
    878799,
    877887,
    988698,
    989899,
    988888,
    676797,
    888887,
    969877,
    698996,
    897798,
    778988,
    878798,
    888888,
    888688,
    998888,
    888789,
    879776,
    887798,
    798888,
    988887,
    877888,
    677989,
    876899,
    879967,
    789687,
    888998,
    777787,
    789999,
    988787,
    997787,
    676898,
    766888,
    888888,
    768788,
    868789,
    799788,
    989888,
    976768,
    887787,
    877777,
    798777,
    898879,
    988698,
    798799,
    678878,
    787997,
    877867,
    898987,
    989777,
    899878,
    989687,
    788787,
    786788,
    787887,
    879887,
    778888,
    989887,
    877678,
    768879,
    889667,
    798798,
    999877,
    877788,
    878897,
    999879,
    996987,
    989879,
    878988,
    779697,
    877988,
    878977,
    979898,
    888889,
    777876,
    897787,
    687887,
    889877,
    786698,
    877977,
    779896,
    989888,
    877778,
    699879,
    989887,
    767898,
    698987,
    897877,
    779798,
    668969,
    897798,
    878879,
    898879,
    798888,
    868867,
    777779,
    888787,
    878898,
    777878,
    987978,
    789898,
    869897,
    788888,
    898687,
    978788,
    776898,
    867797,
    989987,
    778898,
    878887,
    886888,
    886698,
    777899,
    878889,
    777678,
    887886,
    998878,
    767799,
    877789,
    776988,
    767996,
    887788,
    688777,
    797888,
    777889,
    799888,
    979988,
    788966,
    787887,
    887777,
    888798,
    868887,
    988777,
    877789,
    877876,
    987777,
    887888,
    778787,
    678897,
    987869,
    878678,
    788678,
    898888,
    976787,
    877787,
    887876,
    687798,
    878878,
    898969,
    887787,
    988888,
    978988,
    888788,
    798888,
    898978,
    877979,
    798799,
    769869,
    787768,
    787987,
    766789,
    877778,
    889898,
    798686,
    979878,
    787767,
    769888,
    786977,
    768786,
    778799,
    897878,
    877898,
    789978,
    897789,
    796897,
    787679,
    868888,
    887899,
    877698,
    788879,
    798688,
    997877,
    788978,
    768978,
    788788,
    777798,
    888788,
    777778,
    788888,
    789987,
    878998,
    989977,
    787888,
    898877,
    889899,
    888987,
    897879,
    797899,
    987869,
    787887,
    787889,
    896688,
    888678,
    889766,
    787789,
    788889,
    788867,
    869789,
    778988,
    879867,
    767799,
    889788,
    897777,
    877768,
    887777,
    889888,
    887668,
    977897,
    977788,
    978899,
    788888,
    798788,
    778988,
    788987,
    798686,
    896778,
    789777,
    778887,
    778777,
    877888,
    787899,
    988776,
    978978,
    877787,
    798978,
    788797,
    887888,
    768886,
    887879,
    886798,
    787887,
    878887,
    877889,
    879878,
    679878,
    788797,
    887887,
    899997,
    897679,
    998878,
    878986,
    867778,
    997798,
    678978,
    777798,
    788879,
    767679,
    777878,
    777897,
    877679,
    888888,
    898767,
    988787,
    887788,
    987667,
    689987,
    998797,
    689898,
    887968,
    889677,
    788777,
    888866,
    799779,
    896687,
    988999,
    888987,
    868678,
    987788,
    976787,
    888999,
    987887,
    967778,
    877898,
    877786,
    898969,
    777799,
    887687,
    788987,
    787799,
    878778,
    977888,
    687977,
    867998,
    888898,
    679887,
    799778,
    776986,
    789886,
    989878,
    779797,
    977878,
    868978,
    878976,
    897878,
    888779,
    888769,
    979878,
    777888,
    976779,
    678988,
    887977,
    767788,
    879977,
    788977,
    778787,
    676988,
    897897,
    988888,
    799797,
    788778,
    878888,
    779898,
    878778,
    789898,
    889987,
    797978,
    888788,
    788989,
    989987,
    788897,
    787798,
    797878,
    688889,
    887689,
    999998,
    889887,
    979797,
    888678,
    968899,
    887868,
    789877,
    999898,
    887778,
    678888,
    998788,
    997798,
    888966,
    988888,
    788877,
    877989,
    887899,
    778879,
    687797,
    786777,
    888888,
    777788,
    997799,
    977968,
    968897,
    788687,
    688997,
    888877,
    787878,
    798977,
    877777,
    879877,
    789897,
    679788,
    897799,
    777789,
    777897,
    777777,
    898787,
    977787,
    797897,
    968788,
    967877,
    976969,
    887777,
    887888,
    777778,
    887777,
    797878,
    888878,
    688868,
    787787,
    778877,
    778788,
    767888,
    988988,
    978778,
    798986,
    978879,
    678888,
    767887,
    987889,
    668778,
    887699,
    877788,
    898788,
    889678,
    898887,
    968796,
    889899,
    687898,
    788798,
    869889,
    798778,
    889888,
    797888,
    989877,
    879997,
    788798,
    777878,
    878899,
    788997,
    877778,
    877897,
    798976,
    988887,
    878887,
    686867,
    898788,
    887798,
    888778,
    679967,
    787878,
    897988,
    897877,
    787878,
    869867,
    878887,
    788888,
    878888,
    999778,
    687898,
    977789,
    677878,
    888778,
    899898,
    996888,
    898988,
    978788,
    776889,
    898869,
    877777,
    887968,
    798997,
    777778,
    798679,
    878988,
    897867,
    787998,
    689889,
    986878,
    989889,
    787778,
    787888,
    898987,
    986788,
    788988,
    899997,
    898888,
    687877,
    779678,
    979786,
    698798,
    778898,
    888888,
    997788,
    987777,
    769787,
    867898,
    788977,
    778988,
    868678,
    688889,
    997778,
    787779,
    877887,
    998889,
    877687,
    878798,
    779989,
    888797,
    777888,
    889887,
    898897,
    798778,
    888967,
    877897,
    968778,
    798988,
    888878,
    787798,
    886786,
    888978,
    777688,
    779788,
    878898,
    876897,
    798987,
    999778,
    778897,
    887997,
    987989,
    799788,
    887988,
    878788,
    979978,
    776878,
    778889,
    898886,
    787876,
    869886,
    989978,
    988888,
    889679,
    888979,
    986778,
    999898,
    886787,
    787977,
    979898,
    777697,
    898677,
    889877,
    997888,
    878978,
    789886,
    989969,
    898788,
    887878,
    988988,
    698888,
    997687,
    698979,
    766998,
    978898,
    897988,
    779667,
    878876,
    787886,
    887999,
    978778,
    777779,
    787778,
    897897,
    778878,
    788898,
    678778,
    787878,
    997787,
    978778,
    869777,
    998787,
    898787,
    897999,
    797978,
    797687,
    888787,
    879878,
    879977,
    968877,
    967767,
    788679,
    879778,
    787878,
    789887,
    897678,
    888787,
    888797,
    877978,
    878887,
    777778,
    887898,
    978889,
    887988,
    897877,
    998789,
    888867,
    879886,
    687778,
    977978,
    787788,
    887878,
    898787,
    797878,
    877788,
    897698,
    778687,
    867878,
    888688,
    978888,
    878688,
    888888,
    878888,
    898889,
    798787,
    868889,
    797899,
    777797,
    998779,
    878988,
    888788,
    988977,
    887887,
    788888,
    787697,
    777879,
    888878,
    797776,
    777788,
    788788,
    978777,
    978888,
    997799,
    897878,
    768887,
    788788,
    889879,
    979789,
    787898,
    878898,
    997878,
    879778,
    796779,
    987789,
    878787,
    799969,
    889998,
    877887,
    979988,
    798687,
    888989,
    789987,
    867778,
    977688,
    789988,
    878778,
    779877,
    698798,
    788887,
    887699,
    877887,
    778988,
    878997,
    788688,
    988867,
    877778,
    886878,
    797777,
    999898,
    987787,
    898889,
    797767,
    887878,
    878789,
    898888,
    777697,
    988678,
    788779,
    788988,
    978879,
    887888,
    787888,
    877798,
    778987,
    978879,
    869787,
    778887,
    778888,
    988897,
    889888,
    789889,
    876698,
    777688,
    787888,
    889878,
    888789,
    899988,
    887897,
    888698,
    987779,
    788899,
    889878,
    888786,
    878778,
    878977,
    997886,
    878788,
    679979,
    797788,
    877877,
    787988,
    777677,
    898797,
    698786,
    878777,
    788977,
    778888,
    989898,
    988978,
    776979,
    797779,
    888898,
    779998,
    887988,
    889987,
    799789,
    888988,
    776888,
    898887,
    896887,
    987678,
    787887,
    789777,
    888887,
    989869,
    978778,
    779889,
    886987,
    789897,
    986889,
    898878,
    968888,
    778988,
    789897,
    886878,
    989878,
    879779,
    798788,
    787887,
    888878,
    977778,
    888988,
    889779,
    777887,
    988777,
    789889,
    899789,
    978878,
    888787,
    987876,
    888897,
    887778,
    898978,
    799998,
    798778,
    689888,
    689786,
    768987,
    877688,
    778777,
    998797,
    888869,
    978687,
    778988,
    788996,
    999777,
    888998,
    878977,
    888879,
    667778,
    789889,
    777998,
    989777,
    889789,
    886887,
    768777,
    789869,
    879778,
    898888,
    898877,
    879887,
    888887,
    967788,
    777888,
    787899,
    978989,
    878879,
    988888,
    787899,
    887677,
    779888,
    788788,
    787778,
    979988,
    887977,
    797998,
    887987,
    886986,
    877988,
    878998,
    887889,
    888887,
    887799,
    879987,
    876978,
    878778,
    889978,
    777889,
    689778,
    888777,
    788776,
    887999,
    778989,
    878698,
    888898,
    787798,
    877788,
    898868,
    688787,
    987897,
    977689,
    897978,
    677786,
    977888,
    797877,
    679888,
    878989,
    779787,
    988788,
    878778,
    978888,
    897789,
    899679,
    988796,
    896777,
    779787,
    769997,
    776897,
    788996,
    888978,
    988887,
    878878,
    776787,
    886979,
    788886,
    898977,
    878888,
    798798,
    787889,
    798897,
    997987,
    997796,
    687978,
    987678,
    888977,
    877797,
    777778,
    878878,
    878998,
    776978,
    869799,
    868878,
    797789,
    797688,
    879687,
    976977,
    678879,
    787988,
    969766,
    778778,
    978787,
    889887,
    888977,
    668889,
    787898,
    888888,
    978788,
    677876,
    897979,
    987878,
    979887,
    769877,
    878978,
    879788,
    877788,
    788888,
    877889,
    789789,
    889888,
    787877,
    787898,
    889987,
    888897,
    986788,
    778987,
    788778,
    977778,
    877968,
    788778,
    779788,
    768788,
    889888,
    787888,
    667889,
    978887,
    778889,
    889687,
    878898,
    998888,
    898768,
    777869,
    987787,
    987868,
    879787,
    886897,
    988887,
    989888,
    789889,
    887786,
    888878,
    769997,
    977988,
    999887,
    987788,
    897698,
    898787,
    889878,
    898789,
    777787,
    879887,
    778779,
    878888,
    878877,
    778898,
    987897,
    997878,
    899788,
    898668,
    896878,
    899998,
    988869,
    787778,
    687898,
    987899,
    988697,
    777789,
    878879,
    767768,
    788889,
    977777,
    887877,
    779787,
    889689,
    787888,
    969788,
    888889,
    778897,
    787777,
    789778,
    697878,
    886788,
    768778,
    786797,
    779889,
    888888,
    788888,
    998688,
    898898,
    777798,
    889898,
    778779,
    777879,
    778977,
    679879,
    888978,
    888678,
    987796,
    688778,
    777878,
    777978,
    798887,
    768789,
    887797,
    878799,
    989677,
    879888,
    867778,
    887877,
    878777,
    967786,
    899999,
    787898,
    789887,
    998779,
    798887,
    798798,
    887878,
    989876,
    888766,
    788897,
    999798,
    788888,
    889888,
    697868,
    688778,
    888798,
    878878,
    988888,
    798979,
    777988,
    879878,
    987789,
    889788,
    897889,
    798888,
    968897,
    887787,
    787799,
    888998,
    698888,
    887879,
    897689,
    797868,
    988987,
    877869,
    789888,
    797877,
    888878,
    679887,
    799876,
    879887,
    788676,
    788897,
    878977,
    878789,
    887986,
    977887,
    688798,
    887986,
    778767,
    778767,
    878778,
    998897,
    798887,
    877776,
    888878,
    797788,
    889778,
    778878,
    877778,
    987888,
    878798,
    867898,
    689988,
    788777,
    877788,
    777977,
    987998,
    787889,
    898887,
    789787,
    898888,
    769879,
    898898,
    978888,
    988776,
    798869,
    898868,
    798887,
    877987,
    777989,
    999788,
    777988,
    888876,
    888967,
    878797,
    878798,
    798888,
    788797,
    897788,
    778997,
    777999,
    778897,
    879887,
    989778,
    796889,
    688798,
    878688,
    887888,
    988899,
    789879,
    789798,
    999889,
    889877,
    889689,
    997877,
    886689,
    787879,
    888978,
    789797,
    778886,
    696886,
    799798,
    889789,
    686889,
    877977,
    888797,
    877898,
    888779,
    677777,
    978787,
    989787,
    879877,
    777779,
    797978,
    798779,
    879778,
    878879,
    776688,
    887989,
    777887,
    989888,
    988887,
    788778,
    778996,
    897877,
    868898,
    897878,
    977888,
    877889,
    878788,
    777989,
    677888,
    977878,
    888677,
    987887,
    878787,
    877777,
    887699,
    777778,
    879778,
    887878,
    887796,
    888898,
    898898,
    778798,
    987877,
    686797,
    788887,
    989887,
    777768,
    778877,
    878798,
    979867,
    898787,
    688697,
    879669,
    798779,
    988879,
    868887,
    787978,
    989877,
    878887,
    997777,
    777888,
    788868,
    876776,
    987887,
    889988,
    878788,
    878789,
    978698,
    978779,
    877888,
    788887,
    868887,
    978887,
    989688,
    899788,
    788886,
    887888,
    877978,
    889897,
    987776,
    898889,
    787998,
    887999,
    799887,
    988778,
    878988,
    797786,
    778988,
    777977,
    889888,
    779887,
    889798,
    887988,
    677888,
    888987,
    788989,
    869998,
    996899,
    987988,
    889779,
    878877,
    877687,
    878888,
    877898,
    788889,
    878676,
    787887,
    888779,
    988887,
    798887,
    788797,
    899887,
    779677,
    787987,
    777989,
    888878,
    789888,
    767779,
    777778,
    898969,
    788788,
    898888,
    887888,
    788778,
    868898,
    977878,
    898888,
    988797,
    889688,
    888878,
    888888,
    878697,
    877886,
    888889,
    797797,
    697989,
    897997,
    897879,
    888888,
    788898,
    789778,
    786888,
    987888,
    967888,
    977968,
    869779,
    877979,
    688899,
    896879,
    799888,
    778788,
    968899,
    786988,
    888978,
    787997,
    977878,
    986779,
    889787,
    987789,
    987987,
    689897,
    776679,
    778698,
    786898,
    889878,
    888768,
    777977,
    776876,
    789787,
    878796,
    877687,
    779688,
    888788,
    879879,
    887697,
    888898,
    777696,
    778776,
    986888,
    898788,
    899768,
    787777,
    787978,
    889778,
    998986,
    879788,
    988889,
    888888,
    796889,
    899888,
    799889,
    788878,
    779867,
    788877,
    888877,
    777876,
    777788,
    989866,
    896679,
    878697,
    878888,
    689999,
    887978,
    688999,
    998879,
    997888,
    989979,
    669997,
    897798,
    797899,
    978888,
    888969,
    878798,
    788789,
    888887,
    887787,
    778799,
    888898,
    978789,
    787987,
    797797,
    687788,
    867878,
    877788,
    888787,
    787978,
    878888,
    798999,
    887888,
    688877,
    788878,
    697889,
    888787,
    769978,
    887679,
    788686,
    888778,
    999986,
    867767,
    989978,
    798897,
    779898,
    878899,
    888688,
    998798,
    898887,
    877798,
    878887,
    978878,
    778888,
    876789,
    798978,
    689888,
    778887,
    797898,
    887979,
    989988,
    968898,
    886899,
    988796,
    987778,
    688777,
    898988,
    878878,
    887977,
    788878,
    999998,
    877898,
    888678,
    888888,
    887886,
    887889,
    697887,
    788889,
    769798,
    889788,
    789889,
    878997,
    877768,
    769787,
    988779,
    787888,
    778878,
    989788,
    887898,
    878887,
    989777,
    877898,
    888777,
    888788,
    786678,
    889687,
    679678,
    697798,
    876678,
    899878,
    677998,
    877676,
    999889,
    988989,
    889788,
    987887,
    797787,
    876889,
    779898,
    797787,
    779888,
    787788,
    879867,
    788778,
    987879,
    779888,
    879886,
    978789,
    997687,
    877898,
    998789,
    888968,
    896889,
    987888,
    989696,
    968888,
    776878,
    788696,
    798788,
    776879,
    878868,
    798788,
    898779,
    789777,
    786978,
    997987,
    778889,
    787687,
    879977,
    989777,
    887699,
    787787,
    688789,
    986798,
    876878,
    887787,
    989788,
    897898,
    898788,
    878788,
    988878,
    977887,
    766987,
    778998,
    789688,
    798868,
    988788,
    778778,
    867797,
    888688,
    878776,
    787777,
    979998,
    898887,
    987868,
    887779,
    787798,
    889777,
    978887,
    689786,
    788978,
    778988,
    697986,
    877777,
    778776,
    698688,
    888887,
    799987,
    888787,
    898888,
    978899,
    788898,
    766877,
    897788,
    798888,
    697778,
    978877,
    888787,
    888876,
    697798,
    787897,
    778879,
    887886,
    787897,
    987798,
    887979,
    877867,
    877969,
    788787,
    778878,
    978879,
    878889,
    797897,
    878888,
    887888,
    897878,
    868787,
    978766,
    977888,
    797889,
    978897,
    689688,
    768789,
    888998,
    788678,
    876786,
    798787,
    889978,
    869888,
    887779,
    888998,
    778778,
    987977,
    878889,
    899879,
    898988,
    868868,
    798897,
    888876,
    767797,
    978878,
    997988,
    789897,
    897796,
    778987,
    996668,
    877798,
    898789,
    888779,
    789978,
    887777,
    699687,
    998779,
    777888,
    879888,
    688988,
    769787,
    888877,
    879769,
    989677,
    798889,
    668798,
    788787,
    887898,
    688788,
    798886,
    777778,
    998878,
    788788,
    777688,
    887798,
    978789,
    877877,
    779779,
    978899,
    988897,
    878779,
    887987,
    977888,
    889778,
    987888,
    879879,
    677987,
    888768,
    779688,
    879877,
    898677,
    678998,
    887968,
    978988,
    989898,
    889878,
    977797,
    987888,
    888868,
    788899,
    977897,
    978988,
    897867,
    768878,
    777788,
    889877,
    687678,
    787878,
    678878,
    787767,
    887888,
    877777,
    887787,
    978698,
    799798,
    878998,
    779796,
    989778,
    887678,
    778698,
    887877,
    888967,
    866888,
    988887,
    787898,
    887788,
    879797,
    888787,
    997787,
    987677,
    887879,
    888797,
    899898,
    898977,
    878978,
    887687,
    979986,
    798778,
    887878,
    986898,
    979787,
    887778,
    877896,
    797979,
    977788,
    997786,
    789787,
    779788,
    988988,
    788897,
    788797,
    779879,
    978787,
    878887,
    899878,
    889778,
    886778,
    969879,
    687987,
    888888,
    889878,
    878889,
    689788,
    897787,
    888878,
    888778,
    787987,
    877997,
    999777,
    897888,
    768868,
    876797,
    967888,
    777896,
    878789,
    888796,
    888987,
    788998,
    998887,
    888977,
    777988,
    867867,
    777679,
    867787,
    987878,
    689877,
    887998,
    778997,
    988979,
    878988,
    786788,
    776888,
    788779,
    887688,
    778679,
    888889,
    878788,
    899797,
    879799,
    877889,
    988867,
    797989,
    698879,
    897768,
    789787,
    879888,
    878887,
    978798,
    998666,
    877876,
    877777,
    877888,
    887887,
    888887,
    877778,
    998867,
    778988,
    689887,
    687978,
    888998,
    778889,
    987697,
    997787,
    997987,
    887877,
    898877,
    978987,
    877867,
    877878,
    777887,
    668898,
    889877,
    879888,
    799789,
    877977,
    877797,
    778877,
    878888,
    977788,
    786788,
    978878,
    887788,
    869878,
    997878,
    878878,
    887768,
    898888,
    787788,
    877787,
    987887,
    778999,
    889889,
    988887,
    799887,
    777877,
    877778,
    779788,
    777867,
    798787,
    897779,
    788898,
    888777,
    989987,
    889867,
    776778,
    778886,
    997787,
    988799,
    899779,
    979798,
    797887,
    778897,
    797888,
    698888,
    897798,
    887898,
    887687,
    878778,
    879888,
    897678,
    797996,
    776677,
    986888,
    897889,
    878969,
    978889,
    789987,
    778787,
    986768,
    779878,
    877869,
    988798,
    798879,
    788888,
    867788,
    788889,
    878787,
    986688,
    888789,
    879787,
    779869,
    898887,
    868788,
    888777,
    987968,
    878896,
    878898,
    978898,
    886777,
    779788,
    777776,
    877887,
    687878,
    797898,
    897777,
    778789,
    889877,
    978787,
    888867,
    997677,
    888788,
    787898,
    899689,
    887877,
    698887,
    778778,
    697877,
    777997,
    788899,
    899899,
    888897,
    889778,
    877988,
    987878,
    876987,
    998898,
    777979,
    967987,
    899888,
    998989,
    778897,
    677996,
    768977,
    888979,
    897787,
    878978,
    877899,
    998988,
    678877,
    888877,
    987699,
    778898,
    686779,
    788778,
    788797,
    878988,
    786979,
    988788,
    878787,
    877889,
    866888,
    898999,
    778878,
    887886,
    988878,
    779767,
    788977,
    677777,
    988787,
    877777,
    776868,
    989788,
    989887,
    999877,
    889877,
    989898,
    897888,
    889867,
    998887,
    897877,
    877978,
    787898,
    797877,
    787887,
    787779,
    778896,
    988778,
    897878,
    899887,
    777878,
    978977,
    889878,
    898768,
    887899,
    687778,
    799887,
    678988,
    786897,
    888998,
    899686,
    788798,
    888677,
    776787,
    787888,
    779878,
    788788,
    889787,
    878888,
    887888,
    997888,
    877888,
    796888,
    777888,
    868877,
    768987,
    788778,
    998988,
    779788,
    989888,
    878988,
    788798,
    767889,
    878876,
    797876,
    887979,
    978697,
    877799,
    878777,
    787777,
    897879,
    888797,
    878889,
    779877,
    888679,
    967879,
    778779,
    888787,
    889787,
    896878,
    887879,
    877887,
    879868,
    798778,
    789988,
    897988,
    897878,
    789996,
    889778,
    877878,
    876887,
    899788,
    987767,
    797797,
    788989,
    778878,
    799878,
    678787,
    788876,
    796888,
    879989,
    799788,
    878888,
    877788,
    687678,
    888788,
    797878,
    788887,
    897787,
    877878,
    887878,
    798878,
    778779,
    697799,
    798887,
    778887,
    888767,
    788877,
    998898,
    878788,
    887788,
    787787,
    788987,
    888987,
    667987,
    888777,
    777778,
    787688,
    878869,
    788787,
    897988,
    889768,
    789897,
    977877,
    899967,
    688877,
    898987,
    987869,
    978777,
    879887,
    879798,
    777889,
    988698,
    878777,
    888779,
    987989,
    996798,
    988878,
    787979,
    878687,
    698878,
    878778,
    777678,
    979898,
    988999,
    788799,
    889889,
    888787,
    768988,
    787887,
    879877,
    888899,
    877776,
    897787,
    779888,
    778769,
    688887,
    797778,
    898877,
    798788,
    899878,
    889997,
    878989,
    778797,
    887788,
    988888,
    897869,
    787889,
    787778,
    877788,
    896986,
    888999,
    878899,
    787777,
    868887,
    887998,
    798788,
    988879,
    798988,
    979877,
    768868,
    787786,
    899879,
    778689,
    867779,
    868899,
    886877,
    888787,
    886878,
    778878,
    697987,
    986979,
    877798,
    777898,
    688867,
    888998,
    787798,
    799699,
    988778,
    987978,
    977678,
    889679,
    879897,
    879966,
    888899,
    686688,
    988996,
    977888,
    987887,
    979998,
    868768,
    888868,
    979767,
    978988,
    797998,
    887678,
    779688,
    778888,
    787789,
    987987,
    888788,
    999799,
    698697,
    778879,
    798667,
    997989,
    867878,
    677878,
    888876,
    877688,
    689878,
    867867,
    988876,
    887968,
    877888,
    987787,
    887887,
    788888,
    897787,
    787778,
    798777,
    877888,
    878976,
    787889,
    688799,
    888989,
    987987,
    787886,
    898787,
    988678,
    988768,
    979788,
    877898,
    866888,
    886978,
    786687,
    798778,
    787987,
    877877,
    889877,
    878887,
    788688,
    777898,
    678778,
    779978,
    967768,
    878989,
    989788,
    977978,
    887778,
    888888,
    988779,
    896887,
    977988,
    878888,
    989787,
    877879,
    878897,
    888887,
    778987,
    788879,
    787777,
    988878,
    777798,
    788877,
    869788,
    888688,
    889878,
    798886,
    678798,
    977898,
    887888,
    868778,
    878788,
    798889,
    878787,
    877889,
    889687,
    899978,
    877887,
    989779,
    799886,
    977889,
    678989,
    677888,
    867777,
    787779,
    897679,
    688978,
    878778,
    779888,
    678987,
    788898,
    787778,
    878986,
    997778,
    867788,
    777877,
    879997,
    888879,
    799797,
    878778,
    998797,
    869877,
    888688,
    899888,
    779788,
    689887,
    778778,
    798797,
    888879,
    779787,
    778899,
    789778,
    987788,
    977688,
    868979,
    988769,
    978879,
    988776,
    978867,
    788887,
    798767,
    698779,
    869799,
    898787,
    676987,
    878888,
    676789,
    788879,
    788988,
    988977,
    878988,
    777969,
    788789,
    798798,
    767777,
    997778,
    988877,
    798798,
    878778,
    777898,
    888979,
    889768,
    777977,
    879688,
    988869,
    878989,
    899877,
    878977,
    779878,
    978877,
    889767,
    869877,
    888988,
    797878,
    887879,
    988868,
    787997,
    889888,
    877988,
    888776,
    898888,
    877778,
    777778,
    778797,
    897978,
    878796,
    687989,
    888888,
    779897,
    887888,
    968887,
    879697,
    986898,
    889878,
    978877,
    879988,
    868977,
    888997,
    778778,
    898778,
    777898,
    889787,
    778878,
    888887,
    978889,
    687767,
    869698,
    779697,
    988878,
    967879,
    776878,
    987779,
    788687,
    988988,
    868887,
    786787,
    887968,
    678987,
    786877,
    878778,
    788888,
    779888,
    868778,
    778698,
    896777,
    877869,
    877988,
    888899,
    778789,
    787889,
    867798,
    978778,
    687779,
    978789,
    777879,
    777887,
    897879,
    886988,
    877889,
    789798,
    987888,
    967788,
    779897,
    787698,
    866878,
    989787,
    687777,
    799876,
    878897,
    887897,
    898888,
    888787,
    777777,
    968788,
    899887,
    886978,
    888788,
    799988,
    867878,
    787798,
    897887,
    788878,
    789869,
    989898,
    868879,
    898868,
    789897,
    698787,
    866997,
    669999,
    897977,
    686888,
    899787,
    879878,
    886886,
    988879,
    967889,
    878878,
    897888,
    869789,
    778998,
    686897,
    777998,
    997789,
    788877,
    879897,
    898787,
    988889,
    887798,
    898799,
    997788,
    898897,
    968788,
    987779,
    888988,
    788898,
    678889,
    988889,
    978878,
    777897,
    888987,
    887879,
    777777,
    888979,
    879788,
    889889,
    788877,
    779777,
    778887,
    789977,
    867899,
    778788,
    788778,
    778898,
    899788,
    768787,
    678778,
    776788,
    976979,
    787878,
    897778,
    978767,
    888769,
    789788,
    878766,
    986678,
    777787,
    889887,
    888867,
    889798,
    878978,
    976877,
    988868,
    877677,
    898788,
    868888,
    887777,
    877788,
    979876,
    788889,
    989887,
    878689,
    988789,
    886887,
    978878,
    877878,
    878788,
    878779,
    886889,
    988888,
    788787,
    879888,
    778977,
    786988,
    988889,
    869888,
    778699,
    778788,
    778788,
    778778,
    788987,
    877678,
    788787,
    889887,
    878897,
    788868,
    887888,
    798988,
    877998,
    867888,
    878887,
    887899,
    888788,
    887887,
    777968,
    888899,
    787876,
    777888,
    789878,
    876788,
    897898,
    897999,
    786899,
    977887,
    799799,
    869787,
    697768,
    886887,
    699879,
    988986,
    889777,
    788787,
    787799,
    989987,
    779977,
    796877,
    879989,
    888887,
    797667,
    877867,
    678766,
    778887,
    887778,
    767778,
    878786,
    877698,
    778878,
    889677,
    899798,
    987897,
    987979,
    878899,
    798778,
    688788,
    799788,
    777797,
    789778,
    778777,
    888787,
    777797,
    779879,
    779797,
    787777,
    989799,
    879788,
    788897,
    889788,
    888998,
    898978,
    888896,
    878899,
    789888,
    987797,
    887998,
    687977,
    979788,
    889888,
    868897,
    998896,
    897877,
    878986,
    887788,
    889989,
    988876,
    888878,
    887989,
    767978,
    877887,
    878887,
    778789,
    796778,
    997986,
    699899,
    777998,
    688977,
    878777,
    988987,
    887677,
    678896,
    888899,
    997787,
    789887,
    889889,
    879986,
    979987,
    878987,
    898888,
    787987,
    788888,
    776989,
    777999,
    887789,
    879888,
    688788,
    979889,
    888878,
    788796,
    888778,
    788879,
    779987,
    877988,
    768989,
    988978,
    878879,
    789998,
    998879,
    899976,
    778788,
    787788,
    789979,
    898779,
    887888,
    797878,
    888998,
    788878,
    799886,
    888987,
    778878,
    787789,
    888778,
    878988,
    896788,
    789978,
    898979,
    787998,
    889888,
    889788,
    678887,
    867897,
    789797,
    867888,
    787988,
    787988,
    898878,
    978877,
    899778,
    869988,
    989796,
    888987,
    888879,
    899878,
    898688,
    888977,
    789888,
    878887,
    888888,
    879778,
    898877,
    877878,
    878778,
    878888,
    987877,
    977799,
    787788,
    999888,
    788767,
    878876,
    778687,
    889998,
    678778,
    878878,
    878888,
    977679,
    977688,
    889988,
    989986,
    776889,
    899889,
    886788,
    888798,
    776777,
    887878,
    688788,
    777978,
    778878,
    878778,
    987886,
    778767,
    779989,
    788799,
    699978,
    898786,
    887888,
    998778,
    877888,
    887878,
    889878,
    688886,
    777879,
    887888,
    877888,
    776977,
    887789,
    788888,
    979997,
    788877,
    888998,
    788868,
    768898,
    898988,
    688978,
    788867,
    887898,
    868989,
    878798,
    879878,
    889776,
    787979,
    787898,
    877897,
    888878,
    979878,
    688897,
    678869,
    789878,
    889987,
    988778,
    788788,
    978869,
    769889,
    878779,
    977778,
    879778,
    789778,
    878899,
    788876,
    789978,
    988789,
    879977,
    888899,
    889878,
    788877,
    788778,
    998778,
    978967,
    887788,
    978887,
    677888,
    879888,
    886887,
    779697,
    688968,
    889887,
    899877,
    767889,
    987987,
    968876,
    799768,
    999978,
    777878,
    777888,
    899987,
    666977,
    778888,
    877789,
    888968,
    987888,
    898978,
    997788,
    887768,
    788988,
    688797,
    689889,
    997989,
    877988,
    987787,
    786988,
    787877,
    878879,
    777887,
    687888,
    997887,
    697878,
    988887,
    978878,
    879877,
    778888,
    788888,
    878797,
    777866,
    797776,
    968898,
    699777,
    878988,
    888788,
    687798,
    778788,
    868799,
    998697,
    888879,
    877878,
    787777,
    868896,
    887988,
    889988,
    977788,
    887779,
    889877,
    788797,
    778778,
    897788,
    788887,
    677689,
    778778,
    878779,
    798786,
    899989,
    978778,
    887788,
    987787,
    687887,
    699968,
    898898,
    888889,
    888888,
    867876,
    788777,
    788777,
    877989,
    777988,
    977988,
    897878,
    678898,
    787888,
    898798,
    778978,
    878989,
    987877,
    899879,
    778789,
    678988,
    688987,
    979797,
    786878,
    677797,
    887878,
    787878,
    789889,
    787797,
    987698,
    889787,
    886878,
    797888,
    878887,
    977977,
    997899,
    777968,
    778768,
    798679,
    879897,
    887787,
    879876,
    878898,
    899998,
    998878,
    788878,
    787768,
    777879,
    878689,
    897887,
    798788,
    897887,
    876886,
    989998,
    787798,
    887779,
    887687,
    788799,
    987778,
    788777,
    898777,
    888889,
    887998,
    978796,
    987777,
    777879,
    979878,
    999977,
    788979,
    879789,
    977797,
    779788,
    898796,
    976889,
    868778,
    887878,
    697878,
    877778,
    999878,
    788899,
    788978,
    788897,
    878887,
    989887,
    887888,
    988889,
    868889,
    778877,
    686888,
    977978,
    787678,
    898778,
    788787,
    697778,
    989879,
    788877,
    968987,
    797797,
    968979,
    788788,
    788787,
    878889,
    897889,
    886899,
    888877,
    788878,
    988779,
    789876,
    879878,
    768887,
    888898,
    877999,
    797878,
    878998,
    797869,
    887888,
    978877,
    887777,
    888888,
    777779,
    778777,
    987878,
    687796,
    777688,
    887887,
    797898,
    798899,
    687798,
    888888,
    786788,
    788997,
    798666,
    889978,
    687677,
    987876,
    878976,
    888698,
    797878,
    989887,
    786787,
    777689,
    988887,
    786967,
    777869,
    898879,
    978887,
    887888,
    779678,
    798897,
    978778,
    876899,
    989788,
    779997,
    696879,
    778787,
    778886,
    878788,
    788668,
    679787,
    889898,
    888887,
    898878,
    877889,
    798767,
    788778,
    778887,
    889778,
    797997,
    786988,
    798987,
    878888,
    888888,
    877878,
    878888,
    877798,
    679797,
    998887,
    897788,
    877678,
    978788,
    777888,
    798887,
    988898,
    888787,
    898778,
    888998,
    679887,
    898898,
    989878,
    777888,
    799879,
    978999,
    979889,
    777878,
    887888,
    968876,
    778878,
    888997,
    979897,
    777867,
    888777,
    888879,
    789888,
    778877,
    778978,
    886878,
    687977,
    787686,
    977787,
    979989,
    888888,
    889889,
    887889,
    877797,
    887798,
    899899,
    987787,
    668878,
    889789,
    999888,
    688788,
    777888,
    878789,
    878688,
    778779,
    878888,
    887889,
    779986,
    868887,
    877888,
    979889,
    878878,
    898879,
    877888,
    978788,
    889877,
    989788,
    999886,
    978787,
    997779,
    988787,
    876796,
    778788,
    789778,
    887876,
    898888,
    899677,
    998879,
    987798,
    968789,
    879768,
    787787,
    888789,
    988768,
    897999,
    889877,
    787998,
    888988,
    897978,
    878888,
    796869,
    788887,
    788998,
    876769,
    777988,
    798789,
    888777,
    778768,
    778898,
    967897,
    977777,
    789899,
    877888,
    788898,
    877898,
    887888,
    879988,
    969888,
    887877,
    987977,
    879877,
    787787,
    788879,
    787989,
    888878,
    887978,
    988889,
    899877,
    868768,
    798898,
    888898,
    887668,
    797978,
    878989,
    877787,
    777898,
    788996,
    878899,
    988889,
    677887,
    788889,
    988789,
    897778,
    777988,
    887789,
    788878,
    887887,
    768877,
    777878,
    886688,
    687797,
    888877,
    787779,
    768797,
    987876,
    798998,
    788779,
    788887,
    878787,
    789988,
    888789,
    899778,
    887988,
    987989,
    788797,
    777767,
    877788,
    879976,
    787876,
    899998,
    887887,
    777788,
    678888,
    887777,
    898999,
    778787,
    877778,
    988889,
    797678,
    879798,
    878989,
    868888,
    788988,
    888888,
    798889,
    777789,
    879988,
    788997,
    787789,
    999787,
    878877,
    977878,
    899777,
    986988,
    889986,
    886887,
    788679,
    778789,
    888777,
    779978,
    867987,
    878898,
    987899,
    786997,
    988778,
    867779,
    997678,
    696789,
    987978,
    987897,
    888987,
    899997,
    788677,
    888777,
    776777,
    787777,
    898777,
    787777,
    877878,
    888788,
    889878,
    678996,
    778777,
    777779,
    877778,
    979898,
    799888,
    789998,
    698888,
    988798,
    868888,
    788878,
    889879,
    878876,
    988888,
    767878,
    777888,
    988788,
    997877,
    898979,
    898887,
    788888,
    987979,
    888878,
    977999,
    787888,
    897778,
    976878,
    787879,
    978678,
    968796,
    797888,
    978787,
    768786,
    898798,
    788788,
    988898,
    777789,
    887979,
    789788,
    889877,
    978878,
    677989,
    889888,
    798698,
    886777,
    977878,
    878776,
    877877,
    966797,
    878878,
    888988,
    879879,
    889878,
    788789,
    878887,
    888897,
    888787,
    988887,
    979989,
    797868,
    887988,
    888778,
    878889,
    999979,
    788867,
    879879,
    798888,
    888998,
    898868,
    978889,
    777878,
    788778,
    978787,
    989798,
    989898,
    888889,
    789779,
    878878,
    887678,
    797889,
    778977,
    877887,
    988878,
    888777,
    899889,
    988887,
    998787,
    788779,
    978876,
    777778,
    887788,
    778978,
    888789,
    777897,
    988768,
    896788,
    979887,
    987798,
    889779,
    786999,
    787899,
    996878,
    797676,
    887699,
    877899,
    777797,
    789876,
    778888,
    978889,
    787869,
    677887,
    999797,
    887798,
    868889,
    999887,
    788899,
    987877,
    779988,
    888887,
    778787,
    879879,
    787687,
    899998,
    878788,
    887888,
    786889,
    798788,
    887777,
    788987,
    778898,
    989777,
    789879,
    689887,
    898888,
    899888,
    777888,
    988877,
    867888,
    798787,
    897899,
    999978,
    797987,
    878878,
    768987,
    698689,
    887998,
    998798,
    897997,
    787987,
    798898,
    778888,
    887778,
    997877,
    889988,
    889787,
    888878,
    897876,
    888878,
    778788,
    997777,
    788789,
    878777,
    878789,
    779997,
    798769,
    979877,
    888877,
    897798,
    989989,
    799798,
    668778,
    767777,
    989887,
    867888,
    979986,
    788778,
    768988,
    778667,
    767886,
    887687,
    976867,
    777788,
    778779,
    889678,
    878789,
    799888,
    799789,
    788779,
    887777,
    777976,
    996867,
    796797,
    878978,
    876988,
    777778,
    889987,
    898989,
    788779,
    889889,
    778997,
    768889,
    788888,
    878997,
    979888,
    767879,
    868877,
    878878,
    778987,
    998788,
    887689,
    888876,
    778977,
    889797,
    878988,
    978798,
    788898,
    798878,
    887979,
    788969,
    888698,
    987778,
    888796,
    796789,
    978688,
    878787,
    887778,
    797778,
    788798,
    778887,
    889988,
    788888,
    798978,
    879979,
    986868,
    787788,
    979869,
    776887,
    888978,
    888888,
    768877,
    879897,
    887879,
    987888,
    888887,
    778969,
    998898,
    978876,
    889987,
    978777,
    778878,
    798796,
    788888,
    897786,
    789988,
    888798,
    998678,
    788798,
    797889,
    887898,
    877888,
    888788,
    768977,
    877877,
    678797,
    878777,
    889888,
    787879,
    876879,
    877988,
    678776,
    998877,
    798989,
    677888,
    788877,
    877787,
    889878,
    787997,
    897877,
    677978,
    986779,
    778788,
    668888,
    879789,
    978788,
    787778,
    879679,
    777687,
    887897,
    877989,
    878777,
    788776,
    777887,
    788988,
    986778,
    977878,
    797876,
    787789,
    888988,
    887668,
    787977,
    989897,
    887877,
    868997,
    677678,
    899878,
    898979,
    778789,
    768777,
    888777,
    986788,
    878889,
    888887,
    877879,
    688887,
    869798,
    697999,
    677868,
    789789,
    998979,
    788767,
    889889,
    779896,
    677897,
    789898,
    878787,
    987889,
    789787,
    797898,
    889687,
    879788,
    788888,
    968787,
    787789,
    767797,
    898798,
    888787,
    777687,
    789889,
    886897,
    788898,
    898988,
    898898,
    778888,
    897778,
    889689,
    788887,
    778968,
    997969,
    877889,
    889789,
    888888,
    886789,
    888677,
    679878,
    889889,
    788998,
    987798,
    788788,
    789877,
    878877,
    898888,
    887887,
    887779,
    778678,
    899888,
    797776,
    898788,
    887879,
    786897,
    886777,
    888678,
    887797,
    888776,
    777689,
    787778,
    777979,
    996868,
    968889,
    868798,
    987987,
    887767,
    867798,
    987888,
    887799,
    868977,
    978988,
    899778,
    877899,
    878786,
    799768,
    789799,
    977688,
    787977,
    888987,
    878777,
    979798,
    788999,
    798877,
    777796,
    887797,
    998877,
    889999,
    888988,
    888887,
    789988,
    897879,
    877777,
    777968,
    887877,
    877897,
    789688,
    787997,
    978887,
    789988,
    788686,
    878779,
    779778,
    988877,
    867787,
    877878,
    899777,
    998768,
    898888,
    798878,
    886988,
    797787,
    778867,
    977788,
    666789,
    979887,
    877989,
    888777,
    898777,
    788798,
    788897,
    788799,
    886888,
    769897,
    878888,
    887877,
    878887,
    989877,
    888799,
    879898,
    988888,
    788699,
    777787,
    888988,
    889888,
    977879,
    888878,
    898888,
    778888,
    897897,
    888789,
    888889,
    898888,
    788798,
    798778,
    888678,
    877788,
    987888,
    787887,
    777778,
    778789,
    668968,
    777887,
    777877,
    797778,
    989978,
    887788,
    887688,
    887887,
    877689,
    876887,
    796888,
    887977,
    798778,
    898887,
    988878,
    987888,
    888787,
    899789,
    877788,
    888787,
    888787,
    788988,
    897869,
    969788,
    887869,
    778868,
    778767,
    998789,
    887788,
    869986,
    879778,
    877788,
    879998,
    778888,
    689777,
    988889,
    778888,
    988888,
    779869,
    888898,
    879877,
    989888,
    887688,
    989786,
    987886,
    887789,
    786789,
    879888,
    687787,
    777787,
    788987,
    767889,
    898997,
    977888,
    977788,
    777987,
    779786,
    798887,
    788798,
    888787,
    978989,
    877887,
    778887,
    876877,
    788787,
    788778,
    979869,
    888878,
    888888,
    979897,
    898988,
    979787,
    888887,
    798899,
    776868,
    878987,
    876989,
    688868,
    878889,
    878768,
    989877,
    998889,
    888867,
    876777,
    888697,
    788889,
    868868,
    976889,
    898678,
    878788,
    787968,
    677797,
    786878,
    968888,
    887887,
    879998,
    776987,
    887988,
    879986,
    688888,
    998888,
    878788,
    777797,
    688788,
    686897,
    688998,
    687789,
    898878,
    888788,
    977987,
    798788,
    999889,
    876788,
    988877,
    788899,
    888968,
    798778,
    879887,
    878767,
    788987,
    797687,
    888878,
    889989,
    987896,
    898896,
    897788,
    888778,
    799798,
    879898,
    888878,
    888898,
    677797,
    767898,
    877789,
    787978,
    799879,
    788988,
    887898,
    877789,
    678878,
    779798,
    787689,
    678997,
    877799,
    788787,
    877897,
    779889,
    898897,
    878787,
    898978,
    878878,
    888778,
    988888,
    988788,
    898898,
    988779,
    888877,
    987788,
    889968,
    988877,
    886979,
    896778,
    977798,
    979797,
    788679,
    798889,
    887779,
    897779,
    787787,
    888798,
    677968,
    978979,
    888789,
    888888,
    788797,
    987796,
    788788,
    869879,
    977789,
    887778,
    886978,
    887778,
    988988,
    887887,
    988978,
    789877,
    898788,
    687889,
    977797,
    878979,
    787979,
    888787,
    878797,
    898888,
    886887,
    878788,
    978879,
    888778,
    888888,
    888879,
    779887,
    876788,
    898788,
    677798,
    688898,
    978889,
    989887,
    986868,
    877767,
    768887,
    779897,
    967787,
    778978,
    987797,
    867988,
    698887,
    789999,
    978769,
    888878,
    887798,
    788878,
    987899,
    797997,
    977889,
    886787,
    789888,
    877878,
    687877,
    888789,
    788978,
    878879,
    979798,
    988888,
    687898,
    897887,
    898777,
    777878,
    678799,
    779988,
    889878,
    788879,
    788797,
    788778,
    998878,
    867788,
    789797,
    888988,
    777898,
    778898,
    879878,
    878976,
    988778,
    878978,
    666878,
    789888,
    788989,
    879788,
    968889,
    878879,
    769878,
    989788,
    897977,
    767887,
    868878,
    878888,
    786886,
    769887,
    799787,
    788867,
    799886,
    888768,
    989987,
    767767,
    787979,
    798778,
    778897,
    988788,
    896979,
    679968,
    888788,
    897987,
    889878,
    777789,
    777998,
    786988,
    878797,
    788878,
    887988,
    888787,
    767786,
    879879,
    899778,
    989788,
    888789,
    878799,
    688797,
    777999,
    778787,
    869876,
    989777,
    898788,
    898988,
    988788,
    779977,
    998788,
    978888,
    887899,
    878777,
    996789,
    778788,
    977898,
    687978,
    889979,
    867687,
    778789,
    878769,
    878986,
    796868,
    899887,
    768887,
    887678,
    888888,
    889877,
    879887,
    988988,
    879788,
    887977,
    977998,
    877998,
    777789,
    879768,
    979878,
    987678,
    689788,
    688798,
    897889,
    878897,
    967788,
    887889,
    778988,
    888768,
    777988,
    677789,
    987898,
    988869,
    979899,
    978779,
    878978,
    877788,
    778997,
    888889,
    797688,
    897988,
    988888,
    887778,
    789888,
    897767,
    878888,
    879898,
    787987,
    978876,
    868878,
    788888,
    888797,
    997977,
    887789,
    788778,
    987997,
    778778,
    788879,
    899996,
    888978,
    877889,
    887787,
    788879,
    677999,
    877887,
    889978,
    979897,
    778887,
    688886,
    877888,
    778876,
    787988,
    878777,
    888689,
    878878,
    877978,
    798888,
    987779,
    987696,
    786877,
    877798,
    899877,
    886778,
    897786,
    878888,
    976889,
    778888,
    779778,
    677688,
    868687,
    777977,
    787978,
    886797,
    888977,
    898679,
    877889,
    786796,
    988887,
    967687,
    788777,
    889898,
    777977,
    998778,
    879887,
    887889,
    978688,
    988789,
    877888,
    897879,
    667887,
    679878,
    797968,
    777988,
    887887,
    989987,
    888897,
    879789,
    898887,
    887987,
    796987,
    887899,
    988778,
    888877,
    788877,
    778687,
    877777,
    988777,
    878889,
    699886,
    969787,
    877779,
    878878,
    787787,
    788878,
    877887,
    797786,
    887789,
    777878,
    898777,
    699879,
    698778,
    879797,
    898796,
    797778,
    797788,
    797687,
    788977,
    878977,
    788887,
    876979,
    878888,
    888878,
    877878,
    978787,
    877888,
    987998,
    889898,
    888776,
    786778,
    678879,
    789978,
    997799,
    787968,
    776878,
    978888,
    788788,
    888889,
    988799,
    878777,
    799887,
    898898,
    889878,
    887997,
    889698,
    878878,
    877888,
    888889,
    888889,
    778878,
    787988,
    888897,
    977889,
    778777,
    978977,
    798978,
    889978,
    888888,
    787878,
    977788,
    778867,
    879689,
    977688,
    787878,
    788977,
    988897,
    988877,
    867977,
    688796,
    996787,
    889898,
    977888,
    987878,
    676788,
    778887,
    868878,
    798798,
    878887,
    997678,
    799888,
    888697,
    979997,
    998978,
    988887,
    697988,
    777967,
    799877,
    988889,
    877898,
    779978,
    888878,
    877877,
    778877,
    888889,
    677969,
    678778,
    788777,
    787979,
    888897,
    887989,
    977868,
    799898,
    787767,
    887777,
    778798,
    978967,
    777676,
    798678,
    789777,
    999878,
    877778,
    887787,
    777778,
    979886,
    888887,
    987977,
    878888,
    788888,
    887868,
    879876,
    877789,
    987878,
    779788,
    787968,
    877887,
    787897,
    777877,
    787688,
    698888,
    999879,
    888788,
    878879,
    898788,
    888777,
    899968,
    978788,
    897888,
    878667,
    888786,
    788787,
    798868,
    888897,
    797787,
    869887,
    788978,
    879898,
    778886,
    796977,
    886778,
    787798,
    897888,
    999777,
    797677,
    897769,
    878998,
    897788,
    887877,
    889867,
    787787,
    797879,
    777788,
    778888,
    799898,
    899977,
    768886,
    987788,
    888887,
    978887,
    878886,
    788779,
    878876,
    788897,
    787889,
    888778,
    797797,
    888877,
    799787,
    896888,
    786889,
    876889,
    897979,
    776897,
    789778,
    868778,
    778987,
    978986,
    879888,
    969877,
    998978,
    898977,
    787889,
    687998,
    687878,
    879689,
    777877,
    878969,
    887767,
    869877,
    998986,
    788888,
    868779,
    897787,
    998888,
    888888,
    778867,
    789967,
    978877,
    896787,
    679778,
    788788,
    888788,
    698897,
    687788,
    888778,
    899887,
    768888,
    878777,
    886888,
    776778,
    879787,
    879778,
    987798,
    888868,
    779878,
    778787,
    968877,
    888998,
    778876,
    868798,
    988898,
    898788,
    787787,
    797898,
    789788,
    987777,
    667889,
    869778,
    787867,
    899678,
    899877,
    987788,
    966988,
    878868,
    988867,
    876788,
    887878,
    888977,
    777886,
    888997,
    979988,
    889777,
    778797,
    898879,
    998888,
    898787,
    888988,
    677887,
    698877,
    779879,
    796796,
    778787,
    889879,
    878887,
    788878,
    787788,
    898888,
    889888,
    787866,
    688987,
    878888,
    888878,
    969879,
    777878,
    797779,
    688998,
    868779,
    978898,
    889889,
    778688,
    978788,
    988787,
    887778,
    978798,
    768788,
    988898,
    877988,
    787878,
    887798,
    777998,
    887789,
    879789,
    888897,
    998998,
    876878,
    878977,
    988899,
    687899,
    788777,
    777988,
    887987,
    779887,
    877778,
    798888,
    868997,
    898797,
    978787,
    797778,
    896687,
    988889,
    887789,
    877799,
    788788,
    997978,
    877988,
    897877,
    888889,
    788898,
    777878,
    988877,
    798889,
    688778,
    788977,
    788997,
    878977,
    999779,
    889877,
    779876,
    898989,
    878777,
    988788,
    779878,
    779888,
    988697,
    979778,
    787889,
    888776,
    686988,
    789878,
    888797,
    877987,
    789867,
    778889,
    788887,
    767797,
    699889,
    787788,
    968977,
    977889,
    888877,
    887877,
    988797,
    878797,
    997887,
    779997,
    878797,
    787676,
    879778,
    968788,
    887879,
    879778,
    778878,
    888876,
    878678,
    897798,
    986789,
    778799,
    897889,
    896888,
    776699,
    878879,
    779869,
    888898,
    788786,
    789788,
    977889,
    877788,
    878887,
    778889,
    989686,
    998899,
    888877,
    778998,
    888887,
    789899,
    979888,
    969767,
    787989,
    898789,
    877888,
    787766,
    778898,
    887897,
    786888,
    886787,
    876889,
    788998,
    888866,
    896788,
    788988,
    688978,
    799787,
    878999,
    679898,
    986878,
    899789,
    778787,
    768688,
    877798,
    988778,
    777788,
    888778,
    797799,
    877897,
    978778,
    688879,
    877777,
    688767,
    976778,
    876887,
    877779,
    889977,
    888886,
    978988,
    788887,
    788987,
    897767,
    879999,
    789787,
    879888,
    788888,
    679788,
    777887,
    888888,
    988876,
    978988,
    868868,
    699887,
    867886,
    788788,
    788698,
    888878,
    987676,
    978997,
    886878,
    796797,
    787888,
    877797,
    678889,
    667797,
    687878,
    798997,
    879879,
    888978,
    767878,
    687987,
    998898,
    889768,
    868699,
    797888,
    888977,
    778886,
    777999,
    886887,
    888778,
    887777,
    896877,
    867788,
    889788,
    787878,
    787878,
    868898,
    778888,
    788879,
    798987,
    788987,
    987978,
    777888,
    888986,
    878998,
    888996,
    678779,
    788989,
    886877,
    878989,
    887987,
    887777,
    987797,
    888778,
    987898,
    678899,
    878989,
    878777,
    787877,
    769978,
    687887,
    776876,
    788888,
    888988,
    688897,
    867867,
    797877,
    898888,
    799988,
    876767,
    967877,
    798889,
    888889,
    778978,
    798988,
    788897,
    887897,
    886877,
    888797,
    877897,
    886889,
    878888,
    977786,
    887989,
    889887,
    978979,
    888877,
    887698,
    989887,
    777696,
    987678,
    787977,
    867876,
    987777,
    987788,
    889876,
    978787,
    879767,
    898899,
    768888,
    888889,
    968967,
    987778,
    889779,
    788778,
    878887,
    887688,
    767878,
    876989,
    986777,
    988887,
    788888,
    678877,
    888989,
    888889,
    977789,
    787898,
    767877,
    797898,
    877787,
    778698,
    886788,
    888788,
    897897,
    977799,
    968878,
    969877,
    996877,
    988787,
    777987,
    797786,
    888788,
    867987,
    788887,
    778877,
    988886,
    788778,
    879768,
    797888,
    778988,
    878889,
    998787,
    988778,
    789687,
    888997,
    887888,
    788788,
    898896,
    776898,
    889889,
    879788,
    877788,
    878878,
    877788,
    787797,
    678997,
    799979,
    988888,
    788888,
    797998,
    777778,
    889687,
    797887,
    887888,
    986877,
    898998,
    879876,
    887879,
    977888,
    788888,
    878877,
    997788,
    888887,
    986898,
    877779,
    798979,
    889887,
    988796,
    788798,
    897788,
    888777,
    788689,
    878788,
    877767,
    779878,
    878879,
    897888,
    778768,
    889868,
    979888,
    897887,
    787897,
    887887,
    889987,
    899778,
    789888,
    778676,
    988787,
    798978,
    679887,
    878889,
    997798,
    888798,
    888979,
    798889,
    987798,
    787888,
    897868,
    878798,
    876787,
    779779,
    767888,
    868788,
    899788,
    888989,
    978878,
    887789,
    788788,
    878998,
    899888,
    878968,
    797968,
    977789,
    797889,
    989786,
    777787,
    968779,
    896879,
    897896,
    787988,
    888787,
    876888,
    798889,
    789689,
    899778,
    797766,
    686787,
    776877,
    788797,
    878877,
    778777,
    778878,
    797887,
    888688,
    896778,
    897788,
    899998,
    789677,
    779879,
    978999,
    787889,
    888989,
    889778,
    999868,
    977886,
    888888,
    898898,
    888868,
    897978,
    986977,
    898878,
    777897,
    978888,
    788898,
    888669,
    797777,
    886978,
    768898,
    788886,
    769878,
    788697,
    877898,
    889967,
    988899,
    788888,
    978877,
    898997,
    986766,
    797798,
    798879,
    768987,
    787798,
    989888,
    887689,
    787689,
    997888,
    779977,
    897787,
    788988,
    968878,
    987787,
    778889,
    878996,
    787698,
    888698,
    886988,
    869878,
    788889,
    977889,
    677888,
    978868,
    989877,
    889988,
    698777,
    898678,
    798898,
    897778,
    977679,
    967888,
    799977,
    878778,
    886889,
    888768,
    898769,
    978788,
    887888,
    789877,
    978887,
    777998,
    989978,
    868879,
    769787,
    877777,
    798877,
    977878,
    778779,
    779798,
    988988,
    978987,
    798888,
    778798,
    778888,
    977778,
    886798,
    888887,
    778999,
    796977,
    786878,
    988889,
    898887,
    788877,
    998688,
    977778,
    979779,
    787877,
    776767,
    877988,
    988987,
    778878,
    778987,
    788769,
    789887,
    898686,
    887789,
    878998,
    887988,
    868888,
    877778,
    788777,
    887678,
    987788,
    767788,
    778967,
    977889,
    788976,
    988978,
    788896,
    977877,
    988768,
    786989,
    869678,
    887879,
    878986,
    878888,
    766787,
    888787,
    897967,
    677989,
    898787,
    898887,
    787788,
    988988,
    777779,
    887999,
    778898,
    776887,
    787787,
    887798,
    699879,
    898969,
    988788,
    988899,
    878989,
    887898,
    788879,
    789876,
    977877,
    897886,
    988879,
    987887,
    887988,
    778788,
    778678,
    878687,
    988687,
    798898,
    668789,
    678798,
    888888,
    788898,
    897867,
    788777,
    798769,
    877977,
    797978,
    778679,
    798977,
    967878,
    888887,
    798878,
    887997,
    989978,
    787776,
    868898,
    877777,
    998688,
    887868,
    889779,
    878978,
    789777,
    899878,
    989787,
    889888,
    779789,
    898897,
    877898,
    787989,
    768788,
    888768,
    788896,
    879878,
    866977,
    988888,
    779976,
    887788,
    888987,
    786788,
    898877,
    998879,
    897679,
    778896,
    878977,
    877888,
    888678,
    897788,
    878967,
    888678,
    887888,
    989888,
    887786,
    799989,
    778878,
    897979,
    888778,
    698787,
    899967,
    887786,
    877789,
    999879,
    798879,
    788888,
    969778,
    787877,
    877898,
    797887,
    878888,
    878888,
    788997,
    888778,
    787798,
    987779,
    879877,
    977888,
    777778,
    889867,
    988889,
    689767,
    787888,
    687676,
    767887,
    867878,
    987686,
    988887,
    788799,
    877777,
    896897,
    877878,
    779988,
    777978,
    968969,
    898789,
    789878,
    988897,
    899887,
    788879,
    898988,
    687887,
    689998,
    899787,
    888787,
    877879,
    978778,
    778979,
    877989,
    888886,
    798879,
    889777,
    878778,
    778688,
    897779,
    878988,
    968887,
    888897,
    989778,
    878788,
    987789,
    879788,
    888687,
    987688,
    787888,
    989987,
    679887,
    879878,
    968889,
    787877,
    877877,
    886788,
    787677,
    988888,
    779777,
    987877,
    879787,
    898988,
    878877,
    977778,
    778777,
    778986,
    887899,
    888789,
    979799,
    988868,
    889889,
    868778,
    887787,
    777888,
    898978,
    798987,
    869876,
    778889,
    898698,
    677887,
    797898,
    878789,
    997879,
    977796,
    887887,
    798698,
    969888,
    896787,
    787878,
    888867,
    879779,
    897998,
    678876,
    988888,
    998798,
    877869,
    977867,
    767988,
    888688,
    887888,
    898769,
    978787,
    767987,
    897988,
    869988,
    878988,
    777799,
    877788,
    788777,
    897898,
    779897,
    678889,
    889889,
    887887,
    799889,
    869887,
    677877,
    797987,
    787978,
    669887,
    887777,
    899979,
    779888,
    788987,
    868777,
    686897,
    888779,
    788889,
    886889,
    798788,
    898798,
    989888,
    878799,
    877878,
    767788,
    678777,
    877876,
    797898,
    897798,
    888778,
    889888,
    877899,
    988878,
    879888,
    899877,
    898998,
    798987,
    877897,
    797778,
    788988,
    799778,
    988879,
    987889,
    979886,
    978779,
    889677,
    987768,
    787977,
    887877,
    877789,
    988988,
    778868,
    788888,
    788799,
    989778,
    987897,
    988877,
    768888,
    789798,
    777786,
    888778,
    889978,
    798787,
    868778,
    986877,
    778987,
    898797,
    887977,
    879788,
    797888,
    787778,
    888888,
    877978,
    777788,
    899988,
    889966,
    887777,
    787979,
    988888,
    987887,
    978789,
    788979,
    778897,
    996787,
    676777,
    878867,
    886878,
    789789,
    778769,
    887887,
    876878,
    879989,
    878889,
    777887,
    888896,
    978698,
    889697,
    969888,
    997798,
    897799,
    877788,
    787868,
    896987,
    779688,
    886786,
    888988,
    798798,
    787887,
    979779,
    997798,
    877789,
    989779,
    889798,
    779787,
    888786,
    989886,
    788687,
    879999,
    888778,
    997978,
    886786,
    689689,
    678897,
    888889,
    887996,
    897778,
    678878,
    889888,
    778976,
    777787,
    999998,
    878797,
    888788,
    988769,
    888878,
    898769,
    678978,
    889878,
    799877,
    798797,
    897788,
    887877,
    877867,
    889887,
    868788,
    798888,
    788979,
    768987,
    986678,
    979879,
    878797,
    788878,
    896899,
    878797,
    688979,
    987877,
    988987,
    878788,
    877888,
    877977,
    868888,
    789998,
    877987,
    978899,
    789697,
    688897,
    888977,
    897887,
    777878,
    886888,
    798778,
    689988,
    987978,
    787967,
    888878,
    987777,
    978978,
    878886,
    888777,
    778898,
    889988,
    967898,
    877788,
    989889,
    798987,
    697887,
    967777,
    898777,
    889868,
    679798,
    779978,
    687876,
    787797,
    769889,
    888878,
    886777,
    898888,
    869798,
    878987,
    789689,
    989889,
    768999,
    867787,
    788777,
    776788,
    798997,
    888778,
    899897,
    779777,
    888888,
    797789,
    879786,
    768689,
    988987,
    889768,
    888888,
    887789,
    889989,
    878977,
    788987,
    787888,
    877878,
    888687,
    868877,
    988676,
    788698,
    897788,
    877898,
    787789,
    889878,
    986778,
    767889,
    767777,
    899768,
    768886,
    766878,
    986899,
    898897,
    888888,
    786767,
    878886,
    867887,
    887979,
    887897,
    966878,
    787778,
    988877,
    988997,
    878779,
    867777,
    888788,
    778776,
    877897,
    878779,
    798978,
    798989,
    689877,
    787989,
    788988,
    868678,
    879887,
    988696,
    977899,
    888988,
    878987,
    987987,
    876888,
    787887,
    887986,
    786878,
    989887,
    786777,
    778998,
    879987,
    989787,
    878788,
    878797,
    877788,
    888888,
    787879,
    778798,
    877788,
    787888,
    878766,
    887887,
    779779,
    879997,
    878888,
    877777,
    767897,
    889878,
    767977,
    879778,
    778877,
    996697,
    898887,
    887889,
    989788,
    878889,
    888898,
    886798,
    788878,
    777777,
    797898,
    999778,
    879798,
    897988,
    876886,
    798877,
    997688,
    977898,
    699998,
    868987,
    786698,
    888878,
    887886,
    978868,
    778788,
    988887,
    788987,
    887797,
    898799,
    988778,
    888877,
    787787,
    878778,
    889777,
    787798,
    978787,
    789878,
    887887,
    877697,
    788798,
    987868,
    988898,
    979879,
    887778,
    978879,
    978778,
    788687,
    788977,
    998777,
    897988,
    888898,
    777888,
    777997,
    688898,
    888887,
    999778,
    788699,
    877887,
    778878,
    898996,
    698789,
    987779,
    779968,
    988788,
    677667,
    897987,
    887987,
    888799,
    897798,
    878786,
    787767,
    779878,
    787989,
    899788,
    998879,
    978888,
    777798,
    877899,
    798988,
    997788,
    787789,
    688887,
    887897,
    667888,
    787996,
    897886,
    787988,
    879787,
    886777,
    769898,
    789788,
    777878,
    888898,
    878898,
    877878,
    968898,
    798788,
    987877,
    877978,
    778888,
    799897,
    788988,
    786888,
    888897,
    888778,
    998897,
    778896,
    987877,
    779879,
    777886,
    969966,
    888879,
    887899,
    799789,
    878878,
    869897,
    898798,
    987878,
    889888,
    698886,
    788887,
    888889,
    779977,
    777888,
    797789,
    798788,
    788877,
    868899,
    677688,
    988896,
    776876,
    988968,
    787779,
    978899,
    888899,
    778879,
    777779,
    698779,
    878767,
    887996,
    778989,
    788878,
    887769,
    797869,
    797898,
    766887,
    898888,
    868787,
    689989,
    888897,
    987888,
    788978,
    787877,
    877898,
    877778,
    979888,
    898979,
    798898,
    778678,
    797767,
    867888,
    988888,
    886988,
    987798,
    878687,
    976778,
    988789,
    887687,
    778788,
    988686,
    789777,
    778768,
    788889,
    987888,
    777967,
    888798,
    898998,
    898888,
    676898,
    897788,
    887898,
    878978,
    778788,
    887978,
    877698,
    889897,
    899876,
    789787,
    789877,
    889789,
    778679,
    787997,
    778787,
    677887,
    778887,
    988787,
    787967,
    779979,
    899888,
    787788,
    976877,
    889987,
    889778,
    888678,
    888688,
    998987,
    979788,
    879878,
    778798,
    779988,
    697878,
    998888,
    878676,
    889776,
    787879,
    777887,
    788888,
    798888,
    788987,
    787788,
    888978,
    977897,
    787888,
    878798,
    887977,
    778788,
    988979,
    787877,
    889888,
    787798,
    777977,
    877779,
    997967,
    978887,
    887777,
    889877,
    697988,
    889887,
    687789,
    878987,
    899787,
    787887,
    967988,
    887789,
    977889,
    997887,
    687777,
    987888,
    868887,
    777888,
    978777,
    989688,
    797888,
    888887,
    777989,
    889786,
    778996,
    788877,
    988888,
    898878,
    866788,
    876787,
    778879,
    879889,
    988877,
    777889,
    898788,
    989898,
    887998,
    689887,
    878878,
    788779,
    899989,
    798967,
    867869,
    987899,
    898899,
    877797,
    888887,
    798788,
    989999,
    986779,
    988988,
    788788,
    778998,
    787799,
    788888,
    788879,
    987878,
    988978,
    889977,
    898789,
    787887,
    988887,
    787879,
    778997,
    987776,
    888899,
    889789,
    887788,
    877897,
    796889,
    878898,
    877877,
    896879,
    898789,
    789786,
    777788,
    978798,
    889889,
    987887,
    788778,
    788799,
    888778,
    887977,
    698787,
    786798,
    776768,
    677967,
    777787,
    787778,
    987779,
    777977,
    886879,
    789778,
    789789,
    687777,
    779987,
    988688,
    778778,
    788878,
    879888,
    887779,
    888877,
    799869,
    889887,
    778788,
    898997,
    799988,
    888678,
    898988,
    877777,
    789898,
    778789,
    877877,
    788686,
    897978,
    876797,
    967978,
    798779,
    779777,
    889887,
    888897,
    879887,
    886998,
    787798,
    968789,
    968978,
    897898,
    898888,
    967787,
    977668,
    896787,
    798888,
    878687,
    998998,
    879777,
    898797,
    777796,
    688697,
    887677,
    878888,
    788988,
    877697,
    988898,
    987988,
    788797,
    787878,
    899798,
    987977,
    886887,
    689979,
    878978,
    788798,
    899778,
    866768,
    787887,
    879888,
    887888,
    987988,
    899888,
    877977,
    787978,
    777888,
    778988,
    987788,
    888787,
    978878,
    787998,
    868888,
    798889,
    778988,
    888787,
    797778,
    788887,
    897878,
    888789,
    999798,
    886989,
    889787,
    887989,
    887787,
    789879,
    876798,
    786879,
    777998,
    788897,
    778787,
    697779,
    978778,
    888877,
    868877,
    878889,
    787776,
    989777,
    889799,
    788777,
    687777,
    888688,
    897896,
    688877,
    987877,
    878879,
    789797,
    787777,
    987787,
    688877,
    997899,
    989978,
    798778,
    888868,
    888789,
    798999,
    888787,
    978686,
    967887,
    987878,
    687888,
    787789,
    888868,
    879899,
    987789,
    788898,
    879969,
    779677,
    977887,
    988788,
    878886,
    887899,
    798988,
    687889,
    877688,
    779679,
    888877,
    787888,
    888788,
    888988,
    889889,
    776897,
    898887,
    786778,
    888868,
    777999,
    987899,
    898999,
    898697,
    777787,
    786889,
    868789,
    888887,
    678879,
    996897,
    798888,
    788897,
    998788,
    979778,
    778686,
    878987,
    986787,
    987878,
    899788,
    879987,
    887787,
    877878,
    978799,
    897868,
    888787,
    787887,
    867887,
    789798,
    798887,
    877888,
    689788,
    989878,
    777877,
    888886,
    889877,
    968789,
    767877,
    789877,
    779887,
    888778,
    687788,
    667987,
    888777,
    688877,
    777898,
    888988,
    867887,
    778867,
    978789,
    778988,
    897979,
    878978,
    788887,
    887979,
    888788,
    878967,
    877787,
    888787,
    788988,
    778789,
    879878,
    787798,
    988978,
    788988,
    787699,
    786678,
    688897,
    777798,
    777798,
    878888,
    888988,
    779776,
    877878,
    886877,
    789998,
    999888,
    788867,
    888987,
    778888,
    899788,
    769886,
    788878,
    888887,
    778878,
    988889,
    878989,
    778988,
    787878,
    868978,
    876878,
    988887,
    887997,
    798887,
    778989,
    788897,
    769889,
    787977,
    798888,
    879989,
    797688,
    878678,
    687888,
    878678,
    898878,
    988788,
    787888,
    777998,
    886888,
    776887,
    898879,
    776786,
    997878,
    777988,
    968888,
    867868,
    798887,
    778887,
    969877,
    978888,
    887788,
    978888,
    969886,
    898878,
    678876,
    788787,
    988888,
    989867,
    779976,
    988999,
    897999,
    898897,
    779988,
    878897,
    998898,
    787996,
    887888,
    889869,
    769988,
    776979,
    888967,
    688787,
    988789,
    788778,
    987687,
    879778,
    878768,
    769887,
    998666,
    876788,
    787799,
    878789,
    879788,
    777888,
    797787,
    886879,
    888967,
    888888,
    788777,
    988889,
    779868,
    979777,
    777898,
    886867,
    887788,
    867788,
    886888,
    889898,
    777787,
    878989,
    679788,
    988887,
    798899,
    898999,
    887787,
    887997,
    788877,
    988899,
    797899,
    878988,
    877988,
    797697,
    898797,
    989988,
    797977,
    789879,
    987767,
    777877,
    887888,
    878778,
    878987,
    767898,
    977869,
    878988,
    777778,
    997877,
    778777,
    888798,
    988978,
    878876,
    778787,
    888888,
    887877,
    988797,
    787886,
    897889,
    778888,
    898886,
    877788,
    797888,
    879888,
    888887,
    888977,
    876688,
    898979,
    867879,
    789787,
    798689,
    898898,
    788978,
    989987,
    789688,
    778787,
    878989,
    878778,
    798988,
    967677,
    797888,
    877877,
    778897,
    788988,
    978867,
    797889,
    778788,
    878876,
    798887,
    788968,
    979778,
    868789,
    988866,
    798879,
    889788,
    889797,
    989798,
    978777,
    888987,
    989976,
    879697,
    978887,
    788877,
    987888,
    898879,
    887989,
    987889,
    877988,
    989888,
    776679,
    988888,
    788898,
    898988,
    969879,
    969889,
    688787,
    987797,
    876888,
    989786,
    779978,
    776888,
    889978,
    887989,
    777787,
    888879,
    976777,
    777887,
    977688,
    888778,
    787788,
    878779,
    888779,
    869896,
    888798,
    779867,
    868778,
    889988,
    987987,
    798798,
    787999,
    787977,
    898797,
    878879,
    889778,
    888878,
    797879,
    778777,
    689877,
    879988,
    787987,
    888888,
    689779,
    889787,
    777987,
    868799,
    777888,
    878998,
    868897,
    778867,
    787689,
    869698,
    897987,
    869878,
    988689,
    778688,
    898787,
    778677,
    678878,
    787986,
    966668,
    787877,
    878998,
    787887,
    977797,
    787778,
    878798,
    967788,
    898989,
    897698,
    787687,
    786878,
    887877,
    987897,
    797989,
    687786,
    778668,
    887779,
    788778,
    977979,
    889987,
    898787,
    798888,
    689979,
    878787,
    888777,
    888897,
    778888,
    777798,
    869767,
    987887,
    977989,
    778888,
    887996,
    878768,
    878699,
    677979,
    898688,
    976788,
    898978,
    777988,
    788878,
    977787,
    877897,
    998787,
    999868,
    898988,
    878898,
    788787,
    688769,
    877888,
    787887,
    678789,
    899887,
    788777,
    676887,
    887879,
    868797,
    878797,
    798778,
    887787,
    788778,
    876987,
    767977,
    997878,
    877678,
    788878,
    798877,
    789968,
    878689,
    988968,
    898988,
    787787,
    888878,
    778888,
    898798,
    878989,
    888898,
    687897,
    798888,
    789887,
    889889,
    787688,
    986788,
    877866,
    879766,
    887886,
    877689,
    778777,
    676777,
    887798,
    676988,
    988789,
    677988,
    796687,
    888889,
    878988,
    898877,
    888887,
    898868,
    999787,
    878968,
    888789,
    978898,
    777977,
    878778,
    887879,
    889789,
    796998,
    899878,
    889788,
    887798,
    877897,
    789698,
    766977,
    889688,
    777777,
    888897,
    898789,
    789787,
    877988,
    777887,
    798788,
    877887,
    988868,
    888898,
    789779,
    998987,
    897797,
    878878,
    777898,
    699887,
    867898,
    888997,
    887668,
    888887,
    887797,
    889786,
    888978,
    777888,
    779789,
    869867,
    868887,
    689787,
    677888,
    878989,
    888788,
    779798,
    897978,
    898987,
    777799,
    898788,
    787977,
    769688,
    879977,
    789867,
    788877,
    987977,
    968787,
    978878,
    967778,
    877687,
    777887,
    889888,
    788787,
    678888,
    989887,
    887898,
    888778,
    979997,
    977778,
    688987,
    776769,
    898977,
    878788,
    787877,
    688789,
    787798,
    679878,
    778899,
    788888,
    876767,
    888887,
    778886,
    789789,
    897787,
    788887,
    977787,
    788696,
    888788,
    888888,
    777998,
    888989,
    897979,
    798678,
    988778,
    877877,
    978898,
    889888,
    878887,
    877787,
    988887,
    898877,
    776778,
    987978,
    786886,
    788777,
    779888,
    878898,
    787778,
    787998,
    788878,
    687898,
    778888,
    698767,
    889789,
    779977,
    888777,
    878988,
    887987,
    888698,
    788868,
    778898,
    888876,
    878788,
    778767,
    787976,
    978997,
    789788,
    778788,
    888698,
    869679,
    898798,
    988778,
    788677,
    898777,
    879769,
    989978,
    898998,
    878997,
    989888,
    688777,
    887879,
    888888,
    689688,
    686998,
    888878,
    899788,
    878987,
    786996,
    879788,
    887897,
    888987,
    888887,
    767787,
    978879,
    777877,
    867988,
    877779,
    797979,
    887788,
    887768,
    889877,
    988877,
    878787,
    778868,
    998898,
    788888,
    797877,
    878788,
    878889,
    777899,
    897877,
    888897,
    979897,
    878797,
    988969,
    999788,
    876768,
    779898,
    987877,
    786686,
    888867,
    768777,
    778778,
    788788,
    798888,
    668877,
    788698,
    888778,
    776699,
    977997,
    887778,
    898896,
    797987,
    877986,
    789877,
    987789,
    879898,
    898868,
    788778,
    988787,
    797899,
    869797,
    769897,
    867887,
    786888,
    977767,
    879676,
    888876,
    789798,
    888887,
    767798,
    898787,
    888898,
    899997,
    668997,
    779886,
    796788,
    987898,
    678977,
    789997,
    688967,
    789797,
    888987,
    888788,
    967897,
    898898,
    688797,
    898967,
    897888,
    889978,
    889977,
    998887,
    887778,
    878887,
    879688,
    879877,
    778787,
    768877,
    889878,
    877698,
    899968,
    987776,
    699888,
    787987,
    988978,
    689778,
    687869,
    879889,
    788689,
    899787,
    887678,
    787987,
    789978,
    878778,
    887779,
    797778,
    776897,
    787899,
    997978,
    977988,
    788798,
    878997,
    877998,
    898788,
    798879,
    977878,
    886977,
    878798,
    888877,
    777978,
    777888,
    878789,
    787888,
    897779,
    889888,
    789777,
    699997,
    878689,
    878897,
    796787,
    877796,
    898788,
    997879,
    888777,
    968698,
    698897,
    879976,
    988898,
    877978,
    788688,
    968698,
    788889,
    889768,
    967787,
    878888,
    978798,
    788688,
    989998,
    979889,
    977887,
    876787,
    789878,
    787877,
    878787,
    788899,
    788988,
    888899,
    899888,
    888889,
    988889,
    779879,
    788987,
    889778,
    787699,
    787687,
    797886,
    879978,
    799989,
    788788,
    868877,
    779897,
    877878,
    897797,
    789787,
    788887,
    776988,
    699887,
    898787,
    789699,
    797787,
    988898,
    887897,
    887888,
    877897,
    887898,
    898998,
    788788,
    888986,
    797889,
    898878,
    887788,
    889888,
    888889,
    798777,
    977889,
    878889,
    969798,
    799877,
    999877,
    778999,
    899897,
    899976,
    689677,
    778897,
    877887,
    976869,
    886989,
    778877,
    988788,
    877777,
    888877,
    779878,
    886989,
    977788,
    789988,
    777676,
    987799,
    999798,
    777888,
    797878,
    889797,
    877877,
    877978,
    898899,
    967888,
    689777,
    897887,
    769698,
    979898,
    878888,
    897798,
    988797,
    876788,
    668797,
    876777,
    887689,
    867788,
    889978,
    877978,
    979778,
    899987,
    877878,
    888879,
    977868,
    866789,
    888877,
    879877,
    886888,
    797988,
    778888,
    888899,
    888867,
    799778,
    778797,
    679877,
    978778,
    888789,
    876888,
    978979,
    767888,
    979987,
    889786,
    789897,
    888787,
    888777,
    878868,
    866887,
    778797,
    779988,
    887778,
    998888,
    887879,
    778998,
    777986,
    777878,
    889989,
    978777,
    797887,
    897887,
    789878,
    778778,
    876777,
    777988,
    979898,
    988988,
    868887,
    876878,
    878888,
    897978,
    788879,
    877687,
    979888,
    887878,
    789787,
    886988,
    878798,
    898877,
    779778,
    879678,
    777887,
    787978,
    789976,
    888867,
    988778,
    778887,
    767778,
    787888,
    788989,
    778897,
    888777,
    797998,
    979877,
    768997,
    879778,
    898899,
    877768,
    878967,
    988777,
    868789,
    788889,
    798778,
    788777,
    888779,
    778898,
    978878,
    878879,
    879887,
    887879,
    878878,
    778889,
    679787,
    987787,
    788988,
    898779,
    897778,
    878888,
    667889,
    887678,
    998887,
    777769,
    777988,
    898777,
    788798,
    789898,
    979878,
    887998,
    787869,
    978879,
    798887,
    976879,
    778896,
    789787,
    988978,
    898988,
    888889,
    778787,
    777877,
    898989,
    998798,
    777778,
    789869,
    897988,
    877768,
    878877,
    998789,
    998877,
    789877,
    888877,
    967787,
    878777,
    888898,
    887777,
    789776,
    887778,
    877787,
    787767,
    777798,
    988896,
    879798,
    679986,
    877787,
    788887,
    879888,
    788787,
    968778,
    888898,
    887887,
    779788,
    898786,
    877877,
    898769,
    678888,
    977898,
    788889,
    787787,
    967778,
    786778,
    798888,
    867998,
    896777,
    797879,
    798898,
    888776,
    989879,
    878888,
    877878,
    887888,
    989987,
    968787,
    868878,
    868878,
    987878,
    789968,
    897876,
    888887,
    978898,
    778977,
    678997,
    697898,
    878876,
    778987,
    768987,
    899878,
    888887,
    888787,
    879898,
    878879,
    799768,
    877977,
    889778,
    789978,
    799888,
    989888,
    679788,
    678977,
    887897,
    788766,
    899778,
    878878,
    788877,
    898897,
    797878,
    779788,
    778778,
    877869,
    898797,
    786799,
    998869,
    888978,
    887779,
    878779,
    977878,
    889988,
    799779,
    976987,
    789987,
    778976,
    887889,
    777887,
    778778,
    787989,
    779877,
    687788,
    979879,
    788877,
    899878,
    797888,
    878768,
    897998,
    998888,
    787688,
    888988,
    688887,
    779698,
    996887,
    788867,
    998977,
    787887,
    887677,
    979879,
    789767,
    997778,
    888797,
    988888,
    897976,
    987887,
    877777,
    898788,
    877877,
    778897,
    877887,
    797987,
    987878,
    767688,
    879877,
    688776,
    798798,
    879777,
    788798,
    687796,
    878788,
    878779,
    868977,
    889778,
    888888,
    879897,
    698978,
    886897,
    977898,
    797878,
    789799,
    868677,
    888768,
    789877,
    689889,
    787698,
    786867,
    889799,
    889878,
    877799,
    887878,
    988779,
    768677,
    887979,
    887788,
    889987,
    797999,
    878779,
    887777,
    778798,
    868888,
    879789,
    878876,
    997976,
    887777,
    887878,
    887877,
    898867,
    669877,
    788978,
    799999,
    688978,
    788976,
    888979,
    787788,
    789789,
    888897,
    997789,
    899988,
    878688,
    889777,
    797688,
    788787,
    689767,
    776998,
    789898,
    986798,
    897887,
    778767,
    877777,
    899988,
    899887,
    689988,
    987877,
    777969,
    877668,
    677687,
    686788,
    877887,
    788777,
    778978,
    986788,
    888788,
    798899,
    988887,
    877876,
    997978,
    898778,
    788779,
    787989,
    788889,
    786788,
    876778,
    888989,
    698799,
    688889,
    968779,
    787779,
    988677,
    797798,
    879889,
    889878,
    789777,
    778877,
    888998,
    877899,
    878788,
    877678,
    697788,
    888986,
    778988,
    987996,
    778778,
    878767,
    777987,
    867879,
    978677,
    788789,
    979798,
    778796,
    778789,
    888879,
    787878,
    888877,
    878799,
    988687,
    888787,
    797768,
    868689,
    788678,
    686987,
    879888,
    988879,
    888887,
    878887,
    898987,
    788998,
    778876,
    886889,
    988887,
    878878,
    877798,
    868987,
    887878,
    988778,
    887988,
    877989,
    788969,
    877777,
    686889,
    876876,
    897778,
    788788,
    987787,
    888889,
    797778,
    878869,
    877888,
    976788,
    789878,
    889869,
    878987,
    788788,
    687698,
    788977,
    776678,
    687888,
    889878,
    777788,
    799768,
    787797,
    878787,
    879788,
    887787,
    878787,
    787878,
    887887,
    768698,
    896888,
    789988,
    879799,
    989688,
    898788,
    878878,
    879888,
    889877,
    878997,
    887778,
    977787,
    788977,
    888887,
    767898,
    787978,
    887898,
    777988,
    878888,
    898888,
    898787,
    797787,
    786997,
    889889,
    787776,
    778889,
    778889,
    898888,
    868996,
    689677,
    899887,
    878788,
    887987,
    699787,
    878786,
    877787,
    778879,
    878889,
    868888,
    868888,
    877676,
    768887,
    889978,
    788777,
    987787,
    877688,
    989877,
    887887,
    897998,
    886877,
    886878,
    768767,
    878787,
    997998,
    887887,
    797799,
    888787,
    778888,
    988877,
    887879,
    989898,
    998877,
    878778,
    797877,
    767788,
    776877,
    796769,
    877769,
    877888,
    887978,
    887887,
    889889,
    978988,
    889786,
    788987,
    776788,
    889778,
    797888,
    898877,
    986787,
    789987,
    787986,
    879787,
    769769,
    898898,
    888978,
    989786,
    688899,
    887788,
    778889,
    978889,
    777888,
    787966,
    988886,
    967687,
    987789,
    898779,
    779989,
    788796,
    987888,
    787888,
    887897,
    798777,
    798888,
    977788,
    778887,
    788987,
    988889,
    988978,
    889799,
    797789,
    888787,
    888896,
    877778,
    888897,
    999686,
    789889,
    867887,
    887886,
    778877,
    798978,
    777897,
    899898,
    868769,
    887887,
    998888,
    767967,
    897888,
    888889,
    776879,
    989978,
    988877,
    889889,
    897788,
    778887,
    888887,
    878777,
    878898,
    889786,
    887689,
    887787,
    887887,
    799889,
    899888,
    677888,
    779977,
    787878,
    786978,
    878879,
    797978,
    878967,
    868786,
    878988,
    888898,
    979898,
    989888,
    888777,
    787778,
    789977,
    888887,
    898897,
    888787,
    767777,
    887867,
    888887,
    788777,
    997897,
    697896,
    878787,
    887779,
    888787,
    888877,
    886897,
    869689,
    899786,
    887868,
    797779,
    878889,
    898988,
    677666,
    868888,
    787798,
    878978,
    867778,
    777879,
    676688,
    987877,
    987877,
    777897,
    887878,
    977868,
    877687,
    897878,
    999867,
    786988,
    797889,
    787897,
    768698,
    779787,
    876968,
    886889,
    879787,
    877887,
    776878,
    987786,
    777968,
    888788,
    899998,
    768977,
    997888,
    987788,
    878678,
    779888,
    779888,
    788967,
    887978,
    988877,
    798789,
    787897,
    878987,
    788977,
    977987,
    786798,
    978877,
    776787,
    787967,
    777876,
    688988,
    969988,
    889787,
    899989,
    778878,
    896696,
    797878,
    979988,
    997878,
    889878,
    788889,
    887887,
    798779,
    887787,
    798878,
    888788,
    676888,
    898788,
    876997,
    898889,
    988888,
    889777,
    888979,
    788877,
    868888,
    888877,
    787798,
    899887,
    799887,
    778689,
    798877,
    677866,
    897877,
    676878,
    776786,
    878987,
    777798,
    799788,
    988976,
    778689,
    877988,
    798798,
    777688,
    868777,
    877889,
    878777,
    788779,
    799778,
    767989,
    889778,
    978678,
    997987,
    889797,
    887978,
    789979,
    886778,
    877879,
    887898,
    697867,
    978888,
    979778,
    787788,
    879896,
    899877,
    999878,
    877879,
    878888,
    798987,
    898789,
    889977,
    887787,
    869989,
    977777,
    789977,
    887767,
    997777,
    777768,
    879987,
    778786,
    978988,
    987788,
    888887,
    878778,
    998688,
    897788,
    877896,
    887989,
    798888,
    978889,
    778798,
    787887,
    897886,
    867898,
    778789,
    888888,
    778888,
    888687,
    889898,
    888887,
    787879,
    797797,
    888876,
    897688,
    898877,
    788887,
    788989,
    978888,
    878989,
    888969,
    887878,
    887898,
    787988,
    788987,
    787886,
    768778,
    778887,
    889988,
    777878,
    789997,
    888878,
    887988,
    786869,
    987878,
    878888,
    898898,
    888876,
    787868,
    778697,
    788689,
    887978,
    688888,
    797799,
    977779,
    898878,
    999778,
    877987,
    878788,
    889887,
    988779,
    778898,
    988998,
    989878,
    967879,
    899787,
    878798,
    998888,
    888779,
    868887,
    978887,
    877888,
    696989,
    888889,
    897798,
    877889,
    978997,
    877797,
    678686,
    888778,
    778686,
    788888,
    879788,
    789898,
    888886,
    878888,
    988687,
    788789,
    789788,
    887698,
    998987,
    889779,
    798797,
    888877,
    688789,
    899888,
    788888,
    798789,
    886977,
    889998,
    988888,
    798779,
    797988,
    887777,
    787767,
    887868,
    789898,
    778798,
    988899,
    778867,
    678798,
    877698,
    777887,
    877898,
    788988,
    898888,
    979988,
    776877,
    888877,
    987899,
    897888,
    877677,
    887879,
    768868,
    889987,
    769888,
    788879,
    678988,
    789898,
    998878,
    988897,
    678789,
    877787,
    797788,
    879889,
    897877,
    878677,
    777888,
    988788,
    887877,
    986789,
    778978,
    798689,
    987688,
    878899,
    888787,
    888867,
    888777,
    887777,
    698789,
    988899,
    778888,
    987887,
    988977,
    777798,
    778799,
    977786,
    889967,
    888787,
    979777,
    997776,
    779967,
    888978,
    798997,
    979998,
    779798,
    987987,
    877799,
    878888,
    889797,
    988988,
    888777,
    877878,
    799889,
    787889,
    766997,
    889868,
    886778,
    868968,
    988967,
    787888,
    696788,
    789886,
    878987,
    787777,
    777779,
    777878,
    979777,
    899867,
    878688,
    777898,
    767788,
    978899,
    796777,
    997777,
    988998,
    878877,
    778878,
    788899,
    797888,
    887877,
    898888,
    887689,
    899987,
    699987,
    778987,
    879868,
    888787,
    788897,
    997876,
    888887,
    788889,
    978777,
    989897,
    886787,
    898989,
    888967,
    899899,
    668887,
    778697,
    768888,
    977887,
    977977,
    897788,
    887778,
    997976,
    677787,
    788888,
    987777,
    978898,
    899887,
    888998,
    788687,
    786987,
    788989,
    697877,
    778987,
    877888,
    987789,
    888698,
    889688,
    788888,
    777768,
    987898,
    978998,
    799978,
    898788,
    887887,
    788777,
    787988,
    787978,
    876768,
    997987,
    979887,
    788877,
    897889,
    677978,
    878878,
    898786,
    869978,
    798798,
    897968,
    989777,
    877889,
    887887,
    789869,
    898886,
    798967,
    887798,
    969687,
    786897,
    888887,
    798888,
    987878,
    889787,
    887867,
    787879,
    787887,
    877988,
    987787,
    979788,
    889777,
    898876,
    797878,
    768979,
    897978,
    687988,
    987779,
    777678,
    777798,
    798889,
    687998,
    898876,
    789997,
    899889,
    788879,
    679977,
    678688,
    788786,
    679777,
    866867,
    887888,
    697668,
    889887,
    778788,
    878889,
    787888,
    787888,
    898867,
    889777,
    967787,
    888879,
    897798,
    899688,
    978777,
    877789,
    886988,
    698979,
    977779,
    899897,
    768787,
    788888,
    879969,
    887878,
    776667,
    888888,
    899999,
    887879,
    787988,
    878877,
    978888,
    797679,
    798777,
    888989,
    877977,
    788788,
    868788,
    887776,
    879887,
    888879,
    779778,
    699799,
    978786,
    878886,
    798899,
    989886,
    779888,
    887898,
    898899,
    888987,
    869886,
    797798,
    786897,
    887868,
    877887,
    887789,
    898769,
    779788,
    988798,
    868878,
    878787,
    878778,
    888888,
    989989,
    779887,
    789888,
    979867,
    889788,
    987878,
    868678,
    978897,
    778878,
    898888,
    799898,
    788689,
    889978,
    977878,
    688778,
    767889,
    897998,
    687878,
    779787,
    667877,
    978688,
    888878,
    887867,
    977997,
    967887,
    989797,
    976888,
    978778,
    767786,
    888877,
    677877,
    788887,
    886897,
    989887,
    789787,
    788888,
    887668,
    867789,
    898877,
    888898,
    978979,
    788877,
    786786,
    788978,
    878997,
    797777,
    878779,
    688877,
    888877,
    678997,
    887977,
    886996,
    987889,
    777878,
    988778,
    877888,
    888768,
    888988,
    878988,
    978898,
    777778,
    878887,
    887887,
    778888,
    778878,
    897898,
    877899,
    887797,
    988777,
    778887,
    888998,
    787888,
    876797,
    898798,
    679887,
    678878,
    887699,
    877988,
    979787,
    897888,
    888767,
    898888,
    778988,
    877766,
    788877,
    898888,
    789888,
    887877,
    798678,
    877787,
    778788,
    988879,
    878797,
    888997,
    888887,
    878687,
    998778,
    997877,
    987787,
    687988,
    787888,
    778878,
    777887,
    978879,
    699769,
    778878,
    787978,
    798898,
    668898,
    777987,
    987888,
    787777,
    678779,
    778878,
    887787,
    786877,
    788788,
    898769,
    898877,
    787889,
    787987,
    879886,
    798978,
    788977,
    887667,
    898888,
    798887,
    979687,
    788889,
    978788,
    777687,
    888777,
    887888,
    777888,
    999777,
    889978,
    789998,
    998986,
    897799,
    887888,
    897778,
    876888,
    778677,
    778789,
    879799,
    798876,
    889876,
    778988,
    987898,
    899786,
    788778,
    988688,
    878898,
    687888,
    877778,
    777887,
    888687,
    988898,
    878778,
    878797,
    798788,
    888977,
    889778,
    988877,
    798788,
    777897,
    887797,
    798887,
    897887,
    778977,
    877888,
    987888,
    788867,
    979688,
    767877,
    667887,
    778789,
    769879,
    998687,
    889967,
    888887,
    998899,
    987887,
    798977,
    999787,
    888998,
    877897,
    887778,
    877788,
    997887,
    768777,
    667998,
    887766,
    877878,
    877897,
    878899,
    679979,
    787889,
    887889,
    788768,
    779777,
    868966,
    988877,
    787888,
    988879,
    878887,
    866888,
    988787,
    897997,
    996889,
    777889,
    798777,
    888788,
    888999,
    967778,
    668677,
    978689,
    987788,
    798788,
    767788,
    978799,
    767989,
    877788,
    988787,
    886877,
    979888,
    889876,
    877778,
    878989,
    786878,
    787878,
    787998,
    686777,
    868889,
    877988,
    788989,
    997988,
    889779,
    667678,
    987988,
    798877,
    787898,
    888796,
    987778,
    777889,
    786778,
    768699,
    988797,
    977978,
    778778,
    999998,
    778677,
    778979,
    679868,
    878788,
    788777,
    989898,
    888796,
    786989,
    776888,
    887787,
    888788,
    888787,
    797988,
    996777,
    997988,
    888886,
    977879,
    997988,
    787786,
    688998,
    888788,
    788788,
    886887,
    979888,
    779977,
    988987,
    968879,
    788698,
    987988,
    987898,
    786778,
    888798,
    779787,
    888977,
    787798,
    888887,
    798799,
    788987,
    869779,
    878877,
    788887,
    899877,
    967898,
    789789,
    899768,
    889788,
    979797,
    888869,
    898877,
    898778,
    776876,
    987787,
    788886,
    889879,
    799786,
    886876,
    779999,
    789788,
    798889,
    799788,
    998788,
    888789,
    798878,
    887777,
    688698,
    778887,
    977787,
    877788,
    777778,
    786779,
    999777,
    776878,
    777898,
    887977,
    879777,
    888977,
    977989,
    878788,
    896988,
    878886,
    799889,
    787877,
    789769,
    877888,
    789877,
    798787,
    777889,
    977988,
    769897,
    889778,
    777787,
    787977,
    899679,
    777887,
    978886,
    779897,
    898888,
    988889,
    777678,
    879877,
    887898,
    689789,
    878788,
    978786,
    888877,
    878988,
    879779,
    878688,
    688877,
    989877,
    898788,
    776788,
    768898,
    898877,
    779988,
    888888,
    786788,
    786688,
    688888,
    889888,
    778888,
    788778,
    877788,
    888778,
    897887,
    977876,
    778889,
    887869,
    889878,
    987978,
    888887,
    787789,
    788887,
    777866,
    779869,
    687789,
    787897,
    797798,
    888899,
    888867,
    898877,
    978988,
    997898,
    888878,
    797868,
    996788,
    877779,
    898678,
    987798,
    887887,
    978987,
    987799,
    788787,
    898787,
    788879,
    886779,
    787788,
    978689,
    677979,
    998787,
    889777,
    897886,
    778899,
    778798,
    888987,
    976778,
    767889,
    777888,
    888979,
    979798,
    979767,
    678778,
    798789,
    988889,
    668777,
    988888,
    878877,
    889888,
    978988,
    787978,
    888797,
    779887,
    788777,
    799789,
    998877,
    877897,
    988887,
    998777,
    777789,
    777677,
    989988,
    897979,
    888987,
    789777,
    989878,
    799989,
    778797,
    878967,
    888889,
    899886,
    878877,
    877777,
    678788,
    787887,
    879899,
    978887,
    789899,
    986979,
    888998,
    787778,
    779687,
    768788,
    888888,
    788778,
    777988,
    897798,
    777969,
    787877,
    799988,
    898789,
    888778,
    797969,
    898979,
    887798,
    787977,
    997877,
    797788,
    989689,
    877878,
    989768,
    698679,
    787769,
    897877,
    779778,
    786889,
    876889,
    878888,
    887987,
    867886,
    878898,
    889998,
    687889,
    888778,
    789878,
    777878,
    869868,
    887897,
    676889,
    989877,
    878888,
    796878,
    897777,
    979987,
    777768,
    788986,
    988778,
    887887,
    878898,
    798786,
    897787,
    887798,
    788869,
    768697,
    887788,
    888889,
    887787,
    877688,
    978869,
    778798,
    888987,
    799988,
    886988,
    777799,
    868888,
    798888,
    788787,
    897887,
    877787,
    898986,
    798866,
    888989,
    776777,
    889668,
    987768,
    898898,
    888998,
    888699,
    887978,
    778787,
    876887,
    876997,
    868878,
    679778,
    998879,
    787778,
    787998,
    767878,
    888877,
    968888,
    878887,
    787869,
    867899,
    887976,
    878976,
    887767,
    878889,
    776798,
    788879,
    899789,
    787788,
    788979,
    788877,
    888888,
    988877,
    788988,
    869888,
    788998,
    787786,
    697979,
    788777,
    889888,
    887876,
    878898,
    789698,
    777877,
    868778,
    898886,
    779888,
    779797,
    989878,
    989976,
    989787,
    898987,
    988887,
    689867,
    997889,
    778879,
    878878,
    878778,
    998898,
    778786,
    797897,
    878979,
    978778,
    887887,
    997888,
    787877,
    878777,
    687887,
    988787,
    897977,
    889888,
    886899,
    688878,
    888788,
    778788,
    887787,
    978788,
    887877,
    877877,
    888898,
    987878,
    889878,
    889878,
    878687,
    789777,
    877788,
    888786,
    789679,
    787878,
    896888,
    798898,
    987787,
    777777,
    788887,
    888989,
    787789,
    796878,
    789798,
    768979,
    788878,
    877899,
    789867,
    797988,
    888688,
    996888,
    787788,
    787797,
    889788,
    898899,
    877888,
    868878,
    979868,
    878887,
    798798,
    788768,
    997679,
    779787,
    997798,
    869968,
    886787,
    788788,
    988887,
    878988,
    688878,
    989987,
    988779,
    888888,
    889877,
    987898,
    877888,
    987978,
    897889,
    778778,
    688788,
    877767,
    887898,
    798688,
    788778,
    888868,
    877887,
    887977,
    977698,
    788988,
    888877,
    887798,
    989887,
    777888,
    878898,
    899887,
    787787,
    888799,
    778989,
    787988,
    997868,
    897786,
    866776,
    978798,
    898996,
    999877,
    969789,
    877887,
    989978,
    688877,
    978898,
    689778,
    888787,
    788898,
    788888,
    877887,
    778888,
    887779,
    988897,
    888887,
    777787,
    896788,
    886788,
    678888,
    788787,
    897879,
    876868,
    787898,
    888897,
    976887,
    767887,
    878778,
    878787,
    779988,
    799787,
    877888,
    777788,
    969867,
    987878,
    877878,
    798878,
    889998,
    898778,
    866888,
    888988,
    688778,
    877988,
    887789,
    868797,
    878697,
    889878,
    877887,
    988797,
    888889,
    889887,
    879887,
    987787,
    878788,
    886968,
    889887,
    768879,
    978798,
    787969,
    898878,
    798788,
    888878,
    979979,
    688878,
    898888,
    778889,
    977687,
    978777,
    788979,
    978896,
    789788,
    789879,
    868898,
    779877,
    987888,
    797878,
    887987,
    988897,
    887988,
    976887,
    988888,
    678899,
    876869,
    779877,
    797998,
    789789,
    897997,
    786777,
    776888,
    898787,
    978879,
    788889,
    787978,
    888979,
    998888,
    778898,
    798888,
    879778,
    689877,
    976887,
    788788,
    798968,
    988788,
    777976,
    777888,
    868877,
    778898,
    887778,
    767889,
    778678,
    887898,
    888779,
    788787,
    878876,
    887877,
    898677,
    767788,
    687899,
    687788,
    988987,
    977977,
    778877,
    886897,
    687998,
    898789,
    868878,
    666898,
    789897,
    688787,
    877778,
    777787,
    878868,
    998997,
    878777,
    988787,
    778888,
    878799,
    888778,
    878788,
    787878,
    688777,
    798797,
    788888,
    898889,
    878686,
    777997,
    978887,
    989799,
    888787,
    988889,
    778778,
    887878,
    988997,
    967878,
    769868,
    997998,
    777787,
    968878,
    987897,
    778889,
    887897,
    987987,
    878988,
    688788,
    777787,
    886869,
    789987,
    779687,
    887986,
    886786,
    899877,
    867978,
    779898,
    887798,
    888998,
    987988,
    988976,
    899989,
    789667,
    867868,
    887797,
    999799,
    868879,
    877997,
    887897,
    886678,
    787977,
    897979,
    777868,
    887988,
    676997,
    778988,
    799978,
    787787,
    787689,
    777787,
    988889,
    869976,
    897779,
    888797,
    889989,
    798878,
    999987,
    777878,
    877868,
    977788,
    778878,
    888779,
    766778,
    998876,
    888688,
    788878,
    887999,
    788996,
    899897,
    867767,
    979877,
    778888,
    878798,
    878868,
    878889,
    888798,
    898888,
    867878,
    678789,
    777878,
    988979,
    879888,
    787989,
    888998,
    787887,
    898799,
    879878,
    998987,
    989778,
    888897,
    888887,
    778887,
    878888,
    876788,
    877896,
    887889,
    976877,
    777777,
    888698,
    778698,
    889878,
    978898,
    688879,
    888777,
    786898,
    779777,
    898777,
    886787,
    778887,
    998778,
    878999,
    998678,
    878989,
    998867,
    778876,
    787878,
    889777,
    867787,
    888688,
    789866,
    876878,
    867877,
    887778,
    888887,
    797887,
    889788,
    867887,
    777788,
    888978,
    787678,
    777876,
    988778,
    968979,
    997767,
    778998,
    888888,
    687999,
    888878,
    867978,
    876877,
    978789,
    997788,
    886789,
    976988,
    788996,
    978978,
    978787,
    886778,
    878998,
    989878,
    788887,
    998887,
    998888,
    987887,
    777888,
    887889,
    889779,
    877889,
    687978,
    879898,
    988987,
    988788,
    897887,
    878997,
    888887,
    868986,
    888888,
    886897,
    779788,
    877988,
    788796,
    778978,
    787988,
    879879,
    778997,
    987786,
    678886,
    997877,
    887886,
    796798,
    788898,
    787887,
    887799,
    797787,
    876877,
    988668,
    978867,
    897988,
    888997,
    888887,
    788788,
    777788,
    967799,
    787878,
    797979,
    967988,
    866898,
    697887,
    898878,
    879799,
    888779,
    888898,
    977787,
    779788,
    878897,
    977697,
    779779,
    888777,
    679878,
    888898,
    898878,
    978878,
    887978,
    797898,
    787979,
    888897,
    887678,
    799788,
    886878,
    888779,
    899778,
    777886,
    988687,
    777888,
    877797,
    878876,
    888788,
    798689,
    877778,
    777878,
    798698,
    788689,
    998776,
    877887,
    987789,
    877789,
    878879,
    779779,
    979887,
    778878,
    888888,
    778888,
    766968,
    887888,
    788778,
    788787,
    777988,
    877777,
    788887,
    787798,
    788798,
    787988,
    767997,
    977788,
    787887,
    997889,
    988788,
    897778,
    778868,
    998877,
    889877,
    888889,
    888878,
    989778,
    788898,
    977877,
    879878,
    679886,
    979968,
    898898,
    989787,
    787888,
    877889,
    968879,
    987889,
    887688,
    777888,
    877888,
    988897,
    888767,
    788799,
    879778,
    689798,
    978667,
    888889,
    766979,
    978976,
    888877,
    788878,
    877987,
    798869,
    777789,
    868898,
    789688,
    787898,
    778789,
    987788,
    788898,
    988868,
    899887,
    887886,
    778889,
    969888,
    886899,
    898878,
    879778,
    777878,
    888789,
    997888,
    989978,
    898778,
    997779,
    789889,
    996977,
    889979,
    999787,
    778877,
    898686,
    778877,
    989889,
    877899,
    778887,
    768767,
    788788,
    887878,
    978879,
    778988,
    778789,
    777878,
    886966,
    897879,
    879878,
    789987,
    988879,
    898789,
    779769,
    877888,
    768887,
    979787,
    887889,
    989888,
    979886,
    679998,
    898997,
    988869,
    677876,
    777767,
    788778,
    697987,
    887788,
    878689,
    777787,
    997988,
    779997,
    898798,
    876778,
    878879,
    887786,
    878778,
    988887,
    787877,
    899788,
    788997,
    698688,
    888888,
    788777,
    898776,
    798796,
    888879,
    688769,
    987789,
    787687,
    787978,
    877788,
    788987,
    788977,
    777878,
    797898,
    978877,
    778899,
    798798,
    878987,
    878988,
    777777,
    786887,
    889787,
    687776,
    889976,
    898897,
    898798,
    978786,
    687976,
    696777,
    787878,
    988778,
    878777,
    978888,
    897777,
    877679,
    788888,
    978888,
    888678,
    778787,
    889786,
    878887,
    899879,
    997797,
    978777,
    978877,
    867988,
    878886,
    887786,
    877887,
    878778,
    687777,
    778898,
    898989,
    999788,
    788889,
    698877,
    787888,
    997879,
    788788,
    977868,
    697887,
    989676,
    687888,
    978687,
    788987,
    668788,
    798998,
    996968,
    797978,
    797778,
    878767,
    789887,
    686779,
    878877,
    877988,
    787889,
    977879,
    767798,
    878689,
    779987,
    877868,
    798879,
    899788,
    898979,
    879777,
    789788,
    877879,
    787778,
    878888,
    987998,
    688889,
    769798,
    969987,
    898889,
    789896,
    879898,
    877886,
    878779,
    888687,
    779787,
    697697,
    678769,
    798889,
    998989,
    789887,
    777988,
    788988,
    887988,
    988879,
    888796,
    989777,
    887779,
    878878,
    998777,
    778688,
    798899,
    979897,
    876999,
    986896,
    788778,
    889888,
    888898,
    777867,
    768989,
    787879,
    768777,
    877777,
    887878,
    979887,
    777869,
    788879,
    978888,
    897777,
    888989,
    889987,
    689679,
    788778,
    778878,
    987868,
    969877,
    889886,
    967877,
    777988,
    968776,
    798788,
    798868,
    788888,
    777778,
    987676,
    889797,
    887889,
    877788,
    777888,
    688897,
    888787,
    897887,
    877888,
    787986,
    789798,
    869988,
    687888,
    989688,
    778779,
    778898,
    797688,
    797977,
    777797,
    678789,
    887878,
    977877,
    798878,
    898877,
    878868,
    988798,
    889789,
    897886,
    779888,
    778888,
    878878,
    968888,
    867878,
    879788,
    888978,
    788998,
    877889,
    779788,
    878789,
    888887,
    999798,
    689789,
    878879,
    878886,
    768797,
    787996,
    988878,
    888788,
    977787,
    887788,
    796778,
    888999,
    877779,
    777979,
    877789,
    988887,
    777899,
    786988,
    987787,
    788897,
    988787,
    788789,
    787888,
    986877,
    887998,
    987898,
    788788,
    888987,
    889878,
    799988,
    888798,
    768867,
    977987,
    779888,
    787687,
    789789,
    898788,
    988888,
    798777,
    888789,
    976788,
    877897,
    777877,
    888679,
    867986,
    877778,
    798899,
    879997,
    767979,
    788788,
    897697,
    988999,
    986888,
    897878,
    897987,
    876898,
    688978,
    887768,
    887788,
    896878,
    896777,
    769789,
    888887,
    789786,
    887887,
    776778,
    879689,
    678887,
    777797,
    789889,
    888888,
    977869,
    896987,
    867778,
    788888,
    988797,
    987777,
    777798,
    888888,
    788978,
    789797,
    777896,
    798788,
    789787,
    678888,
    977797,
    878998,
    877886,
    877887,
    777988,
    876888,
    887866,
    877988,
    887898,
    788776,
    888776,
    778987,
    797778,
    788888,
    887788,
    888968,
    787868,
    777998,
    799888,
    987888,
    787877,
    778796,
    898889,
    889979,
    797879,
    898878,
    898888,
    898999,
    787778,
    888967,
    787889,
    978787,
    869688,
    779888,
    778778,
    688678,
    769778,
    978689,
    877687,
    787888,
    777868,
    667799,
    879897,
    866676,
    887877,
    787788,
    989776,
    798778,
    769878,
    867699,
    888988,
    767797,
    987788,
    697778,
    998787,
    699867,
    798778,
    789799,
    788977,
    788778,
    876677,
    678888,
    886798,
    888767,
    879897,
    896977,
    987778,
    788699,
    777967,
    767988,
    687889,
    878798,
    888779,
    866867,
    878989,
    877776,
    878787,
    887687,
    798787,
    867787,
    768987,
    889787,
    888888,
    797867,
    878887,
    867877,
    768878,
    788898,
    798789,
    968989,
    976869,
    799888,
    877877,
    788879,
    877888,
    798887,
    768988,
    769877,
    768678,
    887987,
    879687,
    986688,
    897978,
    797879,
    767889,
    968879,
    786868,
    887987,
    788876,
    997987,
    988698,
    887777,
    698788,
    788777,
    987999,
    787769,
    898789,
    779978,
    877787,
    897878,
    687989,
    988678,
    888777,
    788998,
    979799,
    787988,
    799698,
    799979,
    797788,
    777877,
    877688,
    877878,
    878997,
    879878,
    878877,
    978798,
    789978,
    777978,
    789888,
    877788,
    897699,
    667787,
    676887,
    878799,
    987897,
    797896,
    788987,
    786887,
    897879,
    797989,
    988989,
    768888,
    877888,
    688889,
    797877,
    768978,
    888697,
    878788,
    796977,
    799878,
    977767,
    677778,
    879989,
    799887,
    887867,
    889988,
    987878,
    987888,
    978887,
    896778,
    867886,
    777777,
    788988,
    778878,
    987778,
    787998,
    789866,
    888878,
    789879,
    887886,
    869988,
    899898,
    888796,
    878788,
    798977,
    777987,
    777777,
    978788,
    887888,
    797897,
    768789,
    789987,
    897896,
    887899,
    877688,
    776777,
    987887,
    899697,
    798687,
    878887,
    877779,
    987977,
    698886,
    886878,
    788888,
    798988,
    978878,
    989978,
    988987,
    777998,
    986867,
    889989,
    878788,
    997778,
    787798,
    969867,
    769777,
    989888,
    777777,
    888887,
    689887,
    989877,
    788998,
    798998,
    877998,
    968878,
    688788,
    788789,
    788997,
    897789,
    788968,
    667878,
    988879,
    778988,
    977888,
    888899,
    978898,
    787778,
    868879,
    878788,
    898777,
    776889,
    778988,
    888788,
    897977,
    867978,
    798678,
    777979,
    889788,
    878786,
    697777,
    678977,
    787777,
    977888,
    788777,
    787899,
    887889,
    788797,
    788786,
    877787,
    899978,
    788887,
    686989,
    888877,
    868687,
    888888,
    988888,
    798889,
    886877,
    878788,
    977787,
    978998,
    976887,
    787787,
    788879,
    798889,
    978887,
    797798,
    679778,
    797889,
    678889,
    887888,
    787876,
    987866,
    779878,
    988679,
    797988,
    888987,
    787777,
    788987,
    798898,
    967887,
    777777,
    786878,
    867888,
    888777,
    688787,
    689887,
    886778,
    877887,
    888677,
    697878,
    778887,
    769978,
    777687,
    869878,
    899868,
    789789,
    978777,
    777778,
    789877,
    999878,
    888898,
    779798,
    979776,
    977778,
    888888,
    879778,
    889767,
    799877,
    787887,
    887886,
    998997,
    897887,
    998887,
    898797,
    987776,
    777797,
    889798,
    788898,
    769787,
    867777,
    869779,
    797887,
    899989,
    797888,
    799779,
    899697,
    869887,
    877887,
    799889,
    887878,
    897897,
    987888,
    888889,
    878998,
    697788,
    878777,
    869979,
    689879,
    797788,
    778879,
    878978,
    888888,
    987786,
    968797,
    878898,
    887887,
    896869,
    888889,
    887878,
    787999,
    977788,
    787878,
    877879,
    979979,
    887697,
    878788,
    898867,
    788888,
    898778,
    898878,
    798898,
    868888,
    887998,
    896687,
    788996,
    878879,
    778867,
    779777,
    887888,
    777797,
    788777,
    788797,
    687777,
    798888,
    888889,
    889798,
    797988,
    789797,
    898897,
    879788,
    789777,
    678988,
    777776,
    899977,
    778778,
    978868,
    888878,
    898878,
    787888,
    888897,
    879688,
    788777,
    887887,
    987979,
    778887,
    986887,
    877997,
    878899,
    878797,
    999788,
    688799,
    998888,
    897898,
    788787,
    987868,
    788788,
    799779,
    898886,
    878879,
    877787,
    887787,
    887889,
    788787,
    778877,
    888979,
    779767,
    888989,
    988689,
    888799,
    799898,
    899898,
    979887,
    788877,
    777877,
    888787,
    888988,
    799788,
    686888,
    879899,
    998786,
    788897,
    968777,
    786788,
    968976,
    767888,
    667977,
    999777,
    688878,
    888897,
    977697,
    898887,
    799889,
    896878,
    869788,
    786797,
    788997,
    897787,
    998888,
    977788,
    888889,
    987798,
    888698,
    888898,
    788877,
    878878,
    798877,
    798797,
    898888,
    887889,
    878778,
    867888,
    788778,
    788878,
    877897,
    888898,
    887888,
    878877,
    878877,
    887989,
    679887,
    898769,
    788788,
    987788,
    797979,
    788977,
    699778,
    788777,
    797998,
    689886,
    789768,
    779887,
    897978,
    788786,
    888868,
    988887,
    976977,
    777778,
    999797,
    877877,
    898878,
    768979,
    787987,
    898989,
    967888,
    898788,
    777798,
    777978,
    988878,
    867797,
    778888,
    698789,
    878798,
    899969,
    887888,
    787776,
    877889,
    877898,
    798878,
    769888,
    886889,
    787776,
    888787,
    888897,
    687778,
    798889,
    888897,
    798788,
    867878,
    676796,
    998888,
    896677,
    777877,
    889868,
    788888,
    698888,
    787797,
    898888,
    689988,
    877868,
    898877,
    788779,
    698888,
    878988,
    867988,
    888987,
    887978,
    879878,
    897888,
    987877,
    878987,
    878888,
    888777,
    899777,
    898878,
    877778,
    797897,
    888877,
    789777,
    896786,
    779989,
    988786,
    878888,
    878868,
    888789,
    788767,
    677668,
    987999,
    787988,
    888788,
    878878,
    778888,
    889877,
    888788,
    977977,
    769878,
    799798,
    998878,
    998878,
    869798,
    777777,
    978898,
    998979,
    888897,
    899876,
    697878,
    878778,
    798989,
    987887,
    689978,
    798987,
    788889,
    988989,
    968678,
    777796,
    878988,
    798798,
    968779,
    978869,
    888989,
    768876,
    889889,
    887997,
    988899,
    778786,
    898768,
    777878,
    877998,
    989788,
    877988,
    888779,
    787987,
    979798,
    888887,
    999987,
    898696,
    798787,
    789897,
    686868,
    789878,
    998878,
    978789,
    878777,
    887788,
    877869,
    767968,
    779988,
    888688,
    888799,
    689799,
    788797,
    979886,
    878888,
    779867,
    977869,
    988988,
    789878,
    997977,
    797787,
    886889,
    867889,
    888788,
    887977,
    867888,
    888878,
    897877,
    787778,
    887796,
    877868,
    777878,
    988998,
    788877,
    778877,
    778986,
    999877,
    678887,
    788788,
    777877,
    997789,
    978899,
    888888,
    998887,
    678788,
    886998,
    997887,
    978888,
    987888,
    788888,
    779786,
    779999,
    888788,
    889888,
    698988,
    787889,
    878789,
    788788,
    878688,
    988878,
    879898,
    888788,
    888888,
    777978,
    669777,
    898978,
    988789,
    788887,
    879987,
    778677,
    878686,
    677988,
    887768,
    988888,
    799779,
    988867,
    988978,
    787978,
    999778,
    788797,
    879989,
    988779,
    788779,
    887889,
    797877,
    667877,
    977887,
    987778,
    988886,
    889997,
    997878,
    778798,
    876897,
    767969,
    867778,
    987888,
    999779,
    877996,
    879898,
    678788,
    778888,
    788878,
    878987,
    988899,
    899898,
    998968,
    787788,
    887898,
    799778,
    897979,
    787998,
    778898,
    878877,
    989798,
    889778,
    888887,
    888887,
    878988,
    788768,
    889867,
    787888,
    988886,
    898798,
    877999,
    797879,
    997888,
    888967,
    787987,
    887878,
    798787,
    877997,
    777897,
    868987,
    778788,
    779789,
    687798,
    879779,
    886787,
    677779,
    878796,
    777978,
    897996,
    778778,
    977987,
    786879,
    898777,
    988878,
    778688,
    878989,
    989879,
    978888,
    789986,
    989798,
    697988,
    879698,
    797876,
    779969,
    698787,
    898787,
    879888,
    898987,
    789688,
    978877,
    779969,
    889897,
    877789,
    888887,
    869789,
    997778,
    977887,
    778879,
    877778,
    876779,
    779778,
    689978,
    887887,
    678869,
    879867,
    788789,
    898788,
    898687,
    888888,
    998696,
    879787,
    988886,
    698768,
    987888,
    788879,
    888968,
    798878,
    777879,
    879987,
    787789,
    678787,
    888888,
    878879,
    898889,
    988979,
    899999,
    788778,
    897889,
    787998,
    876786,
    968768,
    889878,
    678977,
    779888,
    788887,
    879888,
    889877,
    788878,
    888797,
    887878,
    877787,
    877888,
    799888,
    788897,
    889789,
    987788,
    777887,
    778977,
    687988,
    889787,
    979887,
    789887,
    887778,
    777788,
    998777,
    987967,
    799878,
    797897,
    988888,
    867886,
    869887,
    898898,
    787779,
    688888,
    888888,
    777899,
    886687,
    789878,
    898877,
    888977,
    987888,
    888978,
    977877,
    988899,
    897987,
    897699,
    678887,
    979878,
    888987,
    777788,
    797779,
    878887,
    898899,
    898886,
    789888,
    778887,
    887878,
    979877,
    778768,
    687977,
    669878,
    997887,
    888888,
    788989,
    787988,
    899888,
    897899,
    788668,
    879878,
    788786,
    788797,
    789998,
    889777,
    878897,
    897898,
    888778,
    988888,
    898688,
    787797,
    879898,
    868888,
    977779,
    787978,
    988998,
    888779,
    988889,
    888788,
    666797,
    988879,
    998788,
    777789,
    987987,
    888979,
    778898,
    987888,
    788876,
    888876,
    787997,
    686678,
    878778,
    869687,
    886797,
    878797,
    787889,
    678776,
    877877,
    999788,
    977899,
    789986,
    887889,
    877899,
    886978,
    887989,
    888687,
    898898,
    887899,
    788989,
    778888,
    698768,
    688679,
    886899,
    977889,
    978888,
    877778,
    888878,
    878688,
    778898,
    787778,
    768788,
    878688,
    998898,
    888878,
    979777,
    788878,
    897888,
    886789,
    778887,
    889876,
    877787,
    789897,
    878776,
    786769,
    788789,
    798989,
    798789,
    897887,
    877899,
    899898,
    767887,
    797898,
    878888,
    699988,
    888797,
    877696,
    787867,
    887797,
    888777,
    787789,
    888787,
    668799,
    887987,
    777677,
    889877,
    788887,
    897879,
    797879,
    788889,
    868688,
    879768,
    689799,
    768688,
    888979,
    779788,
    978789,
    998887,
    778777,
    878978,
    998889,
    797887,
    889788,
    879998,
    887687,
    776778,
    778789,
    997889,
    888877,
    767788,
    976899,
    888877,
    797777,
    888787,
    787699,
    888888,
    777878,
    888889,
    977878,
    688777,
    978897,
    778989,
    667976,
    688787,
    889878,
    768898,
    968866,
    778878,
    886778,
    898897,
    878887,
    888678,
    877767,
    877887,
    889987,
    789869,
    878788,
    877798,
    997999,
    888777,
    876879,
    888698,
    787868,
    987898,
    897976,
    888888,
    786889,
    786988,
    898898,
    797967,
    879779,
    689876,
    786688,
    767978,
    887888,
    788779,
    888787,
    798878,
    688878,
    888987,
    877687,
    869978,
    797898,
    978877,
    776868,
    877887,
    878888,
    698879,
    787677,
    887677,
    877778,
    887967,
    779879,
    878787,
    778889,
    788669,
    779978,
    879767,
    988878,
    799888,
    978787,
    679888,
    888977,
    779987,
    877778,
    967788,
    997979,
    989787,
    876778,
    778898,
    678768,
    979788,
    998778,
    887789,
    988788,
    977877,
    899777,
    878888,
    878778,
    678878,
    978786,
    889887,
    887877,
    788897,
    889887,
    997778,
    888869,
    877977,
    688878,
    968887,
    777789,
    988887,
    787799,
    889897,
    899888,
    877978,
    678677,
    868879,
    878989,
    687877,
    876688,
    898869,
    777887,
    788886,
    887977,
    999998,
    888877,
    798988,
    877888,
    888869,
    886898,
    779986,
    887768,
    866878,
    788798,
    879887,
    778977,
    798778,
    798887,
    887878,
    778887,
    688889,
    997967,
    879867,
    788986,
    888888,
    888876,
    788788,
    898877,
    789888,
    877898,
    898789,
    877678,
    798879,
    867777,
    789877,
    888779,
    988777,
    877997,
    778888,
    678776,
    979797,
    786876,
    978787,
    678778,
    879978,
    799999,
    688868,
    978887,
    778887,
    788988,
    767987,
    779788,
    988988,
    888798,
    888997,
    768887,
    698698,
    787797,
    897887,
    797887,
    988976,
    978898,
    879688,
    887777,
    798899,
    778778,
    898778,
    988888,
    888787,
    766787,
    999988,
    877798,
    998879,
    899786,
    788797,
    699788,
    888787,
    877877,
    898888,
    899687,
    799898,
    778778,
    888788,
    998777,
    988788,
    888978,
    888899,
    786887,
    877878,
    788799,
    777788,
    678897,
    768787,
    998778,
    998789,
    787787,
    678977,
    988886,
    898988,
    787897,
    787889,
    786798,
    687789,
    888797,
    788878,
    788978,
    889987,
    887797,
    988697,
    689798,
    878869,
    789789,
    787887,
    878867,
    778876,
    887887,
    787868,
    878898,
    866888,
    899878,
    988789,
    898998,
    888997,
    889978,
    798868,
    777878,
    787978,
    778888,
    799799,
    768887,
    777788,
    878986,
    789797,
    778778,
    896999,
    889897,
    798787,
    889888,
    888898,
    898888,
    888888,
    888987,
    778898,
    789888,
    996877,
    997778,
    879989,
    897777,
    998888,
    998898,
    988888,
    689877,
    987778,
    978776,
    869878,
    797768,
    897799,
    878798,
    877878,
    778778,
    979777,
    887886,
    677888,
    779887,
    987679,
    877799,
    889689,
    887777,
    778988,
    899877,
    878797,
    878887,
    998877,
    688687,
    797787,
    879988,
    787789,
    779886,
    888877,
    688877,
    879898,
    877898,
    978887,
    966778,
    887998,
    778898,
    788878,
    869778,
    867788,
    987779,
    979988,
    887877,
    997868,
    789778,
    988988,
    878788,
    789989,
    788878,
    887777,
    878888,
    888888,
    688888,
    798878,
    787877,
    797978,
    899687,
    989889,
    787779,
    979789,
    887877,
    868888,
    988988,
    787887,
    788897,
    889779,
    788879,
    967898,
    979978,
    779779,
    778976,
    878976,
    989877,
    999778,
    889798,
    687788,
    788877,
    889989,
    988887,
    787797,
    787898,
    897798,
    888989,
    887897,
    788889,
    899978,
    779867,
    787797,
    978889,
    988889,
    887897,
    888776,
    698788,
    798879,
    787677,
    787888,
    779888,
    988888,
    888897,
    778678,
    787799,
    788899,
    787888,
    868769,
    688887,
    878897,
    878788,
    878788,
    796868,
    788777,
    889879,
    878787,
    778898,
    889878,
    887887,
    879987,
    798687,
    796797,
    887877,
    798696,
    779688,
    787988,
    989788,
    778997,
    887977,
    777979,
    997999,
    898788,
    889898,
    798776,
    878877,
    698887,
    687788,
    867899,
    878888,
    878898,
    997787,
    877867,
    878778,
    779887,
    898969,
    968878,
    797788,
    678978,
    898788,
    889877,
    877988,
    878878,
    678998,
    888788,
    878887,
    888897,
    989797,
    766797,
    897779,
    788978,
    888676,
    977877,
    687778,
    986787,
    877976,
    987769,
    878977,
    898779,
    887777,
    877988,
    888877,
    978789,
    799787,
    877898,
    788989,
    789888,
    789887,
    887797,
    779798,
    897879,
    778787,
    778787,
    988798,
    678778,
    987879,
    876986,
    888878,
    778888,
    898878,
    877786,
    888878,
    799997,
    887797,
    877678,
    986778,
    877898,
    789887,
    888797,
    898799,
    899879,
    887877,
    898887,
    888787,
    799877,
    789789,
    988887,
    877978,
    868877,
    778878,
    888788,
    977879,
    777777,
    789697,
    978899,
    877987,
    999797,
    668879,
    878697,
    878687,
    867888,
    778788,
    886787,
    998787,
    789778,
    787778,
    878888,
    778779,
    896896,
    778878,
    799788,
    897777,
    989877,
    798989,
    867888,
    669888,
    888988,
    798899,
    788889,
    879777,
    898779,
    888778,
    677788,
    877998,
    889899,
    887898,
    997977,
    778788,
    788987,
    999888,
    898898,
    776797,
    878788,
    786979,
    899788,
    987897,
    788999,
    988888,
    787786,
    698969,
    877998,
    788798,
    879887,
    899978,
    996777,
    867889,
    778889,
    877879,
    787988,
    877799,
    887878,
    778797,
    777688,
    776986,
    778878,
    978898,
    999869,
    789978,
    787887,
    788878,
    898898,
    788978,
    877897,
    678988,
    887868,
    889787,
    997778,
    897889,
    988878,
    996988,
    788888,
    887878,
    789879,
    779787,
    978867,
    678777,
    887687,
    887877,
    898888,
    968777,
    787977,
    978878,
    996969,
    878699,
    677788,
    799788,
    977887,
    778977,
    898779,
    887889,
    886879,
    989878,
    677877,
    997678,
    878768,
    887869,
    699769,
    888967,
    777999,
    989888,
    778888,
    789988,
    877888,
    776878,
    887986,
    889677,
    679787,
    679887,
    879897,
    887896,
    877779,
    796888,
    788779,
    879878,
    887876,
    888877,
    788999,
    798789,
    879989,
    788897,
    887778,
    898888,
    876798,
    878788,
    798977,
    887778,
    967898,
    876788,
    897787,
    797787,
    997788,
    988979,
    787877,
    888888,
    787779,
    687879,
    988699,
    877978,
    869788,
    988998,
    878988,
    889878,
    988787,
    976888,
    779798,
    866778,
    889778,
    788879,
    779888,
    896979,
    878779,
    776778,
    887888,
    678677,
    788797,
    998789,
    898996,
    887787,
    888787,
    797779,
    888898,
    878888,
    886998,
    677789,
    878697,
    889777,
    888977,
    879678,
    887878,
    766886,
    877987,
    886877,
    868778,
    779897,
    987978,
    877877,
    888898,
    798977,
    789789,
    976779,
    777787,
    887788,
    878878,
    877779,
    786886,
    778989,
    778678,
    998987,
    867978,
    877987,
    888779,
    778887,
    989676,
    987878,
    768988,
    888787,
    878897,
    987778,
    798977,
    898879,
    879669,
    888877,
    877879,
    876988,
    789777,
    878779,
    679689,
    776889,
    888888,
    788888,
    788998,
    786787,
    997977,
    988789,
    889977,
    779788,
    998989,
    788779,
    887788,
    876887,
    798789,
    888688,
    978888,
    866778,
    888886,
    987787,
    677777,
    887798,
    997789,
    978698,
    778876,
    878789,
    897877,
    888778,
    697679,
    886887,
    898786,
    687778,
    898898,
    888787,
    998878,
    898887,
    788888,
    779697,
    888788,
    878878,
    878788,
    877687,
    797977,
    799687,
    969777,
    689988,
    868978,
    998787,
    688988,
    787988,
    878897,
    688898,
    978878,
    978887,
    997868,
    896887,
    899987,
    988879,
    879788,
    777889,
    787777,
    788678,
    888877,
    876987,
    878689,
    899987,
    899989,
    777868,
    878788,
    787778,
    976777,
    799888,
    667769,
    897976,
    676899,
    889889,
    888778,
    778876,
    878687,
    897979,
    779789,
    878787,
    788888,
    889988,
    677888,
    978977,
    998777,
    787878,
    887868,
    799797,
    779887,
    688887,
    789779,
    877789,
    888688,
    877887,
    888888,
    978978,
    789987,
    888987,
    798886,
    979787,
    777987,
    887868,
    887886,
    889778,
    867879,
    787997,
    887789,
    778977,
    887878,
    987987,
    989796,
    688779,
    998989,
    888968,
    868688,
    779868,
    788788,
    889887,
    878878,
    688878,
    887778,
    879888,
    986788,
    887878,
    788787,
    799688,
    779976,
    789897,
    797978,
    788988,
    978988,
    788987,
    679878,
    768788,
    988877,
    877689,
    787888,
    987978,
    888797,
    879999,
    887778,
    687788,
    887776,
    889789,
    898789,
    987887,
    878887,
    978788,
    888778,
    879879,
    877788,
    996787,
    988687,
    877878,
    886898,
    896779,
    999987,
    797788,
    999988,
    778898,
    786889,
    998987,
    878887,
    898898,
    897998,
    779879,
    898888,
    868988,
    988879,
    788979,
    987878,
    987889,
    889787,
    798787,
    978999,
    988777,
    688696,
    778999,
    788788,
    898868,
    778779,
    797788,
    877897,
    866787,
    778767,
    878778,
    887978,
    878878,
    878978,
    889878,
    878789,
    898878,
    779889,
    798878,
    788898,
    898879,
    877897,
    879787,
    878887,
    788998,
    888877,
    876887,
    787898,
    888788,
    887988,
    888888,
    788998,
    678987,
    877887,
    887867,
    799886,
    867878,
    899877,
    797697,
    967698,
    878979,
    678889,
    987779,
    778786,
    887787,
    887778,
    788987,
    977988,
    797879,
    888669,
    788896,
    897788,
    987867,
    777899,
    888898,
    998887,
    988998,
    988887,
    678997,
    987697,
    696888,
    897788,
    688798,
    979898,
    888867,
    876688,
    898887,
    878878,
    888887,
    887899,
    677887,
    898898,
    779879,
    787877,
    888987,
    978798,
    777897,
    789867,
    876877,
    878789,
    789987,
    878678,
    889887,
    788879,
    777886,
    977879,
    878886,
    878887,
    878888,
    776687,
    988687,
    876787,
    786777,
    787998,
    897878,
    986987,
    778988,
    978688,
    788787,
    798988,
    789887,
    898887,
    898677,
    887877,
    688888,
    978979,
    888897,
    978878,
    787889,
    888999,
    878887,
    899988,
    989887,
    687887,
    778869,
    778967,
    877688,
    779877,
    978877,
    989987,
    678879,
    788778,
    777988,
    867888,
    879789,
    988777,
    788887,
    877787,
    797887,
    979877,
    889967,
    887877,
    798887,
    889878,
    878899,
    998889,
    878998,
    788787,
    877879,
    869796,
    988789,
    988878,
    988778,
    989978,
    987777,
    877788,
    778888,
    879896,
    898799,
    779768,
    877887,
    979777,
    778987,
    899896,
    868979,
    888777,
    877887,
    899888,
    769998,
    978888,
    877798,
    867879,
    987877,
    686788,
    788977,
    898987,
    878897,
    998778,
    887879,
    888876,
    888788,
    798878,
    888897,
    698788,
    676987,
    876787,
    776787,
    887779,
    889778,
    878898,
    998778,
    768786,
    687978,
    986779,
    789988,
    678989,
    779778,
    989787,
    989986,
    786887,
    887977,
    788989,
    798678,
    787787,
    788887,
    978787,
    987779,
    777878,
    888988,
    687878,
    887788,
    889688,
    977999,
    897988,
    968889,
    788797,
    987978,
    788898,
    887878,
    969787,
    788877,
    877998,
    777796,
    767778,
    987998,
    879689,
    787887,
    979889,
    779776,
    978798,
    778887,
    897998,
    778977,
    888787,
    988786,
    999988,
    977767,
    798887,
    887878,
    978878,
    797888,
    787998,
    787897,
    897789,
    678887,
    999778,
    899788,
    797887,
    988888,
    798788,
    787786,
    989879,
    778688,
    778887,
    889787,
    697868,
    689868,
    889767,
    777778,
    869988,
    878897,
    888988,
    889779,
    899887,
    789798,
    978969,
    988987,
    898877,
    898776,
    787878,
    897887,
    888978,
    967889,
    788797,
    978899,
    687877,
    786788,
    787888,
    898977,
    878779,
    887778,
    787878,
    787768,
    797888,
    879688,
    968778,
    888769,
    877677,
    788897,
    698997,
    797897,
    877788,
    977788,
    877988,
    887987,
    889998,
    868678,
    777889,
    988987,
    977987,
    778998,
    878687,
    887979,
    777698,
    878879,
    997968,
    868876,
    878668,
    778798,
    787886,
    787888,
    777688,
    896786,
    778898,
    888877,
    877898,
    889897,
    888778,
    887978,
    788887,
    799787,
    877886,
    986778,
    788869,
    768899,
    878886,
    968977,
    697887,
    789889,
    677987,
    688889,
    878789,
    879888,
    867888,
    868976,
    787697,
    787876,
    989778,
    668896,
    897887,
    877899,
    986699,
    778786,
    798889,
    877978,
    779778,
    898887,
    889999,
    698767,
    787797,
    886888,
    778897,
    779887,
    898978,
    777877,
    788889,
    898786,
    976989,
    788797,
    886888,
    889677,
    788698,
    997877,
    978788,
    877988,
    877987,
    767787,
    898968,
    888988,
    768788,
    787877,
    888877,
    788788,
    887868,
    997898,
    779878,
    897768,
    897689,
    978967,
    877699,
    676897,
    987877,
    778988,
    899778,
    788688,
    867999,
    877997,
    877888,
    898778,
    887888,
    778787,
    977899,
    977898,
    899899,
    899798,
    688788,
    879787,
    778688,
    877869,
    988778,
    878879,
    878897,
    989877,
    878887,
    799789,
    877798,
    678887,
    767779,
    888798,
    777787,
    997797,
    898788,
    878888,
    798968,
    889898,
    888788,
    788779,
    889879,
    788689,
    787888,
    897878,
    887779,
    888887,
    976888,
    689878,
    877988,
    688796,
    879779,
    798778,
    797888,
    697798,
    797788,
    976796,
    888768,
    998878,
    789887,
    887889,
    889697,
    798697,
    878778,
    878787,
    889878,
    886878,
    798789,
    787888,
    767788,
    797879,
    789788,
    787988,
    779777,
    697989,
    998767,
    898778,
    877786,
    877788,
    888797,
    888888,
    878897,
    979788,
    988887,
    877787,
    868878,
    797988,
    888877,
    878888,
    787888,
    887899,
    798769,
    688788,
    886898,
    896897,
    787887,
    887868,
    987898,
    897898,
    787888,
    878797,
    698799,
    898678,
    788877,
    879876,
    978887,
    888889,
    796888,
    787777,
    897978,
    968868,
    987886,
    867788,
    887976,
    967786,
    987976,
    678879,
    778868,
    768998,
    887987,
    887888,
    776788,
    777878,
    878789,
    767767,
    787779,
    767989,
    989698,
    788789,
    899887,
    777888,
    969878,
    988889,
    868888,
    879779,
    898969,
    997778,
    697878,
    688989,
    897888,
    676788,
    677887,
    898787,
    896787,
    889787,
    799977,
    889789,
    898886,
    897677,
    878878,
    879788,
    778797,
    988678,
    687787,
    779788,
    788988,
    688787,
    877778,
    889687,
    986766,
    878878,
    788788,
    778898,
    899989,
    897798,
    768989,
    678978,
    697987,
    887679,
    788877,
    968688,
    867799,
    987788,
    888788,
    996877,
    898887,
    987698,
    967889,
    677878,
    797877,
    788889,
    868876,
    978786,
    878889,
    968888,
    689979,
    866988,
    879887,
    898789,
    889968,
    787788,
    879898,
    779878,
    799688,
    988987,
    788779,
    687887,
    889788,
    978887,
    777878,
    987686,
    788878,
    777889,
    879878,
    977768,
    978888,
    886788,
    789698,
    988978,
    888797,
    888969,
    797777,
    888898,
    678989,
    888869,
    977769,
    788877,
    879979,
    889887,
    787888,
    787896,
    987898,
    897778,
    787777,
    788888,
    787998,
    788879,
    777798,
    878978,
    899899,
    897898,
    878696,
    887888,
    688888,
    978888,
    888787,
    788987,
    987788,
    797898,
    888989,
    978888,
    787688,
    998788,
    798779,
    778878,
    988787,
    878797,
    879777,
    796798,
    989977,
    888897,
    768786,
    879888,
    877877,
    788899,
    788877,
    887977,
    897878,
    678888,
    788987,
    876778,
    999788,
    877877,
    898977,
    876889,
    879889,
    888777,
    988889,
    798877,
    986999,
    777787,
    788878,
    777787,
    679888,
    767768,
    787778,
    888878,
    977887,
    967779,
    988889,
    877678,
    998979,
    978796,
    668878,
    998878,
    778888,
    678887,
    879889,
    788798,
    988878,
    878878,
    788788,
    887878,
    878899,
    997878,
    887798,
    877887,
    888988,
    888677,
    777798,
    898898,
    878876,
    778976,
    878977,
    868768,
    779877,
    779677,
    886789,
    987879,
    988887,
    778877,
    788897,
    788789,
    977877,
    878889,
    788798,
    789898,
    988899,
    986867,
    789687,
    898989,
    988778,
    787678,
    877778,
    987798,
    878776,
    787889,
    798888,
    887889,
    877797,
    888889,
    887977,
    868799,
    889678,
    788888,
    978877,
    878988,
    789868,
    779998,
    788787,
    987789,
    778798,
    877888,
    998898,
    879888,
    887798,
    869889,
    878787,
    888979,
    889788,
    788787,
    977797,
    767877,
    778977,
    788989,
    887788,
    878787,
    978878,
    788978,
    876889,
    886898,
    896788,
    868989,
    888777,
    889886,
    778898,
    888787,
    977989,
    999868,
    888789,
    888979,
    787996,
    788989,
    898898,
    879976,
    667887,
    979988,
    878868,
    787898,
    978888,
    689989,
    988879,
    977787,
    889879,
    876976,
    778787,
    788888,
    898888,
    888878,
    987989,
    798688,
    697797,
    777868,
    798887,
    888887,
    986769,
    887677,
    786999,
    888978,
    888798,
    898888,
    998778,
    899779,
    878987,
    797768,
    896787,
    869778,
    996897,
    867888,
    889887,
    777887,
    879787,
    799688,
    879978,
    899799,
    879879,
    798888,
    689786,
    987779,
    697798,
    787788,
    797686,
    867887,
    779886,
    979779,
    997779,
    979768,
    988887,
    978988,
    776879,
    987788,
    877778,
    887888,
    778979,
    877899,
    877988,
    888789,
    787878,
    788988,
    898978,
    887868,
    888877,
    897689,
    988888,
    788788,
    879888,
    988678,
    779888,
    698877,
    778788,
    989788,
    898988,
    688878,
    888997,
    888878,
    798878,
    778698,
    898798,
    888787,
    977878,
    877777,
    878888,
    778796,
    878866,
    788778,
    889768,
    879788,
    987888,
    998778,
    888887,
    888887,
    898997,
    899899,
    767687,
    888767,
    877787,
    877877,
    887688,
    878888,
    888879,
    788887,
    788769,
    989997,
    887898,
    889777,
    799997,
    789889,
    778678,
    889878,
    789788,
    788877,
    787878,
    888989,
    879887,
    787987,
    998888,
    888879,
    887887,
    888998,
    797778,
    778787,
    779698,
    898798,
    787798,
    887788,
    887897,
    887888,
    878877,
    777988,
    878768,
    989876,
    878788,
    788877,
    686776,
    878987,
    987888,
    897788,
    987787,
    777779,
    987998,
    888997,
    888778,
    798998,
    887797,
    877899,
    798788,
    768889,
    686879,
    798998,
    776769,
    887767,
    878867,
    877789,
    767978,
    786789,
    878887,
    788698,
    888989,
    889766,
    787879,
    779987,
    986789,
    877798,
    887688,
    888867,
    888887,
    778686,
    777878,
    889877,
    888777,
    877989,
    888877,
    898778,
    889789,
    789999,
    788888,
    888978,
    779788,
    877977,
    888878,
    888777,
    688798,
    778777,
    899898,
    778797,
    889788,
    787887,
    778886,
    798888,
    878878,
    789877,
    887799,
    989898,
    898687,
    776998,
    979888,
    778878,
    888687,
    988898,
    999988,
    879986,
    877887,
    897888,
    778888,
    798899,
    777877,
    867877,
    878898,
    787889,
    866897,
    789988,
    967788,
    989897,
    878877,
    789687,
    989778,
    888898,
    878878,
    878778,
    878888,
    897888,
    889889,
    878989,
    798789,
    978867,
    798888,
    897898,
    887997,
    798876,
    998878,
    788897,
    777779,
    877878,
    889797,
    998777,
    867977,
    987789,
    877889,
    877787,
    677787,
    888877,
    988886,
    886787,
    886978,
    897777,
    899889,
    996897,
    777679,
    888788,
    787878,
    786887,
    868789,
    988887,
    698868,
    787878,
    877968,
    897898,
    899797,
    779889,
    978788,
    987987,
    788778,
    799979,
    876799,
    788968,
    688789,
    988888,
    888796,
    898786,
    987988,
    899868,
    877777,
    678888,
    878776,
    779889,
    788889,
    877778,
    777698,
    888889,
    998777,
    889977,
    978988,
    886789,
    786977,
    899877,
    978789,
    889977,
    888887,
    978878,
    778988,
    886687,
    897988,
    979897,
    968777,
    887767,
    889879,
    777777,
    998878,
    887987,
    888888,
    978869,
    879988,
    888778,
    778998,
    886688,
    787777,
    878787,
    879786,
    787798,
    998878,
    786898,
    778987,
    889977,
    977697,
    788998,
    988987,
    797979,
    677799,
    897888,
    777787,
    888786,
    797877,
    877886,
    777669,
    879878,
    888878,
    676986,
    698778,
    887888,
    898798,
    988779,
    778777,
    888877,
    878797,
    989879,
    978988,
    888987,
    998679,
    978686,
    897998,
    888887,
    898889,
    988977,
    798778,
    787897,
    688887,
    989978,
    868768,
    888877,
    789887,
    787889,
    789867,
    877887,
    896889,
    687886,
    676887,
    878888,
    888988,
    998887,
    788798,
    987777,
    977799,
    787886,
    798877,
    997868,
    777797,
    877979,
    977887,
    869878,
    997977,
    887878,
    889879,
    769888,
    888778,
    688789,
    789778,
    898878,
    777776,
    887888,
    688988,
    879786,
    976878,
    887879,
    987889,
    898996,
    896879,
    986689,
    878687,
    768889,
    889888,
    798799,
    888888,
    878988,
    687888,
    879778,
    968687,
    886887,
    887887,
    698788,
    978887,
    897888,
    779788,
    889779,
    897679,
    688896,
    788887,
    896899,
    669987,
    878888,
    867887,
    988777,
    788987,
    888699,
    787778,
    879788,
    889988,
    777778,
    887787,
    787887,
    886887,
    988888,
    977778,
    779797,
    888898,
    898968,
    867778,
    888887,
    898796,
    888777,
    899778,
    887877,
    788886,
    879788,
    778787,
    778796,
    877998,
    878888,
    897898,
    876898,
    887877,
    788768,
    998788,
    789778,
    998988,
    888878,
    787978,
    778888,
    877869,
    887799,
    998688,
    878967,
    789799,
    898887,
    877976,
    899799,
    877969,
    888888,
    768988,
    888977,
    878788,
    987798,
    899789,
    988788,
    988798,
    777798,
    889887,
    797788,
    868887,
    778878,
    888788,
    788799,
    988887,
    777788,
    898897,
    889777,
    797896,
    766789,
    888798,
    987788,
    899777,
    998889,
    898789,
    887778,
    888777,
    887789,
    888978,
    998889,
    979778,
    678888,
    898787,
    676779,
    778677,
    899877,
    889787,
    778887,
    689987,
    868797,
    787877,
    899979,
    898779,
    797898,
    767888,
    778866,
    997767,
    777689,
    978987,
    779887,
    897768,
    879677,
    897798,
    998678,
    989979,
    787887,
    977787,
    899789,
    788788,
    789968,
    889888,
    988788,
    788998,
    768779,
    986898,
    687878,
    787868,
    878888,
    788768,
    877787,
    789997,
    776888,
    777787,
    877798,
    877877,
    777877,
    888776,
    879876,
    778778,
    789898,
    679887,
    868798,
    877787,
    889788,
    768777,
    987988,
    777788,
    777778,
    888799,
    878888,
    887888,
    988898,
    897877,
    977889,
    797787,
    988869,
    878786,
    777877,
    997889,
    787979,
    988898,
    896788,
    778999,
    878678,
    788888,
    879788,
    678778,
    787888,
    788799,
    887877,
    879788,
    778979,
    888787,
    897686,
    886788,
    877878,
    987888,
    687777,
    978787,
    878788,
    878886,
    888687,
    797786,
    887887,
    788898,
    788867,
    788879,
    878887,
    879777,
    897897,
    797789,
    889898,
    979768,
    888768,
    678888,
    779868,
    899776,
    677887,
    887898,
    877878,
    797687,
    798999,
    897869,
    878788,
    788888,
    977678,
    878987,
    799988,
    898777,
    879878,
    788787,
    897987,
    699798,
    887887,
    868988,
    778877,
    888788,
    899887,
    668798,
    876968,
    978888,
    698867,
    887887,
    678787,
    799997,
    979787,
    787878,
    878779,
    888987,
    678969,
    889868,
    798677,
    798779,
    968878,
    988889,
    898788,
    888778,
    799768,
    876778,
    787888,
    789888,
    688979,
    987897,
    778776,
    968878,
    877788,
    778987,
    788767,
    879787,
    888787,
    887888,
    988787,
    889898,
    879778,
    898978,
    798989,
    889888,
    777797,
    889887,
    768978,
    787799,
    688897,
    879779,
    869896,
    786689,
    877888,
    877796,
    886779,
    888987,
    779889,
    698997,
    988788,
    986797,
    897877,
    777896,
    788879,
    786767,
    877988,
    767988,
    887877,
    979997,
    879888,
    787887,
    887978,
    899777,
    888889,
    897978,
    899778,
    889797,
    688679,
    878878,
    988977,
    899878,
    979798,
    887787,
    789787,
    887787,
    878887,
    978888,
    876897,
    897898,
    876787,
    888878,
    788797,
    877888,
    688777,
    988867,
    677898,
    777787,
    869788,
    788776,
    768899,
    898778,
    889979,
    868777,
    789778,
    798878,
    988787,
    988877,
    878878,
    887998,
    789797,
    879979,
    788787,
    988887,
    888897,
    888877,
    778687,
    878898,
    988886,
    688997,
    989887,
    797688,
    879899,
    788789,
    788887,
    788996,
    698888,
    776777,
    777878,
    988798,
    997787,
    897776,
    897989,
    688898,
    988987,
    879896,
    998976,
    878887,
    786887,
    768777,
    987888,
    968888,
    868897,
    688877,
    879778,
    878778,
    878887,
    879787,
    777678,
    888896,
    898998,
    889788,
    788897,
    788868,
    788889,
    888988,
    788777,
    878788,
    798897,
    888879,
    697688,
    888877,
    888988,
    688888,
    897776,
    878788,
    987787,
    799878,
    798887,
    988897,
    888878,
    798878,
    888986,
    678978,
    788899,
    998797,
    898989,
    777988,
    789898,
    988788,
    879867,
    988788,
    888768,
    977977,
    987887,
    977869,
    888888,
    868968,
    898889,
    889978,
    988898,
    888888,
    889889,
    787888,
    897987,
    768878,
    987879,
    887789,
    986778,
    788897,
    867689,
    997998,
    789877,
    788887,
    887697,
    898888,
    688688,
    769878,
    987877,
    777898,
    669787,
    989788,
    998689,
    898899,
    897787,
    768777,
    888779,
    678778,
    777988,
    897879,
    898878,
    897887,
    786997,
    887788,
    977886,
    778887,
    878878,
    898998,
    977989,
    698878,
    887867,
    768797,
    878877,
    878798,
    889788,
    888888,
    777979,
    977887,
    978878,
    999896,
    988779,
    888797,
    678778,
    787889,
    789989,
    988888,
    878689,
    887789,
    998988,
    988987,
    779987,
    778699,
    987978,
    877777,
    988897,
    878877,
    878887,
    788796,
    989988,
    988969,
    778888,
    877888,
    978788,
    987887,
    798888,
    888888,
    768787,
    797697,
    798988,
    897797,
    778898,
    876889,
    898798,
    797777,
    879878,
    788789,
    868788,
    788888,
    888897,
    968968,
    988687,
    877778,
    878868,
    898868,
    898888,
    988886,
    878796,
    888778,
    797877,
    786876,
    877897,
    896889,
    888998,
    787879,
    997878,
    788898,
    869896,
    698788,
    887877,
    896787,
    877878,
    676888,
    887998,
    688787,
    787986,
    877786,
    777767,
    887797,
    778887,
    788888,
    866878,
    887998,
    888989,
    788787,
    878787,
    787989,
    798778,
    777788,
    977678,
    998778,
    789987,
    787888,
    899978,
    999998,
    977978,
    788889,
    987868,
    879687,
    789897,
    787769,
    688777,
    999979,
    887777,
    777986,
    998698,
    797778,
    879778,
    888989,
    778688,
    778876,
    887877,
    887798,
    998688,
    977788,
    887888,
    976788,
    877878,
    798797,
    889888,
    888788,
    998897,
    977779,
    789989,
    896798,
    989889,
    898977,
    788898,
    878778,
    978797,
    897788,
    988887,
    887679,
    799976,
    987998,
    798888,
    978777,
    878979,
    787988,
    768876,
    799878,
    978777,
    998688,
    787978,
    877798,
    897878,
    889899,
    887978,
    778897,
    887888,
    777778,
    997979,
    889978,
    986889,
    796788,
    988988,
    979878,
    778877,
    899797,
    978768,
    878787,
    888897,
    779889,
    788968,
    889998,
    879887,
    889878,
    977678,
    887987,
    989888,
    787898,
    899887,
    687878,
    788797,
    868878,
    887978,
    788789,
    778788,
    679899,
    898897,
    887867,
    878898,
    778687,
    987987,
    778667,
    898787,
    877787,
    779999,
    878787,
    997777,
    788897,
    789888,
    886899,
    788788,
    788896,
    677779,
    899878,
    888788,
    877897,
    877776,
    898969,
    887788,
    987887,
    997896,
    887878,
    788688,
    868888,
    888898,
    988987,
    886888,
    689678,
    867888,
    696667,
    978789,
    789788,
    789888,
    789777,
    687779,
    789879,
    879787,
    687767,
    779978,
    977877,
    898897,
    877988,
    888989,
    897979,
    788888,
    769999,
    778787,
    788889,
    797887,
    798898,
    777788,
    889769,
    867668,
    997776,
    788777,
    977998,
    877897,
    877787,
    888778,
    886876,
    898888,
    868887,
    778877,
    689986,
    798998,
    897886,
    979778,
    978977,
    987678,
    997877,
    878998,
    888888,
    898887,
    888877,
    888888,
    887788,
    987987,
    898876,
    877997,
    878896,
    769988,
    688686,
    887888,
    788987,
    778797,
    888988,
    787877,
    899778,
    888877,
    789998,
    978679,
    978779,
    787867,
    888788,
    888798,
    888876,
    999798,
    798888,
    676898,
    889978,
    789977,
    777978,
    888778,
    868897,
    789788,
    999988,
    979887,
    887988,
    778879,
    878788,
    788977,
    997868,
    887779,
    778887,
    786889,
    888887,
    877787,
    798678,
    887977,
    997777,
    888789,
    779778,
    776787,
    687777,
    777777,
    689888,
    889979,
    897788,
    877868,
    986876,
    878899,
    977687,
    888999,
    798977,
    898867,
    877778,
    778987,
    797888,
    778787,
    987788,
    898797,
    789879,
    879987,
    886888,
    877796,
    779996,
    978877,
    998887,
    877898,
    778889,
    877989,
    877787,
    977878,
    968777,
    988788,
    878688,
    989797,
    878788,
    687879,
    887978,
    888978,
    889789,
    987879,
    897787,
    767988,
    887978,
    787678,
    878967,
    787778,
    877899,
    889889,
    688898,
    889787,
    887788,
    879978,
    897968,
    877788,
    788887,
    677886,
    887898,
    897777,
    876877,
    997978,
    789867,
    699877,
    799898,
    886899,
    977899,
    898978,
    988768,
    886897,
    798988,
    888887,
    788978,
    886778,
    878876,
    977878,
    887689,
    886888,
    898889,
    989878,
    889877,
    898799,
    777886,
    888898,
    868777,
    899899,
    888978,
    886998,
    897877,
    899888,
    887797,
    778788,
    786877,
    879897,
    878879,
    897698,
    877876,
    888787,
    978888,
    777789,
    978788,
    979888,
    977887,
    887787,
    888788,
    888777,
    998978,
    767897,
    878887,
    867878,
    878778,
    797777,
    878887,
    987897,
    797877,
    797688,
    878888,
    788998,
    689898,
    788789,
    869977,
    978899,
    787988,
    878878,
    797898,
    779888,
    787978,
    887998,
    988798,
    877798,
    967989,
    698878,
    887789,
    779879,
    687886,
    889896,
    998887,
    968887,
    778869,
    987887,
    967897,
    768789,
    898889,
    987888,
    787888,
    688779,
    888769,
    668887,
    879878,
    898769,
    788887,
    877878,
    888797,
    787778,
    876689,
    888778,
    798887,
    787767,
    697778,
    778987,
    888767,
    887886,
    988987,
    798978,
    987889,
    987888,
    779889,
    899777,
    788878,
    887889,
    879877,
    778996,
    988888,
    978988,
    778987,
    987878,
    877787,
    777788,
    889877,
    787887,
    878877,
    888887,
    778898,
    888897,
    889788,
    868888,
    888788,
    998786,
    897987,
    887887,
    988888,
    789898,
    777796,
    887787,
    978798,
    998887,
    769989,
    779976,
    677697,
    988886,
    797987,
    797988,
    977979,
    778888,
    987777,
    778778,
    799797,
    686778,
    887898,
    797777,
    778876,
    968887,
    788788,
    879688,
    887988,
    988888,
    888887,
    788776,
    898788,
    787999,
    888766,
    998887,
    768788,
    899789,
    788788,
    989777,
    889888,
    787898,
    889889,
    777878,
    887878,
    989968,
    879787,
    767988,
    898789,
    888888,
    978876,
    888888,
    788978,
    788967,
    899887,
    898889,
    897988,
    887896,
    888877,
    787787,
    768878,
    778878,
    988888,
    887978,
    887778,
    789897,
    667898,
    987998,
    886899,
    879967,
    688789,
    887879,
    979887,
    998788,
    786977,
    797778,
    898798,
    879788,
    887869,
    886889,
    897987,
    796798,
    877977,
    787776,
    877877,
    887776,
    888788,
    788787,
    889777,
    889878,
    888897,
    996888,
    789788,
    888778,
    788887,
    798899,
    988779,
    897888,
    987886,
    887988,
    897897,
    777897,
    876997,
    988789,
    777788,
    886978,
    788877,
    888997,
    878866,
    876889,
    887787,
    768787,
    976878,
    869898,
    786788,
    778987,
    977868,
    788688,
    896778,
    787998,
    787876,
    787787,
    977777,
    778789,
    779897,
    798989,
    777778,
    867787,
    789889,
    769787,
    888787,
    688788,
    787887,
    778868,
    869788,
    889878,
    889878,
    789888,
    798887,
    776696,
    788888,
    878887,
    777989,
    988777,
    787998,
    877998,
    787776,
    999888,
    879998,
    698987,
    789797,
    989697,
    897888,
    787887,
    889886,
    977889,
    888997,
    798989,
    768987,
    786987,
    889878,
    996987,
    989889,
    778867,
    789887,
    988886,
    878788,
    888768,
    887787,
    787698,
    978777,
    878887,
    999889,
    768878,
    879887,
    967989,
    798898,
    898879,
    878987,
    777878,
    888888,
    878787,
    788788,
    799898,
    788878,
    887787,
    787788,
    787778,
    889888,
    887878,
    798878,
    898698,
    998789,
    898778,
    799779,
    897887,
    868886,
    778878,
    689677,
    977888,
    897787,
    978877,
    778898,
    977886,
    788889,
    878678,
    888989,
    778687,
    886878,
    669889,
    788686,
    788778,
    887878,
    988899,
    887998,
    887888,
    888789,
    787967,
    769889,
    687887,
    777986,
    796788,
    767877,
    887788,
    878778,
    988887,
    886888,
    788987,
    897899,
    899788,
    878787,
    997787,
    976878,
    988776,
    878898,
    989787,
    888688,
    869988,
    689978,
    889987,
    879878,
    889977,
    777786,
    898898,
    866988,
    889998,
    889797,
    887977,
    799889,
    896877,
    777978,
    798866,
    787778,
    887888,
    777889,
    989788,
    868799,
    878978,
    898888,
    887878,
    988788,
    889888,
    889898,
    987898,
    786798,
    977797,
    979797,
    776687,
    988778,
    887779,
    888898,
    879887,
    698867,
    788987,
    878888,
    988989,
    878889,
    899688,
    768778,
    887787,
    787988,
    777668,
    997879,
    788866,
    886889,
    899787,
    887968,
    887996,
    687766,
    768996,
    888898,
    879998,
    897978,
    878788,
    788768,
    787889,
    978878,
    898688,
    788788,
    987878,
    688877,
    878678,
    878686,
    978798,
    877788,
    788867,
    888777,
    788869,
    888697,
    897889,
    798988,
    868787,
    886878,
    887887,
    886867,
    887897,
    689988,
    787788,
    898878,
    697878,
    977798,
    778777,
    887866,
    878888,
    878788,
    787978,
    786878,
    888777,
    898888,
    878897,
    778888,
    898788,
    878988,
    898899,
    888879,
    687877,
    776878,
    897888,
    879988,
    989778,
    969768,
    997697,
    998888,
    777889,
    788788,
    798776,
    989987,
    787788,
    696878,
    999896,
    878887,
    887889,
    789787,
    779887,
    779788,
    997978,
    779797,
    877678,
    898887,
    698798,
    877697,
    688878,
    868987,
    887898,
    888889,
    878888,
    887788,
    887786,
    878897,
    988796,
    889988,
    898777,
    786888,
    867898,
    888797,
    968879,
    997787,
    967888,
    778888,
    687777,
    879779,
    787788,
    999887,
    788889,
    876988,
    996986,
    998788,
    888878,
    788789,
    689979,
    778767,
    978897,
    987888,
    767887,
    878868,
    888777,
    688788,
    989777,
    978878,
    777798,
    876998,
    677876,
    688787,
    987898,
    888776,
    988897,
    789898,
    798769,
    786967,
    888898,
    878977,
    797677,
    998688,
    886689,
    977798,
    887788,
    988877,
    879688,
    989987,
    678799,
    799887,
    787888,
    789888,
    777877,
    878899,
    789899,
    876878,
    998778,
    867967,
    797889,
    697877,
    789686,
    898888,
    778788,
    889888,
    678978,
    787798,
    987998,
    888987,
    898878,
    887888,
    987797,
    889997,
    887879,
    889799,
    978987,
    688799,
    889877,
    787977,
    969878,
    877997,
    978978,
    888899,
    888778,
    888797,
    786888,
    877888,
    799688,
    788986,
    878998,
    878767,
    877868,
    879888,
    687988,
    789888,
    879797,
    978878,
    789988,
    788888,
    877887,
    977869,
    787887,
    799788,
    778899,
    887898,
    798788,
    767878,
    788988,
    989878,
    889977,
    988788,
    889869,
    997978,
    878987,
    887989,
    987788,
    877898,
    898798,
    788987,
    688878,
    798897,
    779889,
    888997,
    978799,
    778887,
    989987,
    787889,
    778987,
    877989,
    878976,
    967898,
    786979,
    887899,
    788877,
    889868,
    987777,
    788888,
    887899,
    887868,
    967788,
    898788,
    978787,
    888868,
    777786,
    797779,
    986788,
    878799,
    778898,
    788777,
    877987,
    787778,
    878879,
    898798,
    888868,
    778788,
    869788,
    888688,
    877688,
    879878,
    997898,
    888886,
    868888,
    867788,
    788797,
    988798,
    988766,
    898978,
    988777,
    886897,
    898789,
    989987,
    888889,
    888889,
    796769,
    889798,
    899788,
    776877,
    998788,
    877877,
    779699,
    779778,
    788668,
    778888,
    988798,
    799869,
    889777,
    997788,
    888888,
    879787,
    779769,
    988878,
    887897,
    967988,
    787869,
    976888,
    898897,
    987888,
    887788,
    897778,
    779978,
    876788,
    877987,
    997997,
    777887,
    888877,
    879787,
    988799,
    878988,
    877787,
    788777,
    799986,
    776888,
    889798,
    789777,
    798698,
    879987,
    769798,
    778887,
    788888,
    988889,
    878779,
    888788,
    798879,
    869777,
    787679,
    696688,
    877877,
    789778,
    877888,
    778788,
    898878,
    779978,
    896677,
    888779,
    689887,
    697888,
    998898,
    888898,
    787688,
    978867,
    897788,
    897997,
    888888,
    879896,
    688787,
    886789,
    888986,
    787788,
    877878,
    977988,
    888878,
    968688,
    688888,
    977788,
    867899,
    776997,
    898988,
    889687,
    878889,
    988688,
    779996,
    878967,
    897779,
    888878,
    788879,
    888699,
    787877,
    978797,
    888997,
    978678,
    897887,
    888878,
    979787,
    969898,
    788978,
    788888,
    797778,
    887988,
    887889,
    687688,
    789888,
    899888,
    878897,
    787776,
    888787,
    878988,
    778878,
    777888,
    679967,
    878677,
    898888,
    967889,
    997879,
    877778,
    887798,
    889877,
    878878,
    678678,
    779787,
    798798,
    988888,
    787978,
    888877,
    896888,
    789897,
    798989,
    778788,
    898668,
    988877,
    889677,
    777787,
    877698,
    899878,
    888987,
    887877,
    887877,
    687677,
    899778,
    798779,
    787979,
    878887,
    898778,
    898787,
    888787,
    889787,
    788888,
    787979,
    788897,
    967787,
    979788,
    786879,
    898788,
    869887,
    888788,
    788779,
    787689,
    787796,
    877988,
    777897,
    777988,
    797988,
    879677,
    877777,
    877798,
    777987,
    998788,
    678778,
    788997,
    777887,
    768887,
    998988,
    776888,
    897697,
    896876,
    977697,
    979887,
    977888,
    878868,
    877898,
    797777,
    898887,
    787997,
    887778,
    978779,
    697978,
    788778,
    798989,
    697876,
    778888,
    878868,
    887888,
    898977,
    988888,
    799787,
    987789,
    778778,
    778778,
    667988,
    897878,
    788989,
    798888,
    768878,
    978889,
    767888,
    887788,
    778786,
    779797,
    988877,
    698796,
    798877,
    797768,
    786798,
    887888,
    768887,
    888898,
    877989,
    888887,
    877988,
    978887,
    888778,
    677987,
    897887,
    997887,
    887668,
    977788,
    888797,
    789897,
    889878,
    978877,
    879898,
    997988,
    978877,
    777788,
    988867,
    878988,
    689988,
    788997,
    767889,
    887686,
    887887,
    897979,
    897777,
    889898,
    898878,
    786787,
    879899,
    778998,
    788877,
    877887,
    997886,
    898887,
    898788,
    787878,
    688988,
    787889,
    878976,
    978888,
    789778,
    997897,
    888797,
    767776,
    868788,
    887887,
    777898,
    888686,
    888778,
    799787,
    988697,
    767797,
    699977,
    976978,
    887969,
    897887,
    777799,
    887868,
    888788,
    678887,
    878978,
    797976,
    886798,
    878877,
    778998,
    786778,
    898797,
    986879,
    788988,
    698987,
    888878,
    877797,
    799888,
    887776,
    999999,
    786886,
    777788,
    777798,
    878878,
    977877,
    799978,
    887876,
    977777,
    966798,
    778799,
    788897,
    778979,
    898777,
    778788,
    689698,
    786787,
    877888,
    997787,
    879678,
    979878,
    887789,
    798878,
    789768,
    889789,
    998967,
    996789,
    777977,
    997978,
    768978,
    878988,
    899879,
    787899,
    779888,
    777886,
    888987,
    787688,
    978978,
    897977,
    988698,
    987789,
    787877,
    977787,
    897788,
    987898,
    898868,
    889768,
    877778,
    878788,
    888897,
    799878,
    898899,
    677888,
    979896,
    977978,
    867989,
    877878,
    978778,
    696797,
    799988,
    979767,
    977888,
    799889,
    978777,
    989788,
    998898,
    888988,
    879778,
    788878,
    888777,
    767779,
    877877,
    978768,
    987887,
    886867,
    987777,
    988689,
    767789,
    878787,
    778878,
    888987,
    988886,
    778878,
    988988,
    788878,
    678786,
    898889,
    799888,
    668678,
    779976,
    798878,
    889777,
    889998,
    799899,
    989769,
    877787,
    787887,
    879887,
    787997,
    898877,
    778977,
    688977,
    888877,
    768779,
    898788,
    766779,
    777978,
    878888,
    887987,
    877788,
    778899,
    877987,
    678868,
    888768,
    987888,
    897889,
    888789,
    779897,
    878888,
    878787,
    777879,
    988876,
    789796,
    776788,
    999797,
    998886,
    897977,
    867888,
    889987,
    778777,
    798788,
    977767,
    787978,
    878979,
    777898,
    786989,
    777788,
    888888,
    897887,
    988797,
    689888,
    897878,
    777678,
    877788,
    998689,
    887976,
    877898,
    878988,
    878887,
    787786,
    798888,
    777787,
    788778,
    988767,
    989987,
    787796,
    899979,
    878778,
    978766,
    998677,
    888978,
    887878,
    878977,
    898888,
    787778,
    788777,
    887877,
    978788,
    767889,
    979878,
    888968,
    788998,
    778978,
    797887,
    869687,
    798887,
    698889,
    888899,
    887889,
    789888,
    878877,
    889868,
    868787,
    878877,
    877788,
    886888,
    777777,
    868777,
    887879,
    889887,
    779888,
    889777,
    988897,
    787797,
    777978,
    989987,
    779878,
    976887,
    969687,
    787778,
    698997,
    878786,
    887897,
    987997,
    898778,
    887788,
    867877,
    777766,
    888989,
    677777,
    988789,
    899889,
    897767,
    799788,
    989887,
    779868,
    888878,
    997979,
    777788,
    788898,
    788779,
    899887,
    778979,
    889977,
    777789,
    767898,
    868999,
    888886,
    797776,
    879798,
    898898,
    987988,
    896866,
    767978,
    877787,
    889998,
    899887,
    867777,
    987977,
    787889,
    798877,
    888978,
    779988,
    987678,
    779687,
    897787,
    988787,
    889979,
    776879,
    977888,
    887788,
    888699,
    878877,
    789897,
    987888,
    887898,
    878688,
    988788,
    679797,
    988887,
    787888,
    996767,
    778988,
    877987,
    998878,
    878788,
    999686,
    878787,
    789888,
    987687,
    787977,
    788988,
    878786,
    978878,
    778787,
    868887,
    787788,
    778987,
    888889,
    887888,
    777788,
    987887,
    778779,
    887887,
    889878,
    868788,
    997997,
    678788,
    787968,
    968877,
    889789,
    868878,
    987889,
    768698,
    987887,
    778797,
    767887,
    879789,
    779877,
    888978,
    778888,
    889798,
    899978,
    787788,
    886898,
    688688,
    888779,
    697777,
    677788,
    697878,
    898899,
    877878,
    877899,
    889788,
    887767,
    968787,
    797887,
    879879,
    788966,
    698788,
    786889,
    788788,
    788787,
    886869,
    867798,
    798799,
    868896,
    888779,
    878888,
    979896,
    788887,
    887688,
    888689,
    988799,
    899799,
    777968,
    889788,
    789879,
    767889,
    778897,
    986778,
    987778,
    878977,
    978888,
    988889,
    787998,
    888979,
    988877,
    776887,
    888788,
    878877,
    988989,
    986788,
    977877,
    777879,
    888889,
    988898,
    889887,
    978767,
    888787,
    977889,
    967787,
    898899,
    878869,
    789788,
    878978,
    968977,
    888999,
    777878,
    787997,
    688797,
    868978,
    789887,
    898788,
    978788,
    787787,
    768888,
    876778,
    977778,
    778788,
    898988,
    999887,
    979877,
    988686,
    787779,
    977898,
    777988,
    997988,
    898987,
    779897,
    796888,
    898878,
    778988,
    888688,
    987787,
    878877,
    789899,
    788788,
    778879,
    898789,
    898976,
    877797,
    888778,
    879888,
    989878,
    778768,
    888888,
    878989,
    977778,
    798778,
    978888,
    996877,
    997787,
    888978,
    889877,
    987888,
    799677,
    777898,
    998797,
    986798,
    796869,
    988778,
    798898,
    778878,
    798778,
    888998,
    877888,
    778888,
    997878,
    887977,
    898897,
    776788,
    888768,
    786787,
    899887,
    888797,
    778799,
    877897,
    798878,
    877788,
    987988,
    769789,
    988977,
    876968,
    799887,
    798678,
    776889,
    877788,
    888789,
    788987,
    888787,
    887898,
    988988,
    777979,
    888876,
    879778,
    787877,
    878797,
    677797,
    789877,
    978887,
    897878,
    866997,
    887987,
    779778,
    778778,
    997988,
    788877,
    976788,
    887879,
    979778,
    889888,
    877878,
    788777,
    788898,
    879897,
    897778,
    868877,
    798788,
    987787,
    887887,
    987878,
    987898,
    978678,
    888798,
    877888,
    879788,
    876968,
    968989,
    877798,
    788779,
    888878,
    897789,
    868788,
    998878,
    988789,
    888878,
    888887,
    877788,
    877878,
    877797,
    788779,
    888779,
    797787,
    779897,
    887877,
    888887,
    787897,
    798778,
    869888,
    979878,
    897877,
    777888,
    788887,
    787887,
    988988,
    988778,
    899778,
    787888,
    788887,
    897778,
    897997,
    878888,
    677886,
    786887,
    888877,
    788799,
    787889,
    887888,
    898898,
    788887,
    997877,
    869897,
    787786,
    877888,
    777978,
    877769,
    889788,
    868869,
    988878,
    878779,
    988897,
    789799,
    778966,
    886787,
    688898,
    888978,
    788879,
    996887,
    678998,
    898778,
    977877,
    987977,
    768996,
    689988,
    678788,
    877898,
    889777,
    879879,
    977988,
    899889,
    788988,
    897978,
    888887,
    979888,
    777788,
    778887,
    987778,
    776979,
    897777,
    678777,
    868988,
    687877,
    989799,
    788897,
    986997,
    789888,
    888878,
    777687,
    889987,
    887998,
    898787,
    678878,
    887887,
    897877,
    968877,
    797787,
    777778,
    888686,
    887978,
    797767,
    888998,
    878987,
    867677,
    768687,
    987788,
    888888,
    887997,
    976898,
    988777,
    789888,
    799878,
    878698,
    778978,
    978869,
    997868,
    868967,
    878887,
    798896,
    779887,
    888987,
    887877,
    887888,
    788877,
    878788,
    878888,
    879979,
    697687,
    677798,
    886898,
    889789,
    898989,
    889897,
    676989,
    798878,
    897877,
    688779,
    777788,
    879866,
    877777,
    788798,
    877777,
    799777,
    979888,
    788876,
    988888,
    897778,
    777796,
    978787,
    978778,
    778887,
    887888,
    788689,
    789886,
    678997,
    688777,
    789778,
    989978,
    778988,
    798887,
    877887,
    888887,
    897798,
    888978,
    787879,
    998799,
    788878,
    879977,
    888887,
    788988,
    887678,
    788797,
    869899,
    898888,
    888989,
    988988,
    788986,
    878877,
    897988,
    889878,
    798978,
    889888,
    778878,
    778878,
    887887,
    779977,
    889877,
    888886,
    888887,
    779788,
    888868,
    788787,
    799888,
    899878,
    788897,
    889987,
    677676,
    778888,
    888776,
    888879,
    777779,
    979888,
    877887,
    687678,
    887788,
    888887,
    898788,
    899879,
    878877,
    988788,
    898889,
    997887,
    877779,
    979797,
    888888,
    977898,
    898869,
    879898,
    878877,
    787897,
    888697,
    877898,
    887897,
    878786,
    898887,
    789898,
    876778,
    997777,
    898788,
    889976,
    888877,
    988797,
    869988,
    898787,
    776776,
    977977,
    879879,
    979778,
    899998,
    986778,
    768988,
    867888,
    879997,
    789978,
    797878,
    787886,
    987787,
    897779,
    879779,
    777767,
    888888,
    979787,
    787877,
    798788,
    677887,
    988679,
    679967,
    878897,
    778789,
    877778,
    788877,
    887788,
    778888,
    889778,
    877789,
    879897,
    779976,
    778888,
    789888,
    979888,
    788768,
    967899,
    897777,
    878789,
    788678,
    888786,
    879886,
    788889,
    878887,
    787998,
    886677,
    878888,
    799788,
    899987,
    898779,
    687788,
    788877,
    988888,
    877787,
    776978,
    667888,
    878997,
    988877,
    999798,
    787888,
    877886,
    787889,
    968788,
    897789,
    888798,
    976778,
    977877,
    978787,
    788977,
    788978,
    868898,
    788788,
    887897,
    878779,
    986769,
    878889,
    899887,
    888877,
    678778,
    798788,
    878889,
    779798,
    888787,
    979888,
    897787,
    788968,
    677798,
    799786,
    787897,
    867788,
    789887,
    889887,
    887879,
    789877,
    779889,
    779988,
    877887,
    988897,
    978777,
    897778,
    889687,
    976868,
    878888,
    787888,
    878779,
    877888,
    979887,
    799978,
    979886,
    768798,
    876687,
    878898,
    978778,
    786898,
    899999,
    778988,
    897976,
    878776,
    797898,
    777878,
    877898,
    776799,
    797989,
    777886,
    787769,
    877888,
    888788,
    776887,
    888988,
    887879,
    788897,
    887778,
    998866,
    787978,
    977878,
    789899,
    888787,
    988967,
    878978,
    799688,
    787878,
    978877,
    988996,
    787878,
    877888,
    886988,
    997888,
    887768,
    779878,
    678897,
    878787,
    778789,
    897678,
    868769,
    879987,
    888889,
    867877,
    669987,
    699797,
    789977,
    887787,
    799897,
    787787,
    797888,
    887876,
    888788,
    879676,
    896798,
    978869,
    986979,
    767878,
    889999,
    888798,
    877797,
    879889,
    776878,
    998888,
    888989,
    979797,
    878899,
    788698,
    887877,
    797889,
    768887,
    889678,
    888887,
    787898,
    788887,
    887798,
    787899,
    777889,
    777867,
    898888,
    779787,
    978789,
    879687,
    778687,
    898878,
    676867,
    778888,
    978877,
    789789,
    879977,
    988878,
    887787,
    877987,
    898798,
    777798,
    887787,
    897888,
    978888,
    987878,
    969869,
    778989,
    887878,
    888878,
    889977,
    896779,
    869897,
    887767,
    778877,
    878778,
    777998,
    778877,
    777888,
    768997,
    768989,
    878977,
    988877,
    979878,
    889977,
    899989,
    876978,
    687987,
    778998,
    878888,
    889988,
    799778,
    888988,
    889787,
    878888,
    879977,
    789868,
    897988,
    986778,
    878877,
    778788,
    779797,
    979787,
    888896,
    888787,
    997788,
    989888,
    789788,
    789887,
    899887,
    786877,
    777777,
    678978,
    777878,
    887767,
    778899,
    887877,
    988986,
    879878,
    899888,
    877888,
    689886,
    688878,
    877887,
    888787,
    778978,
    777977,
    688779,
    989897,
    869878,
    878798,
    897987,
    768876,
    787869,
    778878,
    788889,
    777878,
    788778,
    887997,
    888987,
    879778,
    798978,
    878797,
    787778,
    876668,
    778679,
    976878,
    889889,
    887887,
    889798,
    898678,
    777788,
    888778,
    887998,
    788968,
    788877,
    879769,
    769787,
    899779,
    888777,
    886778,
    777678,
    679976,
    788679,
    879887,
    787877,
    979878,
    778988,
    768878,
    687797,
    878879,
    788787,
    778687,
    897797,
    896779,
    879889,
    779799,
    798778,
    778879,
    978888,
    788988,
    878898,
    879688,
    779797,
    788987,
    778677,
    987997,
    987788,
    886997,
    897988,
    878869,
    877777,
    877778,
    888887,
    887778,
    689788,
    888997,
    896787,
    888789,
    877889,
    988798,
    969868,
    999779,
    789977,
    888768,
    787778,
    889978,
    877789,
    898897,
    797767,
    779887,
    788688,
    979779,
    998768,
    888877,
    778789,
    967668,
    789888,
    967769,
    886878,
    879687,
    887887,
    888799,
    688888,
    887899,
    789868,
    799888,
    786796,
    787688,
    678889,
    878779,
    898997,
    987988,
    897876,
    888887,
    788788,
    678899,
    979978,
    788989,
    888768,
    899767,
    878789,
    876897,
    898688,
    879899,
    978977,
    778689,
    898787,
    777688,
    779978,
    768788,
    888788,
    988997,
    787988,
    888888,
    787788,
    787668,
    979667,
    868778,
    788888,
    797878,
    898778,
    977667,
    888877,
    998779,
    778877,
    786987,
    888887,
    788977,
    778898,
    786797,
    889887,
    688788,
    877897,
    989997,
    877688,
    988789,
    877878,
    896989,
    887888,
    977978,
    788798,
    889987,
    878898,
    888988,
    787889,
    879888,
    898778,
    889779,
    777986,
    877988,
    698788,
    889889,
    969979,
    788778,
    888886,
    897779,
    879977,
    777879,
    887877,
    868887,
    888968,
    887888,
    876997,
    786887,
    798897,
    788778,
    867878,
    988788,
    886687,
    787898,
    788888,
    688788,
    977778,
    988777,
    896988,
    999779,
    977988,
    888798,
    788879,
    767889,
    977888,
    788888,
    878887,
    899899,
    787797,
    797879,
    988687,
    896788,
    866678,
    786988,
    899999,
    989897,
    788987,
    788977,
    687788,
    979887,
    789679,
    879776,
    896998,
    788987,
    879878,
    869876,
    687777,
    799978,
    897977,
    898898,
    877886,
    977787,
    897888,
    886786,
    798876,
    989988,
    688986,
    797699,
    877778,
    888877,
    878687,
    887988,
    879997,
    877797,
    888998,
    888897,
    878888,
    799879,
    778767,
    777998,
    887898,
    888878,
    987888,
    878878,
    778887,
    778886,
    998789,
    889878,
    877898,
    767887,
    787778,
    778897,
    877778,
    779788,
    897978,
    777888,
    898899,
    777978,
    886998,
    878898,
    988988,
    788978,
    887887,
    888889,
    887897,
    698896,
    976876,
    688888,
    786877,
    889888,
    877779,
    886898,
    788879,
    768888,
    988776,
    777789,
    889788,
    777987,
    898789,
    888878,
    898797,
    987997,
    877788,
    888997,
    879997,
    687879,
    886688,
    788889,
    977877,
    788778,
    878877,
    797787,
    879778,
    887989,
    788888,
    897678,
    878788,
    677998,
    977987,
    787978,
    879878,
    977889,
    978889,
    798979,
    897879,
    977879,
    878979,
    887789,
    877788,
    788788,
    788788,
    688789,
    777867,
    777887,
    799978,
    787778,
    977886,
    787788,
    878798,
    888878,
    987777,
    999787,
    688788,
    767797,
    889887,
    777776,
    887798,
    877887,
    978889,
    897978,
    897886,
    887989,
    687989,
    798887,
    869999,
    788888,
    978887,
    886889,
    788888,
    878887,
    866878,
    786877,
    798987,
    887887,
    777978,
    787697,
    878878,
    987779,
    888788,
    768889,
    978896,
    888778,
    877698,
    868776,
    677987,
    779888,
    977797,
    777877,
    897888,
    877776,
    788687,
    898877,
    878777,
    887689,
    987877,
    887779,
    978798,
    978788,
    987777,
    799899,
    787988,
    799798,
    897778,
    897767,
    976977,
    887988,
    787878,
    868997,
    688988,
    988969,
    989887,
    888977,
    979978,
    879776,
    878977,
    788788,
    887888,
    977769,
    688788,
    877997,
    799798,
    788888,
    988878,
    867888,
    887998,
    877678,
    699879,
    788778,
    789779,
    888889,
    987997,
    788768,
    877778,
    897687,
    879998,
    888897,
    778788,
    787878,
    688989,
    886978,
    676887,
    787869,
    878787,
    876888,
    778887,
    797799,
    889887,
    879897,
    788798,
    787778,
    889868,
    788798,
    788877,
    788898,
    788777,
    787898,
    778778,
    888796,
    978889,
    878989,
    898868,
    877798,
    787776,
    887789,
    897888,
    887797,
    987779,
    987797,
    897788,
    887888,
    887887,
    789998,
    887887,
    769869,
    877897,
    677978,
    797768,
    788878,
    888888,
    789886,
    678868,
    898878,
    878886,
    888977,
    879699,
    898978,
    788867,
    998897,
    897868,
    887777,
    687878,
    887887,
    889789,
    887877,
    797778,
    887989,
    988878,
    779768,
    797977,
    897788,
    699777,
    777887,
    767868,
    877877,
    877787,
    779887,
    697796,
    888778,
    778887,
    888888,
    788788,
    888877,
    788789,
    888767,
    787788,
    888778,
    867887,
    788878,
    787778,
    698786,
    897988,
    787778,
    887787,
    876779,
    778898,
    899878,
    787968,
    688899,
    688876,
    798888,
    789776,
    987779,
    777897,
    777889,
    899778,
    788767,
    776797,
    778787,
    769787,
    988879,
    886889,
    787998,
    897886,
    777798,
    888878,
    768899,
    778979,
    898788,
    887877,
    967778,
    888998,
    787896,
    779889,
    989987,
    979768,
    798689,
    897787,
    878869,
    869878,
    887788,
    889889,
    877897,
    776877,
    887867,
    888787,
    789896,
    867878,
    897767,
    889887,
    769787,
    878788,
    998997,
    979899,
    887877,
    887788,
    787888,
    777787,
    878898,
    798689,
    898777,
    899978,
    988998,
    998987,
    778778,
    877786,
    788878,
    787878,
    877888,
    978887,
    877789,
    878887,
    979889,
    978888,
    787688,
    988687,
    898878,
    877877,
    787878,
    888989,
    998978,
    799877,
    776887,
    777879,
    888979,
    889777,
    877986,
    977867,
    878778,
    789877,
    798887,
    877989,
    899778,
    787889,
    988798,
    997787,
    779997,
    787767,
    788978,
    798789,
    977799,
    978997,
    898779,
    787868,
    898869,
    778899,
    888987,
    887788,
    879897,
    777688,
    989898,
    878876,
    877777,
    997698,
    988877,
    878777,
    777799,
    877778,
    878887,
    797678,
    799678,
    887888,
    879988,
    788689,
    899878,
    888898,
    868776,
    777887,
    877878,
    777887,
    888878,
    897678,
    877878,
    767769,
    898888,
    889668,
    998879,
    877888,
    876878,
    878878,
    897797,
    788878,
    788788,
    777989,
    689778,
    878879,
    897887,
    996798,
    678888,
    878998,
    998889,
    877788,
    878787,
    897889,
    779788,
    978798,
    777788,
    978789,
    879878,
    888888,
    998877,
    767777,
    777789,
    989778,
    888888,
    697878,
    988687,
    679867,
    888878,
    888887,
    987789,
    788898,
    788988,
    788879,
    697789,
    677778,
    878887,
    798978,
    789779,
    898886,
    977776,
    986997,
    679978,
    778887,
    989699,
    997787,
    978878,
    977778,
    688877,
    789787,
    797998,
    888898,
    888977,
    778887,
    767789,
    799788,
    888787,
    788778,
    868887,
    789787,
    698799,
    877798,
    889798,
    987877,
    986888,
    878868,
    877869,
    778986,
    998877,
    898998,
    887688,
    776987,
    978898,
    787889,
    887788,
    876877,
    987978,
    788897,
    877778,
    878768,
    877897,
    778786,
    887888,
    788778,
    778797,
    888887,
    776987,
    888978,
    778878,
    898987,
    887676,
    788968,
    786867,
    897788,
    798787,
    968878,
    898878,
    768889,
    779878,
    777687,
    898987,
    879778,
    777869,
    786788,
    797787,
    878878,
    779898,
    889776,
    778997,
    778878,
    888878,
    788777,
    777978,
    879779,
    899798,
    689898,
    998798,
    987878,
    889886,
    687779,
    899779,
    889788,
    989797,
    778987,
    677799,
    797768,
    789889,
    978868,
    998878,
    778689,
    998778,
    798989,
    777877,
    898776,
    998788,
    988898,
    888889,
    978778,
    677888,
    778896,
    776879,
    787897,
    778887,
    798989,
    887787,
    777777,
    886679,
    679877,
    787869,
    977788,
    887898,
    797878,
    788978,
    877887,
    787898,
    798878,
    798987,
    997787,
    877997,
    887868,
    977998,
    989889,
    999877,
    778878,
    798797,
    998798,
    878878,
    787889,
    897887,
    778888,
    877899,
    987978,
    877778,
    679988,
    968887,
    987878,
    968787,
    799787,
    889786,
    798996,
    897979,
    897898,
    988778,
    998898,
    897898,
    887678,
    779889,
    978877,
    877787,
    778897,
    797888,
    689777,
    687788,
    876789,
    777798,
    786898,
    887896,
    878797,
    777886,
    868877,
    978789,
    987787,
    879988,
    787799,
    879898,
    697788,
    878877,
    778888,
    877887,
    778778,
    898899,
    977778,
    879987,
    797788,
    898987,
    879888,
    887977,
    878689,
    677888,
    897877,
    787888,
    899778,
    778797,
    877986,
    777798,
    887778,
    867886,
    779988,
    987998,
    997887,
    897687,
    987889,
    987877,
    988978,
    977878,
    778878,
    896776,
    889899,
    787887,
    887898,
    899898,
    978987,
    887878,
    778778,
    687889,
    788888,
    989888,
    868778,
    778877,
    888789,
    799897,
    777888,
    877679,
    878888,
    887797,
    989898,
    788889,
    988889,
    978977,
    887789,
    988897,
    777899,
    878697,
    687788,
    887688,
    879678,
    877888,
    866888,
    877897,
    788779,
    876897,
    787768,
    888779,
    778886,
    679798,
    868897,
    779769,
    979898,
    978877,
    797977,
    978887,
    789886,
    988867,
    987898,
    867797,
    776788,
    689679,
    977986,
    869786,
    878887,
    777787,
    886877,
    689968,
    888877,
    988787,
    888889,
    888787,
    998886,
    798787,
    887888,
    698987,
    977979,
    689877,
    788887,
    989878,
    788887,
    897867,
    978768,
    798877,
    768888,
    778787,
    988878,
    777977,
    787777,
    798888,
    888999,
    888989,
    987778,
    898989,
    977676,
    899788,
    778777,
    877878,
    799668,
    899787,
    889889,
    798668,
    888879,
    777799,
    979797,
    868888,
    877897,
    879876,
    788988,
    878787,
    899988,
    868878,
    878998,
    778768,
    779878,
    789888,
    988888,
    697878,
    888898,
    787768,
    877988,
    979678,
    889968,
    987797,
    879769,
    967678,
    887799,
    878798,
    797879,
    887897,
    967978,
    868787,
    878787,
    788789,
    898789,
    878797,
    896897,
    878888,
    899796,
    687987,
    989886,
    778877,
    776678,
    888877,
    777867,
    697977,
    798798,
    997888,
    977877,
    787999,
    889797,
    786789,
    987777,
    866878,
    688877,
    798797,
    888899,
    777786,
    877878,
    878989,
    786977,
    788897,
    879898,
    687877,
    897877,
    897876,
    898778,
    887887,
    888699,
    688888,
    877879,
    987877,
    786887,
    688798,
    767787,
    897898,
    987886,
    788987,
    897978,
    887789,
    889888,
    896889,
    788978,
    778988,
    899979,
    788786,
    687878,
    888777,
    897688,
    787799,
    888876,
    977988,
    877789,
    888888,
    867797,
    997799,
    887778,
    996997,
    768778,
    878877,
    899966,
    787799,
    999887,
    887897,
    988696,
    778788,
    998786,
    776779,
    879879,
    688887,
    878778,
    797788,
    977987,
    887896,
    888798,
    697797,
    778898,
    988868,
    987778,
    777789,
    897798,
    878879,
    897877,
    878697,
    877878,
    988788,
    777798,
    898788,
    987989,
    887799,
    977889,
    788778,
    897987,
    989799,
    888788,
    988688,
    788788,
    789798,
    788887,
    888898,
    798688,
    786867,
    878987,
    789767,
    977878,
    789788,
    887886,
    797779,
    888768,
    878787,
    888887,
    988787,
    888789,
    769968,
    877878,
    787687,
    887889,
    897877,
    888988,
    988888,
    978878,
    776899,
    886887,
    768988,
    897788,
    898677,
    999897,
    779987,
    889889,
    889886,
    989878,
    877788,
    878889,
    698778,
    787778,
    897899,
    777887,
    777989,
    796788,
    898786,
    978989,
    779799,
    787798,
    787778,
    878888,
    788877,
    888768,
    998896,
    888978,
    979989,
    878879,
    886888,
    788779,
    898776,
    798788,
    888988,
    788888,
    687878,
    777797,
    888878,
    987688,
    888879,
    878888,
    987988,
    878777,
    999999,
    988677,
    798798,
    787797,
    778787,
    879989,
    987886,
    976788,
    788776,
    788688,
    778787,
    788889,
    687989,
    878788,
    788778,
    987888,
    778897,
    877688,
    878788,
    869797,
    978867,
    898878,
    687886,
    779789,
    778777,
    789889,
    788797,
    797868,
    789896,
    899798,
    976898,
    778987,
    879878,
    878877,
    879977,
    869897,
    797887,
    877997,
    978889,
    996776,
    797778,
    876989,
    788687,
    876888,
    778786,
    777878,
    867777,
    779789,
    989877,
    787898,
    987888,
    799888,
    797778,
    877787,
    887797,
    978878,
    798887,
    679788,
    999878,
    976868,
    879779,
    877887,
    797688,
    999788,
    878798,
    888877,
    778787,
    886768,
    788788,
    878987,
    977966,
    987787,
    887877,
    978888,
    786878,
    897868,
    879678,
    887879,
    897778,
    787888,
    988678,
    878887,
    979967,
    796979,
    687886,
    798878,
    897788,
    887788,
    888878,
    777797,
    896976,
    976789,
    997879,
    898777,
    778889,
    977868,
    876979,
    988776,
    767787,
    768788,
    878897,
    787787,
    898878,
    787998,
    787888,
    969999,
    898688,
    888888,
    797898,
    788787,
    787898,
    998786,
    887798,
    878788,
    677778,
    789888,
    888886,
    798886,
    887676,
    769788,
    988777,
    789687,
    888979,
    879899,
    799888,
    987787,
    888787,
    978988,
    988868,
    898878,
    896789,
    777887,
    878886,
    789789,
    779787,
    799887,
    978967,
    878978,
    788877,
    787777,
    797889,
    778767,
    888987,
    887786,
    886878,
    797877,
    778789,
    879888,
    887876,
    887978,
    898778,
    797887,
    998987,
    877878,
    789877,
    889897,
    988779,
    678888,
    987697,
    777787,
    968887,
    988787,
    787886,
    787867,
    687877,
    787998,
    788997,
    878877,
    777887,
    776977,
    878977,
    789887,
    977898,
    887799,
    989789,
    887779,
    788778,
    887887,
    877888,
    868899,
    878888,
    978999,
    887789,
    786878,
    788798,
    977888,
    987877,
    788777,
    889987,
    689888,
    897878,
    798879,
    998767,
    877779,
    677779,
    877677,
    778887,
    688899,
    987779,
    869787,
    788967,
    898978,
    996996,
    998669,
    898898,
    868878,
    886988,
    888969,
    868788,
    787877,
    888878,
    779988,
    777778,
    877669,
    987777,
    886777,
    877979,
    887866,
    688788,
    787879,
    799878,
    898797,
    889887,
    867789,
    977897,
    787768,
    777789,
    888888,
    897878,
    878988,
    787878,
    689888,
    888797,
    988786,
    888779,
    787887,
    888896,
    669898,
    888779,
    888687,
    787889,
    898987,
    677797,
    898797,
    876797,
    878969,
    978888,
    776987,
    776889,
    688987,
    978988,
    877778,
    778878,
    888878,
    787877,
    889998,
    877978,
    888987,
    798889,
    897888,
    888777,
    799887,
    787886,
    879868,
    998786,
    889878,
    798887,
    779798,
    777988,
    679797,
    988777,
    878869,
    787879,
    788897,
    879878,
    888888,
    897889,
    887889,
    788686,
    778688,
    899878,
    888988,
    688778,
    898878,
    787788,
    789788,
    979778,
    899978,
    788887,
    887887,
    888987,
    889897,
    889898,
    787877,
    789867,
    788878,
    798689,
    777777,
    999788,
    688787,
    787767,
    879798,
    878897,
    767879,
    978788,
    888788,
    888997,
    988688,
    988787,
    889878,
    788788,
    797898,
    879878,
    878778,
    788766,
    977798,
    787887,
    777888,
    898789,
    988797,
    789689,
    988768,
    877787,
    877878,
    879788,
    999798,
    767887,
    876977,
    776879,
    968876,
    787887,
    778788,
    988888,
    787888,
    889978,
    886998,
    798897,
    979898,
    787988,
    788878,
    879798,
    778877,
    899978,
    988897,
    887798,
    979877,
    887767,
    877787,
    887889,
    889897,
    997878,
    878677,
    778889,
    667989,
    888969,
    977878,
    789879,
    988888,
    989888,
    878987,
    866968,
    778989,
    877899,
    898788,
    987878,
    798679,
    779768,
    777888,
    879878,
    779788,
    988686,
    789888,
    797868,
    787778,
    789888,
    788798,
    777777,
    879789,
    887787,
    868877,
    899677,
    786899,
    786797,
    899888,
    898869,
    778779,
    798987,
    788789,
    878997,
    768778,
    778787,
    887879,
    789888,
    978777,
    789798,
    788677,
    968977,
    787797,
    797888,
    987879,
    897968,
    798877,
    887787,
    888777,
    688888,
    776697,
    778786,
    868777,
    998977,
    778889,
    878988,
    989887,
    977897,
    898998,
    878898,
    778679,
    787989,
    787889,
    888979,
    977788,
    969778,
    878988,
    988789,
    788779,
    898897,
    989888,
    898898,
    887867,
    998879,
    787887,
    697878,
    887786,
    887687,
    897888,
    787777,
    788978,
    789878,
    787998,
    797986,
    789977,
    778888,
    778887,
    776978,
    876798,
    868978,
    798689,
    887778,
    898887,
    877688,
    769898,
    789788,
    789777,
    887878,
    898878,
    988889,
    779678,
    787988,
    677888,
    779777,
    788698,
    787879,
    977778,
    787878,
    779888,
    789877,
    876889,
    877887,
    888876,
    888878,
    878787,
    878878,
    779988,
    969878,
    788897,
    997977,
    979887,
    888788,
    678787,
    767898,
    888787,
    778788,
    888788,
    899987,
    888888,
    898899,
    788778,
    987689,
    777887,
    689788,
    789878,
    778787,
    777887,
    788897,
    787887,
    777977,
    788899,
    787788,
    968869,
    879786,
    889889,
    888887,
    879788,
    889988,
    888878,
    887778,
    888889,
    899978,
    888987,
    698798,
    788688,
    998979,
    787888,
    776879,
    987689,
    776997,
    778969,
    869877,
    687697,
    888987,
    877777,
    879977,
    798798,
    887988,
    786889,
    778988,
    787777,
    978987,
    787978,
    778786,
    986877,
    898988,
    888887,
    788886,
    886879,
    788797,
    877877,
    877779,
    999878,
    988878,
    779697,
    778778,
    679977,
    887968,
    978989,
    898887,
    789887,
    678697,
    887787,
    988987,
    887878,
    779888,
    876887,
    788877,
    978986,
    877777,
    996797,
    797777,
    888888,
    888988,
    877788,
    977887,
    898687,
    777987,
    878898,
    889896,
    889878,
    687888,
    676887,
    978978,
    876978,
    888787,
    896778,
    697886,
    788897,
    788798,
    678777,
    777997,
    989988,
    988778,
    778787,
    888899,
    878878,
    977876,
    898876,
    889788,
    887768,
    799788,
    889698,
    879876,
    888687,
    989876,
    698987,
    888868,
    779877,
    887797,
    888898,
    888888,
    788799,
    769987,
    887897,
    878699,
    897778,
    879789,
    989897,
    798787,
    877888,
    987879,
    877889,
    978798,
    778979,
    888787,
    877787,
    888888,
    877778,
    887888,
    677878,
    886889,
    878788,
    878787,
    886879,
    887988,
    798867,
    789988,
    979888,
    889978,
    778888,
    796697,
    777699,
    888789,
    886788,
    799888,
    769789,
    788878,
    888799,
    688788,
    889978,
    888689,
    866778,
    987778,
    788799,
    977798,
    887796,
    778787,
    787979,
    978878,
    988887,
    988786,
    887878,
    798887,
    877777,
    899798,
    897896,
    899877,
    888778,
    887777,
    867779,
    796788,
    768789,
    879789,
    786689,
    869776,
    778778,
    886797,
    688787,
    878967,
    968889,
    768878,
    988888,
    787888,
    877879,
    889788,
    688886,
    877989,
    787979,
    787777,
    877987,
    777976,
    897787,
    887767,
    999899,
    988888,
    888878,
    788977,
    778798,
    788779,
    887877,
    678788,
    878778,
    798887,
    878988,
    689897,
    888879,
    977888,
    879789,
    869797,
    668778,
    878787,
    978777,
    788878,
    977897,
    887787,
    887897,
    878877,
    677788,
    779867,
    778888,
    879977,
    688878,
    798898,
    887798,
    988988,
    787888,
    898878,
    797778,
    887778,
    887887,
    979878,
    988879,
    988799,
    998777,
    998788,
    887888,
    777768,
    776979,
    789696,
    899877,
    988998,
    787998,
    797888,
    788688,
    779876,
    798888,
    898677,
    977878,
    797977,
    878879,
    878669,
    977876,
    786997,
    788887,
    776877,
    877766,
    788876,
    887787,
    888787,
    687978,
    798876,
    889888,
    978976,
    798877,
    967788,
    878777,
    787877,
    879878,
    798888,
    887879,
    987887,
    798887,
    978876,
    889778,
    687999,
    779779,
    769898,
    878787,
    879787,
    797778,
    798879,
    888897,
    878988,
    698879,
    869869,
    887878,
    887988,
    887898,
    987786,
    978876,
    987699,
    688788,
    687888,
    888787,
    888878,
    777889,
    777888,
    667777,
    887778,
    688778,
    776889,
    887986,
    888787,
    988788,
    888879,
    668876,
    789787,
    888878,
    876797,
    778779,
    698898,
    878877,
    878688,
    878778,
    879987,
    889877,
    887978,
    799978,
    778687,
    678988,
    697786,
    798887,
    988988,
    788897,
    997796,
    987788,
    779779,
    888788,
    688878,
    889877,
    778886,
    877878,
    778879,
    888888,
    887876,
    887887,
    789888,
    899889,
    787788,
    888869,
    787978,
    779877,
    689686,
    889877,
    776788,
    678878,
    978686,
    789897,
    897998,
    888869,
    788887,
    889789,
    877889,
    878678,
    887979,
    888797,
    787996,
    686777,
    868877,
    887978,
    888778,
    878777,
    868888,
    896789,
    887887,
    798987,
    798667,
    776778,
    877888,
    767877,
    987899,
    989878,
    888988,
    779889,
    878888,
    988786,
    787698,
    699988,
    777778,
    878787,
    787887,
    898878,
    878877,
    979776,
    978778,
    779787,
    877778,
    887788,
    977987,
    786988,
    778787,
    888888,
    788879,
    786788,
    988887,
    788777,
    978689,
    988788,
    779778,
    778879,
    777879,
    898787,
    979778,
    778897,
    878868,
    778887,
    969868,
    689797,
    967989,
    877787,
    967779,
    878778,
    769978,
    878997,
    778878,
    999997,
    788977,
    879777,
    677986,
    778889,
    897889,
    778978,
    989689,
    888988,
    687787,
    988797,
    987888,
    968977,
    787888,
    798787,
    789887,
    897889,
    778677,
    996688,
    988997,
    898788,
    787787,
    977878,
    898896,
    788788,
    879777,
    998777,
    878888,
    976877,
    978779,
    989896,
    778779,
    898767,
    888987,
    788978,
    889788,
    879776,
    887997,
    878988,
    888967,
    988779,
    779877,
    987779,
    779689,
    689777,
    887878,
    768789,
    888699,
    699789,
    888887,
    877878,
    968878,
    888986,
    779789,
    878667,
    878896,
    788878,
    777977,
    888986,
    888877,
    878777,
    778887,
    888888,
    888878,
    879687,
    887867,
    867778,
    778977,
    789788,
    797989,
    798879,
    786998,
    687898,
    879777,
    977878,
    788788,
    878799,
    888788,
    878877,
    777776,
    988799,
    887897,
    898989,
    688988,
    777889,
    886987,
    879679,
    888867,
    687787,
    778987,
    888988,
    876788,
    778688,
    767668,
    778877,
    778896,
    877999,
    987798,
    867679,
    697879,
    788997,
    788788,
    787887,
    877987,
    888997,
    879888,
    969798,
    796776,
    797878,
    787878,
    689989,
    878779,
    889888,
    788986,
    977767,
    788678,
    898898,
    868997,
    888899,
    889778,
    987878,
    688698,
    878889,
    687787,
    988988,
    677887,
    777979,
    878877,
    988688,
    867787,
    977998,
    787788,
    867989,
    887967,
    787887,
    899878,
    888887,
    988778,
    798888,
    898997,
    889787,
    987788,
    887779,
    777788,
    888779,
    988787,
    877887,
    788889,
    878899,
    877888,
    988878,
    788787,
    799798,
    888878,
    888898,
    789879,
    898887,
    878888,
    989876,
    777889,
    888877,
    899788,
    798897,
    787788,
    888897,
    797888,
    878897,
    988888,
    987798,
    898778,
    897888,
    988688,
    879788,
    777787,
    798789,
    987887,
    889987,
    778889,
    878889,
    867887,
    677798,
    776888,
    977788,
    877978,
    898977,
    987889,
    877678,
    879698,
    897788,
    878878,
    788899,
    887888,
    877779,
    787999,
    888877,
    899888,
    877878,
    788876,
    798889,
    878788,
    887877,
    887877,
    779797,
    867786,
    888797,
    788778,
    888888,
    899779,
    897897,
    978877,
    888777,
    687887,
    778778,
    987887,
    777888,
    878888,
    887889,
    877797,
    898788,
    887987,
    787879,
    778877,
    887777,
    888889,
    878867,
    877789,
    779889,
    996878,
    697687,
    997689,
    779978,
    799899,
    667878,
    769897,
    978888,
    976778,
    798887,
    786898,
    876787,
    897886,
    878878,
    897879,
    788878,
    778978,
    789998,
    898899,
    887887,
    977989,
    989688,
    877997,
    877899,
    869889,
    776898,
    888889,
    867887,
    867887,
    786788,
    869889,
    878668,
    788689,
    869888,
    687987,
    787886,
    879877,
    778889,
    889777,
    788788,
    799787,
    968779,
    798677,
    886988,
    779777,
    867899,
    778899,
    898989,
    898888,
    978796,
    879878,
    878797,
    788788,
    787998,
    887788,
    989896,
    979779,
    968988,
    877788,
    877988,
    778988,
    877779,
    987777,
    998887,
    878898,
    889787,
    898889,
    787877,
    988897,
    887888,
    877897,
    798889,
    788868,
    888787,
    989867,
    789798,
    898898,
    868977,
    779888,
    888887,
    877989,
    897787,
    989688,
    987787,
    878886,
    877976,
    788997,
    788777,
    989988,
    888778,
    978986,
    889689,
    789679,
    777888,
    888887,
    889688,
    798987,
    778687,
    868977,
    897898,
    788778,
    979788,
    998877,
    787788,
    987769,
    897677,
    778768,
    887979,
    788998,
    877888,
    797888,
    879987,
    778898,
    886897,
    798887,
    798778,
    876897,
    799799,
    888698,
    787789,
    868688,
    778767,
    888989,
    777788,
    878877,
    878898,
    766877,
    897877,
    887777,
    898986,
    969899,
    868889,
    978776,
    787888,
    777877,
    876777,
    898989,
    788887,
    776888,
    798977,
    886878,
    788779,
    888799,
    876877,
    877777,
    886888,
    888997,
    978788,
    887769,
    877766,
    988989,
    897788,
    998887,
    877887,
    879777,
    987887,
    876868,
    886888,
    877877,
    988778,
    897779,
    789787,
    867888,
    878687,
    898668,
    789987,
    797898,
    888879,
    796776,
    989878,
    776798,
    997877,
    979788,
    767787,
    988789,
    886898,
    976999,
    888998,
    999888,
    988777,
    987998,
    998787,
    978888,
    869988,
    779777,
    887888,
    877898,
    789999,
    788787,
    877877,
    768887,
    888878,
    897777,
    778888,
    897877,
    899898,
    878777,
    897798,
    878878,
    796788,
    868677,
    798777,
    887887,
    868878,
    888788,
    778787,
    877989,
    889788,
    788898,
    688666,
    786788,
    787889,
    898777,
    867888,
    897878,
    788997,
    979787,
    977766,
    888798,
    779878,
    779888,
    898879,
    789768,
    689989,
    888878,
    779868,
    997776,
    778988,
    988988,
    779998,
    988897,
    798887,
    798889,
    688787,
    889998,
    798888,
    779787,
    887887,
    879777,
    767976,
    998879,
    976687,
    798777,
    978987,
    876777,
    898988,
    768888,
    688969,
    878867,
    769789,
    887987,
    887777,
    889778,
    788877,
    877896,
    889788,
    868889,
    779889,
    777878,
    998668,
    997979,
    999778,
    688898,
    886999,
    787678,
    789899,
    797977,
    887988,
    767877,
    798878,
    988789,
    869987,
    778889,
    798978,
    879799,
    898898,
    988779,
    877888,
    688879,
    688987,
    888887,
    789889,
    977797,
    787978,
    768878,
    877886,
    978887,
    788988,
    788797,
    678697,
    889987,
    778887,
    989789,
    977989,
    698777,
    768878,
    978979,
    779778,
    776788,
    788888,
    788877,
    889888,
    888797,
    888988,
    878777,
    888886,
    788979,
    877788,
    988877,
    997878,
    887877,
    778869,
    866777,
    978888,
    776788,
    878789,
    888969,
    797688,
    787778,
    888787,
    887777,
    988687,
    869888,
    887768,
    688778,
    977879,
    687988,
    699788,
    679987,
    898798,
    777788,
    788788,
    888889,
    987897,
    978898,
    779877,
    879878,
    987977,
    778788,
    797768,
    879789,
    868977,
    987799,
    878779,
    878777,
    797768,
    777789,
    877887,
    788878,
    768788,
    988868,
    888898,
    987788,
    989767,
    777889,
    897797,
    787878,
    787789,
    888977,
    897897,
    887669,
    797887,
    778878,
    978878,
    977878,
    788767,
    887788,
    899788,
    898878,
    988888,
    878878,
    877898,
    888988,
    778787,
    868877,
    777968,
    789878,
    969778,
    778988,
    797876,
    877877,
    767887,
    888897,
    696787,
    896989,
    898987,
    988889,
    877787,
    867896,
    778988,
    777789,
    887888,
    887988,
    786767,
    789887,
    788997,
    987696,
    788788,
    787988,
    878989,
    988888,
    767887,
    999687,
    788988,
    788897,
    799988,
    778799,
    998878,
    868778,
    876989,
    788898,
    878979,
    778878,
    977879,
    786778,
    887978,
    798898,
    668878,
    977988,
    788888,
    888867,
    778886,
    777868,
    788996,
    798887,
    787788,
    768868,
    779988,
    887988,
    877887,
    799786,
    789898,
    787888,
    789766,
    678699,
    978888,
    888788,
    897887,
    978789,
    787799,
    987779,
    799778,
    788977,
    978779,
    987878,
    888998,
    878879,
    888978,
    878788,
    686798,
    878788,
    887789,
    988789,
    776779,
    879779,
    888787,
    898987,
    888988,
    688878,
    877869,
    898879,
    786888,
    878978,
    789979,
    877898,
    778978,
    789898,
    777898,
    687998,
    788888,
    778888,
    978777,
    897787,
    879878,
    687689,
    698867,
    787776,
    878879,
    789899,
    877799,
    768987,
    879669,
    977789,
    898878,
    877877,
    887888,
    898798,
    889888,
    877889,
    889777,
    896888,
    886789,
    787878,
    899788,
    798787,
    777787,
    876889,
    668878,
    788898,
    777989,
    887876,
    968988,
    978988,
    978887,
    889687,
    888798,
    998989,
    978877,
    987879,
    886678,
    988776,
    888878,
    778988,
    797877,
    788777,
    797868,
    966887,
    879777,
    796789,
    799799,
    777877,
    788788,
    777779,
    987979,
    787988,
    877768,
    778878,
    887777,
    876797,
    989877,
    787977,
    897987,
    887786,
    878888,
    978687,
    778777,
    888978,
    877779,
    888998,
    989976,
    998988,
    888889,
    877998,
    878997,
    878999,
    798787,
    888799,
    777777,
    799978,
    898788,
    888778,
    889888,
    877888,
    978978,
    888888,
    788687,
    889797,
    887789,
    767887,
    977988,
    998698,
    979887,
    779799,
    698789,
    787788,
    987777,
    978789,
    878688,
    976897,
    688788,
    787877,
    889787,
    897878,
    898777,
    799786,
    979987,
    698888,
    988778,
    778888,
    698776,
    977877,
    669787,
    879778,
    977799,
    867778,
    888877,
    787878,
    768778,
    998888,
    888769,
    887688,
    897687,
    878989,
    977788,
    888887,
    799887,
    878777,
    899888,
    797777,
    888898,
    679899,
    867898,
    989887,
    698687,
    877879,
    789887,
    768888,
    998677,
    786889,
    878877,
    768878,
    977898,
    879889,
    988987,
    777867,
    887889,
    997699,
    788888,
    778887,
    798878,
    767987,
    879886,
    679678,
    978877,
    888777,
    878788,
    889677,
    976887,
    888887,
    789788,
    888988,
    998878,
    987967,
    866878,
    887889,
    888779,
    787878,
    788787,
    689987,
    888898,
    888899,
    877878,
    688788,
    898899,
    988987,
    688879,
    697888,
    899787,
    888777,
    997978,
    778787,
    897888,
    787688,
    887878,
    897689,
    798688,
    678697,
    987698,
    887878,
    977878,
    789777,
    768787,
    998877,
    788887,
    878887,
    897877,
    789889,
    777988,
    988989,
    878778,
    897878,
    877779,
    877797,
    889987,
    778978,
    789897,
    797877,
    778887,
    879987,
    977898,
    878898,
    886699,
    798987,
    888788,
    778787,
    968877,
    687788,
    778678,
    888789,
    898767,
    989789,
    979678,
    777778,
    889886,
    877788,
    868988,
    776976,
    799887,
    888697,
    977787,
    887678,
    979689,
    888886,
    788697,
    877988,
    868877,
    897788,
    787878,
    867888,
    886788,
    787879,
    788878,
    878778,
    777888,
    898788,
    877969,
    889868,
    888688,
    788888,
    867887,
    887989,
    768887,
    779779,
    988887,
    798678,
    889888,
    778867,
    777688,
    878886,
    898798,
    788779,
    887889,
    867877,
    887777,
    788878,
    888898,
    799878,
    876786,
    877798,
    877898,
    987988,
    896776,
    988987,
    888877,
    879787,
    998889,
    778778,
    888979,
    887999,
    968987,
    778797,
    877878,
    886987,
    897887,
    786676,
    989889,
    787998,
    779889,
    787989,
    799898,
    778998,
    787788,
    779899,
    879778,
    888788,
    889889,
    787788,
    688797,
    878866,
    889989,
    787798,
    977877,
    889977,
    799798,
    989887,
    977789,
    688998,
    687879,
    787997,
    889879,
    988777,
    998799,
    899977,
    778878,
    877789,
    878887,
    777878,
    898778,
    777898,
    887798,
    878987,
    877888,
    769787,
    988768,
    888888,
    799786,
    987778,
    988877,
    879889,
    878988,
    778688,
    998797,
    777778,
    988878,
    888888,
    787778,
    887798,
    967777,
    898798,
    788688,
    888778,
    786988,
    776898,
    978798,
    777877,
    789887,
    898889,
    897786,
    798778,
    989887,
    887887,
    878997,
    778787,
    889988,
    789878,
    877997,
    788876,
    876779,
    679786,
    877887,
    879788,
    879788,
    867768,
    896888,
    797888,
    897988,
    789777,
    998798,
    787878,
    877677,
    997698,
    888988,
    797987,
    979777,
    997678,
    888888,
    888887,
    867989,
    869888,
    788887,
    686787,
    897877,
    898767,
    779777,
    788999,
    889878,
    888779,
    989778,
    878877,
    978878,
    888988,
    989878,
    998988,
    786778,
    997787,
    989887,
    778877,
    787887,
    667778,
    798978,
    678777,
    798788,
    789887,
    887988,
    997888,
    897898,
    889797,
    997897,
    898798,
    689986,
    788888,
    689878,
    676888,
    897878,
    687788,
    998788,
    779878,
    777877,
    888678,
    787868,
    987998,
    877987,
    887778,
    878877,
    888888,
    789969,
    988889,
    867797,
    687987,
    777989,
    976786,
    897879,
    989877,
    788777,
    868778,
    787788,
    786978,
    887779,
    867887,
    667778,
    766786,
    989698,
    988788,
    877867,
    897886,
    898788,
    788879,
    899877,
    888799,
    778989,
    988887,
    889888,
    878776,
    788978,
    986789,
    868778,
    787889,
    786776,
    897878,
    888898,
    888688,
    898989,
    999778,
    788998,
    877877,
    887887,
    878879,
    777978,
    888878,
    798979,
    688978,
    788887,
    786897,
    867777,
    897878,
    989788,
    897979,
    789987,
    897797,
    888869,
    887898,
    887697,
    797878,
    769989,
    888788,
    979878,
    979789,
    876978,
    687977,
    977788,
    877677,
    876899,
    776776,
    876778,
    789989,
    997889,
    787769,
    977788,
    888677,
    888887,
    898997,
    867888,
    879887,
    987877,
    777798,
    979877,
    687778,
    889888,
    887787,
    977787,
    888997,
    978989,
    797867,
    898877,
    978888,
    888989,
    768789,
    787898,
    887887,
    888879,
    976898,
    998879,
    986898,
    777897,
    977768,
    788987,
    989778,
    987787,
    667998,
    888889,
    688899,
    798886,
    877678,
    996888,
    867886,
    879998,
    898987,
    878769,
    868879,
    876869,
    778798,
    987888,
    977679,
    877897,
    888688,
    888878,
    986799,
    898887,
    778889,
    887898,
    788889,
    797797,
    788777,
    787698,
    798777,
    788769,
    977988,
    877997,
    898897,
    787778,
    768889,
    797898,
    878878,
    788888,
    888986,
    787988,
    878877,
    886789,
    687798,
    888988,
    768897,
    889988,
    898876,
    799887,
    989877,
    878799,
    686978,
    888788,
    798798,
    797777,
    688777,
    777988,
    888788,
    889677,
    787988,
    877787,
    667879,
    767888,
    877866,
    988989,
    797777,
    899988,
    689979,
    898889,
    979897,
    898878,
    988789,
    888788,
    778979,
    866897,
    879888,
    888787,
    998996,
    886897,
    978889,
    879987,
    877687,
    876888,
    787788,
    877778,
    788778,
    897887,
    778897,
    888878,
    778796,
    988887,
    776677,
    889887,
    888877,
    877778,
    767778,
    998979,
    787988,
    867887,
    898777,
    997987,
    876777,
    977889,
    878987,
    999877,
    888987,
    888878,
    887769,
    788677,
    787777,
    789988,
    879898,
    877788,
    779876,
    878868,
    878877,
    977778,
    998988,
    897989,
    888887,
    787786,
    888877,
    887889,
    878767,
    999786,
    978887,
    978898,
    778989,
    897778,
    888789,
    868787,
    787967,
    767878,
    798878,
    898888,
    779878,
    879789,
    878798,
    876887,
    978877,
    868787,
    888898,
    977876,
    777797,
    777877,
    878677,
    787789,
    866988,
    777688,
    877699,
    897897,
    888979,
    988876,
    876799,
    788898,
    878976,
    998798,
    887977,
    898879,
    787987,
    777889,
    978678,
    878887,
    886878,
    677989,
    678878,
    899778,
    878868,
    788789,
    888788,
    678888,
    777878,
    866788,
    878886,
    877878,
    988886,
    769889,
    889787,
    887868,
    777977,
    887778,
    789779,
    778777,
    887889,
    778787,
    999796,
    777889,
    987878,
    798978,
    968877,
    788669,
    787868,
    879978,
    677787,
    788887,
    668998,
    778889,
    788887,
    688697,
    777979,
    789997,
    887787,
    677787,
    899687,
    899779,
    998988,
    788697,
    887787,
    887888,
    697889,
    788767,
    877877,
    877899,
    987788,
    889679,
    989877,
    978888,
    688888,
    988988,
    888799,
    788978,
    877788,
    889797,
    778877,
    877798,
    887977,
    778988,
    787878,
    898877,
    777787,
    987877,
    878788,
    887788,
    878868,
    888777,
    867798,
    798879,
    987988,
    788787,
    788688,
    779797,
    899797,
    799777,
    888777,
    898898,
    897789,
    978879,
    778888,
    987977,
    888777,
    898898,
    787868,
    888867,
    888777,
    869977,
    878797,
    788887,
    988887,
    796887,
    877988,
    678887,
    898877,
    988879,
    877788,
    787888,
    886998,
    789977,
    988778,
    977879,
    986988,
    998788,
    876778,
    788779,
    899798,
    997878,
    779998,
    878879,
    787888,
    897797,
    889989,
    867798,
    888899,
    686876,
    788878,
    778889,
    888877,
    889889,
    878878,
    797879,
    788876,
    768867,
    799897,
    988868,
    878699,
    788787,
    889678,
    997867,
    878977,
    779876,
    776888,
    898886,
    777878,
    787879,
    989989,
    998897,
    968778,
    778887,
    987999,
    898989,
    899888,
    888767,
    788988,
    888786,
    877887,
    788778,
    888788,
    897888,
    898966,
    888799,
    997866,
    868886,
    899988,
    787897,
    788978,
    977968,
    787697,
    887778,
    876867,
    888897,
    869998,
    887888,
    768899,
    979898,
    888888,
    768889,
    899889,
    799778,
    979897,
    788877,
    787788,
    878777,
    778988,
    787897,
    889767,
    889888,
    978698,
    778888,
    878678,
    997888,
    987889,
    778889,
    787879,
    999788,
    787789,
    787899,
    879779,
    977978,
    776778,
    889876,
    788677,
    688887,
    787988,
    889798,
    978788,
    867889,
    977879,
    768877,
    788678,
    788767,
    876799,
    676788,
    897886,
    788987,
    897987,
    787998,
    889878,
    777877,
    897877,
    777897,
    979779,
    787697,
    877999,
    977787,
    688797,
    888698,
    777898,
    797688,
    778988,
    797898,
    989888,
    778887,
    997999,
    888689,
    688778,
    887877,
    789888,
    977979,
    779877,
    897889,
    886978,
    788779,
    878898,
    878798,
    988778,
    788867,
    888888,
    888977,
    889898,
    877787,
    777777,
    897888,
    878788,
    887778,
    688897,
    878888,
    788788,
    889888,
    868898,
    887877,
    978977,
    787777,
    886887,
    768869,
    887987,
    778888,
    889886,
    968869,
    977868,
    887779,
    887989,
    787887,
    878778,
    777887,
    797688,
    897887,
    798987,
    797868,
    876679,
    799978,
    877986,
    978887,
    778777,
    799687,
    898888,
    777798,
    878867,
    878789,
    877789,
    788789,
    968887,
    879888,
    798676,
    988899,
    988886,
    777778,
    867687,
    889878,
    688879,
    789977,
    978889,
    989867,
    877778,
    789778,
    778698,
    889778,
    797797,
    878777,
    878778,
    787988,
    888687,
    977798,
    869779,
    789878,
    989797,
    988798,
    888878,
    886799,
    998798,
    787887,
    968788,
    988788,
    877997,
    788679,
    977677,
    879989,
    887878,
    779787,
    886888,
    879778,
    888777,
    877776,
    778688,
    777887,
    799888,
    877869,
    787788,
    968897,
    987887,
    979688,
    679789,
    697778,
    988788,
    878898,
    787898,
    878977,
    887898,
    888889,
    877877,
    788787,
    788778,
    868788,
    677788,
    877788,
    687868,
    677876,
    889887,
    897887,
    779977,
    778787,
    778978,
    889798,
    878868,
    779887,
    867898,
    677787,
    868888,
    677889,
    887797,
    887886,
    879777,
    777996,
    976887,
    879888,
    876786,
    968897,
    888889,
    888777,
    888886,
    889798,
    978989,
    687887,
    789797,
    768886,
    886788,
    799968,
    677777,
    788898,
    778787,
    987977,
    898898,
    686767,
    876789,
    988899,
    887787,
    687779,
    898767,
    989678,
    989677,
    879878,
    788798,
    779787,
    787878,
    889789,
    797689,
    886898,
    889887,
    786777,
    787997,
    687879,
    888679,
    986868,
    998977,
    776887,
    779896,
    987789,
    887988,
    767879,
    879778,
    777988,
    797989,
    777987,
    976789,
    788778,
    998978,
    778887,
    789778,
    787696,
    788878,
    798879,
    878877,
    788987,
    868877,
    896886,
    888868,
    778978,
    867897,
    976689,
    788887,
    887888,
    987888,
    989788,
    978797,
    789777,
    788879,
    988777,
    789879,
    879787,
    897966,
    878868,
    866978,
    787777,
    799789,
    797787,
    779898,
    688797,
    697678,
    688898,
    897668,
    778698,
    899988,
    779987,
    888988,
    779797,
    787978,
    769967,
    778768,
    878987,
    787979,
    679788,
    786889,
    788787,
    866888,
    987687,
    889687,
    888897,
    788788,
    988898,
    888788,
    976789,
    789887,
    787879,
    977797,
    999977,
    888877,
    879888,
    699868,
    899787,
    987669,
    998768,
    678997,
    969887,
    878997,
    778768,
    887888,
    897768,
    889887,
    779978,
    767899,
    888787,
    997689,
    788887,
    787989,
    786868,
    677998,
    678778,
    798889,
    977868,
    877978,
    897987,
    878887,
    868878,
    978687,
    877697,
    799877,
    687787,
    799778,
    978979,
    869898,
    898897,
    796798,
    989888,
    979887,
    888877,
    969898,
    799878,
    897978,
    796868,
    877778,
    789889,
    777777,
    779978,
    877878,
    787889,
    988777,
    787869,
    988679,
    878888,
    998878,
    789778,
    879887,
    997897,
    787898,
    988766,
    676986,
    798879,
    889679,
    878777,
    876779,
    879878,
    779879,
    798888,
    878798,
    787789,
    776796,
    786879,
    897988,
    697897,
    898787,
    788878,
    796888,
    779887,
    978787,
    997988,
    887877,
    789898,
    798786,
    898968,
    799778,
    998778,
    777797,
    768867,
    978878,
    898788,
    887978,
    789788,
    878889,
    798878,
    798786,
    889679,
    888988,
    896896,
    988787,
    987798,
    877888,
    777779,
    889986,
    997886,
    977768,
    888788,
    676677,
    688799,
    987687,
    967998,
    897779,
    978877,
    887888,
    787798,
    897878,
    988779,
    788688,
    878997,
    878777,
    899877,
    778978,
    877887,
    887698,
    899889,
    897888,
    887888,
    779677,
    889896,
    688989,
    877789,
    797788,
    797986,
    778987,
    999788,
    898898,
    897887,
    877887,
    978689,
    878988,
    979897,
    976867,
    898878,
    679678,
    877978,
    998978,
    889787,
    888877,
    978788,
    876878,
    969977,
    997988,
    777778,
    889988,
    889888,
    878978,
    676877,
    768788,
    688878,
    978887,
    878788,
    777878,
    968876,
    898677,
    889889,
    978867,
    976887,
    887989,
    887877,
    869978,
    987897,
    978889,
    899897,
    797776,
    887876,
    777887,
    886888,
    889888,
    878878,
    989787,
    788978,
    889977,
    786977,
    987779,
    788886,
    787987,
    877898,
    778878,
    787898,
    888888,
    787998,
    966867,
    879697,
    699889,
    878777,
    787877,
    988987,
    977787,
    777877,
    888786,
    888987,
    996786,
    878788,
    797789,
    897796,
    788778,
    888887,
    877788,
    678998,
    697787,
    778878,
    989887,
    869988,
    886888,
    798886,
    677888,
    878877,
    776898,
    787799,
    878877,
    978987,
    877777,
    778879,
    888788,
    888987,
    998878,
    779988,
    778888,
    887766,
    877777,
    778987,
    967896,
    777887,
    877797,
    877887,
    798777,
    787778,
    779886,
    777788,
    788898,
    768867,
    697687,
    677868,
    878967,
    768988,
    897889,
    777979,
    988878,
    889778,
    887889,
    777897,
    888788,
    878869,
    789877,
    988868,
    798789,
    687787,
    877997,
    788966,
    867988,
    978876,
    968887,
    897888,
    897988,
    787988,
    887987,
    877799,
    888897,
    768888,
    887976,
    788877,
    767988,
    888887,
    899787,
    768897,
    977997,
    987787,
    978987,
    787779,
    799778,
    798797,
    878869,
    988887,
    999968,
    886879,
    888898,
    877888,
    897888,
    878889,
    788887,
    978879,
    777888,
    887787,
    798787,
    998868,
    689688,
    987788,
    766877,
    887987,
    778987,
    788778,
    988778,
    898798,
    888878,
    978888,
    987787,
    788889,
    978798,
    788687,
    777878,
    888977,
    777877,
    878877,
    778896,
    998967,
    887898,
    888877,
    796869,
    888788,
    898788,
    798787,
    797797,
    988877,
    888879,
    777997,
    899787,
    898897,
    787887,
    877988,
    768797,
    988898,
    777778,
    789788,
    878887,
    799977,
    869988,
    788777,
    886878,
    789887,
    898877,
    878678,
    887787,
    877788,
    877978,
    979976,
    978777,
    897767,
    977877,
    888977,
    888688,
    779798,
    989877,
    978777,
    789977,
    899787,
    987787,
    886878,
    987779,
    788987,
    797888,
    889979,
    896877,
    797987,
    996778,
    887989,
    888868,
    787879,
    879888,
    778887,
    976987,
    886978,
    978988,
    798777,
    888799,
    797798,
    977678,
    788878,
    987887,
    797868,
    787777,
    788777,
    767888,
    988898,
    877888,
    686769,
    997989,
    778786,
    988987,
    888876,
    878696,
    787878,
    667897,
    888878,
    779777,
    787887,
    886868,
    798978,
    687987,
    787798,
    889888,
    887878,
    888878,
    987698,
    978789,
    988977,
    877897,
    689877,
    868798,
    789978,
    788788,
    876777,
    897688,
    898887,
    896877,
    988799,
    897887,
    979778,
    797777,
    887687,
    797878,
    767766,
    876687,
    798788,
    976888,
    789986,
    898779,
    677988,
    788887,
    688987,
    897788,
    869888,
    789988,
    877777,
    888868,
    777878,
    886798,
    879899,
    979988,
    878888,
    789888,
    879778,
    779968,
    797888,
    887878,
    787888,
    778878,
    977886,
    878766,
    878987,
    679889,
    889887,
    898786,
    798888,
    798878,
    787789,
    987878,
    779888,
    777888,
    787877,
    776668,
    987899,
    888988,
    797787,
    988876,
    879878,
    897778,
    867879,
    987787,
    779777,
    798786,
    879978,
    778888,
    797697,
    887968,
    777988,
    889779,
    897879,
    677786,
    787877,
    788898,
    788888,
    769887,
    889787,
    769897,
    768888,
    887788,
    769877,
    889789,
    888877,
    888779,
    888878,
    889779,
    897987,
    877898,
    688979,
    887889,
    988787,
    899887,
    777888,
    888789,
    778798,
    887998,
    998999,
    999797,
    886887,
    687789,
    787798,
    969898,
    997878,
    888898,
    777868,
    878887,
    977978,
    799778,
    989898,
    798788,
    779797,
    996877,
    978776,
    798979,
    878797,
    977877,
    787897,
    888888,
    678887,
    789987,
    999878,
    777767,
    798778,
    889797,
    778878,
    977887,
    789998,
    787888,
    878989,
    899889,
    898897,
    789887,
    866698,
    868778,
    799978,
    777978,
    788898,
    988888,
    778777,
    678888,
    888777,
    997878,
    968996,
    897988,
    866789,
    978689,
    888786,
    768988,
    788879,
    778789,
    888987,
    878878,
    779987,
    889887,
    779778,
    888777,
    889876,
    888877,
    786778,
    879878,
    996898,
    788887,
    989778,
    887799,
    868789,
    898688,
    867787,
    997798,
    798798,
    897788,
    888988,
    878888,
    879867,
    698987,
    798889,
    776797,
    776998,
    788889,
    889788,
    888967,
    878779,
    988876,
    878987,
    786699,
    979789,
    886788,
    779778,
    879887,
    698898,
    878879,
    879888,
    788977,
    687868,
    877868,
    877788,
    699798,
    787879,
    868798,
    878969,
    687969,
    776988,
    688878,
    877789,
    878889,
    978987,
    998879,
    789897,
    789988,
    776789,
    986987,
    798777,
    998778,
    887779,
    787878,
    788887,
    887878,
    878886,
    978789,
    797887,
    788788,
    978868,
    888778,
    988988,
    877798,
    868888,
    779788,
    888897,
    887889,
    978878,
    877787,
    778777,
    898896,
    877789,
    988878,
    987898,
    797777,
    889978,
    887677,
    788787,
    887788,
    897889,
    689778,
    798787,
    998887,
    688877,
    878977,
    898877,
    878888,
    798879,
    887778,
    778988,
    888889,
    877987,
    888788,
    878669,
    786888,
    779789,
    789888,
    897989,
    688888,
    987697,
    788676,
    788788,
    879987,
    999987,
    798978,
    998677,
    987997,
    878988,
    687677,
    787897,
    777889,
    777886,
    877889,
    779797,
    788887,
    997788,
    889768,
    787898,
    798878,
    978877,
    889678,
    887988,
    789877,
    788798,
    777888,
    799879,
    878877,
    789887,
    898798,
    977888,
    888979,
    997897,
    788769,
    877987,
    787886,
    977798,
    788999,
    889788,
    787887,
    688977,
    886778,
    788878,
    898977,
    898769,
    876777,
    878887,
    888787,
    687788,
    677877,
    978876,
    678788,
    777788,
    887877,
    797787,
    866989,
    778998,
    898777,
    977698,
    878989,
    787788,
    789686,
    998888,
    978976,
    879988,
    988688,
    786777,
    898889,
    889877,
    896789,
    769879,
    898767,
    789989,
    888978,
    796768,
    789799,
    896886,
    899978,
    779977,
    987879,
    898999,
    789797,
    886888,
    879889,
    788888,
    788988,
    887987,
    877898,
    768869,
    888876,
    988779,
    677786,
    897987,
    888987,
    677788,
    886987,
    689768,
    787898,
    897798,
    878787,
    898878,
    789877,
    887789,
    788868,
    879788,
    896889,
    867688,
    898878,
    888798,
    877887,
    867888,
    986768,
    788878,
    897886,
    888879,
    779887,
    788787,
    897878,
    988797,
    888788,
    888969,
    779777,
    787979,
    877799,
    987878,
    979697,
    778776,
    886887,
    897897,
    687799,
    898787,
    789878,
    787888,
    777977,
    778986,
    787667,
    789988,
    979998,
    878899,
    886997,
    879786,
    867768,
    878877,
    979768,
    897788,
    778878,
    988897,
    797888,
    788778,
    789888,
    778897,
    778997,
    988886,
    788779,
    789889,
    969789,
    786677,
    969789,
    778787,
    797777,
    798799,
    878987,
    987688,
    867867,
    899979,
    797987,
    988989,
    768978,
    897698,
    788789,
    798777,
    899788,
    887897,
    788877,
    888888,
    989978,
    879878,
    876777,
    899878,
    888877,
    789788,
    777987,
    679688,
    786797,
    878777,
    978767,
    799778,
    877988,
    987988,
    996977,
    988998,
    788888,
    887788,
    978978,
    978678,
    988878,
    898897,
    678878,
    988767,
    878988,
    879869,
    879787,
    889777,
    797878,
    888877,
    786699,
    986977,
    799868,
    688788,
    788878,
    798898,
    689868,
    888888,
    867887,
    778768,
    888798,
    787777,
    869899,
    688689,
    889689,
    779898,
    789999,
    788877,
    888968,
    888888,
    878789,
    878889,
    886789,
    789988,
    698877,
    787889,
    889888,
    799888,
    699798,
    777788,
    979878,
    878787,
    787776,
    788878,
    977886,
    787887,
    887798,
    887797,
    987998,
    898669,
    998889,
    878998,
    797879,
    897988,
    798999,
    867877,
    767869,
    969777,
    796878,
    989877,
    978787,
    888778,
    797887,
    778679,
    877678,
    898797,
    998877,
    898767,
    777899,
    898878,
    887889,
    779877,
    987888,
    888787,
    978778,
    987886,
    787878,
    766888,
    998978,
    868778,
    897689,
    868789,
    888797,
    878988,
    898888,
    898898,
    986787,
    997697,
    768998,
    787898,
    788687,
    888877,
    978888,
    887888,
    897776,
    888888,
    878898,
    769987,
    868788,
    878887,
    798789,
    896697,
    786889,
    898989,
    778699,
    878788,
    977777,
    787877,
    897968,
    889977,
    778887,
    877978,
    997886,
    877788,
    979887,
    798898,
    878676,
    978986,
    786677,
    788677,
    888888,
    668778,
    889887,
    779898,
    878678,
    889786,
    887787,
    867778,
    877988,
    987979,
    877888,
    988887,
    889779,
    967896,
    878777,
    878889,
    998888,
    977986,
    998777,
    776998,
    798767,
    877788,
    888869,
    978889,
    987787,
    978877,
    778978,
    988787,
    777778,
    898778,
    879987,
    988679,
    778967,
    876789,
    888898,
    778788,
    788879,
    789788,
    989887,
    898998,
    778977,
    878897,
    778778,
    978878,
    988779,
    886876,
    877877,
    899869,
    888886,
    888787,
    977788,
    688789,
    777688,
    877777,
    997887,
    889797,
    776898,
    998877,
    977876,
    787787,
    988878,
    679787,
    889776,
    797989,
    788676,
    869878,
    779789,
    689888,
    879888,
    998787,
    979997,
    687789,
    687899,
    797676,
    888877,
    787898,
    689878,
    978988,
    879789,
    998768,
    799789,
    878987,
    887899,
    887788,
    788787,
    787868,
    888888,
    767987,
    879888,
    777768,
    988789,
    978877,
    869787,
    888788,
    879978,
    898878,
    877678,
    788997,
    787888,
    797798,
    786887,
    879888,
    877768,
    878878,
    798797,
    788977,
    989788,
    988989,
    679878,
    776878,
    896877,
    876879,
    878878,
    967889,
    889986,
    788787,
    899987,
    778788,
    698888,
    896887,
    898798,
    789779,
    887799,
    778888,
    777887,
    787897,
    997878,
    897878,
    889877,
    988678,
    977978,
    689977,
    786778,
    889978,
    788987,
    688787,
    787888,
    798998,
    898697,
    887988,
    798689,
    878777,
    779978,
    788789,
    897988,
    787987,
    688898,
    878787,
    887979,
    898689,
    868787,
    877987,
    978886,
    877989,
    998788,
    998787,
    788879,
    978788,
    887886,
    678787,
    799987,
    999888,
    878979,
    879779,
    867868,
    797988,
    897988,
    777687,
    899878,
    897686,
    998977,
    887887,
    778788,
    677898,
    798768,
    879878,
    889978,
    788987,
    889679,
    889888,
    967888,
    988888,
    786787,
    888877,
    978867,
    889898,
    988888,
    988888,
    869887,
    779788,
    889987,
    986979,
    878887,
    977888,
    788887,
    988888,
    787788,
    889788,
    679688,
    888799,
    888889,
    887778,
    877697,
    886687,
    898997,
    898888,
    779989,
    889788,
    978797,
    877788,
    989878,
    898679,
    788978,
    778888,
    888697,
    877777,
    879768,
    777877,
    888998,
    878678,
    779987,
    886899,
    978878,
    968998,
    989787,
    777977,
    788889,
    799888,
    787878,
    879888,
    887889,
    688998,
    878878,
    768786,
    698876,
    887977,
    877778,
    778888,
    888698,
    798777,
    878786,
    767787,
    879878,
    867778,
    887977,
    779779,
    999978,
    977788,
    687787,
    787988,
    897976,
    886898,
    989878,
    797989,
    887777,
    888978,
    777877,
    788978,
    988988,
    799788,
    797766,
    867778,
    877877,
    769887,
    978879,
    888897,
    778789,
    887888,
    799897,
    778888,
    878897,
    888988,
    988897,
    799877,
    898998,
    787888,
    887776,
    887886,
    778798,
    988878,
    778888,
    787789,
    787998,
    887977,
    789888,
    889898,
    786789,
    887986,
    898989,
    779878,
    788998,
    887877,
    888787,
    897789,
    688887,
    788799,
    899887,
    998887,
    999987,
    878898,
    689887,
    788887,
    886878,
    689878,
    898779,
    776688,
    788897,
    798777,
    677987,
    797788,
    889977,
    989997,
    788897,
    998988,
    787786,
    878787,
    978878,
    999787,
    769887,
    877987,
    897887,
    996878,
    878788,
    899789,
    888887,
    886889,
    876879,
    889867,
    879898,
    788899,
    987879,
    777888,
    898889,
    897778,
    887877,
    898886,
    887887,
    877797,
    687897,
    788977,
    889987,
    788898,
    677767,
    988878,
    878788,
    686889,
    787887,
    787776,
    978788,
    868797,
    887877,
    788789,
    896788,
    977878,
    688789,
    886797,
    889978,
    897978,
    679687,
    878998,
    878789,
    888899,
    888787,
    787788,
    786898,
    897889,
    888877,
    898879,
    799888,
    997898,
    896689,
    887899,
    878888,
    898886,
    878997,
    778878,
    787878,
    878888,
    798989,
    878878,
    788777,
    979887,
    999787,
    877888,
    798778,
    669686,
    879977,
    788878,
    868876,
    766899,
    697777,
    878887,
    677979,
    977799,
    868678,
    767888,
    888697,
    988889,
    868987,
    888789,
    898986,
    776888,
    987878,
    969678,
    787778,
    689778,
    786888,
    776978,
    979889,
    699779,
    997899,
    898878,
    887796,
    769777,
    788888,
    877887,
    899778,
    877888,
    999877,
    787687,
    878789,
    787898,
    878789,
    788878,
    868988,
    778788,
    887788,
    876988,
    896878,
    778689,
    799789,
    879887,
    898888,
    777787,
    777789,
    897989,
    887799,
    879898,
    888987,
    887787,
    789887,
    789797,
    977998,
    878877,
    967986,
    777787,
    888798,
    787898,
    997877,
    787878,
    778878,
    789798,
    788668,
    878877,
    999798,
    888878,
    989679,
    887877,
    887797,
    799778,
    988899,
    777786,
    777988,
    787997,
    778878,
    987887,
    878889,
    999778,
    788898,
    889878,
    887999,
    886668,
    779877,
    767778,
    897888,
    797997,
    788987,
    898778,
    889988,
    977779,
    777779,
    898977,
    778886,
    877887,
    887897,
    888979,
    777778,
    899886,
    788798,
    877877,
    888887,
    879878,
    888889,
    887768,
    877887,
    779787,
    787787,
    789989,
    988877,
    787796,
    886977,
    968879,
    987779,
    868778,
    889877,
    986967,
    887788,
    877977,
    978979,
    898899,
    787867,
    899887,
    887788,
    687687,
    987878,
    986979,
    887788,
    878888,
    966889,
    987899,
    876977,
    998767,
    779788,
    888988,
    787798,
    978687,
    887889,
    778988,
    879778,
    867879,
    789877,
    987897,
    888888,
    788798,
    989787,
    788998,
    777988,
    777789,
    987877,
    888679,
    779889,
    777998,
    769878,
    786998,
    887887,
    877678,
    888889,
    886878,
    778887,
    688789,
    887898,
    787979,
    797797,
    798889,
    988889,
    887767,
    778987,
    777678,
    986897,
    679887,
    888888,
    778988,
    898798,
    887777,
    879889,
    876888,
    879877,
    888889,
    877876,
    788878,
    899878,
    978889,
    997997,
    997977,
    767988,
    888878,
    788767,
    877789,
    889877,
    898777,
    888687,
    887888,
    788786,
    878999,
    878988,
    897879,
    897877,
    886886,
    988787,
    776889,
    779888,
    789897,
    878868,
    787887,
    888988,
    799978,
    687767,
    788897,
    877868,
    886797,
    888899,
    798888,
    978788,
    897779,
    768889,
    787888,
    687988,
    979887,
    797786,
    787887,
    997878,
    987988,
    787977,
    987779,
    878797,
    799878,
    879887,
    789878,
    787888,
    788878,
    978777,
    977887,
    799887,
    698786,
    777878,
    888888,
    789778,
    977869,
    787768,
    987789,
    688777,
    897786,
    897789,
    777878,
    777888,
    787877,
    687778,
    697978,
    986898,
    788977,
    997969,
    888787,
    768986,
    889888,
    778987,
    778888,
    878877,
    898988,
    897876,
    788877,
    777888,
    788789,
    768798,
    889898,
    877887,
    769789,
    887898,
    987998,
    788899,
    879888,
    888877,
    987799,
    887888,
    977989,
    887878,
    767788,
    988778,
    778879,
    889799,
    788879,
    789789,
    777978,
    886787,
    787888,
    889899,
    777888,
    987788,
    997878,
    887888,
    866897,
    678989,
    878977,
    888987,
    888888,
    886789,
    789798,
    797788,
    778888,
    789888,
    787987,
    779787,
    877887,
    889777,
    779987,
    997886,
    887898,
    779788,
    998799,
    789797,
    797898,
    787899,
    788669,
    797889,
    888978,
    887889,
    889888,
    799886,
    788877,
    787888,
    868887,
    988787,
    689789,
    986787,
    886888,
    998889,
    867977,
    897699,
    879986,
    678888,
    888777,
    678887,
    798898,
    997797,
    878999,
    978978,
    977877,
    788996,
    877777,
    887968,
    898797,
    969777,
    888879,
    898978,
    878769,
    788776,
    788987,
    889978,
    887998,
    878887,
    778798,
    777867,
    787789,
    888699,
    977788,
    788897,
    778787,
    787776,
    789788,
    998977,
    868787,
    787889,
    978877,
    789869,
    978998,
    897988,
    797786,
    888868,
    998977,
    899789,
    798778,
    878999,
    877878,
    777987,
    987979,
    889878,
    898996,
    887978,
    789677,
    888977,
    678787,
    877797,
    876888,
    787887,
    799878,
    767997,
    878887,
    777876,
    978988,
    986888,
    787987,
    797697,
    888988,
    789889,
    878878,
    797788,
    878768,
    997679,
    788878,
    877977,
    788867,
    779878,
    698787,
    888798,
    697977,
    887878,
    797787,
    688887,
    889878,
    779778,
    689789,
    788789,
    778888,
    789797,
    888877,
    679889,
    878888,
    878678,
    899898,
    878897,
    688679,
    888788,
    876997,
    878897,
    888888,
    779998,
    698988,
    777889,
    767889,
    989788,
    789777,
    987789,
    789899,
    799976,
    987889,
    888988,
    989987,
    977797,
    878868,
    788688,
    887788,
    887688,
    977786,
    888789,
    888698,
    988779,
    788787,
    797998,
    787798,
    796789,
    788787,
    778778,
    878878,
    687988,
    978888,
    778988,
    997697,
    778886,
    678668,
    887887,
    989867,
    998877,
    888797,
    889876,
    878987,
    788788,
    678998,
    888767,
    777987,
    999988,
    798778,
    877978,
    798899,
    868878,
    888878,
    797978,
    978897,
    877788,
    798788,
    697966,
    688688,
    788899,
    786678,
    877878,
    878787,
    867888,
    888898,
    786997,
    866898,
    779797,
    877888,
    777778,
    788879,
    767988,
    996878,
    889767,
    778698,
    889778,
    977878,
    877889,
    888799,
    799888,
    988899,
    789886,
    889778,
    787869,
    868898,
    789877,
    789788,
    798977,
    778878,
    788797,
    888987,
    897887,
    978998,
    777698,
    887877,
    789898,
    787897,
    898898,
    968778,
    787777,
    879798,
    899879,
    797988,
    879787,
    897999,
    698769,
    987787,
    888979,
    878787,
    888877,
    989898,
    789888,
    897887,
    999778,
    797796,
    877899,
    879877,
    987987,
    997898,
    897888,
    788899,
    778788,
    877997,
    887887,
    898968,
    879877,
    886986,
    788876,
    888878,
    789868,
    778898,
    897887,
    899987,
    888877,
    777889,
    998888,
    768777,
    978788,
    978869,
    977788,
    988767,
    889886,
    989888,
    787797,
    877778,
    786867,
    978998,
    897889,
    879776,
    898878,
    888888,
    799897,
    899788,
    798887,
    877979,
    788887,
    799798,
    988987,
    876678,
    888787,
    879788,
    787886,
    688987,
    887998,
    786978,
    888888,
    798778,
    778978,
    968787,
    787879,
    778798,
    796977,
    987886,
    777889,
    888788,
    788977,
    868878,
    877988,
    887779,
    868877,
    977978,
    879888,
    778797,
    778869,
    778788,
    978978,
    896788,
    877889,
    878678,
    789897,
    898886,
    976787,
    887767,
    998788,
    688887,
    789888,
    788767,
    897977,
    899667,
    896867,
    688978,
    788987,
    978898,
    888689,
    787989,
    988778,
    879779,
    888887,
    787888,
    878788,
    879898,
    797887,
    887888,
    989888,
    788798,
    688778,
    787687,
    787887,
    989778,
    787779,
    887788,
    788886,
    789888,
    888976,
    678987,
    898998,
    897699,
    876897,
    886688,
    887887,
    898976,
    978787,
    997678,
    889978,
    788897,
    978778,
    789698,
    877898,
    888798,
    897678,
    897788,
    888878,
    896878,
    888878,
    979896,
    889877,
    799889,
    789898,
    888767,
    889878,
    777897,
    798789,
    988989,
    889789,
    877889,
    867888,
    878889,
    898788,
    877878,
    797688,
    788778,
    988879,
    779777,
    788678,
    887878,
    887998,
    887778,
    988797,
    678978,
    777789,
    786999,
    789998,
    988998,
    877997,
    888967,
    987797,
    788988,
    778977,
    778778,
    989797,
    997877,
    699788,
    797878,
    988978,
    878898,
    887889,
    878878,
    798998,
    876787,
    786679,
    997796,
    889777,
    678688,
    869887,
    788888,
    877999,
    998788,
    779997,
    987888,
    978989,
    977778,
    877977,
    978899,
    968888,
    877787,
    878688,
    778969,
    888677,
    798879,
    778898,
    789777,
    679968,
    777987,
    788768,
    888879,
    887987,
    877868,
    889888,
    788877,
    879998,
    988797,
    768878,
    888978,
    776998,
    898888,
    787888,
    889889,
    889777,
    988799,
    897997,
    897788,
    987899,
    899988,
    968988,
    888899,
    998879,
    878876,
    978968,
    898878,
    879796,
    788978,
    777879,
    778987,
    787979,
    789997,
    878879,
    879898,
    889879,
    898887,
    889987,
    877888,
    888979,
    778797,
    779978,
    898788,
    687897,
    788888,
    978877,
    787778,
    668777,
    879988,
    987898,
    799979,
    867888,
    878787,
    779877,
    777877,
    887888,
    888689,
    788897,
    768787,
    867899,
    776797,
    987778,
    879879,
    988887,
    888888,
    888678,
    988987,
    889787,
    779789,
    786978,
    879986,
    978988,
    886777,
    798789,
    777996,
    878787,
    988688,
    688988,
    888889,
    888966,
    689868,
    798898,
    788888,
    788678,
    778878,
    867887,
    788888,
    888887,
    969877,
    789866,
    967986,
    898788,
    689669,
    999687,
    779889,
    788688,
    998888,
    998878,
    787888,
    989788,
    998878,
    686869,
    887889,
    867788,
    889977,
    979888,
    787898,
    788789,
    777788,
    889898,
    887888,
    689897,
    977888,
    778898,
    778887,
    879887,
    898977,
    797887,
    987778,
    789777,
    989788,
    778687,
    976798,
    777887,
    979896,
    898888,
    877889,
    878798,
    788888,
    987697,
    998879,
    887889,
    768678,
    897999,
    778987,
    978888,
    898777,
    788879,
    898788,
    799898,
    789978,
    968989,
    768967,
    788998,
    876878,
    788977,
    887887,
    798877,
    987789,
    787986,
    889679,
    879997,
    887677,
    879886,
    778787,
    788889,
    987888,
    888788,
    799988,
    888888,
    778889,
    878789,
    777777,
    987777,
    888867,
    788889,
    787688,
    978878,
    999877,
    788887,
    878897,
    798887,
    988789,
    767989,
    777978,
    877787,
    886978,
    797896,
    798867,
    887789,
    878898,
    778788,
    779878,
    887986,
    799887,
    789778,
    787777,
    778696,
    798887,
    799897,
    787898,
    679988,
    879798,
    887899,
    788999,
    787787,
    689898,
    899887,
    798897,
    678978,
    988887,
    878799,
    879887,
    888678,
    678879,
    887777,
    887887,
    789788,
    888788,
    797777,
    788899,
    877889,
    987789,
    798888,
    899897,
    798887,
    877776,
    897979,
    777988,
    877888,
    878967,
    879878,
    889776,
    779889,
    889988,
    777888,
    888888,
    888898,
    888778,
    767866,
    879768,
    898768,
    867777,
    867787,
    787869,
    887977,
    787889,
    788678,
    769878,
    789877,
    888978,
    879979,
    879868,
    868787,
    887679,
    897968,
    989987,
    779999,
    889878,
    887887,
    899977,
    787888,
    998777,
    978998,
    777778,
    989789,
    878878,
    687777,
    787998,
    886988,
    987869,
    799789,
    799868,
    887896,
    789889,
    987978,
    878898,
    888978,
    886899,
    978987,
    867987,
    888866,
    997798,
    897887,
    868878,
    776897,
    877789,
    777767,
    877888,
    889768,
    899888,
    677878,
    787877,
    997787,
    678988,
    898879,
    878777,
    987876,
    897767,
    978978,
    978778,
    878778,
    978789,
    998768,
    868898,
    688788,
    877887,
    988778,
    788878,
    798887,
    778778,
    778888,
    798879,
    877977,
    798887,
    787898,
    767788,
    677979,
    887878,
    888777,
    789787,
    977887,
    888779,
    777996,
    777899,
    779789,
    879977,
    878979,
    877888,
    997878,
    987798,
    898878,
    777678,
    887897,
    778988,
    988778,
    888777,
    798988,
    787889,
    877778,
    898788,
    767989,
    898777,
    788698,
    779896,
    879997,
    899878,
    989766,
    779888,
    888878,
    679988,
    687788,
    779998,
    797868,
    888788,
    798968,
    877979,
    786797,
    887888,
    988788,
    888698,
    687987,
    998769,
    898798,
    888888,
    887777,
    689698,
    787988,
    987867,
    877788,
    899877,
    877889,
    767897,
    797797,
    887987,
    879778,
    788897,
    987787,
    687798,
    678877,
    779888,
    989796,
    987697,
    879888,
    969788,
    878887,
    878889,
    888889,
    888797,
    867699,
    788777,
    779878,
    899898,
    867768,
    977887,
    888777,
    978889,
    876898,
    898777,
    987798,
    787988,
    778797,
    999788,
    768789,
    798879,
    877699,
    796789,
    777887,
    988979,
    787777,
    988888,
    776898,
    777788,
    999977,
    886978,
    877977,
    966688,
    767988,
    979867,
    787878,
    998987,
    897987,
    887676,
    877986,
    987878,
    887898,
    789886,
    897889,
    898899,
    978987,
    786989,
    987799,
    688687,
    876987,
    998977,
    978978,
    777986,
    886788,
    869989,
    889799,
    977889,
    879897,
    789878,
    887789,
    968878,
    778898,
    779986,
    896997,
    897797,
    778897,
    979679,
    868699,
    868868,
    788869,
    889787,
    798777,
    798888,
    777988,
    879888,
    897888,
    776788,
    878898,
    977868,
    797777,
    777867,
    997669,
    888797,
    788778,
    777787,
    987878,
    998788,
    788788,
    787899,
    888778,
    988798,
    878878,
    889998,
    898869,
    888866,
    787887,
    987878,
    789889,
    897887,
    689888,
    988778,
    877988,
    987887,
    787887,
    787897,
    787878,
    988787,
    877799,
    989787,
    879887,
    669887,
    899679,
    888998,
    877876,
    878678,
    978888,
    878799,
    778777,
    976887,
    797897,
    777897,
    976879,
    789888,
    787887,
    978987,
    889777,
    888877,
    677977,
    898887,
    887879,
    878966,
    778787,
    887976,
    889989,
    998877,
    978798,
    998787,
    776887,
    988798,
    879889,
    886887,
    898878,
    768889,
    898868,
    976888,
    889996,
    897787,
    878799,
    878889,
    879888,
    788988,
    798789,
    998898,
    978877,
    879989,
    888797,
    977777,
    998677,
    879978,
    799888,
    777898,
    868789,
    788987,
    879898,
    897788,
    788888,
    787789,
    889878,
    788888,
    888989,
    888898,
    798887,
    788796,
    878888,
    986697,
    889887,
    966898,
    697877,
    887778,
    878878,
    887877,
    867788,
    778778,
    999887,
    987988,
    876779,
    978878,
    786787,
    867998,
    787888,
    887878,
    798898,
    788778,
    889777,
    898787,
    889876,
    988788,
    877987,
    888797,
    789987,
    687888,
    778786,
    888878,
    789988,
    897987,
    778788,
    877887,
    878898,
    777787,
    877897,
    877878,
    878766,
    878879,
    788877,
    888767,
    898798,
    877987,
    877877,
    877888,
    798678,
    987689,
    887778,
    988687,
    987768,
    889897,
    799787,
    789787,
    788997,
    887798,
    787787,
    777778,
    898776,
    988898,
    879888,
    987978,
    887787,
    988778,
    778878,
    886889,
    689898,
    789987,
    778877,
    788877,
    787878,
    888888,
    877998,
    878996,
    787786,
    988777,
    897887,
    976898,
    797999,
    787879,
    898776,
    789878,
    888978,
    778798,
    778888,
    878888,
    779878,
    788898,
    979878,
    888879,
    877789,
    887888,
    888778,
    767889,
    779888,
    877786,
    877888,
    889888,
    689986,
    789897,
    899779,
    977679,
    878887,
    867789,
    777877,
    889799,
    987887,
    798877,
    787887,
    888779,
    898988,
    689989,
    888888,
    877779,
    788978,
    898689,
    789787,
    898867,
    888677,
    787977,
    877798,
    777986,
    678698,
    887898,
    888677,
    977878,
    898778,
    888878,
    788688,
    877869,
    798777,
    899888,
    977767,
    977788,
    797779,
    979888,
    776888,
    988788,
    998878,
    978988,
    787979,
    797978,
    786877,
    878789,
    977898,
    887789,
    879978,
    677799,
    888887,
    877867,
    887877,
    788877,
    789788,
    787879,
    789887,
    878989,
    777787,
    998987,
    886989,
    877888,
    887888,
    887798,
    798878,
    988869,
    869877,
    789877,
    789878,
    787798,
    788899,
    987798,
    987888,
    698789,
    699998,
    798897,
    788878,
    978879,
    888897,
    788878,
    897887,
    979997,
    779798,
    888777,
    978789,
    788878,
    877777,
    678879,
    879678,
    977798,
    778987,
    999889,
    878788,
    879768,
    667778,
    688979,
    788987,
    988977,
    788987,
    888978,
    888778,
    878888,
    988876,
    799888,
    788687,
    878779,
    898689,
    779799,
    878986,
    779988,
    997678,
    688887,
    986789,
    997798,
    888888,
    878887,
    788688,
    676879,
    997779,
    888778,
    867898,
    979787,
    788878,
    997877,
    677896,
    887888,
    898878,
    998788,
    889878,
    787977,
    987877,
    889788,
    699889,
    988977,
    899898,
    878788,
    888978,
    788877,
    988777,
    878878,
    786889,
    777887,
    778787,
    787988,
    898787,
    777878,
    889789,
    787898,
    878768,
    978787,
    987799,
    777897,
    989998,
    987767,
    778797,
    877987,
    888998,
    689799,
    799778,
    868898,
    898889,
    789968,
    877788,
    878777,
    878769,
    898889,
    896998,
    887967,
    886686,
    799887,
    787887,
    788887,
    876879,
    898887,
    788879,
    999878,
    967879,
    778886,
    788799,
    789778,
    779899,
    787897,
    887988,
    986878,
    879678,
    778987,
    668787,
    876768,
    988767,
    869898,
    998996,
    787978,
    888796,
    887798,
    678779,
    788787,
    778688,
    897898,
    789788,
    888686,
    968799,
    896787,
    877778,
    877866,
    786878,
    676877,
    899898,
    796777,
    878889,
    787696,
    887779,
    877896,
    887878,
    787867,
    877679,
    878889,
    878868,
    988969,
    777888,
    787988,
    886888,
    777878,
    977887,
    786797,
    887888,
    898889,
    787688,
    798877,
    969777,
    768787,
    788987,
    979888,
    899987,
    788788,
    999887,
    887999,
    878886,
    887878,
    998798,
    686868,
    787779,
    889798,
    989798,
    788888,
    899889,
    978987,
    977877,
    987997,
    888997,
    988987,
    888877,
    777889,
    898987,
    788987,
    888878,
    878888,
    987876,
    979898,
    787769,
    787787,
    977686,
    798666,
    867788,
    896677,
    779797,
    887779,
    788887,
    898887,
    788799,
    886987,
    888798,
    898797,
    898777,
    787987,
    977889,
    769788,
    887877,
    788987,
    778677,
    777788,
    898799,
    878789,
    997878,
    999888,
    897779,
    777898,
    978778,
    779888,
    877796,
    768778,
    798877,
    789969,
    788867,
    789877,
    789868,
    768878,
    887887,
    877888,
    888988,
    778877,
    787988,
    687987,
    868898,
    887896,
    897789,
    978787,
    968889,
    988778,
    898887,
    787889,
    899989,
    888899,
    898876,
    778877,
    777778,
    777876,
    789887,
    778878,
    989878,
    677788,
    879977,
    878779,
    889998,
    886788,
    788887,
    777878,
    888789,
    887787,
    877879,
    679887,
    788799,
    889998,
    697798,
    978888,
    887887,
    988888,
    777897,
    878877,
    878898,
    966788,
    687879,
    777799,
    787998,
    878978,
    887677,
    778788,
    797878,
    799877,
    779798,
    888789,
    776779,
    997986,
    789987,
    899976,
    777978,
    876779,
    887879,
    777878,
    688868,
    797977,
    787978,
    997777,
    798889,
    987898,
    868799,
    778997,
    878789,
    777978,
    869779,
    897868,
    877769,
    888887,
    887898,
    968887,
    968798,
    777968,
    897888,
    879876,
    777897,
    887878,
    787878,
    889988,
    789898,
    678766,
    779778,
    788997,
    799987,
    988789,
    786788,
    798886,
    798798,
    889897,
    977887,
    987897,
    888888,
    778887,
    877777,
    778898,
    678788,
    888797,
    877876,
    798779,
    779988,
    988878,
    877788,
    887687,
    777898,
    876887,
    677876,
    889898,
    689876,
    678888,
    887778,
    687887,
    788677,
    887978,
    879669,
    778767,
    798879,
    878678,
    878688,
    877798,
    867777,
    887887,
    887787,
    888988,
    788787,
    677797,
    788777,
    778889,
    887776,
    768689,
    868767,
    987988,
    778887,
    898977,
    878898,
    878796,
    767669,
    788799,
    789978,
    698789,
    889898,
    776789,
    798987,
    878898,
    978887,
    887877,
    777978,
    879788,
    876798,
    888798,
    889888,
    997877,
    888877,
    787897,
    877888,
    987878,
    886888,
    877886,
    967878,
    678986,
    878898,
    878978,
    778889,
    887988,
    778997,
    878989,
    697687,
    778968,
    699787,
    887989,
    778987,
    887898,
    897869,
    787997,
    898987,
    889989,
    988878,
    888888,
    899787,
    798988,
    888796,
    798878,
    687888,
    887889,
    778897,
    887769,
    899887,
    898778,
    986878,
    788788,
    688999,
    787779,
    779788,
    887888,
    798877,
    766677,
    796778,
    967888,
    668789,
    887789,
    987678,
    898767,
    899897,
    787979,
    798989,
    976888,
    787898,
    798878,
    878988,
    778988,
    777868,
    889888,
    687789,
    876878,
    697777,
    888799,
    876887,
    787787,
    897786,
    987889,
    778897,
    789789,
    898797,
    788886,
    788998,
    778788,
    688688,
    788997,
    797878,
    887688,
    989789,
    977797,
    868976,
    689989,
    967688,
    878878,
    887887,
    788877,
    778778,
    877777,
    888976,
    976898,
    798887,
    898776,
    668697,
    786888,
    787897,
    898798,
    897888,
    787977,
    888898,
    888889,
    887987,
    777898,
    776889,
    898767,
    868888,
    788989,
    987777,
    889998,
    877887,
    968888,
    886698,
    877888,
    787988,
    878876,
    898888,
    878898,
    879896,
    787888,
    887797,
    777897,
    887898,
    769776,
    967867,
    896789,
    878789,
    789989,
    888987,
    868877,
    877777,
    887798,
    788877,
    978987,
    978677,
    786789,
    788997,
    978887,
    777786,
    797879,
    888778,
    897868,
    887888,
    867878,
    878977,
    979798,
    888689,
    897697,
    987798,
    787877,
    887888,
    888678,
    876887,
    877889,
    887787,
    896899,
    889898,
    999788,
    987688,
    988979,
    779989,
    887778,
    798877,
    887976,
    777888,
    877689,
    899889,
    888778,
    876896,
    868877,
    979878,
    798867,
    898989,
    878888,
    889776,
    898877,
    788878,
    777987,
    788877,
    797888,
    978767,
    777768,
    879886,
    877888,
    878788,
    797868,
    788788,
    988687,
    777687,
    889777,
    687887,
    997888,
    777688,
    896877,
    899987,
    876886,
    787768,
    879878,
    899986,
    768888,
    877889,
    886978,
    877788,
    887786,
    887888,
    877878,
    887878,
    878878,
    979989,
    867988,
    776878,
    777887,
    779898,
    969987,
    798887,
    978888,
    889986,
    786769,
    788878,
    898886,
    788678,
    787788,
    798776,
    878788,
    889876,
    878988,
    797986,
    897999,
    987777,
    868987,
    877797,
    798877,
    898769,
    867797,
    778896,
    978787,
    878888,
    988888,
    778687,
    876798,
    798888,
    879789,
    768988,
    877877,
    888887,
    877888,
    877887,
    988888,
    787876,
    787779,
    867868,
    679778,
    779978,
    779788,
    898889,
    889689,
    888889,
    799886,
    879879,
    987879,
    788799,
    897989,
    879887,
    998886,
    887896,
    878868,
    879799,
    977889,
    787788,
    778988,
    987887,
    887787,
    678977,
    977989,
    787777,
    977887,
    997997,
    898887,
    788698,
    788787,
    777898,
    987778,
    778889,
    788796,
    797897,
    799879,
    977778,
    888987,
    776769,
    989697,
    789798,
    788889,
    687877,
    678788,
    867977,
    887887,
    897897,
    888978,
    987787,
    787987,
    678788,
    978987,
    988887,
    888787,
    988878,
    997787,
    967988,
    778887,
    879978,
    787789,
    888779,
    897688,
    798878,
    778897,
    799888,
    799878,
    887778,
    788888,
    988887,
    788977,
    978899,
    878889,
    879777,
    877888,
    877976,
    877679,
    877898,
    889678,
    897868,
    778778,
    799776,
    777878,
    998787,
    889978,
    988889,
    889888,
    878879,
    887767,
    989886,
    788988,
    788778,
    878888,
    878898,
    786888,
    867877,
    988788,
    787887,
    888888,
    878778,
    777878,
    968997,
    788878,
    887879,
    898778,
    978878,
    878989,
    888889,
    788887,
    788877,
    698897,
    776887,
    877889,
    688788,
    867797,
    987977,
    777979,
    778897,
    789789,
    878778,
    898897,
    786888,
    789777,
    797797,
    887789,
    888968,
    678778,
    887888,
    788878,
    899988,
    897879,
    866878,
    888888,
    978778,
    767878,
    786797,
    788889,
    777787,
    776877,
    776778,
    887888,
    797978,
    877789,
    787788,
    787789,
    789887,
    877888,
    899789,
    889888,
    889689,
    887979,
    987987,
    878866,
    787797,
    977679,
    777898,
    777798,
    788778,
    888897,
    789867,
    777889,
    787876,
    868877,
    887878,
    877887,
    889788,
    887689,
    876988,
    878897,
    988888,
    777897,
    988888,
    868987,
    788887,
    887878,
    988889,
    876777,
    888888,
    987979,
    777686,
    978887,
    779889,
    979888,
    979887,
    978987,
    879887,
    677788,
    888979,
    896779,
    788887,
    778689,
    897977,
    887997,
    887787,
    898988,
    988777,
    778878,
    888886,
    887779,
    878889,
    898778,
    886777,
    789778,
    879987,
    897998,
    978988,
    978788,
    797887,
    877888,
    977887,
    977787,
    787877,
    788788,
    899777,
    787888,
    677789,
    998679,
    887797,
    897889,
    786798,
    778898,
    788788,
    769887,
    789877,
    789887,
    988988,
    988777,
    879779,
    779788,
    889778,
    986977,
    786998,
    879788,
    787787,
    888888,
    779789,
    888978,
    877897,
    987897,
    769677,
    888897,
    878989,
    889779,
    789999,
    888888,
    987879,
    788789,
    889777,
    887889,
    888988,
    889897,
    987889,
    888778,
    787778,
    777877,
    878977,
    778878,
    788798,
    888986,
    897678,
    779787,
    787778,
    787788,
    887888,
    778787,
    886898,
    878788,
    977897,
    778888,
    878877,
    888797,
    889777,
    996897,
    879888,
    878799,
    797866,
    878988,
    888878,
    789877,
    888887,
    887787,
    887786,
    888877,
    888978,
    887787,
    779798,
    777967,
    897886,
    877787,
    789777,
    879787,
    878868,
    987976,
    787869,
    888876,
    896797,
    887888,
    669887,
    997679,
    798778,
    998887,
    778876,
    977679,
    888977,
    787798,
    787897,
    988877,
    687779,
    999678,
    878989,
    898888,
    898799,
    789978,
    887889,
    797878,
    977888,
    777998,
    888678,
    879978,
    779987,
    877799,
    799697,
    898778,
    998699,
    878777,
    978878,
    886887,
    887888,
    788788,
    897986,
    797778,
    998778,
    998889,
    787788,
    887787,
    778798,
    798778,
    988867,
    889777,
    888988,
    779797,
    887899,
    677867,
    878787,
    778978,
    987788,
    889878,
    777988,
    888877,
    799888,
    868999,
    988888,
    777889,
    787799,
    887877,
    778867,
    977969,
    897898,
    786887,
    979798,
    788887,
    888798,
    887878,
    789867,
    797878,
    888978,
    889879,
    886998,
    877788,
    988879,
    997788,
    987797,
    787888,
    786998,
    888797,
    778768,
    979797,
    778887,
    876986,
    777987,
    877788,
    688898,
    998899,
    788787,
    777889,
    988867,
    987997,
    888988,
    878878,
    877887,
    986899,
    897788,
    978699,
    886779,
    787888,
    898898,
    987788,
    677688,
    898788,
    677978,
    788897,
    879768,
    788798,
    988987,
    667897,
    878797,
    997898,
    888969,
    978889,
    887998,
    779867,
    898899,
    798887,
    789797,
    898878,
    768978,
    988888,
    689788,
    877898,
    976778,
    988976,
    798777,
    797697,
    798888,
    689799,
    876776,
    889789,
    778898,
    888787,
    778898,
    687878,
    778676,
    798688,
    788787,
    987679,
    978877,
    788778,
    797787,
    787888,
    888787,
    988876,
    889878,
    897888,
    688988,
    767888,
    867977,
    988887,
    978898,
    978888,
    988888,
    879879,
    898797,
    967888,
    777688,
    777897,
    798877,
    877788,
    778778,
    998798,
    687889,
    689986,
    877768,
    888988,
    767977,
    778967,
    788888,
    878897,
    998888,
    878878,
    767887,
    699978,
    977688,
    878898,
    777888,
    887887,
    986888,
    888897,
    798988,
    678878,
    768868,
    788787,
    767886,
    788986,
    777979,
    778679,
    788779,
    778798,
    987888,
    786788,
    789988,
    677977,
    679887,
    988868,
    779997,
    889878,
    977778,
    979879,
    768967,
    788887,
    767979,
    678787,
    877799,
    789889,
    997788,
    688799,
    789988,
    768896,
    998698,
    797878,
    698788,
    779878,
    878978,
    978986,
    878799,
    788878,
    978677,
    978788,
    798878,
    878887,
    987798,
    888688,
    797886,
    797678,
    778997,
    677877,
    889789,
    877998,
    867899,
    898888,
    788889,
    798887,
    898878,
    977879,
    897887,
    878779,
    987977,
    886888,
    788979,
    997777,
    688888,
    988679,
    888687,
    799878,
    788878,
    778887,
    788989,
    878898,
    899877,
    789878,
    999889,
    898778,
    898887,
    887878,
    987988,
    697889,
    888887,
    769788,
    888979,
    878889,
    877877,
    798889,
    888797,
    797777,
    886869,
    897879,
    767679,
    888987,
    789678,
    888767,
    798878,
    788976,
    887788,
    797887,
    786878,
    669788,
    889878,
    689688,
    777978,
    788888,
    688878,
    676777,
    878797,
    697787,
    889787,
    798977,
    887889,
    767979,
    677979,
    987887,
    987997,
    887787,
    877777,
    777889,
    898888,
    897777,
    989778,
    867888,
    878889,
    878789,
    786798,
    766699,
    687878,
    898797,
    977978,
    888987,
    877768,
    788888,
    896986,
    978778,
    788876,
    787779,
    898976,
    886798,
    969987,
    898777,
    678878,
    988788,
    969878,
    998789,
    988998,
    897887,
    988998,
    676789,
    777768,
    789988,
    687877,
    677888,
    888887,
    868779,
    766778,
    976788,
    878888,
    787898,
    887777,
    676887,
    788889,
    887879,
    886876,
    978897,
    887689,
    787898,
    777789,
    986898,
    888888,
    769999,
    797788,
    877887,
    788797,
    687777,
    778987,
    877688,
    777999,
    987999,
    697887,
    688979,
    977998,
    777878,
    898878,
    778898,
    879878,
    897876,
    877787,
    968777,
    768777,
    887766,
    878778,
    788787,
    878778,
    897977,
    787988,
    889798,
    878798,
    978688,
    998699,
    878996,
    898898,
    789887,
    877868,
    777986,
    978698,
    876779,
    887789,
    889897,
    698877,
    776778,
    868889,
    768778,
    997897,
    799787,
    779988,
    888787,
    878888,
    899988,
    977897,
    779799,
    878898,
    778878,
    688779,
    879789,
    989787,
    988787,
    878778,
    987777,
    898777,
    778778,
    986899,
    898878,
    977877,
    889978,
    888888,
    887788,
    688878,
    777778,
    787778,
    888777,
    679799,
    878777,
    978776,
    778988,
    778797,
    878869,
    788989,
    989889,
    897797,
    769896,
    766877,
    798977,
    777887,
    878677,
    779889,
    778877,
    786898,
    887999,
    987777,
    897889,
    888889,
    879877,
    997787,
    878978,
    989996,
    898777,
    888888,
    789788,
    889797,
    876789,
    997989,
    879889,
    798766,
    778786,
    778788,
    788788,
    976778,
    787769,
    888898,
    987999,
    878789,
    777788,
    788788,
    878778,
    788887,
    877789,
    876877,
    969968,
    867979,
    878888,
    899988,
    787797,
    787898,
    897888,
    897778,
    888779,
    788688,
    789797,
    797897,
    687778,
    878887,
    878767,
    978879,
    768888,
    688987,
    788687,
    879879,
    887887,
    797887,
    787889,
    888878,
    986799,
    877778,
    789778,
    787799,
    887977,
    797797,
    798978,
    987878,
    986888,
    779779,
    789877,
    698889,
    877767,
    877888,
    888877,
    788878,
    888787,
    777789,
    888887,
    788887,
    978778,
    987978,
    887778,
    898776,
    987778,
    988888,
    888778,
    777787,
    877789,
    798878,
    778878,
    889979,
    677798,
    798888,
    879887,
    988797,
    878879,
    688888,
    766886,
    898778,
    877889,
    878877,
    887789,
    888978,
    867877,
    787787,
    777988,
    778878,
    799977,
    886977,
    797788,
    686879,
    879788,
    798688,
    879978,
    896889,
    897878,
    887798,
    988978,
    688789,
    887869,
    897687,
    988787,
    897988,
    787777,
    779898,
    899799,
    798768,
    787888,
    887978,
    886898,
    788889,
    987786,
    879768,
    879887,
    878778,
    779787,
    788878,
    886968,
    787876,
    989878,
    978877,
    879878,
    896777,
    877797,
    799877,
    887878,
    887787,
    789767,
    876868,
    887888,
    778988,
    988997,
    798898,
    886989,
    778779,
    797767,
    987788,
    898778,
    789899,
    878888,
    799888,
    778879,
    778876,
    888877,
    797868,
    988879,
    998887,
    787797,
    798968,
    888998,
    788788,
    778889,
    778888,
    889879,
    978988,
    788969,
    986989,
    898898,
    778799,
    976687,
    988978,
    889779,
    878897,
    888989,
    887789,
    879889,
    678789,
    888778,
    987987,
    978887,
    798867,
    988778,
    778787,
    888778,
    789787,
    888786,
    698788,
    886878,
    777878,
    986888,
    798879,
    788799,
    988777,
    778888,
    888768,
    788688,
    986888,
    798788,
    789879,
    796687,
    778998,
    989678,
    877777,
    687978,
    987778,
    887979,
    788897,
    789789,
    776698,
    899678,
    898778,
    689888,
    988867,
    678799,
    889877,
    988797,
    787777,
    988977,
    987987,
    776897,
    887877,
    978788,
    677998,
    879788,
    898767,
    998977,
    688897,
    969889,
    888888,
    877789,
    776988,
    999978,
    888769,
    877889,
    779888,
    889878,
    898888,
    879879,
    888999,
    977888,
    888988,
    989898,
    777867,
    778878,
    778878,
    977786,
    998798,
    887888,
    988986,
    868797,
    888778,
    898977,
    886777,
    967878,
    898877,
    878878,
    868798,
    978687,
    777968,
    787998,
    776987,
    967887,
    877878,
    688789,
    787898,
    888788,
    879897,
    987687,
    888677,
    778887,
    979788,
    988689,
    877688,
    788777,
    898998,
    898779,
    887998,
    887788,
    868767,
    797898,
    797967,
    878776,
    868889,
    887798,
    878878,
    888867,
    979867,
    897767,
    777787,
    879898,
    797979,
    879887,
    898777,
    887979,
    878868,
    788788,
    798868,
    778688,
    788988,
    888787,
    888888,
    898898,
    768986,
    987879,
    788877,
    778898,
    877787,
    987788,
    878877,
    877888,
    998798,
    798777,
    899786,
    778877,
    967876,
    977777,
    788897,
    888788,
    877998,
    989996,
    877878,
    889797,
    778877,
    978988,
    978788,
    787889,
    898889,
    889787,
    779769,
    978968,
    798799,
    697788,
    767988,
    778877,
    779887,
    887887,
    978799,
    978778,
    888797,
    699977,
    789897,
    877889,
    877978,
    879888,
    778888,
    877798,
    887888,
    879878,
    999688,
    989988,
    888978,
    779776,
    977889,
    888978,
    987877,
    777789,
    989677,
    787878,
    878979,
    887788,
    789786,
    878688,
    887888,
    798779,
    998897,
    998786,
    898888,
    776986,
    678868,
    788879,
    778888,
    696778,
    868878,
    988887,
    796886,
    678778,
    888889,
    888897,
    798777,
    766688,
    979888,
    768878,
    867878,
    898779,
    886778,
    887786,
    776989,
    798888,
    879989,
    797886,
    978797,
    789978,
    798788,
    768686,
    877889,
    889868,
    699998,
    987887,
    889877,
    786987,
    897696,
    887898,
    878887,
    668767,
    877868,
    788998,
    876778,
    987988,
    777977,
    788968,
    999878,
    798976,
    678877,
    888896,
    888689,
    967877,
    888897,
    778778,
    979788,
    789766,
    798986,
    977978,
    898787,
    777877,
    889779,
    888889,
    788888,
    878889,
    778778,
    888878,
    789768,
    877888,
    798898,
    778987,
    878877,
    789788,
    888977,
    988987,
    788778,
    897777,
    889978,
    977888,
    797797,
    686886,
    788797,
    787779,
    886679,
    787778,
    788878,
    998887,
    789778,
    878788,
    798888,
    788676,
    888788,
    788778,
    887776,
    778888,
    777878,
    887698,
    987767,
    678987,
    787888,
    888879,
    788787,
    778789,
    878777,
    987887,
    798879,
    999888,
    778899,
    898788,
    888888,
    789798,
    989788,
    897787,
    897987,
    899887,
    877988,
    878986,
    777778,
    688986,
    788888,
    788777,
    767769,
    777998,
    888868,
    977897,
    887787,
    889878,
    778768,
    988799,
    898977,
    788898,
    877789,
    869778,
    797887,
    899869,
    998978,
    998778,
    888888,
    997878,
    787889,
    867779,
    877797,
    987897,
    788987,
    797799,
    989987,
    778889,
    677876,
    887779,
    987787,
    777777,
    888898,
    778789,
    887998,
    877788,
    677787,
    788889,
    799898,
    879889,
    889877,
    876869,
    767897,
    788788,
    779787,
    788768,
    877878,
    687788,
    799787,
    787798,
    886879,
    888888,
    997997,
    887978,
    778888,
    978897,
    977777,
    897878,
    899877,
    979877,
    777787,
    878798,
    778767,
    798688,
    997986,
    787878,
    688789,
    888677,
    888789,
    787877,
    887878,
    999798,
    998897,
    978888,
    878789,
    969887,
    888898,
    787968,
    789977,
    886877,
    998877,
    877888,
    779877,
    989798,
    899976,
    779877,
    777788,
    876889,
    899788,
    877888,
    877899,
    888898,
    999989,
    877877,
    788878,
    978797,
    877988,
    889779,
    999997,
    788787,
    878968,
    787987,
    898879,
    977968,
    869789,
    877778,
    888878,
    779989,
    878998,
    797787,
    778787,
    786976,
    779886,
    997877,
    869988,
    999789,
    877889,
    886987,
    967889,
    878888,
    778887,
    897798,
    789878,
    898767,
    779868,
    998878,
    776877,
    878877,
    898778,
    869688,
    788778,
    878888,
    977976,
    876987,
    686877,
    687887,
    998877,
    987698,
    878688,
    788898,
    898987,
    887777,
    788878,
    997878,
    967888,
    788886,
    969869,
    977987,
    687898,
    899768,
    877898,
    897888,
    898988,
    768889,
    887999,
    877776,
    878689,
    788789,
    886799,
    876967,
    868988,
    779989,
    798769,
    678778,
    898898,
    988798,
    797987,
    998877,
    898877,
    779877,
    788978,
    898778,
    888779,
    797777,
    799977,
    689897,
    889887,
    888868,
    888778,
    778897,
    888979,
    886889,
    887977,
    879778,
    878899,
    889788,
    887788,
    889688,
    769788,
    887787,
    777798,
    887999,
    777698,
    988889,
    877777,
    788987,
    998788,
    889878,
    889877,
    977676,
    878779,
    877798,
    887878,
    778688,
    877979,
    877979,
    888988,
    899967,
    877899,
    688978,
    898798,
    878888,
    678998,
    789897,
    788697,
    887977,
    679898,
    787788,
    786887,
    878878,
    989888,
    886897,
    778777,
    888788,
    667698,
    779877,
    989967,
    898879,
    998788,
    988798,
    878888,
    996897,
    789876,
    767788,
    989679,
    798898,
    988887,
    877987,
    778877,
    898877,
    878787,
    878887,
    968798,
    888979,
    888977,
    878878,
    888789,
    999789,
    787786,
    878788,
    979989,
    867797,
    898889,
    897898,
    987788,
    787877,
    799887,
    887978,
    778976,
    987896,
    777888,
    786888,
    877877,
    689779,
    869997,
    777766,
    767868,
    878889,
    879797,
    678778,
    877776,
    896788,
    888988,
    877898,
    877998,
    988779,
    789878,
    788989,
    968688,
    788978,
    877799,
    779897,
    898787,
    777777,
    887798,
    889788,
    788877,
    787878,
    979877,
    997887,
    889888,
    878788,
    978777,
    867887,
    888779,
    967868,
    899898,
    888788,
    887887,
    877778,
    697866,
    888887,
    768987,
    977897,
    898779,
    889897,
    887986,
    888679,
    979878,
    888787,
    787869,
    888869,
    888787,
    889679,
    877987,
    889867,
    987977,
    789778,
    879979,
    797888,
    868878,
    887688,
    786769,
    976678,
    887888,
    768888,
    789797,
    889888,
    787787,
    878888,
    887999,
    778877,
    776779,
    688988,
    868788,
    877788,
    897998,
    778888,
    887968,
    798897,
    976888,
    799986,
    796899,
    967769,
    867788,
    987787,
    777789,
    888888,
    889998,
    778897,
    887889,
    977786,
    886879,
    888997,
    996887,
    888897,
    978888,
    689898,
    879778,
    998797,
    889787,
    987888,
    787788,
    778877,
    778998,
    888668,
    789787,
    977986,
    789987,
    879798,
    889988,
    988788,
    797877,
    887769,
    786977,
    978968,
    986777,
    896887,
    877988,
    996988,
    799798,
    788789,
    996688,
    876878,
    779787,
    888999,
    988789,
    787886,
    878677,
    798898,
    697788,
    876978,
    978896,
    798887,
    677978,
    888978,
    777798,
    787987,
    798787,
    996888,
    768698,
    989887,
    986999,
    777678,
    996997,
    879877,
    896878,
    978788,
    878967,
    689978,
    878777,
    977787,
    798888,
    888797,
    988888,
    877789,
    778987,
    888989,
    869788,
    888767,
    898787,
    787777,
    697777,
    788888,
    889878,
    786767,
    798779,
    897788,
    888897,
    788777,
    889889,
    787887,
    779778,
    778796,
    878778,
    899779,
    888787,
    987798,
    887767,
    797986,
    897987,
    989878,
    887866,
    877898,
    888786,
    799888,
    988768,
    887777,
    878879,
    787996,
    877788,
    877788,
    888978,
    887887,
    768888,
    888887,
    888768,
    799777,
    899677,
    789797,
    888977,
    888978,
    878867,
    978877,
    787878,
    987878,
    887889,
    997777,
    667787,
    977977,
    788779,
    887797,
    966888,
    776988,
    998777,
    998777,
    888786,
    799889,
    979687,
    879887,
    788677,
    998799,
    988779,
    778878,
    887777,
    779887,
    878777,
    989877,
    978788,
    997797,
    899877,
    889997,
    977989,
    888897,
    889979,
    766878,
    779979,
    877898,
    778788,
    897898,
    988999,
    888778,
    789789,
    787989,
    777788,
    789886,
    887898,
    878767,
    778897,
    676887,
    887798,
    798868,
    879789,
    689888,
    868778,
    787899,
    889997,
    878879,
    889789,
    889787,
    879877,
    988978,
    898778,
    778798,
    888887,
    888689,
    898987,
    776877,
    878879,
    697789,
    979788,
    998899,
    977687,
    688788,
    777887,
    887788,
    878896,
    999779,
    897888,
    798886,
    998788,
    876887,
    879988,
    989987,
    888778,
    899888,
    689777,
    888789,
    997797,
    878897,
    998887,
    778987,
    886798,
    987987,
    786777,
    776887,
    968886,
    977988,
    888878,
    678897,
    789989,
    989767,
    897889,
    787877,
    876798,
    798788,
    899988,
    767987,
    788778,
    688786,
    779778,
    788789,
    887789,
    897889,
    978799,
    968798,
    989977,
    878889,
    789777,
    777987,
    779967,
    769788,
    776998,
    767878,
    679788,
    987868,
    978989,
    887978,
    987887,
    888789,
    778867,
    779776,
    998788,
    889897,
    789897,
    888798,
    887887,
    879898,
    878988,
    898879,
    797888,
    897777,
    977788,
    679878,
    986888,
    797788,
    778889,
    698789,
    898978,
    878888,
    678788,
    888877,
    879987,
    678878,
    998888,
    797778,
    678798,
    898989,
    796888,
    896779,
    779879,
    787989,
    778778,
    998788,
    877978,
    778798,
    878879,
    877886,
    877976,
    797677,
    888889,
    879797,
    878688,
    966889,
    979797,
    788778,
    976789,
    868887,
    987887,
    768889,
    778998,
    789888,
    878879,
    767898,
    988888,
    887789,
    898889,
    788888,
    886878,
    798889,
    878888,
    787898,
    879878,
    788978,
    677788,
    888888,
    777798,
    787879,
    787688,
    778888,
    767798,
    987888,
    778678,
    988878,
    886978,
    978876,
    989888,
    898787,
    779889,
    788888,
    887768,
    876788,
    898778,
    778676,
    987888,
    888779,
    878888,
    687789,
    889778,
    998778,
    879887,
    878988,
    867888,
    998868,
    867898,
    988987,
    779789,
    888888,
    878778,
    888889,
    788888,
    887797,
    868988,
    786889,
    779878,
    876888,
    878879,
    797778,
    888787,
    979998,
    689778,
    787998,
    788789,
    798798,
    688789,
    779788,
    797787,
    779698,
    779888,
    688787,
    879788,
    779788,
    989787,
    899888,
    886868,
    877899,
    878779,
    998887,
    888879,
    878796,
    888798,
    788977,
    998997,
    888889,
    889987,
    677886,
    887978,
    978887,
    889678,
    987977,
    979898,
    788868,
    878898,
    977878,
    798897,
    788688,
    879798,
    788878,
    777796,
    788887,
    889897,
    796768,
    899698,
    867888,
    799787,
    879989,
    687878,
    778889,
    788779,
    799777,
    977876,
    777888,
    766897,
    768788,
    899987,
    877886,
    697987,
    877867,
    998877,
    779979,
    978879,
    878877,
    777788,
    887687,
    878988,
    879887,
    988968,
    778888,
    888688,
    998889,
    878767,
    788889,
    778888,
    897887,
    879768,
    898888,
    798789,
    797697,
    788879,
    887779,
    788968,
    878889,
    789886,
    878886,
    887787,
    879798,
    988788,
    977868,
    879887,
    886778,
    879778,
    788877,
    889788,
    787898,
    898677,
    787989,
    797887,
    877888,
    799888,
    776997,
    879799,
    788787,
    998779,
    788987,
    888987,
    878969,
    887878,
    877877,
    878898,
    799887,
    989789,
    977787,
    876779,
    788777,
    688898,
    879788,
    787698,
    779878,
    988776,
    778888,
    979988,
    788787,
    889888,
    968788,
    878768,
    888799,
    677798,
    789788,
    877697,
    897787,
    978888,
    868778,
    799679,
    788889,
    787777,
    877878,
    777889,
    686888,
    777889,
    898986,
    798777,
    788778,
    889897,
    867878,
    899879,
    777777,
    888777,
    879687,
    787979,
    889778,
    987787,
    887869,
    796889,
    888798,
    997898,
    878886,
    878897,
    867988,
    988888,
    888668,
    988766,
    878979,
    898797,
    796787,
    778977,
    998897,
    798868,
    897886,
    967878,
    799969,
    899798,
    969977,
    677879,
    877978,
    888898,
    697888,
    869787,
    998989,
    778899,
    887798,
    967878,
    777876,
    679888,
    876998,
    979788,
    899988,
    997877,
    898898,
    897876,
    889879,
    778789,
    886987,
    977896,
    777888,
    678786,
    879889,
    798879,
    766878,
    888967,
    879878,
    779978,
    878779,
    798776,
    897966,
    798989,
    888878,
    888989,
    877888,
    976899,
    777786,
    788878,
    788877,
    887977,
    999787,
    767768,
    788887,
    798879,
    778778,
    798779,
    798887,
    979898,
    798888,
    778777,
    879879,
    997878,
    888887,
    777767,
    787986,
    889778,
    867678,
    887898,
    779878,
    878866,
    776878,
    877787,
    879798,
    697778,
    998998,
    887897,
    899788,
    987887,
    879898,
    888888,
    677788,
    877788,
    977797,
    887778,
    987789,
    778868,
    786898,
    988869,
    898798,
    678898,
    898979,
    687788,
    879768,
    888897,
    687776,
    798879,
    888778,
    797966,
    867897,
    879796,
    888797,
    978976,
    878987,
    887888,
    877989,
    787788,
    888887,
    979778,
    877867,
    797697,
    796986,
    888678,
    786887,
    778886,
    878887,
    888897,
    788878,
    867788,
    787677,
    887788,
    689978,
    888679,
    889777,
    888888,
    979988,
    698788,
    976787,
    888886,
    767997,
    988876,
    976788,
    788798,
    877988,
    889887,
    887879,
    879998,
    778779,
    897788,
    977898,
    788877,
    979888,
    788786,
    877968,
    889788,
    989788,
    978877,
    978868,
    787888,
    778798,
    887999,
    896686,
    877798,
    888898,
    789778,
    787678,
    897789,
    879987,
    889979,
    797998,
    898998,
    787879,
    888788,
    977879,
    798977,
    878877,
    998778,
    888898,
    899987,
    887987,
    888978,
    887998,
    877777,
    979776,
    878678,
    778987,
    878988,
    897988,
    787898,
    798998,
    779798,
    988988,
    789977,
    978778,
    999888,
    869788,
    879687,
    976888,
    878977,
    876778,
    887797,
    989788,
    768868,
    676778,
    887878,
    798799,
    988898,
    998877,
    878898,
    788688,
    889789,
    978778,
    788887,
    677977,
    798889,
    888987,
    787787,
    788799,
    779886,
    786777,
    879797,
    888888,
    978899,
    779998,
    879988,
    768787,
    786978,
    878989,
    978977,
    677989,
    788777,
    878888,
    887787,
    788978,
    968888,
    788786,
    989788,
    779788,
    898799,
    888779,
    788787,
    989877,
    867897,
    886978,
    878979,
    988887,
    888887,
    788777,
    967988,
    887788,
    767698,
    878787,
    987699,
    687869,
    778978,
    898879,
    787878,
    879766,
    788988,
    687798,
    888779,
    879888,
    979788,
    788866,
    887879,
    977879,
    687787,
    788877,
    867978,
    877798,
    878977,
    889988,
    879888,
    688977,
    799867,
    798989,
    889897,
    699897,
    898688,
    899978,
    889678,
    788787,
    897868,
    788867,
    999968,
    988886,
    776867,
    898687,
    789788,
    787768,
    987887,
    778799,
    877987,
    879776,
    787888,
    897998,
    778887,
    978887,
    877979,
    987979,
    877778,
    778877,
    889777,
    888876,
    888667,
    889787,
    888989,
    888888,
    888786,
    887887,
    787788,
    788999,
    977797,
    898888,
    778888,
    979886,
    788968,
    778987,
    877889,
    786888,
    889778,
    878978,
    687776,
    788988,
    698788,
    787987,
    779888,
    786877,
    898897,
    777888,
    879898,
    877789,
    778798,
    976868,
    877987,
    897867,
    688678,
    798889,
    889788,
    869897,
    876788,
    998887,
    787888,
    998988,
    788878,
    788776,
    798789,
    788888,
    886688,
    889868,
    788778,
    968678,
    797977,
    878897,
    776697,
    789899,
    877788,
    877699,
    788887,
    889777,
    877986,
    987887,
    889968,
    799987,
    698776,
    987888,
    887798,
    968978,
    878877,
    968778,
    889789,
    788877,
    788968,
    777987,
    789988,
    788987,
    797898,
    788799,
    878878,
    879777,
    798887,
    889978,
    887867,
    879688,
    778887,
    888999,
    799887,
    887888,
    877979,
    899887,
    888798,
    998887,
    789778,
    996678,
    888688,
    888888,
    678897,
    897787,
    988878,
    797778,
    789988,
    779988,
    878876,
    976878,
    887888,
    987796,
    698997,
    787997,
    788996,
    887879,
    796898,
    797797,
    889688,
    788877,
    997888,
    779779,
    797687,
    877978,
    888787,
    777677,
    897878,
    998879,
    988787,
    799988,
    898778,
    688898,
    887867,
    778877,
    897779,
    986877,
    967789,
    798798,
    678976,
    897778,
    888898,
    966799,
    688678,
    887787,
    987877,
    878979,
    878898,
    889769,
    778879,
    697787,
    997888,
    787789,
    888978,
    877888,
    778797,
    889779,
    888788,
    977678,
    887988,
    888878,
    898768,
    878767,
    887777,
    888678,
    799987,
    998769,
    789879,
    978688,
    889878,
    787688,
    898888,
    688889,
    878778,
    889889,
    768778,
    879898,
    868986,
    998897,
    967987,
    877898,
    888888,
    889799,
    888789,
    887987,
    868888,
    778786,
    789889,
    878887,
    888788,
    877989,
    786777,
    877799,
    888688,
    788887,
    887989,
    787688,
    978998,
    788888,
    888977,
    979788,
    889998,
    799889,
    677897,
    768988,
    977868,
    887899,
    788988,
    979989,
    897887,
    789788,
    788899,
    897997,
    688887,
    887777,
    777888,
    798796,
    878787,
    888798,
    778798,
    867779,
    898879,
    778778,
    879787,
    788888,
    878788,
    897878,
    887777,
    779887,
    789988,
    897979,
    789867,
    878778,
    998979,
    988989,
    897668,
    997678,
    788887,
    997978,
    678887,
    697899,
    988977,
    898686,
    798789,
    779888,
    779777,
    979788,
    769888,
    778888,
    988998,
    879867,
    968888,
    889899,
    787886,
    668778,
    789788,
    789787,
    688877,
    787788,
    978798,
    677887,
    789888,
    788788,
    787988,
    687787,
    688997,
    977897,
    898988,
    888687,
    778988,
    888888,
    897999,
    889789,
    769979,
    887889,
    976978,
    788968,
    879669,
    796878,
    889868,
    867687,
    998988,
    877897,
    987887,
    878788,
    888789,
    898897,
    798877,
    877788,
    797988,
    968798,
    988879,
    989887,
    778887,
    798888,
    777879,
    869897,
    887878,
    988877,
    878878,
    897878,
    788878,
    787979,
    887786,
    899789,
    888889,
    787997,
    978777,
    788876,
    987788,
    786888,
    878768,
    888798,
    779788,
    788878,
    987978,
    887877,
    797787,
    769867,
    878887,
    798877,
    887688,
    978987,
    897879,
    788987,
    898778,
    966999,
    878788,
    786887,
    788788,
    789888,
    988887,
    998887,
    779878,
    889887,
    967889,
    887788,
    987989,
    767787,
    778889,
    876987,
    798788,
    798778,
    888877,
    877878,
    999777,
    897878,
    678877,
    977978,
    997787,
    887987,
    887687,
    889898,
    986989,
    888776,
    788679,
    888978,
    877886,
    787888,
    678989,
    888768,
    876878,
    967689,
    887968,
    778898,
    999798,
    887888,
    776777,
    888879,
    688687,
    788887,
    877897,
    888699,
    888977,
    786678,
    886788,
    789988,
    979799,
    978877,
    686777,
    988887,
    789787,
    787887,
    888877,
    988886,
    887978,
    877886,
    878888,
    687989,
    787787,
    888788,
    798878,
    899778,
    898768,
    979987,
    888778,
    998876,
    779998,
    787877,
    987687,
    777788,
    978976,
    876889,
    687988,
    887687,
    988777,
    977979,
    788888,
    799897,
    978978,
    977788,
    897978,
    778879,
    979778,
    968769,
    978888,
    878887,
    787688,
    969899,
    669879,
    897886,
    788887,
    997779,
    878878,
    798888,
    887777,
    797778,
    788789,
    887887,
    888889,
    688998,
    889767,
    799789,
    779878,
    877789,
    898778,
    887778,
    887778,
    879899,
    898768,
    887987,
    987889,
    778777,
    788897,
    778798,
    878678,
    798888,
    987887,
    998898,
    987978,
    799789,
    888897,
    997897,
    887987,
    987988,
    977987,
    897778,
    989888,
    898776,
    887889,
    888877,
    888987,
    967997,
    788868,
    877787,
    778887,
    788977,
    788878,
    978798,
    987896,
    796888,
    788778,
    878867,
    977877,
    688887,
    777788,
    989877,
    878977,
    878868,
    877797,
    978667,
    887877,
    898968,
    768787,
    768988,
    888788,
    887668,
    778698,
    977888,
    689778,
    698786,
    887977,
    888997,
    869888,
    777988,
    879789,
    887778,
    897898,
    869888,
    788878,
    998777,
    888988,
    788777,
    898888,
    968887,
    887977,
    787988,
    777888,
    979789,
    878789,
    777989,
    869977,
    897879,
    889798,
    686778,
    878788,
    879988,
    778887,
    786999,
    988889,
    898799,
    988777,
    788879,
    979777,
    767897,
    788798,
    787979,
    987898,
    879887,
    788698,
    888978,
    797777,
    787788,
    787779,
    888878,
    899788,
    987888,
    987868,
    888887,
    687788,
    887988,
    887987,
    788976,
    779698,
    877788,
    879787,
    787989,
    877688,
    879679,
    798899,
    679888,
    978787,
    776796,
    978798,
    787986,
    889789,
    788888,
    678687,
    797677,
    878868,
    868987,
    677977,
    889887,
    987877,
    799687,
    898968,
    869798,
    797988,
    786977,
    887999,
    777878,
    776786,
    978979,
    787988,
    778977,
    787977,
    778888,
    679687,
    988888,
    788779,
    798877,
    797777,
    888989,
    978769,
    789897,
    788888,
    979867,
    877989,
    877787,
    887698,
    787888,
    687888,
    878787,
    888899,
    788889,
    778888,
    987797,
    897787,
    779889,
    878788,
    878887,
    978778,
    977888,
    778878,
    888888,
    879898,
    988898,
    879977,
    797998,
    877787,
    799778,
    879697,
    877787,
    787778,
    786888,
    989797,
    887787,
    669697,
    889879,
    878777,
    978977,
    888878,
    798786,
    797788,
    889779,
    688788,
    897888,
    878789,
    788798,
    887678,
    787788,
    978799,
    879997,
    877889,
    689698,
    778887,
    888688,
    878798,
    869797,
    777798,
    888987,
    677878,
    876988,
    778987,
    877878,
    998996,
    978996,
    878787,
    787897,
    787879,
    787788,
    798867,
    968989,
    789888,
    878688,
    787878,
    789787,
    786889,
    996987,
    866677,
    978878,
    688678,
    879899,
    987897,
    769878,
    879776,
    689997,
    887888,
    988877,
    777767,
    988988,
    877888,
    897886,
    999986,
    898777,
    997778,
    887776,
    878899,
    867879,
    877796,
    877898,
    898878,
    889899,
    798788,
    798798,
    889678,
    889888,
    996887,
    878878,
    779767,
    777997,
    698998,
    877678,
    878779,
    897777,
    888979,
    978788,
    799998,
    678988,
    878986,
    778886,
    779778,
    888887,
    886878,
    777786,
    788877,
    899879,
    887797,
    897787,
    988879,
    888887,
    768878,
    898887,
    867987,
    888778,
    786889,
    777688,
    688878,
    777878,
    789778,
    898896,
    789887,
    889777,
    889777,
    887787,
    798888,
    987678,
    788898,
    878886,
    797776,
    877978,
    779778,
    796888,
    896888,
    888787,
    998879,
    789899,
    878777,
    878897,
    887788,
    878877,
    878887,
    887998,
    878886,
    867988,
    888877,
    888787,
    789888,
    879878,
    879798,
    678777,
    778689,
    889878,
    788788,
    689789,
    888999,
    687787,
    877878,
    877887,
    878889,
    888897,
    778987,
    887988,
    868989,
    877878,
    777777,
    777688,
    897697,
    886676,
    878888,
    979888,
    998887,
    787978,
    787889,
    778887,
    899687,
    888788,
    888996,
    979777,
    979888,
    798878,
    687796,
    988889,
    789897,
    888887,
    888797,
    798888,
    987978,
    977897,
    687878,
    899788,
    888898,
    979797,
    769697,
    777888,
    987778,
    777798,
    879799,
    878878,
    888787,
    989789,
    879968,
    686898,
    898788,
    979797,
    787876,
    978898,
    699897,
    788877,
    779988,
    877778,
    799887,
    778997,
    697988,
    977786,
    789887,
    888769,
    777999,
    777888,
    887788,
    787788,
    889688,
    877979,
    897899,
    898978,
    788898,
    898877,
    777899,
    879979,
    787879,
    879668,
    669879,
    888787,
    778897,
    789798,
    899898,
    798899,
    676789,
    776787,
    778899,
    877889,
    869776,
    869878,
    976887,
    887687,
    998998,
    899868,
    877989,
    897789,
    976986,
    988877,
    878987,
    789986,
    987888,
    887887,
    787678,
    897797,
    888878,
    887698,
    798778,
    887998,
    798898,
    888888,
    897778,
    889777,
    776988,
    898778,
    987998,
    998798,
    688697,
    878789,
    977988,
    787788,
    787777,
    778877,
    777888,
    887877,
    989978,
    998976,
    778878,
    788887,
    889789,
    878799,
    978878,
    977989,
    889989,
    867787,
    889877,
    989888,
    869777,
    978887,
    878988,
    898888,
    778887,
    877778,
    798978,
    887978,
    867768,
    878899,
    876779,
    888877,
    898898,
    986688,
    878887,
    787888,
    877799,
    898968,
    998777,
    877778,
    977787,
    789888,
    878787,
    898878,
    888878,
    988998,
    987979,
    679898,
    688897,
    987887,
    798898,
    678788,
    878898,
    888787,
    797877,
    888878,
    697887,
    887878,
    796778,
    887877,
    897799,
    799879,
    877877,
    978869,
    886766,
    868789,
    888778,
    989878,
    797778,
    798799,
    887987,
    989989,
    967788,
    898787,
    879877,
    777788,
    887999,
    889898,
    778778,
    788879,
    889888,
    888678,
    788778,
    978978,
    879788,
    877797,
    789877,
    787867,
    876787,
    786798,
    877889,
    888788,
    778897,
    888977,
    799979,
    888998,
    888779,
    767899,
    978889,
    689986,
    978787,
    688689,
    778787,
    887887,
    798989,
    778789,
    778888,
    997878,
    786888,
    986889,
    998777,
    876868,
    779888,
    879889,
    877868,
    689898,
    768988,
    988979,
    989767,
    679799,
    787988,
    888769,
    679997,
    998979,
    899889,
    767798,
    688887,
    786796,
    998978,
    877698,
    788897,
    877886,
    867877,
    769788,
    978778,
    889999,
    789868,
    878787,
    687877,
    888979,
    797997,
    767877,
    787888,
    677867,
    687787,
    876789,
    789967,
    888688,
    988987,
    789977,
    899887,
    998878,
    988778,
    877898,
    978877,
    888778,
    777887,
    998777,
    896989,
    779887,
    978787,
    989698,
    767787,
    997697,
    986887,
    777887,
    788879,
    887888,
    779877,
    788687,
    898886,
    896887,
    777787,
    888988,
    788777,
    978898,
    868776,
    898787,
    888878,
    879779,
    788879,
    998889,
    798878,
    797867,
    869888,
    788898,
    878778,
    998788,
    889877,
    777878,
    898799,
    778798,
    877788,
    768778,
    998878,
    887987,
    679768,
    978878,
    879777,
    988878,
    878787,
    998887,
    887788,
    877879,
    887876,
    779889,
    878788,
    998868,
    788888,
    888898,
    886687,
    889787,
    898797,
    986887,
    998868,
    676999,
    788888,
    878768,
    896869,
    787778,
    788888,
    778786,
    787888,
    877768,
    889778,
    797887,
    798879,
    999778,
    777977,
    779697,
    687978,
    776788,
    867888,
    787797,
    799878,
    798978,
    788778,
    789888,
    988779,
    976887,
    679879,
    888986,
    879889,
    987998,
    888788,
    888876,
    878786,
    976877,
    977797,
    987988,
    878888,
    989988,
    888899,
    877896,
    767887,
    686986,
    779788,
    867998,
    778888,
    789768,
    777877,
    787687,
    678967,
    768678,
    887787,
    989767,
    789878,
    888778,
    899787,
    986998,
    987879,
    899987,
    797787,
    899977,
    878778,
    787777,
    888889,
    688977,
    886887,
    778898,
    878888,
    787899,
    779886,
    988777,
    897988,
    886789,
    888797,
    998988,
    869897,
    869779,
    778887,
    778989,
    897797,
    877887,
    897998,
    879999,
    868786,
    868887,
    978776,
    878677,
    997878,
    889798,
    677768,
    999898,
    688789,
    877789,
    667898,
    798888,
    887887,
    979789,
    798998,
    799788,
    887878,
    998698,
    798888,
    767988,
    898888,
    997898,
    876876,
    898797,
    689977,
    789988,
    798668,
    788888,
    988788,
    788998,
    789888,
    979868,
    777896,
    788879,
    788789,
    688678,
    777988,
    787887,
    987687,
    779896,
    886788,
    979788,
    879989,
    887787,
    988797,
    988799,
    878787,
    896876,
    998887,
    988976,
    787788,
    997777,
    878888,
    989796,
    787788,
    887898,
    778888,
    988877,
    887778,
    868879,
    876787,
    877787,
    668987,
    787867,
    888999,
    779887,
    788788,
    888889,
    777989,
    868788,
    978797,
    898978,
    788897,
    988789,
    787689,
    778778,
    978876,
    676778,
    878897,
    777888,
    797787,
    998979,
    899887,
    978898,
    898898,
    887888,
    878778,
    887778,
    988877,
    887998,
    787978,
    788878,
    869888,
    888968,
    777878,
    978877,
    778989,
    988886,
    789776,
    786887,
    788877,
    888787,
    766788,
    787998,
    987798,
    888988,
    879876,
    867788,
    779898,
    778888,
    777699,
    878998,
    988978,
    898687,
    879988,
    988788,
    888788,
    978687,
    988787,
    898788,
    867866,
    769867,
    787978,
    887777,
    778778,
    789987,
    877788,
    996987,
    876889,
    987779,
    799889,
    789878,
    888888,
    777778,
    878788,
    788889,
    688679,
    886778,
    888887,
    987798,
    799887,
    778798,
    768777,
    788688,
    787889,
    779888,
    778888,
    997798,
    989887,
    888688,
    988789,
    867779,
    798987,
    697878,
    788678,
    688887,
    687677,
    877987,
    778989,
    778988,
    888997,
    878888,
    998786,
    888779,
    878898,
    779879,
    989987,
    878788,
    788887,
    778978,
    989768,
    977777,
    778888,
    988788,
    798778,
    989879,
    687788,
    677788,
    988889,
    788776,
    877977,
    898888,
    977889,
    888668,
    688889,
    767767,
    987799,
    897888,
    976876,
    897897,
    888787,
    877779,
    798768,
    888897,
    989777,
    877788,
    888888,
    899687,
    777878,
    788788,
    979879,
    787878,
    877988,
    897789,
    888877,
    789986,
    797787,
    896978,
    978979,
    898888,
    787866,
    998897,
    789788,
    988879,
    897768,
    878977,
    787888,
    887988,
    778878,
    687887,
    887777,
    897787,
    986787,
    888887,
    998798,
    668788,
    978988,
    789779,
    789798,
    787787,
    989799,
    977878,
    889868,
    778887,
    887868,
    887899,
    887987,
    786888,
    689887,
    877988,
    887878,
    876897,
    879977,
    987797,
    799898,
    877898,
    887878,
    978888,
    978998,
    878987,
    987788,
    878789,
    789798,
    987987,
    699988,
    878788,
    689989,
    777869,
    888988,
    687976,
    777898,
    777887,
    887887,
    878788,
    678877,
    888987,
    878896,
    888977,
    898789,
    779799,
    787878,
    888799,
    778787,
    867777,
    788889,
    877967,
    787878,
    678886,
    886776,
    887787,
    678868,
    778778,
    889868,
    897677,
    978879,
    878789,
    987877,
    889779,
    887879,
    788988,
    887768,
    687889,
    887788,
    888867,
    996778,
    898678,
    778686,
    788887,
    778788,
    989967,
    897967,
    987998,
    897878,
    798877,
    897978,
    879887,
    887878,
    788797,
    887887,
    897886,
    869777,
    877888,
    678988,
    887797,
    886978,
    977797,
    768788,
    769898,
    787887,
    777797,
    788798,
    977878,
    877877,
    887979,
    989878,
    778766,
    878878,
    789887,
    889778,
    988886,
    887876,
    898879,
    787887,
    876879,
    887878,
    667777,
    976687,
    899869,
    686689,
    787879,
    777889,
    687778,
    787888,
    879899,
    988778,
    997988,
    879789,
    777899,
    898987,
    788887,
    878888,
    877868,
    777888,
    997877,
    779889,
    879798,
    778797,
    978788,
    878889,
    798877,
    779897,
    868787,
    999788,
    889677,
    678797,
    888987,
    898988,
    788889,
    977966,
    968898,
    889987,
    888789,
    988978,
    896976,
    868787,
    868778,
    888888,
    879899,
    877787,
    688886,
    988887,
    788977,
    887698,
    686887,
    876978,
    798778,
    888789,
    778688,
    789889,
    886998,
    989777,
    878788,
    978777,
    897887,
    788777,
    868878,
    888878,
    798887,
    879879,
    788686,
    977888,
    888777,
    898697,
    878778,
    887687,
    778777,
    888878,
    786896,
    777888,
    968698,
    788888,
    867976,
    898888,
    778697,
    879678,
    879996,
    797898,
    887887,
    977988,
    798899,
    898888,
    876999,
    878779,
    899887,
    798877,
    878778,
    797777,
    898878,
    788879,
    878878,
    799987,
    897678,
    778779,
    888898,
    897787,
    779898,
    696877,
    786877,
    999989,
    768778,
    769989,
    687898,
    788897,
    897888,
    878979,
    777787,
    888998,
    899877,
    987797,
    789968,
    877789,
    888778,
    777876,
    888778,
    778979,
    897788,
    869988,
    877888,
    778878,
    679877,
    776778,
    879899,
    899689,
    867687,
    789897,
    868978,
    889797,
    889868,
    799877,
    888787,
    679777,
    878886,
    888778,
    888877,
    888968,
    886888,
    788988,
    898889,
    786888,
    989778,
    887888,
    978996,
    878888,
    877889,
    888788,
    888786,
    889789,
    978778,
    888789,
    799878,
    788686,
    777889,
    888998,
    978868,
    888888,
    788979,
    679877,
    778777,
    967889,
    878778,
    677898,
    768877,
    986788,
    768887,
    696766,
    986887,
    888798,
    678868,
    787999,
    686887,
    888988,
    888898,
    798887,
    969987,
    878888,
    788987,
    788888,
    987686,
    979789,
    877787,
    889777,
    778787,
    788887,
    798978,
    888779,
    876988,
    897867,
    977867,
    866778,
    778887,
    768998,
    887788,
    877887,
    799887,
    678897,
    897679,
    988879,
    888988,
    687989,
    688987,
    789888,
    988878,
    677668,
    888898,
    886796,
    787998,
    899788,
    887887,
    889667,
    898887,
    777897,
    688996,
    787789,
    898867,
    778897,
    887887,
    888878,
    877878,
    987888,
    797869,
    787997,
    888986,
    688887,
    887777,
    888888,
    978778,
    878889,
    869787,
    878877,
    769889,
    997886,
    979887,
    779868,
    689888,
    989888,
    787997,
    987987,
    778788,
    887787,
    787788,
    888787,
    777889,
    788788,
    688897,
    788788,
    788787,
    877777,
    887987,
    978787,
    899897,
    878788,
    886897,
    788766,
    777988,
    887889,
    777898,
    989987,
    987887,
    787876,
    979989,
    867688,
    878877,
    878889,
    897787,
    777778,
    786787,
    878997,
    888888,
    899679,
    986977,
    889787,
    797978,
    979888,
    778789,
    788798,
    876888,
    886876,
    878888,
    687877,
    989669,
    978889,
    787778,
    888978,
    887697,
    988788,
    887788,
    889888,
    868797,
    778697,
    887897,
    978688,
    776897,
    888788,
    987968,
    986877,
    976979,
    789798,
    879876,
    767889,
    787697,
    879889,
    889788,
    978768,
    787798,
    788868,
    898867,
    977779,
    879889,
    988888,
    887999,
    797988,
    969968,
    888788,
    688888,
    868778,
    678868,
    879779,
    888876,
    888698,
    788898,
    887788,
    787888,
    999987,
    788888,
    876899,
    878989,
    868979,
    898788,
    788868,
    977877,
    787889,
    678977,
    779878,
    976978,
    679989,
    877777,
    788788,
    886887,
    887998,
    878887,
    989778,
    998886,
    778868,
    689977,
    877687,
    778877,
    887779,
    786679,
    777688,
    988988,
    888796,
    877978,
    887788,
    787878,
    799878,
    989887,
    788877,
    987777,
    888688,
    889798,
    879888,
    889878,
    888687,
    777789,
    798787,
    688888,
    788888,
    979787,
    987888,
    998878,
    867888,
    789898,
    888888,
    988777,
    886776,
    898989,
    876968,
    868888,
    678789,
    988887,
    788799,
    878879,
    979887,
    788788,
    878999,
    879897,
    667778,
    797887,
    888897,
    978678,
    768986,
    887898,
    779876,
    867898,
    976767,
    888897,
    779888,
    867778,
    787877,
    896779,
    889987,
    889887,
    778788,
    797888,
    886888,
    798878,
    887888,
    897897,
    898878,
    797968,
    788897,
    877887,
    897987,
    977878,
    768999,
    897779,
    776887,
    977777,
    998678,
    989998,
    988789,
    978878,
    889789,
    789777,
    878778,
    899897,
    777898,
    988788,
    876778,
    978898,
    879797,
    879689,
    787989,
    899898,
    787787,
    987867,
    869988,
    877878,
    898977,
    778888,
    778878,
    797789,
    967978,
    888797,
    988777,
    797896,
    788988,
    788887,
    899889,
    887767,
    977888,
    688898,
    878976,
    698876,
    778878,
    878877,
    889888,
    678788,
    998767,
    788989,
    797888,
    797877,
    878986,
    887768,
    898788,
    888878,
    688977,
    978997,
    788877,
    889888,
    779787,
    988879,
    678898,
    978889,
    787987,
    888798,
    798889,
    886686,
    787777,
    877778,
    987867,
    867888,
    977789,
    888778,
    979797,
    968888,
    888677,
    878997,
    779788,
    987966,
    878887,
    787878,
    797998,
    978977,
    689789,
    988878,
    878899,
    798988,
    878888,
    877967,
    778999,
    968776,
    888887,
    978877,
    987969,
    878789,
    778789,
    888797,
    788998,
    988886,
    787887,
    878798,
    788878,
    889779,
    896878,
    688888,
    897768,
    868889,
    778787,
    778978,
    999978,
    988889,
    788997,
    898888,
    778888,
    977777,
    987887,
    988976,
    867788,
    878879,
    777997,
    987778,
    788887,
    797679,
    797989,
    897887,
    987797,
    876979,
    787888,
    977879,
    679878,
    867979,
    987889,
    986877,
    899998,
    787778,
    977889,
    878777,
    888878,
    888978,
    888877,
    988678,
    788969,
    789778,
    978698,
    678788,
    889888,
    988888,
    687888,
    897788,
    878898,
    777998,
    987888,
    878868,
    797788,
    977897,
    776788,
    788798,
    987988,
    887779,
    888889,
    868878,
    778979,
    788887,
    887777,
    778887,
    879888,
    878877,
    776877,
    877898,
    998777,
    778788,
    787889,
    898887,
    878678,
    988877,
    988978,
    767788,
    888986,
    997888,
    898987,
    889878,
    888878,
    888879,
    869787,
    798889,
    878886,
    779998,
    878979,
    988777,
    768787,
    879779,
    877987,
    667776,
    987787,
    887878,
    898879,
    879877,
    978797,
    997698,
    678778,
    988788,
    988988,
    788788,
    778988,
    699888,
    799878,
    887979,
    767878,
    787877,
    976888,
    876786,
    888897,
    887878,
    778788,
    866789,
    798967,
    887967,
    777678,
    988787,
    887878,
    897879,
    888787,
    898888,
    778887,
    999889,
    988887,
    887788,
    898887,
    786879,
    778686,
    788878,
    878677,
    986779,
    788878,
    787787,
    879878,
    878777,
    787788,
    788777,
    877787,
    767778,
    868887,
    788877,
    898988,
    677868,
    797987,
    989976,
    868977,
    897886,
    876887,
    877887,
    989778,
    788788,
    987787,
    799878,
    886777,
    878798,
    688787,
    788888,
    887789,
    869889,
    697887,
    699887,
    998778,
    767868,
    776998,
    787987,
    888978,
    898878,
    788867,
    987898,
    897677,
    978989,
    887787,
    868888,
    877987,
    887777,
    979896,
    988869,
    698887,
    887878,
    888679,
    698899,
    997987,
    877888,
    777899,
    887879,
    787887,
    977888,
    769787,
    868889,
    777887,
    878887,
    877877,
    778986,
    798877,
    987889,
    888897,
    777886,
    988987,
    898887,
    989787,
    868776,
    678778,
    898887,
    799977,
    898887,
    687979,
    879899,
    879878,
    778769,
    669679,
    877897,
    998778,
    888878,
    787889,
    778777,
    878788,
    877877,
    887877,
    788968,
    878979,
    888989,
    896878,
    878778,
    888897,
    878898,
    966898,
    788879,
    887789,
    867887,
    768779,
    878898,
    788776,
    977698,
    987897,
    879878,
    799777,
    697888,
    869998,
    888888,
    787778,
    877899,
    887878,
    667678,
    779899,
    899788,
    888778,
    888888,
    798898,
    788988,
    787978,
    878987,
    878899,
    789889,
    888977,
    696888,
    877888,
    987887,
    877789,
    879799,
    876767,
    997876,
    888987,
    988788,
    878989,
    787987,
    876786,
    887887,
    877869,
    898978,
    878798,
    978697,
    978686,
    888987,
    877789,
    777989,
    898868,
    889798,
    889799,
    778777,
    787778,
    978776,
    989898,
    889878,
    899777,
    887877,
    997978,
    876987,
    898878,
    887987,
    788978,
    788787,
    979977,
    887887,
    898988,
    699797,
    778999,
    789977,
    869879,
    778788,
    789787,
    998788,
    988799,
    898789,
    977789,
    899987,
    878878,
    989988,
    787777,
    778878,
    768997,
    789978,
    877889,
    888979,
    796878,
    879788,
    787897,
    797999,
    868889,
    879988,
    877778,
    868888,
    888977,
    878798,
    887688,
    978798,
    688788,
    687788,
    876979,
    798898,
    898777,
    789886,
    977987,
    977787,
    979696,
    777789,
    878888,
    877989,
    798767,
    877788,
    888897,
    988888,
    799798,
    778778,
    987788,
    879877,
    788797,
    877868,
    998789,
    889698,
    787778,
    888799,
    787887,
    787967,
    878887,
    998777,
    887878,
    789799,
    787888,
    798898,
    988987,
    889787,
    879997,
    778777,
    679876,
    978877,
    787898,
    779777,
    787797,
    978789,
    898787,
    799789,
    797978,
    879796,
    876797,
    978687,
    798977,
    879989,
    887878,
    777988,
    886778,
    897788,
    768787,
    788878,
    968789,
    787887,
    978689,
    888889,
    889877,
    787878,
    989797,
    888889,
    879877,
    778987,
    798879,
    877798,
    687977,
    787967,
    898978,
    878686,
    798977,
    668988,
    879887,
    679878,
    878888,
    888677,
    869988,
    778788,
    886878,
    898876,
    987889,
    788779,
    887867,
    797966,
    888887,
    988867,
    777799,
    888677,
    788778,
    998887,
    776786,
    787887,
    887887,
    887978,
    997887,
    788887,
    879878,
    898797,
    889787,
    897897,
    888996,
    886888,
    878898,
    797998,
    888878,
    878977,
    888878,
    977689,
    887887,
    786979,
    988987,
    888789,
    888998,
    686889,
    798798,
    977976,
    878888,
    887897,
    678797,
    888779,
    896888,
    767878,
    788798,
    696788,
    987878,
    977989,
    788997,
    789889,
    787789,
    876898,
    787887,
    798789,
    786877,
    787977,
    797898,
    787787,
    878877,
    888977,
    889899,
    768878,
    777799,
    967898,
    968887,
    899989,
    887779,
    897798,
    687889,
    879887,
    977787,
    868779,
    797797,
    976779,
    899777,
    879889,
    989777,
    877778,
    788977,
    898787,
    888788,
    877798,
    787787,
    697988,
    798888,
    798768,
    998868,
    978878,
    979797,
    978898,
    788868,
    979988,
    889778,
    887987,
    789789,
    888878,
    779767,
    786888,
    877777,
    769878,
    688889,
    887797,
    989887,
    788879,
    879798,
    768778,
    779968,
    888877,
    788688,
    988798,
    877789,
    888979,
    877787,
    888897,
    899868,
    788797,
    889898,
    768688,
    899888,
    889798,
    898698,
    787878,
    989788,
    988798,
    878979,
    967888,
    676798,
    967878,
    969888,
    979878,
    986779,
    868797,
    879888,
    977797,
    788988,
    787888,
    698698,
    899887,
    779889,
    998887,
    787887,
    879777,
    787877,
    878979,
    896986,
    877779,
    889788,
    787798,
    879999,
    978888,
    868689,
    787788,
    999867,
    886988,
    887876,
    979878,
    777888,
    878868,
    878797,
    797697,
    978888,
    878887,
    877798,
    889977,
    889898,
    797787,
    879769,
    879988,
    886897,
    788798,
    899987,
    777877,
    786896,
    879998,
    688877,
    778987,
    687867,
    678789,
    787887,
    968788,
    989788,
    877998,
    877877,
    799788,
    888788,
    968978,
    878989,
    878978,
    896796,
    887887,
    777788,
    799778,
    869787,
    879798,
    778788,
    787888,
    777777,
    776887,
    877868,
    998788,
    877787,
    778899,
    979777,
    777789,
    969898,
    987987,
    867979,
    878687,
    798978,
    779876,
    898889,
    689799,
    888889,
    998978,
    688967,
    878987,
    788797,
    778799,
    988778,
    888797,
    888878,
    868887,
    799988,
    766887,
    776878,
    779778,
    888887,
    778978,
    899888,
    887887,
    886878,
    997998,
    776768,
    879888,
    998878,
    977878,
    888667,
    888868,
    778887,
    877877,
    889776,
    978998,
    789878,
    799867,
    879888,
    887767,
    879897,
    997789,
    778878,
    788788,
    786897,
    778867,
    778779,
    977978,
    796968,
    778887,
    878889,
    878999,
    778879,
    887898,
    777877,
    797868,
    877869,
    987788,
    668878,
    899887,
    898887,
    886987,
    989898,
    779697,
    887779,
    897968,
    778979,
    797987,
    798888,
    788886,
    777877,
    869877,
    878787,
    776879,
    778988,
    786887,
    898677,
    888876,
    888987,
    888797,
    978888,
    887868,
    788997,
    977877,
    897779,
    987887,
    777779,
    887897,
    967899,
    679868,
    778987,
    889878,
    979899,
    889978,
    968888,
    789978,
    798888,
    977887,
    977877,
    789869,
    877778,
    666799,
    679899,
    786797,
    886888,
    798888,
    978876,
    887778,
    877889,
    777878,
    898887,
    868877,
    787798,
    868889,
    878989,
    869767,
    788878,
    888779,
    789678,
    889779,
    898888,
    886877,
    787887,
    968788,
    788986,
    888978,
    898878,
    778888,
    878788,
    887889,
    776779,
    677797,
    688888,
    888887,
    888787,
    978887,
    788867,
    978897,
    678777,
    798888,
    889779,
    878878,
    888888,
    986777,
    988688,
    798896,
    877988,
    776987,
    697897,
    799876,
    797878,
    878777,
    877878,
    898887,
    687778,
    778878,
    686887,
    778886,
    798888,
    886876,
    988878,
    767989,
    897768,
    888888,
    886778,
    767767,
    778777,
    898779,
    778898,
    788889,
    887898,
    998986,
    888779,
    879788,
    879778,
    786787,
    889798,
    987987,
    779976,
    888788,
    899987,
    897868,
    788996,
    776868,
    887897,
    967778,
    767777,
    688887,
    899899,
    779878,
    788888,
    977776,
    888887,
    888777,
    799686,
    898798,
    787779,
    889898,
    897777,
    888878,
    897987,
    678776,
    767977,
    677698,
    878876,
    898868,
    788777,
    868977,
    788888,
    978997,
    877887,
    988898,
    788686,
    777977,
    777779,
    698679,
    888898,
    899897,
    878787,
    779787,
    889989,
    997889,
    778677,
    976688,
    979788,
    778698,
    888888,
    677797,
    898789,
    678898,
    887978,
    888989,
    879977,
    779779,
    768798,
    886779,
    887977,
    988897,
    776866,
    777798,
    799786,
    997768,
    788878,
    787797,
    888878,
    888887,
    687787,
    777878,
    899788,
    777997,
    777888,
    887778,
    889887,
    898887,
    887888,
    868988,
    779787,
    767798,
    799987,
    898786,
    989879,
    978778,
    979899,
    777887,
    886898,
    987987,
    877878,
    879777,
    797988,
    888678,
    788788,
    887978,
    887897,
    788788,
    878767,
    978879,
    888888,
    888999,
    787988,
    888678,
    898889,
    879867,
    797787,
    777888,
    789988,
    977677,
    888897,
    987888,
    888777,
    777897,
    997968,
    879887,
    697889,
    877877,
    788778,
    998879,
    786697,
    688868,
    988878,
    899679,
    888878,
    868796,
    878977,
    877878,
    697789,
    889879,
    898877,
    988687,
    898777,
    778897,
    779686,
    787769,
    967889,
    788887,
    897688,
    978788,
    777889,
    787897,
    787969,
    789899,
    986979,
    899879,
    897777,
    987689,
    787879,
    788887,
    978898,
    779677,
    878897,
    887888,
    878778,
    777687,
    887988,
    988897,
    897778,
    788999,
    778798,
    999898,
    879877,
    777887,
    667886,
    999789,
    889988,
    876978,
    887777,
    898998,
    769899,
    789679,
    978697,
    689899,
    999798,
    687797,
    888779,
    879778,
    787897,
    689768,
    897777,
    968977,
    876879,
    898777,
    877788,
    779868,
    787988,
    778888,
    877788,
    987789,
    987988,
    796778,
    777977,
    789787,
    997797,
    998777,
    889768,
    889878,
    798899,
    878899,
    879797,
    688868,
    777777,
    978787,
    778777,
    788887,
    898689,
    887878,
    886889,
    898889,
    866786,
    878989,
    887688,
    798788,
    878788,
    977798,
    888878,
    779889,
    879878,
    788888,
    797878,
    777978,
    878887,
    897897,
    787987,
    888899,
    899888,
    787887,
    788878,
    978798,
    977878,
    877889,
    789997,
    997788,
    787899,
    987798,
    887888,
    888669,
    778887,
    967969,
    787986,
    797869,
    887778,
    868788,
    788788,
    998877,
    889987,
    778878,
    888787,
    878776,
    888768,
    898787,
    988888,
    787877,
    879798,
    799799,
    787687,
    777879,
    898777,
    877888,
    897776,
    898978,
    688779,
    787889,
    888689,
    878899,
    978887,
    887797,
    897878,
    886886,
    789788,
    988779,
    877989,
    788779,
    978886,
    877999,
    897787,
    679888,
    876899,
    877888,
    978768,
    798987,
    797798,
    888989,
    688779,
    997888,
    968978,
    777868,
    978869,
    878787,
    986878,
    997788,
    898798,
    888787,
    898889,
    788898,
    879777,
    877988,
    777887,
    799997,
    899988,
    787977,
    888787,
    988777,
    898798,
    788787,
    788798,
    898989,
    879889,
    879687,
    778898,
    888779,
    986988,
    888798,
    798778,
    887899,
    889777,
    886788,
    797787,
    888897,
    877768,
    778789,
    889778,
    987799,
    877879,
    868788,
    987979,
    778878,
    969889,
    887979,
    967877,
    687787,
    866778,
    878889,
    797878,
    788879,
    989886,
    877878,
    998867,
    778678,
    787888,
    988879,
    767878,
    679777,
    768799,
    986687,
    797886,
    789698,
    988887,
    988898,
    886688,
    788678,
    888798,
    877687,
    889869,
    986886,
    778867,
    877887,
    988886,
    889978,
    778778,
    877868,
    878889,
    677778,
    887777,
    988887,
    888968,
    878997,
    777797,
    789868,
    888777,
    887889,
    778897,
    899788,
    798987,
    778778,
    888888,
    788897,
    978898,
    887987,
    787887,
    798899,
    886778,
    889788,
    698878,
    789788,
    877888,
    788888,
    998888,
    787778,
    877877,
    979988,
    879787,
    788679,
    887888,
    689777,
    878768,
    788798,
    787986,
    977677,
    689877,
    867787,
    868887,
    877866,
    897787,
    778877,
    988778,
    887797,
    888879,
    798897,
    777987,
    798987,
    897877,
    789978,
    788887,
    878888,
    889869,
    988777,
    979876,
    788888,
    886898,
    778999,
    679998,
    888688,
    779789,
    867888,
    898888,
    898889,
    879789,
    978779,
    788796,
    788789,
    878779,
    776978,
    878799,
    687879,
    788798,
    899887,
    678868,
    888788,
    889888,
    688788,
    886787,
    887799,
    797979,
    887987,
    897886,
    987897,
    778778,
    778788,
    888787,
    889878,
    779889,
    778798,
    878887,
    688768,
    789888,
    888987,
    888896,
    868877,
    777798,
    787888,
    767999,
    878889,
    897867,
    888989,
    878878,
    889788,
    878799,
    779899,
    999988,
    978778,
    788988,
    877988,
    977688,
    786898,
    778787,
    899798,
    877888,
    876978,
    987767,
    788789,
    787987,
    889769,
    878788,
    889999,
    897879,
    887887,
    898678,
    969888,
    787867,
    887987,
    898768,
    777869,
    767999,
    877778,
    878878,
    989897,
    888787,
    889888,
    877878,
    777888,
    787788,
    897766,
    778777,
    778887,
    987888,
    878778,
    686977,
    698887,
    887688,
    778999,
    788887,
    769898,
    987788,
    887979,
    887677,
    888787,
    788777,
    879888,
    778988,
    777889,
    798778,
    789888,
    987778,
    878898,
    888977,
    878897,
    799777,
    997787,
    788687,
    788778,
    888679,
    777789,
    888877,
    897788,
    868788,
    879788,
    888987,
    787887,
    986897,
    988989,
    987888,
    988977,
    877878,
    897868,
    687899,
    896988,
    697997,
    687878,
    788789,
    898788,
    897897,
    888798,
    787888,
    878869,
    987887,
    899889,
    978977,
    989988,
    789878,
    878776,
    887997,
    976899,
    897876,
    797767,
    787878,
    788998,
    989866,
    777899,
    978798,
    677888,
    988998,
    888789,
    868888,
    987667,
    879878,
    879777,
    888989,
    788677,
    989898,
    888768,
    787879,
    798877,
    778987,
    798778,
    687787,
    869779,
    988798,
    887889,
    787987,
    778976,
    889876,
    778787,
    689897,
    688887,
    888997,
    778998,
    797768,
    877688,
    878797,
    698877,
    889978,
    689697,
    896779,
    977787,
    878889,
    977887,
    876888,
    887879,
    988788,
    777877,
    887767,
    987788,
    888777,
    897787,
    798778,
    989788,
    878868,
    986687,
    788878,
    899797,
    788877,
    778697,
    898979,
    777887,
    876989,
    877677,
    788889,
    898779,
    878778,
    878886,
    788987,
    888878,
    877779,
    876898,
    779789,
    768988,
    888887,
    688768,
    788887,
    797988,
    987777,
    879887,
    877777,
    889878,
    777989,
    888788,
    877878,
    977787,
    788868,
    988787,
    688688,
    976678,
    778788,
    898789,
    988998,
    887877,
    889796,
    867986,
    879978,
    788998,
    798988,
    986988,
    999878,
    977998,
    898988,
    888988,
    976899,
    987899,
    878787,
    979889,
    898898,
    888987,
    898888,
    887888,
    887686,
    787777,
    878998,
    788787,
    778788,
    977767,
    779788,
    788898,
    787878,
    878667,
    967978,
    888877,
    888899,
    968887,
    968897,
    976779,
    888889,
    777898,
    798788,
    797779,
    899878,
    986867,
    997877,
    889989,
    879798,
    986776,
    789779,
    778678,
    999977,
    788876,
    798989,
    888679,
    776978,
    797888,
    799878,
    797787,
    887897,
    887988,
    878868,
    799877,
    799888,
    868888,
    687888,
    889898,
    777879,
    898899,
    869876,
    888788,
    989688,
    997889,
    787798,
    879887,
    679887,
    986787,
    788888,
    888867,
    887779,
    898777,
    888886,
    898879,
    997899,
    889997,
    987878,
    768878,
    878778,
    978778,
    897688,
    869788,
    888887,
    997788,
    777777,
    878878,
    779777,
    767887,
    688687,
    878778,
    788986,
    889887,
    888987,
    797887,
    869777,
    787978,
    999798,
    688896,
    889979,
    999897,
    787978,
    899978,
    978688,
    997887,
    877888,
    889988,
    888778,
    797789,
    788889,
    977797,
    877787,
    887787,
    888887,
    997778,
    888888,
    778996,
    899778,
    978987,
    679887,
    798888,
    876788,
    686789,
    889887,
    987787,
    777898,
    879887,
    888889,
    879767,
    888778,
    886978,
    667869,
    797777,
    788788,
    889968,
    878887,
    687779,
    789788,
    797987,
    787786,
    888779,
    878888,
    789877,
    868798,
    979897,
    888887,
    877887,
    997688,
    886889,
    988876,
    776798,
    887789,
    988879,
    987898,
    688888,
    897997,
    897887,
    998878,
    879788,
    879888,
    969787,
    977879,
    788979,
    787988,
    688988,
    889988,
    898787,
    888778,
    778988,
    879977,
    779887,
    998978,
    969777,
    988778,
    766697,
    768798,
    977878,
    878887,
    898878,
    778786,
    798799,
    897788,
    799869,
    678779,
    968877,
    987877,
    677898,
    888789,
    978777,
    778788,
    877896,
    888979,
    978779,
    889777,
    877879,
    888778,
    788967,
    987778,
    777887,
    998787,
    987868,
    878878,
    788888,
    878987,
    988987,
    887888,
    777878,
    678879,
    777888,
    798887,
    977789,
    788998,
    769969,
    897978,
    898977,
    977689,
    789898,
    896799,
    678878,
    879788,
    689797,
    787778,
    888678,
    887798,
    688976,
    988877,
    778788,
    777798,
    777778,
    789788,
    889778,
    997787,
    987697,
    878698,
    977897,
    877767,
    888888,
    668877,
    787887,
    778787,
    688977,
    678776,
    868897,
    798986,
    789777,
    788899,
    796899,
    978789,
    987889,
    787889,
    877999,
    877988,
    987998,
    788878,
    879987,
    687788,
    697887,
    898788,
    787898,
    888877,
    798897,
    777966,
    899789,
    778878,
    789678,
    979979,
    888878,
    877877,
    788889,
    878678,
    969988,
    989888,
    788897,
    788879,
    787978,
    788877,
    897688,
    778886,
    898887,
    878989,
    897978,
    789977,
    788897,
    889988,
    678889,
    878788,
    866678,
    779897,
    887777,
    788888,
    988977,
    888798,
    797778,
    898778,
    887787,
    989798,
    979787,
    887788,
    898887,
    998989,
    967778,
    778699,
    787787,
    867779,
    987778,
    989778,
    898888,
    788787,
    996869,
    788798,
    989888,
    786987,
    888788,
    799987,
    787879,
    988788,
    888878,
    878888,
    877997,
    888797,
    889767,
    879678,
    978897,
    888887,
    986787,
    988787,
    787868,
    878798,
    887877,
    768777,
    876787,
    778977,
    799878,
    767989,
    798779,
    789688,
    787788,
    877787,
    889987,
    788889,
    867969,
    888788,
    677798,
    778977,
    689778,
    988767,
    887768,
    886877,
    888888,
    789788,
    987778,
    688678,
    887778,
    887898,
    987889,
    897978,
    987888,
    767897,
    878788,
    878997,
    987778,
    787799,
    788877,
    998886,
    997879,
    988888,
    788778,
    788988,
    878798,
    987777,
    877787,
    777878,
    988898,
    888888,
    768778,
    888688,
    798788,
    779797,
    888987,
    987868,
    798887,
    987978,
    988778,
    677787,
    867678,
    788988,
    867899,
    799787,
    877768,
    897777,
    787778,
    978667,
    899887,
    977788,
    787778,
    897878,
    778987,
    777687,
    988888,
    879878,
    977689,
    886887,
    987688,
    987877,
    779977,
    787986,
    988767,
    887887,
    989699,
    899889,
    788987,
    889898,
    899977,
    878887,
    778797,
    999789,
    989898,
    778787,
    887976,
    978878,
    879878,
    878879,
    898798,
    877887,
    679877,
    777887,
    889877,
    777898,
    787986,
    878867,
    987787,
    876887,
    888876,
    778777,
    988779,
    888988,
    868788,
    988799,
    677777,
    878878,
    888789,
    968698,
    776869,
    867879,
    878799,
    778798,
    988777,
    899868,
    787679,
    977788,
    787878,
    889878,
    777789,
    888987,
    887879,
    778688,
    898988,
    877978,
    788788,
    879789,
    778788,
    969887,
    887688,
    978968,
    777998,
    987878,
    789879,
    777878,
    678888,
    887867,
    999988,
    977977,
    687798,
    877768,
    679877,
    676667,
    879977,
    878898,
    898899,
    877787,
    887899,
    898998,
    898779,
    877789,
    788876,
    778777,
    776898,
    868889,
    878978,
    988769,
    887888,
    978788,
    888868,
    877899,
    787888,
    998887,
    878878,
    878788,
    689878,
    697879,
    987978,
    797787,
    986789,
    778978,
    988788,
    977788,
    777888,
    888878,
    888778,
    887689,
    787788,
    997996,
    888997,
    987988,
    797868,
    998787,
    889978,
    877877,
    899787,
    786899,
    889888,
    898687,
    697797,
    678788,
    777878,
    889788,
    987877,
    869988,
    989777,
    988788,
    787779,
    799877,
    686888,
    897799,
    897797,
    777797,
    877898,
    798887,
    978877,
    787978,
    897868,
    898778,
    878788,
    879898,
    788887,
    887989,
    777788,
    788897,
    787777,
    878798,
    886788,
    878886,
    799888,
    979887,
    968898,
    799897,
    986998,
    968789,
    888989,
    978797,
    878798,
    798688,
    878878,
    977889,
    989888,
    967689,
    898787,
    979779,
    778888,
    779877,
    787897,
    787897,
    889876,
    878897,
    888867,
    787987,
    787778,
    886989,
    887997,
    788876,
    688778,
    789798,
    786878,
    787789,
    679788,
    988989,
    778788,
    887787,
    779887,
    879988,
    878888,
    898788,
    778887,
    797789,
    878877,
    779868,
    789688,
    786978,
    788887,
    878867,
    866879,
    877778,
    989888,
    677888,
    788978,
    887877,
    878888,
    888888,
    878887,
    888887,
    797798,
    898897,
    898889,
    788788,
    889778,
    896897,
    868798,
    978797,
    777787,
    788877,
    988768,
    998887,
    777687,
    987889,
    896877,
    878879,
    967877,
    889977,
    689888,
    888778,
    867888,
    788889,
    777779,
    877799,
    688988,
    787798,
    897978,
    887877,
    878777,
    897789,
    677789,
    778688,
    888978,
    877776,
    779888,
    889788,
    987878,
    968698,
    898888,
    979987,
    688887,
    888888,
    687886,
    999888,
    778987,
    888688,
    777787,
    878777,
    888799,
    868788,
    878978,
    989768,
    898878,
    898887,
    888768,
    679788,
    797778,
    989888,
    897868,
    978998,
    888879,
    777777,
    797788,
    997887,
    877778,
    898788,
    688877,
    878999,
    878789,
    879787,
    968899,
    887776,
    877768,
    887879,
    977778,
    888677,
    878879,
    788877,
    877988,
    879768,
    789888,
    788897,
    697888,
    788887,
    979897,
    887777,
    979878,
    889777,
    977878,
    779889,
    888788,
    777879,
    888699,
    788687,
    888996,
    878887,
    787877,
    798879,
    798987,
    786988,
    879779,
    879988,
    788778,
    667898,
    888697,
    998887,
    676788,
    878798,
    969888,
    798888,
    999778,
    687896,
    788889,
    979769,
    897887,
    988787,
    977877,
    879789,
    677878,
    987979,
    888987,
    898888,
    899887,
    998889,
    768799,
    987878,
    888998,
    977888,
    887688,
    787787,
    778797,
    878788,
    898889,
    999887,
    896869,
    978898,
    997987,
    878797,
    798788,
    787889,
    688787,
    989777,
    888798,
    888798,
    878689,
    898878,
    868788,
    898979,
    888876,
    978787,
    786886,
    897788,
    888998,
    889886,
    887898,
    878888,
    787879,
    889778,
    798876,
    886899,
    778789,
    897778,
    876888,
    868889,
    789979,
    768877,
    877778,
    879879,
    887989,
    878688,
    878898,
    998898,
    787878,
    868988,
    977778,
    888887,
    878899,
    687878,
    867789,
    697898,
    888887,
    879988,
    889798,
    888999,
    787786,
    687898,
    788888,
    678778,
    988898,
    788777,
    999777,
    989898,
    879877,
    776977,
    988988,
    977788,
    897989,
    877788,
    888897,
    867797,
    789878,
    787888,
    789997,
    998687,
    878667,
    697696,
    798878,
    877897,
    889887,
    876798,
    889978,
    679979,
    777886,
    989989,
    888888,
    876876,
    887868,
    788788,
    786777,
    968997,
    779878,
    777789,
    887897,
    977778,
    988988,
    878778,
    877878,
    888888,
    877687,
    988788,
    897888,
    877678,
    898876,
    876797,
    997988,
    998979,
    777788,
    887798,
    787887,
    898969,
    786877,
    796878,
    877899,
    678887,
    889999,
    988887,
    889788,
    777887,
    877897,
    888697,
    876998,
    788789,
    997878,
    679878,
    978898,
    897988,
    988869,
    778878,
    988888,
    988878,
    787887,
    787778,
    887787,
    786989,
    789997,
    898889,
    987879,
    788978,
    888768,
    667868,
    887889,
    788887,
    786887,
    997777,
    897966,
    877988,
    988787,
    877897,
    798968,
    787988,
    677889,
    899897,
    798897,
    898788,
    777878,
    988888,
    997979,
    888767,
    877779,
    778687,
    887967,
    676979,
    878888,
    687889,
    868788,
    899878,
    986887,
    887879,
    888979,
    787797,
    788887,
    688797,
    978786,
    877789,
    778997,
    879788,
    898778,
    997879,
    996987,
    897777,
    778779,
    687879,
    877888,
    888868,
    788877,
    897788,
    788899,
    878798,
    889878,
    889897,
    789789,
    878687,
    877977,
    766876,
    876869,
    776878,
    898778,
    887899,
    777787,
    877888,
    677987,
    887998,
    678898,
    897997,
    879789,
    888779,
    787879,
    697788,
    877888,
    887888,
    877788,
    898887,
    888787,
    886879,
    989989,
    988877,
    988787,
    976786,
    778867,
    898888,
    989978,
    698878,
    878898,
    867888,
    887899,
    889886,
    898887,
    888867,
    768977,
    887988,
    997899,
    878888,
    778777,
    987988,
    776998,
    878887,
    888888,
    778998,
    867968,
    777798,
    788777,
    977878,
    789787,
    898988,
    789888,
    887777,
    787797,
    798987,
    888878,
    987798,
    888788,
    877879,
    779868,
    987887,
    778788,
    888789,
    988988,
    887878,
    779868,
    689797,
    977886,
    878998,
    886879,
    997898,
    697779,
    887898,
    778987,
    787879,
    777889,
    878987,
    777968,
    898977,
    897979,
    788889,
    978888,
    888878,
    978787,
    879867,
    697799,
    778686,
    898887,
    798887,
    887688,
    788768,
    899989,
    777779,
    898889,
    979877,
    988778,
    778788,
    877887,
    789889,
    888899,
    788878,
    986878,
    998987,
    887887,
    798897,
    797787,
    997899,
    778997,
    977868,
    778887,
    786886,
    678887,
    787988,
    767777,
    888989,
    878788,
    888997,
    987967,
    888777,
    887899,
    986979,
    877799,
    988878,
    879876,
    778798,
    789988,
    897989,
    998669,
    787998,
    667877,
    787779,
    888889,
    877978,
    989878,
    679877,
    897697,
    777788,
    787788,
    787788,
    798789,
    788789,
    979888,
    797677,
    789777,
    897879,
    887779,
    769877,
    977966,
    877877,
    976776,
    978877,
    878886,
    886877,
    888868,
    887867,
    899888,
    788777,
    787876,
    889777,
    877977,
    989979,
    789667,
    788889,
    987977,
    787887,
    988889,
    877788,
    777887,
    897768,
    998898,
    787777,
    677889,
    778887,
    978888,
    888876,
    888888,
    798788,
    877798,
    777888,
    898788,
    888888,
    778988,
    688987,
    998788,
    967967,
    769786,
    787797,
    889888,
    986788,
    877998,
    877878,
    778979,
    998677,
    988868,
    786788,
    768898,
    788788,
    888787,
    987979,
    898786,
    787887,
    888987,
    778899,
    897777,
    987887,
    887998,
    977788,
    987877,
    778876,
    988889,
    869998,
    787878,
    876788,
    876898,
    878876,
    787877,
    877779,
    977988,
    778987,
    989678,
    879988,
    789978,
    877979,
    788797,
    899688,
    987878,
    797778,
    899989,
    879976,
    877778,
    887988,
    679688,
    778878,
    988998,
    788888,
    979889,
    869779,
    988788,
    988788,
    987786,
    887887,
    878887,
    899787,
    788786,
    887777,
    898877,
    788789,
    989788,
    987989,
    978767,
    987787,
    787888,
    787878,
    866899,
    788988,
    678997,
    887887,
    988888,
    678887,
    777888,
    899887,
    997986,
    878989,
    888788,
    788887,
    877898,
    777888,
    778897,
    888897,
    899788,
    877989,
    778988,
    698968,
    777898,
    778878,
    677989,
    887768,
    777997,
    888869,
    679978,
    988778,
    788869,
    988898,
    768878,
    778869,
    779888,
    878688,
    879878,
    877877,
    787868,
    898678,
    897787,
    687987,
    998689,
    987788,
    887778,
    888867,
    898687,
    977778,
    989898,
    898987,
    777887,
    796878,
    897877,
    798898,
    989888,
    868888,
    797687,
    777888,
    788687,
    997888,
    878978,
    878888,
    799987,
    887788,
    878978,
    887889,
    889778,
    777978,
    698899,
    888998,
    677978,
    798898,
    777989,
    998886,
    887877,
    789879,
    888787,
    877876,
    778796,
    678888,
    967788,
    788787,
    789789,
    778688,
    787788,
    879887,
    788898,
    899876,
    978897,
    787878,
    878888,
    877678,
    778899,
    788777,
    899788,
    898889,
    787878,
    988878,
    888677,
    787888,
    878989,
    897986,
    789877,
    789987,
    898789,
    868799,
    978868,
    888798,
    877898,
    877788,
    987998,
    988897,
    999687,
    998888,
    877679,
    897989,
    888989,
    698887,
    788789,
    778888,
    887876,
    797989,
    798989,
    887889,
    987788,
    988789,
    978979,
    787797,
    768878,
    887879,
    977789,
    889987,
    979787,
    897877,
    777897,
    878977,
    787987,
    778799,
    788888,
    979897,
    889878,
    869878,
    788878,
    888887,
    878976,
    897879,
    887788,
    878876,
    768988,
    997876,
    877788,
    788878,
    787999,
    697878,
    979877,
    798887,
    876897,
    986779,
    778897,
    767979,
    897887,
    776888,
    868889,
    769878,
    768788,
    898897,
    787787,
    987897,
    987788,
    776789,
    868769,
    889978,
    897887,
    798688,
    767987,
    878886,
    787987,
    867878,
    777967,
    869888,
    998888,
    987798,
    778698,
    997967,
    867779,
    787797,
    878878,
    789698,
    778787,
    877877,
    988888,
    968897,
    997767,
    887777,
    689899,
    879677,
    878778,
    888887,
    797689,
    988687,
    778998,
    977787,
    668876,
    977888,
    688878,
    977888,
    987897,
    888988,
    787787,
    798877,
    976898,
    788987,
    888878,
    677989,
    878778,
    898777,
    888879,
    876877,
    988868,
    787878,
    987887,
    898877,
    697867,
    887767,
    787878,
    779878,
    987977,
    778776,
    877888,
    778688,
    979787,
    687888,
    788879,
    867877,
    988776,
    877789,
    778998,
    669797,
    988897,
    999778,
    788888,
    888877,
    888989,
    787878,
    799889,
    788697,
    669788,
    988997,
    779898,
    869777,
    787978,
    888779,
    886887,
    998879,
    888988,
    779798,
    877788,
    799797,
    887878,
    778777,
    797776,
    877778,
    898788,
    996889,
    888787,
    778788,
    889887,
    988767,
    687689,
    798897,
    798788,
    887887,
    888777,
    789887,
    978888,
    887886,
    997889,
    799788,
    878886,
    989789,
    986878,
    778978,
    888787,
    888897,
    787888,
    877878,
    797878,
    888779,
    898977,
    977886,
    788888,
    987967,
    898788,
    897897,
    878888,
    778768,
    978878,
    987889,
    788787,
    897888,
    887887,
    989898,
    777969,
    879778,
    877788,
    897878,
    778897,
    677778,
    988787,
    768876,
    679786,
    877778,
    978798,
    987978,
    977788,
    686696,
    788778,
    986788,
    787789,
    798878,
    879787,
    887888,
    878967,
    797879,
    776668,
    887788,
    977788,
    987978,
    898787,
    898788,
    988888,
    997887,
    788879,
    887767,
    799878,
    777879,
    789787,
    878678,
    786789,
    798777,
    877888,
    889687,
    877888,
    889868,
    897979,
    678778,
    888787,
    687778,
    978988,
    888767,
    878879,
    798887,
    867988,
    889777,
    998878,
    889989,
    787788,
    778778,
    769699,
    778988,
    778779,
    879898,
    968678,
    878788,
    879798,
    886887,
    987878,
    878969,
    798989,
    798699,
    777968,
    788977,
    768878,
    888787,
    788878,
    987879,
    888787,
    889788,
    877989,
    977679,
    688788,
    897977,
    799988,
    767978,
    979977,
    999787,
    788976,
    878887,
    778888,
    878987,
    788689,
    798879,
    877979,
    877898,
    778999,
    788878,
    998977,
    867777,
    888867,
    788889,
    889876,
    889886,
    778876,
    968687,
    798787,
    779877,
    768997,
    788888,
    979779,
    978868,
    978987,
    668788,
    788879,
    998787,
    797868,
    799887,
    898898,
    888876,
    877796,
    789877,
    977878,
    788899,
    798788,
    789796,
    878768,
    789876,
    788977,
    799777,
    879898,
    778988,
    977877,
    679887,
    897796,
    778988,
    798887,
    888767,
    897688,
    688779,
    788967,
    787789,
    879688,
    798777,
    987986,
    888887,
    888887,
    887887,
    798688,
    987977,
    889897,
    977797,
    788789,
    989787,
    778797,
    787689,
    897866,
    898877,
    679887,
    988987,
    878697,
    889877,
    998777,
    887888,
    687978,
    888788,
    878987,
    878886,
    878898,
    787987,
    688879,
    887867,
    988788,
    888978,
    888888,
    898878,
    988889,
    879978,
    897789,
    787988,
    877897,
    777887,
    789987,
    878786,
    998988,
    877868,
    787788,
    889787,
    898768,
    978687,
    888778,
    766879,
    997798,
    689988,
    876878,
    797888,
    879778,
    799986,
    899788,
    787769,
    979798,
    688777,
    889887,
    978997,
    679788,
    798888,
    878798,
    879978,
    878876,
    878889,
    776689,
    987788,
    889899,
    877788,
    788698,
    986789,
    897989,
    769887,
    968888,
    887889,
    788887,
    787778,
    888887,
    978667,
    996778,
    867888,
    799787,
    878888,
    876688,
    669779,
    878977,
    887787,
    678977,
    789978,
    687689,
    787687,
    778998,
    679797,
    876798,
    788788,
    998897,
    789889,
    678778,
    879777,
    968769,
    887888,
    789888,
    879989,
    888767,
    689878,
    887877,
    886797,
    678688,
    888997,
    678879,
    868879,
    798887,
    989887,
    779689,
    977897,
    977869,
    887677,
    988778,
    998879,
    988988,
    788988,
    998899,
    689887,
    987897,
    796899,
    876899,
    889777,
    877878,
    898877,
    778869,
    887887,
    988888,
    777777,
    687977,
    889887,
    887879,
    786896,
    896989,
    867879,
    889979,
    797987,
    879888,
    899977,
    998988,
    878978,
    868877,
    888889,
    787789,
    968998,
    978969,
    878878,
    678787,
    888978,
    878889,
    998878,
    697778,
    976897,
    887977,
    876978,
    989878,
    679888,
    899788,
    877797,
    888779,
    989798,
    897988,
    778878,
    979889,
    778988,
    678887,
    989779,
    787788,
    767887,
    897778,
    776789,
    877788,
    778779,
    778787,
    977799,
    777898,
    777889,
    778988,
    879899,
    888678,
    977888,
    888988,
    876897,
    897787,
    898997,
    867886,
    888888,
    787777,
    979886,
    887878,
    997767,
    878678,
    788798,
    777889,
    787878,
    779777,
    878787,
    778878,
    688889,
    798868,
    987688,
    987988,
    888978,
    777678,
    898888,
    699788,
    777888,
    798767,
    768867,
    778988,
    979697,
    799777,
    798887,
    987887,
    789698,
    996789,
    888788,
    878778,
    787977,
    897989,
    898768,
    767978,
    897796,
    888877,
    798678,
    979888,
    988987,
    888988,
    997776,
    866899,
    888887,
    877878,
    799988,
    987787,
    878788,
    798898,
    868888,
    777888,
    787887,
    787779,
    898778,
    988987,
    998887,
    798787,
    777777,
    866876,
    689798,
    976899,
    878888,
    879788,
    898898,
    887977,
    787677,
    879777,
    878787,
    987998,
    877778,
    878788,
    998876,
    988979,
    868987,
    777888,
    898888,
    878797,
    988787,
    888898,
    878897,
    999878,
    877977,
    978778,
    989989,
    788788,
    797788,
    776788,
    987777,
    787778,
    778888,
    868977,
    778997,
    888778,
    798878,
    886887,
    867789,
    997888,
    888898,
    969889,
    876778,
    797787,
    887787,
    879878,
    968788,
    998878,
    988887,
    798988,
    877787,
    796788,
    879987,
    977787,
    877799,
    799787,
    777679,
    688887,
    979787,
    986877,
    787776,
    888978,
    778888,
    798876,
    887879,
    866988,
    887798,
    786996,
    788898,
    768788,
    687898,
    669776,
    977777,
    777898,
    986778,
    869877,
    997787,
    787778,
    888898,
    888998,
    988887,
    868868,
    788999,
    897779,
    887889,
    888779,
    786978,
    977878,
    779976,
    877898,
    879979,
    898888,
    898878,
    698679,
    799788,
    879798,
    978867,
    789888,
    788676,
    888798,
    978888,
    689978,
    788778,
    889887,
    788877,
    898996,
    879798,
    687897,
    879888,
    977897,
    897889,
    897799,
    878887,
    798788,
    779987,
    888689,
    787798,
    898879,
    689767,
    789799,
    978878,
    798888,
    898977,
    988787,
    899887,
    989787,
    798886,
    988887,
    798897,
    767779,
    799889,
    868798,
    989888,
    888776,
    777999,
    779897,
    798799,
    888778,
    888688,
    887999,
    687877,
    889778,
    879778,
    886689,
    779778,
    878888,
    878879,
    877878,
    888877,
    798888,
    987777,
    897979,
    797788,
    767878,
    888887,
    878789,
    999788,
    898979,
    897779,
    868888,
    787886,
    878788,
    968778,
    888987,
    878788,
    898996,
    888989,
    977998,
    778897,
    887888,
    796987,
    878878,
    979978,
    978788,
    887898,
    787778,
    889888,
    778897,
    788887,
    786887,
    896798,
    968798,
    898787,
    998768,
    767889,
    777798,
    888889,
    787888,
    987786,
    888879,
    978978,
    888987,
    888877,
    788887,
    897887,
    897888,
    888788,
    788779,
    899889,
    668879,
    898788,
    778778,
    789898,
    778878,
    786967,
    886878,
    987787,
    878888,
    998898,
    888788,
    969776,
    789778,
    889886,
    978877,
    879698,
    787988,
    878776,
    988899,
    867898,
    877979,
    888787,
    789887,
    887989,
    988986,
    888789,
    978888,
    888788,
    888778,
    998968,
    888989,
    789789,
    788878,
    679877,
    889778,
    788797,
    887777,
    889977,
    787898,
    887779,
    967887,
    787896,
    878889,
    778789,
    767997,
    778877,
    786877,
    798679,
    888878,
    789777,
    798766,
    778987,
    679978,
    988787,
    977977,
    687899,
    888889,
    887877,
    888988,
    787786,
    968877,
    778897,
    899789,
    887878,
    877767,
    889778,
    879777,
    878888,
    786677,
    777878,
    989788,
    987787,
    878777,
    978779,
    888777,
    788788,
    887878,
    888896,
    687897,
    878787,
    778779,
    988778,
    899887,
    789877,
    888968,
    876888,
    877988,
    777787,
    887896,
    889996,
    878788,
    969888,
    789788,
    888877,
    878987,
    877797,
    688777,
    888878,
    876798,
    878778,
    789898,
    786777,
    878889,
    888787,
    879889,
    888887,
    789789,
    877878,
    899898,
    989897,
    687687,
    888789,
    877778,
    889787,
    977978,
    967689,
    878768,
    777786,
    899788,
    688679,
    887877,
    877886,
    867887,
    889799,
    777787,
    798889,
    888879,
    887887,
    988879,
    888877,
    787766,
    879776,
    678778,
    888968,
    888887,
    987999,
    889777,
    898799,
    786987,
    887898,
    778997,
    779887,
    898687,
    978867,
    699896,
    998897,
    889888,
    878779,
    898988,
    887998,
    898778,
    979798,
    988889,
    987887,
    887777,
    878788,
    898779,
    788887,
    789887,
    788779,
    897798,
    788769,
    877878,
    679989,
    979678,
    777897,
    878898,
    767797,
    987899,
    988687,
    799788,
    679988,
    789898,
    786878,
    888788,
    797777,
    988789,
    887878,
    889878,
    777798,
    688778,
    787688,
    886888,
    979688,
    889867,
    886888,
    677999,
    798697,
    997789,
    989988,
    788788,
    696989,
    899777,
    887878,
    778887,
    798768,
    887667,
    887987,
    777888,
    988689,
    867679,
    877889,
    978767,
    869777,
    887978,
    886776,
    788987,
    787898,
    877776,
    979878,
    768778,
    876768,
    898897,
    989888,
    889766,
    878789,
    978787,
    989889,
    987698,
    888788,
    997678,
    878889,
    898888,
    787898,
    787688,
    889697,
    778798,
    878777,
    878898,
    888778,
    687878,
    889688,
    689799,
    988888,
    888798,
    778988,
    888898,
    888688,
    779789,
    887888,
    887879,
    787868,
    778877,
    999988,
    796898,
    997787,
    898977,
    798886,
    778787,
    778877,
    997878,
    888878,
    889788,
    888678,
    889689,
    797786,
    789898,
    698779,
    896987,
    887786,
    798876,
    788789,
    876787,
    978787,
    998898,
    778978,
    796867,
    998998,
    778997,
    876866,
    888779,
    987777,
    788786,
    778788,
    887978,
    877988,
    787787,
    779787,
    778877,
    878798,
    778888,
    899777,
    897678,
    889779,
    988878,
    997888,
    899879,
    789778,
    896978,
    788788,
    978988,
    897887,
    888897,
    887877,
    978989,
    777868,
    689898,
    778877,
    888899,
    798999,
    866777,
    889798,
    978977,
    689887,
    977778,
    688978,
    888887,
    898989,
    987787,
    879676,
    777988,
    697878,
    789788,
    798979,
    887997,
    978867,
    888888,
    778677,
    988878,
    878869,
    878778,
    888876,
    988797,
    788868,
    996987,
    877887,
    787777,
    879877,
    977889,
    779889,
    878878,
    788898,
    988878,
    997878,
    887877,
    878787,
    787878,
    777898,
    769777,
    798889,
    877887,
    697787,
    887787,
    879977,
    786978,
    987688,
    687998,
    988888,
    987799,
    987768,
    898878,
    877867,
    786788,
    799887,
    877878,
    798889,
    987777,
    788868,
    888987,
    898877,
    877869,
    899887,
    879887,
    987889,
    788877,
    689867,
    988779,
    889798,
    787769,
    888786,
    989778,
    788797,
    796779,
    767887,
    978799,
    788687,
    779798,
    799678,
    878876,
    998878,
    767787,
    777988,
    889777,
    887987,
    777877,
    788988,
    897899,
    879878,
    797887,
    898969,
    888769,
    888799,
    778777,
    887778,
    898687,
    677998,
    987889,
    879876,
    878978,
    688687,
    879777,
    888878,
    869977,
    887778,
    789898,
    878887,
    889788,
    788987,
    779988,
    997977,
    887877,
    788878,
    899788,
    977998,
    998689,
    978887,
    996787,
    788687,
    987778,
    898786,
    887988,
    787977,
    787877,
    888897,
    979788,
    898896,
    889988,
    779876,
    898889,
    899889,
    777966,
    887786,
    689988,
    787777,
    788798,
    897999,
    798898,
    877886,
    888899,
    788998,
    777889,
    888779,
    887777,
    698887,
    877788,
    788779,
    998867,
    778797,
    887796,
    877679,
    788988,
    778698,
    889778,
    978977,
    788677,
    787687,
    888788,
    889887,
    997796,
    877787,
    877979,
    878877,
    897896,
    787787,
    967788,
    789789,
    688888,
    779788,
    889788,
    787797,
    887698,
    978769,
    897688,
    877877,
    877877,
    878998,
    778797,
    797987,
    889879,
    887879,
    779778,
    878797,
    779969,
    888787,
    898787,
    887767,
    797778,
    797688,
    989888,
    997979,
    787799,
    888788,
    798778,
    688989,
    797787,
    877987,
    788779,
    877789,
    967789,
    777789,
    797777,
    989788,
    797888,
    787778,
    778877,
    779788,
    877778,
    878997,
    789998,
    899786,
    886778,
    688778,
    887699,
    978989,
    779877,
    798887,
    877977,
    888888,
    688878,
    679889,
    778978,
    788878,
    768898,
    986887,
    867877,
    977788,
    797898,
    888898,
    787979,
    977777,
    988877,
    787787,
    888689,
    788896,
    879768,
    897877,
    789789,
    877787,
    778868,
    699778,
    786886,
    897798,
    887978,
    978797,
    886877,
    989888,
    888898,
    888787,
    888888,
    798876,
    899789,
    888889,
    788789,
    678778,
    988778,
    788888,
    889877,
    888987,
    888788,
    777798,
    878898,
    778779,
    869768,
    889877,
    889988,
    788876,
    888886,
    869778,
    879779,
    768877,
    989778,
    787977,
    788987,
    879997,
    888798,
    878778,
    977687,
    867778,
    789898,
    767898,
    887876,
    897887,
    889676,
    678977,
    879878,
    878878,
    888898,
    877879,
    778988,
    987797,
    787879,
    886777,
    779877,
    889979,
    888998,
    787777,
    789888,
    788786,
    777978,
    987679,
    868777,
    778998,
    787878,
    789868,
    888889,
    878996,
    788777,
    788888,
    788877,
    878987,
    888789,
    768789,
    968879,
    777968,
    777878,
    786888,
    687879,
    797798,
    889886,
    897889,
    877867,
    999798,
    799788,
    779887,
    688888,
    987777,
    877687,
    688889,
    786869,
    878988,
    968799,
    987798,
    788879,
    988888,
    978978,
    786889,
    876778,
    888778,
    877697,
    677778,
    876889,
    779989,
    878977,
    897888,
    878688,
    878798,
    988877,
    876988,
    997888,
    788778,
    887889,
    978767,
    878889,
    987899,
    889887,
    987889,
    798779,
    878996,
    987888,
    797888,
    887889,
    778887,
    879667,
    767887,
    898788,
    767778,
    868778,
    988889,
    797789,
    977778,
    886877,
    988787,
    788698,
    878888,
    978988,
    778898,
    797778,
    988876,
    989787,
    878797,
    798898,
    788779,
    787799,
    997988,
    697878,
    789898,
    988979,
    777787,
    887987,
    888787,
    799898,
    998778,
    868687,
    899888,
    887778,
    887898,
    986778,
    976797,
    887876,
    778888,
    686997,
    877787,
    879787,
    987968,
    877889,
    787788,
    879868,
    986878,
    888787,
    877979,
    889997,
    998799,
    968777,
    887786,
    978766,
    987896,
    878979,
    968876,
    887789,
    988779,
    978898,
    766887,
    799689,
    878868,
    788878,
    778987,
    889778,
    987787,
    876886,
    877978,
    776977,
    877787,
    898798,
    988888,
    887788,
    898678,
    777788,
    878778,
    987987,
    877777,
    889698,
    687888,
    888887,
    878997,
    776779,
    888799,
    766899,
    786976,
    898889,
    989887,
    798788,
    897687,
    978868,
    978888,
    768798,
    888997,
    798797,
    998888,
    887778,
    779687,
    886897,
    787878,
    898977,
    898996,
    867777,
    789878,
    778778,
    978788,
    678778,
    878687,
    887877,
    977787,
    769878,
    987978,
    787869,
    897988,
    789688,
    788879,
    779878,
    797688,
    878976,
    877788,
    889877,
    877878,
    699977,
    888976,
    877798,
    887988,
    978798,
    897878,
    888887,
    877788,
    989788,
    896979,
    988797,
    888888,
    897689,
    788878,
    888899,
    797788,
    789978,
    996869,
    698877,
    778798,
    899778,
    878788,
    777797,
    879896,
    887797,
    787888,
    878777,
    678878,
    968779,
    779789,
    878777,
    787898,
    987689,
    786886,
    877889,
    868868,
    878789,
    788888,
    879778,
    879788,
    869788,
    869967,
    768887,
    788777,
    888789,
    889887,
    797899,
    896888,
    867879,
    887879,
    787969,
    687888,
    878878,
    887978,
    878987,
    877786,
    899877,
    989777,
    877788,
    687766,
    889896,
    977788,
    789898,
    979799,
    778787,
    997898,
    789878,
    889888,
    677767,
    868989,
    687877,
    788888,
    979786,
    778897,
    778789,
    897887,
    686889,
    688979,
    788977,
    869777,
    889697,
    878779,
    887777,
    989897,
    777987,
    678886,
    798878,
    878878,
    889888,
    866768,
    877877,
    698989,
    687878,
    689778,
    788967,
    898968,
    878867,
    879988,
    768777,
    767988,
    778798,
    868887,
    998787,
    986788,
    887879,
    888889,
    777998,
    867887,
    999677,
    978866,
    877778,
    889788,
    676788,
    967767,
    889788,
    788899,
    777889,
    887897,
    777787,
    887968,
    896998,
    986878,
    797887,
    896896,
    677898,
    998888,
    798687,
    686977,
    879778,
    787877,
    887878,
    878987,
    797778,
    788796,
    998877,
    878888,
    777898,
    799968,
    797879,
    788887,
    887778,
    778888,
    787977,
    789788,
    887787,
    996678,
    967888,
    888878,
    988988,
    787868,
    877987,
    888788,
    867779,
    778987,
    788788,
    888989,
    888867,
    887899,
    879878,
    799988,
    887887,
    977898,
    987767,
    687878,
    779789,
    987787,
    778799,
    879798,
    868887,
    878889,
    888787,
    778788,
    887877,
    869779,
    887877,
    799788,
    777788,
    876788,
    798699,
    767687,
    887788,
    777888,
    898779,
    989779,
    776987,
    779979,
    889788,
    768888,
    789787,
    999787,
    888789,
    878777,
    869788,
    878687,
    867787,
    896888,
    797999,
    988788,
    887877,
    877778,
    778776,
    988797,
    788797,
    787778,
    697876,
    879698,
    887987,
    787978,
    887789,
    798788,
    789877,
    787967,
    788889,
    877879,
    769669,
    878889,
    986688,
    788888,
    989778,
    888688,
    889889,
    996887,
    788877,
    868686,
    877789,
    998878,
    888877,
    879887,
    798778,
    888898,
    889798,
    768669,
    777899,
    788978,
    877988,
    798888,
    878789,
    878778,
    889698,
    788898,
    897668,
    777998,
    888678,
    879879,
    879899,
    988788,
    877777,
    877988,
    799879,
    878978,
    888788,
    779868,
    877878,
    997898,
    888868,
    787899,
    888988,
    888786,
    696887,
    888888,
    797898,
    797988,
    978997,
    896886,
    887777,
    898968,
    777889,
    788999,
    796899,
    779878,
    779778,
    797988,
    898797,
    777788,
    687788,
    769987,
    888867,
    898888,
    889778,
    888887,
    788879,
    787798,
    969869,
    878897,
    876788,
    877878,
    678888,
    978899,
    987896,
    876976,
    878979,
    887788,
    797868,
    988888,
    766877,
    789788,
    867788,
    997876,
    788886,
    888798,
    977876,
    898998,
    987977,
    889889,
    878998,
    777788,
    786888,
    778888,
    877878,
    888888,
    877778,
    868678,
    898999,
    788778,
    897789,
    888797,
    897987,
    979788,
    888979,
    998879,
    887789,
    688788,
    798799,
    967789,
    977999,
    668798,
    787888,
    779987,
    787878,
    877887,
    799786,
    777799,
    787779,
    887688,
    777878,
    978898,
    989988,
    878886,
    987977,
    887869,
    997887,
    898988,
    898889,
    879789,
    898787,
    786779,
    999876,
    988888,
    778996,
    988788,
    988977,
    768787,
    898898,
    778888,
    787778,
    887777,
    788887,
    879987,
    886777,
    987998,
    799887,
    897998,
    876699,
    879898,
    879879,
    777778,
    888887,
    778788,
    968998,
    977787,
    698698,
    887888,
    898789,
    679987,
    889868,
    769767,
    767979,
    689878,
    878877,
    888788,
    798789,
    778777,
    887879,
    787769,
    898777,
    689789,
    878778,
    767877,
    798797,
    889899,
    789788,
    877978,
    788778,
    679788,
    789688,
    776899,
    779887,
    779789,
    897778,
    788988,
    898899,
    776888,
    886879,
    878897,
    898798,
    998888,
    789866,
    688886,
    879886,
    888798,
    698777,
    877977,
    978989,
    778877,
    898888,
    889786,
    969998,
    797999,
    778779,
    888877,
    777787,
    886888,
    888888,
    888879,
    988797,
    899988,
    987778,
    877788,
    899688,
    787688,
    897786,
    899787,
    799897,
    898899,
    879989,
    868788,
    788789,
    968787,
    999999,
    687687,
    889888,
    879999,
    786887,
    888789,
    899898,
    999879,
    697797,
    788999,
    888787,
    989778,
    688878,
    779778,
    976869,
    888877,
    788999,
    977977,
    888887,
    788878,
    777889,
    898778,
    777787,
    978878,
    798869,
    788988,
    779797,
    888787,
    986979,
    788688,
    779787,
    787978,
    967789,
    779667,
    797887,
    888867,
    787769,
    768988,
    867899,
    987778,
    979986,
    777788,
    868878,
    877688,
    788887,
    887689,
    778889,
    778889,
    779898,
    897899,
    778788,
    879787,
    878877,
    878979,
    797998,
    789977,
    788876,
    886769,
    787868,
    999688,
    887967,
    888889,
    798889,
    889986,
    977978,
    997888,
    777877,
    868878,
    888868,
    778798,
    888789,
    787788,
    978787,
    888898,
    776778,
    789798,
    797787,
    798879,
    789767,
    889877,
    678778,
    896876,
    778878,
    779778,
    768969,
    887877,
    698887,
    897887,
    879777,
    879866,
    887877,
    798877,
    899987,
    987887,
    878878,
    877778,
    899888,
    989968,
    887778,
    878879,
    889878,
    878866,
    788698,
    886788,
    897979,
    789788,
    787898,
    987688,
    868998,
    886988,
    878898,
    878977,
    889899,
    787887,
    867797,
    889787,
    777898,
    877968,
    787888,
    887788,
    887786,
    878888,
    779888,
    899789,
    987888,
    788888,
    789777,
    887988,
    888787,
    778996,
    797789,
    888977,
    778979,
    887888,
    677897,
    898988,
    798879,
    798796,
    888878,
    887687,
    788798,
    889888,
    778889,
    978788,
    889977,
    997878,
    977887,
    986878,
    878787,
    888888,
    877879,
    677798,
    867868,
    887789,
    988868,
    878699,
    898877,
    888686,
    886898,
    876889,
    878789,
    978789,
    988887,
    788988,
    978679,
    778778,
    888888,
    799779,
    778879,
    888987,
    898888,
    678786,
    978988,
    987887,
    879886,
    798686,
    898889,
    697789,
    887768,
    788787,
    888798,
    998977,
    797787,
    986779,
    878898,
    778677,
    879877,
    988979,
    797878,
    977668,
    987897,
    987778,
    879777,
    868877,
    788879,
    879778,
    897787,
    889776,
    998779,
    888888,
    687778,
    789768,
    778889,
    798887,
    878778,
    988988,
    698888,
    988788,
    788989,
    897888,
    997988,
    888868,
    978888,
    797887,
    769787,
    768886,
    888679,
    887777,
    776778,
    997987,
    868888,
    897799,
    898778,
    788798,
    878978,
    887698,
    977878,
    888788,
    897878,
    898977,
    987887,
    777978,
    888897,
    898979,
    998768,
    887877,
    978787,
    878899,
    777898,
    898897,
    676978,
    877889,
    989887,
    878989,
    877877,
    888889,
    667877,
    998998,
    898678,
    887898,
    778888,
    977998,
    898879,
    997777,
    876977,
    998899,
    888687,
    776997,
    889897,
    779877,
    886977,
    878878,
    799886,
    988887,
    989778,
    788887,
    777868,
    768877,
    968777,
    867867,
    788989,
    788677,
    889776,
    897879,
    776889,
    878788,
    978987,
    796788,
    898997,
    997887,
    698798,
    898788,
    787979,
    979987,
    878777,
    888987,
    989988,
    778988,
    879879,
    788878,
    978778,
    678887,
    689887,
    998899,
    987677,
    987788,
    897898,
    878888,
    888797,
    788897,
    877888,
    878788,
    878788,
    888778,
    788888,
    999986,
    989889,
    877998,
    978789,
    899877,
    778897,
    888787,
    889979,
    988868,
    888988,
    688879,
    899769,
    897876,
    777898,
    977988,
    788787,
    878789,
    789877,
    789787,
    978788,
    887687,
    887997,
    889798,
    898898,
    688889,
    796778,
    886989,
    798888,
    867776,
    997998,
    788878,
    787877,
    778797,
    987887,
    788987,
    798886,
    788888,
    778777,
    888888,
    878978,
    897998,
    887886,
    979878,
    889779,
    898888,
    687987,
    998788,
    788777,
    797978,
    788788,
    888878,
    866879,
    888687,
    988798,
    889878,
    978799,
    976887,
    989787,
    897988,
    889868,
    977799,
    867797,
    776777,
    787688,
    877879,
    887889,
    888788,
    877779,
    687988,
    977778,
    888989,
    878788,
    987788,
    879786,
    888888,
    887877,
    679789,
    877887,
    688897,
    897997,
    779999,
    898698,
    888999,
    886687,
    777889,
    879888,
    877896,
    778979,
    777888,
    887877,
    777878,
    979887,
    877867,
    788979,
    778778,
    877998,
    799797,
    766788,
    786978,
    887787,
    878968,
    668976,
    697989,
    797898,
    867997,
    768989,
    878986,
    798887,
    888979,
    978877,
    969977,
    778767,
    779897,
    979987,
    897876,
    678878,
    887878,
    787988,
    878878,
    777888,
    798877,
    988888,
    788797,
    788798,
    877987,
    789887,
    777678,
    887898,
    987988,
    888977,
    997768,
    888787,
    799898,
    878879,
    989887,
    797877,
    877886,
    786877,
    879968,
    786777,
    688686,
    979869,
    889888,
    999898,
    878968,
    778897,
    889779,
    888889,
    977887,
    977899,
    986897,
    887778,
    877878,
    887788,
    878797,
    797899,
    977877,
    798888,
    787989,
    798898,
    967998,
    697897,
    976878,
    896788,
    866889,
    888788,
    987798,
    786899,
    799887,
    888777,
    877789,
    879879,
    689789,
    777888,
    888899,
    686898,
    787998,
    988878,
    887898,
    788877,
    978878,
    886887,
    787798,
    877789,
    979699,
    988898,
    879778,
    888788,
    878979,
    978886,
    768796,
    998676,
    788888,
    899887,
    878798,
    779887,
    889869,
    798796,
    987777,
    797897,
    889897,
    877776,
    788787,
    988969,
    777788,
    988987,
    888779,
    797997,
    779896,
    787797,
    978878,
    788889,
    688887,
    886789,
    798767,
    878768,
    898678,
    989888,
    887888,
    888788,
    879867,
    887889,
    678787,
    778778,
    887789,
    888887,
    968687,
    789898,
    778888,
    889886,
    768988,
    898877,
    788778,
    797787,
    878788,
    977779,
    899878,
    997878,
    888998,
    888897,
    988678,
    978797,
    687987,
    868686,
    777896,
    887887,
    688788,
    898877,
    899778,
    788877,
    777878,
    986787,
    688988,
    777898,
    877877,
    888788,
    688878,
    778798,
    979767,
    787897,
    788878,
    889877,
    779779,
    789889,
    986788,
    777877,
    789789,
    777877,
    888889,
    767879,
    788787,
    688888,
    876796,
    787797,
    789878,
    986987,
    978889,
    878977,
    897799,
    888776,
    788778,
    897789,
    879998,
    998897,
    778878,
    787878,
    897788,
    898898,
    897789,
    798778,
    898888,
    767877,
    879798,
    989887,
    877978,
    978889,
    978888,
    876798,
    887778,
    898898,
    788989,
    877786,
    888887,
    778977,
    787787,
    898897,
    968788,
    787788,
    887968,
    898778,
    797877,
    878797,
    977987,
    988887,
    786787,
    799887,
    898778,
    778887,
    899788,
    687799,
    788778,
    797778,
    888688,
    997978,
    688899,
    887787,
    889787,
    987778,
    878877,
    999888,
    787878,
    778788,
    778787,
    878786,
    789888,
    887887,
    768779,
    987878,
    768888,
    787888,
    877978,
    779778,
    687888,
    988687,
    877877,
    878689,
    788787,
    887778,
    989878,
    878789,
    776888,
    998998,
    987788,
    879989,
    798798,
    987878,
    888878,
    678777,
    778987,
    788878,
    778798,
    898987,
    687979,
    788778,
    889889,
    787888,
    787778,
    898887,
    778787,
    788778,
    887878,
    689978,
    798888,
    878988,
    888987,
    986889,
    788899,
    788888,
    788876,
    786889,
    866877,
    978689,
    989977,
    789988,
    887777,
    789989,
    886787,
    898876,
    878798,
    977888,
    999687,
    887899,
    788987,
    777876,
    978788,
    887898,
    688878,
    879896,
    788887,
    889888,
    687879,
    668787,
    887888,
    796778,
    888878,
    899768,
    878878,
    896988,
    878898,
    678897,
    798787,
    889768,
    777888,
    876887,
    977787,
    878868,
    889887,
    887889,
    789988,
    888777,
    887769,
    878987,
    888898,
    878797,
    799897,
    988768,
    896798,
    876996,
    787687,
    886977,
    888988,
    777879,
    878666,
    887978,
    869888,
    988878,
    979888,
    798887,
    897777,
    889878,
    887778,
    879988,
    899668,
    878788,
    798689,
    879867,
    887998,
    878898,
    678876,
    876688,
    898997,
    978777,
    888878,
    977779,
    789789,
    678688,
    888998,
    878887,
    877698,
    698778,
    977878,
    797679,
    878897,
    786988,
    878887,
    878889,
    888898,
    688888,
    969787,
    878979,
    779788,
    888987,
    877788,
    789888,
    878989,
    998788,
    779778,
    898878,
    688989,
    977678,
    898687,
    779787,
    788877,
    968977,
    898877,
    877787,
    899688,
    889777,
    998888,
    788878,
    987878,
    897877,
    777887,
    978878,
    788996,
    779877,
    897778,
    788989,
    887787,
    778797,
    987787,
    787987,
    777998,
    779888,
    777799,
    878977,
    887788,
    879989,
    687887,
    876887,
    697898,
    998797,
    787778,
    897788,
    888889,
    887886,
    868979,
    797788,
    868698,
    896878,
    789878,
    887776,
    777889,
    889878,
    988888,
    878889,
    899877,
    998877,
    886977,
    889877,
    779879,
    966888,
    769888,
    998879,
    789788,
    896788,
    968778,
    799779,
    787979,
    778888,
    788879,
    887899,
    788687,
    888889,
    798787,
    777978,
    877887,
    899777,
    889888,
    687977,
    787799,
    878778,
    988697,
    968889,
    786778,
    887786,
    797987,
    798786,
    886687,
    887768,
    697897,
    677768,
    886989,
    887877,
    868796,
    887789,
    887889,
    987978,
    877879,
    967786,
    888988,
    888878,
    688877,
    878889,
    777888,
    787677,
    789878,
    898768,
    887878,
    888878,
    867887,
    888787,
    678687,
    798697,
    887998,
    877778,
    978877,
    879978,
    898798,
    887787,
    778789,
    789778,
    897797,
    877879,
    798777,
    878988,
    897777,
    677788,
    777877,
    779887,
    897878,
    978886,
    889878,
    798797,
    888888,
    787978,
    977897,
    977787,
    897798,
    787987,
    767888,
    967998,
    868878,
    878787,
    998878,
    979866,
    879778,
    788798,
    888989,
    678877,
    988879,
    878888,
    786788,
    788887,
    877868,
    887887,
    878889,
    878978,
    897879,
    679878,
    998968,
    679988,
    887788,
    877796,
    878887,
    779888,
    877777,
    889778,
    678887,
    787788,
    977879,
    888786,
    776777,
    797886,
    699776,
    887987,
    887887,
    897789,
    997978,
    987879,
    996879,
    778878,
    897988,
    877788,
    978786,
    988797,
    786799,
    978888,
    887887,
    789987,
    769876,
    799887,
    878999,
    679998,
    967987,
    797887,
    888979,
    967898,
    778887,
    779987,
    787898,
    788789,
    767888,
    978778,
    898778,
    887787,
    879998,
    898798,
    887777,
    799679,
    778787,
    678788,
    797789,
    769898,
    788977,
    789889,
    887978,
    978868,
    678977,
    778687,
    887968,
    689897,
    888888,
    898988,
    786877,
    999869,
    896888,
    788888,
    898879,
    788877,
    777888,
    887798,
    889978,
    767867,
    878887,
    899787,
    979778,
    997678,
    787977,
    888788,
    889989,
    888898,
    698889,
    787788,
    788788,
    768988,
    988978,
    687887,
    898977,
    898887,
    988897,
    777787,
    898887,
    888778,
    977897,
    787899,
    889886,
    988877,
    699798,
    877799,
    889989,
    887787,
    799897,
    687678,
    889778,
    677789,
    887899,
    899876,
    968987,
    878888,
    777788,
    877787,
    889897,
    787788,
    879878,
    778978,
    787866,
    897689,
    876877,
    878668,
    879888,
    877877,
    979889,
    678876,
    797888,
    788988,
    878887,
    988878,
    888887,
    968697,
    997787,
    988788,
    789987,
    779988,
    787888,
    987898,
    777897,
    788888,
    878979,
    979778,
    888789,
    888986,
    769777,
    888979,
    888887,
    689887,
    688798,
    988888,
    978779,
    888899,
    889779,
    799799,
    876987,
    898888,
    898897,
    777887,
    796888,
    797887,
    897877,
    777789,
    896888,
    789898,
    678887,
    878876,
    876888,
    878867,
    878886,
    766898,
    878897,
    899779,
    688987,
    897777,
    697987,
    979777,
    788877,
    878778,
    799697,
    878877,
    877987,
    667788,
    788889,
    887898,
    988878,
    778899,
    788979,
    877999,
    877998,
    889978,
    989886,
    888886,
    787797,
    787797,
    877779,
    888788,
    797887,
    888888,
    877797,
    888888,
    987889,
    889967,
    789768,
    896989,
    668876,
    776897,
    699888,
    977789,
    888788,
    878678,
    799987,
    889898,
    788688,
    876899,
    988777,
    977887,
    897898,
    787978,
    887789,
    977798,
    778797,
    998687,
    797876,
    787977,
    879897,
    879897,
    879778,
    998878,
    888888,
    889797,
    888897,
    877788,
    888788,
    867788,
    888898,
    889878,
    779988,
    897888,
    878788,
    887777,
    789889,
    869787,
    787876,
    887776,
    977988,
    888798,
    887898,
    877868,
    777767,
    799887,
    877886,
    989778,
    988777,
    777768,
    988788,
    877787,
    788768,
    788769,
    878988,
    988768,
    978879,
    798988,
    798798,
    797987,
    887869,
    889879,
    877787,
    788888,
    888888,
    798968,
    867877,
    998789,
    687888,
    786897,
    867778,
    998676,
    878868,
    899877,
    868777,
    989878,
    778888,
    889878,
    867879,
    788878,
    797778,
    777788,
    778778,
    979989,
    688788,
    976678,
    787789,
    967789,
    978788,
    997787,
    998689,
    789878,
    777789,
    979777,
    788898,
    688797,
    899798,
    898889,
    866878,
    787999,
    997888,
    898878,
    798987,
    787996,
    789668,
    978879,
    696877,
    987787,
    988787,
    789988,
    888786,
    988788,
    978879,
    887979,
    999898,
    999787,
    789869,
    776778,
    898788,
    778887,
    688879,
    897888,
    879778,
    987898,
    877797,
    878887,
    778888,
    779676,
    987997,
    889877,
    988787,
    779878,
    988787,
    777997,
    777987,
    678789,
    878788,
    889978,
    699888,
    677868,
    978979,
    776898,
    889988,
    788877,
    877887,
    878787,
    998789,
    988889,
    789889,
    878987,
    889798,
    899789,
    777788,
    889798,
    878776,
    679778,
    788887,
    888799,
    779877,
    877898,
    877886,
    899887,
    867788,
    787778,
    887787,
    899899,
    877786,
    898888,
    787797,
    897978,
    877778,
    887898,
    987789,
    987777,
    988877,
    998696,
    878886,
    777897,
    899776,
    888878,
    777997,
    697667,
    887978,
    888867,
    788787,
    879778,
    888887,
    987688,
    977686,
    879998,
    789787,
    879998,
    987777,
    787877,
    877888,
    978887,
    998878,
    787878,
    878787,
    978789,
    989879,
    778898,
    776869,
    888886,
    979977,
    798989,
    869888,
    887777,
    879888,
    797877,
    789799,
    877887,
    776787,
    867877,
    889877,
    797898,
    878898,
    888887,
    799888,
    887879,
    787989,
    787877,
    889867,
    688988,
    889877,
    877988,
    788877,
    889677,
    778868,
    978797,
    897976,
    787878,
    887778,
    788678,
    878787,
    879796,
    778886,
    977767,
    889976,
    898877,
    888668,
    889778,
    987777,
    878789,
    789887,
    778897,
    777898,
    788889,
    787688,
    987898,
    888778,
    688988,
    897887,
    887877,
    868888,
    898777,
    968777,
    897787,
    998698,
    898967,
    788887,
    788889,
    798988,
    877767,
    898768,
    776897,
    789998,
    877777,
    979887,
    887877,
    889878,
    888788,
    988777,
    797789,
    889877,
    786977,
    888779,
    879768,
    777887,
    888888,
    778898,
    797686,
    889889,
    878997,
    678888,
    987687,
    978878,
    879797,
    899898,
    787977,
    888778,
    986978,
    687987,
    689897,
    879887,
    878777,
    878776,
    788786,
    977798,
    888988,
    886897,
    886887,
    787988,
    889887,
    897779,
    979889,
    779886,
    787788,
    798888,
    899989,
    977887,
    887888,
    788998,
    977987,
    778688,
    779898,
    777886,
    798789,
    799897,
    799778,
    679799,
    968878,
    987887,
    776786,
    778897,
    999677,
    978987,
    778778,
    787977,
    987778,
    888767,
    788889,
    778877,
    799777,
    898777,
    998978,
    787778,
    778888,
    768988,
    978876,
    999877,
    777778,
    988898,
    687987,
    878797,
    787888,
    778788,
    699979,
    998677,
    879879,
    868897,
    998878,
    777796,
    689797,
    878779,
    788788,
    887777,
    677787,
    778878,
    887868,
    888989,
    878788,
    869888,
    878797,
    869786,
    698879,
    689878,
    989778,
    987688,
    797768,
    778798,
    678678,
    799798,
    888778,
    887688,
    998779,
    678787,
    987788,
    796988,
    778878,
    797787,
    779788,
    887798,
    998877,
    878868,
    989777,
    878778,
    887988,
    978777,
    878999,
    778877,
    788888,
    988877,
    989988,
    889878,
    888787,
    979967,
    869997,
    798786,
    797898,
    788888,
    969799,
    897899,
    978889,
    878779,
    997878,
    778878,
    779867,
    866898,
    767899,
    898878,
    878688,
    988878,
    978978,
    777788,
    879788,
    898878,
    877988,
    888786,
    797977,
    899996,
    998878,
    887788,
    967986,
    898988,
    887879,
    887897,
    798987,
    889976,
    787878,
    999978,
    768677,
    798998,
    887778,
    879896,
    787688,
    888798,
    879879,
    878888,
    987868,
    888887,
    779777,
    979797,
    978699,
    777876,
    889879,
    888787,
    877778,
    987787,
    897898,
    888877,
    678877,
    788887,
    879687,
    887889,
    898779,
    778687,
    869877,
    788878,
    878899,
    868987,
    888887,
    887977,
    689996,
    767679,
    988888,
    897778,
    887898,
    979898,
    878897,
    779789,
    987888,
    887879,
    996998,
    788798,
    988788,
    888788,
    668878,
    897987,
    778678,
    877877,
    769677,
    889787,
    798687,
    897977,
    967898,
    889979,
    888988,
    787878,
    988878,
    888988,
    887877,
    889887,
    888888,
    988869,
    988787,
    779788,
    677878,
    788788,
    889878,
    787779,
    889877,
    899988,
    688997,
    987888,
    887778,
    888978,
    978678,
    787888,
    786877,
    789677,
    696797,
    969889,
    887986,
    788997,
    988877,
    789788,
    777866,
    776888,
    787789,
    878878,
    977789,
    888778,
    888888,
    889797,
    879788,
    888687,
    788887,
    788879,
    768878,
    869989,
    978867,
    697978,
    888779,
    977888,
    879768,
    887987,
    778887,
    987868,
    789898,
    988898,
    888888,
    888879,
    978979,
    788998,
    798777,
    898887,
    697898,
    779788,
    888868,
    778887,
    878897,
    877997,
    988668,
    768887,
    778988,
    767877,
    787887,
    978778,
    988887,
    888878,
    897898,
    779887,
    889977,
    788768,
    788997,
    887988,
    668987,
    886987,
    786788,
    798879,
    778886,
    878786,
    878778,
    887887,
    989998,
    878787,
    978688,
    877878,
    879879,
    687887,
    889886,
    888878,
    789887,
    777878,
    678788,
    788898,
    788878,
    877877,
    788778,
    687798,
    899888,
    788788,
    898876,
    888888,
    977898,
    978798,
    988897,
    888877,
    977899,
    688998,
    779879,
    887789,
    888988,
    989777,
    799778,
    788888,
    787878,
    978779,
    887777,
    778879,
    897778,
    779777,
    768778,
    898879,
    886788,
    888897,
    988898,
    778777,
    878989,
    998888,
    788886,
    878798,
    768887,
    977879,
    878878,
    897778,
    987668,
    777877,
    887777,
    898978,
    988798,
    969997,
    786786,
    878796,
    788987,
    778978,
    888889,
    787676,
    989867,
    788687,
    877887,
    778988,
    787689,
    989897,
    889686,
    688797,
    887689,
    879977,
    697987,
    799876,
    898877,
    888878,
    888779,
    867989,
    889878,
    898789,
    786987,
    898788,
    777987,
    987988,
    777877,
    887899,
    889887,
    898777,
    777987,
    788778,
    678886,
    887997,
    696988,
    788768,
    777897,
    798898,
    779987,
    888898,
    687878,
    977777,
    777876,
    878878,
    787789,
    898789,
    878887,
    767778,
    878788,
    797999,
    877667,
    888878,
    968888,
    787988,
    688987,
    878778,
    877879,
    787888,
    678988,
    978798,
    888877,
    976988,
    888788,
    678898,
    868786,
    998898,
    989768,
    679889,
    876988,
    888888,
    987988,
    888877,
    987778,
    877779,
    689876,
    998778,
    788787,
    886687,
    799988,
    678677,
    978887,
    889778,
    887777,
    897879,
    888889,
    878787,
    887886,
    879779,
    888777,
    789798,
    677778,
    888789,
    796888,
    797989,
    888989,
    786777,
    797888,
    888879,
    877779,
    877977,
    897877,
    978788,
    788788,
    778987,
    888877,
    887897,
    889788,
    888979,
    987887,
    778769,
    886688,
    878679,
    897689,
    788889,
    789767,
    788898,
    878879,
    898898,
    888876,
    697786,
    788689,
    997788,
    987878,
    877878,
    789698,
    887887,
    878687,
    887877,
    788988,
    876888,
    998877,
    777998,
    877798,
    779898,
    888867,
    777898,
    887789,
    878889,
    889688,
    888989,
    987887,
    968877,
    979787,
    989787,
    887897,
    887877,
    978799,
    878898,
    788788,
    678789,
    789878,
    897898,
    798877,
    668787,
    778888,
    786789,
    876988,
    887787,
    788977,
    889798,
    979877,
    788876,
    779789,
    888788,
    787778,
    887888,
    989678,
    989998,
    877787,
    788887,
    779797,
    897868,
    788788,
    868778,
    777778,
    878888,
    878797,
    989879,
    768888,
    979779,
    768889,
    887877,
    677789,
    779897,
    777877,
    687976,
    977987,
    668678,
    889886,
    887798,
    889878,
    878888,
    887977,
    798876,
    787887,
    879769,
    866978,
    978868,
    897887,
    767688,
    787777,
    788888,
    979888,
    768888,
    886779,
    788979,
    787779,
    787877,
    889889,
    887886,
    988788,
    898987,
    976798,
    887887,
    878977,
    988787,
    978788,
    899797,
    789887,
    888889,
    868797,
    888966,
    886889,
    787977,
    798687,
    988788,
    879887,
    888887,
    877977,
    787976,
    788978,
    779788,
    668888,
    978897,
    787878,
    887997,
    677969,
    779788,
    878787,
    877887,
    878787,
    977987,
    878998,
    878987,
    798877,
    687887,
    898668,
    788797,
    897888,
    888798,
    988788,
    988687,
    876787,
    998987,
    876799,
    998977,
    787888,
    897776,
    877977,
    888998,
    889978,
    888788,
    797886,
    786698,
    887988,
    788897,
    778988,
    779876,
    687888,
    878788,
    778767,
    687767,
    998777,
    899878,
    968988,
    998788,
    887888,
    877877,
    678997,
    888988,
    988777,
    898979,
    977799,
    887998,
    677886,
    779878,
    877887,
    889797,
    987888,
    788998,
    887987,
    987898,
    778888,
    888898,
    978778,
    899997,
    878689,
    778978,
    788877,
    686889,
    889798,
    797897,
    777888,
    678767,
    887797,
    796787,
    878797,
    879678,
    878879,
    877988,
    888767,
    978697,
    778796,
    876878,
    788887,
    989897,
    889797,
    988879,
    877789,
    797878,
    978878,
    787888,
    776998,
    889789,
    879798,
    899777,
    889877,
    968886,
    777998,
    888778,
    797879,
    798888,
    777989,
    887988,
    998877,
    977879,
    887798,
    978788,
    968679,
    888798,
    788877,
    987779,
    988777,
    978778,
    897888,
    887787,
    788786,
    788787,
    768669,
    877888,
    887998,
    967889,
    679886,
    777977,
    787788,
    797988,
    786777,
    988889,
    688898,
    888698,
    978987,
    678888,
    888678,
    678778,
    787887,
    877998,
    887877,
    898877,
    797978,
    788869,
    897878,
    867778,
    797767,
    877998,
    888888,
    799887,
    899886,
    877877,
    877797,
    798778,
    787877,
    778887,
    788989,
    888797,
    877797,
    788898,
    688979,
    788896,
    798989,
    786897,
    688788,
    888997,
    887888,
    678888,
    798889,
    877788,
    888979,
    987867,
    879876,
    898897,
    886799,
    788879,
    999976,
    788888,
    787897,
    778876,
    787798,
    776897,
    887777,
    688887,
    899888,
    878897,
    777798,
    789996,
    778888,
    878887,
    886778,
    878876,
    779788,
    787798,
    867896,
    978687,
    789788,
    799777,
    697688,
    887889,
    979789,
    788889,
    888888,
    788898,
    898888,
    787997,
    878878,
    987877,
    786779,
    887877,
    798778,
    788789,
    877878,
    999898,
    997898,
    988978,
    678898,
    867778,
    987879,
    678877,
    778779,
    797878,
    689878,
    769788,
    898797,
    877868,
    978778,
    888987,
    977777,
    888888,
    987987,
    789897,
    987779,
    788887,
    868787,
    888878,
    897877,
    986988,
    898887,
    888797,
    789786,
    798796,
    776878,
    977797,
    788877,
    788889,
    879878,
    899777,
    788888,
    778876,
    788888,
    977887,
    879788,
    878878,
    878887,
    798888,
    876877,
    788968,
    788798,
    987876,
    877787,
    877978,
    797989,
    899888,
    877769,
    797877,
    979887,
    768789,
    778677,
    987799,
    899987,
    878787,
    797788,
    787978,
    888888,
    988879,
    687888,
    787789,
    898887,
    777989,
    989987,
    789776,
    879787,
    789898,
    988689,
    887867,
    778979,
    676889,
    697978,
    777878,
    779787,
    787798,
    879778,
    698679,
    988868,
    787879,
    989787,
    876879,
    889776,
    777786,
    777696,
    877799,
    888888,
    788987,
    878777,
    779877,
    888798,
    978877,
    878797,
    996788,
    976989,
    678887,
    868888,
    887988,
    978989,
    777876,
    878776,
    889888,
    799979,
    878777,
    897788,
    878998,
    779799,
    898998,
    878788,
    966897,
    988877,
    877888,
    898788,
    887776,
    789877,
    687889,
    886876,
    798677,
    789868,
    789768,
    976777,
    978889,
    769677,
    777978,
    977677,
    797997,
    788677,
    887796,
    897888,
    679787,
    898888,
    898788,
    789886,
    888897,
    768777,
    779879,
    878888,
    987787,
    797886,
    888989,
    786878,
    778888,
    877788,
    878789,
    888799,
    696877,
    787979,
    988968,
    888778,
    876798,
    878779,
    888979,
    868877,
    878778,
    878778,
    887987,
    888788,
    678778,
    879898,
    986787,
    798778,
    898777,
    877887,
    799896,
    887777,
    778889,
    868998,
    788988,
    798877,
    688778,
    778899,
    678899,
    989797,
    888889,
    887889,
    977878,
    897998,
    786888,
    788888,
    886869,
    878979,
    779798,
    998888,
    887877,
    787787,
    898778,
    898787,
    887976,
    897776,
    897878,
    667877,
    886898,
    777888,
    778788,
    988777,
    867687,
    899678,
    788868,
    678887,
    888898,
    888778,
    878998,
    797899,
    788896,
    897987,
    978888,
    977999,
    987789,
    889988,
    778788,
    988887,
    788798,
    788998,
    887689,
    879889,
    877788,
    987787,
    788769,
    888898,
    767887,
    987998,
    878688,
    777987,
    867887,
    867897,
    788898,
    979887,
    789897,
    788886,
    889788,
    979977,
    898889,
    788898,
    887897,
    698867,
    889878,
    688897,
    887788,
    788878,
    787667,
    879797,
    989789,
    788698,
    889988,
    998877,
    779886,
    987978,
    788769,
    886778,
    698688,
    887888,
    987797,
    888788,
    778979,
    778777,
    988798,
    887888,
    778788,
    988879,
    888887,
    888888,
    787998,
    768789,
    778798,
    998787,
    788988,
    888697,
    777987,
    988889,
    889768,
    979868,
    887788,
    788888,
    768778,
    798899,
    798787,
    978889,
    777788,
    777787,
    897887,
    889887,
    877787,
    877779,
    789988,
    878788,
    798997,
    878988,
    788888,
    868789,
    886997,
    898699,
    877688,
    768989,
    987979,
    899977,
    797887,
    787778,
    878878,
    899899,
    888967,
    787788,
    887998,
    778897,
    779688,
    688777,
    877778,
    788789,
    777788,
    799777,
    877879,
    879968,
    888799,
    677777,
    887687,
    877778,
    778778,
    987878,
    879787,
    988778,
    888888,
    898878,
    889798,
    878987,
    777888,
    887889,
    868887,
    788787,
    789898,
    978998,
    776899,
    889866,
    978688,
    878968,
    867987,
    678777,
    769977,
    788896,
    877886,
    987888,
    978776,
    888877,
    987778,
    769989,
    999987,
    786887,
    788888,
    878786,
    777879,
    779776,
    789787,
    786888,
    788788,
    787799,
    777877,
    799879,
    876886,
    888689,
    978787,
    788998,
    778779,
    868677,
    787879,
    889987,
    787989,
    877898,
    789887,
    778988,
    987878,
    999778,
    697886,
    867787,
    866987,
    797977,
    888688,
    887876,
    978876,
    987787,
    787888,
    879678,
    778967,
    878988,
    897888,
    878788,
    988889,
    979887,
    889788,
    887889,
    988898,
    687989,
    998978,
    788869,
    878688,
    788888,
    877678,
    877887,
    887677,
    787889,
    898878,
    988778,
    888898,
    989878,
    888898,
    877788,
    778789,
    867898,
    798769,
    887787,
    778977,
    889777,
    888898,
    978988,
    888997,
    879897,
    787787,
    888987,
    798787,
    877679,
    787778,
    888988,
    888778,
    787778,
    888989,
    688887,
    789779,
    877789,
    879879,
    988988,
    888887,
    889776,
    787887,
    777899,
    888779,
    988887,
    888989,
    778888,
    777797,
    886786,
    879889,
    888878,
    978889,
    979887,
    777778,
    888877,
    768888,
    877877,
    988878,
    896988,
    668879,
    978789,
    798689,
    997788,
    898787,
    888787,
    869979,
    976788,
    778788,
    887687,
    878797,
    989877,
    798787,
    778976,
    888788,
    988978,
    798689,
    988788,
    888798,
    887787,
    888877,
    788788,
    789777,
    678679,
    889979,
    698897,
    788878,
    798778,
    998888,
    687988,
    878777,
    788787,
    978889,
    887788,
    779899,
    788797,
    787797,
    988779,
    768886,
    877798,
    769889,
    778987,
    878798,
    968868,
    788978,
    787986,
    788789,
    788778,
    687799,
    778988,
    777688,
    988777,
    897889,
    889988,
    798876,
    977896,
    889888,
    869987,
    779898,
    689778,
    877987,
    888999,
    767878,
    887878,
    777877,
    887788,
    779899,
    788888,
    899897,
    878788,
    889886,
    888888,
    768888,
    878877,
    789877,
    887678,
    899898,
    778769,
    778878,
    887876,
    688788,
    867899,
    878987,
    799777,
    878987,
    789887,
    897888,
    888878,
    889698,
    898767,
    788888,
    697879,
    787888,
    888987,
    697789,
    777877,
    889886,
    878777,
    899888,
    778788,
    978788,
    887697,
    988898,
    889797,
    897778,
    788788,
    878688,
    778787,
    787886,
    968898,
    878687,
    778888,
    987788,
    977898,
    977777,
    866878,
    988897,
    788788,
    996777,
    798677,
    868978,
    988888,
    897777,
    688877,
    868779,
    768788,
    898778,
    679778,
    977698,
    978887,
    999978,
    678988,
    788977,
    978979,
    788889,
    899987,
    977799,
    788677,
    986888,
    987888,
    898788,
    997897,
    787988,
    886789,
    798778,
    888798,
    978888,
    888698,
    767898,
    877877,
    879878,
    887787,
    778797,
    788978,
    887778,
    788898,
    988788,
    898877,
    889776,
    788879,
    777788,
    779897,
    997888,
    888887,
    898776,
    789897,
    688688,
    788797,
    989789,
    778868,
    987789,
    968897,
    977877,
    797878,
    977867,
    877998,
    977887,
    879777,
    978798,
    986789,
    998768,
    878897,
    878888,
    978997,
    878989,
    877989,
    888779,
    978878,
    978968,
    868978,
    798888,
    878897,
    778888,
    888996,
    989768,
    889876,
    697789,
    888977,
    897876,
    897778,
    987987,
    777989,
    778988,
    787669,
    888887,
    877888,
    897797,
    997877,
    888978,
    687888,
    989978,
    799888,
    978778,
    876777,
    778979,
    679877,
    877878,
    979878,
    687988,
    899887,
    879887,
    878899,
    788878,
    878887,
    987988,
    787698,
    887968,
    966687,
    787788,
    888886,
    888877,
    788888,
    778687,
    877888,
    787668,
    887789,
    887888,
    798878,
    788777,
    889787,
    798788,
    886796,
    878989,
    898789,
    788787,
    678878,
    877877,
    966768,
    879777,
    898789,
    977989,
    989888,
    778788,
    778978,
    878878,
    788777,
    988888,
    788987,
    798897,
    988777,
    977798,
    787867,
    768797,
    877778,
    788798,
    987878,
    888989,
    888998,
    979876,
    888867,
    877988,
    789887,
    877889,
    688797,
    888987,
    978878,
    867777,
    987879,
    888877,
    779987,
    997777,
    998976,
    789987,
    886798,
    789877,
    977887,
    877988,
    878787,
    998869,
    787888,
    888898,
    889987,
    968788,
    887888,
    679779,
    899778,
    988789,
    779987,
    698877,
    866998,
    998779,
    886976,
    788977,
    797878,
    777788,
    689698,
    888798,
    778979,
    897778,
    986888,
    787967,
    979778,
    988869,
    878779,
    698887,
    777888,
    988787,
    789798,
    888799,
    778998,
    887869,
    688888,
    988887,
    789878,
    878878,
    777989,
    787879,
    877787,
    997779,
    798888,
    888777,
    988778,
    897977,
    768968,
    987777,
    878888,
    978797,
    888877,
    879877,
    797798,
    787968,
    688789,
    688787,
    788898,
    787786,
    789777,
    897897,
    787798,
    796878,
    987788,
    887878,
    768887,
    877867,
    888777,
    777978,
    878798,
    678989,
    699879,
    877867,
    769898,
    777698,
    888788,
    987788,
    879787,
    878777,
    768788,
    967897,
    788998,
    897778,
    687776,
    778987,
    897988,
    877797,
    677787,
    898787,
    887887,
    889979,
    888799,
    899997,
    988886,
    866778,
    878867,
    787877,
    996999,
    786797,
    899878,
    788978,
    877889,
    897888,
    888678,
    988888,
    778878,
    798768,
    788787,
    777877,
    889889,
    977888,
    888986,
    989888,
    998877,
    899777,
    877987,
    899867,
    778889,
    877886,
    876688,
    789877,
    997779,
    888968,
    887997,
    778878,
    878887,
    968787,
    798687,
    878687,
    897789,
    887878,
    887987,
    778787,
    888988,
    888987,
    678889,
    777997,
    779776,
    978786,
    888978,
    778788,
    779689,
    878778,
    777987,
    888789,
    796998,
    798879,
    878887,
    987988,
    779978,
    878989,
    867887,
    788998,
    679886,
    988987,
    888777,
    788897,
    878779,
    967887,
    877977,
    778989,
    879997,
    897889,
    799778,
    888788,
    778797,
    789898,
    898889,
    887777,
    787798,
    888879,
    886778,
    669789,
    887988,
    896887,
    888998,
    989788,
    889797,
    778977,
    868997,
    888789,
    888788,
    779898,
    888798,
    889889,
    798887,
    989997,
    887887,
    887789,
    789789,
    678788,
    987879,
    897778,
    967788,
    889878,
    978878,
    887789,
    687768,
    697988,
    777998,
    977978,
    986878,
    868888,
    987878,
    887877,
    879789,
    878788,
    887887,
    888778,
    877687,
    868868,
    879889,
    977878,
    989788,
    788897,
    778887,
    888979,
    897686,
    779887,
    977889,
    776898,
    988987,
    887878,
    878688,
    977898,
    788767,
    899877,
    879687,
    888778,
    768897,
    778789,
    798788,
    767798,
    968877,
    776687,
    798977,
    777798,
    799888,
    688888,
    887997,
    887787,
    779888,
    977787,
    777978,
    987787,
    888979,
    889799,
    888889,
    998888,
    876978,
    867987,
    869799,
    888777,
    888879,
    898686,
    697988,
    887899,
    777879,
    886778,
    797797,
    779978,
    887878,
    699787,
    998799,
    786877,
    998887,
    788987,
    888888,
    888887,
    899899,
    788887,
    979877,
    887798,
    896677,
    878887,
    897778,
    888786,
    887897,
    888778,
    998798,
    768998,
    888687,
    988867,
    897987,
    988978,
    977876,
    879787,
    977877,
    788787,
    887798,
    788798,
    998886,
    787988,
    788666,
    898876,
    988788,
    879989,
    877889,
    877778,
    987899,
    788778,
    998878,
    889886,
    977799,
    777778,
    996888,
    887787,
    898878,
    887896,
    777988,
    786886,
    677898,
    778988,
    987967,
    799697,
    887788,
    788878,
    888876,
    799888,
    786897,
    887797,
    878787,
    697879,
    789977,
    888996,
    777889,
    889788,
    799878,
    888888,
    787888,
    677769,
    968889,
    997779,
    889896,
    988887,
    787898,
    998788,
    898798,
    699888,
    978888,
    788876,
    879979,
    888976,
    778778,
    887878,
    877977,
    899878,
    987877,
    867888,
    897787,
    669676,
    897887,
    877899,
    877877,
    968778,
    789787,
    787777,
    777688,
    978689,
    877878,
    987877,
    778887,
    778788,
    888998,
    988967,
    997888,
    898877,
    797777,
    879978,
    888989,
    788878,
    788888,
    978987,
    677699,
    788898,
    889877,
    778888,
    689677,
    788677,
    777788,
    897778,
    699877,
    687887,
    789778,
    779887,
    887977,
    867989,
    888878,
    988797,
    778688,
    897788,
    779779,
    987889,
    888878,
    778899,
    887786,
    778888,
    799887,
    998878,
    888677,
    687877,
    788878,
    797868,
    989978,
    888777,
    888977,
    888877,
    878797,
    787877,
    887798,
    888787,
    888787,
    989878,
    867869,
    888788,
    768778,
    988878,
    887987,
    798876,
    977877,
    697898,
    777879,
    878887,
    779998,
    977698,
    898977,
    898779,
    978886,
    788888,
    889888,
    899786,
    888889,
    878978,
    988899,
    878788,
    778697,
    799987,
    788777,
    787786,
    989687,
    988888,
    878878,
    698877,
    988878,
    978788,
    998787,
    777867,
    768789,
    877768,
    987877,
    767898,
    788877,
    888898,
    788788,
    867897,
    879887,
    676986,
    888778,
    988776,
    999687,
    986778,
    888877,
    787768,
    687778,
    778877,
    788798,
    878789,
    879997,
    987987,
    988677,
    988887,
    888887,
    887988,
    798879,
    888787,
    988888,
    868877,
    879889,
    789868,
    767887,
    788968,
    898777,
    779988,
    988888,
    877887,
    977888,
    889898,
    687888,
    786896,
    878799,
    888676,
    778888,
    889879,
    699898,
    789778,
    699788,
    879898,
    797798,
    987878,
    877896,
    789779,
    988899,
    678668,
    977777,
    679788,
    778789,
    978697,
    778776,
    797799,
    788878,
    979787,
    887977,
    988779,
    887978,
    788788,
    767889,
    977788,
    988788,
    889789,
    699967,
    888677,
    888897,
    888787,
    898888,
    698788,
    888798,
    786787,
    879879,
    977787,
    799787,
    778889,
    787879,
    798776,
    878889,
    898879,
    987998,
    887897,
    887778,
    778998,
    788677,
    798887,
    767886,
    878988,
    899987,
    978788,
    786887,
    987887,
    779787,
    777888,
    779878,
    978688,
    889768,
    987788,
    988979,
    679799,
    788889,
    798889,
    798898,
    887897,
    777789,
    888786,
    888888,
    889877,
    886887,
    788778,
    789766,
    787778,
    888888,
    778687,
    799697,
    897988,
    979887,
    888967,
    877789,
    887887,
    779798,
    886977,
    789898,
    887869,
    887898,
    667988,
    798889,
    897876,
    878988,
    678887,
    877787,
    898797,
    787687,
    988999,
    777899,
    787788,
    787789,
    776878,
    788778,
    688989,
    788868,
    989866,
    997689,
    688878,
    777687,
    789797,
    878989,
    978887,
    689988,
    888978,
    889888,
    797888,
    876987,
    878768,
    889778,
    878886,
    786987,
    788877,
    787879,
    877689,
    886788,
    797888,
    978888,
    889768,
    898877,
    878888,
    888878,
    778888,
    788988,
    786698,
    878889,
    889786,
    877899,
    688677,
    888997,
    877887,
    879888,
    988787,
    899797,
    768888,
    886898,
    778898,
    978778,
    788879,
    977886,
    887978,
    967889,
    776988,
    997888,
    787876,
    787788,
    767977,
    688888,
    886787,
    797887,
    898877,
    977797,
    788788,
    778767,
    877788,
    989998,
    867789,
    976778,
    888779,
    769768,
    988878,
    678867,
    888977,
    997988,
    878878,
    789887,
    899988,
    967888,
    989899,
    887988,
    688787,
    678977,
    879696,
    887869,
    788788,
    788777,
    877877,
    776777,
    786788,
    788888,
    877876,
    797978,
    868888,
    988767,
    987886,
    789788,
    797887,
    797966,
    788999,
    777798,
    787897,
    989899,
    778877,
    678887,
    778778,
    788977,
    889899,
    888798,
    888977,
    769998,
    878986,
    879888,
    878887,
    776788,
    878878,
    868768,
    886998,
    886777,
    999888,
    877979,
    777988,
    886898,
    789977,
    668978,
    778897,
    889877,
    879987,
    787779,
    787978,
    797976,
    898877,
    688978,
    778779,
    898789,
    698986,
    799988,
    878878,
    888878,
    799789,
    797987,
    788787,
    889887,
    897898,
    888788,
    887889,
    797896,
    889979,
    799778,
    786779,
    887989,
    887877,
    888677,
    888879,
    777796,
    876789,
    777987,
    887789,
    878777,
    887987,
    768987,
    788888,
    797789,
    778988,
    779887,
    887796,
    976977,
    887677,
    878876,
    787978,
    986788,
    778878,
    778898,
    788879,
    887977,
    879998,
    777687,
    898998,
    797788,
    798788,
    988877,
    999877,
    787789,
    887998,
    889878,
    776888,
    878779,
    787768,
    788779,
    878888,
    889878,
    878787,
    888877,
    676979,
    978788,
    868878,
    789787,
    799897,
    887888,
    886989,
    767897,
    787879,
    777799,
    796978,
    868889,
    899698,
    898786,
    778778,
    777879,
    889778,
    887887,
    988989,
    868877,
    987888,
    788697,
    888798,
    896888,
    999989,
    888878,
    988677,
    889698,
    887786,
    889778,
    798887,
    988878,
    888687,
    896877,
    778978,
    777778,
    898978,
    699788,
    689788,
    796976,
    877798,
    689888,
    869768,
    877878,
    678786,
    777877,
    688789,
    897779,
    868768,
    887788,
    987996,
    977799,
    798996,
    899888,
    788878,
    777887,
    987688,
    787897,
    986987,
    889899,
    997898,
    879788,
    988788,
    879997,
    776788,
    787777,
    888978,
    688978,
    799789,
    778898,
    787698,
    788888,
    978798,
    887898,
    787887,
    888888,
    899789,
    887786,
    879788,
    979776,
    987778,
    899897,
    788988,
    798788,
    798677,
    988787,
    897988,
    698868,
    886768,
    778887,
    778987,
    888788,
    879897,
    889997,
    888778,
    888989,
    888887,
    889977,
    779787,
    997787,
    788788,
    888779,
    798767,
    878777,
    899779,
    889888,
    997797,
    688997,
    869888,
    786786,
    988979,
    777897,
    887888,
    888677,
    898988,
    988798,
    786888,
    787789,
    668778,
    897787,
    796768,
    788668,
    787877,
    887798,
    989988,
    777888,
    978878,
    888888,
    878888,
    887768,
    987799,
    887796,
    879988,
    778789,
    798788,
    668797,
    878798,
    888877,
    797888,
    998889,
    878878,
    797788,
    786878,
    888987,
    689988,
    888788,
    896789,
    787788,
    778787,
    888877,
    889988,
    699779,
    779778,
    977879,
    778679,
    869889,
    898879,
    787797,
    979798,
    888787,
    687888,
    889698,
    889867,
    776978,
    888998,
    878868,
    786767,
    678789,
    999888,
    888667,
    999979,
    998766,
    998988,
    779687,
    789888,
    997787,
    879898,
    889769,
    978788,
    888777,
    888899,
    779898,
    796979,
    787988,
    887897,
    987678,
    888989,
    888767,
    879988,
    799889,
    788788,
    978887,
    888877,
    887766,
    788877,
    787889,
    888787,
    978788,
    898887,
    789777,
    978888,
    979778,
    879877,
    878769,
    769687,
    987788,
    777888,
    688988,
    888879,
    987888,
    779877,
    778878,
    798876,
    788686,
    888878,
    787777,
    886898,
    789888,
    798987,
    797989,
    767988,
    787797,
    867876,
    778788,
    778877,
    799687,
    799979,
    889878,
    898897,
    887779,
    786888,
    788787,
    787787,
    887797,
    786898,
    878988,
    777888,
    788789,
    988888,
    879779,
    788789,
    878997,
    988778,
    868877,
    898888,
    989799,
    787978,
    799869,
    777888,
    897888,
    879777,
    989786,
    877879,
    777878,
    878797,
    788788,
    777889,
    899867,
    888977,
    776688,
    988798,
    878787,
    998989,
    998888,
    997979,
    978977,
    798777,
    778898,
    778779,
    878777,
    978878,
    778868,
    778799,
    998988,
    889668,
    887777,
    897777,
    887969,
    877777,
    897877,
    898988,
    887888,
    887678,
    788898,
    778887,
    877887,
    888897,
    988678,
    697897,
    878898,
    897898,
    888789,
    688888,
    978887,
    888787,
    788677,
    777788,
    878999,
    887788,
    788878,
    878999,
    789668,
    778778,
    889999,
    988887,
    889798,
    888778,
    788789,
    798777,
    988797,
    888676,
    979867,
    888967,
    987887,
    888778,
    778877,
    887778,
    888977,
    988768,
    879787,
    788788,
    987777,
    899787,
    889788,
    878789,
    898888,
    877896,
    988788,
    777887,
    787798,
    869786,
    898888,
    777878,
    876787,
    897778,
    888887,
    879888,
    998788,
    887797,
    768977,
    888787,
    898989,
    779878,
    877687,
    797988,
    979688,
    878767,
    867887,
    787887,
    879997,
    886798,
    888888,
    889888,
    887988,
    798877,
    787878,
    977778,
    778866,
    898898,
    868887,
    879797,
    978978,
    878778,
    778888,
    788888,
    878987,
    877989,
    889887,
    699668,
    878877,
    898889,
    768899,
    778897,
    988899,
    788778,
    789789,
    888787,
    887788,
    986778,
    877878,
    789788,
    789888,
    877798,
    978787,
    988979,
    878879,
    778986,
    878898,
    897998,
    877799,
    888887,
    778788,
    987778,
    788778,
    899777,
    888877,
    878789,
    879887,
    787897,
    788789,
    767767,
    797888,
    897888,
    788888,
    767797,
    879887,
    788899,
    888788,
    997777,
    997887,
    898897,
    778876,
    879778,
    879678,
    886889,
    888878,
    889887,
    688888,
    976767,
    688878,
    689878,
    877789,
    889867,
    879878,
    977888,
    866787,
    889898,
    797998,
    889998,
    987979,
    977678,
    669878,
    787767,
    786998,
    697888,
    867877,
    788788,
    777986,
    798797,
    897879,
    868787,
    867777,
    888878,
    787878,
    779877,
    879887,
    778687,
    898789,
    888788,
    869688,
    789879,
    988877,
    799888,
    889799,
    798899,
    887886,
    697878,
    667878,
    987887,
    778977,
    777888,
    878797,
    878779,
    978787,
    887898,
    799888,
    988889,
    878768,
    977869,
    889887,
    898787,
    877888,
    867789,
    889997,
    768878,
    898978,
    889797,
    979897,
    897789,
    787887,
    678888,
    877977,
    799887,
    877778,
    888779,
    986877,
    887887,
    976987,
    886678,
    787778,
    698987,
    889877,
    997887,
    787779,
    796977,
    788887,
    778788,
    669779,
    878898,
    887978,
    989979,
    697799,
    878888,
    878788,
    888887,
    769888,
    989879,
    898869,
    788788,
    779868,
    677989,
    898988,
    987889,
    787978,
    897788,
    689889,
    879879,
    679887,
    889987,
    897778,
    888797,
    887877,
    878988,
    979878,
    778977,
    898888,
    787889,
    787789,
    888887,
    878888,
    786778,
    978688,
    979878,
    888788,
    788897,
    888879,
    777897,
    798788,
    978888,
    889897,
    799888,
    788988,
    797767,
    777787,
    888998,
    887877,
    969788,
    799897,
    888896,
    788979,
    686879,
    996697,
    878888,
    689888,
    787778,
    887778,
    878888,
    898789,
    788997,
    767896,
    887886,
    888779,
    878888,
    787886,
    886887,
    879887,
    888878,
    899898,
    777886,
    777877,
    877888,
    978897,
    789789,
    768896,
    887997,
    879878,
    778779,
    787979,
    789798,
    977988,
    868678,
    979887,
    887798,
    998978,
    979997,
    897778,
    698888,
    888977,
    898977,
    988888,
    889797,
    968898,
    888777,
    787868,
    878787,
    888799,
    888979,
    787899,
    767988,
    778887,
    788977,
    687889,
    779968,
    898976,
    688977,
    988999,
    799888,
    769987,
    887888,
    889677,
    888786,
    999899,
    887989,
    988886,
    787878,
    888778,
    887777,
    978867,
    787798,
    778877,
    787779,
    968978,
    888888,
    789889,
    997798,
    876978,
    997798,
    798796,
    888878,
    899787,
    887879,
    689987,
    778798,
    998788,
    989887,
    787976,
    877897,
    778888,
    788868,
    786888,
    888787,
    787788,
    777986,
    899888,
    777876,
    888887,
    989797,
    898997,
    787979,
    988988,
    979889,
    889878,
    788978,
    888889,
    888778,
    788778,
    799889,
    677888,
    776789,
    878889,
    889779,
    889788,
    898997,
    876887,
    877897,
    978987,
    877878,
    988788,
    779888,
    997976,
    887987,
    777988,
    988799,
    877988,
    787896,
    988778,
    688986,
    778898,
    887877,
    888878,
    788887,
    888788,
    999879,
    779797,
    776988,
    677786,
    997879,
    976987,
    688878,
    979878,
    889888,
    878887,
    887798,
    778797,
    988977,
    889999,
    677887,
    798698,
    769878,
    877777,
    899798,
    788767,
    779868,
    888777,
    888777,
    677799,
    797887,
    888799,
    787677,
    788789,
    776787,
    768877,
    989888,
    777977,
    888897,
    787888,
    887878,
    767786,
    768888,
    877978,
    889778,
    878989,
    889888,
    888786,
    988967,
    776898,
    799877,
    987788,
    999688,
    877897,
    798799,
    778688,
    777778,
    887688,
    989976,
    788887,
    886777,
    887679,
    988777,
    969879,
    897887,
    876887,
    789678,
    889978,
    678887,
    679976,
    899789,
    787788,
    697878,
    988878,
    789888,
    688797,
    987887,
    887877,
    788779,
    787988,
    988897,
    867886,
    778888,
    879786,
    888879,
    678879,
    879887,
    778899,
    897797,
    888888,
    877777,
    978797,
    889868,
    889678,
    878887,
    897977,
    788787,
    977998,
    876888,
    997779,
    688788,
    888778,
    977989,
    877878,
    898877,
    887887,
    777778,
    779887,
    879988,
    887977,
    978898,
    889888,
    996889,
    987797,
    878898,
    778777,
    888798,
    878987,
    787888,
    886797,
    887788,
    979987,
    887897,
    876978,
    867778,
    888979,
    889787,
    887898,
    887799,
    978877,
    798776,
    888987,
    878879,
    887796,
    768787,
    778797,
    788778,
    888796,
    987887,
    698978,
    788877,
    887788,
    777899,
    777798,
    888788,
    987898,
    889787,
    787896,
    798788,
    688798,
    977796,
    987878,
    888887,
    888988,
    986879,
    788878,
    777878,
    876977,
    787797,
    788887,
    869778,
    997979,
    887787,
    787968,
    879876,
    878876,
    986899,
    878887,
    887777,
    987886,
    777977,
    887877,
    787889,
    878889,
    789798,
    898898,
    767799,
    889689,
    968999,
    697889,
    987877,
    879888,
    998886,
    998788,
    888789,
    979877,
    788878,
    877688,
    769997,
    797869,
    998979,
    797897,
    778898,
    967889,
    888868,
    889789,
    687988,
    788789,
    788889,
    877988,
    868969,
    997889,
    999887,
    988987,
    897699,
    878867,
    878978,
    787978,
    898789,
    879979,
    968768,
    667868,
    989998,
    899877,
    978888,
    977879,
    876789,
    887777,
    887778,
    888888,
    767767,
    986888,
    776797,
    978887,
    967899,
    897878,
    887878,
    889897,
    877998,
    878687,
    686896,
    989988,
    779878,
    978998,
    877887,
    877797,
    797987,
    888888,
    896889,
    788967,
    897878,
    777988,
    896878,
    886898,
    787787,
    767797,
    888898,
    898989,
    887978,
    889888,
    798789,
    876776,
    997889,
    788898,
    778887,
    786887,
    877987,
    878777,
    977878,
    897878,
    696998,
    898888,
    788977,
    778787,
    778888,
    998988,
    898877,
    778888,
    887687,
    977768,
    898788,
    988968,
    988898,
    878876,
    998999,
    777787,
    678787,
    798787,
    779788,
    889997,
    777898,
    886778,
    976987,
    878878,
    867787,
    887787,
    789887,
    867888,
    778788,
    888878,
    789788,
    877878,
    797999,
    868888,
    878779,
    898677,
    879787,
    887776,
    877989,
    876878,
    888776,
    796888,
    779679,
    997788,
    788778,
    788877,
    997888,
    788888,
    788688,
    889769,
    888867,
    768886,
    896798,
    977787,
    797777,
    778878,
    767987,
    887889,
    877899,
    787886,
    877789,
    789898,
    776888,
    778898,
    778877,
    898877,
    886978,
    997678,
    879788,
    678787,
    977897,
    798897,
    877798,
    888777,
    878786,
    788987,
    677887,
    688678,
    898788,
    888788,
    997778,
    877788,
    887788,
    899798,
    777798,
    789768,
    778798,
    878786,
    879877,
    787977,
    799887,
    779997,
    697687,
    898998,
    788677,
    796879,
    887998,
    888799,
    887779,
    797879,
    779888,
    978998,
    888878,
    977867,
    977778,
    978987,
    888779,
    889877,
    686879,
    886798,
    998977,
    888787,
    997888,
    787777,
    878877,
    877887,
    988899,
    888797,
    886899,
    879898,
    688988,
    897888,
    877888,
    988898,
    776898,
    688888,
    778787,
    878987,
    978698,
    797898,
    978888,
    787898,
    798688,
    978877,
    877887,
    788797,
    887878,
    988889,
    769887,
    887778,
    787888,
    876879,
    789798,
    878886,
    889889,
    879789,
    886897,
    988887,
    698887,
    898888,
    778899,
    987979,
    778978,
    878899,
    878888,
    786978,
    686888,
    978878,
    778797,
    888778,
    878979,
    878987,
    979788,
    788867,
    788968,
    887678,
    778786,
    787889,
    867879,
    988688,
    977878,
    689879,
    687968,
    999898,
    888988,
    899877,
    898888,
    788788,
    779887,
    878799,
    888769,
    788877,
    877789,
    889888,
    888886,
    988877,
    897778,
    889789,
    979778,
    877778,
    889767,
    678778,
    886897,
    888797,
    767888,
    876987,
    687768,
    898877,
    787788,
    698887,
    876798,
    689899,
    988877,
    787978,
    787798,
    887979,
    889887,
    787877,
    889888,
    877998,
    968878,
    969987,
    879688,
    977887,
    786799,
    888888,
    878778,
    879899,
    789887,
    888879,
    988999,
    897788,
    898888,
    677768,
    797978,
    989979,
    987777,
    887887,
    888989,
    778887,
    878788,
    898878,
    977886,
    996677,
    898777,
    779778,
    778877,
    777879,
    886887,
    788788,
    988689,
    789877,
    878797,
    976797,
    888777,
    977867,
    777888,
    789787,
    788978,
    788777,
    878986,
    779888,
    979989,
    978688,
    888778,
    788878,
    788998,
    788888,
    777887,
    878887,
    798788,
    867868,
    887787,
    878899,
    778889,
    679689,
    879689,
    888767,
    988979,
    988988,
    889888,
    888868,
    977778,
    898777,
    788788,
    778878,
    897777,
    767977,
    897898,
    798787,
    887888,
    989788,
    869889,
    888877,
    977788,
    998987,
    877887,
    977889,
    798877,
    867987,
    988787,
    787898,
    888879,
    787977,
    878986,
    896989,
    887998,
    867797,
    888988,
    887988,
    877788,
    978767,
    888879,
    896778,
    997897,
    878979,
    898878,
    969688,
    988788,
    887888,
    898777,
    789777,
    888979,
    867779,
    899798,
    889688,
    898777,
    888888,
    799879,
    776797,
    899987,
    988888,
    888667,
    877788,
    988688,
    888887,
    877879,
    879788,
    977777,
    897888,
    988797,
    698888,
    888787,
    998867,
    877777,
    878998,
    979897,
    997987,
    787897,
    889989,
    878788,
    788979,
    789778,
    988997,
    987887,
    787777,
    887887,
    797888,
    788998,
    879697,
    788779,
    676878,
    678777,
    787877,
    867889,
    776887,
    868987,
    897769,
    787877,
    987889,
    678797,
    768878,
    988796,
    889778,
    768888,
    877897,
    799877,
    887887,
    888978,
    898787,
    889889,
    977986,
    776897,
    699889,
    998999,
    778788,
    899698,
    888799,
    988689,
    888877,
    868979,
    878776,
    788789,
    897787,
    688988,
    789687,
    679868,
    979987,
    888767,
    887887,
    878878,
    888977,
    788778,
    779998,
    987878,
    986968,
    899799,
    888866,
    968988,
    888978,
    888889,
    888789,
    886977,
    877869,
    878868,
    788978,
    777778,
    898997,
    877886,
    778789,
    978888,
    798789,
    979888,
    777787,
    788887,
    778888,
    987978,
    779897,
    787877,
    678789,
    887888,
    888887,
    698886,
    879998,
    987988,
    788878,
    877798,
    896787,
    787888,
    887888,
    777989,
    788787,
    778786,
    767878,
    889889,
    799878,
    888887,
    897878,
    777977,
    776877,
    878987,
    786788,
    797888,
    977878,
    989798,
    997776,
    788899,
    978697,
    778886,
    787879,
    879688,
    897797,
    966878,
    789878,
    788786,
    868978,
    878777,
    888989,
    799888,
    787687,
    778988,
    978897,
    887798,
    897787,
    797887,
    888878,
    688977,
    688978,
    988878,
    787878,
    788788,
    877988,
    789977,
    899989,
    878899,
    777778,
    687897,
    889888,
    777868,
    779988,
    977788,
    897779,
    987888,
    678877,
    887977,
    977876,
    778787,
    777697,
    978898,
    999888,
    886878,
    768698,
    988688,
    888899,
    897778,
    979989,
    998897,
    898778,
    687888,
    989788,
    888878,
    777887,
    797688,
    788797,
    687697,
    889868,
    977787,
    887879,
    998987,
    878898,
    876778,
    896896,
    787789,
    889676,
    878789,
    788789,
    899888,
    878898,
    887877,
    788888,
    778889,
    998887,
    898978,
    688987,
    689787,
    768889,
    888778,
    877778,
    988789,
    789677,
    787768,
    878789,
    797777,
    978798,
    889677,
    989789,
    898767,
    787788,
    787789,
    668788,
    868997,
    896688,
    878889,
    977788,
    899878,
    978888,
    769888,
    666689,
    889697,
    778666,
    978877,
    797876,
    878788,
    897797,
    887998,
    889878,
    888777,
    678767,
    898888,
    988889,
    787768,
    877998,
    788767,
    768989,
    978979,
    778868,
    887897,
    787798,
    977888,
    888888,
    887898,
    878687,
    699878,
    778788,
    788898,
    888788,
    788877,
    878788,
    798888,
    799997,
    896978,
    899896,
    877887,
    897988,
    888779,
    898789,
    889897,
    778987,
    677987,
    977887,
    697768,
    988797,
    896977,
    778767,
    869887,
    998977,
    778997,
    788798,
    786777,
    888888,
    877996,
    898778,
    767786,
    788889,
    866887,
    887778,
    877888,
    989777,
    988778,
    887888,
    989778,
    896788,
    887787,
    888878,
    777889,
    878878,
    977889,
    767798,
    777888,
    888768,
    887777,
    776787,
    789786,
    778889,
    776698,
    898876,
    868878,
    877768,
    777889,
    999868,
    789977,
    879788,
    878788,
    889797,
    988778,
    877888,
    778988,
    898877,
    877777,
    777987,
    797898,
    988899,
    898778,
    999788,
    878978,
    888976,
    697877,
    978779,
    778778,
    888769,
    788998,
    787778,
    889779,
    788798,
    879897,
    887867,
    866778,
    798788,
    979879,
    887888,
    689987,
    996798,
    969788,
    786787,
    977888,
    869778,
    878987,
    778678,
    798987,
    777788,
    988879,
    777777,
    776878,
    877878,
    687779,
    878777,
    778898,
    996867,
    879978,
    789869,
    988797,
    698987,
    968879,
    898787,
    988879,
    777787,
    987898,
    878967,
    898899,
    887786,
    878788,
    777688,
    888867,
    878787,
    888886,
    879999,
    888888,
    878977,
    978988,
    997896,
    887977,
    878787,
    878978,
    797687,
    989787,
    777797,
    687797,
    779887,
    777878,
    867769,
    878988,
    689777,
    889777,
    779789,
    877899,
    888889,
    788889,
    977779,
    877878,
    898889,
    888797,
    988788,
    888877,
    889877,
    697787,
    779878,
    877778,
    788877,
    878877,
    978898,
    798688,
    798777,
    768889,
    796897,
    988878,
    789987,
    888768,
    878889,
    677878,
    787888,
    878897,
    978778,
    888788,
    889788,
    887678,
    977889,
    898977,
    879988,
    977987,
    888887,
    968788,
    878888,
    978978,
    789788,
    778678,
    797779,
    887688,
    898768,
    879769,
    877887,
    877978,
    688888,
    897889,
    778778,
    979879,
    789987,
    868797,
    986986,
    988989,
    989887,
    889877,
    889798,
    988779,
    888987,
    878787,
    888777,
    898897,
    898888,
    687998,
    879897,
    896798,
    789888,
    788867,
    878888,
    877788,
    887977,
    768877,
    887777,
    878888,
    988768,
    878867,
    888898,
    979787,
    889687,
    898887,
    878788,
    897887,
    897998,
    877777,
    778977,
    789897,
    878798,
    787979,
    777878,
    778889,
    779888,
    698889,
    778777,
    797989,
    997779,
    779967,
    787888,
    687887,
    977888,
    877897,
    989768,
    878987,
    778887,
    977886,
    878889,
    998879,
    889999,
    886887,
    987797,
    877878,
    889989,
    779977,
    776799,
    897877,
    799987,
    778898,
    887789,
    878889,
    789879,
    677898,
    899878,
    888976,
    787887,
    799678,
    989789,
    988779,
    888788,
    678896,
    977887,
    777687,
    787787,
    787799,
    778889,
    677789,
    968888,
    879888,
    789987,
    988897,
    879789,
    799987,
    987998,
    988797,
    777989,
    888678,
    877776,
    898679,
    989778,
    898688,
    688868,
    989789,
    878777,
    888998,
    798899,
    878888,
    889887,
    879687,
    668797,
    978898,
    698877,
    879878,
    779798,
    789886,
    798888,
    798968,
    997999,
    696787,
    787878,
    878798,
    778768,
    799878,
    779787,
    788896,
    889798,
    888888,
    997799,
    797977,
    986987,
    777798,
    977877,
    798889,
    886878,
    877788,
    888878,
    788876,
    998967,
    777898,
    678979,
    796689,
    887768,
    789978,
    888978,
    789788,
    789987,
    788787,
    889887,
    888797,
    888878,
    878798,
    887887,
    877776,
    977887,
    778788,
    877977,
    977879,
    789798,
    787697,
    797889,
    687988,
    988778,
    778778,
    987899,
    787777,
    778787,
    878697,
    898977,
    779887,
    796698,
    977878,
    987798,
    968887,
    888787,
    798688,
    978789,
    877877,
    888877,
    778878,
    888678,
    898977,
    899778,
    688887,
    987978,
    789876,
    697798,
    877877,
    988788,
    877779,
    887877,
    878896,
    888798,
    778979,
    888888,
    888887,
    988898,
    798788,
    788777,
    896877,
    796787,
    969978,
    879777,
    787878,
    768789,
    678788,
    979877,
    877889,
    787786,
    797887,
    976987,
    779898,
    887778,
    867689,
    988789,
    877887,
    988877,
    878768,
    898898,
    968887,
    878877,
    778799,
    798788,
    979878,
    787878,
    768888,
    888879,
    769788,
    987898,
    877687,
    798877,
    978778,
    987889,
    888786,
    886887,
    887878,
    888787,
    777797,
    776878,
    887997,
    679979,
    799877,
    988889,
    777988,
    778878,
    979798,
    886887,
    969788,
    998879,
    997778,
    888778,
    978777,
    868878,
    778878,
    877866,
    977877,
    896897,
    678777,
    887796,
    788787,
    999787,
    777898,
    897789,
    887779,
    779878,
    888898,
    697777,
    698788,
    887889,
    788898,
    888987,
    889887,
    797777,
    797778,
    877687,
    779788,
    788677,
    868777,
    878769,
    767788,
    677886,
    898797,
    768989,
    798877,
    798896,
    768898,
    888876,
    877798,
    797778,
    688977,
    767798,
    778997,
    799896,
    797898,
    888788,
    697896,
    688978,
    698877,
    777778,
    878788,
    787797,
    998879,
    778788,
    788788,
    878987,
    898799,
    777787,
    787788,
    968888,
    978789,
    887878,
    787788,
    777898,
    877788,
    787887,
    879778,
    778788,
    898879,
    898887,
    878798,
    889766,
    888787,
    966887,
    796788,
    878788,
    878866,
    778798,
    867977,
    887898,
    988767,
    787897,
    998788,
    776889,
    988888,
    686988,
    799798,
    879888,
    878768,
    869878,
    888788,
    778787,
    778788,
    788878,
    689897,
    788787,
    886878,
    979988,
    789879,
    988889,
    789968,
    789888,
    889898,
    798679,
    877778,
    677986,
    998989,
    987988,
    888787,
    767886,
    778898,
    778678,
    777876,
    889897,
    967988,
    887877,
    788888,
    966787,
    989978,
    877867,
    778787,
    787768,
    689898,
    977776,
    778776,
    896776,
    887789,
    788886,
    797888,
    868889,
    787786,
    989798,
    788878,
    967688,
    796878,
    878898,
    888787,
    997887,
    788889,
    876777,
    888988,
    888978,
    889887,
    887868,
    778887,
    779968,
    789888,
    889788,
    687797,
    788898,
    979798,
    878899,
    987888,
    788678,
    678888,
    988997,
    887878,
    988887,
    768798,
    988777,
    777668,
    888779,
    788777,
    898779,
    877868,
    888787,
    887888,
    888988,
    797888,
    777799,
    997967,
    989868,
    778787,
    998878,
    778767,
    887898,
    798878,
    797877,
    676889,
    788788,
    978977,
    888778,
    889876,
    889688,
    898687,
    789779,
    986977,
    677876,
    779977,
    887867,
    878776,
    788888,
    887778,
    888877,
    887887,
    798789,
    788888,
    679887,
    886786,
    967699,
    778879,
    878877,
    787788,
    977976,
    778687,
    887789,
    778978,
    689996,
    977769,
    686889,
    997777,
    879878,
    876788,
    988777,
    788899,
    979877,
    787878,
    877768,
    778888,
    777788,
    898869,
    787797,
    798888,
    798879,
    988789,
    888788,
    878787,
    878789,
    887898,
    877879,
    898898,
    798878,
    779778,
    788699,
    888997,
    798898,
    877888,
    787788,
    877799,
    977888,
    889988,
    779867,
    888798,
    968777,
    877777,
    787878,
    868887,
    977799,
    878967,
    988897,
    888779,
    978798,
    888778,
    998879,
    887888,
    778789,
    687897,
    678986,
    887797,
    998888,
    887877,
    899778,
    767778,
    887768,
    878978,
    889787,
    777878,
    876888,
    888868,
    786878,
    877678,
    678887,
    778876,
    777788,
    999788,
    877788,
    787898,
    796888,
    897786,
    687998,
    877776,
    878779,
    778688,
    767998,
    779898,
    997989,
    977887,
    878787,
    689797,
    778888,
    889799,
    979888,
    877898,
    777888,
    868889,
    689789,
    888987,
    977678,
    787799,
    877898,
    788889,
    898888,
    877688,
    966887,
    877799,
    889797,
    787877,
    777988,
    877879,
    787988,
    977988,
    878887,
    767878,
    879889,
    797888,
    898887,
    789898,
    678888,
    988677,
    797798,
    888889,
    789767,
    887697,
    977797,
    798898,
    786789,
    878997,
    987689,
    978887,
    698897,
    997777,
    897798,
    699787,
    887897,
    789787,
    978787,
    788879,
    887988,
    988987,
    988989,
    879787,
    988878,
    778768,
    789898,
    787767,
    878868,
    778779,
    979988,
    778986,
    978797,
    678888,
    788886,
    687997,
    898868,
    788787,
    679769,
    877687,
    988778,
    698778,
    989878,
    878879,
    987698,
    998987,
    887797,
    797888,
    798887,
    967886,
    988988,
    798768,
    888878,
    898987,
    998779,
    888778,
    888887,
    788788,
    688899,
    897897,
    877788,
    788978,
    878897,
    779888,
    967797,
    777888,
    778777,
    878888,
    898976,
    997778,
    877679,
    877879,
    896878,
    868899,
    979687,
    877898,
    877976,
    889976,
    889889,
    699988,
    777787,
    997879,
    888887,
    878889,
    786887,
    797778,
    797897,
    799868,
    878687,
    977887,
    878889,
    997897,
    897887,
    979987,
    888778,
    788887,
    777779,
    787787,
    878876,
    796899,
    888777,
    887779,
    898787,
    787979,
    998878,
    778778,
    888877,
    697879,
    878888,
    699888,
    776899,
    798888,
    878888,
    787868,
    886798,
    978789,
    877977,
    786778,
    969789,
    978898,
    888988,
    868789,
    877798,
    888788,
    888888,
    689878,
    799767,
    887797,
    987786,
    987869,
    886668,
    797998,
    697789,
    877787,
    869989,
    798887,
    878788,
    777789,
    879888,
    776789,
    877798,
    799779,
    989988,
    877786,
    887898,
    778997,
    789878,
    886888,
    789988,
    898986,
    888887,
    877887,
    788786,
    987789,
    887888,
    877897,
    888686,
    778896,
    879887,
    878789,
    778887,
    799988,
    778877,
    888988,
    777897,
    698998,
    768787,
    798877,
    888877,
    799777,
    667978,
    889897,
    687788,
    777888,
    887797,
    989887,
    877798,
    877798,
    787887,
    789877,
    778798,
    878988,
    796989,
    997888,
    888887,
    986977,
    889777,
    799888,
    887789,
    888778,
    779879,
    899888,
    797878,
    796886,
    878886,
    787988,
    877788,
    888887,
    886887,
    798799,
    899778,
    876978,
    877887,
    897988,
    778777,
    878789,
    897877,
    777777,
    799888,
    697987,
    786787,
    676798,
    877697,
    788988,
    789879,
    897788,
    867799,
    889988,
    797769,
    779887,
    977696,
    979679,
    877787,
    777878,
    999968,
    876888,
    779876,
    878888,
    879777,
    887979,
    788868,
    888798,
    877876,
    788987,
    778886,
    778788,
    779789,
    777677,
    887976,
    888797,
    788889,
    978797,
    987987,
    696879,
    777888,
    778898,
    878878,
    787798,
    987698,
    796687,
    868786,
    998989,
    879879,
    788687,
    687996,
    889899,
    777799,
    697878,
    778777,
    978877,
    877776,
    798787,
    778878,
    899898,
    887678,
    788788,
    977688,
    877798,
    968787,
    877677,
    788989,
    779778,
    888878,
    977998,
    888869,
    978788,
    878798,
    897969,
    989778,
    888887,
    878787,
    877888,
    878778,
    879887,
    888987,
    887867,
    977897,
    877988,
    786877,
    878878,
    777777,
    787787,
    977678,
    788678,
    787787,
    897888,
    876797,
    878897,
    988898,
    789879,
    987787,
    898688,
    689868,
    788788,
    988887,
    897797,
    887787,
    787988,
    889779,
    778697,
    897887,
    877877,
    776787,
    897877,
    878778,
    887886,
    988899,
    879877,
    887778,
    786978,
    789989,
    778997,
    797777,
    868888,
    978688,
    787886,
    888978,
    968887,
    798787,
    889789,
    788879,
    899988,
    789888,
    767987,
    798998,
    777777,
    877878,
    868878,
    887987,
    798979,
    999789,
    868878,
    997676,
    888779,
    878787,
    889888,
    798868,
    968987,
    967888,
    979879,
    788799,
    888887,
    967868,
    879977,
    777767,
    767799,
    776786,
    898877,
    888888,
    687777,
    789888,
    798898,
    699987,
    987777,
    688897,
    989768,
    889788,
    887888,
    889888,
    878877,
    799688,
    796798,
    898989,
    887877,
    676997,
    788778,
    678878,
    778988,
    888879,
    867886,
    979889,
    987788,
    778697,
    878969,
    788677,
    979888,
    978878,
    878879,
    898777,
    998868,
    797979,
    689988,
    978997,
    988888,
    688878,
    888988,
    897877,
    889899,
    878687,
    787889,
    689678,
    889887,
    768889,
    869887,
    898688,
    978887,
    786897,
    977988,
    798987,
    978787,
    887767,
    877877,
    776888,
    787987,
    979977,
    897777,
    779768,
    879788,
    887678,
    898889,
    978889,
    878987,
    977878,
    776888,
    867788,
    988787,
    987779,
    888897,
    967877,
    987887,
    987886,
    888869,
    778977,
    879887,
    776778,
    877998,
    897778,
    999898,
    877777,
    978978,
    997679,
    798777,
    787888,
    997797,
    778788,
    787888,
    967897,
    768878,
    998888,
    777678,
    878978,
    788788,
    877687,
    788697,
    776799,
    897877,
    887698,
    788879,
    877787,
    779889,
    788997,
    879887,
    787778,
    889987,
    988868,
    888888,
    799796,
    877878,
    789876,
    767898,
    898876,
    778866,
    688769,
    877878,
    997967,
    988997,
    869798,
    778998,
    987887,
    787778,
    877879,
    788879,
    987886,
    869877,
    968789,
    987866,
    779877,
    987878,
    997678,
    788777,
    777897,
    887979,
    888869,
    876878,
    779886,
    989887,
    977798,
    787887,
    898788,
    899898,
    977987,
    979976,
    988888,
    888889,
    889888,
    978768,
    678778,
    787788,
    678887,
    777769,
    788889,
    888797,
    988788,
    797888,
    886878,
    986678,
    769878,
    988777,
    886977,
    878877,
    986987,
    878788,
    787768,
    779988,
    878779,
    986887,
    768878,
    987878,
    886697,
    998788,
    877688,
    779799,
    779878,
    788878,
    888789,
    888878,
    977687,
    788798,
    877888,
    888898,
    777897,
    888889,
    889997,
    868877,
    976788,
    898968,
    778968,
    879799,
    889798,
    889978,
    878788,
    888889,
    888779,
    697787,
    778778,
    888888,
    678868,
    788888,
    877778,
    777698,
    868998,
    798887,
    879788,
    877978,
    889988,
    887779,
    788878,
    698888,
    988898,
    987777,
    787899,
    988788,
    878877,
    789888,
    897898,
    799997,
    988887,
    999868,
    879889,
    787889,
    777868,
    788688,
    899678,
    888987,
    978889,
    886777,
    887888,
    867978,
    878897,
    977789,
    776888,
    877988,
    687788,
    778987,
    998889,
    978879,
    799878,
    778788,
    788787,
    799898,
    787987,
    878877,
    987978,
    976899,
    889787,
    687899,
    787777,
    687988,
    788789,
    897887,
    767877,
    987888,
    888796,
    879887,
    678867,
    789787,
    788798,
    678878,
    767887,
    798887,
    887898,
    997878,
    879788,
    888898,
    877868,
    778687,
    888796,
    888979,
    886786,
    888769,
    778887,
    777988,
    689877,
    878878,
    887878,
    888777,
    677986,
    988888,
    778779,
    887786,
    887799,
    889888,
    988777,
    797877,
    897678,
    878868,
    879879,
    987878,
    989887,
    887877,
    886899,
    878777,
    779987,
    787868,
    876887,
    679869,
    776886,
    888877,
    887887,
    977778,
    887787,
    877698,
    888889,
    788678,
    877988,
    798988,
    698977,
    776897,
    788787,
    889898,
    778767,
    989798,
    896998,
    898897,
    879878,
    886878,
    987877,
    998797,
    888888,
    787889,
    979878,
    797887,
    898978,
    887789,
    889679,
    888988,
    898888,
    798989,
    878998,
    778987,
    778777,
    898997,
    787778,
    998788,
    688888,
    887686,
    689988,
    876687,
    789788,
    897797,
    866989,
    888998,
    887977,
    998878,
    787876,
    987969,
    888988,
    898888,
    897778,
    777879,
    897789,
    786886,
    989996,
    987979,
    888797,
    877887,
    877866,
    887888,
    977878,
    878888,
    897779,
    986888,
    889888,
    989877,
    868988,
    798788,
    787787,
    888988,
    788898,
    788777,
    779777,
    888778,
    897868,
    997889,
    779787,
    688878,
    777898,
    797699,
    776879,
    788788,
    997778,
    888889,
    777689,
    789877,
    986788,
    878977,
    778898,
    888787,
    898988,
    889987,
    997679,
    988887,
    877798,
    677786,
    897777,
    788788,
    697798,
    978888,
    786978,
    988978,
    788789,
    877788,
    786888,
    778978,
    988878,
    686967,
    867879,
    878787,
    777888,
    888788,
    789879,
    888966,
    788798,
    787697,
    689789,
    987688,
    778887,
    777887,
    787778,
    887877,
    888878,
    988977,
    886787,
    879888,
    799997,
    778878,
    988888,
    896997,
    978897,
    677887,
    877777,
    796899,
    899777,
    978979,
    877788,
    888788,
    968978,
    879887,
    989889,
    978888,
    979888,
    768889,
    778979,
    778989,
    888788,
    797888,
    879787,
    788698,
    778878,
    889787,
    787687,
    887889,
    778787,
    788787,
    887778,
    798989,
    678779,
    887876,
    888677,
    688778,
    888799,
    788789,
    988788,
    787876,
    687887,
    887699,
    799789,
    978697,
    878777,
    888679,
    989998,
    797787,
    788988,
    987877,
    797887,
    877888,
    888797,
    788989,
    988669,
    777798,
    788979,
    989797,
    888788,
    899898,
    888977,
    787789,
    888888,
    786888,
    978888,
    888987,
    977878,
    788777,
    878976,
    876777,
    776879,
    698887,
    897989,
    888878,
    786897,
    778879,
    778787,
    899787,
    897696,
    878797,
    899698,
    879787,
    778978,
    887977,
    788776,
    678988,
    779976,
    787769,
    978787,
    879787,
    988879,
    688787,
    789888,
    978969,
    898968,
    897888,
    686976,
    677868,
    998786,
    679988,
    899896,
    999889,
    787789,
    867998,
    877779,
    788878,
    897877,
    788679,
    777788,
    798876,
    898867,
    878779,
    797698,
    888777,
    787988,
    877878,
    789787,
    878879,
    789676,
    987997,
    878889,
    879878,
    688799,
    888898,
    988888,
    788897,
    778788,
    879779,
    867687,
    878787,
    976879,
    877877,
    798989,
    888777,
    879767,
    888887,
    897678,
    787987,
    869796,
    697887,
    788778,
    866797,
    788887,
    897798,
    867868,
    977886,
    978796,
    798889,
    878988,
    878887,
    987999,
    777878,
    887768,
    798887,
    979778,
    997979,
    868778,
    697977,
    989889,
    778988,
    978788,
    888798,
    777679,
    988679,
    696897,
    889866,
    778888,
    977779,
    889979,
    778788,
    978898,
    878979,
    877896,
    778887,
    768789,
    966988,
    869887,
    778778,
    877878,
    698899,
    688787,
    788678,
    887777,
    877777,
    779867,
    788866,
    887787,
    889697,
    778878,
    888898,
    898888,
    899889,
    777787,
    887878,
    887788,
    778877,
    789888,
    688898,
    888887,
    988697,
    998688,
    777878,
    888888,
    899786,
    888688,
    877878,
    889888,
    878898,
    788898,
    888878,
    979788,
    796988,
    896888,
    888897,
    787768,
    888878,
    787788,
    979888,
    878899,
    788896,
    789888,
    886788,
    798878,
    979789,
    888878,
    888978,
    897786,
    978976,
    799976,
    989769,
    888778,
    989888,
    777978,
    989789,
    987787,
    898779,
    798989,
    887888,
    789888,
    888897,
    899887,
    686999,
    788977,
    786788,
    778879,
    789778,
    788787,
    877877,
    799797,
    988788,
    997798,
    798787,
    788978,
    887868,
    788888,
    887688,
    778878,
    876789,
    768978,
    878779,
    878989,
    998897,
    689968,
    786867,
    767986,
    787878,
    978779,
    878767,
    878797,
    698878,
    998797,
    988897,
    898798,
    887989,
    878776,
    778889,
    889777,
    888878,
    778799,
    887787,
    867978,
    786888,
    897787,
    788878,
    888898,
    889888,
    798978,
    778877,
    987789,
    687798,
    778888,
    867779,
    877688,
    767886,
    788777,
    888778,
    787786,
    888788,
    878988,
    897878,
    887888,
    897898,
    877988,
    878988,
    896798,
    788998,
    798798,
    788889,
    777987,
    899778,
    777788,
    778988,
    788987,
    989789,
    769789,
    888788,
    998898,
    777988,
    789999,
    898788,
    888988,
    878888,
    778769,
    888798,
    887878,
    887988,
    888878,
    977778,
    789787,
    788988,
    888886,
    788898,
    879879,
    887778,
    877678,
    788777,
    888778,
    967988,
    868766,
    778868,
    678888,
    898776,
    797799,
    768788,
    789796,
    878787,
    688778,
    977967,
    888769,
    988788,
    977878,
    778988,
    878777,
    887778,
    698876,
    888887,
    878897,
    768879,
    778877,
    877788,
    888888,
    887787,
    787689,
    878877,
    689789,
    799799,
    897778,
    789868,
    777888,
    887778,
    889889,
    978778,
    878879,
    988897,
    888897,
    687878,
    797988,
    899688,
    887979,
    876788,
    789889,
    777668,
    677788,
    997787,
    888898,
    968997,
    788877,
    878889,
    887789,
    996867,
    897789,
    969968,
    887778,
    787867,
    889687,
    878879,
    887888,
    789998,
    786866,
    888887,
    899797,
    878779,
    897888,
    879868,
    768867,
    786787,
    777889,
    867788,
    788787,
    788767,
    889799,
    778989,
    888796,
    766878,
    768788,
    988898,
    969977,
    869668,
    779878,
    899778,
    877687,
    797888,
    889787,
    887786,
    979998,
    869978,
    868697,
    888788,
    778786,
    678786,
    887778,
    997878,
    888798,
    798887,
    889878,
    988878,
    979977,
    779988,
    878797,
    788988,
    789787,
    687867,
    799976,
    787776,
    978768,
    779897,
    797889,
    876878,
    868897,
    797879,
    788768,
    888786,
    777799,
    887799,
    999879,
    778787,
    877699,
    887788,
    986799,
    777687,
    777787,
    777888,
    767977,
    798977,
    887797,
    889768,
    899888,
    988887,
    877789,
    887779,
    787788,
    878677,
    787889,
    878888,
    979879,
    888887,
    979779,
    687687,
    787679,
    798789,
    887978,
    788879,
    797879,
    677877,
    978989,
    999999,
    778988,
    776866,
    878887,
    688799,
    877968,
    787898,
    798878,
    897888,
    777798,
    769878,
    876788,
    778887,
    798878,
    788969,
    968878,
    986887,
    777778,
    688877,
    789879,
    779888,
    997678,
    788887,
    888699,
    787978,
    888978,
    797789,
    888888,
    796788,
    887797,
    878767,
    799888,
    977868,
    888788,
    887687,
    789889,
    778878,
    889878,
    776877,
    878768,
    879878,
    978888,
    978889,
    767998,
    787988,
    878778,
    776878,
    886778,
    879789,
    898897,
    787988,
    878898,
    787786,
    797788,
    998898,
    879777,
    878877,
    777888,
    678888,
    889888,
    788778,
    989987,
    687978,
    886879,
    998988,
    768989,
    877888,
    698888,
    897699,
    778888,
    788887,
    777888,
    989888,
    888898,
    877968,
    879879,
    788797,
    977779,
    899878,
    777997,
    868967,
    898889,
    987888,
    897986,
    877767,
    887878,
    898796,
    998789,
    887877,
    777998,
    987689,
    887977,
    877988,
    988896,
    888997,
    878966,
    879987,
    888778,
    797786,
    766878,
    886789,
    778778,
    787778,
    889887,
    877878,
    899687,
    778897,
    689788,
    787977,
    878978,
    978797,
    777998,
    789877,
    888778,
    687978,
    887888,
    888997,
    878986,
    988879,
    898887,
    968889,
    798799,
    989988,
    677896,
    798886,
    887968,
    868888,
    898788,
    868697,
    988998,
    789888,
    789888,
    768777,
    779997,
    889888,
    986997,
    888879,
    697778,
    877888,
    687787,
    886788,
    787777,
    788697,
    789997,
    787889,
    778878,
    897787,
    899888,
    887689,
    779898,
    788886,
    787888,
    998969,
    778777,
    979888,
    898789,
    778877,
    899797,
    878976,
    767886,
    777888,
    989788,
    787887,
    888878,
    688777,
    999776,
    799879,
    878778,
    768767,
    788897,
    997677,
    788778,
    877898,
    768987,
    797788,
    977788,
    769787,
    879797,
    878888,
    868879,
    978896,
    878888,
    987877,
    878979,
    767879,
    998889,
    976866,
    999799,
    899699,
    787887,
    788798,
    997878,
    877896,
    998799,
    788878,
    978879,
    987776,
    886787,
    879898,
    788798,
    899878,
    767788,
    867988,
    799878,
    978888,
    887778,
    789977,
    998978,
    877898,
    888889,
    976899,
    777778,
    769987,
    799896,
    897898,
    978888,
    897888,
    888897,
    878789,
    788996,
    777978,
    997798,
    987887,
    768889,
    878898,
    687887,
    789878,
    888686,
    778887,
    977797,
    678878,
    778888,
    896788,
    887898,
    867779,
    789977,
    787777,
    877786,
    878778,
    897776,
    978768,
    877788,
    889887,
    888769,
    687788,
    877967,
    778778,
    798677,
    797878,
    987778,
    777887,
    788697,
    867887,
    878878,
    797978,
    878878,
    788888,
    889789,
    886778,
    779998,
    889788,
    888978,
    979878,
    777986,
    987977,
    797879,
    876896,
    878988,
    997788,
    888888,
    789877,
    789978,
    987997,
    867987,
    799878,
    978878,
    677887,
    976888,
    687887,
    877776,
    787777,
    768888,
    889898,
    777877,
    768888,
    667988,
    888888,
    877977,
    878877,
    888887,
    878899,
    768888,
    788788,
    878687,
    977777,
    787788,
    887986,
    887878,
    877998,
    976998,
    977998,
    879688,
    888988,
    877879,
    788888,
    788786,
    888789,
    798868,
    997998,
    889887,
    789788,
    766788,
    878888,
    679887,
    888778,
    887867,
    888867,
    878687,
    699967,
    868778,
    879678,
    876787,
    788978,
    777667,
    867879,
    767788,
    888899,
    797687,
    788887,
    779777,
    877797,
    678888,
    779787,
    787977,
    886887,
    867788,
    989867,
    988789,
    887866,
    877778,
    877888,
    887877,
    878698,
    887878,
    887699,
    877868,
    899768,
    888787,
    887879,
    788778,
    897796,
    879787,
    777798,
    878986,
    879877,
    978889,
    878888,
    787789,
    777688,
    877886,
    698799,
    988987,
    678698,
    769899,
    898889,
    898786,
    868988,
    777887,
    698799,
    868887,
    987887,
    997897,
    897789,
    878899,
    889888,
    697877,
    888887,
    887698,
    897886,
    788688,
    877987,
    797789,
    878986,
    788797,
    878778,
    879888,
    788887,
    786978,
    797699,
    987897,
    878899,
    868789,
    987887,
    988787,
    898887,
    878788,
    887876,
    786788,
    988888,
    877867,
    789878,
    778879,
    779679,
    778877,
    798678,
    778877,
    797877,
    878797,
    878778,
    686777,
    977878,
    787978,
    878878,
    899887,
    988799,
    978897,
    887898,
    987899,
    788887,
    877788,
    778879,
    976877,
    888878,
    777777,
    888887,
    896767,
    787888,
    878977,
    878897,
    877788,
    888897,
    688778,
    697777,
    777797,
    899799,
    797779,
    987787,
    788868,
    868688,
    998779,
    689878,
    887997,
    887769,
    877998,
    987676,
    888878,
    887786,
    788777,
    998887,
    879887,
    777787,
    897799,
    779988,
    887788,
    787876,
    778787,
    976778,
    798799,
    977869,
    878889,
    789778,
    968697,
    979978,
    777989,
    988879,
    878688,
    778887,
    977987,
    978789,
    787987,
    787778,
    988788,
    797888,
    997987,
    889678,
    678788,
    987769,
    888788,
    787789,
    888889,
    788897,
    888768,
    989878,
    787898,
    989678,
    788887,
    888888,
    889787,
    767977,
    767878,
    778788,
    979888,
    887697,
    779887,
    779889,
    879988,
    889877,
    898879,
    987997,
    787877,
    879888,
    887969,
    888698,
    978788,
    877888,
    768869,
    668998,
    886888,
    888888,
    987877,
    787877,
    799877,
    877977,
    777897,
    687967,
    768887,
    889786,
    798897,
    778787,
    898977,
    889998,
    788697,
    977887,
    786788,
    877998,
    899878,
    787899,
    688878,
    888877,
    988977,
    978978,
    986988,
    788698,
    878778,
    868899,
    998789,
    888787,
    978777,
    878787,
    787879,
    778978,
    989779,
    886797,
    899777,
    877887,
    877786,
    777899,
    987888,
    989788,
    878777,
    777767,
    888888,
    778778,
    777669,
    889789,
    878887,
    798788,
    768888,
    868877,
    779877,
    887988,
    887986,
    978797,
    868969,
    877989,
    878897,
    797978,
    878888,
    876889,
    888896,
    677988,
    878898,
    988696,
    788888,
    889879,
    777887,
    886878,
    787798,
    778797,
    777787,
    898988,
    877796,
    788887,
    989787,
    887868,
    778789,
    777677,
    699888,
    878768,
    789876,
    897987,
    889888,
    989888,
    886899,
    788678,
    788897,
    887787,
    688789,
    879789,
    898976,
    778868,
    776888,
    897777,
    998766,
    978988,
    888778,
    998687,
    868776,
    987799,
    998878,
    898688,
    988888,
    899778,
    888989,
    887778,
    988869,
    797878,
    998776,
    887878,
    689788,
    778889,
    898789,
    799798,
    768997,
    778898,
    879879,
    777877,
    988898,
    778988,
    987887,
    877787,
    877998,
    868788,
    798889,
    877788,
    878887,
    888878,
    688778,
    887888,
    799687,
    779868,
    886978,
    879897,
    979796,
    887888,
    887777,
    969788,
    789888,
    987888,
    886778,
    977887,
    989888,
    887978,
    789877,
    769969,
    878779,
    867777,
    787978,
    977896,
    786788,
    777987,
    688769,
    896889,
    777687,
    677778,
    867976,
    879888,
    796988,
    788898,
    997889,
    889898,
    687788,
    787787,
    878788,
    687879,
    788677,
    887978,
    966899,
    898687,
    799787,
    876787,
    878889,
    887889,
    897786,
    878789,
    887879,
    887879,
    789979,
    878787,
    797679,
    887766,
    687779,
    798778,
    788888,
    799877,
    999988,
    989779,
    769868,
    888889,
    668997,
    887898,
    787888,
    778868,
    898778,
    887888,
    877698,
    677899,
    798788,
    977977,
    699877,
    776786,
    897779,
    987899,
    679766,
    888988,
    889788,
    799798,
    977878,
    878897,
    788988,
    788979,
    769896,
    887788,
    987998,
    876868,
    788788,
    977986,
    888877,
    888977,
    969867,
    787888,
    769877,
    778777,
    978987,
    898868,
    779787,
    888887,
    797877,
    978977,
    777877,
    786878,
    797787,
    877777,
    898997,
    879888,
    789887,
    787797,
    878888,
    889888,
    876798,
    989868,
    788878,
    889987,
    978689,
    887776,
    887798,
    897977,
    977898,
    998788,
    888886,
    897778,
    778788,
    798878,
    897877,
    889887,
    977888,
    798798,
    888799,
    688787,
    676797,
    888887,
    768788,
    868866,
    788778,
    788779,
    978898,
    877679,
    778878,
    878978,
    798978,
    888788,
    878678,
    987878,
    989878,
    769788,
    868999,
    878787,
    877879,
    798797,
    788789,
    888789,
    988677,
    699877,
    779789,
    798887,
    779678,
    878867,
    787977,
    888988,
    788887,
    778878,
    778778,
    897978,
    877878,
    788698,
    797889,
    787787,
    877987,
    879878,
    997889,
    776977,
    788877,
    888878,
    778768,
    897888,
    877799,
    977877,
    878789,
    798786,
    779979,
    889768,
    878897,
    869888,
    678679,
    878977,
    798887,
    888978,
    776788,
    888777,
    887787,
    867898,
    887788,
    878787,
    878797,
    787977,
    879898,
    897798,
    898988,
    887879,
    789777,
    778678,
    778898,
    986877,
    788976,
    967888,
    878778,
    887877,
    887689,
    997688,
    988879,
    898867,
    987878,
    897888,
    988778,
    876988,
    886987,
    877789,
    779998,
    786878,
    799978,
    897888,
    777889,
    696988,
    689899,
    989879,
    697979,
    679987,
    887988,
    778897,
    876987,
    797978,
    778989,
    879997,
    989778,
    877789,
    887778,
    978887,
    889978,
    887979,
    788867,
    878888,
    788987,
    887778,
    789978,
    777767,
    787986,
    989878,
    989687,
    769989,
    677788,
    788887,
    799887,
    897888,
    877788,
    888868,
    778889,
    798788,
    887886,
    778887,
    688788,
    777789,
    788797,
    777998,
    786676,
    679976,
    897787,
    789778,
    869786,
    889987,
    896988,
    788887,
    978977,
    778687,
    877977,
    886886,
    879678,
    878778,
    878787,
    988988,
    788698,
    778898,
    898878,
    787778,
    878788,
    786778,
    888998,
    789799,
    878786,
    988798,
    889778,
    777797,
    898778,
    977877,
    997869,
    889787,
    877789,
    879767,
    898797,
    897679,
    978888,
    797889,
    688878,
    888778,
    676978,
    788888,
    788778,
    878997,
    788886,
    787677,
    888789,
    877988,
    888988,
    688786,
    888867,
    789998,
    878788,
    798786,
    877877,
    778988,
    879779,
    877797,
    888888,
    888776,
    967989,
    886877,
    977989,
    789778,
    889887,
    786867,
    679867,
    879888,
    877778,
    788889,
    978878,
    788997,
    899878,
    688887,
    886788,
    899768,
    878878,
    788788,
    779777,
    977686,
    778889,
    788888,
    879779,
    889889,
    877788,
    767877,
    877889,
    789789,
    696878,
    768878,
    888687,
    777787,
    897788,
    888899,
    979888,
    688886,
    978877,
    889779,
    789787,
    789888,
    779998,
    776977,
    686877,
    898779,
    888888,
    679988,
    997797,
    896877,
    888887,
    768888,
    888997,
    887977,
    878987,
    669877,
    798887,
    887788,
    779778,
    988778,
    778897,
    988798,
    887998,
    798877,
    879879,
    879788,
    777967,
    689777,
    778779,
    778777,
    879879,
    978899,
    987886,
    879888,
    779677,
    897788,
    898688,
    878878,
    888978,
    878878,
    977887,
    787877,
    888778,
    777888,
    778879,
    798988,
    677879,
    978788,
    998887,
    777879,
    879797,
    987886,
    689878,
    788788,
    876988,
    866988,
    787898,
    888899,
    897666,
    887778,
    987899,
    768977,
    778779,
    977877,
    888787,
    877698,
    977877,
    887678,
    768798,
    887786,
    986798,
    897978,
    679898,
    887898,
    987779,
    788777,
    987887,
    877789,
    678968,
    789986,
    887777,
    787879,
    878888,
    888776,
    778787,
    799987,
    866789,
    788888,
    897898,
    869878,
    787879,
    988689,
    969988,
    768879,
    878896,
    778887,
    887887,
    997969,
    778687,
    877778,
    888998,
    787888,
    886899,
    698988,
    668889,
    898688,
    797889,
    987888,
    897869,
    767987,
    776878,
    798979,
    888786,
    789787,
    968667,
    668798,
    997889,
    979888,
    767978,
    898779,
    979877,
    877877,
    878778,
    878996,
    966988,
    897787,
    788876,
    886997,
    788788,
    797978,
    877778,
    788899,
    986797,
    787779,
    787888,
    668878,
    889898,
    888887,
    788988,
    787978,
    967976,
    798898,
    877688,
    977788,
    699999,
    797698,
    887777,
    898868,
    887977,
    787878,
    776897,
    977989,
    878879,
    886998,
    898998,
    888988,
    998797,
    887779,
    987777,
    779877,
    997788,
    889887,
    886998,
    787879,
    977979,
    768777,
    787887,
    888678,
    988977,
    877788,
    797887,
    877887,
    787877,
    878887,
    877977,
    888877,
    878778,
    779998,
    878897,
    899897,
    967869,
    896887,
    888877,
    877996,
    886899,
    888768,
    998798,
    787787,
    978889,
    977889,
    689898,
    888788,
    867798,
    887688,
    977899,
    778888,
    979989,
    878797,
    887897,
    888878,
    779877,
    778787,
    796778,
    777777,
    988888,
    878968,
    779777,
    779979,
    777998,
    969787,
    788897,
    876888,
    977987,
    776879,
    998997,
    888888,
    689887,
    889777,
    699778,
    779678,
    777897,
    978767,
    777788,
    678789,
    776879,
    879778,
    798997,
    698877,
    779887,
    888987,
    688889,
    889968,
    998878,
    687677,
    899688,
    899888,
    787867,
    787888,
    779898,
    887988,
    879887,
    887878,
    888887,
    987977,
    878788,
    888898,
    867888,
    989877,
    679877,
    778779,
    887888,
    798779,
    886897,
    899988,
    878798,
    787977,
    888979,
    786978,
    779698,
    699678,
    888798,
    978888,
    777689,
    787778,
    789798,
    888887,
    987797,
    976868,
    778777,
    978787,
    896677,
    788889,
    878977,
    887899,
    996778,
    897687,
    878797,
    787877,
    888788,
    886778,
    896779,
    767868,
    788989,
    878888,
    869699,
    878778,
    699787,
    886877,
    778787,
    989779,
    797778,
    697887,
    998878,
    989878,
    797887,
    787978,
    768788,
    777879,
    778878,
    788878,
    978796,
    678877,
    878798,
    899778,
    888787,
    898887,
    798789,
    788887,
    778777,
    886877,
    878888,
    898888,
    878787,
    878878,
    899677,
    879978,
    698888,
    877879,
    877877,
    777888,
    768987,
    887867,
    798797,
    798886,
    897898,
    678887,
    797888,
    777878,
    889876,
    788679,
    789877,
    886879,
    887866,
    877869,
    888777,
    777778,
    878878,
    878889,
    888987,
    978897,
    887987,
    988997,
    886878,
    697678,
    779779,
    898897,
    878787,
    896977,
    878688,
    988799,
    888878,
    787887,
    978978,
    888889,
    987878,
    787878,
    677698,
    798899,
    788888,
    788779,
    899899,
    798887,
    889879,
    879778,
    787897,
    888887,
    797879,
    798997,
    788997,
    896979,
    887778,
    967987,
    698887,
    978887,
    788888,
    887687,
    889996,
    889678,
    888877,
    798897,
    788997,
    888978,
    787878,
    978877,
    899799,
    877976,
    888899,
    788889,
    889778,
    978788,
    999877,
    778778,
    887777,
    998987,
    878889,
    787987,
    778688,
    886887,
    788887,
    779776,
    888969,
    778667,
    877888,
    978779,
    877797,
    776788,
    878888,
    877778,
    869899,
    889788,
    798878,
    798788,
    867979,
    888898,
    778978,
    998898,
    888879,
    688896,
    898886,
    987979,
    778878,
    887787,
    779789,
    877888,
    976797,
    889887,
    987688,
    887889,
    799888,
    988998,
    787799,
    887787,
    997867,
    788779,
    888886,
    898899,
    967778,
    989887,
    678888,
    888677,
    797878,
    998886,
    787878,
    887798,
    898887,
    889778,
    776899,
    777879,
    968988,
    987796,
    977998,
    777778,
    789878,
    988778,
    887799,
    698778,
    888898,
    889877,
    889889,
    798798,
    887967,
    888888,
    787777,
    899877,
    888797,
    778978,
    887779,
    778879,
    788768,
    877778,
    978777,
    968887,
    898899,
    877788,
    897789,
    778887,
    798899,
    876798,
    788778,
    889777,
    878798,
    877788,
    878877,
    787898,
    988778,
    988887,
    899978,
    998987,
    887687,
    868667,
    678878,
    776887,
    698977,
    898788,
    887787,
    989777,
    997799,
    889779,
    788897,
    886878,
    979988,
    788787,
    788786,
    889889,
    789888,
    987977,
    898877,
    887887,
    777876,
    888777,
    788987,
    797979,
    888686,
    888798,
    769768,
    896978,
    779877,
    688867,
    867898,
    889997,
    877878,
    998778,
    798888,
    777987,
    877779,
    978877,
    886798,
    888678,
    696878,
    878897,
    978889,
    797778,
    876977,
    978889,
    887888,
    777779,
    778977,
    988978,
    898787,
    988886,
    997888,
    988776,
    796678,
    788998,
    878688,
    787869,
    968787,
    877798,
    987898,
    887787,
    777978,
    888788,
    889896,
    778797,
    897889,
    799676,
    788787,
    977877,
    878888,
    877878,
    778778,
    787889,
    888788,
    887787,
    978887,
    999678,
    877777,
    879686,
    689976,
    889887,
    877899,
    687787,
    788797,
    789889,
    787996,
    998988,
    998787,
    777788,
    886888,
    877988,
    797798,
    897777,
    799988,
    866877,
    888898,
    997988,
    888898,
    668699,
    798997,
    789897,
    687767,
    989986,
    778876,
    787687,
    768897,
    797888,
    777777,
    887876,
    899886,
    898977,
    897999,
    787778,
    997887,
    988897,
    977777,
    887778,
    798997,
    878787,
    878788,
    988876,
    886878,
    887899,
    779778,
    887878,
    887889,
    688877,
    888999,
    768777,
    897988,
    889777,
    767788,
    979688,
    998897,
    879888,
    889977,
    898778,
    787987,
    978897,
    799899,
    678888,
    779877,
    888888,
    889887,
    779888,
    888878,
    779988,
    997778,
    799787,
    677877,
    898988,
    898887,
    979879,
    788796,
    788778,
    879988,
    797888,
    789868,
    878787,
    788798,
    789779,
    677889,
    787887,
    677877,
    798798,
    789787,
    888788,
    787788,
    777877,
    789998,
    878767,
    797979,
    898788,
    879787,
    788877,
    898888,
    988878,
    776868,
    988998,
    798988,
    779979,
    877887,
    788979,
    878879,
    777998,
    978889,
    888877,
    798786,
    887789,
    968788,
    879789,
    787699,
    889879,
    777779,
    989879,
    786778,
    778798,
    897788,
    966788,
    998787,
    778898,
    888987,
    878867,
    768778,
    779888,
    786776,
    878677,
    888878,
    879888,
    877867,
    877978,
    986967,
    877888,
    899889,
    788967,
    988688,
    998797,
    788888,
    797888,
    776798,
    888789,
    977888,
    896998,
    776888,
    778788,
    897778,
    787997,
    988898,
    797897,
    699796,
    977877,
    998697,
    897879,
    898779,
    878799,
    788896,
    887798,
    768778,
    888877,
    998996,
    777978,
    877788,
    988997,
    977998,
    887778,
    768778,
    789788,
    879777,
    999869,
    979778,
    888988,
    888888,
    978998,
    779897,
    969877,
    889877,
    887888,
    978888,
    688777,
    977787,
    797977,
    778898,
    986788,
    977888,
    777978,
    887788,
    879777,
    798798,
    868788,
    887989,
    687888,
    997779,
    969877,
    898889,
    797787,
    887988,
    987989,
    898987,
    897998,
    888788,
    987879,
    868797,
    988978,
    788776,
    898798,
    977787,
    987669,
    978889,
    977888,
    689688,
    886868,
    777898,
    887988,
    878767,
    788779,
    886768,
    797879,
    778977,
    779778,
    788687,
    977977,
    777687,
    798978,
    877797,
    777788,
    869788,
    877998,
    889787,
    778897,
    789888,
    688798,
    798878,
    689787,
    877977,
    977878,
    689968,
    768878,
    788868,
    989689,
    867779,
    877879,
    688989,
    988787,
    897887,
    986877,
    888988,
    897777,
    877889,
    898788,
    887897,
    788977,
    887877,
    888989,
    978877,
    779888,
    879876,
    889688,
    788798,
    776877,
    977796,
    888886,
    997899,
    798887,
    777976,
    698877,
    978788,
    898876,
    788798,
    888979,
    868786,
    877779,
    669899,
    887878,
    787689,
    668887,
    888878,
    788988,
    798777,
    987989,
    687897,
    989688,
    888898,
    797978,
    787798,
    888887,
    998777,
    887899,
    767889,
    798786,
    879877,
    888888,
    789878,
    798778,
    998779,
    788798,
    988899,
    976888,
    887887,
    786796,
    689878,
    789787,
    799887,
    888887,
    787878,
    788778,
    988789,
    687889,
    787898,
    988868,
    898888,
    888798,
    777989,
    868698,
    778787,
    888778,
    878889,
    888686,
    987987,
    878676,
    988896,
    887978,
    888888,
    978889,
    777878,
    788787,
    768897,
    787888,
    879688,
    898898,
    777697,
    899787,
    778888,
    778788,
    788799,
    789877,
    877888,
    698888,
    788868,
    888778,
    777978,
    879778,
    898878,
    978978,
    788777,
    877888,
    888989,
    886978,
    786897,
    887868,
    799689,
    678877,
    788877,
    788798,
    976978,
    799768,
    979789,
    877768,
    878798,
    977788,
    879988,
    898889,
    878978,
    979888,
    978899,
    697788,
    868777,
    688997,
    888787,
    888779,
    968889,
    798889,
    898697,
    988887,
    988898,
    878979,
    799678,
    789898,
    787787,
    887887,
    889798,
    788997,
    888898,
    778877,
    899798,
    797977,
    878888,
    697989,
    798868,
    897788,
    796978,
    798767,
    768898,
    877687,
    977777,
    898777,
    788888,
    899969,
    778897,
    877787,
    888798,
    878689,
    697877,
    998989,
    768889,
    988889,
    789788,
    789888,
    788798,
    768777,
    887989,
    877788,
    788879,
    689777,
    897778,
    878898,
    887678,
    797776,
    978797,
    997787,
    877998,
    797998,
    869877,
    987888,
    997888,
    878787,
    777788,
    888887,
    887798,
    878788,
    887798,
    898999,
    887988,
    899788,
    779788,
    689897,
    787888,
    997878,
    969879,
    668796,
    888888,
    988889,
    789969,
    888998,
    797887,
    888788,
    976887,
    797778,
    878988,
    787886,
    888899,
    887998,
    878888,
    887978,
    999789,
    886888,
    789687,
    878888,
    888888,
    786687,
    987788,
    786787,
    868797,
    778797,
    878788,
    777798,
    967967,
    797889,
    867687,
    888887,
    787888,
    898978,
    889888,
    879888,
    869878,
    698786,
    799779,
    987987,
    787689,
    878887,
    888988,
    768898,
    886998,
    678789,
    878688,
    788887,
    877796,
    987768,
    887886,
    678986,
    878878,
    879789,
    877799,
    899878,
    978977,
    888888,
    978798,
    897787,
    878678,
    778878,
    887899,
    998968,
    888878,
    878889,
    878967,
    787788,
    888788,
    887778,
    778887,
    868777,
    787867,
    888877,
    897887,
    677987,
    977779,
    879988,
    977889,
    988988,
    878977,
    997988,
    789876,
    888787,
    777898,
    888788,
    977977,
    778878,
    789779,
    788988,
    879879,
    797887,
    987687,
    978976,
    777888,
    989989,
    998879,
    788798,
    998998,
    888977,
    987697,
    787977,
    988798,
    778888,
    789788,
    878987,
    779767,
    977877,
    788798,
    997889,
    789877,
    878689,
    889889,
    788879,
    788887,
    986788,
    697888,
    889787,
    886786,
    878778,
    796888,
    777778,
    887989,
    888877,
    977988,
    997798,
    889888,
    888897,
    887778,
    898777,
    786776,
    988988,
    877889,
    876888,
    798989,
    879777,
    878787,
    868798,
    887788,
    787678,
    889778,
    697979,
    888688,
    799988,
    988898,
    787778,
    777888,
    777978,
    788969,
    899888,
    687977,
    878876,
    888978,
    887998,
    777898,
    989779,
    977688,
    988777,
    778888,
    889989,
    677787,
    888788,
    988887,
    897899,
    797689,
    788778,
    989797,
    779988,
    788677,
    867888,
    798889,
    877987,
    888786,
    877777,
    778978,
    788889,
    988887,
    798767,
    897888,
    989998,
    898889,
    897878,
    888776,
    788777,
    789778,
    777999,
    677889,
    886799,
    897886,
    889798,
    878686,
    887879,
    797779,
    997788,
    888679,
    988988,
    778887,
    778968,
    968868,
    887977,
    986997,
    988668,
    888897,
    897877,
    769777,
    967898,
    768778,
    888788,
    798889,
    888677,
    888788,
    788777,
    778778,
    989978,
    988679,
    866888,
    778888,
    878988,
    886877,
    897886,
    788778,
    898987,
    789887,
    897767,
    899878,
    967799,
    897897,
    889879,
    778888,
    786886,
    868898,
    898788,
    968786,
    789789,
    778787,
    777889,
    767989,
    779888,
    879878,
    778788,
    789988,
    977797,
    878878,
    878789,
    787877,
    777688,
    898878,
    786668,
    788798,
    979879,
    978877,
    989789,
    889786,
    678888,
    696867,
    799787,
    887888,
    789868,
    887887,
    868888,
    778997,
    888779,
    978776,
    788897,
    899877,
    888877,
    886898,
    868777,
    898788,
    887988,
    987799,
    878797,
    897977,
    878778,
    989799,
    787888,
    788897,
    787787,
    887888,
    887987,
    688898,
    879898,
    997977,
    777889,
    788796,
    898777,
    976987,
    689998,
    899987,
    897877,
    898777,
    988878,
    778879,
    878889,
    879876,
    979988,
    899788,
    987797,
    787798,
    788787,
    778788,
    879778,
    879887,
    787877,
    878876,
    888896,
    877887,
    776878,
    997996,
    878798,
    777998,
    788988,
    888798,
    977878,
    988887,
    997989,
    976887,
    887988,
    988977,
    889878,
    878678,
    787788,
    677889,
    779877,
    888898,
    978887,
    799877,
    898776,
    788786,
    898897,
    897798,
    976689,
    897868,
    786888,
    797768,
    888897,
    787778,
    978867,
    889888,
    899688,
    879878,
    868877,
    788698,
    868777,
    989888,
    987798,
    977889,
    968998,
    778677,
    798788,
    687777,
    878777,
    877778,
    879797,
    687888,
    689878,
    977989,
    797869,
    768998,
    877887,
    778779,
    889798,
    888987,
    978889,
    888877,
    877677,
    788888,
    788879,
    978787,
    798778,
    788778,
    878888,
    779878,
    787888,
    987769,
    888687,
    888898,
    898787,
    779778,
    879879,
    976799,
    887878,
    878796,
    988777,
    898788,
    777798,
    897888,
    798987,
    889888,
    979888,
    887888,
    888777,
    879778,
    788789,
    967989,
    998878,
    988878,
    778788,
    979898,
    976978,
    687889,
    678887,
    876878,
    887778,
    777878,
    888787,
    789888,
    877987,
    779868,
    778988,
    877777,
    997788,
    789789,
    876788,
    797886,
    867777,
    968688,
    779977,
    688897,
    777988,
    887888,
    867698,
    787687,
    798878,
    987886,
    967877,
    888797,
    888898,
    799999,
    879868,
    779868,
    889888,
    788997,
    997889,
    889988,
    787987,
    788979,
    887988,
    877797,
    878778,
    688788,
    888978,
    988998,
    878887,
    877877,
    997979,
    977789,
    879979,
    887888,
    788688,
    788689,
    897889,
    879898,
    879788,
    878799,
    786987,
    878778,
    899899,
    886889,
    879778,
    888789,
    887789,
    896988,
    888797,
    899767,
    887687,
    888689,
    886787,
    987879,
    787898,
    968999,
    798887,
    997788,
    898878,
    788988,
    878967,
    887879,
    877798,
    898989,
    887688,
    888879,
    777787,
    787986,
    897898,
    978779,
    878988,
    986868,
    878877,
    987676,
    988897,
    787797,
    789786,
    698889,
    876787,
    898878,
    778789,
    878889,
    767797,
    799877,
    887887,
    678878,
    989798,
    888987,
    977688,
    867678,
    886897,
    788888,
    897779,
    988877,
    898788,
    889888,
    688998,
    887888,
    869879,
    877887,
    876767,
    976899,
    887776,
    968777,
    786888,
    888887,
    878868,
    788889,
    778986,
    777777,
    987869,
    888976,
    787988,
    877797,
    788877,
    978799,
    987977,
    877868,
    877877,
    788867,
    879888,
    888888,
    697778,
    798687,
    787877,
    888887,
    989866,
    888776,
    877878,
    788799,
    887978,
    777789,
    887787,
    777878,
    798788,
    787898,
    877889,
    778787,
    678888,
    878778,
    888998,
    788978,
    888788,
    787978,
    778788,
    879788,
    887778,
    877789,
    988797,
    888778,
    998677,
    988899,
    797787,
    888779,
    769898,
    888878,
    876978,
    887796,
    887969,
    878977,
    978877,
    788879,
    997776,
    888878,
    779798,
    987767,
    987798,
    876788,
    778879,
    788877,
    988787,
    778878,
    787886,
    788888,
    988888,
    788898,
    888888,
    978887,
    987977,
    888988,
    779698,
    887898,
    777987,
    879688,
    887877,
    887689,
    877789,
    887888,
    978777,
    798977,
    778887,
    788788,
    777877,
    978777,
    779787,
    688887,
    799787,
    889787,
    776779,
    988877,
    878887,
    797979,
    899787,
    869887,
    779786,
    878789,
    779998,
    768997,
    796898,
    889898,
    788978,
    888899,
    779898,
    776778,
    888787,
    888798,
    888779,
    979988,
    998799,
    888679,
    677787,
    888887,
    879868,
    998779,
    788678,
    988778,
    988888,
    876677,
    788877,
    868878,
    788778,
    766777,
    768889,
    878788,
    779987,
    798688,
    797888,
    988889,
    788779,
    798987,
    778969,
    877998,
    897968,
    779798,
    877788,
    887687,
    888868,
    888887,
    768877,
    897969,
    778878,
    988768,
    788888,
    798977,
    769888,
    887878,
    766878,
    989788,
    688896,
    978879,
    778878,
    787868,
    878879,
    778788,
    779977,
    886888,
    777988,
    788786,
    787779,
    898887,
    788897,
    898879,
    878778,
    779987,
    778787,
    877778,
    899999,
    889777,
    787997,
    877778,
    788898,
    789768,
    887887,
    878978,
    878978,
    887897,
    678998,
    889688,
    986886,
    887779,
    879987,
    887888,
    987887,
    898887,
    878966,
    776877,
    977888,
    888788,
    888888,
    798787,
    867886,
    878686,
    977889,
    789868,
    987879,
    787879,
    987989,
    789888,
    978777,
    967999,
    787788,
    877798,
    886799,
    687778,
    777779,
    988878,
    988789,
    898997,
    867887,
    869878,
    878799,
    899796,
    869889,
    988797,
    777879,
    778878,
    968787,
    787998,
    988887,
    898788,
    877786,
    988688,
    867886,
    978879,
    976777,
    888768,
    788878,
    889879,
    798887,
    788878,
    898969,
    979878,
    989878,
    787888,
    786868,
    889978,
    889877,
    896898,
    778879,
    886978,
    788787,
    886778,
    788887,
    689887,
    878788,
    788978,
    687887,
    987787,
    778879,
    877888,
    889877,
    877778,
    788877,
    788788,
    878998,
    978678,
    879877,
    789798,
    789779,
    677987,
    989887,
    888967,
    988779,
    899799,
    986797,
    888878,
    698978,
    788877,
    787788,
    787888,
    787778,
    789887,
    878878,
    899789,
    887777,
    789678,
    799899,
    897888,
    978669,
    988789,
    979697,
    799889,
    999889,
    888898,
    787786,
    888788,
    787887,
    887886,
    798798,
    977978,
    798878,
    878688,
    788888,
    877787,
    878779,
    977888,
    888689,
    868898,
    777977,
    878778,
    788889,
    787787,
    967787,
    777788,
    997777,
    866878,
    887879,
    998888,
    888688,
    797887,
    788786,
    788686,
    999787,
    878888,
    796778,
    979988,
    899878,
    889768,
    877988,
    888769,
    778888,
    987768,
    897979,
    976799,
    879888,
    877776,
    789999,
    887788,
    978877,
    788888,
    868877,
    767877,
    898879,
    797898,
    688777,
    799996,
    778787,
    878997,
    787888,
    886779,
    877787,
    898787,
    877967,
    999988,
    888799,
    889869,
    797879,
    998988,
    987988,
    777987,
    887788,
    889988,
    998999,
    798779,
    887998,
    978778,
    798887,
    689868,
    778788,
    878878,
    687789,
    779897,
    879897,
    678898,
    787688,
    867877,
    979888,
    898778,
    878978,
    777898,
    778887,
    867878,
    787778,
    788678,
    778988,
    997897,
    976877,
    798887,
    888798,
    789889,
    888778,
    887668,
    987887,
    889887,
    977887,
    797798,
    779998,
    988767,
    878898,
    878899,
    877898,
    878778,
    977798,
    799987,
    968799,
    688887,
    788889,
    888887,
    788887,
    787788,
    798889,
    877889,
    797679,
    889778,
    877798,
    978896,
    888977,
    879877,
    788878,
    789989,
    788878,
    888777,
    888997,
    677778,
    876898,
    888878,
    888999,
    789878,
    788887,
    877986,
    768888,
    998976,
    979987,
    786788,
    989778,
    777688,
    888888,
    788889,
    978778,
    797987,
    878887,
    788788,
    888777,
    887787,
    877788,
    877787,
    886898,
    898987,
    966988,
    878898,
    786878,
    787888,
    978887,
    876887,
    978898,
    789798,
    788889,
    798788,
    768878,
    877876,
    996877,
    786988,
    977888,
    988878,
    888788,
    878898,
    788978,
    768877,
    879687,
    777789,
    877988,
    689797,
    778887,
    778768,
    988898,
    878896,
    787997,
    897888,
    897987,
    788878,
    877788,
    698887,
    798966,
    678899,
    778866,
    889897,
    789877,
    788886,
    998988,
    787876,
    889878,
    997877,
    888997,
    898789,
    788877,
    888977,
    888678,
    978777,
    788887,
    978776,
    889998,
    887888,
    889877,
    978877,
    777878,
    889878,
    887788,
    878879,
    698896,
    788787,
    987999,
    898978,
    778897,
    978788,
    888978,
    888679,
    989778,
    779977,
    877988,
    889786,
    798887,
    787887,
    989868,
    877999,
    879898,
    887887,
    877698,
    677887,
    787886,
    789877,
    887798,
    878878,
    778898,
    977876,
    789788,
    798789,
    877878,
    877887,
    876889,
    777789,
    788887,
    888888,
    886998,
    988888,
    878879,
    976798,
    867887,
    897777,
    889898,
    788888,
    978977,
    887887,
    798878,
    886787,
    987888,
    889898,
    988768,
    897889,
    788668,
    778977,
    797777,
    878877,
    978877,
    878778,
    899778,
    778897,
    978987,
    788877,
    976868,
    887698,
    788887,
    978987,
    788799,
    877678,
    977988,
    788889,
    787777,
    888978,
    877788,
    877997,
    988876,
    877988,
    777678,
    998987,
    988796,
    999977,
    766888,
    888998,
    788878,
    896779,
    779878,
    797887,
    798687,
    688777,
    878797,
    898888,
    769899,
    987876,
    976778,
    966877,
    978878,
    899786,
    887787,
    887787,
    998798,
    697788,
    988998,
    768787,
    787888,
    967898,
    777788,
    878779,
    787888,
    978889,
    788979,
    898767,
    886869,
    897777,
    798888,
    886888,
    989999,
    767977,
    887988,
    888787,
    978787,
    998889,
    776677,
    887998,
    888899,
    978988,
    889777,
    769976,
    879789,
    877788,
    676976,
    877877,
    987977,
    878777,
    889787,
    799688,
    978986,
    787879,
    798868,
    787889,
    886977,
    877989,
    888867,
    797879,
    888788,
    889888,
    888788,
    988897,
    878988,
    799787,
    976877,
    877889,
    798997,
    969889,
    777888,
    787898,
    878789,
    998788,
    888778,
    888977,
    889887,
    778878,
    879978,
    779797,
    879879,
    887779,
    977888,
    888988,
    889879,
    787888,
    987777,
    779877,
    997979,
    988887,
    888879,
    898988,
    888899,
    776998,
    967869,
    787797,
    768897,
    677776,
    767667,
    888877,
    867887,
    798789,
    988889,
    998797,
    887878,
    999787,
    796778,
    878888,
    778797,
    897798,
    788787,
    878797,
    788879,
    778888,
    977777,
    877779,
    888679,
    887987,
    778779,
    769777,
    686979,
    878788,
    888789,
    897796,
    988979,
    667969,
    996796,
    877789,
    787987,
    979789,
    777766,
    798878,
    799777,
    789778,
    976888,
    798878,
    898888,
    888788,
    869886,
    869678,
    887899,
    978778,
    788879,
    978696,
    888896,
    888688,
    777889,
    788778,
    888677,
    887888,
    877798,
    877888,
    878877,
    678988,
    877967,
    898877,
    768887,
    886987,
    797899,
    878777,
    788789,
    877788,
    799987,
    987987,
    866898,
    878878,
    879687,
    787897,
    798767,
    779977,
    887888,
    897988,
    787988,
    797897,
    887788,
    798799,
    788768,
    779886,
    788789,
    789777,
    778877,
    688988,
    877989,
    787897,
    888897,
    788778,
    687977,
    777888,
    787698,
    977789,
    866987,
    977889,
    788677,
    798887,
    876886,
    877787,
    666988,
    889788,
    789878,
    998779,
    778877,
    798778,
    879879,
    787799,
    788888,
    868968,
    786686,
    986789,
    668797,
    878879,
    786989,
    898988,
    788997,
    888869,
    968997,
    788898,
    888798,
    998888,
    887898,
    977679,
    888877,
    999897,
    967897,
    787799,
    888868,
    798796,
    789878,
    988878,
    988897,
    887867,
    888988,
    989887,
    786878,
    988887,
    798799,
    978789,
    966887,
    777897,
    888777,
    887768,
    887779,
    687977,
    978897,
    889788,
    889678,
    877987,
    988788,
    787889,
    777779,
    776778,
    977977,
    677778,
    769876,
    777969,
    898887,
    878977,
    887978,
    887888,
    887777,
    897788,
    987689,
    799899,
    879888,
    886788,
    778879,
    888798,
    898987,
    878688,
    778888,
    787789,
    877669,
    889878,
    877888,
    788979,
    887988,
    878898,
    789989,
    799888,
    887788,
    989899,
    877888,
    887889,
    788887,
    677898,
    888789,
    897677,
    987898,
    987786,
    788778,
    968887,
    988778,
    899989,
    797877,
    867797,
    988998,
    899789,
    787888,
    889989,
    867878,
    877977,
    788777,
    889788,
    878869,
    788789,
    897877,
    777788,
    888798,
    798989,
    988798,
    987788,
    898879,
    978987,
    897987,
    877867,
    888988,
    786988,
    788689,
    877888,
    888799,
    788889,
    968787,
    897879,
    877776,
    969777,
    878888,
    896979,
    777777,
    888888,
    879798,
    687887,
    789888,
    699796,
    978979,
    886798,
    879877,
    778888,
    778976,
    886798,
    987798,
    768687,
    877687,
    888888,
    789886,
    888878,
    889978,
    686788,
    878899,
    787797,
    887897,
    678886,
    878987,
    987888,
    868788,
    878778,
    788888,
    787689,
    768878,
    787777,
    888889,
    678897,
    878689,
    779978,
    799688,
    889977,
    886787,
    897878,
    889789,
    888988,
    877897,
    967897,
    878788,
    889898,
    989889,
    867898,
    898778,
    788878,
    788987,
    886898,
    878878,
    788888,
    988887,
    787888,
    798989,
    968777,
    768789,
    778888,
    777888,
    777777,
    897777,
    788869,
    967998,
    988978,
    888878,
    998778,
    887879,
    888998,
    776788,
    967777,
    898878,
    887777,
    987876,
    888999,
    887888,
    798778,
    787978,
    898888,
    889987,
    978786,
    999797,
    789789,
    888886,
    977879,
    978677,
    777787,
    897878,
    688778,
    767888,
    779868,
    768698,
    787676,
    787778,
    787768,
    778888,
    879776,
    677778,
    879886,
    887789,
    689879,
    787787,
    898678,
    778889,
    987868,
    998977,
    888889,
    798777,
    998798,
    987789,
    876788,
    798878,
    877879,
    778989,
    897778,
    879978,
    867888,
    879787,
    887898,
    788788,
    889797,
    788888,
    998987,
    788988,
    788898,
    887896,
    777979,
    988878,
    787987,
    978786,
    788987,
    779797,
    779798,
    868889,
    767777,
    898878,
    796987,
    688787,
    888886,
    878878,
    878888,
    878878,
    798688,
    898779,
    877988,
    797877,
    888789,
    777989,
    877987,
    777789,
    779988,
    898777,
    876898,
    778877,
    886987,
    889879,
    867878,
    798987,
    888889,
    777788,
    789777,
    968867,
    788978,
    878988,
    976687,
    988797,
    798879,
    877797,
    878866,
    968879,
    688868,
    868789,
    879779,
    887787,
    889879,
    898777,
    898689,
    878797,
    977997,
    788777,
    897789,
    889788,
    777987,
    877879,
    997988,
    889787,
    898887,
    777767,
    979978,
    778899,
    887978,
    898997,
    898888,
    686788,
    887876,
    887778,
    788787,
    888779,
    688997,
    988688,
    888676,
    778899,
    977787,
    888877,
    988877,
    688886,
    998787,
    797668,
    889899,
    987789,
    789788,
    897877,
    878697,
    978999,
    877978,
    779787,
    988897,
    878877,
    896897,
    878867,
    789888,
    877887,
    887898,
    889789,
    678777,
    979879,
    887796,
    997877,
    897889,
    876899,
    987798,
    687889,
    898977,
    898798,
    979977,
    978896,
    877887,
    778798,
    987987,
    788888,
    897887,
    797988,
    988877,
    989789,
    797987,
    779878,
    977867,
    788978,
    797788,
    778998,
    677798,
    877879,
    876997,
    877897,
    789987,
    798798,
    998878,
    988967,
    767787,
    979778,
    879798,
    796888,
    869887,
    798876,
    967788,
    788877,
    778777,
    889787,
    797797,
    888798,
    866888,
    977798,
    988799,
    987878,
    797886,
    878886,
    889888,
    878879,
    898687,
    788788,
    879788,
    797799,
    998886,
    788789,
    789888,
    788777,
    878987,
    886878,
    899988,
    789979,
    788887,
    988787,
    877699,
    788787,
    877776,
    997887,
    888889,
    778878,
    898786,
    788878,
    788977,
    779789,
    776778,
    899787,
    989968,
    787866,
    878877,
    778878,
    799787,
    878677,
    776898,
    888878,
    779887,
    897879,
    877777,
    777988,
    679867,
    887889,
    997778,
    777877,
    776896,
    788887,
    797897,
    887988,
    977988,
    787887,
    888799,
    879788,
    989779,
    789797,
    898787,
    997777,
    779888,
    677887,
    887878,
    887779,
    976888,
    777769,
    688978,
    777788,
    798898,
    777697,
    788768,
    787887,
    968787,
    999778,
    697768,
    689789,
    788868,
    889988,
    996878,
    887988,
    989887,
    978877,
    887888,
    799788,
    987698,
    679887,
    887887,
    878869,
    887787,
    867899,
    989899,
    887877,
    877988,
    896788,
    799997,
    977778,
    876888,
    878797,
    997778,
    777867,
    897989,
    778897,
    898988,
    788888,
    978888,
    887987,
    799778,
    888778,
    776888,
    787697,
    888877,
    887888,
    888879,
    886868,
    896888,
    888887,
    798979,
    778888,
    777886,
    888787,
    987887,
    777988,
    979978,
    789886,
    767888,
    888887,
    777787,
    787797,
    898898,
    679877,
    687888,
    997797,
    899879,
    887789,
    697778,
    877878,
    988969,
    687887,
    987988,
    987988,
    987789,
    789798,
    787979,
    969987,
    787688,
    867989,
    787989,
    689898,
    887868,
    888888,
    986889,
    878998,
    888988,
    879787,
    979977,
    897777,
    777677,
    878787,
    787898,
    788887,
    786788,
    888898,
    688977,
    888777,
    788777,
    888777,
    879667,
    877998,
    799868,
    889788,
    878887,
    997879,
    788787,
    798888,
    669888,
    869787,
    898886,
    887798,
    989999,
    887868,
    899989,
    977796,
    778887,
    878997,
    877787,
    887988,
    997879,
    887788,
    987898,
    787688,
    788968,
    888877,
    887978,
    787877,
    768788,
    978889,
    888877,
    878886,
    789978,
    898988,
    888888,
    989799,
    778868,
    878678,
    879888,
    888898,
    878988,
    997988,
    898789,
    888678,
    878787,
    767879,
    877797,
    788888,
    878788,
    988988,
    988887,
    788689,
    887889,
    898887,
    899988,
    798887,
    688788,
    897998,
    787887,
    889988,
    897878,
    877897,
    989869,
    978979,
    878878,
    788877,
    877986,
    797979,
    988887,
    788899,
    888767,
    777787,
    787778,
    987998,
    879788,
    779987,
    988886,
    888677,
    777697,
    778788,
    978779,
    898788,
    888868,
    788777,
    979777,
    878777,
    888886,
    778877,
    877778,
    887687,
    797866,
    878886,
    879988,
    889798,
    686878,
    887779,
    676978,
    778777,
    787777,
    779978,
    988788,
    677897,
    879788,
    899887,
    778888,
    978989,
    878888,
    798778,
    899688,
    977988,
    789887,
    797787,
    876898,
    677898,
    987977,
    989788,
    997878,
    889987,
    877878,
    897888,
    798986,
    788877,
    889988,
    888799,
    887787,
    788888,
    788878,
    897878,
    868799,
    887687,
    676878,
    987877,
    899676,
    788788,
    888898,
    877898,
    789887,
    777798,
    776878,
    769767,
    889878,
    898699,
    998778,
    897788,
    886778,
    977978,
    789899,
    877788,
    777786,
    797888,
    878889,
    979869,
    778889,
    777898,
    968877,
    987798,
    879989,
    868677,
    787678,
    878797,
    797887,
    678878,
    689777,
    887996,
    788878,
    997878,
    878798,
    796878,
    898787,
    887897,
    888887,
    987888,
    888988,
    888797,
    799799,
    788777,
    887878,
    788789,
    878977,
    778978,
    978688,
    888779,
    778797,
    787787,
    988778,
    788979,
    877788,
    997869,
    978699,
    987798,
    887678,
    788868,
    888897,
    879988,
    997889,
    887787,
    888998,
    898996,
    898878,
    778877,
    889878,
    787696,
    977988,
    987978,
    768877,
    778797,
    787887,
    889788,
    977878,
    797767,
    887887,
    789989,
    986889,
    978997,
    777878,
    898697,
    878769,
    789998,
    876988,
    798888,
    778878,
    797896,
    687788,
    797899,
    989996,
    788887,
    879899,
    777887,
    868697,
    768788,
    887868,
    789988,
    887878,
    787978,
    888888,
    867989,
    877898,
    788799,
    888888,
    798977,
    976988,
    778786,
    799679,
    787789,
    888888,
    999989,
    668898,
    777777,
    786888,
    888678,
    787768,
    778798,
    897878,
    999878,
    888888,
    896878,
    898989,
    887888,
    787676,
    678789,
    767867,
    679979,
    799988,
    889787,
    889898,
    788767,
    889888,
    899887,
    878787,
    877978,
    987986,
    898796,
    987788,
    988887,
    787986,
    898876,
    797789,
    788988,
    877798,
    889788,
    778977,
    789886,
    887778,
    778989,
    778886,
    888879,
    977677,
    797776,
    888998,
    789898,
    889877,
    898888,
    877988,
    787887,
    879988,
    788878,
    788787,
    986889,
    987976,
    868876,
    888889,
    697978,
    997887,
    898887,
    787977,
    789988,
    887889,
    667988,
    788987,
    887799,
    988778,
    878899,
    796678,
    886768,
    787897,
    798989,
    778867,
    778897,
    778787,
    888987,
    768788,
    787978,
    778776,
    788678,
    898687,
    799888,
    979869,
    778779,
    887898,
    889778,
    967988,
    789889,
    798879,
    887987,
    687988,
    888889,
    887676,
    879867,
    896788,
    778889,
    878988,
    997999,
    988888,
    888797,
    989889,
    979797,
    777888,
    877798,
    987788,
    687987,
    778888,
    788679,
    778988,
    969698,
    887999,
    986987,
    879778,
    777769,
    788777,
    878998,
    986688,
    888887,
    789788,
    776887,
    999888,
    896777,
    788898,
    788788,
    986999,
    876678,
    989876,
    888878,
    878878,
    877778,
    787788,
    778786,
    787898,
    886778,
    787778,
    967768,
    878986,
    798889,
    898898,
    877978,
    778677,
    887879,
    888777,
    897677,
    679688,
    878797,
    797687,
    798899,
    888899,
    686788,
    879996,
    868888,
    797877,
    897768,
    778887,
    788789,
    879779,
    877987,
    788887,
    888787,
    878997,
    878889,
    798877,
    987688,
    689798,
    779797,
    888888,
    877886,
    888998,
    777978,
    787988,
    788888,
    888798,
    988678,
    977788,
    777779,
    788698,
    987968,
    999888,
    798698,
    876778,
    897788,
    898779,
    687799,
    898777,
    887687,
    889798,
    898877,
    789878,
    787898,
    897787,
    996877,
    789878,
    888897,
    878768,
    888888,
    797787,
    879887,
    788988,
    987979,
    769998,
    878786,
    787887,
    678877,
    778888,
    886797,
    788897,
    878888,
    786686,
    797878,
    878797,
    687887,
    679898,
    888786,
    989988,
    787888,
    878877,
    778886,
    899998,
    866888,
    969698,
    788879,
    988667,
    898887,
    776788,
    788889,
    778888,
    788897,
    878977,
    988798,
    868879,
    888878,
    697889,
    878888,
    988878,
    878797,
    898778,
    877978,
    987986,
    798788,
    979888,
    778868,
    987989,
    877889,
    788879,
    889887,
    787767,
    778879,
    876787,
    988777,
    887777,
    877878,
    778867,
    888799,
    877977,
    767677,
    788787,
    989787,
    788997,
    787898,
    879898,
    898889,
    899679,
    987779,
    787868,
    877878,
    998777,
    778887,
    868988,
    979879,
    787897,
    778888,
    778887,
    989788,
    899789,
    778988,
    888887,
    788877,
    788869,
    887899,
    779777,
    886788,
    987888,
    978886,
    787998,
    887788,
    787888,
    886777,
    797987,
    787878,
    977978,
    876766,
    879887,
    868988,
    887878,
    878978,
    877798,
    767889,
    869878,
    688889,
    787678,
    987898,
    898887,
    887977,
    797787,
    689789,
    777797,
    998888,
    789777,
    787888,
    878887,
    887678,
    878867,
    876777,
    878877,
    868787,
    978878,
    788877,
    877898,
    889786,
    787886,
    988877,
    688787,
    888878,
    868787,
    888987,
    888878,
    788798,
    789788,
    787978,
    778897,
    798787,
    888989,
    788788,
    887898,
    677777,
    677878,
    889679,
    888887,
    798788,
    776986,
    878777,
    766968,
    887968,
    879878,
    898887,
    788879,
    799877,
    897877,
    878786,
    886987,
    877788,
    989877,
    878789,
    786788,
    778777,
    896898,
    877778,
    887797,
    878977,
    777787,
    977777,
    778788,
    889879,
    888978,
    788976,
    778898,
    887888,
    668876,
    788979,
    877787,
    997789,
    879796,
    988898,
    977979,
    779797,
    887879,
    887997,
    878889,
    879799,
    878879,
    888897,
    778678,
    987867,
    887777,
    977899,
    797878,
    888877,
    798897,
    888798,
    967999,
    777778,
    887777,
    897889,
    798778,
    977878,
    787878,
    697867,
    866789,
    778777,
    777887,
    988877,
    887789,
    869788,
    888786,
    877997,
    677789,
    888778,
    978898,
    876987,
    797887,
    768699,
    987887,
    787777,
    879777,
    768797,
    887778,
    777767,
    988897,
    799898,
    778897,
    787899,
    798888,
    788867,
    788899,
    778687,
    877979,
    889878,
    978878,
    989977,
    988678,
    788787,
    677879,
    878896,
    967788,
    978878,
    866978,
    888968,
    876887,
    787868,
    887878,
    989988,
    797889,
    887989,
    998787,
    778867,
    797789,
    798889,
    888778,
    897799,
    779867,
    778878,
    776878,
    998888,
    879798,
    878898,
    799789,
    988787,
    777688,
    889879,
    878778,
    987889,
    767787,
    998888,
    788789,
    898888,
    787987,
    878888,
    669888,
    877767,
    868768,
    867698,
    768778,
    798976,
    888887,
    889987,
    788789,
    788697,
    887986,
    898888,
    877868,
    896786,
    788979,
    976767,
    888787,
    987886,
    868797,
    998877,
    887977,
    778777,
    986888,
    977878,
    768779,
    989878,
    998877,
    887878,
    968788,
    988899,
    888788,
    887768,
    668976,
    886887,
    979876,
    897897,
    997977,
    799797,
    898777,
    877887,
    989887,
    987786,
    988878,
    878997,
    977986,
    967998,
    897786,
    789979,
    888888,
    777889,
    778778,
    899767,
    677779,
    877887,
    898887,
    878678,
    867777,
    688879,
    989886,
    787879,
    878788,
    877898,
    998788,
    978789,
    778779,
    877888,
    878777,
    877966,
    879879,
    889779,
    798788,
    797978,
    688789,
    789688,
    897877,
    678986,
    889888,
    878778,
    977887,
    789888,
    898776,
    987899,
    896778,
    798788,
    778888,
    778969,
    887868,
    876786,
    878976,
    889777,
    897788,
    888888,
    787968,
    897878,
    899799,
    898878,
    778887,
    878997,
    798997,
    898867,
    988978,
    787798,
    777788,
    768697,
    779879,
    778888,
    889868,
    888789,
    977878,
    878777,
    877888,
    876798,
    879967,
    869777,
    988878,
    788869,
    778989,
    889988,
    778978,
    778887,
    879997,
    777897,
    887887,
    789998,
    888897,
    778887,
    976787,
    979888,
    787779,
    689887,
    898889,
    697877,
    988888,
    877889,
    877788,
    698898,
    987788,
    796889,
    787888,
    978967,
    777877,
    778897,
    787988,
    888778,
    889888,
    877899,
    779787,
    897998,
    878878,
    778787,
    778887,
    989797,
    799689,
    778776,
    978987,
    887897,
    668888,
    878877,
    898877,
    878887,
    778889,
    879889,
    788889,
    878888,
    688677,
    978987,
    887877,
    777987,
    878788,
    866867,
    877788,
    788799,
    768787,
    899788,
    788877,
    898878,
    788889,
    888887,
    797877,
    797778,
    788978,
    878878,
    897878,
    787898,
    779878,
    777999,
    798798,
    887888,
    998989,
    768788,
    788887,
    778888,
    789778,
    887887,
    988988,
    789787,
    697888,
    987889,
    979899,
    887878,
    889778,
    998778,
    897887,
    878999,
    987997,
    777788,
    889898,
    777876,
    688888,
    778798,
    788968,
    788868,
    879796,
    666887,
    889697,
    768878,
    867878,
    887888,
    698899,
    867897,
    786669,
    899878,
    788887,
    889889,
    779887,
    687987,
    988876,
    888776,
    678778,
    888867,
    878788,
    998888,
    888878,
    779998,
    877988,
    979899,
    888787,
    887786,
    886988,
    878799,
    899879,
    787889,
    777887,
    786898,
    897777,
    886776,
    887868,
    688979,
    897877,
    788697,
    798786,
    869998,
    978898,
    879788,
    887779,
    788877,
    786888,
    877887,
    787779,
    776899,
    887797,
    777789,
    986887,
    667997,
    778989,
    787888,
    887788,
    898998,
    887788,
    778899,
    788877,
    788787,
    999778,
    878887,
    897999,
    877888,
    899878,
    877877,
    887878,
    887888,
    878998,
    878888,
    888797,
    869788,
    887788,
    979887,
    876878,
    777868,
    989787,
    788897,
    779787,
    889899,
    779988,
    798878,
    889777,
    876778,
    788968,
    978787,
    677779,
    767697,
    976777,
    887776,
    788878,
    998988,
    778877,
    896688,
    887887,
    777888,
    878767,
    788786,
    876988,
    977777,
    877868,
    877799,
    889898,
    889888,
    798978,
    879779,
    788797,
    899868,
    989888,
    788869,
    679787,
    888777,
    897898,
    897877,
    786888,
    978689,
    797797,
    789777,
    778689,
    987989,
    888869,
    996787,
    897779,
    876768,
    678888,
    877878,
    787887,
    899869,
    988788,
    689969,
    878899,
    887787,
    978879,
    979978,
    768978,
    887878,
    768787,
    887787,
    776988,
    888888,
    787688,
    768879,
    778978,
    899798,
    877889,
    888987,
    997787,
    887988,
    788878,
    767877,
    969867,
    999877,
    778797,
    988788,
    896779,
    866787,
    778799,
    789699,
    776979,
    888797,
    697776,
    887876,
    877897,
    877698,
    997999,
    887797,
    787768,
    899867,
    878887,
    787779,
    967877,
    779779,
    987787,
    677877,
    788899,
    788878,
    689898,
    689888,
    897889,
    879678,
    977987,
    989797,
    797878,
    887798,
    887777,
    899996,
    777887,
    879888,
    788877,
    999988,
    788996,
    867787,
    798888,
    889867,
    789789,
    877788,
    988878,
    896879,
    678986,
    788778,
    787977,
    787878,
    787877,
    688677,
    988799,
    998988,
    977888,
    897788,
    788888,
    887788,
    887788,
    889878,
    867897,
    788987,
    768998,
    887767,
    867788,
    889887,
    986887,
    887898,
    998778,
    898878,
    697768,
    797987,
    879887,
    988777,
    887968,
    888887,
    877788,
    778978,
    779779,
    877889,
    789977,
    888888,
    776878,
    898777,
    766877,
    886797,
    798788,
    788777,
    888879,
    988787,
    786677,
    968777,
    767877,
    776778,
    887888,
    877988,
    788988,
    768978,
    869879,
    777778,
    888988,
    787778,
    799889,
    776797,
    998988,
    887788,
    986987,
    798998,
    889869,
    888977,
    878888,
    788868,
    788877,
    788888,
    897998,
    998889,
    798887,
    777799,
    888778,
    877889,
    978986,
    798987,
    688786,
    888788,
    787979,
    978887,
    787898,
    897767,
    998987,
    889888,
    688977,
    998878,
    898798,
    979878,
    978898,
    897799,
    867887,
    687899,
    977888,
    897887,
    766897,
    887888,
    979879,
    989776,
    888988,
    777868,
    879897,
    987878,
    779788,
    898887,
    699887,
    768887,
    787986,
    888677,
    887768,
    877868,
    888899,
    788887,
    998978,
    888778,
    768879,
    888876,
    888998,
    799988,
    788778,
    788886,
    999888,
    797989,
    987978,
    777779,
    789977,
    767897,
    899789,
    778869,
    979989,
    897987,
    977889,
    889888,
    777899,
    798779,
    789877,
    769878,
    878999,
    988798,
    778678,
    989788,
    767888,
    898798,
    867988,
    789879,
    899888,
    887878,
    798778,
    878799,
    788988,
    879777,
    798796,
    978879,
    777989,
    777897,
    779789,
    877977,
    768878,
    778886,
    976878,
    976797,
    888688,
    797886,
    978767,
    886988,
    697888,
    889888,
    797888,
    789688,
    978879,
    789878,
    886989,
    867887,
    997787,
    978798,
    988678,
    868677,
    779788,
    769788,
    878777,
    898987,
    789889,
    888878,
    896798,
    888688,
    987789,
    768897,
    779799,
    878768,
    899888,
    879679,
    888777,
    897878,
    878778,
    887786,
    979886,
    888889,
    988799,
    787789,
    988899,
    697988,
    889888,
    977787,
    777887,
    788879,
    797878,
    988967,
    778887,
    798779,
    877898,
    787886,
    788889,
    788978,
    787999,
    787898,
    888889,
    887877,
    688778,
    869868,
    779978,
    877798,
    897989,
    787799,
    899987,
    997989,
    887977,
    989888,
    877888,
    879897,
    777878,
    897887,
    779888,
    878978,
    778778,
    678997,
    978797,
    788699,
    987776,
    879977,
    869767,
    677798,
    879869,
    687897,
    778887,
    887979,
    888989,
    989878,
    886787,
    887868,
    796889,
    888998,
    788876,
    988977,
    888878,
    788979,
    887788,
    888888,
    788898,
    877897,
    889869,
    779867,
    887777,
    889878,
    678897,
    677887,
    888798,
    989676,
    788788,
    889979,
    989789,
    978997,
    977697,
    888878,
    898887,
    979888,
    878877,
    779779,
    876897,
    789997,
    986886,
    888998,
    687989,
    786787,
    788778,
    887887,
    887878,
    879997,
    887989,
    986898,
    887899,
    877799,
    677898,
    988999,
    887888,
    878777,
    786789,
    877867,
    797988,
    988988,
    768787,
    788877,
    778788,
    777789,
    988989,
    876897,
    868698,
    877887,
    787988,
    777888,
    979788,
    988989,
    988979,
    898799,
    878899,
    879787,
    798788,
    988999,
    789786,
    789798,
    886888,
    788778,
    777878,
    769987,
    977898,
    867887,
    888989,
    887879,
    788887,
    788788,
    878787,
    878887,
    978777,
    776797,
    867998,
    988868,
    687996,
    868788,
    777788,
    897878,
    878978,
    888787,
    897986,
    988988,
    797779,
    887798,
    888978,
    869889,
    888777,
    878889,
    878778,
    899988,
    878768,
    788877,
    988788,
    878979,
    789888,
    979877,
    879888,
    799798,
    897998,
    787899,
    778988,
    777778,
    888667,
    886777,
    779899,
    889789,
    866978,
    998676,
    798898,
    777879,
    898987,
    977896,
    777789,
    898888,
    778886,
    987888,
    789988,
    778888,
    987889,
    899798,
    989887,
    788878,
    887988,
    887788,
    897887,
    777886,
    878876,
    786878,
    788898,
    987867,
    888978,
    787978,
    888877,
    888688,
    976778,
    888879,
    868777,
    868897,
    777779,
    776999,
    878888,
    988898,
    887867,
    777987,
    999889,
    879798,
    799866,
    787888,
    887898,
    786769,
    778768,
    977878,
    989877,
    878986,
    788877,
    978888,
    787877,
    887797,
    686886,
    887777,
    867879,
    788888,
    987788,
    878887,
    867678,
    987797,
    878988,
    878968,
    887886,
    878778,
    898777,
    888778,
    788989,
    877777,
    777988,
    979779,
    877877,
    876878,
    899998,
    998678,
    767897,
    899688,
    997799,
    877788,
    777898,
    987899,
    977788,
    887686,
    998797,
    787898,
    788887,
    999787,
    888698,
    988778,
    977876,
    886877,
    978998,
    998888,
    767896,
    788779,
    888879,
    778887,
    779888,
    988977,
    777897,
    989789,
    768788,
    788768,
    978887,
    788796,
    998787,
    878899,
    989777,
    887898,
    877777,
    898897,
    788977,
    887898,
    888879,
    988876,
    778987,
    786987,
    877797,
    777788,
    897888,
    887888,
    788988,
    877688,
    988787,
    778788,
    877689,
    689899,
    799978,
    897898,
    878987,
    788877,
    987889,
    896878,
    787777,
    778869,
    898887,
    896889,
    986786,
    789979,
    889789,
    868789,
    876879,
    898768,
    688899,
    898987,
    978877,
    988778,
    997886,
    876978,
    888777,
    989877,
    888887,
    897688,
    898987,
    887979,
    888768,
    877788,
    888768,
    768867,
    998887,
    777988,
    798787,
    789978,
    997797,
    898687,
    979987,
    989887,
    888989,
    887799,
    777877,
    899789,
    877786,
    799777,
    778787,
    889788,
    988798,
    879887,
    877887,
    978898,
    889777,
    887878,
    877867,
    889787,
    887979,
    767778,
    779868,
    887678,
    787878,
    769786,
    786888,
    877898,
    788776,
    887888,
    887786,
    887678,
    868877,
    699878,
    887797,
    888689,
    787888,
    777878,
    989998,
    878887,
    979789,
    886789,
    779889,
    997787,
    798777,
    778778,
    888898,
    986868,
    897878,
    887797,
    779698,
    978967,
    978889,
    779787,
    878988,
    879798,
    697886,
    988989,
    799889,
    879968,
    977887,
    887968,
    789788,
    878898,
    878898,
    987768,
    878888,
    887869,
    897876,
    978798,
    987676,
    967798,
    988878,
    989899,
    788978,
    789988,
    877789,
    776889,
    998687,
    888778,
    888889,
    877799,
    798988,
    998887,
    698967,
    877888,
    779878,
    788887,
    889769,
    997878,
    877878,
    878888,
    798976,
    987777,
    887787,
    979878,
    898879,
    889787,
    896978,
    778988,
    778888,
    888799,
    887897,
    877889,
    988979,
    877898,
    888787,
    776878,
    879887,
    887789,
    778976,
    988988,
    988889,
    989787,
    898878,
    887688,
    779778,
    888988,
    788878,
    789997,
    787898,
    987879,
    878878,
    878786,
    777877,
    879778,
    878697,
    879768,
    878797,
    877877,
    878878,
    868887,
    777898,
    988897,
    688779,
    787877,
    778777,
    878989,
    998899,
    798778,
    867788,
    787676,
    877879,
    798788,
    988978,
    779986,
    987898,
    789879,
    877787,
    788879,
    888999,
    878986,
    698876,
    897889,
    887887,
    787877,
    987978,
    886777,
    889878,
    777889,
    967697,
    899988,
    877897,
    887877,
    688888,
    786978,
    898678,
    676978,
    878898,
    887977,
    877887,
    777798,
    789878,
    979778,
    998978,
    679878,
    778877,
    897788,
    776787,
    787789,
    787877,
    677878,
    878897,
    687878,
    887887,
    789878,
    898787,
    798989,
    879878,
    878787,
    888966,
    778878,
    988787,
    989878,
    998769,
    677796,
    989987,
    977888,
    888968,
    679766,
    899788,
    888876,
    989986,
    888787,
    889898,
    678677,
    977898,
    899799,
    877787,
    987888,
    768979,
    889889,
    788878,
    797888,
    889887,
    679978,
    996889,
    787778,
    977977,
    889978,
    988899,
    977897,
    888977,
    978977,
    989788,
    877888,
    987889,
    798887,
    777986,
    687988,
    879888,
    968989,
    868976,
    788788,
    789988,
    988887,
    769989,
    978689,
    777778,
    989897,
    789887,
    898888,
    778787,
    979799,
    869979,
    979886,
    988778,
    887787,
    797877,
    867888,
    788777,
    778887,
    998897,
    877987,
    888887,
    787888,
    978887,
    976887,
    977877,
    787997,
    797889,
    777788,
    788867,
    979788,
    898786,
    898698,
    978677,
    668788,
    877887,
    778787,
    888878,
    787896,
    787886,
    788787,
    877688,
    778877,
    988798,
    879989,
    978977,
    978988,
    788786,
    777878,
    977888,
    768987,
    987777,
    767898,
    986879,
    887888,
    887899,
    878886,
    777878,
    787686,
    878769,
    868899,
    768889,
    997887,
    988777,
    788787,
    988899,
    988799,
    987789,
    988777,
    787878,
    886888,
    888898,
    888897,
    788888,
    777978,
    779679,
    877988,
    898966,
    879888,
    797688,
    787878,
    769778,
    779887,
    797697,
    898787,
    686788,
    778977,
    999867,
    887787,
    879998,
    777888,
    977869,
    988787,
    988987,
    788987,
    777789,
    789687,
    889788,
    887898,
    798786,
    998778,
    878787,
    888768,
    769876,
    787797,
    878788,
    786998,
    798898,
    877778,
    768798,
    998778,
    986787,
    888888,
    878888,
    678898,
    877877,
    678887,
    679798,
    867898,
    777888,
    877769,
    889977,
    799977,
    868888,
    998978,
    789886,
    798797,
    778879,
    877777,
    797888,
    899887,
    687767,
    679878,
    666876,
    988887,
    997778,
    998868,
    887788,
    788886,
    777798,
    779976,
    797898,
    888898,
    998668,
    896787,
    878988,
    788898,
    777778,
    779878,
    788888,
    879789,
    798887,
    789977,
    788699,
    877889,
    898777,
    898978,
    788786,
    798769,
    788877,
    888798,
    787677,
    777888,
    898878,
    878787,
    697997,
    787898,
    878866,
    977777,
    797779,
    987979,
    787889,
    778798,
    788868,
    988887,
    789889,
    878788,
    777787,
    877886,
    779897,
    988789,
    769898,
    787778,
    776979,
    967888,
    999788,
    797788,
    977898,
    777898,
    878887,
    888688,
    989788,
    687779,
    877877,
    888888,
    979998,
    788787,
    989788,
    788987,
    988887,
    887887,
    989998,
    988778,
    987987,
    977869,
    888798,
    688898,
    898889,
    788767,
    888898,
    788986,
    988889,
    788767,
    877778,
    889778,
    977888,
    888888,
    796977,
    967669,
    887877,
    888796,
    977799,
    787688,
    976888,
    877878,
    888988,
    898976,
    987888,
    877987,
    877779,
    888777,
    989878,
    789678,
    676877,
    967897,
    988987,
    898977,
    787988,
    887998,
    778769,
    879999,
    788788,
    968888,
    678978,
    679778,
    688889,
    997888,
    778987,
    668888,
    978779,
    788988,
    898976,
    768788,
    979869,
    978789,
    787787,
    897886,
    888787,
    787887,
    888978,
    888777,
    988797,
    798896,
    878788,
    989787,
    788988,
    897778,
    898878,
    789788,
    788788,
    787998,
    879689,
    876878,
    877778,
    778878,
    878787,
    788887,
    988787,
    878897,
    779688,
    897999,
    876798,
    778998,
    877889,
    689978,
    887978,
    688777,
    888786,
    798798,
    887889,
    877677,
    788788,
    787788,
    788898,
    878898,
    797898,
    888768,
    788886,
    989879,
    799878,
    889978,
    898788,
    868686,
    787778,
    889867,
    877979,
    777989,
    987777,
    877767,
    896887,
    898987,
    878788,
    789988,
    697867,
    976679,
    789788,
    798788,
    967789,
    779779,
    986877,
    788878,
    788788,
    787877,
    867699,
    788787,
    887899,
    897778,
    779887,
    986789,
    987988,
    888797,
    769788,
    787879,
    776886,
    987878,
    788997,
    787779,
    898899,
    798889,
    978699,
    788778,
    977878,
    777978,
    777789,
    997798,
    888988,
    887997,
    878687,
    778788,
    988788,
    888898,
    787977,
    887877,
    879989,
    877778,
    878776,
    989887,
    889778,
    786887,
    888897,
    777897,
    778698,
    677869,
    868878,
    888898,
    879988,
    787988,
    789879,
    798887,
    779898,
    986788,
    978889,
    989897,
    988899,
    689897,
    786997,
    887888,
    898887,
    766878,
    888877,
    778877,
    687687,
    798789,
    877988,
    978767,
    877899,
    788988,
    879899,
    888886,
    798787,
    787779,
    978878,
    887878,
    778789,
    898889,
    887887,
    887887,
    877788,
    798878,
    887889,
    887877,
    889888,
    978977,
    788897,
    888779,
    787869,
    867987,
    778779,
    797677,
    788987,
    989888,
    998979,
    869977,
    787877,
    778989,
    976788,
    978888,
    868877,
    987878,
    867888,
    879888,
    987788,
    867979,
    687888,
    877878,
    877879,
    997787,
    898878,
    887677,
    879788,
    988787,
    698777,
    987776,
    786889,
    869868,
    789799,
    899987,
    876779,
    888887,
    988779,
    988789,
    877887,
    879987,
    887888,
    798877,
    789978,
    988898,
    897887,
    887977,
    887777,
    989777,
    887678,
    877778,
    787878,
    999768,
    798898,
    769978,
    788987,
    896896,
    986779,
    777777,
    899998,
    979699,
    778896,
    778877,
    776789,
    888869,
    678787,
    989998,
    888888,
    878779,
    787778,
    787888,
    888799,
    788677,
    798886,
    988778,
    868889,
    887797,
    778999,
    896896,
    898866,
    788886,
    888797,
    878779,
    878988,
    898788,
    988878,
    979889,
    988888,
    878887,
    788878,
    788879,
    877887,
    778977,
    887888,
    878778,
    667978,
    889886,
    768796,
    988888,
    888887,
    988879,
    778998,
    789897,
    777768,
    799977,
    879887,
    877868,
    977788,
    888777,
    777888,
    787799,
    967878,
    997898,
    988877,
    888988,
    877788,
    787976,
    878779,
    987779,
    898898,
    878779,
    888878,
    888878,
    788788,
    878887,
    677887,
    778997,
    868678,
    877978,
    888897,
    878899,
    799778,
    779889,
    688877,
    789688,
    987878,
    878897,
    868977,
    778788,
    788886,
    779799,
    767876,
    789789,
    887789,
    978987,
    889876,
    898888,
    787897,
    977789,
    877899,
    889888,
    888778,
    977777,
    788897,
    989877,
    798887,
    877878,
    897788,
    989788,
    787898,
    687898,
    976987,
    767799,
    876777,
    987787,
    886878,
    987678,
    866889,
    789778,
    688779,
    888988,
    779878,
    988878,
    787686,
    887987,
    868787,
    987878,
    888777,
    867888,
    878878,
    768998,
    997979,
    777988,
    998799,
    897877,
    779967,
    797779,
    887879,
    977788,
    788698,
    898979,
    687878,
    897987,
    798798,
    977878,
    877776,
    877788,
    798897,
    779878,
    888778,
    878879,
    787977,
    897798,
    776986,
    688977,
    799799,
    888788,
    788888,
    788989,
    988988,
    897877,
    888888,
    798897,
    777968,
    777879,
    888987,
    887776,
    777998,
    876678,
    778879,
    698988,
    887986,
    888788,
    989988,
    778978,
    886777,
    988786,
    979798,
    786776,
    878978,
    768688,
    968887,
    787888,
    878688,
    787888,
    878878,
    686797,
    779987,
    797989,
    787878,
    879789,
    687778,
    887879,
    978967,
    988877,
    787878,
    877876,
    997877,
    889987,
    878777,
    989698,
    698867,
    797887,
    787886,
    899898,
    887798,
    787796,
    788777,
    897778,
    989798,
    886779,
    788978,
    678787,
    978897,
    798878,
    798989,
    878887,
    889988,
    899687,
    878677,
    878788,
    787788,
    867787,
    798879,
    787779,
    788979,
    989889,
    767869,
    798868,
    889677,
    879788,
    879879,
    879786,
    789898,
    877678,
    798788,
    787697,
    867779,
    978777,
    886777,
    899889,
    779777,
    887887,
    889789,
    998978,
    888788,
    878868,
    798878,
    877779,
    779787,
    877877,
    888877,
    778977,
    787679,
    898788,
    879886,
    978888,
    788778,
    778677,
    898886,
    788796,
    788889,
    896798,
    988779,
    687888,
    678677,
    789787,
    666888,
    786679,
    889877,
    768799,
    889877,
    879889,
    797779,
    897888,
    688786,
    889977,
    879877,
    986888,
    789989,
    788788,
    977888,
    789997,
    869788,
    698886,
    878897,
    878977,
    998788,
    877988,
    788887,
    988787,
    777798,
    877987,
    778779,
    787778,
    777888,
    778677,
    877878,
    797887,
    788998,
    787888,
    888998,
    788679,
    889778,
    689889,
    769888,
    769788,
    776887,
    767888,
    798898,
    998897,
    887788,
    788867,
    897897,
    788989,
    789888,
    986897,
    778779,
    878787,
    888787,
    787698,
    778879,
    799987,
    888888,
    888888,
    777968,
    997878,
    687967,
    867898,
    787768,
    988899,
    778688,
    788888,
    889797,
    888677,
    888997,
    898887,
    898798,
    777887,
    888968,
    798889,
    888798,
    879977,
    898888,
    986787,
    867887,
    688897,
    897879,
    786797,
    889888,
    778878,
    978898,
    789878,
    778889,
    769977,
    989988,
    886988,
    878889,
    968877,
    897889,
    878777,
    768778,
    779877,
    977778,
    889778,
    878898,
    978799,
    986786,
    878999,
    998877,
    977888,
    979798,
    986878,
    988789,
    798887,
    878788,
    678787,
    997799,
    988797,
    887888,
    987788,
    888979,
    887776,
    868888,
    988798,
    877887,
    798897,
    796979,
    888878,
    887998,
    887877,
    989778,
    687779,
    896887,
    987888,
    677888,
    787998,
    788977,
    778878,
    887797,
    869978,
    788878,
    979899,
    889787,
    798988,
    786888,
    787888,
    886987,
    777977,
    777979,
    887887,
    989887,
    768887,
    878887,
    977787,
    788978,
    887668,
    799778,
    888886,
    777878,
    867797,
    877876,
    878789,
    778789,
    889889,
    888787,
    797767,
    979989,
    777788,
    878878,
    778878,
    788879,
    797978,
    688789,
    887997,
    788666,
    788978,
    787978,
    886788,
    978878,
    988779,
    978879,
    888978,
    976877,
    868777,
    778898,
    987787,
    889888,
    998797,
    888879,
    787787,
    888987,
    877788,
    989899,
    677998,
    887778,
    898787,
    868988,
    778898,
    698869,
    779887,
    777678,
    778876,
    878879,
    797778,
    989989,
    779879,
    777978,
    899898,
    768888,
    889888,
    679888,
    677776,
    786988,
    987888,
    687899,
    898779,
    887878,
    777867,
    887776,
    887897,
    699876,
    687798,
    698878,
    778768,
    898877,
    887788,
    789787,
    878988,
    877799,
    779778,
    789979,
    798766,
    696878,
    977798,
    978778,
    878687,
    887976,
    888978,
    989877,
    986778,
    889998,
    977899,
    987798,
    787878,
    878788,
    987998,
    887988,
    778777,
    867798,
    787889,
    898778,
    778789,
    768988,
    987968,
    789788,
    899878,
    987779,
    896869,
    877789,
    779788,
    868987,
    889787,
    779886,
    977689,
    778877,
    778899,
    787767,
    879889,
    886979,
    787888,
    888889,
    998986,
    977788,
    778998,
    779888,
    887877,
    888986,
    867896,
    789886,
    687888,
    889788,
    889898,
    888877,
    877888,
    889798,
    999776,
    898777,
    789889,
    986899,
    788677,
    787898,
    787889,
    877887,
    888877,
    878887,
    789988,
    889867,
    888988,
    878888,
    978889,
    699788,
    998687,
    877887,
    778988,
    888788,
    778766,
    788778,
    787877,
    796869,
    789788,
    887978,
    867786,
    887867,
    987677,
    786877,
    887978,
    886799,
    769889,
    786898,
    877878,
    897777,
    886888,
    787798,
    869897,
    889696,
    988787,
    989689,
    987977,
    887788,
    779797,
    889798,
    868889,
    879898,
    768776,
    789899,
    669778,
    898877,
    888888,
    789799,
    776898,
    788788,
    979889,
    998886,
    888778,
    968886,
    687787,
    888798,
    988997,
    789889,
    689778,
    878986,
    987788,
    798868,
    877867,
    977888,
    987898,
    876788,
    788899,
    797879,
    678787,
    899878,
    878888,
    899887,
    987778,
    888778,
    877888,
    786788,
    787777,
    887886,
    986768,
    786988,
    998988,
    977888,
    878977,
    888887,
    778877,
    887978,
    786989,
    787888,
    889797,
    878768,
    979977,
    878887,
    978777,
    977898,
    878798,
    977678,
    768978,
    868687,
    989797,
    777999,
    868786,
    888688,
    876778,
    887897,
    888889,
    879879,
    788998,
    977776,
    799778,
    888878,
    789888,
    789867,
    788899,
    679878,
    789987,
    889989,
    798886,
    777889,
    788777,
    877977,
    988777,
    796888,
    888878,
    788777,
    978898,
    889967,
    787688,
    889876,
    798977,
    778887,
    787889,
    788997,
    776698,
    889899,
    889797,
    988798,
    797876,
    977897,
    977898,
    778878,
    887887,
    778789,
    789889,
    996787,
    898787,
    997799,
    897968,
    989787,
    778988,
    779778,
    879998,
    877696,
    899799,
    766887,
    878887,
    678878,
    898999,
    988988,
    899788,
    987887,
    878877,
    777788,
    888897,
    879877,
    687978,
    999797,
    987886,
    898897,
    798877,
    888677,
    787789,
    888979,
    998786,
    888879,
    799776,
    888998,
    778878,
    877789,
    868896,
    788796,
    997886,
    687777,
    798888,
    988988,
    797887,
    869689,
    879868,
    977797,
    789987,
    788896,
    888778,
    698887,
    879886,
    897787,
    878799,
    977898,
    989787,
    898877,
    888788,
    989788,
    778988,
    989787,
    868878,
    978799,
    878778,
    787889,
    669887,
    897778,
    887778,
    978899,
    867878,
    797878,
    696778,
    888978,
    779688,
    987798,
    797988,
    787898,
    686788,
    698878,
    768998,
    897776,
    878879,
    987988,
    767879,
    898877,
    888877,
    798788,
    988789,
    797899,
    787887,
    878887,
    887887,
    788887,
    898887,
    889867,
    899998,
    898787,
    978788,
    779779,
    877878,
    787777,
    799799,
    778889,
    788789,
    778787,
    887788,
    988787,
    889686,
    888788,
    987789,
    997788,
    878888,
    679797,
    878789,
    788788,
    989876,
    666788,
    879988,
    787776,
    898778,
    978787,
    999887,
    788788,
    977787,
    778889,
    789878,
    777899,
    878789,
    897896,
    878889,
    887987,
    887888,
    876779,
    877888,
    987978,
    977878,
    987878,
    889778,
    897788,
    889788,
    777866,
    788877,
    899967,
    699887,
    888787,
    869788,
    897778,
    979788,
    987778,
    987888,
    888686,
    977899,
    998797,
    877988,
    678997,
    898768,
    787878,
    888987,
    988988,
    787888,
    888988,
    889978,
    779987,
    778877,
    786988,
    789688,
    777879,
    888897,
    978988,
    778876,
    977798,
    787789,
    779887,
    688988,
    778888,
    887789,
    898897,
    788877,
    988688,
    667898,
    798879,
    878888,
    867987,
    789889,
    778787,
    777789,
    978787,
    898687,
    788779,
    797777,
    777896,
    878788,
    788798,
    977898,
    988788,
    798779,
    898898,
    977889,
    777667,
    889788,
    777777,
    877786,
    888788,
    897886,
    887778,
    778989,
    779789,
    887786,
    888889,
    799868,
    977988,
    889888,
    789779,
    987769,
    798768,
    786777,
    977877,
    899798,
    689889,
    778877,
    878878,
    977877,
    888886,
    798778,
    888887,
    867879,
    766897,
    988888,
    879987,
    878789,
    788697,
    977799,
    977887,
    887797,
    978878,
    788688,
    897898,
    878797,
    988888,
    978777,
    796887,
    778978,
    776787,
    897697,
    797887,
    669788,
    778998,
    778967,
    886896,
    988777,
    876879,
    798887,
    878899,
    787799,
    869788,
    888877,
    887788,
    989778,
    888988,
    877989,
    877987,
    897987,
    878889,
    787778,
    997886,
    878898,
    889788,
    868899,
    788778,
    869887,
    988787,
    889778,
    778789,
    888789,
    777688,
    977876,
    879788,
    887869,
    877776,
    989887,
    677789,
    788989,
    889888,
    998787,
    979868,
    886898,
    788878,
    789678,
    879787,
    897777,
    788787,
    888888,
    886687,
    797888,
    868997,
    878879,
    899789,
    777897,
    779779,
    897878,
    998888,
    887877,
    989888,
    787898,
    877778,
    977998,
    988798,
    888778,
    886979,
    687878,
    889969,
    988789,
    898887,
    878888,
    977988,
    788977,
    679788,
    878987,
    798787,
    797878,
    779788,
    987867,
    798899,
    987688,
    889788,
    888878,
    977896,
    888978,
    898788,
    978898,
    869787,
    679878,
    879888,
    989897,
    877787,
    788767,
    778788,
    779887,
    978996,
    778788,
    877887,
    887998,
    877769,
    688968,
    788778,
    898888,
    687879,
    788778,
    777897,
    878878,
    978878,
    767767,
    668789,
    978688,
    898887,
    978999,
    786978,
    886879,
    877889,
    768987,
    878878,
    977987,
    888799,
    888889,
    887879,
    886779,
    899897,
    888888,
    877687,
    688897,
    889788,
    898987,
    779989,
    787878,
    768877,
    988676,
    977868,
    866978,
    897888,
    878997,
    798878,
    787888,
    778987,
    788778,
    877988,
    877889,
    889886,
    878978,
    678798,
    677889,
    889886,
    887899,
    769886,
    877888,
    789878,
    778768,
    788868,
    888998,
    879786,
    787798,
    879776,
    678878,
    878976,
    898687,
    788887,
    988678,
    777889,
    679877,
    778987,
    768697,
    787888,
    787688,
    996878,
    997878,
    868787,
    988876,
    876978,
    978968,
    889978,
    878788,
    889888,
    777898,
    768898,
    777799,
    877878,
    798898,
    777778,
    889888,
    898886,
    787787,
    878878,
    888898,
    898899,
    977798,
    889966,
    778878,
    798987,
    787887,
    997797,
    868787,
    886977,
    798888,
    877878,
    979876,
    977897,
    898796,
    877878,
    877888,
    798777,
    887878,
    788897,
    986889,
    787788,
    976897,
    767987,
    688788,
    787887,
    899997,
    787878,
    988877,
    787887,
    788797,
    698797,
    679998,
    678978,
    878887,
    899799,
    898898,
    876796,
    777878,
    997887,
    968687,
    789796,
    778888,
    878897,
    887999,
    967778,
    887886,
    796889,
    887798,
    888788,
    788998,
    898788,
    889778,
    899879,
    888777,
    979886,
    698998,
    766879,
    887797,
    988887,
    988888,
    789887,
    898977,
    888777,
    778988,
    787887,
    898778,
    779886,
    868888,
    779788,
    788886,
    898888,
    978876,
    878898,
    887788,
    878868,
    787767,
    889788,
    778887,
    779778,
    778977,
    887678,
    997799,
    878767,
    976897,
    987879,
    667897,
    776787,
    778888,
    978888,
    689887,
    899988,
    989787,
    878977,
    788878,
    778978,
    889788,
    877966,
    688897,
    869788,
    798778,
    768679,
    996869,
    989768,
    889787,
    798878,
    899887,
    889988,
    788787,
    788787,
    797976,
    698897,
    888887,
    789867,
    986987,
    978967,
    788888,
    787878,
    769898,
    887888,
    788899,
    787898,
    788898,
    988999,
    779979,
    887888,
    679798,
    877768,
    879788,
    878877,
    688887,
    989778,
    789986,
    888887,
    976878,
    698777,
    898898,
    998778,
    888997,
    787869,
    888987,
    878887,
    987788,
    777777,
    886888,
    897798,
    997897,
    999788,
    899777,
    898979,
    687987,
    788677,
    888879,
    887898,
    877777,
    898887,
    797797,
    787988,
    887898,
    888787,
    789698,
    888776,
    787887,
    688687,
    798799,
    889878,
    868778,
    977978,
    778779,
    688788,
    878788,
    887998,
    779898,
    788888,
    777778,
    677787,
    877778,
    888777,
    966999,
    877688,
    877789,
    888788,
    987988,
    888788,
    979798,
    777878,
    966877,
    878878,
    789879,
    867869,
    789787,
    976686,
    778877,
    878978,
    986888,
    777766,
    888878,
    888878,
    877787,
    787678,
    989988,
    796897,
    978797,
    967877,
    788778,
    888778,
    797887,
    877887,
    878878,
    677797,
    768777,
    777779,
    778677,
    898778,
    998898,
    878889,
    889987,
    787867,
    877888,
    899887,
    988888,
    899887,
    888978,
    777888,
    988888,
    988878,
    877998,
    987987,
    786788,
    776978,
    878878,
    899796,
    878787,
    978877,
    887788,
    887886,
    789886,
    877987,
    797989,
    878888,
    888878,
    888878,
    787778,
    879877,
    798887,
    778787,
    998776,
    778878,
    878978,
    978696,
    888888,
    787978,
    797987,
    876786,
    899788,
    888879,
    888998,
    898998,
    888779,
    988768,
    769778,
    887899,
    889976,
    989879,
    898898,
    878788,
    788868,
    878977,
    778877,
    678788,
    898788,
    877878,
    778878,
    997987,
    887789,
    789879,
    878878,
    787977,
    787889,
    987887,
    979978,
    898779,
    988788,
    976878,
    779779,
    678787,
    889888,
    788688,
    778888,
    777888,
    887878,
    888987,
    877889,
    888868,
    877876,
    879978,
    988877,
    788887,
    877897,
    977797,
    798688,
    978787,
    897799,
    788887,
    787869,
    689797,
    888679,
    777689,
    878679,
    888787,
    989787,
    978988,
    878998,
    768878,
    887778,
    889898,
    896877,
    978787,
    889979,
    999789,
    888897,
    899796,
    698889,
    878788,
    979877,
    778878,
    898778,
    987778,
    779867,
    889887,
    777777,
    798999,
    878898,
    787779,
    888987,
    888978,
    887789,
    788888,
    778998,
    898888,
    788878,
    888779,
    897887,
    888867,
    889968,
    888878,
    678888,
    687889,
    998887,
    788866,
    787768,
    787878,
    988797,
    889978,
    986877,
    976776,
    898788,
    978989,
    987977,
    888878,
    788898,
    979887,
    987788,
    969878,
    789888,
    879877,
    898987,
    899969,
    698877,
    777769,
    897798,
    888987,
    889788,
    887887,
    768999,
    699788,
    979799,
    778888,
    796878,
    897889,
    788878,
    889789,
    888778,
    777788,
    899898,
    797777,
    878889,
    989777,
    889798,
    799799,
    888899,
    978888,
    888798,
    789898,
    877877,
    678877,
    879798,
    778679,
    978797,
    889788,
    898676,
    777877,
    888888,
    899798,
    887887,
    787899,
    896797,
    889997,
    788768,
    778998,
    899878,
    878797,
    777779,
    868888,
    779798,
    987888,
    888888,
    787788,
    679797,
    868778,
    777779,
    878877,
    889998,
    988878,
    889689,
    787979,
    776869,
    878977,
    887988,
    878786,
    798779,
    878799,
    798988,
    887999,
    778887,
    779687,
    888877,
    797769,
    788988,
    787778,
    998888,
    987887,
    889688,
    978878,
    878979,
    788888,
    797888,
    768777,
    987679,
    888899,
    998799,
    887899,
    668978,
    887879,
    877867,
    979869,
    769897,
    777876,
    669978,
    988988,
    667877,
    988778,
    797798,
    878777,
    877878,
    887988,
    876867,
    689788,
    888887,
    798787,
    876876,
    688779,
    999776,
    898888,
    888887,
    897787,
    798787,
    889877,
    977888,
    867677,
    779686,
    898878,
    798887,
    987889,
    999888,
    797888,
    888688,
    788898,
    786787,
    678868,
    778698,
    889777,
    888887,
    887788,
    977899,
    798898,
    877777,
    777878,
    776899,
    877778,
    898777,
    986779,
    779978,
    797789,
    787987,
    887887,
    988997,
    877887,
    769889,
    787788,
    887887,
    887779,
    787888,
    877788,
    979987,
    889788,
    998876,
    999767,
    986979,
    867687,
    878897,
    767778,
    798878,
    667778,
    888788,
    977889,
    778899,
    979768,
    778787,
    698787,
    977689,
    887688,
    787787,
    787786,
    889787,
    987898,
    897889,
    798988,
    978786,
    897899,
    967788,
    877988,
    898778,
    778868,
    879987,
    889898,
    988989,
    888998,
    878866,
    989977,
    877897,
    889778,
    987968,
    997987,
    887987,
    878889,
    788778,
    898887,
    778889,
    887888,
    868687,
    877977,
    897899,
    787877,
    868879,
    788879,
    889788,
    788976,
    897869,
    787777,
    766977,
    897879,
    986979,
    899767,
    687777,
    897878,
    887867,
    788688,
    898898,
    688879,
    897987,
    989878,
    799978,
    996768,
    787887,
    887879,
    876898,
    887879,
    978898,
    767789,
    869887,
    789898,
    876877,
    866998,
    798878,
    796889,
    877988,
    798897,
    898887,
    788787,
    888777,
    887878,
    777978,
    788867,
    887768,
    677778,
    788798,
    978679,
    978678,
    878887,
    987877,
    979887,
    897879,
    797898,
    998998,
    877887,
    789898,
    887978,
    888888,
    888887,
    879979,
    778777,
    687888,
    898898,
    999888,
    777897,
    879988,
    888887,
    989897,
    798788,
    987787,
    989998,
    898679,
    978786,
    879788,
    997999,
    879898,
    888687,
    878898,
    787868,
    888679,
    989889,
    878787,
    769777,
    888879,
    977787,
    788878,
    788897,
    777778,
    988869,
    777888,
    777788,
    868987,
    896678,
    886978,
    877778,
    797887,
    786886,
    776888,
    867797,
    888789,
    897888,
    988887,
    799797,
    887877,
    988688,
    897689,
    677778,
    988887,
    986777,
    888868,
    877787,
    897986,
    887989,
    787798,
    898778,
    787788,
    878877,
    887897,
    888898,
    877967,
    878788,
    896878,
    798988,
    878868,
    687779,
    777978,
    886997,
    977797,
    888979,
    788688,
    977888,
    977797,
    789877,
    887878,
    787989,
    877788,
    777899,
    878677,
    678897,
    799787,
    788768,
    798787,
    888979,
    767799,
    887777,
    888986,
    798888,
    889988,
    897897,
    888888,
    798788,
    888878,
    787897,
    679777,
    987789,
    877887,
    777989,
    988888,
    868877,
    877897,
    797998,
    877788,
    788888,
    968778,
    969878,
    877897,
    897898,
    787888,
    886989,
    699988,
    787777,
    989777,
    888797,
    876888,
    898998,
    879878,
    788789,
    877968,
    779787,
    779788,
    799966,
    989888,
    787777,
    889878,
    789799,
    888798,
    779987,
    777768,
    788879,
    888898,
    787977,
    889968,
    769869,
    987787,
    788998,
    877788,
    877788,
    878888,
    988789,
    788797,
    888967,
    886787,
    989878,
    987888,
    968899,
    768798,
    987798,
    978877,
    888877,
    888969,
    877898,
    987887,
    978887,
    688898,
    898888,
    769787,
    777978,
    679878,
    786977,
    777779,
    789897,
    787978,
    887789,
    998888,
    988888,
    887888,
    887799,
    888868,
    788778,
    877978,
    778798,
    776798,
    888778,
    779999,
    789979,
    788877,
    887787,
    888798,
    698979,
    878988,
    688878,
    867888,
    887787,
    877998,
    888988,
    788787,
    788968,
    887798,
    779878,
    997889,
    878877,
    777887,
    769888,
    788878,
    789777,
    878998,
    868778,
    999897,
    888888,
    786787,
    787988,
    997898,
    887789,
    789778,
    898888,
    787869,
    878788,
    777868,
    868869,
    688877,
    889788,
    778678,
    898868,
    897878,
    898877,
    887998,
    878777,
    797788,
    888778,
    679797,
    788898,
    688787,
    799899,
    977798,
    878888,
    788867,
    788988,
    979977,
    766887,
    897887,
    989777,
    778798,
    789878,
    878978,
    969888,
    687988,
    978887,
    987878,
    987898,
    888888,
    887887,
    877889,
    879887,
    998877,
    988898,
    788799,
    768679,
    989878,
    888978,
    978687,
    787687,
    889787,
    878887,
    888878,
    877988,
    799788,
    987988,
    898787,
    678986,
    978879,
    988987,
    786998,
    779998,
    887879,
    889788,
    888887,
    876879,
    776789,
    888787,
    879888,
    886777,
    977799,
    886799,
    979878,
    789787,
    788888,
    788998,
    967798,
    696888,
    788688,
    889787,
    887788,
    998797,
    787879,
    687789,
    777988,
    886867,
    866898,
    787788,
    787767,
    967877,
    988878,
    788887,
    789968,
    877778,
    897887,
    887778,
    888886,
    797766,
    898877,
    879997,
    987888,
    888889,
    989888,
    889889,
    668697,
    879997,
    767799,
    788879,
    788878,
    878778,
    898688,
    787777,
    778889,
    968988,
    788789,
    869879,
    898766,
    889778,
    779799,
    887988,
    676888,
    889888,
    797887,
    797878,
    769978,
    988788,
    987997,
    988888,
    699989,
    678878,
    787799,
    699889,
    987887,
    778877,
    767887,
    979777,
    887779,
    877998,
    788877,
    988897,
    887897,
    977887,
    878676,
    999887,
    777868,
    889788,
    888888,
    987979,
    688877,
    879889,
    889787,
    777698,
    898866,
    777888,
    878987,
    769868,
    879889,
    898978,
    788879,
    877788,
    788767,
    868799,
    988777,
    678986,
    789889,
    968899,
    697987,
    887888,
    978677,
    768777,
    778879,
    879687,
    998799,
    878898,
    796777,
    978687,
    689878,
    888878,
    889687,
    988887,
    899887,
    778797,
    897778,
    867988,
    887978,
    887677,
    788889,
    788798,
    897796,
    868887,
    789988,
    978899,
    788788,
    878787,
    768887,
    977876,
    998796,
    779877,
    778988,
    878998,
    769777,
    877789,
    897779,
    777789,
    777678,
    988887,
    779787,
    897899,
    887878,
    788878,
    768779,
    987778,
    887886,
    798779,
    788898,
    788699,
    878798,
    977878,
    988988,
    788778,
    888786,
    888988,
    887788,
    788988,
    777887,
    888978,
    888887,
    887787,
    878797,
    788898,
    879777,
    787877,
    976977,
    679797,
    987799,
    788997,
    798888,
    888787,
    686978,
    888777,
    677978,
    879879,
    788897,
    988798,
    788787,
    777777,
    987798,
    878886,
    889977,
    998778,
    988987,
    796799,
    977878,
    677879,
    778989,
    787887,
    787686,
    888899,
    787866,
    698797,
    789788,
    988787,
    899997,
    779879,
    778897,
    877986,
    697889,
    889889,
    868887,
    698788,
    888777,
    778888,
    878777,
    687967,
    987687,
    968886,
    876878,
    898988,
    878786,
    887886,
    877888,
    878788,
    888788,
    799898,
    789789,
    988778,
    879887,
    897989,
    699779,
    788876,
    867877,
    877698,
    888998,
    988887,
    878879,
    987787,
    878978,
    889896,
    798997,
    897776,
    677777,
    888878,
    886877,
    778779,
    986877,
    778988,
    987977,
    698877,
    888887,
    988887,
    779797,
    778776,
    968888,
    788878,
    876777,
    788879,
    688786,
    797997,
    777868,
    877977,
    888678,
    888887,
    898787,
    977989,
    887998,
    789786,
    968798,
    987988,
    678788,
    779778,
    878778,
    878789,
    798879,
    889876,
    988878,
    788877,
    889877,
    787889,
    888797,
    777787,
    996878,
    777987,
    878887,
    677997,
    979799,
    876997,
    697776,
    879796,
    888876,
    887879,
    877879,
    988886,
    899799,
    897788,
    978698,
    796688,
    797687,
    868887,
    898867,
    799877,
    877787,
    887878,
    889788,
    788898,
    899899,
    788889,
    987778,
    899788,
    789877,
    887799,
    676799,
    888888,
    988787,
    798767,
    988898,
    789799,
    886877,
    978988,
    769778,
    788697,
    897887,
    999869,
    889788,
    987879,
    798897,
    986897,
    888879,
    887897,
    979988,
    779987,
    888896,
    888788,
    878879,
    996989,
    868778,
    977768,
    878887,
    799897,
    998886,
    988888,
    796977,
    788788,
    797869,
    889888,
    976986,
    778888,
    777998,
    987996,
    888898,
    869668,
    776887,
    798777,
    786988,
    987898,
    988678,
    889897,
    876898,
    878998,
    798898,
    887778,
    878888,
    886778,
    888767,
    878898,
    677897,
    879987,
    778778,
    668899,
    978998,
    798977,
    989977,
    887886,
    887878,
    988888,
    988788,
    987798,
    999887,
    788988,
    799788,
    788889,
    787789,
    878878,
    866679,
    989988,
    678776,
    788777,
    888897,
    887878,
    988777,
    898988,
    978998,
    787789,
    889887,
    788778,
    878878,
    878888,
    877886,
    998779,
    888869,
    997989,
    677996,
    966888,
    888988,
    888988,
    798888,
    988799,
    888777,
    879877,
    877887,
    896786,
    887889,
    879989,
    877867,
    888878,
    979978,
    888989,
    777777,
    888988,
    888779,
    677897,
    788888,
    888877,
    877867,
    779888,
    887698,
    978889,
    696888,
    898898,
    878898,
    889988,
    787787,
    897868,
    896888,
    967997,
    998798,
    888789,
    979877,
    988778,
    899888,
    978867,
    988977,
    678678,
    888878,
    878968,
    888776,
    777787,
    887767,
    968788,
    877789,
    888797,
    889888,
    776798,
    887888,
    797887,
    786688,
    798688,
    778888,
    799988,
    887777,
    877788,
    888878,
    787886,
    898988,
    789878,
    989878,
    778879,
    787899,
    878888,
    777676,
    878788,
    767789,
    979978,
    778787,
    887888,
    789677,
    888797,
    887676,
    888887,
    989998,
    888978,
    777868,
    889696,
    787687,
    897888,
    888988,
    888798,
    997799,
    798778,
    978889,
    788777,
    889986,
    798876,
    897787,
    987899,
    888677,
    889867,
    879889,
    678989,
    888689,
    989887,
    997799,
    898887,
    787697,
    788877,
    769898,
    768889,
    699799,
    977888,
    987887,
    878789,
    887978,
    968886,
    996778,
    868888,
    868977,
    788987,
    787887,
    878887,
    698978,
    788877,
    977677,
    668888,
    889789,
    988896,
    878877,
    778768,
    997777,
    778898,
    697789,
    769798,
    988897,
    977877,
    897979,
    997767,
    788778,
    989888,
    998897,
    766798,
    978799,
    978798,
    777886,
    897869,
    686877,
    878678,
    789987,
    868988,
    779778,
    887988,
    887887,
    898776,
    779997,
    797887,
    668799,
    789696,
    898977,
    787878,
    788888,
    997788,
    768978,
    686888,
    787886,
    877998,
    898897,
    888877,
    876798,
    778878,
    877689,
    869688,
    878887,
    876888,
    889977,
    799877,
    888778,
    777788,
    777878,
    788767,
    679988,
    797787,
    778688,
    798777,
    878878,
    887768,
    987999,
    777789,
    878789,
    877798,
    999888,
    879888,
    997988,
    878887,
    797877,
    987796,
    687986,
    987798,
    777899,
    898979,
    899798,
    797689,
    787878,
    999787,
    778778,
    889779,
    889978,
    777888,
    889789,
    897678,
    787997,
    779896,
    898779,
    899876,
    787997,
    887988,
    888977,
    888689,
    879787,
    887788,
    878889,
    878987,
    878779,
    887887,
    797879,
    978989,
    767769,
    788797,
    978998,
    878768,
    887797,
    777888,
    998878,
    977887,
    878978,
    788788,
    676867,
    866888,
    797878,
    779877,
    888787,
    988786,
    797878,
    968999,
    878968,
    778889,
    977877,
    888798,
    688876,
    788778,
    888888,
    787888,
    867887,
    987788,
    879778,
    888899,
    797797,
    889889,
    789879,
    788987,
    898898,
    879787,
    779878,
    978897,
    889989,
    987978,
    878886,
    898789,
    988888,
    997888,
    888876,
    897987,
    898878,
    788987,
    868898,
    879887,
    788877,
    877778,
    787688,
    798889,
    798877,
    968898,
    877898,
    886877,
    698889,
    877888,
    788888,
    887878,
    889888,
    767888,
    799779,
    868689,
    787988,
    888777,
    979778,
    868768,
    887899,
    869988,
    788788,
    778788,
    888787,
    787779,
    897897,
    797797,
    888978,
    787699,
    978888,
    987876,
    776778,
    978878,
    998989,
    977787,
    797788,
    877988,
    987987,
    878787,
    878877,
    987878,
    989898,
    778977,
    778987,
    677896,
    778979,
    889776,
    888889,
    997799,
    797979,
    878877,
    798898,
    888798,
    797687,
    888788,
    979767,
    888987,
    887889,
    788877,
    878969,
    878887,
    877889,
    888977,
    888697,
    989978,
    688798,
    887888,
    978798,
    789979,
    888787,
    778896,
    878788,
    898888,
    888888,
    997978,
    897888,
    887789,
    788888,
    798788,
    877889,
    787797,
    878799,
    977878,
    888678,
    889789,
    878997,
    987888,
    888877,
    988978,
    788778,
    878977,
    788998,
    898889,
    887897,
    978987,
    778677,
    996888,
    889789,
    978788,
    888797,
    988787,
    797979,
    887987,
    878988,
    887779,
    898978,
    896879,
    867698,
    978869,
    997888,
    698688,
    798978,
    978978,
    699987,
    788988,
    787789,
    779778,
    979776,
    866677,
    777987,
    887799,
    997987,
    788678,
    789788,
    799688,
    888768,
    778888,
    989676,
    978868,
    878778,
    778988,
    778778,
    998887,
    698768,
    797679,
    777887,
    986877,
    766878,
    778997,
    878988,
    667888,
    869879,
    977899,
    867767,
    878988,
    886777,
    987877,
    888987,
    788888,
    788787,
    888898,
    878899,
    679888,
    887987,
    698776,
    898878,
    886799,
    799986,
    996988,
    989967,
    687778,
    887778,
    778788,
    867886,
    977788,
    687878,
    777988,
    887788,
    886888,
    797679,
    877879,
    977788,
    878899,
    887897,
    878888,
    788878,
    887779,
    787778,
    877887,
    797899,
    787778,
    978978,
    998788,
    787897,
    878877,
    978887,
    789778,
    877888,
    788889,
    788888,
    778988,
    887887,
    787789,
    889887,
    778968,
    878978,
    988988,
    889989,
    897787,
    787697,
    899877,
    988896,
    789779,
    789779,
    888868,
    899778,
    897687,
    977988,
    878976,
    867886,
    999778,
    896878,
    887789,
    898979,
    977889,
    868777,
    888977,
    999879,
    766779,
    887978,
    787788,
    868788,
    877988,
    798977,
    777678,
    778888,
    898888,
    989879,
    786977,
    889868,
    798878,
    779877,
    887789,
    877889,
    888987,
    867976,
    968888,
    886877,
    898989,
    888886,
    788679,
    779987,
    768878,
    987877,
    789999,
    678777,
    889886,
    787778,
    878877,
    798777,
    667878,
    877998,
    996777,
    787779,
    988977,
    888878,
    988888,
    889796,
    987689,
    887888,
    986878,
    976877,
    998778,
    688889,
    777879,
    868787,
    679887,
    897768,
    788989,
    899776,
    789987,
    879868,
    899797,
    898879,
    778887,
    897677,
    977878,
    878677,
    977999,
    897879,
    779687,
    889878,
    899988,
    897986,
    679977,
    988789,
    886888,
    899878,
    879887,
    868767,
    998899,
    888788,
    997789,
    888888,
    898678,
    899796,
    678877,
    889687,
    888899,
    897877,
    898889,
    988789,
    878887,
    688979,
    879887,
    878899,
    878879,
    898779,
    976788,
    888798,
    787999,
    789898,
    996788,
    679869,
    779788,
    769678,
    899897,
    878877,
    688778,
    987867,
    889878,
    697989,
    697797,
    799687,
    787879,
    698987,
    797988,
    887779,
    899899,
    797777,
    888778,
    788877,
    897788,
    689988,
    787978,
    868888,
    878777,
    878877,
    778889,
    978888,
    788889,
    897869,
    877777,
    788887,
    878889,
    789787,
    788787,
    889886,
    788788,
    877798,
    789887,
    877689,
    776789,
    788688,
    879687,
    796878,
    988697,
    886798,
    877867,
    777799,
    978887,
    797976,
    878797,
    889777,
    777877,
    889896,
    889788,
    788877,
    988879,
    777898,
    967898,
    888788,
    798886,
    898879,
    878688,
    878877,
    888777,
    877888,
    777886,
    777796,
    878988,
    669968,
    889979,
    778777,
    898887,
    887887,
    989877,
    788888,
    786767,
    887878,
    898689,
    778768,
    889889,
    787787,
    687779,
    888788,
    998887,
    688798,
    767978,
    877978,
    889788,
    968887,
    899688,
    898988,
    779796,
    798789,
    798986,
    868778,
    687787,
    898888,
    889698,
    978878,
    678778,
    779878,
    987897,
    688786,
    879988,
    989987,
    879686,
    887987,
    886778,
    898888,
    876887,
    888677,
    888877,
    968778,
    778788,
    799998,
    886867,
    797999,
    888899,
    879796,
    988868,
    888789,
    787888,
    877699,
    778787,
    898868,
    788688,
    868869,
    998778,
    887788,
    888879,
    869797,
    879877,
    778887,
    797977,
    899889,
    897886,
    888668,
    879776,
    998889,
    998877,
    987787,
    798987,
    987987,
    698876,
    887888,
    977787,
    879897,
    899989,
    986766,
    879877,
    888898,
    798967,
    777978,
    898789,
    878987,
    988787,
    878988,
    877687,
    878898,
    778789,
    787879,
    787879,
    778996,
    789887,
    998888,
    878787,
    887988,
    778888,
    888988,
    777897,
    888886,
    897887,
    888789,
    878777,
    986888,
    789786,
    878888,
    799979,
    989898,
    898898,
    788887,
    777988,
    988788,
    767787,
    779888,
    888986,
    886998,
    786797,
    888768,
    887878,
    987978,
    976889,
    788779,
    888788,
    789977,
    678798,
    897899,
    787878,
    796888,
    998878,
    978877,
    787788,
    778998,
    798877,
    789678,
    998787,
    678989,
    978988,
    887779,
    868877,
    888987,
    988679,
    887888,
    898978,
    878866,
    897978,
    796878,
    878798,
    788868,
    777786,
    889789,
    887778,
    878789,
    776879,
    877887,
    887897,
    788887,
    679888,
    788878,
    997788,
    788887,
    898789,
    888788,
    878998,
    888898,
    789999,
    798888,
    887896,
    778787,
    869887,
    889987,
    988888,
    988879,
    987678,
    789797,
    799779,
    888888,
    797968,
    778898,
    696787,
    998868,
    989879,
    899879,
    877768,
    879768,
    788777,
    899986,
    897878,
    777878,
    788877,
    968788,
    878778,
    788678,
    888887,
    987888,
    987878,
    788888,
    778887,
    797989,
    977687,
    888889,
    777887,
    888978,
    978979,
    798977,
    788887,
    987769,
    689887,
    788866,
    778878,
    898788,
    898878,
    778879,
    989797,
    887799,
    787688,
    968788,
    798988,
    798777,
    797798,
    899897,
    879988,
    878879,
    889787,
    887778,
    898777,
    888788,
    788886,
    888889,
    977887,
    977788,
    966887,
    977788,
    897687,
    868887,
    678987,
    688878,
    787767,
    899988,
    668999,
    987788,
    978798,
    867688,
    886888,
    968988,
    869787,
    878688,
    778998,
    888767,
    878997,
    978887,
    799879,
    887978,
    988768,
    898668,
    788878,
    889988,
    997879,
    779877,
    878888,
    799676,
    988967,
    878898,
    888988,
    888778,
    976889,
    887799,
    686897,
    977888,
    879988,
    886877,
    778987,
    897887,
    879888,
    677786,
    886997,
    877778,
    988897,
    889887,
    978778,
    888797,
    887777,
    787786,
    877878,
    879688,
    788888,
    678789,
    789767,
    887888,
    887679,
    787876,
    798787,
    796976,
    797878,
    877798,
    796869,
    878987,
    888787,
    788888,
    889888,
    878988,
    888788,
    888788,
    888879,
    689789,
    898778,
    779789,
    888888,
    889888,
    889778,
    778677,
    878898,
    777978,
    778988,
    868788,
    889777,
    898798,
    777886,
    779798,
    898768,
    878877,
    978978,
    878977,
    799889,
    798879,
    767877,
    878888,
    687888,
    787889,
    988777,
    888889,
    877988,
    788898,
    796967,
    877788,
    868988,
    777766,
    877798,
    687778,
    889778,
    878978,
    867768,
    978799,
    697877,
    997867,
    887788,
    889879,
    767987,
    999898,
    787789,
    988877,
    877878,
    698888,
    777888,
    889887,
    877978,
    888787,
    797788,
    987889,
    878978,
    788987,
    898997,
    889889,
    788878,
    897999,
    798787,
    697998,
    887677,
    978789,
    877778,
    677898,
    888788,
    888988,
    986988,
    878778,
    888876,
    788888,
    988868,
    878878,
    888787,
    887788,
    767899,
    868887,
    798788,
    777779,
    787889,
    897877,
    776988,
    879988,
    787899,
    887978,
    797788,
    978888,
    988889,
    798899,
    888988,
    798989,
    889878,
    868699,
    888787,
    776888,
    778887,
    777987,
    797968,
    878988,
    887977,
    796877,
    997789,
    878788,
    989678,
    888676,
    878789,
    866888,
    698887,
    777798,
    689778,
    868788,
    768989,
    879788,
    887677,
    879778,
    787797,
    887787,
    888777,
    898887,
    778769,
    878888,
    777888,
    789899,
    798987,
    777887,
    688698,
    897988,
    969878,
    766877,
    876879,
    777897,
    877778,
    877787,
    778687,
    879998,
    879778,
    777778,
    878987,
    987799,
    889897,
    987887,
    698789,
    788778,
    778976,
    879797,
    868787,
    889998,
    797797,
    789978,
    897988,
    877787,
    897988,
    887987,
    878868,
    798987,
    978988,
    888889,
    898787,
    896878,
    987786,
    889776,
    897788,
    877987,
    878787,
    879988,
    778799,
    799897,
    777776,
    988678,
    879887,
    788788,
    878887,
    988868,
    987969,
    867769,
    898799,
    987999,
    878778,
    878878,
    888879,
    888886,
    688787,
    887788,
    787978,
    878989,
    896868,
    778988,
    898777,
    898886,
    779788,
    977679,
    999878,
    677887,
    898787,
    688779,
    987988,
    788787,
    788877,
    877787,
    877797,
    877887,
    668776,
    887889,
    768888,
    988688,
    878888,
    797796,
    977879,
    987968,
    787977,
    778967,
    999879,
    898997,
    788897,
    887898,
    898988,
    887888,
    888789,
    787878,
    988788,
    788876,
    889799,
    868878,
    798778,
    786796,
    987988,
    888887,
    898977,
    878998,
    887889,
    778789,
    869889,
    698889,
    888887,
    978878,
    778899,
    788988,
    888898,
    867876,
    668788,
    869787,
    888877,
    897788,
    887999,
    787767,
    878798,
    788887,
    898696,
    897878,
    987788,
    987777,
    778878,
    888997,
    978777,
    778778,
    889689,
    998888,
    976879,
    797979,
    788877,
    787898,
    987788,
    889787,
    986888,
    688877,
    888878,
    788878,
    877887,
    879889,
    888878,
    699888,
    798798,
    779798,
    898888,
    878878,
    886986,
    767876,
    877887,
    997779,
    778878,
    888868,
    869886,
    789987,
    886969,
    799986,
    788777,
    898868,
    867788,
    786989,
    868879,
    877888,
    887889,
    877868,
    788899,
    767788,
    798787,
    997788,
    787688,
    878696,
    887776,
    697888,
    898987,
    878787,
    778886,
    899777,
    777788,
    787788,
    788977,
    877789,
    867867,
    987888,
    798797,
    777987,
    778887,
    769987,
    898899,
    888877,
    779886,
    878788,
    777878,
    897867,
    896987,
    778888,
    787787,
    887788,
    977888,
    767877,
    977778,
    668879,
    968888,
    689898,
    798789,
    989899,
    979888,
    888999,
    998878,
    997769,
    967796,
    986777,
    888798,
    777878,
    778877,
    788787,
    886997,
    787777,
    677989,
    887777,
    978798,
    998888,
    787787,
    889888,
    787796,
    777887,
    769787,
    878797,
    879887,
    797887,
    896787,
    888787,
    888986,
    886777,
    787887,
    998778,
    897888,
    888877,
    789798,
    878878,
    888877,
    988877,
    997978,
    787977,
    687988,
    898669,
    888888,
    797887,
    787799,
    988887,
    697878,
    788678,
    789788,
    779866,
    768868,
    869797,
    897898,
    789889,
    878878,
    878999,
    887787,
    879986,
    867778,
    887877,
    987868,
    897898,
    798789,
    999888,
    887987,
    888778,
    878888,
    687877,
    878788,
    796687,
    797888,
    776778,
    787878,
    786786,
    798888,
    979788,
    799797,
    998897,
    787677,
    688898,
    888878,
    998798,
    998878,
    789878,
    888889,
    879787,
    877788,
    777788,
    778789,
    788887,
    977888,
    888677,
    987789,
    777796,
    777898,
    787888,
    787899,
    887989,
    888888,
    998689,
    879789,
    877989,
    897768,
    888988,
    878776,
    877789,
    779896,
    777787,
    888787,
    867888,
    888868,
    788798,
    887998,
    886879,
    786778,
    788778,
    978868,
    888896,
    979778,
    887799,
    989888,
    877888,
    888887,
    888787,
    868898,
    769897,
    698778,
    787888,
    978779,
    977876,
    888878,
    777789,
    888878,
    887797,
    996787,
    989876,
    888767,
    888779,
    788689,
    767797,
    988777,
    998789,
    787888,
    888988,
    889778,
    888788,
    987787,
    978797,
    899879,
    888968,
    887798,
    998978,
    879898,
    966998,
    777898,
    879778,
    778786,
    887978,
    888876,
    798887,
    678778,
    777998,
    888979,
    797887,
    877978,
    987688,
    967868,
    887987,
    877778,
    777977,
    677978,
    888888,
    787878,
    889787,
    888878,
    767668,
    798997,
    898887,
    877878,
    988978,
    998889,
    888777,
    987787,
    878877,
    867987,
    788687,
    898878,
    879777,
    889776,
    878877,
    788899,
    888888,
    878867,
    988777,
    767778,
    888877,
    778879,
    788989,
    786788,
    897699,
    779978,
    978886,
    977788,
    997997,
    898679,
    887798,
    887777,
    878897,
    867987,
    878888,
    977868,
    888877,
    777687,
    778888,
    799898,
    877887,
    779969,
    878789,
    878889,
    886788,
    889887,
    899888,
    777888,
    798799,
    888967,
    798777,
    778888,
    769788,
    786677,
    677779,
    698677,
    987786,
    798967,
    789777,
    978988,
    788787,
    967878,
    789798,
    999798,
    797799,
    776997,
    998879,
    887989,
    888689,
    888996,
    779877,
    778888,
    868789,
    788897,
    899788,
    879987,
    987889,
    897876,
    988888,
    898888,
    788987,
    788897,
    887788,
    878897,
    689789,
    788878,
    988768,
    988898,
    879777,
    668778,
    699689,
    768886,
    979788,
    889788,
    997798,
    896888,
    978978,
    998878,
    888887,
    698898,
    877769,
    887867,
    888989,
    997996,
    898999,
    687888,
    889888,
    677878,
    698786,
    988887,
    879889,
    788877,
    798788,
    978777,
    897788,
    897788,
    968879,
    877999,
    778788,
    787889,
    788879,
    878888,
    997898,
    888888,
    889987,
    798789,
    988979,
    879767,
    787778,
    888798,
    988988,
    778987,
    877988,
    888788,
    887787,
    988787,
    879678,
    688979,
    778976,
    677888,
    888778,
    878789,
    878878,
    898978,
    988878,
    977987,
    888887,
    778878,
    898889,
    789886,
    697987,
    897679,
    878988,
    889978,
    876877,
    987987,
    787898,
    896996,
    996789,
    788768,
    987698,
    787898,
    888878,
    677788,
    988877,
    788878,
    789978,
    887868,
    887877,
    987898,
    678978,
    789788,
    887788,
    788888,
    787787,
    996688,
    778697,
    888988,
    888987,
    977988,
    887978,
    879977,
    887878,
    877979,
    889889,
    887878,
    887888,
    878899,
    888778,
    879789,
    888997,
    878787,
    686687,
    997898,
    897787,
    887897,
    896678,
    898678,
    878988,
    878976,
    969877,
    798797,
    889778,
    976987,
    876987,
    887798,
    796777,
    898977,
    877887,
    887977,
    689898,
    997779,
    667778,
    977877,
    897797,
    878787,
    978768,
    878877,
    889797,
    997777,
    987888,
    888788,
    797788,
    988778,
    979986,
    799888,
    978779,
    898977,
    979888,
    778788,
    887779,
    896778,
    788868,
    968767,
    877779,
    868789,
    878988,
    888787,
    889997,
    988988,
    888888,
    987997,
    887788,
    797879,
    878797,
    888797,
    889879,
    887878,
    888887,
    777788,
    888799,
    677777,
    787778,
    976879,
    788797,
    968779,
    877988,
    687797,
    887976,
    988988,
    997989,
    768898,
    788868,
    878999,
    887778,
    778787,
    888788,
    778797,
    877888,
    798978,
    878898,
    878888,
    879879,
    977889,
    887787,
    799978,
    698779,
    787779,
    888998,
    969899,
    888988,
    987887,
    877888,
    888779,
    768888,
    888889,
    787869,
    777897,
    788967,
    998798,
    976968,
    879887,
    789988,
    778877,
    888797,
    998777,
    997788,
    778878,
    867878,
    969778,
    789886,
    978676,
    878876,
    768776,
    998777,
    899897,
    787787,
    997778,
    977986,
    778878,
    997779,
    779989,
    797798,
    989778,
    887779,
    779788,
    888978,
    689798,
    698896,
    997787,
    876888,
    888878,
    778789,
    788888,
    887877,
    998879,
    778888,
    878887,
    987978,
    868997,
    768789,
    988678,
    787989,
    877788,
    887787,
    769789,
    999878,
    887788,
    889778,
    897976,
    887789,
    789777,
    787886,
    677898,
    787988,
    788777,
    878888,
    788889,
    778888,
    997979,
    788888,
    887869,
    999977,
    967879,
    888888,
    778987,
    798877,
    798897,
    678789,
    778989,
    777888,
    989998,
    887986,
    887689,
    877987,
    879888,
    888787,
    788797,
    979987,
    777969,
    989878,
    788697,
    788778,
    888889,
    866798,
    988878,
    979798,
    988899,
    778697,
    877689,
    777978,
    787788,
    888988,
    798989,
    988777,
    878668,
    898888,
    787888,
    668788,
    799996,
    879897,
    988899,
    867779,
    768898,
    878688,
    979986,
    898998,
    689887,
    976788,
    878677,
    777689,
    887787,
    778887,
    687789,
    988788,
    788798,
    887778,
    778877,
    987897,
    777898,
    778787,
    896899,
    777897,
    777898,
    777879,
    878969,
    898797,
    887778,
    899898,
    877898,
    787987,
    787879,
    789787,
    778877,
    798789,
    889988,
    888867,
    768898,
    988779,
    798976,
    887878,
    868999,
    897779,
    866978,
    989788,
    887886,
    768887,
    787898,
    878788,
    979879,
    886979,
    777886,
    988898,
    878897,
    988979,
    879778,
    769779,
    878978,
    887779,
    789977,
    978777,
    977697,
    997687,
    678978,
    788797,
    897878,
    798897,
    878898,
    878799,
    789897,
    778787,
    898699,
    897887,
    889887,
    888787,
    887889,
    698978,
    879899,
    898676,
    679778,
    987878,
    887888,
    897999,
    898888,
    978897,
    879989,
    778778,
    998898,
    889877,
    998887,
    898688,
    888669,
    776787,
    778887,
    777778,
    879889,
    977787,
    877887,
    899988,
    897688,
    987776,
    798769,
    888778,
    977889,
    687878,
    887797,
    768989,
    778897,
    877988,
    996767,
    998778,
    879897,
    778878,
    787788,
    878787,
    897888,
    687878,
    876789,
    788877,
    887897,
    997887,
    877888,
    998876,
    897889,
    889879,
    888989,
    988677,
    778896,
    778787,
    988768,
    878778,
    998778,
    876789,
    887888,
    978877,
    886977,
    678877,
    979898,
    788887,
    778768,
    869978,
    787788,
    988879,
    877889,
    777888,
    788897,
    876797,
    679977,
    978996,
    897989,
    798987,
    978787,
    988678,
    889878,
    798678,
    988979,
    877888,
    898798,
    988897,
    789777,
    977777,
    788888,
    787788,
    888888,
    898888,
    977977,
    887886,
    898779,
    777788,
    779679,
    888888,
    878788,
    779697,
    787877,
    888986,
    878977,
    889877,
    798799,
    977876,
    789787,
    776678,
    798778,
    878787,
    796788,
    997978,
    978877,
    677888,
    688878,
    688878,
    879887,
    888889,
    889987,
    787867,
    889778,
    878789,
    878797,
    888979,
    888769,
    979787,
    888678,
    788898,
    778889,
    887977,
    777698,
    788789,
    889799,
    789978,
    877799,
    977788,
    898897,
    888777,
    987677,
    779677,
    998788,
    878769,
    868979,
    889988,
    777778,
    878788,
    866897,
    976888,
    888988,
    767788,
    888888,
    778876,
    797879,
    977788,
    877779,
    778988,
    788898,
    898788,
    988897,
    878988,
    988877,
    787999,
    788777,
    998778,
    788787,
    797779,
    778767,
    877797,
    786877,
    997889,
    877887,
    677787,
    877787,
    688968,
    877878,
    687898,
    889778,
    879788,
    798898,
    786778,
    888797,
    787988,
    688986,
    788999,
    887896,
    978888,
    878798,
    877888,
    687788,
    889767,
    897987,
    768886,
    687797,
    887897,
    768879,
    887889,
    868877,
    797887,
    888898,
    898889,
    788876,
    687787,
    767776,
    789987,
    887888,
    887878,
    878798,
    897978,
    799787,
    888889,
    787778,
    678989,
    986977,
    889767,
    999898,
    786788,
    788899,
    788698,
    897769,
    787987,
    887787,
    887689,
    889889,
    966779,
    888877,
    798789,
    787778,
    788688,
    887878,
    787778,
    889878,
    788897,
    798886,
    778888,
    877899,
    888877,
    688888,
    778877,
    889987,
    989878,
    678788,
    787989,
    897988,
    887778,
    887989,
    888789,
    898788,
    979996,
    987767,
    978776,
    888897,
    977888,
    887788,
    888877,
    868777,
    879788,
    687896,
    777798,
    798896,
    688888,
    988977,
    867996,
    798878,
    777977,
    878879,
    979878,
    888786,
    888887,
    678787,
    798988,
    897888,
    778897,
    786879,
    789877,
    667878,
    787797,
    988897,
    788887,
    798777,
    888878,
    677789,
    788787,
    868879,
    797788,
    688787,
    697988,
    889787,
    897886,
    789978,
    979878,
    888687,
    899899,
    788798,
    888897,
    877988,
    877777,
    978788,
    878878,
    888878,
    998887,
    688878,
    898987,
    988887,
    888777,
    988899,
    787679,
    799787,
    888899,
    799788,
    778888,
    998798,
    988978,
    788798,
    777687,
    889998,
    779988,
    768897,
    988886,
    776778,
    877877,
    987877,
    797878,
    789888,
    989787,
    798998,
    899888,
    788797,
    688776,
    789997,
    778887,
    889868,
    897788,
    777897,
    888888,
    789886,
    887967,
    786779,
    669787,
    897889,
    778868,
    878886,
    779799,
    888877,
    797878,
    766686,
    977787,
    788698,
    999888,
    889878,
    887777,
    889779,
    788776,
    988978,
    878789,
    787988,
    888788,
    876986,
    868797,
    798998,
    898888,
    667897,
    978778,
    887868,
    787876,
    896977,
    687866,
    879888,
    988877,
    888679,
    777997,
    969967,
    788777,
    888988,
    877787,
    677878,
    888879,
    887988,
    789779,
    878877,
    897867,
    879789,
    978997,
    778779,
    988789,
    879778,
    878879,
    788978,
    988798,
    998967,
    878879,
    889769,
    666798,
    777998,
    889876,
    788788,
    788898,
    878987,
    798778,
    787879,
    879997,
    787787,
    688879,
    779768,
    788877,
    778888,
    989879,
    887777,
    888888,
    868969,
    889787,
    799888,
    788898,
    887887,
    776977,
    787799,
    879877,
    896777,
    986788,
    788889,
    689897,
    777777,
    987678,
    889878,
    888878,
    898789,
    778897,
    997776,
    897788,
    897787,
    898899,
    788799,
    868787,
    878977,
    877788,
    797996,
    787788,
    878888,
    789888,
    778978,
    889877,
    788877,
    797786,
    887888,
    878878,
    868888,
    788979,
    779886,
    979868,
    899897,
    768897,
    779698,
    989889,
    887968,
    776789,
    877768,
    687887,
    987886,
    798877,
    887977,
    787988,
    779677,
    888997,
    778777,
    898879,
    888988,
    896787,
    877878,
    789778,
    788787,
    977886,
    878878,
    879977,
    888888,
    688898,
    789798,
    778787,
    978888,
    977788,
    997887,
    767879,
    697889,
    787887,
    887777,
    797778,
    879987,
    787787,
    887788,
    988898,
    788789,
    688999,
    777887,
    687898,
    888788,
    787777,
    879898,
    897888,
    788899,
    888878,
    778997,
    788967,
    798887,
    788667,
    787787,
    889889,
    888778,
    877869,
    886978,
    877877,
    767899,
    889977,
    887887,
    677988,
    888987,
    878977,
    788977,
    888878,
    997698,
    888878,
    788879,
    788978,
    867887,
    778798,
    776878,
    898767,
    898799,
    968789,
    788868,
    879779,
    988786,
    878889,
    987779,
    787788,
    879978,
    987897,
    886699,
    788787,
    799986,
    889867,
    898767,
    978798,
    887687,
    778889,
    988877,
    687879,
    767786,
    877788,
    878889,
    987986,
    688898,
    798968,
    888778,
    797898,
    897886,
    878797,
    988866,
    888798,
    686988,
    898988,
    698897,
    789687,
    787988,
    798877,
    989988,
    777798,
    778989,
    788778,
    878888,
    776986,
    798987,
    987879,
    888888,
    897888,
    969779,
    987887,
    886878,
    888786,
    878989,
    887777,
    798788,
    878888,
    788789,
    687778,
    997688,
    878888,
    787789,
    977688,
    887897,
    778888,
    776889,
    788878,
    788969,
    777978,
    688888,
    878888,
    788776,
    878888,
    887886,
    887989,
    776778,
    788788,
    787898,
    877988,
    888878,
    788778,
    877797,
    978888,
    897799,
    787778,
    678889,
    688877,
    878989,
    976886,
    868888,
    667788,
    797788,
    988787,
    877898,
    877988,
    888778,
    877898,
    877788,
    998867,
    786677,
    676778,
    788888,
    789778,
    767978,
    777978,
    778978,
    799788,
    888898,
    779886,
    877898,
    997789,
    788898,
    799976,
    788978,
    889877,
    787778,
    778787,
    878798,
    778977,
    787787,
    877787,
    998988,
    778768,
    787877,
    787878,
    898776,
    876789,
    889778,
    878979,
    888698,
    878888,
    878878,
    788768,
    788879,
    797879,
    889987,
    886777,
    798888,
    777977,
    888978,
    898876,
    787888,
    887776,
    698789,
    888788,
    989778,
    887878,
    877787,
    697887,
    776879,
    767787,
    987886,
    988978,
    679788,
    787998,
    987878,
    778867,
    767699,
    888877,
    887798,
    888887,
    766886,
    887688,
    898889,
    889967,
    887778,
    788788,
    877898,
    788898,
    979777,
    798798,
    879988,
    789898,
    776999,
    679888,
    979869,
    989978,
    878967,
    888798,
    778797,
    778877,
    887798,
    787877,
    878878,
    897897,
    797998,
    888897,
    688888,
    878678,
    888978,
    979897,
    876797,
    679887,
    877989,
    888888,
    777878,
    978877,
    787888,
    787887,
    879777,
    888778,
    678968,
    766777,
    798797,
    868977,
    976878,
    987687,
    889889,
    998877,
    878778,
    797778,
    778977,
    997897,
    898878,
    798889,
    979888,
    789878,
    998799,
    787867,
    988778,
    788997,
    889776,
    987979,
    876787,
    887998,
    988798,
    987788,
    898789,
    887867,
    787889,
    778788,
    789898,
    797798,
    979899,
    688788,
    977798,
    778878,
    899878,
    977887,
    777888,
    788876,
    868879,
    789798,
    877889,
    789897,
    897786,
    978877,
    999887,
    886887,
    868887,
    997898,
    886977,
    898799,
    777879,
    887777,
    789767,
    689896,
    868798,
    977787,
    899797,
    877889,
    776889,
    898878,
    887789,
    878887,
    778888,
    788787,
    777878,
    887888,
    987779,
    888876,
    888878,
    897798,
    999878,
    887788,
    797998,
    687787,
    878878,
    888987,
    888877,
    868788,
    887877,
    897877,
    776778,
    787787,
    977787,
    878976,
    779987,
    896888,
    978787,
    889687,
    888778,
    799779,
    788888,
    899797,
    788967,
    969777,
    988888,
    978897,
    887978,
    788878,
    787677,
    967987,
    688998,
    879779,
    878677,
    979887,
    879887,
    988877,
    877879,
    797877,
    787988,
    887777,
    887898,
    987777,
    788979,
    877887,
    788889,
    898787,
    797787,
    889886,
    789898,
    878677,
    987888,
    889877,
    887787,
    979778,
    878998,
    979798,
    987786,
    779888,
    877878,
    677889,
    988977,
    899889,
    787868,
    888977,
    888799,
    768877,
    878789,
    687889,
    968899,
    778989,
    778687,
    898789,
    897978,
    798978,
    889878,
    979786,
    788978,
    876878,
    977898,
    778888,
    767887,
    879887,
    887878,
    887876,
    877877,
    897887,
    777867,
    979788,
    799879,
    888779,
    988997,
    887867,
    897867,
    766787,
    776989,
    778898,
    988889,
    688687,
    896997,
    789779,
    897998,
    888788,
    788888,
    989988,
    879868,
    787766,
    987989,
    987878,
    886987,
    977997,
    799687,
    977979,
    777988,
    799787,
    977687,
    897876,
    887887,
    778986,
    777776,
    889877,
    777778,
    978989,
    888887,
    788897,
    967998,
    876888,
    688997,
    788688,
    888879,
    677879,
    776787,
    987869,
    888887,
    899978,
    868778,
    696787,
    797777,
    777788,
    797789,
    787877,
    876966,
    777877,
    777978,
    788878,
    886999,
    888778,
    977786,
    889779,
    777868,
    977788,
    997789,
    777688,
    898888,
    777787,
    798987,
    778788,
    778889,
    888777,
    997687,
    778978,
    886879,
    898788,
    788786,
    777679,
    888698,
    989878,
    898777,
    777896,
    878887,
    798997,
    887877,
    886878,
    698687,
    978687,
    868998,
    878798,
    967789,
    777787,
    778888,
    797888,
    899776,
    888777,
    689978,
    788897,
    898989,
    888786,
    787886,
    898987,
    888768,
    788987,
    869777,
    797889,
    888889,
    798987,
    797887,
    797898,
    888989,
    986788,
    877898,
    989877,
    899796,
    776999,
    897888,
    967888,
    798878,
    868778,
    878887,
    678789,
    978989,
    786998,
    877787,
    797986,
    789778,
    778868,
    897778,
    877987,
    788878,
    798698,
    899986,
    898768,
    887888,
    989778,
    796897,
    978998,
    778798,
    887878,
    797788,
    887878,
    697887,
    888877,
    796888,
    789789,
    798688,
    678678,
    779899,
    887986,
    987799,
    778798,
    998897,
    777887,
    886877,
    878799,
    767878,
    878897,
    887877,
    876877,
    878799,
    779888,
    987789,
    887889,
    977688,
    777878,
    879899,
    968888,
    879978,
    787988,
    889889,
    897878,
    897797,
    768888,
    988878,
    789888,
    879788,
    888777,
    878986,
    876999,
    978867,
    699778,
    878889,
    989897,
    887777,
    878876,
    778888,
    779868,
    988797,
    788788,
    787886,
    777979,
    898786,
    989898,
    787889,
    876887,
    989767,
    889978,
    887778,
    788867,
    788977,
    988787,
    889877,
    798777,
    789788,
    787778,
    779688,
    978888,
    888988,
    788788,
    787868,
    778778,
    867798,
    978798,
    688889,
    887868,
    897878,
    889787,
    888788,
    677868,
    977798,
    788977,
    997889,
    988887,
    887887,
    889889,
    888876,
    888688,
    888897,
    897796,
    877777,
    869987,
    798888,
    688779,
    878897,
    899798,
    799897,
    987789,
    888867,
    999889,
    898868,
    978878,
    798879,
    979797,
    888888,
    888888,
    778766,
    777879,
    878878,
    888788,
    977887,
    698989,
    869999,
    878778,
    998688,
    879787,
    968899,
    689897,
    779788,
    878888,
    777889,
    878768,
    887777,
    867788,
    768787,
    896897,
    889778,
    888879,
    978968,
    787898,
    886868,
    798797,
    688778,
    779887,
    867998,
    778779,
    788787,
    879867,
    788787,
    897877,
    797778,
    878868,
    987988,
    878898,
    777868,
    689978,
    987979,
    786988,
    879878,
    787889,
    899898,
    778888,
    867979,
    897789,
    877899,
    788998,
    888878,
    777886,
    878898,
    789687,
    887978,
    898888,
    888787,
    778777,
    888688,
    999789,
    889796,
    786898,
    988998,
    988896,
    877787,
    978786,
    888888,
    978797,
    787989,
    778788,
    866877,
    998888,
    789898,
    899789,
    788898,
    978789,
    787898,
    889777,
    976879,
    898977,
    778877,
    879887,
    988887,
    787788,
    889778,
    788777,
    887888,
    897987,
    978777,
    888887,
    978699,
    887978,
    988889,
    787999,
    788798,
    777797,
    768978,
    897996,
    877777,
    888878,
    888889,
    987776,
    887678,
    688988,
    767888,
    787679,
    787987,
    797887,
    697878,
    798767,
    977898,
    778887,
    887767,
    879779,
    988798,
    888888,
    777898,
    778898,
    889778,
    979979,
    887867,
    688789,
    798778,
    888788,
    977789,
    797788,
    777788,
    889887,
    778998,
    787688,
    788888,
    688889,
    888799,
    788998,
    787888,
    877798,
    987897,
    777799,
    777778,
    777877,
    878788,
    678977,
    987889,
    876787,
    977887,
    877687,
    777977,
    779979,
    877787,
    987898,
    967769,
    788778,
    778877,
    877787,
    788897,
    877987,
    797887,
    877877,
    777889,
    887997,
    878888,
    877987,
    887979,
    786888,
    898878,
    988799,
    798888,
    778788,
    797769,
    688787,
    798787,
    768787,
    868796,
    878867,
    887799,
    766698,
    798898,
    879876,
    768778,
    989877,
    999879,
    978788,
    988798,
    777987,
    869887,
    987789,
    887878,
    869877,
    799778,
    778798,
    878796,
    889879,
    677788,
    868889,
    789988,
    877787,
    788789,
    878878,
    987987,
    879976,
    777889,
    788768,
    897887,
    886688,
    867877,
    877768,
    876767,
    988888,
    878978,
    689988,
    967778,
    787777,
    787986,
    688868,
    989787,
    878879,
    899787,
    886887,
    877788,
    876788,
    789889,
    878887,
    888878,
    788799,
    887997,
    767788,
    787787,
    796877,
    878886,
    697977,
    978887,
    798899,
    797967,
    799889,
    876787,
    798867,
    798878,
    796798,
    797877,
    888897,
    887678,
    988779,
    978877,
    788788,
    777978,
    878977,
    888887,
    998888,
    898877,
    888789,
    969698,
    788778,
    987768,
    888997,
    888678,
    878886,
    778768,
    897898,
    968769,
    778887,
    877897,
    879787,
    788768,
    977977,
    976888,
    988867,
    786887,
    798896,
    888887,
    788889,
    777867,
    797799,
    878879,
    988987,
    868869,
    877877,
    878869,
    777678,
    798878,
    988678,
    886988,
    788798,
    887978,
    797876,
    978887,
    969789,
    888978,
    789879,
    678778,
    997987,
    676889,
    978689,
    977879,
    889877,
    797788,
    788777,
    787797,
    787777,
    788796,
    888898,
    788777,
    788889,
    787679,
    887889,
    878989,
    788767,
    768978,
    887898,
    888777,
    767668,
    888878,
    977977,
    798999,
    788988,
    988779,
    788898,
    797888,
    787789,
    879777,
    786888,
    888788,
    779878,
    888877,
    788978,
    789988,
    989688,
    898978,
    789787,
    887878,
    988787,
    876969,
    777987,
    887889,
    787687,
    878778,
    978899,
    878788,
    789987,
    778897,
    897697,
    978777,
    988688,
    787978,
    879988,
    879997,
    869789,
    789898,
    877687,
    878688,
    897768,
    688789,
    789978,
    877777,
    897796,
    788988,
    778878,
    899698,
    878878,
    887887,
    777777,
    897988,
    887787,
    888767,
    886898,
    777987,
    889888,
    879779,
    777787,
    897878,
    877777,
    776799,
    989689,
    778687,
    877899,
    877796,
    897799,
    788768,
    889887,
    777987,
    798887,
    878889,
    788887,
    988767,
    788878,
    888778,
    868888,
    696688,
    689797,
    976699,
    778878,
    778879,
    979889,
    796888,
    779887,
    898988,
    777867,
    998877,
    877878,
    768898,
    998886,
    898767,
    677799,
    889778,
    787979,
    778787,
    888867,
    797889,
    788887,
    878977,
    787776,
    887898,
    977977,
    877898,
    978778,
    787787,
    869888,
    888888,
    788788,
    788888,
    879778,
    797977,
    878989,
    777898,
    788787,
    878988,
    798887,
    888788,
    887899,
    897988,
    798897,
    988777,
    888778,
    888779,
    798888,
    777779,
    777778,
    687867,
    789987,
    968887,
    777886,
    899888,
    986878,
    798789,
    788988,
    798877,
    877878,
    878779,
    878888,
    979877,
    899887,
    898777,
    868778,
    977897,
    778877,
    987979,
    988878,
    798979,
    988787,
    799887,
    979778,
    788878,
    777999,
    786888,
    988879,
    987788,
    778787,
    879798,
    889888,
    887887,
    788778,
    777868,
    977897,
    988777,
    689796,
    789789,
    789878,
    878877,
    767888,
    787886,
    778978,
    789998,
    878887,
    796877,
    786989,
    978787,
    789798,
    787778,
    987787,
    888768,
    977888,
    788789,
    867877,
    778979,
    978878,
    898787,
    787677,
    888689,
    799999,
    968988,
    988887,
    787778,
    877788,
    889899,
    867777,
    997688,
    878968,
    787789,
    778898,
    778788,
    786978,
    987898,
    778777,
    888688,
    788887,
    999877,
    888888,
    769888,
    988888,
    986888,
    798789,
    988867,
    888867,
    977779,
    898788,
    998797,
    886866,
    898878,
    768988,
    789788,
    888768,
    778877,
    898878,
    669898,
    988678,
    879888,
    789778,
    787978,
    889788,
    898798,
    867998,
    787677,
    777788,
    888898,
    887979,
    889899,
    877788,
    887896,
    988769,
    997779,
    988776,
    789888,
    876787,
    998877,
    978967,
    877777,
    897788,
    777797,
    687779,
    788778,
    778677,
    977988,
    989877,
    888986,
    688787,
    879979,
    788787,
    787867,
    798769,
    887978,
    788698,
    678988,
    979877,
    967987,
    899879,
    888887,
    987879,
    778778,
    979897,
    796888,
    888788,
    989798,
    897887,
    899788,
    779989,
    978788,
    986897,
    968798,
    988897,
    786788,
    878798,
    977689,
    777888,
    877878,
    987887,
    776878,
    687989,
    878988,
    797977,
    868888,
    789787,
    896699,
    888696,
    777887,
    888888,
    998879,
    886988,
    976988,
    788768,
    989888,
    879879,
    889989,
    877899,
    898797,
    798888,
    698888,
    979779,
    887888,
    789889,
    888978,
    877869,
    898688,
    787876,
    868798,
    778899,
    797889,
    988788,
    988778,
    897897,
    788877,
    788786,
    889777,
    798987,
    878787,
    898799,
    978698,
    788977,
    788998,
    898887,
    877779,
    887678,
    987687,
    888888,
    867788,
    886888,
    799898,
    897779,
    778877,
    987978,
    777887,
    878897,
    987788,
    787796,
    898878,
    767888,
    869997,
    788886,
    989996,
    877888,
    868888,
    887878,
    788888,
    978899,
    678788,
    798969,
    786878,
    688866,
    887988,
    898778,
    788679,
    788977,
    987778,
    888676,
    888977,
    777867,
    898977,
    987779,
    698789,
    987778,
    889697,
    978778,
    787789,
    979996,
    798978,
    879987,
    999778,
    898897,
    978687,
    896977,
    998878,
    978886,
    789887,
    889898,
    787796,
    877879,
    777889,
    899888,
    688977,
    788797,
    888798,
    889768,
    887799,
    768798,
    889787,
    688988,
    897888,
    787977,
    889687,
    698889,
    887896,
    868877,
    899986,
    788898,
    898986,
    787888,
    788896,
    786777,
    877878,
    797896,
    688887,
    889779,
    878888,
    788899,
    877887,
    877989,
    788788,
    878788,
    898688,
    987788,
    998787,
    768889,
    798789,
    798888,
    879868,
    987887,
    777888,
    798987,
    798998,
    788789,
    776776,
    889877,
    878878,
    978889,
    868698,
    977797,
    786789,
    787788,
    789987,
    688987,
    797686,
    889898,
    897678,
    788689,
    897879,
    977977,
    888878,
    879787,
    977898,
    777789,
    988797,
    989888,
    878887,
    689778,
    886798,
    877869,
    967888,
    786989,
    988877,
    869898,
    798797,
    778797,
    698978,
    977799,
    988976,
    769887,
    988867,
    698878,
    888689,
    889787,
    789878,
    877777,
    878968,
    898897,
    889988,
    887878,
    877787,
    989788,
    778799,
    999889,
    887887,
    888988,
    888877,
    887989,
    898888,
    688787,
    786789,
    787787,
    787767,
    876977,
    888878,
    979797,
    787778,
    798788,
    888886,
    888768,
    877776,
    888888,
    789878,
    788877,
    888877,
    798979,
    898778,
    687889,
    697996,
    877978,
    868988,
    887898,
    998797,
    878988,
    788878,
    978877,
    778968,
    878797,
    878977,
    797788,
    897798,
    879987,
    887778,
    778898,
    778879,
    769689,
    687877,
    778978,
    898997,
    988989,
    887888,
    989868,
    897997,
    898988,
    888888,
    887887,
    688898,
    797988,
    888789,
    889978,
    787868,
    888789,
    888879,
    978987,
    988677,
    788797,
    787889,
    678788,
    787779,
    898987,
    987869,
    898988,
    867878,
    989887,
    777876,
    877798,
    696798,
    777987,
    977887,
    987698,
    988777,
    887888,
    887988,
    798899,
    777898,
    697988,
    798876,
    879877,
    777976,
    877987,
    888886,
    977876,
    788968,
    897987,
    898988,
    868889,
    867889,
    887888,
    798698,
    777979,
    977898,
    966866,
    678777,
    988778,
    987888,
    878879,
    889697,
    868898,
    786678,
    766978,
    879887,
    789799,
    877798,
    867787,
    879877,
    888898,
    789768,
    988898,
    699788,
    788978,
    889888,
    889978,
    797788,
    888688,
    687889,
    877879,
    777778,
    887879,
    898888,
    887779,
    898779,
    979986,
    798788,
    888789,
    988897,
    688888,
    898878,
    987789,
    866877,
    877787,
    886769,
    788886,
    879889,
    878688,
    789889,
    888887,
    878698,
    888888,
    979689,
    678999,
    788899,
    889877,
    679787,
    777778,
    769977,
    778887,
    787788,
    888888,
    776897,
    989787,
    769797,
    877879,
    787788,
    988878,
    789887,
    888689,
    988768,
    887789,
    878978,
    988778,
    887878,
    889898,
    788877,
    869989,
    798798,
    879888,
    897778,
    887776,
    788888,
    878888,
    978887,
    878888,
    788977,
    777888,
    787877,
    888988,
    887878,
    788878,
    987877,
    688989,
    778778,
    788887,
    986987,
    798788,
    779699,
    787788,
    666888,
    799979,
    887988,
    898888,
    878898,
    898897,
    778888,
    888788,
    898887,
    879897,
    898677,
    787988,
    688788,
    778787,
    778898,
    768688,
    687876,
    899797,
    779976,
    888688,
    967687,
    799997,
    888897,
    867868,
    888887,
    798788,
    886898,
    887987,
    979777,
    977778,
    777887,
    677888,
    786897,
    887887,
    888777,
    778888,
    889788,
    898998,
    797789,
    899868,
    878697,
    888987,
    888879,
    797878,
    789987,
    888897,
    789888,
    988687,
    988888,
    878698,
    899769,
    689978,
    779888,
    979888,
    898778,
    998977,
    877988,
    688867,
    877787,
    767867,
    797888,
    878877,
    987767,
    887787,
    778778,
    886988,
    977888,
    777787,
    888879,
    788779,
    798787,
    977798,
    888688,
    877889,
    787977,
    678978,
    989879,
    788887,
    886787,
    898798,
    878886,
    888977,
    897779,
    889788,
    877886,
    787878,
    878999,
    897788,
    899888,
    998697,
    887887,
    978887,
    786877,
    686777,
    877787,
    777986,
    887977,
    778687,
    977879,
    999987,
    679866,
    768988,
    888988,
    789689,
    889998,
    788889,
    878789,
    888689,
    689789,
    879997,
    978689,
    789777,
    897788,
    787978,
    897898,
    997888,
    877787,
    777888,
    876888,
    988888,
    888977,
    988999,
    876788,
    877779,
    988776,
    987787,
    987888,
    788897,
    779899,
    777787,
    877898,
    789968,
    798988,
    887779,
    867789,
    888878,
    878786,
    797888,
    879998,
    868788,
    987687,
    997786,
    886778,
    669666,
    878879,
    699878,
    898978,
    878888,
    978888,
    999779,
    777886,
    789798,
    878897,
    788879,
    779887,
    999977,
    868788,
    987888,
    987888,
    878786,
    877787,
    866998,
    898888,
    877787,
    777798,
    877789,
    878978,
    799777,
    797888,
    887879,
    888888,
    888886,
    898786,
    779766,
    989988,
    898787,
    668887,
    797897,
    878887,
    788979,
    789989,
    977986,
    779887,
    877977,
    887688,
    967876,
    798877,
    887877,
    788888,
    887788,
    879897,
    879798,
    798897,
    897778,
    978888,
    797987,
    887768,
    789799,
    898977,
    878889,
    879898,
    889998,
    968987,
    997787,
    788888,
    887977,
    879788,
    699777,
    878787,
    788696,
    878987,
    969987,
    988887,
    868878,
    878896,
    879878,
    896887,
    777987,
    787888,
    976887,
    898888,
    787878,
    768896,
    766768,
    797778,
    987887,
    998669,
    878797,
    787777,
    886888,
    769778,
    868687,
    787778,
    797878,
    799877,
    798877,
    887778,
    777989,
    899887,
    787969,
    869776,
    788897,
    998788,
    899787,
    977799,
    689778,
    788888,
    879789,
    988998,
    888887,
    769999,
    876786,
    878798,
    889688,
    877987,
    868987,
    896777,
    978977,
    879678,
    867878,
    778889,
    987877,
    788798,
    989977,
    879988,
    888897,
    879979,
    787869,
    898887,
    779996,
    867798,
    889778,
    888897,
    999898,
    889898,
    688896,
    787787,
    879888,
    768997,
    987878,
    798788,
    778989,
    988879,
    697787,
    688988,
    987878,
    779987,
    677688,
    789987,
    777898,
    889789,
    868887,
    787787,
    897888,
    798789,
    897777,
    798899,
    888798,
    888899,
    878779,
    788789,
    678987,
    799897,
    977897,
    878788,
    779787,
    877887,
    869777,
    797888,
    877667,
    679777,
    978976,
    978988,
    888878,
    788888,
    776877,
    878778,
    777996,
    696888,
    866878,
    887789,
    897878,
    897889,
    887997,
    977688,
    788897,
    778679,
    788876,
    788897,
    987887,
    799886,
    799979,
    888988,
    868987,
    986987,
    866788,
    779897,
    877988,
    789989,
    888878,
    798788,
    788787,
    788787,
    877688,
    988988,
    788878,
    899976,
    797877,
    777897,
    879787,
    876778,
    977887,
    669978,
    779877,
    776888,
    678887,
    778879,
    789788,
    879788,
    997989,
    678987,
    997879,
    796787,
    777777,
    998788,
    888898,
    887989,
    899887,
    887677,
    877787,
    777868,
    878889,
    879867,
    867798,
    889787,
    987769,
    899788,
    888988,
    886888,
    887796,
    977879,
    899797,
    877968,
    898889,
    888877,
    879777,
    878777,
    887887,
    686988,
    788898,
    876889,
    978877,
    788788,
    797898,
    899868,
    978987,
    988787,
    988978,
    797678,
    877776,
    887768,
    799876,
    888888,
    887789,
    799987,
    778999,
    789877,
    799867,
    988878,
    987989,
    977789,
    877877,
    877788,
    779887,
    697878,
    898989,
    788768,
    768889,
    888778,
    788777,
    877889,
    777886,
    687889,
    888977,
    789889,
    988887,
    877778,
    797978,
    767888,
    866887,
    886789,
    878978,
    978868,
    988888,
    877879,
    688888,
    898778,
    888878,
    877877,
    687998,
    887777,
    777777,
    877888,
    899878,
    888877,
    877778,
    989788,
    887978,
    788988,
    888888,
    788878,
    868888,
    888888,
    889887,
    788877,
    778898,
    877868,
    978898,
    898888,
    788877,
    879888,
    977877,
    887797,
    889777,
    888778,
    799777,
    888988,
    887778,
    788778,
    988779,
    987777,
    789799,
    887897,
    888777,
    877787,
    798767,
    997877,
    777899,
    778889,
    879889,
    977966,
    788777,
    887876,
    788788,
    788877,
    799897,
    878798,
    777878,
    788787,
    799877,
    679877,
    988898,
    888897,
    688777,
    888868,
    898986,
    898778,
    897687,
    798797,
    778999,
    778898,
    886987,
    787788,
    889879,
    698787,
    888879,
    878789,
    779797,
    887887,
    787798,
    877878,
    898678,
    778777,
    879689,
    989889,
    799879,
    888777,
    687678,
    898977,
    777877,
    778988,
    897889,
    878788,
    878989,
    887877,
    989678,
    888998,
    889878,
    887978,
    788787,
    777886,
    888777,
    897887,
    888788,
    777968,
    879678,
    988889,
    678887,
    797676,
    878888,
    887888,
    988886,
    878988,
    698888,
    868988,
    788987,
    897897,
    879887,
    878887,
    978867,
    788978,
    879777,
    868877,
    877878,
    796787,
    686888,
    978788,
    877877,
    888797,
    798878,
    988987,
    978797,
    989896,
    889777,
    897789,
    698777,
    888789,
    767888,
    897978,
    896787,
    788877,
    788888,
    789886,
    688678,
    976878,
    978989,
    868788,
    778878,
    898887,
    986869,
    868989,
    787777,
    868789,
    978987,
    987798,
    777778,
    888798,
    689778,
    777977,
    988897,
    878898,
    897878,
    777787,
    979897,
    778877,
    878869,
    877777,
    988898,
    787878,
    866988,
    789779,
    799877,
    999687,
    787898,
    887799,
    888887,
    688877,
    779978,
    897888,
    889899,
    778977,
    769789,
    886789,
    979887,
    788797,
    879877,
    877977,
    777898,
    878887,
    979987,
    797887,
    988867,
    897797,
    887887,
    878978,
    889888,
    879877,
    688899,
    898788,
    888877,
    977799,
    787868,
    877879,
    788888,
    668988,
    868878,
    889887,
    887887,
    888887,
    786977,
    768687,
    898899,
    879668,
    697888,
    988767,
    688887,
    798897,
    797868,
    788878,
    788877,
    978767,
    888987,
    888888,
    888878,
    698879,
    997888,
    887877,
    979678,
    778888,
    779879,
    887768,
    768788,
    888788,
    686887,
    886898,
    878777,
    987788,
    789679,
    777867,
    778977,
    876888,
    978976,
    788877,
    768879,
    889688,
    688888,
    887877,
    867887,
    987778,
    787878,
    797889,
    678788,
    978776,
    798987,
    779777,
    778778,
    899787,
    879867,
    888998,
    798878,
    787898,
    968898,
    788768,
    888778,
    776789,
    897977,
    998877,
    897897,
    788687,
    977898,
    769768,
    988889,
    798988,
    899779,
    868889,
    979877,
    798888,
    779777,
    988888,
    978897,
    796878,
    887889,
    688886,
    778896,
    887878,
    797788,
    777778,
    778887,
    798879,
    888878,
    778678,
    898979,
    778788,
    888787,
    898989,
    887888,
    778779,
    797888,
    877778,
    669868,
    778688,
    898888,
    888897,
    777876,
    788778,
    877999,
    898977,
    879777,
    877798,
    896898,
    989767,
    786877,
    878888,
    877897,
    776888,
    878897,
    888897,
    788778,
    688777,
    888888,
    897786,
    978899,
    877887,
    887887,
    886988,
    788778,
    877789,
    989879,
    987778,
    979798,
    888878,
    889889,
    889796,
    786898,
    868797,
    789679,
    796988,
    988678,
    898876,
    778978,
    987799,
    877779,
    779787,
    778678,
    888877,
    877987,
    878989,
    798888,
    896876,
    879887,
    987878,
    887877,
    988888,
    887987,
    888887,
    987897,
    888889,
    668789,
    878968,
    989689,
    789778,
    897977,
    678969,
    798969,
    789987,
    888887,
    987988,
    798778,
    877789,
    877879,
    998887,
    887797,
    788787,
    968978,
    788788,
    697868,
    887899,
    879878,
    889897,
    689688,
    876979,
    877868,
    777777,
    876968,
    878999,
    778989,
    788888,
    779876,
    777999,
    978978,
    877888,
    788979,
    768876,
    786777,
    767687,
    988776,
    778889,
    888878,
    778888,
    778776,
    999978,
    688887,
    787778,
    787988,
    767668,
    787987,
    987888,
    668876,
    886899,
    897978,
    768788,
    797777,
    778877,
    899787,
    887798,
    976877,
    978968,
    898788,
    899878,
    769779,
    899878,
    788777,
    886998,
    778779,
    898898,
    778878,
    779887,
    976788,
    988898,
    977888,
    877877,
    778898,
    998787,
    878876,
    988887,
    966899,
    887886,
    879888,
    878877,
    978898,
    987878,
    887978,
    898896,
    689797,
    879889,
    797868,
    968986,
    788788,
    777768,
    687789,
    888778,
    889778,
    988887,
    878999,
    887877,
    888887,
    878796,
    886788,
    878767,
    788989,
    888877,
    797997,
    697987,
    767898,
    978968,
    879888,
    886989,
    998677,
    799889,
    988778,
    988878,
    967779,
    888877,
    897876,
    868778,
    888889,
    888888,
    779878,
    878878,
    778777,
    788878,
    978978,
    897888,
    787897,
    897868,
    767886,
    989779,
    688898,
    868889,
    778879,
    697887,
    977786,
    898877,
    999768,
    687978,
    797788,
    789887,
    898976,
    988877,
    898788,
    888677,
    777897,
    767978,
    877978,
    887889,
    976978,
    977777,
    776788,
    987779,
    777888,
    678988,
    867887,
    877787,
    788899,
    777878,
    787987,
    787887,
    876899,
    688888,
    798878,
    877988,
    887799,
    778667,
    878888,
    788889,
    796897,
    788698,
    797887,
    788787,
    878977,
    976787,
    888888,
    978887,
    988868,
    978687,
    988897,
    799876,
    777878,
    778989,
    977888,
    788779,
    987888,
    878889,
    798888,
    879778,
    797898,
    888777,
    997797,
    877778,
    788879,
    879677,
    788897,
    887899,
    777789,
    788777,
    797969,
    797898,
    888888,
    887888,
    878789,
    998978,
    886889,
    869779,
    867899,
    978887,
    778788,
    888768,
    799778,
    898787,
    877876,
    897789,
    778777,
    788777,
    887888,
    786887,
    878889,
    786898,
    898777,
    897887,
    798787,
    878969,
    888888,
    887789,
    897788,
    978789,
    987879,
    777887,
    877877,
    788887,
    779977,
    968888,
    888979,
    788878,
    778869,
    897999,
    878687,
    788887,
    878997,
    789887,
    889987,
    877989,
    887887,
    879777,
    777888,
    988887,
    988879,
    778767,
    779798,
    779778,
    898679,
    978768,
    788789,
    978789,
    867678,
    678888,
    987787,
    799878,
    878788,
    998899,
    798788,
    788778,
    778888,
    898877,
    887888,
    779988,
    987878,
    978776,
    988898,
    989667,
    676887,
    899878,
    777789,
    986988,
    797888,
    878877,
    779897,
    897779,
    898888,
    889698,
    978789,
    786878,
    879679,
    886889,
    987988,
    888798,
    976877,
    979778,
    889798,
    977977,
    686779,
    896778,
    898997,
    787688,
    788687,
    899787,
    877878,
    767878,
    799976,
    987797,
    777888,
    777887,
    877877,
    788788,
    799988,
    778698,
    798978,
    688779,
    788888,
    778778,
    678777,
    887777,
    778798,
    787789,
    798987,
    889687,
    778979,
    788887,
    888879,
    868988,
    898787,
    786877,
    779987,
    787988,
    698778,
    789978,
    986668,
    787987,
    867888,
    877779,
    898778,
    988788,
    999877,
    789976,
    877788,
    797879,
    767897,
    888888,
    887887,
    789878,
    787779,
    789898,
    787977,
    798889,
    778897,
    888898,
    889886,
    888777,
    678999,
    877789,
    788799,
    889677,
    879979,
    778887,
    896778,
    878867,
    777789,
    976897,
    987877,
    798887,
    878899,
    989888,
    977787,
    988789,
    987886,
    798777,
    788878,
    988898,
    988679,
    779788,
    879877,
    889888,
    877787,
    879698,
    788886,
    898778,
    867778,
    787997,
    889888,
    789789,
    778678,
    799887,
    897977,
    888788,
    897989,
    777877,
    778898,
    887988,
    987889,
    789989,
    877997,
    779968,
    787898,
    896899,
    887797,
    888788,
    888898,
    787888,
    798889,
    789877,
    798988,
    888878,
    888897,
    888887,
    998887,
    878888,
    787678,
    688778,
    776799,
    789888,
    898787,
    777879,
    779888,
    786889,
    689668,
    887688,
    777888,
    888878,
    989777,
    988779,
    889798,
    779978,
    978799,
    777788,
    878878,
    887888,
    787788,
    877988,
    876777,
    677899,
    878799,
    879788,
    967896,
    979779,
    878978,
    898779,
    878688,
    988877,
    977876,
    887779,
    899888,
    978777,
    878886,
    779868,
    688778,
    787787,
    987777,
    688777,
    787797,
    788899,
    978779,
    978687,
    996877,
    776998,
    788898,
    876887,
    888877,
    997977,
    778777,
    678787,
    998989,
    888798,
    977868,
    877868,
    997888,
    788869,
    898896,
    876886,
    888887,
    688776,
    887777,
    789987,
    978889,
    877779,
    888897,
    679978,
    766888,
    877888,
    788978,
    878879,
    879677,
    889888,
    766867,
    788779,
    998867,
    778898,
    877788,
    887979,
    797877,
    888967,
    878898,
    687967,
    888979,
    777789,
    887798,
    897977,
    897679,
    697889,
    899887,
    889799,
    997879,
    777787,
    897877,
    998889,
    897987,
    788677,
    978787,
    977787,
    999877,
    788887,
    877987,
    788787,
    787788,
    877888,
    989686,
    796999,
    788887,
    999888,
    877887,
    886877,
    898968,
    887878,
    978887,
    988977,
    976889,
    777978,
    878888,
    777887,
    888779,
    877789,
    896777,
    888988,
    879887,
    887888,
    887788,
    988789,
    798786,
    868777,
    788898,
    998889,
    888889,
    889979,
    789977,
    778798,
    788979,
    988788,
    889788,
    879787,
    979686,
    787887,
    899877,
    889877,
    797768,
    986778,
    797979,
    978888,
    888797,
    786768,
    979898,
    777788,
    789788,
    777797,
    886697,
    798888,
    798878,
    888789,
    779887,
    889887,
    689789,
    967797,
    896778,
    888987,
    778887,
    888989,
    789788,
    988688,
    877889,
    788787,
    978988,
    888868,
    977878,
    798797,
    878688,
    888977,
    788896,
    798877,
    787968,
    887987,
    888876,
    887979,
    867699,
    879789,
    877997,
    968879,
    877988,
    967878,
    988877,
    787698,
    787787,
    797787,
    787788,
    768999,
    886987,
    998888,
    876979,
    868779,
    799889,
    788779,
    778789,
    869877,
    977888,
    778888,
    889897,
    777877,
    887886,
    988679,
    878788,
    988778,
    877778,
    877898,
    769777,
    778898,
    879777,
    798888,
    886888,
    898698,
    887899,
    976788,
    988877,
    888896,
    986887,
    789898,
    879898,
    978777,
    888897,
    789878,
    877987,
    979877,
    797798,
    787987,
    897878,
    878689,
    787867,
    897879,
    877887,
    986987,
    888876,
    877687,
    879788,
    889876,
    978789,
    879988,
    898987,
    769888,
    897879,
    798877,
    976886,
    876798,
    887787,
    868689,
    989989,
    789988,
    788789,
    788788,
    897887,
    777768,
    878888,
    897768,
    777888,
    787777,
    679789,
    789888,
    778978,
    888786,
    887879,
    879999,
    778878,
    878888,
    796979,
    997987,
    788888,
    877886,
    778767,
    797897,
    988868,
    788789,
    667788,
    986967,
    788799,
    688777,
    988888,
    887897,
    977778,
    877668,
    876788,
    687977,
    988888,
    788988,
    798998,
    868977,
    978879,
    777798,
    778777,
    888789,
    988789,
    787799,
    976887,
    888888,
    768878,
    789989,
    777878,
    887778,
    788787,
    877678,
    779878,
    888797,
    988777,
    868867,
    888878,
    776999,
    787888,
    977979,
    797687,
    988877,
    787968,
    899877,
    887779,
    779777,
    679879,
    878778,
    687888,
    889889,
    877978,
    888878,
    878698,
    978888,
    877888,
    788989,
    897797,
    676778,
    789798,
    878978,
    888888,
    787878,
    787989,
    688887,
    797989,
    778777,
    786787,
    879867,
    889787,
    888788,
    887868,
    977988,
    878887,
    997787,
    887976,
    878799,
    887878,
    986786,
    887878,
    988779,
    798798,
    888887,
    989888,
    888878,
    788878,
    979776,
    777877,
    778888,
    888898,
    888898,
    897887,
    988897,
    877998,
    998678,
    798786,
    786986,
    868887,
    888978,
    888789,
    989779,
    678777,
    697877,
    887788,
    987979,
    888888,
    789687,
    978788,
    896888,
    888896,
    978898,
    789877,
    898969,
    986798,
    896887,
    798979,
    998889,
    798887,
    897898,
    978876,
    888778,
    986789,
    898789,
    977897,
    898996,
    897778,
    886877,
    889998,
    988987,
    879778,
    787778,
    977797,
    777999,
    798777,
    988878,
    878898,
    786988,
    999796,
    977789,
    778997,
    668877,
    778678,
    877987,
    978777,
    889777,
    798787,
    898787,
    788888,
    787698,
    886899,
    887998,
    876978,
    789877,
    788997,
    978989,
    867787,
    786789,
    787899,
    887777,
    899788,
    788878,
    879778,
    887879,
    878887,
    889779,
    878677,
    877898,
    978779,
    878788,
    988898,
    997769,
    886998,
    898877,
    888888,
    986978,
    778878,
    689997,
    899878,
    898887,
    998766,
    776669,
    687869,
    898799,
    887997,
    868889,
    679786,
    888977,
    779789,
    969788,
    777778,
    888697,
    898789,
    778887,
    887888,
    777789,
    987888,
    798779,
    888688,
    968977,
    797888,
    768888,
    688778,
    897789,
    788879,
    996777,
    977988,
    679888,
    896797,
    687898,
    897877,
    777788,
    898887,
    789878,
    996986,
    877687,
    787889,
    888778,
    988878,
    887977,
    997688,
    799887,
    877787,
    789788,
    986879,
    798877,
    978887,
    788798,
    898987,
    888779,
    799987,
    878897,
    998897,
    887886,
    869778,
    888897,
    869989,
    898689,
    879887,
    878879,
    878887,
    887876,
    888888,
    888899,
    988977,
    788888,
    768999,
    767887,
    787669,
    688788,
    878779,
    877786,
    986897,
    899776,
    979788,
    778888,
    888977,
    788798,
    877786,
    888788,
    866998,
    888797,
    899798,
    787887,
    769887,
    778978,
    879777,
    877877,
    796977,
    979988,
    788788,
    898889,
    679979,
    888698,
    879888,
    788778,
    897697,
    699889,
    888888,
    789987,
    987888,
    786789,
    988878,
    787987,
    888979,
    899877,
    788978,
    978878,
    797888,
    887788,
    877888,
    788788,
    877888,
    978786,
    878778,
    979887,
    788778,
    888877,
    799988,
    788889,
    789678,
    978888,
    779879,
    778877,
    977999,
    898988,
    887866,
    877677,
    778678,
    888799,
    977887,
    878888,
    768798,
    877868,
    878797,
    788887,
    877898,
    888787,
    878778,
    888988,
    878787,
    888989,
    889898,
    988888,
    877889,
    898988,
    768779,
    678776,
    998989,
    979889,
    897987,
    987788,
    778977,
    778779,
    897888,
    987787,
    697897,
    677978,
    878789,
    968788,
    888898,
    888788,
    888998,
    997788,
    877867,
    697888,
    897887,
    979898,
    788979,
    886988,
    687988,
    787888,
    798688,
    788778,
    978787,
    888887,
    878788,
    799868,
    988889,
    779888,
    877887,
    888798,
    997887,
    778887,
    887688,
    899878,
    677788,
    899676,
    986777,
    698879,
    767776,
    789788,
    789899,
    886888,
    789778,
    796888,
    767998,
    778878,
    886799,
    687979,
    899898,
    877778,
    888988,
    787978,
    777779,
    799889,
    798777,
    799797,
    779988,
    777888,
    989798,
    989877,
    779897,
    899998,
    779777,
    898899,
    787777,
    789879,
    887889,
    877999,
    888788,
    778888,
    898888,
    987977,
    788888,
    878979,
    886889,
    778887,
    788778,
    888788,
    878868,
    898777,
    988768,
    787878,
    898877,
    698987,
    997998,
    989789,
    887798,
    898788,
    778679,
    978879,
    787868,
    989877,
    768899,
    999768,
    798978,
    887888,
    778876,
    787787,
    777789,
    968798,
    787798,
    888897,
    886769,
    798779,
    868889,
    887997,
    798776,
    899888,
    797777,
    988897,
    888789,
    889977,
    788798,
    867687,
    878787,
    879787,
    977877,
    799779,
    798968,
    788879,
    888778,
    688788,
    876967,
    788887,
    797878,
    679888,
    878788,
    769877,
    988897,
    888888,
    787878,
    788887,
    777888,
    878787,
    877878,
    887998,
    778878,
    878887,
    988979,
    978877,
    789777,
    899879,
    878898,
    886778,
    889897,
    878788,
    889878,
    986688,
    887898,
    888797,
    868878,
    979768,
    878789,
    887787,
    687798,
    887798,
    897799,
    877889,
    689897,
    686888,
    768898,
    787879,
    897898,
    877787,
    887867,
    788888,
    778688,
    897997,
    778888,
    898677,
    788768,
    899689,
    787788,
    798988,
    798878,
    868687,
    888788,
    979988,
    887899,
    899889,
    878899,
    887897,
    897688,
    878878,
    898988,
    778899,
    989988,
    897989,
    998987,
    888887,
    869777,
    887788,
    789898,
    889889,
    876987,
    788787,
    878888,
    697996,
    677878,
    989777,
    787777,
    867879,
    798788,
    878788,
    878987,
    888797,
    888798,
    778778,
    898877,
    787897,
    899777,
    887778,
    977878,
    888798,
    788897,
    988787,
    988979,
    876879,
    899778,
    889877,
    979777,
    798886,
    879888,
    988789,
    879879,
    878787,
    868978,
    888868,
    978788,
    887878,
    778778,
    968899,
    787888,
    986888,
    777888,
    798997,
    676787,
    869788,
    978888,
    989798,
    889788,
    798898,
    787968,
    889899,
    887989,
    788798,
    679868,
    877888,
    897888,
    876898,
    878767,
    779888,
    688876,
    877887,
    888878,
    779888,
    898788,
    888988,
    788887,
    777778,
    978969,
    969878,
    789776,
    788879,
    797789,
    896877,
    778677,
    887998,
    778899,
    878888,
    888878,
    788997,
    988788,
    786878,
    989698,
    998977,
    878787,
    987797,
    888878,
    787886,
    877888,
    778897,
    777897,
    878797,
    786877,
    887987,
    878888,
    986777,
    868988,
    887788,
    986779,
    877898,
    889869,
    997988,
    998788,
    779897,
    989779,
    999777,
    898869,
    777876,
    898778,
    877897,
    778778,
    998768,
    777677,
    899788,
    778796,
    777787,
    987789,
    878989,
    877889,
    878788,
    789788,
    978777,
    777897,
    787989,
    889787,
    998798,
    676978,
    797686,
    787879,
    888688,
    878797,
    879678,
    889878,
    988776,
    777797,
    678788,
    888787,
    888889,
    987978,
    786687,
    998877,
    788888,
    879779,
    987878,
    888987,
    787978,
    897888,
    667986,
    777888,
    987879,
    897879,
    776878,
    998678,
    886777,
    979878,
    888699,
    878898,
    889898,
    789998,
    897988,
    887698,
    898978,
    998787,
    878888,
    898887,
    887878,
    879678,
    787978,
    788876,
    999778,
    779687,
    889886,
    988879,
    887898,
    877968,
    878779,
    788788,
    787686,
    999768,
    877789,
    888777,
    878868,
    688877,
    867697,
    887988,
    768689,
    887989,
    979787,
    788879,
    788797,
    778788,
    978887,
    778888,
    678998,
    988887,
    897797,
    978988,
    899688,
    899889,
    778888,
    876979,
    788888,
    778876,
    777798,
    887889,
    987889,
    879868,
    887777,
    777878,
    876678,
    877978,
    797779,
    876888,
    688888,
    688987,
    889897,
    877868,
    787887,
    778877,
    987898,
    878766,
    888989,
    896888,
    769868,
    798788,
    787889,
    977888,
    987788,
    898888,
    898898,
    989799,
    888778,
    879978,
    868967,
    798898,
    967788,
    979788,
    787877,
    888777,
    776899,
    898888,
    788689,
    788877,
    886799,
    977996,
    967998,
    897899,
    779897,
    967776,
    877787,
    988989,
    897976,
    787988,
    889798,
    888869,
    888897,
    778787,
    897687,
    976898,
    779887,
    787977,
    987987,
    877878,
    788988,
    768778,
    888878,
    888897,
    778678,
    697988,
    989688,
    788888,
    787988,
    967797,
    889898,
    889788,
    799777,
    888978,
    978877,
    977887,
    688989,
    987997,
    787988,
    987798,
    888798,
    687797,
    989797,
    779997,
    898878,
    878879,
    979897,
    988879,
    887877,
    787879,
    768877,
    788889,
    888878,
    797986,
    676787,
    889898,
    878787,
    678799,
    777898,
    978888,
    879887,
    897797,
    768788,
    889778,
    697777,
    887988,
    798798,
    879888,
    789978,
    999779,
    787898,
    877788,
    777687,
    787688,
    887897,
    988789,
    888978,
    788789,
    787778,
    888987,
    979979,
    886978,
    888989,
    867878,
    787889,
    788977,
    978888,
    768877,
    898888,
    889868,
    778787,
    787889,
    887677,
    878887,
    887977,
    798888,
    887988,
    879878,
    787888,
    768789,
    778888,
    979687,
    778898,
    979987,
    879988,
    797798,
    988778,
    879979,
    877867,
    789888,
    878779,
    689777,
    788867,
    687968,
    787687,
    888898,
    879797,
    677876,
    778898,
    877987,
    888989,
    797869,
    767777,
    888678,
    688697,
    999968,
    887989,
    878897,
    887898,
    778787,
    897779,
    988778,
    678978,
    777988,
    889998,
    788987,
    888977,
    968787,
    989888,
    779776,
    788788,
    888987,
    877989,
    769869,
    999896,
    898897,
    667788,
    876987,
    787878,
    897678,
    896778,
    997898,
    887798,
    976967,
    789897,
    877877,
    768688,
    878867,
    899686,
    887698,
    899979,
    888798,
    787886,
    777787,
    887898,
    878898,
    779787,
    776979,
    778777,
    967788,
    878888,
    989877,
    867889,
    777877,
    887889,
    798798,
    898877,
    789777,
    969799,
    778888,
    768887,
    888897,
    788888,
    789878,
    889787,
    898888,
    789888,
    777978,
    987868,
    798788,
    888879,
    988788,
    997879,
    898777,
    777868,
    987787,
    788776,
    798978,
    887877,
    688887,
    779877,
    767876,
    997886,
    878799,
    877788,
    897798,
    778888,
    786989,
    988797,
    868769,
    889899,
    888687,
    878877,
    988797,
    787887,
    687887,
    777988,
    778887,
    878998,
    789898,
    878897,
    798888,
    777888,
    788778,
    968898,
    889877,
    788877,
    878787,
    898787,
    989799,
    998667,
    889987,
    988776,
    778888,
    988989,
    798967,
    776877,
    988777,
    677868,
    978797,
    869997,
    777896,
    979888,
    976786,
    788778,
    887977,
    879787,
    887898,
    688888,
    977798,
    988786,
    797679,
    878768,
    778877,
    897897,
    888978,
    889978,
    789889,
    699877,
    888787,
    798898,
    797997,
    878778,
    788878,
    897778,
    788867,
    887889,
    788788,
    888878,
    789978,
    877987,
    898788,
    877877,
    879998,
    789898,
    968877,
    777787,
    798977,
    888987,
    978797,
    877797,
    889887,
    997788,
    877888,
    887888,
    687998,
    897977,
    998978,
    979787,
    988988,
    977767,
    777799,
    887898,
    797788,
    888799,
    878789,
    989888,
    968897,
    888779,
    889798,
    779897,
    886689,
    877867,
    876788,
    798887,
    988987,
    797898,
    778878,
    897868,
    877967,
    888887,
    896878,
    778787,
    796898,
    777777,
    988777,
    998877,
    777879,
    997879,
    778877,
    886979,
    877878,
    988777,
    887869,
    969888,
    788897,
    878876,
    889788,
    887888,
    887977,
    878876,
    879779,
    977788,
    777878,
    767788,
    769998,
    887898,
    876878,
    767789,
    897889,
    978898,
    977977,
    878787,
    687777,
    788779,
    897776,
    887688,
    897898,
    788987,
    788886,
    787787,
    787887,
    797788,
    876788,
    887989,
    778887,
    878876,
    887979,
    899987,
    968888,
    888788,
    778878,
    988886,
    877788,
    888777,
    878979,
    888976,
    888988,
    976978,
    778878,
    778887,
    677898,
    896679,
    987869,
    797887,
    778677,
    887898,
    797878,
    777989,
    988998,
    867897,
    777888,
    998888,
    998788,
    787898,
    898889,
    898778,
    788876,
    887788,
    978998,
    878779,
    799879,
    887797,
    898776,
    877978,
    778878,
    987878,
    998887,
    898887,
    687787,
    678788,
    986789,
    887887,
    769878,
    898877,
    788677,
    877777,
    986888,
    877777,
    689878,
    888787,
    779878,
    888987,
    988679,
    868898,
    787788,
    987777,
    897887,
    767998,
    889887,
    776888,
    789988,
    888788,
    778997,
    877988,
    899896,
    878778,
    887998,
    798977,
    978797,
    798888,
    888988,
    887778,
    878789,
    877688,
    866988,
    687888,
    877889,
    787987,
    787787,
    987878,
    887898,
    899777,
    788978,
    888878,
    878878,
    676888,
    789976,
    778687,
    667778,
    878787,
    998889,
    879678,
    878798,
    997898,
    878797,
    996968,
    796877,
    968678,
    889886,
    779688,
    888878,
    997897,
    898787,
    778878,
    899778,
    989897,
    778799,
    989779,
    788778,
    788777,
    787779,
    798777,
    899687,
    977888,
    797999,
    777877,
    787977,
    897778,
    887788,
    877978,
    999977,
    887786,
    778887,
    899897,
    778988,
    777877,
    787886,
    978767,
    877788,
    889897,
    868887,
    898787,
    787879,
    887687,
    688777,
    788967,
    788988,
    787879,
    697977,
    889988,
    787888,
    977788,
    886878,
    767988,
    888899,
    887778,
    886878,
    797788,
    878878,
    867988,
    876999,
    977888,
    778878,
    699886,
    798778,
    888799,
    886899,
    888788,
    697878,
    788886,
    789787,
    997879,
    688998,
    888867,
    987877,
    799788,
    787987,
    796979,
    997788,
    777999,
    888888,
    789788,
    878797,
    888889,
    968897,
    877788,
    778798,
    967887,
    887878,
    778878,
    897777,
    699888,
    887789,
    896798,
    879898,
    987878,
    987967,
    888778,
    798888,
    887868,
    799779,
    887887,
    788787,
    887877,
    888788,
    789888,
    998897,
    787768,
    778868,
    979887,
    898989,
    886876,
    788788,
    897897,
    767887,
    787888,
    787788,
    888789,
    776777,
    798877,
    988978,
    889797,
    798988,
    898888,
    797887,
    676867,
    898868,
    897977,
    876777,
    897786,
    888887,
    789897,
    787768,
    789998,
    887867,
    696778,
    777787,
    778888,
    887777,
    878779,
    789787,
    887778,
    688888,
    897797,
    788888,
    767877,
    877988,
    888887,
    868887,
    877778,
    997877,
    878778,
    878998,
    877877,
    878978,
    989879,
    777869,
    678889,
    876778,
    887977,
    776777,
    899789,
    877787,
    787877,
    776877,
    778778,
    888778,
    878878,
    898788,
    878889,
    788687,
    788898,
    889977,
    778788,
    876997,
    776978,
    797787,
    876778,
    887888,
    868978,
    887788,
    879889,
    878997,
    887768,
    778699,
    887778,
    797989,
    997678,
    897798,
    877786,
    888878,
    987679,
    967888,
    978677,
    767978,
    988777,
    979887,
    888889,
    887867,
    778788,
    798888,
    898787,
    878789,
    899777,
    887789,
    678987,
    998798,
    888878,
    688887,
    998978,
    868977,
    878898,
    989879,
    879987,
    898999,
    989898,
    779878,
    787788,
    988886,
    789867,
    888877,
    876679,
    978899,
    878788,
    768887,
    978888,
    989887,
    788988,
    887778,
    997778,
    888777,
    778877,
    787687,
    786797,
    978898,
    789889,
    879879,
    898987,
    978867,
    876888,
    888797,
    779877,
    977787,
    878887,
    787997,
    888788,
    977797,
    887988,
    887977,
    867879,
    787987,
    788699,
    797878,
    969877,
    878978,
    986888,
    778787,
    767878,
    877986,
    878798,
    798887,
    868788,
    979897,
    976877,
    698879,
    888877,
    978786,
    867999,
    788878,
    888888,
    978878,
    987897,
    877967,
    888787,
    787889,
    879887,
    799888,
    787897,
    788986,
    797888,
    788787,
    889888,
    887779,
    998889,
    777788,
    878767,
    887997,
    898877,
    989878,
    888677,
    889888,
    897786,
    897897,
    898988,
    888889,
    686688,
    878969,
    798778,
    888788,
    888878,
    776866,
    897769,
    788898,
    777888,
    886889,
    687978,
    787887,
    787887,
    988898,
    778879,
    997869,
    868678,
    786777,
    778887,
    779877,
    969778,
    888787,
    887777,
    898869,
    787997,
    879886,
    788977,
    978779,
    788988,
    877988,
    977798,
    778979,
    778887,
    898689,
    877898,
    789988,
    998869,
    896897,
    889887,
    876997,
    679798,
    767887,
    768778,
    787777,
    896797,
    877899,
    878988,
    888877,
    968899,
    888898,
    869889,
    876688,
    888897,
    889788,
    888987,
    979778,
    788777,
    878877,
    788989,
    786987,
    889787,
    767879,
    788888,
    788888,
    789898,
    887797,
    887787,
    899889,
    977897,
    779896,
    988879,
    989877,
    788887,
    879867,
    788798,
    898896,
    688787,
    799667,
    897889,
    798878,
    988878,
    787778,
    888978,
    787878,
    888879,
    787788,
    988787,
    977988,
    799887,
    878878,
    798987,
    989797,
    869767,
    898889,
    988698,
    776987,
    988888,
    889898,
    998988,
    987989,
    778987,
    878787,
    888787,
    888997,
    689899,
    987786,
    978778,
    989788,
    779787,
    896868,
    979888,
    878997,
    976869,
    777887,
    788899,
    798787,
    878899,
    898779,
    797979,
    779698,
    977788,
    889788,
    887788,
    997878,
    877987,
    997886,
    879868,
    879977,
    988987,
    898979,
    788878,
    977998,
    877778,
    898887,
    678887,
    786996,
    777978,
    796798,
    989778,
    779778,
    888797,
    877876,
    889888,
    789779,
    899877,
    777968,
    989797,
    988878,
    887688,
    888877,
    887987,
    978766,
    869877,
    787897,
    888988,
    778888,
    688988,
    786797,
    887888,
    988788,
    889878,
    788897,
    788797,
    878888,
    978778,
    789989,
    967888,
    888769,
    787688,
    979868,
    887887,
    799876,
    987777,
    988879,
    887886,
    889797,
    889889,
    787797,
    767898,
    878787,
    987879,
    988667,
    797798,
    887797,
    889768,
    868888,
    887897,
    778786,
    888699,
    777678,
    887898,
    879897,
    789998,
    899977,
    779997,
    789768,
    878778,
    979778,
    789799,
    897898,
    897678,
    869878,
    987897,
    988887,
    877987,
    697978,
    867878,
    886887,
    978798,
    687988,
    787788,
    889897,
    797888,
    788889,
    878777,
    789779,
    776989,
    977768,
    868899,
    997867,
    778778,
    779778,
    877887,
    878778,
    897888,
    797987,
    787799,
    897778,
    868787,
    988778,
    779789,
    697876,
    998887,
    987897,
    697889,
    778886,
    687887,
    888888,
    896987,
    888779,
    887988,
    677896,
    779988,
    887778,
    888888,
    767797,
    877767,
    789778,
    778769,
    898697,
    877897,
    888788,
    989889,
    988798,
    878788,
    896898,
    987867,
    878787,
    887789,
    898878,
    788889,
    979887,
    798998,
    987898,
    899888,
    678897,
    898787,
    768896,
    879897,
    787778,
    778876,
    799987,
    969687,
    869877,
    988977,
    977788,
    977796,
    988897,
    778998,
    877797,
    889877,
    987998,
    879767,
    978888,
    888788,
    877898,
    768887,
    877878,
    687788,
    888878,
    668787,
    788878,
    998888,
    987888,
    889888,
    778979,
    777898,
    887877,
    889978,
    989769,
    988789,
    788988,
    779889,
    888787,
    768888,
    967877,
    787987,
    787788,
    778789,
    876798,
    997879,
    877797,
    778877,
    988898,
    898787,
    899777,
    778866,
    877886,
    878797,
    998988,
    889987,
    798877,
    987788,
    877977,
    697888,
    889777,
    898978,
    786988,
    897678,
    887788,
    788878,
    987787,
    779796,
    986886,
    778888,
    878979,
    899878,
    878887,
    898787,
    689878,
    788987,
    879787,
    897978,
    678768,
    987787,
    888978,
    668679,
    779887,
    887996,
    778989,
    779888,
    899876,
    986889,
    889788,
    677878,
    677677,
    868789,
    878879,
    878998,
    896688,
    787778,
    878888,
    788779,
    678688,
    988887,
    789898,
    997787,
    988878,
    777998,
    888898,
    988877,
    688886,
    877878,
    869968,
    878789,
    778997,
    789687,
    887796,
    787869,
    778788,
    878769,
    889767,
    987687,
    978886,
    898778,
    977889,
    779896,
    789897,
    699969,
    998978,
    787888,
    888786,
    697767,
    878898,
    887886,
    878979,
    767789,
    679876,
    977777,
    897777,
    979976,
    787887,
    778888,
    777888,
    788977,
    889997,
    787987,
    898787,
    997789,
    988798,
    998878,
    988787,
    988789,
    889879,
    997888,
    789688,
    787888,
    778788,
    788788,
    988876,
    788878,
    987878,
    787797,
    887877,
    987978,
    888877,
    988899,
    977799,
    979888,
    878888,
    897988,
    778768,
    978888,
    987877,
    898789,
    868789,
    977888,
    889799,
    777978,
    788799,
    878799,
    788797,
    886898,
    997878,
    886889,
    797768,
    997987,
    977987,
    767899,
    878788,
    679987,
    788798,
    896997,
    979799,
    899799,
    768888,
    798787,
    788699,
    888788,
    889888,
    977779,
    987788,
    788988,
    888787,
    887988,
    979877,
    988788,
    777877,
    887879,
    978979,
    897788,
    688787,
    787688,
    789789,
    667789,
    787878,
    887777,
    887898,
    769987,
    878877,
    788889,
    877878,
    789787,
    888779,
    889778,
    876777,
    978788,
    887789,
    999797,
    878798,
    788987,
    798999,
    888778,
    779798,
    899788,
    889978,
    799777,
    887888,
    876778,
    796988,
    877679,
    788888,
    868788,
    788867,
    898877,
    788898,
    787888,
    978678,
    888988,
    787677,
    887988,
    877879,
    789797,
    778888,
    777978,
    867798,
    988777,
    898879,
    888888,
    989877,
    777877,
    779787,
    988799,
    877687,
    897698,
    878887,
    777898,
    898879,
    798878,
    777896,
    688899,
    878887,
    787698,
    888998,
    777798,
    879988,
    798778,
    778888,
    787877,
    887987,
    877789,
    887887,
    778896,
    987899,
    886768,
    877778,
    779888,
    887877,
    788787,
    798787,
    978889,
    889779,
    788776,
    798896,
    878888,
    878777,
    888978,
    778797,
    897878,
    878897,
    879798,
    787887,
    778778,
    778877,
    788897,
    998789,
    788877,
    988788,
    979787,
    789768,
    897787,
    888787,
    888789,
    877877,
    869897,
    778779,
    778798,
    878787,
    888787,
    778878,
    767877,
    988878,
    788798,
    889888,
    897977,
    899998,
    767877,
    877778,
    677877,
    987777,
    997788,
    978689,
    987978,
    887798,
    896986,
    778977,
    888786,
    788789,
    888768,
    688898,
    868798,
    897887,
    868878,
    868688,
    778687,
    788898,
    998887,
    988979,
    878799,
    977766,
    788788,
    977778,
    788989,
    977698,
    997898,
    787877,
    778788,
    888787,
    978777,
    979878,
    798889,
    779778,
    897979,
    777879,
    798779,
    797997,
    879879,
    698897,
    877897,
    788778,
    797788,
    898887,
    888878,
    868798,
    789878,
    878787,
    797889,
    987778,
    866787,
    887778,
    888787,
    996898,
    987798,
    777678,
    999988,
    987788,
    796878,
    888898,
    778777,
    968879,
    979888,
    769878,
    768798,
    887899,
    888868,
    867987,
    779988,
    788988,
    898998,
    878788,
    889977,
    879877,
    979986,
    787867,
    787977,
    879777,
    687777,
    878787,
    786888,
    998767,
    877878,
    887788,
    776988,
    999876,
    978977,
    877886,
    988888,
    867777,
    877897,
    787988,
    768978,
    667989,
    878877,
    877888,
    868688,
    877797,
    799887,
    898887,
    978897,
    898887,
    787876,
    888766,
    878888,
    678868,
    897899,
    778888,
    887886,
    799798,
    768789,
    869767,
    879889,
    787998,
    788798,
    887888,
    887878,
    889797,
    888889,
    878988,
    887989,
    989878,
    787779,
    788868,
    889878,
    788788,
    777867,
    767787,
    877879,
    788988,
    877887,
    778889,
    778888,
    987777,
    777878,
    778778,
    987897,
    787879,
    879787,
    698786,
    988887,
    999898,
    769878,
    898978,
    897897,
    977788,
    996998,
    868667,
    798878,
    787688,
    788887,
    988778,
    788897,
    979778,
    877889,
    789887,
    988887,
    688797,
    788677,
    778999,
    788787,
    868867,
    788888,
    878787,
    887886,
    797878,
    867989,
    888889,
    887988,
    889889,
    889997,
    798688,
    869788,
    798778,
    797887,
    987787,
    876896,
    898888,
    788789,
    989887,
    887899,
    887986,
    878989,
    978897,
    777888,
    787888,
    789699,
    979888,
    987777,
    787988,
    977789,
    688978,
    887777,
    886989,
    776977,
    888868,
    797688,
    887797,
    897889,
    988769,
    879887,
    799787,
    888879,
    876986,
    898788,
    787899,
    989969,
    786887,
    798899,
    898997,
    778767,
    788886,
    798897,
    777767,
    877887,
    887889,
    877778,
    778978,
    897878,
    788979,
    787677,
    988688,
    978677,
    766798,
    778888,
    877878,
    898878,
    888697,
    887878,
    879879,
    688768,
    789888,
    987878,
    889869,
    879899,
    888789,
    879799,
    678887,
    789898,
    787799,
    778877,
    778878,
    888789,
    777769,
    788777,
    988878,
    887888,
    899867,
    776869,
    788677,
    777767,
    868897,
    869776,
    877798,
    788889,
    878778,
    996798,
    878868,
    987788,
    887797,
    889879,
    796988,
    978798,
    787877,
    789789,
    877979,
    899989,
    797698,
    788787,
    887788,
    888777,
    888977,
    879978,
    787898,
    987899,
    688787,
    988889,
    889879,
    888879,
    667877,
    888788,
    887897,
    786876,
    867998,
    988797,
    889877,
    888888,
    786977,
    888887,
    779687,
    789887,
    878977,
    899879,
    787988,
    997787,
    888998,
    877779,
    889887,
    887978,
    867787,
    896887,
    967897,
    998878,
    787888,
    887879,
    888887,
    897977,
    967796,
    989888,
    768797,
    978676,
    888698,
    887788,
    696779,
    799778,
    988888,
    898889,
    888887,
    678788,
    887789,
    889788,
    688868,
    786868,
    767778,
    889887,
    877789,
    998689,
    998667,
    777776,
    877988,
    879978,
    788887,
    787987,
    887788,
    788989,
    789778,
    679888,
    687787,
    986698,
    889988,
    887976,
    976988,
    787777,
    979789,
    897788,
    878876,
    768998,
    768789,
    888786,
    797988,
    978897,
    797878,
    998888,
    699978,
    888679,
    988778,
    888797,
    788978,
    876877,
    877687,
    888879,
    778788,
    898877,
    978898,
    888997,
    898887,
    868769,
    888868,
    798788,
    878877,
    878698,
    786889,
    787797,
    887886,
    888877,
    978788,
    778887,
    888897,
    987788,
    778888,
    877888,
    797978,
    698687,
    777968,
    788788,
    888866,
    788978,
    979878,
    889688,
    878897,
    778786,
    878778,
    866876,
    887878,
    988778,
    897788,
    787788,
    988989,
    788896,
    877888,
    888878,
    888777,
    988786,
    797988,
    777987,
    987877,
    868878,
    889788,
    679788,
    778989,
    877887,
    779868,
    888779,
    968888,
    877888,
    798787,
    879887,
    778788,
    787889,
    986877,
    688677,
    997789,
    876687,
    788778,
    978799,
    879877,
    889869,
    988898,
    988878,
    797877,
    887788,
    698887,
    878887,
    969897,
    779687,
    796799,
    789887,
    988797,
    978888,
    787868,
    798798,
    878789,
    998788,
    799988,
    968867,
    898887,
    778888,
    778788,
    787878,
    697788,
    876997,
    988778,
    899876,
    989888,
    978788,
    778886,
    867876,
    899898,
    989688,
    786877,
    676788,
    779787,
    789878,
    769786,
    889789,
    789798,
    787678,
    788786,
    778988,
    787678,
    667678,
    786787,
    987877,
    797999,
    977988,
    787877,
    778878,
    997778,
    798888,
    678878,
    977897,
    769688,
    787987,
    887978,
    988779,
    886778,
    878776,
    878878,
    798878,
    986778,
    778789,
    998768,
    979796,
    877787,
    888798,
    897978,
    688979,
    878778,
    777689,
    787787,
    967988,
    877779,
    777977,
    887788,
    787887,
    887887,
    899988,
    988887,
    877988,
    899898,
    878887,
    777897,
    878878,
    889888,
    778669,
    688788,
    899877,
    797889,
    778778,
    878788,
    888778,
    879786,
    976677,
    878878,
    979677,
    786889,
    987888,
    987787,
    888968,
    778898,
    876797,
    989897,
    897777,
    879979,
    977799,
    767778,
    797977,
    786987,
    878778,
    988768,
    999888,
    777989,
    888777,
    778797,
    978798,
    897889,
    788976,
    697799,
    877888,
    788867,
    898889,
    788876,
    888889,
    788798,
    887886,
    769898,
    798778,
    788868,
    796777,
    788987,
    689788,
    886799,
    889886,
    878789,
    788888,
    678886,
    768877,
    877777,
    888688,
    888786,
    676799,
    897778,
    897978,
    878676,
    789887,
    899897,
    797978,
    688886,
    976977,
    779778,
    789877,
    879898,
    778788,
    888877,
    888788,
    778889,
    789876,
    876879,
    888788,
    699897,
    897878,
    887897,
    798997,
    978889,
    899797,
    877778,
    868786,
    878888,
    779887,
    888889,
    798879,
    888987,
    888799,
    888888,
    877776,
    879899,
    878697,
    778878,
    888876,
    787778,
    868888,
    897778,
    878687,
    787977,
    988887,
    798687,
    888788,
    888979,
    898787,
    866888,
    877677,
    967979,
    888989,
    888787,
    877698,
    989988,
    888878,
    897887,
    998987,
    889777,
    788787,
    788887,
    799779,
    877989,
    778877,
    778998,
    787797,
    797787,
    868687,
    979879,
    988977,
    766897,
    878988,
    978887,
    799888,
    789696,
    788789,
    898898,
    888779,
    979788,
    896866,
    678886,
    678777,
    867988,
    976877,
    786797,
    889778,
    788888,
    987787,
    897689,
    799889,
    887989,
    878978,
    968687,
    687898,
    887988,
    768789,
    888887,
    898796,
    988989,
    979777,
    887977,
    868898,
    888878,
    887898,
    778788,
    776776,
    788878,
    878867,
    976978,
    878797,
    786798,
    887799,
    889787,
    986887,
    778887,
    787787,
    878978,
    888898,
    997999,
    997978,
    878986,
    988778,
    787789,
    999987,
    888887,
    879787,
    978877,
    768988,
    998767,
    879877,
    976788,
    878788,
    678877,
    887988,
    998887,
    767878,
    698869,
    978889,
    769696,
    777888,
    977788,
    777787,
    779977,
    887898,
    888878,
    979877,
    988877,
    889887,
    977987,
    799978,
    787877,
    777887,
    787889,
    889887,
    889788,
    889887,
    888887,
    988778,
    768778,
    988878,
    778879,
    888988,
    779778,
    887879,
    887778,
    868887,
    898767,
    788898,
    789878,
    988878,
    887877,
    879888,
    877797,
    979879,
    878777,
    788878,
    977879,
    987777,
    967778,
    787788,
    787777,
    798898,
    789988,
    789889,
    778787,
    889886,
    989869,
    787787,
    998886,
    878988,
    777967,
    798789,
    677896,
    898676,
    786798,
    888987,
    897788,
    788788,
    798768,
    888898,
    888886,
    997776,
    868698,
    998887,
    899988,
    978899,
    897778,
    677776,
    987787,
    697787,
    988887,
    897778,
    987878,
    768989,
    986777,
    887978,
    888777,
    668878,
    897877,
    986879,
    876886,
    787776,
    889987,
    999779,
    867787,
    778787,
    879778,
    797988,
    678876,
    879878,
    889688,
    978799,
    889887,
    877898,
    897888,
    889788,
    788968,
    779788,
    968897,
    798888,
    888887,
    888898,
    798889,
    877878,
    898786,
    779896,
    778787,
    786899,
    886777,
    977887,
    879976,
    889787,
    777886,
    677788,
    998988,
    897998,
    887788,
    886788,
    888878,
    788889,
    887986,
    986889,
    796987,
    897877,
    788976,
    788898,
    977997,
    997698,
    977898,
    898877,
    789889,
    778868,
    888888,
    888878,
    887688,
    778876,
    887999,
    788998,
    867887,
    776687,
    878797,
    798779,
    787998,
    786898,
    797887,
    787889,
    788897,
    988887,
    887888,
    878778,
    897887,
    877977,
    869778,
    987978,
    779999,
    887889,
    697677,
    889888,
    989787,
    988788,
    998788,
    798879,
    878788,
    897898,
    687787,
    787778,
    878877,
    878887,
    788989,
    897988,
    787978,
    786789,
    879778,
    888897,
    988988,
    988677,
    776989,
    777787,
    898887,
    778778,
    977778,
    678877,
    888998,
    797887,
    778779,
    889887,
    888789,
    777997,
    777877,
    898797,
    787779,
    887778,
    788788,
    888789,
    888977,
    878877,
    887788,
    977788,
    878879,
    868977,
    786898,
    999878,
    787788,
    888768,
    978878,
    887688,
    788789,
    788986,
    787878,
    898789,
    778867,
    786797,
    979878,
    887889,
    998887,
    797868,
    979978,
    898886,
    688897,
    888888,
    877768,
    787776,
    797879,
    679879,
    778877,
    878798,
    798867,
    887888,
    878787,
    967887,
    688878,
    877767,
    889677,
    978787,
    878888,
    969889,
    788889,
    777887,
    889877,
    788797,
    788796,
    997888,
    777987,
    897878,
    977977,
    988877,
    987886,
    969888,
    679886,
    878787,
    877889,
    787868,
    766778,
    877779,
    879779,
    897777,
    878888,
    789888,
    786788,
    889777,
    789886,
    878877,
    889889,
    888779,
    667999,
    787787,
    987787,
    688889,
    988978,
    888787,
    868786,
    887797,
    998887,
    888979,
    899798,
    976877,
    678988,
    878796,
    778769,
    898987,
    879988,
    787768,
    898878,
    787787,
    787878,
    797778,
    876778,
    978876,
    987787,
    898897,
    788978,
    889868,
    888878,
    797888,
    867879,
    879887,
    988797,
    688987,
    897886,
    877787,
    897788,
    877789,
    979678,
    888787,
    888898,
    788988,
    977889,
    886788,
    798879,
    887888,
    798887,
    877988,
    979989,
    887897,
    888787,
    988787,
    989877,
    877888,
    889778,
    898887,
    978988,
    798868,
    887777,
    887888,
    878898,
    897996,
    887987,
    987978,
    777997,
    678978,
    887888,
    678878,
    987788,
    977889,
    978698,
    697876,
    888877,
    886697,
    889788,
    887977,
    888898,
    799788,
    986788,
    989788,
    888779,
    887787,
    899797,
    797887,
    788888,
    898888,
    979699,
    979788,
    888777,
    787899,
    977968,
    868887,
    778876,
    689978,
    877678,
    777789,
    787987,
    877678,
    998888,
    698876,
    877897,
    798788,
    888797,
    787898,
    879998,
    896788,
    978768,
    786787,
    888876,
    877967,
    878698,
    987687,
    787789,
    888889,
    778697,
    879888,
    787798,
    897698,
    976888,
    798877,
    898898,
    886887,
    879998,
    989679,
    878978,
    887998,
    878967,
    989777,
    798877,
    878878,
    879877,
    798788,
    889788,
    788887,
    688789,
    697887,
    886888,
    879788,
    778886,
    699689,
    988778,
    878777,
    867889,
    987789,
    797789,
    769888,
    787787,
    878867,
    797897,
    887677,
    977797,
    988796,
    988798,
    988777,
    898789,
    888799,
    688899,
    786698,
    887779,
    789897,
    787788,
    998879,
    767777,
    889976,
    789787,
    788789,
    978998,
    789688,
    787988,
    988896,
    878787,
    798778,
    899779,
    899878,
    779877,
    776998,
    888967,
    797879,
    798678,
    987988,
    878878,
    898886,
    786988,
    688678,
    778977,
    798698,
    897987,
    978777,
    998979,
    888767,
    887788,
    888888,
    687897,
    988888,
    788897,
    788876,
    788987,
    897968,
    988888,
    897879,
    788998,
    896868,
    698897,
    787886,
    888899,
    888887,
    789978,
    787896,
    798878,
    878989,
    888989,
    898887,
    877777,
    797879,
    788787,
    878888,
    978997,
    788877,
    977878,
    878979,
    787788,
    878777,
    799898,
    788788,
    899699,
    879787,
    768686,
    877687,
    977887,
    877978,
    878989,
    979787,
    798768,
    897899,
    897787,
    876877,
    886888,
    788988,
    997779,
    678797,
    888886,
    789887,
    888788,
    697787,
    798968,
    877798,
    879798,
    769787,
    878888,
    767888,
    887778,
    879788,
    777778,
    798799,
    888689,
    879877,
    797877,
    797777,
    988878,
    776986,
    877877,
    877897,
    868879,
    878986,
    789788,
    889887,
    789678,
    979998,
    877888,
    777778,
    887888,
    677787,
    987877,
    878887,
    888988,
    777877,
    888988,
    986798,
    897889,
    778899,
    878978,
    778887,
    888878,
    888877,
    878696,
    886789,
    978788,
    698797,
    888789,
    898798,
    977887,
    776787,
    888887,
    777888,
    788967,
    778699,
    987776,
    876987,
    888678,
    878688,
    787799,
    778989,
    888778,
    878778,
    978688,
    789689,
    987889,
    889787,
    898777,
    879777,
    978778,
    899997,
    887677,
    988977,
    899678,
    898798,
    897877,
    887997,
    799887,
    987877,
    878887,
    879877,
    878779,
    767867,
    788698,
    877788,
    899978,
    788878,
    887989,
    799986,
    787978,
    998799,
    877868,
    888789,
    788787,
    878678,
    887868,
    988887,
    988787,
    788878,
    889767,
    987888,
    989797,
    698688,
    867778,
    678698,
    887886,
    898788,
    987899,
    897987,
    798778,
    978889,
    889988,
    887888,
    878769,
    887868,
    769797,
    898779,
    878978,
    677789,
    997889,
    987787,
    988797,
    878979,
    878998,
    878977,
    969777,
    888789,
    869779,
    968979,
    889777,
    888888,
    987968,
    989777,
    768898,
    789877,
    879799,
    888997,
    979899,
    767887,
    987887,
    678889,
    786898,
    888888,
    677777,
    898887,
    887988,
    888877,
    986867,
    888897,
    888678,
    887777,
    978788,
    888897,
    888889,
    867868,
    888768,
    888888,
    889687,
    899888,
    977777,
    886987,
    898976,
    777878,
    866797,
    868897,
    896888,
    789787,
    998897,
    989888,
    888878,
    787868,
    887788,
    968777,
    898787,
    888889,
    888998,
    877776,
    797688,
    898899,
    898689,
    887879,
    997787,
    779679,
    969766,
    887788,
    768899,
    878888,
    878886,
    797797,
    788898,
    877988,
    878867,
    999778,
    987887,
    888976,
    867787,
    867886,
    877886,
    788888,
    899879,
    778978,
    789787,
    887886,
    777877,
    979777,
    788997,
    787777,
    887879,
    798977,
    898979,
    677997,
    779888,
    889986,
    797979,
    888997,
    769978,
    877888,
    898689,
    987978,
    789797,
    898787,
    998788,
    879876,
    887889,
    889977,
    789788,
    867888,
    887888,
    878977,
    787999,
    898887,
    886878,
    878887,
    786777,
    878997,
    888788,
    877897,
    888888,
    678988,
    789877,
    786888,
    898877,
    889888,
    678786,
    878888,
    896797,
    777788,
    878897,
    798687,
    788688,
    877898,
    888797,
    977799,
    897897,
    799969,
    887978,
    888877,
    887688,
    879787,
    888879,
    888966,
    887877,
    788798,
    879777,
    887988,
    887777,
    888988,
    888987,
    887887,
    997788,
    778878,
    978877,
    677978,
    887889,
    989788,
    878779,
    887877,
    877787,
    988879,
    878798,
    689788,
    787888,
    877888,
    767787,
    678899,
    898787,
    978997,
    889699,
    789778,
    899788,
    889978,
    796898,
    988788,
    878878,
    797888,
    888879,
    788787,
    978987,
    888798,
    898997,
    799788,
    778888,
    887798,
    888778,
    889898,
    988777,
    987788,
    877888,
    787797,
    896879,
    978888,
    887989,
    877988,
    877898,
    789879,
    988879,
    888887,
    887997,
    977898,
    879979,
    866788,
    898777,
    788887,
    897787,
    798899,
    887777,
    877898,
    887887,
    988886,
    799778,
    888788,
    886878,
    988878,
    987897,
    767687,
    868778,
    987787,
    777978,
    877878,
    997778,
    799986,
    978898,
    899889,
    778788,
    788777,
    897988,
    789797,
    868978,
    779768,
    888987,
    787989,
    987987,
    898787,
    987887,
    977778,
    888878,
    877996,
    788878,
    887779,
    896789,
    886797,
    878977,
    898988,
    977797,
    777888,
    886786,
    888978,
    888898,
    798986,
    798898,
    888878,
    888898,
    787788,
    978879,
    788678,
    888788,
    786778,
    898777,
    787998,
    968879,
    789878,
    897779,
    787787,
    788878,
    687778,
    979888,
    768889,
    868697,
    888876,
    768697,
    888789,
    767897,
    997878,
    776778,
    787879,
    678969,
    779889,
    778686,
    887779,
    989889,
    868689,
    788687,
    797979,
    778866,
    898968,
    987798,
    788767,
    888878,
    876778,
    887867,
    889877,
    998889,
    977768,
    776789,
    868776,
    788788,
    678777,
    898889,
    987878,
    779988,
    779887,
    888888,
    986888,
    896887,
    778888,
    979898,
    998778,
    889887,
    777977,
    888889,
    887887,
    887779,
    696987,
    789778,
    776898,
    999986,
    787789,
    668888,
    898868,
    786996,
    989988,
    887999,
    889889,
    987887,
    977887,
    889799,
    779787,
    787776,
    768886,
    797786,
    777879,
    787897,
    879776,
    878899,
    778979,
    688776,
    877888,
    988797,
    788896,
    898989,
    787788,
    779679,
    867796,
    889798,
    899787,
    788877,
    799879,
    977778,
    687889,
    987877,
    777778,
    888678,
    677778,
    878876,
    777978,
    788988,
    899879,
    878796,
    777779,
    887869,
    787878,
    789998,
    877778,
    888888,
    877888,
    889687,
    877888,
    886678,
    779789,
    887789,
    988788,
    789868,
    888888,
    678797,
    997979,
    687877,
    888777,
    767887,
    878989,
    777787,
    988888,
    676889,
    779897,
    899977,
    889898,
    898889,
    878887,
    687678,
    898888,
    786877,
    887878,
    888876,
    869667,
    778786,
    887787,
    797789,
    889879,
    898668,
    888868,
    898769,
    887867,
    979898,
    788788,
    788788,
    876869,
    987888,
    977789,
    898776,
    776778,
    687878,
    779877,
    988767,
    868779,
    877799,
    688686,
    977888,
    879698,
    878979,
    869698,
    688788,
    788879,
    888997,
    867898,
    868977,
    787798,
    899977,
    867778,
    987687,
    888878,
    878688,
    879788,
    798888,
    878887,
    997799,
    988968,
    879976,
    888887,
    888888,
    788888,
    867787,
    688967,
    699778,
    788888,
    767889,
    797798,
    789878,
    879986,
    787887,
    977888,
    899788,
    899888,
    789788,
    997887,
    886987,
    877777,
    778996,
    888788,
    898887,
    787779,
    887889,
    898867,
    888897,
    797969,
    797877,
    798877,
    896778,
    977878,
    777779,
    797867,
    889887,
    888788,
    888777,
    998898,
    788877,
    898877,
    869697,
    888988,
    968879,
    978699,
    899997,
    888887,
    987977,
    878988,
    988887,
    887889,
    788888,
    689697,
    778776,
    878898,
    679968,
    788687,
    788896,
    968787,
    889878,
    978788,
    877898,
    979778,
    767897,
    798878,
    778879,
    898888,
    897998,
    868878,
    876789,
    998867,
    788789,
    988778,
    778878,
    979887,
    796977,
    778887,
    987988,
    978879,
    779898,
    887777,
    988788,
    987898,
    876987,
    988887,
    798778,
    869778,
    989886,
    898788,
    887788,
    877787,
    868978,
    777797,
    787777,
    788778,
    777977,
    878798,
    977867,
    997878,
    897888,
    778998,
    777888,
    678888,
    996898,
    978889,
    688787,
    787887,
    887789,
    878788,
    887677,
    887798,
    867989,
    768668,
    988987,
    788877,
    787977,
    779878,
    987788,
    778889,
    769868,
    788677,
    888888,
    889877,
    877988,
    789989,
    789778,
    987888,
    978877,
    888987,
    677786,
    878788,
    898678,
    997688,
    778688,
    787786,
    878787,
    977767,
    867768,
    998868,
    978977,
    788679,
    889986,
    788888,
    787977,
    888778,
    678787,
    878788,
    979777,
    787977,
    878789,
    979898,
    868987,
    979787,
    897888,
    868898,
    887799,
    789778,
    889977,
    997698,
    877897,
    878978,
    987898,
    888769,
    889788,
    878887,
    787877,
    767898,
    886788,
    788888,
    898878,
    878887,
    887988,
    968899,
    876798,
    967768,
    877789,
    877789,
    997778,
    969888,
    678898,
    778888,
    889889,
    778998,
    878687,
    777878,
    777697,
    779898,
    988988,
    777978,
    789897,
    688887,
    798879,
    998887,
    888879,
    869879,
    887986,
    977877,
    898888,
    798786,
    898989,
    999788,
    897988,
    878879,
    788786,
    886988,
    996877,
    999887,
    977999,
    898786,
    787977,
    989879,
    797797,
    789998,
    778887,
    788898,
    779877,
    876898,
    777788,
    787987,
    787998,
    888899,
    889678,
    898887,
    798978,
    879886,
    878688,
    887687,
    977777,
    987797,
    798987,
    787887,
    888978,
    886888,
    778877,
    877987,
    888897,
    878786,
    798788,
    988678,
    789877,
    978966,
    689878,
    787777,
    877889,
    877777,
    777868,
    877679,
    877779,
    989989,
    678779,
    779797,
    877799,
    998899,
    977799,
    898877,
    887877,
    988788,
    787976,
    686778,
    888788,
    898787,
    877688,
    888987,
    887787,
    989888,
    788787,
    886678,
    796778,
    679677,
    799688,
    879878,
    797998,
    797878,
    789798,
    788878,
    997778,
    878777,
    778989,
    888869,
    777888,
    697888,
    777878,
    877778,
    786777,
    878797,
    796678,
    788798,
    688877,
    879878,
    887788,
    986978,
    878787,
    887767,
    689887,
    998779,
    798777,
    877777,
    879868,
    677877,
    887888,
    869897,
    898877,
    888778,
    799777,
    898989,
    777887,
    978978,
    897789,
    888799,
    888687,
    887798,
    997998,
    888679,
    887987,
    698887,
    696876,
    887988,
    887898,
    877888,
    888878,
    799879,
    979788,
    898788,
    887779,
    778887,
    797868,
    786888,
    889877,
    886688,
    789877,
    798997,
    798777,
    687987,
    887988,
    889888,
    788899,
    889779,
    887688,
    988878,
    888888,
    888888,
    977789,
    678879,
    878797,
    787887,
    978788,
    867878,
    798886,
    888978,
    777878,
    798886,
    889679,
    888997,
    787887,
    789899,
    979986,
    866789,
    668789,
    778887,
    988898,
    689787,
    777889,
    788796,
    788787,
    788889,
    888878,
    786797,
    778797,
    878878,
    988788,
    888778,
    877977,
    798879,
    986787,
    887778,
    988797,
    966897,
    998977,
    988879,
    688778,
    877877,
    888786,
    888778,
    897979,
    987787,
    769976,
    967888,
    877889,
    978888,
    897678,
    777789,
    899868,
    677779,
    988897,
    898677,
    777989,
    888987,
    777788,
    798877,
    688879,
    789877,
    879787,
    887778,
    786778,
    868898,
    687787,
    798797,
    877788,
    868878,
    889897,
    788889,
    777677,
    789777,
    898988,
    788788,
    889788,
    779788,
    777777,
    797778,
    987887,
    878887,
    779778,
    977787,
    879887,
    889997,
    789789,
    887986,
    896899,
    898888,
    778989,
    889797,
    979778,
    798999,
    977978,
    887877,
    967878,
    888897,
    777777,
    679679,
    779888,
    788877,
    897978,
    889878,
    778998,
    888778,
    876878,
    788888,
    697989,
    899788,
    889978,
    778766,
    979988,
    987988,
    999788,
    888878,
    978887,
    779897,
    788879,
    667679,
    889788,
    887988,
    679798,
    978787,
    877797,
    878887,
    897889,
    887888,
    998788,
    887778,
    869878,
    979788,
    877797,
    979687,
    969997,
    889767,
    778979,
    888786,
    777878,
    988987,
    987887,
    977798,
    777698,
    988798,
    789776,
    988878,
    887887,
    798898,
    777779,
    797677,
    787998,
    998788,
    778899,
    887888,
    889887,
    898678,
    788777,
    879898,
    878889,
    878766,
    788889,
    788988,
    877787,
    879789,
    878887,
    998988,
    887978,
    988988,
    877788,
    788889,
    787796,
    777788,
    788788,
    997689,
    687987,
    878778,
    988977,
    988878,
    778888,
    878878,
    797777,
    887987,
    787778,
    888878,
    978788,
    788698,
    877866,
    878887,
    989988,
    877788,
    888887,
    789798,
    878878,
    897889,
    887988,
    796877,
    779989,
    787867,
    777999,
    779888,
    988699,
    777798,
    777798,
    789888,
    889989,
    777787,
    878997,
    888789,
    878888,
    898877,
    988887,
    788987,
    988789,
    788779,
    899878,
    877797,
    777979,
    898899,
    887776,
    998686,
    888879,
    679887,
    989888,
    979888,
    787687,
    878986,
    777877,
    877888,
    778877,
    788779,
    777797,
    877897,
    887778,
    788978,
    998897,
    988897,
    999899,
    889788,
    777796,
    997788,
    789987,
    697877,
    778898,
    778778,
    899788,
    978878,
    888897,
    887878,
    887887,
    889669,
    798698,
    878788,
    887987,
    888978,
    877888,
    988977,
    998797,
    898878,
    878878,
    998787,
    886688,
    878899,
    666789,
    878978,
    898897,
    878779,
    979788,
    977887,
    898878,
    988889,
    978778,
    878687,
    888988,
    877878,
    899797,
    778978,
    897977,
    887777,
    887779,
    789798,
    688777,
    787869,
    767787,
    987778,
    987899,
    788797,
    767998,
    687888,
    769988,
    788877,
    788889,
    687778,
    889998,
    878798,
    787878,
    889879,
    799778,
    688897,
    778978,
    786888,
    876787,
    877886,
    787777,
    987879,
    787889,
    998776,
    888989,
    997678,
    797977,
    977977,
    786867,
    778788,
    898788,
    888777,
    868889,
    786777,
    888998,
    877879,
    878798,
    997888,
    778798,
    787788,
    789889,
    887998,
    978889,
    678787,
    667997,
    988779,
    877788,
    777889,
    998878,
    877688,
    888787,
    788988,
    877977,
    978777,
    787878,
    879977,
    778877,
    878878,
    788788,
    888698,
    889789,
    878677,
    777698,
    888789,
    888887,
    888989,
    788788,
    969798,
    987889,
    788999,
    887787,
    778688,
    788787,
    798998,
    778876,
    899878,
    888888,
    886888,
    977776,
    779889,
    968797,
    779778,
    898887,
    788896,
    798889,
    797878,
    999788,
    889677,
    699789,
    887787,
    977897,
    989878,
    897869,
    688887,
    978777,
    988779,
    767788,
    887799,
    898786,
    877797,
    887897,
    988789,
    977896,
    978887,
    786879,
    788878,
    887697,
    777888,
    888798,
    898888,
    798789,
    797867,
    788877,
    767999,
    777878,
    998788,
    678767,
    897797,
    877999,
    989778,
    878678,
    887788,
    888778,
    788878,
    876786,
    788888,
    787789,
    789798,
    888989,
    787868,
    788986,
    898878,
    979999,
    898977,
    787897,
    997888,
    798886,
    978688,
    897786,
    876988,
    997788,
    899889,
    798766,
    976777,
    797778,
    799778,
    889788,
    978898,
    786796,
    798779,
    877979,
    989689,
    778878,
    778777,
    787878,
    788778,
    777898,
    988888,
    786977,
    878977,
    787796,
    868786,
    776799,
    997978,
    888768,
    798797,
    689887,
    878888,
    888989,
    888797,
    886777,
    887879,
    787777,
    978979,
    889779,
    888888,
    886988,
    988887,
    788899,
    899888,
    879897,
    788787,
    698978,
    889878,
    768889,
    877898,
    889779,
    967997,
    778778,
    986789,
    887887,
    788878,
    899897,
    888887,
    867888,
    777878,
    687868,
    888778,
    689877,
    787888,
    888888,
    688867,
    986898,
    777687,
    777787,
    879769,
    777978,
    876777,
    779988,
    997887,
    989888,
    676889,
    898967,
    987877,
    889788,
    768778,
    678778,
    898878,
    766779,
    769779,
    688889,
    797886,
    887868,
    887878,
    788877,
    997879,
    798888,
    787998,
    889977,
    767787,
    877688,
    889887,
    889887,
    888888,
    776878,
    877877,
    888787,
    798888,
    777778,
    876997,
    679789,
    998887,
    886988,
    888876,
    676986,
    989788,
    767888,
    767777,
    788998,
    867988,
    986887,
    787788,
    877969,
    887978,
    886898,
    768898,
    977798,
    689978,
    886978,
    987788,
    987986,
    898778,
    787899,
    676779,
    788787,
    899978,
    778886,
    988786,
    888889,
    887899,
    998997,
    898898,
    787967,
    798978,
    899978,
    787897,
    889978,
    877887,
    888877,
    788778,
    887887,
    796888,
    799789,
    888889,
    688879,
    777778,
    878887,
    877697,
    867878,
    978898,
    978996,
    888888,
    979997,
    999988,
    796797,
    878688,
    978897,
    798789,
    798869,
    877869,
    888797,
    787788,
    878897,
    977796,
    776779,
    878889,
    779867,
    798788,
    977897,
    987886,
    788789,
    769787,
    888777,
    788967,
    888688,
    866878,
    779888,
    877798,
    887987,
    978888,
    898898,
    998778,
    897688,
    887969,
    877897,
    888797,
    798888,
    879878,
    997786,
    988897,
    679789,
    877688,
    998777,
    777778,
    778799,
    687987,
    877978,
    788886,
    789889,
    888968,
    887988,
    767887,
    678887,
    897777,
    769868,
    688897,
    687798,
    788887,
    788888,
    988878,
    788776,
    987867,
    788889,
    989787,
    688776,
    788786,
    788887,
    987897,
    888888,
    888699,
    879778,
    788888,
    877777,
    989996,
    786988,
    769889,
    698787,
    888787,
    978877,
    976898,
    676698,
    898768,
    897888,
    786788,
    999889,
    667779,
    977778,
    787877,
    877887,
    988788,
    887798,
    888886,
    898888,
    978888,
    778887,
    778788,
    888788,
    787787,
    878698,
    789899,
    898799,
    877888,
    877978,
    798889,
    877876,
    778787,
    898798,
    878778,
    968978,
    797878,
    987787,
    887686,
    687988,
    988786,
    898987,
    778877,
    688977,
    879887,
    877779,
    768987,
    967887,
    999987,
    886787,
    887788,
    888777,
    868797,
    788888,
    889797,
    889897,
    999778,
    897789,
    888987,
    886898,
    677888,
    987888,
    787987,
    788789,
    898878,
    788878,
    868998,
    797977,
    876677,
    797779,
    798787,
    787777,
    677878,
    788879,
    798869,
    977787,
    878877,
    968879,
    977788,
    876789,
    877877,
    877777,
    868888,
    688897,
    977687,
    889888,
    869699,
    998986,
    796897,
    877889,
    877878,
    887777,
    888989,
    898779,
    988777,
    788799,
    767788,
    876788,
    798796,
    787777,
    778988,
    786798,
    789889,
    988878,
    877987,
    887786,
    797888,
    898788,
    767786,
    888886,
    878887,
    898988,
    987989,
    887788,
    868897,
    897777,
    888887,
    989877,
    788877,
    889898,
    897888,
    899986,
    788789,
    898888,
    978787,
    999889,
    798898,
    988867,
    887889,
    878878,
    887878,
    788888,
    877888,
    888786,
    777776,
    868999,
    998878,
    887888,
    877878,
    888888,
    988878,
    778979,
    668987,
    988879,
    798879,
    788779,
    778877,
    788888,
    888798,
    987798,
    667886,
    788998,
    897787,
    969889,
    987788,
    678888,
    799777,
    887899,
    787876,
    898779,
    877998,
    897977,
    978887,
    997688,
    788977,
    888788,
    788878,
    687787,
    777687,
    778877,
    878886,
    879988,
    986789,
    878878,
    789778,
    977877,
    987788,
    987668,
    878978,
    888978,
    898679,
    768877,
    887968,
    769899,
    888878,
    768977,
    888887,
    689886,
    988878,
    888776,
    888788,
    678868,
    898778,
    777788,
    897879,
    898878,
    888877,
    798987,
    788777,
    867987,
    998878,
    798899,
    889877,
    879778,
    878787,
    878898,
    787999,
    877888,
    888788,
    877679,
    998878,
    878898,
    868778,
    779887,
    789786,
    987978,
    877877,
    789879,
    788878,
    889988,
    887867,
    879778,
    778897,
    677877,
    788778,
    778998,
    788887,
    878987,
    897777,
    997779,
    888888,
    887788,
    978877,
    889787,
    798887,
    986989,
    769667,
    887876,
    989798,
    778888,
    989987,
    998788,
    898869,
    987897,
    898878,
    688969,
    897777,
    887788,
    888787,
    888877,
    778887,
    697789,
    988888,
    789979,
    987889,
    678887,
    987997,
    876867,
    789888,
    778987,
    787887,
    689889,
    878798,
    789867,
    778889,
    788877,
    877778,
    898787,
    879987,
    888987,
    778799,
    898989,
    777787,
    868688,
    879789,
    776887,
    786876,
    888887,
    999778,
    799878,
    887799,
    898887,
    789776,
    797997,
    897967,
    886878,
    896997,
    797886,
    889686,
    769787,
    786999,
    777779,
    797867,
    796898,
    978888,
    898988,
    888688,
    997777,
    677887,
    898887,
    897778,
    877878,
    887788,
    897778,
    668789,
    789789,
    788887,
    778779,
    878878,
    887998,
    878787,
    887877,
    789897,
    887878,
    997888,
    988879,
    797978,
    887998,
    788788,
    888778,
    898766,
    686779,
    778797,
    778897,
    889777,
    799777,
    977798,
    677989,
    696878,
    897868,
    987888,
    678787,
    898878,
    768789,
    687897,
    888878,
    798888,
    878898,
    798898,
    787887,
    888778,
    879868,
    977798,
    998988,
    868879,
    678878,
    877976,
    777888,
    887786,
    798778,
    787988,
    889889,
    686788,
    676798,
    786879,
    796777,
    777988,
    887688,
    867788,
    788789,
    788898,
    678896,
    778896,
    768887,
    898879,
    888788,
    979878,
    887789,
    678877,
    796787,
    988789,
    878778,
    678798,
    879899,
    899787,
    878987,
    888799,
    767779,
    778779,
    788899,
    787998,
    688779,
    877878,
    988986,
    687869,
    888787,
    866888,
    799898,
    788787,
    799897,
    879787,
    878999,
    799777,
    788979,
    887888,
    678878,
    987976,
    987779,
    888998,
    887789,
    877678,
    788788,
    798799,
    689988,
    787988,
    988788,
    998778,
    887879,
    877898,
    997899,
    988777,
    778779,
    978898,
    779768,
    888888,
    679876,
    877698,
    998688,
    987779,
    899999,
    799888,
    776877,
    976668,
    769898,
    788989,
    777887,
    887788,
    777799,
    887767,
    779988,
    887989,
    877878,
    978987,
    876878,
    688987,
    777868,
    878887,
    997898,
    988776,
    777779,
    888798,
    788797,
    899698,
    779886,
    877878,
    869898,
    889799,
    987787,
    778779,
    977788,
    788769,
    878677,
    999888,
    777768,
    978788,
    889879,
    968787,
    779896,
    989887,
    888898,
    889789,
    879978,
    889678,
    877968,
    889978,
    888989,
    889777,
    798868,
    698988,
    798679,
    877878,
    899789,
    777988,
    888877,
    968778,
    977887,
    787897,
    788886,
    987878,
    988987,
    988979,
    888888,
    788888,
    977788,
    798787,
    886998,
    998798,
    878887,
    787887,
    888997,
    798797,
    788987,
    778787,
    888878,
    887698,
    786878,
    877679,
    967787,
    787988,
    979787,
    779777,
    877877,
    899888,
    787878,
    868877,
    988977,
    778779,
    988798,
    987889,
    987998,
    977778,
    887987,
    777678,
    977768,
    877678,
    687987,
    777898,
    988777,
    987787,
    867987,
    876899,
    898888,
    977879,
    897898,
    787886,
    898887,
    889799,
    798787,
    988787,
    878888,
    876878,
    669878,
    787878,
    799788,
    788777,
    977997,
    879897,
    776687,
    787768,
    787778,
    799787,
    877887,
    998879,
    888888,
    787898,
    788978,
    889796,
    889978,
    887887,
    889887,
    879878,
    867769,
    888989,
    788798,
    897989,
    787767,
    998878,
    689787,
    879979,
    998888,
    898977,
    878998,
    878879,
    898698,
    878896,
    977897,
    889796,
    969788,
    787799,
    887987,
    977888,
    877878,
    788887,
    887888,
    896878,
    888878,
    778767,
    798888,
    767797,
    888888,
    778867,
    876688,
    768987,
    987997,
    897988,
    887778,
    779997,
    688888,
    879677,
    878768,
    888879,
    888887,
    898779,
    688668,
    998778,
    698697,
    898888,
    899778,
    889798,
    688879,
    789799,
    776787,
    679798,
    869877,
    898979,
    689879,
    779978,
    877988,
    799688,
    888998,
    898797,
    777789,
    978997,
    989776,
    898887,
    988997,
    978687,
    868898,
    886888,
    876878,
    988977,
    977979,
    879997,
    877788,
    976869,
    789799,
    789878,
    999988,
    879988,
    798878,
    888688,
    868888,
    877767,
    787887,
    787877,
    688879,
    788889,
    777878,
    887998,
    897797,
    888889,
    778888,
    879899,
    888978,
    898889,
    778876,
    877978,
    868878,
    889877,
    977787,
    687799,
    798898,
    787886,
    778878,
    888887,
    687788,
    777887,
    887889,
    778777,
    879698,
    897878,
    777877,
    777788,
    879876,
    777888,
    788878,
    978788,
    777978,
    799788,
    886898,
    878687,
    979889,
    777967,
    789879,
    888788,
    788878,
    999797,
    778887,
    968878,
    887888,
    888898,
    989788,
    887766,
    787787,
    887876,
    869788,
    798876,
    978879,
    787787,
    877889,
    789889,
    789678,
    888898,
    787767,
    779788,
    787778,
    788968,
    887787,
    798897,
    689889,
    966898,
    788898,
    788878,
    997888,
    777776,
    788877,
    699898,
    878887,
    686897,
    778987,
    778879,
    867667,
    778879,
    789798,
    997879,
    788798,
    878898,
    778888,
    789788,
    888777,
    987997,
    798889,
    868798,
    897788,
    887877,
    878888,
    698888,
    798779,
    977877,
    897878,
    698888,
    696867,
    778888,
    899888,
    899878,
    788898,
    987988,
    878788,
    878887,
    779888,
    897789,
    876798,
    778869,
    879987,
    978776,
    876976,
    887868,
    778789,
    878888,
    877888,
    778897,
    879797,
    788886,
    786779,
    878877,
    787879,
    778798,
    797779,
    789778,
    998899,
    789999,
    989779,
    799988,
    687877,
    877997,
    978967,
    789987,
    788877,
    878997,
    777888,
    877877,
    978698,
    897787,
    788897,
    877889,
    888868,
    789988,
    976897,
    797887,
    797787,
    887889,
    677887,
    978888,
    876988,
    988877,
    789887,
    679688,
    798777,
    678887,
    867778,
    798686,
    788888,
    978978,
    987789,
    677798,
    788887,
    899898,
    787999,
    687778,
    887989,
    888989,
    978789,
    878889,
    878877,
    778877,
    779888,
    768866,
    877777,
    777887,
    779779,
    869888,
    878797,
    969989,
    788888,
    887887,
    898888,
    879997,
    779977,
    979869,
    777878,
    876888,
    988878,
    978899,
    887698,
    878989,
    878878,
    797668,
    979888,
    887878,
    787888,
    798989,
    968788,
    697788,
    999868,
    977797,
    867889,
    767687,
    797887,
    877877,
    788788,
    988979,
    877878,
    887788,
    888699,
    778779,
    788767,
    776788,
    788979,
    798888,
    777888,
    776877,
    899987,
    878687,
    876897,
    889897,
    978777,
    987787,
    898986,
    688779,
    888887,
    877877,
    976788,
    897887,
    889998,
    987878,
    889988,
    877897,
    898898,
    889798,
    887888,
    999777,
    998897,
    889788,
    778988,
    778978,
    878978,
    877978,
    997988,
    789877,
    787696,
    888777,
    789997,
    887977,
    898979,
    878777,
    687988,
    687978,
    797878,
    886797,
    897788,
    889787,
    788976,
    877778,
    898789,
    878887,
    788888,
    688998,
    877789,
    977787,
    878699,
    788877,
    888888,
    888789,
    987878,
    977687,
    868888,
    887789,
    897768,
    687878,
    896988,
    888897,
    779867,
    999877,
    897768,
    778888,
    887878,
    988886,
    798999,
    789767,
    997987,
    977797,
    799978,
    677778,
    887898,
    788986,
    978898,
    877988,
    787788,
    877886,
    898878,
    968878,
    798767,
    879878,
    778898,
    877687,
    778778,
    897868,
    687799,
    787877,
    878898,
    787778,
    886997,
    878787,
    888897,
    888978,
    978887,
    886887,
    779877,
    888978,
    978867,
    978997,
    778788,
    987888,
    797897,
    767878,
    889887,
    878779,
    676887,
    878878,
    888978,
    979788,
    888688,
    668798,
    869787,
    797898,
    877878,
    877869,
    779889,
    778787,
    988867,
    776889,
    787776,
    788787,
    789887,
    898766,
    878777,
    789899,
    798888,
    778797,
    787997,
    796778,
    778896,
    678977,
    889698,
    898887,
    788778,
    878798,
    977876,
    997888,
    788788,
    667966,
    887877,
    897997,
    778887,
    778799,
    778998,
    876776,
    789769,
    679788,
    788787,
    878878,
    876889,
    787978,
    798879,
    999688,
    988798,
    889879,
    877868,
    798877,
    887867,
    868679,
    868988,
    887879,
    899879,
    896798,
    686887,
    877987,
    899878,
    877889,
    898977,
    777887,
    888677,
    779899,
    888876,
    988778,
    886877,
    888888,
    998799,
    778887,
    676889,
    669798,
    788787,
    798787,
    988799,
    876988,
    798879,
    886888,
    878878,
    778897,
    877978,
    778776,
    877999,
    888788,
    888687,
    888879,
    879888,
    888798,
    878887,
    888878,
    887779,
    798798,
    888778,
    898798,
    787687,
    788778,
    767869,
    888987,
    777779,
    896878,
    989979,
    999886,
    978878,
    787897,
    778878,
    688778,
    789878,
    978678,
    888987,
    878768,
    887889,
    788778,
    977797,
    877888,
    887778,
    777788,
    987897,
    997987,
    779688,
    787798,
    766877,
    778789,
    897888,
    886878,
    978987,
    888978,
    768798,
    887877,
    877786,
    897788,
    997668,
    678777,
    889977,
    789788,
    879886,
    778768,
    997778,
    887896,
    678897,
    788868,
    978987,
    977776,
    799888,
    887988,
    877688,
    867787,
    888788,
    866888,
    896988,
    888888,
    788788,
    987778,
    788898,
    879866,
    877987,
    988887,
    898777,
    887877,
    879879,
    777977,
    779899,
    887889,
    777987,
    777778,
    978777,
    978886,
    897899,
    769888,
    888677,
    987777,
    897779,
    778899,
    888678,
    988886,
    878789,
    898888,
    888887,
    978797,
    677888,
    888978,
    888797,
    777989,
    987797,
    779887,
    776788,
    788888,
    787786,
    789886,
    767788,
    977788,
    788779,
    878887,
    879798,
    789989,
    887977,
    869878,
    888887,
    787687,
    788888,
    887888,
    788788,
    987877,
    887978,
    869879,
    788888,
    987788,
    788877,
    787877,
    988669,
    898787,
    668899,
    797988,
    987978,
    988987,
    889888,
    987778,
    787896,
    888887,
    777878,
    889988,
    799778,
    888778,
    687798,
    797888,
    998778,
    878787,
    879899,
    788787,
    878988,
    899877,
    787798,
    899669,
    878988,
    879889,
    888779,
    777777,
    887787,
    887687,
    778799,
    889778,
    987798,
    987898,
    987788,
    888778,
    978778,
    878779,
    788787,
    888988,
    897777,
    887868,
    989888,
    777778,
    787778,
    788769,
    788688,
    778869,
    688777,
    887889,
    796787,
    868898,
    678697,
    788877,
    799788,
    887787,
    888997,
    888777,
    678777,
    868798,
    988878,
    887977,
    977888,
    878889,
    887778,
    878687,
    897888,
    778879,
    877878,
    987987,
    887788,
    789789,
    869786,
    879898,
    978786,
    789899,
    878888,
    889879,
    877878,
    999997,
    787868,
    988679,
    788799,
    887987,
    898799,
    887888,
    986798,
    979687,
    886987,
    888887,
    968888,
    787778,
    788879,
    877978,
    778887,
    777898,
    797777,
    698879,
    889877,
    876888,
    796787,
    967688,
    868888,
    978789,
    877988,
    689888,
    878879,
    897778,
    988686,
    898889,
    877887,
    888888,
    988788,
    978898,
    778797,
    878877,
    678878,
    867888,
    789898,
    767887,
    678787,
    888878,
    999868,
    988777,
    887777,
    888878,
    987879,
    787799,
    779798,
    998898,
    878778,
    798788,
    778878,
    787888,
    898888,
    767787,
    878877,
    887877,
    999899,
    788999,
    987887,
    988778,
    888997,
    888788,
    888877,
    898788,
    979887,
    878787,
    889888,
    989887,
    888888,
    778798,
    898799,
    997868,
    777778,
    877778,
    997889,
    787767,
    788788,
    978886,
    788679,
    688867,
    789687,
    868798,
    797879,
    698797,
    777778,
    769777,
    879779,
    687798,
    887779,
    799789,
    877779,
    987797,
    779767,
    987989,
    887898,
    789978,
    889976,
    997777,
    889897,
    988878,
    977896,
    797788,
    988767,
    897778,
    977887,
    988888,
    976797,
    888898,
    879978,
    878797,
    888798,
    888988,
    878879,
    788887,
    896888,
    787878,
    988877,
    787888,
    687788,
    788878,
    987887,
    899879,
    977679,
    887888,
    887878,
    777898,
    788987,
    877678,
    986889,
    978988,
    979879,
    888877,
    797879,
    989797,
    999798,
    889789,
    988788,
    988888,
    768787,
    777778,
    968888,
    689779,
    688776,
    896888,
    977888,
    889889,
    778877,
    898789,
    889886,
    887897,
    898977,
    978788,
    967899,
    968798,
    787878,
    888799,
    886889,
    778798,
    988787,
    777677,
    967987,
    767887,
    788888,
    999877,
    789978,
    888878,
    797987,
    898688,
    987888,
    877977,
    789879,
    787986,
    987978,
    977879,
    977987,
    988788,
    787777,
    777668,
    797977,
    898868,
    797976,
    868777,
    788677,
    889978,
    788878,
    977787,
    879779,
    778798,
    999787,
    867777,
    778788,
    987988,
    777778,
    878897,
    777967,
    989888,
    898877,
    779768,
    778999,
    987886,
    879679,
    988797,
    867779,
    778888,
    868987,
    788777,
    887897,
    879678,
    789879,
    988778,
    989997,
    876687,
    968878,
    878787,
    768788,
    797898,
    988889,
    888797,
    898788,
    878878,
    787878,
    979989,
    777878,
    786877,
    887877,
    789899,
    688898,
    889966,
    777777,
    897968,
    697777,
    878899,
    878887,
    876978,
    978777,
    869887,
    998878,
    787777,
    677768,
    777888,
    788799,
    778889,
    978998,
    997678,
    987878,
    788898,
    896796,
    797967,
    889888,
    998887,
    977778,
    888698,
    686797,
    778898,
    889878,
    997897,
    996888,
    997798,
    877877,
    798877,
    889788,
    787867,
    669997,
    788778,
    898997,
    779889,
    887979,
    879998,
    888889,
    888788,
    888778,
    788778,
    899788,
    786878,
    977698,
    778777,
    798998,
    978967,
    688878,
    997978,
    898888,
    777897,
    868778,
    979878,
    788768,
    867788,
    877788,
    878789,
    778877,
    968868,
    797679,
    877787,
    888887,
    988988,
    688888,
    878867,
    898698,
    878778,
    988988,
    889867,
    887988,
    788977,
    787888,
    777688,
    989987,
    987868,
    887889,
    888786,
    787878,
    877887,
    879968,
    788988,
    888888,
    898878,
    887889,
    878898,
    668787,
    778989,
    977779,
    986977,
    897787,
    988889,
    887997,
    788997,
    888887,
    897987,
    898889,
    988888,
    987888,
    889887,
    979778,
    777997,
    978787,
    977888,
    777899,
    796879,
    887686,
    978777,
    877777,
    879878,
    896788,
    779987,
    788668,
    876886,
    688888,
    978988,
    897887,
    788778,
    878888,
    799778,
    778888,
    689788,
    886887,
    869777,
    889998,
    877799,
    878698,
    877887,
    878688,
    877889,
    998788,
    778997,
    997888,
    888779,
    988888,
    977889,
    888897,
    879897,
    778877,
    988897,
    888997,
    879978,
    787789,
    889877,
    779877,
    887788,
    878877,
    777788,
    799978,
    787898,
    668777,
    989888,
    986789,
    777879,
    778778,
    777898,
    987998,
    978988,
    868877,
    888787,
    878989,
    797888,
    877887,
    697977,
    898987,
    778667,
    788796,
    877689,
    778798,
    888998,
    888888,
    787996,
    868889,
    866878,
    887779,
    888778,
    688979,
    887898,
    789877,
    688698,
    996686,
    797887,
    977897,
    879789,
    788786,
    778687,
    789988,
    867979,
    989878,
    788878,
    788687,
    788878,
    787878,
    698788,
    679866,
    788877,
    979688,
    887899,
    988978,
    799979,
    878888,
    768967,
    968989,
    779987,
    978868,
    878797,
    888967,
    988997,
    788687,
    887799,
    887777,
    999777,
    777888,
    796878,
    988796,
    877898,
    779887,
    788988,
    889788,
    878788,
    798998,
    998868,
    899778,
    877988,
    788788,
    898897,
    778768,
    987888,
    768879,
    887988,
    877877,
    998778,
    998888,
    988876,
    796788,
    788988,
    788888,
    879797,
    979988,
    998777,
    897788,
    887787,
    897897,
    988778,
    799988,
    697878,
    778969,
    887767,
    879798,
    777887,
    878786,
    889878,
    877797,
    997789,
    888889,
    888878,
    878777,
    997888,
    777786,
    889988,
    868888,
    878897,
    688889,
    766869,
    789999,
    789777,
    887787,
    779878,
    776878,
    968877,
    877876,
    878897,
    968878,
    877898,
    889988,
    877887,
    799889,
    977888,
    979877,
    677978,
    677777,
    987777,
    787887,
    686878,
    869798,
    798888,
    888888,
    778877,
    777897,
    897788,
    877777,
    888887,
    889878,
    777677,
    977777,
    978889,
    888788,
    788697,
    988798,
    789977,
    777788,
    986898,
    778898,
    888887,
    987899,
    888877,
    877797,
    878768,
    777877,
    887878,
    896988,
    898777,
    789789,
    797988,
    687997,
    798998,
    889888,
    797878,
    978788,
    997778,
    887898,
    887778,
    767788,
    789889,
    686876,
    988886,
    977678,
    798677,
    796688,
    868978,
    887868,
    899988,
    687778,
    888789,
    778777,
    788777,
    779789,
    878988,
    976888,
    888788,
    998687,
    898888,
    878778,
    988988,
    889788,
    879797,
    988987,
    767787,
    988898,
    988887,
    688888,
    998899,
    689887,
    786869,
    898779,
    996898,
    997978,
    878788,
    988677,
    877898,
    777879,
    678878,
    898699,
    879899,
    997878,
    897798,
    687797,
    977898,
    887987,
    887789,
    887899,
    868776,
    889988,
    868879,
    878876,
    878788,
    888867,
    787898,
    877897,
    798777,
    898898,
    978698,
    778779,
    898888,
    898888,
    877788,
    868977,
    879787,
    968888,
    687878,
    779987,
    888777,
    888788,
    888987,
    898888,
    978887,
    788679,
    667898,
    887897,
    988798,
    787879,
    877788,
    878797,
    777888,
    878889,
    867866,
    897888,
    888888,
    777766,
    889669,
    877976,
    887888,
    977788,
    796799,
    888977,
    687777,
    978787,
    779878,
    799878,
    889888,
    888887,
    968977,
    988877,
    887888,
    678988,
    799867,
    777988,
    877779,
    779878,
    889779,
    768797,
    789777,
    988897,
    878777,
    889979,
    788787,
    867677,
    898887,
    686897,
    888988,
    887887,
    778778,
    877887,
    889786,
    768979,
    679877,
    887888,
    796887,
    786988,
    787998,
    798888,
    878697,
    989777,
    768888,
    897779,
    797677,
    978968,
    998888,
    688788,
    887698,
    976799,
    997677,
    978888,
    997776,
    979987,
    977887,
    889788,
    987889,
    897998,
    887787,
    878898,
    797798,
    787968,
    789888,
    787897,
    888888,
    887887,
    868979,
    988778,
    686989,
    877878,
    877777,
    979778,
    898899,
    988887,
    868787,
    897897,
    877887,
    687988,
    887788,
    879868,
    888986,
    977789,
    988989,
    878988,
    987698,
    898789,
    888888,
    689887,
    899789,
    898787,
    888887,
    877798,
    897999,
    987789,
    878689,
    979779,
    978979,
    879789,
    787997,
    997777,
    879877,
    889688,
    888967,
    878889,
    887988,
    898987,
    888879,
    888988,
    678878,
    778788,
    878888,
    898977,
    877778,
    788678,
    887987,
    797898,
    887778,
    987798,
    888888,
    887787,
    978876,
    888787,
    888798,
    998879,
    898988,
    788679,
    988698,
    777979,
    798688,
    787889,
    888869,
    787797,
    787887,
    777686,
    767879,
    887899,
    678878,
    877678,
    877887,
    687889,
    898777,
    888877,
    898787,
    978688,
    799898,
    888687,
    987996,
    799878,
    687886,
    778879,
    998888,
    799877,
    878999,
    787887,
    997778,
    767769,
    889788,
    998897,
    888798,
    778777,
    787787,
    887877,
    877888,
    898796,
    797779,
    888768,
    797777,
    898888,
    888898,
    988988,
    968888,
    887698,
    968778,
    787888,
    978879,
    788698,
    979887,
    889778,
    787969,
    677798,
    999698,
    986886,
    987788,
    886887,
    797799,
    799787,
    886797,
    779877,
    988687,
    689889,
    788877,
    777787,
    789787,
    797699,
    789779,
    677887,
    877986,
    898688,
    788988,
    787977,
    898779,
    677878,
    897877,
    869898,
    888967,
    896889,
    887776,
    798889,
    686889,
    888888,
    778888,
    898678,
    987888,
    888887,
    887997,
    778877,
    987898,
    777996,
    776878,
    879988,
    897886,
    879678,
    877887,
    789879,
    976999,
    778688,
    779797,
    787878,
    786999,
    878887,
    989889,
    778787,
    887867,
    887688,
    766998,
    788977,
    997997,
    888888,
    777987,
    889777,
    778988,
    877777,
    778688,
    778789,
    879987,
    887777,
    979899,
    877898,
    688689,
    879877,
    897779,
    798876,
    898697,
    768878,
    787778,
    998788,
    888987,
    978688,
    988798,
    877897,
    987877,
    897788,
    988766,
    897899,
    798998,
    778877,
    987789,
    698788,
    787898,
    777878,
    988879,
    997688,
    877887,
    989688,
    778878,
    778897,
    889878,
    799779,
    888987,
    876788,
    788778,
    688898,
    988967,
    888999,
    888887,
    688968,
    999877,
    879788,
    788886,
    968768,
    898797,
    788778,
    999889,
    877878,
    878877,
    899798,
    988779,
    877986,
    988787,
    798797,
    988788,
    878988,
    797988,
    877888,
    778887,
    986996,
    888877,
    888986,
    887899,
    886877,
    879877,
    799987,
    699887,
    886868,
    887768,
    897878,
    888988,
    778877,
    799978,
    677879,
    997897,
    867777,
    788987,
    889866,
    878898,
    878888,
    778788,
    876797,
    879879,
    777778,
    787976,
    788796,
    878778,
    899777,
    788887,
    877977,
    877788,
    978898,
    899787,
    987877,
    887868,
    777878,
    987889,
    987886,
    779697,
    869979,
    778789,
    898889,
    988799,
    988796,
    867679,
    966677,
    898686,
    867788,
    798777,
    888777,
    878888,
    787897,
    876978,
    776868,
    887889,
    888898,
    989787,
    887887,
    679997,
    888878,
    889888,
    886887,
    887778,
    678777,
    888898,
    987898,
    878897,
    899977,
    777788,
    879868,
    988886,
    889887,
    788778,
    899788,
    787887,
    868999,
    788988,
    778767,
    687889,
    779788,
    888888,
    897869,
    698788,
    766888,
    886897,
    798969,
    979888,
    778767,
    887888,
    878997,
    788889,
    876778,
    888796,
    998879,
    879778,
    886887,
    788878,
    798897,
    989887,
    788888,
    868787,
    787998,
    689669,
    988889,
    878779,
    989888,
    779686,
    897888,
    868978,
    899977,
    877997,
    789986,
    899868,
    899889,
    788798,
    788997,
    876868,
    879899,
    687699,
    988798,
    878898,
    799888,
    798888,
    987899,
    877896,
    888877,
    788787,
    986987,
    898877,
    668877,
    886788,
    878897,
    689898,
    878799,
    978888,
    988889,
    887977,
    978888,
    979798,
    888776,
    898876,
    778988,
    978877,
    879988,
    777987,
    879879,
    887888,
    878878,
    789877,
    768777,
    986888,
    899877,
    889788,
    986977,
    998997,
    998766,
    788788,
    888968,
    677889,
    768897,
    798978,
    897879,
    787667,
    978778,
    888888,
    888788,
    867798,
    769776,
    797898,
    689888,
    987676,
    689988,
    797798,
    877688,
    789788,
    778687,
    787987,
    866989,
    767887,
    886777,
    986786,
    968786,
    878868,
    979977,
    787878,
    779897,
    788869,
    868887,
    887777,
    987888,
    867887,
    879988,
    788896,
    978888,
    889889,
    867899,
    788878,
    889998,
    889887,
    788897,
    887778,
    978998,
    789679,
    788988,
    887788,
    898778,
    778868,
    879798,
    878777,
    968899,
    997887,
    897689,
    698787,
    768898,
    786898,
    769898,
    799887,
    867779,
    977789,
    887998,
    779776,
    987989,
    867877,
    997869,
    897876,
    788779,
    888897,
    887787,
    889886,
    788997,
    886876,
    888888,
    978878,
    699787,
    788678,
    787777,
    886899,
    797778,
    877888,
    886999,
    988788,
    879788,
    977698,
    786878,
    878778,
    689877,
    798888,
    878888,
    879798,
    779787,
    889877,
    677889,
    968789,
    978889,
    998998,
    878898,
    887878,
    898897,
    777889,
    888888,
    887997,
    777998,
    888889,
    979877,
    979898,
    786787,
    778987,
    778878,
    866988,
    778879,
    778878,
    888779,
    877998,
    887797,
    877776,
    879877,
    898978,
    897888,
    899868,
    897899,
    788899,
    888878,
    886888,
    987867,
    768897,
    977777,
    987979,
    778798,
    777878,
    879867,
    798878,
    877799,
    987987,
    878778,
    888689,
    787898,
    867787,
    789877,
    888977,
    989788,
    899878,
    689878,
    779788,
    689788,
    879887,
    889898,
    878977,
    788988,
    899889,
    989888,
    797876,
    888778,
    788788,
    878898,
    879789,
    777878,
    887877,
    889988,
    688978,
    989788,
    787788,
    777878,
    889879,
    878678,
    888687,
    889788,
    797977,
    886787,
    787877,
    788787,
    798777,
    798787,
    778889,
    798688,
    877778,
    887778,
    888888,
    789788,
    788878,
    788676,
    878787,
    879987,
    987998,
    888688,
    887876,
    987898,
    779897,
    879968,
    888788,
    867977,
    779678,
    787789,
    898989,
    988887,
    988896,
    997797,
    897878,
    898886,
    888877,
    997689,
    788788,
    886797,
    888888,
    877988,
    798977,
    779877,
    787897,
    877778,
    788887,
    967868,
    799888,
    788779,
    989878,
    988879,
    888898,
    787888,
    899787,
    787867,
    888988,
    998878,
    989788,
    778898,
    777788,
    889878,
    877979,
    899977,
    798798,
    788876,
    878877,
    987898,
    866878,
    888787,
    879777,
    988898,
    878786,
    897877,
    777778,
    978798,
    988898,
    888989,
    777788,
    887778,
    788987,
    779898,
    688898,
    877877,
    977687,
    777778,
    879968,
    778977,
    988888,
    788989,
    988779,
    977989,
    778978,
    878868,
    787799,
    778987,
    899987,
    999788,
    887779,
    979898,
    977888,
    877988,
    798788,
    899888,
    798788,
    778998,
    867699,
    988788,
    779888,
    979879,
    788698,
    777777,
    789877,
    887799,
    779777,
    787799,
    678797,
    787869,
    767877,
    879988,
    969778,
    887997,
    996888,
    797979,
    778887,
    997897,
    999678,
    968689,
    787676,
    797988,
    789988,
    887988,
    889777,
    977687,
    987869,
    678887,
    788876,
    778888,
    889987,
    888787,
    778866,
    879788,
    878769,
    887788,
    777776,
    876798,
    866788,
    979877,
    779798,
    878777,
    888898,
    797768,
    878987,
    988878,
    888668,
    997797,
    898888,
    888987,
    767998,
    888877,
    879788,
    888877,
    899889,
    778689,
    888978,
    778987,
    878798,
    687877,
    877798,
    897888,
    979788,
    777686,
    788788,
    888778,
    977888,
    878777,
    897778,
    968888,
    786997,
    788887,
    787876,
    689698,
    778888,
    898988,
    798879,
    789879,
    877878,
    899889,
    887778,
    987976,
    778887,
    898879,
    978787,
    778988,
    877799,
    877898,
    679888,
    878886,
    786886,
    989767,
    777876,
    666688,
    878868,
    896789,
    896779,
    887877,
    989878,
    688878,
    776888,
    877788,
    888877,
    988988,
    688978,
    788787,
    879898,
    789877,
    878788,
    877889,
    878988,
    987977,
    778778,
    977877,
    988977,
    887788,
    887687,
    876768,
    869898,
    877787,
    998998,
    878877,
    778778,
    879799,
    779788,
    779998,
    799788,
    998698,
    789877,
    889797,
    867898,
    987789,
    979979,
    678888,
    888777,
    899798,
    997786,
    889886,
    887778,
    788888,
    789778,
    887777,
    777788,
    888897,
    978687,
    978878,
    897777,
    887766,
    778798,
    978879,
    789768,
    867978,
    878889,
    777897,
    799777,
    788877,
    788888,
    889879,
    778778,
    778888,
    888897,
    978887,
    898689,
    769888,
    867879,
    979688,
    988888,
    987989,
    778877,
    776778,
    977898,
    897789,
    778887,
    877888,
    888776,
    978779,
    788789,
    877888,
    898989,
    888877,
    688877,
    886788,
    887688,
    789886,
    877788,
    778877,
    887798,
    678978,
    887868,
    798689,
    776988,
    688978,
    888799,
    877888,
    777777,
    878987,
    997796,
    879878,
    788877,
    788789,
    978977,
    888878,
    777789,
    878887,
    877977,
    978888,
    776789,
    887786,
    769778,
    997988,
    997778,
    776897,
    788877,
    888888,
    977878,
    877797,
    897698,
    787778,
    888898,
    989878,
    788678,
    967888,
    996988,
    888778,
    787899,
    879798,
    788888,
    878896,
    788887,
    978888,
    978997,
    878678,
    868797,
    888897,
    787887,
    778788,
    888998,
    779887,
    888777,
    796769,
    789867,
    779788,
    978777,
    768778,
    798889,
    888978,
    798779,
    777779,
    978789,
    898897,
    989977,
    988787,
    797877,
    797868,
    768889,
    879678,
    996878,
    887988,
    867778,
    878979,
    887888,
    889888,
    888986,
    877678,
    787868,
    778887,
    889788,
    989786,
    778898,
    888777,
    878899,
    877889,
    778796,
    799788,
    997889,
    777778,
    989977,
    878899,
    978787,
    889879,
    888788,
    888787,
    777888,
    997789,
    879696,
    797877,
    767798,
    968797,
    988897,
    797779,
    878898,
    997987,
    687899,
    678878,
    798988,
    878768,
    989868,
    977798,
    768997,
    877887,
    887886,
    977997,
    888777,
    979898,
    888787,
    888998,
    778787,
    888787,
    778877,
    878877,
    777787,
    877879,
    799778,
    978877,
    888699,
    886867,
    897978,
    799887,
    879779,
    898878,
    878969,
    978889,
    897887,
    979776,
    878978,
    878989,
    778879,
    777887,
    878979,
    896788,
    877877,
    877788,
    878867,
    897978,
    768688,
    766987,
    778869,
    879779,
    876888,
    978779,
    796877,
    887678,
    788987,
    876889,
    787997,
    876889,
    877797,
    888687,
    979888,
    679789,
    888878,
    788869,
    687968,
    788779,
    786868,
    878877,
    877687,
    688788,
    898897,
    778788,
    779786,
    888989,
    987888,
    888787,
    788768,
    778889,
    788877,
    779897,
    898777,
    697798,
    877787,
    777868,
    877898,
    787788,
    798887,
    888988,
    778797,
    688787,
    777878,
    778987,
    888878,
    878897,
    777889,
    787877,
    788777,
    788788,
    886879,
    879979,
    776987,
    787886,
    889877,
    786868,
    977797,
    789888,
    888889,
    777788,
    668887,
    877799,
    799786,
    987869,
    998776,
    887788,
    776898,
    778778,
    778878,
    987888,
    788798,
    798879,
    888788,
    677677,
    777878,
    887999,
    697787,
    887788,
    878888,
    878777,
    897779,
    987878,
    787688,
    798788,
    979889,
    888988,
    998786,
    787778,
    879798,
    888868,
    878977,
    787787,
    788798,
    678887,
    897877,
    797789,
    797778,
    788887,
    778798,
    997677,
    888997,
    798987,
    898798,
    899979,
    878878,
    898888,
    888788,
    888789,
    778978,
    999878,
    878887,
    977989,
    987977,
    878988,
    778999,
    877777,
    787898,
    787876,
    887889,
    887898,
    877879,
    877899,
    987778,
    897897,
    789899,
    898889,
    888988,
    998988,
    888887,
    897887,
    888887,
    988778,
    998988,
    888788,
    979888,
    988788,
    898777,
    677988,
    689788,
    787987,
    779777,
    876977,
    978868,
    867897,
    889789,
    777897,
    887798,
    876687,
    888878,
    777778,
    887898,
    867777,
    889987,
    788797,
    886877,
    878887,
    987777,
    786687,
    898867,
    898989,
    898886,
    787989,
    979898,
    898787,
    888797,
    779788,
    788896,
    888879,
    878997,
    777688,
    878988,
    887877,
    678879,
    987888,
    878787,
    898778,
    897787,
    898798,
    788779,
    897898,
    778997,
    979778,
    898688,
    767777,
    887887,
    998777,
    798988,
    867778,
    999898,
    898898,
    977787,
    888879,
    977787,
    996877,
    878779,
    888888,
    978889,
    799977,
    769899,
    778788,
    898768,
    978887,
    677899,
    788788,
    896777,
    988988,
    878787,
    978977,
    877879,
    897798,
    987777,
    877778,
    869787,
    887777,
    677797,
    689977,
    688678,
    897777,
    797789,
    788978,
    798998,
    878777,
    888878,
    667897,
    789798,
    767888,
    869887,
    788688,
    868878,
    877978,
    968988,
    988989,
    888989,
    898979,
    888778,
    788787,
    887898,
    887988,
    989976,
    999787,
    878978,
    778877,
    787787,
    977786,
    888887,
    897877,
    989879,
    977878,
    788988,
    797687,
    888777,
    788878,
    888786,
    868887,
    979898,
    888787,
    787988,
    898967,
    866777,
    769788,
    877878,
    896789,
    988778,
    778789,
    788897,
    777768,
    786998,
    797999,
    876998,
    877868,
    777878,
    798778,
    887888,
    799769,
    888778,
    988987,
    879696,
    699678,
    788989,
    976888,
    997887,
    887878,
    888888,
    887788,
    898997,
    777988,
    888887,
    888877,
    787878,
    998787,
    878988,
    777978,
    768777,
    877977,
    896887,
    967878,
    897978,
    877899,
    788868,
    888667,
    898997,
    778998,
    788688,
    977899,
    978887,
    878987,
    979877,
    876788,
    787989,
    777797,
    887888,
    988987,
    979986,
    886878,
    978678,
    877789,
    987879,
    797887,
    687879,
    887898,
    878888,
    878878,
    789988,
    989997,
    779887,
    797887,
    888777,
    989877,
    887978,
    997977,
    788888,
    979886,
    777979,
    897998,
    888887,
    999998,
    788768,
    977878,
    887798,
    777797,
    789987,
    868897,
    868788,
    888787,
    788888,
    779778,
    996898,
    786698,
    897667,
    898778,
    888788,
    798787,
    987788,
    879786,
    898889,
    797977,
    788788,
    779987,
    887978,
    887886,
    887878,
    687878,
    868967,
    887889,
    888888,
    797777,
    898979,
    776988,
    878777,
    778877,
    688879,
    787689,
    887789,
    699979,
    877797,
    896987,
    987878,
    888787,
    668787,
    887998,
    868997,
    786778,
    898879,
    767768,
    677878,
    788888,
    877788,
    879977,
    898899,
    689788,
    866779,
    697867,
    799788,
    797968,
    776987,
    886986,
    789889,
    977779,
    887989,
    998887,
    779888,
    898898,
    976878,
    768679,
    978888,
    787978,
    869888,
    869788,
    788997,
    877788,
    997787,
    898687,
    787976,
    897768,
    986888,
    789798,
    768888,
    779978,
    997988,
    877977,
    887887,
    879887,
    996787,
    778897,
    788897,
    778798,
    778979,
    887898,
    878978,
    777867,
    879877,
    879879,
    997878,
    798877,
    789866,
    896787,
    787798,
    888697,
    898777,
    768976,
    967787,
    789988,
    788769,
    868889,
    699788,
    888889,
    868868,
    889788,
    868878,
    877788,
    798898,
    797978,
    978778,
    988888,
    889998,
    978987,
    879889,
    878987,
    989789,
    789796,
    888787,
    789987,
    788978,
    988798,
    787799,
    688888,
    898978,
    788777,
    898798,
    978867,
    977897,
    988877,
    787867,
    878976,
    778867,
    687687,
    899898,
    798878,
    787989,
    978799,
    998888,
    987788,
    889988,
    867788,
    978787,
    779889,
    888888,
    786978,
    878789,
    876888,
    767778,
    878867,
    777998,
    986989,
    898988,
    778877,
    889887,
    978888,
    976997,
    977788,
    767887,
    877778,
    889777,
    968887,
    787887,
    778779,
    798978,
    788878,
    989878,
    878779,
    788788,
    776888,
    778688,
    787778,
    988998,
    879877,
    889798,
    688978,
    988888,
    877779,
    779778,
    787689,
    889797,
    777988,
    978788,
    688877,
    889797,
    789868,
    878877,
    788999,
    699889,
    978789,
    876877,
    897798,
    988797,
    789687,
    878898,
    777878,
    789797,
    777698,
    768887,
    888666,
    997888,
    898868,
    778789,
    886889,
    877986,
    889798,
    778897,
    767988,
    876878,
    888887,
    978787,
    778787,
    786788,
    979988,
    997898,
    988886,
    799997,
    889888,
    789988,
    887877,
    989877,
    888789,
    978987,
    998786,
    889768,
    788878,
    768978,
    888788,
    898967,
    786777,
    789879,
    997897,
    799698,
    978698,
    798787,
    779877,
    888889,
    878896,
    888888,
    876778,
    879879,
    898876,
    897878,
    889897,
    987888,
    797786,
    677787,
    898989,
    788777,
    987767,
    997987,
    888688,
    679899,
    989687,
    998778,
    978697,
    878788,
    767978,
    686779,
    788989,
    778788,
    889888,
    888988,
    888678,
    799868,
    986878,
    878778,
    898888,
    788978,
    978887,
    987888,
    898788,
    879988,
    878889,
    878788,
    776769,
    977797,
    879779,
    878766,
    979888,
    868868,
    888777,
    779888,
    789878,
    868877,
    978886,
    866877,
    778776,
    689868,
    987979,
    989888,
    778976,
    887987,
    688778,
    778789,
    878897,
    999799,
    768877,
    879969,
    879798,
    979788,
    879778,
    798889,
    888977,
    788787,
    877677,
    778889,
    677887,
    878889,
    699789,
    887987,
    888887,
    798878,
    688798,
    768798,
    778878,
    998878,
    879989,
    988998,
    988798,
    789888,
    987777,
    889689,
    887888,
    798789,
    788878,
    886878,
    788686,
    997888,
    888988,
    788887,
    889888,
    888888,
    897797,
    888888,
    787887,
    878898,
    798876,
    779888,
    788877,
    987788,
    878768,
    878988,
    777796,
    798888,
    778788,
    988788,
    777777,
    878777,
    977798,
    997788,
    988879,
    887887,
    697788,
    886879,
    869779,
    886787,
    887877,
    898776,
    987787,
    798788,
    898787,
    789989,
    797888,
    886877,
    897778,
    997887,
    799889,
    889779,
    979898,
    998787,
    697888,
    977876,
    986768,
    767888,
    897887,
    977886,
    997966,
    786878,
    788789,
    987988,
    777887,
    898887,
    778976,
    687788,
    778887,
    978887,
    787778,
    889887,
    887887,
    798786,
    778896,
    768788,
    977878,
    689689,
    888878,
    888687,
    797887,
    879879,
    997898,
    888898,
    997876,
    779889,
    878687,
    987879,
    787887,
    778879,
    898697,
    886777,
    777877,
    799787,
    888878,
    879687,
    877789,
    679787,
    887697,
    989877,
    779868,
    888688,
    687889,
    887778,
    787889,
    799996,
    987778,
    886887,
    777988,
    988968,
    779888,
    976889,
    789998,
    777987,
    867867,
    787777,
    788788,
    789988,
    798978,
    888877,
    888887,
    897778,
    897877,
    878688,
    987778,
    789787,
    997877,
    889797,
    989777,
    987979,
    888989,
    979967,
    787889,
    889777,
    888899,
    899896,
    899677,
    767886,
    788979,
    788777,
    988797,
    768787,
    878779,
    798978,
    887798,
    778889,
    968988,
    788897,
    978788,
    887779,
    887786,
    897877,
    788789,
    787879,
    889788,
    977788,
    767976,
    788978,
    678688,
    898787,
    878977,
    988998,
    777689,
    887878,
    778798,
    789998,
    887798,
    778897,
    879798,
    878868,
    777789,
    886888,
    777789,
    877899,
    788778,
    789678,
    689699,
    877767,
    879888,
    789878,
    689677,
    799877,
    979988,
    989779,
    679887,
    787887,
    888887,
    899878,
    778669,
    777778,
    779887,
    888889,
    789686,
    888777,
    777868,
    887988,
    798898,
    977886,
    888888,
    869667,
    888788,
    977887,
    878776,
    777778,
    877968,
    788869,
    687698,
    989888,
    878978,
    789887,
    996896,
    678886,
    887688,
    679889,
    776878,
    786879,
    788788,
    778987,
    879778,
    787778,
    777997,
    797988,
    886878,
    789777,
    989886,
    688878,
    897897,
    897788,
    798787,
    778767,
    866778,
    878799,
    698868,
    879876,
    788978,
    898897,
    877877,
    797788,
    977878,
    797789,
    988787,
    688878,
    869898,
    988879,
    998889,
    898777,
    877997,
    886789,
    898887,
    888898,
    897898,
    998878,
    777777,
    798886,
    877888,
    879768,
    978887,
    887887,
    778967,
    888888,
    798987,
    988888,
    997897,
    767899,
    787798,
    779889,
    886896,
    888797,
    778878,
    787777,
    897779,
    878887,
    869897,
    887878,
    887798,
    897679,
    798866,
    878878,
    898687,
    778778,
    778789,
    888888,
    979888,
    889888,
    788769,
    798778,
    879888,
    787777,
    898998,
    989699,
    777898,
    779979,
    877798,
    667878,
    799778,
    978698,
    869778,
    887786,
    878898,
    788877,
    877878,
    898978,
    779878,
    987787,
    778788,
    888888,
    889997,
    888878,
    788888,
    796786,
    887879,
    788887,
    777688,
    877787,
    678798,
    878877,
    879788,
    987687,
    988887,
    998779,
    988968,
    988887,
    777789,
    789787,
    888787,
    777897,
    996797,
    878787,
    778879,
    989887,
    886768,
    987898,
    977897,
    988778,
    798888,
    977898,
    788877,
    978878,
    888978,
    878789,
    987887,
    998798,
    987988,
    888788,
    879878,
    986788,
    889878,
    998888,
    768786,
    797787,
    888788,
    688879,
    878876,
    868876,
    987768,
    888687,
    889787,
    778788,
    888877,
    779897,
    998798,
    868898,
    898777,
    778779,
    788789,
    987699,
    898888,
    878779,
    997888,
    898897,
    778799,
    997897,
    899699,
    768887,
    778799,
    889869,
    968677,
    967799,
    878787,
    997777,
    788889,
    897688,
    687879,
    788877,
    888887,
    898898,
    889999,
    887789,
    778797,
    877968,
    898888,
    898897,
    877899,
    977697,
    776899,
    779899,
    968877,
    788877,
    999778,
    878778,
    888787,
    888887,
    787677,
    699868,
    788889,
    878998,
    986777,
    878798,
    778877,
    877778,
    987899,
    787766,
    788888,
    878867,
    889778,
    768988,
    898887,
    798989,
    987769,
    788987,
    988776,
    789889,
    787878,
    877897,
    787776,
    887789,
    989976,
    899877,
    889677,
    797888,
    868878,
    868888,
    678878,
    977877,
    876679,
    989888,
    867787,
    677886,
    888977,
    778887,
    776887,
    889778,
    987769,
    787778,
    868677,
    988898,
    778679,
    886968,
    777887,
    878879,
    967878,
    878887,
    778996,
    787978,
    788779,
    789897,
    889998,
    798978,
    787876,
    867777,
    778699,
    888896,
    878866,
    787888,
    677898,
    988978,
    987779,
    988989,
    987896,
    777688,
    878876,
    778788,
    887968,
    898898,
    778797,
    797897,
    888878,
    777987,
    787788,
    779887,
    888787,
    677898,
    897776,
    776789,
    768788,
    987888,
    698998,
    877779,
    788797,
    797887,
    878798,
    787998,
    888779,
    688788,
    789897,
    788776,
    887796,
    988978,
    987878,
    676978,
    979796,
    687878,
    879977,
    668879,
    868788,
    787886,
    977877,
    899789,
    787868,
    878967,
    786788,
    877768,
    879989,
    778788,
    799787,
    887977,
    797988,
    798788,
    889887,
    867898,
    877678,
    968878,
    698988,
    888977,
    779898,
    788869,
    976797,
    787996,
    787889,
    766889,
    888998,
    766878,
    788887,
    788779,
    869787,
    888978,
    788887,
    787887,
    799969,
    778688,
    869898,
    788798,
    797867,
    888898,
    877676,
    988998,
    778789,
    878998,
    879877,
    788778,
    988789,
    778888,
    778896,
    787897,
    867998,
    887788,
    798887,
    997787,
    879877,
    767999,
    798778,
    788888,
    696678,
    899877,
    779889,
    877889,
    887789,
    988777,
    788778,
    778778,
    889787,
    887678,
    888888,
    878878,
    988798,
    887777,
    989887,
    879787,
    797677,
    689789,
    788799,
    879877,
    879877,
    786877,
    898877,
    798888,
    988977,
    787888,
    789989,
    897998,
    887988,
    878788,
    787979,
    888987,
    787888,
    899789,
    888788,
    887977,
    768878,
    878887,
    778987,
    967778,
    897787,
    978787,
    789788,
    777878,
    888888,
    888898,
    979989,
    778877,
    888779,
    988787,
    878897,
    888778,
    687869,
    778987,
    788677,
    788988,
    977878,
    887688,
    787899,
    887889,
    777778,
    778978,
    889798,
    898797,
    899788,
    987789,
    888788,
    987877,
    798688,
    899897,
    988689,
    879877,
    687887,
    988789,
    788878,
    689788,
    777878,
    888978,
    877677,
    879898,
    779887,
    988899,
    778897,
    689789,
    779878,
    878788,
    977988,
    779697,
    886879,
    998787,
    779987,
    689879,
    788877,
    878798,
    788787,
    787878,
    986687,
    788886,
    696978,
    878978,
    888877,
    777968,
    878878,
    888787,
    799777,
    788889,
    896788,
    887887,
    778678,
    879977,
    889996,
    877767,
    686878,
    767997,
    888987,
    688777,
    798797,
    977889,
    798788,
    688788,
    879778,
    986786,
    688677,
    789988,
    887898,
    887868,
    778798,
    897778,
    968788,
    799886,
    799876,
    878787,
    778889,
    977868,
    889999,
    799988,
    777886,
    978798,
    987877,
    988988,
    897887,
    698899,
    978878,
    878797,
    888789,
    876778,
    768799,
    877887,
    868887,
    698989,
    878879,
    888987,
    778978,
    887797,
    887889,
    888877,
    768768,
    977988,
    869787,
    887789,
    787978,
    788977,
    999988,
    688779,
    888788,
    697976,
    667997,
    887788,
    978778,
    788977,
    887898,
    888988,
    779889,
    778898,
    877897,
    878778,
    787798,
    787788,
    898787,
    987698,
    787997,
    888797,
    677877,
    798799,
    879788,
    787797,
    778788,
    677779,
    867888,
    988797,
    778789,
    888887,
    978779,
    888797,
    766978,
    878878,
    899687,
    799888,
    798778,
    877788,
    887789,
    887897,
    797778,
    778878,
    889876,
    778788,
    688797,
    789988,
    778768,
    887789,
    886797,
    876798,
    787789,
    978778,
    889898,
    878788,
    889797,
    787978,
    788788,
    779789,
    778787,
    969879,
    787778,
    988977,
    878698,
    888888,
    988878,
    886789,
    888888,
    698888,
    776887,
    888898,
    988779,
    997767,
    986979,
    976887,
    788787,
    868877,
    878998,
    777877,
    888679,
    887797,
    889887,
    899977,
    978767,
    877879,
    779687,
    978888,
    877889,
    877787,
    788967,
    787777,
    887767,
    888888,
    879887,
    787968,
    787878,
    889787,
    788897,
    989978,
    777879,
    779797,
    886897,
    768988,
    887987,
    888888,
    778878,
    977779,
    986887,
    788698,
    878898,
    997878,
    889777,
    789786,
    977786,
    987888,
    878897,
    877998,
    778879,
    769797,
    788868,
    878689,
    878667,
    868798,
    777787,
    887688,
    889888,
    878887,
    977988,
    879986,
    777978,
    986878,
    887899,
    888978,
    789779,
    789887,
    987677,
    779898,
    788889,
    888897,
    876888,
    888788,
    888767,
    777788,
    797897,
    869888,
    887977,
    797987,
    987888,
    976886,
    898877,
    869878,
    887968,
    787979,
    879997,
    778888,
    887778,
    888867,
    879798,
    887988,
    778796,
    778778,
    777878,
    888788,
    877797,
    789779,
    998669,
    888796,
    778866,
    898877,
    868887,
    787897,
    778788,
    786987,
    997887,
    799677,
    867778,
    879788,
    778887,
    776899,
    989897,
    688898,
    799898,
    988787,
    798778,
    878796,
    898787,
    799977,
    878898,
    878688,
    779898,
    687888,
    978978,
    787877,
    887779,
    887787,
    977887,
    678879,
    889798,
    799787,
    777997,
    778888,
    888786,
    777877,
    796689,
    878997,
    879878,
    868798,
    877999,
    897869,
    779887,
    897778,
    787668,
    787878,
    987988,
    788787,
    988888,
    886986,
    787878,
    878877,
    676787,
    888977,
    698787,
    876879,
    688777,
    789789,
    878897,
    887797,
    897799,
    868787,
    677888,
    799978,
    767788,
    979797,
    788977,
    798977,
    779887,
    888998,
    877867,
    878988,
    768878,
    889978,
    799988,
    896799,
    768978,
    877888,
    778897,
    777779,
    867899,
    777876,
    767796,
    768778,
    698878,
    978787,
    687877,
    788997,
    987898,
    976888,
    977887,
    899778,
    787887,
    787798,
    978999,
    898797,
    778878,
    878887,
    877668,
    997889,
    797898,
    988878,
    887887,
    878988,
    787888,
    778988,
    779887,
    777887,
    987876,
    987778,
    676787,
    888988,
    778778,
    768788,
    776878,
    878777,
    767888,
    789987,
    778898,
    977677,
    998978,
    888688,
    889798,
    989877,
    887987,
    887887,
    676798,
    887888,
    988897,
    898988,
    788778,
    678798,
    869987,
    787788,
    988777,
    777878,
    997788,
    789897,
    868986,
    887887,
    897887,
    977787,
    888888,
    988887,
    878889,
    777888,
    768889,
    896899,
    877898,
    898897,
    876998,
    879888,
    888797,
    887677,
    877767,
    977787,
    768698,
    876689,
    978898,
    888777,
    878876,
    887888,
    777888,
    978869,
    677878,
    788796,
    888777,
    799897,
    777888,
    888888,
    788877,
    998677,
    888888,
    778776,
    988988,
    789768,
    778877,
    867988,
    689779,
    877868,
    998887,
    896878,
    997767,
    777867,
    887896,
    989889,
    978778,
    897768,
    788988,
    977889,
    986898,
    797899,
    987888,
    877989,
    677797,
    879698,
    969898,
    897988,
    998889,
    997976,
    878698,
    788877,
    968887,
    678979,
    788898,
    777988,
    898879,
    977897,
    977887,
    889977,
    866998,
    989789,
    878887,
    998686,
    998898,
    777977,
    788887,
    886978,
    978797,
    879899,
    888879,
    878678,
    997788,
    778887,
    779799,
    898797,
    877867,
    797898,
    788897,
    888978,
    898877,
    898888,
    887889,
    988867,
    878878,
    787977,
    778788,
    889768,
    797788,
    898966,
    978798,
    888887,
    878889,
    998989,
    986977,
    988876,
    778878,
    968968,
    978788,
    978887,
    778677,
    867887,
    787887,
    687888,
    978977,
    886887,
    787777,
    887897,
    666689,
    978777,
    977898,
    778797,
    688797,
    867787,
    899687,
    798877,
    779987,
    868978,
    788776,
    787988,
    996878,
    997878,
    887877,
    887886,
    787877,
    777798,
    869877,
    987688,
    879889,
    787799,
    778998,
    797887,
    996887,
    878986,
    797788,
    887889,
    689977,
    979789,
    788887,
    988878,
    998887,
    878898,
    888677,
    889888,
    878778,
    888777,
    988987,
    888888,
    888898,
    988879,
    887988,
    789788,
    997887,
    988878,
    779866,
    868686,
    967766,
    788787,
    788889,
    877778,
    888789,
    978886,
    789879,
    978788,
    978689,
    798878,
    878876,
    778998,
    888888,
    897877,
    877889,
    889797,
    787778,
    879778,
    967999,
    677788,
    777786,
    787988,
    877787,
    888878,
    797989,
    678989,
    888887,
    989888,
    978778,
    778897,
    888788,
    997878,
    896678,
    888777,
    697697,
    987988,
    976878,
    877878,
    877777,
    778778,
    879987,
    878888,
    977967,
    888698,
    777868,
    897778,
    876887,
    687777,
    778897,
    887787,
    987777,
    789866,
    898978,
    999788,
    897897,
    977877,
    888779,
    898778,
    868989,
    977799,
    888888,
    797799,
    788767,
    978877,
    798978,
    897777,
    879887,
    877786,
    879877,
    687878,
    877769,
    787968,
    988887,
    788978,
    787886,
    998688,
    897778,
    976878,
    889887,
    778888,
    799988,
    998898,
    798777,
    798779,
    887987,
    887887,
    777667,
    788789,
    877769,
    798879,
    798798,
    878879,
    777699,
    789668,
    898877,
    898788,
    888879,
    879967,
    988779,
    678887,
    888877,
    986879,
    898878,
    997899,
    676889,
    999888,
    778977,
    987887,
    988678,
    897998,
    897998,
    788978,
    698787,
    799889,
    998898,
    687688,
    687789,
    797799,
    879879,
    877798,
    868887,
    987887,
    989889,
    899778,
    898887,
    879878,
    898888,
    877976,
    899877,
    678999,
    788888,
    978888,
    877978,
    689897,
    889988,
    977788,
    877869,
    888798,
    887797,
    798887,
    886867,
    877888,
    877778,
    788797,
    877898,
    898778,
    777799,
    767878,
    987799,
    777776,
    888787,
    977899,
    788977,
    778887,
    888798,
    788898,
    888977,
    887887,
    888689,
    787887,
    897897,
    868897,
    798896,
    878688,
    978878,
    887798,
    777888,
    898786,
    688887,
    867768,
    888978,
    799878,
    889878,
    987768,
    788798,
    998888,
    976888,
    878979,
    787778,
    986887,
    989968,
    769877,
    688998,
    777777,
    788877,
    788788,
    777898,
    878887,
    878797,
    876797,
    898978,
    968888,
    967876,
    877898,
    788877,
    868889,
    778869,
    978897,
    877878,
    876797,
    998798,
    978789,
    887987,
    998799,
    878889,
    777987,
    788979,
    797888,
    868978,
    898798,
    788988,
    777897,
    997688,
    886888,
    978779,
    788988,
    788799,
    879898,
    777687,
    798967,
    999878,
    788888,
    788768,
    778979,
    877898,
    678878,
    887988,
    789889,
    898878,
    689889,
    888788,
    697898,
    878788,
    788797,
    776787,
    788888,
    688689,
    787979,
    889787,
    888778,
    969889,
    787788,
    988677,
    889878,
    879778,
    778977,
    889887,
    987797,
    888877,
    876897,
    877869,
    988978,
    876888,
    887977,
    997878,
    889788,
    868889,
    889887,
    789888,
    778876,
    876878,
    977887,
    788997,
    878778,
    887999,
    898889,
    788877,
    778678,
    888877,
    889677,
    688989,
    788897,
    788887,
    866777,
    988888,
    899777,
    887787,
    799788,
    786777,
    776998,
    879887,
    787667,
    878897,
    988887,
    797887,
    788988,
    786787,
    677879,
    988878,
    998767,
    897888,
    787877,
    789898,
    887887,
    876998,
    887898,
    776768,
    988998,
    676889,
    798899,
    886788,
    787798,
    797798,
    888878,
    987778,
    888988,
    898879,
    798897,
    677788,
    989999,
    978787,
    777888,
    668877,
    978786,
    778887,
    998799,
    867887,
    977877,
    777787,
    688798,
    789879,
    787877,
    767779,
    997888,
    888899,
    886778,
    877977,
    768787,
    788898,
    898778,
    788787,
    998896,
    888788,
    986887,
    889888,
    877888,
    887976,
    777888,
    797988,
    887787,
    898789,
    988888,
    789877,
    886877,
    976977,
    789977,
    687779,
    769986,
    778687,
    887898,
    888878,
    879878,
    787977,
    869787,
    999788,
    988797,
    678989,
    668778,
    787879,
    877697,
    788677,
    877878,
    879867,
    897978,
    978868,
    888978,
    998866,
    998896,
    797888,
    988778,
    897777,
    797677,
    987978,
    778997,
    877787,
    897767,
    876788,
    777878,
    878997,
    777977,
    787797,
    789798,
    768987,
    889879,
    888788,
    998967,
    887988,
    878887,
    877896,
    779798,
    988979,
    866777,
    879788,
    799778,
    877778,
    899986,
    876888,
    788887,
    798896,
    889779,
    787889,
    888797,
    688887,
    697897,
    977888,
    789778,
    979878,
    788787,
    789798,
    897796,
    778777,
    878968,
    977799,
    778887,
    978898,
    987668,
    877887,
    877977,
    888688,
    888777,
    869769,
    777887,
    788877,
    687887,
    888777,
    877777,
    879997,
    789788,
    867887,
    677889,
    797889,
    778989,
    876978,
    987878,
    898988,
    878978,
    788878,
    877788,
    768778,
    698887,
    798788,
    996878,
    667877,
    879887,
    887788,
    798886,
    878888,
    687888,
    989999,
    998778,
    678899,
    886986,
    787778,
    896876,
    797887,
    978789,
    888877,
    888798,
    787986,
    779887,
    867799,
    888887,
    876787,
    877778,
    777899,
    778777,
    888687,
    879878,
    898778,
    876787,
    779679,
    887897,
    797878,
    878787,
    779867,
    787888,
    769778,
    786898,
    887777,
    887797,
    878888,
    778897,
    667996,
    978967,
    888888,
    889879,
    988788,
    777787,
    797687,
    779986,
    777997,
    997878,
    998899,
    899888,
    878987,
    777869,
    987788,
    899888,
    788796,
    887689,
    887979,
    877978,
    787887,
    778868,
    888979,
    888786,
    889988,
    698687,
    789989,
    888797,
    788997,
    796978,
    778799,
    887877,
    887899,
    997987,
    878797,
    799698,
    878778,
    887898,
    978898,
    797877,
    898898,
    677889,
    889687,
    877878,
    887887,
    977898,
    778798,
    767787,
    898989,
    898797,
    987889,
    878887,
    887788,
    696978,
    786779,
    887787,
    977789,
    877778,
    777797,
    879787,
    778879,
    878897,
    877888,
    898878,
    879799,
    979788,
    697898,
    977897,
    899979,
    868788,
    698989,
    799697,
    878778,
    788789,
    998899,
    979789,
    877878,
    889688,
    879788,
    888787,
    896898,
    986888,
    789697,
    796989,
    878798,
    768867,
    879769,
    889998,
    777978,
    888888,
    887898,
    877779,
    798878,
    687887,
    787777,
    979767,
    877888,
    998878,
    778988,
    888787,
    887897,
    878987,
    989987,
    787979,
    888987,
    977787,
    988877,
    898876,
    787777,
    979888,
    767778,
    767667,
    789897,
    697989,
    976889,
    987897,
    889886,
    888878,
    989778,
    687779,
    886877,
    778778,
    679788,
    797899,
    778779,
    888878,
    888878,
    789888,
    877878,
    787978,
    787786,
    978789,
    877898,
    777788,
    887887,
    888888,
    778899,
    878797,
    987877,
    778987,
    898878,
    777769,
    977788,
    877887,
    877889,
    998778,
    988696,
    887987,
    889898,
    889786,
    997977,
    877678,
    877887,
    888777,
    779968,
    797987,
    987878,
    888778,
    877899,
    799888,
    798778,
    988686,
    977767,
    788888,
    777998,
    787888,
    898876,
    778989,
    688797,
    899686,
    769798,
    877689,
    787676,
    879689,
    877769,
    886877,
    789889,
    897887,
    878777,
    887877,
    877889,
    987778,
    787988,
    878989,
    877767,
    968978,
    777898,
    788888,
    867787,
    688789,
    788688,
    778778,
    887888,
    989779,
    779887,
    688967,
    887878,
    898788,
    888788,
    788787,
    877687,
    687887,
    787776,
    789788,
    968888,
    979878,
    977778,
    989886,
    878888,
    978898,
    688877,
    779888,
    799777,
    987779,
    687976,
    988789,
    878986,
    887887,
    878877,
    887776,
    877786,
    978888,
    778878,
    779987,
    978978,
    888978,
    978777,
    688877,
    899996,
    888899,
    778896,
    777968,
    796887,
    877987,
    797979,
    888887,
    886878,
    777797,
    888878,
    888888,
    788998,
    688887,
    988899,
    879889,
    887787,
    887788,
    898688,
    678968,
    877987,
    888888,
    978789,
    898987,
    997978,
    868887,
    888777,
    888878,
    788899,
    897678,
    789878,
    978698,
    799887,
    877878,
    887887,
    878797,
    876889,
    978869,
    887887,
    778778,
    778888,
    978887,
    987988,
    887886,
    996779,
    778768,
    889887,
    887797,
    798889,
    789889,
    879888,
    897878,
    989788,
    786867,
    898779,
    888887,
    887777,
    896888,
    996788,
    888779,
    897868,
    679988,
    877878,
    998887,
    887796,
    787787,
    788897,
    897899,
    867789,
    887877,
    777767,
    787797,
    898898,
    878798,
    899778,
    888988,
    988779,
    798879,
    877897,
    897867,
    889887,
    988788,
    968888,
    888887,
    976887,
    677878,
    877776,
    869789,
    989879,
    777988,
    887998,
    897887,
    679989,
    787997,
    878777,
    799879,
    787788,
    868879,
    889777,
    769888,
    978787,
    786987,
    877889,
    777697,
    977798,
    798877,
    877989,
    886897,
    968677,
    878888,
    897987,
    788887,
    867768,
    889978,
    877877,
    798887,
    866887,
    799868,
    899798,
    977987,
    776878,
    798869,
    988897,
    778878,
    979879,
    787778,
    867778,
    788876,
    987968,
    877787,
    787877,
    876789,
    797779,
    899888,
    799788,
    789789,
    779878,
    897789,
    898778,
    977789,
    798788,
    769886,
    787886,
    869986,
    787987,
    989877,
    788988,
    878888,
    887798,
    898988,
    877789,
    876998,
    879887,
    788987,
    786769,
    898778,
    788888,
    898899,
    868797,
    888687,
    877787,
    968978,
    997888,
    788778,
    997697,
    888888,
    778798,
    887978,
    899778,
    897968,
    877886,
    879976,
    677799,
    777778,
    977888,
    898988,
    798687,
    789987,
    878797,
    897776,
    896869,
    988979,
    798778,
    897888,
    898879,
    987878,
    878776,
    768778,
    788899,
    769788,
    879878,
    897786,
    778988,
    888788,
    997778,
    799977,
    877878,
    887899,
    689789,
    899798,
    898877,
    688777,
    868888,
    788878,
    797977,
    887778,
    788898,
    968878,
    968778,
    988877,
    779677,
    778888,
    896887,
    787778,
    978778,
    886877,
    888878,
    797699,
    778787,
    977868,
    988797,
    888888,
    789877,
    988878,
    688996,
    686789,
    877977,
    886788,
    778797,
    878879,
    988888,
    799879,
    797978,
    887796,
    878899,
    879988,
    698999,
    788768,
    788877,
    977988,
    998777,
    798988,
    879887,
    777888,
    889877,
    889878,
    868889,
    679788,
    778889,
    888787,
    778889,
    887978,
    877878,
    899798,
    898887,
    768776,
    867768,
    898866,
    877799,
    789788,
    879688,
    896776,
    887898,
    898976,
    987887,
    977778,
    899887,
    899977,
    987878,
    767887,
    877977,
    787677,
    787788,
    798997,
    788668,
    778797,
    799887,
    888887,
    978878,
    978788,
    877878,
    878797,
    777977,
    877777,
    688888,
    979778,
    888889,
    888988,
    898888,
    797888,
    966989,
    787987,
    987869,
    888789,
    888876,
    978888,
    787989,
    878686,
    778767,
    988788,
    888889,
    789987,
    978778,
    976887,
    776966,
    788988,
    887797,
    898877,
    787999,
    878788,
    887987,
    888878,
    788888,
    788878,
    697786,
    878888,
    768887,
    887988,
    887888,
    877677,
    877979,
    997898,
    889789,
    879876,
    688676,
    978777,
    978798,
    798969,
    888677,
    866878,
    798889,
    788799,
    798888,
    998986,
    779897,
    988697,
    778889,
    798878,
    988979,
    988798,
    987987,
    776779,
    887879,
    899778,
    987698,
    887878,
    999779,
    889778,
    897778,
    887899,
    789889,
    898777,
    798679,
    898887,
    789768,
    898887,
    887879,
    889797,
    788769,
    987878,
    798697,
    987989,
    978789,
    769897,
    787878,
    987778,
    988778,
    888968,
    988978,
    877989,
    798889,
    979697,
    877899,
    986788,
    889778,
    986778,
    876888,
    887878,
    877678,
    878888,
    988777,
    899788,
    967879,
    888898,
    888889,
    887878,
    888697,
    799897,
    978878,
    978899,
    788788,
    888878,
    978998,
    987898,
    869768,
    979787,
    788688,
    897998,
    888889,
    787788,
    888678,
    768878,
    797777,
    888997,
    677879,
    777887,
    787788,
    878778,
    877787,
    778998,
    979887,
    878878,
    786788,
    899779,
    888789,
    888888,
    797887,
    787678,
    888778,
    786887,
    877978,
    888989,
    788987,
    887888,
    888888,
    769788,
    976779,
    787977,
    787988,
    778987,
    898779,
    798687,
    997988,
    888777,
    868898,
    779899,
    887799,
    788777,
    679898,
    877779,
    776888,
    887988,
    877767,
    698786,
    887787,
    987888,
    797977,
    797687,
    877788,
    677877,
    679888,
    878898,
    999877,
    886887,
    788888,
    888778,
    888879,
    897888,
    976887,
    888887,
    897887,
    897969,
    878898,
    886798,
    888889,
    777867,
    887888,
    978788,
    879788,
    977779,
    987887,
    898778,
    776787,
    877868,
    867988,
    988787,
    776878,
    697799,
    798788,
    778778,
    798799,
    867767,
    888997,
    798667,
    987889,
    899877,
    788999,
    879998,
    787968,
    698797,
    897679,
    778798,
    888879,
    879777,
    688877,
    698787,
    888777,
    987889,
    768798,
    988799,
    787888,
    798767,
    878888,
    988998,
    788788,
    767987,
    778896,
    997998,
    989879,
    798889,
    799877,
    878898,
    989897,
    878787,
    887799,
    989869,
    898777,
    768887,
    978977,
    888888,
    878798,
    877787,
    899888,
    976887,
    789797,
    887789,
    788879,
    977897,
    798866,
    796876,
    878779,
    987688,
    899779,
    879899,
    978987,
    798878,
    768889,
    976878,
    887976,
    887788,
    788677,
    988877,
    888877,
    788877,
    897887,
    799778,
    888788,
    899767,
    888887,
    887778,
    788997,
    867786,
    978887,
    668877,
    868887,
    879986,
    779987,
    988978,
    877688,
    777767,
    998867,
    898796,
    878978,
    778887,
    779999,
    998887,
    887768,
    968888,
    868787,
    787987,
    778797,
    998887,
    878988,
    786778,
    988878,
    688878,
    778868,
    768868,
    998797,
    877988,
    888887,
    887798,
    988977,
    777878,
    879698,
    879777,
    887778,
    688877,
    878977,
    888688,
    699986,
    977867,
    798887,
    768887,
    888897,
    999778,
    979888,
    879886,
    987778,
    877978,
    888688,
    987679,
    889878,
    897988,
    769787,
    886689,
    988987,
    788788,
    978878,
    886679,
    976977,
    889997,
    777778,
    878868,
    889787,
    798987,
    998888,
    978887,
    989778,
    868797,
    978788,
    989888,
    786888,
    877698,
    798788,
    986798,
    888877,
    778888,
    879887,
    698878,
    987789,
    787698,
    898868,
    778767,
    788798,
    867887,
    799989,
    787686,
    987788,
    898879,
    898978,
    878877,
    878688,
    878887,
    887788,
    788879,
    887788,
    687987,
    887887,
    986778,
    977976,
    987979,
    879798,
    877877,
    887889,
    787798,
    788879,
    977897,
    888999,
    777887,
    887777,
    788987,
    788877,
    978768,
    977888,
    878878,
    997878,
    897889,
    878898,
    888886,
    867768,
    777788,
    989788,
    887877,
    978787,
    877879,
    787878,
    898877,
    978778,
    997678,
    898668,
    779888,
    878987,
    677776,
    979887,
    777888,
    787988,
    997878,
    898879,
    778886,
    877888,
    888868,
    888888,
    979876,
    897778,
    787887,
    888778,
    798776,
    779787,
    888897,
    787889,
    979777,
    799877,
    988697,
    999887,
    789888,
    886898,
    788788,
    887866,
    888678,
    889898,
    867896,
    869879,
    787889,
    877778,
    689986,
    987879,
    878787,
    778989,
    777788,
    778888,
    978787,
    886879,
    777788,
    679989,
    997869,
    886788,
    888999,
    878897,
    877878,
    887988,
    787777,
    987877,
    787668,
    978668,
    779897,
    787877,
    988889,
    889796,
    789988,
    788787,
    778697,
    977998,
    787698,
    797788,
    788978,
    878786,
    886787,
    867787,
    889797,
    887996,
    869886,
    867879,
    797978,
    888889,
    876988,
    799799,
    789868,
    888878,
    988898,
    778978,
    779889,
    888898,
    968978,
    879898,
    886769,
    988688,
    887989,
    898887,
    768878,
    888788,
    788789,
    888988,
    998897,
    887778,
    797987,
    988767,
    888788,
    888879,
    687797,
    787887,
    796798,
    788889,
    768889,
    898898,
    778987,
    786787,
    789887,
    978888,
    878877,
    789878,
    787779,
    896777,
    968788,
    968898,
    878889,
    668777,
    987799,
    787887,
    868788,
    798887,
    777877,
    897879,
    888687,
    888788,
    898889,
    888887,
    669988,
    878868,
    888887,
    879877,
    787887,
    886888,
    878779,
    967888,
    789889,
    886778,
    878788,
    787898,
    787888,
    667889,
    788788,
    778697,
    987988,
    877988,
    787997,
    867778,
    878788,
    877888,
    799777,
    989889,
    989788,
    978868,
    686876,
    887886,
    987877,
    689789,
    697998,
    888768,
    878698,
    787787,
    777768,
    898889,
    978777,
    767879,
    868778,
    888687,
    798987,
    988778,
    987898,
    778879,
    678899,
    799987,
    769786,
    688896,
    798877,
    988689,
    888877,
    998899,
    978778,
    978797,
    887788,
    878778,
    979878,
    878879,
    877887,
    877988,
    878798,
    886788,
    977887,
    978879,
    898777,
    989978,
    887678,
    777789,
    788888,
    778888,
    887797,
    898778,
    888688,
    877999,
    888787,
    688987,
    676897,
    779787,
    887788,
    789887,
    788997,
    897768,
    979788,
    898887,
    887878,
    998888,
    889797,
    898987,
    988877,
    669876,
    887978,
    889986,
    788769,
    776688,
    767799,
    799788,
    978877,
    997887,
    889787,
    886988,
    888968,
    769987,
    878878,
    999878,
    978778,
    779977,
    989689,
    897978,
    877887,
    989778,
    978778,
    787787,
    768797,
    788879,
    687878,
    787877,
    887788,
    688988,
    877777,
    977968,
    779986,
    678899,
    788886,
    888868,
    788779,
    899889,
    778776,
    788777,
    788778,
    877877,
    777778,
    888788,
    778997,
    878789,
    887787,
    877788,
    797787,
    897799,
    887998,
    889778,
    796869,
    887899,
    877887,
    769777,
    999977,
    898797,
    787778,
    877797,
    887878,
    889787,
    788888,
    697887,
    878777,
    797788,
    877678,
    789787,
    897897,
    887999,
    768877,
    889897,
    888897,
    797887,
    798897,
    788987,
    777778,
    779878,
    877778,
    887889,
    896898,
    988888,
    878799,
    777798,
    877768,
    787879,
    878768,
    767776,
    788799,
    677799,
    887877,
    878887,
    877778,
    788977,
    776978,
    788688,
    898879,
    976978,
    889778,
    887877,
    887988,
    888969,
    888688,
    797889,
    688878,
    779879,
    899888,
    989789,
    788778,
    788766,
    898896,
    688898,
    678789,
    887878,
    787989,
    787886,
    878998,
    978887,
    887988,
    887879,
    877768,
    688779,
    878679,
    888877,
    788988,
    887778,
    997998,
    787789,
    988779,
    877788,
    878897,
    889788,
    779778,
    799889,
    897888,
    777998,
    788798,
    896788,
    999768,
    789988,
    868699,
    788789,
    879997,
    788798,
    787676,
    889888,
    788877,
    678776,
    878877,
    779888,
    887896,
    988887,
    778887,
    878767,
    899789,
    687869,
    889679,
    677897,
    798778,
    998798,
    979867,
    787878,
    797998,
    679689,
    888887,
    788997,
    987987,
    798877,
    797888,
    887789,
    878687,
    898978,
    897977,
    779878,
    897879,
    889978,
    978687,
    887978,
    778878,
    799878,
    877787,
    988797,
    879788,
    898799,
    897969,
    889767,
    678978,
    887988,
    788768,
    989798,
    768787,
    769989,
    788877,
    977879,
    767778,
    886978,
    767988,
    887769,
    787787,
    996988,
    799889,
    687877,
    779778,
    799988,
    788997,
    988786,
    679888,
    989978,
    988868,
    788778,
    978797,
    988788,
    988768,
    988888,
    898988,
    767798,
    778887,
    787778,
    888878,
    988786,
    997787,
    986898,
    887797,
    788787,
    868878,
    788887,
    686977,
    787788,
    768699,
    888787,
    888887,
    868878,
    987789,
    888676,
    778776,
    788787,
    788678,
    889767,
    887888,
    787879,
    886989,
    889788,
    879767,
    977778,
    778888,
    678899,
    979977,
    767879,
    896777,
    888787,
    788777,
    767988,
    879887,
    869888,
    987778,
    889789,
    788688,
    897899,
    988887,
    787996,
    779889,
    799878,
    888768,
    898987,
    798677,
    778879,
    988888,
    888687,
    888797,
    769769,
    888778,
    786698,
    988889,
    778878,
    987779,
    897869,
    677999,
    878988,
    878679,
    887987,
    777988,
    988776,
    787789,
    888778,
    779888,
    898877,
    889888,
    868999,
    698868,
    867878,
    878898,
    877678,
    798988,
    799969,
    888877,
    797989,
    897998,
    797987,
    778968,
    798887,
    879887,
    986987,
    778787,
    976778,
    878888,
    879878,
    868889,
    877879,
    878889,
    878688,
    789778,
    878678,
    888778,
    877798,
    999789,
    888778,
    998897,
    877986,
    998878,
    688888,
    777787,
    888878,
    887989,
    789768,
    789777,
    987988,
    798987,
    778979,
    797988,
    889888,
    879889,
    987788,
    878789,
    778787,
    797768,
    798768,
    886878,
    869977,
    778877,
    777989,
    988878,
    787987,
    777986,
    887877,
    899799,
    768777,
    898878,
    888888,
    787789,
    977788,
    888868,
    687778,
    888879,
    889789,
    988889,
    787798,
    778997,
    998796,
    886887,
    888877,
    869868,
    977887,
    977887,
    887787,
    787778,
    688778,
    878887,
    788878,
    798888,
    976788,
    778888,
    798998,
    677877,
    889897,
    787797,
    788888,
    688788,
    898788,
    878889,
    878977,
    689798,
    987889,
    988988,
    896888,
    987778,
    878868,
    988878,
    888878,
    879877,
    888867,
    777898,
    869699,
    777889,
    778978,
    888887,
    888887,
    677789,
    768877,
    799788,
    779788,
    778899,
    889899,
    788776,
    988899,
    878878,
    767888,
    978778,
    799697,
    878889,
    899677,
    998787,
    797888,
    768797,
    888786,
    996777,
    798798,
    989888,
    996898,
    887878,
    778789,
    877897,
    789868,
    898878,
    997788,
    797888,
    878688,
    888887,
    878779,
    878677,
    779889,
    768799,
    888777,
    888887,
    766878,
    898888,
    987877,
    889999,
    899888,
    788777,
    698788,
    878786,
    788878,
    789897,
    878868,
    669888,
    798998,
    789998,
    889787,
    787678,
    788779,
    789797,
    878788,
    769776,
    786987,
    789788,
    976888,
    878878,
    887777,
    697869,
    787888,
    668678,
    989887,
    879888,
    788899,
    899978,
    989687,
    987898,
    888888,
    997788,
    778878,
    877878,
    897787,
    887998,
    797887,
    969987,
    889889,
    879798,
    988978,
    789978,
    878688,
    988879,
    997877,
    888677,
    898999,
    878778,
    787679,
    888777,
    778978,
    788788,
    877987,
    798877,
    879898,
    887798,
    878867,
    798869,
    786989,
    879898,
    987878,
    899998,
    887887,
    878888,
    897888,
    887787,
    887878,
    888788,
    878778,
    888876,
    877798,
    868989,
    879978,
    888887,
    798988,
    789788,
    798898,
    798787,
    877877,
    998989,
    988676,
    986886,
    788878,
    978877,
    788767,
    777997,
    888778,
    788679,
    786888,
    778877,
    787976,
    978767,
    778677,
    987887,
    888979,
    779787,
    789777,
    878977,
    988877,
    888788,
    798989,
    678979,
    877988,
    799888,
    768889,
    877777,
    888878,
    779788,
    897789,
    887887,
    778878,
    978798,
    877698,
    878969,
    888788,
    898988,
    777879,
    779886,
    678877,
    768998,
    787878,
    897788,
    878888,
    879788,
    678888,
    887678,
    887777,
    987877,
    877879,
    778879,
    867977,
    987899,
    879878,
    897888,
    797878,
    787888,
    777977,
    888767,
    788788,
    689897,
    878768,
    887888,
    988878,
    888878,
    887967,
    998978,
    788687,
    679989,
    987999,
    878778,
    777877,
    688896,
    987778,
    886777,
    898897,
    876887,
    877898,
    786896,
    877797,
    886867,
    687778,
    887779,
    897778,
    998788,
    778898,
    878797,
    888886,
    888897,
    897886,
    887797,
    977887,
    778867,
    788978,
    888777,
    968989,
    987897,
    998788,
    689988,
    987898,
    887878,
    986778,
    877876,
    878868,
    998887,
    989997,
    989777,
    896989,
    798788,
    998786,
    878797,
    777777,
    866778,
    887778,
    789878,
    887777,
    877899,
    877868,
    788788,
    889998,
    979787,
    889868,
    878878,
    789798,
    988888,
    789698,
    878977,
    897986,
    898879,
    899686,
    789797,
    887689,
    678897,
    879668,
    989878,
    877899,
    997888,
    697779,
    978976,
    769698,
    877889,
    778788,
    779898,
    677988,
    898799,
    688988,
    886876,
    878788,
    789979,
    797888,
    987869,
    888886,
    988887,
    898877,
    777788,
    897897,
    889877,
    979879,
    777797,
    889878,
    777897,
    678878,
    799878,
    699788,
    977898,
    888878,
    789879,
    889888,
    768888,
    788888,
    988688,
    888898,
    779887,
    688877,
    689788,
    788788,
    788787,
    887798,
    988778,
    877699,
    798989,
    788997,
    677888,
    977877,
    987998,
    887888,
    897788,
    898977,
    897988,
    788787,
    797968,
    988889,
    867988,
    777786,
    778788,
    989788,
    879879,
    788788,
    888998,
    887699,
    898868,
    997898,
    898977,
    779886,
    987869,
    677887,
    779689,
    978888,
    798868,
    888888,
    878878,
    897888,
    787887,
    888788,
    889898,
    888887,
    679889,
    998787,
    798877,
    788988,
    886778,
    877788,
    798879,
    898787,
    878789,
    887798,
    967877,
    888767,
    888767,
    897888,
    788887,
    877778,
    887877,
    898887,
    797887,
    877697,
    778788,
    868788,
    879797,
    777879,
    889896,
    778976,
    886997,
    777888,
    878978,
    998798,
    988877,
    768989,
    787887,
    869767,
    788978,
    876788,
    899788,
    898776,
    887889,
    987877,
    787877,
    897877,
    868688,
    768888,
    887879,
    887888,
    868989,
    898787,
    777968,
    878778,
    779967,
    879988,
    878787,
    777987,
    888788,
    787887,
    897987,
    879798,
    788888,
    778888,
    878788,
    879878,
    787696,
    888878,
    788979,
    888888,
    979987,
    787878,
    887977,
    997788,
    787789,
    879986,
    879878,
    888989,
    777888,
    777888,
    986779,
    788878,
    899888,
    677777,
    787799,
    788779,
    778786,
    687778,
    988698,
    999789,
    888888,
    988698,
    778778,
    779699,
    876988,
    786778,
    787878,
    879877,
    788898,
    777676,
    998878,
    988997,
    897878,
    788877,
    786779,
    789977,
    887878,
    887897,
    888888,
    887676,
    988868,
    678988,
    898878,
    766787,
    997879,
    887897,
    788786,
    997887,
    787778,
    889886,
    778787,
    888889,
    688889,
    689788,
    798878,
    889898,
    889889,
    788988,
    886786,
    799878,
    777977,
    798788,
    778977,
    888778,
    888889,
    787798,
    779787,
    898977,
    898878,
    898978,
    778888,
    886887,
    769876,
    998888,
    787777,
    878888,
    688876,
    869776,
    777788,
    878788,
    897778,
    888988,
    787777,
    788798,
    789887,
    797779,
    778888,
    888778,
    898878,
    966889,
    878687,
    887888,
    889777,
    889878,
    887998,
    887878,
    887786,
    788797,
    787888,
    878778,
    988898,
    877788,
    879877,
    997979,
    777698,
    977889,
    787788,
    787797,
    798988,
    777777,
    877786,
    878888,
    988778,
    987877,
    987688,
    887877,
    898889,
    887878,
    787889,
    877889,
    997887,
    797977,
    988787,
    689877,
    978987,
    887876,
    868877,
    899997,
    698888,
    878779,
    689799,
    979887,
    887797,
    888887,
    778788,
    898878,
    788777,
    897889,
    778989,
    877988,
    897887,
    788789,
    777977,
    879888,
    787988,
    889798,
    998797,
    977887,
    979987,
    888878,
    888888,
    998788,
    788787,
    878768,
    888877,
    989887,
    889798,
    889777,
    778867,
    789879,
    789998,
    968877,
    888988,
    788879,
    878797,
    896886,
    987797,
    899877,
    878879,
    786688,
    988897,
    879887,
    698887,
    988877,
    698969,
    788977,
    877797,
    778677,
    888978,
    889899,
    898978,
    988877,
    898797,
    788798,
    889978,
    688987,
    779788,
    977897,
    878679,
    887879,
    969999,
    977787,
    869977,
    779889,
    888889,
    887978,
    897789,
    966687,
    789998,
    888887,
    777988,
    868899,
    978798,
    876678,
    887868,
    787888,
    788678,
    888899,
    878889,
    996897,
    897978,
    988988,
    687889,
    887799,
    898887,
    977999,
    888888,
    878699,
    778978,
    977698,
    778799,
    989789,
    887987,
    877787,
    789787,
    789888,
    886976,
    978979,
    888988,
    879899,
    997978,
    998778,
    789887,
    897978,
    897987,
    987668,
    768779,
    698887,
    898888,
    687787,
    799976,
    888868,
    877877,
    869888,
    788788,
    888878,
    977978,
    787979,
    868888,
    887987,
    698778,
    777878,
    768767,
    897888,
    797898,
    788796,
    987988,
    977888,
    888898,
    989769,
    778797,
    886777,
    776778,
    789898,
    878889,
    798898,
    898798,
    887889,
    887766,
    786878,
    889688,
    787876,
    689899,
    888888,
    869777,
    788766,
    966797,
    886878,
    786878,
    988987,
    897887,
    889887,
    766888,
    998887,
    888897,
    788887,
    799877,
    797688,
    798888,
    977898,
    787898,
    877889,
    877678,
    878889,
    878886,
    898878,
    789686,
    778888,
    778878,
    787787,
    889887,
    966787,
    788989,
    788778,
    887888,
    896779,
    777887,
    889898,
    997897,
    978787,
    886779,
    888778,
    888879,
    897777,
    869768,
    898887,
    778788,
    978777,
    878888,
    778768,
    887698,
    888887,
    878878,
    976777,
    879887,
    776787,
    787977,
    786878,
    797977,
    888779,
    986879,
    888868,
    688898,
    697888,
    888779,
    877888,
    778797,
    688789,
    787887,
    767787,
    767786,
    986997,
    888967,
    789787,
    989979,
    779768,
    887978,
    887688,
    987877,
    876778,
    878796,
    997877,
    689888,
    887888,
    799788,
    788977,
    898778,
    789869,
    789887,
    777868,
    678767,
    889877,
    979899,
    998798,
    779888,
    787888,
    788776,
    779678,
    779887,
    769978,
    787678,
    878797,
    788878,
    777978,
    888787,
    777976,
    966798,
    887877,
    898987,
    789979,
    977977,
    788777,
    698979,
    688878,
    778988,
    779886,
    889896,
    898997,
    787987,
    877898,
    867968,
    797769,
    887779,
    677778,
    877778,
    888877,
    798768,
    787778,
    989797,
    798988,
    688768,
    778888,
    968887,
    777788,
    789887,
    878898,
    698869,
    889888,
    887889,
    778787,
    698898,
    777889,
    868788,
    889888,
    667887,
    698898,
    988878,
    777688,
    777788,
    989888,
    877977,
    888778,
    868887,
    776898,
    888897,
    787968,
    867867,
    987699,
    787877,
    889878,
    877767,
    879787,
    796777,
    879897,
    888777,
    789698,
    879688,
    777976,
    977688,
    678888,
    898788,
    888888,
    789878,
    888777,
    888878,
    777787,
    888997,
    877779,
    987987,
    797799,
    889977,
    877998,
    788977,
    888877,
    987677,
    888986,
    888896,
    777887,
    769998,
    788778,
    988787,
    767988,
    877897,
    779878,
    787977,
    789779,
    878888,
    767887,
    887798,
    897987,
    778697,
    887897,
    889887,
    778787,
    798968,
    787888,
    877679,
    877888,
    778978,
    899878,
    877976,
    888888,
    777898,
    888788,
    797868,
    789697,
    788787,
    889878,
    767888,
    788887,
    879799,
    778788,
    777877,
    787877,
    779887,
    886887,
    967787,
    967887,
    887777,
    897969,
    777867,
    987787,
    777878,
    678678,
    889978,
    678778,
    787888,
    688986,
    968777,
    688686,
    977896,
    788987,
    979887,
    986789,
    878996,
    889878,
    887777,
    867789,
    997888,
    677987,
    878687,
    697987,
    868779,
    997978,
    977768,
    777789,
    889788,
    786868,
    897889,
    677787,
    687879,
    999889,
    778988,
    797887,
    788778,
    888899,
    778988,
    799886,
    876678,
    687879,
    778878,
    888889,
    777988,
    789998,
    688879,
    998999,
    778896,
    769888,
    999888,
    977677,
    878696,
    898878,
    967789,
    888789,
    798788,
    777888,
    787787,
    886997,
    788788,
    877897,
    787887,
    777987,
    888988,
    798888,
    887779,
    888999,
    767788,
    768678,
    687888,
    877778,
    989988,
    788987,
    789798,
    887776,
    788989,
    788888,
    687887,
    678867,
    898797,
    887867,
    887898,
    887977,
    877977,
    877999,
    678988,
    987887,
    778898,
    897787,
    887897,
    877888,
    988879,
    878978,
    768777,
    888989,
    988888,
    999888,
    888977,
    788787,
    988778,
    798978,
    899879,
    787988,
    876778,
    778777,
    787978,
    899787,
    887888,
    977787,
    788888,
    888687,
    877887,
    887978,
    788879,
    888969,
    888887,
    988899,
    789867,
    978777,
    988877,
    687879,
    897778,
    779987,
    977679,
    877887,
    898788,
    876896,
    979886,
    967788,
    767789,
    886898,
    887788,
    787698,
    989878,
    987798,
    866787,
    668878,
    878978,
    978979,
    777877,
    777869,
    977879,
    889789,
    788787,
    978777,
    987686,
    877987,
    988887,
    967687,
    887888,
    777896,
    787687,
    889897,
    788888,
    878787,
    687798,
    899897,
    778898,
    979888,
    887897,
    988987,
    789877,
    799978,
    878777,
    887998,
    777877,
    878887,
    898897,
    967788,
    769789,
    677997,
    798989,
    887688,
    778788,
    889888,
    888788,
    877789,
    887868,
    788789,
    878678,
    776978,
    777887,
    777899,
    789787,
    999887,
    886788,
    986798,
    788767,
    867886,
    788887,
    878867,
    797878,
    689988,
    889898,
    979768,
    777888,
    767787,
    778898,
    778887,
    899778,
    898878,
    897876,
    988678,
    789878,
    968778,
    998968,
    888899,
    969887,
    888996,
    776978,
    879886,
    978776,
    899977,
    887897,
    789897,
    778887,
    697788,
    889789,
    998898,
    987897,
    988878,
    779986,
    778888,
    978878,
    788798,
    688677,
    988878,
    799888,
    786788,
    978889,
    788876,
    787987,
    889886,
    987878,
    778697,
    867788,
    788789,
    898888,
    898778,
    988977,
    878877,
    767877,
    778888,
    878896,
    988777,
    788886,
    787887,
    787878,
    988777,
    979888,
    898778,
    867996,
    788777,
    897898,
    888888,
    998779,
    977888,
    798798,
    779776,
    778887,
    988977,
    998678,
    799967,
    977888,
    788789,
    779769,
    768886,
    877869,
    777798,
    878978,
    877697,
    877687,
    988678,
    886877,
    888997,
    887799,
    788989,
    778887,
    876778,
    976788,
    698778,
    897877,
    977687,
    789777,
    988878,
    788878,
    888779,
    889887,
    979888,
    898888,
    888898,
    976878,
    869878,
    879988,
    877888,
    687878,
    878897,
    888786,
    978889,
    898778,
    887887,
    798887,
    788878,
    897889,
    878887,
    988888,
    789989,
    898787,
    887978,
    787889,
    788777,
    768987,
    878989,
    789778,
    979987,
    968788,
    767899,
    777798,
    978997,
    888887,
    878779,
    678977,
    887767,
    988878,
    878877,
    899987,
    788988,
    988679,
    887987,
    878888,
    978887,
    988897,
    978887,
    677778,
    797797,
    787676,
    789777,
    676668,
    778878,
    778678,
    887989,
    889867,
    788889,
    877968,
    777867,
    777788,
    897988,
    877897,
    878888,
    876779,
    787787,
    888779,
    867988,
    887777,
    768899,
    776888,
    886878,
    797779,
    997878,
    688777,
    899897,
    876787,
    898878,
    999887,
    777887,
    697697,
    798797,
    788889,
    878777,
    798788,
    897989,
    788878,
    898768,
    989788,
    978788,
    778888,
    777887,
    887998,
    689977,
    898877,
    677979,
    888888,
    889868,
    968767,
    989988,
    797767,
    888888,
    797977,
    788778,
    689888,
    887988,
    867878,
    888889,
    798776,
    787879,
    777786,
    878876,
    888787,
    987898,
    766897,
    788878,
    887899,
    889878,
    798887,
    798879,
    778788,
    778888,
    888668,
    887878,
    787688,
    878987,
    887798,
    887988,
    888877,
    876878,
    778978,
    787798,
    878779,
    778999,
    869777,
    768787,
    689778,
    889888,
    778888,
    778877,
    788898,
    898788,
    887998,
    878887,
    888777,
    886778,
    978788,
    878787,
    988799,
    888887,
    878777,
    898888,
    987978,
    987988,
    887789,
    988788,
    888887,
    977798,
    868879,
    997878,
    778888,
    878999,
    888777,
    689797,
    888878,
    976888,
    797879,
    788877,
    886879,
    878797,
    888886,
    798778,
    977888,
    977998,
    786777,
    798768,
    798888,
    887766,
    888798,
    787978,
    888688,
    986878,
    888879,
    887798,
    899788,
    668877,
    987699,
    878777,
    787786,
    979976,
    999868,
    788976,
    669798,
    977897,
    987988,
    988677,
    878888,
    789778,
    777886,
    798898,
    887779,
    967988,
    979798,
    767886,
    668878,
    998788,
    996788,
    989877,
    887888,
    897778,
    898687,
    777997,
    998797,
    777998,
    798877,
    898878,
    778878,
    888787,
    886878,
    787777,
    789789,
    877878,
    679978,
    867888,
    878877,
    788887,
    878878,
    797888,
    976868,
    897898,
    887777,
    876986,
    976786,
    888678,
    888899,
    687699,
    898787,
    868887,
    876789,
    789989,
    779987,
    986888,
    878989,
    877979,
    888988,
    777877,
    898768,
    978778,
    897878,
    777798,
    877887,
    887999,
    877787,
    886878,
    688899,
    986988,
    888799,
    979898,
    698868,
    799898,
    897998,
    888899,
    777679,
    777777,
    987978,
    899888,
    767886,
    887797,
    998868,
    677996,
    987879,
    778878,
    876887,
    899787,
    798778,
    779798,
    879877,
    978798,
    887978,
    878897,
    878778,
    877986,
    788889,
    997797,
    987879,
    987978,
    778888,
    789878,
    997876,
    868898,
    877887,
    797898,
    889988,
    888886,
    888788,
    997877,
    786997,
    977988,
    787769,
    789797,
    877787,
    888778,
    787878,
    887787,
    788987,
    777788,
    879789,
    796867,
    766888,
    777698,
    898988,
    888788,
    987886,
    889778,
    886879,
    977988,
    779789,
    779778,
    788878,
    797888,
    888878,
    987788,
    778798,
    878788,
    788979,
    887989,
    787798,
    887778,
    877788,
    788789,
    787878,
    988788,
    978999,
    999979,
    898897,
    989879,
    889898,
    887889,
    778676,
    897798,
    688987,
    879877,
    979888,
    879887,
    778888,
    788897,
    887877,
    777899,
    778978,
    887888,
    879897,
    778898,
    888777,
    798888,
    798767,
    776888,
    978998,
    689897,
    787967,
    887878,
    787878,
    887879,
    787668,
    877788,
    798677,
    788776,
    897977,
    887888,
    898777,
    679888,
    999777,
    778978,
    677777,
    788789,
    797989,
    877888,
    868888,
    878788,
    788798,
    968877,
    798876,
    889667,
    878688,
    877687,
    998788,
    778889,
    887899,
    798778,
    887777,
    797997,
    878988,
    776888,
    778889,
    988887,
    788898,
    979787,
    799798,
    798877,
    788797,
    888967,
    989887,
    967978,
    788777,
    788877,
    877879,
    887889,
    978869,
    888979,
    897978,
    877778,
    687886,
    877787,
    897987,
    887678,
    876788,
    788987,
    988788,
    877769,
    868887,
    687788,
    788899,
    877897,
    967888,
    788898,
    998968,
    788787,
    887888,
    788977,
    877887,
    698889,
    997897,
    878987,
    778888,
    898899,
    798688,
    889887,
    687687,
    978798,
    868787,
    879986,
    886897,
    789877,
    798767,
    898878,
    887788,
    778887,
    787779,
    877978,
    799978,
    778896,
    878677,
    988788,
    878888,
    887978,
    898898,
    888997,
    777979,
    988887,
    887787,
    898788,
    888877,
    877898,
    788788,
    777978,
    869798,
    898887,
    678888,
    688688,
    778986,
    876798,
    898778,
    796886,
    788888,
    988867,
    878976,
    877697,
    798988,
    988777,
    688977,
    889876,
    978978,
    988787,
    997877,
    878889,
    788867,
    797698,
    867897,
    987778,
    799887,
    987888,
    678779,
    977968,
    768898,
    777978,
    978886,
    888999,
    878898,
    778778,
    998897,
    967968,
    978778,
    977987,
    877886,
    888896,
    787766,
    877887,
    887887,
    889978,
    787879,
    799887,
    688878,
    799888,
    978879,
    778776,
    988887,
    778887,
    878779,
    888777,
    787878,
    877788,
    786776,
    778778,
    797889,
    878886,
    877887,
    879769,
    988866,
    778988,
    787868,
    877888,
    877787,
    987888,
    787689,
    889987,
    878998,
    779898,
    779889,
    878888,
    788687,
    988977,
    998987,
    877978,
    988877,
    688898,
    887887,
    899888,
    779769,
    687987,
    888869,
    888788,
    897876,
    788997,
    988987,
    988777,
    878988,
    899887,
    979779,
    788988,
    897797,
    888788,
    686897,
    988687,
    978777,
    788898,
    879779,
    988877,
    787787,
    879888,
    899988,
    887787,
    888998,
    888787,
    799888,
    798877,
    897877,
    888777,
    796878,
    777987,
    977878,
    898879,
    787867,
    776889,
    879798,
    887878,
    878888,
    988887,
    778777,
    888978,
    787986,
    987878,
    878888,
    989987,
    787787,
    796879,
    878997,
    987788,
    799787,
    898898,
    787698,
    887786,
    888999,
    777979,
    986778,
    878679,
    888788,
    797777,
    777989,
    779778,
    887879,
    978889,
    888877,
    888977,
    878986,
    876789,
    989688,
    779886,
    898888,
    887888,
    889887,
    888878,
    877686,
    879878,
    966977,
    789778,
    788878,
    878878,
    788888,
    798698,
    878889,
    788988,
    886799,
    699897,
    888987,
    887789,
    776779,
    889797,
    976977,
    778997,
    798886,
    887997,
    888877,
    878978,
    787789,
    987978,
    788997,
    887878,
    776877,
    989779,
    796889,
    798897,
    798876,
    987887,
    877789,
    988888,
    688678,
    876979,
    799888,
    897788,
    998799,
    888977,
    887879,
    797697,
    787788,
    878886,
    977779,
    768977,
    996898,
    887878,
    768978,
    776868,
    789778,
    798687,
    787787,
    879677,
    778889,
    877979,
    997877,
    876779,
    888789,
    778968,
    986878,
    867896,
    696898,
    788978,
    898797,
    799879,
    798787,
    776799,
    887776,
    878878,
    888798,
    877878,
    987778,
    887678,
    877779,
    788778,
    887698,
    777688,
    788986,
    877889,
    777879,
    798878,
    887797,
    786899,
    778977,
    877878,
    777889,
    877997,
    788796,
    968877,
    877797,
    877889,
    888768,
    797799,
    978998,
    789787,
    888798,
    897987,
    788667,
    987898,
    789887,
    887786,
    778986,
    689778,
    977789,
    898788,
    887879,
    788787,
    977787,
    888888,
    778799,
    999997,
    788798,
    868979,
    878877,
    787988,
    987878,
    889797,
    988977,
    888788,
    887797,
    878787,
    697778,
    886979,
    797877,
    688986,
    768798,
    678878,
    877867,
    789876,
    798798,
    777788,
    878769,
    888679,
    888868,
    677887,
    797978,
    778798,
    788688,
    788989,
    877877,
    798699,
    779988,
    776787,
    686899,
    897878,
    977787,
    779897,
    998787,
    987888,
    897667,
    788887,
    768878,
    887868,
    899687,
    877888,
    777788,
    878778,
    888777,
    668789,
    798988,
    878778,
    979977,
    998876,
    799889,
    898897,
    886887,
    978987,
    887878,
    799778,
    887777,
    786988,
    878889,
    787776,
    688977,
    788799,
    787788,
    898787,
    897888,
    689877,
    678977,
    878889,
    686878,
    887778,
    678779,
    777778,
    988667,
    778798,
    879997,
    878798,
    998876,
    778787,
    779799,
    767768,
    889889,
    966877,
    687777,
    878897,
    768996,
    888888,
    769896,
    896798,
    798889,
    978788,
    987788,
    779777,
    789777,
    787987,
    776877,
    778878,
    978788,
    989897,
    998789,
    777669,
    887877,
    978887,
    778878,
    788878,
    787788,
    787768,
    777996,
    888989,
    996879,
    997878,
    987778,
    887898,
    687977,
    897787,
    889788,
    898868,
    798898,
    798868,
    998787,
    888799,
    887978,
    888889,
    876987,
    897888,
    778676,
    877877,
    777798,
    877679,
    898987,
    878797,
    878778,
    888979,
    879888,
    777788,
    887797,
    789998,
    887977,
    888797,
    768867,
    678888,
    997898,
    686889,
    888888,
    897888,
    868786,
    696997,
    776878,
    799897,
    798978,
    976888,
    989998,
    877887,
    787888,
    889878,
    689997,
    896987,
    788789,
    779877,
    787778,
    888779,
    887868,
    897887,
    776878,
    778888,
    797777,
    788878,
    869988,
    887777,
    788688,
    878878,
    888798,
    796978,
    888798,
    977869,
    798878,
    978797,
    786988,
    897799,
    679998,
    799899,
    877878,
    888888,
    889888,
    778778,
    689889,
    777888,
    987887,
    789888,
    988889,
    878878,
    878986,
    877888,
    677787,
    788777,
    888888,
    989888,
    678777,
    877887,
    998787,
    797877,
    988876,
    868798,
    887788,
    777889,
    887878,
    789877,
    889778,
    888978,
    679979,
    889987,
    888886,
    899787,
    797998,
    967787,
    878887,
    778888,
    986887,
    787896,
    788787,
    868787,
    688787,
    897878,
    888888,
    898889,
    899799,
    977887,
    888776,
    978879,
    877879,
    689868,
    879788,
    878987,
    878887,
    878779,
    866879,
    887797,
    787879,
    998888,
    898678,
    778979,
    878789,
    778877,
    889778,
    778987,
    969878,
    869868,
    988898,
    989896,
    787898,
    988778,
    887888,
    889988,
    988679,
    777787,
    878788,
    889886,
    777878,
    789968,
    988798,
    887676,
    886776,
    788988,
    688888,
    777787,
    777787,
    998778,
    978879,
    967788,
    999798,
    898697,
    888899,
    988978,
    787798,
    778779,
    889878,
    789989,
    998688,
    778677,
    897979,
    998976,
    976787,
    778869,
    998889,
    987988,
    787778,
    889879,
    777776,
    878787,
    988867,
    778886,
    878888,
    789897,
    878979,
    987688,
    887868,
    879898,
    888778,
    788988,
    898779,
    889979,
    987888,
    987778,
    889996,
    688879,
    968987,
    886767,
    877788,
    786879,
    988887,
    878887,
    877789,
    777777,
    898888,
    998879,
    968669,
    767987,
    787896,
    977898,
    798867,
    878789,
    888789,
    777887,
    877668,
    888778,
    889887,
    788776,
    996797,
    888889,
    978996,
    787789,
    979877,
    888788,
    788886,
    879778,
    888787,
    787787,
    887887,
    898877,
    788777,
    889779,
    787989,
    889688,
    888997,
    887888,
    898787,
    987797,
    967697,
    877698,
    787899,
    878877,
    868798,
    787688,
    887688,
    787898,
    897877,
    969788,
    767878,
    877987,
    778679,
    877999,
    777878,
    978778,
    887866,
    888986,
    779778,
    878897,
    977896,
    878899,
    888977,
    787887,
    789889,
    889878,
    978777,
    886888,
    888776,
    997898,
    888788,
    789788,
    776977,
    778889,
    877877,
    986877,
    887889,
    877988,
    677877,
    968799,
    867688,
    899978,
    899889,
    787898,
    688887,
    799788,
    977877,
    788796,
    987977,
    699778,
    799869,
    887888,
    877986,
    897878,
    979888,
    898787,
    889788,
    777678,
    798888,
    787988,
    868887,
    889988,
    888787,
    689878,
    788888,
    789789,
    688879,
    888879,
    779987,
    998898,
    887788,
    788768,
    899798,
    787778,
    887888,
    798779,
    878889,
    898788,
    877966,
    779887,
    988688,
    789687,
    888898,
    776999,
    898788,
    976868,
    988898,
    898778,
    787887,
    888987,
    878779,
    797886,
    889889,
    777868,
    889897,
    777979,
    768867,
    988889,
    888898,
    878987,
    978687,
    787688,
    888886,
    896778,
    888968,
    887888,
    887868,
    987889,
    887897,
    877788,
    767877,
    969698,
    779987,
    989879,
    968996,
    878787,
    888888,
    879988,
    878767,
    878766,
    788888,
    989887,
    789978,
    889878,
    778869,
    877877,
    997899,
    887988,
    789778,
    888887,
    987787,
    998989,
    887879,
    798777,
    978887,
    788878,
    889897,
    787877,
    879778,
    869887,
    878989,
    797889,
    887898,
    678877,
    889877,
    688778,
    887988,
    889777,
    698999,
    768688,
    979678,
    788888,
    679878,
    877888,
    788868,
    887888,
    787779,
    887869,
    787876,
    898896,
    999997,
    788887,
    678878,
    797987,
    887787,
    877897,
    887878,
    897877,
    897777,
    978779,
    789978,
    798799,
    868777,
    887976,
    998689,
    989788,
    887677,
    778797,
    778788,
    776798,
    788788,
    989789,
    878798,
    867799,
    797988,
    898868,
    978878,
    996877,
    788787,
    887876,
    878688,
    798796,
    978779,
    699888,
    868778,
    999799,
    987888,
    888788,
    888789,
    877988,
    897888,
    788788,
    878977,
    887878,
    686897,
    876867,
    897787,
    989787,
    988889,
    697687,
    678889,
    767786,
    878888,
    788987,
    877886,
    887777,
    797888,
    698887,
    798778,
    878888,
    879788,
    779789,
    888988,
    878977,
    888989,
    776778,
    787887,
    888779,
    978978,
    678776,
    877867,
    678897,
    797869,
    869888,
    778878,
    879788,
    788977,
    887697,
    897777,
    788888,
    778887,
    878787,
    788787,
    897788,
    878666,
    788989,
    879787,
    778789,
    878699,
    987788,
    887787,
    878886,
    789888,
    888978,
    988788,
    777798,
    777967,
    777879,
    797889,
    777888,
    778888,
    788799,
    988897,
    779998,
    786788,
    899997,
    768877,
    798879,
    778777,
    787868,
    888998,
    887789,
    987968,
    988878,
    987787,
    866887,
    987798,
    798996,
    888889,
    788877,
    898786,
    787698,
    788888,
    879797,
    776887,
    889877,
    777969,
    879787,
    897878,
    878888,
    877878,
    888888,
    888798,
    888776,
    986978,
    898777,
    779788,
    999778,
    879878,
    977788,
    788787,
    897877,
    978976,
    798799,
    698788,
    877877,
    887778,
    888888,
    867878,
    788698,
    798787,
    788797,
    787888,
    798887,
    987799,
    788979,
    996878,
    887879,
    898878,
    898799,
    689878,
    878788,
    887778,
    888786,
    788777,
    887888,
    978798,
    997788,
    887778,
    877978,
    988898,
    789878,
    877998,
    988877,
    887797,
    979888,
    779787,
    878878,
    687868,
    899887,
    888878,
    788879,
    779778,
    767787,
    887878,
    888777,
    688788,
    778877,
    886898,
    988789,
    899888,
    898698,
    878886,
    998787,
    997879,
    878887,
    999888,
    689868,
    898778,
    888976,
    877899,
    888877,
    778888,
    877899,
    888888,
    978877,
    878887,
    978789,
    777888,
    877777,
    886898,
    988797,
    778796,
    886878,
    768888,
    899799,
    687878,
    888768,
    789687,
    778877,
    778788,
    787888,
    978887,
    877798,
    898888,
    789889,
    967988,
    787887,
    867789,
    788897,
    887768,
    898867,
    889877,
    998876,
    899787,
    898788,
    877788,
    697988,
    988789,
    987768,
    888777,
    778898,
    898789,
    877798,
    978887,
    698789,
    888878,
    979898,
    778876,
    988888,
    678879,
    987879,
    968786,
    878789,
    898888,
    988977,
    787878,
    777987,
    799768,
    868698,
    778778,
    779779,
    878877,
    887887,
    997888,
    977987,
    689889,
    787777,
    777888,
    788879,
    887989,
    887677,
    778898,
    898677,
    788877,
    768889,
    777877,
    788877,
    898976,
    768786,
    988878,
    887878,
    788889,
    877986,
    968796,
    788887,
    977787,
    987687,
    687898,
    977876,
    797878,
    897878,
    878887,
    979887,
    797887,
    987978,
    978888,
    987978,
    998878,
    898799,
    888779,
    979798,
    787989,
    788677,
    799788,
    688868,
    899999,
    867889,
    888888,
    887778,
    988778,
    878877,
    988879,
    967877,
    888868,
    888998,
    879988,
    887787,
    778779,
    786978,
    788889,
    887988,
    888878,
    788778,
    898786,
    898888,
    987898,
    789788,
    988678,
    786987,
    779878,
    887789,
    777886,
    889879,
    778767,
    888987,
    777887,
    789797,
    789688,
    787898,
    798898,
    787967,
    688878,
    797789,
    779888,
    899977,
    799979,
    878898,
    967878,
    888777,
    688777,
    878988,
    897678,
    889977,
    968899,
    978789,
    789787,
    877889,
    967788,
    697698,
    789669,
    888988,
    679778,
    887788,
    987788,
    879878,
    889768,
    897878,
    878878,
    788768,
    878889,
    787797,
    677988,
    989788,
    998979,
    688797,
    888798,
    896877,
    797887,
    778788,
    888878,
    788788,
    789778,
    978879,
    687766,
    888687,
    887888,
    998677,
    987777,
    788889,
    977787,
    778888,
    889887,
    689877,
    778898,
    867897,
    768788,
    887887,
    979876,
    978899,
    887898,
    888888,
    887867,
    876877,
    878877,
    887888,
    797787,
    688886,
    987999,
    798887,
    978788,
    898787,
    788876,
    887798,
    898989,
    799678,
    877867,
    877797,
    988997,
    797979,
    779998,
    887977,
    989777,
    788887,
    887987,
    879778,
    888978,
    879897,
    788799,
    889789,
    897888,
    898989,
    986778,
    977978,
    778777,
    787789,
    779887,
    989889,
    768866,
    788988,
    978878,
    988797,
    778988,
    877878,
    988679,
    897877,
    898888,
    888787,
    888776,
    869687,
    977879,
    867878,
    878988,
    876887,
    787788,
    787788,
    879677,
    786978,
    987687,
    888888,
    787898,
    878879,
    787887,
    767889,
    778899,
    787886,
    877787,
    798897,
    888798,
    787877,
    969678,
    888887,
    677677,
    877979,
    777997,
    777878,
    799888,
    878889,
    988878,
    798968,
    987978,
    978978,
    787799,
    996877,
    877886,
    976988,
    886877,
    987877,
    988778,
    879887,
    989789,
    986977,
    879987,
    877987,
    898889,
    888967,
    886778,
    887788,
    977788,
    889986,
    778788,
    687889,
    797778,
    788887,
    897977,
    777879,
    977978,
    787669,
    888787,
    789778,
    998768,
    987868,
    867887,
    889677,
    899888,
    777969,
    877888,
    888669,
    898968,
    798868,
    796878,
    689798,
    777877,
    777789,
    888798,
    886886,
    877686,
    896876,
    788886,
    777789,
    777887,
    878787,
    977887,
    778788,
    979888,
    787999,
    779886,
    787879,
    998886,
    778778,
    888788,
    788868,
    897798,
    877798,
    887777,
    878888,
    988877,
    879898,
    979789,
    788688,
    788779,
    788777,
    988868,
    887998,
    687987,
    788888,
    767878,
    989887,
    879989,
    878778,
    788789,
    888888,
    888988,
    968897,
    687888,
    799766,
    889868,
    777878,
    967869,
    668796,
    887788,
    868698,
    787787,
    897888,
    899788,
    869997,
    678878,
    977888,
    686997,
    988778,
    886788,
    799787,
    786779,
    977789,
    886788,
    787886,
    878978,
    798888,
    797989,
    766978,
    899889,
    977877,
    877788,
    888888,
    976989,
    868889,
    887977,
    977898,
    888867,
    878768,
    878887,
    887888,
    869778,
    768877,
    899779,
    897776,
    897898,
    788889,
    788888,
    889789,
    889788,
    778867,
    886898,
    997989,
    898988,
    778978,
    777878,
    897769,
    987888,
    788887,
    788778,
    888897,
    797797,
    788887,
    798887,
    989889,
    877888,
    879789,
    878888,
    878878,
    788889,
    786878,
    777988,
    878888,
    786989,
    887888,
    678988,
    779867,
    798778,
    887888,
    898988,
    977698,
    888788,
    778888,
    888887,
    789877,
    889869,
    778799,
    999788,
    788687,
    888789,
    888879,
    879866,
    889779,
    888788,
    877869,
    768879,
    877876,
    988777,
    978799,
    877788,
    876778,
    989887,
    887787,
    967788,
    989988,
    988779,
    888888,
    868698,
    787888,
    998879,
    886887,
    887897,
    789797,
    877877,
    889987,
    778889,
    887989,
    877787,
    888787,
    677777,
    867886,
    778887,
    879887,
    899677,
    879677,
    788878,
    698796,
    887789,
    887788,
    787867,
    867878,
    687786,
    988788,
    778999,
    698788,
    797999,
    998678,
    787896,
    777777,
    898798,
    967977,
    888788,
    977887,
    897798,
    678888,
    679888,
    899787,
    878797,
    787888,
    987897,
    989788,
    987997,
    977977,
    788789,
    778779,
    978877,
    888888,
    877879,
    677866,
    988888,
    788888,
    897788,
    777798,
    687798,
    897978,
    976888,
    878988,
    788799,
    797797,
    796778,
    768679,
    878798,
    767887,
    897778,
    899987,
    788888,
    897888,
    987798,
    869987,
    778898,
    997897,
    778787,
    888887,
    878888,
    888886,
    888877,
    788889,
    888889,
    797789,
    879897,
    887977,
    878786,
    799878,
    778887,
    889799,
    897789,
    878987,
    989898,
    986889,
    867788,
    997679,
    787977,
    978878,
    887699,
    877798,
    797778,
    779887,
    786868,
    688878,
    979778,
    889987,
    877887,
    777788,
    899898,
    787888,
    899868,
    878789,
    786798,
    898888,
    868868,
    797878,
    997787,
    887777,
    878798,
    789887,
    978887,
    899799,
    898899,
    888796,
    788988,
    998788,
    777688,
    887886,
    888877,
    989677,
    897898,
    898667,
    998877,
    888888,
    878978,
    779967,
    788878,
    987877,
    788887,
    678678,
    878888,
    788977,
    987898,
    979887,
    998778,
    778868,
    777897,
    897787,
    897768,
    777889,
    787876,
    898889,
    777978,
    887977,
    798799,
    988887,
    778976,
    986777,
    797887,
    977988,
    886978,
    877989,
    987787,
    877798,
    779897,
    888888,
    888879,
    888688,
    888888,
    679987,
    787689,
    977786,
    988897,
    867997,
    986978,
    786888,
    989778,
    766788,
    787777,
    968868,
    787768,
    889788,
    799886,
    887987,
    796798,
    798797,
    889897,
    797778,
    886988,
    789788,
    888888,
    788898,
    787988,
    878876,
    989998,
    888898,
    779777,
    978889,
    898878,
    778798,
    897987,
    887787,
    976889,
    888977,
    677979,
    778788,
    977988,
    988969,
    978786,
    898868,
    887777,
    787788,
    876869,
    788979,
    887987,
    888778,
    898789,
    887797,
    999779,
    787889,
    779888,
    877779,
    699889,
    766877,
    677988,
    889997,
    799888,
    896878,
    897988,
    778988,
    778868,
    888888,
    798778,
    988888,
    787978,
    989798,
    888778,
    878997,
    888876,
    898798,
    688788,
    987888,
    799788,
    788677,
    778777,
    777898,
    888877,
    789788,
    787877,
    878878,
    787798,
    688687,
    798767,
    687977,
    888778,
    877778,
    887797,
    997878,
    777778,
    887798,
    877898,
    888977,
    788778,
    898877,
    787967,
    977787,
    889787,
    876787,
    888977,
    869889,
    778787,
    787878,
    967889,
    797768,
    779788,
    886787,
    988767,
    889968,
    889777,
    968779,
    998778,
    877986,
    887898,
    697777,
    787777,
    779887,
    878878,
    787888,
    878788,
    788887,
    787877,
    898977,
    788776,
    796878,
    899876,
    879867,
    969877,
    897888,
    787898,
    777988,
    777987,
    887777,
    887977,
    787878,
    877899,
    779776,
    777768,
    698788,
    988887,
    778978,
    898778,
    679778,
    797978,
    878778,
    998787,
    879999,
    778787,
    879878,
    678768,
    998888,
    788786,
    897886,
    898878,
    869777,
    977996,
    786877,
    778886,
    789888,
    989789,
    789869,
    869877,
    968888,
    797788,
    687687,
    868978,
    779888,
    878787,
    788779,
    878868,
    988988,
    978789,
    878988,
    788877,
    888878,
    687888,
    897889,
    877989,
    787797,
    876878,
    988797,
    879977,
    879988,
    998988,
    878877,
    988876,
    977787,
    778898,
    869987,
    876787,
    779998,
    796789,
    898988,
    888888,
    897897,
    677898,
    889877,
    789778,
    788977,
    988887,
    767787,
    898788,
    879888,
    779868,
    667787,
    897998,
    789789,
    887987,
    886687,
    899697,
    877888,
    679888,
    878878,
    678886,
    987789,
    879887,
    987777,
    887788,
    796797,
    777887,
    988997,
    978687,
    779997,
    878888,
    779797,
    888889,
    678988,
    887978,
    878888,
    678878,
    898887,
    788888,
    888687,
    697888,
    877778,
    888897,
    797787,
    699886,
    778778,
    768998,
    776978,
    796979,
    778888,
    767777,
    788779,
    898797,
    799798,
    788888,
    777877,
    976978,
    878888,
    797978,
    788877,
    888886,
    788769,
    887687,
    987787,
    897977,
    876787,
    977979,
    778778,
    798878,
    777989,
    877877,
    898787,
    987788,
    886889,
    779868,
    977877,
    976988,
    778678,
    998798,
    888988,
    978687,
    897979,
    778888,
    877868,
    788798,
    767889,
    888787,
    889698,
    888898,
    787997,
    887767,
    887878,
    768988,
    888879,
    686888,
    669789,
    798778,
    789879,
    788777,
    888887,
    878778,
    787897,
    878878,
    878887,
    887988,
    788888,
    989787,
    789889,
    877988,
    677878,
    888778,
    777768,
    889877,
    797887,
    787878,
    896778,
    796987,
    778998,
    888889,
    997678,
    988787,
    867897,
    999887,
    688887,
    968877,
    879879,
    978788,
    888877,
    877677,
    787788,
    797786,
    787777,
    968687,
    987879,
    788798,
    776798,
    879998,
    799678,
    988878,
    978768,
    799769,
    978887,
    797899,
    697798,
    897887,
    688897,
    978898,
    979788,
    888787,
    877887,
    787868,
    978789,
    688978,
    987898,
    878879,
    889798,
    788878,
    788988,
    789899,
    798786,
    876778,
    688988,
    988687,
    888978,
    688778,
    888677,
    798679,
    779778,
    789778,
    976888,
    887776,
    888989,
    687978,
    888867,
    796898,
    887779,
    779978,
    888897,
    779888,
    989797,
    879878,
    988788,
    798898,
    888797,
    877779,
    788789,
    887787,
    889877,
    888878,
    967777,
    677797,
    797888,
    979779,
    897788,
    988879,
    988789,
    778778,
    789996,
    999777,
    777767,
    889788,
    879679,
    978879,
    878778,
    889777,
    778899,
    888889,
    888769,
    897997,
    788788,
    988689,
    879898,
    878788,
    788879,
    978987,
    987897,
    777778,
    977778,
    987868,
    798788,
    779788,
    778979,
    777779,
    978879,
    887878,
    889897,
    788978,
    977889,
    779787,
    876988,
    899878,
    888879,
    997877,
    779998,
    888877,
    779877,
    897988,
    777778,
    888887,
    779988,
    878967,
    689666,
    697867,
    868877,
    788888,
    988798,
    789879,
    688798,
    988877,
    788778,
    889889,
    979887,
    978789,
    867878,
    798989,
    787787,
    977897,
    796968,
    979696,
    897789,
    789887,
    797787,
    887887,
    886798,
    778896,
    797797,
    996778,
    997888,
    887777,
    887888,
    977697,
    679787,
    677897,
    788878,
    787799,
    798777,
    689987,
    798897,
    899886,
    899789,
    687777,
    977899,
    788987,
    678778,
    689787,
    996978,
    878888,
    897789,
    889778,
    887988,
    897778,
    789989,
    868889,
    978787,
    877888,
    897678,
    878779,
    888996,
    887778,
    787878,
    899968,
    877786,
    787887,
    788987,
    778999,
    889698,
    977788,
    988878,
    769999,
    899788,
    987869,
    977989,
    978889,
    777988,
    888679,
    688789,
    888996,
    878767,
    788898,
    767987,
    889879,
    788878,
    778779,
    989897,
    686887,
    986878,
    899899,
    889787,
    889698,
    979677,
    887778,
    789889,
    898888,
    888787,
    799968,
    868777,
    888888,
    987967,
    787888,
    888887,
    677897,
    887988,
    798898,
    997989,
    877889,
    977998,
    879878,
    879778,
    898878,
    687988,
    787787,
    788878,
    989878,
    778797,
    797888,
    997888,
    987989,
    987888,
    788887,
    887778,
    998888,
    887798,
    998768,
    877889,
    798689,
    769787,
    689888,
    798887,
    777798,
    789887,
    887979,
    997887,
    897979,
    698668,
    687898,
    867878,
    899887,
    978899,
    876887,
    897777,
    778788,
    897897,
    888967,
    869687,
    889977,
    887788,
    879788,
    769898,
    777677,
    889888,
    787779,
    787888,
    878998,
    969888,
    888797,
    869789,
    788877,
    897789,
    679897,
    789778,
    887888,
    997688,
    997768,
    888878,
    889789,
    968967,
    889778,
    887999,
    788968,
    787886,
    778888,
    889978,
    888877,
    877886,
    776887,
    988898,
    877888,
    778788,
    798876,
    977896,
    798898,
    877878,
    987987,
    787986,
    798789,
    878998,
    878778,
    778777,
    797786,
    879889,
    797687,
    986687,
    877889,
    877789,
    778988,
    698988,
    887897,
    898977,
    667998,
    978798,
    879888,
    789877,
    677889,
    878688,
    788779,
    989987,
    898799,
    778788,
    896986,
    878788,
    977978,
    796769,
    788778,
    887978,
    878798,
    997889,
    997687,
    789877,
    768688,
    767667,
    789798,
    889888,
    879877,
    899899,
    898787,
    799878,
    787898,
    999877,
    787879,
    777797,
    778988,
    797776,
    898967,
    889978,
    688878,
    877977,
    877877,
    799789,
    989797,
    979888,
    988888,
    697989,
    778769,
    777888,
    777879,
    877877,
    888999,
    688988,
    876788,
    799769,
    888889,
    778867,
    797878,
    787796,
    887797,
    889988,
    778789,
    898888,
    899789,
    879878,
    977797,
    788766,
    788788,
    879878,
    877787,
    887886,
    879798,
    987997,
    898878,
    688699,
    867897,
    967778,
    998769,
    768788,
    787778,
    888888,
    686789,
    688879,
    878978,
    877977,
    686878,
    887897,
    686976,
    677996,
    787687,
    887987,
    687896,
    886888,
    686999,
    978887,
    988889,
    798977,
    987677,
    899768,
    888789,
    779888,
    977889,
    798788,
    779679,
    897998,
    787888,
    769788,
    987777,
    888877,
    788887,
    986779,
    999988,
    778876,
    787877,
    797988,
    799876,
    686777,
    777978,
    888978,
    867777,
    888699,
    989898,
    878987,
    886798,
    888898,
    796698,
    789987,
    878888,
    879886,
    888797,
    888788,
    978688,
    878887,
    877778,
    797698,
    887979,
    897888,
    978879,
    877788,
    788889,
    787777,
    897888,
    789787,
    889797,
    776777,
    977686,
    989887,
    787888,
    988897,
    976988,
    879869,
    777878,
    798777,
    987879,
    898879,
    789778,
    887788,
    879897,
    878888,
    778887,
    677786,
    979787,
    688888,
    778987,
    696986,
    798789,
    687797,
    777798,
    877888,
    788887,
    777698,
    887887,
    877968,
    987887,
    789789,
    797787,
    877788,
    898799,
    886778,
    888879,
    688877,
    797888,
    997966,
    899777,
    777778,
    888866,
    789898,
    787788,
    887986,
    689687,
    798878,
    989788,
    878997,
    799767,
    898678,
    877877,
    888977,
    897788,
    787977,
    678788,
    697888,
    877979,
    788787,
    686989,
    976878,
    689778,
    987988,
    778687,
    988788,
    778787,
    888777,
    977877,
    898997,
    799868,
    787989,
    987768,
    878787,
    897676,
    988898,
    988787,
    877996,
    778798,
    777787,
    998778,
    668798,
    988987,
    879988,
    887879,
    768786,
    867688,
    889978,
    879789,
    677778,
    877797,
    787868,
    888888,
    889797,
    888976,
    878877,
    779788,
    678788,
    788989,
    787987,
    787787,
    789887,
    677888,
    877778,
    789986,
    779767,
    778798,
    777888,
    798877,
    879989,
    788767,
    989887,
    778778,
    686988,
    888899,
    888869,
    698977,
    877998,
    888887,
    978776,
    887877,
    887988,
    897877,
    879787,
    787889,
    787986,
    678777,
    887879,
    989789,
    888777,
    678877,
    888989,
    788788,
    889978,
    977798,
    878989,
    878877,
    778898,
    778779,
    888876,
    888679,
    768887,
    987877,
    889778,
    986789,
    787968,
    888886,
    698688,
    878877,
    779898,
    877777,
    788788,
    877888,
    876878,
    896969,
    788877,
    988998,
    788888,
    988867,
    698887,
    979878,
    888789,
    696896,
    887878,
    987777,
    888977,
    988897,
    699688,
    797898,
    788778,
    787897,
    778877,
    787788,
    879898,
    978798,
    887977,
    787778,
    879878,
    767887,
    889977,
    989877,
    798878,
    879878,
    879887,
    878898,
    898776,
    979788,
    879898,
    887777,
    678988,
    889788,
    897798,
    787967,
    678989,
    676867,
    978868,
    898988,
    978788,
    788877,
    888988,
    878998,
    789788,
    889878,
    798897,
    997878,
    878876,
    897878,
    987777,
    789877,
    889887,
    777778,
    787889,
    997977,
    979676,
    889889,
    788878,
    889888,
    787898,
    888887,
    989866,
    787798,
    888877,
    789879,
    888788,
    999678,
    968778,
    987798,
    898688,
    887779,
    969897,
    876879,
    887878,
    788878,
    699888,
    878998,
    769787,
    787789,
    888768,
    787897,
    797978,
    777868,
    887797,
    787987,
    878788,
    679998,
    797877,
    798888,
    878778,
    869878,
    887998,
    687899,
    878888,
    986877,
    879877,
    797988,
    888978,
    889876,
    789897,
    887777,
    677778,
    788769,
    779988,
    887678,
    988778,
    987779,
    897886,
    789988,
    878969,
    778887,
    799897,
    977997,
    898678,
    889797,
    887778,
    898868,
    788778,
    788788,
    778788,
    988899,
    988788,
    986789,
    878777,
    886898,
    689877,
    878767,
    988889,
    777777,
    799786,
    867869,
    898686,
    898787,
    789988,
    778788,
    867787,
    797979,
    888877,
    787777,
    879788,
    869877,
    699788,
    868877,
    798787,
    788789,
    988968,
    788778,
    897787,
    688678,
    797898,
    787686,
    779788,
    787977,
    978797,
    788789,
    888797,
    787897,
    879987,
    867878,
    887898,
    977899,
    967879,
    987877,
    788789,
    968888,
    888687,
    897767,
    878798,
    788887,
    867898,
    989877,
    987878,
    898679,
    897878,
    887877,
    796787,
    977878,
    788776,
    889788,
    777896,
    777797,
    878796,
    788788,
    878987,
    868788,
    898888,
    899788,
    887888,
    898888,
    968988,
    888878,
    788878,
    878778,
    887888,
    898989,
    788987,
    788788,
    787787,
    988788,
    897888,
    878877,
    677976,
    877999,
    787786,
    879886,
    788977,
    877689,
    878887,
    797986,
    889876,
    788788,
    877786,
    878978,
    677769,
    778888,
    888788,
    888978,
    877799,
    889878,
    777878,
    887888,
    878988,
    867778,
    778777,
    788887,
    788779,
    999789,
    986878,
    888787,
    789777,
    878789,
    777887,
    866887,
    978787,
    788897,
    778977,
    877876,
    868799,
    867786,
    878887,
    888887,
    778778,
    986978,
    989889,
    888787,
    768998,
    889978,
    779889,
    878887,
    977988,
    888777,
    887887,
    978897,
    889868,
    888878,
    878879,
    867988,
    887779,
    798877,
    688867,
    877899,
    887777,
    787997,
    987786,
    899799,
    978898,
    788777,
    888798,
    777787,
    888779,
    887986,
    889789,
    779889,
    889768,
    787797,
    779878,
    788877,
    788789,
    898687,
    887979,
    777867,
    787768,
    777679,
    878788,
    787988,
    789999,
    798877,
    987776,
    977988,
    998878,
    979687,
    787789,
    877889,
    887798,
    878978,
    799979,
    897779,
    788888,
    886879,
    788888,
    789788,
    878978,
    767777,
    987799,
    698887,
    778878,
    889787,
    877787,
    878876,
    887877,
    979897,
    987878,
    777889,
    878778,
    887787,
    788786,
    878788,
    867976,
    888878,
    698998,
    889888,
    877877,
    767878,
    897778,
    777788,
    887787,
    888978,
    778888,
    767878,
    999789,
    777779,
    888677,
    887776,
    878799,
    978889,
    779887,
    779799,
    768887,
    988779,
    969877,
    876888,
    769867,
    877779,
    987977,
    987978,
    878888,
    787688,
    786778,
    878767,
    787886,
    988788,
    887877,
    777777,
    788778,
    769988,
    798788,
    776778,
    788799,
    779797,
    879799,
    987679,
    989977,
    797797,
    987898,
    889779,
    999778,
    778997,
    876887,
    797767,
    777878,
    878787,
    778898,
    877787,
    887988,
    987888,
    877989,
    878789,
    889898,
    877897,
    986978,
    978888,
    888899,
    898979,
    977878,
    998798,
    779899,
    989877,
    877788,
    888877,
    898888,
    788979,
    888769,
    787798,
    768997,
    778888,
    987786,
    778887,
    787897,
    678878,
    777898,
    787887,
    988989,
    988788,
    877988,
    889978,
    977887,
    887888,
    996898,
    878978,
    897768,
    778887,
    788878,
    767989,
    888878,
    987789,
    776978,
    787788,
    898979,
    979778,
    786978,
    887987,
    887687,
    778978,
    767777,
    687698,
    679687,
    787778,
    778789,
    887798,
    978998,
    987977,
    888698,
    889967,
    889889,
    998888,
    879967,
    778788,
    977887,
    879778,
    898876,
    987887,
    789888,
    967987,
    697768,
    897887,
    887679,
    887877,
    798878,
    788977,
    988888,
    877877,
    887888,
    878667,
    898877,
    896689,
    988778,
    788996,
    769886,
    888897,
    879878,
    878788,
    786888,
    988787,
    898897,
    789797,
    887887,
    888877,
    787899,
    978798,
    999779,
    888877,
    788979,
    888778,
    887788,
    889788,
    897987,
    989687,
    878788,
    988988,
    778766,
    788778,
    767888,
    776877,
    997996,
    886987,
    788678,
    877877,
    678789,
    998767,
    788887,
    979788,
    787878,
    878876,
    876878,
    997888,
    988889,
    778889,
    988998,
    688889,
    897887,
    888889,
    687787,
    678878,
    798898,
    888988,
    987778,
    977878,
    877997,
    878988,
    779868,
    688887,
    878788,
    778877,
    989877,
    898977,
    777978,
    868889,
    688888,
    798689,
    798799,
    888799,
    798787,
    897898,
    888887,
    977888,
    887877,
    778888,
    978889,
    798888,
    988886,
    888977,
    987989,
    797787,
    798988,
    887887,
    977868,
    878698,
    789787,
    797877,
    887788,
    778888,
    986887,
    888987,
    769887,
    878877,
    898688,
    797766,
    669777,
    889979,
    668777,
    888888,
    787869,
    778799,
    898778,
    987689,
    999988,
    798887,
    968888,
    787988,
    767979,
    988978,
    788698,
    878788,
    987788,
    886768,
    799787,
    887787,
    988688,
    779887,
    888899,
    889778,
    888898,
    888879,
    988888,
    778788,
    788697,
    888778,
    678878,
    888888,
    989779,
    787888,
    779887,
    888878,
    888888,
    888777,
    787787,
    877987,
    898888,
    888876,
    898886,
    877788,
    988796,
    888888,
    789879,
    799898,
    788999,
    769887,
    779898,
    898798,
    879778,
    897988,
    787887,
    978798,
    787898,
    877667,
    788787,
    768678,
    798887,
    698797,
    788989,
    969879,
    797797,
    878899,
    779967,
    887979,
    797779,
    879887,
    789789,
    878968,
    788798,
    788987,
    889967,
    987988,
    789988,
    877688,
    878777,
    897966,
    789797,
    687887,
    788977,
    977778,
    787878,
    888987,
    998878,
    887779,
    788878,
    879879,
    998786,
    897878,
    997788,
    898988,
    978779,
    989877,
    979788,
    889877,
    798776,
    878989,
    787778,
    877687,
    779798,
    796778,
    867969,
    676997,
    878887,
    778879,
    888789,
    888699,
    899687,
    987777,
    977877,
    777778,
    886997,
    887877,
    777889,
    898887,
    887776,
    778788,
    888978,
    877777,
    998788,
    998787,
    789788,
    879878,
    788869,
    878898,
    788877,
    787678,
    777888,
    778798,
    868887,
    797876,
    998987,
    679778,
    887798,
    886899,
    678799,
    778797,
    977798,
    986788,
    677898,
    887889,
    797887,
    987797,
    877778,
    898878,
    899787,
    787978,
    887897,
    876897,
    777978,
    767878,
    988888,
    968768,
    788978,
    786799,
    969798,
    899878,
    879869,
    878899,
    888888,
    777877,
    987888,
    886789,
    689888,
    877788,
    769898,
    886887,
    888898,
    899968,
    787778,
    786677,
    989988,
    796897,
    768788,
    897987,
    788698,
    978987,
    977867,
    888687,
    897887,
    888777,
    988897,
    789987,
    777987,
    798887,
    888988,
    886668,
    788978,
    679878,
    877888,
    888776,
    777977,
    788877,
    877888,
    868788,
    877978,
    699887,
    898878,
    878779,
    877697,
    687879,
    898889,
    999788,
    778779,
    777967,
    778888,
    697978,
    987888,
    797968,
    878887,
    896888,
    897688,
    888867,
    899778,
    778788,
    798986,
    977967,
    897877,
    777889,
    888877,
    897898,
    888988,
    888987,
    866798,
    768887,
    886769,
    998877,
    897867,
    988898,
    778878,
    797998,
    888777,
    887788,
    789878,
    898868,
    888878,
    979888,
    999987,
    989987,
    798888,
    888889,
    797897,
    886967,
    687978,
    977686,
    786888,
    779687,
    988987,
    787877,
    877978,
    978996,
    786989,
    877787,
    876889,
    988768,
    999878,
    878887,
    878898,
    877897,
    788987,
    888788,
    878787,
    788898,
    788689,
    887788,
    987997,
    788886,
    899777,
    888887,
    688887,
    788988,
    888878,
    888797,
    998897,
    898888,
    888888,
    988977,
    899778,
    787778,
    898798,
    888888,
    898878,
    878988,
    776877,
    776877,
    888997,
    788787,
    786887,
    799787,
    889879,
    787989,
    888889,
    997798,
    787888,
    777798,
    887978,
    888889,
    777787,
    887799,
    888778,
    979879,
    689997,
    688787,
    796878,
    788779,
    887788,
    778867,
    879889,
    896889,
    887788,
    889877,
    897777,
    888688,
    887789,
    788897,
    879786,
    877898,
    888877,
    798889,
    678888,
    979887,
    778888,
    877877,
    898878,
    977788,
    889698,
    898987,
    879999,
    876978,
    888877,
    878878,
    797877,
    778868,
    788878,
    977778,
    767989,
    779797,
    999979,
    768878,
    889687,
    886789,
    899878,
    897977,
    788797,
    778986,
    788888,
    887677,
    878879,
    887779,
    778777,
    889779,
    888999,
    988997,
    887878,
    888799,
    787799,
    778868,
    689978,
    876888,
    888789,
    787986,
    988887,
    886998,
    779876,
    998877,
    766898,
    787788,
    888888,
    878677,
    797788,
    787988,
    899978,
    888867,
    888888,
    777869,
    888788,
    877878,
    897998,
    977897,
    887688,
    899797,
    678987,
    688998,
    986877,
    777887,
    778787,
    867877,
    877989,
    679787,
    798767,
    768698,
    776778,
    889989,
    778887,
    778967,
    888888,
    876887,
    878778,
    898687,
    887798,
    779988,
    778689,
    877888,
    786779,
    799997,
    887798,
    787878,
    897878,
    766988,
    879769,
    787887,
    897888,
    897789,
    889978,
    877989,
    877798,
    967787,
    888978,
    799898,
    989988,
    889778,
    678877,
    888678,
    787987,
    988787,
    988867,
    779899,
    898799,
    888988,
    878897,
    789779,
    788877,
    788698,
    768888,
    889898,
    788887,
    887887,
    978888,
    888887,
    787789,
    898977,
    868876,
    789786,
    679999,
    877899,
    877877,
    898888,
    777887,
    877888,
    868879,
    897879,
    898898,
    979878,
    976778,
    897888,
    888798,
    897886,
    788888,
    769687,
    997889,
    787778,
    788889,
    877799,
    778879,
    688768,
    776967,
    779789,
    787778,
    877778,
    998989,
    886878,
    788889,
    989898,
    877788,
    778788,
    877898,
    988878,
    989887,
    786989,
    888898,
    878988,
    897887,
    777878,
    688878,
    697798,
    787799,
    886777,
    778788,
    788879,
    898969,
    878787,
    888988,
    689887,
    778888,
    879979,
    888877,
    889869,
    997868,
    988897,
    798688,
    779786,
    887796,
    788697,
    878788,
    788787,
    989897,
    687987,
    978888,
    888777,
    979777,
    877877,
    887879,
    889677,
    776796,
    879977,
    777877,
    888977,
    898988,
    987897,
    768897,
    777779,
    789888,
    888768,
    898888,
    777786,
    879998,
    677887,
    887888,
    878777,
    888877,
    998879,
    778888,
    898867,
    887887,
    777888,
    778878,
    879889,
    788978,
    896787,
    888877,
    787778,
    898786,
    898998,
    788777,
    989898,
    989898,
    886997,
    888887,
    778788,
    889788,
    669897,
    888987,
    879879,
    798867,
    877887,
    786778,
    767896,
    898888,
    987779,
    988888,
    879798,
    889889,
    867879,
    889779,
    887868,
    768886,
    869778,
    879897,
    798787,
    788867,
    777987,
    788887,
    888789,
    887888,
    798977,
    878888,
    877886,
    876988,
    887787,
    998889,
    678888,
    897887,
    887968,
    889988,
    867679,
    898869,
    898778,
    787888,
    887877,
    977999,
    688887,
    797879,
    679879,
    888687,
    898888,
    899888,
    878788,
    888987,
    797997,
    796979,
    688888,
    789886,
    869898,
    777767,
    967778,
    788977,
    898987,
    888787,
    978887,
    777797,
    867699,
    689889,
    789787,
    787886,
    678798,
    777767,
    778898,
    888998,
    797878,
    889897,
    788898,
    797888,
    868779,
    868789,
    799897,
    879888,
    978678,
    989989,
    789987,
    987787,
    999787,
    889888,
    889888,
    877888,
    997989,
    887877,
    788978,
    888898,
    977887,
    979878,
    878779,
    677888,
    888778,
    989787,
    878878,
    888887,
    877877,
    877688,
    988987,
    697667,
    998889,
    888799,
    877887,
    877987,
    797767,
    987789,
    797888,
    877677,
    878978,
    777868,
    888998,
    888888,
    898997,
    997986,
    678786,
    987787,
    878988,
    778988,
    777986,
    789886,
    686789,
    876868,
    887997,
    788888,
    888668,
    778888,
    767879,
    788889,
    877787,
    799887,
    977888,
    888777,
    899778,
    889887,
    887687,
    877777,
    887996,
    799979,
    769797,
    787898,
    788887,
    787798,
    866789,
    778789,
    788998,
    776789,
    788779,
    888777,
    888878,
    886697,
    789778,
    998888,
    888786,
    777987,
    877868,
    988697,
    788787,
    888877,
    888989,
    678786,
    777787,
    878787,
    879888,
    877897,
    887768,
    888796,
    788977,
    777789,
    787866,
    998989,
    689779,
    987868,
    978877,
    877877,
    778787,
    888769,
    989997,
    889878,
    989878,
    898997,
    777889,
    878987,
    788788,
    778787,
    888769,
    887767,
    889788,
    888998,
    878778,
    678887,
    878778,
    888677,
    799978,
    768787,
    978878,
    898878,
    888877,
    898787,
    978888,
    889787,
    897898,
    789788,
    887787,
    889887,
    797888,
    778978,
    678978,
    777779,
    768688,
    868779,
    878878,
    968978,
    888867,
    697978,
    977787,
    878787,
    989898,
    887986,
    678877,
    877898,
    888988,
    889799,
    886987,
    777789,
    877777,
    898887,
    988787,
    878888,
    977687,
    688886,
    886888,
    997777,
    786886,
    678797,
    887888,
    786888,
    988888,
    998877,
    687898,
    787878,
    888889,
    899677,
    878878,
    888877,
    788798,
    887767,
    988788,
    888777,
    887897,
    897778,
    978877,
    868889,
    779798,
    779879,
    988978,
    978977,
    988779,
    777776,
    767789,
    878988,
    887898,
    998797,
    699799,
    879787,
    877786,
    988798,
    777767,
    778988,
    979877,
    778868,
    788887,
    797787,
    989689,
    867768,
    988889,
    987986,
    998898,
    887899,
    988779,
    987677,
    787899,
    989777,
    897797,
    988799,
    876788,
    779778,
    688977,
    889778,
    888778,
    788787,
    877767,
    969797,
    989878,
    788888,
    887787,
    767879,
    767879,
    967788,
    887679,
    797888,
    866898,
    889877,
    878988,
    788869,
    896688,
    886887,
    788988,
    867777,
    898768,
    889788,
    869877,
    877777,
    798678,
    987778,
    788888,
    778889,
    877678,
    977776,
    679887,
    868888,
    898768,
    798788,
    888887,
    788897,
    778979,
    887888,
    779888,
    787887,
    688887,
    867898,
    888788,
    787677,
    967768,
    798887,
    898887,
    789977,
    888797,
    697788,
    987988,
    888778,
    878898,
    889779,
    679878,
    878787,
    988978,
    978899,
    789978,
    678889,
    889887,
    987888,
    888889,
    688779,
    878888,
    777768,
    788787,
    877877,
    788789,
    997878,
    968979,
    898877,
    877779,
    778679,
    797987,
    788899,
    897798,
    768798,
    788887,
    899777,
    888889,
    986988,
    766689,
    989878,
    778787,
    898697,
    888678,
    878769,
    878876,
    977798,
    887787,
    786867,
    778878,
    898987,
    778988,
    888969,
    899788,
    898879,
    879778,
    768866,
    877889,
    777897,
    788998,
    889786,
    788768,
    987877,
    689888,
    987798,
    778878,
    788787,
    788678,
    776887,
    887798,
    679688,
    989899,
    977889,
    777788,
    886789,
    877899,
    888788,
    888988,
    888988,
    898897,
    888788,
    797968,
    888788,
    789977,
    878877,
    896877,
    989778,
    789887,
    698797,
    987667,
    897988,
    988899,
    789888,
    868789,
    687779,
    889988,
    798968,
    677978,
    888876,
    888987,
    888788,
    979788,
    898879,
    768988,
    998997,
    899788,
    777888,
    878679,
    898778,
    897878,
    978777,
    888977,
    778877,
    789888,
    998798,
    788789,
    888777,
    889788,
    878898,
    886697,
    898878,
    977879,
    987899,
    788987,
    799787,
    998988,
    788898,
    898768,
    788899,
    888797,
    986877,
    786888,
    979889,
    798877,
    878877,
    897778,
    878889,
    977878,
    897888,
    777978,
    887888,
    787688,
    898897,
    788998,
    987998,
    776788,
    976778,
    879777,
    879978,
    797988,
    887879,
    788899,
    798878,
    779967,
    668687,
    868888,
    898987,
    888888,
    978887,
    878688,
    888888,
    886777,
    778787,
    886888,
    997879,
    797889,
    877886,
    878799,
    997988,
    697887,
    987898,
    898668,
    889988,
    887788,
    788868,
    987788,
    777997,
    787797,
    898869,
    879988,
    888898,
    797786,
    787776,
    879879,
    878877,
    989988,
    869979,
    887799,
    887888,
    878878,
    989878,
    878898,
    777679,
    798988,
    878887,
    669978,
    988778,
    778877,
    777886,
    978877,
    977678,
    987888,
    779687,
    777878,
    979887,
    876788,
    897888,
    988696,
    778788,
    888797,
    869698,
    788789,
    988899,
    887788,
    978988,
    889788,
    887889,
    799888,
    897888,
    887688,
    877768,
    778899,
    888787,
    888878,
    778999,
    899987,
    877879,
    788878,
    888799,
    888788,
    879797,
    888877,
    778787,
    887878,
    969889,
    787898,
    988898,
    889889,
    888889,
    778776,
    797988,
    887898,
    778777,
    787777,
    778887,
    877988,
    797878,
    879887,
    987797,
    988866,
    789889,
    789897,
    987788,
    888998,
    998789,
    898899,
    889678,
    877789,
    787987,
    798887,
    996868,
    878778,
    897887,
    797867,
    779787,
    788997,
    788886,
    696797,
    887678,
    878878,
    978889,
    888796,
    889778,
    788779,
    688789,
    778796,
    888978,
    878788,
    868988,
    877798,
    898887,
    999798,
    978987,
    888878,
    887676,
    789979,
    788887,
    978777,
    779868,
    889987,
    699779,
    987886,
    776789,
    878987,
    787776,
    987888,
    888977,
    986778,
    777898,
    797888,
    888896,
    988889,
    987788,
    978878,
    777778,
    788678,
    877796,
    776877,
    877779,
    778988,
    989688,
    779899,
    878998,
    898867,
    788879,
    778787,
    879878,
    668967,
    977898,
    988797,
    997779,
    976988,
    887887,
    878688,
    977779,
    787989,
    897897,
    888899,
    798677,
    888886,
    797698,
    878689,
    886786,
    897787,
    877689,
    978777,
    988778,
    797888,
    888879,
    778787,
    797977,
    888688,
    779789,
    898889,
    788788,
    888878,
    877889,
    988878,
    996789,
    787797,
    797788,
    878688,
    798777,
    876878,
    888777,
    799998,
    798977,
    677989,
    978767,
    997898,
    879877,
    798888,
    988898,
    778878,
    977887,
    888988,
    877897,
    798888,
    997798,
    787987,
    899776,
    778767,
    896888,
    886977,
    777877,
    997887,
    887998,
    879878,
    986869,
    887897,
    788988,
    879897,
    877777,
    987779,
    888987,
    887977,
    797887,
    888889,
    776888,
    879998,
    777878,
    898886,
    789886,
    678686,
    967788,
    789776,
    978777,
    787887,
    889789,
    788978,
    797798,
    888978,
    987968,
    768799,
    999897,
    798779,
    898978,
    889986,
    778788,
    986787,
    778888,
    796978,
    787799,
    778898,
    897777,
    876798,
    788987,
    987779,
    779868,
    898899,
    788897,
    887877,
    889798,
    698898,
    788987,
    777878,
    978988,
    787787,
    879779,
    777788,
    986889,
    888897,
    787988,
    887988,
    867988,
    878876,
    777977,
    988888,
    787889,
    788887,
    778899,
    776996,
    779886,
    887776,
    897887,
    979679,
    768967,
    878797,
    979787,
    978799,
    787677,
    886977,
    889888,
    888898,
    868787,
    898797,
    986888,
    788988,
    887898,
    978796,
    977777,
    988868,
    888867,
    977777,
    879888,
    987789,
    879887,
    787788,
    979888,
    878797,
    888978,
    797787,
    777767,
    979878,
    776877,
    989977,
    887869,
    687878,
    998888,
    789688,
    787879,
    997889,
    889688,
    888878,
    779987,
    889878,
    786778,
    868787,
    987898,
    888799,
    986866,
    898688,
    779978,
    998777,
    888897,
    888887,
    986998,
    698787,
    779897,
    668677,
    886877,
    897799,
    777799,
    777886,
    877888,
    878788,
    777898,
    787788,
    886778,
    778888,
    988898,
    878778,
    777879,
    878777,
    777788,
    877886,
    689777,
    979898,
    887778,
    979776,
    777878,
    898977,
    988888,
    988877,
    987777,
    778966,
    787879,
    879878,
    799889,
    898788,
    777878,
    898998,
    986866,
    788878,
    978877,
    767997,
    998898,
    688897,
    798897,
    877689,
    877699,
    898767,
    768998,
    798978,
    788886,
    888778,
    789787,
    979886,
    797788,
    998887,
    977799,
    878887,
    988768,
    868877,
    897878,
    767778,
    887867,
    897778,
    889899,
    678887,
    886898,
    897777,
    886877,
    998788,
    897789,
    976878,
    686778,
    878877,
    887879,
    876877,
    888677,
    968788,
    988888,
    797888,
    787776,
    998988,
    797768,
    669778,
    778898,
    886987,
    888877,
    888789,
    778877,
    888799,
    887979,
    688888,
    987878,
    778867,
    879678,
    778977,
    898787,
    767789,
    878778,
    897788,
    787687,
    868879,
    978877,
    898889,
    697887,
    788878,
    898878,
    887868,
    889988,
    987878,
    788878,
    799888,
    988878,
    777669,
    979877,
    889888,
    697779,
    897677,
    887978,
    989789,
    798786,
    986688,
    878788,
    898788,
    988887,
    888877,
    877778,
    987877,
    898779,
    877878,
    977887,
    769898,
    787778,
    879777,
    876877,
    779778,
    867878,
    877887,
    888868,
    786678,
    687899,
    797776,
    679799,
    899689,
    996869,
    897878,
    878878,
    677888,
    789778,
    877999,
    788777,
    779788,
    696889,
    977988,
    787887,
    797889,
    786877,
    887978,
    879988,
    777688,
    899688,
    868978,
    878877,
    898988,
    888788,
    787876,
    789888,
    986777,
    869787,
    988999,
    777898,
    788887,
    767888,
    888887,
    767886,
    879788,
    897887,
    786987,
    877678,
    788888,
    977788,
    878887,
    879688,
    988788,
    976797,
    968888,
    889879,
    777978,
    977789,
    789988,
    899877,
    787767,
    979788,
    788877,
    887988,
    889878,
    778889,
    997796,
    778887,
    789797,
    867898,
    887887,
    989788,
    887977,
    879897,
    776878,
    879988,
    887897,
    898878,
    878887,
    887788,
    778977,
    877778,
    888877,
    778877,
    778988,
    988888,
    989896,
    897676,
    788987,
    787877,
    887777,
    978987,
    687687,
    988889,
    888788,
    777988,
    788889,
    868786,
    978888,
    877877,
    788797,
    798789,
    888998,
    877878,
    696888,
    989979,
    877787,
    877997,
    887886,
    777888,
    878788,
    878777,
    897998,
    688888,
    789789,
    888997,
    887889,
    886778,
    987888,
    976788,
    998777,
    677778,
    898877,
    889868,
    788779,
    778798,
    788867,
    888898,
    888888,
    897887,
    777877,
    868998,
    987978,
    986778,
    998899,
    787888,
    787889,
    788877,
    777977,
    787787,
    787888,
    776677,
    678686,
    778898,
    888688,
    879698,
    879798,
    898787,
    887788,
    888897,
    886877,
    889889,
    887767,
    889778,
    998988,
    888888,
    887887,
    676878,
    789679,
    887988,
    897879,
    997877,
    877988,
    786886,
    987889,
    888887,
    988798,
    869896,
    777778,
    988899,
    669788,
    877887,
    779878,
    977989,
    888878,
    998899,
    797877,
    788889,
    667778,
    878979,
    779978,
    977877,
    898968,
    787778,
    769878,
    878799,
    887888,
    779778,
    866987,
    779887,
    797987,
    877777,
    888889,
    889877,
    877988,
    977978,
    778977,
    987798,
    887977,
    888687,
    888689,
    778899,
    769796,
    867897,
    797667,
    897768,
    686999,
    897878,
    676789,
    889889,
    988777,
    787777,
    879789,
    878777,
    988877,
    889778,
    889878,
    787767,
    888977,
    798788,
    967798,
    779789,
    887888,
    897887,
    789787,
    766797,
    888988,
    988789,
    987998,
    778789,
    887979,
    889779,
    777878,
    977778,
    778888,
    887877,
    867769,
    879887,
    898878,
    879887,
    878779,
    979987,
    888988,
    899998,
    799789,
    887888,
    877778,
    798998,
    998889,
    877876,
    887788,
    888887,
    787888,
    877977,
    787878,
    878778,
    777977,
    897979,
    777687,
    988777,
    778987,
    979987,
    898877,
    788789,
    888788,
    868886,
    778988,
    999869,
    877689,
    977879,
    899988,
    898796,
    878798,
    878788,
    897778,
    888968,
    897976,
    787886,
    977778,
    899688,
    897878,
    978997,
    887778,
    998988,
    898878,
    877987,
    698788,
    878788,
    687887,
    888899,
    799977,
    779887,
    788898,
    688888,
    888677,
    877887,
    778778,
    777977,
    787988,
    978987,
    979878,
    888898,
    888877,
    779877,
    888987,
    888779,
    798898,
    887997,
    899767,
    896689,
    888796,
    888697,
    798869,
    888769,
    879677,
    877668,
    878777,
    777877,
    798878,
    888679,
    787879,
    678868,
    998778,
    888999,
    979897,
    788889,
    788787,
    787787,
    897798,
    787778,
    677987,
    967887,
    786777,
    686997,
    798887,
    878799,
    778877,
    689779,
    687988,
    988888,
    879898,
    898888,
    887889,
    989797,
    887868,
    677778,
    778797,
    677877,
    998887,
    979899,
    777777,
    798888,
    789888,
    986768,
    876876,
    687787,
    788887,
    778989,
    888689,
    988777,
    788977,
    778788,
    887796,
    888686,
    788997,
    988887,
    887987,
    697878,
    788797,
    697779,
    898978,
    888879,
    888789,
    788778,
    788868,
    878987,
    788778,
    878888,
    897786,
    987888,
    877877,
    888876,
    979798,
    778779,
    888977,
    889798,
    988798,
    898677,
    888888,
    799887,
    987987,
    789778,
    787877,
    888788,
    787887,
    898688,
    789878,
    788777,
    897688,
    889868,
    898887,
    687978,
    887898,
    779979,
    899779,
    888777,
    787788,
    787877,
    878888,
    987898,
    888788,
    997787,
    897879,
    678777,
    777887,
    988878,
    888879,
    788897,
    788878,
    766788,
    999878,
    799979,
    779878,
    787988,
    876897,
    978898,
    878688,
    988997,
    888998,
    999777,
    878877,
    899689,
    687888,
    878898,
    787998,
    798879,
    777887,
    789889,
    869877,
    699978,
    888888,
    887878,
    968886,
    799888,
    788788,
    896678,
    779878,
    797987,
    779788,
    986887,
    778888,
    778879,
    798967,
    868879,
    877799,
    888897,
    788897,
    787978,
    888987,
    786877,
    889798,
    697967,
    889879,
    789777,
    877878,
    779788,
    779687,
    986787,
    987667,
    868786,
    997788,
    788797,
    688787,
    698797,
    678779,
    889878,
    778887,
    899787,
    887678,
    867698,
    888886,
    989798,
    679878,
    777688,
    878677,
    778978,
    998889,
    776877,
    667889,
    689787,
    996977,
    798798,
    888989,
    789769,
    988888,
    777789,
    887878,
    788889,
    777878,
    889888,
    888888,
    998788,
    689897,
    897689,
    878986,
    768789,
    889877,
    879688,
    787887,
    666798,
    777988,
    789777,
    987787,
    787778,
    667777,
    779888,
    898889,
    888889,
    897987,
    688889,
    778776,
    898877,
    878878,
    866889,
    788676,
    788788,
    998887,
    998887,
    889799,
    798778,
    988889,
    878998,
    878968,
    877798,
    788989,
    977877,
    878868,
    786787,
    878687,
    888679,
    778879,
    788799,
    687887,
    679866,
    879887,
    988969,
    777878,
    796887,
    797797,
    888777,
    786878,
    998898,
    777777,
    688897,
    998768,
    987998,
    877898,
    978787,
    777886,
    998887,
    778877,
    898988,
    878797,
    876889,
    788879,
    989888,
    888776,
    787778,
    669779,
    989796,
    888987,
    877876,
    888689,
    889687,
    786786,
    868779,
    777778,
    978787,
    888788,
    887887,
    887779,
    678897,
    766697,
    699678,
    798898,
    788777,
    978988,
    888766,
    888786,
    778887,
    687798,
    878678,
    778989,
    887999,
    899987,
    786877,
    999976,
    889978,
    887866,
    888799,
    987897,
    977887,
    778889,
    868777,
    788889,
    888878,
    866798,
    878779,
    778899,
    798879,
    899897,
    778797,
    879788,
    898987,
    778878,
    887878,
    798999,
    988777,
    888777,
    887767,
    897779,
    888889,
    879888,
    888887,
    988896,
    768987,
    898887,
    797687,
    898888,
    768776,
    889987,
    779897,
    987768,
    888888,
    788888,
    678997,
    889868,
    887679,
    797898,
    888978,
    689869,
    777977,
    867679,
    888887,
    887887,
    978887,
    887699,
    879888,
    899868,
    988888,
    789998,
    977877,
    889877,
    888688,
    678789,
    989868,
    887889,
    689877,
    978678,
    999888,
    989879,
    688788,
    798877,
    977787,
    787776,
    888678,
    998978,
    788768,
    887878,
    876688,
    777687,
    878799,
    787776,
    879888,
    878999,
    887897,
    788788,
    787877,
    899898,
    789779,
    897788,
    989978,
    888888,
    988877,
    788869,
    789878,
    898788,
    878886,
    878988,
    688877,
    797988,
    989897,
    688878,
    868777,
    868986,
    787788,
    898978,
    898887,
    796787,
    787787,
    778969,
    888788,
    888798,
    788987,
    878888,
    878797,
    888787,
    978779,
    987878,
    888978,
    987887,
    798798,
    968888,
    988788,
    789698,
    788686,
    878989,
    898788,
    878898,
    687998,
    888889,
    888668,
    889888,
    778796,
    878777,
    878886,
    797888,
    988778,
    896887,
    988979,
    788898,
    996888,
    877679,
    878899,
    878989,
    788876,
    787889,
    787899,
    889897,
    987767,
    898789,
    788997,
    688887,
    767868,
    778898,
    989798,
    787887,
    989889,
    879897,
    898879,
    988888,
    788868,
    888977,
    888768,
    876978,
    778877,
    887997,
    799987,
    787898,
    677899,
    888987,
    987879,
    987888,
    978886,
    879787,
    788687,
    997987,
    878689,
    977778,
    779798,
    887788,
    987987,
    977887,
    867788,
    798897,
    797788,
    898877,
    676677,
    788897,
    888889,
    797877,
    786879,
    888989,
    887876,
    988979,
    787788,
    788898,
    877887,
    787678,
    787898,
    877788,
    889888,
    888667,
    878978,
    789787,
    768986,
    798987,
    788777,
    888788,
    788888,
    798898,
    988889,
    999766,
    799698,
    997887,
    787979,
    878889,
    998869,
    878788,
    887869,
    878779,
    988778,
    988887,
    798788,
    988979,
    877778,
    768788,
    677877,
    769777,
    878888,
    978888,
    779897,
    888868,
    886988,
    987878,
    988987,
    769898,
    777898,
    898877,
    767897,
    977788,
    787797,
    778986,
    898898,
    878886,
    999778,
    967897,
    767698,
    987776,
    887778,
    688989,
    877888,
    878898,
    997979,
    978778,
    877898,
    887776,
    877977,
    877888,
    967988,
    896997,
    899979,
    697797,
    867998,
    897879,
    879778,
    898897,
    776988,
    679888,
    979787,
    887887,
    899878,
    876878,
    997687,
    788888,
    887777,
    888879,
    877878,
    897889,
    767897,
    769877,
    898778,
    797888,
    889887,
    799887,
    789878,
    787998,
    887887,
    779677,
    898789,
    799788,
    989888,
    787789,
    886787,
    788687,
    797897,
    788977,
    898898,
    788978,
    679787,
    787988,
    787679,
    677788,
    779898,
    898978,
    876898,
    898777,
    868787,
    777678,
    797897,
    998767,
    888987,
    889677,
    898777,
    868777,
    897887,
    879898,
    899888,
    688897,
    898778,
    888979,
    888979,
    778678,
    887778,
    988778,
    787676,
    877898,
    998888,
    877877,
    789888,
    898888,
    777887,
    888997,
    988767,
    888797,
    878888,
    788878,
    889897,
    878678,
    888888,
    889988,
    767677,
    788778,
    896879,
    799788,
    888977,
    776699,
    898789,
    688778,
    888897,
    887667,
    788878,
    787878,
    787798,
    978888,
    868788,
    797977,
    889879,
    878788,
    797878,
    788788,
    887986,
    887796,
    988776,
    888787,
    898897,
    787867,
    777987,
    787768,
    998777,
    886998,
    778787,
    787978,
    988789,
    777788,
    778888,
    889778,
    889787,
    888888,
    778788,
    888787,
    888977,
    888787,
    887778,
    899799,
    877868,
    876798,
    787989,
    887887,
    798979,
    689898,
    897898,
    777796,
    967998,
    887678,
    888788,
    789886,
    699998,
    788878,
    969788,
    796777,
    877777,
    789987,
    897798,
    887988,
    789887,
    789777,
    788789,
    989798,
    789786,
    998889,
    977789,
    777689,
    896779,
    979878,
    799986,
    999798,
    788777,
    787889,
    898888,
    977879,
    987897,
    989888,
    779787,
    897787,
    788888,
    887888,
    788777,
    888799,
    886889,
    888988,
    789879,
    898767,
    799869,
    888887,
    868998,
    898887,
    787888,
    787888,
    769767,
    868978,
    787777,
    887877,
    997798,
    797977,
    887869,
    879798,
    987879,
    979878,
    988889,
    999878,
    896788,
    877888,
    887978,
    878877,
    978787,
    797977,
    878889,
    888778,
    877699,
    679779,
    777887,
    797879,
    888777,
    966779,
    877688,
    898798,
    689887,
    879787,
    988777,
    987997,
    887796,
    887898,
    779778,
    778788,
    878877,
    987777,
    978779,
    797887,
    788988,
    888798,
    988898,
    787888,
    678877,
    887888,
    667879,
    879776,
    877899,
    878999,
    868678,
    897878,
    887787,
    697877,
    778878,
    888969,
    898868,
    889997,
    988898,
    787787,
    999887,
    777989,
    778889,
    988979,
    886878,
    799877,
    979779,
    797889,
    789799,
    877788,
    787678,
    979877,
    878678,
    878776,
    977787,
    798877,
    788877,
    788666,
    788788,
    888777,
    798779,
    788897,
    887888,
    677678,
    887887,
    968867,
    887887,
    888778,
    888878,
    897979,
    797879,
    878898,
    699878,
    879888,
    787869,
    787899,
    988876,
    987787,
    888788,
    789789,
    788988,
    888868,
    888889,
    987987,
    879887,
    879887,
    668997,
    998887,
    788978,
    688788,
    796878,
    787787,
    786888,
    777778,
    888878,
    988768,
    787889,
    878976,
    987898,
    786876,
    888678,
    788877,
    788987,
    878977,
    678787,
    898796,
    868788,
    678887,
    878788,
    968878,
    788998,
    767887,
    898897,
    677887,
    898868,
    798989,
    897878,
    898777,
    779788,
    797978,
    779778,
    768697,
    787988,
    878887,
    769779,
    996878,
    887888,
    778879,
    889787,
    976797,
    777977,
    787877,
    786898,
    967877,
    988867,
    777789,
    996878,
    777886,
    777988,
    877988,
    867879,
    898788,
    768898,
    786788,
    878788,
    787876,
    799889,
    877768,
    889887,
    788987,
    888788,
    787776,
    868779,
    698989,
    887888,
    878788,
    878787,
    888987,
    787878,
    898768,
    878778,
    988787,
    989886,
    888877,
    878887,
    998887,
    877699,
    798697,
    998796,
    886999,
    797789,
    898989,
    777896,
    878977,
    979868,
    878879,
    997888,
    977877,
    887889,
    877996,
    676886,
    788988,
    888797,
    777777,
    978677,
    897877,
    798889,
    798977,
    677878,
    878789,
    878979,
    888998,
    868797,
    767988,
    786877,
    779788,
    897798,
    877877,
    868768,
    878877,
    788788,
    798987,
    778878,
    889788,
    878776,
    886888,
    879888,
    889778,
    779897,
    988797,
    887878,
    789788,
    787877,
    768887,
    787988,
    888868,
    889899,
    876897,
    979777,
    877779,
    997867,
    798687,
    678797,
    778877,
    789789,
    998877,
    999989,
    779787,
    766897,
    779887,
    778798,
    787987,
    877788,
    777987,
    878988,
    978896,
    879778,
    798896,
    879877,
    877887,
    989888,
    887889,
    787789,
    878987,
    888887,
    887977,
    798887,
    988788,
    798798,
    769688,
    986898,
    888977,
    888787,
    866789,
    888888,
    998789,
    788687,
    768898,
    989789,
    878777,
    779877,
    966688,
    899889,
    999988,
    888888,
    688878,
    888777,
    987786,
    778878,
    778779,
    898778,
    797797,
    888888,
    788868,
    878767,
    977787,
    889878,
    779898,
    788887,
    776887,
    887797,
    787999,
    877876,
    778788,
    799897,
    778777,
    867679,
    988889,
    888777,
    888789,
    888887,
    977978,
    988968,
    877897,
    897778,
    888888,
    888877,
    997978,
    977989,
    887878,
    779888,
    787688,
    887787,
    878877,
    898978,
    778897,
    788776,
    997776,
    678878,
    788977,
    788897,
    967998,
    687888,
    778999,
    968989,
    897679,
    887678,
    888768,
    679778,
    887888,
    887788,
    777778,
    888797,
    779988,
    897989,
    887788,
    778978,
    887988,
    887778,
    687887,
    786688,
    979887,
    879889,
    986877,
    989986,
    698786,
    799798,
    768888,
    789788,
    889787,
    886877,
    787878,
    877878,
    877876,
    787888,
    898978,
    888898,
    677877,
    877889,
    798788,
    677998,
    687788,
    899889,
    878787,
    968889,
    889678,
    898887,
    888897,
    778768,
    898898,
    896998,
    876997,
    788888,
    877887,
    777879,
    899887,
    869698,
    688888,
    888798,
    888878,
    899878,
    778899,
    787879,
    788787,
    977788,
    888779,
    789678,
    878777,
    899998,
    898898,
    987987,
    788887,
    687888,
    898767,
    776979,
    988888,
    867879,
    988877,
    787987,
    897999,
    998768,
    888889,
    688777,
    878787,
    788768,
    797886,
    986766,
    797688,
    677987,
    898977,
    978789,
    977779,
    987977,
    678887,
    998888,
    877697,
    778888,
    878889,
    788677,
    877887,
    787979,
    666988,
    877969,
    889889,
    799878,
    768969,
    888989,
    879888,
    888997,
    878997,
    779978,
    897978,
    799778,
    899778,
    888988,
    797888,
    878788,
    869867,
    788688,
    798788,
    788988,
    798888,
    999788,
    987788,
    777788,
    898988,
    878786,
    788799,
    877877,
    877898,
    997977,
    888679,
    898798,
    967878,
    869778,
    877888,
    888876,
    889877,
    798898,
    787797,
    787869,
    788887,
    878798,
    787878,
    878679,
    988788,
    888967,
    888878,
    878787,
    898898,
    887888,
    789796,
    887886,
    888798,
    778788,
    878777,
    889777,
    788788,
    797967,
    987787,
    886899,
    888788,
    877697,
    888797,
    988779,
    789988,
    889788,
    777778,
    678878,
    977689,
    987798,
    878968,
    789778,
    878878,
    988798,
    899777,
    989887,
    968776,
    778979,
    879797,
    798786,
    979877,
    888886,
    878989,
    798878,
    878888,
    789988,
    978898,
    889979,
    879889,
    778768,
    787867,
    879998,
    778778,
    888688,
    778788,
    797878,
    877768,
    797988,
    887889,
    978877,
    787897,
    977787,
    988788,
    788998,
    889988,
    798786,
    779788,
    987978,
    888887,
    877777,
    886798,
    787788,
    988777,
    889789,
    789887,
    879888,
    898887,
    988778,
    877888,
    888879,
    997988,
    998978,
    977988,
    678999,
    878987,
    788788,
    898878,
    978698,
    698978,
    878889,
    878887,
    887789,
    877876,
    899879,
    868778,
    887789,
    878789,
    888978,
    897878,
    888989,
    777687,
    688888,
    889888,
    877978,
    886687,
    799676,
    788897,
    788899,
    699877,
    798897,
    877888,
    988787,
    979877,
    777977,
    788887,
    788888,
    867777,
    998998,
    799897,
    979669,
    989969,
    889887,
    898888,
    798877,
    987768,
    787978,
    666796,
    888878,
    898978,
    887679,
    888878,
    989978,
    887977,
    788887,
    887878,
    888789,
    887887,
    897688,
    777987,
    897977,
    788878,
    987888,
    778687,
    787979,
    787687,
    878988,
    997888,
    698888,
    879897,
    778869,
    788788,
    777987,
    878999,
    889876,
    779676,
    788999,
    878868,
    887788,
    767976,
    878888,
    988688,
    988789,
    886969,
    978888,
    968888,
    778887,
    787689,
    869887,
    766888,
    888778,
    878789,
    889886,
    988887,
    787877,
    779889,
    888897,
    787777,
    778898,
    788777,
    887889,
    776876,
    987888,
    977877,
    888777,
    879777,
    777988,
    878888,
    887888,
    789877,
    998787,
    788987,
    888888,
    688888,
    778669,
    798887,
    789889,
    777868,
    788788,
    877888,
    987788,
    768886,
    788786,
    878789,
    887898,
    889778,
    777998,
    787969,
    788998,
    788888,
    777878,
    887878,
    898877,
    789987,
    897778,
    787797,
    978977,
    886888,
    878988,
    686987,
    778887,
    869787,
    877789,
    678787,
    778877,
    989987,
    778876,
    769989,
    788777,
    988888,
    887879,
    979696,
    897789,
    879879,
    877898,
    879877,
    999797,
    879889,
    877777,
    679778,
    888989,
    978777,
    878888,
    876867,
    789689,
    688869,
    786899,
    876778,
    898877,
    887788,
    787888,
    877777,
    869779,
    877879,
    788778,
    988888,
    789898,
    799889,
    969788,
    779987,
    878899,
    987888,
    878788,
    788897,
    789887,
    867887,
    897787,
    786878,
    788788,
    988778,
    867787,
    798776,
    788888,
    699888,
    896987,
    879797,
    897777,
    877896,
    988887,
    786789,
    878788,
    987869,
    768897,
    788868,
    878889,
    877677,
    998777,
    898898,
    896787,
    787877,
    888878,
    787688,
    878787,
    768998,
    789787,
    988897,
    788787,
    778899,
    788897,
    798887,
    877889,
    878897,
    977798,
    999798,
    779676,
    878977,
    768788,
    778977,
    887988,
    788787,
    978797,
    787778,
    679687,
    889787,
    998888,
    988977,
    887789,
    888887,
    879887,
    778977,
    778977,
    678888,
    888786,
    868877,
    998778,
    977969,
    788887,
    987788,
    777888,
    788977,
    679978,
    887897,
    777887,
    878877,
    888788,
    897768,
    668778,
    688877,
    777777,
    977969,
    787787,
    998978,
    888778,
    677879,
    788768,
    889899,
    988886,
    888996,
    779789,
    979777,
    987898,
    887879,
    699878,
    989878,
    787798,
    797868,
    887778,
    787877,
    778888,
    796888,
    897698,
    989978,
    889878,
    989899,
    887879,
    779888,
    777888,
    879788,
    888978,
    799797,
    697798,
    867877,
    979876,
    888897,
    788778,
    878988,
    879789,
    787888,
    879978,
    778879,
    879778,
    888898,
    898788,
    799768,
    787998,
    988787,
    797787,
    898778,
    787877,
    978987,
    888877,
    889868,
    769789,
    768778,
    979877,
    789788,
    787667,
    689878,
    978897,
    689888,
    888879,
    698788,
    987798,
    778987,
    988988,
    789698,
    888898,
    788878,
    998888,
    889867,
    877798,
    989888,
    989889,
    688878,
    888786,
    769977,
    978998,
    978797,
    887877,
    878889,
    789987,
    699988,
    898898,
    788887,
    879969,
    878979,
    888888,
    798797,
    879778,
    787788,
    787976,
    888999,
    789887,
    788979,
    797979,
    877878,
    677889,
    988788,
    888888,
    789886,
    698788,
    687799,
    878778,
    998888,
    988887,
    988799,
    979888,
    697779,
    998777,
    789789,
    778868,
    987787,
    798688,
    799789,
    888897,
    977867,
    977879,
    988677,
    877788,
    788988,
    867868,
    978897,
    886987,
    788988,
    879878,
    798977,
    677997,
    898888,
    989688,
    887787,
    788798,
    787777,
    798787,
    776778,
    878778,
    777786,
    887988,
    977988,
    868787,
    878779,
    897999,
    796878,
    988898,
    889998,
    898897,
    876899,
    887886,
    786988,
    778776,
    797968,
    788797,
    888978,
    988887,
    767788,
    888876,
    878788,
    888877,
    897767,
    887798,
    877767,
    788797,
    988687,
    776897,
    688988,
    877877,
    869978,
    988978,
    867777,
    778678,
    898887,
    888788,
    888887,
    878777,
    888788,
    888987,
    779887,
    887896,
    996777,
    888899,
    777778,
    787878,
    888988,
    998767,
    868978,
    678799,
    878797,
    887898,
    778989,
    967797,
    778797,
    887987,
    878688,
    998898,
    887979,
    968889,
    889888,
    787897,
    796779,
    778787,
    878989,
    878968,
    797888,
    768768,
    896977,
    798888,
    878898,
    787889,
    887988,
    987879,
    888888,
    896887,
    989778,
    679878,
    987888,
    888787,
    777978,
    787788,
    987778,
    879897,
    778998,
    788886,
    777889,
    798886,
    779886,
    789788,
    888888,
    888868,
    878998,
    978899,
    868778,
    776788,
    799888,
    796977,
    897778,
    788787,
    878779,
    979797,
    887677,
    799877,
    988777,
    888787,
    888978,
    888989,
    999888,
    888997,
    679679,
    797979,
    788988,
    898786,
    777889,
    888898,
    789878,
    687868,
    778887,
    897788,
    798897,
    898987,
    799968,
    688978,
    986779,
    798888,
    888778,
    989887,
    877978,
    789786,
    987797,
    897989,
    789798,
    798876,
    898878,
    687796,
    887988,
    997896,
    686977,
    799987,
    986878,
    778787,
    878888,
    689788,
    999796,
    987787,
    798889,
    998686,
    778887,
    788887,
    887996,
    788867,
    888888,
    776676,
    878889,
    898879,
    787777,
    877998,
    787777,
    987898,
    677886,
    787777,
    888769,
    877797,
    887778,
    997778,
    799888,
    887877,
    869979,
    799977,
    888878,
    767787,
    788878,
    778879,
    988879,
    799887,
    788888,
    888797,
    796788,
    679879,
    778776,
    878899,
    677887,
    867878,
    788988,
    897997,
    787897,
    887778,
    887778,
    778987,
    978868,
    897877,
    787988,
    887778,
    778887,
    778888,
    887878,
    988886,
    888988,
    888789,
    898878,
    898879,
    878989,
    788877,
    778876,
    778997,
    967768,
    989877,
    977779,
    778968,
    988889,
    889688,
    999778,
    797778,
    877778,
    898977,
    888798,
    888978,
    989889,
    898778,
    978679,
    898987,
    878877,
    979879,
    778779,
    896788,
    897887,
    978889,
    898888,
    787988,
    866777,
    789878,
    768968,
    887978,
    879888,
    868887,
    977997,
    867888,
    778777,
    878877,
    888889,
    799887,
    787876,
    889769,
    678988,
    779878,
    988978,
    877878,
    899878,
    877979,
    898869,
    778787,
    798788,
    778899,
    888978,
    977777,
    797879,
    888799,
    888978,
    787886,
    797798,
    979788,
    879889,
    897786,
    776877,
    897887,
    778877,
    898877,
    879778,
    987778,
    878787,
    787978,
    888878,
    777787,
    787788,
    878869,
    779988,
    877887,
    878899,
    987977,
    786888,
    889788,
    889887,
    987898,
    897887,
    887889,
    797977,
    889887,
    787898,
    779888,
    778889,
    888889,
    878677,
    888897,
    977979,
    788777,
    876869,
    889888,
    788988,
    777888,
    997979,
    989798,
    887987,
    879788,
    787869,
    878866,
    968888,
    878698,
    878978,
    787787,
    888887,
    868987,
    797887,
    867679,
    889889,
    877999,
    889688,
    888988,
    688878,
    776888,
    887877,
    877688,
    979787,
    679979,
    888789,
    887889,
    796877,
    889797,
    867678,
    998878,
    888888,
    887789,
    889898,
    877889,
    767788,
    767886,
    889797,
    799778,
    868889,
    768788,
    677867,
    896868,
    887778,
    897699,
    898788,
    899778,
    787877,
    788688,
    968787,
    898878,
    797778,
    898888,
    787889,
    989777,
    887998,
    879768,
    868978,
    987767,
    798887,
    787788,
    777967,
    888678,
    998988,
    897777,
    987879,
    998878,
    887788,
    788788,
    887978,
    978789,
    898878,
    677887,
    878888,
    869877,
    787997,
    779788,
    989878,
    788888,
    997777,
    867687,
    878996,
    988887,
    976887,
    697887,
    887899,
    788678,
    877877,
    676787,
    779779,
    778867,
    779886,
    779689,
    669977,
    989888,
    898978,
    888797,
    788768,
    977778,
    998898,
    877788,
    886777,
    868688,
    867888,
    979777,
    788878,
    997788,
    689897,
    877877,
    879778,
    787898,
    789878,
    899977,
    877787,
    878997,
    987778,
    797779,
    888888,
    888997,
    787887,
    777777,
    679788,
    788799,
    788779,
    777879,
    887998,
    777878,
    987988,
    889878,
    978889,
    889787,
    868899,
    997789,
    788777,
    797887,
    898899,
    886677,
    978999,
    788997,
    868797,
    878797,
    887777,
    778978,
    987687,
    798789,
    879887,
    987987,
    888788,
    887789,
    668887,
    888888,
    898686,
    988988,
    988777,
    977887,
    877878,
    977787,
    977889,
    889787,
    878889,
    777987,
    688876,
    876878,
    697796,
    768899,
    998698,
    789879,
    877879,
    878787,
    886879,
    888777,
    696787,
    776988,
    887767,
    878886,
    878989,
    877788,
    989989,
    778988,
    879687,
    979789,
    968877,
    997889,
    787896,
    998877,
    877889,
    799898,
    877787,
    897687,
    977888,
    897677,
    987887,
    879977,
    768879,
    898989,
    879778,
    869878,
    887788,
    787787,
    887789,
    978799,
    887888,
    799877,
    978987,
    888878,
    688898,
    789996,
    968889,
    777888,
    878976,
    787787,
    787887,
    867887,
    678787,
    787887,
    888787,
    877788,
    779888,
    688787,
    767789,
    787987,
    879778,
    877788,
    887776,
    886779,
    988799,
    789878,
    896779,
    998877,
    888889,
    788788,
    887887,
    698878,
    778878,
    868779,
    979889,
    799788,
    897798,
    898789,
    987887,
    889679,
    786778,
    889687,
    988888,
    888888,
    898977,
    787877,
    868787,
    987779,
    998989,
    778898,
    878997,
    798686,
    879986,
    888798,
    999797,
    787897,
    786977,
    898989,
    787798,
    888888,
    797979,
    776778,
    877878,
    779868,
    898898,
    887777,
    867677,
    977778,
    878987,
    777879,
    887898,
    879888,
    998878,
    988887,
    777888,
    888866,
    778777,
    898989,
    886968,
    687788,
    899788,
    778897,
    688889,
    989988,
    798679,
    789896,
    888898,
    886878,
    789787,
    878977,
    898898,
    889669,
    797887,
    888889,
    787797,
    788767,
    778896,
    886878,
    888787,
    989888,
    798889,
    988877,
    898978,
    897769,
    776777,
    668778,
    877897,
    988777,
    778897,
    988778,
    796768,
    788998,
    896887,
    899789,
    868877,
    978878,
    778787,
    777879,
    787788,
    897789,
    887977,
    888887,
    868978,
    888978,
    797887,
    799887,
    989877,
    888878,
    888878,
    878877,
    987889,
    799879,
    778889,
    887986,
    977968,
    777978,
    879679,
    688786,
    878879,
    878787,
    798887,
    898779,
    978888,
    878877,
    886889,
    889778,
    878888,
    788989,
    888777,
    899988,
    868898,
    678879,
    777879,
    788989,
    886888,
    889878,
    777988,
    889767,
    988697,
    888879,
    887687,
    787977,
    786888,
    888888,
    786688,
    969889,
    778899,
    798977,
    888797,
    787888,
    988987,
    879776,
    887678,
    898987,
    887788,
    786867,
    888888,
    868889,
    986887,
    888778,
    889887,
    777898,
    878887,
    898998,
    897889,
    768978,
    877779,
    886797,
    986888,
    768989,
    799898,
    877789,
    778987,
    979887,
    789777,
    678878,
    778867,
    878678,
    778979,
    879887,
    789788,
    877777,
    868778,
    998877,
    677798,
    986879,
    778867,
    797969,
    897898,
    888998,
    767878,
    889966,
    797777,
    788978,
    889778,
    887867,
    788977,
    698898,
    988888,
    886887,
    877787,
    898787,
    777898,
    988667,
    988777,
    867888,
    778978,
    888887,
    798978,
    878688,
    867877,
    897899,
    888778,
    778887,
    988887,
    698897,
    787978,
    878976,
    797887,
    788988,
    988899,
    776878,
    887798,
    778897,
    887778,
    987887,
    798679,
    798968,
    878787,
    879876,
    978869,
    777899,
    878987,
    788876,
    787977,
    878889,
    778778,
    877788,
    899968,
    877778,
    786778,
    978997,
    888797,
    888798,
    798977,
    979789,
    788887,
    888887,
    778887,
    888996,
    778988,
    778879,
    787979,
    968787,
    788697,
    768978,
    787898,
    978779,
    889788,
    888879,
    778989,
    677878,
    778878,
    987977,
    788888,
    798876,
    878787,
    888878,
    878768,
    798787,
    889877,
    887788,
    897977,
    988898,
    889898,
    798788,
    778868,
    879978,
    788798,
    968979,
    988878,
    887998,
    678788,
    699667,
    877988,
    778888,
    888779,
    878889,
    999887,
    799898,
    887788,
    788799,
    798877,
    886878,
    999778,
    878777,
    788877,
    869789,
    878877,
    688998,
    768977,
    787787,
    887877,
    889898,
    796788,
    877798,
    779778,
    989898,
    799778,
    887778,
    989978,
    878979,
    797788,
    788977,
    888898,
    987878,
    797889,
    967888,
    889786,
    968777,
    887968,
    786888,
    779987,
    897988,
    988978,
    878778,
    788897,
    888979,
    887898,
    698888,
    788897,
    878888,
    787888,
    879979,
    977998,
    889788,
    877889,
    898988,
    787997,
    987787,
    887788,
    888877,
    987888,
    977988,
    877777,
    799778,
    889798,
    786888,
    868698,
    678786,
    969868,
    778977,
    779888,
    799798,
    868787,
    778778,
    898688,
    997997,
    787978,
    779788,
    999786,
    778988,
    787998,
    789799,
    777888,
    878869,
    787998,
    768977,
    889778,
    898788,
    998898,
    787779,
    778879,
    798876,
    869888,
    768968,
    979877,
    977778,
    988788,
    888898,
    778997,
    788988,
    877898,
    877888,
    887979,
    777888,
    788799,
    788788,
    787988,
    798779,
    677788,
    789688,
    887877,
    698768,
    797797,
    788787,
    887668,
    898978,
    978877,
    886989,
    987788,
    979778,
    879889,
    987878,
    877788,
    798698,
    889887,
    787767,
    878897,
    799787,
    898876,
    788787,
    678887,
    878887,
    988988,
    879688,
    877888,
    887988,
    988787,
    888877,
    877886,
    796879,
    868788,
    778969,
    789878,
    898797,
    897897,
    788886,
    998998,
    687978,
    787887,
    888797,
    789787,
    798878,
    889788,
    778978,
    968889,
    888798,
    779686,
    788977,
    779787,
    688687,
    889878,
    888878,
    778888,
    877989,
    888867,
    787878,
    788797,
    787788,
    896969,
    779798,
    898899,
    897878,
    689977,
    878866,
    776688,
    898788,
    878878,
    978887,
    998897,
    898877,
    888888,
    978987,
    979979,
    888888,
    699788,
    879888,
    787868,
    787879,
    878668,
    788986,
    988697,
    878697,
    787888,
    888977,
    799888,
    878877,
    777877,
    766698,
    688789,
    896888,
    879989,
    978889,
    799767,
    877878,
    766687,
    876787,
    967788,
    987879,
    878697,
    888868,
    877788,
    898878,
    897688,
    799898,
    988888,
    898898,
    788987,
    887898,
    797886,
    888789,
    989868,
    888988,
    988988,
    888878,
    987877,
    877788,
    778899,
    678687,
    888789,
    879979,
    887787,
    897778,
    779796,
    968787,
    787777,
    778888,
    888778,
    868896,
    987687,
    878687,
    878777,
    898888,
    779787,
    878698,
    989877,
    888779,
    977877,
    898687,
    979887,
    687778,
    989978,
    877688,
    788777,
    799888,
    887789,
    779788,
    877798,
    867789,
    887886,
    868988,
    878877,
    787678,
    998877,
    888987,
    787887,
    988888,
    978688,
    978779,
    987877,
    879996,
    889887,
    788988,
    787888,
    778778,
    788977,
    887778,
    877878,
    787887,
    878788,
    987967,
    889988,
    878888,
    968969,
    887777,
    979987,
    788979,
    878799,
    887978,
    887879,
    987777,
    778788,
    768688,
    777787,
    887887,
    899787,
    879898,
    788879,
    797998,
    887699,
    977989,
    797899,
    788777,
    887888,
    787778,
    787877,
    879878,
    887887,
    998986,
    976898,
    879776,
    677678,
    897887,
    787888,
    869969,
    798788,
    897798,
    887888,
    788788,
    698687,
    887887,
    779789,
    888888,
    788898,
    878798,
    788988,
    889787,
    787888,
    879887,
    699798,
    787888,
    698997,
    888998,
    879878,
    978888,
    798897,
    988877,
    789989,
    879989,
    878966,
    988777,
    779876,
    778977,
    797886,
    889987,
    789988,
    788987,
    996967,
    998789,
    777879,
    789788,
    668878,
    766787,
    788877,
    788887,
    897978,
    889788,
    888779,
    897779,
    677897,
    886898,
    669887,
    978887,
    987877,
    877798,
    977778,
    888999,
    977889,
    877777,
    896977,
    787679,
    677897,
    989799,
    889978,
    887877,
    777789,
    888978,
    979878,
    767769,
    989888,
    779886,
    688968,
    889898,
    679898,
    867788,
    897888,
    698797,
    898788,
    886768,
    889876,
    878778,
    788968,
    888778,
    878887,
    787997,
    888788,
    686798,
    987888,
    788987,
    678777,
    789788,
    889867,
    888978,
    988778,
    977977,
    878987,
    778798,
    778897,
    878878,
    887998,
    889878,
    799777,
    987789,
    796878,
    889888,
    788988,
    899978,
    988778,
    969887,
    878888,
    898887,
    978889,
    889889,
    788798,
    898888,
    897768,
    898867,
    889988,
    878788,
    887777,
    898878,
    897877,
    778889,
    888788,
    889879,
    697876,
    797987,
    879988,
    987887,
    789879,
    978798,
    887877,
    889788,
    989887,
    888878,
    798689,
    899887,
    898888,
    777978,
    788798,
    778997,
    978889,
    888979,
    678878,
    798989,
    877989,
    798988,
    787878,
    899888,
    788788,
    769777,
    776888,
    888898,
    979978,
    878787,
    788677,
    797877,
    997788,
    889677,
    988897,
    779777,
    978897,
    688877,
    868887,
    788686,
    988997,
    778887,
    989877,
    797887,
    867899,
    878688,
    968767,
    798898,
    787777,
    777897,
    896987,
    788889,
    987898,
    898898,
    877787,
    798878,
    886898,
    988968,
    778787,
    678767,
    798898,
    667798,
    787778,
    888877,
    877887,
    798789,
    978887,
    789777,
    877899,
    967786,
    889878,
    887789,
    788697,
    879989,
    878978,
    788778,
    889779,
    877687,
    988988,
    997978,
    868898,
    987969,
    777689,
    998997,
    977787,
    879876,
    796898,
    888969,
    777877,
    777787,
    788988,
    977987,
    888888,
    898988,
    998788,
    788878,
    777788,
    887897,
    977877,
    986879,
    786878,
    789799,
    888898,
    899898,
    889899,
    698778,
    889897,
    888789,
    798887,
    997788,
    879878,
    868997,
    887877,
    787788,
    968898,
    798888,
    699887,
    988897,
    888988,
    777987,
    878898,
    976778,
    788787,
    778988,
    888878,
    788889,
    867988,
    797788,
    978997,
    898876,
    788788,
    877877,
    778887,
    887689,
    978988,
    978688,
    767899,
    676988,
    878888,
    878798,
    778888,
    988786,
    787878,
    899788,
    889789,
    989888,
    888688,
    777797,
    877768,
    688799,
    989769,
    778987,
    767766,
    988888,
    888897,
    777888,
    878887,
    778878,
    869886,
    787878,
    887797,
    986868,
    788988,
    778888,
    897787,
    868898,
    978788,
    768886,
    999788,
    697889,
    887868,
    788877,
    887879,
    779888,
    889778,
    888986,
    988896,
    878889,
    868889,
    877977,
    777877,
    877988,
    989877,
    887699,
    869898,
    676897,
    788678,
    789887,
    799877,
    988787,
    878977,
    766886,
    987887,
    877788,
    877997,
    978887,
    898878,
    898779,
    787897,
    987867,
    887889,
    986889,
    787789,
    787877,
    788987,
    877778,
    988689,
    677896,
    988777,
    867787,
    869977,
    889967,
    796688,
    779868,
    778778,
    988676,
    878797,
    878988,
    989987,
    878878,
    776896,
    868989,
    988879,
    987878,
    877687,
    888778,
    878987,
    979877,
    889878,
    879978,
    869977,
    797888,
    889879,
    868879,
    888877,
    979876,
    887968,
    987877,
    979877,
    889898,
    788787,
    797978,
    968877,
    997678,
    798787,
    897698,
    788686,
    797877,
    898968,
    877877,
    988788,
    966778,
    776876,
    866868,
    987988,
    889899,
    867867,
    997898,
    887978,
    799988,
    878787,
    997988,
    877678,
    897977,
    898877,
    898799,
    888969,
    789879,
    778878,
    879788,
    978888,
    887778,
    878889,
    988676,
    978888,
    887887,
    999798,
    788778,
    877889,
    698777,
    998787,
    786868,
    898788,
    887967,
    879787,
    777987,
    777788,
    878687,
    888886,
    979779,
    888989,
    967767,
    898986,
    879777,
    998787,
    789798,
    977987,
    898978,
    878979,
    878778,
    786789,
    899776,
    777989,
    887788,
    878688,
    788788,
    879867,
    897778,
    796788,
    788998,
    769886,
    787977,
    788877,
    778979,
    887678,
    687898,
    896987,
    886797,
    787877,
    768787,
    889777,
    878886,
    876688,
    778669,
    886978,
    967798,
    977788,
    788998,
    897797,
    777867,
    866887,
    779898,
    888878,
    879877,
    798988,
    878878,
    888877,
    877788,
    988876,
    878788,
    888988,
    868987,
    778887,
    797886,
    799797,
    979777,
    687968,
    779798,
    669976,
    898889,
    689888,
    887887,
    879788,
    887879,
    887889,
    788699,
    897788,
    877787,
    898787,
    887778,
    878689,
    878877,
    888977,
    876787,
    789888,
    877988,
    879896,
    897978,
    886978,
    989977,
    779796,
    879799,
    978777,
    777997,
    768689,
    988888,
    778899,
    877888,
    996887,
    798988,
    677789,
    869878,
    789677,
    887898,
    888788,
    887888,
    879698,
    887689,
    897887,
    888878,
    987799,
    777798,
    897777,
    787977,
    898879,
    887987,
    799888,
    989988,
    988868,
    988879,
    999998,
    877796,
    978878,
    987977,
    789888,
    888797,
    877778,
    888987,
    867987,
    889778,
    978787,
    999788,
    978987,
    787888,
    978897,
    678979,
    877887,
    768878,
    879899,
    788878,
    868778,
    887878,
    887889,
    779889,
    898888,
    977778,
    878888,
    898976,
    987789,
    788886,
    878968,
    888779,
    897898,
    768796,
    768888,
    889678,
    977789,
    776879,
    668988,
    879987,
    998877,
    797889,
    787787,
    878988,
    888988,
    787789,
    888879,
    787887,
    869979,
    888897,
    778898,
    789687,
    888678,
    789888,
    779978,
    689767,
    899898,
    768799,
    888978,
    788878,
    878878,
    898797,
    888898,
    888687,
    889877,
    897787,
    688987,
    787667,
    787886,
    887879,
    998878,
    778776,
    887889,
    767887,
    899899,
    877878,
    897788,
    687887,
    976898,
    887978,
    978788,
    768899,
    987778,
    899997,
    788878,
    897998,
    879967,
    988888,
    799888,
    888678,
    789888,
    887888,
    868778,
    887688,
    897787,
    878797,
    886779,
    877887,
    888887,
    668877,
    788797,
    878768,
    697897,
    987998,
    888787,
    777779,
    867988,
    788787,
    978888,
    987798,
    879988,
    788998,
    868688,
    778797,
    778899,
    788878,
    978988,
    879777,
    799889,
    888868,
    989888,
    989898,
    777987,
    777877,
    778697,
    888977,
    888778,
    887776,
    979798,
    879997,
    787788,
    988878,
    877989,
    878887,
    777778,
    797788,
    868968,
    669888,
    799798,
    987876,
    877979,
    887889,
    786968,
    679778,
    776897,
    798878,
    978779,
    878678,
    887888,
    897887,
    877897,
    698869,
    799988,
    768868,
    868788,
    778877,
    979799,
    798798,
    987787,
    787877,
    768789,
    877788,
    778997,
    887898,
    988879,
    878777,
    887688,
    977699,
    888887,
    776997,
    988787,
    989978,
    789977,
    988887,
    978977,
    789877,
    687779,
    778868,
    877766,
    988898,
    877878,
    897869,
    887888,
    678977,
    887888,
    998889,
    779878,
    886678,
    689869,
    897798,
    887888,
    897788,
    888689,
    897879,
    778878,
    799796,
    779789,
    997877,
    897887,
    877787,
    888798,
    777898,
    767878,
    888988,
    888778,
    777788,
    769988,
    789977,
    978787,
    997887,
    889986,
    789789,
    988887,
    978988,
    898777,
    688887,
    789987,
    798777,
    787898,
    777678,
    687978,
    778987,
    988789,
    778779,
    887987,
    897678,
    887899,
    879968,
    778988,
    898888,
    978787,
    888777,
    877878,
    778788,
    876898,
    898997,
    977787,
    879868,
    978867,
    777899,
    897898,
    888687,
    779798,
    788977,
    988687,
    887778,
    877897,
    998988,
    879766,
    877799,
    977767,
    877777,
    888868,
    977897,
    889877,
    887888,
    788678,
    878878,
    887788,
    878778,
    888987,
    999768,
    777799,
    889797,
    899897,
    798878,
    988877,
    897897,
    888778,
    887689,
    977788,
    999878,
    887988,
    879977,
    767997,
    777798,
    887887,
    668888,
    787778,
    997897,
    787686,
    896797,
    879898,
    768878,
    877778,
    787778,
    887779,
    877988,
    789796,
    789887,
    887687,
    978787,
    788886,
    789778,
    888988,
    886787,
    888788,
    777787,
    879997,
    766878,
    887888,
    888967,
    988898,
    879888,
    788878,
    867988,
    779879,
    878888,
    788778,
    886797,
    788978,
    779876,
    688789,
    878777,
    788676,
    777788,
    888878,
    869896,
    969787,
    878987,
    786978,
    887898,
    768778,
    978988,
    968869,
    778968,
    899787,
    778787,
    887899,
    987777,
    778887,
    887868,
    798887,
    778799,
    878786,
    878996,
    889989,
    777787,
    888777,
    987778,
    968967,
    687788,
    879888,
    798897,
    878798,
    978797,
    988988,
    799778,
    888897,
    677688,
    798978,
    788887,
    868787,
    689988,
    999798,
    997787,
    887878,
    879988,
    887799,
    786787,
    788869,
    887899,
    787878,
    878888,
    698999,
    987867,
    977878,
    887778,
    898899,
    787878,
    688868,
    978767,
    888668,
    879877,
    889788,
    886887,
    788778,
    988978,
    978699,
    878989,
    876778,
    878797,
    889889,
    787797,
    677797,
    897867,
    788998,
    887777,
    887877,
    777686,
    796978,
    977877,
    898989,
    987778,
    786888,
    977888,
    997988,
    898687,
    966898,
    889889,
    889878,
    888887,
    878877,
    887897,
    978888,
    778887,
    798899,
    788787,
    798999,
    878787,
    998889,
    899879,
    998698,
    898877,
    879788,
    978979,
    998897,
    977998,
    988799,
    977788,
    888889,
    877988,
    868888,
    988888,
    768977,
    797798,
    789787,
    898878,
    776897,
    779878,
    798998,
    887887,
    887896,
    877787,
    788779,
    966787,
    776887,
    977889,
    777788,
    896897,
    979788,
    977876,
    878888,
    798878,
    788888,
    799897,
    877876,
    877787,
    778897,
    789777,
    988866,
    798889,
    987776,
    777899,
    888788,
    899889,
    898787,
    788788,
    976797,
    979879,
    897999,
    768988,
    698899,
    888987,
    689868,
    997977,
    899869,
    889798,
    778878,
    887887,
    898777,
    798878,
    897969,
    788879,
    787878,
    877778,
    787779,
    897786,
    688988,
    888998,
    779879,
    779889,
    688888,
    787777,
    887789,
    878978,
    897988,
    887787,
    769998,
    887977,
    877868,
    787997,
    789877,
    877888,
    676887,
    779989,
    777888,
    887898,
    887798,
    777979,
    877888,
    786887,
    987888,
    898877,
    789678,
    979796,
    787779,
    889778,
    778878,
    779788,
    679888,
    697988,
    888977,
    998796,
    688778,
    999888,
    899898,
    799798,
    787997,
    887887,
    897797,
    987778,
    887798,
    789777,
    998698,
    878878,
    788686,
    978697,
    798777,
    868876,
    777898,
    897877,
    878788,
    767797,
    889878,
    879686,
    667788,
    778678,
    998887,
    898697,
    897777,
    788888,
    886886,
    887888,
    667789,
    898697,
    789878,
    899788,
    798879,
    698777,
    898789,
    789688,
    887889,
    877888,
    788797,
    797788,
    767788,
    887788,
    878788,
    789888,
    777778,
    888898,
    789887,
    987978,
    888889,
    879997,
    769798,
    777897,
    868887,
    987987,
    897777,
    769978,
    768979,
    897898,
    779787,
    988877,
    667878,
    677797,
    888787,
    978677,
    877888,
    968788,
    889977,
    978977,
    798878,
    768787,
    669976,
    778888,
    887788,
    888786,
    798999,
    786687,
    878888,
    787879,
    778888,
    677997,
    777986,
    986998,
    778888,
    887987,
    987889,
    889878,
    987797,
    879888,
    978888,
    978887,
    988877,
    888788,
    879987,
    988779,
    797997,
    788879,
    787878,
    887896,
    988988,
    778888,
    888788,
    887677,
    786897,
    788778,
    888778,
    777886,
    888779,
    898887,
    878897,
    888986,
    977878,
    679788,
    977789,
    877888,
    677888,
    779777,
    786788,
    688778,
    788878,
    778868,
    776698,
    787988,
    777776,
    988787,
    879998,
    888778,
    979788,
    989778,
    899868,
    778868,
    968788,
    987898,
    688989,
    887788,
    887799,
    778887,
    779877,
    768688,
    777688,
    879788,
    787778,
    979877,
    979788,
    878686,
    996987,
    887869,
    788789,
    887999,
    888777,
    777889,
    889888,
    887878,
    798787,
    987767,
    868777,
    888777,
    898887,
    877888,
    978888,
    889887,
    978878,
    887998,
    899877,
    898669,
    788877,
    987898,
    776977,
    776787,
    989879,
    887888,
    788788,
    887979,
    977988,
    798889,
    677878,
    778896,
    697777,
    998877,
    788867,
    887979,
    787798,
    689768,
    788877,
    798869,
    977979,
    688797,
    786796,
    877798,
    778987,
    877888,
    978787,
    886888,
    987978,
    799899,
    898777,
    789878,
    969788,
    877788,
    878889,
    897979,
    978778,
    687777,
    898786,
    898878,
    996878,
    887787,
    878778,
    778997,
    788888,
    799688,
    768878,
    799677,
    788987,
    888787,
    978697,
    979779,
    897789,
    888887,
    778797,
    899866,
    887777,
    777777,
    778887,
    787788,
    698787,
    788977,
    988887,
    779977,
    796687,
    777898,
    879978,
    878778,
    788689,
    878678,
    689999,
    786977,
    889867,
    877687,
    779788,
    878977,
    988898,
    779886,
    898778,
    889977,
    888989,
    887777,
    888888,
    688777,
    879879,
    899887,
    887888,
    889879,
    888897,
    888798,
    778777,
    688689,
    678877,
    789787,
    796996,
    876767,
    877888,
    876878,
    986987,
    888778,
    788777,
    787778,
    878987,
    879897,
    687778,
    878886,
    778877,
    688879,
    998887,
    878797,
    887779,
    877878,
    789699,
    986878,
    789798,
    968787,
    697987,
    888889,
    778787,
    787687,
    878787,
    688778,
    798877,
    887988,
    979888,
    887889,
    888798,
    877877,
    877889,
    878878,
    796986,
    788779,
    687789,
    789788,
    888768,
    787989,
    779999,
    868977,
    778976,
    978798,
    787896,
    878888,
    797889,
    786997,
    868777,
    778977,
    888796,
    788897,
    778898,
    878777,
    877778,
    976897,
    789898,
    877898,
    998887,
    887899,
    677898,
    878888,
    888798,
    796878,
    887787,
    898889,
    797787,
    868778,
    876887,
    888879,
    888778,
    798778,
    767787,
    888896,
    788777,
    887978,
    788899,
    768778,
    687888,
    888787,
    978776,
    877979,
    789887,
    878768,
    788798,
    876897,
    777888,
    778787,
    988788,
    877888,
    787876,
    887989,
    788886,
    788878,
    788788,
    888889,
    888787,
    687888,
    888787,
    799789,
    988888,
    897898,
    778797,
    677887,
    787776,
    977778,
    997877,
    898788,
    787777,
    787897,
    878777,
    779887,
    878788,
    887988,
    678897,
    876997,
    888878,
    878787,
    778788,
    888688,
    888998,
    878778,
    889798,
    897877,
    988887,
    777888,
    787777,
    887788,
    787977,
    787878,
    887877,
    979978,
    787777,
    787878,
    788887,
    877876,
    977886,
    788788,
    689897,
    788789,
    887797,
    787976,
    887777,
    789879,
    867887,
    776797,
    988767,
    878888,
    888888,
    878688,
    989997,
    868988,
    788778,
    787697,
    889797,
    878679,
    887878,
    887977,
    778779,
    696797,
    778698,
    778887,
    899787,
    778899,
    777898,
    779987,
    978778,
    778887,
    887889,
    898777,
    989798,
    788869,
    899868,
    988989,
    778678,
    796998,
    788997,
    889777,
    988879,
    898878,
    899877,
    888789,
    998879,
    897777,
    888788,
    769988,
    887887,
    879788,
    777878,
    879877,
    889778,
    877896,
    777977,
    887899,
    989876,
    888988,
    887987,
    988886,
    898879,
    978888,
    888886,
    698896,
    967888,
    887967,
    688778,
    998967,
    977687,
    887996,
    899777,
    887678,
    979787,
    877989,
    888888,
    977889,
    877987,
    677988,
    776877,
    799898,
    867998,
    878887,
    888887,
    966787,
    878688,
    897877,
    786898,
    787898,
    987688,
    888788,
    977868,
    887877,
    797687,
    898799,
    798788,
    777878,
    888988,
    989798,
    998978,
    697877,
    698778,
    977878,
    898988,
    768878,
    977777,
    967878,
    887886,
    879887,
    997888,
    888898,
    896887,
    777979,
    788989,
    897989,
    888887,
    777788,
    899976,
    898997,
    788899,
    788989,
    878878,
    889987,
    888787,
    688767,
    887977,
    779788,
    897878,
    986689,
    688888,
    998788,
    978798,
    787899,
    878897,
    977866,
    787879,
    978889,
    877987,
    977979,
    879988,
    778678,
    997887,
    788879,
    898678,
    999778,
    799996,
    878878,
    888788,
    888777,
    889999,
    987789,
    788778,
    678979,
    788799,
    767868,
    979877,
    996778,
    888798,
    778888,
    878969,
    979898,
    796789,
    987767,
    977879,
    678789,
    787799,
    778979,
    877989,
    978888,
    877988,
    798898,
    797897,
    787979,
    667787,
    778787,
    967687,
    778979,
    778799,
    679866,
    787878,
    967899,
    887989,
    977887,
    878777,
    888988,
    889877,
    898798,
    897977,
    878988,
    889676,
    769789,
    987797,
    778798,
    988997,
    778998,
    978869,
    787787,
    898888,
    798888,
    778777,
    679889,
    897786,
    887777,
    877879,
    999977,
    988997,
    877988,
    977977,
    999698,
    867789,
    777887,
    877799,
    889687,
    989789,
    877978,
    897899,
    988987,
    887887,
    887788,
    778877,
    777977,
    889888,
    889899,
    987689,
    879877,
    978799,
    887877,
    788979,
    778978,
    888877,
    877898,
    899777,
    687878,
    889788,
    779999,
    798889,
    979868,
    789777,
    888888,
    798888,
    786778,
    777898,
    798779,
    887787,
    978889,
    788979,
    889886,
    988888,
    888986,
    877887,
    698678,
    998977,
    967677,
    879888,
    987977,
    888798,
    897987,
    978788,
    888878,
    777787,
    779799,
    787899,
    898897,
    997889,
    788868,
    768888,
    677877,
    886877,
    779789,
    767797,
    788888,
    997887,
    788977,
    778996,
    998878,
    877879,
    877789,
    886987,
    788798,
    779778,
    878987,
    896997,
    888989,
    978779,
    888998,
    988778,
    677888,
    788787,
    689899,
    879876,
    878879,
    877878,
    879898,
    878868,
    986979,
    889988,
    788777,
    968687,
    789878,
    798788,
    978897,
    898788,
    788877,
    777777,
    888788,
    898688,
    888876,
    898879,
    897679,
    768687,
    899787,
    986876,
    887898,
    996788,
    779798,
    679979,
    687779,
    678987,
    876879,
    777997,
    786987,
    989788,
    987898,
    888887,
    787899,
    867997,
    898886,
    767797,
    887978,
    787978,
    789679,
    798778,
    787999,
    977988,
    996889,
    688997,
    799999,
    798878,
    968878,
    667988,
    988897,
    777988,
    788876,
    977778,
    887777,
    878987,
    888997,
    887868,
    878778,
    898988,
    978877,
    878986,
    778897,
    888887,
    898988,
    976798,
    876898,
    868877,
    978998,
    877998,
    878777,
    988877,
    887899,
    786987,
    778877,
    889898,
    669887,
    778887,
    878898,
    797786,
    689968,
    867677,
    889787,
    798879,
    877887,
    878789,
    789887,
    989778,
    887887,
    868899,
    899898,
    897689,
    777798,
    788887,
    987888,
    876877,
    877788,
    878788,
    987967,
    778678,
    878698,
    899877,
    888898,
    897776,
    787789,
    888778,
    899886,
    798898,
    989978,
    877887,
    888879,
    878787,
    888787,
    787887,
    797799,
    899987,
    888779,
    887687,
    988879,
    777888,
    888679,
    987786,
    988888,
    898888,
    888888,
    777966,
    988788,
    888887,
    887898,
    889997,
    889899,
    879968,
    877877,
    867788,
    779788,
    877897,
    878778,
    777888,
    798867,
    668988,
    898888,
    868887,
    778688,
    998888,
    878888,
    797979,
    999769,
    777797,
    787787,
    998787,
    778798,
    698776,
    888988,
    888868,
    777788,
    997899,
    677767,
    788968,
    687887,
    997778,
    878898,
    778687,
    878997,
    987777,
    987777,
    877878,
    887888,
    989887,
    877779,
    779789,
    868688,
    887878,
    698686,
    879879,
    897979,
    987889,
    877699,
    889878,
    768889,
    768886,
    797978,
    977878,
    877878,
    798798,
    888789,
    786998,
    898777,
    678788,
    888876,
    869887,
    879879,
    888889,
    688786,
    887898,
    888876,
    977877,
    888887,
    777778,
    797767,
    989978,
    899979,
    889877,
    899888,
    788889,
    787887,
    889898,
    976887,
    887976,
    888898,
    989877,
    978989,
    868797,
    987789,
    779799,
    787898,
    778967,
    798798,
    887878,
    887888,
    977777,
    986999,
    878898,
    689788,
    898877,
    897878,
    988788,
    778888,
    778888,
    997688,
    777788,
    789977,
    787898,
    789889,
    897988,
    886777,
    688886,
    889789,
    878877,
    878876,
    888788,
    887789,
    989887,
    878797,
    797878,
    889869,
    978988,
    688897,
    898979,
    688788,
    788679,
    966777,
    777898,
    888887,
    786778,
    897789,
    687888,
    789797,
    787778,
    987788,
    988989,
    898886,
    777898,
    688788,
    987888,
    868769,
    888888,
    787889,
    879867,
    988867,
    878778,
    878988,
    789878,
    889777,
    887798,
    896788,
    786987,
    687996,
    888777,
    678778,
    778977,
    798777,
    796779,
    979786,
    878788,
    779787,
    787797,
    888787,
    967978,
    887778,
    878897,
    889867,
    878788,
    979778,
    979898,
    999787,
    879778,
    889878,
    888899,
    687899,
    977888,
    887777,
    898998,
    999987,
    788778,
    886877,
    797987,
    798898,
    887868,
    977789,
    797697,
    798888,
    889788,
    776677,
    898888,
    799898,
    899978,
    697988,
    888977,
    898777,
    997977,
    798968,
    787777,
    878787,
    797878,
    888698,
    787698,
    789888,
    797888,
    798987,
    798889,
    877898,
    988878,
    798797,
    988878,
    978887,
    987687,
    686888,
    877797,
    978798,
    878787,
    977889,
    687988,
    886687,
    678787,
    979777,
    988886,
    989687,
    867978,
    877868,
    768888,
    966788,
    888979,
    878879,
    889978,
    888788,
    689988,
    998898,
    777878,
    778778,
    777779,
    788889,
    797878,
    798877,
    887768,
    886779,
    777887,
    988968,
    778767,
    777987,
    797997,
    778886,
    898798,
    868787,
    988877,
    787899,
    888787,
    768898,
    888797,
    677868,
    988899,
    789888,
    877789,
    888788,
    778888,
    888798,
    989678,
    887888,
    787888,
    788898,
    888889,
    987998,
    778887,
    788878,
    698799,
    888878,
    889898,
    988978,
    999789,
    868999,
    796877,
    977987,
    887987,
    977978,
    778988,
    886899,
    898989,
    777788,
    799977,
    797898,
    788788,
    689788,
    988878,
    887877,
    869888,
    978777,
    788777,
    988788,
    779876,
    889878,
    868869,
    888888,
    798787,
    876968,
    876877,
    987799,
    869888,
    887779,
    887888,
    989797,
    779878,
    868888,
    898678,
    786888,
    978867,
    987887,
    988989,
    889788,
    866787,
    888868,
    867897,
    787778,
    877969,
    788888,
    899688,
    869898,
    788779,
    876878,
    788898,
    789776,
    888867,
    779968,
    978898,
    887978,
    888797,
    787798,
    767878,
    988887,
    898799,
    867689,
    888888,
    776878,
    899786,
    787877,
    998878,
    787887,
    777979,
    887889,
    877786,
    777888,
    788877,
    898788,
    989678,
    998898,
    997888,
    677786,
    978897,
    897886,
    987878,
    788877,
    899787,
    878978,
    788878,
    687787,
    878878,
    787889,
    786888,
    888887,
    887888,
    778989,
    889878,
    878988,
    889778,
    998897,
    798668,
    788889,
    788978,
    978877,
    788787,
    777998,
    976797,
    867978,
    888988,
    989979,
    689779,
    699778,
    889679,
    879787,
    799978,
    989778,
    897696,
    987787,
    688879,
    878767,
    876987,
    977798,
    888788,
    878888,
    787888,
    678888,
    866878,
    687897,
    777889,
    778979,
    877688,
    868889,
    787888,
    988678,
    777869,
    787788,
    988789,
    998988,
    898786,
    889876,
    978779,
    778876,
    888787,
    788899,
    998798,
    997898,
    887788,
    787876,
    887887,
    889887,
    788798,
    778776,
    888888,
    789787,
    687877,
    887877,
    889787,
    889988,
    889778,
    788977,
    687878,
    877888,
    786879,
    888888,
    788878,
    778789,
    787987,
    778978,
    877866,
    878888,
    879777,
    799879,
    879987,
    697977,
    898978,
    888876,
    779877,
    778877,
    878899,
    777797,
    876877,
    887778,
    899878,
    888897,
    778889,
    679876,
    787878,
    997978,
    788788,
    788778,
    989988,
    798987,
    999778,
    877988,
    877686,
    887978,
    988889,
    869797,
    778887,
    688797,
    788787,
    897888,
    697889,
    978767,
    987888,
    897697,
    898779,
    788887,
    888889,
    988999,
    999987,
    688789,
    887878,
    798899,
    978888,
    998898,
    897688,
    879898,
    888777,
    886777,
    776679,
    878778,
    888778,
    878879,
    999999,
    777877,
    968877,
    888878,
    787868,
    877998,
    887676,
    777969,
    997998,
    889897,
    769678,
    888779,
    887887,
    887877,
    877788,
    977798,
    888988,
    978878,
    888887,
    778998,
    788698,
    878779,
    888787,
    998778,
    898887,
    979889,
    776777,
    887799,
    979877,
    899988,
    977877,
    977776,
    899996,
    898977,
    878687,
    979879,
    886888,
    889896,
    878867,
    888888,
    878799,
    887697,
    888788,
    688889,
    878898,
    888878,
    787979,
    787888,
    779988,
    877788,
    979789,
    878878,
    777888,
    877889,
    788676,
    897879,
    788868,
    687898,
    787987,
    778889,
    988887,
    898899,
    969888,
    878777,
    788888,
    887779,
    778788,
    788888,
    968878,
    898878,
    877887,
    777987,
    686886,
    879989,
    878798,
    998678,
    877977,
    699888,
    788887,
    786987,
    977987,
    998779,
    778899,
    787778,
    897787,
    797789,
    788888,
    789867,
    787688,
    786867,
    778786,
    878777,
    787889,
    876778,
    889796,
    868787,
    689877,
    788878,
    868979,
    998998,
    977787,
    886977,
    778886,
    868887,
    787888,
    988768,
    778787,
    897977,
    767689,
    888988,
    988798,
    788777,
    987768,
    788778,
    878799,
    888988,
    888789,
    987788,
    876897,
    889678,
    897779,
    888897,
    889888,
    787879,
    687897,
    899978,
    787977,
    878886,
    787896,
    868787,
    778879,
    887899,
    887787,
    788868,
    888899,
    996778,
    998978,
    889789,
    789888,
    986778,
    787779,
    877897,
    897787,
    788778,
    778887,
    879767,
    769887,
    998887,
    777779,
    777978,
    877787,
    778886,
    899787,
    989778,
    899789,
    978888,
    877886,
    888789,
    879787,
    788878,
    977779,
    978996,
    788989,
    889889,
    699977,
    797879,
    887978,
    989786,
    798888,
    877887,
    886788,
    978886,
    997889,
    899799,
    889777,
    788888,
    888899,
    986878,
    987887,
    897888,
    887867,
    786778,
    778777,
    699877,
    788888,
    788788,
    787988,
    898887,
    777889,
    887988,
    977888,
    776877,
    888876,
    678987,
    978889,
    897888,
    788877,
    798787,
    787797,
    778779,
    887779,
    689987,
    888877,
    976886,
    777988,
    798888,
    789777,
    777688,
    998786,
    697898,
    689899,
    989989,
    898889,
    897987,
    988797,
    898887,
    987988,
    878889,
    787778,
    899897,
    998888,
    988888,
    789887,
    788878,
    788877,
    697878,
    897987,
    789868,
    898878,
    677679,
    877779,
    786788,
    779987,
    868867,
    687878,
    897778,
    886899,
    797788,
    889888,
    888776,
    687889,
    798979,
    887879,
    766998,
    779789,
    788877,
    987887,
    987886,
    989788,
    897787,
    868798,
    987976,
    977988,
    898989,
    878798,
    776889,
    878888,
    789879,
    799788,
    878797,
    888997,
    777889,
    887898,
    877978,
    988689,
    968876,
    776999,
    878798,
    976978,
    867878,
    689787,
    687879,
    677889,
    877977,
    988879,
    798879,
    788878,
    888979,
    787986,
    887978,
    889978,
    777876,
    897787,
    797989,
    778888,
    877978,
    779887,
    877887,
    788887,
    777878,
    979787,
    788899,
    997879,
    877788,
    777779,
    688979,
    797789,
    787877,
    698978,
    779868,
    868877,
    877888,
    769879,
    889888,
    776778,
    978978,
    887879,
    769978,
    888896,
    778767,
    977789,
    877778,
    897967,
    788787,
    888978,
    696976,
    868778,
    888987,
    897789,
    789898,
    788889,
    998898,
    887877,
    768888,
    878968,
    778779,
    977788,
    897688,
    898779,
    878778,
    879778,
    877877,
    779979,
    869888,
    886887,
    788789,
    778779,
    977766,
    878987,
    899898,
    888688,
    887879,
    886778,
    888988,
    789697,
    877898,
    976797,
    876868,
    898889,
    778888,
    897988,
    899697,
    777798,
    787886,
    898688,
    798798,
    898787,
    789989,
    978878,
    889867,
    897677,
    879769,
    979998,
    889988,
    777886,
    889889,
    978787,
    878898,
    988878,
    677688,
    887887,
    869779,
    779889,
    988898,
    878878,
    768889,
    777877,
    989778,
    887798,
    888768,
    788879,
    879978,
    877788,
    978878,
    787887,
    797798,
    898968,
    798879,
    887678,
    887788,
    889899,
    787787,
    878878,
    877977,
    888777,
    687967,
    877888,
    677778,
    978988,
    777789,
    888798,
    688879,
    868786,
    886787,
    788898,
    778888,
    788887,
    879888,
    779988,
    978779,
    878887,
    877877,
    777866,
    887878,
    668796,
    777787,
    789786,
    998777,
    786788,
    899976,
    988888,
    787898,
    998977,
    787879,
    799687,
    698779,
    999878,
    877787,
    779788,
    877977,
    797899,
    779798,
    787687,
    686799,
    899787,
    888877,
    787778,
    898777,
    978878,
    888878,
    787777,
    977987,
    967677,
    988867,
    868989,
    778787,
    887786,
    878968,
    879899,
    776797,
    789887,
    779878,
    777877,
    788887,
    789777,
    768778,
    989889,
    878778,
    688999,
    879998,
    788878,
    889887,
    987897,
    878997,
    889977,
    999788,
    689778,
    787789,
    778887,
    778787,
    777878,
    777777,
    976987,
    667798,
    689787,
    789997,
    789968,
    889886,
    878878,
    889978,
    977668,
    897889,
    978789,
    788787,
    886797,
    798777,
    687889,
    897978,
    887898,
    987768,
    898778,
    787987,
    888898,
    888797,
    797878,
    886998,
    787788,
    788768,
    777886,
    997898,
    899888,
    987987,
    787787,
    788867,
    878877,
    798888,
    788889,
    799789,
    879877,
    878786,
    799889,
    778877,
    668878,
    989798,
    888779,
    788868,
    778887,
    797779,
    778787,
    798888,
    778877,
    779787,
    678876,
    789779,
    788978,
    776887,
    887777,
    677778,
    778899,
    869878,
    868888,
    986997,
    989986,
    867787,
    788788,
    877778,
    888888,
    988689,
    978797,
    888889,
    898888,
    787777,
    778797,
    987797,
    788997,
    998888,
    997899,
    887887,
    888877,
    787778,
    787879,
    788878,
    989787,
    898898,
    866977,
    789778,
    988777,
    688888,
    788898,
    967897,
    687988,
    897887,
    977988,
    878887,
    787679,
    889898,
    888897,
    898779,
    978779,
    779898,
    999988,
    878978,
    878879,
    779887,
    977998,
    778978,
    778887,
    778878,
    879969,
    889788,
    777879,
    878887,
    877788,
    897688,
    878798,
    879979,
    788998,
    868998,
    677889,
    698977,
    878996,
    987878,
    897887,
    899798,
    777878,
    689887,
    678979,
    868877,
    798876,
    798697,
    888889,
    978879,
    788998,
    689876,
    867987,
    787888,
    977977,
    879898,
    979867,
    678979,
    987779,
    887998,
    787786,
    879989,
    897768,
    986879,
    889887,
    897897,
    777888,
    997988,
    687778,
    887897,
    879877,
    887789,
    898797,
    998877,
    886887,
    787888,
    897987,
    898879,
    877899,
    878787,
    879888,
    899977,
    978896,
    869789,
    879868,
    887899,
    687988,
    698787,
    799688,
    889988,
    988968,
    886888,
    898878,
    788888,
    898897,
    777888,
    888888,
    888987,
    778788,
    878978,
    689767,
    979777,
    989879,
    787678,
    798878,
    778686,
    788779,
    868968,
    899878,
    787878,
    898978,
    987788,
    988986,
    987667,
    898986,
    788888,
    898887,
    978878,
    799899,
    879886,
    997769,
    777879,
    879977,
    867878,
    768877,
    876797,
    787897,
    798888,
    879669,
    987788,
    788897,
    998878,
    878867,
    778787,
    679788,
    787898,
    788887,
    878888,
    888889,
    966889,
    998887,
    797899,
    878797,
    978797,
    878879,
    879978,
    789987,
    787877,
    678787,
    778998,
    989899,
    787897,
    877889,
    877877,
    888877,
    878676,
    789799,
    787889,
    777979,
    888898,
    887788,
    898877,
    889787,
    787678,
    877778,
    877888,
    789988,
    779788,
    678898,
    978787,
    988889,
    877779,
    878797,
    887778,
    888787,
    878977,
    698888,
    888898,
    978987,
    698878,
    979788,
    888779,
    878789,
    987887,
    878997,
    888697,
    897697,
    887677,
    978986,
    888987,
    888887,
    989898,
    687898,
    777887,
    876888,
    888878,
    866988,
    777989,
    888787,
    979787,
    787987,
    878878,
    889997,
    698996,
    889779,
    888768,
    879887,
    898877,
    799878,
    888977,
    797778,
    889789,
    887899,
    999799,
    978897,
    788898,
    688677,
    787889,
    876979,
    887878,
    787788,
    988977,
    778878,
    889998,
    869889,
    877888,
    899886,
    786888,
    796877,
    898787,
    879777,
    886779,
    888878,
    788778,
    998988,
    677967,
    797896,
    897878,
    797888,
    788888,
    798897,
    878797,
    988868,
    989888,
    878977,
    767799,
    897887,
    887887,
    978779,
    779887,
    998787,
    788998,
    877899,
    999888,
    777788,
    888777,
    988878,
    988888,
    897997,
    876778,
    779988,
    688877,
    779877,
    789778,
    787877,
    989776,
    978789,
    777898,
    778888,
    776798,
    779877,
    799977,
    788898,
    888977,
    878887,
    879989,
    787779,
    789879,
    989878,
    798986,
    897788,
    678987,
    986878,
    789879,
    888888,
    977798,
    798787,
    878788,
    988879,
    987797,
    779889,
    778987,
    887786,
    998787,
    889997,
    789778,
    797897,
    788977,
    889898,
    878878,
    798878,
    978797,
    888797,
    787789,
    767767,
    678888,
    789778,
    997877,
    898878,
    777779,
    889789,
    899898,
    989688,
    767786,
    877988,
    978877,
    667787,
    777998,
    776888,
    897887,
    877788,
    686698,
    969987,
    799798,
    888788,
    987868,
    887888,
    897899,
    898889,
    767797,
    999798,
    787977,
    697788,
    877889,
    888968,
    797888,
    788888,
    787877,
    999988,
    998878,
    797887,
    877898,
    779877,
    997898,
    797977,
    787897,
    696799,
    778987,
    888787,
    689978,
    879879,
    789878,
    977987,
    968967,
    988898,
    777897,
    788787,
    798788,
    876988,
    877878,
    988778,
    786888,
    789778,
    878879,
    789697,
    798878,
    997789,
    977786,
    877779,
    788996,
    767988,
    789778,
    888778,
    777788,
    777788,
    797768,
    677978,
    889888,
    867988,
    887867,
    767998,
    879778,
    789787,
    977778,
    887679,
    798887,
    879778,
    889687,
    987787,
    787778,
    877887,
    878988,
    778789,
    899977,
    787977,
    768888,
    989799,
    688787,
    698866,
    887898,
    997899,
    878789,
    898888,
    989787,
    879977,
    878788,
    978779,
    989896,
    788798,
    998987,
    878978,
    887999,
    878879,
    688787,
    867778,
    788878,
    789876,
    888898,
    888897,
    898788,
    976897,
    976798,
    877878,
    897877,
    888888,
    787887,
    888888,
    877667,
    877878,
    967979,
    797789,
    787889,
    987977,
    867888,
    887789,
    877778,
    887798,
    787879,
    887888,
    888898,
    987887,
    978887,
    888878,
    768779,
    987877,
    788877,
    987788,
    988887,
    988988,
    899978,
    876889,
    887877,
    898997,
    987887,
    976678,
    788988,
    879777,
    886899,
    989878,
    887998,
    877887,
    878788,
    888787,
    988879,
    889788,
    787779,
    897788,
    989889,
    886969,
    687987,
    679888,
    888767,
    879889,
    778889,
    698898,
    897979,
    879988,
    879888,
    877979,
    778879,
    688789,
    968898,
    887788,
    876868,
    898898,
    688678,
    786689,
    787778,
    797889,
    878768,
    878898,
    779987,
    877898,
    878788,
    869998,
    886879,
    877768,
    679768,
    988797,
    888798,
    678878,
    777867,
    987798,
    889778,
    887687,
    788797,
    887978,
    887787,
    779889,
    777788,
    986898,
    888987,
    877888,
    876797,
    988888,
    798897,
    679999,
    778888,
    878688,
    799867,
    886787,
    677888,
    678897,
    788897,
    778678,
    877879,
    677799,
    887887,
    869877,
    679878,
    777787,
    966979,
    888788,
    886777,
    887997,
    888789,
    879787,
    887787,
    778867,
    888797,
    687777,
    887898,
    998778,
    778989,
    889786,
    977779,
    799788,
    967787,
    887898,
    789987,
    977978,
    886999,
    986787,
    989778,
    769888,
    777768,
    778888,
    888887,
    968898,
    798888,
    778776,
    988887,
    988988,
    987698,
    979789,
    867789,
    767898,
    898897,
    789869,
    889877,
    679887,
    679768,
    788788,
    987898,
    798878,
    888787,
    766788,
    686778,
    888886,
    976786,
    988987,
    888689,
    887989,
    879788,
    898787,
    876889,
    887987,
    888877,
    887879,
    967979,
    987988,
    778889,
    867788,
    887777,
    878888,
    888777,
    799979,
    787788,
    789877,
    777888,
    899776,
    878778,
    687987,
    878989,
    988988,
    879998,
    788779,
    778888,
    779878,
    778878,
    887789,
    987997,
    877688,
    799779,
    888788,
    777778,
    888796,
    789687,
    888787,
    888978,
    889987,
    888888,
    788887,
    888787,
    879977,
    788788,
    788879,
    788867,
    889888,
    989998,
    998797,
    796987,
    788988,
    998999,
    877897,
    887787,
    786887,
    967787,
    788898,
    896889,
    678888,
    777876,
    997897,
    777887,
    997887,
    887898,
    988777,
    998988,
    879788,
    868898,
    877879,
    787866,
    787968,
    787777,
    988768,
    778788,
    887887,
    988898,
    878689,
    897887,
    888789,
    896888,
    988897,
    689797,
    687999,
    778778,
    989989,
    888876,
    787968,
    788799,
    886688,
    887697,
    877786,
    789877,
    888797,
    788787,
    968789,
    889869,
    888896,
    877986,
    978987,
    767776,
    778788,
    778879,
    788989,
    768797,
    987886,
    887787,
    788888,
    988978,
    797877,
    978889,
    778778,
    988886,
    889786,
    898789,
    787777,
    877788,
    787887,
    898788,
    978899,
    788998,
    787777,
    887698,
    877787,
    797779,
    877978,
    687779,
    897778,
    786688,
    987778,
    787788,
    789778,
    898996,
    886778,
    877869,
    888878,
    878988,
    978987,
    888897,
    778977,
    798999,
    997766,
    889898,
    799878,
    889877,
    888887,
    678888,
    897968,
    688786,
    889787,
    778888,
    769887,
    796778,
    888896,
    897679,
    786889,
    787788,
    977779,
    888887,
    779989,
    887878,
    889888,
    778987,
    679768,
    898898,
    887888,
    797986,
    877977,
    786998,
    977987,
    786989,
    799888,
    788988,
    898898,
    978688,
    878787,
    879787,
    878778,
    899877,
    996787,
    877878,
    887788,
    987988,
    677988,
    787969,
    887979,
    788787,
    879677,
    788796,
    788888,
    877679,
    987776,
    877898,
    899889,
    667878,
    987889,
    877988,
    987777,
    987989,
    877876,
    798798,
    778887,
    879786,
    978888,
    999878,
    888878,
    877878,
    779687,
    898878,
    987968,
    878787,
    988878,
    888868,
    878988,
    788988,
    888878,
    789889,
    887789,
    777898,
    878778,
    887897,
    689688,
    789777,
    887888,
    887877,
    779988,
    889776,
    897866,
    989898,
    788998,
    998767,
    998768,
    878989,
    787979,
    778688,
    898788,
    898798,
    978778,
    878878,
    987778,
    786998,
    799987,
    879688,
    777978,
    988897,
    898877,
    797888,
    889789,
    868888,
    896878,
    877787,
    867676,
    887977,
    887889,
    898979,
    799688,
    988877,
    799978,
    988887,
    877798,
    777886,
    888889,
    799887,
    887788,
    798888,
    889987,
    898888,
    987687,
    687689,
    778989,
    878897,
    888888,
    878887,
    998897,
    788788,
    788898,
    787777,
    877988,
    989777,
    898868,
    786879,
    898989,
    878997,
    689996,
    777778,
    878898,
    877988,
    978867,
    878868,
    778798,
    788678,
    788877,
    688878,
    978787,
    776679,
    888886,
    798887,
    897869,
    868788,
    686788,
    887966,
    889767,
    979766,
    886899,
    888768,
    888987,
    797878,
    677977,
    777877,
    799678,
    988789,
    777798,
    877867,
    986988,
    898988,
    778689,
    888877,
    889787,
    889987,
    778766,
    887889,
    998788,
    796978,
    787888,
    989888,
    887998,
    877887,
    888898,
    878787,
    886888,
    878879,
    866789,
    877787,
    987888,
    878798,
    997878,
    798789,
    767779,
    777877,
    788788,
    877787,
    678889,
    888988,
    679887,
    968899,
    899868,
    778998,
    977968,
    788778,
    888887,
    978777,
    789786,
    877897,
    878888,
    979999,
    977979,
    778789,
    886788,
    887887,
    997878,
    988899,
    989887,
    887789,
    889879,
    887788,
    988967,
    788778,
    779887,
    899778,
    977787,
    779696,
    899977,
    777889,
    877778,
    998876,
    889977,
    797877,
    998797,
    868889,
    889679,
    969978,
    778687,
    788887,
    779779,
    787687,
    888777,
    869878,
    877777,
    989778,
    988777,
    777878,
    977787,
    797887,
    778879,
    887688,
    989889,
    789787,
    888888,
    777888,
    888896,
    877888,
    987888,
    878788,
    977967,
    667998,
    998899,
    976787,
    988798,
    767798,
    899868,
    788988,
    787899,
    887976,
    887688,
    879688,
    977787,
    799988,
    978788,
    886878,
    886779,
    779978,
    878798,
    898767,
    797888,
    887988,
    878787,
    886888,
    889887,
    998989,
    896868,
    899787,
    797899,
    888799,
    886967,
    788888,
    989887,
    977787,
    897787,
    889777,
    778899,
    788867,
    989677,
    898799,
    898889,
    887888,
    778898,
    887867,
    778888,
    987778,
    677779,
    799788,
    789678,
    788879,
    787887,
    899897,
    888887,
    887778,
    777778,
    688987,
    788767,
    768876,
    788887,
    868897,
    688878,
    888689,
    888979,
    888988,
    687878,
    799878,
    778799,
    989788,
    887788,
    889878,
    997878,
    878898,
    788888,
    788898,
    787888,
    787887,
    879777,
    887889,
    777778,
    897989,
    789887,
    987777,
    688887,
    877888,
    988978,
    788799,
    877769,
    787796,
    887888,
    888788,
    887899,
    798899,
    888778,
    977979,
    898998,
    887878,
    888777,
    898889,
    979888,
    889899,
    786877,
    788777,
    889787,
    878877,
    897888,
    978888,
    978897,
    778889,
    687776,
    977788,
    896977,
    879989,
    787789,
    889778,
    766996,
    777897,
    888969,
    889787,
    899876,
    888888,
    888876,
    799898,
    779879,
    788987,
    797788,
    889696,
    998889,
    997788,
    866899,
    898877,
    778889,
    888777,
    788778,
    978888,
    987888,
    878887,
    897899,
    898887,
    869797,
    888977,
    888768,
    796788,
    887887,
    788699,
    898898,
    887997,
    879879,
    979877,
    778878,
    897978,
    778687,
    776777,
    887788,
    898877,
    778777,
    888978,
    797788,
    797976,
    789869,
    789879,
    978778,
    898989,
    877897,
    687669,
    977998,
    679867,
    779987,
    799888,
    898789,
    877789,
    887698,
    886698,
    788988,
    977797,
    977899,
    878898,
    888896,
    788987,
    879869,
    789789,
    988886,
    777888,
    778788,
    888886,
    888897,
    877889,
    777976,
    898977,
    899888,
    878987,
    769798,
    687778,
    888878,
    787669,
    678878,
    797977,
    788898,
    788798,
    788888,
    878877,
    697887,
    788977,
    787797,
    997997,
    676698,
    989887,
    887777,
    978888,
    877868,
    788788,
    788779,
    788877,
    887788,
    899878,
    986998,
    869878,
    899688,
    898899,
    798877,
    886887,
    888777,
    788887,
    768689,
    888879,
    878979,
    998788,
    878677,
    789888,
    789999,
    998777,
    788779,
    877687,
    988777,
    789889,
    776869,
    987986,
    887778,
    898988,
    877887,
    788788,
    887768,
    878777,
    977889,
    979796,
    877997,
    776976,
    886878,
    778998,
    889789,
    877879,
    888986,
    887688,
    998887,
    997798,
    776876,
    889776,
    989777,
    787888,
    768867,
    888888,
    687899,
    877898,
    778888,
    888779,
    988678,
    868978,
    778888,
    978778,
    889767,
    777897,
    987777,
    987799,
    687769,
    879889,
    878789,
    878778,
    776777,
    878688,
    977787,
    879886,
    787889,
    898778,
    978978,
    698987,
    777789,
    898788,
    888788,
    977977,
    776877,
    978888,
    889878,
    879979,
    767877,
    779899,
    988969,
    798799,
    897989,
    778877,
    886977,
    888898,
    889787,
    887778,
    987897,
    889778,
    977989,
    897887,
    687769,
    769797,
    769897,
    778788,
    889789,
    887968,
    888888,
    789888,
    769768,
    787877,
    889797,
    878987,
    798878,
    887988,
    888788,
    889798,
    987778,
    779878,
    888878,
    878988,
    988977,
    787678,
    979788,
    877877,
    998889,
    887867,
    788798,
    879878,
    898678,
    787898,
    688877,
    787888,
    887999,
    879879,
    888778,
    996777,
    797868,
    777887,
    866878,
    977778,
    987978,
    898798,
    888778,
    789997,
    789868,
    779988,
    686679,
    897987,
    798777,
    778777,
    888777,
    778776,
    988967,
    878687,
    887878,
    898889,
    778798,
    778867,
    797779,
    888897,
    878877,
    977967,
    778789,
    768967,
    878778,
    679887,
    679996,
    877888,
    787888,
    887876,
    689997,
    899998,
    988969,
    978698,
    789878,
    997798,
    789769,
    898877,
    788778,
    776777,
    887698,
    888778,
    768988,
    887888,
    787979,
    788978,
    698777,
    797789,
    887888,
    777788,
    789786,
    798676,
    789866,
    888778,
    977877,
    878877,
    777788,
    877888,
    977888,
    877888,
    877888,
    687896,
    977888,
    868698,
    768987,
    779997,
    967798,
    897776,
    877797,
    888867,
    779868,
    879897,
    788887,
    878898,
    988788,
    978878,
    887888,
    889768,
    988888,
    887788,
    798877,
    898779,
    779789,
    877898,
    978867,
    788896,
    888887,
    767999,
    789778,
    987886,
    999868,
    887788,
    978789,
    887889,
    888887,
    787787,
    878787,
    778876,
    879777,
    878768,
    978797,
    987668,
    778888,
    797679,
    879798,
    777867,
    678789,
    798778,
    899869,
    888887,
    898778,
    877889,
    777888,
    879789,
    768887,
    997788,
    898886,
    798887,
    888978,
    678788,
    678987,
    788877,
    877777,
    678898,
    897698,
    797887,
    679787,
    998778,
    889967,
    797899,
    878897,
    897868,
    988688,
    878688,
    878688,
    778989,
    979777,
    797787,
    888877,
    968877,
    978678,
    788797,
    788798,
    867878,
    787867,
    877987,
    767667,
    898786,
    989998,
    999867,
    878978,
    888887,
    877989,
    678888,
    887886,
    768787,
    776776,
    787778,
    778989,
    778876,
    968899,
    987877,
    789797,
    688887,
    767879,
    689898,
    879898,
    888877,
    767998,
    887788,
    888769,
    888878,
    987998,
    698787,
    988688,
    879797,
    898798,
    978787,
    968798,
    798888,
    877687,
    868779,
    888879,
    878788,
    887778,
    787767,
    869768,
    788978,
    797798,
    899986,
    889689,
    888968,
    878867,
    789887,
    888998,
    887897,
    869887,
    888677,
    988989,
    887779,
    879767,
    788878,
    886787,
    978767,
    888786,
    868878,
    776997,
    887698,
    788878,
    979787,
    888787,
    897987,
    988786,
    787876,
    888788,
    888869,
    887887,
    779679,
    797888,
    878987,
    777879,
    968987,
    868778,
    787797,
    979688,
    788769,
    778998,
    798879,
    878788,
    868989,
    788787,
    987798,
    898998,
    877777,
    987878,
    678778,
    787678,
    787899,
    978768,
    798796,
    898878,
    976889,
    988888,
    779978,
    677887,
    776788,
    789787,
    788877,
    897988,
    887987,
    867779,
    786898,
    867887,
    888869,
    888977,
    787898,
    788987,
    899978,
    877977,
    778777,
    768788,
    877988,
    889687,
    898786,
    787889,
    868888,
    888878,
    878889,
    979779,
    777998,
    769867,
    797778,
    877887,
    777878,
    887798,
    989789,
    998968,
    788899,
    868897,
    678767,
    898887,
    868787,
    787887,
    778787,
    787998,
    987989,
    798887,
    888777,
    688899,
    888887,
    799798,
    897788,
    987978,
    889888,
    777887,
    887867,
    779678,
    789787,
    788678,
    888787,
    889988,
    899979,
    879878,
    687796,
    687777,
    879888,
    887979,
    879678,
    877877,
    788888,
    888877,
    788777,
    887788,
    888988,
    888798,
    778878,
    968898,
    878777,
    988778,
    889778,
    776987,
    789886,
    789787,
    779788,
    986887,
    678768,
    887778,
    897789,
    778878,
    778888,
    897878,
    768878,
    788878,
    789877,
    778898,
    797798,
    887799,
    787886,
    787787,
    777788,
    788777,
    986987,
    888988,
    786888,
    979976,
    888789,
    789988,
    888898,
    988889,
    988789,
    887988,
    778698,
    787797,
    889879,
    898889,
    789886,
    898989,
    768888,
    887989,
    888886,
    878997,
    886879,
    869796,
    778889,
    888798,
    887688,
    889979,
    878789,
    878898,
    889776,
    787796,
    797988,
    978888,
    888888,
    897878,
    978898,
    987869,
    878977,
    888778,
    978898,
    888888,
    889898,
    998888,
    867877,
    769988,
    778898,
    888799,
    797678,
    888667,
    787796,
    777877,
    888779,
    787877,
    887897,
    887777,
    788898,
    767879,
    788798,
    988898,
    778898,
    878979,
    787877,
    989868,
    988889,
    768878,
    887878,
    798887,
    767898,
    987879,
    869899,
    688979,
    889887,
    768899,
    687687,
    889878,
    778879,
    777878,
    788978,
    778887,
    897887,
    868777,
    687778,
    977988,
    967977,
    969887,
    798788,
    878778,
    868999,
    877888,
    989888,
    688778,
    897889,
    977887,
    978787,
    888897,
    889987,
    679776,
    889897,
    877768,
    887899,
    688789,
    878888,
    888799,
    966776,
    788879,
    888878,
    867798,
    967988,
    888868,
    988787,
    878688,
    788787,
    878887,
    787777,
    697787,
    788776,
    888968,
    788787,
    677998,
    887888,
    789787,
    888997,
    879777,
    868988,
    786899,
    677787,
    987777,
    698979,
    866998,
    887778,
    676877,
    899977,
    897778,
    897898,
    899778,
    769778,
    978768,
    768977,
    889999,
    689788,
    967788,
    999797,
    868787,
    888888,
    987887,
    888778,
    887969,
    886988,
    788778,
    989788,
    888887,
    878988,
    869878,
    877777,
    877878,
    878988,
    878887,
    888988,
    889997,
    887878,
    788686,
    798798,
    789877,
    789877,
    786788,
    987887,
    997969,
    878877,
    688699,
    787879,
    876796,
    789797,
    889789,
    889898,
    788669,
    878886,
    798888,
    888779,
    978988,
    799879,
    787988,
    888888,
    878899,
    698887,
    888987,
    979978,
    888876,
    878878,
    679986,
    887876,
    687897,
    998887,
    788788,
    869986,
    978989,
    888989,
    798677,
    897787,
    767887,
    878997,
    788697,
    888998,
    887896,
    978867,
    786879,
    978888,
    787778,
    779789,
    798688,
    778789,
    889887,
    887877,
    778887,
    897977,
    897689,
    897788,
    788898,
    787989,
    789877,
    888988,
    887987,
    898978,
    879987,
    898888,
    687878,
    688779,
    897797,
    887878,
    997779,
    889789,
    897876,
    767888,
    799898,
    886979,
    787888,
    877778,
    777788,
    899787,
    978889,
    888999,
    887999,
    887768,
    968787,
    898788,
    677976,
    777989,
    889979,
    788987,
    787778,
    799888,
    788979,
    887889,
    799787,
    678887,
    897788,
    877889,
    888688,
    777788,
    787888,
    888877,
    876978,
    798898,
    897888,
    887788,
    898978,
    978787,
    778878,
    888798,
    788878,
    787887,
    899888,
    876788,
    887886,
    687677,
    878779,
    888766,
    787789,
    889888,
    789897,
    888897,
    886887,
    799777,
    988889,
    887987,
    899798,
    787787,
    997686,
    988979,
    699789,
    868979,
    779888,
    978978,
    988699,
    888779,
    989867,
    778797,
    978888,
    876879,
    797879,
    777878,
    778788,
    888887,
    978788,
    867788,
    977978,
    777686,
    977888,
    896887,
    989877,
    868788,
    878989,
    698777,
    877887,
    887899,
    787888,
    977788,
    788899,
    977787,
    888977,
    879896,
    888798,
    887997,
    798778,
    997889,
    989797,
    787788,
    888698,
    997887,
    888877,
    779879,
    797898,
    878796,
    787987,
    787998,
    879997,
    886887,
    878978,
    779988,
    888898,
    998687,
    878889,
    879998,
    898778,
    887677,
    887788,
    988787,
    988776,
    778778,
    997888,
    987898,
    998898,
    787889,
    688877,
    878988,
    886978,
    888897,
    799788,
    778798,
    687688,
    798889,
    789878,
    968888,
    898688,
    779768,
    796878,
    888668,
    879868,
    989699,
    898889,
    877887,
    777886,
    777878,
    979877,
    789976,
    897868,
    778778,
    978678,
    988888,
    788896,
    887897,
    888787,
    889779,
    779888,
    699997,
    989778,
    978787,
    796878,
    788687,
    888777,
    887778,
    777987,
    778997,
    899779,
    687898,
    888887,
    888888,
    998778,
    899877,
    898989,
    787877,
    889877,
    996888,
    979987,
    878778,
    777888,
    868986,
    677987,
    968788,
    789976,
    799978,
    887998,
    789776,
    989677,
    778789,
    787877,
    698887,
    787879,
    788778,
    797787,
    888899,
    766998,
    897786,
    877786,
    997977,
    788778,
    698887,
    877787,
    899898,
    978778,
    989987,
    887998,
    986878,
    887787,
    876998,
    888878,
    789779,
    868779,
    778788,
    887688,
    778778,
    777878,
    797896,
    887878,
    878869,
    886877,
    788988,
    688889,
    877787,
    998797,
    798888,
    797779,
    798787,
    878878,
    687877,
    998977,
    788877,
    899976,
    978877,
    877988,
    887687,
    877688,
    876997,
    778878,
    887888,
    999876,
    697787,
    998998,
    879999,
    898798,
    878898,
    878879,
    878986,
    897978,
    889899,
    779888,
    997678,
    888879,
    887777,
    978777,
    899877,
    889779,
    978877,
    796878,
    779777,
    887987,
    767888,
    888778,
    888879,
    888898,
    888977,
    779778,
    799877,
    887788,
    697879,
    978898,
    788886,
    978779,
    777789,
    988989,
    888977,
    988767,
    887888,
    897889,
    877888,
    877779,
    888887,
    769797,
    878668,
    979988,
    987999,
    977977,
    777798,
    868877,
    878789,
    888799,
    888887,
    879698,
    687887,
    988879,
    797969,
    876787,
    889668,
    887899,
    777978,
    677868,
    787998,
    797789,
    889988,
    787898,
    897877,
    787877,
    698788,
    897988,
    788968,
    889877,
    788887,
    787677,
    787699,
    988998,
    878888,
    877978,
    798888,
    779988,
    789897,
    888877,
    879897,
    897789,
    978788,
    798987,
    887788,
    788777,
    887877,
    889998,
    878789,
    766987,
    789799,
    878878,
    778886,
    899997,
    979967,
    878978,
    878898,
    767888,
    876877,
    777799,
    888987,
    888887,
    998899,
    968669,
    889798,
    787887,
    988988,
    998887,
    987899,
    776768,
    787978,
    887797,
    899787,
    688888,
    778876,
    799978,
    877877,
    967878,
    778878,
    876768,
    888898,
    968796,
    979977,
    877899,
    979777,
    978789,
    878889,
    887877,
    688977,
    878878,
    999879,
    879989,
    969888,
    776898,
    878788,
    897778,
    878898,
    678777,
    777988,
    778888,
    877776,
    779777,
    877897,
    998878,
    879879,
    788798,
    988799,
    888879,
    978979,
    989786,
    877878,
    788887,
    988877,
    797998,
    787887,
    877867,
    879786,
    898678,
    767898,
    978769,
    788888,
    969879,
    778866,
    788997,
    678877,
    799688,
    877796,
    887687,
    889668,
    779979,
    988898,
    666879,
    788799,
    879668,
    989889,
    977877,
    888687,
    888987,
    887888,
    877987,
    898787,
    889988,
    878788,
    976887,
    788987,
    779788,
    877967,
    788887,
    998998,
    788768,
    997997,
    776676,
    788887,
    898697,
    797797,
    899876,
    897998,
    777988,
    878779,
    777788,
    878788,
    887898,
    789688,
    889887,
    989887,
    988878,
    797977,
    788888,
    888788,
    798977,
    778788,
    888777,
    888979,
    778979,
    887777,
    798868,
    799778,
    788777,
    889879,
    788777,
    878877,
    879889,
    787789,
    876997,
    778789,
    879897,
    877988,
    878786,
    877878,
    867788,
    778778,
    777999,
    888896,
    786769,
    798987,
    978988,
    798777,
    787977,
    997877,
    897687,
    777877,
    788878,
    988688,
    897877,
    788877,
    788888,
    787887,
    789888,
    787987,
    888697,
    987988,
    978887,
    987889,
    988678,
    776878,
    987787,
    799878,
    787878,
    789679,
    986786,
    869878,
    897897,
    787897,
    767987,
    788878,
    888988,
    898877,
    789987,
    898789,
    679787,
    787989,
    788776,
    788979,
    967897,
    787998,
    878978,
    789778,
    777697,
    878968,
    788899,
    978967,
    887897,
    798788,
    979978,
    788978,
    969797,
    997986,
    667689,
    888778,
    789987,
    788889,
    987878,
    899898,
    878996,
    689788,
    788788,
    987887,
    688967,
    788876,
    778688,
    966779,
    987797,
    888878,
    989777,
    878778,
    887899,
    897779,
    989778,
    877778,
    888789,
    898878,
    887897,
    988788,
    888768,
    798877,
    797989,
    786897,
    697869,
    977867,
    998868,
    686868,
    988868,
    777877,
    798989,
    987978,
    988887,
    788678,
    887987,
    887778,
    767798,
    787888,
    899768,
    989777,
    988867,
    888887,
    878768,
    779789,
    988988,
    689987,
    897989,
    887778,
    897866,
    889797,
    899898,
    787898,
    888888,
    988876,
    887967,
    867788,
    887789,
    778888,
    998769,
    977877,
    887876,
    987797,
    787898,
    897787,
    878888,
    769778,
    878789,
    868898,
    887788,
    888669,
    996788,
    768688,
    888798,
    889788,
    797787,
    777887,
    797689,
    888769,
    797977,
    978877,
    788898,
    887989,
    897778,
    887789,
    997897,
    686887,
    878877,
    777878,
    878999,
    878897,
    786878,
    788798,
    987886,
    877888,
    877788,
    889789,
    988697,
    889967,
    888789,
    789777,
    998886,
    698878,
    987688,
    788877,
    987879,
    887777,
    896897,
    887898,
    877988,
    879886,
    978878,
    888988,
    868978,
    777898,
    888877,
    798999,
    897878,
    877887,
    879796,
    699869,
    997887,
    888778,
    789889,
    889867,
    768878,
    878788,
    897888,
    869768,
    869889,
    798877,
    888787,
    986878,
    867679,
    888887,
    988869,
    997988,
    876778,
    987977,
    888897,
    787788,
    778878,
    986786,
    797788,
    879989,
    797788,
    788968,
    879887,
    776879,
    888788,
    698667,
    879777,
    788877,
    898778,
    778888,
    777788,
    977889,
    788878,
    786887,
    898796,
    888778,
    898967,
    886878,
    788987,
    888989,
    878897,
    777878,
    796989,
    899678,
    977786,
    779979,
    897797,
    877778,
    877979,
    988997,
    788987,
    688779,
    989787,
    979877,
    877787,
    788798,
    788877,
    888869,
    887797,
    888887,
    978888,
    987688,
    889787,
    897777,
    878788,
    987888,
    799878,
    877787,
    887669,
    887889,
    779977,
    877776,
    878889,
    988778,
    767876,
    977878,
    978897,
    888688,
    988876,
    687878,
    989889,
    877869,
    787867,
    799888,
    988889,
    998798,
    769787,
    789888,
    888977,
    978887,
    786778,
    898897,
    687986,
    889788,
    786789,
    897768,
    969787,
    988888,
    887888,
    987897,
    886778,
    678877,
    788779,
    887879,
    877899,
    878778,
    887879,
    797788,
    797789,
    867798,
    997887,
    878887,
    788899,
    998998,
    987979,
    876988,
    887888,
    767888,
    868889,
    787989,
    887878,
    987788,
    787788,
    889869,
    997676,
    968868,
    797869,
    887998,
    898687,
    888987,
    988678,
    996887,
    787888,
    687779,
    798977,
    888788,
    979678,
    876978,
    687787,
    799979,
    887888,
    788889,
    879869,
    968876,
    968988,
    798899,
    978877,
    777988,
    788998,
    788899,
    898797,
    789977,
    889788,
    679777,
    887889,
    688887,
    778977,
    878887,
    688878,
    788978,
    797788,
    867888,
    867888,
    889898,
    887778,
    998787,
    988687,
    967878,
    876889,
    877778,
    878778,
    789787,
    777786,
    789998,
    877897,
    888887,
    987776,
    878788,
    898888,
    687798,
    897888,
    989887,
    987887,
    888877,
    967867,
    898787,
    767787,
    887769,
    878979,
    889778,
    788889,
    789787,
    978887,
    878988,
    899987,
    887878,
    979766,
    798888,
    796888,
    878888,
    898777,
    889877,
    878788,
    777987,
    887977,
    679787,
    788886,
    789679,
    989878,
    988996,
    877787,
    686887,
    887788,
    796897,
    888878,
    798888,
    877768,
    878778,
    888768,
    998887,
    978897,
    878887,
    996878,
    978878,
    879788,
    988987,
    797897,
    976887,
    889969,
    989779,
    788798,
    778798,
    877697,
    888889,
    787887,
    668888,
    897787,
    978886,
    897787,
    677688,
    888878,
    798888,
    989997,
    679888,
    787888,
    788786,
    997787,
    898897,
    768977,
    879769,
    798868,
    877789,
    688887,
    799788,
    888987,
    876667,
    788887,
    778798,
    878788,
    888997,
    787789,
    788877,
    979877,
    799969,
    988778,
    878899,
    979879,
    786879,
    878897,
    877698,
    789987,
    888888,
    788869,
    879888,
    688888,
    778888,
    778778,
    887888,
    968689,
    768997,
    898678,
    968878,
    887888,
    788887,
    999978,
    888878,
    876677,
    789888,
    888787,
    878779,
    979878,
    887878,
    687779,
    797778,
    777779,
    887787,
    888778,
    898687,
    878798,
    887987,
    889777,
    989779,
    988879,
    869977,
    788989,
    977889,
    878879,
    878878,
    777886,
    867988,
    779977,
    988878,
    988898,
    897898,
    899878,
    799989,
    778889,
    979788,
    788899,
    798798,
    888877,
    987988,
    878888,
    788886,
    787878,
    979988,
    896889,
    879898,
    988888,
    798778,
    897988,
    788878,
    889978,
    779788,
    977887,
    887776,
    888888,
    778778,
    998877,
    997988,
    887877,
    776999,
    878898,
    677786,
    779797,
    798978,
    886887,
    778788,
    688898,
    788888,
    778788,
    878878,
    778877,
    779887,
    799786,
    888978,
    778688,
    777878,
    898887,
    989977,
    887888,
    877977,
    899698,
    878989,
    777878,
    976898,
    879897,
    789877,
    888897,
    778688,
    787777,
    788887,
    888788,
    988776,
    798788,
    989878,
    887888,
    878989,
    878969,
    998997,
    788788,
    688999,
    798789,
    888878,
    768787,
    968878,
    897789,
    877777,
    876688,
    878888,
    868877,
    987898,
    777778,
    899869,
    898888,
    877867,
    987998,
    987868,
    968877,
    797879,
    768888,
    777988,
    797778,
    998898,
    878788,
    988887,
    888898,
    968888,
    988877,
    888887,
    987788,
    787969,
    878969,
    988789,
    789978,
    798797,
    988879,
    968786,
    787787,
    767679,
    688797,
    877687,
    989879,
    887798,
    877988,
    898888,
    797897,
    878689,
    989878,
    977668,
    898878,
    787888,
    778777,
    978898,
    898789,
    888897,
    788787,
    778976,
    988787,
    979789,
    798977,
    887898,
    978678,
    777789,
    887878,
    879888,
    787979,
    987778,
    679879,
    898787,
    877889,
    778977,
    888878,
    898767,
    888887,
    877977,
    876987,
    989878,
    689978,
    699878,
    879989,
    998898,
    778867,
    788988,
    778769,
    787786,
    789787,
    787788,
    877878,
    989798,
    788778,
    688888,
    887778,
    967988,
    887977,
    798777,
    887778,
    898887,
    888979,
    999867,
    888787,
    786988,
    777697,
    787877,
    777677,
    778996,
    789787,
    788877,
    979786,
    778787,
    888998,
    798889,
    697788,
    898977,
    777787,
    989788,
    887868,
    878888,
    988797,
    997878,
    988769,
    867888,
    898688,
    787879,
    877997,
    687888,
    877797,
    866868,
    978977,
    768898,
    986999,
    987789,
    787888,
    879989,
    888789,
    768887,
    878977,
    987976,
    879979,
    697868,
    788897,
    988876,
    988998,
    779778,
    766889,
    899988,
    977878,
    787789,
    888798,
    788899,
    888978,
    898778,
    787786,
    778788,
    697878,
    788988,
    777788,
    978688,
    789878,
    788897,
    668879,
    888676,
    688788,
    877987,
    788777,
    797997,
    887888,
    787888,
    988878,
    889879,
    779689,
    988697,
    888877,
    988797,
    898798,
    688779,
    898887,
    987997,
    887988,
    987888,
    878876,
    889878,
    888877,
    777878,
    878978,
    986788,
    788879,
    788779,
    778788,
    788779,
    998779,
    878887,
    697787,
    898888,
    688889,
    877899,
    888799,
    878999,
    788897,
    788797,
    787898,
    888788,
    799767,
    987879,
    887778,
    877777,
    878887,
    898887,
    877888,
    886879,
    788978,
    779877,
    898788,
    978888,
    898889,
    799787,
    688889,
    788888,
    976789,
    977869,
    786987,
    898798,
    888688,
    899887,
    778789,
    888678,
    887786,
    988788,
    887788,
    799897,
    878867,
    878898,
    688789,
    787677,
    867988,
    988788,
    978989,
    797778,
    888788,
    987777,
    987779,
    788889,
    797797,
    687998,
    987677,
    977887,
    777768,
    777898,
    778788,
    679788,
    888788,
    788887,
    787998,
    878788,
    888788,
    876788,
    689788,
    888678,
    878879,
    796877,
    899997,
    688788,
    789999,
    778988,
    788786,
    886986,
    769776,
    888897,
    778897,
    788986,
    989897,
    879787,
    897987,
    888878,
    979697,
    877887,
    977979,
    987789,
    888878,
    898767,
    987777,
    889977,
    787788,
    877887,
    678879,
    788879,
    879787,
    999877,
    777889,
    877878,
    867997,
    788888,
    878878,
    888987,
    988787,
    878778,
    889689,
    888987,
    877888,
    888978,
    868779,
    887888,
    868787,
    678888,
    899789,
    677888,
    889878,
    889788,
    688789,
    887768,
    778788,
    889989,
    777769,
    888866,
    878897,
    988998,
    778988,
    888878,
    787969,
    766989,
    797877,
    779987,
    987997,
    888889,
    788678,
    878798,
    778778,
    888796,
    789888,
    888788,
    779867,
    888887,
    888998,
    878888,
    877777,
    878788,
    899878,
    887899,
    787689,
    878788,
    889988,
    897888,
    887898,
    877888,
    878797,
    889988,
    888678,
    778879,
    687877,
    778977,
    889889,
    966988,
    888988,
    886879,
    878786,
    799798,
    898788,
    877778,
    879897,
    788888,
    998778,
    887889,
    878878,
    879998,
    778876,
    877796,
    878698,
    877887,
    968869,
    897877,
    789798,
    878889,
    887787,
    678898,
    787877,
    787988,
    778779,
    798888,
    799888,
    788768,
    987798,
    887798,
    988879,
    887899,
    779888,
    997787,
    968788,
    788798,
    889689,
    977778,
    788877,
    888788,
    888789,
    778798,
    987779,
    888868,
    777999,
    799989,
    688898,
    978797,
    897768,
    768777,
    889787,
    889889,
    999698,
    888878,
    768788,
    888889,
    888887,
    887977,
    679798,
    768868,
    989876,
    788877,
    987968,
    779889,
    987887,
    887787,
    898899,
    877879,
    978888,
    878889,
    677897,
    889878,
    998779,
    778798,
    788786,
    878897,
    878888,
    897888,
    798776,
    897877,
    778897,
    998978,
    888687,
    798898,
    888887,
    987678,
    878777,
    789689,
    678887,
    898799,
    779778,
    789876,
    797777,
    688897,
    988797,
    688786,
    787978,
    787798,
    687876,
    898777,
    678887,
    989988,
    987888,
    899977,
    767988,
    878877,
    889878,
    888879,
    679787,
    778989,
    787777,
    798678,
    789878,
    777978,
    899889,
    877999,
    768787,
    888779,
    689898,
    998898,
    787778,
    787678,
    888877,
    888787,
    878879,
    778868,
    797868,
    787879,
    987779,
    897889,
    876887,
    687898,
    897788,
    789888,
    687978,
    677798,
    889899,
    877797,
    978786,
    877887,
    898878,
    987897,
    989777,
    798789,
    979899,
    787687,
    799789,
    788987,
    787687,
    789789,
    778778,
    887989,
    787888,
    986978,
    979778,
    987988,
    897877,
    787887,
    887889,
    688777,
    898888,
    887788,
    988999,
    779998,
    779767,
    898898,
    887798,
    977787,
    778669,
    787977,
    787699,
    798997,
    799788,
    987888,
    777778,
    888876,
    988799,
    897897,
    878777,
    987777,
    888877,
    878987,
    777779,
    999888,
    889777,
    889888,
    976798,
    887888,
    997788,
    798777,
    888987,
    889778,
    878778,
    879878,
    979877,
    787987,
    688898,
    967779,
    888889,
    789868,
    877797,
    777889,
    899868,
    888878,
    887777,
    988899,
    899898,
    986778,
    778689,
    897877,
    987767,
    788889,
    879888,
    797787,
    867878,
    778999,
    788888,
    777778,
    899788,
    888777,
    887876,
    778887,
    687667,
    887888,
    687888,
    889888,
    687977,
    788798,
    886888,
    879788,
    878887,
    877887,
    788789,
    878997,
    887868,
    878867,
    988889,
    797988,
    788987,
    796887,
    989788,
    689787,
    877897,
    887897,
    867878,
    879888,
    778877,
    798787,
    787886,
    788889,
    798877,
    898787,
    788889,
    887777,
    778768,
    879778,
    887878,
    789787,
    889688,
    798898,
    988799,
    799787,
    888988,
    879877,
    998897,
    979889,
    887888,
    887677,
    788678,
    987777,
    788876,
    788976,
    888689,
    987799,
    977886,
    979889,
    988877,
    778899,
    988797,
    878778,
    788978,
    779968,
    887989,
    989798,
    898797,
    788788,
    988889,
    778668,
    887788,
    878689,
    999797,
    887778,
    788878,
    977698,
    979999,
    788988,
    978977,
    888676,
    769978,
    778768,
    798989,
    796788,
    887868,
    989887,
    787878,
    788789,
    877879,
    887887,
    976678,
    977887,
    788977,
    887788,
    877767,
    777779,
    976877,
    778768,
    798778,
    888697,
    797868,
    877988,
    867698,
    878877,
    787787,
    997977,
    888779,
    687888,
    776879,
    878776,
    889988,
    887897,
    887789,
    878878,
    999779,
    787968,
    788988,
    888887,
    786898,
    978788,
    789888,
    888987,
    797977,
    778796,
    888687,
    788697,
    867878,
    898997,
    998768,
    887887,
    797988,
    777777,
    888876,
    777887,
    879878,
    878779,
    787867,
    778868,
    688878,
    997788,
    787998,
    888788,
    969779,
    879787,
    899878,
    789877,
    887788,
    787888,
    889878,
    898789,
    888697,
    698777,
    688977,
    887787,
    977777,
    888797,
    677877,
    776898,
    898897,
    978887,
    788677,
    878988,
    898799,
    887987,
    888778,
    977878,
    866878,
    788888,
    898887,
    768878,
    799889,
    798989,
    777978,
    776897,
    877878,
    876786,
    997688,
    878799,
    898988,
    888989,
    987898,
    988788,
    777798,
    898789,
    778898,
    687898,
    878787,
    878778,
    887988,
    877779,
    888888,
    888977,
    877787,
    789887,
    977889,
    978879,
    988989,
    787889,
    879889,
    798887,
    878888,
    789976,
    988787,
    988899,
    877888,
    887878,
    888997,
    979778,
    688777,
    988889,
    977878,
    886989,
    677798,
    887677,
    777789,
    878887,
    788888,
    897889,
    888878,
    787788,
    888889,
    886797,
    768976,
    978678,
    878798,
    777878,
    878887,
    787878,
    877688,
    887877,
    968866,
    888878,
    878798,
    799868,
    889868,
    878888,
    889868,
    877688,
    888797,
    787989,
    889768,
    977896,
    989687,
    997898,
    787987,
    977896,
    788889,
    868987,
    989987,
    777896,
    788786,
    888889,
    977878,
    889777,
    898777,
    887887,
    889787,
    897687,
    879888,
    888899,
    888988,
    889789,
    776887,
    797889,
    987787,
    979977,
    977777,
    787777,
    687787,
    778888,
    888889,
    768698,
    898878,
    787867,
    888689,
    788879,
    987978,
    989787,
    987889,
    787798,
    777777,
    879787,
    999877,
    978898,
    888889,
    898987,
    788877,
    878988,
    778878,
    988879,
    987797,
    777987,
    897998,
    878888,
    677696,
    788887,
    987878,
    888887,
    878789,
    878879,
    998887,
    887888,
    778878,
    988888,
    879877,
    898887,
    976886,
    987967,
    876879,
    798896,
    897888,
    798777,
    789789,
    997878,
    788978,
    878969,
    687868,
    677878,
    879867,
    988769,
    698768,
    888788,
    888888,
    888987,
    977789,
    886779,
    889786,
    887977,
    888789,
    787877,
    977778,
    987888,
    778788,
    898787,
    887869,
    898678,
    788668,
    799667,
    798788,
    678877,
    997988,
    898989,
    867788,
    887888,
    778787,
    677879,
    898897,
    798969,
    778979,
    789888,
    988887,
    898969,
    998787,
    898888,
    879889,
    787767,
    978787,
    789786,
    898778,
    887877,
    999888,
    679788,
    989687,
    878988,
    668778,
    878879,
    989779,
    899989,
    999887,
    787888,
    887977,
    988868,
    777797,
    679997,
    887787,
    988899,
    978787,
    887887,
    988777,
    877876,
    889978,
    767789,
    679777,
    779878,
    778777,
    987786,
    677979,
    778789,
    878898,
    898776,
    888787,
    987698,
    779788,
    778877,
    988977,
    987879,
    987798,
    987687,
    787787,
    898997,
    878778,
    788898,
    697689,
    879889,
    787798,
    677878,
    778887,
    788879,
    688888,
    798777,
    889888,
    787798,
    976876,
    987887,
    778696,
    888877,
    788877,
    787887,
    998978,
    889879,
    889997,
    778877,
    877776,
    787787,
    777877,
    889898,
    879888,
    788987,
    877997,
    998898,
    887867,
    986697,
    897877,
    896987,
    798887,
    888877,
    769897,
    878778,
    878887,
    877797,
    898788,
    776798,
    778868,
    787787,
    977969,
    899977,
    978797,
    878988,
    888787,
    987978,
    899877,
    979978,
    888778,
    896789,
    888798,
    868776,
    798967,
    879888,
    977888,
    986987,
    777876,
    887888,
    897687,
    887878,
    789878,
    978897,
    798989,
    778798,
    868897,
    788977,
    867797,
    879779,
    779978,
    887789,
    788799,
    778897,
    678799,
    877797,
    968888,
    887999,
    888988,
    898767,
    978878,
    988887,
    888878,
    787879,
    897886,
    887887,
    877797,
    789887,
    888787,
    789878,
    788797,
    787877,
    787786,
    978998,
    778878,
    886878,
    789888,
    778988,
    878976,
    876896,
    888777,
    889878,
    787877,
    889878,
    997878,
    888869,
    988678,
    788879,
    787877,
    778789,
    698789,
    988789,
    988868,
    878779,
    887998,
    777778,
    878787,
    898778,
    897687,
    798788,
    869987,
    898887,
    797878,
    898898,
    989788,
    777988,
    877888,
    888888,
    879868,
    888878,
    799888,
    888887,
    979978,
    888898,
    897888,
    677689,
    878877,
    987878,
    678678,
    998887,
    998789,
    789888,
    787788,
    886878,
    887879,
    888878,
    787799,
    977878,
    799898,
    779688,
    879897,
    877879,
    977787,
    987879,
    687878,
    888997,
    878768,
    776889,
    897888,
    888897,
    687778,
    787789,
    898887,
    879897,
    776888,
    988896,
    998678,
    877887,
    877788,
    777878,
    869788,
    687887,
    897778,
    888898,
    998989,
    688888,
    799878,
    877787,
    786897,
    996987,
    889987,
    977678,
    687987,
    788778,
    987788,
    879978,
    988899,
    788889,
    788777,
    787778,
    687878,
    777987,
    799889,
    778789,
    887887,
    878788,
    889786,
    977897,
    987787,
    887897,
    789776,
    886789,
    978986,
    988897,
    778698,
    779879,
    867889,
    798778,
    979977,
    888897,
    777888,
    776879,
    987789,
    788889,
    987777,
    678988,
    897879,
    887788,
    788897,
    778888,
    797897,
    798778,
    976888,
    899788,
    979977,
    698788,
    689769,
    789689,
    668787,
    876787,
    788877,
    898789,
    798788,
    899777,
    777978,
    778898,
    878868,
    768787,
    888778,
    988788,
    878798,
    777869,
    887789,
    988878,
    779786,
    889878,
    789868,
    788797,
    797778,
    987788,
    887977,
    877679,
    788787,
    788988,
    879988,
    889977,
    778788,
    978976,
    788798,
    978878,
    976878,
    887987,
    878997,
    787789,
    878879,
    777887,
    967888,
    887997,
    798678,
    777897,
    797897,
    668798,
    888789,
    998778,
    786877,
    887998,
    778787,
    888798,
    987899,
    897799,
    787788,
    879997,
    788877,
    899879,
    888998,
    887979,
    878978,
    779878,
    887878,
    899987,
    779898,
    788779,
    887888,
    887787,
    788889,
    898677,
    768989,
    886787,
    966897,
    796898,
    879889,
    688997,
    988887,
    887769,
    799878,
    878797,
    778876,
    986898,
    788889,
    889778,
    878779,
    878888,
    788776,
    788978,
    878977,
    887689,
    788978,
    976898,
    887687,
    779789,
    977878,
    889788,
    888977,
    879778,
    798898,
    788777,
    998789,
    987789,
    787786,
    989888,
    987776,
    897768,
    798779,
    878888,
    878798,
    988989,
    887697,
    977878,
    878888,
    887887,
    768988,
    888889,
    888997,
    777987,
    897887,
    778776,
    789868,
    988987,
    888888,
    879789,
    978998,
    799988,
    888778,
    879898,
    888789,
    766999,
    778887,
    997979,
    789988,
    878878,
    788887,
    989788,
    878787,
    897888,
    887888,
    989679,
    978896,
    776876,
    786888,
    877899,
    888877,
    967798,
    877779,
    788878,
    787789,
    988689,
    987988,
    888878,
    978788,
    877676,
    887888,
    896888,
    777887,
    877898,
    989788,
    796877,
    799879,
    887797,
    796777,
    667898,
    977787,
    687889,
    877778,
    898888,
    788887,
    798778,
    897888,
    888887,
    987877,
    788698,
    778887,
    678978,
    887787,
    888978,
    887898,
    988889,
    787878,
    788879,
    878787,
    798788,
    978898,
    787979,
    678788,
    877778,
    877889,
    777787,
    978678,
    899988,
    899777,
    978887,
    996889,
    889888,
    898887,
    997777,
    876787,
    987778,
    888799,
    689897,
    887977,
    799998,
    877777,
    868879,
    797978,
    889798,
    776987,
    889967,
    878698,
    887889,
    799798,
    779887,
    988987,
    879778,
    888879,
    977887,
    888997,
    799888,
    788787,
    788799,
    796777,
    877788,
    887998,
    878688,
    886788,
    878879,
    877978,
    667967,
    878989,
    978687,
    778778,
    689688,
    998768,
    678878,
    976977,
    778977,
    789898,
    987786,
    888779,
    887868,
    797877,
    987678,
    888997,
    879788,
    788977,
    989987,
    878677,
    776787,
    898888,
    877897,
    679877,
    898988,
    777876,
    987889,
    989878,
    877788,
    978798,
    887988,
    868889,
    869799,
    786988,
    777787,
    978876,
    997779,
    798777,
    877888,
    998887,
    788797,
    979889,
    787879,
    689776,
    679977,
    878779,
    897889,
    879976,
    776679,
    778768,
    798888,
    888889,
    777989,
    988978,
    887898,
    978799,
    989769,
    788866,
    897798,
    879978,
    889886,
    878878,
    997886,
    988887,
    879988,
    887886,
    868889,
    688688,
    788789,
    788778,
    878889,
    888879,
    797888,
    876679,
    877888,
    787879,
    788978,
    888787,
    878788,
    889879,
    887878,
    889889,
    888877,
    777887,
    888978,
    788788,
    689897,
    987888,
    988797,
    877798,
    789787,
    787778,
    879888,
    777887,
    887867,
    778888,
    877768,
    888799,
    787888,
    877887,
    789898,
    887878,
    877768,
    888877,
    887867,
    887679,
    888678,
    889877,
    888888,
    899988,
    798788,
    678778,
    797887,
    778768,
    789898,
    688888,
    888888,
    878877,
    979868,
    988989,
    887877,
    877997,
    978789,
    868897,
    887987,
    769879,
    797988,
    777869,
    878986,
    788878,
    777788,
    879977,
    888968,
    978878,
    878968,
    788798,
    889867,
    786779,
    977987,
    978889,
    987788,
    898887,
    986687,
    887987,
    888697,
    887787,
    888989,
    888877,
    997876,
    779877,
    888987,
    788887,
    979898,
    989687,
    677877,
    869888,
    787778,
    978888,
    878787,
    876779,
    867778,
    998897,
    979887,
    677878,
    777689,
    976768,
    778788,
    987788,
    778898,
    779788,
    979779,
    978887,
    788788,
    778978,
    878777,
    787769,
    688897,
    889897,
    878988,
    788878,
    777778,
    787689,
    777787,
    878888,
    878886,
    776888,
    898887,
    878888,
    998887,
    889978,
    896977,
    879977,
    879888,
    678878,
    688879,
    888788,
    888987,
    888869,
    898788,
    988778,
    787687,
    888898,
    888776,
    986789,
    987778,
    877868,
    878977,
    878887,
    979897,
    989889,
    897997,
    877868,
    877988,
    998698,
    798777,
    998898,
    898877,
    698877,
    988788,
    698988,
    878888,
    899798,
    877788,
    888887,
    777987,
    977889,
    866797,
    887887,
    888978,
    888787,
    788878,
    687887,
    888787,
    878877,
    978878,
    787898,
    797878,
    898877,
    878898,
    886976,
    988898,
    778687,
    868878,
    888877,
    788868,
    789776,
    968877,
    888677,
    998877,
    787888,
    787778,
    787678,
    889887,
    897876,
    976889,
    978789,
    889777,
    969898,
    989788,
    778978,
    888888,
    887887,
    787768,
    678767,
    878898,
    977778,
    777988,
    998887,
    778876,
    978799,
    778989,
    887788,
    888879,
    679977,
    787689,
    998786,
    879798,
    777888,
    788879,
    789787,
    798879,
    867787,
    978788,
    688997,
    886889,
    779978,
    889988,
    778787,
    877778,
    989788,
    797897,
    788887,
    887797,
    789797,
    897897,
    999887,
    888796,
    787987,
    889677,
    776889,
    997787,
    886978,
    788678,
    978787,
    876868,
    877889,
    898887,
    786899,
    687789,
    876788,
    897889,
    887878,
    787796,
    888697,
    878978,
    778787,
    678788,
    797678,
    788668,
    988887,
    887779,
    886789,
    878677,
    889978,
    877877,
    878989,
    797898,
    688897,
    787877,
    897778,
    887687,
    788787,
    887878,
    886887,
    799778,
    678787,
    787867,
    787889,
    878878,
    677888,
    786888,
    797679,
    789867,
    897777,
    897888,
    777877,
    798778,
    788997,
    778899,
    886897,
    789978,
    987888,
    896888,
    886888,
    787978,
    787797,
    787888,
    969889,
    997787,
    889787,
    889678,
    787888,
    997768,
    789889,
    689798,
    788879,
    788788,
    787787,
    789887,
    998988,
    997786,
    989898,
    898898,
    797879,
    877878,
    687887,
    898788,
    789988,
    788778,
    778889,
    899677,
    988797,
    868788,
    778788,
    879798,
    679797,
    788978,
    778777,
    777787,
    686888,
    798797,
    999778,
    897987,
    878788,
    768787,
    797878,
    788987,
    877969,
    697877,
    788778,
    799898,
    977988,
    998678,
    786778,
    796898,
    978967,
    898779,
    889787,
    888788,
    779788,
    789888,
    889878,
    887987,
    867777,
    699698,
    899979,
    788988,
    877777,
    777989,
    779878,
    797998,
    886798,
    988878,
    997886,
    868799,
    886887,
    797888,
    999779,
    688987,
    889977,
    779788,
    979788,
    787798,
    788978,
    878789,
    777897,
    987889,
    978877,
    888789,
    679879,
    979778,
    897677,
    678888,
    869976,
    699789,
    877988,
    889898,
    798887,
    899689,
    888877,
    978887,
    778878,
    888768,
    887988,
    899778,
    988779,
    768887,
    787797,
    878688,
    899978,
    798977,
    898889,
    888887,
    996889,
    987788,
    868998,
    787786,
    987777,
    878767,
    876898,
    777878,
    778887,
    778779,
    787779,
    768778,
    687878,
    987689,
    887978,
    888767,
    798878,
    778889,
    998998,
    898976,
    797988,
    878988,
    889898,
    887988,
    887998,
    878887,
    777988,
    788989,
    987987,
    777777,
    689778,
    779787,
    878887,
    878776,
    778896,
    787969,
    878976,
    997886,
    778788,
    998897,
    978986,
    888878,
    887977,
    978787,
    978889,
    987879,
    878679,
    778778,
    887978,
    978988,
    897877,
    878787,
    897798,
    778768,
    986788,
    887868,
    788789,
    989898,
    687788,
    889787,
    789878,
    876688,
    778868,
    787787,
    887789,
    788887,
    779786,
    678798,
    767887,
    989988,
    798878,
    998777,
    988977,
    677888,
    789887,
    977777,
    877869,
    778789,
    878887,
    977979,
    989669,
    977888,
    976878,
    798789,
    877889,
    778888,
    797887,
    976787,
    878887,
    688878,
    887879,
    677867,
    998966,
    689786,
    677687,
    788868,
    897897,
    887787,
    899866,
    777878,
    988888,
    967788,
    789897,
    988776,
    868999,
    878779,
    968889,
    877878,
    778787,
    877778,
    788789,
    888688,
    696888,
    789679,
    998887,
    787978,
    788888,
    687778,
    788778,
    776887,
    798789,
    798877,
    889788,
    778897,
    777878,
    787889,
    888777,
    898788,
    887788,
    979788,
    898788,
    898878,
    886988,
    786998,
    888888,
    899888,
    888899,
    887978,
    778687,
    967877,
    779798,
    887897,
    888887,
    689799,
    987869,
    877878,
    888887,
    987879,
    877788,
    978778,
    988678,
    878887,
    778877,
    869899,
    798997,
    889799,
    988887,
    979798,
    787778,
    978878,
    887787,
    877977,
    888777,
    988787,
    798878,
    688787,
    868868,
    798888,
    966897,
    988788,
    767778,
    876888,
    887878,
    977788,
    699988,
    988778,
    989887,
    778898,
    886788,
    788798,
    877878,
    876788,
    678787,
    788978,
    877787,
    698999,
    988888,
    787987,
    778777,
    988688,
    969878,
    879988,
    767777,
    877779,
    767688,
    777897,
    889897,
    889877,
    888679,
    787878,
    889787,
    996867,
    798778,
    788779,
    877897,
    898888,
    978888,
    787998,
    778987,
    799897,
    898679,
    877779,
    898788,
    886767,
    978968,
    699897,
    887897,
    798888,
    886977,
    887868,
    698887,
    988887,
    878998,
    977777,
    778888,
    977799,
    897776,
    887878,
    687988,
    898789,
    888966,
    788888,
    778679,
    878869,
    877688,
    788878,
    977798,
    879988,
    677798,
    778879,
    778886,
    888789,
    779886,
    988788,
    899999,
    987778,
    978878,
    877898,
    978797,
    868778,
    679979,
    887876,
    778978,
    877977,
    977879,
    898798,
    888887,
    877987,
    898878,
    889867,
    777889,
    878787,
    888888,
    677987,
    888788,
    889788,
    799888,
    788787,
    778888,
    868996,
    867997,
    988968,
    867778,
    888988,
    888777,
    768888,
    888999,
    887988,
    777787,
    869978,
    969876,
    999877,
    797887,
    998898,
    888887,
    877898,
    898777,
    998778,
    887888,
    798868,
    887778,
    887697,
    898798,
    888789,
    798797,
    889897,
    778998,
    888976,
    887888,
    868888,
    689778,
    787978,
    998878,
    798988,
    799878,
    987878,
    888988,
    878869,
    876788,
    888888,
    698978,
    788777,
    787898,
    989878,
    888977,
    879889,
    779788,
    769876,
    878887,
    968787,
    798987,
    888889,
    988998,
    989779,
    887889,
    887898,
    899978,
    778679,
    978878,
    688788,
    879797,
    878688,
    898888,
    896789,
    888887,
    899897,
    978788,
    798888,
    888799,
    899877,
    986887,
    997787,
    777888,
    766978,
    879887,
    888968,
    777789,
    898688,
    787877,
    897878,
    897798,
    977797,
    877687,
    797877,
    798887,
    998777,
    879898,
    887977,
    898797,
    868987,
    797787,
    779688,
    899897,
    887799,
    888788,
    888677,
    787777,
    889877,
    778767,
    767797,
    878977,
    798989,
    879779,
    798777,
    878887,
    877879,
    788777,
    877887,
    788787,
    876787,
    778777,
    788788,
    777978,
    898788,
    789989,
    987687,
    798887,
    997787,
    679898,
    688698,
    777788,
    878978,
    888798,
    988869,
    878977,
    776888,
    787878,
    777786,
    778988,
    877779,
    978979,
    779778,
    799898,
    778777,
    799877,
    978679,
    898898,
    987897,
    978688,
    886787,
    899897,
    799878,
    778989,
    868879,
    778688,
    798878,
    788988,
    889978,
    878687,
    988896,
    868876,
    799779,
    876788,
    787787,
    777888,
    978777,
    777888,
    889778,
    777897,
    888888,
    778798,
    779868,
    787779,
    877788,
    799777,
    799686,
    788987,
    888778,
    778876,
    779998,
    878787,
    877888,
    998899,
    788878,
    797898,
    887897,
    788777,
    678878,
    686768,
    788887,
    876889,
    888987,
    778788,
    788788,
    896897,
    878799,
    899787,
    789887,
    799896,
    777888,
    877787,
    897897,
    789788,
    798988,
    697887,
    787686,
    876899,
    989887,
    786888,
    797789,
    878877,
    798887,
    889777,
    797786,
    987888,
    888976,
    788997,
    889788,
    878897,
    877887,
    788968,
    889798,
    987879,
    877687,
    898897,
    867977,
    997787,
    776798,
    988789,
    689879,
    798888,
    888878,
    889777,
    989998,
    888799,
    789779,
    968988,
    878888,
    776888,
    889779,
    868778,
    968788,
    977788,
    888887,
    977897,
    977889,
    888788,
    898678,
    889777,
    879978,
    996778,
    878897,
    877777,
    877886,
    998778,
    797867,
    889888,
    778699,
    998789,
    788886,
    896879,
    787978,
    988888,
    979777,
    897886,
    789776,
    697788,
    878877,
    977788,
    879678,
    878777,
    889789,
    777989,
    877979,
    996887,
    787887,
    798788,
    987988,
    988786,
    878888,
    778989,
    686788,
    787777,
    978877,
    778888,
    878788,
    786876,
    888776,
    878788,
    787889,
    898877,
    668799,
    887888,
    778787,
    889798,
    787779,
    879777,
    887779,
    888798,
    989787,
    779787,
    887986,
    789977,
    878977,
    788968,
    777888,
    888997,
    877898,
    888769,
    888889,
    889789,
    888788,
    887787,
    788899,
    987678,
    789879,
    987879,
    867687,
    878898,
    878998,
    689988,
    688688,
    988987,
    889788,
    898889,
    887878,
    788799,
    887887,
    866898,
    677799,
    888788,
    799767,
    887778,
    778788,
    787889,
    788877,
    889878,
    898978,
    987978,
    768768,
    787778,
    797887,
    778888,
    878787,
    987987,
    779778,
    887888,
    879966,
    976998,
    887888,
    778778,
    778888,
    997887,
    897889,
    788888,
    868878,
    897887,
    878687,
    787678,
    699797,
    898776,
    977877,
    899989,
    878877,
    988769,
    777997,
    886788,
    878899,
    898897,
    769987,
    978877,
    888887,
    978887,
    778787,
    897767,
    777868,
    878788,
    997868,
    899887,
    888879,
    787787,
    898787,
    778889,
    667879,
    978889,
    876676,
    778889,
    979888,
    778987,
    977797,
    887878,
    977978,
    987899,
    966878,
    789877,
    988778,
    677876,
    978878,
    878888,
    787887,
    877887,
    877869,
    978878,
    778997,
    689998,
    776888,
    797888,
    898789,
    978899,
    879779,
    777978,
    889988,
    989887,
    669986,
    889977,
    789978,
    788878,
    887889,
    699978,
    988788,
    877897,
    886778,
    988887,
    989887,
    988778,
    787878,
    977898,
    788768,
    997878,
    888787,
    897878,
    899897,
    778897,
    777798,
    678888,
    777887,
    778878,
    876886,
    877869,
    898877,
    887988,
    888899,
    897898,
    778878,
    787768,
    989868,
    877787,
    998999,
    997779,
    788779,
    978767,
    787888,
    888878,
    799887,
    987786,
    877789,
    888978,
    978889,
    877887,
    867886,
    877797,
    898978,
    889788,
    878787,
    978787,
    877878,
    879778,
    888887,
    888898,
    887888,
    879787,
    887968,
    877878,
    777788,
    898889,
    898888,
    888787,
    988889,
    779877,
    897878,
    867797,
    778879,
    887897,
    888888,
    889698,
    786778,
    979988,
    887988,
    767888,
    797888,
    878869,
    787998,
    999776,
    767887,
    877987,
    869879,
    967898,
    879778,
    898977,
    888887,
    978867,
    788987,
    788777,
    966887,
    788786,
    878888,
    879777,
    878879,
    888797,
    988788,
    999977,
    998879,
    788798,
    886886,
    798687,
    887989,
    678788,
    886777,
    888898,
    969868,
    898878,
    979999,
    779978,
    798777,
    888888,
    899898,
    989877,
    997798,
    697899,
    977787,
    778978,
    888789,
    788887,
    797789,
    787688,
    998888,
    879987,
    979897,
    777888,
    878888,
    887867,
    889988,
    898778,
    778678,
    777788,
    788798,
    678787,
    788889,
    788789,
    786788,
    988888,
    788979,
    797888,
    887786,
    678778,
    788787,
    697888,
    788787,
    888889,
    789897,
    998688,
    889788,
    889897,
    878897,
    787798,
    878887,
    778878,
    877877,
    789887,
    797867,
    697878,
    698978,
    797887,
    788878,
    797979,
    888778,
    779786,
    977798,
    988878,
    868787,
    887888,
    796888,
    677777,
    877898,
    797989,
    898787,
    977788,
    877787,
    788688,
    878988,
    989977,
    899788,
    889689,
    898968,
    888888,
    788878,
    878878,
    878988,
    898687,
    897788,
    789888,
    788777,
    898768,
    788778,
    787877,
    888768,
    888987,
    978787,
    879777,
    878787,
    778878,
    778997,
    977888,
    778788,
    989896,
    887877,
    888877,
    988778,
    887789,
    689868,
    797988,
    797687,
    977888,
    777888,
    888888,
    887888,
    888889,
    777877,
    798888,
    779988,
    988987,
    688896,
    897878,
    888886,
    788887,
    876777,
    887978,
    699878,
    888889,
    777888,
    978878,
    898798,
    997978,
    888888,
    787777,
    988888,
    887787,
    878796,
    987979,
    877968,
    888876,
    888778,
    869898,
    899887,
    976888,
    779997,
    778886,
    878787,
    888878,
    998898,
    978987,
    688967,
    879997,
    888778,
    779887,
    787888,
    989898,
    778867,
    799898,
    987986,
    887788,
    889987,
    877877,
    996789,
    778788,
    678897,
    696879,
    878788,
    788978,
    887889,
    867887,
    898987,
    786688,
    778887,
    887978,
    889778,
    878998,
    898877,
    899979,
    878877,
    888996,
    788887,
    888798,
    879688,
    897789,
    788986,
    879878,
    877769,
    878879,
    788889,
    899877,
    988879,
    898778,
    789877,
    799679,
    799887,
    877879,
    787778,
    988887,
    876787,
    987898,
    798897,
    977897,
    778779,
    878777,
    799687,
    878887,
    688886,
    999798,
    788989,
    878988,
    799788,
    877876,
    777799,
    678879,
    877787,
    899798,
    987897,
    768977,
    989787,
    866899,
    879786,
    798897,
    988789,
    878978,
    888987,
    898887,
    779988,
    779987,
    887788,
    876798,
    976867,
    898898,
    878889,
    867978,
    797868,
    798987,
    689888,
    878898,
    879897,
    967878,
    788888,
    868888,
    778688,
    787878,
    876898,
    887869,
    786877,
    677978,
    988788,
    987898,
    887776,
    887787,
    988797,
    878997,
    797898,
    887778,
    778878,
    788787,
    787886,
    789768,
    788779,
    686898,
    978897,
    878776,
    687897,
    879887,
    888867,
    988887,
    977897,
    868787,
    887987,
    867788,
    798897,
    888887,
    778877,
    868977,
    889887,
    687977,
    987778,
    787897,
    889968,
    886887,
    779898,
    878878,
    789899,
    888797,
    967998,
    899887,
    788889,
    779797,
    787877,
    869878,
    899787,
    787778,
    788896,
    988788,
    887777,
    788788,
    897696,
    887779,
    999977,
    978989,
    887888,
    878768,
    779789,
    797887,
    789889,
    878789,
    796898,
    888888,
    898897,
    768888,
    778887,
    888876,
    889977,
    887776,
    879888,
    878767,
    867789,
    877887,
    988777,
    977878,
    889798,
    888979,
    988888,
    887789,
    699897,
    878977,
    788887,
    788887,
    767797,
    879778,
    797988,
    787888,
    888888,
    889898,
    778977,
    889787,
    788788,
    888877,
    978988,
    898689,
    978967,
    788699,
    788789,
    988787,
    897889,
    977989,
    788878,
    979788,
    889798,
    878887,
    676896,
    777888,
    688987,
    898787,
    897977,
    787889,
    967888,
    687889,
    888896,
    788878,
    688788,
    787888,
    898888,
    888889,
    878997,
    897888,
    787878,
    786678,
    989688,
    989987,
    897779,
    788798,
    879886,
    788699,
    877687,
    888787,
    788988,
    896878,
    977898,
    678997,
    777787,
    988877,
    889779,
    776898,
    788788,
    898997,
    887888,
    689878,
    979888,
    887898,
    878877,
    988778,
    887889,
    779769,
    889788,
    777797,
    887788,
    776897,
    788888,
    999989,
    998888,
    877788,
    779778,
    779898,
    979688,
    879889,
    697777,
    988688,
    777688,
    899788,
    777797,
    888897,
    687787,
    877778,
    876977,
    977687,
    976877,
    997987,
    888788,
    887977,
    788988,
    769899,
    889978,
    889888,
    687888,
    987887,
    898798,
    967898,
    778779,
    777976,
    889799,
    888787,
    877798,
    989779,
    887888,
    677699,
    899896,
    989687,
    888888,
    877888,
    886877,
    877888,
    767878,
    876879,
    877867,
    788788,
    789777,
    978987,
    897978,
    688978,
    879777,
    877798,
    799869,
    987699,
    968888,
    989888,
    787778,
    877886,
    987887,
    977788,
    886877,
    899789,
    788897,
    897998,
    769887,
    888867,
    867778,
    967877,
    969877,
    797778,
    779878,
    789778,
    878977,
    697877,
    878877,
    877896,
    979877,
    776789,
    698988,
    988887,
    989779,
    877887,
    887997,
    978977,
    889878,
    889897,
    887888,
    868797,
    779787,
    877688,
    786888,
    776678,
    777698,
    878889,
    897987,
    977979,
    879777,
    888997,
    899798,
    777887,
    777977,
    988798,
    788888,
    987797,
    897887,
    678987,
    988887,
    977887,
    878988,
    999988,
    879878,
    978888,
    768797,
    678878,
    987967,
    879887,
    878798,
    788966,
    898799,
    789797,
    999989,
    988968,
    788889,
    878787,
    788887,
    899778,
    879878,
    767878,
    778987,
    877797,
    787888,
    789779,
    987886,
    988897,
    877788,
    876997,
    788799,
    669777,
    887789,
    787999,
    988788,
    877969,
    887878,
    777889,
    887888,
    878876,
    787998,
    888888,
    688978,
    997896,
    788787,
    888888,
    776898,
    768897,
    896968,
    897877,
    767679,
    787778,
    977887,
    777787,
    889788,
    776889,
    887997,
    978788,
    789879,
    687889,
    989687,
    888879,
    888886,
    777886,
    876887,
    888798,
    769767,
    788987,
    988879,
    788799,
    889888,
    777778,
    697969,
    877879,
    798889,
    686988,
    997798,
    678889,
    787779,
    888777,
    888987,
    788968,
    878877,
    778878,
    879987,
    988988,
    978688,
    778788,
    888888,
    979987,
    888978,
    878789,
    989889,
    787897,
    897778,
    899876,
    799786,
    787998,
    897977,
    979988,
    878898,
    778888,
    788897,
    799896,
    999897,
    889787,
    778878,
    889797,
    996877,
    789886,
    879787,
    969788,
    878988,
    878887,
    878877,
    788887,
    998968,
    878798,
    888779,
    898689,
    897899,
    787888,
    797969,
    899778,
    988989,
    798889,
    787768,
    696898,
    887898,
    788797,
    877788,
    788678,
    888798,
    778789,
    988778,
    787867,
    977788,
    889886,
    779878,
    877877,
    888797,
    897988,
    888777,
    887689,
    678797,
    978988,
    887868,
    987689,
    778789,
    987978,
    789776,
    688998,
    777887,
    998979,
    878887,
    996778,
    968788,
    787876,
    877868,
    699798,
    968898,
    777779,
    788978,
    786788,
    696887,
    877888,
    978687,
    888988,
    869789,
    878868,
    997887,
    978897,
    797988,
    797887,
    868798,
    788777,
    779786,
    677778,
    777678,
    978898,
    979687,
    867797,
    788799,
    997876,
    869788,
    889888,
    778788,
    887899,
    877868,
    898667,
    798788,
    778897,
    898798,
    969889,
    779887,
    877889,
    786777,
    877787,
    879878,
    779897,
    779778,
    887797,
    988797,
    889787,
    869888,
    888978,
    869787,
    889888,
    888877,
    789989,
    887879,
    888779,
    888879,
    777777,
    879798,
    787788,
    888877,
    988878,
    888878,
    968879,
    887989,
    877967,
    697899,
    787978,
    787979,
    898879,
    777876,
    888997,
    989987,
    987888,
    786677,
    978878,
    787777,
    778887,
    977877,
    776788,
    878886,
    787888,
    889886,
    697898,
    798868,
    976987,
    788788,
    778868,
    888867,
    879897,
    888778,
    896888,
    979869,
    987888,
    797678,
    769788,
    887988,
    777876,
    798887,
    977888,
    869968,
    788768,
    888977,
    769979,
    878877,
    867997,
    787887,
    778788,
    778987,
    878887,
    788888,
    788887,
    786779,
    667978,
    788779,
    768898,
    998788,
    877887,
    888777,
    868688,
    899888,
    777987,
    897887,
    896687,
    868789,
    788789,
    778897,
    788877,
    878887,
    897887,
    878967,
    778879,
    886699,
    888887,
    896788,
    877786,
    898887,
    977899,
    997889,
    998789,
    788878,
    977997,
    977788,
    878967,
    878898,
    887899,
    888787,
    887778,
    787887,
    977766,
    889777,
    787788,
    888979,
    888979,
    888888,
    887788,
    698887,
    878878,
    899888,
    886888,
    967798,
    977789,
    877776,
    888767,
    886898,
    878887,
    778888,
    998788,
    899798,
    877788,
    989769,
    987777,
    879897,
    988688,
    787788,
    796779,
    789787,
    687878,
    898778,
    988866,
    788987,
    978788,
    767878,
    797979,
    788888,
    797789,
    889988,
    678797,
    886876,
    689968,
    796898,
    789788,
    888878,
    877769,
    887777,
    898889,
    787888,
    797786,
    778776,
    888888,
    989798,
    998979,
    877797,
    779889,
    869887,
    798987,
    877989,
    776888,
    889787,
    889887,
    878887,
    877896,
    878998,
    797787,
    989787,
    777788,
    787868,
    778798,
    689878,
    787898,
    898688,
    788878,
    788798,
    787778,
    998897,
    877879,
    698898,
    979788,
    889897,
    767788,
    768886,
    789788,
    787798,
    788889,
    887789,
    878887,
    987777,
    888899,
    878878,
    787688,
    878786,
    888879,
    987986,
    988988,
    789788,
    697779,
    997988,
    987787,
    777778,
    677888,
    789889,
    888977,
    689776,
    986689,
    798797,
    979978,
    887898,
    899997,
    778798,
    888787,
    689978,
    878896,
    789988,
    878789,
    887987,
    797788,
    989796,
    877877,
    778979,
    878789,
    996987,
    888688,
    788897,
    978878,
    779978,
    988686,
    897987,
    889689,
    778979,
    988678,
    877888,
    886977,
    986988,
    899799,
    878867,
    688868,
    988787,
    888777,
    879888,
    887669,
    788988,
    988789,
    887889,
    988778,
    888887,
    889888,
    788889,
    878778,
    887898,
    877977,
    988777,
    888879,
    977776,
    878788,
    779868,
    788976,
    887799,
    888878,
    788878,
    967778,
    879898,
    887776,
    888889,
    869788,
    878899,
    869897,
    779798,
    878789,
    788878,
    877869,
    888979,
    877869,
    887778,
    888899,
    987988,
    897877,
    699889,
    888787,
    877788,
    987877,
    889887,
    798788,
    878889,
    867887,
    787987,
    889778,
    898789,
    667876,
    877786,
    878879,
    777796,
    888786,
    978899,
    889988,
    767698,
    798787,
    778878,
    879987,
    677798,
    979977,
    979987,
    788779,
    987898,
    978989,
    889977,
    768778,
    789888,
    788876,
    766878,
    989978,
    867867,
    789887,
    698888,
    887789,
    898987,
    778788,
    968789,
    979888,
    798678,
    887766,
    777768,
    988888,
    798998,
    788896,
    889889,
    888778,
    777976,
    886887,
    796867,
    877877,
    986989,
    968987,
    977987,
    988899,
    888868,
    788878,
    788788,
    877877,
    777888,
    979787,
    979778,
    878899,
    877878,
    788887,
    888997,
    988888,
    888888,
    788976,
    878878,
    798777,
    777988,
    888797,
    888878,
    787989,
    788897,
    799767,
    887698,
    889788,
    789988,
    879796,
    779998,
    897699,
    786787,
    879788,
    789787,
    987767,
    887778,
    887988,
    996687,
    776789,
    887869,
    699888,
    669868,
    888688,
    779778,
    799888,
    788699,
    899887,
    777977,
    887999,
    899698,
    889879,
    799799,
    888976,
    877798,
    999886,
    797889,
    878977,
    777876,
    899878,
    779878,
    687868,
    898888,
    987789,
    879879,
    889887,
    799769,
    877777,
    778897,
    888889,
    878768,
    989889,
    777888,
    987886,
    798787,
    889878,
    788789,
    778787,
    787888,
    898878,
    877887,
    888868,
    877777,
    788878,
    768777,
    778787,
    897798,
    897876,
    777788,
    989789,
    887789,
    977688,
    977688,
    798898,
    888887,
    776878,
    977689,
    799989,
    988868,
    888986,
    977799,
    868888,
    987888,
    889886,
    997897,
    878787,
    978788,
    776777,
    879787,
    887977,
    889886,
    888689,
    797876,
    688777,
    788668,
    888968,
    897787,
    788968,
    787787,
    677997,
    898878,
    878678,
    989977,
    899888,
    767877,
    878899,
    779788,
    887888,
    988879,
    776689,
    898787,
    987788,
    888877,
    877788,
    899878,
    888778,
    788979,
    677897,
    788877,
    878888,
    996887,
    879877,
    688899,
    988898,
    878899,
    777878,
    688788,
    787989,
    888787,
    978978,
    988878,
    787887,
    887798,
    788888,
    886888,
    788879,
    799777,
    889778,
    777788,
    898988,
    967996,
    896969,
    776798,
    777987,
    878987,
    898776,
    888788,
    778878,
    877788,
    966688,
    888678,
    979978,
    697778,
    998899,
    968868,
    766886,
    677778,
    888978,
    888888,
    989878,
    879878,
    867798,
    877867,
    878677,
    779777,
    778877,
    988888,
    878997,
    998766,
    789888,
    897787,
    887878,
    868888,
    787989,
    988979,
    787788,
    788876,
    777788,
    978799,
    778879,
    887988,
    869987,
    878888,
    788878,
    987869,
    878779,
    878998,
    687967,
    788778,
    887879,
    977898,
    966798,
    978878,
    668788,
    778898,
    778886,
    887898,
    777798,
    976987,
    998867,
    897877,
    787889,
    777888,
    987986,
    788778,
    777988,
    988768,
    879778,
    989879,
    799797,
    879888,
    778878,
    888896,
    988897,
    898889,
    987788,
    889887,
    779997,
    677779,
    797789,
    889888,
    997897,
    778778,
    898887,
    868889,
    988778,
    768877,
    889799,
    789787,
    998797,
    787898,
    677799,
    787969,
    786876,
    888877,
    878977,
    988996,
    789787,
    978877,
    998879,
    977898,
    889878,
    879998,
    797977,
    877797,
    987778,
    777978,
    787786,
    878998,
    887888,
    679788,
    888889,
    989786,
    977987,
    897787,
    679888,
    889788,
    988888,
    788879,
    798897,
    788888,
    878877,
    789867,
    999778,
    879679,
    997878,
    778888,
    698788,
    788988,
    988788,
    778987,
    687987,
    787799,
    897998,
    767888,
    789988,
    888787,
    986767,
    989979,
    899898,
    769768,
    686988,
    996887,
    798877,
    796877,
    798899,
    878777,
    788787,
    777776,
    988788,
    886977,
    797766,
    777798,
    897887,
    898688,
    988898,
    886886,
    877869,
    898678,
    677789,
    888677,
    888678,
    888889,
    679987,
    888887,
    777788,
    968888,
    788779,
    887768,
    887877,
    767787,
    787888,
    998887,
    668887,
    787998,
    987789,
    777988,
    787787,
    799888,
    887978,
    987877,
    987797,
    888878,
    789878,
    888787,
    788986,
    788886,
    779879,
    888798,
    988796,
    888899,
    976876,
    877797,
    889869,
    977978,
    898976,
    888988,
    767776,
    987988,
    898777,
    897899,
    778999,
    788878,
    988768,
    778868,
    887788,
    998877,
    899777,
    868968,
    978986,
    787687,
    899777,
    887888,
    978988,
    888888,
    889777,
    978889,
    977788,
    868898,
    669977,
    897868,
    888977,
    998989,
    886879,
    889888,
    888796,
    897878,
    987989,
    979788,
    797899,
    766986,
    778978,
    688777,
    789877,
    679778,
    997877,
    788798,
    877889,
    798977,
    878979,
    988877,
    878668,
    779889,
    788967,
    679787,
    878889,
    898887,
    898797,
    888989,
    798878,
    979797,
    896868,
    987986,
    798877,
    776688,
    679888,
    887788,
    888788,
    697778,
    888686,
    897889,
    977977,
    888777,
    778799,
    788888,
    877988,
    777868,
    897788,
    878988,
    789789,
    887768,
    889869,
    788978,
    877888,
    987987,
    778777,
    897786,
    777789,
    687887,
    889788,
    788999,
    979999,
    979877,
    876777,
    878896,
    897687,
    988889,
    978677,
    979988,
    889887,
    879878,
    786767,
    887877,
    988998,
    877798,
    979786,
    768886,
    889687,
    778878,
    896887,
    968897,
    888778,
    998888,
    966787,
    878788,
    888968,
    679886,
    787777,
    989876,
    688977,
    877787,
    879778,
    889867,
    668688,
    788986,
    777879,
    869868,
    977888,
    778898,
    889899,
    867878,
    889869,
    888787,
    878876,
    698998,
    987878,
    988887,
    877898,
    889979,
    797979,
    978787,
    988978,
    688978,
    786788,
    787988,
    888787,
    778996,
    989897,
    768967,
    899977,
    889787,
    778898,
    796977,
    786987,
    878789,
    779887,
    877877,
    788798,
    879877,
    888899,
    789697,
    878867,
    689888,
    788699,
    878788,
    878977,
    897887,
    787788,
    888788,
    667798,
    888897,
    776998,
    878888,
    787779,
    998987,
    789888,
    787787,
    888978,
    788898,
    888888,
    878687,
    987797,
    767677,
    777789,
    888777,
    977888,
    877867,
    888867,
    879889,
    789987,
    788797,
    896877,
    878779,
    898886,
    799877,
    889888,
    899788,
    999687,
    768998,
    778778,
    788787,
    897988,
    988788,
    877887,
    877868,
    978989,
    899888,
    989889,
    788787,
    887797,
    989798,
    878877,
    887899,
    789898,
    888887,
    887776,
    878777,
    787877,
    888886,
    968789,
    998786,
    887887,
    787777,
    898878,
    798977,
    987788,
    888888,
    787677,
    879698,
    878799,
    777888,
    788977,
    897788,
    799778,
    789868,
    997899,
    889999,
    887799,
    888779,
    798978,
    668698,
    977787,
    768798,
    787898,
    987988,
    878888,
    798778,
    799888,
    777986,
    978869,
    789887,
    887799,
    997796,
    888978,
    878778,
    987968,
    798978,
    979887,
    788778,
    887768,
    798797,
    968798,
    897898,
    998688,
    877878,
    898887,
    779898,
    878988,
    869897,
    887878,
    778978,
    798987,
    788777,
    889798,
    887968,
    998796,
    889878,
    778789,
    788896,
    788997,
    978888,
    768788,
    979798,
    997878,
    777778,
    887868,
    989878,
    889698,
    868797,
    868788,
    779787,
    987886,
    788767,
    778898,
    887868,
    997897,
    787787,
    989687,
    787688,
    788896,
    988897,
    678887,
    879788,
    777887,
    798778,
    989888,
    868887,
    888786,
    888787,
    898977,
    786989,
    788878,
    988798,
    987867,
    888788,
    988777,
    978877,
    967899,
    867967,
    886879,
    988789,
    876777,
    688787,
    879987,
    888897,
    867778,
    877898,
    779988,
    998688,
    876878,
    889787,
    878888,
    897898,
    888799,
    798878,
    967686,
    977887,
    779878,
    688687,
    778688,
    788978,
    798878,
    886979,
    778889,
    988688,
    868867,
    678999,
    887876,
    988877,
    889988,
    888877,
    789799,
    877878,
    888767,
    876987,
    868977,
    888988,
    789799,
    897889,
    986887,
    878887,
    898887,
    868879,
    968898,
    989777,
    777988,
    877887,
    878799,
    899877,
    888968,
    778889,
    889788,
    877798,
    987789,
    988778,
    878787,
    788788,
    687877,
    877788,
    688788,
    697878,
    979977,
    988968,
    878797,
    988887,
    777797,
    789669,
    798888,
    778678,
    977687,
    878888,
    988898,
    777877,
    978779,
    897887,
    787897,
    898897,
    787897,
    697778,
    988898,
    999877,
    888877,
    977989,
    987878,
    898887,
    889889,
    978879,
    788877,
    778786,
    987678,
    768877,
    778987,
    887787,
    888878,
    778887,
    978877,
    798677,
    888788,
    988888,
    777888,
    887888,
    878877,
    788799,
    677776,
    878777,
    778888,
    887866,
    786877,
    798776,
    876887,
    979997,
    788888,
    888878,
    978878,
    778779,
    787898,
    799878,
    778878,
    688868,
    888877,
    788987,
    878777,
    879877,
    879799,
    789789,
    878887,
    668877,
    896779,
    878877,
    878787,
    877888,
    887987,
    877999,
    776888,
    968887,
    997768,
    889999,
    888897,
    989897,
    788886,
    789696,
    888768,
    968789,
    777888,
    796788,
    987878,
    798897,
    779887,
    878878,
    779789,
    789798,
    798886,
    798987,
    977888,
    987778,
    777786,
    788878,
    777988,
    789997,
    876789,
    878879,
    997986,
    899787,
    787977,
    787978,
    978789,
    887889,
    887798,
    979788,
    976876,
    667779,
    876876,
    798988,
    788887,
    888989,
    778789,
    988787,
    788876,
    878777,
    778989,
    788788,
    778877,
    778999,
    789777,
    778787,
    798887,
    788777,
    888978,
    877988,
    888896,
    879878,
    868797,
    788789,
    898986,
    889977,
    899788,
    987767,
    878698,
    697879,
    888797,
    997778,
    978789,
    887969,
    787878,
    779889,
    889788,
    888868,
    698888,
    898798,
    979787,
    679777,
    888678,
    889977,
    869879,
    779989,
    788998,
    797788,
    777888,
    798677,
    778797,
    766677,
    887669,
    988797,
    789776,
    898888,
    788797,
    688888,
    878888,
    778788,
    789887,
    888886,
    899988,
    777978,
    988987,
    787788,
    798778,
    877988,
    777779,
    676788,
    776787,
    876897,
    877979,
    979787,
    687988,
    899888,
    886787,
    788867,
    888798,
    776887,
    887867,
    788788,
    778888,
    897776,
    889898,
    897687,
    669688,
    999877,
    899979,
    667787,
    879887,
    776898,
    767868,
    879877,
    668777,
    998886,
    797778,
    789788,
    887789,
    878798,
    776777,
    897797,
    888987,
    889798,
    889886,
    987887,
    799889,
    979889,
    769798,
    889797,
    996887,
    777796,
    876679,
    778799,
    997888,
    787897,
    979887,
    788888,
    888988,
    886787,
    777879,
    779789,
    776897,
    897879,
    888888,
    787777,
    786998,
    868787,
    788977,
    787889,
    888878,
    778877,
    797797,
    889988,
    797769,
    787878,
    997778,
    988789,
    787787,
    779997,
    997779,
    887968,
    797986,
    797987,
    978788,
    678786,
    777689,
    887999,
    776898,
    778887,
    878777,
    987987,
    897778,
    878989,
    788779,
    788867,
    688868,
    777987,
    766989,
    799867,
    766887,
    879787,
    689677,
    978987,
    897879,
    787888,
    888768,
    987799,
    988888,
    797798,
    888687,
    978777,
    688777,
    898787,
    788879,
    989889,
    987788,
    868789,
    877879,
    897698,
    877778,
    798877,
    779979,
    877878,
    877899,
    989898,
    888778,
    999888,
    786888,
    878687,
    788987,
    997788,
    887889,
    787677,
    997888,
    887889,
    887777,
    878788,
    798768,
    699977,
    878788,
    898787,
    778899,
    788787,
    888869,
    798697,
    888787,
    988798,
    899869,
    868887,
    989777,
    886977,
    677889,
    986777,
    777977,
    986888,
    998888,
    879778,
    968788,
    798886,
    988768,
    977877,
    898878,
    778778,
    888977,
    988977,
    788789,
    877787,
    878789,
    987797,
    788897,
    797987,
    889898,
    796889,
    679887,
    978867,
    979788,
    788878,
    888979,
    889978,
    878778,
    689777,
    888879,
    788798,
    888877,
    898878,
    887887,
    887989,
    889899,
    778887,
    698897,
    777878,
    888887,
    899889,
    787787,
    987787,
    999988,
    797797,
    796899,
    878788,
    788789,
    978798,
    698687,
    869798,
    788778,
    688778,
    968897,
    878877,
    887877,
    877788,
    889877,
    888876,
    778868,
    787687,
    897778,
    778787,
    977877,
    877976,
    988877,
    699687,
    888688,
    979889,
    878899,
    779988,
    787787,
    889787,
    987778,
    989868,
    799977,
    877788,
    779777,
    798877,
    998787,
    988879,
    879789,
    797678,
    888797,
    788988,
    778987,
    778788,
    968779,
    888778,
    776688,
    778777,
    767778,
    877878,
    986778,
    887778,
    877878,
    688789,
    877988,
    789977,
    998777,
    878897,
    786797,
    968778,
    789797,
    888798,
    787889,
    788788,
    697988,
    876868,
    888797,
    987888,
    898979,
    979887,
    787697,
    878778,
    789878,
    777997,
    978778,
    989988,
    778789,
    879878,
    888676,
    798777,
    787776,
    888898,
    979898,
    888797,
    897788,
    898887,
    967779,
    779788,
    897898,
    879788,
    888779,
    887897,
    778897,
    777786,
    898689,
    989887,
    886779,
    778988,
    787888,
    978688,
    888988,
    796987,
    977998,
    989787,
    878899,
    877978,
    687898,
    977778,
    897688,
    997988,
    877796,
    888768,
    889788,
    877878,
    786878,
    788899,
    767879,
    998868,
    898897,
    788786,
    779978,
    887987,
    879897,
    968889,
    877899,
    798979,
    897987,
    889788,
    886798,
    887788,
    878797,
    877888,
    887977,
    897887,
    687787,
    799898,
    679998,
    988798,
    877898,
    887779,
    878999,
    878889,
    878877,
    767898,
    877799,
    997889,
    769797,
    789888,
    988787,
    778979,
    888888,
    887879,
    787898,
    889788,
    887678,
    888776,
    789778,
    889778,
    888787,
    789978,
    889878,
    787687,
    987887,
    888687,
    887788,
    888978,
    787768,
    887787,
    797887,
    988787,
    877788,
    898778,
    887879,
    979899,
    888688,
    787878,
    787778,
    889797,
    998779,
    778877,
    887678,
    797889,
    978797,
    999968,
    688976,
    797979,
    768778,
    776798,
    787976,
    889876,
    797988,
    888898,
    888798,
    988976,
    888689,
    976987,
    999788,
    788998,
    897986,
    687977,
    788777,
    778778,
    887877,
    789796,
    889879,
    787867,
    887889,
    899678,
    798898,
    888877,
    779767,
    896877,
    887868,
    766788,
    777987,
    878888,
    897988,
    997778,
    787997,
    898978,
    878888,
    887886,
    897778,
    979888,
    888878,
    888689,
    677889,
    786879,
    877887,
    786799,
    997778,
    888898,
    688898,
    899888,
    978798,
    797777,
    878889,
    879867,
    688888,
    887898,
    888887,
    877888,
    768968,
    789877,
    987778,
    778997,
    978889,
    797878,
    977888,
    878876,
    898897,
    687879,
    698768,
    886798,
    886777,
    799786,
    989978,
    787887,
    888877,
    988887,
    878787,
    887889,
    887788,
    878878,
    887786,
    898988,
    887788,
    987797,
    699897,
    997967,
    888788,
    868879,
    889777,
    879779,
    797978,
    778888,
    878887,
    889877,
    679896,
    888797,
    778877,
    989796,
    889988,
    789687,
    889988,
    797889,
    798898,
    778978,
    999889,
    777898,
    798779,
    986797,
    898898,
    786778,
    878888,
    889877,
    887978,
    889778,
    878878,
    889768,
    778877,
    897778,
    867889,
    888886,
    877879,
    989687,
    778688,
    787788,
    977879,
    888778,
    978878,
    878798,
    779777,
    887978,
    678887,
    977667,
    888787,
    788897,
    998988,
    788878,
    988977,
    787788,
    878968,
    889978,
    778789,
    699678,
    988877,
    989978,
    798889,
    788988,
    887778,
    879888,
    798797,
    988968,
    996898,
    887689,
    887867,
    798998,
    788879,
    879787,
    788877,
    878777,
    879769,
    988898,
    887988,
    887887,
    787798,
    789788,
    687988,
    788887,
    988778,
    887978,
    688879,
    788996,
    889889,
    888977,
    887989,
    979888,
    879978,
    786778,
    799889,
    976778,
    888877,
    988888,
    798798,
    887887,
    878788,
    878788,
    997788,
    797697,
    978768,
    789878,
    787787,
    888787,
    888868,
    687676,
    788899,
    798787,
    889899,
    796777,
    897978,
    996988,
    888889,
    789888,
    778777,
    898877,
    977898,
    778799,
    777887,
    986988,
    998697,
    797878,
    777998,
    878768,
    787878,
    888878,
    998788,
    787788,
    678687,
    988888,
    678887,
    896779,
    799777,
    977877,
    978687,
    886897,
    788998,
    888887,
    888889,
    877988,
    877789,
    979897,
    777899,
    779886,
    888798,
    868897,
    778788,
    888777,
    887897,
    778769,
    787888,
    897898,
    968778,
    689979,
    787897,
    987898,
    886998,
    978898,
    788888,
    879678,
    788798,
    788879,
    677989,
    997988,
    879978,
    889798,
    987877,
    998887,
    896979,
    987998,
    878798,
    889789,
    677689,
    977977,
    777888,
    688877,
    788888,
    787889,
    977977,
    787779,
    779787,
    886889,
    988997,
    887699,
    879997,
    898878,
    789976,
    789888,
    888887,
    877879,
    886878,
    879798,
    877997,
    888878,
    767888,
    778799,
    988887,
    798887,
    888688,
    889877,
    977878,
    888997,
    787777,
    878796,
    789777,
    878787,
    877767,
    997978,
    697787,
    798997,
    777879,
    678898,
    787878,
    888897,
    868789,
    787887,
    697787,
    887679,
    877977,
    688778,
    787787,
    978888,
    887978,
    788688,
    997877,
    797789,
    977998,
    888898,
    899987,
    897788,
    887688,
    798988,
    797987,
    778987,
    789886,
    898989,
    877877,
    989779,
    788877,
    887868,
    978997,
    888888,
    998788,
    877898,
    889887,
    899887,
    979788,
    988778,
    867689,
    898897,
    787988,
    988689,
    878799,
    878888,
    877897,
    889776,
    879889,
    886878,
    887899,
    679868,
    789888,
    778678,
    989797,
    787797,
    887897,
    888887,
    798778,
    787789,
    879888,
    788968,
    888788,
    897777,
    899979,
    898977,
    877878,
    988987,
    987978,
    798879,
    777778,
    978798,
    878887,
    887777,
    899798,
    788786,
    778896,
    898898,
    987989,
    887898,
    887777,
    997777,
    888886,
    867788,
    986797,
    787878,
    688888,
    786877,
    989889,
    798886,
    678777,
    797997,
    877787,
    978997,
    678797,
    779898,
    978987,
    697987,
    677988,
    788779,
    998867,
    678877,
    769787,
    878987,
    877777,
    678988,
    978888,
    778888,
    878797,
    788987,
    798779,
    979879,
    788788,
    796788,
    688786,
    897978,
    886767,
    878877,
    787978,
    786787,
    989787,
    788687,
    978798,
    787888,
    877967,
    898687,
    787698,
    898996,
    778799,
    889887,
    878977,
    779889,
    798787,
    888768,
    886888,
    689768,
    777879,
    788889,
    877898,
    898677,
    787798,
    888888,
    777879,
    988797,
    879778,
    997787,
    888797,
    777868,
    688788,
    897898,
    778888,
    877977,
    889677,
    888977,
    878797,
    888889,
    888889,
    988787,
    788889,
    988788,
    787787,
    899799,
    889988,
    987887,
    797886,
    867887,
    887878,
    888889,
    988798,
    788786,
    788886,
    788789,
    787787,
    687889,
    899999,
    899788,
    877767,
    977898,
    866878,
    977797,
    978887,
    797888,
    779877,
    868778,
    888888,
    887689,
    688898,
    868768,
    877798,
    777778,
    888798,
    898979,
    967888,
    979879,
    887878,
    987887,
    787987,
    787788,
    777888,
    878896,
    897777,
    897889,
    887898,
    677787,
    788878,
    777699,
    788887,
    889789,
    879878,
    888878,
    789998,
    878788,
    997779,
    788967,
    798988,
    879887,
    778877,
    688988,
    989787,
    797789,
    788788,
    898878,
    887786,
    799788,
    988877,
    889887,
    987889,
    878787,
    777898,
    788998,
    877986,
    989878,
    989688,
    888877,
    899797,
    999697,
    679877,
    988788,
    987987,
    789978,
    888887,
    999988,
    878668,
    888876,
    999787,
    897878,
    779766,
    797978,
    897879,
    777889,
    798798,
    787789,
    788797,
    777779,
    878877,
    787879,
    987686,
    978977,
    888878,
    889767,
    798888,
    787887,
    967887,
    788787,
    976688,
    778988,
    888999,
    997788,
    887889,
    978887,
    967797,
    887697,
    797879,
    888978,
    778869,
    879787,
    887789,
    877888,
    987879,
    876887,
    887787,
    789889,
    789978,
    899897,
    687787,
    897899,
    776677,
    767789,
    879989,
    876777,
    977889,
    779879,
    787876,
    898989,
    889779,
    787897,
    987779,
    968798,
    978778,
    787878,
    898998,
    778889,
    968977,
    787777,
    787898,
    996879,
    987998,
    877997,
    778988,
    788788,
    777879,
    987889,
    779778,
    997888,
    787789,
    889877,
    877898,
    888888,
    687987,
    987787,
    878688,
    977779,
    769989,
    978987,
    688888,
    887698,
    888867,
    888888,
    897777,
    687886,
    887677,
    886688,
    977788,
    769887,
    878786,
    997999,
    767776,
    788689,
    778777,
    977787,
    897898,
    889887,
    799878,
    898789,
    899889,
    887877,
    879689,
    898877,
    987897,
    876878,
    878997,
    867998,
    798777,
    789679,
    876986,
    997777,
    677888,
    787889,
    798888,
    877888,
    878778,
    898977,
    778798,
    979988,
    696787,
    799978,
    887777,
    878989,
    788878,
    879989,
    777788,
    887797,
    689788,
    888788,
    888788,
    898797,
    887888,
    888878,
    678878,
    896988,
    797888,
    987969,
    897977,
    797688,
    887787,
    986888,
    888966,
    878978,
    997787,
    877787,
    868976,
    878888,
    799878,
    898796,
    979987,
    798789,
    779787,
    778888,
    778988,
    788869,
    888777,
    889889,
    777989,
    789887,
    769898,
    798878,
    899778,
    786997,
    888868,
    789987,
    897889,
    868888,
    689787,
    798898,
    877878,
    898878,
    888777,
    798978,
    997898,
    879867,
    878876,
    689787,
    787998,
    797897,
    987988,
    888878,
    789878,
    789668,
    879687,
    788987,
    999787,
    898887,
    888888,
    868778,
    887798,
    788987,
    786677,
    976887,
    877789,
    688899,
    788897,
    897787,
    987777,
    888776,
    778677,
    778896,
    889687,
    787878,
    887889,
    998988,
    688888,
    886878,
    897867,
    878997,
    888887,
    978779,
    989868,
    797888,
    988788,
    788798,
    978988,
    988878,
    678988,
    886878,
    667888,
    876778,
    898878,
    788977,
    878778,
    967888,
    888978,
    797778,
    768688,
    987997,
    788879,
    888778,
    868878,
    777788,
    887879,
    788979,
    987668,
    979778,
    789788,
    777967,
    878878,
    777789,
    978788,
    787787,
    987869,
    796888,
    886888,
    888789,
    888789,
    796887,
    996798,
    769688,
    886979,
    797998,
    687888,
    787898,
    797787,
    868988,
    788779,
    988888,
    697887,
    887787,
    688787,
    878896,
    886877,
    899789,
    777887,
    696977,
    887988,
    767888,
    896878,
    798898,
    997768,
    888767,
    788887,
    878976,
    788867,
    788778,
    778768,
    898889,
    888898,
    668798,
    977878,
    788798,
    778988,
    896798,
    788979,
    897768,
    889777,
    788888,
    877768,
    879878,
    777899,
    978768,
    977988,
    776989,
    989877,
    878779,
    778767,
    888997,
    988888,
    877789,
    796787,
    777879,
    888988,
    878989,
    788787,
    878778,
    767988,
    888888,
    887988,
    879788,
    767777,
    879787,
    887889,
    779778,
    788998,
    787778,
    767779,
    988869,
    677877,
    878988,
    888879,
    888978,
    788877,
    799899,
    789778,
    768788,
    768968,
    787878,
    797888,
    888778,
    887989,
    877988,
    879678,
    687786,
    778788,
    889888,
    887787,
    988989,
    788988,
    888787,
    877797,
    798777,
    788988,
    898989,
    878978,
    898889,
    799967,
    897688,
    877888,
    888878,
    777887,
    888868,
    888988,
    877778,
    769799,
    987869,
    798897,
    879689,
    889978,
    678789,
    888898,
    886989,
    889688,
    977887,
    888897,
    788976,
    897877,
    878877,
    998698,
    868877,
    888778,
    877888,
    897989,
    778877,
    888898,
    787889,
    877979,
    987888,
    999788,
    977988,
    879788,
    978889,
    877688,
    889987,
    987877,
    878987,
    776988,
    778967,
    989889,
    778789,
    787777,
    787889,
    877798,
    788978,
    677787,
    788969,
    788877,
    889877,
    787779,
    697997,
    767787,
    778877,
    888889,
    879888,
    779888,
    798898,
    878888,
    889776,
    797678,
    887888,
    779887,
    788877,
    898789,
    787878,
    968788,
    887978,
    778888,
    967887,
    778898,
    776879,
    778878,
    867786,
    678998,
    777888,
    787988,
    678888,
    778888,
    687778,
    668796,
    887888,
    798888,
    869988,
    888878,
    878798,
    898787,
    888889,
    877998,
    887867,
    886778,
    688788,
    788679,
    898987,
    798787,
    979787,
    687867,
    897896,
    688978,
    788998,
    888779,
    778768,
    989678,
    798889,
    787787,
    977686,
    678788,
    987696,
    878978,
    889788,
    787878,
    677887,
    898797,
    677768,
    877878,
    878787,
    788877,
    968976,
    887799,
    768887,
    888786,
    788897,
    979869,
    878888,
    977888,
    887789,
    988888,
    888786,
    889777,
    797876,
    788989,
    977887,
    998898,
    978788,
    998968,
    768779,
    897888,
    788788,
    977867,
    778887,
    868778,
    878877,
    987987,
    887779,
    887867,
    779788,
    788779,
    898988,
    788897,
    888889,
    878788,
    998887,
    786899,
    889877,
    887767,
    888887,
    997687,
    967787,
    777889,
    867978,
    788798,
    979879,
    888687,
    888687,
    977988,
    788788,
    699879,
    797778,
    987776,
    788777,
    989798,
    778787,
    778889,
    877897,
    888889,
    988877,
    888897,
    978789,
    879898,
    878799,
    889888,
    787787,
    997987,
    998897,
    877998,
    687797,
    899769,
    888888,
    779879,
    898978,
    787886,
    899898,
    777698,
    679666,
    898788,
    899789,
    887789,
    877899,
    678798,
    688787,
    778988,
    777877,
    689869,
    777967,
    797997,
    979879,
    787867,
    878687,
    888768,
    887997,
    788778,
    689988,
    779978,
    688789,
    978897,
    998878,
    888778,
    978877,
    788789,
    897787,
    898878,
    767686,
    888889,
    887878,
    877887,
    787888,
    779978,
    869967,
    788778,
    788787,
    878978,
    689677,
    967789,
    779988,
    688788,
    889797,
    898879,
    888888,
    886868,
    878797,
    897886,
    787787,
    887978,
    889997,
    988787,
    989678,
    898997,
    777888,
    879889,
    877878,
    877998,
    687998,
    977898,
    877778,
    987897,
    898788,
    998987,
    899888,
    788878,
    777897,
    888978,
    898786,
    787887,
    897769,
    997767,
    887786,
    788669,
    889788,
    688888,
    879878,
    988877,
    877878,
    897887,
    897867,
    999878,
    767799,
    879777,
    999688,
    897878,
    888889,
    779987,
    779789,
    898887,
    798799,
    776988,
    778778,
    689869,
    987787,
    978978,
    877878,
    977779,
    879779,
    796788,
    997798,
    976967,
    689889,
    877678,
    787788,
    788886,
    788987,
    678979,
    988887,
    678978,
    776698,
    969888,
    796977,
    787997,
    897889,
    788967,
    877787,
    798869,
    778899,
    797778,
    879877,
    787778,
    988789,
    877787,
    996797,
    888888,
    897886,
    797788,
    888887,
    898898,
    898796,
    787799,
    798778,
    898769,
    887688,
    878979,
    878989,
    878788,
    798779,
    978686,
    789876,
    788697,
    987698,
    788787,
    777867,
    877789,
    978688,
    898778,
    988787,
    888988,
    887998,
    788886,
    789888,
    889767,
    988889,
    779786,
    788788,
    888878,
    787877,
    968688,
    897789,
    676888,
    888869,
    886887,
    787878,
    988987,
    877787,
    679788,
    878997,
    896878,
    889888,
    898867,
    777898,
    778989,
    997988,
    887777,
    987787,
    996776,
    797786,
    887988,
    989879,
    998888,
    888688,
    878879,
    799979,
    787877,
    876687,
    799688,
    777877,
    879777,
    876787,
    988889,
    989786,
    787989,
    998777,
    878779,
    897676,
    898899,
    787877,
    968888,
    888679,
    877897,
    878677,
    968986,
    797687,
    887679,
    979888,
    779797,
    788898,
    879787,
    878788,
    888867,
    787778,
    797877,
    889887,
    797798,
    868879,
    988777,
    979687,
    888768,
    878888,
    776977,
    886887,
    888778,
    879988,
    996777,
    979898,
    897878,
    689897,
    889879,
    887987,
    789878,
    878887,
    787777,
    888777,
    878896,
    879877,
    878878,
    788767,
    889888,
    967888,
    878876,
    779898,
    777888,
    688786,
    788887,
    888978,
    889769,
    887998,
    787887,
    976998,
    788788,
    778877,
    998788,
    878988,
    799798,
    888869,
    988886,
    879887,
    778888,
    688979,
    787868,
    797878,
    997879,
    797788,
    698787,
    898868,
    877789,
    898987,
    887667,
    778688,
    878788,
    888787,
    698888,
    777988,
    788878,
    987777,
    878878,
    899989,
    777789,
    878898,
    788888,
    887888,
    876978,
    777978,
    888887,
    889789,
    989987,
    977878,
    989777,
    886788,
    677879,
    897668,
    677876,
    988869,
    789787,
    779698,
    797778,
    876878,
    777888,
    789878,
    879788,
    677888,
    989998,
    877899,
    697788,
    898898,
    687869,
    789978,
    888687,
    789899,
    878877,
    887888,
    988988,
    788989,
    898678,
    778779,
    887878,
    867888,
    786787,
    899788,
    787789,
    978876,
    778687,
    876998,
    879787,
    899887,
    788778,
    996989,
    899788,
    897878,
    889997,
    979788,
    879979,
    798888,
    777878,
    897877,
    798998,
    689879,
    878889,
    788768,
    889977,
    998988,
    997879,
    987797,
    789998,
    878798,
    779979,
    788777,
    767789,
    687768,
    878878,
    887778,
    887787,
    879886,
    999877,
    769868,
    887788,
    789888,
    887787,
    787888,
    797878,
    887887,
    978987,
    998887,
    879879,
    687899,
    888677,
    889687,
    888888,
    987777,
    687777,
    988798,
    876789,
    898889,
    767889,
    787778,
    778987,
    799878,
    688778,
    778988,
    877778,
    867668,
    877888,
    887768,
    767889,
    798788,
    889787,
    888898,
    787888,
    678888,
    898899,
    878977,
    898798,
    788897,
    877878,
    889787,
    878787,
    979889,
    887888,
    888879,
    889877,
    878789,
    778978,
    788996,
    787968,
    999898,
    778888,
    789678,
    878888,
    877878,
    887878,
    977768,
    888797,
    687889,
    888798,
    778898,
    868788,
    777888,
    798887,
    867788,
    898867,
    878889,
    888886,
    889679,
    788687,
    797988,
    997688,
    888888,
    778967,
    798698,
    988888,
    987988,
    778788,
    897898,
    797789,
    887878,
    799897,
    779798,
    799979,
    986689,
    979867,
    888898,
    988779,
    889896,
    887767,
    887777,
    888897,
    889688,
    878777,
    897787,
    868878,
    688788,
    877776,
    899798,
    978889,
    889768,
    778877,
    879797,
    986888,
    787998,
    789877,
    797788,
    999888,
    778979,
    879878,
    877868,
    989877,
    778768,
    788789,
    778786,
    979887,
    788998,
    898768,
    978877,
    787889,
    888778,
    968787,
    978776,
    997697,
    788888,
    887788,
    787787,
    898879,
    787888,
    979787,
    777987,
    887798,
    887988,
    876979,
    898988,
    798798,
    979779,
    978788,
    878977,
    998779,
    888678,
    887788,
    688877,
    887988,
    878796,
    888878,
    788877,
    869888,
    868778,
    976777,
    887787,
    888988,
    997878,
    878996,
    888878,
    777887,
    898768,
    986789,
    677986,
    677887,
    987676,
    787879,
    798797,
    977889,
    768868,
    987888,
    787789,
    967878,
    688888,
    988977,
    776888,
    788789,
    778989,
    697988,
    678797,
    988887,
    878989,
    787776,
    887879,
    878789,
    878688,
    968877,
    797987,
    897788,
    886887,
    777878,
    787967,
    877796,
    878889,
    688878,
    798777,
    879888,
    788888,
    778987,
    889768,
    778888,
    798896,
    878776,
    997898,
    877877,
    878898,
    778777,
    979787,
    799876,
    888877,
    878788,
    879976,
    877888,
    778778,
    897878,
    986698,
    887897,
    787989,
    667687,
    897897,
    988867,
    788798,
    998877,
    889798,
    778777,
    897987,
    687777,
    779998,
    888887,
    998887,
    777688,
    788678,
    887789,
    779987,
    789877,
    887777,
    887677,
    978688,
    788769,
    878878,
    879798,
    787989,
    789778,
    788678,
    787879,
    698888,
    789867,
    888787,
    778998,
    888878,
    878777,
    799988,
    799988,
    988987,
    897678,
    879887,
    799796,
    968877,
    788788,
    777776,
    878888,
    988877,
    979877,
    887988,
    887788,
    877879,
    886777,
    898979,
    797888,
    987787,
    888887,
    978998,
    876787,
    889777,
    899986,
    867689,
    879879,
    989878,
    888867,
    788998,
    889877,
    898877,
    888886,
    878789,
    788899,
    778877,
    788979,
    876879,
    899688,
    889888,
    779778,
    989879,
    897798,
    978778,
    777798,
    888797,
    686686,
    888777,
    999876,
    878889,
    888898,
    899888,
    876786,
    898897,
    768897,
    889678,
    768897,
    677798,
    788887,
    987896,
    887889,
    897788,
    988888,
    876786,
    879979,
    687878,
    988877,
    788997,
    898778,
    988887,
    889798,
    886688,
    879788,
    788698,
    879787,
    878999,
    888788,
    888688,
    988998,
    876787,
    798999,
    878899,
    898889,
    877898,
    878679,
    778678,
    778788,
    998888,
    687788,
    877886,
    878997,
    897787,
    888887,
    789979,
    998779,
    898788,
    788697,
    879878,
    868976,
    788888,
    776889,
    887687,
    887777,
    877987,
    979866,
    979789,
    898888,
    799688,
    777886,
    877789,
    689978,
    889877,
    768989,
    878988,
    898988,
    788877,
    679988,
    766898,
    779788,
    979887,
    888868,
    978798,
    788897,
    689878,
    779997,
    788996,
    679888,
    789789,
    876897,
    767968,
    887896,
    696877,
    888788,
    878998,
    878788,
    876786,
    998877,
    978878,
    787998,
    988788,
    677887,
    878877,
    878898,
    877898,
    877787,
    887967,
    787768,
    788788,
    989888,
    887877,
    987786,
    898876,
    787877,
    977878,
    787778,
    887778,
    887887,
    779788,
    889887,
    689889,
    787878,
    777899,
    878879,
    777877,
    789889,
    789887,
    978887,
    988998,
    788978,
    778777,
    788767,
    877789,
    978999,
    898887,
    988878,
    998897,
    897777,
    887988,
    687789,
    868877,
    789878,
    778786,
    877888,
    987969,
    787889,
    878769,
    797878,
    889887,
    978887,
    797897,
    779989,
    768787,
    897889,
    878977,
    898886,
    898888,
    677777,
    868888,
    887789,
    779987,
    768778,
    979979,
    887879,
    898677,
    878879,
    889987,
    887787,
    788877,
    986779,
    689897,
    777887,
    989898,
    878886,
    798888,
    877867,
    986788,
    879988,
    889987,
    898888,
    767888,
    779878,
    888897,
    698797,
    888878,
    887798,
    677977,
    776778,
    789889,
    687886,
    888788,
    797978,
    877768,
    787679,
    979778,
    779778,
    787778,
    887677,
    778776,
    799879,
    887978,
    789877,
    788987,
    787867,
    987879,
    888788,
    787977,
    967976,
    877787,
    967897,
    899896,
    897769,
    886799,
    888888,
    678788,
    977999,
    788787,
    986689,
    777997,
    669888,
    778998,
    778776,
    789778,
    868879,
    898888,
    887688,
    777979,
    898777,
    878698,
    868887,
    888877,
    889889,
    888878,
    896779,
    997877,
    888887,
    987888,
    988778,
    888978,
    788987,
    678887,
    899977,
    796798,
    786977,
    967778,
    769889,
    787888,
    799886,
    797888,
    988887,
    878888,
    777988,
    897878,
    897898,
    768789,
    989897,
    878898,
    697798,
    878988,
    876788,
    868797,
    987787,
    788898,
    978678,
    896888,
    876899,
    868798,
    797778,
    978878,
    788887,
    787979,
    988688,
    787888,
    888777,
    788796,
    886698,
    779888,
    699887,
    877979,
    887777,
    898779,
    789987,
    887899,
    797778,
    897997,
    678878,
    777887,
    897887,
    786788,
    978789,
    889876,
    778798,
    778779,
    878887,
    887788,
    878998,
    889898,
    878868,
    776886,
    998787,
    979799,
    988977,
    976888,
    988798,
    677887,
    888887,
    898888,
    677979,
    777689,
    688899,
    778897,
    797887,
    689987,
    899877,
    878887,
    997888,
    967989,
    787867,
    887878,
    879789,
    879799,
    788887,
    778978,
    898899,
    977778,
    878777,
    888887,
    898777,
    997689,
    788787,
    788897,
    689779,
    678889,
    779898,
    977868,
    997788,
    787787,
    887687,
    888889,
    789798,
    876877,
    897787,
    889878,
    888877,
    889897,
    897799,
    677888,
    888688,
    887998,
    798797,
    697888,
    888788,
    887897,
    788788,
    778888,
    777878,
    988688,
    788788,
    678888,
    887988,
    988768,
    787788,
    988687,
    879876,
    777777,
    888878,
    679777,
    978898,
    899867,
    889899,
    778877,
    778789,
    777887,
    879899,
    887789,
    777998,
    887788,
    778988,
    878898,
    899997,
    777879,
    977767,
    887787,
    677878,
    787878,
    698897,
    888989,
    699788,
    988886,
    877978,
    788777,
    878987,
    799898,
    878869,
    978789,
    878887,
    889779,
    969988,
    876989,
    779879,
    877797,
    887768,
    778997,
    888777,
    798878,
    687777,
    988788,
    668988,
    889788,
    788968,
    877978,
    887678,
    988867,
    787979,
    888887,
    879988,
    886788,
    778679,
    878878,
    786888,
    777678,
    887887,
    878799,
    778779,
    988878,
    977987,
    687789,
    788978,
    689878,
    878689,
    988988,
    797988,
    879989,
    986988,
    899878,
    787687,
    687788,
    777789,
    798888,
    787889,
    978888,
    878978,
    877877,
    778677,
    996988,
    888998,
    678889,
    868878,
    789798,
    877798,
    889789,
    786897,
    897878,
    888898,
    777897,
    667887,
    887889,
    877978,
    987787,
    977769,
    979798,
    879887,
    876789,
    888988,
    697888,
    766897,
    977888,
    879887,
    988778,
    879778,
    987678,
    877778,
    778897,
    797788,
    778989,
    867879,
    886789,
    788877,
    898687,
    997889,
    889776,
    788798,
    889887,
    887786,
    887788,
    866887,
    878987,
    788877,
    877888,
    978788,
    979879,
    889887,
    787977,
    778786,
    898797,
    787977,
    979967,
    888779,
    979879,
    997789,
    887777,
    997787,
    798978,
    889797,
    768887,
    687899,
    889887,
    798897,
    897876,
    787778,
    987987,
    998887,
    786896,
    897998,
    878787,
    888987,
    987868,
    897888,
    988997,
    979997,
    888888,
    877896,
    787978,
    788898,
    888687,
    778889,
    898888,
    989878,
    778679,
    889887,
    778779,
    678888,
    898988,
    788789,
    888886,
    869888,
    777997,
    788889,
    978797,
    877988,
    769777,
    797897,
    888978,
    868879,
    888867,
    877769,
    998789,
    797987,
    987899,
    888988,
    888686,
    777877,
    996999,
    898778,
    787988,
    787887,
    968878,
    867767,
    879777,
    878999,
    987797,
    966798,
    998997,
    798798,
    788778,
    778787,
    789688,
    988877,
    878899,
    878898,
    979886,
    988889,
    787789,
    888877,
    888987,
    698898,
    688776,
    888878,
    788778,
    878789,
    778888,
    796897,
    878776,
    876778,
    778877,
    998777,
    888887,
    898888,
    787889,
    787988,
    998878,
    877797,
    689886,
    768778,
    987878,
    888987,
    899699,
    879999,
    678876,
    888877,
    877887,
    788887,
    779789,
    779978,
    789888,
    787989,
    868777,
    888888,
    888687,
    877789,
    877796,
    797869,
    878779,
    687999,
    788877,
    798798,
    867788,
    888687,
    899889,
    888888,
    678777,
    888789,
    877687,
    888698,
    878988,
    786969,
    768978,
    878878,
    888777,
    868769,
    997988,
    987877,
    997779,
    889868,
    779888,
    887787,
    889877,
    989786,
    898776,
    999787,
    798779,
    879978,
    789866,
    899878,
    679968,
    868988,
    876688,
    778887,
    888888,
    687688,
    986777,
    788678,
    787898,
    879898,
    897779,
    876778,
    889887,
    677877,
    877789,
    887867,
    697987,
    998798,
    776899,
    979877,
    987767,
    878797,
    696887,
    787878,
    977886,
    787889,
    978877,
    888789,
    979679,
    789887,
    777777,
    868878,
    776798,
    867996,
    887967,
    887788,
    697869,
    788877,
    888788,
    899889,
    887886,
    887689,
    887889,
    789767,
    789887,
    898979,
    789888,
    768799,
    768899,
    797789,
    887868,
    778779,
    789788,
    878777,
    887897,
    889677,
    788787,
    889698,
    867987,
    988877,
    898887,
    687887,
    787877,
    898986,
    777777,
    878877,
    877787,
    976877,
    768679,
    867888,
    878978,
    998867,
    898887,
    788789,
    978987,
    879896,
    788989,
    868888,
    777897,
    786777,
    887889,
    777777,
    797788,
    887798,
    788789,
    888969,
    779777,
    778788,
    978778,
    888788,
    678988,
    886886,
    687998,
    978978,
    677887,
    789997,
    989888,
    887787,
    997878,
    779877,
    889888,
    988778,
    979777,
    789988,
    879888,
    777868,
    897879,
    787787,
    798697,
    788898,
    898888,
    877988,
    778888,
    888988,
    778789,
    779668,
    887787,
    978897,
    688977,
    787687,
    888899,
    877798,
    877878,
    898888,
    778767,
    778997,
    889886,
    986788,
    778987,
    788888,
    778988,
    677889,
    887879,
    778888,
    888878,
    888878,
    888898,
    978778,
    968987,
    888798,
    887877,
    767788,
    987888,
    787998,
    888889,
    699987,
    679886,
    867786,
    897877,
    987787,
    979897,
    687789,
    889968,
    888987,
    878888,
    878776,
    888888,
    897787,
    888787,
    897887,
    878869,
    787877,
    999688,
    887788,
    976989,
    969678,
    799889,
    868889,
    796876,
    898877,
    888689,
    888878,
    769876,
    868778,
    788878,
    778867,
    678877,
    888989,
    997867,
    677778,
    768777,
    787887,
    897799,
    788799,
    898888,
    887978,
    777898,
    788798,
    788878,
    886888,
    787676,
    778888,
    888787,
    777877,
    989889,
    788986,
    776988,
    697778,
    797778,
    978877,
    797867,
    777996,
    878898,
    988889,
    887986,
    888786,
    769767,
    897888,
    879889,
    877978,
    988988,
    978869,
    878789,
    888888,
    779888,
    987889,
    978799,
    977898,
    788899,
    887877,
    778878,
    787898,
    897978,
    889697,
    888986,
    897678,
    688987,
    897998,
    777978,
    877888,
    779788,
    897887,
    877898,
    677778,
    768988,
    898979,
    877777,
    788777,
    878889,
    988866,
    999878,
    779777,
    896689,
    776968,
    889887,
    987979,
    889688,
    986899,
    878979,
    988877,
    898789,
    878988,
    888897,
    788879,
    689887,
    889867,
    797778,
    787788,
    879797,
    998678,
    778797,
    998887,
    679697,
    877788,
    788987,
    798878,
    687779,
    887977,
    798799,
    997778,
    787978,
    779788,
    887897,
    777988,
    677777,
    977887,
    897889,
    997989,
    986777,
    788866,
    698797,
    888777,
    698888,
    899977,
    878878,
    999988,
    977688,
    888788,
    787788,
    888867,
    788798,
    776779,
    787896,
    788898,
    888878,
    889777,
    888977,
    787797,
    878878,
    899788,
    777798,
    889887,
    798878,
    868898,
    678767,
    989997,
    787978,
    786898,
    786699,
    788788,
    788898,
    977989,
    798787,
    787679,
    876896,
    878888,
    888788,
    988897,
    778797,
    987898,
    978788,
    789698,
    797898,
    877787,
    886679,
    797798,
    878889,
    879877,
    798797,
    878888,
    788888,
    989897,
    869787,
    889778,
    888877,
    867787,
    899868,
    787767,
    987899,
    977777,
    877877,
    886788,
    698988,
    768779,
    867787,
    998998,
    787898,
    878888,
    977777,
    987767,
    888778,
    789879,
    888788,
    798898,
    878888,
    668887,
    788877,
    788769,
    897777,
    776898,
    777778,
    787787,
    787778,
    797887,
    798876,
    897789,
    988979,
    879877,
    888767,
    877876,
    888779,
    798879,
    887987,
    898899,
    679897,
    878778,
    997877,
    778889,
    787988,
    777887,
    888968,
    787787,
    886977,
    978897,
    688897,
    698888,
    778788,
    887887,
    988989,
    899777,
    777787,
    777888,
    797898,
    888779,
    778997,
    888887,
    777978,
    877677,
    879886,
    788977,
    778779,
    879888,
    769898,
    789787,
    767878,
    777889,
    788888,
    877768,
    877887,
    878788,
    788887,
    688788,
    878979,
    977879,
    988888,
    697879,
    888888,
    888989,
    768878,
    876977,
    867868,
    987988,
    769787,
    878777,
    878868,
    986797,
    789788,
    777879,
    899878,
    678678,
    969878,
    897887,
    969887,
    788888,
    999787,
    887988,
    867887,
    777788,
    788877,
    888979,
    879889,
    897888,
    996896,
    977677,
    778887,
    889789,
    888977,
    777898,
    699898,
    676798,
    868888,
    887897,
    798898,
    988698,
    778878,
    898877,
    899867,
    879887,
    987986,
    797797,
    788988,
    787988,
    786798,
    978988,
    877878,
    988888,
    888888,
    778889,
    797979,
    977978,
    888868,
    888797,
    769988,
    877777,
    888799,
    977988,
    997789,
    886789,
    688788,
    878898,
    977798,
    788688,
    788778,
    898877,
    779667,
    787989,
    888888,
    777888,
    988887,
    787998,
    869888,
    998776,
    899778,
    987987,
    789879,
    887988,
    768886,
    997879,
    898789,
    787789,
    878888,
    888799,
    886788,
    787779,
    879967,
    868767,
    877967,
    888798,
    877876,
    768869,
    867787,
    779889,
    887888,
    898788,
    778788,
    788868,
    887767,
    786889,
    897698,
    778898,
    777778,
    788898,
    788779,
    787878,
    779897,
    789798,
    787989,
    897799,
    878868,
    788887,
    989888,
    789789,
    888787,
    788888,
    778998,
    897779,
    779787,
    688888,
    878977,
    778887,
    788897,
    887869,
    887898,
    887889,
    887969,
    867778,
    888788,
    888888,
    988887,
    898878,
    797768,
    979987,
    678899,
    887978,
    879987,
    889788,
    799988,
    888787,
    989989,
    987778,
    887889,
    788779,
    977688,
    888787,
    889978,
    868788,
    889789,
    888997,
    868878,
    976778,
    789788,
    889987,
    788889,
    789688,
    798888,
    898998,
    998788,
    978996,
    878998,
    879988,
    887778,
    979786,
    969688,
    677767,
    788878,
    788687,
    696798,
    896878,
    797877,
    899779,
    897979,
    777878,
    896988,
    968779,
    898897,
    877888,
    878878,
    888899,
    789786,
    888787,
    878678,
    887988,
    878768,
    998877,
    987799,
    888997,
    876798,
    888779,
    999988,
    787978,
    887998,
    788888,
    677877,
    777778,
    788987,
    977886,
    869667,
    877869,
    789787,
    879876,
    789777,
    789888,
    788889,
    877787,
    787986,
    878986,
    998877,
    776877,
    778796,
    778778,
    879988,
    888888,
    888888,
    788787,
    889997,
    888788,
    887877,
    788786,
    789887,
    989778,
    877778,
    887978,
    897777,
    789687,
    889797,
    897786,
    877889,
    988987,
    888878,
    696888,
    887787,
    989886,
    987997,
    788788,
    988668,
    766888,
    777999,
    787779,
    888886,
    886668,
    989798,
    788879,
    889889,
    788788,
    779879,
    976877,
    777768,
    878887,
    877788,
    888779,
    788867,
    877896,
    887798,
    898798,
    789797,
    797877,
    778879,
    898888,
    799777,
    799788,
    987878,
    887877,
    777887,
    877787,
    888887,
    787698,
    898987,
    887777,
    678887,
    796788,
    778788,
    877889,
    879776,
    788768,
    868787,
    968699,
    778797,
    888668,
    778788,
    878899,
    788888,
    998997,
    867867,
    888887,
    687696,
    799778,
    878898,
    999999,
    987769,
    887887,
    788797,
    878897,
    897798,
    898988,
    998888,
    788889,
    888899,
    889796,
    778899,
    886978,
    768877,
    778889,
    989979,
    798798,
    876887,
    867897,
    867787,
    778799,
    887876,
    877997,
    887979,
    868798,
    988779,
    888976,
    777877,
    997788,
    798788,
    766688,
    677879,
    877677,
    787989,
    789888,
    986779,
    879877,
    877787,
    888768,
    997678,
    787899,
    877878,
    898797,
    798877,
    887788,
    979787,
    979688,
    886977,
    778988,
    778699,
    888797,
    987779,
    788888,
    786989,
    998889,
    787789,
    878778,
    777787,
    889998,
    788678,
    878997,
    888798,
    878878,
    987988,
    899788,
    778988,
    878778,
    988987,
    787688,
    988799,
    989878,
    978988,
    888787,
    888887,
    997868,
    898887,
    789878,
    788797,
    877888,
    887888,
    978867,
    768877,
    977776,
    887778,
    788787,
    777988,
    789896,
    986877,
    988887,
    886699,
    777779,
    877697,
    968998,
    887889,
    986877,
    987798,
    879776,
    788889,
    877778,
    888876,
    878887,
    777777,
    898867,
    789799,
    879888,
    689888,
    888877,
    787797,
    768788,
    679777,
    978869,
    888887,
    977878,
    877987,
    778978,
    989879,
    888889,
    897777,
    768989,
    788889,
    787967,
    877897,
    987977,
    978976,
    788989,
    798678,
    799998,
    797788,
    977778,
    698886,
    878888,
    887798,
    698788,
    987899,
    898878,
    868898,
    898787,
    988888,
    988988,
    778888,
    988897,
    867898,
    777887,
    999888,
    789997,
    978898,
    988777,
    878679,
    898997,
    987789,
    788688,
    877887,
    777876,
    867876,
    777878,
    787888,
    986877,
    876798,
    687898,
    778898,
    878776,
    878897,
    777887,
    798989,
    778777,
    777888,
    979698,
    897989,
    977888,
    967888,
    888987,
    678979,
    888898,
    977678,
    898898,
    678886,
    788987,
    898876,
    867887,
    988899,
    768889,
    786796,
    778897,
    896779,
    798879,
    887787,
    997789,
    888777,
    977888,
    787886,
    879989,
    779988,
    776788,
    788898,
    876888,
    877987,
    978789,
    988998,
    798988,
    788779,
    878897,
    988867,
    797797,
    778668,
    988888,
    969778,
    687798,
    788798,
    889798,
    677997,
    988777,
    978898,
    879887,
    978998,
    977697,
    888878,
    899778,
    877686,
    877876,
    869788,
    887666,
    879787,
    679877,
    678868,
    768868,
    898788,
    888978,
    987888,
    879977,
    886878,
    877687,
    889787,
    697787,
    898789,
    778787,
    989998,
    778879,
    868679,
    877897,
    787878,
    777898,
    767787,
    697889,
    789878,
    889788,
    977787,
    987979,
    897887,
    888698,
    897799,
    887887,
    789999,
    798677,
    886797,
    878879,
    898876,
    788779,
    777868,
    779868,
    767788,
    888779,
    889869,
    977886,
    877787,
    889797,
    887868,
    887897,
    897687,
    798767,
    677999,
    798988,
    789768,
    798898,
    999886,
    889977,
    977677,
    788789,
    788768,
    797887,
    888897,
    887977,
    878687,
    898887,
    889779,
    777678,
    788677,
    787777,
    798987,
    889887,
    879778,
    787889,
    797977,
    777677,
    897889,
    778887,
    888898,
    888777,
    777879,
    887887,
    879798,
    867797,
    777899,
    867878,
    887879,
    888778,
    798877,
    788889,
    989897,
    779878,
    977787,
    688989,
    788897,
    889867,
    778789,
    868798,
    878987,
    788887,
    898897,
    879989,
    978968,
    787877,
    987778,
    977877,
    867878,
    988877,
    888887,
    988897,
    898999,
    877887,
    977766,
    878886,
    899899,
    897877,
    999679,
    977987,
    888677,
    788787,
    778878,
    967887,
    887888,
    786877,
    977987,
    798787,
    979898,
    898989,
    777888,
    788787,
    988799,
    877977,
    887999,
    989888,
    698798,
    787789,
    778788,
    986877,
    787786,
    787677,
    779998,
    878689,
    788888,
    877988,
    788887,
    797988,
    779798,
    879978,
    878688,
    967988,
    988998,
    887988,
    767877,
    767878,
    788777,
    896878,
    798978,
    997898,
    778877,
    898789,
    788799,
    778979,
    777886,
    777667,
    789977,
    978788,
    787877,
    897898,
    888888,
    877889,
    889978,
    868888,
    879897,
    679787,
    988779,
    898788,
    777777,
    986897,
    887988,
    789997,
    697788,
    798987,
    898778,
    886898,
    888789,
    787787,
    889886,
    989979,
    798778,
    996878,
    787888,
    679788,
    789787,
    887898,
    889678,
    876988,
    977987,
    898878,
    879987,
    878878,
    888887,
    998787,
    898888,
    788988,
    889788,
    878886,
    877896,
    788789,
    867998,
    899898,
    899799,
    877789,
    788987,
    777688,
    887879,
    677788,
    878889,
    987776,
    897977,
    878988,
    878677,
    878998,
    697878,
    898668,
    777677,
    898778,
    896786,
    997778,
    887898,
    779677,
    888687,
    888987,
    899788,
    989887,
    977768,
    677766,
    978878,
    888868,
    999978,
    877799,
    867779,
    968899,
    879878,
    877979,
    988999,
    778898,
    777779,
    797888,
    978879,
    876997,
    888868,
    887677,
    878797,
    777978,
    866978,
    687987,
    987998,
    779688,
    877988,
    878889,
    998887,
    799776,
    898788,
    797886,
    988967,
    798988,
    878687,
    888787,
    777797,
    889877,
    888898,
    898886,
    888887,
    787988,
    996888,
    878779,
    789778,
    787887,
    898889,
    786788,
    688878,
    897777,
    888778,
    777799,
    899878,
    898878,
    787868,
    877787,
    888778,
    677767,
    788878,
    689898,
    978888,
    688778,
    778977,
    798778,
    887867,
    887767,
    877778,
    897878,
    988778,
    688787,
    777877,
    988878,
    789968,
    778987,
    769788,
    887978,
    878787,
    987689,
    788976,
    899688,
    989688,
    777699,
    878888,
    797788,
    778888,
    899888,
    799767,
    789878,
    988888,
    888777,
    788767,
    989688,
    888778,
    896777,
    888887,
    788889,
    787889,
    887899,
    978868,
    888978,
    988867,
    887788,
    688877,
    787867,
    898897,
    778698,
    787777,
    878887,
    888797,
    988877,
    798867,
    688688,
    797987,
    889898,
    777769,
    778797,
    889878,
    788988,
    679978,
    898988,
    777987,
    798777,
    887889,
    898887,
    789898,
    978788,
    879667,
    778888,
    778797,
    788786,
    798789,
    887988,
    877778,
    789799,
    877898,
    789787,
    787777,
    877879,
    778897,
    997977,
    789798,
    778787,
    788988,
    797877,
    898898,
    888897,
    887898,
    879878,
    888878,
    769879,
    787788,
    798788,
    778976,
    696698,
    898788,
    686778,
    789887,
    977796,
    986787,
    888877,
    778787,
    878678,
    698898,
    887989,
    987796,
    988767,
    797888,
    797778,
    898877,
    888888,
    678986,
    778797,
    798868,
    798987,
    999887,
    797779,
    778888,
    789778,
    987866,
    678787,
    888787,
    787777,
    997888,
    788879,
    978888,
    877687,
    668777,
    778777,
    777788,
    999878,
    997887,
    879688,
    987786,
    787897,
    879788,
    888679,
    978888,
    888887,
    787878,
    889678,
    889779,
    889778,
    778696,
    888987,
    788779,
    778668,
    779898,
    878889,
    869978,
    887888,
    979787,
    788788,
    798687,
    798778,
    688978,
    696867,
    978989,
    878688,
    988887,
    778687,
    769888,
    798887,
    988787,
    699798,
    888778,
    778799,
    788888,
    678767,
    768788,
    868988,
    888887,
    888888,
    878778,
    977888,
    798787,
    899769,
    678798,
    978798,
    897787,
    798878,
    677988,
    767777,
    797887,
    898779,
    887997,
    897787,
    886779,
    679989,
    889789,
    788878,
    687777,
    877889,
    897987,
    888988,
    878988,
    876899,
    978997,
    796887,
    989787,
    788887,
    789888,
    788987,
    988898,
    897886,
    898787,
    786789,
    778989,
    887677,
    888887,
    688897,
    887799,
    888889,
    999998,
    788689,
    787878,
    988677,
    787788,
    898987,
    978687,
    987687,
    897897,
    789787,
    899887,
    796878,
    986877,
    977979,
    879789,
    877998,
    788787,
    898678,
    868887,
    997967,
    898768,
    898878,
    886778,
    977997,
    678978,
    879897,
    889876,
    888776,
    766879,
    878997,
    877779,
    788678,
    798887,
    988778,
    979977,
    887878,
    867878,
    888887,
    888778,
    777989,
    977897,
    889887,
    697989,
    798788,
    878799,
    786787,
    877687,
    888778,
    767888,
    898868,
    978798,
    778686,
    889979,
    888887,
    786776,
    888967,
    988968,
    798989,
    877798,
    889789,
    889789,
    877898,
    688777,
    878878,
    988788,
    989887,
    898777,
    889787,
    787897,
    887868,
    898778,
    989897,
    898879,
    779979,
    778778,
    899877,
    779977,
    898789,
    898788,
    788887,
    899887,
    888778,
    899879,
    899788,
    789897,
    778687,
    888797,
    889787,
    788799,
    978898,
    868788,
    796897,
    877779,
    898788,
    977897,
    889789,
    876779,
    888898,
    878978,
    898887,
    888866,
    786977,
    696889,
    987979,
    969778,
    879878,
    799897,
    899788,
    777879,
    878898,
    788689,
    876979,
    988688,
    888768,
    898887,
    887877,
    888799,
    889889,
    789877,
    878787,
    779767,
    778889,
    689777,
    868989,
    889988,
    887788,
    887878,
    697887,
    798797,
    787778,
    787966,
    689987,
    976779,
    877889,
    887997,
    998777,
    879789,
    986897,
    777887,
    777877,
    888988,
    878897,
    877787,
    877987,
    897888,
    688976,
    879889,
    779888,
    997787,
    889887,
    876877,
    788777,
    878878,
    968987,
    889788,
    788888,
    877978,
    997778,
    797887,
    787997,
    877889,
    788869,
    876798,
    877879,
    888877,
    886898,
    797687,
    887887,
    788888,
    789798,
    679778,
    799997,
    886786,
    777798,
    677779,
    697888,
    888779,
    789878,
    877698,
    988788,
    878999,
    789779,
    797998,
    788888,
    869799,
    788978,
    877888,
    778898,
    899789,
    789699,
    787997,
    887987,
    887898,
    787787,
    979869,
    878986,
    868687,
    788887,
    778778,
    769888,
    787969,
    789798,
    877689,
    887676,
    977788,
    877998,
    999677,
    789888,
    879788,
    978789,
    777797,
    787668,
    787978,
    877789,
    977886,
    978678,
    877877,
    777689,
    997786,
    887888,
    778977,
    878888,
    788889,
    799866,
    879797,
    869887,
    878878,
    788789,
    887966,
    687778,
    988878,
    999698,
    877898,
    787888,
    888976,
    798887,
    687867,
    868987,
    778999,
    787779,
    767788,
    688878,
    988988,
    997777,
    768687,
    799788,
    788789,
    887897,
    787778,
    888788,
    778897,
    989799,
    687878,
    779978,
    789888,
    997878,
    977878,
    977879,
    788887,
    888877,
    877878,
    698889,
    988888,
    886768,
    788697,
    979777,
    789887,
    798996,
    888887,
    976769,
    778889,
    978888,
    778688,
    778878,
    977789,
    778799,
    787787,
    987878,
    868888,
    788978,
    987888,
    767787,
    888878,
    877989,
    889787,
    898799,
    868778,
    998889,
    778887,
    687997,
    887698,
    789889,
    698789,
    788887,
    797776,
    978689,
    779778,
    888897,
    798888,
    688787,
    779879,
    879887,
    888978,
    987878,
    699777,
    986887,
    767676,
    797886,
    787687,
    768989,
    987879,
    978898,
    997987,
    879888,
    989898,
    997998,
    998998,
    879978,
    697678,
    888778,
    878877,
    989789,
    999878,
    998878,
    899887,
    787889,
    888867,
    769878,
    898777,
    889878,
    886889,
    878789,
    787877,
    888898,
    878878,
    988888,
    786788,
    779889,
    778878,
    798687,
    998987,
    897889,
    898997,
    798877,
    779789,
    779977,
    877777,
    777877,
    888787,
    777888,
    988977,
    787889,
    889878,
    899679,
    887878,
    887777,
    989777,
    886997,
    999687,
    797787,
    788687,
    887988,
    897896,
    768799,
    878998,
    899879,
    787779,
    877776,
    778889,
    898787,
    787998,
    789787,
    877877,
    789978,
    878886,
    778987,
    877789,
    989889,
    887877,
    977898,
    798977,
    898988,
    697686,
    878987,
    789778,
    798878,
    986879,
    777888,
    887788,
    987889,
    867887,
    868978,
    888677,
    677788,
    788889,
    888879,
    899877,
    887877,
    797788,
    767676,
    769899,
    878799,
    679878,
    999788,
    799678,
    998879,
    989787,
    879788,
    888788,
    786688,
    989888,
    877687,
    877889,
    988987,
    986878,
    777689,
    878877,
    887878,
    887878,
    697688,
    778777,
    777897,
    988898,
    786789,
    889778,
    778899,
    787689,
    689787,
    879879,
    878888,
    888778,
    777876,
    799787,
    989798,
    888979,
    898799,
    788779,
    978878,
    877778,
    789898,
    787886,
    887787,
    898878,
    768888,
    789879,
    767878,
    698879,
    788777,
    678977,
    778997,
    887788,
    967887,
    788797,
    778987,
    979788,
    787878,
    796798,
    787799,
    879886,
    886878,
    988878,
    898768,
    887969,
    898768,
    797898,
    887779,
    899778,
    679887,
    687778,
    886977,
    897987,
    677899,
    778887,
    777898,
    888877,
    779868,
    898888,
    898777,
    776888,
    888799,
    777889,
    889768,
    769777,
    888788,
    979967,
    789998,
    777677,
    879876,
    889898,
    879886,
    797787,
    786787,
    899677,
    698887,
    979879,
    788788,
    877898,
    788979,
    889787,
    788787,
    688788,
    878788,
    987886,
    888987,
    888777,
    898886,
    778888,
    878777,
    777898,
    888687,
    888788,
    998887,
    786898,
    878887,
    888879,
    878878,
    877768,
    897796,
    778887,
    887787,
    888786,
    987779,
    886788,
    878796,
    978786,
    978987,
    887888,
    888797,
    786879,
    978887,
    899977,
    887887,
    778876,
    899889,
    688888,
    789998,
    699877,
    777987,
    898878,
    898997,
    788888,
    688999,
    887777,
    687987,
    978789,
    868978,
    878979,
    678887,
    788899,
    797869,
    687889,
    979788,
    778977,
    896886,
    789989,
    797789,
    786967,
    697887,
    987887,
    897886,
    887776,
    786877,
    787989,
    788878,
    787767,
    788777,
    877887,
    878887,
    887879,
    887977,
    798778,
    799887,
    887989,
    878797,
    687797,
    978988,
    768897,
    878779,
    987977,
    798897,
    798889,
    797888,
    787787,
    967978,
    976997,
    787987,
    879989,
    878887,
    799796,
    899979,
    877888,
    798788,
    779778,
    898878,
    888886,
    798878,
    898976,
    878867,
    788689,
    899877,
    678888,
    687988,
    789898,
    879876,
    977867,
    889777,
    767788,
    887968,
    678788,
    988899,
    877797,
    988788,
    878888,
    998879,
    788878,
    777897,
    988887,
    778987,
    878879,
    677868,
    799788,
    887976,
    778897,
    798889,
    887899,
    898888,
    789888,
    787877,
    788887,
    787676,
    887788,
    887967,
    988687,
    888887,
    786887,
    888868,
    778678,
    778889,
    789678,
    778888,
    797898,
    998867,
    778778,
    777978,
    798778,
    878797,
    988977,
    987889,
    788878,
    888878,
    986788,
    897899,
    787877,
    978777,
    986978,
    878877,
    787777,
    779877,
    788978,
    798888,
    998889,
    898987,
    978898,
    987869,
    897887,
    789797,
    788978,
    877878,
    768788,
    878888,
    686899,
    977887,
    887886,
    887878,
    887987,
    796777,
    989888,
    699978,
    777888,
    987978,
    797768,
    887787,
    977979,
    798899,
    777878,
    888878,
    987777,
    878878,
    788688,
    888799,
    897889,
    989887,
    886896,
    888988,
    888789,
    988878,
    878789,
    877787,
    997889,
    778997,
    788988,
    889987,
    968867,
    797868,
    998887,
    989988,
    997979,
    897787,
    667878,
    877777,
    887879,
    878778,
    787977,
    787798,
    888977,
    987888,
    996989,
    997798,
    868888,
    998888,
    777776,
    987798,
    697878,
    988879,
    878777,
    898788,
    877768,
    889987,
    778988,
    797898,
    877786,
    678799,
    887887,
    779787,
    877798,
    878789,
    688789,
    768888,
    898777,
    877776,
    866898,
    977779,
    887988,
    687866,
    779697,
    788786,
    889689,
    866976,
    786697,
    689977,
    978776,
    888788,
    878778,
    988767,
    698878,
    988687,
    788788,
    888878,
    888786,
    689789,
    878777,
    879978,
    877877,
    787867,
    968779,
    898877,
    887789,
    898898,
    879879,
    688977,
    888888,
    868777,
    686986,
    779897,
    788888,
    798776,
    679979,
    678868,
    787777,
    977888,
    678788,
    889768,
    698888,
    767878,
    697787,
    888879,
    778988,
    887888,
    798788,
    777786,
    987676,
    877789,
    887887,
    678898,
    798988,
    878888,
    768778,
    767988,
    898797,
    886889,
    879878,
    989878,
    677788,
    778887,
    889888,
    998789,
    788887,
    788988,
    988688,
    778767,
    787978,
    887778,
    887878,
    888878,
    789777,
    779968,
    887777,
    989787,
    778868,
    997677,
    889767,
    888888,
    877868,
    988678,
    898887,
    887978,
    786889,
    898988,
    888988,
    997678,
    786867,
    877699,
    987977,
    887777,
    988888,
    879868,
    787898,
    797987,
    769988,
    887877,
    688767,
    869798,
    788887,
    879789,
    889888,
    789979,
    878888,
    798888,
    888789,
    687778,
    897888,
    979788,
    668788,
    897978,
    787877,
    878697,
    878877,
    786777,
    878898,
    888898,
    798986,
    887987,
    987888,
    877967,
    788977,
    997998,
    767877,
    678877,
    879987,
    798787,
    888777,
    778787,
    977878,
    878897,
    798979,
    988799,
    888997,
    787798,
    768977,
    878888,
    789787,
    868789,
    879788,
    988779,
    778889,
    897986,
    788878,
    888898,
    877888,
    876969,
    777989,
    789798,
    878977,
    888888,
    977976,
    878887,
    879878,
    788878,
    877999,
    878877,
    778768,
    788778,
    799988,
    967897,
    779889,
    967978,
    777889,
    877779,
    788888,
    887987,
    987977,
    877787,
    878996,
    778878,
    788886,
    968876,
    896887,
    878978,
    789777,
    977888,
    688897,
    887998,
    799886,
    989886,
    999968,
    779778,
    798869,
    989778,
    887788,
    898888,
    777878,
    979677,
    988787,
    978878,
    688778,
    988887,
    698969,
    899879,
    778877,
    888688,
    888988,
    899998,
    889877,
    879876,
    898878,
    878787,
    886789,
    777987,
    687887,
    786789,
    867988,
    679898,
    798796,
    878788,
    888777,
    997877,
    977898,
    678779,
    978888,
    687677,
    889997,
    878688,
    887888,
    878889,
    987698,
    799888,
    988868,
    898679,
    886787,
    888888,
    978797,
    877977,
    678997,
    998767,
    876879,
    878778,
    989798,
    998888,
    877779,
    887888,
    898688,
    766786,
    977697,
    988887,
    897998,
    778788,
    878789,
    888889,
    878778,
    888978,
    888977,
    887787,
    878997,
    877887,
    987878,
    989888,
    897788,
    689887,
    978998,
    877788,
    979898,
    779977,
    879879,
    788876,
    887777,
    688776,
    898887,
    779989,
    889968,
    977788,
    888888,
    877776,
    788779,
    676677,
    887778,
    897888,
    879786,
    778879,
    888798,
    989888,
    868767,
    889787,
    888878,
    888887,
    897867,
    797797,
    888967,
    986977,
    878968,
    977886,
    999877,
    878698,
    877799,
    678988,
    879998,
    977867,
    877878,
    879799,
    788889,
    778698,
    978799,
    777688,
    986798,
    789788,
    899767,
    776898,
    999777,
    787879,
    788888,
    887988,
    888898,
    978898,
    788778,
    897989,
    688778,
    879879,
    778988,
    677787,
    877778,
    898678,
    788888,
    978798,
    797889,
    779698,
    978999,
    887887,
    899897,
    877867,
    988787,
    868887,
    988978,
    779888,
    778978,
    876889,
    787888,
    988868,
    788787,
    977878,
    899799,
    887888,
    878777,
    789989,
    798978,
    798878,
    779877,
    888896,
    879877,
    877988,
    997888,
    878889,
    788968,
    777888,
    977889,
    979968,
    898988,
    878879,
    899888,
    887798,
    988888,
    678787,
    887797,
    988797,
    898977,
    888887,
    978989,
    688887,
    869877,
    888788,
    876977,
    777789,
    788988,
    987968,
    888898,
    878989,
    777788,
    988689,
    787879,
    877778,
    889997,
    767778,
    779888,
    888778,
    866798,
    877879,
    898778,
    778887,
    878777,
    997768,
    787888,
    789898,
    779987,
    887888,
    868798,
    879888,
    897887,
    896777,
    978988,
    788978,
    688887,
    798799,
    878798,
    897677,
    889877,
    897987,
    976879,
    899878,
    777876,
    776778,
    787879,
    999778,
    887876,
    687788,
    789978,
    988987,
    697787,
    679669,
    887789,
    788879,
    898897,
    989898,
    887888,
    789799,
    898788,
    787777,
    998986,
    779878,
    979878,
    978886,
    988877,
    787878,
    786867,
    798999,
    887987,
    879778,
    987888,
    986888,
    788999,
    788778,
    787978,
    887799,
    887878,
    787897,
    877787,
    878889,
    998888,
    988899,
    887888,
    888878,
    879788,
    888788,
    987779,
    778987,
    777877,
    777977,
    787877,
    888886,
    879878,
    889877,
    988888,
    878877,
    788977,
    988978,
    989868,
    798688,
    667998,
    877887,
    899788,
    788768,
    788697,
    999888,
    978789,
    768788,
    887779,
    777788,
    888977,
    788778,
    687778,
    876669,
    997787,
    788997,
    888988,
    888888,
    889798,
    989897,
    687899,
    878667,
    987878,
    778878,
    888998,
    897877,
    778979,
    978879,
    889988,
    878886,
    778788,
    878698,
    989888,
    887887,
    798887,
    878887,
    768787,
    777888,
    987877,
    897988,
    888878,
    889888,
    888777,
    988788,
    898678,
    999779,
    778786,
    977888,
    888789,
    977977,
    697877,
    978889,
    788978,
    978777,
    677899,
    987887,
    978797,
    887867,
    789889,
    898889,
    788869,
    987888,
    877886,
    988787,
    988887,
    787998,
    986689,
    889996,
    969677,
    767887,
    886778,
    798879,
    897788,
    699888,
    888889,
    778878,
    888789,
    888998,
    967997,
    887789,
    898989,
    898888,
    898888,
    798769,
    779878,
    879896,
    788987,
    888877,
    888997,
    978988,
    777868,
    779967,
    877988,
    886688,
    988899,
    889888,
    797888,
    796788,
    898787,
    988779,
    788979,
    787886,
    988998,
    987877,
    669988,
    777888,
    778978,
    997788,
    678787,
    889868,
    888998,
    878967,
    888798,
    889879,
    768869,
    888878,
    978899,
    787898,
    878978,
    998777,
    886977,
    788799,
    878989,
    788988,
    886887,
    899877,
    787878,
    886778,
    777878,
    778786,
    878879,
    978977,
    977788,
    878788,
    887777,
    878888,
    776999,
    987688,
    879889,
    788879,
    886988,
    979897,
    887888,
    798787,
    799778,
    777797,
    979886,
    888888,
    689879,
    678898,
    978687,
    766879,
    699988,
    798886,
    666888,
    798778,
    879779,
    976699,
    887777,
    877968,
    887888,
    678678,
    988888,
    878788,
    876988,
    978787,
    777768,
    799889,
    887888,
    899886,
    987887,
    888878,
    979988,
    777979,
    887988,
    786988,
    989799,
    777887,
    878878,
    889778,
    977868,
    889978,
    988778,
    778789,
    977888,
    977777,
    777979,
    886987,
    998878,
    886987,
    778897,
    989788,
    878897,
    878789,
    887889,
    878988,
    967897,
    768788,
    978898,
    688889,
    989879,
    889897,
    987888,
    789788,
    798998,
    989878,
    696797,
    788787,
    868777,
    996777,
    679899,
    888986,
    787888,
    876777,
    888888,
    999787,
    887998,
    976968,
    796877,
    878787,
    888887,
    679998,
    879889,
    888886,
    768878,
    798978,
    889879,
    888999,
    886798,
    888877,
    787988,
    799888,
    897687,
    788878,
    989998,
    967787,
    977798,
    768878,
    997986,
    688987,
    777797,
    788986,
    787989,
    788689,
    977997,
    768887,
    699878,
    899878,
    777888,
    888867,
    777977,
    878877,
    778788,
    888967,
    778897,
    787766,
    889668,
    788776,
    788888,
    887789,
    978697,
    777888,
    788998,
    778788,
    878897,
    888787,
    877779,
    887878,
    876887,
    688868,
    877789,
    887989,
    788678,
    888687,
    779786,
    999687,
    789889,
    789877,
    876798,
    888987,
    789767,
    877888,
    877878,
    877988,
    788879,
    867897,
    887989,
    878987,
    878777,
    988988,
    778877,
    877798,
    779787,
    899998,
    796797,
    878779,
    777896,
    977788,
    678888,
    897769,
    987889,
    788987,
    688889,
    977886,
    966787,
    968788,
    878978,
    778798,
    977967,
    778789,
    888769,
    887889,
    787887,
    768777,
    879797,
    778688,
    977788,
    979878,
    786887,
    888788,
    778768,
    989997,
    789688,
    887877,
    978897,
    677898,
    987989,
    687888,
    787788,
    877997,
    988889,
    777788,
    778887,
    777778,
    887788,
    788898,
    879797,
    987878,
    897888,
    788778,
    898879,
    789888,
    888887,
    887778,
    797988,
    777887,
    899978,
    988698,
    778887,
    969878,
    886877,
    788968,
    889788,
    889888,
    878678,
    887778,
    789787,
    969888,
    977879,
    899988,
    789788,
    898787,
    888788,
    797898,
    777868,
    897688,
    767879,
    889998,
    778889,
    897687,
    877779,
    777977,
    968788,
    778788,
    897799,
    789787,
    898776,
    778898,
    789988,
    888899,
    878887,
    778877,
    999777,
    988987,
    878779,
    878796,
    898778,
    888777,
    778778,
    768889,
    787887,
    978889,
    889989,
    878887,
    889869,
    877778,
    898779,
    867678,
    997996,
    999867,
    888978,
    869886,
    788677,
    898688,
    786987,
    788876,
    887779,
    799898,
    787877,
    977899,
    767976,
    888898,
    877879,
    777789,
    787878,
    987788,
    677688,
    978898,
    898787,
    988789,
    778998,
    898877,
    799886,
    987877,
    688887,
    697878,
    779888,
    899778,
    897988,
    799789,
    889869,
    778888,
    777868,
    888888,
    877988,
    888978,
    976897,
    988978,
    988887,
    778877,
    899789,
    677877,
    877768,
    898786,
    988897,
    778889,
    978888,
    978887,
    788877,
    977777,
    868778,
    896997,
    887888,
    779689,
    979788,
    878977,
    888977,
    797888,
    778878,
    689888,
    978998,
    778877,
    878889,
    988679,
    878878,
    898997,
    788899,
    778888,
    977979,
    878898,
    899779,
    879986,
    776898,
    687768,
    787898,
    899677,
    878788,
    878788,
    889998,
    787878,
    879999,
    878886,
    688868,
    879877,
    797999,
    887897,
    998998,
    687778,
    688888,
    978869,
    977876,
    987777,
    787786,
    878778,
    899869,
    788789,
    678986,
    879888,
    898879,
    798887,
    798897,
    899877,
    899879,
    799778,
    898788,
    888798,
    788798,
    898898,
    899977,
    898968,
    776877,
    998788,
    788897,
    988978,
    779898,
    998978,
    778876,
    768789,
    788889,
    768698,
    686797,
    778977,
    989888,
    998789,
    876768,
    878999,
    966688,
    687797,
    768788,
    877777,
    887787,
    698787,
    878887,
    878876,
    797779,
    877999,
    789778,
    888888,
    879998,
    798899,
    889886,
    967987,
    999979,
    987898,
    687989,
    787887,
    786878,
    898889,
    698887,
    888999,
    799898,
    898777,
    788878,
    778988,
    867867,
    788798,
    678877,
    788877,
    997986,
    898868,
    788779,
    888777,
    888887,
    878987,
    878888,
    869979,
    877879,
    888877,
    887888,
    879797,
    799878,
    789889,
    789888,
    877797,
    788778,
    698797,
    979986,
    886888,
    678787,
    878796,
    786886,
    877877,
    788899,
    868777,
    889779,
    788879,
    798978,
    677789,
    966877,
    899888,
    768797,
    877788,
    998788,
    878888,
    788887,
    887888,
    777997,
    888997,
    777879,
    878788,
    888989,
    868788,
    798778,
    968888,
    787977,
    877677,
    798797,
    786888,
    779887,
    987878,
    888988,
    788989,
    787777,
    977898,
    788786,
    877889,
    686668,
    877898,
    877897,
    876878,
    788778,
    988776,
    967878,
    889898,
    877789,
    968777,
    688688,
    779788,
    878888,
    886877,
    988998,
    978979,
    778778,
    878789,
    898986,
    787897,
    687887,
    868988,
    896998,
    887888,
    878888,
    887779,
    998897,
    988787,
    867979,
    668878,
    778988,
    789668,
    789877,
    899787,
    779698,
    799877,
    777987,
    977998,
    788689,
    868879,
    987788,
    979898,
    789998,
    887887,
    876878,
    887986,
    879989,
    888889,
    987888,
    886887,
    888868,
    697899,
    978896,
    888888,
    889889,
    867888,
    698787,
    787878,
    789789,
    788877,
    869988,
    898798,
    988898,
    878689,
    897788,
    878788,
    888887,
    767877,
    779679,
    978887,
    978899,
    778799,
    886977,
    888898,
    889878,
    889879,
    878878,
    889877,
    787888,
    879998,
    799967,
    777797,
    789878,
    977788,
    877878,
    797867,
    979888,
    878778,
    888798,
    888789,
    889687,
    788778,
    777777,
    998778,
    786898,
    898879,
    778979,
    897877,
    988788,
    989869,
    879899,
    878798,
    887966,
    797988,
    988688,
    979676,
    788778,
    997769,
    788889,
    677799,
    797787,
    778988,
    878978,
    799788,
    879887,
    777988,
    967778,
    778788,
    887897,
    987877,
    869879,
    888787,
    877789,
    779787,
    788697,
    878887,
    889788,
    897879,
    779798,
    989877,
    987877,
    777788,
    878977,
    897889,
    788786,
    877988,
    987887,
    888888,
    877887,
    898778,
    879798,
    788689,
    688777,
    788877,
    888767,
    776887,
    998797,
    896787,
    779889,
    897788,
    967777,
    778978,
    887977,
    887798,
    898787,
    898878,
    779787,
    687788,
    798888,
    788898,
    778889,
    779778,
    798977,
    989988,
    787867,
    788998,
    997787,
    778787,
    886988,
    767887,
    798878,
    797777,
    977897,
    888898,
    888897,
    886788,
    877888,
    778889,
    888988,
    899888,
    677897,
    799877,
    877798,
    886887,
    877996,
    987886,
    778798,
    788878,
    989987,
    878797,
    899797,
    878877,
    887797,
    788888,
    678899,
    988887,
    887887,
    878787,
    679888,
    889787,
    798877,
    788987,
    998869,
    986978,
    896988,
    888986,
    869788,
    988877,
    798887,
    787788,
    777889,
    877978,
    967788,
    879898,
    988986,
    899897,
    887878,
    897788,
    887967,
    897877,
    787779,
    867876,
    888978,
    677898,
    978798,
    788687,
    879787,
    887977,
    888886,
    866887,
    987788,
    778898,
    889766,
    787887,
    798888,
    688876,
    989787,
    797779,
    999989,
    789986,
    778779,
    888987,
    877878,
    788789,
    887896,
    788978,
    878889,
    897899,
    878767,
    878776,
    777869,
    877888,
    988788,
    797879,
    789888,
    979888,
    787888,
    786788,
    777797,
    888778,
    776877,
    878677,
    687798,
    786977,
    789778,
    887778,
    797979,
    976887,
    887988,
    889767,
    887898,
    698779,
    787887,
    868776,
    788888,
    789898,
    897788,
    788978,
    879889,
    988787,
    788897,
    698896,
    797878,
    877878,
    888778,
    878779,
    878988,
    778888,
    777779,
    876779,
    787888,
    987796,
    779888,
    787987,
    888898,
    988897,
    887798,
    797887,
    777989,
    889898,
    799888,
    788898,
    888769,
    787898,
    878977,
    869887,
    767886,
    886777,
    879887,
    998788,
    687897,
    687879,
    988788,
    878787,
    789788,
    779988,
    788998,
    788799,
    897787,
    797878,
    877787,
    877897,
    888798,
    988886,
    797966,
    868679,
    889878,
    888788,
    777889,
    887888,
    798989,
    897898,
    998988,
    888998,
    878878,
    877889,
    777778,
    967977,
    789789,
    788798,
    798968,
    989697,
    788867,
    788999,
    777798,
    998886,
    778888,
    898787,
    776987,
    878889,
    897888,
    787878,
    778666,
    789789,
    887877,
    898878,
    889988,
    797887,
    898788,
    898799,
    889877,
    877889,
    688887,
    898879,
    888886,
    889887,
    889887,
    899978,
    797987,
    897798,
    779879,
    876988,
    787877,
    798797,
    887889,
    787777,
    788898,
    769767,
    887886,
    797977,
    888898,
    889797,
    778899,
    897686,
    977899,
    798886,
    988979,
    777887,
    879798,
    787887,
    898997,
    979898,
    877967,
    889878,
    978998,
    778888,
    678978,
    979989,
    997878,
    977877,
    987668,
    879887,
    888888,
    977798,
    977897,
    978878,
    876876,
    689879,
    978977,
    878888,
    887879,
    887779,
    789988,
    667867,
    889798,
    697786,
    777888,
    879787,
    788869,
    887877,
    677779,
    877878,
    687998,
    888787,
    788897,
    678787,
    897979,
    768788,
    799789,
    868778,
    887977,
    979677,
    888898,
    988778,
    766878,
    878797,
    879989,
    976799,
    898797,
    888879,
    877987,
    788798,
    798989,
    889878,
    887776,
    687877,
    877696,
    667988,
    978697,
    788897,
    878878,
    787999,
    668699,
    878867,
    787778,
    897898,
    889979,
    777778,
    788987,
    878787,
    878876,
    787888,
    787889,
    968788,
    788698,
    778778,
    887897,
    979998,
    977897,
    889987,
    787777,
    768888,
    877769,
    988768,
    797798,
    978787,
    987688,
    888787,
    898977,
    687687,
    977898,
    778897,
    888889,
    787786,
    686877,
    978978,
    888788,
    889788,
    867678,
    886996,
    787988,
    877787,
    878788,
    899988,
    798787,
    899778,
    888888,
    867777,
    968879,
    877797,
    887877,
    788789,
    776766,
    887997,
    879698,
    787787,
    867998,
    779687,
    978886,
    779778,
    877788,
    976977,
    888677,
    877879,
    787889,
    869978,
    877688,
    879778,
    878687,
    988877,
    989779,
    779797,
    897977,
    777978,
    878987,
    887889,
    778887,
    977877,
    887889,
    777787,
    688876,
    978899,
    899878,
    988867,
    888878,
    889788,
    988888,
    969778,
    888878,
    787889,
    698788,
    887879,
    887799,
    787797,
    898978,
    889868,
    777977,
    968889,
    888877,
    778986,
    877797,
    789877,
    887689,
    977798,
    788888,
    989787,
    798788,
    888977,
    678777,
    879688,
    888979,
    979886,
    888878,
    879887,
    989879,
    778787,
    976877,
    789889,
    888698,
    889779,
    898888,
    888978,
    987898,
    889779,
    996888,
    899778,
    878997,
    787988,
    777786,
    898788,
    788989,
    997987,
    877899,
    877789,
    998787,
    897789,
    898988,
    886888,
    788877,
    889798,
    677898,
    877878,
    889967,
    899787,
    887876,
    988898,
    887789,
    878888,
    896687,
    899889,
    778877,
    777768,
    778898,
    988889,
    687887,
    799896,
    897897,
    787888,
    788787,
    788999,
    788979,
    888788,
    988876,
    878898,
    887887,
    998979,
    987789,
    689898,
    678768,
    877986,
    778898,
    778987,
    788778,
    887879,
    898788,
    876779,
    678778,
    777689,
    878778,
    897977,
    888787,
    977976,
    988878,
    997888,
    887877,
    887987,
    779988,
    986777,
    798788,
    887776,
    888797,
    878787,
    787788,
    767867,
    787887,
    897887,
    777889,
    978787,
    887798,
    779987,
    888888,
    788889,
    797898,
    967898,
    888898,
    779989,
    799778,
    698896,
    988887,
    888788,
    889898,
    888889,
    988888,
    787978,
    898978,
    788788,
    889798,
    988897,
    777778,
    887789,
    698788,
    798779,
    787797,
    888888,
    878679,
    788786,
    877987,
    788766,
    787777,
    868889,
    887777,
    776787,
    888679,
    878678,
    799887,
    778877,
    786798,
    878897,
    888797,
    676879,
    988878,
    797787,
    699879,
    867797,
    988887,
    979988,
    876897,
    797789,
    768798,
    787879,
    898888,
    889899,
    888667,
    997888,
    778979,
    987889,
    687777,
    778689,
    687887,
    889887,
    798787,
    877868,
    988877,
    889779,
    888879,
    788789,
    777899,
    778978,
    777968,
    889888,
    688888,
    898878,
    999887,
    888888,
    778998,
    877888,
    776777,
    886788,
    887678,
    888788,
    787887,
    797999,
    798777,
    877777,
    799877,
    987877,
    887678,
    887978,
    867889,
    779779,
    987766,
    978968,
    778878,
    998789,
    888767,
    888798,
    688988,
    688898,
    969888,
    798798,
    788898,
    789987,
    777888,
    779697,
    688879,
    878877,
    888779,
    889879,
    987878,
    777888,
    887797,
    888988,
    988879,
    896877,
    698787,
    678997,
    788976,
    687877,
    787877,
    889796,
    889798,
    977787,
    689987,
    776987,
    887666,
    989888,
    999878,
    888778,
    997899,
    888789,
    977787,
    888797,
    778897,
    897798,
    887899,
    777666,
    777877,
    777878,
    787888,
    788889,
    788879,
    788788,
    998887,
    887887,
    788977,
    778666,
    986777,
    889968,
    898786,
    998887,
    987788,
    988978,
    989788,
    878788,
    888867,
    796898,
    999979,
    788989,
    776866,
    886877,
    768889,
    988887,
    877788,
    977979,
    898897,
    888796,
    789797,
    787788,
    787898,
    778897,
    788788,
    787777,
    977778,
    777879,
    888776,
    788789,
    988978,
    878898,
    778988,
    989796,
    697799,
    899897,
    878978,
    789878,
    988899,
    989998,
    897878,
    679878,
    889878,
    769879,
    876798,
    889787,
    778788,
    998787,
    787778,
    887977,
    878768,
    877778,
    876978,
    998888,
    987789,
    778887,
    798687,
    896897,
    878998,
    688799,
    988787,
    778878,
    789898,
    877888,
    879788,
    987789,
    879889,
    878988,
    978977,
    778687,
    889987,
    886889,
    898888,
    899878,
    967878,
    788788,
    878688,
    968796,
    786798,
    988669,
    789887,
    978788,
    988878,
    798977,
    798667,
    778888,
    978987,
    987877,
    788798,
    879687,
    788687,
    788788,
    798878,
    878778,
    678888,
    777768,
    787978,
    777798,
    797787,
    788779,
    897898,
    989988,
    889879,
    877998,
    788678,
    979677,
    778787,
    679777,
    987978,
    988788,
    987787,
    988889,
    879897,
    896777,
    788877,
    777876,
    889878,
    898888,
    889788,
    997699,
    878799,
    789889,
    676878,
    888777,
    886997,
    787877,
    788978,
    977788,
    797797,
    998877,
    877786,
    987697,
    968998,
    797788,
    888989,
    688789,
    887798,
    888889,
    698889,
    998888,
    978977,
    898896,
    888787,
    998777,
    787886,
    888688,
    687978,
    978787,
    777798,
    877777,
    888877,
    797966,
    788679,
    878788,
    798868,
    899798,
    788987,
    687988,
    698888,
    868869,
    869777,
    798788,
    889898,
    888888,
    899799,
    889779,
    979888,
    877798,
    888888,
    877878,
    988878,
    889887,
    987777,
    977869,
    986678,
    998988,
    768887,
    787969,
    997889,
    887886,
    788878,
    788898,
    888887,
    697798,
    877779,
    889788,
    979797,
    788789,
    887979,
    889888,
    898898,
    767889,
    888879,
    789887,
    789988,
    887798,
    878788,
    788887,
    697887,
    879779,
    888999,
    988678,
    788887,
    878878,
    998878,
    897786,
    788698,
    988999,
    878887,
    776889,
    877988,
    767887,
    978989,
    898979,
    978687,
    896868,
    698766,
    899997,
    988778,
    888977,
    678779,
    798787,
    677787,
    788888,
    877878,
    879788,
    897799,
    976877,
    879998,
    886879,
    879878,
    878786,
    897887,
    779788,
    987988,
    978788,
    897896,
    878698,
    899788,
    988668,
    887779,
    797889,
    789877,
    867977,
    977888,
    777989,
    779877,
    799778,
    786879,
    887878,
    889967,
    778887,
    886999,
    869979,
    697688,
    878888,
    887888,
    878877,
    977987,
    787779,
    988968,
    998778,
    777787,
    977888,
    877889,
    667697,
    778877,
    978968,
    798787,
    889889,
    898878,
    679878,
    888978,
    766988,
    686786,
    787788,
    876799,
    877987,
    799778,
    878669,
    798788,
    869788,
    877788,
    888879,
    989788,
    898778,
    977798,
    988786,
    889887,
    887779,
    989677,
    897888,
    876998,
    989888,
    878778,
    878979,
    697778,
    889778,
    979778,
    786888,
    799886,
    788876,
    888888,
    897888,
    988778,
    877887,
    878778,
    889878,
    697977,
    988889,
    788788,
    898786,
    989687,
    887869,
    888898,
    898888,
    879899,
    888698,
    887877,
    877888,
    876889,
    787777,
    789777,
    898887,
    789778,
    768878,
    788967,
    879989,
    899779,
    677789,
    878878,
    986888,
    877779,
    989777,
    988887,
    778789,
    787796,
    797989,
    789877,
    786999,
    798899,
    798978,
    887878,
    776777,
    888888,
    886677,
    987997,
    787787,
    797888,
    889888,
    877987,
    987996,
    877888,
    778887,
    778887,
    878988,
    789779,
    798879,
    787898,
    888887,
    968888,
    788769,
    877887,
    878887,
    797768,
    887987,
    987986,
    899877,
    788888,
    999978,
    887888,
    898897,
    877777,
    899697,
    798977,
    887798,
    867987,
    876988,
    788878,
    968787,
    988879,
    698878,
    779987,
    998888,
    787889,
    899788,
    779877,
    768787,
    787888,
    798988,
    977987,
    977789,
    966878,
    998798,
    778989,
    888887,
    799688,
    769778,
    787868,
    799798,
    888877,
    877789,
    887987,
    878988,
    778897,
    888977,
    888786,
    878987,
    788977,
    988898,
    797788,
    879998,
    778687,
    678879,
    777787,
    879898,
    978778,
    779896,
    688989,
    877879,
    878787,
    779878,
    887788,
    889779,
    887878,
    878778,
    898876,
    788776,
    978888,
    788887,
    698978,
    878797,
    867869,
    787897,
    789977,
    787888,
    788878,
    877978,
    887988,
    998886,
    888878,
    888887,
    868888,
    888887,
    978797,
    788878,
    777699,
    778687,
    867789,
    888789,
    788988,
    798979,
    788888,
    779788,
    888788,
    988689,
    878997,
    786788,
    697889,
    897987,
    777978,
    888798,
    888787,
    888697,
    777799,
    788888,
    877788,
    899789,
    988768,
    788776,
    888887,
    888787,
    776699,
    988978,
    887978,
    976797,
    886889,
    878878,
    677896,
    768697,
    996777,
    688798,
    979786,
    999988,
    988988,
    878798,
    877899,
    888888,
    778877,
    799689,
    886788,
    798787,
    887876,
    789689,
    877898,
    888979,
    797889,
    887897,
    779887,
    978988,
    877888,
    877878,
    677787,
    887897,
    678878,
    869868,
    778989,
    767887,
    978879,
    687788,
    878888,
    769799,
    889887,
    888786,
    698979,
    988788,
    897897,
    897978,
    668789,
    787978,
    997988,
    979878,
    887887,
    887787,
    679798,
    777897,
    878779,
    899897,
    888689,
    787977,
    877789,
    887698,
    988887,
    987896,
    788787,
    888876,
    897886,
    888788,
    998988,
    678987,
    879889,
    878879,
    778878,
    868888,
    987978,
    897888,
    879887,
    779697,
    987988,
    888878,
    888777,
    878868,
    798878,
    787877,
    998898,
    788778,
    867869,
    998988,
    877788,
    889868,
    787777,
    789889,
    788897,
    787876,
    867787,
    978876,
    797789,
    897878,
    787888,
    779788,
    887787,
    879978,
    787988,
    887876,
    797888,
    888878,
    787786,
    898767,
    888788,
    789977,
    778976,
    786787,
    887987,
    678888,
    788868,
    888879,
    889988,
    788897,
    987787,
    779777,
    868878,
    887689,
    678877,
    867877,
    877878,
    988878,
    877788,
    899687,
    878778,
    788877,
    788777,
    787888,
    978897,
    688867,
    889987,
    688878,
    989698,
    778979,
    988966,
    768997,
    778877,
    889977,
    678887,
    899977,
    977778,
    989988,
    798978,
    777986,
    888868,
    987879,
    878888,
    786798,
    879978,
    798887,
    986898,
    788878,
    999889,
    789887,
    978878,
    998777,
    978799,
    878887,
    798987,
    969879,
    787798,
    788898,
    868779,
    878987,
    777688,
    788878,
    787777,
    987787,
    978889,
    998778,
    869979,
    788878,
    789889,
    877777,
    788999,
    879889,
    768778,
    979976,
    897779,
    887977,
    877978,
    786777,
    878878,
    878888,
    899778,
    687789,
    899696,
    769798,
    889987,
    877888,
    797887,
    899787,
    987879,
    897877,
    787879,
    887798,
    796788,
    877877,
    798976,
    778778,
    968789,
    778796,
    778898,
    788877,
    968697,
    688877,
    687888,
    699697,
    887898,
    868869,
    797767,
    867779,
    887977,
    889777,
    999788,
    987687,
    879988,
    788877,
    779878,
    889878,
    887799,
    888777,
    978879,
    796778,
    796889,
    879979,
    789879,
    789797,
    888688,
    789897,
    787889,
    878886,
    999788,
    796897,
    788889,
    878878,
    868879,
    988877,
    778677,
    888877,
    777767,
    778789,
    977977,
    798889,
    976788,
    877888,
    978879,
    877797,
    798889,
    887877,
    686998,
    778768,
    898778,
    778788,
    897789,
    888776,
    988878,
    778888,
    878698,
    767888,
    988689,
    788897,
    796978,
    789788,
    777796,
    787788,
    866997,
    769897,
    879898,
    877887,
    777789,
    798779,
    689889,
    688778,
    888777,
    877977,
    898786,
    899887,
    777787,
    787986,
    877889,
    777676,
    886987,
    887879,
    697897,
    978798,
    987977,
    788897,
    987896,
    898879,
    868887,
    878978,
    888877,
    786987,
    897777,
    977978,
    788977,
    778888,
    887988,
    788888,
    878988,
    887887,
    987978,
    879788,
    877877,
    997988,
    888886,
    697878,
    989788,
    997778,
    889999,
    796899,
    677687,
    778887,
    687689,
    799888,
    988788,
    868887,
    788878,
    878968,
    868988,
    779668,
    887797,
    877678,
    987878,
    668887,
    777987,
    987997,
    769889,
    988778,
    877879,
    889776,
    888887,
    888888,
    979879,
    799768,
    897778,
    697988,
    789787,
    977878,
    889897,
    877778,
    898978,
    878777,
    877778,
    898887,
    889888,
    677787,
    977879,
    878789,
    889879,
    979787,
    888987,
    987677,
    879869,
    877898,
    877878,
    989997,
    778897,
    888898,
    798677,
    887898,
    877888,
    879889,
    889878,
    798887,
    989887,
    789988,
    688796,
    779788,
    878988,
    779987,
    968969,
    789887,
    889868,
    778878,
    788888,
    788798,
    877689,
    787786,
    878888,
    888797,
    778867,
    788698,
    777879,
    887778,
    977787,
    798887,
    888897,
    788877,
    887778,
    897976,
    698887,
    887776,
    889777,
    977878,
    778687,
    989968,
    977978,
    789887,
    798787,
    888886,
    888879,
    878998,
    869667,
    987989,
    698867,
    988888,
    879888,
    887898,
    996889,
    898888,
    887868,
    788778,
    778877,
    867966,
    777977,
    878988,
    888879,
    677877,
    877787,
    869787,
    678688,
    897789,
    887777,
    866787,
    787778,
    977779,
    787886,
    887988,
    799779,
    889878,
    877888,
    797878,
    998798,
    888878,
    899788,
    978787,
    769888,
    786877,
    768787,
    798886,
    899879,
    798978,
    769888,
    799788,
    677897,
    877798,
    669897,
    688988,
    898777,
    888888,
    777876,
    899878,
    668988,
    888788,
    778887,
    798788,
    789897,
    768888,
    887787,
    778877,
    987889,
    977977,
    788779,
    777867,
    879789,
    778778,
    878766,
    787897,
    988888,
    896887,
    786897,
    878977,
    887979,
    797879,
    888888,
    866788,
    889789,
    688678,
    788978,
    788988,
    898687,
    888778,
    787879,
    678778,
    888897,
    978897,
    978776,
    887998,
    978779,
    968869,
    977779,
    778899,
    798876,
    989799,
    787899,
    798997,
    987886,
    778789,
    867978,
    886888,
    978778,
    777777,
    698889,
    967897,
    788688,
    988799,
    988797,
    868778,
    787779,
    778778,
    798787,
    996867,
    886698,
    898887,
    868788,
    788769,
    998887,
    787877,
    897978,
    888879,
    978687,
    678877,
    867897,
    988888,
    898788,
    877979,
    988877,
    888789,
    978999,
    888887,
    998777,
    987887,
    878788,
    887899,
    999987,
    977997,
    787867,
    896877,
    888878,
    996768,
    766788,
    778877,
    787878,
    887787,
    769777,
    997688,
    797879,
    798887,
    798778,
    978878,
    887678,
    998887,
    879998,
    788787,
    898688,
    888967,
    868688,
    987899,
    888688,
    776899,
    998698,
    886887,
    997999,
    788789,
    798998,
    898689,
    787888,
    866786,
    888787,
    768989,
    677987,
    768979,
    877876,
    877788,
    877797,
    879789,
    676698,
    776887,
    878867,
    889878,
    978977,
    986978,
    667887,
    768989,
    977987,
    878988,
    797887,
    978797,
    788877,
    778788,
    778698,
    888887,
    877897,
    787977,
    787868,
    697878,
    897888,
    787788,
    779897,
    987887,
    696878,
    887987,
    896889,
    797786,
    898888,
    987768,
    888877,
    896978,
    889897,
    989788,
    789887,
    788788,
    889888,
    888767,
    998877,
    787997,
    777888,
    788897,
    987878,
    777878,
    796877,
    768778,
    878899,
    888799,
    988878,
    787887,
    976697,
    988768,
    778988,
    788887,
    888897,
    787788,
    887999,
    877886,
    988899,
    688787,
    878988,
    786878,
    978678,
    899778,
    979779,
    887768,
    868778,
    687879,
    886887,
    967889,
    879797,
    898978,
    987787,
    887889,
    778877,
    878878,
    877797,
    878977,
    879878,
    978787,
    988868,
    787778,
    786878,
    977886,
    887878,
    899879,
    876887,
    979899,
    878898,
    898878,
    987677,
    979888,
    989969,
    887888,
    888789,
    789788,
    687788,
    879797,
    767879,
    778788,
    787896,
    788778,
    798968,
    778887,
    867889,
    888788,
    978987,
    778879,
    999777,
    788668,
    888787,
    898768,
    788989,
    778879,
    989798,
    889978,
    789887,
    887888,
    778987,
    777787,
    878896,
    878799,
    879798,
    988897,
    778877,
    998896,
    779669,
    776888,
    899888,
    888787,
    787886,
    787788,
    797789,
    878798,
    987896,
    888668,
    987868,
    979878,
    777777,
    886777,
    776887,
    888777,
    798897,
    876789,
    778789,
    779888,
    987788,
    887877,
    787778,
    978787,
    888867,
    988798,
    789676,
    797798,
    787888,
    898888,
    888798,
    788877,
    868978,
    887798,
    788878,
    886888,
    787897,
    889979,
    879797,
    778897,
    788878,
    888898,
    998789,
    898789,
    887877,
    967787,
    878879,
    888798,
    878697,
    769787,
    789987,
    777887,
    799778,
    877786,
    788788,
    777877,
    778977,
    788788,
    768769,
    888878,
    887889,
    889789,
    888786,
    878898,
    888879,
    788876,
    978987,
    779788,
    878888,
    988787,
    888888,
    678798,
    778777,
    887878,
    788867,
    777687,
    799988,
    787678,
    878798,
    978998,
    997688,
    998779,
    799899,
    987778,
    979769,
    778788,
    777898,
    787887,
    888886,
    798978,
    777789,
    878978,
    877788,
    888778,
    778887,
    876779,
    888879,
    897788,
    878798,
    867889,
    999978,
    778987,
    778887,
    788779,
    798998,
    878688,
    876899,
    788879,
    768897,
    896889,
    698878,
    797787,
    879799,
    978886,
    878788,
    877788,
    779876,
    879987,
    788788,
    878988,
    777777,
    888879,
    967778,
    877898,
    786799,
    977788,
    787877,
    779878,
    788787,
    897977,
    898779,
    988786,
    888778,
    888686,
    778987,
    778777,
    998989,
    777878,
    878987,
    898888,
    877798,
    899898,
    878878,
    889888,
    878887,
    997889,
    879897,
    877978,
    787777,
    888978,
    788977,
    989778,
    988876,
    799967,
    879797,
    687788,
    779876,
    687888,
    789797,
    877988,
    869877,
    896987,
    898879,
    798878,
    978877,
    876988,
    888977,
    786898,
    998687,
    887988,
    789787,
    888868,
    987778,
    889798,
    899999,
    878789,
    788799,
    888888,
    989787,
    888777,
    878797,
    768798,
    889989,
    867898,
    877887,
    889798,
    798677,
    866886,
    978899,
    889779,
    778797,
    688789,
    897987,
    798787,
    878897,
    979789,
    877966,
    777986,
    979788,
    876887,
    799767,
    877877,
    877778,
    999899,
    898887,
    899778,
    786888,
    778976,
    767889,
    788788,
    788788,
    778867,
    887798,
    897866,
    768998,
    996778,
    879787,
    788877,
    788797,
    877877,
    887989,
    868896,
    888888,
    977988,
    777887,
    677888,
    978789,
    887897,
    878787,
    879988,
    997689,
    877698,
    876887,
    979987,
    868887,
    887798,
    887888,
    787889,
    788887,
    888788,
    797979,
    897887,
    878668,
    898787,
    687778,
    786987,
    878878,
    877877,
    897779,
    966798,
    787988,
    887889,
    767879,
    786878,
    988689,
    887888,
    777888,
    878778,
    777787,
    878887,
    779887,
    878978,
    878687,
    797796,
    989878,
    778877,
    887877,
    897887,
    779878,
    787968,
    798887,
    988887,
    878778,
    888997,
    797889,
    899987,
    899769,
    769699,
    788797,
    888978,
    887996,
    897886,
    879777,
    887899,
    898798,
    987887,
    899888,
    798798,
    898677,
    698787,
    997878,
    887977,
    989887,
    878979,
    898878,
    988987,
    788878,
    868788,
    977798,
    799686,
    678798,
    786887,
    767778,
    768898,
    887978,
    897887,
    889888,
    799688,
    976778,
    888777,
    789778,
    778778,
    867889,
    977688,
    787888,
    877799,
    778888,
    777697,
    977888,
    887788,
    979898,
    687786,
    978768,
    888877,
    887897,
    878778,
    777889,
    788787,
    878977,
    787899,
    878887,
    988887,
    879777,
    688879,
    888897,
    877888,
    898879,
    788988,
    787998,
    899989,
    898888,
    888987,
    878789,
    898888,
    887877,
    979788,
    779888,
    888789,
    877887,
    688889,
    778798,
    777978,
    877896,
    787868,
    868878,
    877869,
    887789,
    998788,
    787978,
    678887,
    987877,
    877697,
    788878,
    988978,
    788879,
    777789,
    787887,
    799878,
    987997,
    887868,
    688687,
    879779,
    878897,
    878779,
    788797,
    966787,
    977798,
    977986,
    789888,
    767978,
    898977,
    887978,
    887977,
    787798,
    886979,
    869797,
    766887,
    698876,
    686877,
    778678,
    797778,
    888989,
    788787,
    876889,
    988777,
    886788,
    877888,
    997888,
    777687,
    987887,
    768887,
    898988,
    797777,
    797878,
    876767,
    998987,
    898786,
    787879,
    889877,
    988778,
    878877,
    977799,
    988888,
    888877,
    786889,
    687887,
    687989,
    898879,
    777887,
    779779,
    888887,
    779878,
    988778,
    889777,
    988897,
    779777,
    778888,
    689788,
    678978,
    779976,
    989976,
    987878,
    788887,
    889898,
    797798,
    788879,
    889888,
    787998,
    888787,
    869688,
    987797,
    778887,
    997787,
    788877,
    988999,
    989787,
    797778,
    877978,
    688888,
    799777,
    879678,
    787876,
    699787,
    779687,
    986878,
    879888,
    878886,
    987968,
    688787,
    778887,
    889879,
    797888,
    777987,
    887777,
    878778,
    888888,
    887969,
    779989,
    998688,
    778797,
    987887,
    787888,
    788977,
    779989,
    898877,
    897879,
    978899,
    888798,
    979887,
    779999,
    789868,
    899788,
    986786,
    789788,
    998997,
    887879,
    788798,
    877896,
    788789,
    887889,
    778877,
    798899,
    788886,
    889989,
    888888,
    788878,
    789897,
    897999,
    988779,
    668886,
    777788,
    979887,
    789888,
    778988,
    896889,
    877979,
    777889,
    888798,
    878888,
    788698,
    787797,
    877888,
    867878,
    767887,
    898788,
    987777,
    898796,
    987789,
    978776,
    997897,
    678889,
    668967,
    877878,
    777878,
    987687,
    788778,
    686879,
    887987,
    997677,
    878978,
    797878,
    788788,
    888898,
    877788,
    977867,
    787979,
    989787,
    878988,
    788888,
    897799,
    978987,
    988987,
    788998,
    879778,
    687898,
    887799,
    697688,
    886789,
    887899,
    788888,
    798997,
    988977,
    789986,
    686877,
    776768,
    888887,
    768877,
    777797,
    779669,
    796988,
    888877,
    889679,
    888879,
    868878,
    887788,
    899887,
    898889,
    878697,
    897778,
    887988,
    889887,
    798886,
    878767,
    887679,
    778797,
    899886,
    888968,
    897799,
    889778,
    977969,
    898778,
    777898,
    878989,
    777889,
    788998,
    888877,
    988977,
    988878,
    768877,
    888888,
    778778,
    887877,
    798788,
    799897,
    879779,
    798779,
    887687,
    988787,
    988877,
    789898,
    988897,
    788989,
    779886,
    877677,
    969888,
    778988,
    986878,
    988888,
    787968,
    979898,
    867887,
    887688,
    879877,
    678878,
    898796,
    998688,
    778878,
    897769,
    788887,
    998778,
    778876,
    977788,
    987977,
    779786,
    779688,
    979888,
    778889,
    888787,
    696687,
    877887,
    879777,
    787788,
    976779,
    898767,
    789777,
    998779,
    888899,
    776978,
    689977,
    877777,
    778888,
    778787,
    886789,
    788678,
    868986,
    878687,
    988879,
    876788,
    778876,
    678997,
    879878,
    978888,
    778989,
    988887,
    988798,
    987887,
    787987,
    897876,
    987787,
    797898,
    878897,
    868789,
    889968,
    788877,
    878797,
    789787,
    869978,
    767777,
    688787,
    879896,
    987877,
    787777,
    788677,
    887978,
    879799,
    788788,
    788998,
    787997,
    878986,
    997776,
    677878,
    887988,
    978788,
    886789,
    897789,
    877689,
    986878,
    797898,
    889698,
    888878,
    798868,
    978887,
    978798,
    878898,
    886777,
    869777,
    888989,
    978877,
    899978,
    887788,
    987787,
    666787,
    798777,
    898798,
    777787,
    778787,
    798777,
    879768,
    898889,
    787898,
    999888,
    789987,
    887877,
    987879,
    779878,
    787778,
    896988,
    897789,
    798877,
    889889,
    797887,
    897989,
    689878,
    878987,
    878989,
    879886,
    998798,
    988868,
    867887,
    888779,
    788677,
    897788,
    888779,
    798989,
    887878,
    878878,
    878896,
    978888,
    698869,
    777879,
    797978,
    787999,
    987886,
    777799,
    779778,
    989878,
    887978,
    887778,
    877688,
    898788,
    887897,
    987667,
    896689,
    867866,
    798877,
    788867,
    886776,
    887797,
    678978,
    998777,
    778787,
    867878,
    778887,
    788887,
    987788,
    886977,
    887886,
    777978,
    798998,
    877796,
    787878,
    988878,
    788979,
    878787,
    878998,
    679789,
    888888,
    879888,
    777898,
    778788,
    887896,
    788988,
    798789,
    899687,
    697789,
    797788,
    876898,
    799678,
    777788,
    877778,
    877967,
    688998,
    988788,
    799876,
    878897,
    778989,
    889989,
    877878,
    888878,
    998788,
    787977,
    788988,
    898778,
    889767,
    779877,
    968698,
    987768,
    787777,
    897888,
    786888,
    887889,
    999777,
    878989,
    778978,
    898777,
    887878,
    879877,
    787787,
    789768,
    779887,
    786879,
    778988,
    787869,
    788797,
    777787,
    988888,
    997888,
    788898,
    888898,
    898778,
    987988,
    887777,
    788797,
    986888,
    987879,
    778898,
    886876,
    877877,
    779888,
    978877,
    887877,
    898887,
    687768,
    898787,
    797877,
    887879,
    788877,
    898788,
    887898,
    778688,
    896978,
    799889,
    787788,
    679787,
    967887,
    868888,
    876688,
    779867,
    889889,
    688797,
    778899,
    889979,
    898787,
    879788,
    988897,
    797778,
    879877,
    789779,
    878888,
    789786,
    877887,
    868778,
    887768,
    878879,
    787678,
    988888,
    778887,
    788798,
    767987,
    768897,
    868887,
    999888,
    797879,
    788668,
    877789,
    888788,
    888867,
    888788,
    788778,
    887878,
    977797,
    769968,
    788787,
    977996,
    978888,
    777998,
    877877,
    878889,
    688988,
    887897,
    787989,
    787888,
    897989,
    687987,
    777797,
    977897,
    878877,
    698877,
    678777,
    788879,
    868998,
    778979,
    877779,
    867776,
    698887,
    887886,
    867888,
    767798,
    897889,
    878798,
    878877,
    687887,
    986786,
    898788,
    789987,
    787997,
    778969,
    779976,
    878977,
    797898,
    686888,
    879977,
    677996,
    789788,
    776687,
    778876,
    788676,
    788797,
    888778,
    768787,
    997688,
    799788,
    888787,
    788798,
    689788,
    968677,
    798888,
    688777,
    998897,
    688686,
    877899,
    878899,
    877798,
    669888,
    888988,
    786777,
    969877,
    788678,
    887888,
    778989,
    987877,
    897798,
    879888,
    899797,
    979868,
    788988,
    978788,
    789997,
    999787,
    878877,
    999778,
    879999,
    799778,
    978888,
    989787,
    789897,
    798677,
    887878,
    799698,
    787889,
    898877,
    697768,
    888698,
    777788,
    888878,
    777787,
    888778,
    776887,
    799897,
    779898,
    987778,
    688877,
    778878,
    798788,
    887866,
    889769,
    699977,
    888777,
    779788,
    877978,
    797788,
    879778,
    978887,
    789877,
    987799,
    888797,
    888988,
    777778,
    777788,
    967897,
    789878,
    987878,
    789877,
    696989,
    689879,
    779767,
    879898,
    879877,
    778877,
    687889,
    889886,
    978987,
    698877,
    699976,
    797687,
    789789,
    987877,
    687778,
    889888,
    777878,
    788868,
    987879,
    989888,
    777886,
    787888,
    797778,
    897878,
    977988,
    678897,
    788787,
    888787,
    987778,
    677798,
    688997,
    777887,
    987878,
    988779,
    887889,
    878889,
    888779,
    787797,
    788878,
    778779,
    789888,
    767987,
    868777,
    777769,
    768688,
    887878,
    979789,
    988699,
    989879,
    788788,
    878889,
    878787,
    888897,
    879888,
    897879,
    877789,
    799888,
    888897,
    969988,
    779988,
    888778,
    889868,
    788888,
    889877,
    787879,
    977888,
    878888,
    689797,
    877988,
    788698,
    978686,
    788898,
    977687,
    788878,
    998688,
    798879,
    767978,
    898788,
    888678,
    978787,
    789778,
    778888,
    878899,
    789888,
    689898,
    888878,
    679979,
    969877,
    868988,
    797889,
    888978,
    878898,
    987988,
    778888,
    789777,
    967878,
    867987,
    978887,
    868898,
    868768,
    678988,
    778877,
    697986,
    787798,
    869877,
    777879,
    897887,
    978698,
    778878,
    888777,
    778977,
    868877,
    779878,
    678878,
    788988,
    698777,
    689787,
    899998,
    768786,
    788898,
    888778,
    888779,
    777989,
    688697,
    988986,
    888887,
    866888,
    797779,
    988877,
    797799,
    889878,
    767998,
    888888,
    886997,
    788777,
    988967,
    779887,
    879787,
    788789,
    778877,
    799887,
    888897,
    888788,
    867988,
    898986,
    999987,
    897889,
    778788,
    878878,
    878878,
    888789,
    977787,
    887778,
    879878,
    767899,
    898889,
    897788,
    777887,
    877779,
    888777,
    877776,
    878998,
    686788,
    877877,
    687996,
    898767,
    679989,
    677887,
    878778,
    889878,
    887877,
    987888,
    986878,
    797978,
    776788,
    877987,
    988778,
    699888,
    787777,
    978887,
    977989,
    977977,
    889889,
    988787,
    879888,
    878878,
    788876,
    878998,
    998867,
    788977,
    987978,
    788879,
    878988,
    888998,
    878889,
    888787,
    998788,
    788688,
    878896,
    778989,
    988888,
    968988,
    989878,
    877877,
    988988,
    769888,
    887886,
    789778,
    877888,
    878778,
    768778,
    797887,
    776787,
    778777,
    977868,
    787877,
    677878,
    898768,
    879878,
    777677,
    878887,
    888879,
    787798,
    796867,
    888689,
    988889,
    778787,
    886888,
    877997,
    786889,
    878678,
    987998,
    979988,
    989777,
    898889,
    988866,
    676697,
    878699,
    797789,
    977988,
    887988,
    987798,
    888876,
    787999,
    788778,
    988798,
    896889,
    877797,
    799777,
    778777,
    878878,
    877768,
    787887,
    778769,
    887679,
    787999,
    898987,
    788978,
    778868,
    997976,
    788877,
    988688,
    898989,
    897888,
    877689,
    778887,
    789786,
    889788,
    877987,
    887997,
    898787,
    798887,
    977787,
    798997,
    988889,
    887877,
    777777,
    887967,
    688978,
    889889,
    798777,
    887988,
    887898,
    988789,
    778988,
    789999,
    996888,
    988979,
    889878,
    887689,
    788898,
    778977,
    788677,
    777898,
    789989,
    977698,
    878979,
    889789,
    676988,
    788787,
    878667,
    777698,
    896877,
    888988,
    967788,
    987979,
    879978,
    878776,
    788777,
    787888,
    996776,
    787869,
    879898,
    789898,
    888679,
    789767,
    679977,
    668789,
    977688,
    877778,
    778667,
    988897,
    789878,
    878778,
    877799,
    787687,
    798776,
    898889,
    968888,
    889869,
    868899,
    898787,
    998678,
    878987,
    798898,
    987897,
    978877,
    888878,
    897778,
    888898,
    987779,
    867879,
    779898,
    797767,
    686679,
    898868,
    799988,
    899897,
    889997,
    888977,
    788679,
    787688,
    978878,
    797986,
    889978,
    868777,
    887888,
    688889,
    788798,
    897999,
    788788,
    788968,
    878788,
    897787,
    886887,
    868879,
    889979,
    799779,
    788777,
    878779,
    776977,
    788987,
    889877,
    798897,
    868899,
    786889,
    979779,
    887877,
    796887,
    987988,
    888888,
    989768,
    788777,
    788887,
    877798,
    789777,
    898977,
    788788,
    889778,
    879788,
    887786,
    878878,
    977878,
    779889,
    788888,
    977978,
    887887,
    887876,
    678678,
    687766,
    789876,
    787869,
    779778,
    888899,
    898778,
    977787,
    798778,
    797779,
    788888,
    897778,
    978688,
    888797,
    877879,
    778867,
    787887,
    787887,
    879678,
    877778,
    788889,
    986799,
    879888,
    886877,
    867888,
    886898,
    768777,
    978898,
    989789,
    777877,
    788778,
    778779,
    888678,
    877989,
    787899,
    887779,
    879889,
    789978,
    878798,
    777687,
    888878,
    989798,
    779687,
    888788,
    678667,
    887878,
    798888,
    888978,
    869887,
    778776,
    878878,
    798986,
    978697,
    778888,
    797788,
    879888,
    789897,
    688779,
    689678,
    977788,
    997879,
    879869,
    897778,
    987979,
    979799,
    789788,
    898887,
    777988,
    776877,
    878998,
    777898,
    868768,
    789897,
    798769,
    788899,
    978978,
    888967,
    898779,
    768868,
    787877,
    898988,
    798777,
    877787,
    898888,
    896787,
    789877,
    878979,
    997988,
    978979,
    888788,
    787898,
    698779,
    789898,
    778778,
    777887,
    967787,
    788769,
    687877,
    978878,
    676879,
    889878,
    899897,
    798788,
    797778,
    987987,
    879988,
    788889,
    768778,
    888889,
    687789,
    888989,
    887988,
    877878,
    787899,
    877979,
    787787,
    899878,
    767887,
    776789,
    898878,
    689787,
    887888,
    896689,
    877889,
    878787,
    997786,
    887776,
    788689,
    879787,
    777888,
    967768,
    687869,
    798788,
    799868,
    978888,
    888897,
    797768,
    878777,
    787977,
    866888,
    987678,
    888977,
    878988,
    787886,
    788887,
    978877,
    767799,
    787886,
    787887,
    787989,
    988877,
    978977,
    767978,
    889887,
    897788,
    976877,
    798887,
    797879,
    877989,
    768889,
    778888,
    897879,
    788776,
    789789,
    887787,
    869767,
    888788,
    779978,
    887888,
    888788,
    888968,
    898787,
    977868,
    798867,
    796887,
    789768,
    777777,
    877799,
    987888,
    779879,
    877778,
    868897,
    987968,
    896888,
    988789,
    977777,
    777797,
    767878,
    787778,
    688886,
    797888,
    887888,
    677888,
    888986,
    777979,
    898899,
    889986,
    987978,
    978787,
    788877,
    787799,
    869888,
    787868,
    869889,
    988877,
    889787,
    768888,
    889888,
    878888,
    978877,
    979777,
    798779,
    677898,
    877978,
    877868,
    867877,
    887968,
    887797,
    898787,
    878778,
    798888,
    869778,
    888999,
    887999,
    899887,
    888777,
    889989,
    776877,
    778888,
    887789,
    779897,
    798697,
    887998,
    888888,
    977789,
    876988,
    878888,
    799789,
    868897,
    897998,
    797879,
    878888,
    797878,
    778989,
    888998,
    988769,
    879879,
    887778,
    798888,
    788887,
    777767,
    887886,
    887887,
    898897,
    779679,
    877988,
    888999,
    787688,
    898788,
    877888,
    898798,
    998787,
    888979,
    978877,
    887687,
    998887,
    698867,
    887879,
    778777,
    796878,
    897888,
    878898,
    876787,
    976798,
    888977,
    889878,
    668867,
    988978,
    789878,
    679777,
    788778,
    897888,
    989869,
    887768,
    787997,
    888697,
    777799,
    988667,
    778688,
    797996,
    788787,
    987877,
    799787,
    887888,
    888869,
    798988,
    688788,
    889978,
    698877,
    887768,
    886968,
    876998,
    878788,
    889888,
    788867,
    898898,
    986898,
    888978,
    777676,
    877996,
    798897,
    786877,
    989789,
    778878,
    899887,
    878879,
    888777,
    766789,
    888786,
    877879,
    879886,
    877787,
    889788,
    897878,
    967898,
    688787,
    787777,
    677976,
    878778,
    877788,
    887788,
    778788,
    898778,
    878796,
    768998,
    788989,
    878779,
    898887,
    887787,
    676768,
    987877,
    786898,
    766988,
    777899,
    888778,
    868789,
    779887,
    689989,
    777698,
    788769,
    698877,
    677988,
    678988,
    778998,
    887897,
    889788,
    688987,
    677868,
    787888,
    879979,
    797897,
    877897,
    777887,
    978889,
    768798,
    698888,
    768787,
    888867,
    787898,
    777987,
    899778,
    968889,
    898888,
    777779,
    766889,
    686996,
    878867,
    998887,
    778897,
    898877,
    877889,
    889887,
    677798,
    679979,
    888768,
    788887,
    777879,
    878988,
    897788,
    879887,
    787876,
    888876,
    889877,
    787788,
    888987,
    798976,
    989887,
    767877,
    789788,
    978888,
    878977,
    887888,
    869899,
    987877,
    798877,
    879778,
    898788,
    786887,
    879887,
    787778,
    889788,
    867889,
    997788,
    697979,
    788987,
    988888,
    887878,
    688687,
    988978,
    887999,
    897967,
    889898,
    788877,
    777778,
    888788,
    877779,
    879688,
    878787,
    887876,
    868978,
    787787,
    887878,
    677887,
    678767,
    779778,
    988676,
    779888,
    868877,
    887688,
    878878,
    887878,
    986887,
    979688,
    798798,
    799689,
    777879,
    978678,
    886898,
    778998,
    788798,
    788867,
    799969,
    878978,
    789888,
    797888,
    987788,
    877797,
    889668,
    877897,
    789798,
    888696,
    888768,
    878868,
    798988,
    967877,
    788778,
    797888,
    798788,
    798879,
    887786,
    977787,
    778797,
    787879,
    887787,
    777887,
    797887,
    678888,
    877868,
    887889,
    789788,
    887878,
    898887,
    987798,
    679898,
    868767,
    899788,
    887787,
    778989,
    788899,
    788888,
    888878,
    788878,
    897877,
    878988,
    987768,
    878889,
    969768,
    877889,
    788897,
    877797,
    689897,
    978977,
    998967,
    778798,
    878889,
    689799,
    888798,
    799779,
    888797,
    888977,
    788777,
    999888,
    777988,
    787677,
    878788,
    987778,
    979988,
    787887,
    898767,
    886877,
    978768,
    687977,
    889898,
    767798,
    978788,
    878887,
    787798,
    987899,
    977877,
    888787,
    798978,
    679798,
    789878,
    877898,
    889866,
    797979,
    897877,
    777899,
    978797,
    998988,
    787899,
    796767,
    978889,
    787878,
    897779,
    977777,
    688876,
    877779,
    779887,
    778887,
    898888,
    987777,
    697976,
    989998,
    878878,
    888978,
    868779,
    988687,
    987889,
    777888,
    887987,
    788878,
    788787,
    787897,
    876788,
    698788,
    889678,
    797789,
    788787,
    997778,
    668887,
    888787,
    888997,
    979766,
    887878,
    987688,
    799877,
    779789,
    988878,
    688977,
    876868,
    878799,
    887799,
    789889,
    797868,
    887986,
    898787,
    789777,
    888889,
    768788,
    699778,
    976889,
    698878,
    689887,
    889787,
    887997,
    887887,
    988668,
    988688,
    888987,
    777878,
    888978,
    978897,
    988898,
    877877,
    678889,
    797878,
    688887,
    776879,
    898888,
    899867,
    788787,
    998889,
    777879,
    768777,
    989878,
    877888,
    888977,
    999778,
    698878,
    778987,
    897699,
    897787,
    799788,
    787788,
    787867,
    877888,
    798688,
    887887,
    877968,
    988988,
    988889,
    788789,
    798967,
    787978,
    878979,
    878988,
    798789,
    987698,
    987877,
    888889,
    897778,
    697878,
    877877,
    799768,
    887787,
    797889,
    688786,
    667897,
    887787,
    778977,
    788787,
    789876,
    897887,
    879889,
    799787,
    887778,
    887888,
    988988,
    879678,
    898986,
    988777,
    777797,
    776877,
    888888,
    888878,
    878997,
    778788,
    998877,
    698779,
    988678,
    878978,
    888979,
    888879,
    888867,
    777787,
    797779,
    987897,
    786788,
    876887,
    888988,
    887877,
    887788,
    787898,
    988778,
    777888,
    888896,
    796788,
    877896,
    789797,
    888777,
    887698,
    897887,
    877987,
    799878,
    997987,
    888777,
    879888,
    866996,
    888889,
    986988,
    697887,
    888978,
    878778,
    978888,
    766777,
    779777,
    878788,
    888768,
    788777,
    888766,
    778866,
    777668,
    778988,
    778798,
    879887,
    967877,
    898788,
    888878,
    867889,
    997968,
    786777,
    877879,
    879788,
    898787,
    878777,
    877888,
    689878,
    888798,
    978788,
    998869,
    988777,
    977888,
    897767,
    789788,
    897868,
    698788,
    779787,
    897799,
    698888,
    798878,
    888878,
    889779,
    877678,
    779886,
    987686,
    878997,
    888999,
    686787,
    789869,
    788789,
    889898,
    878977,
    997779,
    787787,
    778997,
    888768,
    778886,
    877898,
    787977,
    979886,
    989687,
    777987,
    778768,
    778877,
    789986,
    887877,
    688988,
    998878,
    987989,
    778888,
    879687,
    787788,
    786868,
    789977,
    698777,
    987888,
    898998,
    876899,
    767798,
    789778,
    788898,
    867787,
    798778,
    897779,
    878878,
    978778,
    798878,
    688869,
    788897,
    989879,
    878678,
    888988,
    897786,
    688788,
    867787,
    888887,
    998998,
    996989,
    788879,
    787898,
    787789,
    799877,
    897778,
    898988,
    979977,
    777898,
    869668,
    877998,
    869787,
    779767,
    887787,
    878877,
    989778,
    878676,
    898797,
    787878,
    778866,
    777788,
    979798,
    769898,
    777678,
    879867,
    987879,
    888888,
    977977,
    787778,
    878988,
    996877,
    888777,
    879887,
    787788,
    878988,
    789798,
    879878,
    988878,
    787878,
    877879,
    889888,
    897678,
    689687,
    778888,
    989798,
    877998,
    799987,
    689887,
    788788,
    878888,
    888989,
    789877,
    879878,
    776888,
    769797,
    797789,
    869789,
    998889,
    989797,
    687789,
    887788,
    898879,
    878986,
    987879,
    888788,
    788787,
    888799,
    878788,
    788887,
    879798,
    788777,
    787897,
    778697,
    887968,
    888879,
    888787,
    877897,
    898979,
    877787,
    878797,
    788788,
    878799,
    878978,
    888987,
    897877,
    889889,
    887879,
    798778,
    897787,
    789988,
    869879,
    787888,
    677878,
    778898,
    887898,
    787788,
    887799,
    888888,
    877788,
    987987,
    888887,
    867786,
    776789,
    788688,
    678798,
    778877,
    777788,
    889889,
    778877,
    887777,
    778888,
    987997,
    779878,
    997789,
    977879,
    897897,
    777888,
    888987,
    787788,
    797997,
    797888,
    887888,
    877868,
    878788,
    778879,
    898986,
    698878,
    887778,
    789767,
    878888,
    768888,
    876877,
    967977,
    788868,
    978789,
    988889,
    889998,
    887988,
    897887,
    887878,
    888977,
    878797,
    899978,
    798878,
    877869,
    887979,
    687787,
    988987,
    788899,
    887867,
    798999,
    777788,
    878778,
    787988,
    797787,
    888889,
    968768,
    887886,
    898889,
    797887,
    787898,
    798889,
    877868,
    789887,
    666788,
    886877,
    887978,
    778778,
    879877,
    998788,
    978989,
    789878,
    988779,
    878897,
    997978,
    878778,
    797889,
    798879,
    778767,
    789687,
    888898,
    777788,
    888787,
    778988,
    888879,
    887778,
    888788,
    688879,
    878976,
    877789,
    898997,
    787787,
    778788,
    697887,
    878898,
    978678,
    979697,
    878898,
    898797,
    977967,
    779967,
    686878,
    897899,
    777979,
    768789,
    876677,
    788699,
    887788,
    868777,
    777797,
    987988,
    898897,
    867877,
    787878,
    797797,
    987898,
    777798,
    977878,
    988877,
    888978,
    897787,
    789777,
    877897,
    978988,
    787789,
    898687,
    888898,
    789877,
    788898,
    667796,
    976766,
    886879,
    878887,
    778778,
    988788,
    978889,
    876988,
    887678,
    977899,
    897789,
    889977,
    789789,
    977787,
    799867,
    777789,
    887877,
    789897,
    768898,
    878878,
    979997,
    889786,
    778977,
    777798,
    778978,
    787777,
    678888,
    887799,
    768867,
    898878,
    779989,
    878796,
    998888,
    787877,
    888877,
    798777,
    867798,
    897998,
    887987,
    877978,
    989698,
    868868,
    899788,
    988998,
    889769,
    889688,
    878796,
    989887,
    788887,
    888778,
    787887,
    899787,
    789888,
    888776,
    999978,
    788877,
    888899,
    678898,
    878887,
    879897,
    788787,
    968797,
    698777,
    798879,
    879897,
    888889,
    788899,
    888867,
    879788,
    887977,
    779987,
    878897,
    788888,
    766869,
    987799,
    797978,
    898886,
    676787,
    887979,
    878978,
    788878,
    877888,
    868688,
    888769,
    688777,
    897988,
    887777,
    878777,
    889877,
    797877,
    776888,
    887789,
    778777,
    899977,
    886886,
    979888,
    788687,
    767777,
    878997,
    888899,
    887777,
    776788,
    688988,
    897788,
    777878,
    797987,
    888888,
    888878,
    778888,
    978977,
    688979,
    879778,
    988988,
    997988,
    878898,
    789678,
    879889,
    788777,
    987898,
    789868,
    877898,
    888688,
    969778,
    788988,
    898886,
    887789,
    887788,
    787897,
    787977,
    888797,
    796788,
    999978,
    878897,
    887878,
    788778,
    889878,
    898878,
    889797,
    977867,
    796787,
    866978,
    789888,
    687797,
    879779,
    998878,
    888686,
    778789,
    779789,
    879888,
    897788,
    988999,
    798896,
    778978,
    869978,
    987689,
    887868,
    999878,
    786687,
    986887,
    899787,
    887977,
    889786,
    868779,
    878998,
    897889,
    898888,
    899678,
    689788,
    787679,
    787877,
    787777,
    988888,
    888788,
    989777,
    897677,
    886887,
    787877,
    878886,
    878787,
    887789,
    988889,
    999799,
    888988,
    697989,
    796788,
    787888,
    678897,
    887879,
    877888,
    789988,
    899688,
    778688,
    678878,
    788867,
    876897,
    878878,
    988887,
    898888,
    987899,
    888767,
    997798,
    887878,
    978898,
    976878,
    787999,
    988897,
    799689,
    877797,
    879986,
    888778,
    878888,
    799878,
    798879,
    878887,
    878787,
    887888,
    877969,
    979798,
    877798,
    987889,
    777779,
    989987,
    887788,
    768878,
    987788,
    887778,
    988888,
    888977,
    887866,
    796887,
    988788,
    897868,
    867779,
    898888,
    769997,
    877799,
    888778,
    989998,
    878778,
    778878,
    977887,
    878669,
    997887,
    878998,
    698888,
    787879,
    678887,
    887788,
    889878,
    677987,
    888878,
    677879,
    768997,
    789878,
    898778,
    888697,
    878778,
    698888,
    898877,
    998978,
    789888,
    767889,
    877887,
    767798,
    888789,
    789779,
    878798,
    988897,
    988788,
    778797,
    887878,
    888978,
    768899,
    887768,
    898788,
    969889,
    788878,
    887778,
    768787,
    797998,
    768888,
    889988,
    886797,
    788786,
    988799,
    777989,
    887889,
    788777,
    977788,
    886778,
    979878,
    787889,
    798877,
    797988,
    978799,
    878868,
    997878,
    788888,
    888978,
    787798,
    798776,
    888878,
    777888,
    888787,
    998787,
    877888,
    788977,
    987888,
    888988,
    877877,
    798789,
    779898,
    787688,
    777989,
    879787,
    699887,
    887979,
    988768,
    878878,
    898989,
    898786,
    887879,
    787778,
    977889,
    878787,
    998879,
    878788,
    697987,
    788777,
    976778,
    986897,
    677767,
    776887,
    779799,
    778888,
    887778,
    887678,
    888878,
    888888,
    978888,
    687878,
    878677,
    798897,
    687876,
    888979,
    798878,
    978668,
    879797,
    777988,
    888798,
    777887,
    887768,
    986779,
    777879,
    977798,
    796878,
    897688,
    998679,
    888888,
    877989,
    887898,
    897878,
    899789,
    886877,
    897898,
    798897,
    789978,
    869887,
    779868,
    997898,
    987766,
    689778,
    688886,
    787888,
    888878,
    898998,
    887887,
    788798,
    987879,
    978888,
    789787,
    687888,
    778788,
    787787,
    777888,
    887886,
    878888,
    777977,
    688886,
    899799,
    798898,
    889788,
    679878,
    898887,
    997878,
    987697,
    788776,
    999877,
    977878,
    878888,
    796887,
    977878,
    887889,
    698789,
    779877,
    878968,
    787797,
    989888,
    797967,
    889879,
    889867,
    896899,
    898778,
    879787,
    868787,
    988677,
    978789,
    876777,
    988877,
    888798,
    787888,
    876898,
    778876,
    688778,
    789777,
    897688,
    878877,
    789787,
    887777,
    898888,
    787779,
    869888,
    898888,
    987787,
    978777,
    789668,
    877788,
    687988,
    789767,
    888997,
    867887,
    877878,
    897877,
    788768,
    888878,
    788989,
    888798,
    888799,
    898798,
    788798,
    886997,
    888788,
    679878,
    898797,
    789886,
    776877,
    797889,
    887866,
    877887,
    967979,
    778897,
    988777,
    778788,
    877788,
    878879,
    777687,
    888879,
    789678,
    887888,
    888797,
    979869,
    879989,
    778777,
    679998,
    866776,
    979879,
    768987,
    787887,
    988878,
    767898,
    986889,
    767887,
    988999,
    977989,
    978897,
    878789,
    686778,
    798867,
    897878,
    977879,
    778878,
    988887,
    988997,
    888787,
    777887,
    868877,
    889787,
    687768,
    788688,
    787797,
    989769,
    878899,
    988788,
    898787,
    877998,
    776988,
    878977,
    997787,
    789888,
    987996,
    898997,
    798998,
    778777,
    768777,
    687888,
    777778,
    887878,
    788778,
    779977,
    978987,
    989888,
    987797,
    986768,
    987777,
    789979,
    879869,
    799968,
    888797,
    787888,
    987877,
    779898,
    998888,
    878798,
    887869,
    877868,
    898789,
    688788,
    678786,
    989987,
    986866,
    876887,
    898998,
    877887,
    678987,
    777989,
    888788,
    889969,
    867876,
    978889,
    986777,
    788888,
    878879,
    888796,
    898787,
    687979,
    886897,
    788876,
    887878,
    778879,
    778779,
    897897,
    788787,
    888868,
    798777,
    986887,
    988888,
    798879,
    967988,
    897678,
    888698,
    897989,
    788788,
    987978,
    988897,
    988887,
    987888,
    988887,
    897788,
    898778,
    789878,
    678788,
    998779,
    788988,
    678877,
    889988,
    798877,
    878697,
    897888,
    798887,
    898778,
    888877,
    967868,
    797988,
    878798,
    977886,
    899778,
    888876,
    898778,
    777768,
    878788,
    888778,
    788887,
    977976,
    989898,
    888788,
    778889,
    787767,
    888886,
    787967,
    769677,
    988778,
    997778,
    878688,
    988888,
    788698,
    777988,
    978976,
    877987,
    878899,
    767887,
    767787,
    777797,
    889889,
    797877,
    999878,
    768897,
    767988,
    987998,
    987878,
    777987,
    878887,
    877888,
    887988,
    797796,
    888968,
    878888,
    797979,
    896888,
    887887,
    987787,
    787787,
    867889,
    868788,
    879886,
    688878,
    987797,
    788898,
    788887,
    968797,
    987887,
    887877,
    788776,
    888886,
    888699,
    798887,
    876797,
    866878,
    788899,
    876777,
    777897,
    769989,
    877897,
    987887,
    777888,
    778788,
    898788,
    788988,
    789779,
    688888,
    777787,
    679869,
    787878,
    888777,
    788876,
    888878,
    888787,
    897977,
    976788,
    877887,
    888969,
    887789,
    899889,
    889788,
    787788,
    878777,
    798688,
    977879,
    989777,
    897888,
    779877,
    878788,
    988777,
    987988,
    667788,
    997779,
    778898,
    789887,
    776978,
    897877,
    778787,
    888678,
    769996,
    979888,
    698898,
    987799,
    877788,
    887799,
    898788,
    787878,
    988878,
    888978,
    687978,
    887667,
    889798,
    889878,
    988898,
    798887,
    787788,
    887977,
    987778,
    786888,
    889887,
    879898,
    867887,
    788978,
    879789,
    779796,
    888787,
    887998,
    898877,
    778768,
    978878,
    888787,
    986887,
    988678,
    987977,
    876869,
    887687,
    787898,
    789879,
    889888,
    887679,
    888997,
    889899,
    889689,
    879878,
    978776,
    867789,
    779777,
    888698,
    678787,
    767678,
    987998,
    989768,
    697888,
    897778,
    798887,
    998887,
    988877,
    688678,
    997778,
    898877,
    887687,
    887988,
    978987,
    989868,
    878988,
    897777,
    987686,
    879887,
    978777,
    678997,
    877789,
    887779,
    988988,
    788987,
    888889,
    679889,
    888897,
    888778,
    879988,
    979899,
    988788,
    989889,
    896878,
    897777,
    787888,
    677999,
    878777,
    777877,
    888687,
    889889,
    878868,
    996888,
    797778,
    878887,
    777778,
    876887,
    898879,
    899976,
    898989,
    887677,
    999878,
    776897,
    767888,
    698877,
    688777,
    987787,
    678889,
    789878,
    787869,
    789888,
    677787,
    996879,
    888887,
    788889,
    778788,
    777787,
    889787,
    797888,
    788977,
    789898,
    787876,
    776898,
    889788,
    888779,
    879887,
    876789,
    887877,
    788989,
    878987,
    878788,
    888988,
    999687,
    977996,
    969979,
    889888,
    798888,
    877778,
    877996,
    767989,
    988987,
    777777,
    689988,
    779876,
    687678,
    799979,
    887889,
    886887,
    779897,
    887878,
    877798,
    788898,
    888979,
    778988,
    878886,
    789887,
    787979,
    778898,
    777887,
    787988,
    889888,
    889989,
    799878,
    788898,
    787887,
    889787,
    688888,
    879879,
    789888,
    787898,
    887898,
    889978,
    977889,
    789879,
    798787,
    688778,
    788889,
    987877,
    789987,
    899988,
    798777,
    969779,
    787877,
    787677,
    878987,
    978888,
    988778,
    898778,
    899969,
    988898,
    868878,
    876897,
    898988,
    777878,
    788877,
    768887,
    787789,
    889886,
    898879,
    866977,
    987886,
    797767,
    786989,
    887778,
    889778,
    879697,
    988979,
    797797,
    888888,
    878986,
    778878,
    878879,
    878877,
    679877,
    798979,
    799879,
    969778,
    789789,
    999898,
    877878,
    886877,
    897887,
    787887,
    877998,
    789979,
    787987,
    878678,
    889689,
    888777,
    889989,
    978788,
    777797,
    878898,
    777986,
    978788,
    988988,
    998877,
    877788,
    887988,
    878779,
    898988,
    888988,
    897867,
    978897,
    868978,
    786888,
    878797,
    977668,
    889799,
    899778,
    878888,
    788788,
    778887,
    777877,
    999887,
    889687,
    787879,
    678888,
    888776,
    878799,
    879877,
    986886,
    778896,
    989788,
    677878,
    879899,
    996988,
    887897,
    969786,
    787977,
    876878,
    888788,
    878898,
    888989,
    868898,
    879788,
    877896,
    998889,
    887878,
    787776,
    888888,
    787887,
    898879,
    989788,
    888879,
    878778,
    897879,
    986878,
    977778,
    876979,
    988898,
    879988,
    687878,
    987897,
    788767,
    799988,
    978778,
    787876,
    897899,
    788887,
    877787,
    897878,
    688978,
    787999,
    788798,
    787779,
    877877,
    797987,
    989698,
    898798,
    788787,
    979877,
    887876,
    788898,
    776889,
    889776,
    977888,
    777998,
    878788,
    779889,
    987798,
    989887,
    987687,
    998788,
    879777,
    977888,
    897979,
    768787,
    788888,
    887897,
    967788,
    896866,
    888787,
    786779,
    686796,
    867886,
    777888,
    688878,
    788988,
    887899,
    689988,
    878786,
    977888,
    776968,
    787768,
    879678,
    877986,
    978887,
    879887,
    888976,
    789879,
    787987,
    877988,
    887767,
    999878,
    978887,
    877878,
    677887,
    876988,
    789978,
    777868,
    899878,
    998798,
    976768,
    877778,
    987888,
    789977,
    987678,
    977787,
    889978,
    698778,
    898987,
    797868,
    788797,
    788687,
    797787,
    886867,
    787878,
    989898,
    897777,
    888977,
    897888,
    988888,
    798987,
    899897,
    789797,
    788778,
    878788,
    878887,
    787988,
    877779,
    876777,
    868887,
    877778,
    767997,
    889889,
    888987,
    768798,
    967897,
    777898,
    887877,
    888887,
    889878,
    779888,
    689868,
    778889,
    797796,
    779878,
    787797,
    878688,
    878889,
    778898,
    888798,
    778778,
    798769,
    989988,
    888788,
    777888,
    777977,
    988988,
    989998,
    878797,
    768679,
    797978,
    868889,
    777978,
    969878,
    889888,
    797888,
    789798,
    787678,
    988889,
    888888,
    988777,
    868977,
    898778,
    898888,
    988876,
    888889,
    789677,
    888788,
    778977,
    788698,
    977979,
    979688,
    987767,
    887787,
    787789,
    888767,
    777899,
    786988,
    877689,
    887986,
    876789,
    787788,
    887787,
    889787,
    776797,
    968889,
    878976,
    887887,
    789778,
    889677,
    878999,
    887786,
    989897,
    978878,
    988878,
    887887,
    769987,
    977877,
    877788,
    889897,
    979989,
    886889,
    889778,
    797777,
    986789,
    798779,
    796868,
    777769,
    776879,
    877888,
    888799,
    888997,
    798888,
    887787,
    768787,
    778899,
    988888,
    996988,
    889778,
    988988,
    889797,
    679997,
    687977,
    887889,
    879888,
    887889,
    788768,
    777888,
    878687,
    878877,
    979778,
    677988,
    787777,
    988879,
    989887,
    979668,
    878688,
    978989,
    977988,
    976797,
    777787,
    887887,
    987677,
    798778,
    777797,
    868797,
    876878,
    778987,
    989898,
    978889,
    888898,
    879879,
    987789,
    778887,
    677788,
    797688,
    868778,
    988777,
    777887,
    877876,
    799888,
    888888,
    888779,
    788888,
    787798,
    987878,
    788797,
    788888,
    879978,
    878778,
    888778,
    777798,
    887888,
    977988,
    788888,
    888987,
    778878,
    866778,
    898788,
    898779,
    777777,
    799788,
    888778,
    978797,
    797887,
    777778,
    897788,
    899887,
    887797,
    897678,
    896798,
    977678,
    788977,
    779787,
    779797,
    989899,
    787877,
    878887,
    797876,
    778677,
    896787,
    687888,
    879988,
    688788,
    889889,
    877798,
    898797,
    988989,
    788797,
    897877,
    988976,
    767979,
    768978,
    998777,
    787998,
    878778,
    888788,
    797888,
    897799,
    987899,
    767977,
    887888,
    978788,
    877768,
    787889,
    988897,
    678889,
    787678,
    888879,
    887778,
    977887,
    777878,
    978896,
    969876,
    889888,
    977887,
    668878,
    887678,
    778779,
    988968,
    888887,
    778778,
    879888,
    798977,
    677888,
    978787,
    787888,
    887988,
    687889,
    778789,
    697977,
    977897,
    867887,
    666986,
    987778,
    786798,
    879878,
    978977,
    777798,
    988979,
    887887,
    977979,
    896798,
    798778,
    989977,
    877777,
    988888,
    778878,
    797897,
    797778,
    869777,
    797778,
    887977,
    877798,
    767978,
    877879,
    796878,
    788886,
    687878,
    777968,
    989768,
    678877,
    978977,
    977898,
    777888,
    888768,
    679977,
    899999,
    887877,
    788789,
    987778,
    677777,
    899878,
    688768,
    888797,
    768799,
    889877,
    998987,
    869878,
    788997,
    997898,
    999678,
    887878,
    669879,
    778877,
    997877,
    777687,
    788899,
    888769,
    688886,
    776678,
    788876,
    889898,
    897879,
    877787,
    988878,
    897888,
    988787,
    789978,
    779797,
    777769,
    889888,
    769778,
    888679,
    978879,
    767869,
    888877,
    899897,
    777888,
    777969,
    777877,
    889777,
    978989,
    788869,
    788777,
    987787,
    867788,
    888877,
    888787,
    887779,
    878778,
    987898,
    989987,
    777898,
    788788,
    889889,
    777998,
    988779,
    789697,
    796797,
    887887,
    768898,
    786979,
    877999,
    887788,
    989786,
    868996,
    887898,
    787697,
    799779,
    886988,
    867987,
    888688,
    789788,
    988878,
    867797,
    868868,
    877886,
    787779,
    897888,
    776887,
    888867,
    789776,
    798869,
    888867,
    997977,
    678868,
    789989,
    897988,
    887787,
    988787,
    889777,
    789897,
    777889,
    797878,
    798878,
    898878,
    797797,
    887889,
    988798,
    879888,
    777887,
    777777,
    887777,
    896877,
    898789,
    767767,
    777889,
    798798,
    679797,
    977899,
    789786,
    897866,
    788886,
    778688,
    998887,
    877988,
    768887,
    878978,
    987887,
    779889,
    899788,
    877768,
    887878,
    888898,
    787798,
    787889,
    886778,
    987888,
    968877,
    786898,
    788777,
    678888,
    888897,
    979779,
    788888,
    787779,
    988889,
    897977,
    668789,
    788796,
    987778,
    898888,
    768777,
    797888,
    778687,
    778888,
    877886,
    978778,
    877997,
    888788,
    797988,
    877788,
    997888,
    779696,
    898878,
    887898,
    897896,
    968787,
    798887,
    877977,
    888888,
    879797,
    879778,
    679878,
    688867,
    878788,
    888788,
    796997,
    677797,
    778778,
    697877,
    897779,
    868898,
    887878,
    886886,
    687866,
    888969,
    878778,
    777877,
    887786,
    867777,
    879769,
    787977,
    678899,
    887887,
    977787,
    868888,
    789899,
    977898,
    966678,
    789797,
    988788,
    978878,
    878778,
    679877,
    879788,
    877777,
    898799,
    876869,
    877887,
    787899,
    978998,
    997789,
    889876,
    868979,
    987888,
    978878,
    697979,
    988677,
    677788,
    787788,
    888978,
    868878,
    777897,
    879778,
    779987,
    788888,
    887887,
    978878,
    887888,
    776979,
    897777,
    699778,
    888986,
    779866,
    878798,
    888778,
    887888,
    887999,
    868887,
    787968,
    786866,
    988878,
    988888,
    898788,
    797788,
    798989,
    887887,
    888989,
    888898,
    778897,
    778879,
    798787,
    778777,
    877788,
    788978,
    978887,
    789777,
    888789,
    987788,
    977777,
    878777,
    878988,
    879778,
    889878,
    868886,
    878878,
    978677,
    897877,
    877988,
    787876,
    987878,
    978888,
    988878,
    679879,
    966878,
    677888,
    986787,
    778768,
    778987,
    787778,
    687889,
    988788,
    997888,
    887878,
    898887,
    776687,
    888799,
    898789,
    888888,
    688988,
    697898,
    777898,
    878787,
    777987,
    888786,
    777978,
    879979,
    798987,
    798787,
    899898,
    797666,
    896878,
    879899,
    999888,
    887897,
    999798,
    877788,
    878986,
    898987,
    788889,
    788987,
    877878,
    798899,
    797997,
    888788,
    897877,
    988779,
    888787,
    888977,
    997778,
    798788,
    898778,
    879966,
    889988,
    887788,
    768898,
    887787,
    886888,
    777688,
    788877,
    889879,
    978778,
    678978,
    888768,
    978886,
    977878,
    978788,
    867887,
    777798,
    777778,
    878897,
    897879,
    976988,
    877887,
    899988,
    786888,
    798697,
    889967,
    888877,
    788989,
    788676,
    678788,
    978799,
    667767,
    789797,
    888779,
    899789,
    867978,
    777978,
    698788,
    998898,
    988887,
    698897,
    778777,
    787767,
    788898,
    877998,
    778898,
    888787,
    788977,
    767777,
    897898,
    879988,
    997988,
    879999,
    998888,
    698878,
    788669,
    987887,
    998878,
    878888,
    786669,
    878867,
    879776,
    898788,
    789786,
    886787,
    776867,
    878987,
    988877,
    776899,
    976787,
    897877,
    777987,
    876888,
    876999,
    787987,
    987787,
    767868,
    797778,
    977997,
    889687,
    788877,
    986878,
    977777,
    687889,
    896798,
    887778,
    878777,
    889798,
    987778,
    796986,
    988877,
    687889,
    867877,
    889867,
    778778,
    789878,
    789679,
    988878,
    887878,
    779878,
    786798,
    877868,
    887888,
    889789,
    877887,
    688888,
    887778,
    687868,
    987969,
    999767,
    788788,
    678688,
    798798,
    788769,
    668787,
    888879,
    897777,
    887778,
    979767,
    867987,
    867878,
    789888,
    897998,
    787987,
    978887,
    777699,
    787877,
    879988,
    988787,
    689978,
    888798,
    778899,
    899768,
    868798,
    878786,
    988777,
    897899,
    777788,
    797677,
    798787,
    778979,
    977797,
    778898,
    888887,
    877978,
    898777,
    877789,
    887787,
    788888,
    777789,
    887968,
    778877,
    778996,
    968989,
    897996,
    779679,
    877877,
    788887,
    996688,
    779798,
    888898,
    978898,
    768988,
    889878,
    868998,
    878988,
    868986,
    778689,
    778688,
    999888,
    988888,
    888788,
    879768,
    897878,
    978998,
    888978,
    876978,
    878788,
    889797,
    787767,
    789779,
    887978,
    777898,
    889888,
    788777,
    978788,
    888887,
    978978,
    967787,
    987887,
    688798,
    787676,
    877788,
    988977,
    788888,
    899778,
    778987,
    878797,
    799889,
    899886,
    879977,
    787988,
    998868,
    787788,
    897687,
    868898,
    777888,
    896788,
    878687,
    889776,
    888987,
    878798,
    988698,
    788889,
    799887,
    887677,
    978888,
    889679,
    988986,
    987898,
    787788,
    988869,
    997878,
    887876,
    787998,
    877778,
    977889,
    787777,
    988878,
    788888,
    888877,
    999768,
    877878,
    688897,
    888889,
    999977,
    988788,
    988887,
    969769,
    788978,
    987788,
    887898,
    888989,
    998788,
    798777,
    977868,
    787868,
    779888,
    799888,
    888887,
    787887,
    887877,
    887797,
    978789,
    898787,
    987678,
    799877,
    878789,
    888879,
    778898,
    888878,
    788778,
    888877,
    877978,
    987787,
    879976,
    867888,
    789789,
    967798,
    789879,
    898889,
    788887,
    897698,
    787786,
    888776,
    898867,
    887898,
    887888,
    778778,
    889778,
    978887,
    798888,
    888879,
    887888,
    789677,
    787876,
    698788,
    766787,
    778978,
    878789,
    896869,
    897687,
    888889,
    787778,
    886767,
    967788,
    878777,
    897968,
    668788,
    787977,
    799997,
    787887,
    997989,
    998878,
    778967,
    877987,
    888697,
    878878,
    888787,
    878798,
    788889,
    786887,
    788987,
    878877,
    988978,
    899787,
    676898,
    888898,
    997797,
    869987,
    878777,
    798988,
    887987,
    998799,
    896798,
    777778,
    776789,
    887987,
    986868,
    798788,
    987889,
    897868,
    898789,
    878886,
    898888,
    888778,
    788868,
    878898,
    998797,
    887869,
    779889,
    788988,
    778788,
    677987,
    787978,
    899788,
    877789,
    967889,
    798898,
    879898,
    788797,
    788978,
    988797,
    889787,
    777777,
    698899,
    789878,
    788688,
    878888,
    988776,
    877879,
    899978,
    989797,
    887879,
    887686,
    877988,
    977888,
    788877,
    787878,
    888998,
    788887,
    898789,
    788877,
    988888,
    787788,
    898777,
    888687,
    798797,
    898787,
    789888,
    978788,
    988969,
    887888,
    986688,
    797788,
    777678,
    878787,
    989878,
    777898,
    878799,
    778888,
    788788,
    788898,
    688867,
    889796,
    877887,
    987876,
    767888,
    888699,
    788788,
    767796,
    887877,
    888776,
    889797,
    889888,
    788979,
    879887,
    888988,
    787987,
    799778,
    788887,
    778886,
    987778,
    888878,
    779777,
    868899,
    787878,
    799987,
    978888,
    897897,
    987887,
    888879,
    887987,
    887887,
    878997,
    898788,
    889878,
    798789,
    788876,
    877688,
    797678,
    988987,
    778788,
    787898,
    879878,
    968888,
    988968,
    889787,
    987869,
    988877,
    799877,
    789879,
    988877,
    786776,
    988888,
    887777,
    778799,
    787888,
    877867,
    878999,
    686988,
    687777,
    779778,
    788778,
    898878,
    678789,
    888878,
    798788,
    799788,
    786878,
    878877,
    789886,
    868879,
    989678,
    899987,
    987998,
    777988,
    787699,
    877887,
    789779,
    878786,
    878887,
    878789,
    788887,
    887987,
    976786,
    897879,
    887799,
    989678,
    887888,
    788878,
    998977,
    879988,
    887877,
    777778,
    998878,
    989898,
    898797,
    778867,
    888877,
    868887,
    978777,
    879999,
    879779,
    978878,
    879789,
    988888,
    898787,
    977989,
    687878,
    877788,
    788967,
    789778,
    787877,
    798866,
    687787,
    887978,
    699789,
    898887,
    877987,
    878888,
    887998,
    887677,
    786879,
    988988,
    889888,
    898777,
    887778,
    687679,
    798998,
    989978,
    986677,
    888787,
    778877,
    888698,
    787867,
    679886,
    987879,
    798798,
    879777,
    988787,
    887888,
    888797,
    888978,
    968779,
    788979,
    888877,
    877878,
    898887,
    888878,
    788998,
    788988,
    798789,
    989897,
    988779,
    777887,
    868898,
    877897,
    878877,
    987879,
    878898,
    788787,
    868788,
    777889,
    888787,
    689977,
    988889,
    986898,
    889886,
    879798,
    869786,
    888966,
    698899,
    898877,
    778778,
    889979,
    887788,
    788696,
    898787,
    787888,
    787787,
    886767,
    789888,
    876688,
    977789,
    997976,
    688787,
    789879,
    686788,
    876788,
    988778,
    887979,
    787789,
    788888,
    987888,
    968969,
    787986,
    977998,
    899977,
    988787,
    978898,
    888977,
    898887,
    688789,
    887778,
    877798,
    887888,
    897787,
    899777,
    888889,
    798888,
    997887,
    799777,
    888797,
    789678,
    779899,
    868887,
    796899,
    778798,
    878797,
    789797,
    987798,
    677777,
    768887,
    767777,
    998787,
    779788,
    777898,
    797787,
    988976,
    788899,
    787888,
    777868,
    878698,
    898887,
    887888,
    976888,
    787878,
    689998,
    896868,
    877766,
    889878,
    887879,
    779679,
    979889,
    696888,
    989997,
    889797,
    798988,
    978998,
    789887,
    996987,
    788797,
    888997,
    777968,
    789777,
    797969,
    986977,
    788798,
    888888,
    987777,
    788877,
    898776,
    977889,
    888878,
    887788,
    898998,
    877687,
    798787,
    798979,
    888987,
    788887,
    899869,
    876887,
    787867,
    688898,
    887878,
    779678,
    989977,
    897988,
    887887,
    997899,
    898997,
    878788,
    998787,
    887987,
    899787,
    788688,
    867776,
    778877,
    779767,
    678988,
    988777,
    778776,
    988899,
    776987,
    787668,
    888978,
    877789,
    889788,
    678789,
    877799,
    878687,
    778888,
    778887,
    978788,
    687869,
    869987,
    888889,
    787888,
    877878,
    996888,
    696889,
    898877,
    779978,
    788676,
    797776,
    878887,
    887978,
    888787,
    788878,
    888878,
    887897,
    879998,
    888787,
    778898,
    887789,
    978976,
    778889,
    767879,
    688777,
    968887,
    886989,
    788868,
    788887,
    887787,
    889997,
    897788,
    789688,
    779886,
    778768,
    878887,
    998978,
    898978,
    787779,
    899986,
    787898,
    987778,
    899888,
    878787,
    798699,
    977888,
    797989,
    888698,
    988979,
    877787,
    788988,
    887878,
    777977,
    888978,
    788786,
    698789,
    878987,
    778798,
    888877,
    698987,
    788888,
    787997,
    779799,
    788897,
    879787,
    787787,
    879888,
    879997,
    867978,
    878998,
    877788,
    987778,
    887976,
    887898,
    778897,
    889797,
    978878,
    898779,
    996867,
    678768,
    787769,
    788779,
    688898,
    897878,
    977988,
    887998,
    787997,
    868977,
    789898,
    988897,
    978799,
    998787,
    879779,
    867879,
    776768,
    777778,
    878678,
    788768,
    777987,
    788998,
    897888,
    879789,
    788968,
    887888,
    898768,
    788688,
    988789,
    878777,
    878787,
    878876,
    887787,
    789986,
    777878,
    978897,
    876888,
    779878,
    779878,
    996788,
    988778,
    787778,
    888798,
    787868,
    879988,
    887887,
    778879,
    777779,
    788789,
    788876,
    696978,
    876788,
    888787,
    878879,
    879898,
    779887,
    878789,
    698688,
    998868,
    679778,
    779886,
    978768,
    877877,
    798887,
    697778,
    788998,
    878977,
    797778,
    799878,
    788877,
    776987,
    988788,
    677896,
    778899,
    987978,
    779887,
    888898,
    887877,
    879997,
    878787,
    777998,
    778978,
    789698,
    888789,
    879687,
    897898,
    899888,
    788778,
    789977,
    787979,
    888887,
    678787,
    888989,
    889788,
    797898,
    778878,
    876998,
    779979,
    878888,
    879797,
    898898,
    877897,
    888877,
    888988,
    888789,
    989887,
    787878,
    887777,
    879688,
    787798,
    888777,
    689968,
    777788,
    797687,
    798777,
    878879,
    789878,
    887787,
    697777,
    998868,
    797898,
    887788,
    879987,
    797887,
    788797,
    987798,
    787877,
    878878,
    989778,
    777899,
    787867,
    998898,
    888987,
    878879,
    787677,
    899897,
    877878,
    888889,
    877878,
    886797,
    887888,
    877786,
    877878,
    787989,
    787689,
    786787,
    798889,
    988887,
    888977,
    798699,
    877989,
    988779,
    889687,
    888788,
    769878,
    889988,
    989998,
    878987,
    999899,
    798898,
    977889,
    879797,
    888789,
    797888,
    878867,
    678887,
    788987,
    898889,
    888998,
    988787,
    787778,
    878987,
    678868,
    788977,
    987788,
    888897,
    766779,
    879789,
    799998,
    888899,
    988676,
    777779,
    988889,
    779988,
    878779,
    799767,
    988887,
    798989,
    698788,
    887977,
    888888,
    898778,
    988867,
    787879,
    877777,
    887787,
    779888,
    987777,
    788999,
    789779,
    988677,
    776997,
    887879,
    788988,
    897766,
    687786,
    978886,
    798886,
    878776,
    987888,
    888867,
    788779,
    968888,
    788797,
    898879,
    666787,
    898787,
    777899,
    787987,
    797677,
    888878,
    898979,
    788878,
    687778,
    899868,
    887887,
    787687,
    888888,
    867897,
    976887,
    888888,
    788878,
    877777,
    868988,
    879688,
    897787,
    777787,
    767779,
    877978,
    989979,
    888777,
    867778,
    887768,
    888679,
    667987,
    887888,
    987878,
    877997,
    796887,
    778988,
    887778,
    979888,
    878988,
    688878,
    877896,
    886877,
    887786,
    888776,
    798987,
    787896,
    886987,
    778766,
    888886,
    778797,
    788878,
    888787,
    898778,
    888888,
    788967,
    768689,
    888788,
    887888,
    999888,
    888878,
    786789,
    799787,
    879787,
    778888,
    878788,
    788778,
    798878,
    977988,
    789788,
    877868,
    889887,
    887876,
    877878,
    879698,
    889887,
    888877,
    877787,
    787896,
    987879,
    888698,
    788798,
    887879,
    788978,
    787968,
    788978,
    679877,
    786677,
    879988,
    769788,
    788679,
    987886,
    787896,
    779888,
    988778,
    978898,
    779787,
    979778,
    987787,
    698789,
    899889,
    987878,
    779878,
    879978,
    888878,
    778797,
    799787,
    778888,
    989777,
    778889,
    769876,
    997889,
    877788,
    797777,
    877887,
    867987,
    987888,
    798988,
    978897,
    888778,
    888779,
    779797,
    889788,
    786786,
    889966,
    686879,
    777699,
    989978,
    989888,
    868997,
    789779,
    989797,
    698878,
    987988,
    967887,
    888797,
    879888,
    988767,
    788867,
    798788,
    686898,
    767887,
    899877,
    877688,
    777878,
    878888,
    878878,
    877979,
    889877,
    888998,
    777778,
    698876,
    787998,
    777886,
    877769,
    887779,
    997888,
    879978,
    898677,
    979888,
    898987,
    768878,
    988787,
    688888,
    796897,
    698888,
    789888,
    878876,
    887998,
    798867,
    779778,
    988787,
    796967,
    988789,
    868878,
    977987,
    788879,
    888799,
    779788,
    898866,
    888988,
    967878,
    778989,
    797688,
    786888,
    889779,
    796978,
    886879,
    787898,
    899789,
    768677,
    768679,
    888988,
    988888,
    887879,
    897898,
    897987,
    987697,
    888977,
    688968,
    888778,
    887787,
    877886,
    998776,
    889889,
    978788,
    788888,
    688878,
    879797,
    696897,
    779787,
    787788,
    889777,
    999798,
    789888,
    868988,
    777867,
    899778,
    888988,
    798778,
    887698,
    878997,
    878797,
    888788,
    786898,
    789878,
    977788,
    777778,
    887898,
    697788,
    877877,
    878889,
    788978,
    777888,
    989777,
    787897,
    889788,
    887789,
    887788,
    878879,
    897898,
    787788,
    977968,
    778886,
    797888,
    888799,
    877987,
    978888,
    997878,
    887887,
    668887,
    877798,
    877999,
    788786,
    889787,
    878887,
    777999,
    978778,
    887877,
    868888,
    879777,
    777798,
    978987,
    788889,
    897779,
    789788,
    979788,
    797876,
    788988,
    887787,
    888987,
    896987,
    976976,
    978787,
    886788,
    788899,
    788878,
    888988,
    988879,
    898898,
    878868,
    877869,
    798888,
    886777,
    798987,
    788976,
    877969,
    898876,
    879978,
    869987,
    877789,
    888776,
    988789,
    887977,
    869788,
    987979,
    797888,
    777786,
    897888,
    888898,
    978788,
    767888,
    888798,
    678996,
    787878,
    878898,
    897888,
    789978,
    789668,
    888997,
    778697,
    887688,
    877998,
    888888,
    797888,
    898779,
    987788,
    897887,
    898889,
    897978,
    688787,
    899898,
    798968,
    978789,
    877779,
    778876,
    998788,
    789887,
    887979,
    978886,
    987677,
    879678,
    997878,
    797878,
    787978,
    796967,
    796887,
    878769,
    789877,
    877878,
    877878,
    888789,
    798878,
    798898,
    668899,
    879877,
    878997,
    789878,
    898798,
    798896,
    788877,
    688778,
    989878,
    678888,
    878989,
    879888,
    797778,
    676697,
    869799,
    878988,
    798989,
    878778,
    797787,
    787989,
    899987,
    868777,
    788887,
    888869,
    889986,
    887886,
    988778,
    888878,
    879889,
    788789,
    888889,
    798888,
    897878,
    968886,
    878868,
    778868,
    878978,
    987886,
    988766,
    788988,
    886878,
    878779,
    888787,
    687888,
    779887,
    879897,
    677989,
    798878,
    877898,
    887888,
    886886,
    897778,
    877988,
    876787,
    887778,
    799978,
    787888,
    789887,
    787978,
    878778,
    879978,
    887887,
    788778,
    877778,
    798799,
    889977,
    787687,
    788887,
    786788,
    899778,
    889787,
    888788,
    888778,
    999877,
    797887,
    878886,
    868778,
    978989,
    678868,
    789778,
    788788,
    797888,
    777778,
    878789,
    799878,
    877989,
    988897,
    877969,
    778788,
    889786,
    898687,
    888998,
    878787,
    887978,
    689788,
    778967,
    878889,
    777788,
    698788,
    888888,
    978876,
    688878,
    877787,
    798888,
    868987,
    789788,
    778988,
    988898,
    789887,
    898886,
    788789,
    878799,
    779796,
    787887,
    987998,
    789878,
    978769,
    777888,
    887887,
    888888,
    787988,
    678997,
    889787,
    878987,
    887889,
    878986,
    978889,
    887788,
    777787,
    978778,
    689989,
    888787,
    787878,
    786878,
    989888,
    787789,
    896877,
    988787,
    799887,
    888997,
    887877,
    788886,
    898688,
    987878,
    888977,
    878966,
    687788,
    888979,
    986678,
    788987,
    777879,
    998767,
    898777,
    767798,
    668878,
    886987,
    789898,
    768988,
    898899,
    768887,
    887887,
    988898,
    678897,
    687897,
    888778,
    888797,
    878879,
    896877,
    689967,
    789788,
    888888,
    789887,
    898877,
    898887,
    799787,
    787997,
    887978,
    887779,
    968988,
    778986,
    888898,
    878887,
    888789,
    677987,
    977978,
    987698,
    977978,
    777699,
    877788,
    888878,
    797888,
    987887,
    979778,
    777888,
    978878,
    788789,
    778887,
    778777,
    777898,
    799787,
    788967,
    799998,
    787887,
    787888,
    878887,
    898788,
    889887,
    898879,
    887887,
    888798,
    899779,
    878787,
    998778,
    788978,
    977877,
    799869,
    778786,
    996787,
    887798,
    978887,
    868988,
    878979,
    897876,
    797897,
    877788,
    787788,
    778897,
    987876,
    888787,
    778887,
    877886,
    997987,
    888788,
    867889,
    778778,
    888978,
    698876,
    887899,
    988887,
    879977,
    868987,
    787999,
    688967,
    878967,
    888987,
    897789,
    789897,
    798878,
    888988,
    768797,
    889788,
    879898,
    786887,
    987979,
    978787,
    887689,
    978798,
    777888,
    987996,
    797797,
    898889,
    898879,
    878877,
    689896,
    788978,
    887897,
    786989,
    788788,
    986777,
    878877,
    978779,
    897978,
    787677,
    878778,
    887676,
    786977,
    886688,
    776877,
    788778,
    868889,
    787888,
    688778,
    868877,
    788788,
    888988,
    689887,
    678799,
    898878,
    777877,
    798779,
    978998,
    898788,
    988999,
    878889,
    797788,
    989879,
    888879,
    788777,
    888889,
    889889,
    688787,
    788877,
    777898,
    897888,
    968977,
    788879,
    868988,
    879897,
    878978,
    799888,
    797867,
    877697,
    797888,
    689687,
    887878,
    878887,
    868798,
    887888,
    789996,
    978789,
    877678,
    978878,
    778877,
    887787,
    788887,
    777987,
    889999,
    988798,
    898698,
    878798,
    887886,
    977787,
    778879,
    887788,
    887977,
    778786,
    978887,
    986897,
    888798,
    887688,
    897889,
    777977,
    777988,
    887778,
    979798,
    887779,
    677988,
    888778,
    799798,
    786977,
    787778,
    778877,
    878779,
    799888,
    787796,
    798998,
    797887,
    887886,
    878878,
    897897,
    888788,
    889778,
    989777,
    898787,
    798888,
    998786,
    898678,
    888789,
    897868,
    888979,
    787787,
    777769,
    998688,
    887787,
    878898,
    897888,
    797978,
    778888,
    879767,
    987798,
    878898,
    888889,
    879977,
    898997,
    887787,
    989796,
    897788,
    769968,
    877887,
    769977,
    877989,
    789879,
    869897,
    988898,
    678988,
    787887,
    887886,
    687889,
    888877,
    776888,
    787778,
    979779,
    787888,
    997767,
    699788,
    688789,
    897797,
    978989,
    687888,
    879879,
    987887,
    898986,
    688899,
    998886,
    788888,
    788778,
    988787,
    877888,
    988697,
    888878,
    786998,
    877787,
    787887,
    789877,
    978887,
    788889,
    868767,
    887888,
    998887,
    988987,
    778978,
    787887,
    778979,
    989798,
    779776,
    698779,
    787977,
    778889,
    898779,
    778888,
    787998,
    777979,
    997788,
    797889,
    889786,
    779988,
    887678,
    987797,
    967978,
    976899,
    688889,
    776779,
    878977,
    788689,
    778778,
    897868,
    876777,
    687778,
    789879,
    898868,
    798898,
    779878,
    778887,
    878898,
    778898,
    787987,
    778788,
    699787,
    789877,
    979888,
    889988,
    868887,
    988977,
    887787,
    779878,
    779789,
    887886,
    997887,
    788989,
    888887,
    878789,
    897778,
    897778,
    889988,
    967998,
    878788,
    977798,
    788989,
    788899,
    997767,
    996789,
    879878,
    678877,
    887788,
    888999,
    877978,
    887686,
    999987,
    898876,
    678979,
    788999,
    788888,
    797788,
    868889,
    877767,
    697986,
    877789,
    899789,
    787878,
    898887,
    768996,
    879787,
    887787,
    787787,
    898879,
    777878,
    897887,
    787788,
    778868,
    787898,
    879878,
    887868,
    869877,
    887897,
    888877,
    877768,
    888788,
    767889,
    879877,
    897798,
    888869,
    987788,
    988889,
    867797,
    779887,
    777897,
    977897,
    898877,
    776866,
    868998,
    876898,
    777976,
    798987,
    887887,
    679797,
    978877,
    797799,
    887768,
    779798,
    677888,
    779799,
    796978,
    679787,
    887967,
    877788,
    799989,
    789898,
    787978,
    878897,
    999688,
    977897,
    877888,
    897887,
    887889,
    898677,
    978889,
    887896,
    997777,
    697877,
    778878,
    788797,
    977677,
    788788,
    877868,
    887788,
    767977,
    879888,
    878878,
    778877,
    977979,
    778778,
    877888,
    777789,
    787978,
    787899,
    976887,
    977769,
    779868,
    888886,
    888987,
    687887,
    789788,
    877878,
    897896,
    987889,
    796866,
    696889,
    789799,
    977888,
    788777,
    878887,
    888898,
    888876,
    978798,
    977977,
    997977,
    987788,
    787888,
    887799,
    788868,
    788687,
    878897,
    987897,
    877789,
    887887,
    778678,
    799877,
    799788,
    988888,
    897898,
    788887,
    897968,
    869787,
    798888,
    687689,
    779778,
    877779,
    886889,
    878788,
    989786,
    877889,
    889778,
    898898,
    788877,
    788778,
    887888,
    888987,
    978878,
    997788,
    897898,
    887788,
    779887,
    888779,
    887788,
    989788,
    888886,
    777787,
    979899,
    977867,
    877898,
    796887,
    788987,
    878789,
    978788,
    778787,
    787776,
    878899,
    987877,
    787888,
    688779,
    797987,
    797678,
    877767,
    879987,
    888887,
    778898,
    787889,
    779798,
    877987,
    777787,
    887787,
    877976,
    697997,
    887787,
    777797,
    778786,
    887777,
    788687,
    888888,
    878788,
    889899,
    888677,
    888979,
    779897,
    988787,
    778898,
    877789,
    978797,
    776786,
    989688,
    887878,
    897887,
    878977,
    787889,
    777978,
    777888,
    876867,
    978899,
    998798,
    888778,
    789688,
    697888,
    887899,
    887678,
    877786,
    778877,
    998788,
    987878,
    978988,
    877988,
    868868,
    878987,
    886867,
    887798,
    899777,
    887898,
    899999,
    768989,
    878988,
    998788,
    977987,
    877788,
    987888,
    796889,
    789897,
    876787,
    888878,
    879977,
    878886,
    968788,
    879988,
    699789,
    789776,
    787867,
    989978,
    877888,
    787987,
    899887,
    888789,
    778878,
    898788,
    887889,
    888998,
    798688,
    877797,
    767699,
    998897,
    887768,
    899997,
    787877,
    788888,
    988777,
    988778,
    888887,
    887887,
    989779,
    966788,
    797979,
    988978,
    788787,
    886789,
    868879,
    877688,
    868776,
    977787,
    788977,
    878987,
    879988,
    977878,
    889787,
    796988,
    988987,
    678778,
    877977,
    798987,
    787779,
    787788,
    868897,
    888786,
    976779,
    797798,
    779977,
    877779,
    987978,
    888868,
    899798,
    897879,
    897888,
    888978,
    769798,
    888898,
    789897,
    898878,
    787899,
    788698,
    867988,
    878798,
    878779,
    889687,
    888768,
    887888,
    878996,
    688898,
    987888,
    989876,
    778777,
    978877,
    888997,
    878988,
    997789,
    888879,
    988986,
    878877,
    999899,
    987768,
    897777,
    868899,
    788979,
    987898,
    887677,
    776697,
    887787,
    777887,
    798869,
    878897,
    978796,
    898876,
    788796,
    877687,
    988987,
    797987,
    978987,
    987698,
    887899,
    888788,
    889789,
    798878,
    987879,
    797898,
    888979,
    888778,
    887877,
    777767,
    877988,
    787979,
    699878,
    878978,
    778788,
    978788,
    886786,
    878789,
    768678,
    787878,
    879887,
    787879,
    798876,
    887697,
    798677,
    787887,
    688789,
    787888,
    789878,
    889978,
    999887,
    988678,
    788989,
    778798,
    777789,
    778879,
    877877,
    887897,
    887897,
    888678,
    778877,
    897979,
    798678,
    877879,
    997997,
    978887,
    878887,
    787978,
    897897,
    767779,
    778879,
    698878,
    698778,
    988998,
    889897,
    788979,
    998777,
    768768,
    788878,
    877897,
    998788,
    778877,
    899889,
    787798,
    888787,
    898778,
    978997,
    787778,
    978899,
    897879,
    777777,
    778979,
    787798,
    888777,
    989897,
    789888,
    797989,
    887977,
    876887,
    878889,
    789887,
    999878,
    798987,
    678888,
    788877,
    878977,
    989678,
    887788,
    786788,
    898779,
    877898,
    869987,
    889798,
    898897,
    797887,
    887888,
    778897,
    779889,
    676787,
    668987,
    889877,
    968988,
    778888,
    887688,
    797898,
    887868,
    687777,
    787887,
    789788,
    987989,
    879678,
    999799,
    897988,
    789989,
    887768,
    897777,
    787888,
    677887,
    888888,
    888677,
    677878,
    987787,
    698697,
    798989,
    787878,
    869987,
    977988,
    888798,
    788878,
    888777,
    887778,
    879898,
    987889,
    898788,
    988777,
    869798,
    778897,
    977768,
    879798,
    969997,
    878878,
    788888,
    677889,
    999877,
    787788,
    888778,
    789778,
    889899,
    877879,
    777888,
    789979,
    786887,
    777867,
    788889,
    886989,
    688999,
    979897,
    788879,
    698877,
    777968,
    788686,
    899697,
    867888,
    878888,
    887878,
    999788,
    978899,
    778798,
    878878,
    777868,
    899777,
    778878,
    667897,
    888888,
    878979,
    877787,
    787979,
    889877,
    897889,
    787779,
    799778,
    788898,
    878676,
    887876,
    888879,
    976888,
    787888,
    687899,
    777778,
    978888,
    877987,
    678888,
    888888,
    788988,
    879889,
    787779,
    898986,
    868998,
    887867,
    998898,
    998887,
    889888,
    877877,
    888878,
    878788,
    679788,
    886667,
    777998,
    888998,
    977988,
    889986,
    778878,
    879887,
    977877,
    986876,
    888778,
    799989,
    787888,
    898778,
    878887,
    788888,
    687988,
    887896,
    676877,
    878788,
    799877,
    998786,
    779888,
    888879,
    997688,
    988897,
    788887,
    789879,
    889887,
    887788,
    967678,
    889789,
    868889,
    677987,
    789998,
    896998,
    777788,
    798988,
    789678,
    768887,
    778898,
    888689,
    887877,
    679787,
    779878,
    878778,
    878798,
    988777,
    787888,
    888878,
    887887,
    879787,
    877789,
    987976,
    789887,
    978787,
    879988,
    968887,
    887978,
    978877,
    888877,
    998998,
    787787,
    888778,
    778889,
    978787,
    898888,
    888677,
    967888,
    788887,
    789797,
    897888,
    877788,
    778878,
    887778,
    888799,
    898777,
    888789,
    888799,
    788789,
    886789,
    898887,
    778896,
    788787,
    887897,
    768787,
    898988,
    797687,
    897988,
    968878,
    777978,
    789888,
    778778,
    678798,
    779888,
    877868,
    698789,
    997887,
    877776,
    887776,
    888778,
    888789,
    779878,
    887867,
    886798,
    977889,
    988799,
    887898,
    877778,
    798788,
    779798,
    869789,
    777888,
    788787,
    966798,
    987888,
    889989,
    888889,
    898868,
    988897,
    877878,
    879878,
    879997,
    878989,
    788888,
    967798,
    869889,
    897878,
    998988,
    678888,
    889997,
    987868,
    978877,
    889888,
    878788,
    988877,
    899987,
    887899,
    678787,
    888989,
    877796,
    697888,
    797787,
    987789,
    979987,
    879969,
    997978,
    979897,
    887987,
    988677,
    778788,
    889787,
    798777,
    787787,
    877878,
    988888,
    889987,
    788878,
    798997,
    777988,
    897699,
    987877,
    769787,
    898778,
    999798,
    878678,
    798788,
    888778,
    988777,
    878999,
    976878,
    988877,
    689777,
    878888,
    788777,
    788888,
    988888,
    866878,
    998897,
    998888,
    868979,
    988788,
    998898,
    798997,
    879878,
    877978,
    776789,
    897777,
    877878,
    778888,
    977768,
    899977,
    878788,
    869788,
    886997,
    989786,
    776798,
    778877,
    989676,
    887978,
    889697,
    887887,
    788989,
    778887,
    898698,
    699879,
    886789,
    987978,
    987777,
    799888,
    878797,
    878779,
    767787,
    788977,
    879898,
    777776,
    897999,
    899899,
    867899,
    877688,
    788777,
    787887,
    788777,
    877799,
    889968,
    788897,
    788888,
    867879,
    887899,
    688687,
    698977,
    787788,
    888877,
    779787,
    879878,
    698688,
    879879,
    779789,
    778877,
    778978,
    789779,
    797988,
    997789,
    978789,
    787876,
    886987,
    987899,
    989777,
    878877,
    888789,
    887997,
    789778,
    887897,
    788898,
    887978,
    788788,
    788987,
    778878,
    879787,
    787889,
    877888,
    787887,
    778898,
    868877,
    779798,
    688897,
    678888,
    888888,
    889888,
    786878,
    887768,
    967878,
    878876,
    987898,
    879988,
    686998,
    897978,
    889778,
    799778,
    778978,
    897886,
    999778,
    977897,
    887887,
    768887,
    687976,
    787878,
    786869,
    768879,
    878867,
    877787,
    788887,
    797889,
    887977,
    888788,
    778889,
    986888,
    888787,
    677887,
    798877,
    788878,
    799998,
    887888,
    998778,
    778798,
    799778,
    787697,
    777787,
    988867,
    878897,
    878788,
    879897,
    788898,
    979979,
    777888,
    776868,
    897977,
    787889,
    888888,
    878979,
    998668,
    898988,
    789978,
    887797,
    788788,
    798887,
    889899,
    777768,
    889897,
    879878,
    787887,
    789897,
    779789,
    878979,
    787786,
    888889,
    878677,
    968788,
    988797,
    977786,
    978987,
    889997,
    786789,
    788979,
    779888,
    787777,
    887779,
    887987,
    897788,
    989789,
    689798,
    899887,
    677769,
    989886,
    897988,
    988899,
    676768,
    888888,
    787776,
    787767,
    778887,
    887797,
    778878,
    869889,
    867877,
    787687,
    877888,
    777887,
    898978,
    888988,
    768767,
    888798,
    889666,
    787878,
    768886,
    899989,
    867889,
    777789,
    888679,
    877987,
    888887,
    898797,
    888798,
    678898,
    886878,
    877987,
    889787,
    889788,
    889987,
    888898,
    777877,
    787788,
    898687,
    986878,
    987899,
    967977,
    877889,
    888978,
    987779,
    797878,
    887877,
    898989,
    798788,
    886968,
    788778,
    778788,
    978979,
    679976,
    988988,
    799998,
    798888,
    688778,
    799898,
    877979,
    989878,
    989888,
    888888,
    788777,
    788778,
    887767,
    877777,
    978987,
    788999,
    877687,
    887976,
    888687,
    888978,
    897777,
    877776,
    888776,
    778877,
    988788,
    879788,
    779688,
    899769,
    889787,
    998889,
    997777,
    987887,
    798898,
    879879,
    989777,
    998787,
    678878,
    898778,
    888697,
    778879,
    967987,
    679777,
    879788,
    977778,
    678877,
    776797,
    878989,
    788768,
    888868,
    867798,
    888998,
    686667,
    787967,
    987689,
    886688,
    678878,
    978888,
    888888,
    798979,
    997877,
    989777,
    889878,
    887978,
    788889,
    997787,
    967869,
    887787,
    866867,
    688777,
    897888,
    789899,
    888997,
    889877,
    866887,
    697986,
    978786,
    888998,
    998788,
    889687,
    888999,
    788788,
    788866,
    879788,
    978778,
    979989,
    788898,
    977777,
    878877,
    868778,
    797879,
    788799,
    798969,
    877788,
    787688,
    888889,
    878787,
    867898,
    687989,
    778997,
    987679,
    888888,
    876878,
    899787,
    877898,
    867768,
    989978,
    988788,
    787989,
    897878,
    898888,
    998879,
    878898,
    987978,
    777889,
    778788,
    788899,
    869878,
    978868,
    878878,
    988896,
    887987,
    887789,
    879988,
    798877,
    888967,
    887889,
    888787,
    899987,
    886797,
    998797,
    888787,
    887868,
    876988,
    687968,
    697777,
    779887,
    878799,
    977967,
    986798,
    777878,
    878987,
    789987,
    899978,
    699778,
    787788,
    888978,
    889978,
    897799,
    868789,
    777788,
    797787,
    987789,
    799779,
    688777,
    877998,
    878898,
    898978,
    878878,
    888798,
    978999,
    879897,
    987787,
    887887,
    869898,
    689888,
    799788,
    779988,
    768788,
    687969,
    997788,
    888868,
    887888,
    797898,
    987998,
    778788,
    688678,
    887888,
    687799,
    778889,
    899968,
    878678,
    898878,
    877888,
    877878,
    799897,
    879788,
    868777,
    887889,
    788788,
    889687,
    888979,
    888798,
    889899,
    788898,
    869898,
    978688,
    787968,
    868778,
    978788,
    677798,
    867898,
    977787,
    878898,
    878898,
    888787,
    677878,
    889888,
    787887,
    788889,
    887788,
    878997,
    778789,
    877788,
    698888,
    779888,
    968898,
    887879,
    876979,
    897988,
    888679,
    879868,
    887788,
    887778,
    886779,
    797888,
    789887,
    979876,
    787778,
    988978,
    798876,
    888787,
    988987,
    887687,
    777778,
    988987,
    777998,
    878799,
    887868,
    966677,
    868988,
    788698,
    797799,
    778787,
    787977,
    777879,
    788987,
    877689,
    888868,
    788777,
    978878,
    978898,
    788988,
    797788,
    888788,
    897778,
    887776,
    987898,
    898898,
    987787,
    989987,
    788978,
    887887,
    777888,
    867998,
    798888,
    888779,
    777887,
    889888,
    888787,
    799878,
    878689,
    998986,
    688688,
    798888,
    879866,
    778778,
    788889,
    898879,
    877798,
    787878,
    897878,
    777787,
    888978,
    788788,
    787879,
    887788,
    899788,
    889888,
    978997,
    987977,
    899896,
    889786,
    679677,
    779798,
    677789,
    978777,
    977779,
    778888,
    888879,
    688778,
    986987,
    878988,
    898768,
    778688,
    887887,
    789889,
    877868,
    898778,
    986986,
    777688,
    788889,
    989788,
    988868,
    897877,
    799779,
    896978,
    878969,
    977888,
    989887,
    987779,
    887889,
    887876,
    898898,
    868878,
    798897,
    876879,
    887767,
    888889,
    789788,
    886778,
    898889,
    887778,
    879769,
    787797,
    888977,
    888886,
    988878,
    787798,
    889688,
    788879,
    789777,
    687887,
    789888,
    878778,
    787978,
    777889,
    878779,
    977899,
    898888,
    989797,
    677998,
    798799,
    767888,
    797986,
    797689,
    988898,
    877889,
    888776,
    877789,
    977677,
    889797,
    878768,
    878877,
    878878,
    668879,
    986888,
    987688,
    988887,
    988879,
    787879,
    798887,
    897889,
    889778,
    777788,
    789886,
    889879,
    976867,
    887788,
    797878,
    999888,
    889877,
    899677,
    889877,
    766868,
    979878,
    878777,
    687797,
    877789,
    799778,
    888678,
    787898,
    887777,
    989878,
    997788,
    897788,
    889778,
    878888,
    977787,
    887977,
    888788,
    888778,
    978768,
    888788,
    878988,
    888677,
    988987,
    888788,
    689896,
    878888,
    877989,
    997869,
    977887,
    998887,
    777998,
    879777,
    889877,
    778797,
    779888,
    777787,
    778888,
    987876,
    777887,
    778879,
    988888,
    798877,
    687789,
    977878,
    788798,
    787978,
    989768,
    879877,
    996977,
    898888,
    768887,
    977789,
    778887,
    869987,
    678679,
    897998,
    886779,
    989888,
    889978,
    987777,
    977877,
    899768,
    888669,
    798786,
    787789,
    899798,
    877688,
    988788,
    888898,
    989778,
    887888,
    787979,
    887878,
    866967,
    788888,
    777797,
    787877,
    888866,
    979787,
    978888,
    889888,
    888777,
    869878,
    879678,
    878887,
    878877,
    998688,
    888788,
    669769,
    988888,
    699888,
    687679,
    778787,
    787888,
    897778,
    978778,
    888777,
    877877,
    898789,
    886797,
    978868,
    988788,
    888778,
    798897,
    888789,
    787979,
    867967,
    788877,
    998978,
    967879,
    878887,
    998978,
    878979,
    888997,
    997786,
    888897,
    877897,
    786979,
    977797,
    978977,
    879779,
    888987,
    888899,
    888888,
    796877,
    876887,
    798787,
    888888,
    898988,
    767898,
    889778,
    887888,
    888789,
    778988,
    888877,
    698669,
    976978,
    897887,
    888678,
    778877,
    796889,
    789887,
    869889,
    778879,
    879877,
    887777,
    899888,
    888777,
    998767,
    967987,
    887799,
    888877,
    989888,
    767898,
    798897,
    767778,
    887887,
    987869,
    798887,
    887797,
    878889,
    979877,
    899778,
    867789,
    966997,
    787889,
    788968,
    979877,
    788877,
    988799,
    798888,
    988789,
    799877,
    787788,
    978977,
    788787,
    969998,
    987788,
    788788,
    888877,
    788877,
    779688,
    898787,
    689788,
    799896,
    868778,
    888777,
    778797,
    888789,
    787987,
    877887,
    989988,
    879789,
    788778,
    879677,
    876899,
    877886,
    878988,
    777777,
    667798,
    898788,
    777988,
    889888,
    788766,
    978878,
    887999,
    767889,
    687997,
    788767,
    888898,
    877878,
    778899,
    688988,
    796767,
    897777,
    978889,
    889787,
    769978,
    887889,
    896887,
    787778,
    688797,
    798778,
    787889,
    788687,
    866878,
    879888,
    887887,
    988899,
    779888,
    867787,
    888769,
    798788,
    897899,
    878878,
    887799,
    988878,
    879798,
    678777,
    888997,
    977899,
    978866,
    878777,
    987898,
    997889,
    777796,
    879888,
    988887,
    978999,
    888789,
    788788,
    899898,
    898897,
    689888,
    778778,
    897889,
    778787,
    977999,
    888978,
    789987,
    887889,
    788778,
    877779,
    889868,
    777687,
    886788,
    787889,
    879977,
    999977,
    868867,
    889767,
    888896,
    898887,
    897898,
    777987,
    888977,
    887777,
    779798,
    798778,
    887688,
    788988,
    777678,
    987898,
    887979,
    887877,
    897898,
    669889,
    789778,
    999878,
    778788,
    887889,
    796786,
    868888,
    777869,
    979978,
    778897,
    879787,
    999776,
    888878,
    988798,
    899899,
    878977,
    897798,
    888798,
    788888,
    788987,
    876768,
    878888,
    776898,
    889879,
    788787,
    678678,
    888767,
    877889,
    697878,
    887888,
    968778,
    889879,
    869978,
    896869,
    898777,
    889689,
    877778,
    788888,
    877688,
    976888,
    787879,
    877788,
    698999,
    787887,
    889879,
    888998,
    887878,
    889888,
    868897,
    688968,
    889778,
    987889,
    897888,
    779898,
    788687,
    878987,
    677777,
    778888,
    978887,
    777789,
    978888,
    887887,
    889868,
    799888,
    898878,
    986798,
    886678,
    966898,
    897788,
    788897,
    876878,
    889898,
    989897,
    898797,
    987888,
    678787,
    878797,
    877779,
    987677,
    787887,
    767988,
    778987,
    988978,
    788869,
    799986,
    789899,
    898976,
    879877,
    896898,
    789779,
    887779,
    797887,
    877968,
    768889,
    787787,
    868788,
    888878,
    868898,
    869898,
    878788,
    898877,
    687777,
    988797,
    988798,
    888988,
    777887,
    889789,
    696878,
    876878,
    877879,
    988889,
    898787,
    877898,
    787788,
    797987,
    778986,
    877799,
    796769,
    879998,
    876898,
    779888,
    887888,
    887877,
    977867,
    777877,
    867998,
    888987,
    769898,
    888779,
    988967,
    789778,
    987789,
    987788,
    797889,
    787979,
    877977,
    777887,
    988879,
    887788,
    888777,
    778789,
    878768,
    797987,
    988998,
    879897,
    768878,
    889878,
    989888,
    787797,
    878878,
    999787,
    778878,
    788787,
    787797,
    968878,
    886798,
    687898,
    877777,
    879888,
    888986,
    987887,
    787788,
    779977,
    788788,
    977999,
    998877,
    888968,
    888787,
    688897,
    788887,
    788978,
    988889,
    888878,
    779998,
    986888,
    887778,
    889988,
    898779,
    886787,
    896889,
    999789,
    886978,
    878798,
    788977,
    877887,
    788788,
    779897,
    777786,
    887878,
    787779,
    796886,
    888967,
    888888,
    788889,
    787868,
    788888,
    778888,
    889676,
    679786,
    988988,
    879889,
    687889,
    897877,
    778787,
    887889,
    879797,
    997969,
    876889,
    877888,
    777779,
    987887,
    887897,
    777897,
    788789,
    778878,
    978879,
    887777,
    998797,
    897887,
    977798,
    788888,
    788987,
    888869,
    987888,
    977788,
    787779,
    987888,
    988887,
    899977,
    878798,
    999788,
    998998,
    888987,
    779886,
    779886,
    777978,
    767789,
    887787,
    779787,
    888878,
    877797,
    797987,
    988879,
    988989,
    788898,
    888977,
    778786,
    878697,
    988799,
    997887,
    898877,
    798888,
    996988,
    888898,
    988869,
    997787,
    897867,
    778698,
    888687,
    788777,
    688788,
    777889,
    877888,
    877888,
    977987,
    888778,
    967879,
    878988,
    798999,
    989878,
    887888,
    989767,
    786869,
    978987,
    888898,
    889788,
    778798,
    896669,
    788687,
    788779,
    777778,
    898798,
    888879,
    677867,
    789897,
    777798,
    898979,
    679788,
    877889,
    768789,
    888898,
    787778,
    887988,
    889977,
    677878,
    798679,
    799877,
    869778,
    788888,
    879776,
    986877,
    888977,
    787977,
    878768,
    979799,
    889788,
    879887,
    777977,
    878899,
    778987,
    698999,
    887889,
    778967,
    888789,
    889878,
    698787,
    777677,
    977878,
    878888,
    786898,
    889698,
    778688,
    677878,
    789788,
    886778,
    887999,
    787968,
    797896,
    878988,
    798797,
    878789,
    778879,
    798889,
    867978,
    678878,
    887979,
    988768,
    888898,
    879786,
    898789,
    888999,
    797878,
    787797,
    987788,
    787988,
    887788,
    798788,
    978898,
    888878,
    767978,
    978887,
    978979,
    978789,
    888978,
    799798,
    797788,
    767879,
    788887,
    777868,
    888887,
    877887,
    789878,
    987798,
    689888,
    866899,
    887988,
    787888,
    888777,
    888988,
    878998,
    888787,
    776788,
    886778,
    869887,
    989898,
    788888,
    887688,
    998697,
    678898,
    799876,
    879788,
    989879,
    878887,
    878787,
    878889,
    888666,
    798878,
    788888,
    878888,
    778868,
    799877,
    689987,
    897787,
    779798,
    879887,
    789797,
    887897,
    788777,
    797788,
    789989,
    677888,
    678987,
    867777,
    789989,
    878797,
    997868,
    888688,
    988768,
    878887,
    888798,
    788788,
    898678,
    797967,
    778777,
    788977,
    788987,
    896897,
    996888,
    887777,
    777788,
    887898,
    787988,
    778788,
    798969,
    788778,
    879877,
    688878,
    988887,
    887779,
    999879,
    999889,
    898989,
    988687,
    789898,
    878797,
    878978,
    788879,
    878677,
    977779,
    968787,
    787778,
    777798,
    878687,
    887878,
    778786,
    887879,
    788877,
    878768,
    786887,
    777787,
    888869,
    788877,
    876987,
    877988,
    897789,
    787789,
    697888,
    999988,
    767899,
    888867,
    998778,
    786797,
    899887,
    777998,
    788878,
    897887,
    889988,
    786778,
    678778,
    897966,
    969887,
    779777,
    697987,
    888778,
    889797,
    779877,
    879978,
    786877,
    886968,
    688899,
    978767,
    798787,
    867779,
    777977,
    877887,
    988787,
    877786,
    989976,
    977978,
    777878,
    887877,
    888778,
    878799,
    778778,
    987788,
    889988,
    999779,
    787988,
    977889,
    788988,
    898778,
    678988,
    877878,
    788787,
    787799,
    878788,
    789777,
    987688,
    689997,
    888878,
    769878,
    877687,
    688689,
    997798,
    769877,
    989787,
    688787,
    878999,
    979869,
    778799,
    788867,
    867778,
    889777,
    789978,
    978789,
    887878,
    797776,
    869987,
    869978,
    778889,
    878697,
    787698,
    878878,
    788878,
    898797,
    878787,
    887869,
    878898,
    878869,
    786888,
    899796,
    878788,
    789897,
    777799,
    898898,
    888789,
    967879,
    887787,
    797778,
    788688,
    988789,
    777778,
    888789,
    789687,
    868787,
    767677,
    897889,
    777698,
    888887,
    878887,
    887877,
    788687,
    997797,
    978786,
    898779,
    889888,
    998979,
    777977,
    988887,
    887888,
    976989,
    779998,
    988978,
    877778,
    798887,
    897898,
    777687,
    888989,
    987887,
    877777,
    787877,
    798988,
    977688,
    789869,
    888878,
    688887,
    879976,
    987668,
    788899,
    987898,
    679878,
    899678,
    886896,
    788879,
    878986,
    798878,
    986888,
    778999,
    787987,
    878798,
    988778,
    898769,
    997788,
    788796,
    888778,
    789877,
    787889,
    897888,
    979766,
    886677,
    687888,
    989799,
    688789,
    788867,
    889886,
    978789,
    776888,
    778997,
    868987,
    998987,
    789888,
    789787,
    889798,
    878888,
    868798,
    979877,
    899987,
    888899,
    677978,
    888989,
    887788,
    678967,
    878888,
    677787,
    888799,
    887797,
    787987,
    978988,
    888888,
    977788,
    878886,
    768777,
    777788,
    978878,
    887799,
    768899,
    876797,
    888776,
    799899,
    777977,
    978789,
    979877,
    787767,
    897787,
    799889,
    899787,
    789878,
    978677,
    889799,
    778779,
    889798,
    888769,
    988787,
    997798,
    869887,
    899888,
    878987,
    887779,
    888897,
    879888,
    898988,
    787797,
    788879,
    788887,
    978989,
    868878,
    788889,
    968897,
    797887,
    876777,
    888877,
    777778,
    967877,
    897788,
    777688,
    667777,
    979779,
    888788,
    879898,
    977788,
    898998,
    776877,
    787789,
    887989,
    789779,
    798877,
    877778,
    878778,
    787789,
    797988,
    767789,
    989877,
    777896,
    887987,
    779789,
    789779,
    869888,
    877678,
    877989,
    899898,
    997867,
    666798,
    879877,
    888889,
    789978,
    777789,
    888878,
    776979,
    798987,
    888777,
    699778,
    888887,
    797778,
    868798,
    888898,
    778978,
    888977,
    897678,
    768788,
    788787,
    898878,
    988889,
    878997,
    968777,
    879987,
    778799,
    998767,
    797988,
    787977,
    866787,
    887767,
    977878,
    989778,
    878888,
    789778,
    879789,
    889799,
    878888,
    778788,
    778877,
    798788,
    888777,
    888789,
    996898,
    787888,
    888777,
    787777,
    898888,
    876987,
    888697,
    767767,
    878898,
    876888,
    887867,
    988788,
    987788,
    878988,
    786879,
    877886,
    877778,
    878999,
    789888,
    778877,
    988789,
    868667,
    777898,
    897878,
    979777,
    687868,
    788988,
    877778,
    988877,
    887988,
    878888,
    997879,
    887796,
    888767,
    869879,
    776797,
    887899,
    877867,
    888798,
    888879,
    876987,
    887887,
    789888,
    986868,
    888797,
    877778,
    877888,
    777688,
    899788,
    989988,
    687976,
    886697,
    788778,
    868799,
    887887,
    998977,
    689888,
    889897,
    697799,
    788787,
    988778,
    879789,
    788789,
    889887,
    778678,
    788989,
    897998,
    789898,
    879989,
    777876,
    888778,
    987689,
    867787,
    877967,
    787688,
    787868,
    788686,
    888987,
    889988,
    998878,
    887988,
    879887,
    889896,
    887998,
    788888,
    688787,
    968888,
    889888,
    879787,
    887679,
    887699,
    769888,
    678887,
    788889,
    888779,
    688887,
    897798,
    879887,
    877888,
    978778,
    879998,
    978988,
    786897,
    778787,
    887888,
    778886,
    788977,
    886878,
    889888,
    787887,
    797779,
    888888,
    777878,
    998886,
    776878,
    978988,
    898897,
    877878,
    778997,
    878978,
    798976,
    897787,
    868787,
    877977,
    777778,
    878899,
    897887,
    869788,
    777887,
    867677,
    977888,
    788898,
    888968,
    898788,
    899887,
    878978,
    978989,
    888898,
    979879,
    777778,
    878798,
    777777,
    887788,
    889787,
    978696,
    887797,
    878788,
    998878,
    888888,
    788888,
    876998,
    787887,
    888798,
    778889,
    788988,
    899887,
    988777,
    898896,
    878878,
    877788,
    988878,
    888978,
    799788,
    977888,
    878788,
    987686,
    787887,
    888788,
    879677,
    687889,
    898778,
    877777,
    997687,
    979898,
    979869,
    899997,
    887779,
    777799,
    898798,
    987998,
    898898,
    789688,
    778989,
    878876,
    869679,
    987878,
    888777,
    688789,
    677678,
    677779,
    777698,
    879976,
    887887,
    888988,
    888867,
    867787,
    889698,
    777788,
    889978,
    888877,
    798677,
    896879,
    788678,
    787898,
    897797,
    966889,
    878898,
    899886,
    997888,
    897897,
    889878,
    878979,
    777878,
    878987,
    888879,
    797978,
    777889,
    878876,
    898867,
    788698,
    888888,
    897889,
    888778,
    878886,
    679877,
    977787,
    888779,
    878889,
    879787,
    877678,
    699987,
    687877,
    787887,
    878889,
    979868,
    886897,
    878877,
    887869,
    898797,
    779968,
    887788,
    777879,
    686687,
    877888,
    887687,
    787869,
    878877,
    778897,
    877778,
    988778,
    788878,
    697988,
    788777,
    989988,
    778778,
    888886,
    878999,
    979888,
    988778,
    888967,
    868777,
    876688,
    798887,
    886768,
    788778,
    879787,
    888777,
    888788,
    788898,
    999976,
    768896,
    898878,
    777778,
    976789,
    977797,
    877896,
    977987,
    678778,
    787798,
    797876,
    688678,
    879897,
    977677,
    867688,
    888977,
    898976,
    876777,
    767798,
    877997,
    789888,
    888897,
    778678,
    898898,
    779887,
    797977,
    887697,
    977886,
    888789,
    689767,
    998898,
    778798,
    897789,
    897877,
    987878,
    786789,
    978787,
    878898,
    888789,
    787777,
    887898,
    877888,
    997798,
    878869,
    888887,
    877897,
    776889,
    888767,
    898788,
    996677,
    797877,
    887767,
    879787,
    788699,
    877868,
    977869,
    899878,
    878876,
    978778,
    878788,
    978988,
    988888,
    899789,
    876678,
    688878,
    998779,
    789779,
    888979,
    788789,
    768978,
    888779,
    777889,
    878777,
    967878,
    879898,
    988877,
    776978,
    889777,
    887888,
    798887,
    879767,
    788787,
    788889,
    987878,
    898887,
    788877,
    888997,
    799888,
    777977,
    897888,
    978777,
    879977,
    978989,
    788888,
    787987,
    878689,
    887996,
    988877,
    778899,
    779888,
    787889,
    798989,
    878789,
    777888,
    797788,
    778787,
    968877,
    977688,
    776988,
    998889,
    898989,
    778867,
    987988,
    879879,
    877878,
    879879,
    877689,
    788887,
    997688,
    778888,
    968787,
    877997,
    988787,
    878888,
    877978,
    768789,
    798778,
    869788,
    797788,
    988986,
    877788,
    978877,
    888777,
    798888,
    888888,
    776869,
    798876,
    867799,
    897878,
    878777,
    987689,
    897898,
    876879,
    877977,
    896687,
    776786,
    888868,
    888898,
    799887,
    878689,
    988688,
    899787,
    879978,
    978688,
    898889,
    798888,
    887989,
    887677,
    688788,
    877688,
    878889,
    787887,
    878779,
    798888,
    778898,
    868787,
    778688,
    897887,
    668878,
    877887,
    777688,
    797888,
    879879,
    786897,
    778887,
    786888,
    898768,
    788787,
    787797,
    878879,
    988776,
    886787,
    887878,
    887877,
    878798,
    878877,
    989897,
    897868,
    778898,
    899969,
    868988,
    876787,
    899887,
    887876,
    978977,
    879788,
    866887,
    899888,
    679779,
    677888,
    899778,
    679987,
    677787,
    888797,
    787868,
    789798,
    789886,
    878878,
    797779,
    688799,
    798799,
    778888,
    878877,
    799788,
    788986,
    887989,
    889989,
    887887,
    788778,
    877988,
    877789,
    878697,
    777898,
    889899,
    988877,
    888789,
    888888,
    787887,
    867878,
    677899,
    897888,
    976899,
    988778,
    787777,
    888788,
    889899,
    878797,
    797988,
    979697,
    999898,
    877888,
    989888,
    978878,
    968898,
    787778,
    888878,
    887997,
    768877,
    877898,
    869889,
    777967,
    876889,
    879788,
    876777,
    988879,
    878788,
    877777,
    787998,
    888987,
    878688,
    788898,
    798988,
    798888,
    878886,
    888976,
    878879,
    776977,
    888987,
    866688,
    998898,
    788887,
    877778,
    788788,
    886797,
    967788,
    799778,
    987778,
    987987,
    777888,
    977697,
    878899,
    987878,
    888777,
    788888,
    878889,
    888988,
    999898,
    878989,
    997877,
    986687,
    988877,
    789788,
    877768,
    788678,
    788789,
    697888,
    979977,
    879897,
    989789,
    788788,
    887988,
    898886,
    779878,
    888897,
    696868,
    899698,
    987879,
    886877,
    679886,
    699788,
    896788,
    778878,
    889897,
    799877,
    888878,
    878888,
    778787,
    798887,
    779978,
    797879,
    768778,
    888899,
    877789,
    887887,
    877769,
    997878,
    786878,
    777796,
    778968,
    898789,
    878887,
    768787,
    988878,
    688888,
    776789,
    778667,
    777888,
    879878,
    878788,
    888967,
    788889,
    878899,
    697898,
    877797,
    689977,
    797886,
    988778,
    788888,
    769977,
    688889,
    887788,
    987787,
    978797,
    698898,
    889897,
    787797,
    899898,
    989978,
    888897,
    888877,
    788798,
    687777,
    788889,
    999877,
    778977,
    777787,
    888777,
    879977,
    898897,
    877788,
    787878,
    878988,
    899799,
    789997,
    879799,
    898887,
    877877,
    887988,
    888799,
    878787,
    789967,
    898888,
    878789,
    789988,
    977886,
    986888,
    878788,
    788987,
    888878,
    879699,
    889978,
    778998,
    678998,
    888887,
    877867,
    967887,
    888889,
    789888,
    788877,
    877779,
    877897,
    888687,
    977888,
    977978,
    788777,
    878896,
    789888,
    888677,
    797897,
    787797,
    678788,
    976788,
    788886,
    778888,
    789787,
    797899,
    779788,
    968887,
    977879,
    788887,
    898787,
    678896,
    777889,
    868777,
    789878,
    897887,
    778798,
    888978,
    898798,
    988897,
    788877,
    888777,
    786998,
    976987,
    988798,
    877769,
    987897,
    897988,
    797887,
    798688,
    897797,
    677988,
    778988,
    888888,
    879768,
    898987,
    867779,
    978989,
    789887,
    679977,
    988886,
    678778,
    797989,
    988879,
    888978,
    779697,
    777886,
    889789,
    987868,
    777789,
    999677,
    988779,
    987689,
    997779,
    887886,
    877878,
    888789,
    987869,
    877778,
    698798,
    898789,
    788898,
    796788,
    768877,
    778689,
    889989,
    778878,
    898776,
    797888,
    899968,
    998898,
    698898,
    788898,
    989788,
    888887,
    878878,
    798898,
    789988,
    788788,
    886987,
    788988,
    777887,
    988788,
    799798,
    877877,
    878888,
    777798,
    786797,
    797976,
    888877,
    876996,
    689888,
    977787,
    797876,
    898776,
    788788,
    787968,
    768888,
    877867,
    778997,
    778877,
    768796,
    878886,
    678977,
    886988,
    888888,
    898799,
    786888,
    699686,
    689777,
    878878,
    777889,
    888988,
    977668,
    797998,
    877899,
    888768,
    877889,
    687778,
    878887,
    787976,
    798888,
    789897,
    887886,
    997878,
    888879,
    978878,
    769787,
    778788,
    899887,
    788878,
    877788,
    886887,
    987687,
    978778,
    779878,
    678877,
    788799,
    978878,
    888967,
    887787,
    877677,
    779877,
    887869,
    787877,
    887879,
    888789,
    768887,
    879687,
    797988,
    877787,
    989788,
    797888,
    998887,
    788896,
    878888,
    888779,
    798779,
    897897,
    778887,
    798779,
    668769,
    878787,
    788899,
    868988,
    787887,
    768788,
    798677,
    779877,
    988876,
    887898,
    879898,
    789888,
    877887,
    898888,
    978889,
    868888,
    897777,
    788798,
    978787,
    898879,
    977888,
    889767,
    788788,
    686878,
    989787,
    887898,
    878888,
    987897,
    988889,
    988889,
    779777,
    788797,
    888777,
    689888,
    977798,
    786789,
    788787,
    678898,
    877968,
    876968,
    879779,
    888988,
    887888,
    778789,
    698899,
    768778,
    787768,
    877786,
    787787,
    878889,
    879968,
    778778,
    898978,
    978976,
    997898,
    778877,
    977878,
    788779,
    788888,
    879888,
    777788,
    988989,
    789877,
    988988,
    976687,
    788997,
    798787,
    978888,
    768888,
    777898,
    899867,
    879787,
    898889,
    888868,
    767889,
    988997,
    788787,
    797886,
    897787,
    888897,
    787887,
    867777,
    779898,
    778888,
    778779,
    777979,
    697978,
    987899,
    988889,
    798788,
    897878,
    888878,
    687898,
    867788,
    888788,
    897688,
    788679,
    797878,
    878888,
    868888,
    899878,
    779878,
    787887,
    778887,
    878697,
    787797,
    678777,
    767687,
    877677,
    888798,
    899878,
    879687,
    887896,
    979888,
    897889,
    979879,
    988888,
    987898,
    899779,
    878878,
    797877,
    979978,
    888887,
    779789,
    888887,
    898878,
    678787,
    779788,
    987697,
    798877,
    888889,
    987887,
    778999,
    779998,
    778878,
    798876,
    688688,
    969786,
    788877,
    998878,
    887978,
    987687,
    678887,
    778989,
    887779,
    788788,
    888877,
    988878,
    887878,
    877779,
    979797,
    867776,
    898687,
    779987,
    778989,
    988899,
    878998,
    789898,
    869778,
    788889,
    879978,
    889878,
    998889,
    887696,
    788886,
    888887,
    878879,
    887877,
    988879,
    767799,
    989887,
    898889,
    877879,
    788777,
    887988,
    878687,
    878978,
    897888,
    788978,
    878788,
    778887,
    887798,
    878889,
    878777,
    787886,
    886888,
    788767,
    988776,
    988896,
    887888,
    888968,
    878778,
    887888,
    797988,
    789889,
    877687,
    888787,
    868977,
    797778,
    887886,
    997879,
    869986,
    888798,
    989789,
    998877,
    687789,
    866798,
    797789,
    888777,
    987977,
    868778,
    886678,
    888997,
    868967,
    677698,
    899767,
    888878,
    797878,
    779877,
    799878,
    888989,
    989887,
    778877,
    898886,
    878877,
    897777,
    789778,
    778887,
    887789,
    788789,
    877989,
    788779,
    787787,
    877899,
    799887,
    987886,
    998888,
    677887,
    887889,
    788897,
    787989,
    879888,
    888888,
    898878,
    897888,
    988687,
    886889,
    878889,
    688879,
    878889,
    878988,
    798989,
    889689,
    789999,
    866779,
    788887,
    777789,
    898787,
    677778,
    979887,
    889887,
    978797,
    798779,
    868996,
    789887,
    777967,
    788887,
    987889,
    798778,
    987787,
    789898,
    986788,
    888779,
    789789,
    789987,
    987899,
    888787,
    999878,
    979777,
    787978,
    867788,
    688898,
    877789,
    877878,
    879688,
    787867,
    886787,
    987787,
    888788,
    788897,
    788778,
    787788,
    698887,
    978888,
    887979,
    877889,
    987889,
    887788,
    777778,
    787987,
    797678,
    979988,
    889788,
    876778,
    788787,
    778877,
    878688,
    696687,
    777887,
    897888,
    878777,
    997796,
    889996,
    798897,
    678887,
    888888,
    888978,
    779877,
    786978,
    979789,
    799789,
    887876,
    887887,
    867789,
    986877,
    689869,
    779798,
    788779,
    778978,
    788888,
    797987,
    987887,
    997887,
    888788,
    988788,
    777878,
    788977,
    898688,
    887788,
    867679,
    987778,
    887897,
    776797,
    777878,
    876998,
    778986,
    899877,
    886978,
    887889,
    799888,
    887688,
    769778,
    867998,
    889888,
    898768,
    779879,
    997877,
    769877,
    777787,
    787877,
    988788,
    878889,
    799887,
    699977,
    898768,
    898998,
    898978,
    797778,
    978987,
    798889,
    677796,
    777777,
    778788,
    788798,
    787878,
    778977,
    788777,
    878789,
    976777,
    778888,
    698697,
    787799,
    979897,
    897889,
    898777,
    879887,
    889998,
    878878,
    697788,
    877978,
    787887,
    776888,
    788888,
    788888,
    777777,
    888887,
    887989,
    988688,
    866777,
    798978,
    888879,
    888986,
    877788,
    889797,
    886869,
    888887,
    787877,
    877788,
    788777,
    788778,
    997997,
    898897,
    789977,
    887878,
    777978,
    977679,
    887878,
    888687,
    978889,
    889777,
    798789,
    779899,
    987987,
    778978,
    788787,
    966687,
    877887,
    797987,
    878887,
    868878,
    687998,
    888888,
    967787,
    998886,
    887878,
    688788,
    889889,
    776897,
    978978,
    796888,
    878887,
    876987,
    988779,
    798787,
    997777,
    886898,
    988897,
    698797,
    787888,
    886779,
    879889,
    977988,
    788878,
    889988,
    798899,
    887797,
    876978,
    798777,
    788988,
    889988,
    897986,
    889887,
    886878,
    889879,
    877898,
    998879,
    888898,
    897897,
    896988,
    988776,
    977987,
    878889,
    866778,
    888797,
    978788,
    888888,
    888787,
    888777,
    777798,
    777877,
    887969,
    787989,
    877879,
    978768,
    877898,
    886978,
    697768,
    988888,
    778777,
    787878,
    979897,
    789788,
    986777,
    887987,
    878987,
    789988,
    988678,
    978897,
    878977,
    798778,
    879798,
    888788,
    776987,
    887987,
    788868,
    877898,
    789888,
    898888,
    787876,
    798776,
    889887,
    988778,
    787876,
    876787,
    889678,
    778777,
    989868,
    877968,
    787888,
    776898,
    787687,
    889787,
    788877,
    888897,
    977797,
    988888,
    788896,
    788987,
    698787,
    898987,
    876988,
    788787,
    779978,
    678778,
    877877,
    887767,
    978896,
    788997,
    887978,
    787889,
    878887,
    979988,
    678979,
    789999,
    887776,
    988888,
    978987,
    878777,
    787888,
    897797,
    978879,
    898677,
    687878,
    777878,
    887886,
    979868,
    987978,
    888989,
    769798,
    977988,
    787868,
    897877,
    876878,
    788999,
    988978,
    778867,
    688789,
    787998,
    796888,
    779877,
    778788,
    989887,
    788888,
    777877,
    767888,
    777878,
    698888,
    887699,
    699878,
    887777,
    987787,
    976778,
    779789,
    887778,
    777897,
    679977,
    979787,
    688987,
    789887,
    787978,
    996889,
    988688,
    888878,
    786977,
    797976,
    788878,
    978979,
    688888,
    798886,
    877978,
    778679,
    888889,
    789997,
    878889,
    897886,
    888789,
    787779,
    979979,
    888786,
    879888,
    877877,
    888889,
    888797,
    778898,
    788886,
    876777,
    988878,
    889977,
    779887,
    987787,
    999896,
    888788,
    678887,
    978898,
    889779,
    867879,
    796989,
    788787,
    777777,
    988888,
    987887,
    898887,
    887778,
    697799,
    877888,
    887769,
    887987,
    988877,
    879787,
    798786,
    688979,
    887988,
    869788,
    787798,
    877778,
    788798,
    677977,
    789887,
    777778,
    888978,
    677677,
    888788,
    878896,
    677988,
    897987,
    899879,
    967778,
    788888,
    788888,
    888787,
    986998,
    889889,
    787778,
    888777,
    987687,
    788887,
    899868,
    878977,
    878878,
    877887,
    768687,
    967788,
    789898,
    888767,
    777888,
    899777,
    777797,
    899887,
    787878,
    787799,
    799778,
    978988,
    788867,
    868877,
    787868,
    987876,
    888797,
    777798,
    789678,
    777977,
    789887,
    797777,
    878788,
    889779,
    878869,
    898898,
    898877,
    877878,
    888878,
    879877,
    888778,
    867889,
    898879,
    988889,
    788777,
    877897,
    888786,
    797788,
    887977,
    787886,
    778876,
    876879,
    797788,
    867997,
    879879,
    887978,
    777888,
    888898,
    878777,
    877678,
    899767,
    877788,
    988889,
    788889,
    788866,
    787888,
    987987,
    796777,
    888879,
    788777,
    896887,
    888898,
    899779,
    877778,
    889778,
    889977,
    787979,
    878899,
    978988,
    887876,
    898867,
    997787,
    988778,
    897888,
    987878,
    889999,
    777987,
    988988,
    787888,
    986887,
    889898,
    987787,
    889889,
    888788,
    888776,
    978798,
    977778,
    788977,
    777769,
    787688,
    898769,
    786986,
    887778,
    878998,
    788876,
    799879,
    678787,
    768877,
    679788,
    888788,
    998978,
    798898,
    787789,
    777777,
    767988,
    887787,
    779877,
    778788,
    967897,
    888987,
    977979,
    887888,
    786898,
    868788,
    788987,
    986989,
    787878,
    689977,
    789689,
    888877,
    878888,
    779778,
    788987,
    987778,
    867879,
    788878,
    777687,
    976779,
    888899,
    779879,
    777787,
    888888,
    888887,
    879899,
    887768,
    778899,
    789887,
    878898,
    878798,
    887878,
    987789,
    887788,
    777778,
    768778,
    877788,
    886887,
    968886,
    888779,
    779889,
    796988,
    888777,
    886797,
    888898,
    787877,
    978788,
    777889,
    787878,
    797777,
    878797,
    886878,
    678687,
    997878,
    877887,
    998878,
    998888,
    788989,
    977996,
    987889,
    787878,
    789979,
    867799,
    689787,
    896877,
    878998,
    888798,
    789877,
    868879,
    898878,
    799786,
    986979,
    878767,
    779888,
    876879,
    897888,
    887788,
    967989,
    879888,
    899777,
    898778,
    888887,
    788879,
    869969,
    788878,
    788977,
    887768,
    878977,
    877987,
    888799,
    788987,
    887988,
    688877,
    989877,
    787887,
    978997,
    788677,
    998898,
    896997,
    779776,
    989886,
    687868,
    987778,
    786897,
    788988,
    988899,
    878788,
    878788,
    878788,
    689787,
    778967,
    996779,
    788876,
    887797,
    898878,
    688977,
    779786,
    978798,
    888887,
    888778,
    778778,
    878997,
    789878,
    787788,
    787889,
    879887,
    888898,
    767888,
    878777,
    888999,
    789787,
    686778,
    787886,
    777777,
    798998,
    887799,
    898879,
    889798,
    888968,
    668897,
    889899,
    987668,
    877777,
    787789,
    987778,
    878988,
    899968,
    967888,
    877778,
    887778,
    886888,
    999878,
    777678,
    887988,
    979988,
    798978,
    898778,
    968779,
    978788,
    777778,
    877887,
    988996,
    767878,
    879787,
    887887,
    787668,
    897879,
    988878,
    897897,
    868999,
    998887,
    879798,
    887887,
    787987,
    788787,
    987898,
    978878,
    888868,
    798888,
    897878,
    898798,
    698868,
    789877,
    889997,
    786898,
    889789,
    979879,
    867988,
    897887,
    779997,
    887899,
    787978,
    889978,
    789978,
    877889,
    677866,
    777678,
    798777,
    888678,
    899867,
    989787,
    878888,
    897689,
    788868,
    788996,
    689987,
    789888,
    888797,
    999787,
    887878,
    997689,
    787899,
    878778,
    889778,
    788997,
    888788,
    888888,
    797788,
    686777,
    989778,
    978889,
    978977,
    788778,
    777878,
    879788,
    888889,
    796997,
    987998,
    977778,
    798898,
    888989,
    877787,
    787897,
    989778,
    788899,
    877897,
    777777,
    779878,
    868777,
    787999,
    879889,
    667876,
    788778,
    898678,
    878789,
    778778,
    889888,
    986789,
    878887,
    798878,
    897798,
    878877,
    977778,
    877677,
    898887,
    878778,
    967979,
    787888,
    888778,
    879778,
    788897,
    987867,
    869897,
    877898,
    787997,
    988889,
    799788,
    688879,
    867777,
    898879,
    798987,
    988689,
    698878,
    887776,
    787698,
    688788,
    876978,
    888998,
    977687,
    787896,
    898877,
    987878,
    778699,
    688767,
    987777,
    788677,
    789887,
    888787,
    886887,
    789797,
    977797,
    786887,
    897987,
    898888,
    878788,
    877987,
    787898,
    688788,
    777878,
    887788,
    968987,
    977687,
    779787,
    787798,
    978897,
    989887,
    877978,
    988877,
    788987,
    887999,
    798877,
    878789,
    888788,
    787878,
    897889,
    879878,
    997887,
    899887,
    789798,
    997887,
    898878,
    877769,
    998887,
    788989,
    788888,
    878999,
    787986,
    888798,
    978799,
    889888,
    888987,
    888978,
    878897,
    787788,
    897788,
    997997,
    889788,
    779879,
    797977,
    898788,
    878877,
    876888,
    877878,
    977788,
    987986,
    767978,
    899878,
    897888,
    999978,
    787888,
    887776,
    979988,
    788778,
    877878,
    798879,
    796789,
    787799,
    677787,
    767888,
    779777,
    887788,
    896888,
    987799,
    877777,
    788987,
    689687,
    999877,
    888988,
    879889,
    878789,
    978988,
    778786,
    877998,
    887798,
    998777,
    777777,
    977788,
    788788,
    887787,
    896987,
    877779,
    988788,
    797879,
    889888,
    798798,
    978998,
    889788,
    898888,
    878878,
    677897,
    778878,
    998697,
    888878,
    888777,
    798998,
    877767,
    887678,
    987698,
    797987,
    787978,
    879879,
    887987,
    888868,
    878998,
    788799,
    787789,
    787776,
    898887,
    888889,
    899799,
    768889,
    777879,
    867997,
    888788,
    989788,
    877787,
    668687,
    898786,
    879999,
    888898,
    778799,
    876787,
    898788,
    697777,
    987898,
    799877,
    788877,
    989887,
    877786,
    788888,
    666789,
    879897,
    887889,
    977787,
    896779,
    686878,
    887668,
    878798,
    897888,
    786988,
    787888,
    789978,
    877886,
    878898,
    876888,
    879878,
    888797,
    768888,
    887989,
    988779,
    688798,
    878898,
    897888,
    888767,
    878898,
    778668,
    868777,
    778986,
    789987,
    897789,
    778787,
    887688,
    889797,
    887886,
    889989,
    896788,
    769888,
    687778,
    888686,
    878877,
    798797,
    798889,
    788967,
    778777,
    898888,
    797899,
    897788,
    778687,
    888887,
    797898,
    988788,
    889888,
    779887,
    778788,
    897999,
    888788,
    898879,
    889878,
    978788,
    888799,
    896867,
    767777,
    978989,
    779677,
    888868,
    989889,
    978788,
    886698,
    988897,
    787888,
    889677,
    999787,
    986887,
    797889,
    787988,
    797988,
    888888,
    988779,
    987898,
    787878,
    768688,
    878898,
    888779,
    878878,
    877888,
    787778,
    887788,
    898798,
    878767,
    867776,
    887898,
    988997,
    778887,
    777877,
    778998,
    787899,
    986979,
    969978,
    787977,
    987679,
    796687,
    888976,
    887779,
    878796,
    787888,
    678779,
    698978,
    777789,
    798778,
    778699,
    879688,
    888887,
    887877,
    986789,
    778877,
    777899,
    869877,
    788888,
    689877,
    989877,
    896768,
    887887,
    686779,
    877789,
    969877,
    678979,
    889879,
    798789,
    878788,
    798787,
    979977,
    767877,
    877777,
    877888,
    977878,
    888877,
    678978,
    678888,
    878778,
    798888,
    788888,
    879787,
    988877,
    879678,
    878789,
    798886,
    888787,
    899888,
    877868,
    878778,
    889878,
    988767,
    776889,
    688977,
    888778,
    978888,
    778898,
    988887,
    887979,
    898888,
    768889,
    898779,
    879788,
    988778,
    677878,
    897777,
    887887,
    988788,
    877877,
    888778,
    889778,
    897877,
    878989,
    978897,
    868988,
    978877,
    888879,
    799787,
    697868,
    779988,
    878777,
    698897,
    878777,
    989998,
    878999,
    898787,
    977977,
    888977,
    889879,
    898978,
    877878,
    778878,
    998688,
    789789,
    997988,
    887678,
    799877,
    799979,
    897887,
    789889,
    888976,
    989888,
    979787,
    887887,
    788788,
    897999,
    988699,
    789897,
    789889,
    986679,
    786986,
    898878,
    876786,
    777888,
    787788,
    989678,
    887878,
    777788,
    787788,
    997897,
    688888,
    768677,
    789779,
    888888,
    788878,
    898978,
    677877,
    887888,
    789798,
    777888,
    978877,
    777788,
    867887,
    777789,
    878969,
    897788,
    887788,
    887787,
    888776,
    898776,
    977688,
    997879,
    889889,
    786798,
    989777,
    788677,
    999778,
    888877,
    877677,
    788777,
    976679,
    879877,
    788787,
    888879,
    787997,
    879888,
    877987,
    778787,
    887787,
    689987,
    788868,
    897979,
    897867,
    788888,
    897989,
    889788,
    889977,
    777768,
    687897,
    877888,
    887998,
    887788,
    888796,
    878888,
    878879,
    877768,
    888977,
    889987,
    799679,
    999987,
    778988,
    879878,
    798877,
    888876,
    977688,
    787987,
    888878,
    889788,
    797888,
    767896,
    788777,
    687888,
    888898,
    779978,
    898999,
    788899,
    978787,
    887788,
    879978,
    887677,
    887897,
    789886,
    988798,
    887977,
    669876,
    798888,
    788878,
    898789,
    798878,
    889788,
    787878,
    799788,
    898887,
    698768,
    867796,
    788967,
    987888,
    877887,
    878888,
    688898,
    788879,
    898878,
    988898,
    878879,
    889897,
    877878,
    879988,
    778887,
    878798,
    877798,
    788887,
    979888,
    888678,
    797878,
    787788,
    879789,
    877766,
    798997,
    999788,
    778897,
    789889,
    788867,
    778797,
    798768,
    879788,
    788778,
    889977,
    978888,
    787678,
    976987,
    888888,
    978888,
    978998,
    978777,
    876899,
    988887,
    778699,
    867788,
    897989,
    877988,
    897977,
    778787,
    788988,
    778878,
    888978,
    879788,
    777878,
    887877,
    767767,
    689787,
    889787,
    978798,
    887887,
    777899,
    799888,
    788887,
    988767,
    778868,
    777778,
    879797,
    777778,
    887778,
    887888,
    988798,
    797888,
    778778,
    998899,
    897888,
    989989,
    789777,
    888997,
    888967,
    889967,
    899878,
    888899,
    799678,
    888879,
    777898,
    886898,
    796897,
    669777,
    987768,
    977889,
    778878,
    988779,
    987888,
    887987,
    777886,
    976798,
    887799,
    687998,
    987879,
    889978,
    888677,
    778776,
    888787,
    887988,
    878788,
    878798,
    897889,
    798888,
    887678,
    989979,
    898888,
    886788,
    868987,
    799877,
    788978,
    989987,
    899988,
    887768,
    787776,
    988788,
    877978,
    889897,
    879679,
    988989,
    897988,
    787877,
    888787,
    896888,
    978887,
    777887,
    688779,
    988886,
    896899,
    788879,
    876789,
    779897,
    779766,
    997878,
    977778,
    998878,
    789998,
    777888,
    867978,
    787887,
    777898,
    687688,
    899887,
    889788,
    997869,
    769899,
    898768,
    788788,
    778697,
    886878,
    987888,
    778777,
    897779,
    797977,
    987798,
    988888,
    898678,
    787878,
    868788,
    889797,
    798889,
    787988,
    799887,
    789789,
    778878,
    888787,
    877878,
    887889,
    897887,
    799978,
    887889,
    688788,
    878978,
    888778,
    887888,
    677798,
    897778,
    988787,
    797697,
    886877,
    677677,
    878978,
    987889,
    778897,
    787887,
    788888,
    877989,
    967978,
    888898,
    887877,
    768788,
    888778,
    867897,
    777896,
    776988,
    877998,
    888999,
    867898,
    768787,
    979897,
    898989,
    888978,
    978887,
    797888,
    768988,
    888988,
    779887,
    997879,
    787987,
    898888,
    878877,
    897878,
    876878,
    788977,
    788978,
    887968,
    787787,
    888688,
    777779,
    888788,
    787978,
    888868,
    789789,
    968867,
    798878,
    666867,
    898768,
    869776,
    886978,
    779898,
    887868,
    798987,
    988868,
    878887,
    787777,
    886879,
    899878,
    877898,
    867787,
    697788,
    799688,
    788967,
    796888,
    687987,
    878978,
    988877,
    788888,
    788888,
    798799,
    778787,
    888787,
    898868,
    879976,
    988698,
    878878,
    998977,
    777888,
    868799,
    988878,
    887797,
    879989,
    899988,
    999997,
    788788,
    777877,
    889978,
    868788,
    869798,
    779877,
    897987,
    879787,
    788787,
    788788,
    777977,
    677986,
    887779,
    787879,
    796879,
    988888,
    788788,
    778789,
    986776,
    886776,
    799788,
    797787,
    797978,
    988787,
    787867,
    876896,
    687778,
    778797,
    987999,
    698878,
    796778,
    987798,
    888879,
    988888,
    776899,
    877869,
    878687,
    888977,
    887888,
    798888,
    877789,
    888777,
    798676,
    877778,
    888867,
    999879,
    788887,
    878887,
    888878,
    977677,
    779987,
    789978,
    999887,
    898878,
    888788,
    778999,
    778797,
    889878,
    878887,
    989888,
    877898,
    878886,
    767787,
    879888,
    979798,
    878998,
    889878,
    877977,
    899878,
    799679,
    988787,
    877899,
    988877,
    879778,
    897868,
    879798,
    797798,
    777878,
    878787,
    878778,
    787887,
    899777,
    998887,
    897797,
    876898,
    787778,
    899787,
    787688,
    887999,
    988888,
    689788,
    788899,
    888898,
    978878,
    888888,
    899776,
    778777,
    887777,
    779767,
    979887,
    978889,
    769767,
    978688,
    888878,
    689888,
    898877,
    777799,
    897777,
    889778,
    777999,
    978778,
    988876,
    778987,
    878777,
    878789,
    787688,
    887787,
    879877,
    698777,
    878898,
    888779,
    888888,
    998988,
    986788,
    879789,
    899877,
    898787,
    888786,
    777869,
    789888,
    777798,
    897997,
    797877,
    788787,
    777798,
    787888,
    788988,
    888877,
    879888,
    788779,
    787777,
    889779,
    767877,
    688879,
    879888,
    767888,
    878777,
    898898,
    878768,
    869788,
    787778,
    897989,
    888898,
    879787,
    888897,
    886989,
    899876,
    987798,
    888888,
    877997,
    977887,
    989979,
    997788,
    888877,
    789887,
    878787,
    799788,
    977779,
    877879,
    789778,
    996978,
    878988,
    777899,
    778788,
    977977,
    967897,
    888677,
    777878,
    978878,
    878787,
    878878,
    778788,
    877788,
    888888,
    797887,
    988979,
    868778,
    888896,
    888989,
    878976,
    899897,
    689888,
    788977,
    888789,
    888899,
    899778,
    988888,
    988878,
    889977,
    788778,
    889898,
    889898,
    879778,
    897796,
    879898,
    977887,
    878689,
    997788,
    789898,
    977978,
    798778,
    878888,
    888878,
    789788,
    776899,
    878988,
    898788,
    786987,
    688688,
    787888,
    878978,
    789788,
    887789,
    898978,
    889797,
    979888,
    997888,
    877888,
    887878,
    777877,
    888888,
    986899,
    879989,
    897988,
    878777,
    897869,
    989867,
    699988,
    898778,
    887977,
    788888,
    777777,
    989899,
    877788,
    887966,
    887687,
    788877,
    978877,
    878877,
    798899,
    778787,
    978889,
    897886,
    889788,
    978889,
    777778,
    897978,
    978899,
    978798,
    678778,
    889989,
    999887,
    977878,
    679899,
    799897,
    988877,
    798796,
    987877,
    988889,
    998888,
    999778,
    778896,
    887897,
    878798,
    788889,
    879767,
    797787,
    898888,
    788797,
    797987,
    978979,
    977778,
    788898,
    988987,
    869888,
    777986,
    998787,
    879797,
    679777,
    797678,
    878778,
    789986,
    777888,
    867898,
    878867,
    999798,
    788888,
    788888,
    777899,
    799987,
    987876,
    778798,
    778778,
    889879,
    887998,
    878897,
    886678,
    997878,
    979798,
    898897,
    889987,
    977988,
    878889,
    898898,
    996976,
    797888,
    779677,
    888777,
    967978,
    978788,
    887898,
    777877,
    779996,
    889886,
    777789,
    878798,
    969878,
    798897,
    897787,
    876977,
    889988,
    889887,
    999886,
    888687,
    787787,
    987698,
    888878,
    888769,
    788997,
    777887,
    787876,
    878879,
    887678,
    689878,
    988889,
    989779,
    789887,
    869788,
    879888,
    877978,
    787887,
    878687,
    988789,
    876889,
    879887,
    777869,
    777878,
    888988,
    877788,
    798898,
    798897,
    767888,
    887877,
    789998,
    788888,
    886779,
    898979,
    679978,
    887798,
    897688,
    989788,
    897998,
    788898,
    768788,
    978778,
    798878,
    878888,
    778898,
    868979,
    898877,
    887887,
    788899,
    787889,
    899889,
    877998,
    877688,
    777777,
    799988,
    978798,
    877699,
    887869,
    988977,
    976876,
    888988,
    888978,
    889888,
    887687,
    968778,
    989777,
    888798,
    887987,
    788977,
    987787,
    869997,
    787868,
    786796,
    989888,
    777778,
    687799,
    989877,
    676689,
    877878,
    887777,
    787879,
    968889,
    778679,
    887898,
    897889,
    887787,
    788977,
    889787,
    886776,
    787767,
    688879,
    877997,
    778678,
    888778,
    786977,
    997789,
    888877,
    797977,
    878787,
    878777,
    788878,
    889988,
    898879,
    789998,
    878788,
    977789,
    877987,
    789788,
    977677,
    877779,
    777978,
    687887,
    898777,
    967998,
    886788,
    798988,
    887979,
    877789,
    989888,
    987789,
    788987,
    888687,
    878786,
    768799,
    967998,
    778876,
    777888,
    778678,
    886877,
    877989,
    788977,
    787897,
    969899,
    998978,
    987788,
    888899,
    889986,
    877887,
    979798,
    888889,
    798898,
    978898,
    886788,
    688777,
    677878,
    787778,
    997697,
    788687,
    867787,
    988999,
    778987,
    878686,
    867978,
    778887,
    777888,
    787898,
    986987,
    778877,
    798878,
    887788,
    779667,
    798788,
    866887,
    789897,
    777988,
    777788,
    888779,
    888888,
    887887,
    887878,
    988869,
    997787,
    779779,
    987778,
    879787,
    889897,
    787888,
    666777,
    889777,
    889877,
    878898,
    988887,
    978878,
    888889,
    878788,
    879777,
    796777,
    787798,
    979888,
    887988,
    988888,
    779788,
    878788,
    888789,
    978888,
    889888,
    778778,
    877887,
    979978,
    899888,
    797888,
    978666,
    878988,
    797779,
    888877,
    789679,
    787899,
    767897,
    979877,
    788779,
    977877,
    787787,
    878778,
    978868,
    777688,
    788867,
    878789,
    887777,
    786877,
    788789,
    787886,
    888788,
    878787,
    768789,
    798879,
    898787,
    978888,
    876977,
    788897,
    688888,
    798699,
    978788,
    878866,
    787777,
    876787,
    899878,
    888787,
    899879,
    897867,
    779888,
    898778,
    898789,
    877798,
    878988,
    788988,
    898887,
    688989,
    876778,
    876979,
    776878,
    888887,
    989887,
    778688,
    777986,
    797788,
    896698,
    776976,
    998698,
    988798,
    988798,
    987897,
    788988,
    888777,
    876777,
    788897,
    897767,
    797786,
    977899,
    878779,
    887876,
    778687,
    879987,
    678898,
    899678,
    788788,
    788886,
    977778,
    878887,
    889779,
    988796,
    989787,
    888887,
    988989,
    888898,
    796888,
    679778,
    978878,
    888677,
    988787,
    787878,
    879888,
    787977,
    889888,
    887776,
    777888,
    899777,
    987989,
    988779,
    698888,
    879887,
    778788,
    977887,
    978678,
    798888,
    877887,
    888787,
    788889,
    889997,
    988887,
    979778,
    899688,
    887798,
    967888,
    887878,
    788888,
    667887,
    876888,
    899777,
    879977,
    789898,
    897798,
    968787,
    887888,
    797877,
    889789,
    988779,
    988877,
    878888,
    799777,
    899789,
    878877,
    986887,
    888788,
    778988,
    997877,
    987877,
    888878,
    768679,
    886997,
    878668,
    898888,
    898879,
    797897,
    878988,
    988788,
    787888,
    988798,
    888987,
    879988,
    899876,
    778879,
    888987,
    777888,
    779868,
    898887,
    968798,
    787889,
    979877,
    887887,
    778978,
    997888,
    779887,
    867988,
    988887,
    768887,
    877877,
    898879,
    788988,
    787999,
    879986,
    767978,
    997686,
    888888,
    877889,
    867888,
    878799,
    987778,
    876869,
    887878,
    967688,
    899778,
    989896,
    888789,
    889797,
    887977,
    898789,
    888887,
    889787,
    787687,
    979778,
    898778,
    868787,
    887899,
    786889,
    998899,
    987989,
    779887,
    887778,
    898679,
    888987,
    988878,
    977877,
    796798,
    767879,
    777779,
    978979,
    878697,
    788797,
    977788,
    888977,
    768889,
    778778,
    787778,
    787787,
    778798,
    689889,
    889987,
    978878,
    876996,
    888696,
    788997,
    788789,
    788988,
    788878,
    898798,
    879777,
    879987,
    797688,
    678778,
    779887,
    888796,
    887888,
    989987,
    899768,
    788678,
    788767,
    988788,
    887787,
    797999,
    878786,
    888988,
    876798,
    897778,
    988879,
    888888,
    869878,
    878976,
    788888,
    988978,
    976886,
    898796,
    988788,
    789988,
    788769,
    868789,
    798988,
    897798,
    778777,
    879897,
    787899,
    879777,
    877888,
    878988,
    887786,
    998888,
    878777,
    888978,
    789979,
    978788,
    877799,
    866788,
    778877,
    779978,
    988877,
    867889,
    967877,
    867868,
    877787,
    977787,
    887888,
    878778,
    888877,
    798799,
    898987,
    987888,
    789779,
    878888,
    788779,
    797898,
    888788,
    778979,
    688877,
    788777,
    888879,
    988878,
    886889,
    888977,
    977768,
    698788,
    977896,
    777878,
    777988,
    788887,
    888888,
    868878,
    886877,
    789887,
    678788,
    788899,
    989889,
    787888,
    777887,
    788868,
    898878,
    868899,
    767878,
    989978,
    878876,
    878889,
    688978,
    887888,
    867889,
    788878,
    978978,
    787999,
    986878,
    978888,
    787998,
    787887,
    788778,
    787788,
    798977,
    888979,
    888768,
    978688,
    898789,
    868879,
    877868,
    998889,
    989878,
    888877,
    867799,
    789876,
    887977,
    778677,
    788898,
    978888,
    787897,
    787897,
    998887,
    966779,
    887868,
    888979,
    888868,
    799978,
    778788,
    899798,
    889988,
    777888,
    797978,
    887878,
    779977,
    888788,
    887887,
    776789,
    776778,
    889878,
    888889,
    898788,
    676978,
    787877,
    878866,
    796977,
    877888,
    888888,
    778776,
    878788,
    797879,
    887887,
    888877,
    787788,
    888878,
    968689,
    877978,
    777897,
    968786,
    878789,
    769978,
    888879,
    876989,
    779877,
    888879,
    997879,
    968688,
    987968,
    777799,
    776887,
    888888,
    888768,
    786777,
    876886,
    777889,
    889888,
    698888,
    978778,
    867778,
    877767,
    778788,
    888778,
    898886,
    777778,
    987777,
    868697,
    778688,
    977898,
    778888,
    789988,
    887887,
    888778,
    887787,
    687977,
    787777,
    877787,
    798978,
    788987,
    887867,
    877787,
    877778,
    978799,
    786688,
    898688,
    979888,
    988897,
    687997,
    888776,
    989697,
    866779,
    877786,
    687679,
    779899,
    778778,
    888988,
    978788,
    878788,
    877876,
    787877,
    868788,
    887688,
    788678,
    788978,
    878777,
    988887,
    788797,
    769898,
    978888,
    879888,
    798677,
    787977,
    777888,
    768789,
    889778,
    987978,
    878778,
    797887,
    788799,
    777888,
    787688,
    888869,
    879868,
    887878,
    978878,
    798766,
    889889,
    888699,
    888888,
    699998,
    998778,
    897968,
    888779,
    877778,
    867888,
    997878,
    678888,
    789978,
    889978,
    877888,
    997798,
    788799,
    978987,
    787888,
    777788,
    797989,
    888887,
    888978,
    787878,
    787778,
    879678,
    698689,
    888988,
    766988,
    887767,
    899789,
    997699,
    997889,
    877877,
    978878,
    876887,
    888899,
    788877,
    887778,
    887788,
    988679,
    888867,
    788778,
    887789,
    788889,
    799878,
    786999,
    888779,
    788897,
    788688,
    888888,
    878997,
    768787,
    788897,
    788787,
    978789,
    788869,
    798878,
    897978,
    787889,
    987697,
    877897,
    868978,
    977879,
    778897,
    878778,
    788878,
    797779,
    877977,
    978988,
    769797,
    877988,
    798789,
    879778,
    786887,
    988879,
    977899,
    879998,
    678987,
    777887,
    897979,
    877987,
    788976,
    888888,
    768989,
    786978,
    678878,
    767687,
    888788,
    679886,
    898897,
    997888,
    878777,
    888786,
    786879,
    887998,
    978898,
    778888,
    987777,
    888897,
    688997,
    878987,
    777698,
    688987,
    888787,
    977969,
    776988,
    787878,
    998689,
    789987,
    888968,
    999798,
    898997,
    968897,
    787787,
    978779,
    889898,
    789788,
    888877,
    986877,
    998888,
    899777,
    896988,
    787798,
    888687,
    977869,
    798788,
    697897,
    766887,
    978987,
    768797,
    987887,
    888796,
    877888,
    878878,
    877887,
    779889,
    887886,
    979888,
    968867,
    978888,
    888878,
    986879,
    988889,
    777789,
    867788,
    876777,
    788988,
    687787,
    988778,
    978888,
    898888,
    699698,
    798898,
    777877,
    879688,
    878887,
    878969,
    899779,
    788878,
    788788,
    997988,
    898877,
    987778,
    898788,
    977877,
    897997,
    898789,
    778897,
    877887,
    789799,
    878898,
    977779,
    988979,
    888888,
    897878,
    899777,
    788887,
    888987,
    788778,
    797889,
    798896,
    977887,
    788797,
    887979,
    989889,
    888979,
    877878,
    688788,
    869798,
    988988,
    898888,
    788899,
    788778,
    988977,
    887877,
    868768,
    897879,
    888887,
    768896,
    989788,
    877988,
    688789,
    778888,
    888788,
    888789,
    877787,
    877878,
    788788,
    988787,
    887876,
    879877,
    889778,
    787877,
    768869,
    898778,
    887887,
    789998,
    777877,
    877998,
    788988,
    789888,
    988878,
    878688,
    868887,
    788788,
    978878,
    977877,
    787776,
    786898,
    899788,
    899888,
    988877,
    888987,
    797887,
    887787,
    899876,
    876978,
    877878,
    698978,
    879878,
    887778,
    978888,
    897899,
    878777,
    898897,
    877998,
    788788,
    997886,
    888786,
    778898,
    898899,
    878787,
    778996,
    898989,
    868879,
    787787,
    778778,
    877778,
    967687,
    787778,
    898888,
    769888,
    987768,
    767778,
    798789,
    868878,
    878798,
    888888,
    978878,
    867878,
    778779,
    968787,
    777888,
    898898,
    888778,
    888698,
    788987,
    698976,
    778887,
    788888,
    796878,
    888977,
    778789,
    889878,
    978876,
    778878,
    777899,
    788788,
    887879,
    897786,
    787787,
    887999,
    887887,
    888798,
    779999,
    888888,
    988978,
    889899,
    898889,
    779777,
    987889,
    989889,
    889898,
    987776,
    877688,
    887888,
    988779,
    978978,
    867879,
    887887,
    897986,
    999778,
    889788,
    788798,
    688977,
    776978,
    798788,
    778887,
    879798,
    977797,
    768886,
    887898,
    787878,
    888779,
    898897,
    888778,
    888897,
    777777,
    787798,
    979867,
    788667,
    898788,
    878887,
    788987,
    768896,
    887897,
    898968,
    777887,
    877668,
    888788,
    787889,
    877789,
    877998,
    886878,
    898789,
    796887,
    896787,
    889878,
    977877,
    887977,
    898888,
    799899,
    787769,
    889977,
    878989,
    878877,
    988797,
    798898,
    777789,
    999977,
    989788,
    887787,
    898777,
    797988,
    977777,
    977877,
    886787,
    867779,
    789888,
    778787,
    778889,
    986899,
    977988,
    879677,
    898889,
    888788,
    978886,
    688678,
    788877,
    888778,
    698887,
    787878,
    879888,
    887888,
    777877,
    887899,
    898888,
    688787,
    797898,
    879678,
    877797,
    998689,
    788679,
    679888,
    986777,
    778888,
    889889,
    999789,
    888988,
    788778,
    869779,
    897888,
    977787,
    868988,
    898888,
    999897,
    987979,
    968989,
    888978,
    888788,
    776788,
    879878,
    787768,
    988989,
    788877,
    887977,
    879997,
    788789,
    788867,
    878888,
    779887,
    888897,
    897868,
    876888,
    877789,
    789888,
    878898,
    788878,
    897889,
    688979,
    988887,
    878989,
    887798,
    979887,
    768887,
    978798,
    869688,
    867997,
    788877,
    877879,
    887987,
    887889,
    988977,
    889878,
    788678,
    888898,
    868978,
    788878,
    879798,
    798778,
    998887,
    889776,
    798877,
    697787,
    689888,
    778688,
    887776,
    996989,
    778988,
    979868,
    788887,
    877897,
    887869,
    688877,
    888897,
    898688,
    878887,
    787898,
    888887,
    779986,
    888786,
    988889,
    767797,
    768789,
    987788,
    889797,
    898898,
    877889,
    989979,
    988768,
    967878,
    797898,
    888778,
    889979,
    798897,
    877878,
    688789,
    877778,
    888797,
    898887,
    879978,
    979998,
    779898,
    988899,
    877778,
    688778,
    779897,
    878889,
    777978,
    777869,
    878689,
    779877,
    896887,
    897778,
    896879,
    878888,
    989986,
    888797,
    887989,
    988988,
    779898,
    778779,
    878987,
    898897,
    769876,
    699897,
    887886,
    888978,
    887978,
    788878,
    867788,
    768687,
    789887,
    978887,
    768788,
    888987,
    687878,
    679778,
    779769,
    788878,
    788678,
    897987,
    867989,
    997889,
    777788,
    879876,
    899989,
    978878,
    777899,
    887698,
    777888,
    987887,
    888796,
    797787,
    897787,
    878896,
    776988,
    988878,
    898886,
    877887,
    778878,
    787897,
    988679,
    877897,
    987887,
    888679,
    987888,
    988887,
    878697,
    888888,
    787787,
    788898,
    887888,
    886889,
    968787,
    787988,
    889887,
    888887,
    978989,
    888777,
    968787,
    798898,
    997878,
    988897,
    868778,
    778889,
    878868,
    787788,
    878897,
    887877,
    799787,
    778878,
    877768,
    877888,
    888997,
    878778,
    788896,
    798879,
    888897,
    897787,
    977978,
    888788,
    888877,
    788896,
    899778,
    787788,
    969876,
    897887,
    887987,
    998898,
    898888,
    788878,
    898698,
    987767,
    689999,
    877888,
    879888,
    878999,
    798777,
    787788,
    989887,
    777778,
    977797,
    898787,
    977887,
    778797,
    878888,
    976889,
    999787,
    878779,
    769779,
    888979,
    888777,
    968898,
    877699,
    887867,
    888889,
    799977,
    789888,
    887888,
    699887,
    887896,
    778866,
    798899,
    887877,
    988898,
    877788,
    898979,
    877988,
    987768,
    869878,
    889788,
    787979,
    989787,
    787888,
    887778,
    879797,
    977879,
    887887,
    788878,
    868898,
    887787,
    789788,
    987797,
    997888,
    988787,
    778887,
    878878,
    887887,
    868897,
    797969,
    987779,
    789878,
    867989,
    888878,
    897797,
    889789,
    969978,
    889988,
    798978,
    777797,
    877988,
    887889,
    799777,
    878887,
    888869,
    797879,
    896979,
    888889,
    668789,
    867987,
    879897,
    888797,
    788867,
    777887,
    988896,
    899977,
    878697,
    877978,
    778888,
    887879,
    877688,
    896779,
    867979,
    889778,
    797887,
    788799,
    888887,
    786998,
    877776,
    887887,
    968777,
    788887,
    898968,
    786877,
    788788,
    887787,
    777778,
    768897,
    898798,
    778768,
    888897,
    878799,
    777887,
    788897,
    786897,
    976978,
    989877,
    797767,
    798989,
    689878,
    797788,
    879986,
    797987,
    988778,
    777968,
    679889,
    977989,
    888978,
    898889,
    777697,
    788877,
    978886,
    779988,
    779986,
    887778,
    867797,
    899987,
    889988,
    778879,
    788978,
    787887,
    877979,
    889887,
    887789,
    778888,
    878676,
    988778,
    879867,
    877978,
    987997,
    898779,
    766999,
    779778,
    979879,
    778967,
    898688,
    798999,
    878878,
    979889,
    789798,
    989788,
    987769,
    879978,
    987679,
    887786,
    798787,
    799866,
    988888,
    788797,
    987788,
    778979,
    888678,
    988888,
    899988,
    977987,
    787987,
    899988,
    898788,
    997677,
    878999,
    968688,
    877977,
    779889,
    988977,
    778787,
    898777,
    788788,
    868888,
    889779,
    899797,
    978788,
    887687,
    797878,
    898878,
    889779,
    899978,
    888897,
    889869,
    987888,
    978877,
    777898,
    888878,
    878898,
    889777,
    977878,
    987988,
    977779,
    988778,
    878799,
    988878,
    787977,
    988979,
    879788,
    899787,
    897888,
    888786,
    788977,
    778677,
    987789,
    787788,
    678777,
    686778,
    898877,
    868888,
    897896,
    888777,
    978876,
    798887,
    787878,
    888986,
    876779,
    679789,
    778778,
    887879,
    879897,
    977997,
    788999,
    887979,
    888889,
    878789,
    888777,
    876888,
    786889,
    888778,
    688888,
    888887,
    978778,
    977798,
    969887,
    888889,
    998798,
    897697,
    788787,
    788698,
    988797,
    898898,
    986787,
    986798,
    887989,
    978778,
    787788,
    697879,
    977878,
    677899,
    967888,
    897878,
    987789,
    888798,
    968986,
    989779,
    878888,
    787978,
    887887,
    897789,
    878888,
    977887,
    887887,
    788888,
    878978,
    877888,
    978888,
    688787,
    887878,
    987678,
    767888,
    777868,
    897988,
    789888,
    878788,
    896878,
    888887,
    767678,
    879898,
    878797,
    789889,
    989896,
    779787,
    988787,
    777777,
    888778,
    698887,
    797898,
    778888,
    778788,
    787799,
    788989,
    877798,
    796787,
    878998,
    667777,
    876878,
    887877,
    879868,
    879679,
    868788,
    887798,
    877878,
    789776,
    888788,
    898698,
    889899,
    787777,
    988878,
    799887,
    788886,
    896897,
    987889,
    778889,
    988868,
    867887,
    788898,
    887898,
    888868,
    688887,
    898888,
    878977,
    998788,
    888886,
    877786,
    867779,
    879888,
    886887,
    788868,
    779978,
    997899,
    797688,
    868889,
    787888,
    787877,
    887987,
    886798,
    986887,
    878788,
    988697,
    789778,
    788788,
    798768,
    978878,
    868977,
    877876,
    789888,
    788878,
    897789,
    778897,
    978899,
    788788,
    977777,
    688789,
    768787,
    687877,
    898677,
    879898,
    997967,
    876997,
    887879,
    887877,
    778899,
    778887,
    799998,
    699778,
    788778,
    887898,
    877676,
    898787,
    899787,
    667877,
    989877,
    688888,
    887876,
    788888,
    788887,
    777978,
    778868,
    897878,
    788887,
    887979,
    888988,
    897989,
    997678,
    879899,
    896988,
    897889,
    978879,
    887888,
    778788,
    878898,
    799788,
    787987,
    978977,
    789778,
    788889,
    768896,
    799788,
    888888,
    888866,
    869879,
    887889,
    787889,
    888777,
    798788,
    789968,
    779888,
    879779,
    788788,
    778786,
    878767,
    988799,
    787987,
    899788,
    786788,
    776878,
    678777,
    977777,
    797977,
    987888,
    898779,
    788698,
    887868,
    967787,
    899777,
    778887,
    689877,
    887878,
    799697,
    978877,
    879788,
    887898,
    669779,
    778778,
    798887,
    888788,
    788778,
    998978,
    788886,
    898768,
    787788,
    698988,
    878888,
    968888,
    788899,
    878787,
    786789,
    887989,
    889788,
    777876,
    887779,
    777898,
    887897,
    886887,
    788797,
    788687,
    787988,
    978998,
    998787,
    888879,
    888888,
    998786,
    777889,
    888887,
    997879,
    877987,
    798777,
    777779,
    787988,
    898878,
    877877,
    869687,
    989978,
    878798,
    689787,
    988889,
    788798,
    788787,
    786887,
    888778,
    878886,
    998776,
    679878,
    887988,
    977787,
    687886,
    777887,
    788688,
    678786,
    888799,
    678979,
    866887,
    977788,
    786799,
    888787,
    988789,
    899776,
    687896,
    768767,
    788898,
    789678,
    878788,
    977777,
    979897,
    876877,
    987786,
    977788,
    887897,
    898989,
    988787,
    887897,
    877897,
    789888,
    888978,
    979777,
    879887,
    867977,
    998789,
    779889,
    878987,
    777986,
    889897,
    967779,
    988788,
    887969,
    987887,
    778798,
    777888,
    968888,
    887798,
    778887,
    897697,
    778888,
    998899,
    876777,
    879796,
    797768,
    878789,
    898879,
    777878,
    868689,
    987788,
    989787,
    878788,
    877787,
    878789,
    979778,
    877878,
    988778,
    789679,
    788786,
    879888,
    878789,
    697888,
    969999,
    887977,
    678888,
    778788,
    697988,
    779887,
    889787,
    987788,
    768888,
    878887,
    878888,
    888678,
    797876,
    888988,
    977778,
    797889,
    998777,
    887797,
    987886,
    797876,
    968769,
    777877,
    888778,
    897789,
    879987,
    878888,
    677978,
    887799,
    888889,
    788878,
    989788,
    768787,
    999699,
    887688,
    879877,
    797998,
    997877,
    889787,
    899788,
    798867,
    778797,
    887877,
    888888,
    877889,
    987999,
    877777,
    967986,
    988788,
    988897,
    789779,
    777799,
    788988,
    987787,
    688788,
    977889,
    888989,
    878687,
    988788,
    877988,
    787777,
    879868,
    787967,
    888879,
    886788,
    868878,
    888976,
    888888,
    789789,
    889989,
    888877,
    877867,
    988888,
    779788,
    888879,
    877796,
    789887,
    778797,
    687879,
    788867,
    778997,
    997979,
    887796,
    778988,
    688777,
    688999,
    777788,
    888988,
    777688,
    797897,
    888896,
    877888,
    897788,
    888878,
    888799,
    778788,
    877888,
    897889,
    878779,
    888879,
    787888,
    868787,
    977777,
    887886,
    878788,
    978987,
    688678,
    887686,
    879679,
    777877,
    778897,
    897898,
    779977,
    686987,
    976898,
    788977,
    688789,
    898886,
    779689,
    879888,
    787999,
    688788,
    777988,
    877799,
    888679,
    868997,
    877676,
    868888,
    897889,
    877897,
    888877,
    687878,
    999987,
    988797,
    989898,
    789898,
    979688,
    878778,
    789889,
    987978,
    898988,
    797997,
    889889,
    897889,
    988887,
    979876,
    888698,
    787677,
    777789,
    987688,
    798897,
    997887,
    878777,
    798777,
    778768,
    977998,
    787887,
    887889,
    796978,
    889798,
    988887,
    778878,
    787878,
    787789,
    679978,
    889899,
    877788,
    779877,
    777778,
    987777,
    978888,
    798787,
    878896,
    887888,
    898777,
    979887,
    978877,
    878898,
    776777,
    879789,
    988879,
    877987,
    798798,
    779776,
    886778,
    878896,
    779776,
    888978,
    977889,
    787787,
    789887,
    788989,
    987777,
    778989,
    867898,
    878879,
    797898,
    979698,
    889979,
    888887,
    878788,
    788797,
    998877,
    798878,
    778998,
    688988,
    887688,
    788797,
    987997,
    889787,
    768987,
    887978,
    888878,
    797797,
    777889,
    787887,
    877788,
    687888,
    788988,
    888988,
    878679,
    998779,
    779887,
    888778,
    779898,
    787798,
    777889,
    888987,
    687998,
    799889,
    889898,
    687889,
    888787,
    799998,
    868886,
    789889,
    999877,
    898979,
    978888,
    798877,
    776779,
    787879,
    987767,
    796998,
    777887,
    678988,
    887897,
    897878,
    988989,
    787786,
    778986,
    976688,
    788789,
    697888,
    978887,
    897787,
    898688,
    897878,
    889798,
    778887,
    888979,
    788879,
    886877,
    968888,
    898799,
    878879,
    879978,
    868867,
    898869,
    877988,
    877987,
    779879,
    687899,
    977778,
    888889,
    988869,
    867889,
    877786,
    878978,
    887887,
    878878,
    887786,
    788877,
    867797,
    899878,
    898888,
    787987,
    887888,
    889787,
    787776,
    878986,
    878866,
    887677,
    987878,
    988777,
    788776,
    898877,
    888868,
    788887,
    898888,
    998888,
    778767,
    899787,
    868878,
    987978,
    877986,
    796989,
    669888,
    698778,
    678997,
    787768,
    998887,
    787899,
    779887,
    876678,
    779678,
    788777,
    879989,
    788778,
    788889,
    776999,
    788897,
    797788,
    778988,
    999878,
    786889,
    878897,
    877788,
    888968,
    788987,
    779879,
    787777,
    799789,
    877898,
    876979,
    988778,
    887888,
    988787,
    868887,
    978797,
    898878,
    887788,
    898887,
    788888,
    887777,
    879798,
    997888,
    787798,
    876769,
    878888,
    789897,
    798778,
    788898,
    788888,
    877899,
    889987,
    687878,
    888697,
    988797,
    879789,
    879877,
    897788,
    778897,
    889777,
    887778,
    888787,
    777888,
    878689,
    797886,
    787786,
    787877,
    886889,
    788896,
    798788,
    899888,
    687899,
    888798,
    979888,
    776887,
    798887,
    867978,
    897779,
    687878,
    788997,
    776788,
    877999,
    887798,
    787878,
    887966,
    888787,
    698876,
    778779,
    977787,
    787788,
    677688,
    898797,
    998799,
    898898,
    889978,
    879798,
    998889,
    889869,
    988888,
    878777,
    878877,
    977886,
    869879,
    888897,
    887897,
    988798,
    698877,
    878997,
    868787,
    878778,
    787888,
    788776,
    888888,
    688797,
    997878,
    888788,
    769667,
    796879,
    988679,
    898688,
    999789,
    786888,
    899987,
    887887,
    988779,
    897777,
    769787,
    967887,
    779878,
    778969,
    887988,
    897797,
    687888,
    878977,
    788878,
    677787,
    878877,
    878868,
    777778,
    889797,
    878787,
    697788,
    787886,
    888787,
    888978,
    887788,
    888897,
    778787,
    698887,
    778898,
    879978,
    778997,
    898899,
    878979,
    688878,
    878898,
    987997,
    988898,
    788798,
    877798,
    887687,
    888787,
    899888,
    898897,
    798988,
    798898,
    898876,
    979896,
    778888,
    888698,
    698878,
    899678,
    888788,
    789777,
    789797,
    987878,
    888978,
    798878,
    778767,
    789788,
    798978,
    778987,
    777778,
    878679,
    777799,
    878687,
    688887,
    889878,
    888897,
    788798,
    778778,
    888777,
    786777,
    898969,
    897999,
    886778,
    888887,
    798898,
    989889,
    899787,
    986778,
    977696,
    888887,
    877877,
    788986,
    789886,
    787878,
    778878,
    787897,
    778968,
    989878,
    877679,
    979797,
    899898,
    788687,
    687789,
    786778,
    989988,
    986999,
    889878,
    778887,
    869879,
    887796,
    876788,
    787769,
    987789,
    878879,
    888988,
    888977,
    788798,
    888977,
    878897,
    687998,
    798779,
    878768,
    988777,
    888877,
    987696,
    987687,
    877788,
    888678,
    886888,
    669887,
    886878,
    878978,
    888879,
    867877,
    688778,
    867788,
    789778,
    799888,
    797887,
    668879,
    796877,
    978768,
    689786,
    868879,
    898778,
    877788,
    787786,
    989788,
    778878,
    988788,
    878987,
    978989,
    887797,
    779879,
    787878,
    979988,
    879877,
    788767,
    679879,
    889877,
    997799,
    888978,
    878997,
    987987,
    778888,
    977777,
    789887,
    898988,
    877877,
    987788,
    987789,
    987877,
    788797,
    998868,
    888877,
    798798,
    787988,
    888787,
    778988,
    986686,
    897886,
    998879,
    877899,
    988879,
    997788,
    799987,
    877988,
    878878,
    878878,
    999798,
    789788,
    988899,
    898678,
    798978,
    688889,
    878789,
    978778,
    877877,
    798868,
    887878,
    879976,
    977799,
    887886,
    788797,
    789687,
    787996,
    678678,
    898979,
    996678,
    788897,
    867779,
    777878,
    888897,
    889878,
    878677,
    978786,
    877888,
    798879,
    888768,
    887898,
    868879,
    788887,
    798987,
    787689,
    987888,
    879898,
    888876,
    779978,
    989888,
    678888,
    888777,
    787888,
    886989,
    897988,
    878788,
    777787,
    888888,
    798786,
    989886,
    888798,
    768988,
    987788,
    887889,
    998887,
    876888,
    887788,
    889777,
    977886,
    799888,
    787889,
    988897,
    787877,
    888977,
    888987,
    888789,
    988887,
    877787,
    779788,
    788878,
    889789,
    797998,
    987878,
    797779,
    976988,
    698878,
    877889,
    778777,
    889768,
    787687,
    667877,
    878866,
    769888,
    868897,
    877876,
    878878,
    897778,
    887887,
    898897,
    887987,
    789897,
    987889,
    878786,
    788697,
    667899,
    788798,
    779988,
    878979,
    977887,
    888867,
    897888,
    788788,
    897668,
    667968,
    787797,
    878888,
    987787,
    987679,
    877889,
    778786,
    888899,
    798887,
    888877,
    887888,
    878888,
    978788,
    777978,
    777886,
    797879,
    668698,
    888876,
    988988,
    887889,
    688888,
    876887,
    898897,
    987798,
    897977,
    788798,
    889988,
    888788,
    877888,
    887897,
    869978,
    776978,
    887788,
    767888,
    876798,
    898877,
    867987,
    777888,
    687998,
    979789,
    988887,
    798877,
    879787,
    677988,
    798788,
    888869,
    898899,
    779788,
    876878,
    877898,
    778887,
    988779,
    997887,
    799888,
    877887,
    886878,
    987698,
    789888,
    798779,
    877876,
    976868,
    887897,
    787898,
    776897,
    878897,
    887888,
    899678,
    978998,
    888877,
    987898,
    897797,
    677897,
    778778,
    777786,
    878977,
    779787,
    777898,
    879878,
    898868,
    887888,
    796688,
    988888,
    868979,
    988787,
    978877,
    888878,
    689777,
    998876,
    777887,
    899869,
    689887,
    797889,
    797879,
    787978,
    798788,
    877899,
    878997,
    887867,
    888677,
    868878,
    888887,
    897778,
    889988,
    788898,
    779787,
    878887,
    887888,
    799877,
    877978,
    788887,
    887878,
    877887,
    987787,
    788887,
    867886,
    987878,
    888677,
    677877,
    777988,
    889798,
    878877,
    687778,
    797868,
    778869,
    886878,
    789988,
    789878,
    878897,
    978987,
    798768,
    786789,
    878789,
    888787,
    967787,
    979877,
    889988,
    777798,
    877687,
    788778,
    898878,
    887868,
    878788,
    798987,
    977788,
    979878,
    777769,
    888887,
    789777,
    798787,
    887977,
    789798,
    877787,
    887878,
    878889,
    898799,
    788687,
    888989,
    778889,
    886788,
    787878,
    798867,
    878987,
    889887,
    878788,
    887798,
    677788,
    879879,
    989968,
    787878,
    878998,
    886788,
    777777,
    879688,
    797789,
    887898,
    698877,
    879897,
    887886,
    987789,
    788789,
    778888,
    777878,
    879977,
    888687,
    676868,
    789887,
    777987,
    687978,
    789777,
    898778,
    787878,
    988978,
    979897,
    899988,
    778788,
    788998,
    777787,
    988888,
    887988,
    887787,
    878798,
    897888,
    798677,
    799888,
    888878,
    789798,
    888779,
    777779,
    897878,
    897889,
    889888,
    879867,
    988888,
    787877,
    887977,
    779889,
    979779,
    678799,
    989678,
    976797,
    868778,
    888879,
    796699,
    789997,
    798787,
    988988,
    787797,
    868688,
    677696,
    987787,
    899878,
    887897,
    799789,
    877897,
    876887,
    697789,
    797788,
    897789,
    888787,
    989988,
    777778,
    979679,
    786888,
    679887,
    876888,
    868786,
    979797,
    777788,
    987788,
    798788,
    778897,
    878888,
    887898,
    998797,
    888797,
    986797,
    888899,
    899789,
    987989,
    788789,
    898887,
    878876,
    997678,
    888989,
    997787,
    876787,
    898987,
    888878,
    878987,
    887787,
    867877,
    877689,
    879899,
    787998,
    889979,
    878877,
    796787,
    688888,
    978767,
    898988,
    888769,
    888987,
    877888,
    988897,
    887767,
    687798,
    886877,
    787687,
    798999,
    788888,
    989888,
    768788,
    688988,
    778877,
    967878,
    987777,
    789877,
    778789,
    777877,
    788899,
    887776,
    987977,
    898777,
    798788,
    988788,
    887788,
    898679,
    998799,
    778899,
    878896,
    687888,
    988889,
    688788,
    888977,
    788988,
    779978,
    896778,
    677798,
    787899,
    988797,
    889877,
    878888,
    787789,
    788988,
    788788,
    797977,
    979888,
    886878,
    698786,
    787778,
    877777,
    977899,
    988978,
    987889,
    968886,
    888897,
    698797,
    788797,
    888988,
    988787,
    898887,
    888899,
    778869,
    788888,
    788878,
    998987,
    799889,
    888896,
    878868,
    888978,
    778896,
    687699,
    868787,
    789866,
    777888,
    898879,
    888877,
    998787,
    778766,
    787798,
    898787,
    888877,
    897887,
    988898,
    887668,
    988779,
    978877,
    877797,
    786887,
    677778,
    887898,
    767779,
    868897,
    997888,
    979997,
    787788,
    997788,
    887987,
    887986,
    689878,
    887778,
    688778,
    888688,
    998987,
    988878,
    897678,
    877779,
    888688,
    976789,
    677879,
    788879,
    777886,
    888787,
    878877,
    888789,
    897779,
    788898,
    967877,
    886788,
    977797,
    887777,
    677767,
    788876,
    788878,
    688776,
    887777,
    777898,
    887967,
    888777,
    779888,
    888777,
    778776,
    888877,
    787789,
    898877,
    697899,
    977788,
    676888,
    977787,
    977898,
    997986,
    979688,
    788778,
    877797,
    879877,
    877988,
    789667,
    876899,
    869798,
    868887,
    898977,
    796886,
    667879,
    789876,
    879787,
    887967,
    778888,
    798877,
    887877,
    988778,
    779877,
    887888,
    777988,
    879988,
    887767,
    677977,
    889898,
    978889,
    868978,
    987998,
    979898,
    797997,
    886877,
    879797,
    687888,
    887888,
    986778,
    868877,
    977788,
    778897,
    788677,
    669798,
    878979,
    887679,
    888799,
    788677,
    789898,
    677987,
    977779,
    977788,
    797788,
    878898,
    986766,
    897898,
    867897,
    977888,
    887877,
    897898,
    988898,
    796687,
    889897,
    979879,
    996788,
    687898,
    778797,
    788867,
    977789,
    897778,
    889788,
    887787,
    777887,
    889888,
    777877,
    778888,
    777887,
    799789,
    879779,
    879788,
    888997,
    778998,
    988788,
    889967,
    978887,
    778978,
    898878,
    888787,
    888888,
    778688,
    887989,
    887897,
    888878,
    677887,
    878787,
    787786,
    888878,
    788887,
    778778,
    868787,
    999779,
    687668,
    798988,
    888898,
    987799,
    889697,
    768878,
    897799,
    778788,
    789796,
    889778,
    699978,
    788888,
    888778,
    888987,
    687888,
    887989,
    979998,
    899877,
    787868,
    969869,
    987999,
    878888,
    898978,
    797988,
    878786,
    886877,
    988898,
    967789,
    768786,
    797877,
    889878,
    887878,
    799888,
    698877,
    797898,
    888979,
    978768,
    998976,
    987898,
    787896,
    778867,
    887776,
    887986,
    877877,
    868978,
    787887,
    898787,
    787788,
    896689,
    788887,
    989778,
    889898,
    888697,
    888877,
    878778,
    779797,
    668788,
    887887,
    878769,
    778979,
    897987,
    889788,
    888978,
    888786,
    989877,
    779678,
    987789,
    888768,
    788776,
    886987,
    887797,
    877879,
    888779,
    788988,
    889898,
    787688,
    867797,
    678878,
    786787,
    899888,
    699988,
    877888,
    888898,
    787899,
    677789,
    798789,
    778878,
    777997,
    878878,
    878889,
    777789,
    867977,
    869798,
    887789,
    877767,
    778888,
    989878,
    967988,
    887777,
    878789,
    777988,
    777779,
    887978,
    876887,
    887888,
    778888,
    988989,
    898768,
    869786,
    878776,
    798767,
    788888,
    886998,
    778888,
    887888,
    978898,
    779779,
    967987,
    787888,
    987969,
    787977,
    878887,
    786699,
    969677,
    797866,
    888778,
    988688,
    978887,
    789787,
    798967,
    697789,
    889778,
    669789,
    788799,
    897998,
    788978,
    888689,
    887789,
    678698,
    799768,
    777679,
    677967,
    888888,
    788878,
    768767,
    897998,
    779998,
    686698,
    788877,
    798877,
    889877,
    888788,
    989878,
    778789,
    877979,
    768779,
    898797,
    779766,
    888988,
    978789,
    887887,
    888988,
    868697,
    779797,
    788877,
    886989,
    679877,
    879996,
    877697,
    768787,
    778877,
    879777,
    688789,
    889789,
    987789,
    878779,
    879987,
    788789,
    878877,
    878788,
    777886,
    878897,
    688987,
    887987,
    878886,
    788777,
    877897,
    689889,
    797978,
    788887,
    687889,
    989998,
    899868,
    786978,
    787869,
    766789,
    688779,
    768988,
    787879,
    889898,
    888888,
    887899,
    677888,
    976877,
    868787,
    979797,
    788888,
    798878,
    878867,
    877797,
    767788,
    878797,
    878898,
    777797,
    689777,
    786798,
    677899,
    898989,
    889778,
    888878,
    789987,
    878888,
    988768,
    878787,
    888868,
    786777,
    887897,
    778788,
    778787,
    798876,
    777777,
    778797,
    988899,
    978778,
    789687,
    776987,
    987879,
    877878,
    878989,
    778989,
    897788,
    988878,
    788977,
    789689,
    796886,
    687878,
    879889,
    887898,
    896888,
    887778,
    777698,
    868889,
    987897,
    678778,
    698789,
    967897,
    789887,
    769887,
    897887,
    778878,
    798977,
    897888,
    876987,
    897777,
    978898,
    898878,
    886778,
    887889,
    879969,
    888788,
    877777,
    699778,
    888799,
    777889,
    689877,
    887887,
    887999,
    699889,
    977888,
    877978,
    897887,
    978688,
    788987,
    998887,
    767767,
    968868,
    877977,
    778789,
    898677,
    799878,
    999768,
    977788,
    977988,
    989867,
    998887,
    987788,
    778778,
    877788,
    977798,
    787887,
    977798,
    878978,
    778788,
    977888,
    877998,
    787788,
    887798,
    877877,
    897797,
    899777,
    767878,
    878788,
    888887,
    788889,
    899888,
    889887,
    778768,
    788886,
    887798,
    889888,
    878887,
    788878,
    878889,
    989887,
    678887,
    887877,
    897888,
    788887,
    969787,
    888788,
    797877,
    877797,
    997797,
    798987,
    987967,
    887778,
    886879,
    979888,
    887887,
    778879,
    878978,
    877788,
    988689,
    799668,
    888977,
    797897,
    669888,
    789998,
    798887,
    898899,
    789798,
    789978,
    676988,
    889788,
    898878,
    878667,
    889888,
    887979,
    778878,
    777898,
    877998,
    779779,
    897798,
    878988,
    778799,
    688788,
    799787,
    887868,
    687978,
    886968,
    788868,
    897897,
    978878,
    889778,
    898687,
    799799,
    787878,
    977777,
    678988,
    678899,
    867889,
    878797,
    778898,
    797779,
    996877,
    988887,
    886889,
    699778,
    787779,
    997988,
    897886,
    987888,
    889888,
    686988,
    888798,
    887797,
    789889,
    978888,
    777886,
    767897,
    768999,
    888898,
    888989,
    788888,
    787888,
    867877,
    788988,
    877878,
    878978,
    688698,
    878797,
    989797,
    887868,
    989679,
    789788,
    886878,
    787876,
    778767,
    889678,
    987887,
    788689,
    697788,
    789788,
    778877,
    899778,
    789999,
    797788,
    777888,
    878897,
    788779,
    899677,
    887779,
    779889,
    978888,
    699788,
    868889,
    977979,
    879888,
    778978,
    798797,
    698876,
    787877,
    766899,
    777878,
    887878,
    679877,
    786888,
    778887,
    777878,
    787887,
    976899,
    798978,
    988788,
    787878,
    778889,
    887886,
    888878,
    977778,
    778767,
    896977,
    778778,
    878767,
    887887,
    889787,
    978867,
    868787,
    997878,
    887677,
    877977,
    888869,
    798879,
    789898,
    896777,
    679797,
    887776,
    778888,
    876887,
    777888,
    687776,
    788888,
    888786,
    777986,
    978787,
    897889,
    889777,
    887677,
    787779,
    887977,
    877889,
    886689,
    788899,
    878789,
    877797,
    788978,
    777899,
    778877,
    799889,
    877888,
    898868,
    798788,
    788688,
    868888,
    879997,
    977788,
    878878,
    788788,
    868888,
    797788,
    988767,
    887768,
    988876,
    878887,
    879789,
    888768,
    888889,
    799888,
    988988,
    878989,
    988987,
    978688,
    888776,
    877778,
    787788,
    788886,
    787897,
    797798,
    699878,
    668888,
    697887,
    777787,
    879788,
    779799,
    787788,
    877878,
    897778,
    978887,
    899799,
    787887,
    789789,
    777999,
    888877,
    989788,
    789779,
    888878,
    889896,
    787887,
    888888,
    988869,
    869877,
    797878,
    778987,
    789688,
    698778,
    888897,
    877978,
    876787,
    678898,
    888989,
    787878,
    788887,
    877678,
    889888,
    998799,
    888988,
    798688,
    888877,
    778798,
    867877,
    879989,
    786989,
    878797,
    877887,
    888867,
    878887,
    789778,
    787778,
    877796,
    878787,
    787898,
    898778,
    976888,
    768778,
    879989,
    798898,
    787897,
    798778,
    897877,
    887886,
    988869,
    999679,
    668968,
    978787,
    988878,
    877889,
    799877,
    886897,
    998997,
    877787,
    788978,
    888779,
    978899,
    968777,
    778888,
    878887,
    787777,
    888797,
    777779,
    988878,
    987887,
    987789,
    877667,
    998878,
    878979,
    988878,
    786989,
    767898,
    878887,
    768778,
    877968,
    787787,
    877688,
    888969,
    869778,
    687888,
    988788,
    889677,
    787887,
    978798,
    888789,
    897899,
    888878,
    879878,
    989899,
    897888,
    798778,
    798988,
    997778,
    888887,
    979788,
    699889,
    879788,
    788788,
    898969,
    887987,
    987877,
    798898,
    688878,
    778689,
    999898,
    768878,
    989779,
    887788,
    776898,
    787987,
    788779,
    877799,
    787898,
    688886,
    988887,
    987899,
    967787,
    899699,
    888788,
    887999,
    778888,
    879778,
    887798,
    889978,
    688888,
    879879,
    788998,
    777869,
    987896,
    877988,
    678867,
    787779,
    889778,
    996777,
    899888,
    869877,
    888777,
    879787,
    878789,
    889878,
    887799,
    887988,
    988788,
    888979,
    697987,
    678776,
    777788,
    888877,
    787799,
    777987,
    889789,
    989677,
    798678,
    989978,
    879997,
    779788,
    878666,
    977776,
    887787,
    798889,
    767898,
    889889,
    878686,
    888777,
    788787,
    669896,
    796889,
    998697,
    798897,
    978979,
    876788,
    998987,
    777788,
    889688,
    988977,
    686889,
    988778,
    888798,
    877777,
    898779,
    688886,
    986978,
    898878,
    978897,
    788878,
    978798,
    797798,
    877888,
    789988,
    798677,
    877788,
    879777,
    778878,
    788778,
    877789,
    898978,
    777778,
    987999,
    888776,
    799877,
    798797,
    977977,
    788868,
    786988,
    878788,
    898988,
    897798,
    877878,
    878789,
    998888,
    998778,
    877787,
    798877,
    787698,
    787999,
    789788,
    689898,
    887789,
    778788,
    889799,
    687898,
    988888,
    887777,
    988687,
    988968,
    989778,
    767899,
    879989,
    898998,
    888888,
    879788,
    898878,
    896686,
    788899,
    777987,
    887897,
    777779,
    889977,
    977977,
    779877,
    788797,
    978898,
    899778,
    688888,
    778787,
    888687,
    897677,
    968776,
    967888,
    997699,
    789778,
    898778,
    888997,
    799987,
    877887,
    987988,
    788787,
    889788,
    896897,
    878887,
    897889,
    879878,
    978888,
    769797,
    777788,
    977877,
    988778,
    898697,
    796788,
    787788,
    878767,
    978988,
    788798,
    789778,
    778899,
    877989,
    877688,
    786778,
    868889,
    689788,
    789868,
    977886,
    787787,
    978897,
    878787,
    898997,
    989999,
    687979,
    786779,
    787799,
    889778,
    978889,
    787779,
    797788,
    878879,
    888877,
    788798,
    888999,
    698897,
    897787,
    897886,
    886788,
    877689,
    677878,
    786897,
    996869,
    877789,
    778988,
    777787,
    877878,
    987877,
    778997,
    888997,
    988988,
    787986,
    889888,
    876879,
    997878,
    877997,
    877779,
    987877,
    788777,
    798997,
    778798,
    867889,
    888888,
    986676,
    988977,
    678898,
    989987,
    867688,
    978887,
    879888,
    887687,
    788798,
    789978,
    887878,
    788877,
    887887,
    889788,
    678897,
    897789,
    678889,
    898878,
    897788,
    878998,
    887887,
    898778,
    887867,
    968878,
    888788,
    789887,
    968898,
    888777,
    788768,
    987788,
    798968,
    797998,
    778888,
    898879,
    888967,
    767968,
    968798,
    679878,
    687868,
    778896,
    998779,
    789879,
    888887,
    898887,
    787998,
    797987,
    878788,
    889976,
    897789,
    868788,
    878988,
    897898,
    878879,
    986769,
    988869,
    876779,
    877787,
    879888,
    877887,
    877699,
    968998,
    899668,
    998777,
    789978,
    978978,
    887978,
    888988,
    879698,
    879799,
    887898,
    886797,
    987979,
    979767,
    788997,
    888789,
    889678,
    899689,
    997777,
    778776,
    776997,
    879987,
    878886,
    888878,
    897777,
    877778,
    888879,
    998788,
    887977,
    887787,
    787789,
    798877,
    879699,
    786787,
    788787,
    878787,
    987897,
    768778,
    879788,
    999778,
    797778,
    899798,
    789899,
    987867,
    877977,
    967788,
    876878,
    887779,
    889787,
    687798,
    977787,
    879697,
    787797,
    889886,
    877877,
    886878,
    886987,
    678868,
    988887,
    878688,
    966976,
    899888,
    978887,
    788787,
    889886,
    887976,
    778878,
    987877,
    887976,
    888769,
    879877,
    988778,
    789889,
    777888,
    797877,
    897887,
    788687,
    798877,
    868878,
    879889,
    788887,
    777896,
    899979,
    788797,
    887888,
    687787,
    897986,
    799889,
    788797,
    998768,
    987779,
    996878,
    677989,
    786887,
    688788,
    997887,
    899779,
    778797,
    869867,
    897797,
    888796,
    778878,
    788896,
    877788,
    788688,
    787978,
    977779,
    897987,
    798868,
    768897,
    978888,
    977879,
    879888,
    979897,
    868976,
    987887,
    896789,
    897887,
    789866,
    899987,
    687778,
    889778,
    879898,
    789967,
    979778,
    968988,
    788877,
    799778,
    878887,
    887977,
    767889,
    878889,
    798887,
    877788,
    689997,
    868987,
    978878,
    978677,
    788989,
    887678,
    967778,
    798997,
    998897,
    966887,
    989889,
    778787,
    878769,
    977897,
    879898,
    978999,
    688878,
    988778,
    788987,
    988887,
    798787,
    979897,
    977778,
    786799,
    998689,
    978966,
    877988,
    778978,
    789968,
    879797,
    788787,
    677888,
    897997,
    878878,
    876888,
    787799,
    788986,
    889789,
    898887,
    788798,
    777876,
    988788,
    976798,
    788697,
    999987,
    789878,
    877978,
    877967,
    987787,
    896778,
    879977,
    967898,
    778787,
    799888,
    888887,
    798878,
    896879,
    987887,
    797878,
    988887,
    886889,
    988887,
    899977,
    888868,
    777787,
    789778,
    886878,
    778879,
    978887,
    778886,
    787778,
    998678,
    798988,
    877678,
    988799,
    888887,
    677997,
    898979,
    989998,
    797768,
    786788,
    898869,
    887899,
    899778,
    789889,
    887878,
    888888,
    878788,
    897777,
    867978,
    777868,
    888677,
    899797,
    788769,
    987988,
    887679,
    899897,
    878688,
    778779,
    866998,
    779876,
    788788,
    789777,
    887878,
    978789,
    796779,
    888887,
    777878,
    887989,
    796887,
    787897,
    878897,
    899987,
    997786,
    876867,
    788987,
    788766,
    879887,
    799888,
    878988,
    898868,
    889878,
    679788,
    996697,
    987987,
    778979,
    787876,
    768876,
    787988,
    878879,
    878899,
    877788,
    876698,
    688977,
    888789,
    878867,
    898877,
    776778,
    778988,
    778887,
    877988,
    888898,
    878898,
    797878,
    989777,
    767897,
    788978,
    779997,
    687778,
    997898,
    998878,
    787778,
    888987,
    897999,
    778777,
    999898,
    978878,
    797688,
    778888,
    878888,
    986788,
    788877,
    878987,
    879778,
    889978,
    779879,
    788889,
    688988,
    687987,
    687868,
    779887,
    778889,
    879788,
    967987,
    888786,
    788789,
    777778,
    888778,
    987968,
    877988,
    877898,
    787899,
    986988,
    888769,
    878797,
    878988,
    897879,
    778877,
    768788,
    888779,
    998998,
    887889,
    999977,
    888786,
    778987,
    899988,
    877878,
    787877,
    898688,
    987769,
    788888,
    987878,
    878788,
    896787,
    899797,
    787889,
    979878,
    769678,
    989878,
    688877,
    877886,
    888888,
    968777,
    988797,
    877798,
    678778,
    878987,
    976888,
    898877,
    888879,
    898786,
    869797,
    788888,
    778897,
    887787,
    897777,
    868879,
    887799,
    778978,
    687678,
    977887,
    877888,
    887888,
    988777,
    886789,
    787978,
    797888,
    877977,
    878788,
    977777,
    898888,
    888888,
    787998,
    978687,
    868778,
    977877,
    888879,
    788788,
    979778,
    887897,
    978678,
    779899,
    888969,
    679888,
    787998,
    889878,
    879988,
    798987,
    879788,
    877788,
    779887,
    778978,
    888878,
    787898,
    978988,
    877898,
    988676,
    699889,
    897978,
    779679,
    978888,
    877887,
    988996,
    699777,
    986897,
    986979,
    787867,
    888978,
    787877,
    898778,
    777886,
    886997,
    987788,
    888986,
    988889,
    768888,
    886796,
    878888,
    879879,
    788888,
    788789,
    887787,
    869888,
    788878,
    798889,
    798888,
    778878,
    787997,
    877988,
    878978,
    977799,
    777988,
    797988,
    889788,
    887798,
    888968,
    778877,
    978777,
    688778,
    877687,
    878889,
    788988,
    887977,
    777697,
    887987,
    779978,
    887877,
    788888,
    788999,
    889878,
    877887,
    888678,
    989778,
    886887,
    989878,
    798888,
    977877,
    788987,
    779986,
    788787,
    888867,
    898897,
    877878,
    777977,
    988998,
    988788,
    888888,
    868889,
    877778,
    788777,
    888868,
    987879,
    878968,
    978887,
    776898,
    978888,
    898889,
    978898,
    987787,
    777878,
    867798,
    897798,
    988789,
    778978,
    779688,
    989988,
    887877,
    978788,
    888978,
    677786,
    776876,
    999886,
    998787,
    796797,
    869678,
    777988,
    788888,
    988978,
    987867,
    797888,
    878888,
    778978,
    787768,
    967678,
    998887,
    888998,
    869788,
    879787,
    888889,
    688788,
    978778,
    777698,
    989778,
    688788,
    778887,
    997878,
    978988,
    699796,
    997987,
    797987,
    768979,
    879988,
    796778,
    878987,
    777878,
    887897,
    777878,
    677878,
    887977,
    697789,
    879777,
    877877,
    897879,
    788887,
    898887,
    977888,
    778886,
    889677,
    897876,
    867888,
    878779,
    799879,
    878986,
    898678,
    976888,
    979998,
    888788,
    987797,
    987889,
    786999,
    668798,
    888879,
    899987,
    788978,
    977889,
    789979,
    888877,
    988967,
    977889,
    889878,
    777778,
    898779,
    868788,
    768887,
    888979,
    987977,
    878987,
    787899,
    887888,
    888877,
    978896,
    788997,
    888997,
    877887,
    897897,
    899898,
    978777,
    888789,
    767699,
    797868,
    899878,
    879898,
    697887,
    698889,
    869887,
    978879,
    889878,
    879879,
    878878,
    779796,
    877787,
    998779,
    987788,
    786877,
    977888,
    986988,
    787989,
    796868,
    877787,
    778787,
    796798,
    787977,
    766987,
    897786,
    797977,
    887896,
    878888,
    789898,
    789986,
    787769,
    799988,
    878777,
    898977,
    788689,
    987889,
    987878,
    899887,
    889877,
    787789,
    878978,
    788776,
    788999,
    986887,
    876887,
    877888,
    798889,
    788697,
    978778,
    998779,
    888988,
    879877,
    888887,
    788699,
    788798,
    888889,
    887877,
    977677,
    777768,
    899788,
    677997,
    898778,
    878786,
    796787,
    879898,
    787768,
    987788,
    878899,
    899888,
    778886,
    888778,
    978888,
    878799,
    798977,
    788979,
    798889,
    688788,
    887887,
    886899,
    777888,
    788978,
    888888,
    878878,
    878678,
    888779,
    668699,
    888899,
    677779,
    888678,
    888898,
    767888,
    996866,
    798787,
    979888,
    787887,
    887879,
    886888,
    898977,
    988777,
    878788,
    878787,
    777799,
    998799,
    797789,
    978897,
    698787,
    978778,
    888898,
    878777,
    888988,
    788888,
    877887,
    678986,
    878788,
    887777,
    888888,
    688768,
    677897,
    788978,
    787677,
    787877,
    679888,
    889877,
    898887,
    789787,
    779898,
    887877,
    779877,
    877788,
    787766,
    677887,
    788888,
    887888,
    978788,
    888797,
    786889,
    988997,
    878798,
    899679,
    878676,
    977889,
    789886,
    896867,
    988888,
    788987,
    897978,
    889888,
    888878,
    989877,
    887798,
    988777,
    979797,
    798978,
    988778,
    898776,
    776898,
    876968,
    997787,
    888779,
    898997,
    978878,
    787886,
    867779,
    888768,
    977798,
    787889,
    788788,
    888687,
    777787,
    878977,
    868976,
    889879,
    877978,
    798778,
    879877,
    788979,
    798889,
    766986,
    769879,
    978777,
    878787,
    988986,
    879689,
    998887,
    787777,
    688787,
    796879,
    677867,
    876778,
    777879,
    888977,
    798779,
    797779,
    878878,
    699788,
    888977,
    877868,
    897788,
    777778,
    798898,
    888777,
    778797,
    879869,
    798887,
    798788,
    789678,
    879879,
    787788,
    679997,
    887987,
    898979,
    797898,
    777778,
    898798,
    979779,
    778788,
    788888,
    878888,
    977879,
    689688,
    886789,
    869788,
    778789,
    788899,
    879779,
    767867,
    786979,
    789888,
    887886,
    887879,
    799887,
    979887,
    868787,
    797887,
    878787,
    978998,
    888797,
    777989,
    978768,
    888788,
    787887,
    878887,
    986878,
    777669,
    898778,
    878888,
    677867,
    777897,
    776789,
    877787,
    798889,
    877777,
    779999,
    897688,
    768879,
    986689,
    787897,
    787689,
    988888,
    889889,
    788776,
    787777,
    889988,
    798887,
    777879,
    977887,
    987799,
    768979,
    788787,
    789988,
    788998,
    888898,
    789887,
    788888,
    988887,
    988779,
    879877,
    888989,
    778787,
    997988,
    977888,
    986777,
    777687,
    867778,
    878968,
    997787,
    988897,
    787768,
    787897,
    776978,
    869788,
    779896,
    788887,
    788887,
    988878,
    897987,
    876897,
    877888,
    889888,
    779788,
    986998,
    778678,
    878879,
    788778,
    868888,
    899689,
    889978,
    667887,
    888878,
    798789,
    887887,
    988888,
    877688,
    879887,
    787878,
    768889,
    897797,
    798979,
    977988,
    888888,
    898788,
    889787,
    678778,
    779786,
    787787,
    787988,
    877988,
    788787,
    988778,
    997987,
    788887,
    878888,
    798787,
    797868,
    879868,
    786879,
    897887,
    988798,
    877788,
    868887,
    889897,
    878778,
    899876,
    889888,
    768778,
    679978,
    988997,
    897898,
    777889,
    678978,
    799887,
    687778,
    788767,
    799977,
    886788,
    899877,
    978767,
    789897,
    777788,
    898767,
    889777,
    978889,
    897867,
    779899,
    888876,
    978768,
    788878,
    888998,
    888788,
    887888,
    887878,
    777978,
    777888,
    888768,
    787779,
    878898,
    898989,
    779979,
    998888,
    977787,
    677898,
    986789,
    978897,
    898679,
    777798,
    999889,
    878788,
    799688,
    878897,
    879878,
    888888,
    797887,
    987786,
    878777,
    878778,
    776889,
    997679,
    888878,
    897889,
    988988,
    888877,
    886786,
    898989,
    687889,
    888886,
    869777,
    898888,
    777788,
    988789,
    788888,
    876898,
    878798,
    897787,
    687888,
    797877,
    889688,
    888878,
    888887,
    787898,
    897688,
    896789,
    786887,
    898977,
    689887,
    888978,
    879788,
    878987,
    897888,
    878868,
    788776,
    788867,
    977878,
    888876,
    878898,
    868787,
    789868,
    797898,
    768798,
    799789,
    688788,
    789788,
    698876,
    977987,
    779767,
    878887,
    788888,
    987967,
    687979,
    887899,
    988899,
    788788,
    887788,
    877888,
    897797,
    869887,
    987867,
    798988,
    878777,
    789697,
    878777,
    787866,
    987897,
    768898,
    887779,
    888777,
    898786,
    787678,
    798999,
    887798,
    887787,
    887788,
    989978,
    769797,
    878876,
    788786,
    886978,
    988789,
    787787,
    888898,
    887788,
    787888,
    887999,
    798886,
    878797,
    987987,
    777777,
    886879,
    888787,
    776888,
    977688,
    767988,
    778878,
    997888,
    977869,
    978776,
    887788,
    797867,
    896688,
    887787,
    888897,
    978977,
    889878,
    778878,
    887879,
    787786,
    877777,
    787877,
    888787,
    896787,
    786867,
    987677,
    887998,
    788776,
    798789,
    788979,
    978889,
    788889,
    879988,
    867876,
    776778,
    897977,
    888888,
    686878,
    787877,
    888887,
    888899,
    778877,
    887867,
    879878,
    876888,
    889698,
    777989,
    998788,
    797878,
    798997,
    888678,
    788889,
    898887,
    999777,
    889996,
    797789,
    889888,
    778879,
    888688,
    788878,
    888998,
    898777,
    989888,
    777798,
    888787,
    887877,
    868979,
    797988,
    888778,
    769897,
    877797,
    877787,
    997798,
    897888,
    987887,
    798687,
    989988,
    788877,
    888688,
    788988,
    978769,
    889878,
    868998,
    789978,
    966987,
    787877,
    877898,
    899897,
    898886,
    778978,
    899888,
    879679,
    888886,
    768788,
    897888,
    789987,
    788768,
    888877,
    878798,
    986879,
    787877,
    887788,
    778796,
    878896,
    788798,
    878898,
    998878,
    777899,
    787779,
    786688,
    877997,
    887788,
    887889,
    879787,
    798798,
    788798,
    878888,
    877889,
    788777,
    788786,
    887786,
    898788,
    888888,
    877799,
    888987,
    886888,
    886678,
    978799,
    978987,
    777888,
    878686,
    887688,
    878789,
    888887,
    879886,
    887898,
    778866,
    778988,
    987888,
    889689,
    979898,
    788778,
    877779,
    889888,
    787889,
    878676,
    788886,
    878788,
    889977,
    786778,
    888879,
    766799,
    797978,
    776888,
    879778,
    878898,
    866788,
    778677,
    787879,
    888977,
    897977,
    889787,
    868799,
    879888,
    698997,
    789888,
    979877,
    788987,
    887797,
    997888,
    879778,
    669789,
    877788,
    997887,
    699779,
    777777,
    889888,
    978988,
    888788,
    887878,
    876766,
    979877,
    779787,
    888788,
    888787,
    867777,
    797789,
    786886,
    779698,
    878896,
    777878,
    887788,
    678768,
    877978,
    979878,
    798786,
    889898,
    979789,
    769869,
    878688,
    888896,
    888767,
    696989,
    787867,
    787876,
    668898,
    789799,
    878888,
    888687,
    868898,
    877998,
    877789,
    877788,
    777889,
    786877,
    987767,
    888898,
    988886,
    778889,
    868798,
    687789,
    788878,
    678788,
    788797,
    878769,
    977867,
    888897,
    989979,
    889979,
    698889,
    769877,
    778787,
    698777,
    888989,
    888899,
    899978,
    778987,
    768988,
    887988,
    798987,
    877679,
    879979,
    879978,
    686679,
    697868,
    889887,
    997889,
    978988,
    798898,
    886786,
    887778,
    897676,
    888787,
    887686,
    796978,
    887888,
    987888,
    887787,
    888798,
    668878,
    877888,
    788898,
    788777,
    778787,
    778789,
    787987,
    868879,
    898889,
    877887,
    787889,
    877877,
    877878,
    878978,
    789787,
    886989,
    787767,
    788868,
    876887,
    977798,
    799678,
    789978,
    788887,
    977888,
    878898,
    876899,
    979799,
    878899,
    777877,
    787869,
    798897,
    797788,
    786786,
    877987,
    877778,
    867778,
    799887,
    777998,
    797888,
    988797,
    866778,
    778689,
    869788,
    788976,
    798788,
    878789,
    797888,
    988978,
    779888,
    788779,
    888877,
    888888,
    889988,
    889997,
    768868,
    879888,
    779788,
    788788,
    777996,
    788997,
    989988,
    878668,
    687897,
    987868,
    867677,
    898877,
    777878,
    798878,
    787878,
    888887,
    797878,
    796688,
    997966,
    798989,
    987786,
    987989,
    876897,
    878898,
    888787,
    887789,
    778888,
    998979,
    888888,
    788788,
    889879,
    878878,
    879879,
    989688,
    987998,
    867788,
    898789,
    888788,
    777788,
    888789,
    976886,
    889988,
    889689,
    896888,
    878867,
    789888,
    697989,
    788977,
    776998,
    888788,
    778887,
    978799,
    887777,
    877779,
    888886,
    879987,
    887789,
    786888,
    789888,
    788778,
    787898,
    878768,
    888887,
    778877,
    977887,
    887879,
    779788,
    696898,
    887798,
    877787,
    887878,
    889778,
    789888,
    869877,
    888887,
    788898,
    776877,
    788887,
    886899,
    889787,
    796989,
    897887,
    877877,
    786887,
    878977,
    776977,
    897988,
    969888,
    787886,
    788899,
    877887,
    987797,
    887888,
    888897,
    779788,
    778787,
    777898,
    879988,
    768888,
    877889,
    877988,
    787889,
    669898,
    887999,
    879777,
    688799,
    887798,
    798977,
    888787,
    798778,
    897988,
    887787,
    887998,
    886867,
    797678,
    888886,
    979878,
    778689,
    788779,
    898888,
    888679,
    899878,
    888877,
    776888,
    798877,
    969987,
    778888,
    988987,
    899877,
    797988,
    897998,
    879788,
    797777,
    777878,
    879788,
    889989,
    887878,
    798676,
    878789,
    988988,
    797888,
    786998,
    786777,
    887769,
    889987,
    876789,
    979967,
    878888,
    889787,
    878668,
    778687,
    889676,
    899979,
    778979,
    769897,
    897888,
    888888,
    888778,
    888889,
    877878,
    979788,
    778778,
    889978,
    898797,
    787977,
    888977,
    979788,
    797769,
    997899,
    888968,
    877879,
    898789,
    897769,
    978889,
    989878,
    878788,
    788788,
    877778,
    797976,
    788898,
    688878,
    889987,
    787797,
    888887,
    678867,
    886796,
    787797,
    877877,
    777878,
    888888,
    898887,
    787988,
    787879,
    877778,
    989887,
    877888,
    777886,
    897898,
    898988,
    898889,
    787778,
    898698,
    778777,
    686778,
    987777,
    797877,
    697987,
    787776,
    889898,
    877979,
    887969,
    788997,
    888688,
    997798,
    787898,
    997688,
    779678,
    988799,
    988878,
    887778,
    977688,
    798777,
    987678,
    987887,
    988897,
    889977,
    877768,
    698898,
    778788,
    997889,
    778798,
    987788,
    888888,
    879888,
    887889,
    977898,
    767889,
    778877,
    988888,
    878966,
    777878,
    797888,
    889698,
    968889,
    798898,
    887678,
    979888,
    799897,
    877978,
    788877,
    877768,
    888769,
    789989,
    879987,
    967888,
    888798,
    869698,
    868877,
    889877,
    968787,
    887877,
    698878,
    888987,
    687967,
    887988,
    777889,
    776889,
    888889,
    677997,
    977988,
    977877,
    896779,
    978778,
    788989,
    986879,
    798978,
    989987,
    888988,
    978988,
    887879,
    678677,
    889787,
    786797,
    697768,
    777986,
    878898,
    689987,
    678998,
    688878,
    886976,
    889678,
    899797,
    868779,
    968788,
    888877,
    878878,
    899788,
    797789,
    897877,
    978888,
    789898,
    779788,
    988788,
    788998,
    798788,
    888878,
    898877,
    977888,
    779877,
    898988,
    998878,
    968788,
    978876,
    888899,
    988878,
    777879,
    778879,
    877878,
    878687,
    678697,
    778789,
    799979,
    679998,
    877789,
    978887,
    898879,
    887798,
    989888,
    788677,
    898898,
    879879,
    889776,
    678788,
    789799,
    979898,
    889877,
    778888,
    979997,
    978799,
    768888,
    999788,
    877888,
    788876,
    877788,
    977678,
    898896,
    997999,
    988877,
    788788,
    787877,
    778988,
    979989,
    887977,
    887779,
    887686,
    877989,
    787899,
    987798,
    987878,
    878898,
    988887,
    877788,
    787788,
    768878,
    886788,
    888997,
    789787,
    798877,
    698679,
    877788,
    977897,
    798987,
    887898,
    887787,
    898888,
    899887,
    879789,
    877887,
    989897,
    797988,
    877788,
    879877,
    897988,
    977798,
    899897,
    887998,
    977788,
    887988,
    889788,
    889889,
    886989,
    686787,
    898968,
    879769,
    788889,
    799886,
    788998,
    897796,
    887898,
    777777,
    989888,
    888786,
    986786,
    679887,
    778877,
    797777,
    787688,
    898889,
    798787,
    898787,
    678887,
    777788,
    897896,
    787787,
    879779,
    988869,
    788797,
    789788,
    868798,
    999877,
    689897,
    988778,
    898688,
    789799,
    797767,
    897767,
    977768,
    898787,
    678996,
    977798,
    978778,
    788788,
    778788,
    788789,
    997978,
    877887,
    897978,
    787988,
    788889,
    887886,
    676887,
    888789,
    787687,
    977886,
    896869,
    888989,
    889788,
    868978,
    979798,
    798777,
    878887,
    798777,
    878998,
    977898,
    778798,
    878888,
    788898,
    899787,
    877678,
    987797,
    689877,
    888688,
    889888,
    878777,
    789876,
    787977,
    887787,
    867988,
    788787,
    887799,
    887888,
    989878,
    888889,
    978878,
    798778,
    888976,
    766887,
    988668,
    799987,
    778688,
    898768,
    699878,
    978788,
    888878,
    898999,
    888978,
    999779,
    887979,
    897777,
    987988,
    868767,
    888798,
    977988,
    778898,
    798778,
    867878,
    688787,
    988866,
    888898,
    788798,
    868767,
    878778,
    788987,
    678887,
    999978,
    878797,
    877798,
    886798,
    878788,
    976868,
    876879,
    889978,
    777798,
    888887,
    798888,
    989787,
    878997,
    787788,
    987797,
    888798,
    898866,
    787878,
    877888,
    787888,
    687887,
    778988,
    968799,
    998869,
    878898,
    798888,
    688989,
    788969,
    778997,
    889887,
    788889,
    888887,
    898688,
    987977,
    698679,
    898689,
    677887,
    988899,
    886897,
    997876,
    867877,
    887988,
    788779,
    887868,
    878767,
    876888,
    896787,
    888888,
    899979,
    988998,
    997888,
    987876,
    877987,
    797888,
    678968,
    887789,
    979887,
    779676,
    788788,
    998987,
    998967,
    877988,
    799997,
    989687,
    887898,
    788688,
    878979,
    888897,
    878878,
    697777,
    898888,
    998897,
    798988,
    677888,
    788978,
    887978,
    887868,
    869797,
    898886,
    977998,
    787977,
    888899,
    666888,
    799986,
    788887,
    776788,
    987987,
    997788,
    889787,
    889989,
    977887,
    887687,
    778767,
    787788,
    879878,
    777977,
    678887,
    899787,
    797899,
    777887,
    788888,
    987887,
    799968,
    779979,
    878887,
    798877,
    878977,
    877877,
    787897,
    778777,
    787889,
    787669,
    878789,
    878978,
    797889,
    988888,
    787889,
    777879,
    888697,
    889786,
    778998,
    798876,
    878878,
    998798,
    888669,
    887888,
    988888,
    777887,
    788987,
    776787,
    677778,
    877897,
    879979,
    899888,
    877877,
    988777,
    877788,
    778787,
    979889,
    898777,
    797897,
    887777,
    889986,
    888787,
    678886,
    689797,
    897777,
    877987,
    988888,
    898789,
    878878,
    777887,
    899779,
    778799,
    989878,
    997687,
    768888,
    789879,
    888768,
    887978,
    977987,
    766867,
    978998,
    979789,
    877778,
    778879,
    787869,
    778787,
    979887,
    799898,
    887888,
    779787,
    677978,
    698798,
    878778,
    977987,
    797766,
    899788,
    777688,
    779777,
    988789,
    788778,
    798868,
    779778,
    888898,
    888689,
    788898,
    878688,
    689896,
    796798,
    788878,
    797896,
    997989,
    789777,
    788888,
    768687,
    687897,
    888887,
    797988,
    698877,
    986887,
    768977,
    878798,
    888879,
    878888,
    888879,
    877989,
    789887,
    776988,
    987779,
    768797,
    677898,
    688889,
    688977,
    878897,
    889688,
    976878,
    878886,
    868796,
    778867,
    979988,
    898777,
    787787,
    897989,
    989988,
    876788,
    878988,
    878987,
    677887,
    768997,
    878877,
    777789,
    789779,
    897888,
    888796,
    767879,
    777888,
    687987,
    779788,
    898878,
    986887,
    779797,
    977777,
    779788,
    878898,
    798979,
    988789,
    877888,
    889989,
    877696,
    767887,
    798788,
    798778,
    888888,
    787978,
    987879,
    776797,
    879788,
    688797,
    787988,
    796788,
    768776,
    888887,
    888997,
    687988,
    877888,
    788798,
    977898,
    877788,
    979867,
    787979,
    797877,
    987689,
    887697,
    986789,
    889869,
    788777,
    789887,
    868778,
    888887,
    897978,
    888678,
    777897,
    878887,
    888798,
    888998,
    788977,
    768686,
    967778,
    789888,
    888898,
    778878,
    988878,
    886879,
    779879,
    889987,
    878897,
    868878,
    788779,
    678877,
    798887,
    878768,
    886879,
    979788,
    789798,
    887779,
    878777,
    877889,
    996778,
    888799,
    798899,
    787887,
    866779,
    868877,
    788689,
    778787,
    777787,
    897889,
    886888,
    988978,
    989867,
    889887,
    768897,
    998986,
    788898,
    988979,
    998798,
    878899,
    787888,
    768789,
    987788,
    878988,
    787799,
    776797,
    798888,
    877878,
    888877,
    677889,
    777988,
    897797,
    987887,
    796789,
    867788,
    787998,
    898868,
    889887,
    678898,
    887977,
    897668,
    677888,
    899887,
    878879,
    787799,
    788878,
    978988,
    879878,
    799787,
    887888,
    787866,
    978887,
    886778,
    879878,
    987869,
    887888,
    977679,
    879878,
    868868,
    889977,
    878688,
    977687,
    868689,
    788877,
    889897,
    886877,
    888887,
    768889,
    968778,
    877968,
    787897,
    788898,
    788889,
    798778,
    868988,
    988888,
    987979,
    878977,
    977877,
    897978,
    787989,
    798887,
    898799,
    887888,
    877889,
    776798,
    879878,
    787877,
    988997,
    779978,
    898876,
    888778,
    889887,
    978797,
    798989,
    778788,
    777788,
    897778,
    778788,
    968787,
    787978,
    867997,
    888798,
    687888,
    779888,
    879778,
    789889,
    897878,
    799798,
    689878,
    989898,
    989898,
    879979,
    878779,
    788687,
    778887,
    777688,
    788798,
    868788,
    886888,
    989888,
    768799,
    788788,
    778788,
    788888,
    789877,
    887866,
    888888,
    779888,
    877798,
    869978,
    877788,
    878789,
    888876,
    878986,
    898699,
    886898,
    788898,
    877888,
    787788,
    878798,
    897778,
    878888,
    788978,
    788778,
    998788,
    797888,
    788878,
    778787,
    888978,
    787779,
    896886,
    687886,
    888888,
    898778,
    888888,
    888878,
    779877,
    788768,
    777798,
    878787,
    897798,
    878697,
    968987,
    776968,
    878878,
    888878,
    777877,
    697789,
    787798,
    688987,
    768977,
    899877,
    897896,
    979878,
    888868,
    688878,
    878889,
    878899,
    887997,
    878888,
    878976,
    867997,
    678888,
    978768,
    787888,
    777888,
    787788,
    877987,
    888788,
    779778,
    879979,
    888979,
    778777,
    987897,
    889898,
    899878,
    877797,
    788877,
    788967,
    789977,
    787977,
    778787,
    777887,
    877868,
    878889,
    687869,
    797897,
    797978,
    887988,
    688779,
    678789,
    876997,
    799879,
    988778,
    878898,
    998787,
    789898,
    977789,
    889788,
    988879,
    987788,
    888678,
    987867,
    999788,
    787688,
    797887,
    786788,
    778687,
    977967,
    878768,
    689987,
    778896,
    788877,
    889878,
    788878,
    779878,
    777977,
    889688,
    888899,
    779988,
    888978,
    798798,
    978979,
    878787,
    878778,
    998777,
    987678,
    876777,
    878898,
    997988,
    898989,
    886888,
    769887,
    878788,
    888778,
    788868,
    887867,
    678788,
    777888,
    897987,
    778788,
    768789,
    878799,
    887888,
    888879,
    767887,
    988898,
    789889,
    777788,
    867788,
    787686,
    767889,
    787678,
    977868,
    787797,
    768777,
    967988,
    768888,
    878988,
    797778,
    879778,
    778887,
    776777,
    897897,
    878788,
    889869,
    988997,
    789987,
    887689,
    778768,
    877889,
    877889,
    987968,
    987797,
    678997,
    799796,
    888988,
    878778,
    778787,
    667879,
    787777,
    878798,
    888787,
    688888,
    789877,
    899878,
    988989,
    888899,
    986688,
    798886,
    989986,
    969787,
    887778,
    697878,
    889888,
    799686,
    987878,
    698779,
    778778,
    898788,
    798797,
    887986,
    768799,
    979997,
    788897,
    786887,
    889787,
    798888,
    887899,
    789889,
    688876,
    887788,
    877868,
    888688,
    978887,
    888788,
    787787,
    777898,
    998777,
    699776,
    868779,
    888778,
    798988,
    879699,
    788897,
    798877,
    876899,
    689699,
    778668,
    777777,
    887978,
    987777,
    998789,
    777777,
    788788,
    878988,
    888887,
    787787,
    867769,
    988788,
    877777,
    888697,
    799879,
    879688,
    998788,
    988878,
    878988,
    787777,
    777986,
    789789,
    887987,
    986789,
    877878,
    878878,
    886979,
    877897,
    788979,
    877787,
    778888,
    988778,
    867977,
    978777,
    787798,
    676878,
    788887,
    978869,
    878787,
    886898,
    879989,
    678888,
    886798,
    787786,
    777899,
    787888,
    899978,
    889788,
    888876,
    787779,
    778879,
    799879,
    779788,
    797777,
    878988,
    879798,
    778899,
    679988,
    778898,
    987879,
    889676,
    777878,
    868989,
    787899,
    898976,
    688777,
    778887,
    788677,
    997978,
    878897,
    877977,
    797798,
    987998,
    888889,
    788878,
    789897,
    788788,
    898789,
    988677,
    768897,
    877977,
    968877,
    879667,
    887779,
    886898,
    788998,
    896887,
    787878,
    796888,
    788879,
    869676,
    987798,
    787786,
    788988,
    897788,
    887787,
    778788,
    778889,
    877787,
    796798,
    888698,
    968997,
    797878,
    787878,
    777876,
    888787,
    888897,
    777778,
    877887,
    797889,
    798878,
    788787,
    888677,
    899798,
    879778,
    889689,
    777898,
    998898,
    688897,
    879687,
    787888,
    778888,
    897787,
    988798,
    886686,
    788886,
    668788,
    786896,
    879898,
    798778,
    887978,
    777889,
    886788,
    778678,
    888888,
    777866,
    798798,
    778689,
    678898,
    767769,
    787787,
    897879,
    889878,
    987898,
    797889,
    877897,
    769789,
    987868,
    987988,
    887777,
    798988,
    797888,
    987889,
    778779,
    786878,
    877879,
    888788,
    897788,
    787778,
    789898,
    898668,
    977889,
    896888,
    998778,
    879878,
    777878,
    788887,
    969777,
    878796,
    888879,
    979877,
    687778,
    887998,
    879798,
    996878,
    678888,
    899888,
    788878,
    886888,
    888788,
    988887,
    798786,
    887778,
    878986,
    888888,
    678978,
    888878,
    787779,
    778787,
    978888,
    788976,
    788799,
    789768,
    877878,
    987898,
    897788,
    979788,
    778787,
    776779,
    668887,
    878887,
    787887,
    788968,
    777998,
    787887,
    978789,
    877888,
    986788,
    797879,
    788789,
    867787,
    776778,
    779977,
    988866,
    867979,
    768898,
    786768,
    898988,
    888988,
    877678,
    989988,
    888887,
    888898,
    898778,
    868897,
    886877,
    977777,
    879778,
    978878,
    899878,
    687778,
    788687,
    898777,
    689777,
    997967,
    676779,
    798777,
    796897,
    799998,
    979797,
    778767,
    888899,
    888777,
    777888,
    768778,
    787887,
    998886,
    788678,
    896977,
    777878,
    897778,
    887778,
    786878,
    888898,
    878889,
    879667,
    778886,
    798688,
    899879,
    777777,
    688867,
    888787,
    788899,
    878779,
    888779,
    879778,
    979778,
    677888,
    998777,
    888886,
    878876,
    888788,
    787798,
    777877,
    787888,
    777888,
    898888,
    787779,
    789988,
    878778,
    678799,
    687997,
    877779,
    687778,
    997878,
    896788,
    887988,
    768778,
    877988,
    979987,
    879787,
    879888,
    798879,
    886777,
    897777,
    799689,
    787796,
    877878,
    688777,
    888887,
    897887,
    886868,
    799869,
    778877,
    689989,
    687788,
    787787,
    788867,
    878789,
    998988,
    887897,
    778889,
    777887,
    778877,
    679689,
    789887,
    787797,
    777878,
    787778,
    877997,
    879877,
    987788,
    797798,
    887988,
    778888,
    876797,
    888888,
    878988,
    877988,
    977978,
    899887,
    998797,
    789779,
    768798,
    979796,
    887768,
    868989,
    788678,
    977887,
    879979,
    677788,
    977889,
    789789,
    787778,
    788778,
    888787,
    887789,
    967867,
    788887,
    776898,
    887887,
    979688,
    898967,
    888898,
    786888,
    978887,
    789797,
    898897,
    879877,
    897886,
    877887,
    687788,
    889887,
    978796,
    789889,
    877889,
    888878,
    689887,
    788698,
    788977,
    988779,
    776897,
    978877,
    786887,
    768797,
    789787,
    889778,
    788899,
    876988,
    879788,
    888998,
    777888,
    799788,
    879797,
    787878,
    878768,
    878887,
    998877,
    777888,
    787979,
    878878,
    799978,
    778878,
    867766,
    868889,
    977788,
    777777,
    778987,
    977876,
    888788,
    879789,
    896789,
    878877,
    678769,
    886768,
    878788,
    799976,
    797898,
    887876,
    678687,
    777778,
    877788,
    786878,
    879798,
    887988,
    878877,
    787779,
    877677,
    798788,
    888888,
    977788,
    877788,
    997868,
    778989,
    878889,
    878878,
    967867,
    799778,
    878878,
    878797,
    888988,
    899878,
    888876,
    788887,
    779868,
    777878,
    788887,
    986689,
    797779,
    877898,
    989887,
    898778,
    778876,
    877989,
    777768,
    788778,
    787878,
    768788,
    887777,
    787887,
    787799,
    877787,
    879787,
    777778,
    788788,
    778877,
    778998,
    988899,
    788789,
    788888,
    967768,
    788877,
    889778,
    778779,
    799797,
    897878,
    788897,
    898887,
    997886,
    987889,
    888987,
    888897,
    998998,
    777797,
    888987,
    768779,
    779768,
    888887,
    798698,
    788888,
    786978,
    788787,
    889898,
    786977,
    888888,
    887888,
    887989,
    778877,
    778797,
    898678,
    889986,
    979667,
    688787,
    896787,
    777887,
    888998,
    786988,
    768878,
    987997,
    797779,
    687986,
    979888,
    997878,
    999889,
    778888,
    877989,
    787979,
    778788,
    888788,
    887788,
    787877,
    898699,
    678879,
    888798,
    888879,
    998889,
    887878,
    887876,
    897988,
    897768,
    797767,
    787977,
    778798,
    878789,
    779889,
    897877,
    878878,
    668777,
    899878,
    787998,
    779789,
    889778,
    898878,
    688987,
    869778,
    789876,
    986878,
    788998,
    789879,
    898888,
    968977,
    889878,
    779976,
    799988,
    888999,
    869777,
    789878,
    987879,
    877977,
    889898,
    788977,
    886678,
    878796,
    888977,
    888878,
    767778,
    787688,
    896888,
    897779,
    879788,
    878989,
    787797,
    787788,
    988869,
    897878,
    889988,
    879888,
    888788,
    997896,
    787878,
    978897,
    797888,
    878799,
    878897,
    797778,
    898998,
    779887,
    888887,
    778778,
    788679,
    897777,
    796698,
    787869,
    898878,
    879977,
    787878,
    897789,
    687887,
    968979,
    778889,
    887678,
    778688,
    877999,
    777879,
    789887,
    889898,
    899898,
    898879,
    777778,
    978987,
    879898,
    988898,
    888897,
    978698,
    689888,
    787688,
    789898,
    779878,
    797788,
    979678,
    989998,
    989789,
    797788,
    978788,
    887868,
    887877,
    898889,
    776878,
    877978,
    687796,
    789786,
    886788,
    788788,
    887999,
    897979,
    787887,
    877988,
    788887,
    798888,
    988997,
    887768,
    788776,
    888778,
    979877,
    888778,
    868788,
    779978,
    676978,
    799777,
    789688,
    877776,
    889687,
    789778,
    669778,
    877786,
    879787,
    789888,
    986878,
    988788,
    799988,
    887778,
    887978,
    898877,
    897778,
    889977,
    878768,
    788987,
    889869,
    788778,
    878789,
    988989,
    776879,
    889898,
    778799,
    797778,
    888787,
    887788,
    888988,
    888988,
    998778,
    987889,
    687888,
    898988,
    788787,
    779787,
    898978,
    978797,
    786978,
    788887,
    889967,
    887767,
    787798,
    879889,
    898878,
    997887,
    788797,
    788888,
    768768,
    787678,
    898899,
    889886,
    898778,
    977867,
    787898,
    878796,
    989797,
    777776,
    887786,
    897899,
    987888,
    877877,
    877878,
    778878,
    787878,
    768788,
    888988,
    877878,
    799787,
    778876,
    768767,
    998788,
    777868,
    788988,
    897788,
    887887,
    768878,
    889977,
    787878,
    787987,
    687898,
    697998,
    799799,
    886878,
    887978,
    798677,
    989687,
    888788,
    678888,
    688788,
    987878,
    899879,
    768968,
    976888,
    787877,
    888889,
    899889,
    999787,
    677787,
    797976,
    888777,
    788978,
    978877,
    778788,
    898896,
    778878,
    798879,
    878777,
    877897,
    878889,
    887876,
    778879,
    887888,
    889776,
    986978,
    887798,
    879878,
    977988,
    778787,
    988989,
    777788,
    788877,
    877789,
    777997,
    978889,
    896887,
    989687,
    979987,
    689797,
    787886,
    677778,
    988778,
    786888,
    777877,
    888766,
    887789,
    876888,
    888797,
    897786,
    798988,
    878797,
    899888,
    999767,
    978788,
    887789,
    878967,
    779889,
    779878,
    788877,
    879798,
    886988,
    877777,
    866799,
    967687,
    987989,
    888879,
    888888,
    787988,
    988867,
    887778,
    888878,
    896978,
    789887,
    888768,
    777899,
    887677,
    978887,
    788787,
    898879,
    899679,
    779767,
    677689,
    987988,
    778968,
    989797,
    788788,
    798766,
    877677,
    699876,
    788879,
    898776,
    878887,
    979687,
    968897,
    987776,
    778678,
    789678,
    988688,
    878988,
    887887,
    888878,
    886887,
    899998,
    798879,
    998888,
    898796,
    878777,
    887887,
    877887,
    989987,
    789789,
    998787,
    877879,
    887888,
    888797,
    778888,
    778887,
    788878,
    679787,
    777779,
    779878,
    888889,
    778789,
    889877,
    798789,
    987887,
    898789,
    988997,
    877788,
    867988,
    777887,
    887798,
    887869,
    987798,
    779969,
    798879,
    788879,
    988878,
    987767,
    889997,
    898788,
    989887,
    777878,
    787987,
    978878,
    778988,
    997887,
    887897,
    989987,
    779877,
    887878,
    888888,
    878979,
    778889,
    887777,
    788878,
    867767,
    778798,
    687877,
    788998,
    688979,
    979877,
    799879,
    987897,
    778867,
    987978,
    888677,
    879897,
    887867,
    788787,
    888866,
    977888,
    888797,
    989899,
    887689,
    668777,
    788878,
    897877,
    788677,
    887888,
    999878,
    798888,
    897978,
    986788,
    989787,
    978998,
    867998,
    689977,
    799888,
    768788,
    987887,
    877879,
    897798,
    788777,
    869869,
    788696,
    877888,
    688897,
    788868,
    779787,
    899887,
    768989,
    887889,
    988898,
    687989,
    689787,
    886787,
    988879,
    888798,
    988987,
    988776,
    878878,
    798888,
    668989,
    768777,
    886898,
    978798,
    989888,
    798689,
    896788,
    777697,
    789688,
    876877,
    789777,
    887687,
    879768,
    888998,
    678878,
    987898,
    787787,
    777888,
    987898,
    789988,
    877799,
    797697,
    679989,
    898788,
    768988,
    788798,
    887788,
    887789,
    778669,
    999888,
    988698,
    778988,
    776887,
    998977,
    887888,
    689877,
    889879,
    988887,
    799877,
    769879,
    987877,
    988887,
    777988,
    798786,
    888888,
    788877,
    799778,
    797779,
    999788,
    877887,
    776877,
    997888,
    978776,
    797998,
    887899,
    897688,
    879877,
    779987,
    778888,
    978987,
    878878,
    877869,
    878877,
    889967,
    787787,
    988878,
    997669,
    788898,
    898777,
    878798,
    878889,
    989877,
    788887,
    777877,
    968878,
    977887,
    989886,
    996778,
    789877,
    796787,
    788866,
    898897,
    877788,
    888767,
    798888,
    976898,
    889879,
    887877,
    997778,
    888688,
    688789,
    978899,
    787877,
    878878,
    797788,
    889976,
    689878,
    878787,
    897788,
    878867,
    788887,
    889787,
    887888,
    877787,
    898887,
    788788,
    778878,
    899988,
    889887,
    898877,
    777887,
    788788,
    979786,
    788878,
    898989,
    987797,
    888987,
    898976,
    978868,
    878887,
    787976,
    898798,
    888887,
    899796,
    898778,
    788888,
    996778,
    688888,
    878898,
    779889,
    899889,
    798677,
    886888,
    788769,
    997896,
    888888,
    878867,
    888787,
    778998,
    687789,
    699787,
    988898,
    868998,
    989787,
    768986,
    789887,
    787776,
    899688,
    788789,
    998887,
    898788,
    777779,
    788798,
    968978,
    989968,
    799878,
    897777,
    779798,
    887888,
    778897,
    967789,
    879798,
    978978,
    678778,
    896798,
    678898,
    996778,
    897777,
    878789,
    887788,
    888888,
    788878,
    898887,
    687778,
    778787,
    787888,
    989799,
    778786,
    888798,
    898888,
    998778,
    887787,
    798677,
    998888,
    789799,
    976777,
    887987,
    998899,
    787897,
    898878,
    787697,
    878887,
    878869,
    779877,
    988988,
    779787,
    889799,
    888998,
    899978,
    887798,
    687886,
    987869,
    877978,
    777889,
    899767,
    898879,
    887877,
    887898,
    888878,
    797979,
    888988,
    878788,
    799877,
    778689,
    877878,
    788789,
    887776,
    968988,
    799988,
    778897,
    878987,
    999797,
    878789,
    768877,
    687776,
    877888,
    877987,
    799689,
    888877,
    887878,
    988887,
    788888,
    788878,
    796688,
    787788,
    778867,
    898688,
    887778,
    987779,
    888788,
    777887,
    877779,
    987699,
    988887,
    778888,
    897768,
    788889,
    978889,
    888889,
    688877,
    976988,
    988776,
    889778,
    888977,
    986787,
    777978,
    778788,
    878977,
    788987,
    877978,
    796888,
    697868,
    999977,
    778787,
    799877,
    779988,
    788778,
    778897,
    877999,
    897968,
    988669,
    788978,
    798788,
    787868,
    778877,
    789677,
    897977,
    786867,
    878788,
    967877,
    889996,
    889778,
    886788,
    789878,
    787767,
    986877,
    978778,
    898778,
    998877,
    988788,
    879889,
    989878,
    797778,
    877799,
    987788,
    687889,
    888777,
    889888,
    788788,
    987898,
    877687,
    999898,
    888888,
    688787,
    998888,
    687889,
    897888,
    886787,
    978778,
    867767,
    777899,
    899699,
    898889,
    777989,
    878898,
    787988,
    978877,
    798887,
    887769,
    988879,
    986887,
    888887,
    869877,
    799888,
    997799,
    878978,
    986887,
    877898,
    899988,
    887898,
    778888,
    679978,
    787898,
    888999,
    889889,
    968878,
    888878,
    878776,
    677878,
    677866,
    987798,
    887978,
    899988,
    999977,
    867878,
    777888,
    696788,
    789788,
    788768,
    988689,
    988878,
    878979,
    767887,
    878688,
    998889,
    788887,
    698778,
    877798,
    877878,
    877979,
    787977,
    789776,
    778888,
    888878,
    878898,
    797677,
    879988,
    788797,
    778789,
    788989,
    889777,
    878878,
    768978,
    889887,
    887788,
    866988,
    888776,
    888979,
    787678,
    788778,
    788778,
    988887,
    889999,
    889797,
    979977,
    886898,
    869876,
    877879,
    777888,
    878988,
    889777,
    986888,
    888877,
    998998,
    886977,
    979879,
    786798,
    787788,
    798687,
    778879,
    977778,
    788878,
    688999,
    878776,
    887678,
    677777,
    778787,
    878896,
    898788,
    787988,
    977887,
    878787,
    967788,
    886878,
    777978,
    879777,
    986676,
    776768,
    798998,
    888887,
    877896,
    887688,
    788787,
    879889,
    979687,
    898887,
    788779,
    977988,
    887886,
    788888,
    877897,
    889986,
    888888,
    877866,
    896788,
    877788,
    888798,
    888998,
    888968,
    888877,
    988789,
    987777,
    877889,
    878889,
    977899,
    899989,
    778789,
    887888,
    688878,
    798888,
    778778,
    978778,
    898888,
    896879,
    687788,
    777888,
    978978,
    778687,
    898777,
    798789,
    789777,
    788877,
    878878,
    978798,
    889889,
    988889,
    888986,
    897988,
    889689,
    779777,
    887878,
    887788,
    787689,
    988888,
    987878,
    998967,
    787897,
    788898,
    798876,
    877879,
    877977,
    888898,
    998879,
    678898,
    887788,
    888798,
    888888,
    879686,
    967888,
    779798,
    898967,
    896777,
    777977,
    988899,
    998886,
    899887,
    899897,
    896877,
    887887,
    898788,
    977777,
    789898,
    986998,
    898888,
    888779,
    977789,
    878899,
    798898,
    989779,
    878877,
    878979,
    699987,
    797996,
    888897,
    887888,
    798798,
    887887,
    689878,
    868769,
    787979,
    687778,
    688879,
    787978,
    897897,
    878798,
    879779,
    889877,
    778888,
    988888,
    788976,
    889888,
    977898,
    787978,
    897888,
    768888,
    968678,
    798788,
    778897,
    977877,
    889887,
    798878,
    887868,
    878967,
    987978,
    787997,
    886877,
    789786,
    767979,
    867687,
    788886,
    898687,
    879899,
    797889,
    779868,
    789987,
    976879,
    888889,
    888797,
    879989,
    888978,
    997877,
    778878,
    778779,
    887797,
    778788,
    988897,
    788787,
    989888,
    887979,
    967677,
    778886,
    788997,
    899788,
    976889,
    788668,
    888789,
    767987,
    778768,
    887788,
    788789,
    898888,
    878987,
    987878,
    789787,
    878779,
    778767,
    897879,
    898777,
    777988,
    779689,
    767996,
    898878,
    688988,
    797787,
    888896,
    899978,
    797876,
    888877,
    778967,
    899698,
    978898,
    778887,
    787897,
    889867,
    987887,
    898868,
    878887,
    878678,
    678788,
    878877,
    797797,
    878867,
    778877,
    879788,
    789687,
    986777,
    777977,
    698887,
    968678,
    888889,
    888877,
    877889,
    688797,
    887668,
    888788,
    876877,
    877887,
    788989,
    767887,
    778798,
    777867,
    979898,
    988978,
    987889,
    789877,
    888697,
    876786,
    896877,
    877667,
    877798,
    988876,
    986777,
    887978,
    966787,
    897898,
    698779,
    787977,
    898898,
    768896,
    777678,
    788887,
    989988,
    786898,
    888978,
    878668,
    888688,
    898869,
    798988,
    878777,
    787887,
    879787,
    669976,
    689887,
    976797,
    978787,
    977788,
    787897,
    788897,
    888788,
    777788,
    698878,
    697878,
    689868,
    889797,
    887898,
    877877,
    876998,
    768987,
    876688,
    777988,
    887878,
    788887,
    877889,
    768797,
    777899,
    888887,
    798877,
    788888,
    898879,
    889967,
    678978,
    999879,
    788978,
    777678,
    888898,
    997989,
    869888,
    888779,
    999778,
    788787,
    878688,
    988888,
    879978,
    897897,
    879778,
    978978,
    888978,
    887999,
    887789,
    897799,
    887887,
    887788,
    979889,
    788888,
    786897,
    896867,
    978999,
    879898,
    767868,
    887687,
    799977,
    878887,
    879997,
    978888,
    988797,
    877976,
    889987,
    799997,
    989867,
    887988,
    797789,
    688777,
    987897,
    777897,
    899677,
    889878,
    879788,
    677877,
    676888,
    897987,
    987787,
    788898,
    879778,
    788788,
    887698,
    887878,
    777889,
    989998,
    768676,
    788787,
    997998,
    799777,
    779689,
    976887,
    678977,
    978889,
    987889,
    789968,
    887688,
    798779,
    767888,
    878788,
    777898,
    787787,
    788788,
    979888,
    887886,
    979798,
    878897,
    898787,
    887776,
    878687,
    888988,
    978778,
    786798,
    978988,
    889877,
    888789,
    898978,
    886779,
    887899,
    876898,
    977978,
    786889,
    888789,
    788889,
    688788,
    877879,
    787788,
    786698,
    887789,
    887798,
    786897,
    986787,
    787777,
    777977,
    797889,
    897798,
    787888,
    697889,
    877987,
    888788,
    878787,
    878787,
    978889,
    969768,
    868877,
    787898,
    888888,
    698778,
    988696,
    689878,
    788988,
    778979,
    868796,
    888888,
    797788,
    776788,
    978779,
    887877,
    876987,
    776879,
    768877,
    989999,
    988776,
    987878,
    877777,
    888888,
    887989,
    889798,
    899868,
    997798,
    888978,
    887999,
    988887,
    787878,
    997888,
    689988,
    886877,
    886897,
    987878,
    867777,
    778786,
    976989,
    979988,
    788868,
    876897,
    886779,
    787997,
    786788,
    888779,
    689878,
    698998,
    777787,
    887876,
    787888,
    998978,
    977888,
    698788,
    888787,
    777777,
    978788,
    788988,
    799787,
    888689,
    888886,
    877799,
    797987,
    898788,
    879787,
    788989,
    888878,
    788998,
    889778,
    979888,
    789887,
    969989,
    688976,
    867878,
    979899,
    878877,
    889868,
    877788,
    778787,
    989777,
    896876,
    877898,
    889977,
    797797,
    878887,
    978787,
    988778,
    797897,
    889878,
    877888,
    988787,
    868777,
    697997,
    888998,
    868998,
    889798,
    887769,
    876687,
    787787,
    777869,
    878888,
    777789,
    887887,
    979779,
    788699,
    888788,
    898978,
    688997,
    888797,
    987779,
    889867,
    899877,
    778998,
    779987,
    889778,
    677978,
    788878,
    888678,
    987889,
    986878,
    889786,
    998689,
    676888,
    798777,
    787788,
    677866,
    968788,
    778689,
    788887,
    789799,
    878889,
    777988,
    777888,
    778798,
    879887,
    988978,
    788876,
    888786,
    998986,
    977977,
    687779,
    978987,
    877779,
    978678,
    887888,
    778988,
    889769,
    888898,
    987978,
    888778,
    788788,
    789887,
    887678,
    876977,
    788667,
    878978,
    878787,
    887998,
    889888,
    988698,
    877888,
    778789,
    887888,
    867878,
    698777,
    787968,
    797877,
    978888,
    687976,
    999989,
    787878,
    877988,
    876997,
    888878,
    777778,
    877788,
    876988,
    899778,
    887989,
    887986,
    767778,
    889869,
    787798,
    676688,
    687867,
    899799,
    888779,
    689688,
    768787,
    788877,
    889887,
    787999,
    767998,
    879779,
    876888,
    999887,
    896887,
    978787,
    878898,
    887696,
    887878,
    786987,
    867878,
    778798,
    778767,
    788797,
    788897,
    898798,
    998888,
    689987,
    997787,
    878688,
    778878,
    877886,
    777898,
    887898,
    889697,
    897799,
    977878,
    886988,
    887789,
    789697,
    768799,
    888797,
    778779,
    779898,
    897787,
    877888,
    879867,
    877786,
    797879,
    987788,
    888968,
    887789,
    867888,
    778888,
    898677,
    878997,
    877879,
    898878,
    778788,
    798889,
    877676,
    879778,
    897798,
    697667,
    789897,
    978887,
    897676,
    879776,
    888778,
    786778,
    777879,
    788787,
    988877,
    977989,
    896979,
    966989,
    877787,
    888788,
    788899,
    887978,
    898888,
    788889,
    888788,
    978769,
    787986,
    989979,
    868997,
    789877,
    798987,
    697777,
    969887,
    899798,
    977888,
    678776,
    988788,
    677798,
    997788,
    968979,
    878777,
    678879,
    978977,
    777778,
    877787,
    777797,
    879888,
    799888,
    778788,
    999797,
    967787,
    679876,
    777767,
    797798,
    887978,
    987788,
    966789,
    989878,
    868888,
    776878,
    778777,
    797897,
    878988,
    697768,
    979788,
    968978,
    979887,
    877679,
    898898,
    998988,
    888787,
    877789,
    878787,
    789878,
    777987,
    887778,
    988887,
    977778,
    988886,
    779888,
    779887,
    777978,
    687887,
    988898,
    877877,
    887799,
    897788,
    877768,
    786788,
    688976,
    989777,
    778987,
    897978,
    879878,
    887989,
    878777,
    878888,
    688787,
    776888,
    997688,
    788777,
    889877,
    878678,
    688878,
    688878,
    886897,
    798878,
    778777,
    898886,
    886888,
    889788,
    979878,
    998678,
    779898,
    789889,
    797788,
    968888,
    788887,
    786798,
    989779,
    797976,
    897977,
    888786,
    797689,
    997798,
    878877,
    769878,
    888887,
    688889,
    897889,
    888788,
    888979,
    989887,
    888988,
    887888,
    697979,
    787888,
    899877,
    897896,
    889888,
    878877,
    878779,
    988677,
    778788,
    879978,
    878778,
    987787,
    869787,
    779789,
    878888,
    899978,
    897867,
    878786,
    877987,
    999679,
    976767,
    977988,
    899878,
    797967,
    888888,
    789878,
    879778,
    979778,
    979977,
    998897,
    878888,
    689878,
    798677,
    997769,
    878678,
    868898,
    789878,
    878787,
    989786,
    888888,
    876979,
    889876,
    797977,
    988889,
    969978,
    798788,
    777888,
    767787,
    877677,
    779998,
    977887,
    889678,
    987888,
    798777,
    688887,
    978988,
    897877,
    679888,
    868888,
    787968,
    877988,
    787778,
    778879,
    797887,
    788768,
    887878,
    698798,
    788878,
    788777,
    878887,
    977888,
    889876,
    888889,
    778878,
    887888,
    777879,
    789897,
    777776,
    889797,
    978878,
    877978,
    877697,
    787788,
    679797,
    898988,
    877888,
    879999,
    868899,
    877787,
    878878,
    979798,
    877788,
    787679,
    788789,
    798879,
    887998,
    888889,
    877777,
    888877,
    889887,
    787677,
    977797,
    788778,
    889889,
    989898,
    878889,
    786887,
    978889,
    888779,
    896798,
    997868,
    697898,
    689887,
    788787,
    879978,
    787798,
    889899,
    887878,
    797898,
    868778,
    768896,
    999787,
    888898,
    778898,
    677899,
    896889,
    877789,
    687889,
    879878,
    878868,
    876988,
    878878,
    879898,
    978797,
    968768,
    998888,
    788989,
    879878,
    688788,
    788899,
    878987,
    798867,
    879989,
    688778,
    888888,
    998768,
    787778,
    777887,
    997988,
    978898,
    776888,
    887898,
    779967,
    789977,
    868987,
    879787,
    789787,
    876987,
    897979,
    888889,
    999898,
    697789,
    886787,
    788897,
    878886,
    787798,
    896888,
    867897,
    897976,
    988877,
    987878,
    678888,
    788687,
    779899,
    878888,
    898887,
    868889,
    888699,
    888798,
    789969,
    876878,
    977896,
    767677,
    888879,
    799978,
    889698,
    998779,
    889799,
    867878,
    777797,
    978778,
    878897,
    887967,
    989778,
    777888,
    779778,
    887877,
    888868,
    898988,
    698786,
    788998,
    988668,
    788799,
    976977,
    997787,
    877976,
    879898,
    887978,
    798778,
    988788,
    999979,
    977878,
    879878,
    888767,
    778877,
    788787,
    979989,
    898787,
    888986,
    787987,
    796788,
    978779,
    899789,
    867776,
    877988,
    777877,
    688888,
    867998,
    786888,
    879878,
    788888,
    878778,
    899768,
    986768,
    889788,
    896678,
    777897,
    778888,
    889887,
    896978,
    869778,
    889987,
    797679,
    777898,
    787787,
    878898,
    987767,
    798869,
    878968,
    896888,
    888978,
    897799,
    997676,
    888688,
    979897,
    887988,
    777789,
    788977,
    888887,
    878788,
    887889,
    777789,
    888698,
    869897,
    787778,
    798877,
    878789,
    869977,
    778888,
    899786,
    977989,
    978888,
    787877,
    879788,
    878777,
    888777,
    778868,
    889788,
    798788,
    898888,
    779688,
    898778,
    989988,
    988988,
    988898,
    878778,
    978878,
    889996,
    877898,
    678888,
    878887,
    877878,
    678899,
    779889,
    779879,
    788888,
    789789,
    799887,
    777987,
    699868,
    768797,
    669778,
    778687,
    878797,
    676888,
    989899,
    897879,
    889788,
    777787,
    897978,
    886887,
    888879,
    988797,
    988797,
    877989,
    868888,
    887797,
    778689,
    988878,
    978796,
    779988,
    788699,
    987777,
    778878,
    778977,
    998897,
    878888,
    677686,
    987888,
    888878,
    878698,
    978789,
    778868,
    886769,
    799977,
    877877,
    778879,
    878788,
    888888,
    678878,
    787986,
    777688,
    678787,
    987897,
    888869,
    769988,
    798888,
    968798,
    889788,
    899787,
    786698,
    978889,
    879879,
    897869,
    868787,
    897678,
    877998,
    796888,
    899868,
    779678,
    888888,
    778878,
    988888,
    978878,
    788798,
    888878,
    898998,
    889879,
    877889,
    777896,
    887887,
    779768,
    998887,
    898888,
    897789,
    778776,
    877887,
    777899,
    887687,
    868777,
    987868,
    878777,
    789789,
    878889,
    988798,
    978787,
    877668,
    988898,
    787798,
    876766,
    777778,
    889778,
    888989,
    798677,
    997778,
    699788,
    879868,
    788788,
    988878,
    996888,
    798778,
    878688,
    668879,
    977889,
    899978,
    897987,
    989777,
    978887,
    878979,
    787977,
    899687,
    888787,
    889877,
    788788,
    877777,
    898888,
    687789,
    769879,
    899979,
    877897,
    999978,
    987888,
    789888,
    887888,
    888779,
    878978,
    778887,
    887876,
    898887,
    788978,
    879887,
    787878,
    868789,
    898877,
    898878,
    787877,
    797788,
    887768,
    798878,
    899967,
    688788,
    679787,
    788888,
    799977,
    789868,
    798878,
    777888,
    778788,
    779778,
    888898,
    866897,
    869987,
    779787,
    776797,
    889777,
    777789,
    788788,
    879879,
    769886,
    978776,
    988798,
    887887,
    889778,
    997768,
    789799,
    989788,
    899887,
    897887,
    867778,
    878999,
    698777,
    778998,
    687698,
    898778,
    797888,
    788787,
    887787,
    778779,
    978887,
    987897,
    689788,
    869998,
    677888,
    887979,
    789879,
    988889,
    776887,
    768778,
    789998,
    689877,
    979776,
    879988,
    877967,
    788879,
    987787,
    797787,
    788886,
    976789,
    788988,
    787889,
    898897,
    797878,
    897976,
    887899,
    977987,
    777788,
    989997,
    788788,
    788879,
    778878,
    877698,
    778888,
    878998,
    899888,
    788888,
    798877,
    977799,
    778878,
    688888,
    879767,
    987889,
    988888,
    878797,
    899797,
    787879,
    878878,
    888997,
    866899,
    896888,
    899887,
    788897,
    887889,
    697788,
    968888,
    877989,
    878779,
    888967,
    888878,
    797977,
    778888,
    868778,
    977888,
    987867,
    999788,
    787798,
    989868,
    869987,
    888797,
    788888,
    677989,
    879999,
    788786,
    888887,
    779787,
    879897,
    888888,
    897888,
    989889,
    798877,
    879688,
    877777,
    977888,
    889787,
    777767,
    787879,
    987777,
    787798,
    878887,
    788877,
    787988,
    769767,
    888768,
    877979,
    877889,
    868868,
    777886,
    677887,
    887886,
    697978,
    888986,
    886887,
    888988,
    878788,
    868999,
    988877,
    798898,
    768998,
    877678,
    787777,
    887878,
    878888,
    888777,
    987877,
    866988,
    878767,
    776689,
    777698,
    887867,
    798877,
    798776,
    779777,
    868988,
    777777,
    677888,
    888789,
    887878,
    988798,
    879887,
    887777,
    877978,
    788879,
    898877,
    789889,
    888888,
    878699,
    797877,
    878668,
    887688,
    777787,
    996888,
    869988,
    789778,
    789978,
    778797,
    897787,
    878989,
    678778,
    888866,
    888877,
    787988,
    688799,
    687697,
    878697,
    886887,
    889776,
    987787,
    778968,
    798798,
    898898,
    899897,
    888867,
    797998,
    686898,
    698987,
    997878,
    976978,
    779878,
    876978,
    878787,
    797787,
    888887,
    868878,
    788887,
    787678,
    898987,
    877778,
    888799,
    798789,
    788888,
    777778,
    977778,
    889898,
    797898,
    888788,
    887889,
    688687,
    887998,
    878776,
    798887,
    878878,
    988897,
    967888,
    878997,
    878899,
    897988,
    688998,
    877798,
    887888,
    888797,
    799767,
    879797,
    888897,
    986888,
    878897,
    676788,
    987988,
    977887,
    988877,
    887768,
    887787,
    996897,
    878797,
    969667,
    779777,
    797897,
    989867,
    977678,
    788878,
    887878,
    798967,
    969898,
    899889,
    867988,
    897888,
    887797,
    977778,
    798878,
    978887,
    887768,
    878778,
    786876,
    787778,
    987778,
    878898,
    687699,
    788976,
    887797,
    879698,
    887887,
    798998,
    896887,
    898798,
    778897,
    888878,
    889888,
    898769,
    878676,
    888787,
    988989,
    886977,
    778877,
    878698,
    877999,
    879676,
    988778,
    898898,
    898879,
    878779,
    777878,
    878789,
    778878,
    987877,
    877878,
    698897,
    889777,
    678788,
    878898,
    797889,
    697799,
    968887,
    798998,
    789988,
    997876,
    978786,
    997699,
    788787,
    977788,
    787767,
    777697,
    667977,
    988868,
    888878,
    897767,
    878898,
    788879,
    877687,
    878766,
    979978,
    867998,
    778878,
    987687,
    888877,
    898788,
    877998,
    896777,
    877878,
    877889,
    697787,
    979877,
    979887,
    877799,
    777798,
    889797,
    787886,
    777887,
    887887,
    878687,
    779889,
    777886,
    998769,
    879888,
    786878,
    897877,
    788987,
    887888,
    878877,
    777788,
    898789,
    878697,
    976989,
    978899,
    888786,
    788787,
    778898,
    779889,
    788989,
    888789,
    888877,
    887878,
    898699,
    798988,
    788799,
    899988,
    979888,
    777767,
    886887,
    788878,
    867988,
    689797,
    887889,
    897989,
    768888,
    887678,
    898788,
    878889,
    799687,
    888787,
    989798,
    688798,
    887778,
    977977,
    878878,
    989887,
    966787,
    787889,
    977899,
    898787,
    898696,
    988977,
    889798,
    887877,
    888988,
    896787,
    788888,
    779998,
    889778,
    997988,
    999688,
    987997,
    787797,
    698867,
    799879,
    886788,
    977986,
    989689,
    887978,
    697779,
    887787,
    887797,
    988979,
    697898,
    698988,
    678986,
    789889,
    997778,
    689778,
    877877,
    787799,
    877877,
    877877,
    888789,
    896986,
    978998,
    997788,
    888887,
    788877,
    888888,
    987899,
    887788,
    988998,
    898987,
    877886,
    977887,
    668677,
    677878,
    798788,
    798778,
    878677,
    879777,
    687887,
    779689,
    887877,
    787887,
    898879,
    978897,
    798788,
    887878,
    787997,
    979798,
    989988,
    779899,
    879788,
    767788,
    796788,
    788778,
    888886,
    987988,
    897877,
    978877,
    866788,
    868777,
    798877,
    899898,
    789867,
    688777,
    888889,
    976897,
    788887,
    788878,
    878789,
    887879,
    879879,
    988998,
    878879,
    897888,
    888798,
    899977,
    777988,
    787787,
    687898,
    878786,
    999887,
    887777,
    777788,
    766978,
    888977,
    788679,
    888888,
    787868,
    878879,
    787888,
    986777,
    976888,
    688889,
    777787,
    887997,
    868898,
    987978,
    887888,
    899978,
    987788,
    789988,
    978777,
    988689,
    789897,
    898879,
    797888,
    889886,
    988778,
    688787,
    997878,
    879989,
    886789,
    777996,
    779778,
    768878,
    988678,
    789888,
    797989,
    778898,
    878788,
    879987,
    989888,
    877768,
    877888,
    976777,
    887987,
    988997,
    898887,
    888877,
    887889,
    899986,
    879876,
    878788,
    988777,
    877878,
    688979,
    878887,
    987888,
    977767,
    988999,
    987878,
    778878,
    887887,
    778669,
    978787,
    987689,
    797778,
    997888,
    778797,
    898789,
    698797,
    888789,
    987778,
    999999,
    779699,
    778877,
    878879,
    888878,
    879877,
    798787,
    786799,
    787978,
    698889,
    789979,
    978879,
    877767,
    897898,
    978888,
    787688,
    898888,
    978689,
    889877,
    798877,
    777898,
    888778,
    888888,
    798787,
    868887,
    778997,
    788889,
    767877,
    687867,
    878869,
    998878,
    977887,
    987878,
    898878,
    897778,
    877878,
    878778,
    778887,
    879869,
    778888,
    889867,
    988787,
    899768,
    787689,
    998799,
    768977,
    778768,
    898888,
    777788,
    997887,
    888977,
    767788,
    888787,
    788878,
    978778,
    797888,
    867898,
    668877,
    988797,
    879868,
    878979,
    798997,
    898787,
    889879,
    968779,
    897897,
    878878,
    888779,
    887777,
    677676,
    677799,
    879898,
    889887,
    897996,
    786678,
    787898,
    897989,
    888787,
    889978,
    887788,
    998889,
    897886,
    778896,
    878878,
    977978,
    798797,
    888788,
    999897,
    777888,
    888787,
    888968,
    779888,
    888888,
    987888,
    798879,
    878777,
    887877,
    888777,
    987889,
    978687,
    977888,
    887797,
    978889,
    898789,
    798987,
    988779,
    787898,
    897988,
    788778,
    979799,
    978989,
    987698,
    877688,
    788798,
    797798,
    788789,
    876778,
    776998,
    879978,
    687988,
    898967,
    888879,
    778779,
    778867,
    768886,
    889797,
    886878,
    778786,
    988898,
    889787,
    877998,
    987889,
    887897,
    888877,
    987877,
    987988,
    977878,
    878789,
    887778,
    799798,
    978888,
    878787,
    898778,
    897887,
    867778,
    897987,
    978879,
    888988,
    777878,
    889878,
    978797,
    777887,
    888887,
    797888,
    888898,
    877987,
    777887,
    997687,
    877788,
    778869,
    988788,
    888779,
    967986,
    798779,
    787787,
    877979,
    898877,
    888778,
    888866,
    699898,
    888877,
    897886,
    886779,
    888978,
    887778,
    987879,
    798987,
    988886,
    899888,
    788998,
    977887,
    777779,
    879889,
    879868,
    778976,
    888687,
    878787,
    778877,
    788767,
    988899,
    887867,
    789988,
    778668,
    988878,
    998788,
    777678,
    887898,
    788897,
    868778,
    888988,
    778879,
    777888,
    877997,
    789788,
    887989,
    869789,
    977888,
    788898,
    787768,
    889778,
    678787,
    899688,
    887987,
    887888,
    997988,
    967997,
    688798,
    788788,
    899877,
    877879,
    787788,
    687778,
    898897,
    777889,
    798689,
    778878,
    878989,
    977878,
    789889,
    777878,
    888778,
    898899,
    886887,
    897887,
    887988,
    788787,
    787878,
    878788,
    798996,
    978878,
    979899,
    988777,
    967668,
    777989,
    887789,
    978788,
    687898,
    688877,
    978789,
    887878,
    778666,
    896986,
    888888,
    887679,
    787978,
    788767,
    878888,
    988678,
    978879,
    686689,
    697798,
    988978,
    878889,
    868797,
    787788,
    778977,
    799897,
    998897,
    978668,
    787888,
    988799,
    778766,
    968779,
    988889,
    877898,
    867987,
    768878,
    899877,
    989787,
    789898,
    887888,
    988787,
    999886,
    788877,
    797988,
    888988,
    888867,
    887778,
    879989,
    898886,
    776797,
    677888,
    888979,
    899798,
    887889,
    877868,
    888879,
    777887,
    888879,
    789878,
    977868,
    879788,
    878878,
    989877,
    877888,
    987668,
    787777,
    868887,
    778878,
    888878,
    979878,
    788879,
    877887,
    789779,
    878779,
    988977,
    799978,
    978997,
    888887,
    977787,
    777688,
    698878,
    786887,
    789898,
    778768,
    787878,
    887988,
    778978,
    798877,
    778889,
    889877,
    777886,
    677898,
    788788,
    777778,
    688887,
    779897,
    986798,
    787888,
    688877,
    897887,
    887877,
    776788,
    689988,
    897867,
    767877,
    989987,
    777788,
    799799,
    788779,
    879779,
    898777,
    789868,
    877987,
    678879,
    877788,
    876777,
    967986,
    997977,
    898788,
    799877,
    867677,
    888678,
    878888,
    798897,
    897877,
    786888,
    988998,
    668868,
    999689,
    778889,
    798887,
    886889,
    877796,
    898897,
    677867,
    987788,
    787889,
    776897,
    877767,
    887878,
    998897,
    887878,
    689968,
    867988,
    879777,
    899777,
    769986,
    879778,
    888886,
    878889,
    789888,
    687797,
    779687,
    789879,
    787987,
    878677,
    986886,
    887998,
    898888,
    789878,
    698879,
    979977,
    778789,
    988778,
    889897,
    898899,
    967689,
    778898,
    888987,
    786788,
    886788,
    876778,
    988799,
    889897,
    689967,
    887778,
    768777,
    877779,
    787898,
    787888,
    998788,
    688879,
    878788,
    878778,
    667787,
    898787,
    697778,
    899777,
    988879,
    777988,
    888877,
    786797,
    877878,
    888778,
    977879,
    888786,
    798768,
    878878,
    799998,
    689788,
    978888,
    977887,
    977787,
    777879,
    777987,
    888987,
    778778,
    788788,
    777898,
    888888,
    787898,
    767986,
    766888,
    967888,
    777687,
    877888,
    978788,
    977987,
    779888,
    778897,
    889798,
    887897,
    987898,
    868787,
    889788,
    897989,
    889787,
    886887,
    789898,
    987999,
    877789,
    786678,
    788788,
    878877,
    898787,
    878979,
    778689,
    778789,
    778688,
    767878,
    877889,
    888978,
    887889,
    979887,
    768696,
    799876,
    897788,
    878879,
    879777,
    868889,
    789877,
    879889,
    797787,
    988778,
    978999,
    979889,
    888977,
    879887,
    688898,
    898887,
    767787,
    887887,
    898899,
    876888,
    787987,
    878796,
    778797,
    877987,
    868798,
    787789,
    677687,
    988888,
    687898,
    978887,
    989877,
    877798,
    877887,
    777788,
    989878,
    888788,
    789877,
    899887,
    988688,
    897868,
    888798,
    979999,
    787897,
    989888,
    887879,
    977798,
    867888,
    778997,
    997899,
    897767,
    767868,
    868998,
    899888,
    798677,
    796689,
    797887,
    789789,
    867796,
    769878,
    689898,
    897888,
    787988,
    988987,
    978877,
    799978,
    786777,
    888879,
    778997,
    899886,
    768889,
    887876,
    887988,
    887887,
    887888,
    786689,
    798888,
    988789,
    888987,
    769778,
    879889,
    878987,
    789798,
    678778,
    788788,
    987788,
    978779,
    766788,
    687887,
    767998,
    978978,
    868788,
    887788,
    878898,
    887787,
    778897,
    799888,
    888787,
    877997,
    976989,
    987898,
    899898,
    696889,
    777988,
    687788,
    898687,
    778798,
    788787,
    778867,
    999867,
    877787,
    879788,
    768868,
    789899,
    987898,
    887879,
    887778,
    799776,
    887788,
    988979,
    888798,
    898797,
    889887,
    888878,
    978777,
    867787,
    877778,
    778798,
    787866,
    877788,
    888887,
    777988,
    878977,
    887986,
    988987,
    778878,
    988878,
    878878,
    888787,
    788789,
    888897,
    767798,
    888777,
    787787,
    879789,
    788887,
    787877,
    987789,
    778788,
    968888,
    988997,
    888978,
    777878,
    977786,
    778888,
    998877,
    788868,
    998767,
    987777,
    898788,
    687787,
    987889,
    887668,
    778888,
    887799,
    886886,
    887867,
    697877,
    987777,
    679888,
    967787,
    968788,
    787869,
    887878,
    877797,
    778878,
    977878,
    787898,
    778987,
    788886,
    869788,
    868968,
    877788,
    877878,
    978879,
    889888,
    897699,
    777988,
    796777,
    797879,
    988887,
    788798,
    777777,
    988886,
    789977,
    887878,
    877979,
    897897,
    868998,
    887977,
    888879,
    899779,
    988778,
    877776,
    787778,
    989798,
    777987,
    979968,
    798676,
    887889,
    678987,
    777769,
    897878,
    788769,
    797878,
    977898,
    878879,
    687766,
    868898,
    877878,
    877887,
    888787,
    788878,
    878787,
    887678,
    788888,
    999887,
    887786,
    868778,
    989678,
    888997,
    788878,
    898976,
    987998,
    697899,
    877778,
    789888,
    886888,
    786798,
    987689,
    776888,
    988888,
    989878,
    678887,
    888988,
    788999,
    788788,
    778789,
    878788,
    688677,
    688786,
    668779,
    887977,
    888989,
    886878,
    797798,
    897679,
    787688,
    888888,
    989888,
    987878,
    888888,
    778798,
    878798,
    877789,
    887766,
    889877,
    887899,
    778877,
    888787,
    788997,
    789989,
    688888,
    786799,
    978868,
    997778,
    788987,
    789767,
    699968,
    897789,
    889888,
    777878,
    988896,
    787887,
    767987,
    887999,
    888988,
    878867,
    787877,
    898868,
    877898,
    799788,
    877778,
    988888,
    788787,
    787878,
    977777,
    989989,
    887887,
    877788,
    788877,
    876987,
    798797,
    886787,
    886888,
    687778,
    878887,
    887787,
    786977,
    978986,
    987897,
    789888,
    687899,
    678897,
    677978,
    977888,
    778787,
    976777,
    897879,
    997876,
    887998,
    878889,
    978888,
    998888,
    887779,
    798777,
    779797,
    889799,
    876878,
    897767,
    788977,
    788878,
    887869,
    878887,
    977799,
    778788,
    887978,
    888898,
    787877,
    888877,
    877798,
    878788,
    878879,
    889889,
    868898,
    788796,
    888778,
    778977,
    788987,
    978897,
    878877,
    886796,
    878877,
    787997,
    777878,
    788787,
    977887,
    979897,
    776786,
    767776,
    888877,
    898767,
    789799,
    978978,
    778987,
    788778,
    787779,
    898878,
    677897,
    688986,
    898897,
    777878,
    888796,
    877998,
    867889,
    777789,
    998878,
    877989,
    887798,
    787777,
    998979,
    886877,
    888788,
    887898,
    798788,
    769678,
    788978,
    998777,
    767877,
    768899,
    898897,
    796889,
    878998,
    888888,
    887788,
    777878,
    888987,
    788797,
    777888,
    888887,
    887887,
    897878,
    897967,
    899998,
    869979,
    998988,
    878899,
    877879,
    778777,
    777878,
    998768,
    768979,
    867868,
    787889,
    667897,
    998788,
    677867,
    678879,
    977687,
    778779,
    998869,
    879977,
    877788,
    897698,
    877978,
    798776,
    878967,
    878699,
    889769,
    879789,
    878888,
    788778,
    869887,
    798678,
    888967,
    999679,
    878886,
    687877,
    778777,
    789879,
    898798,
    896898,
    988967,
    788889,
    888978,
    797988,
    789897,
    888787,
    988878,
    868878,
    888896,
    778887,
    778888,
    898878,
    898877,
    978889,
    897787,
    799889,
    978787,
    787987,
    886777,
    887778,
    798787,
    778797,
    887999,
    697788,
    776787,
    887898,
    776897,
    779677,
    888787,
    979886,
    997877,
    987696,
    887798,
    978876,
    798886,
    688868,
    787888,
    777996,
    967988,
    977888,
    887887,
    898868,
    878887,
    898878,
    978978,
    887897,
    777678,
    798887,
    688977,
    888979,
    988888,
    788789,
    777788,
    879977,
    788878,
    778878,
    868988,
    889767,
    869877,
    779779,
    788888,
    869788,
    987897,
    896887,
    898886,
    868768,
    887878,
    978777,
    898788,
    788978,
    887898,
    796888,
    888766,
    899977,
    867967,
    878978,
    788798,
    979987,
    876878,
    877778,
    778888,
    877978,
    878787,
    887889,
    898888,
    897686,
    887888,
    998878,
    777777,
    976898,
    878788,
    686867,
    896676,
    787779,
    697788,
    787789,
    977898,
    777768,
    788879,
    989879,
    999877,
    988898,
    897887,
    997877,
    788898,
    987788,
    788878,
    789887,
    787867,
    988788,
    976976,
    676798,
    798879,
    887878,
    888988,
    899768,
    777887,
    788878,
    798688,
    788887,
    888888,
    876888,
    778669,
    789897,
    898986,
    888686,
    787886,
    877787,
    897979,
    879787,
    867698,
    888767,
    798898,
    886788,
    879877,
    877677,
    779787,
    799879,
    898687,
    776998,
    887988,
    878778,
    779888,
    988968,
    879777,
    878687,
    988887,
    776987,
    789989,
    887889,
    887987,
    977779,
    977898,
    887988,
    777898,
    877977,
    888888,
    798888,
    978998,
    789967,
    688777,
    777789,
    777887,
    878887,
    999878,
    876767,
    987799,
    786878,
    788988,
    887877,
    897698,
    988888,
    888987,
    888998,
    998888,
    876888,
    798687,
    779698,
    977988,
    767789,
    978878,
    977788,
    887898,
    896988,
    878876,
    987979,
    977698,
    988788,
    798788,
    778887,
    699798,
    988787,
    896897,
    796788,
    879788,
    787788,
    988888,
    988987,
    998786,
    799888,
    889898,
    778978,
    878677,
    996887,
    988689,
    878878,
    889989,
    668778,
    776888,
    988798,
    778877,
    888799,
    887988,
    888787,
    799867,
    798898,
    788869,
    778868,
    889877,
    889789,
    978888,
    778778,
    989978,
    768997,
    987887,
    768989,
    987788,
    688896,
    688886,
    789998,
    898798,
    876987,
    778778,
    989778,
    898798,
    777787,
    888787,
    887888,
    869767,
    968978,
    888887,
    878678,
    767788,
    968897,
    778879,
    878779,
    888977,
    767787,
    768878,
    798889,
    777877,
    789877,
    779877,
    779889,
    878886,
    888978,
    887988,
    889777,
    768896,
    687797,
    798778,
    876688,
    799779,
    898979,
    988777,
    778788,
    879988,
    797688,
    797979,
    978878,
    879878,
    788796,
    888988,
    897887,
    989788,
    678877,
    887977,
    887798,
    888898,
    887899,
    887878,
    876886,
    987898,
    887878,
    887787,
    767877,
    988898,
    886888,
    798889,
    887898,
    788776,
    797778,
    787777,
    788797,
    797799,
    887998,
    788987,
    888798,
    797886,
    888798,
    878889,
    889868,
    888777,
    867978,
    977786,
    797889,
    989788,
    777889,
    878897,
    889886,
    799788,
    888888,
    998798,
    898878,
    988788,
    767798,
    989897,
    799779,
    889799,
    797877,
    889879,
    888777,
    797968,
    996888,
    777787,
    989789,
    697787,
    798889,
    877889,
    897877,
    888887,
    788979,
    797889,
    687899,
    766688,
    797896,
    976879,
    877787,
    988697,
    766887,
    877779,
    966877,
    869878,
    787788,
    887978,
    777878,
    999898,
    878888,
    778979,
    778888,
    789688,
    889778,
    788797,
    787687,
    879988,
    777787,
    787778,
    999789,
    878888,
    787977,
    987988,
    787979,
    888997,
    788888,
    888787,
    789799,
    888889,
    898787,
    888788,
    786887,
    988678,
    778867,
    678889,
    778888,
    887989,
    668977,
    989877,
    789997,
    697987,
    778989,
    797876,
    898768,
    786779,
    977778,
    777679,
    888878,
    888888,
    777877,
    797888,
    897788,
    877777,
    887788,
    878997,
    977977,
    678787,
    778787,
    788989,
    878887,
    879788,
    887989,
    889877,
    796899,
    799977,
    977888,
    877977,
    898787,
    877886,
    767877,
    778878,
    888898,
    969779,
    898878,
    887987,
    879987,
    899787,
    779978,
    677668,
    878788,
    979798,
    866889,
    687878,
    787988,
    977898,
    788788,
    878877,
    887788,
    797877,
    887888,
    889877,
    887787,
    778678,
    868887,
    789788,
    879896,
    998788,
    999887,
    789777,
    768988,
    798897,
    887988,
    778888,
    787788,
    986887,
    867768,
    887988,
    799797,
    897688,
    798878,
    886877,
    878987,
    788988,
    978887,
    888787,
    787886,
    878988,
    788878,
    787877,
    989887,
    798877,
    789888,
    768777,
    787667,
    777978,
    977896,
    777888,
    878789,
    888877,
    888778,
    797787,
    898869,
    887878,
    888797,
    878678,
    777887,
    789787,
    698868,
    887887,
    898878,
    879778,
    787998,
    877988,
    787778,
    778967,
    868966,
    777988,
    877888,
    787879,
    897977,
    686778,
    697699,
    878888,
    778767,
    889788,
    979779,
    887878,
    778788,
    889887,
    887879,
    889788,
    898887,
    778987,
    677889,
    799888,
    777877,
    989768,
    997788,
    878887,
    787777,
    868977,
    967989,
    798879,
    878878,
    797789,
    778977,
    878788,
    877898,
    897877,
    779779,
    787879,
    998889,
    977796,
    898979,
    769896,
    677988,
    888777,
    779778,
    788799,
    787888,
    897889,
    878897,
    698787,
    887898,
    788778,
    788898,
    688777,
    868978,
    978788,
    788889,
    977798,
    888789,
    899988,
    888889,
    787998,
    888788,
    887668,
    897888,
    977877,
    887778,
    979778,
    987888,
    787888,
    778987,
    789898,
    987988,
    788887,
    796988,
    988878,
    797889,
    679877,
    889787,
    977698,
    888888,
    978888,
    997788,
    888778,
    896979,
    877789,
    888976,
    878888,
    776798,
    887978,
    978876,
    997878,
    876779,
    779996,
    867888,
    778987,
    877677,
    887877,
    888888,
    897887,
    898876,
    977777,
    687888,
    698667,
    888778,
    768687,
    788868,
    688979,
    878787,
    769889,
    987878,
    997677,
    877897,
    987978,
    798978,
    878678,
    778788,
    899987,
    799888,
    877879,
    977887,
    988978,
    788676,
    888999,
    777899,
    888998,
    986977,
    989777,
    988797,
    787787,
    879897,
    779778,
    779967,
    989799,
    689797,
    987898,
    988877,
    777899,
    789787,
    688777,
    798879,
    989787,
    787878,
    879787,
    877887,
    877898,
    798887,
    878788,
    878897,
    688777,
    798798,
    877879,
    888988,
    887798,
    788998,
    878897,
    788788,
    897897,
    777889,
    888969,
    897766,
    788898,
    878787,
    977898,
    886886,
    868788,
    886888,
    877977,
    887988,
    689898,
    797788,
    888877,
    888997,
    778998,
    799898,
    878689,
    787887,
    788779,
    888987,
    888789,
    879977,
    788888,
    678887,
    888986,
    788778,
    767889,
    887898,
    879977,
    987778,
    889698,
    998887,
    789889,
    888979,
    778678,
    777787,
    897887,
    796977,
    888788,
    868777,
    978797,
    879897,
    686789,
    878768,
    878888,
    988879,
    777678,
    889879,
    686778,
    886987,
    879889,
    897867,
    787698,
    887868,
    988878,
    778677,
    796687,
    877778,
    898768,
    878879,
    778798,
    879886,
    788888,
    777878,
    989868,
    798798,
    777899,
    977998,
    889788,
    987787,
    778778,
    887887,
    868777,
    878988,
    878877,
    689888,
    879779,
    778888,
    789976,
    798877,
    886887,
    798988,
    888788,
    788798,
    786777,
    878898,
    877986,
    878989,
    878887,
    778799,
    897976,
    787789,
    898879,
    796888,
    987879,
    777768,
    888987,
    897879,
    777698,
    787787,
    987887,
    888979,
    898889,
    967889,
    887898,
    978998,
    787787,
    888788,
    987876,
    998878,
    977978,
    698678,
    767787,
    887888,
    987786,
    788789,
    798878,
    987789,
    779877,
    889698,
    798888,
    978888,
    867887,
    897898,
    787678,
    878896,
    987899,
    877877,
    986897,
    877879,
    889798,
    887799,
    877878,
    787987,
    789779,
    777877,
    887978,
    688678,
    888889,
    769877,
    989989,
    886977,
    888979,
    998687,
    979676,
    887777,
    678788,
    967779,
    788899,
    788777,
    879898,
    887788,
    987887,
    897777,
    799989,
    779789,
    896887,
    887789,
    789888,
    777779,
    986868,
    989898,
    867877,
    879678,
    788778,
    988889,
    787977,
    777679,
    787888,
    787988,
    787788,
    889987,
    799797,
    778787,
    797888,
    978988,
    887988,
    898787,
    887797,
    988878,
    766796,
    978798,
    877877,
    676997,
    888997,
    988867,
    789998,
    787777,
    788777,
    977878,
    869879,
    767988,
    887978,
    878779,
    786879,
    788888,
    876788,
    788887,
    896897,
    989787,
    798886,
    777788,
    787878,
    988787,
    887767,
    978977,
    898886,
    897679,
    779679,
    787877,
    888788,
    899888,
    776899,
    888798,
    668978,
    888867,
    899777,
    777687,
    798788,
    768978,
    797887,
    879878,
    886878,
    878987,
    778798,
    787688,
    867879,
    879788,
    899777,
    878688,
    797887,
    779788,
    797788,
    888786,
    799777,
    967879,
    798799,
    886787,
    876889,
    896778,
    786788,
    979697,
    779987,
    988877,
    899889,
    778878,
    886789,
    878678,
    689988,
    798999,
    777989,
    788888,
    888986,
    768978,
    998789,
    898987,
    887878,
    888777,
    789977,
    988788,
    788977,
    867869,
    989877,
    887988,
    897867,
    877988,
    877797,
    678879,
    869798,
    998787,
    898888,
    887888,
    677679,
    779778,
    987788,
    989897,
    778766,
    797898,
    798786,
    778987,
    997788,
    777798,
    689887,
    989779,
    977787,
    887797,
    979978,
    897679,
    989787,
    788777,
    778778,
    889887,
    988978,
    788787,
    777778,
    777889,
    789888,
    788897,
    987987,
    787878,
    979888,
    967778,
    787876,
    989878,
    787787,
    888877,
    898788,
    679668,
    778898,
    977798,
    698798,
    897888,
    988988,
    879878,
    999798,
    879997,
    868677,
    888976,
    787988,
    889889,
    788889,
    789786,
    887879,
    988897,
    878898,
    888798,
    798788,
    798788,
    778788,
    788777,
    787787,
    978787,
    778988,
    788867,
    987877,
    788998,
    887878,
    887789,
    977889,
    897699,
    889967,
    769778,
    877898,
    767997,
    879689,
    777877,
    888898,
    988889,
    887886,
    979989,
    777877,
    978898,
    897887,
    877878,
    787787,
    878989,
    889879,
    767876,
    878876,
    776788,
    779877,
    798887,
    978988,
    877879,
    796978,
    886889,
    898978,
    789689,
    697787,
    789887,
    877888,
    888888,
    679779,
    787886,
    778877,
    868768,
    988768,
    988876,
    887786,
    878989,
    889889,
    687688,
    878789,
    768899,
    877988,
    879888,
    876789,
    888679,
    888788,
    776996,
    787868,
    987768,
    888898,
    888698,
    788797,
    886789,
    877896,
    688979,
    997999,
    688888,
    887789,
    988886,
    899898,
    896987,
    877799,
    887788,
    787988,
    787989,
    878789,
    688888,
    898879,
    889878,
    789788,
    868897,
    999768,
    987897,
    887878,
    888888,
    787879,
    978988,
    778877,
    889887,
    879977,
    677778,
    979889,
    778899,
    688898,
    887779,
    978886,
    898999,
    897986,
    797879,
    766979,
    877867,
    888877,
    688897,
    888879,
    789688,
    788868,
    978778,
    897898,
    777997,
    888878,
    787977,
    897987,
    878798,
    788897,
    798877,
    878898,
    976878,
    997979,
    786789,
    688988,
    788979,
    778987,
    787889,
    977887,
    976989,
    877898,
    797779,
    879878,
    887888,
    879787,
    999788,
    888889,
    989787,
    789898,
    868899,
    788888,
    797779,
    886997,
    887787,
    987787,
    679868,
    977977,
    978787,
    967887,
    988788,
    899879,
    988688,
    897878,
    778978,
    877797,
    898778,
    887797,
    888786,
    878787,
    778968,
    798886,
    877697,
    888779,
    886887,
    787778,
    789888,
    969878,
    978977,
    797889,
    887889,
    898988,
    978787,
    897778,
    898788,
    797786,
    897868,
    869789,
    778867,
    978878,
    798887,
    879889,
    869698,
    788897,
    877998,
    877898,
    688887,
    688888,
    888778,
    888987,
    889797,
    888988,
    797777,
    797778,
    767888,
    879887,
    897786,
    879777,
    777888,
    789779,
    888787,
    887898,
    887878,
    788879,
    977667,
    887989,
    879889,
    768887,
    888978,
    797676,
    788888,
    788888,
    788888,
    877698,
    887878,
    898878,
    897789,
    777877,
    787778,
    798788,
    888878,
    888987,
    976897,
    779689,
    797979,
    878878,
    877688,
    789878,
    789889,
    898877,
    979688,
    988888,
    887787,
    777777,
    677798,
    896878,
    898879,
    798898,
    887888,
    769789,
    977777,
    799889,
    988779,
    887888,
    986768,
    898797,
    989778,
    877868,
    887977,
    988777,
    779888,
    897778,
    877878,
    978887,
    798988,
    978888,
    977778,
    897968,
    987787,
    978989,
    886778,
    977877,
    697887,
    868688,
    689799,
    977797,
    898988,
    879788,
    886879,
    988779,
    778778,
    888888,
    787886,
    678898,
    887789,
    879778,
    676877,
    887788,
    677787,
    897896,
    867987,
    779899,
    878777,
    887878,
    988898,
    877697,
    987777,
    787998,
    878787,
    798788,
    787899,
    788968,
    868689,
    877878,
    889997,
    988679,
    786776,
    888978,
    678879,
    976989,
    876886,
    689789,
    787788,
    879787,
    996898,
    888789,
    879789,
    987878,
    778788,
    797899,
    887677,
    968788,
    877888,
    987798,
    898989,
    676877,
    778887,
    886887,
    788787,
    978887,
    777787,
    877886,
    997968,
    998797,
    878889,
    789868,
    698899,
    978888,
    877978,
    888798,
    978988,
    888778,
    787787,
    988897,
    998988,
    798877,
    799986,
    778898,
    778786,
    887799,
    768887,
    888677,
    879888,
    977898,
    787789,
    788786,
    897678,
    878779,
    887998,
    879897,
    697978,
    887998,
    987779,
    797798,
    988988,
    867978,
    888887,
    778788,
    789897,
    789778,
    878878,
    878978,
    997987,
    877778,
    988887,
    778877,
    999889,
    888886,
    788997,
    987769,
    688786,
    768889,
    777878,
    889798,
    877788,
    879697,
    899787,
    876887,
    778788,
    899888,
    979779,
    889988,
    978889,
    798798,
    888778,
    879688,
    798977,
    887867,
    878898,
    786788,
    868978,
    877878,
    986779,
    888888,
    789677,
    886868,
    798887,
    979889,
    876898,
    787798,
    887988,
    888877,
    888687,
    788787,
    987889,
    678878,
    867888,
    779898,
    788788,
    899787,
    778978,
    997788,
    788898,
    888787,
    879779,
    789797,
    798697,
    877777,
    788788,
    777869,
    898786,
    987878,
    968797,
    688778,
    777977,
    787799,
    689867,
    978887,
    698789,
    898787,
    889788,
    989787,
    898989,
    789778,
    697889,
    888779,
    879888,
    788877,
    978787,
    867988,
    988998,
    877888,
    998989,
    887977,
    698878,
    878767,
    877988,
    787769,
    887786,
    878788,
    778879,
    879986,
    876867,
    798678,
    979988,
    687878,
    988989,
    899898,
    787997,
    868768,
    877788,
    888888,
    798678,
    788989,
    987787,
    777796,
    988878,
    887797,
    899877,
    888877,
    878877,
    898779,
    688887,
    887778,
    878787,
    687796,
    878678,
    668898,
    978888,
    978878,
    877778,
    788869,
    878887,
    869887,
    786897,
    877787,
    878878,
    779788,
    988887,
    887688,
    779886,
    679878,
    888898,
    678788,
    988868,
    688787,
    879888,
    787978,
    688688,
    777887,
    888878,
    887889,
    968879,
    887779,
    878978,
    879888,
    687867,
    877877,
    787779,
    879788,
    798787,
    777888,
    798778,
    999779,
    778986,
    777887,
    798799,
    988878,
    797888,
    867977,
    886877,
    978877,
    788998,
    778886,
    799779,
    887987,
    988788,
    796789,
    677768,
    787987,
    799988,
    888777,
    878878,
    966968,
    888897,
    987898,
    989798,
    787688,
    887978,
    987777,
    779687,
    887787,
    678876,
    688787,
    767777,
    797887,
    878887,
    797888,
    877987,
    787797,
    887899,
    989788,
    896898,
    878887,
    777788,
    887898,
    878986,
    777897,
    888887,
    899899,
    898877,
    687998,
    998877,
    888887,
    897977,
    888889,
    788798,
    987768,
    778896,
    778787,
    687887,
    886878,
    879888,
    787778,
    768887,
    788777,
    979967,
    997897,
    888798,
    887878,
    887896,
    886897,
    878888,
    888688,
    887879,
    789886,
    679799,
    798869,
    978777,
    787688,
    979888,
    888779,
    878879,
    898887,
    877776,
    878878,
    987887,
    968678,
    897788,
    887778,
    998978,
    887878,
    778878,
    987769,
    768898,
    789987,
    799888,
    887786,
    888676,
    776887,
    897898,
    879787,
    888868,
    979677,
    888978,
    879878,
    698678,
    768897,
    788878,
    678799,
    787897,
    778888,
    777987,
    887778,
    677687,
    797779,
    797786,
    678786,
    988978,
    777776,
    678787,
    887788,
    967888,
    888886,
    889887,
    787886,
    887898,
    768977,
    778797,
    777889,
    778778,
    986886,
    887888,
    897889,
    868788,
    996787,
    788886,
    688777,
    687977,
    899887,
    778687,
    887777,
    887878,
    689987,
    787888,
    988688,
    977877,
    978977,
    787789,
    976689,
    888787,
    979878,
    796878,
    799798,
    897787,
    788988,
    888887,
    898898,
    677998,
    878986,
    897778,
    987988,
    877777,
    898897,
    688689,
    868879,
    886676,
    889677,
    799878,
    787777,
    999797,
    887788,
    897887,
    776878,
    777788,
    768988,
    888798,
    786788,
    898989,
    689877,
    799989,
    777788,
    889797,
    777879,
    797787,
    768799,
    979889,
    788879,
    888997,
    787687,
    789778,
    688977,
    879779,
    798788,
    787868,
    777888,
    889887,
    787798,
    988777,
    879887,
    888787,
    787987,
    798986,
    878789,
    978977,
    896997,
    788897,
    789878,
    677878,
    799878,
    887787,
    896798,
    877777,
    799887,
    888976,
    889868,
    767887,
    998887,
    678877,
    788976,
    898888,
    789799,
    979978,
    687788,
    886987,
    788687,
    868778,
    869879,
    798787,
    797887,
    799999,
    887778,
    879889,
    778897,
    898788,
    788888,
    788889,
    888899,
    687997,
    878878,
    877879,
    778888,
    888788,
    877688,
    888698,
    879878,
    878678,
    886868,
    778878,
    787797,
    886968,
    897798,
    768888,
    788789,
    888778,
    767778,
    688698,
    787789,
    888787,
    786778,
    979788,
    888778,
    868888,
    799777,
    867878,
    878899,
    868987,
    798788,
    967887,
    878898,
    868887,
    888798,
    887998,
    898787,
    777798,
    999886,
    798688,
    879888,
    898689,
    768897,
    789778,
    987879,
    878878,
    879988,
    797978,
    878896,
    778777,
    888879,
    778778,
    788888,
    888688,
    669968,
    898868,
    889887,
    777787,
    887789,
    889798,
    788878,
    897887,
    797798,
    787788,
    988798,
    798988,
    787897,
    777988,
    668978,
    867879,
    898788,
    877789,
    888697,
    887889,
    878677,
    978977,
    789987,
    788798,
    767789,
    797897,
    887877,
    787978,
    899888,
    896879,
    898886,
    777798,
    889898,
    987787,
    878898,
    688897,
    787787,
    879899,
    789777,
    878787,
    899779,
    787778,
    989898,
    889889,
    979887,
    878888,
    878878,
    889989,
    887787,
    788797,
    786797,
    888797,
    797977,
    998869,
    787888,
    777899,
    877888,
    879887,
    788777,
    998877,
    877898,
    888887,
    779986,
    997887,
    879898,
    869887,
    878888,
    797787,
    777979,
    988898,
    778888,
    879778,
    889789,
    899878,
    778799,
    778987,
    889789,
    878888,
    878798,
    977788,
    789878,
    878977,
    778777,
    889989,
    887687,
    998998,
    888976,
    997886,
    887786,
    897878,
    788977,
    798778,
    889778,
    989788,
    888988,
    888879,
    788887,
    889987,
    896799,
    897877,
    778767,
    778878,
    689979,
    888877,
    877877,
    888777,
    787778,
    887778,
    897779,
    887999,
    868678,
    898888,
    787788,
    878887,
    899877,
    788897,
    896887,
    988889,
    787778,
    787987,
    976796,
    787887,
    788688,
    997878,
    888978,
    778876,
    988889,
    878767,
    886979,
    978787,
    998988,
    797878,
    987989,
    897777,
    786778,
    996887,
    896777,
    989788,
    798789,
    799968,
    877877,
    888898,
    989966,
    768977,
    688788,
    999988,
    788877,
    788968,
    778689,
    997987,
    798987,
    687888,
    978998,
    777788,
    787987,
    787797,
    988787,
    876798,
    889688,
    888988,
    898879,
    799778,
    887869,
    887789,
    776778,
    888777,
    879769,
    887868,
    678898,
    778877,
    887797,
    798876,
    968788,
    897888,
    777997,
    778888,
    788888,
    889779,
    798979,
    699889,
    978987,
    689777,
    787787,
    977998,
    976978,
    879788,
    698798,
    787777,
    798787,
    898879,
    878778,
    888978,
    888978,
    786688,
    887789,
    877799,
    779988,
    877877,
    978899,
    978988,
    877898,
    777789,
    898878,
    778788,
    988778,
    987777,
    888888,
    888787,
    787887,
    897877,
    789888,
    889797,
    889889,
    767767,
    797889,
    877788,
    877888,
    888698,
    988889,
    777869,
    696769,
    897887,
    789878,
    888988,
    787879,
    887896,
    987976,
    777898,
    799997,
    888967,
    888776,
    797887,
    897889,
    868897,
    898997,
    877969,
    979979,
    888887,
    899877,
    888768,
    788889,
    778767,
    767787,
    979769,
    878878,
    889966,
    698787,
    787869,
    779978,
    787878,
    876868,
    998888,
    977886,
    679987,
    878777,
    888888,
    799869,
    899997,
    997877,
    779876,
    789789,
    878888,
    978887,
    978887,
    867788,
    788888,
    988768,
    899787,
    977888,
    797677,
    987987,
    888777,
    789888,
    877887,
    988888,
    789798,
    788888,
    978887,
    888888,
    877879,
    788778,
    888999,
    688887,
    887978,
    779878,
    678698,
    889777,
    878778,
    877786,
    977768,
    898997,
    778888,
    988789,
    888867,
    888886,
    888778,
    787867,
    887887,
    787697,
    778989,
    866887,
    687888,
    778677,
    997977,
    887778,
    887888,
    787698,
    878767,
    887898,
    787999,
    687678,
    878988,
    978998,
    877789,
    779877,
    778889,
    788788,
    778977,
    788979,
    877867,
    888779,
    978789,
    777878,
    988998,
    769877,
    767878,
    787889,
    888777,
    977877,
    687988,
    887889,
    778987,
    777786,
    889787,
    877788,
    889788,
    888898,
    887898,
    876988,
    788879,
    677789,
    787876,
    898889,
    896888,
    878896,
    986787,
    878898,
    798768,
    689696,
    977779,
    897969,
    998968,
    888987,
    778899,
    887898,
    897676,
    797998,
    788889,
    868988,
    867778,
    888878,
    988887,
    897877,
    898897,
    878879,
    898788,
    866778,
    776899,
    788987,
    988879,
    988878,
    789977,
    988889,
    876887,
    779978,
    788887,
    979867,
    969899,
    999886,
    886778,
    877777,
    889889,
    889878,
    988786,
    797897,
    888888,
    767877,
    988877,
    787877,
    879688,
    988778,
    988978,
    778998,
    888788,
    977979,
    998978,
    888798,
    988888,
    988878,
    878967,
    879999,
    988877,
    878877,
    896798,
    898887,
    788989,
    978689,
    788897,
    888979,
    787778,
    888997,
    998798,
    878898,
    777789,
    789678,
    878877,
    897786,
    888977,
    989788,
    867777,
    878887,
    688788,
    878889,
    878788,
    779688,
    887977,
    878877,
    789789,
    978986,
    686679,
    996977,
    687988,
    787887,
    768778,
    888888,
    788787,
    699967,
    778879,
    877888,
    797699,
    888797,
    779897,
    767876,
    977777,
    877888,
    869888,
    668798,
    898887,
    688799,
    878787,
    787778,
    777877,
    869677,
    877779,
    888898,
    998878,
    788899,
    788889,
    897868,
    988777,
    999888,
    889778,
    877788,
    878878,
    787788,
    787787,
    888799,
    897788,
    977978,
    978877,
    867788,
    877786,
    969679,
    878877,
    889688,
    878689,
    789798,
    787988,
    898789,
    798699,
    878887,
    979787,
    878888,
    987887,
    797687,
    878879,
    988888,
    999988,
    888777,
    777897,
    987778,
    868868,
    898788,
    888799,
    867898,
    967878,
    968889,
    977979,
    766677,
    786999,
    878788,
    798678,
    768968,
    977987,
    777877,
    868868,
    899888,
    779978,
    897988,
    787798,
    987877,
    887777,
    997788,
    997786,
    989889,
    979789,
    877777,
    987799,
    788877,
    878788,
    667868,
    877788,
    788997,
    868899,
    777978,
    679889,
    987779,
    988788,
    998788,
    678787,
    877776,
    798998,
    977878,
    977998,
    778888,
    887778,
    987787,
    879887,
    886879,
    687878,
    879998,
    878788,
    777787,
    788787,
    879798,
    979787,
    787988,
    779867,
    768789,
    987889,
    798987,
    787888,
    687788,
    899887,
    676788,
    888778,
    997687,
    777878,
    788878,
    868798,
    777778,
    878888,
    778678,
    787889,
    898888,
    877997,
    978887,
    867988,
    999888,
    877697,
    987977,
    887899,
    777789,
    968678,
    978878,
    788877,
    689889,
    878969,
    879778,
    878778,
    988887,
    978889,
    887776,
    977887,
    786997,
    976679,
    987779,
    888687,
    789877,
    887778,
    888798,
    789688,
    887888,
    889888,
    979787,
    987889,
    988899,
    877888,
    688889,
    799788,
    779867,
    988886,
    988777,
    799997,
    789988,
    888977,
    787988,
    789786,
    789777,
    988988,
    887798,
    899898,
    687988,
    878888,
    879887,
    988888,
    679887,
    898877,
    887888,
    887988,
    887688,
    878788,
    989868,
    878796,
    878986,
    898777,
    798778,
    886996,
    776787,
    687877,
    777879,
    978969,
    799889,
    988779,
    899997,
    888787,
    898786,
    776989,
    868877,
    666888,
    888878,
    888988,
    798888,
    886787,
    898899,
    888979,
    799777,
    989889,
    787879,
    868787,
    987777,
    789888,
    778776,
    888889,
    788877,
    899677,
    896888,
    978797,
    977776,
    667798,
    777987,
    887878,
    889788,
    997888,
    897899,
    888878,
    778788,
    998888,
    899886,
    778897,
    999889,
    988789,
    877889,
    868799,
    777789,
    777777,
    788987,
    676987,
    898898,
    879988,
    779787,
    888888,
    887786,
    978887,
    879879,
    878978,
    876898,
    998788,
    669689,
    679868,
    877997,
    889877,
    988898,
    878898,
    789888,
    689877,
    878797,
    877899,
    788879,
    678789,
    889888,
    877788,
    887888,
    879778,
    688788,
    967679,
    789788,
    698788,
    897887,
    767977,
    788887,
    986889,
    778879,
    778987,
    779888,
    797878,
    889887,
    887789,
    788878,
    787887,
    888767,
    977778,
    787988,
    986789,
    988788,
    778988,
    868798,
    888687,
    887778,
    878997,
    769798,
    768888,
    686878,
    867879,
    889798,
    878879,
    998888,
    898788,
    778899,
    789889,
    778698,
    897977,
    797877,
    786887,
    889797,
    686879,
    986978,
    777878,
    788779,
    968889,
    999887,
    886789,
    788788,
    788987,
    967888,
    777898,
    789897,
    887989,
    996997,
    777888,
    788977,
    979979,
    789989,
    877789,
    899778,
    797777,
    997688,
    877877,
    976987,
    779778,
    876886,
    978889,
    978778,
    778898,
    787887,
    868888,
    989898,
    888798,
    999988,
    768889,
    888988,
    788987,
    998886,
    779889,
    869977,
    768787,
    878999,
    798789,
    887987,
    987977,
    877868,
    888887,
    797788,
    869998,
    778878,
    888777,
    887788,
    786988,
    899777,
    998688,
    977989,
    888978,
    797789,
    888887,
    797699,
    789698,
    978978,
    877897,
    767887,
    778787,
    689898,
    797888,
    978878,
    887787,
    997986,
    689879,
    887898,
    689989,
    699878,
    887878,
    878987,
    899977,
    688888,
    897889,
    666977,
    988869,
    988889,
    988979,
    989888,
    969777,
    789978,
    777778,
    978878,
    688987,
    988697,
    998979,
    888888,
    778788,
    798888,
    998878,
    876788,
    868986,
    788789,
    788779,
    978888,
    888878,
    689788,
    888788,
    989788,
    888979,
    876998,
    787967,
    878987,
    886988,
    878777,
    978978,
    778989,
    978879,
    868798,
    889877,
    888888,
    767899,
    877888,
    788788,
    777978,
    787987,
    888788,
    779889,
    968999,
    798979,
    889868,
    778788,
    788978,
    897987,
    879768,
    788889,
    798788,
    787997,
    897888,
    898978,
    788888,
    888889,
    779989,
    777786,
    868888,
    879877,
    978778,
    878889,
    868886,
    989798,
    877797,
    998896,
    897868,
    797777,
    798877,
    887787,
    668888,
    977987,
    778889,
    978979,
    777788,
    779798,
    878978,
    878678,
    878986,
    887998,
    889887,
    787788,
    978788,
    998778,
    869879,
    777687,
    788877,
    788867,
    678878,
    878878,
    899878,
    789877,
    677888,
    877989,
    889866,
    888889,
    889997,
    877889,
    787878,
    798887,
    887898,
    687897,
    898689,
    787887,
    888898,
    887787,
    767787,
    876987,
    898788,
    768789,
    788789,
    888686,
    786968,
    878776,
    986789,
    787789,
    789869,
    797778,
    889788,
    887898,
    799776,
    798878,
    898887,
    789896,
    888777,
    666986,
    778987,
    889778,
    787768,
    788978,
    888888,
    879999,
    897888,
    779798,
    886887,
    787888,
    887687,
    877777,
    788877,
    878788,
    878998,
    897888,
    789788,
    877868,
    999798,
    877887,
    788779,
    799988,
    889878,
    887977,
    888888,
    899977,
    787779,
    867987,
    997898,
    776878,
    979777,
    887769,
    797798,
    787878,
    978777,
    788787,
    889886,
    778787,
    886978,
    999769,
    987688,
    898988,
    897888,
    767879,
    668878,
    988788,
    778877,
    867879,
    778888,
    888888,
    696887,
    887888,
    788976,
    879887,
    796689,
    887696,
    689786,
    898888,
    697787,
    888987,
    777887,
    777987,
    788678,
    787887,
    788987,
    797877,
    888789,
    978879,
    979896,
    789777,
    899769,
    888789,
    887988,
    878879,
    778788,
    966789,
    799977,
    877978,
    877896,
    797878,
    978888,
    778979,
    788898,
    668888,
    888688,
    888898,
    877798,
    678887,
    877789,
    877978,
    688677,
    777978,
    787879,
    699788,
    879878,
    898889,
    777886,
    978887,
    899888,
    988866,
    788868,
    887878,
    678778,
    887888,
    676889,
    788886,
    889998,
    777887,
    976986,
    886887,
    788779,
    877699,
    889877,
    877799,
    889989,
    988778,
    886789,
    899879,
    798887,
    877687,
    977787,
    778889,
    789798,
    897867,
    687778,
    977778,
    987779,
    877988,
    898778,
    776998,
    889769,
    978898,
    887877,
    977969,
    888878,
    967696,
    878778,
    796888,
    878887,
    777987,
    787778,
    787798,
    779899,
    879877,
    769889,
    888867,
    877777,
    868788,
    797878,
    887896,
    897879,
    888788,
    687787,
    788689,
    999778,
    987898,
    777688,
    878899,
    777877,
    898798,
    888879,
    897887,
    998679,
    979798,
    786798,
    867888,
    677788,
    998787,
    978679,
    898678,
    779879,
    797988,
    789886,
    988878,
    988787,
    787889,
    897789,
    888688,
    967779,
    877778,
    987788,
    769889,
    787899,
    787688,
    868889,
    888988,
    788897,
    687669,
    967777,
    878878,
    799996,
    889798,
    887879,
    878777,
    976786,
    997798,
    988878,
    877978,
    879887,
    877879,
    887668,
    888789,
    977668,
    988988,
    887798,
    686869,
    787877,
    887889,
    788888,
    878888,
    889978,
    979988,
    778778,
    979977,
    898888,
    879998,
    777797,
    779667,
    688687,
    889978,
    787889,
    788869,
    888997,
    778898,
    787798,
    688888,
    986987,
    987896,
    888997,
    878798,
    887778,
    779787,
    897788,
    877879,
    978866,
    886777,
    998797,
    987877,
    877888,
    978998,
    887787,
    988777,
    988778,
    987877,
    877888,
    976797,
    897766,
    887878,
    789879,
    788888,
    889998,
    967868,
    878877,
    986977,
    889897,
    797687,
    797889,
    998987,
    778888,
    889897,
    986688,
    877878,
    977888,
    878777,
    988778,
    878787,
    898898,
    978778,
    878999,
    879678,
    889988,
    988877,
    787879,
    878797,
    867869,
    968779,
    787669,
    987677,
    887879,
    889778,
    798889,
    877898,
    998778,
    977777,
    796887,
    877877,
    788889,
    777886,
    987989,
    676786,
    688998,
    877879,
    879898,
    777887,
    798779,
    777787,
    688978,
    977767,
    867799,
    987788,
    877786,
    787779,
    677698,
    889668,
    988778,
    877789,
    788887,
    877879,
    889878,
    877879,
    987778,
    997777,
    678788,
    989998,
    888787,
    888778,
    976697,
    699887,
    788896,
    888798,
    799778,
    877987,
    767688,
    899988,
    988778,
    779887,
    867878,
    787788,
    989788,
    876889,
    889898,
    989879,
    978987,
    968878,
    787777,
    998888,
    789777,
    796979,
    789789,
    886888,
    788689,
    977769,
    897789,
    887788,
    889997,
    789778,
    889878,
    878778,
    687698,
    688787,
    769878,
    768888,
    788788,
    678889,
    788688,
    778978,
    897788,
    788879,
    678978,
    878988,
    886788,
    887787,
    688699,
    888987,
    868797,
    898978,
    788997,
    878779,
    887869,
    877878,
    897988,
    888887,
    977877,
    987699,
    899777,
    778899,
    887799,
    878877,
    998868,
    777988,
    779888,
    788888,
    878986,
    898787,
    887898,
    789987,
    889887,
    788867,
    988889,
    888987,
    799988,
    887988,
    797967,
    786986,
    786888,
    976999,
    787888,
    879899,
    788878,
    998878,
    798778,
    979688,
    978788,
    777888,
    877887,
    788978,
    888676,
    677789,
    999767,
    978869,
    787697,
    788897,
    978677,
    898877,
    778787,
    787889,
    977788,
    778879,
    798888,
    899887,
    877887,
    878769,
    989967,
    877788,
    787979,
    788687,
    798788,
    777777,
    878789,
    888797,
    687886,
    688876,
    868987,
    978978,
    977879,
    779879,
    998987,
    777977,
    886899,
    889798,
    979769,
    686877,
    797799,
    687878,
    998779,
    698788,
    689787,
    878788,
    988688,
    989778,
    878899,
    877869,
    697799,
    987966,
    888788,
    968777,
    797888,
    779988,
    677879,
    798788,
    897888,
    788887,
    798797,
    797798,
    788978,
    788977,
    888887,
    887999,
    888787,
    886877,
    889977,
    799787,
    899988,
    778867,
    897976,
    787778,
    788898,
    788998,
    977997,
    896898,
    889997,
    876766,
    789878,
    877987,
    788868,
    878889,
    888878,
    788889,
    878866,
    889788,
    789967,
    877997,
    778898,
    899889,
    889879,
    877888,
    778988,
    787878,
    767978,
    878888,
    877879,
    897897,
    796796,
    888888,
    787797,
    789678,
    778988,
    777879,
    896798,
    797879,
    987789,
    776889,
    677988,
    798779,
    868887,
    776779,
    787877,
    788886,
    877879,
    876778,
    888978,
    798888,
    789788,
    989868,
    787887,
    887998,
    877689,
    798889,
    968867,
    878887,
    779987,
    788887,
    788888,
    878866,
    898788,
    997898,
    877687,
    878998,
    887888,
    778799,
    888788,
    978888,
    778788,
    779879,
    897878,
    888788,
    687987,
    987978,
    869988,
    987878,
    988898,
    899797,
    788778,
    887888,
    886888,
    788678,
    988796,
    988787,
    688967,
    786878,
    887886,
    777999,
    797888,
    988789,
    888977,
    889687,
    778787,
    877888,
    787999,
    779777,
    988888,
    989788,
    976988,
    778668,
    878879,
    888777,
    989986,
    778676,
    888989,
    786787,
    788996,
    778898,
    786878,
    679788,
    987689,
    877887,
    887786,
    888979,
    877796,
    998888,
    979779,
    789878,
    999877,
    788787,
    989997,
    777888,
    798989,
    778778,
    798877,
    987788,
    897878,
    877987,
    878979,
    977897,
    897978,
    897868,
    987779,
    879997,
    788789,
    977777,
    878876,
    867778,
    898898,
    879787,
    776997,
    689977,
    877878,
    878688,
    786677,
    888878,
    878698,
    678887,
    876889,
    786787,
    787998,
    887787,
    897898,
    778889,
    878799,
    776897,
    779979,
    978887,
    877789,
    886789,
    789776,
    888868,
    888978,
    777796,
    778877,
    786887,
    878679,
    787776,
    878887,
    879778,
    887876,
    769878,
    777998,
    989767,
    889887,
    778886,
    887987,
    766788,
    778797,
    988888,
    777678,
    779878,
    888898,
    877668,
    789987,
    987878,
    887888,
    768879,
    788678,
    786879,
    788788,
    977788,
    889877,
    886998,
    888677,
    777778,
    887778,
    888889,
    888877,
    777898,
    788687,
    779898,
    998686,
    878687,
    788889,
    787887,
    987888,
    878988,
    689696,
    889788,
    779697,
    876787,
    696787,
    878988,
    888998,
    767888,
    878768,
    878878,
    887878,
    879788,
    978787,
    778877,
    778789,
    888789,
    877978,
    889978,
    688778,
    769887,
    989877,
    878777,
    988898,
    897787,
    887788,
    867888,
    987977,
    887888,
    898877,
    978878,
    888798,
    787789,
    788869,
    877897,
    788787,
    786779,
    978678,
    789676,
    779868,
    787797,
    679778,
    977978,
    778887,
    998988,
    869686,
    978798,
    778789,
    988799,
    788699,
    887768,
    789878,
    789787,
    888788,
    878779,
    887778,
    978677,
    788876,
    787866,
    997888,
    879788,
    789798,
    767899,
    977877,
    778878,
    879778,
    788888,
    988787,
    778789,
    799889,
    887799,
    696668,
    787988,
    988778,
    678887,
    778979,
    777889,
    878768,
    978879,
    886866,
    687778,
    888778,
    877977,
    887798,
    777887,
    779798,
    797989,
    988988,
    789899,
    887877,
    897978,
    779787,
    667988,
    888877,
    786988,
    888887,
    988787,
    977988,
    897787,
    968787,
    799778,
    689887,
    788998,
    788988,
    677877,
    878887,
    688798,
    696778,
    879787,
    978899,
    696788,
    788877,
    976888,
    667986,
    969889,
    977867,
    788877,
    889878,
    777686,
    688798,
    887787,
    778887,
    789889,
    789788,
    678898,
    789887,
    899867,
    888688,
    888788,
    987687,
    788789,
    997789,
    878998,
    779787,
    878879,
    787888,
    888878,
    788867,
    898788,
    877978,
    788787,
    889788,
    987697,
    986798,
    879878,
    898798,
    979997,
    878867,
    888889,
    877888,
    977877,
    888886,
    898689,
    979797,
    799898,
    888787,
    988877,
    798987,
    787978,
    789779,
    878777,
    878779,
    888778,
    889987,
    777778,
    789788,
    787797,
    889787,
    797798,
    677988,
    798798,
    779999,
    767769,
    888787,
    988778,
    878887,
    878787,
    786779,
    788778,
    899887,
    887968,
    878988,
    767888,
    699888,
    998778,
    787988,
    798888,
    897977,
    889786,
    997877,
    878889,
    879898,
    989788,
    867878,
    888797,
    887888,
    797786,
    778896,
    798888,
    769878,
    798776,
    798888,
    889868,
    867776,
    789987,
    777888,
    777988,
    868887,
    697779,
    678898,
    868889,
    878778,
    997889,
    989887,
    887889,
    897878,
    887888,
    888888,
    888787,
    888797,
    988877,
    778888,
    798778,
    987878,
    677988,
    788689,
    797887,
    788877,
    787878,
    888978,
    799778,
    977888,
    788998,
    899887,
    989897,
    788899,
    778999,
    887898,
    987797,
    888788,
    889687,
    867976,
    868889,
    877798,
    879777,
    787677,
    767877,
    888689,
    786889,
    689778,
    778886,
    779868,
    787977,
    788888,
    986789,
    687889,
    878877,
    897887,
    888788,
    688889,
    686797,
    997897,
    878888,
    889776,
    897697,
    868797,
    888678,
    877779,
    877897,
    787987,
    678878,
    788976,
    878886,
    888798,
    788978,
    996897,
    797978,
    888888,
    967788,
    877888,
    986889,
    797787,
    898787,
    978778,
    888889,
    887799,
    887988,
    877789,
    888898,
    789988,
    778778,
    899888,
    987977,
    988979,
    677687,
    877888,
    797679,
    887788,
    997886,
    978889,
    788897,
    888988,
    988779,
    867899,
    968889,
    989988,
    889887,
    788978,
    879789,
    886887,
    678986,
    887989,
    886877,
    898888,
    998877,
    777696,
    777876,
    778879,
    889998,
    789787,
    698977,
    887888,
    676789,
    887889,
    797978,
    886877,
    888877,
    779897,
    979898,
    867797,
    878998,
    879887,
    788788,
    877787,
    989968,
    887976,
    787988,
    787977,
    767798,
    878996,
    988877,
    788987,
    988788,
    768887,
    888889,
    887878,
    877977,
    887799,
    668879,
    868798,
    777887,
    778888,
    679679,
    879889,
    798799,
    688868,
    788889,
    989878,
    896788,
    897989,
    878877,
    787976,
    799899,
    879887,
    887798,
    877778,
    787987,
    888898,
    988888,
    878978,
    777779,
    777898,
    888779,
    877899,
    898897,
    868988,
    889888,
    997897,
    997889,
    889687,
    788888,
    887789,
    879877,
    887878,
    889788,
    989776,
    778898,
    878777,
    767897,
    889877,
    887768,
    977788,
    978678,
    877798,
    888778,
    987877,
    779978,
    789978,
    888888,
    789779,
    869886,
    978788,
    888978,
    788899,
    988889,
    878988,
    889898,
    778888,
    778788,
    798988,
    887896,
    897899,
    878786,
    787797,
    898688,
    988877,
    788787,
    799887,
    797786,
    787786,
    888779,
    978887,
    897766,
    879787,
    677899,
    698888,
    897788,
    877878,
    878989,
    878887,
    978768,
    788787,
    797797,
    967888,
    888799,
    877778,
    898799,
    898788,
    788787,
    788878,
    787868,
    889698,
    978789,
    779897,
    987777,
    787698,
    787889,
    768786,
    979797,
    898997,
    787798,
    778999,
    988888,
    886778,
    778877,
    899888,
    789698,
    897887,
    976987,
    989889,
    778876,
    667888,
    979868,
    767878,
    787889,
    988988,
    977878,
    687988,
    897788,
    697878,
    799798,
    888878,
    977988,
    987878,
    978878,
    899898,
    789989,
    888877,
    777977,
    889777,
    698999,
    988867,
    788978,
    979988,
    887768,
    788879,
    787877,
    977778,
    878887,
    777868,
    987977,
    888897,
    977878,
    896877,
    898879,
    797898,
    777877,
    977998,
    987987,
    878877,
    798987,
    876977,
    888687,
    898878,
    998877,
    889877,
    967788,
    887988,
    899987,
    799979,
    879986,
    978988,
    787978,
    788769,
    889698,
    789998,
    987777,
    888877,
    798888,
    888778,
    769978,
    997888,
    788787,
    689788,
    678896,
    688889,
    787899,
    788879,
    887797,
    897988,
    886788,
    788888,
    887787,
    989889,
    889898,
    967878,
    887879,
    877797,
    978998,
    996976,
    998886,
    777788,
    896777,
    977877,
    788877,
    897877,
    998998,
    897798,
    897769,
    989896,
    686887,
    787878,
    977779,
    879888,
    977987,
    977998,
    767889,
    878867,
    878698,
    998778,
    988787,
    987777,
    887888,
    868787,
    798788,
    887878,
    776697,
    879889,
    786888,
    878898,
    897897,
    998796,
    979799,
    897787,
    988978,
    766687,
    887877,
    886796,
    797876,
    787879,
    787787,
    889796,
    788876,
    898877,
    787778,
    889876,
    687886,
    797976,
    789687,
    798877,
    999898,
    978678,
    987888,
    887998,
    889889,
    987978,
    897867,
    888988,
    878878,
    698898,
    898898,
    778987,
    888777,
    988799,
    768779,
    879878,
    977767,
    788979,
    977889,
    798677,
    768878,
    896888,
    897778,
    769978,
    879797,
    787877,
    977988,
    778787,
    878788,
    789888,
    976788,
    887888,
    797778,
    878897,
    788779,
    887676,
    888787,
    789798,
    878979,
    987877,
    887778,
    886888,
    877988,
    897666,
    787687,
    788798,
    998978,
    888788,
    886998,
    799888,
    776789,
    898778,
    886978,
    976977,
    778798,
    898988,
    888887,
    779968,
    968878,
    989777,
    878889,
    778899,
    969787,
    778877,
    987887,
    897898,
    766897,
    787888,
    978978,
    987887,
    789788,
    678878,
    788877,
    776998,
    878987,
    887768,
    887878,
    879898,
    878667,
    788798,
    877868,
    887988,
    878989,
    779987,
    868887,
    896989,
    679799,
    798888,
    868679,
    778789,
    777978,
    877878,
    976988,
    776768,
    768778,
    787688,
    987878,
    878687,
    677897,
    898888,
    989888,
    797888,
    677787,
    787789,
    788797,
    879787,
    887698,
    779897,
    779889,
    877977,
    777879,
    778898,
    778987,
    977997,
    898777,
    698988,
    777796,
    868888,
    888787,
    878878,
    778879,
    889878,
    897778,
    798879,
    886988,
    778876,
    898778,
    798779,
    877877,
    988878,
    878878,
    998799,
    867788,
    778777,
    977988,
    778878,
    767779,
    988688,
    788887,
    997879,
    898979,
    688898,
    978787,
    788788,
    789789,
    798687,
    888878,
    787777,
    887887,
    897778,
    797887,
    978998,
    878687,
    777779,
    778679,
    889868,
    977889,
    768777,
    688888,
    789779,
    887786,
    788788,
    787968,
    788877,
    788888,
    788887,
    788777,
    878888,
    899978,
    887976,
    877887,
    996877,
    869989,
    878888,
    769879,
    867889,
    887786,
    697798,
    899888,
    998887,
    899889,
    888777,
    898697,
    988988,
    788977,
    777778,
    787687,
    888777,
    899879,
    877879,
    788878,
    998878,
    789778,
    978977,
    888897,
    787889,
    977789,
    977777,
    788898,
    888878,
    788898,
    877977,
    788798,
    878689,
    877877,
    778888,
    787997,
    978987,
    888887,
    888778,
    987877,
    897867,
    998788,
    888898,
    887787,
    977988,
    878889,
    877787,
    878879,
    789989,
    878888,
    978899,
    677898,
    889878,
    977787,
    878687,
    777889,
    778778,
    776768,
    777888,
    988887,
    787688,
    978788,
    788788,
    788779,
    876778,
    687898,
    988887,
    888897,
    878888,
    789768,
    878788,
    698797,
    687679,
    797877,
    988777,
    977777,
    798878,
    767878,
    867888,
    878978,
    898888,
    778888,
    878967,
    787778,
    987678,
    889878,
    798877,
    778778,
    788877,
    788788,
    777878,
    788878,
    698888,
    779878,
    778998,
    976887,
    878876,
    877887,
    898778,
    779998,
    888888,
    798788,
    868777,
    879987,
    887978,
    789897,
    889998,
    888878,
    888779,
    788797,
    977788,
    789788,
    987788,
    889777,
    898988,
    888687,
    887776,
    789797,
    988889,
    987789,
    897797,
    976779,
    968778,
    788798,
    778988,
    979778,
    897788,
    896787,
    868998,
    778988,
    976898,
    788778,
    898769,
    678986,
    977768,
    967689,
    889877,
    878698,
    786979,
    666897,
    878698,
    778789,
    789888,
    877689,
    699798,
    779786,
    677997,
    788778,
    788767,
    788977,
    888887,
    777788,
    888788,
    778799,
    878798,
    968798,
    788888,
    978988,
    977788,
    987778,
    788799,
    789978,
    887887,
    788767,
    988888,
    778879,
    898768,
    677677,
    788886,
    888867,
    877888,
    768799,
    788778,
    788887,
    778888,
    788798,
    989776,
    887889,
    888686,
    887979,
    778787,
    978879,
    689789,
    788786,
    676879,
    878979,
    979889,
    976966,
    788889,
    898787,
    778787,
    779687,
    889877,
    886789,
    888777,
    989888,
    889789,
    977788,
    887989,
    867888,
    779988,
    879788,
    898769,
    797797,
    978898,
    787978,
    786896,
    798889,
    677867,
    898887,
    788889,
    878688,
    788798,
    778899,
    789777,
    996797,
    699889,
    777877,
    887878,
    888789,
    778878,
    778887,
    987797,
    988978,
    999769,
    767799,
    787797,
    999977,
    789689,
    868878,
    989988,
    877799,
    867796,
    889977,
    888868,
    888988,
    978977,
    987898,
    887979,
    987888,
    779797,
    788877,
    788888,
    787889,
    877888,
    787889,
    787887,
    868798,
    997877,
    798787,
    877988,
    987987,
    876888,
    788898,
    679888,
    977898,
    897867,
    888786,
    987889,
    787876,
    878878,
    889796,
    979776,
    878779,
    889887,
    777887,
    799798,
    867977,
    789798,
    788779,
    898997,
    788978,
    778796,
    898778,
    779878,
    768978,
    886798,
    978789,
    798787,
    877877,
    769977,
    987778,
    888799,
    787887,
    898887,
    788778,
    798767,
    888777,
    667778,
    897878,
    779897,
    789878,
    788778,
    899988,
    889998,
    879677,
    798777,
    899888,
    767779,
    787788,
    797799,
    789999,
    788687,
    787998,
    789867,
    788688,
    978897,
    789878,
    698878,
    788979,
    788776,
    879878,
    988699,
    879979,
    777777,
    997787,
    888886,
    877777,
    988979,
    797888,
    889988,
    787987,
    887977,
    687779,
    898776,
    988789,
    898888,
    788787,
    898888,
    887877,
    876877,
    877887,
    887689,
    888779,
    777676,
    997877,
    778786,
    776898,
    899988,
    999776,
    787787,
    777986,
    678987,
    988888,
    687879,
    789988,
    887897,
    887799,
    988888,
    897788,
    878888,
    689997,
    899987,
    888889,
    788899,
    878899,
    878678,
    988978,
    987868,
    778798,
    887978,
    778788,
    887789,
    778988,
    698868,
    888787,
    878887,
    988779,
    888877,
    788899,
    889878,
    987887,
    689888,
    888688,
    888788,
    878669,
    897897,
    887897,
    789786,
    888789,
    877878,
    888777,
    788879,
    767986,
    899677,
    877876,
    798988,
    988889,
    777878,
    878889,
    877778,
    787887,
    688779,
    889798,
    786876,
    776878,
    767868,
    797779,
    787787,
    778868,
    878798,
    887868,
    889778,
    878978,
    988888,
    999878,
    698899,
    986889,
    879777,
    768889,
    898879,
    977887,
    798888,
    878988,
    879777,
    687988,
    686987,
    789998,
    788887,
    987898,
    868977,
    779967,
    688777,
    888799,
    778878,
    877868,
    887877,
    789877,
    887799,
    777988,
    878798,
    876887,
    889787,
    979986,
    788987,
    978888,
    788988,
    788898,
    887698,
    766988,
    888798,
    688878,
    886889,
    877988,
    778667,
    779887,
    877898,
    787788,
    898888,
    987778,
    887997,
    879677,
    787988,
    789788,
    878888,
    787887,
    898888,
    979978,
    788898,
    878877,
    978977,
    787998,
    788778,
    788978,
    876788,
    788898,
    988897,
    787888,
    877899,
    878788,
    797788,
    888887,
    877888,
    878788,
    787788,
    897888,
    897778,
    769878,
    977798,
    786898,
    789889,
    889888,
    788888,
    979788,
    898897,
    887778,
    987889,
    868768,
    678787,
    688899,
    797979,
    778688,
    888787,
    898788,
    876879,
    979787,
    868878,
    886778,
    878787,
    886878,
    687886,
    798997,
    787977,
    777778,
    688787,
    799786,
    788879,
    777899,
    778686,
    887699,
    878887,
    888799,
    988696,
    898899,
    997778,
    679679,
    868878,
    698879,
    789899,
    887679,
    897869,
    796988,
    787787,
    878798,
    887977,
    797998,
    787987,
    988898,
    889887,
    877777,
    977788,
    888888,
    879778,
    796677,
    889897,
    898789,
    768997,
    987988,
    867678,
    768798,
    798887,
    698888,
    988899,
    997988,
    877887,
    788888,
    888699,
    776897,
    879968,
    986779,
    996888,
    787767,
    887877,
    868887,
    688787,
    868878,
    798979,
    966778,
    797799,
    876787,
    877987,
    887888,
    797988,
    877799,
    777988,
    888867,
    889676,
    788888,
    798789,
    899888,
    898778,
    886988,
    889889,
    787987,
    896998,
    787789,
    969787,
    897879,
    867988,
    988767,
    789878,
    798999,
    879997,
    888776,
    877699,
    878698,
    778888,
    798989,
    987789,
    989779,
    876678,
    798777,
    698989,
    987878,
    676799,
    777788,
    887778,
    879778,
    788988,
    797788,
    777788,
    788877,
    888867,
    987888,
    879887,
    989778,
    889897,
    788788,
    798777,
    878878,
    989778,
    768978,
    899767,
    686879,
    978888,
    997887,
    877887,
    896878,
    788778,
    987987,
    889789,
    899778,
    877878,
    777899,
    887878,
    879898,
    988866,
    887777,
    888987,
    886988,
    899997,
    979986,
    888688,
    897896,
    986976,
    876987,
    776887,
    888786,
    879799,
    876898,
    888878,
    798976,
    866889,
    988679,
    778878,
    798778,
    998798,
    888888,
    779777,
    988878,
    687777,
    989789,
    798867,
    977977,
    998788,
    888876,
    768878,
    798988,
    877878,
    788878,
    889989,
    988897,
    879977,
    888888,
    888797,
    788899,
    979878,
    887997,
    888798,
    889899,
    878999,
    888887,
    887987,
    777898,
    777879,
    887767,
    879886,
    988878,
    888789,
    777888,
    996878,
    788887,
    778777,
    786777,
    869697,
    777788,
    777788,
    888889,
    777898,
    887878,
    867898,
    879877,
    788988,
    879889,
    888788,
    868888,
    877766,
    878797,
    787777,
    989877,
    779868,
    989778,
    789888,
    889997,
    897767,
    777879,
    698778,
    888787,
    998776,
    889787,
    878897,
    896788,
    779888,
    799787,
    889887,
    787888,
    899977,
    888878,
    877887,
    787887,
    788877,
    786888,
    878768,
    788888,
    787896,
    998778,
    978878,
    877887,
    776687,
    988898,
    879778,
    998888,
    998878,
    799898,
    978989,
    887698,
    889979,
    967776,
    967988,
    768887,
    768798,
    989888,
    978887,
    879888,
    868898,
    878887,
    887897,
    899887,
    977987,
    998787,
    898888,
    778898,
    688778,
    698798,
    878877,
    879766,
    879888,
    868879,
    898977,
    887779,
    888986,
    977776,
    868797,
    998786,
    977989,
    887778,
    979878,
    889798,
    988777,
    878888,
    779977,
    876877,
    779877,
    798899,
    979897,
    889977,
    789887,
    878888,
    799897,
    686898,
    898789,
    799987,
    877789,
    798779,
    877788,
    797787,
    888788,
    897668,
    789766,
    988777,
    787777,
    779778,
    887987,
    878999,
    877788,
    667688,
    787878,
    887888,
    878778,
    798998,
    789889,
    787878,
    888776,
    889898,
    977878,
    777998,
    977867,
    878788,
    977798,
    887878,
    967898,
    767688,
    877898,
    777898,
    977898,
    777797,
    887998,
    687797,
    768878,
    777797,
    888888,
    867887,
    888889,
    788888,
    888877,
    776987,
    778868,
    877687,
    978778,
    688669,
    697987,
    788787,
    887876,
    778977,
    688888,
    888978,
    977778,
    888887,
    889786,
    777788,
    999899,
    888799,
    988988,
    897899,
    778879,
    868999,
    977889,
    887989,
    777896,
    886876,
    998879,
    798878,
    788987,
    886788,
    788988,
    898888,
    867899,
    868886,
    977778,
    876888,
    999877,
    786978,
    789887,
    798978,
    878887,
    888776,
    789779,
    787878,
    878897,
    687767,
    787878,
    889968,
    778799,
    988696,
    887688,
    789897,
    887767,
    877968,
    997788,
    867778,
    868886,
    988878,
    789989,
    887987,
    888877,
    898879,
    688887,
    988878,
    786987,
    967889,
    788878,
    877888,
    978779,
    686888,
    796876,
    997888,
    988889,
    777899,
    889799,
    889789,
    789899,
    988788,
    789898,
    979779,
    989889,
    897788,
    877889,
    787899,
    768988,
    977898,
    869787,
    997889,
    797879,
    897988,
    889868,
    797678,
    888888,
    679789,
    888888,
    767877,
    988788,
    997787,
    988699,
    886877,
    868987,
    776888,
    998987,
    697877,
    897788,
    779977,
    778988,
    887889,
    788787,
    788799,
    788899,
    899897,
    899887,
    987978,
    888878,
    886879,
    799889,
    796968,
    789888,
    889978,
    987789,
    797888,
    677878,
    888879,
    887797,
    787898,
    878887,
    889779,
    898899,
    779969,
    789779,
    889878,
    886767,
    889787,
    798878,
    689778,
    889687,
    699898,
    768887,
    877778,
    989887,
    677777,
    768979,
    889978,
    879788,
    887889,
    988877,
    879898,
    998898,
    988788,
    877787,
    978877,
    888788,
    867898,
    878977,
    888987,
    868888,
    787987,
    878796,
    898869,
    878787,
    897889,
    879678,
    886976,
    987878,
    879878,
    778988,
    887789,
    787898,
    978877,
    887887,
    897988,
    798879,
    887797,
    889989,
    676787,
    677877,
    897887,
    889879,
    967799,
    689777,
    779888,
    698678,
    888788,
    676898,
    789886,
    899777,
    788886,
    886979,
    897687,
    889777,
    778777,
    798968,
    879978,
    798878,
    869787,
    887887,
    777977,
    888798,
    978778,
    977767,
    888888,
    877778,
    877998,
    878998,
    777867,
    778878,
    888778,
    779876,
    897989,
    678788,
    898897,
    799878,
    777897,
    879799,
    888878,
    787777,
    798878,
    887868,
    888989,
    778687,
    889978,
    888898,
    988778,
    987777,
    677769,
    779877,
    878787,
    798897,
    887888,
    789788,
    789878,
    877997,
    788868,
    888788,
    888877,
    887878,
    788978,
    777888,
    777787,
    787868,
    677998,
    889896,
    787877,
    788988,
    888698,
    966788,
    697788,
    887887,
    987878,
    788788,
    877977,
    877878,
    879878,
    978888,
    777887,
    887778,
    898899,
    778998,
    888887,
    989979,
    877898,
    677878,
    899877,
    789879,
    977999,
    797888,
    878896,
    878777,
    786899,
    678767,
    877987,
    677679,
    877787,
    869787,
    987988,
    767889,
    696899,
    777777,
    878888,
    999697,
    899778,
    899878,
    777796,
    768888,
    789879,
    979878,
    698889,
    798898,
    887887,
    979678,
    997778,
    887888,
    889887,
    787778,
    798879,
    989977,
    878976,
    788889,
    877887,
    878868,
    868886,
    798889,
    978687,
    897877,
    779998,
    788989,
    879679,
    868778,
    878897,
    867798,
    779888,
    788886,
    788778,
    676878,
    888788,
    788998,
    898788,
    778787,
    899889,
    768987,
    897887,
    798879,
    788988,
    887877,
    979999,
    978879,
    887888,
    889788,
    789777,
    789978,
    987787,
    798788,
    768867,
    688889,
    878877,
    987988,
    987987,
    777879,
    768777,
    777798,
    988769,
    777689,
    878796,
    876889,
    877898,
    878767,
    798797,
    879789,
    698877,
    889987,
    898779,
    878977,
    788988,
    887789,
    789888,
    887999,
    888768,
    977997,
    888687,
    889897,
    888887,
    796866,
    889889,
    888978,
    798689,
    779678,
    898898,
    796867,
    887996,
    976889,
    878787,
    987898,
    869888,
    879878,
    787879,
    778899,
    987888,
    999877,
    879988,
    878986,
    878877,
    778969,
    887887,
    887888,
    898887,
    798698,
    788988,
    989887,
    798898,
    787868,
    888788,
    678778,
    967779,
    888797,
    798887,
    888878,
    887777,
    799869,
    679878,
    897887,
    887886,
    986876,
    879998,
    789978,
    877788,
    789777,
    878897,
    778887,
    898666,
    979779,
    876978,
    978898,
    897788,
    988788,
    786777,
    787778,
    878878,
    988889,
    988888,
    978869,
    897788,
    877798,
    887888,
    687877,
    888878,
    768788,
    888677,
    987798,
    787888,
    867798,
    887987,
    788788,
    878888,
    776976,
    889978,
    677868,
    878679,
    878878,
    788787,
    887787,
    878888,
    769988,
    988887,
    768969,
    767878,
    867877,
    788989,
    889988,
    777888,
    897899,
    988798,
    786877,
    878778,
    888799,
    788798,
    797988,
    877888,
    898889,
    978878,
    878898,
    788798,
    778988,
    776797,
    777976,
    988889,
    879889,
    879977,
    877679,
    788888,
    788887,
    979767,
    988988,
    689869,
    778899,
    789787,
    897878,
    787789,
    789788,
    888878,
    799797,
    778879,
    888887,
    778987,
    799878,
    787777,
    899987,
    977888,
    879967,
    768798,
    997887,
    777676,
    788697,
    778887,
    878998,
    877897,
    877788,
    878877,
    888997,
    877779,
    877867,
    989789,
    779989,
    889888,
    999789,
    768997,
    867886,
    889777,
    888678,
    687887,
    876878,
    786898,
    777879,
    887898,
    888867,
    868887,
    789899,
    997989,
    798778,
    786698,
    788777,
    878778,
    688778,
    779978,
    899888,
    677888,
    877788,
    879988,
    889778,
    997886,
    877778,
    886879,
    788787,
    786679,
    888968,
    877889,
    997887,
    888767,
    998687,
    867868,
    788899,
    867888,
    878878,
    898798,
    887787,
    787897,
    778897,
    987879,
    788868,
    889987,
    888778,
    988798,
    888977,
    887878,
    988878,
    888989,
    977868,
    896978,
    876978,
    898786,
    778887,
    978877,
    768887,
    698979,
    887787,
    878787,
    888898,
    878989,
    878677,
    787888,
    888777,
    898978,
    768999,
    969888,
    897888,
    788888,
    878988,
    878688,
    889987,
    788886,
    886976,
    689787,
    898788,
    887787,
    978898,
    868889,
    788979,
    896898,
    767867,
    878977,
    888888,
    787798,
    977789,
    997788,
    988797,
    879967,
    978788,
    878989,
    987778,
    668898,
    867797,
    868888,
    788687,
    797798,
    877998,
    788987,
    668677,
    777878,
    779899,
    889778,
    778678,
    778788,
    797988,
    787888,
    789896,
    898778,
    878798,
    787888,
    869788,
    988798,
    879789,
    888789,
    989878,
    778897,
    868898,
    778787,
    978988,
    976887,
    987888,
    866996,
    797898,
    688898,
    787879,
    877888,
    878798,
    778987,
    889898,
    678987,
    898787,
    886987,
    889778,
    888787,
    987988,
    696788,
    977877,
    887767,
    879999,
    798878,
    877886,
    778697,
    698777,
    778998,
    789978,
    677678,
    868778,
    699978,
    787677,
    867788,
    768867,
    767897,
    887768,
    879768,
    878878,
    877788,
    987998,
    787969,
    887877,
    788798,
    787888,
    669799,
    887879,
    788897,
    888979,
    976888,
    878996,
    886988,
    886667,
    879897,
    888788,
    777897,
    798886,
    887888,
    788877,
    676778,
    778798,
    879987,
    787998,
    769868,
    686987,
    987988,
    787779,
    878878,
    687987,
    987877,
    787887,
    788777,
    899888,
    886997,
    886789,
    888777,
    778789,
    777778,
    877896,
    897798,
    877898,
    887689,
    969888,
    997887,
    879788,
    989898,
    777778,
    768878,
    867887,
    867888,
    798778,
    789777,
    978888,
    898898,
    778877,
    799887,
    996888,
    778798,
    898887,
    788778,
    987779,
    798768,
    788878,
    788977,
    789697,
    888777,
    897797,
    787877,
    777988,
    778897,
    888799,
    888878,
    977879,
    778777,
    977877,
    877888,
    888979,
    968767,
    697978,
    887888,
    977978,
    887977,
    987698,
    987687,
    878888,
    877779,
    978979,
    897888,
    779779,
    867868,
    797777,
    978877,
    767877,
    979888,
    887887,
    678788,
    998679,
    878877,
    678798,
    887877,
    877677,
    888779,
    888787,
    777888,
    989777,
    898777,
    877888,
    777777,
    879868,
    678889,
    877987,
    887779,
    798887,
    678788,
    888987,
    888878,
    877788,
    868887,
    897988,
    977879,
    778797,
    877979,
    899776,
    978889,
    887889,
    678886,
    878778,
    868777,
    889777,
    687788,
    888897,
    687768,
    788869,
    888887,
    779778,
    898789,
    788778,
    888798,
    898977,
    778999,
    877787,
    898779,
    898777,
    878877,
    976786,
    879898,
    888987,
    768887,
    868798,
    777888,
    889777,
    778878,
    897879,
    977987,
    976887,
    898799,
    878788,
    686887,
    997889,
    888887,
    988777,
    878877,
    787888,
    789988,
    786788,
    888979,
    777787,
    889888,
    888778,
    887888,
    977869,
    687787,
    878877,
    778987,
    978978,
    787899,
    888889,
    777889,
    788988,
    887789,
    899877,
    889788,
    886898,
    788898,
    886887,
    778897,
    998888,
    886886,
    677688,
    798888,
    678977,
    797878,
    788787,
    877768,
    798887,
    778879,
    887866,
    796887,
    887889,
    987698,
    877979,
    888868,
    777998,
    687988,
    788887,
    699899,
    989889,
    998998,
    887788,
    887789,
    999978,
    888887,
    889678,
    787787,
    777878,
    799887,
    989987,
    787778,
    878888,
    788898,
    677778,
    968888,
    679897,
    779876,
    888877,
    988776,
    789987,
    989887,
    798978,
    899767,
    888676,
    777878,
    998788,
    777876,
    887878,
    987978,
    998897,
    788687,
    788879,
    988987,
    868779,
    687878,
    876868,
    877789,
    797776,
    879898,
    878789,
    897897,
    896987,
    777678,
    789687,
    868787,
    888987,
    777898,
    787988,
    888877,
    877979,
    977878,
    777879,
    899788,
    677977,
    778778,
    878997,
    878887,
    887897,
    788689,
    898887,
    987887,
    889877,
    889888,
    797988,
    798879,
    988798,
    788866,
    888778,
    788767,
    987797,
    989887,
    978969,
    687788,
    878877,
    988778,
    789887,
    798976,
    967896,
    688776,
    879789,
    678787,
    899997,
    999899,
    779797,
    988799,
    888877,
    879868,
    779889,
    887887,
    977889,
    887978,
    778879,
    779778,
    777789,
    789788,
    888888,
    768779,
    987978,
    889877,
    887787,
    889997,
    877788,
    878789,
    888778,
    869888,
    789789,
    977887,
    986988,
    889796,
    888989,
    879898,
    798987,
    878878,
    787878,
    988779,
    978978,
    777787,
    768687,
    789768,
    786988,
    787967,
    778888,
    888798,
    787888,
    878987,
    987977,
    776788,
    897688,
    788788,
    887778,
    878878,
    897789,
    877788,
    898878,
    988977,
    998889,
    887788,
    889998,
    789897,
    777878,
    868899,
    898777,
    988789,
    889888,
    888888,
    787779,
    877977,
    887889,
    888778,
    889797,
    777778,
    778888,
    778977,
    898889,
    986887,
    688997,
    897878,
    987888,
    869879,
    977777,
    977877,
    876897,
    779878,
    889688,
    897887,
    899678,
    977898,
    788678,
    887887,
    888788,
    887879,
    888997,
    877897,
    889797,
    797898,
    788979,
    997788,
    887876,
    778778,
    886888,
    797698,
    897877,
    887788,
    988889,
    886877,
    888699,
    888898,
    697789,
    888879,
    788898,
    678779,
    787899,
    877986,
    787878,
    977888,
    888889,
    899778,
    879888,
    878889,
    787889,
    788798,
    886797,
    788889,
    789787,
    977877,
    877878,
    978777,
    897777,
    777877,
    976878,
    888887,
    878868,
    889777,
    887978,
    788888,
    878979,
    899788,
    876778,
    987886,
    778898,
    968797,
    879888,
    788777,
    778889,
    796967,
    777677,
    797887,
    987888,
    888889,
    798767,
    779997,
    877888,
    978777,
    999988,
    778877,
    878977,
    996898,
    989879,
    979877,
    689788,
    867978,
    899788,
    888888,
    788988,
    967877,
    986989,
    887768,
    877877,
    798978,
    898878,
    986779,
    878976,
    797797,
    978789,
    878897,
    779878,
    778988,
    887888,
    779878,
    877767,
    978778,
    887997,
    879877,
    998788,
    897887,
    789787,
    776888,
    887869,
    987877,
    886778,
    889888,
    778898,
    898988,
    977878,
    888887,
    888977,
    787977,
    878787,
    988878,
    766788,
    668778,
    779796,
    978998,
    887988,
    697998,
    789678,
    978698,
    787897,
    877899,
    886878,
    788799,
    788998,
    998979,
    769797,
    888896,
    987779,
    788787,
    877968,
    886898,
    877976,
    778897,
    878888,
    888787,
    878678,
    887788,
    688787,
    776788,
    898788,
    898789,
    877878,
    887889,
    868768,
    868878,
    889768,
    799879,
    889988,
    878767,
    799788,
    778897,
    787887,
    979898,
    978776,
    787878,
    877978,
    888789,
    787786,
    889798,
    778787,
    788787,
    788788,
    677777,
    778877,
    878888,
    898788,
    878788,
    777898,
    877799,
    879888,
    778797,
    888887,
    697779,
    868787,
    888897,
    897898,
    897887,
    887878,
    797889,
    987767,
    888878,
    789787,
    877688,
    976987,
    797978,
    776777,
    778769,
    968888,
    988799,
    877878,
    776789,
    987977,
    687898,
    976778,
    799988,
    778788,
    887888,
    888878,
    677979,
    978787,
    898879,
    889898,
    988689,
    687788,
    778779,
    797688,
    888977,
    987987,
    767888,
    998778,
    978999,
    788877,
    798898,
    878896,
    888979,
    787888,
    787988,
    887788,
    877799,
    798897,
    978788,
    877778,
    879768,
    799889,
    899978,
    889687,
    788979,
    898789,
    887987,
    888887,
    889887,
    688788,
    779879,
    998877,
    799687,
    878887,
    798877,
    889678,
    978796,
    688888,
    968878,
    788996,
    788677,
    789776,
    889798,
    889788,
    887877,
    687879,
    789788,
    677879,
    888778,
    898878,
    787889,
    887888,
    776978,
    788777,
    687987,
    969767,
    987887,
    888887,
    999797,
    887697,
    777798,
    888878,
    778776,
    898978,
    877797,
    777779,
    988788,
    979889,
    978878,
    887878,
    877766,
    798788,
    897898,
    888898,
    889797,
    898887,
    978777,
    976887,
    689778,
    898877,
    888988,
    788888,
    788989,
    887878,
    988887,
    988888,
    688888,
    688887,
    966788,
    779778,
    768897,
    688989,
    879896,
    787788,
    887997,
    978887,
    788896,
    879888,
    797786,
    887888,
    988977,
    778878,
    887978,
    786678,
    889786,
    877787,
    987768,
    989979,
    788879,
    897878,
    787779,
    789877,
    878878,
    688788,
    888876,
    778689,
    997787,
    789889,
    869878,
    897788,
    888778,
    788997,
    888689,
    986868,
    798697,
    799879,
    877879,
    787889,
    797987,
    898889,
    988788,
    888877,
    687787,
    979788,
    878686,
    779978,
    788879,
    787798,
    687967,
    988778,
    799788,
    789788,
    788769,
    888779,
    978879,
    988768,
    967988,
    879887,
    789777,
    888778,
    878887,
    777988,
    997776,
    677777,
    989987,
    867878,
    888779,
    787897,
    878987,
    878889,
    787977,
    898888,
    789977,
    898877,
    896878,
    887887,
    898788,
    887888,
    889897,
    777899,
    798779,
    678889,
    876796,
    798888,
    997786,
    788877,
    867778,
    889877,
    887997,
    879779,
    777998,
    889678,
    899798,
    878797,
    877676,
    678888,
    777798,
    978888,
    988879,
    778887,
    798777,
    788889,
    788998,
    789787,
    888887,
    879887,
    897986,
    998786,
    897878,
    868987,
    977788,
    877999,
    776888,
    886998,
    788796,
    687877,
    688987,
    789877,
    978787,
    877976,
    989778,
    788887,
    899897,
    887979,
    998889,
    889888,
    787789,
    987877,
    688776,
    899889,
    677886,
    978988,
    779798,
    797877,
    877898,
    787988,
    777868,
    878897,
    878976,
    798889,
    977898,
    888798,
    977898,
    979888,
    987776,
    877977,
    878789,
    878787,
    788988,
    788787,
    888778,
    976877,
    898877,
    898889,
    887778,
    778978,
    797768,
    989777,
    888997,
    888778,
    787777,
    898878,
    867888,
    876877,
    877978,
    777798,
    789788,
    977787,
    988878,
    787987,
    677888,
    886888,
    878867,
    888889,
    988888,
    788878,
    778788,
    687777,
    988879,
    778776,
    877689,
    987877,
    888778,
    888886,
    876888,
    988877,
    889778,
    877788,
    868878,
    789898,
    987777,
    988777,
    878898,
    878878,
    997879,
    888798,
    779887,
    879897,
    888787,
    878788,
    898778,
    898679,
    777999,
    696979,
    888787,
    788676,
    678696,
    878988,
    988777,
    879788,
    878878,
    977788,
    877778,
    877678,
    777778,
    778879,
    878777,
    786976,
    788778,
    887987,
    788788,
    696778,
    997698,
    878798,
    887898,
    887899,
    776986,
    878977,
    888888,
    787987,
    797886,
    798787,
    788988,
    889778,
    888797,
    878979,
    978688,
    777789,
    887778,
    787787,
    886877,
    888986,
    888979,
    698877,
    998889,
    798978,
    787998,
    887868,
    777988,
    788788,
    677886,
    888989,
    878889,
    788989,
    878878,
    886879,
    867796,
    768969,
    798767,
    987878,
    887889,
    878998,
    779888,
    887789,
    788977,
    687887,
    787897,
    979986,
    878878,
    988998,
    798987,
    897867,
    778878,
    888789,
    797798,
    788788,
    877776,
    888887,
    868888,
    879787,
    768787,
    778888,
    787997,
    688887,
    977877,
    999988,
    778877,
    978788,
    788788,
    878889,
    878789,
    778987,
    877977,
    787788,
    768787,
    777978,
    797988,
    699977,
    986789,
    688966,
    877679,
    777898,
    778788,
    788889,
    768868,
    868687,
    888797,
    688888,
    879888,
    989889,
    787787,
    777879,
    887788,
    879879,
    968988,
    797798,
    887686,
    799887,
    787996,
    888768,
    898788,
    878988,
    788778,
    888777,
    888776,
    888687,
    877988,
    778989,
    988687,
    898777,
    887886,
    888878,
    897977,
    787887,
    688888,
    786899,
    787669,
    789776,
    889878,
    976889,
    778988,
    786887,
    999988,
    987889,
    779798,
    689778,
    887868,
    897897,
    977799,
    779999,
    897899,
    878887,
    887789,
    779889,
    878877,
    878688,
    778888,
    787689,
    967888,
    877798,
    986767,
    987787,
    888778,
    789887,
    779989,
    898979,
    987989,
    977897,
    879687,
    998878,
    868878,
    887889,
    679777,
    877999,
    789988,
    978888,
    789878,
    888667,
    878799,
    797999,
    687889,
    878978,
    877797,
    789978,
    876778,
    788798,
    867889,
    888888,
    777889,
    878898,
    877677,
    779678,
    786778,
    978987,
    777988,
    778687,
    898787,
    788668,
    778988,
    989687,
    787687,
    877888,
    778887,
    877899,
    878879,
    779887,
    889888,
    878897,
    778878,
    779688,
    898887,
    878769,
    868797,
    888788,
    776888,
    788877,
    777898,
    779889,
    687999,
    668967,
    978786,
    999698,
    977776,
    788687,
    877888,
    778877,
    788676,
    979967,
    677788,
    989777,
    779679,
    888787,
    887898,
    776878,
    789688,
    798987,
    798877,
    978878,
    778968,
    879777,
    787686,
    888888,
    987788,
    788898,
    797887,
    877877,
    978899,
    888796,
    989769,
    789677,
    778878,
    788878,
    788787,
    788788,
    777888,
    879887,
    879777,
    786988,
    878787,
    869888,
    888777,
    899878,
    889798,
    988997,
    878987,
    999788,
    677987,
    988899,
    878878,
    879888,
    978978,
    998788,
    889899,
    879769,
    878887,
    888978,
    976877,
    888888,
    979778,
    888868,
    789796,
    887777,
    878698,
    687888,
    777878,
    776787,
    777898,
    977677,
    796798,
    868888,
    979988,
    878988,
    886878,
    888797,
    778789,
    987788,
    886888,
    999769,
    797877,
    888687,
    788897,
    799988,
    886889,
    899888,
    788678,
    788897,
    886787,
    878878,
    796889,
    999888,
    788878,
    878888,
    787987,
    788877,
    878877,
    988778,
    987878,
    799989,
    888889,
    779797,
    877888,
    889888,
    878879,
    868969,
    998997,
    897869,
    887788,
    779876,
    779878,
    878689,
    887888,
    777678,
    788888,
    887878,
    978787,
    998897,
    878999,
    678898,
    778898,
    979688,
    886869,
    899989,
    777689,
    787787,
    878896,
    878677,
    878778,
    878888,
    889798,
    777888,
    899899,
    788988,
    679778,
    788888,
    678777,
    887898,
    876778,
    969688,
    877877,
    787788,
    978766,
    879778,
    888877,
    887887,
    987889,
    897878,
    888978,
    797986,
    889879,
    997786,
    777777,
    788887,
    888866,
    887898,
    977687,
    889889,
    887779,
    898886,
    789788,
    888987,
    978988,
    788877,
    788787,
    878997,
    776867,
    988688,
    887878,
    877887,
    988789,
    988998,
    787697,
    986789,
    896788,
    779867,
    898778,
    887887,
    787978,
    788976,
    879776,
    987888,
    887868,
    887788,
    898778,
    899788,
    779888,
    688998,
    788988,
    988989,
    798779,
    878887,
    878889,
    789987,
    788777,
    698896,
    868878,
    887977,
    887878,
    888877,
    888888,
    676887,
    887997,
    689987,
    767889,
    898897,
    879887,
    788897,
    798797,
    897897,
    887888,
    888888,
    898897,
    789989,
    977786,
    786687,
    788998,
    889867,
    998687,
    888778,
    887878,
    987788,
    879879,
    877978,
    977789,
    986979,
    879779,
    978797,
    886787,
    799889,
    669788,
    989788,
    878888,
    977788,
    869879,
    788967,
    887968,
    787988,
    888888,
    779889,
    887877,
    887888,
    887898,
    789887,
    978897,
    988689,
    978887,
    997987,
    886797,
    788998,
    787888,
    897779,
    788969,
    787778,
    877869,
    888798,
    787798,
    988878,
    976689,
    898987,
    789768,
    787788,
    797796,
    778898,
    878978,
    887778,
    887888,
    789687,
    878889,
    788877,
    878877,
    878777,
    889878,
    887789,
    678788,
    787887,
    776798,
    989889,
    886778,
    878898,
    789878,
    888888,
    978777,
    888798,
    879798,
    887889,
    778877,
    897878,
    788787,
    778877,
    897789,
    897777,
    688878,
    797999,
    998996,
    777677,
    768778,
    977788,
    896788,
    778777,
    889887,
    887986,
    879986,
    787887,
    798777,
    988778,
    788988,
    879689,
    787768,
    898768,
    787787,
    788978,
    879978,
    887897,
    887979,
    777888,
    979699,
    978987,
    878988,
    867789,
    868988,
    978866,
    877868,
    687899,
    876887,
    898787,
    986998,
    978789,
    878779,
    868797,
    788678,
    887889,
    998887,
    786877,
    777998,
    679888,
    788987,
    988998,
    888888,
    787888,
    788989,
    887687,
    787787,
    887689,
    888996,
    779888,
    898677,
    999768,
    889799,
    979978,
    788887,
    887988,
    777777,
    777887,
    899777,
    988787,
    879788,
    777789,
    897889,
    899888,
    979976,
    986877,
    879987,
    779877,
    777988,
    989978,
    898788,
    878779,
    769896,
    879898,
    788778,
    778688,
    788878,
    869877,
    898888,
    787977,
    789867,
    878788,
    879898,
    898897,
    888777,
    798899,
    777796,
    988988,
    879878,
    797876,
    887899,
    986878,
    787877,
    986888,
    888977,
    888898,
    778888,
    878887,
    798988,
    869798,
    999778,
    788987,
    986986,
    887878,
    889787,
    787778,
    897889,
    887689,
    887788,
    869878,
    979799,
    879778,
    889887,
    867888,
    868888,
    878778,
    877778,
    878789,
    987987,
    778788,
    869998,
    787787,
    798977,
    779898,
    869888,
    898789,
    888867,
    886788,
    788988,
    999688,
    977789,
    969886,
    986979,
    787877,
    698988,
    889788,
    798789,
    789778,
    988877,
    978768,
    788878,
    888798,
    667887,
    989878,
    788888,
    897898,
    687798,
    989878,
    777897,
    787879,
    879778,
    887788,
    879988,
    969788,
    798788,
    997888,
    787778,
    787797,
    797889,
    768787,
    889886,
    888778,
    877878,
    979969,
    788787,
    798678,
    797877,
    777789,
    877778,
    788778,
    788988,
    778798,
    777879,
    777778,
    887889,
    997978,
    988788,
    787978,
    869998,
    898889,
    879768,
    968796,
    789989,
    979888,
    888877,
    897898,
    877889,
    888779,
    879888,
    888778,
    878888,
    887988,
    767989,
    899789,
    788878,
    887999,
    988778,
    899789,
    977978,
    777777,
    778888,
    877887,
    768987,
    888787,
    886879,
    888978,
    989889,
    888799,
    788987,
    779879,
    998878,
    888787,
    778798,
    887678,
    987879,
    888778,
    998887,
    988888,
    787668,
    879678,
    789689,
    887878,
    878989,
    786878,
    867889,
    888878,
    988888,
    867897,
    788998,
    687687,
    978868,
    777778,
    868887,
    799888,
    797786,
    889988,
    987778,
    887879,
    787898,
    887797,
    777777,
    889878,
    899889,
    688989,
    887889,
    768977,
    989888,
    778878,
    888888,
    889778,
    689877,
    878978,
    878789,
    788977,
    787877,
    889687,
    988899,
    988867,
    878887,
    879788,
    897888,
    789888,
    797888,
    878887,
    887887,
    788688,
    898789,
    789897,
    888779,
    988988,
    889877,
    887889,
    977788,
    777889,
    978878,
    687789,
    886687,
    877878,
    897867,
    688878,
    977778,
    797899,
    997998,
    878887,
    778787,
    888879,
    887878,
    888978,
    797987,
    898988,
    788877,
    899778,
    786897,
    986887,
    978888,
    887886,
    899987,
    798888,
    789988,
    887887,
    788878,
    876898,
    777768,
    787888,
    989998,
    887788,
    778978,
    887977,
    989867,
    788986,
    898889,
    678888,
    898777,
    687897,
    988799,
    779886,
    788999,
    778899,
    767987,
    999887,
    978788,
    877798,
    978989,
    888778,
    989898,
    788898,
    867868,
    878888,
    777877,
    678977,
    777779,
    676787,
    799876,
    888787,
    877878,
    979788,
    888887,
    886789,
    787798,
    977887,
    787886,
    888788,
    989878,
    786978,
    889897,
    979798,
    867886,
    778868,
    888788,
    797988,
    888887,
    768778,
    888869,
    797798,
    779867,
    779898,
    976889,
    788879,
    696889,
    887897,
    788897,
    797798,
    789887,
    799887,
    898877,
    978697,
    989678,
    787778,
    787879,
    889988,
    889788,
    888989,
    987878,
    868978,
    697799,
    788877,
    687889,
    779777,
    889778,
    889679,
    886787,
    976798,
    988878,
    788888,
    877788,
    887787,
    888777,
    878887,
    878979,
    979889,
    879798,
    887787,
    867878,
    678767,
    789888,
    886787,
    898888,
    898987,
    798788,
    888897,
    887977,
    888899,
    777978,
    767887,
    989899,
    999988,
    878778,
    787877,
    788979,
    887888,
    877898,
    989778,
    778877,
    998888,
    898778,
    887879,
    877898,
    867887,
    688788,
    877787,
    789988,
    888888,
    999888,
    988686,
    968798,
    988887,
    879888,
    977688,
    978787,
    988777,
    789888,
    778888,
    796778,
    986896,
    868789,
    888778,
    788988,
    789888,
    988769,
    898779,
    867887,
    778987,
    686989,
    877787,
    878897,
    899867,
    777897,
    886879,
    789988,
    877976,
    877798,
    788999,
    899888,
    978878,
    797796,
    888988,
    989777,
    788878,
    878779,
    778788,
    789869,
    878868,
    987888,
    997779,
    878888,
    777978,
    688879,
    888888,
    788778,
    788778,
    867987,
    698878,
    678889,
    988878,
    898787,
    867987,
    767887,
    888889,
    867886,
    887789,
    777887,
    789778,
    878979,
    978878,
    787787,
    889786,
    789787,
    879777,
    889786,
    889888,
    888876,
    689768,
    878877,
    888789,
    888997,
    778776,
    779867,
    787687,
    788677,
    867797,
    867888,
    788889,
    877979,
    877888,
    978797,
    798888,
    788789,
    889776,
    889979,
    979777,
    989888,
    789778,
    888777,
    778766,
    877978,
    898797,
    886798,
    878878,
    889889,
    889778,
    788987,
    877899,
    878787,
    887678,
    877787,
    787989,
    889877,
    879789,
    889887,
    877898,
    979879,
    887877,
    888889,
    979888,
    998876,
    766888,
    897667,
    678868,
    887889,
    789789,
    789768,
    798978,
    787698,
    778889,
    876888,
    877788,
    877798,
    788778,
    678769,
    887898,
    899877,
    989887,
    889998,
    779777,
    787778,
    888878,
    798888,
    889797,
    889777,
    976988,
    889987,
    668888,
    777878,
    778678,
    788788,
    778889,
    798789,
    899787,
    798878,
    998977,
    888779,
    868667,
    778887,
    789787,
    988887,
    787878,
    679887,
    897778,
    787777,
    987877,
    898989,
    899989,
    789796,
    879787,
    888777,
    768998,
    987788,
    889798,
    778788,
    878897,
    979886,
    686686,
    878779,
    998878,
    779896,
    877987,
    788888,
    767789,
    789878,
    889877,
    687898,
    888988,
    877879,
    878899,
    897787,
    797986,
    986686,
    787789,
    988978,
    797888,
    887688,
    986888,
    889888,
    988787,
    788788,
    878677,
    787887,
    888679,
    879887,
    877689,
    977888,
    989688,
    767879,
    989877,
    777779,
    788877,
    887998,
    887897,
    798889,
    987888,
    888779,
    977686,
    986788,
    788897,
    788687,
    867988,
    978998,
    987898,
    997798,
    887789,
    787878,
    887898,
    998978,
    687987,
    787798,
    986889,
    776687,
    889787,
    989787,
    786778,
    789787,
    768898,
    888878,
    988868,
    889877,
    969778,
    988899,
    897888,
    779789,
    779778,
    888788,
    769798,
    878776,
    776977,
    789778,
    888888,
    978878,
    677989,
    887888,
    997879,
    789867,
    888877,
    986799,
    779789,
    686876,
    788789,
    977778,
    876788,
    688788,
    978889,
    787977,
    887787,
    878867,
    879887,
    798787,
    887677,
    777999,
    879788,
    678898,
    988998,
    789779,
    767788,
    697877,
    987878,
    789998,
    868988,
    768777,
    689888,
    778787,
    797768,
    878786,
    998677,
    888787,
    867887,
    969878,
    877988,
    878898,
    987988,
    978888,
    998988,
    698888,
    887788,
    787768,
    878886,
    888777,
    789799,
    897878,
    967787,
    987886,
    877887,
    898878,
    877886,
    978898,
    887899,
    767877,
    878789,
    787879,
    878787,
    879799,
    877898,
    869798,
    778888,
    998788,
    788889,
    898896,
    799898,
    989899,
    678978,
    788889,
    977869,
    777977,
    997887,
    779988,
    888887,
    897687,
    987878,
    997787,
    887789,
    777678,
    778878,
    877777,
    777898,
    979788,
    977798,
    887978,
    988867,
    769787,
    868889,
    779979,
    788678,
    867978,
    777797,
    867889,
    897769,
    898869,
    798888,
    987989,
    978879,
    677687,
    898868,
    888789,
    898787,
    789989,
    899879,
    887777,
    878778,
    976687,
    799778,
    877797,
    888878,
    979797,
    998867,
    778887,
    869987,
    887888,
    878878,
    887887,
    768878,
    887987,
    877976,
    888977,
    798668,
    667876,
    697979,
    778768,
    777988,
    979779,
    887887,
    888878,
    779898,
    887788,
    779998,
    986789,
    896988,
    689877,
    978889,
    879689,
    889797,
    877998,
    887869,
    797787,
    888988,
    798697,
    879997,
    878866,
    778877,
    787768,
    898788,
    898878,
    878879,
    877788,
    878877,
    877877,
    978979,
    887868,
    997867,
    878897,
    788787,
    878978,
    888987,
    778976,
    779888,
    878898,
    986977,
    978888,
    997878,
    679888,
    977987,
    777789,
    768777,
    868988,
    788776,
    897988,
    898788,
    779898,
    787978,
    878989,
    999787,
    886888,
    877788,
    889888,
    786897,
    888788,
    989779,
    997898,
    997888,
    898787,
    766778,
    778887,
    798988,
    878799,
    878797,
    688779,
    789898,
    897877,
    887897,
    988786,
    887887,
    788889,
    898898,
    787979,
    778788,
    869997,
    967877,
    788887,
    777897,
    868868,
    786988,
    878876,
    877899,
    997979,
    797778,
    989889,
    877677,
    888677,
    869888,
    778687,
    797898,
    999998,
    796899,
    778677,
    987777,
    888888,
    677789,
    886887,
    888788,
    867887,
    898898,
    788868,
    786999,
    887878,
    888868,
    777988,
    887978,
    988889,
    889876,
    876878,
    878789,
    777887,
    898987,
    789789,
    977787,
    788798,
    879787,
    899967,
    888878,
    987879,
    998977,
    778799,
    789988,
    867788,
    686897,
    888988,
    888899,
    978978,
    878687,
    788878,
    986879,
    677888,
    778888,
    877898,
    988999,
    989879,
    878688,
    678878,
    698887,
    799788,
    989787,
    868687,
    898797,
    888789,
    898978,
    787777,
    799968,
    888887,
    787877,
    876877,
    788998,
    878898,
    778988,
    888778,
    977777,
    988677,
    989778,
    778787,
    786987,
    777879,
    788797,
    888887,
    898869,
    987889,
    888788,
    988877,
    777877,
    878889,
    788698,
    778878,
    897888,
    978878,
    897779,
    988868,
    787897,
    888888,
    888978,
    878777,
    796777,
    787889,
    887878,
    999889,
    897788,
    878799,
    778889,
    888889,
    897789,
    879887,
    866997,
    988889,
    797878,
    896888,
    988897,
    998789,
    998897,
    797877,
    788768,
    877888,
    778788,
    888889,
    788887,
    977879,
    898867,
    977787,
    987888,
    897787,
    879787,
    786978,
    777989,
    776877,
    978999,
    878899,
    889797,
    779878,
    898789,
    988978,
    998996,
    688888,
    877769,
    769787,
    788878,
    997697,
    877797,
    887799,
    888969,
    989878,
    878766,
    998877,
    678888,
    889877,
    787798,
    878788,
    878998,
    788768,
    988877,
    788789,
    989998,
    878979,
    879888,
    778887,
    688786,
    787686,
    686778,
    788779,
    788888,
    888778,
    787779,
    878889,
    878888,
    888988,
    789878,
    988898,
    887889,
    778887,
    888887,
    888898,
    787877,
    898988,
    979688,
    878977,
    888689,
    979978,
    998877,
    867978,
    888887,
    687777,
    988687,
    787788,
    868878,
    898878,
    988768,
    877879,
    887879,
    898767,
    777789,
    866887,
    797877,
    988987,
    798878,
    787799,
    878876,
    777998,
    778887,
    887897,
    689788,
    768889,
    898788,
    978787,
    987778,
    878889,
    977969,
    888878,
    988877,
    999698,
    888778,
    897789,
    869777,
    878888,
    878897,
    879779,
    768778,
    878788,
    987798,
    878787,
    877789,
    898787,
    787898,
    987688,
    777978,
    777788,
    987887,
    798889,
    788978,
    988897,
    679978,
    879998,
    878988,
    688889,
    878887,
    878898,
    778887,
    777898,
    878778,
    778987,
    778899,
    787889,
    878798,
    979877,
    888878,
    788879,
    888887,
    897878,
    787887,
    968998,
    997998,
    987797,
    788789,
    778787,
    778878,
    898787,
    687986,
    989989,
    898788,
    987777,
    789877,
    878777,
    679897,
    897888,
    779877,
    888888,
    878878,
    877997,
    888878,
    787689,
    978978,
    778997,
    988698,
    979688,
    778797,
    888889,
    877877,
    777798,
    988888,
    677777,
    888688,
    788988,
    778889,
    888898,
    778799,
    889888,
    898889,
    998989,
    877878,
    779987,
    798986,
    688877,
    898777,
    899788,
    888788,
    898878,
    888977,
    798788,
    998677,
    896877,
    889677,
    878888,
    988868,
    977877,
    888788,
    787886,
    779788,
    789799,
    797899,
    777889,
    887787,
    887898,
    998787,
    777898,
    687977,
    867697,
    799977,
    789977,
    768799,
    888988,
    888778,
    787978,
    789688,
    987679,
    889979,
    868887,
    878988,
    879789,
    888768,
    787899,
    797888,
    876876,
    787777,
    968888,
    768877,
    987887,
    987889,
    888789,
    889879,
    889888,
    879788,
    987977,
    798767,
    976698,
    878776,
    998988,
    877788,
    778986,
    797999,
    987878,
    697888,
    789768,
    779989,
    799787,
    986799,
    788887,
    688887,
    776878,
    976777,
    889978,
    888969,
    897877,
    878877,
    987787,
    788877,
    897788,
    888898,
    888869,
    788789,
    797888,
    897778,
    887789,
    887888,
    778986,
    877788,
    788899,
    787887,
    878988,
    997688,
    798987,
    978878,
    789978,
    898776,
    897877,
    877978,
    888788,
    888987,
    876768,
    788888,
    788868,
    778889,
    888987,
    778797,
    988978,
    778868,
    978899,
    878799,
    978997,
    788877,
    789978,
    897989,
    978889,
    678888,
    788688,
    977697,
    879988,
    868887,
    876988,
    879788,
    777898,
    687888,
    879978,
    777886,
    799879,
    997788,
    796888,
    799876,
    987687,
    687989,
    767888,
    888888,
    898797,
    789868,
    787998,
    897878,
    979897,
    879889,
    789798,
    877778,
    879879,
    877777,
    898877,
    889889,
    998888,
    889878,
    787879,
    877889,
    897876,
    776798,
    878788,
    787877,
    888897,
    796977,
    878879,
    777978,
    788998,
    887889,
    877777,
    787797,
    898967,
    778997,
    897997,
    687879,
    879789,
    778867,
    998998,
    878888,
    887688,
    878878,
    877678,
    978988,
    977877,
    787788,
    678688,
    776888,
    879687,
    898878,
    888889,
    899887,
    899998,
    997878,
    868696,
    788979,
    888978,
    978887,
    877978,
    788997,
    786678,
    788987,
    876987,
    777888,
    886878,
    797787,
    777768,
    978979,
    868778,
    769987,
    897987,
    779878,
    777888,
    888888,
    797878,
    888988,
    888797,
    887989,
    798788,
    778989,
    977988,
    788887,
    788787,
    788877,
    667788,
    786889,
    878877,
    777988,
    788788,
    988887,
    777977,
    787998,
    878788,
    888877,
    778777,
    897878,
    889889,
    788886,
    978887,
    977777,
    778779,
    987988,
    989768,
    878887,
    787787,
    777978,
    879779,
    877778,
    778887,
    798987,
    867877,
    779896,
    877788,
    876678,
    787997,
    897898,
    888889,
    777787,
    877886,
    889888,
    777867,
    988769,
    988777,
    887778,
    889877,
    787799,
    699999,
    687996,
    767888,
    787877,
    777899,
    886877,
    888989,
    788868,
    798978,
    878767,
    997867,
    877896,
    788787,
    898879,
    897788,
    887877,
    887787,
    888989,
    897897,
    987997,
    767798,
    899888,
    788787,
    889888,
    767889,
    787899,
    986798,
    788977,
    977788,
    988787,
    799787,
    888898,
    778788,
    977979,
    779786,
    878888,
    878789,
    889698,
    897677,
    796679,
    879898,
    898979,
    898997,
    677788,
    977767,
    889888,
    788687,
    887688,
    878887,
    798797,
    878888,
    899787,
    789887,
    977887,
    788888,
    889778,
    886887,
    877869,
    887879,
    889887,
    977689,
    798888,
    777778,
    997968,
    889677,
    779688,
    797798,
    867679,
    987887,
    977787,
    798877,
    897987,
    778689,
    776878,
    967887,
    969899,
    888888,
    977887,
    987997,
    998889,
    987989,
    978889,
    777986,
    797887,
    798787,
    888986,
    797897,
    977979,
    877898,
    798788,
    788988,
    878887,
    777997,
    777998,
    786868,
    788989,
    887787,
    879887,
    898897,
    877988,
    778887,
    897978,
    878878,
    877787,
    896876,
    787886,
    876877,
    898987,
    967867,
    798777,
    769887,
    878797,
    898978,
    889777,
    887989,
    978878,
    988687,
    887868,
    877789,
    677787,
    887777,
    888798,
    888777,
    788889,
    788776,
    987886,
    778688,
    878876,
    898888,
    987878,
    888899,
    987788,
    768897,
    898889,
    869877,
    977997,
    876978,
    789998,
    778687,
    768698,
    797887,
    899778,
    898797,
    789789,
    778887,
    887989,
    887788,
    888876,
    787878,
    877898,
    899978,
    887887,
    988788,
    877876,
    978787,
    989788,
    788878,
    688977,
    778789,
    988787,
    779888,
    877888,
    777787,
    778899,
    977978,
    879886,
    889879,
    776988,
    967998,
    689878,
    767778,
    877877,
    788788,
    689798,
    898787,
    877978,
    978778,
    989777,
    877896,
    879787,
    887887,
    799878,
    889987,
    798977,
    888987,
    787988,
    789788,
    987996,
    889778,
    889887,
    769877,
    788797,
    877786,
    778887,
    777777,
    887877,
    768877,
    978998,
    986878,
    687879,
    896979,
    898799,
    879898,
    887868,
    898768,
    889879,
    778787,
    678868,
    879977,
    778797,
    979789,
    998886,
    798788,
    778887,
    667888,
    777778,
    876787,
    888769,
    878869,
    799667,
    887798,
    878878,
    977876,
    697778,
    797889,
    769897,
    887779,
    778898,
    987878,
    888877,
    879888,
    989788,
    979797,
    878789,
    887887,
    789789,
    788898,
    897896,
    886799,
    787877,
    768799,
    788897,
    789877,
    978797,
    888788,
    887998,
    669868,
    898877,
    898798,
    779768,
    898878,
    986687,
    798768,
    988798,
    886887,
    877988,
    889978,
    877878,
    798787,
    799688,
    887778,
    868786,
    689978,
    987968,
    989988,
    898687,
    789877,
    997778,
    977988,
    877887,
    877779,
    787876,
    887977,
    997767,
    688778,
    787677,
    988898,
    869777,
    898788,
    988969,
    788877,
    988888,
    779778,
    967897,
    896798,
    998888,
    789889,
    888798,
    898987,
    797788,
    887798,
    889779,
    987879,
    988887,
    877778,
    688797,
    787768,
    899878,
    789898,
    777879,
    778789,
    888987,
    887677,
    998887,
    778886,
    788798,
    887787,
    887878,
    687977,
    788778,
    997797,
    879687,
    888776,
    889978,
    988876,
    878876,
    877887,
    877889,
    878698,
    777778,
    988879,
    777989,
    899887,
    669898,
    996899,
    878887,
    788897,
    987788,
    977788,
    988788,
    788877,
    899878,
    898968,
    999698,
    978878,
    879789,
    896867,
    988879,
    879777,
    787897,
    878878,
    689787,
    888787,
    897869,
    996888,
    978799,
    788677,
    889788,
    777886,
    877788,
    877777,
    688888,
    798888,
    888878,
    888899,
    788978,
    788788,
    978869,
    787777,
    889978,
    977789,
    867798,
    788889,
    977789,
    797888,
    898889,
    778878,
    877997,
    889998,
    869789,
    898978,
    878878,
    778997,
    788877,
    789887,
    798987,
    977977,
    886887,
    899987,
    866967,
    877879,
    778789,
    788798,
    987799,
    988787,
    678788,
    888787,
    868877,
    777988,
    667988,
    987878,
    989788,
    779888,
    877897,
    879679,
    888897,
    777888,
    879689,
    788787,
    787987,
    989889,
    899867,
    999888,
    886787,
    788888,
    978787,
    787887,
    878898,
    989786,
    998877,
    788878,
    797989,
    788889,
    878777,
    898688,
    787988,
    877788,
    879879,
    898877,
    788898,
    788887,
    799687,
    887898,
    778889,
    888787,
    788888,
    777987,
    887797,
    789878,
    697777,
    989877,
    886988,
    788799,
    998777,
    876987,
    888888,
    688789,
    888867,
    887879,
    887878,
    888788,
    777788,
    868997,
    899788,
    867878,
    898998,
    876888,
    788887,
    898696,
    779998,
    879887,
    887898,
    869787,
    998998,
    887798,
    787787,
    687787,
    899798,
    797887,
    998997,
    996889,
    879788,
    787888,
    969798,
    778967,
    888789,
    987778,
    788799,
    999777,
    966877,
    898767,
    797777,
    867799,
    888888,
    799777,
    798797,
    887987,
    889798,
    788789,
    789886,
    887799,
    777777,
    888788,
    868779,
    689978,
    879778,
    779998,
    877788,
    898776,
    778888,
    796688,
    788886,
    987999,
    888879,
    869886,
    887778,
    777788,
    767868,
    997887,
    899879,
    897978,
    889678,
    878779,
    876878,
    778789,
    886777,
    797979,
    799887,
    786978,
    878887,
    878878,
    787898,
    878987,
    788777,
    888877,
    976978,
    889988,
    779878,
    878798,
    978788,
    898788,
    987677,
    789687,
    868677,
    897967,
    889889,
    867777,
    886987,
    868989,
    897897,
    887998,
    679879,
    878877,
    877888,
    888777,
    886988,
    868986,
    898987,
    878888,
    898979,
    997988,
    779797,
    898899,
    978876,
    787877,
    888879,
    989889,
    888778,
    777868,
    899878,
    788979,
    898876,
    989878,
    998878,
    999787,
    787979,
    879686,
    887877,
    887688,
    888777,
    998977,
    788987,
    899877,
    877889,
    878668,
    898999,
    878888,
    778778,
    977789,
    788988,
    777887,
    798978,
    797776,
    987888,
    787878,
    789877,
    688899,
    877878,
    888797,
    867788,
    878888,
    888767,
    887877,
    988987,
    887878,
    777688,
    888787,
    688876,
    977787,
    887977,
    789979,
    797887,
    888988,
    998687,
    887888,
    777988,
    688778,
    869779,
    889877,
    888889,
    968877,
    887998,
    887798,
    887798,
    878877,
    988889,
    977788,
    878688,
    779897,
    888797,
    878887,
    889879,
    778777,
    887888,
    888798,
    777888,
    898988,
    969687,
    779979,
    889978,
    989889,
    797888,
    889898,
    789767,
    988778,
    987988,
    989788,
    778878,
    998889,
    998878,
    797997,
    986977,
    888796,
    787889,
    699889,
    777979,
    877879,
    989999,
    678779,
    988878,
    888899,
    798768,
    799688,
    989797,
    877677,
    977896,
    867778,
    989897,
    988986,
    987778,
    687697,
    899897,
    989879,
    888777,
    766777,
    877898,
    787999,
    987978,
    798988,
    888897,
    887898,
    978897,
    678877,
    887998,
    787878,
    988687,
    787888,
    777799,
    779798,
    788787,
    777777,
    888968,
    879878,
    978979,
    787877,
    788877,
    988686,
    777788,
    988889,
    876989,
    888797,
    979979,
    888797,
    877798,
    989977,
    888789,
    898877,
    798899,
    799787,
    887988,
    977868,
    877796,
    896888,
    879887,
    989778,
    878888,
    689877,
    887888,
    886988,
    786889,
    797788,
    778798,
    886887,
    688988,
    897887,
    787899,
    977779,
    788888,
    677988,
    878879,
    989888,
    978888,
    797888,
    779889,
    797899,
    967767,
    886888,
    777767,
    977779,
    879878,
    877988,
    787677,
    788788,
    888779,
    878776,
    988897,
    896778,
    867878,
    889898,
    876788,
    777988,
    797798,
    778799,
    888877,
    688887,
    886788,
    779877,
    877776,
    978879,
    978778,
    777868,
    877878,
    688998,
    788887,
    788878,
    868789,
    998886,
    878886,
    878887,
    887868,
    877887,
    888888,
    977778,
    896889,
    878898,
    687788,
    998887,
    786878,
    897779,
    787887,
    777898,
    889788,
    878999,
    869888,
    789888,
    888877,
    687786,
    778898,
    788888,
    788887,
    878778,
    998778,
    989877,
    787797,
    978787,
    877778,
    889898,
    977888,
    869799,
    877778,
    867869,
    788777,
    879787,
    878889,
    977979,
    889897,
    988998,
    887887,
    779998,
    888788,
    687788,
    999697,
    877887,
    879877,
    787897,
    899867,
    889797,
    897676,
    878978,
    878878,
    777877,
    988887,
    988989,
    688786,
    888888,
    778898,
    886778,
    788898,
    798968,
    877779,
    788987,
    987789,
    789689,
    888888,
    778978,
    788897,
    988887,
    888876,
    776778,
    888667,
    788878,
    768888,
    879888,
    988898,
    988787,
    779888,
    698778,
    997887,
    886886,
    878779,
    789678,
    977787,
    967987,
    786888,
    979879,
    768988,
    777779,
    868789,
    777876,
    899867,
    789888,
    888886,
    798888,
    888777,
    887998,
    898788,
    878788,
    787878,
    878997,
    898987,
    878787,
    977887,
    898998,
    798868,
    978877,
    888877,
    788899,
    988798,
    998687,
    879779,
    766988,
    898779,
    988978,
    768787,
    979777,
    987788,
    788779,
    888888,
    687799,
    879987,
    989878,
    887898,
    779999,
    777879,
    687979,
    878789,
    898788,
    787788,
    888788,
    788897,
    997876,
    999897,
    888778,
    867888,
    988768,
    877766,
    788998,
    978697,
    786779,
    976878,
    987977,
    777979,
    987768,
    967768,
    779888,
    788888,
    899888,
    888886,
    769766,
    879979,
    877897,
    789779,
    788787,
    897768,
    988979,
    879887,
    988779,
    798787,
    888788,
    788877,
    877779,
    766878,
    767786,
    989877,
    888898,
    787878,
    998886,
    888797,
    888789,
    999888,
    976687,
    998777,
    997787,
    898888,
    889887,
    988888,
    777868,
    897899,
    978878,
    788888,
    887979,
    789779,
    789899,
    988998,
    787889,
    778778,
    889886,
    888778,
    877997,
    898777,
    788787,
    988878,
    977996,
    678997,
    888977,
    888879,
    889796,
    887787,
    688777,
    988877,
    888788,
    898887,
    988899,
    988787,
    888877,
    997789,
    887887,
    787889,
    778669,
    889988,
    879879,
    778798,
    977678,
    898799,
    879889,
    976789,
    879887,
    987887,
    786778,
    889899,
    889987,
    887786,
    888888,
    987887,
    788777,
    789778,
    878788,
    886786,
    988896,
    888787,
    797788,
    687969,
    877779,
    798878,
    789887,
    878878,
    789877,
    898897,
    777787,
    767689,
    787879,
    778788,
    898799,
    868887,
    787889,
    788878,
    798867,
    778686,
    897977,
    787897,
    888877,
    888888,
    788889,
    988877,
    779778,
    789886,
    889679,
    798978,
    998988,
    778898,
    777897,
    788878,
    899998,
    877787,
    979887,
    967788,
    688687,
    877798,
    979998,
    778877,
    897787,
    898788,
    788779,
    976867,
    778778,
    698887,
    796878,
    778797,
    787989,
    789998,
    787898,
    987877,
    797969,
    787778,
    989997,
    888887,
    887899,
    788788,
    887787,
    776887,
    898989,
    977887,
    868898,
    878788,
    878978,
    988767,
    896868,
    789798,
    877897,
    688879,
    968997,
    879789,
    976898,
    789889,
    898879,
    897787,
    789898,
    998888,
    879788,
    987688,
    977988,
    688989,
    789888,
    897898,
    898978,
    788978,
    778888,
    898766,
    888797,
    788679,
    787869,
    998787,
    768877,
    788788,
    887879,
    978979,
    888977,
    888887,
    877777,
    787777,
    688969,
    978778,
    779988,
    997989,
    888879,
    677886,
    668868,
    788888,
    878887,
    888788,
    898778,
    798887,
    998778,
    889969,
    789897,
    987788,
    898989,
    789989,
    888877,
    997788,
    896768,
    879978,
    697787,
    789788,
    789787,
    877777,
    699877,
    868986,
    878878,
    977898,
    788688,
    878779,
    789998,
    899888,
    889888,
    888888,
    978676,
    897878,
    898888,
    997777,
    787878,
    897799,
    976788,
    778788,
    879787,
    778978,
    777897,
    778787,
    886888,
    797888,
    988878,
    769879,
    778888,
    788798,
    987878,
    877797,
    777888,
    869879,
    988998,
    698896,
    888888,
    989878,
    778886,
    888898,
    697888,
    797866,
    978889,
    898877,
    779878,
    668898,
    687877,
    899979,
    798979,
    887888,
    988798,
    879898,
    887688,
    998888,
    787787,
    877879,
    888687,
    998876,
    777899,
    788988,
    777877,
    797877,
    978788,
    879878,
    887777,
    878997,
    769787,
    779989,
    797767,
    688898,
    888898,
    877789,
    877688,
    987898,
    887778,
    898799,
    978888,
    777889,
    787888,
    789899,
    988779,
    877878,
    887887,
    887897,
    676869,
    869897,
    897888,
    987888,
    899968,
    977888,
    989787,
    777876,
    787988,
    878886,
    899889,
    779779,
    989888,
    786888,
    698777,
    678688,
    687687,
    867967,
    977978,
    889888,
    978888,
    888877,
    678877,
    888679,
    889986,
    888888,
    777896,
    977779,
    778887,
    789977,
    698778,
    796778,
    677878,
    877878,
    887777,
    987888,
    788789,
    897789,
    788897,
    987877,
    879879,
    887888,
    987889,
    799778,
    779867,
    878689,
    989997,
    787888,
    888888,
    888988,
    777998,
    778887,
    897889,
    798888,
    977778,
    977788,
    679888,
    978977,
    897789,
    698887,
    977977,
    998878,
    777978,
    798787,
    878879,
    696768,
    877987,
    888789,
    898788,
    778876,
    979889,
    976987,
    788888,
    878897,
    787798,
    977898,
    888888,
    888987,
    899868,
    899777,
    678787,
    878767,
    777887,
    787889,
    868877,
    778787,
    877888,
    898788,
    786787,
    879868,
    879878,
    879789,
    987889,
    899787,
    878788,
    898998,
    787988,
    887786,
    898788,
    778888,
    777778,
    979887,
    779888,
    999787,
    877969,
    898867,
    898797,
    698987,
    898878,
    778698,
    896888,
    897879,
    978979,
    777786,
    778788,
    897977,
    897989,
    677888,
    888867,
    778787,
    987789,
    798987,
    797887,
    788898,
    788988,
    988778,
    878789,
    978888,
    888877,
    887879,
    878798,
    788877,
    797897,
    889788,
    879778,
    778888,
    767889,
    797876,
    777788,
    987996,
    968968,
    799797,
    868798,
    779787,
    788888,
    787789,
    877978,
    889897,
    788977,
    878887,
    777896,
    887778,
    788789,
    777778,
    978988,
    898687,
    789778,
    978988,
    886778,
    998878,
    879878,
    876788,
    889898,
    976899,
    878876,
    797666,
    799788,
    898787,
    887879,
    688868,
    778778,
    878797,
    977887,
    777687,
    877978,
    789887,
    787779,
    898878,
    989798,
    887978,
    877878,
    998879,
    888777,
    978779,
    877778,
    888679,
    799997,
    999898,
    897778,
    868899,
    877898,
    779879,
    787887,
    887679,
    799788,
    986789,
    788988,
    887887,
    878767,
    898777,
    998988,
    889978,
    889899,
    998778,
    978788,
    987778,
    869987,
    688778,
    767788,
    789668,
    787888,
    778878,
    667979,
    996687,
    887878,
    887877,
    877787,
    889877,
    787777,
    969888,
    878788,
    978978,
    897877,
    887899,
    979989,
    888789,
    987878,
    677998,
    787867,
    898698,
    877987,
    878878,
    988987,
    787787,
    778788,
    799787,
    889797,
    889779,
    988878,
    898779,
    799789,
    977889,
    888797,
    978789,
    786888,
    888987,
    888879,
    987768,
    877788,
    788679,
    797868,
    867897,
    998888,
    888877,
    987887,
    968976,
    989789,
    899799,
    998878,
    869789,
    889787,
    798887,
    899787,
    678798,
    678888,
    787777,
    877988,
    777887,
    698788,
    688898,
    798787,
    888787,
    768877,
    979797,
    888787,
    876788,
    787979,
    789888,
    889777,
    889967,
    888898,
    987699,
    888789,
    978888,
    888688,
    887878,
    888988,
    798776,
    788677,
    776879,
    888886,
    887987,
    786877,
    698887,
    988987,
    798788,
    887887,
    789868,
    689988,
    879887,
    888888,
    988787,
    877867,
    867887,
    878778,
    888888,
    778778,
    877688,
    868877,
    677897,
    878787,
    787987,
    878878,
    978989,
    878789,
    668888,
    889787,
    888997,
    788868,
    888876,
    779898,
    886778,
    779899,
    796878,
    989878,
    887788,
    878998,
    888998,
    778887,
    887887,
    798788,
    889897,
    977878,
    877787,
    689888,
    987788,
    788787,
    768866,
    878998,
    787977,
    898887,
    788799,
    698678,
    787787,
    798877,
    867769,
    878889,
    878787,
    777878,
    898777,
    977998,
    787778,
    699888,
    768788,
    777898,
    789688,
    887888,
    897898,
    878778,
    889888,
    878778,
    787887,
    988687,
    976887,
    779788,
    889898,
    776877,
    897999,
    779977,
    698788,
    687878,
    777787,
    978897,
    669987,
    978898,
    888778,
    788888,
    788887,
    877799,
    688888,
    787899,
    778989,
    888787,
    787778,
    778967,
    789799,
    779989,
    797889,
    898798,
    777998,
    879888,
    888789,
    686878,
    876787,
    687898,
    897889,
    787689,
    777788,
    867887,
    877988,
    999887,
    777787,
    777898,
    766796,
    879888,
    877879,
    778887,
    867788,
    788889,
    988889,
    788788,
    797798,
    786789,
    776888,
    787787,
    888877,
    889777,
    889889,
    689887,
    867988,
    788778,
    879899,
    868888,
    988998,
    787887,
    987769,
    878786,
    877997,
    868798,
    767988,
    887867,
    889876,
    996777,
    789898,
    876878,
    786888,
    779769,
    778886,
    788798,
    777898,
    888788,
    979878,
    879678,
    798789,
    788999,
    788878,
    768878,
    787878,
    887877,
    688979,
    787888,
    878789,
    988979,
    877887,
    889788,
    797777,
    887887,
    789997,
    889877,
    878798,
    979776,
    768989,
    879777,
    888878,
    788888,
    787888,
    889968,
    886777,
    898879,
    987788,
    977877,
    886978,
    788878,
    679778,
    889679,
    778798,
    767888,
    889788,
    878878,
    698888,
    979988,
    778889,
    777968,
    798768,
    868998,
    889777,
    979877,
    777786,
    787979,
    988766,
    888899,
    899788,
    878778,
    888989,
    877887,
    778768,
    988886,
    679787,
    979797,
    787788,
    986767,
    788877,
    886977,
    768877,
    868788,
    878788,
    797677,
    997887,
    998988,
    878877,
    788787,
    887788,
    787777,
    878988,
    797768,
    689989,
    778798,
    678888,
    778987,
    778887,
    889867,
    789888,
    997889,
    879987,
    887978,
    789788,
    788778,
    888886,
    779688,
    998999,
    977779,
    796897,
    998766,
    899787,
    889779,
    877687,
    897787,
    778879,
    987969,
    687798,
    997787,
    787989,
    797788,
    688988,
    797698,
    877778,
    789787,
    998699,
    778788,
    778789,
    887987,
    779777,
    678798,
    888886,
    787889,
    877888,
    888887,
    988888,
    878877,
    698988,
    878888,
    888797,
    797789,
    779987,
    898688,
    778786,
    879898,
    889898,
    879878,
    979789,
    787998,
    788687,
    797988,
    978787,
    898787,
    878798,
    887688,
    977888,
    878799,
    787878,
    688889,
    989898,
    888788,
    888767,
    887888,
    989878,
    877878,
    787997,
    897867,
    798878,
    778778,
    878768,
    888898,
    796887,
    789988,
    688988,
    698779,
    976899,
    688878,
    786878,
    767787,
    899877,
    888887,
    988887,
    788787,
    868788,
    988789,
    787788,
    998878,
    998688,
    897787,
    879797,
    698967,
    887789,
    887778,
    887778,
    778889,
    787978,
    777689,
    988877,
    787897,
    886777,
    977877,
    887868,
    798777,
    889888,
    876887,
    877688,
    878878,
    676889,
    788877,
    999778,
    789778,
    779898,
    888788,
    988888,
    899878,
    689887,
    679887,
    798887,
    768767,
    998877,
    887786,
    788678,
    787777,
    879777,
    786879,
    898876,
    689999,
    988867,
    887788,
    879898,
    899877,
    887869,
    786769,
    887787,
    779878,
    777879,
    898898,
    878879,
    776868,
    989788,
    986987,
    689976,
    797786,
    878779,
    788687,
    876886,
    789867,
    887867,
    777868,
    777878,
    869988,
    878778,
    887799,
    879977,
    988898,
    887899,
    979879,
    878787,
    778889,
    978879,
    888867,
    879999,
    997889,
    788697,
    879887,
    877998,
    878888,
    787896,
    897878,
    997887,
    888869,
    778897,
    688898,
    887868,
    777889,
    878989,
    786887,
    788789,
    887787,
    788988,
    988877,
    888798,
    888777,
    877779,
    867787,
    888899,
    878988,
    888788,
    788689,
    887879,
    889877,
    977887,
    897878,
    878889,
    888898,
    896889,
    899799,
    976878,
    778877,
    887787,
    777878,
    987798,
    977888,
    778978,
    978788,
    778888,
    978779,
    898888,
    789778,
    878787,
    977687,
    888788,
    898878,
    788886,
    898877,
    788878,
    887868,
    888888,
    988989,
    877777,
    678786,
    979689,
    679799,
    867776,
    778798,
    897798,
    768688,
    886878,
    899879,
    978869,
    887888,
    789788,
    778797,
    869887,
    689778,
    877779,
    798879,
    969778,
    778787,
    879866,
    967878,
    888869,
    877867,
    699678,
    988977,
    989787,
    677897,
    869887,
    887788,
    988897,
    888998,
    777998,
    776876,
    887779,
    776797,
    889888,
    887798,
    887987,
    788877,
    799887,
    777787,
    988888,
    987778,
    776888,
    797798,
    887887,
    787778,
    977799,
    887877,
    798987,
    898879,
    679789,
    879789,
    779898,
    868798,
    978889,
    988798,
    877987,
    786879,
    887988,
    789897,
    799778,
    988879,
    698688,
    787988,
    677788,
    868898,
    878796,
    896878,
    898879,
    867777,
    879988,
    888778,
    777989,
    767779,
    777897,
    877879,
    788778,
    986978,
    978986,
    767777,
    899788,
    987977,
    877779,
    888877,
    889879,
    789789,
    878788,
    798787,
    677876,
    988799,
    788877,
    787889,
    797986,
    788779,
    988888,
    888886,
    887888,
    688697,
    878877,
    987887,
    898887,
    899867,
    887997,
    779886,
    887799,
    787869,
    878878,
    687877,
    788899,
    888879,
    877887,
    789768,
    776678,
    797698,
    687899,
    997977,
    887997,
    978998,
    798779,
    777877,
    888998,
    677898,
    768997,
    898787,
    768777,
    877896,
    988979,
    877888,
    877767,
    977778,
    887868,
    887877,
    788889,
    898898,
    778987,
    788779,
    989876,
    798789,
    878889,
    878889,
    787879,
    887877,
    687789,
    877887,
    976888,
    699867,
    887878,
    787977,
    788987,
    788877,
    877887,
    789866,
    989787,
    789887,
    989988,
    768887,
    977878,
    878899,
    688887,
    997888,
    777886,
    878879,
    888787,
    696887,
    689877,
    768788,
    797988,
    799887,
    787889,
    787887,
    967778,
    779879,
    888778,
    978896,
    788998,
    789876,
    798979,
    879688,
    897999,
    878898,
    696979,
    888789,
    679787,
    888678,
    996778,
    786899,
    887787,
    788978,
    777778,
    888987,
    997877,
    887978,
    778788,
    779688,
    898798,
    977988,
    886788,
    876777,
    969688,
    977777,
    789878,
    887889,
    787987,
    779888,
    987877,
    879887,
    887987,
    799888,
    899778,
    788978,
    869878,
    777988,
    988788,
    898779,
    879889,
    878888,
    888967,
    888978,
    867888,
    888998,
    779787,
    978999,
    878977,
    989867,
    877878,
    877888,
    898789,
    978986,
    989787,
    878787,
    797798,
    789887,
    888999,
    779787,
    877878,
    888988,
    887878,
    689777,
    887768,
    988789,
    879967,
    777786,
    869877,
    869788,
    986768,
    899888,
    889867,
    788778,
    777888,
    688867,
    779998,
    676778,
    878896,
    877769,
    677986,
    877887,
    777787,
    787787,
    697697,
    788789,
    779899,
    977788,
    987977,
    876867,
    988776,
    778789,
    688866,
    798888,
    997868,
    798989,
    887898,
    778878,
    798887,
    786878,
    786869,
    988877,
    788798,
    677889,
    887797,
    878787,
    987888,
    887898,
    979887,
    897988,
    789988,
    767989,
    986777,
    869988,
    889798,
    787886,
    699888,
    888879,
    879989,
    778778,
    888888,
    788776,
    668878,
    879888,
    987888,
    678887,
    888899,
    766887,
    687778,
    678689,
    878878,
    987888,
    889898,
    888986,
    788797,
    769889,
    879798,
    977988,
    787978,
    798887,
    887879,
    978887,
    897888,
    676787,
    888788,
    888778,
    776877,
    888778,
    779788,
    798878,
    798898,
    778797,
    888767,
    898867,
    887677,
    887967,
    777799,
    787897,
    887887,
    787777,
    888978,
    778977,
    987888,
    868887,
    898888,
    778878,
    899788,
    789779,
    797878,
    878878,
    878777,
    896778,
    969768,
    787868,
    879778,
    878769,
    778788,
    899877,
    787888,
    686876,
    998879,
    898778,
    889777,
    887898,
    887969,
    797888,
    778778,
    888877,
    688888,
    967787,
    787898,
    678787,
    788777,
    887799,
    879887,
    888897,
    889978,
    887978,
    888878,
    879878,
    888769,
    788988,
    877897,
    777986,
    788788,
    887878,
    997798,
    677778,
    879788,
    896897,
    787878,
    887788,
    696878,
    887777,
    878888,
    867778,
    868899,
    888778,
    987887,
    889978,
    879787,
    788877,
    898989,
    787897,
    668797,
    888776,
    698888,
    877878,
    766786,
    788797,
    967889,
    878788,
    978897,
    997978,
    798878,
    879787,
    876989,
    787798,
    988978,
    888887,
    989687,
    778987,
    977967,
    687888,
    878997,
    877777,
    876886,
    868887,
    788897,
    669978,
    887998,
    887787,
    887977,
    979667,
    676888,
    878777,
    988788,
    788787,
    789987,
    788787,
    767887,
    998798,
    897888,
    798798,
    887878,
    677887,
    877778,
    988877,
    787777,
    987787,
    786787,
    878988,
    886876,
    787889,
    777888,
    989878,
    877898,
    679889,
    678978,
    788988,
    987799,
    898968,
    796898,
    688787,
    988899,
    689988,
    798767,
    678797,
    788888,
    796688,
    878968,
    788687,
    887789,
    787787,
    987968,
    867978,
    899888,
    888889,
    768697,
    988879,
    898968,
    887798,
    787778,
    689989,
    877889,
    998887,
    869989,
    888996,
    998997,
    987797,
    898888,
    778787,
    867788,
    877777,
    887778,
    888989,
    698887,
    787787,
    989887,
    777888,
    799878,
    899777,
    888888,
    988868,
    879896,
    898797,
    778987,
    877968,
    989997,
    978778,
    976987,
    799777,
    989888,
    898787,
    887867,
    798978,
    798798,
    897887,
    988877,
    888987,
    887868,
    779788,
    987879,
    788998,
    998897,
    898797,
    889967,
    878888,
    797899,
    676887,
    778998,
    777997,
    777778,
    898777,
    967978,
    778797,
    976788,
    988798,
    778897,
    887779,
    987889,
    688788,
    788787,
    698789,
    677888,
    778878,
    977876,
    777878,
    689888,
    879788,
    897788,
    887876,
    868979,
    868877,
    887889,
    979889,
    797769,
    788889,
    867788,
    798879,
    979778,
    978998,
    788788,
    878999,
    878777,
    778887,
    877978,
    876778,
    988779,
    879788,
    777797,
    779689,
    879777,
    878877,
    798888,
    897787,
    997787,
    997878,
    876699,
    879888,
    977987,
    799769,
    887896,
    877789,
    877989,
    788896,
    999878,
    788878,
    789996,
    988868,
    978886,
    878777,
    987978,
    898679,
    998888,
    888776,
    798799,
    967778,
    967788,
    778887,
    888988,
    878796,
    879998,
    788789,
    678898,
    899677,
    978798,
    978768,
    878998,
    866778,
    788998,
    787999,
    978888,
    789889,
    889977,
    769997,
    798876,
    997777,
    788789,
    898777,
    788788,
    798898,
    987788,
    686789,
    998887,
    877898,
    877797,
    888879,
    878886,
    788899,
    999877,
    987687,
    888899,
    878888,
    876789,
    996799,
    887799,
    888778,
    799788,
    896689,
    779679,
    888866,
    879789,
    799898,
    989978,
    877788,
    888878,
    777788,
    886798,
    877868,
    997997,
    878899,
    778878,
    899888,
    787888,
    988887,
    899677,
    789798,
    887677,
    879889,
    887988,
    797878,
    778986,
    788788,
    878786,
    878988,
    868788,
    987767,
    897778,
    888998,
    989898,
    796988,
    887899,
    788779,
    798878,
    777998,
    688787,
    778797,
    978889,
    988978,
    687789,
    889877,
    887797,
    789877,
    877888,
    898767,
    878788,
    788988,
    878978,
    787788,
    887988,
    989899,
    899778,
    778786,
    788788,
    766788,
    768986,
    879888,
    778869,
    797898,
    798888,
    898787,
    878786,
    767888,
    888787,
    778678,
    988978,
    978887,
    887978,
    978888,
    887997,
    898897,
    977978,
    876896,
    877977,
    888787,
    788877,
    888967,
    898778,
    879868,
    987678,
    888878,
    777787,
    888879,
    799787,
    889878,
    877898,
    979887,
    879988,
    898679,
    788777,
    997888,
    689877,
    889799,
    877687,
    789877,
    877877,
    878788,
    869998,
    889886,
    788898,
    878998,
    689877,
    887697,
    788988,
    797887,
    889997,
    798888,
    976877,
    876886,
    879966,
    797899,
    887688,
    768889,
    887798,
    897897,
    798888,
    788897,
    777887,
    767799,
    898988,
    898897,
    887998,
    888867,
    888887,
    679878,
    779778,
    887886,
    897989,
    777787,
    977989,
    977888,
    886788,
    898778,
    786798,
    978797,
    888998,
    988768,
    877888,
    899888,
    777788,
    888868,
    788777,
    777776,
    798778,
    788788,
    998879,
    978788,
    798889,
    777978,
    787777,
    867779,
    778989,
    777787,
    779898,
    986878,
    979878,
    868777,
    897688,
    997896,
    978887,
    987898,
    879798,
    899887,
    886777,
    779688,
    887888,
    888889,
    787888,
    798897,
    886788,
    798987,
    786797,
    978889,
    998877,
    878888,
    888887,
    688978,
    988789,
    889777,
    987777,
    788988,
    677787,
    787898,
    788798,
    977888,
    768867,
    789677,
    978887,
    897989,
    789889,
    987877,
    878887,
    778999,
    796879,
    888896,
    779787,
    887998,
    878999,
    878989,
    978697,
    899797,
    678778,
    897868,
    877668,
    898877,
    779786,
    966679,
    887988,
    887888,
    697798,
    778878,
    987879,
    779886,
    977876,
    777977,
    988877,
    786696,
    878777,
    776787,
    798788,
    687889,
    887778,
    877778,
    897788,
    998987,
    787778,
    798888,
    779778,
    979888,
    888798,
    888789,
    878878,
    888989,
    979888,
    888898,
    988878,
    987778,
    878788,
    987877,
    879796,
    877878,
    788989,
    989788,
    879887,
    787876,
    788888,
    898877,
    878867,
    799889,
    778889,
    787789,
    797876,
    977698,
    787889,
    788879,
    897886,
    888798,
    977686,
    779989,
    876788,
    878879,
    789989,
    978887,
    877889,
    878689,
    797788,
    877868,
    789878,
    778798,
    786987,
    967889,
    779977,
    777879,
    897997,
    788888,
    887789,
    887977,
    779889,
    987788,
    778889,
    979778,
    887788,
    987779,
    979897,
    787778,
    876888,
    868668,
    877788,
    778899,
    879787,
    887988,
    789888,
    968879,
    898869,
    878977,
    888897,
    888768,
    998987,
    889696,
    889787,
    878787,
    988897,
    768978,
    978987,
    987888,
    798789,
    867886,
    797887,
    876887,
    878788,
    789976,
    888999,
    878979,
    679887,
    878788,
    798788,
    888788,
    687788,
    878978,
    787998,
    788897,
    877889,
    877889,
    888979,
    887798,
    788787,
    688777,
    798688,
    778897,
    768888,
    989888,
    797779,
    886978,
    968688,
    867879,
    997987,
    768678,
    878989,
    978688,
    888779,
    988889,
    876877,
    888868,
    878888,
    978888,
    968988,
    787978,
    788888,
    788978,
    779888,
    987878,
    877978,
    778898,
    888778,
    678887,
    768788,
    788886,
    778898,
    888679,
    777978,
    888778,
    989788,
    967988,
    699878,
    788878,
    897898,
    896788,
    688788,
    887798,
    877787,
    887899,
    988878,
    777978,
    698977,
    876867,
    876887,
    977878,
    978897,
    887798,
    897889,
    779887,
    988876,
    778878,
    888878,
    888797,
    877888,
    898879,
    888779,
    989778,
    879887,
    877878,
    879898,
    788798,
    977966,
    876878,
    878888,
    798788,
    777788,
    887868,
    898797,
    698887,
    777776,
    778899,
    788967,
    777877,
    878778,
    899877,
    787879,
    889767,
    878998,
    789867,
    878898,
    887879,
    796979,
    788887,
    989788,
    789696,
    979888,
    898788,
    999768,
    876989,
    779787,
    888997,
    978886,
    867788,
    879887,
    876988,
    977888,
    777898,
    987687,
    979788,
    789999,
    878787,
    887998,
    877989,
    998877,
    897877,
    787888,
    788996,
    868977,
    867897,
    797797,
    788877,
    977789,
    879878,
    888988,
    986888,
    768887,
    888797,
    787889,
    789879,
    877786,
    779777,
    776779,
    898798,
    888879,
    888778,
    878888,
    886779,
    877878,
    887778,
    988777,
    788879,
    877889,
    978778,
    778888,
    968999,
    678887,
    987779,
    887777,
    898896,
    876778,
    897888,
    889877,
    798888,
    889889,
    889797,
    888887,
    777998,
    688798,
    798998,
    888677,
    997988,
    886789,
    797878,
    677788,
    898879,
    677998,
    788788,
    887977,
    888896,
    788888,
    886787,
    899798,
    778789,
    889897,
    898888,
    889787,
    978888,
    977797,
    879989,
    889867,
    786887,
    798887,
    978777,
    996798,
    889978,
    876799,
    778777,
    787788,
    777788,
    788797,
    797797,
    789889,
    989977,
    788887,
    886789,
    796776,
    777777,
    898897,
    888978,
    889998,
    987978,
    878888,
    696878,
    876878,
    986996,
    877879,
    777967,
    768788,
    786888,
    799768,
    998898,
    787998,
    978979,
    978878,
    876887,
    797677,
    779886,
    988788,
    797797,
    997897,
    997789,
    678878,
    788987,
    778778,
    898778,
    787978,
    978887,
    899877,
    878788,
    876977,
    686898,
    987898,
    898877,
    877696,
    887779,
    798898,
    887888,
    768888,
    778887,
    789787,
    968967,
    979798,
    786877,
    789988,
    788876,
    887688,
    888887,
    888888,
    688779,
    788898,
    877798,
    768879,
    768897,
    698787,
    797898,
    878989,
    887767,
    888878,
    888888,
    987877,
    778898,
    997979,
    787997,
    888878,
    779887,
    787777,
    787978,
    877887,
    798987,
    876888,
    878987,
    789876,
    878787,
    777798,
    899888,
    888799,
    788789,
    989787,
    978897,
    888679,
    976998,
    768689,
    978877,
    888789,
    979888,
    878997,
    988777,
    977788,
    778878,
    679879,
    777788,
    988877,
    879777,
    798879,
    897788,
    778688,
    768988,
    788988,
    797887,
    767878,
    777987,
    888789,
    887797,
    879989,
    877867,
    888787,
    887778,
    878877,
    787888,
    678889,
    897799,
    889999,
    889779,
    977788,
    797796,
    898887,
    897999,
    788897,
    889878,
    779679,
    777687,
    867977,
    887766,
    886889,
    898978,
    788778,
    899888,
    677777,
    977788,
    878886,
    987977,
    887896,
    978988,
    789777,
    888868,
    888777,
    687898,
    878878,
    897889,
    776878,
    887879,
    979879,
    899687,
    678868,
    888989,
    798778,
    688798,
    789899,
    797987,
    987767,
    778878,
    897778,
    887878,
    888879,
    888688,
    978887,
    888879,
    899988,
    978888,
    789999,
    797786,
    899767,
    889977,
    988777,
    798897,
    779897,
    987798,
    898878,
    978889,
    787777,
    877789,
    778878,
    998977,
    998888,
    878778,
    998887,
    887778,
    988787,
    778878,
    988986,
    888877,
    678887,
    678878,
    866688,
    978877,
    897778,
    878878,
    779798,
    988789,
    868678,
    777787,
    768878,
    898889,
    788889,
    799878,
    887878,
    788768,
    898788,
    977898,
    988877,
    889876,
    788788,
    979878,
    788779,
    788788,
    899888,
    979878,
    777678,
    786896,
    997878,
    789898,
    788889,
    787787,
    689797,
    969998,
    788799,
    778886,
    879878,
    767787,
    879968,
    788997,
    887886,
    789788,
    777877,
    797866,
    887878,
    788799,
    788988,
    897888,
    898677,
    987768,
    899977,
    899888,
    867789,
    897888,
    888888,
    777978,
    668797,
    777868,
    698978,
    888987,
    877768,
    787678,
    886998,
    786789,
    766898,
    887888,
    887689,
    798887,
    678998,
    889788,
    798989,
    887679,
    899979,
    688778,
    888678,
    898887,
    778888,
    887878,
    968988,
    789877,
    789887,
    887988,
    787889,
    889688,
    888887,
    978778,
    789778,
    878786,
    888989,
    778789,
    888888,
    889787,
    888788,
    779988,
    877988,
    888887,
    896897,
    879888,
    888688,
    898688,
    798878,
    778767,
    779888,
    899787,
    778877,
    788889,
    988888,
    778987,
    988799,
    897778,
    787887,
    987777,
    889999,
    987688,
    876878,
    697998,
    899788,
    877778,
    768778,
    967977,
    668888,
    898987,
    878889,
    768789,
    887888,
    778898,
    789777,
    989799,
    877778,
    978998,
    786798,
    777777,
    797898,
    688897,
    987976,
    988798,
    897689,
    788876,
    867889,
    886988,
    998798,
    896987,
    796768,
    679789,
    888889,
    889877,
    778687,
    787788,
    977897,
    888767,
    776888,
    787887,
    968977,
    897998,
    688988,
    868887,
    879776,
    878787,
    989788,
    969667,
    689879,
    897678,
    898888,
    898888,
    878899,
    969889,
    878778,
    878776,
    687888,
    798889,
    867898,
    888788,
    878879,
    889877,
    888989,
    779998,
    897967,
    798897,
    897769,
    798789,
    877887,
    788869,
    799887,
    788898,
    787978,
    999879,
    778878,
    787868,
    987978,
    878889,
    898968,
    877687,
    777778,
    788988,
    977897,
    697777,
    966889,
    978888,
    779788,
    889989,
    787687,
    899989,
    879799,
    798888,
    987988,
    887988,
    988899,
    799797,
    678878,
    878887,
    776687,
    767888,
    787867,
    999898,
    889788,
    777767,
    887788,
    887889,
    799687,
    888876,
    988777,
    879899,
    798978,
    897898,
    777998,
    778978,
    797888,
    678887,
    979877,
    887988,
    878888,
    788889,
    989888,
    787898,
    888888,
    777787,
    899779,
    898989,
    877888,
    868776,
    877878,
    897987,
    777778,
    789996,
    789888,
    869788,
    877888,
    878877,
    787878,
    987877,
    879977,
    888998,
    979877,
    789779,
    877878,
    898879,
    877897,
    677986,
    878878,
    779886,
    868897,
    778778,
    987788,
    887887,
    887878,
    886797,
    989787,
    887798,
    879678,
    977869,
    787868,
    788787,
    978887,
    887888,
    788899,
    678797,
    878788,
    688798,
    989888,
    879878,
    768786,
    879987,
    887887,
    877898,
    887977,
    878878,
    768788,
    777978,
    878888,
    678878,
    876778,
    998788,
    889899,
    888888,
    886898,
    778789,
    887888,
    898777,
    968787,
    778687,
    988778,
    888797,
    876979,
    789967,
    879769,
    676889,
    886789,
    788867,
    787886,
    888787,
    898896,
    789886,
    788777,
    898889,
    878778,
    798868,
    878897,
    888787,
    878898,
    869878,
    767688,
    988697,
    768978,
    996678,
    987899,
    687878,
    776788,
    978879,
    888878,
    899788,
    777899,
    866679,
    878868,
    778677,
    779887,
    899778,
    787989,
    777978,
    677887,
    778888,
    787968,
    766887,
    788897,
    778788,
    777868,
    786888,
    888877,
    776787,
    678697,
    978988,
    787889,
    787987,
    789788,
    876888,
    878969,
    997798,
    898878,
    778799,
    887987,
    789787,
    698887,
    987898,
    988977,
    888989,
    888778,
    977879,
    798889,
    779878,
    787889,
    998888,
    788967,
    877788,
    787897,
    797878,
    767877,
    878979,
    777887,
    878996,
    987877,
    976786,
    879888,
    779899,
    988768,
    896798,
    989887,
    688888,
    797698,
    779977,
    786987,
    898789,
    788778,
    879877,
    887777,
    788779,
    877867,
    888777,
    877887,
    987987,
    678977,
    879779,
    787887,
    997869,
    886988,
    777799,
    888889,
    797778,
    877877,
    888979,
    797888,
    798768,
    877767,
    799877,
    988977,
    878889,
    698878,
    997988,
    688988,
    786988,
    999897,
    688877,
    977797,
    997888,
    978787,
    787898,
    788899,
    778877,
    898796,
    877778,
    887999,
    888778,
    877888,
    887788,
    878799,
    887989,
    689897,
    978877,
    788888,
    978769,
    888789,
    987977,
    788699,
    897888,
    788798,
    888698,
    899888,
    779879,
    898787,
    878777,
    988976,
    778986,
    878887,
    998877,
    877687,
    777988,
    787988,
    998878,
    978798,
    788788,
    979888,
    797889,
    879988,
    888877,
    778688,
    888898,
    787987,
    779887,
    978797,
    787687,
    688777,
    788797,
    787888,
    897779,
    788779,
    798887,
    889869,
    888789,
    898887,
    888998,
    777798,
    887788,
    788697,
    899898,
    897867,
    889988,
    797888,
    797788,
    898987,
    798797,
    787899,
    677989,
    787988,
    988888,
    878878,
    878867,
    789777,
    977777,
    678789,
    988988,
    668878,
    888878,
    787999,
    997689,
    898977,
    779879,
    897877,
    668888,
    978798,
    887787,
    876678,
    897888,
    887789,
    778968,
    989797,
    876787,
    998797,
    888877,
    889777,
    997868,
    698778,
    888868,
    898979,
    788899,
    999789,
    999777,
    989788,
    878879,
    876888,
    897877,
    869887,
    888986,
    789887,
    978988,
    689898,
    777777,
    789887,
    867889,
    797888,
    867787,
    888987,
    899787,
    878779,
    878777,
    877998,
    899989,
    788887,
    779887,
    777868,
    987777,
    787777,
    778768,
    868778,
    788777,
    898888,
    798987,
    788778,
    768898,
    967869,
    888888,
    787878,
    977977,
    689887,
    987698,
    977787,
    788987,
    978899,
    878767,
    988898,
    878798,
    788778,
    998888,
    868679,
    789889,
    786899,
    888777,
    979978,
    987877,
    887778,
    879787,
    887687,
    777976,
    878887,
    887987,
    898768,
    897778,
    978887,
    787898,
    688778,
    879889,
    897986,
    798889,
    878868,
    688676,
    787989,
    779899,
    877889,
    777997,
    877878,
    978879,
    897989,
    868878,
    978877,
    878688,
    888877,
    787886,
    968788,
    887789,
    789888,
    699988,
    877889,
    777686,
    988777,
    788777,
    877879,
    986898,
    788879,
    796888,
    788889,
    776998,
    889868,
    887978,
    889898,
    789887,
    898799,
    996898,
    898797,
    988886,
    698977,
    787778,
    878897,
    787788,
    877777,
    898988,
    987879,
    798988,
    778897,
    988688,
    798886,
    888877,
    877977,
    887798,
    878788,
    788889,
    877788,
    778787,
    769789,
    778997,
    897877,
    898888,
    776877,
    789899,
    778786,
    889887,
    898797,
    886898,
    966978,
    767878,
    978887,
    788988,
    788979,
    697796,
    988897,
    788798,
    888898,
    797779,
    887886,
    798877,
    889877,
    987887,
    887889,
    998788,
    888989,
    898888,
    978887,
    998678,
    897887,
    888898,
    777777,
    777788,
    978878,
    997897,
    789979,
    887787,
    698889,
    878978,
    888788,
    889988,
    978878,
    978978,
    786887,
    876798,
    898786,
    877976,
    987888,
    899797,
    788877,
    779878,
    977788,
    778878,
    989878,
    889976,
    787797,
    887777,
    897777,
    777688,
    878998,
    788778,
    878877,
    787787,
    668878,
    866888,
    877989,
    898887,
    798898,
    688887,
    789798,
    889786,
    697768,
    686897,
    879987,
    688789,
    787878,
    879788,
    899878,
    997898,
    687987,
    787677,
    877776,
    998777,
    889876,
    878887,
    898788,
    887868,
    899786,
    889888,
    878987,
    888778,
    998877,
    897989,
    788888,
    887887,
    886877,
    968987,
    778888,
    669868,
    688788,
    787899,
    778788,
    998888,
    979968,
    877779,
    767889,
    988998,
    777989,
    968688,
    789977,
    989978,
    888798,
    967868,
    867878,
    797996,
    889897,
    777887,
    698886,
    788999,
    867778,
    779978,
    866878,
    887889,
    976888,
    876897,
    888997,
    798988,
    878878,
    888888,
    797889,
    889788,
    777778,
    878787,
    999687,
    788887,
    788898,
    787778,
    677998,
    799688,
    777988,
    988887,
    778886,
    878878,
    988779,
    777977,
    998778,
    877968,
    987879,
    787997,
    888786,
    798877,
    897787,
    977897,
    896897,
    778789,
    789778,
    879877,
    887798,
    877886,
    989687,
    877887,
    888888,
    688888,
    888998,
    987888,
    898967,
    887976,
    978887,
    798888,
    977688,
    878889,
    889689,
    797797,
    867887,
    899778,
    899978,
    886889,
    787887,
    878866,
    879676,
    689887,
    886889,
    789978,
    888867,
    879878,
    887888,
    987787,
    897778,
    978689,
    788987,
    877776,
    787899,
    888979,
    887788,
    989788,
    888999,
    888977,
    987978,
    698988,
    887878,
    977767,
    888798,
    779888,
    978788,
    889778,
    878999,
    767878,
    879977,
    999879,
    976788,
    677987,
    888887,
    797897,
    777688,
    988877,
    788898,
    888899,
    878699,
    688877,
    767777,
    897887,
    778896,
    978888,
    787987,
    898878,
    698888,
    988997,
    886887,
    777997,
    877887,
    877888,
    789887,
    897877,
    877796,
    789779,
    678978,
    788876,
    797978,
    687878,
    879877,
    887777,
    677867,
    789978,
    978998,
    787788,
    988986,
    887877,
    779796,
    887968,
    788879,
    988778,
    898878,
    779778,
    987988,
    897888,
    997769,
    789777,
    789887,
    889898,
    877788,
    997978,
    869787,
    898887,
    787898,
    889878,
    786988,
    878888,
    898888,
    797788,
    789876,
    878787,
    786788,
    989888,
    777896,
    888898,
    687879,
    789788,
    888799,
    976687,
    868787,
    968876,
    767898,
    868877,
    887876,
    887998,
    868997,
    887888,
    779778,
    878788,
    788788,
    778889,
    789779,
    879779,
    878879,
    988687,
    787878,
    898788,
    988667,
    888688,
    986888,
    787689,
    889778,
    977787,
    798988,
    878799,
    797878,
    868988,
    767777,
    798887,
    887687,
    887778,
    878768,
    776986,
    688778,
    687878,
    789788,
    896796,
    787888,
    788877,
    886789,
    897876,
    888977,
    798686,
    988667,
    877768,
    988688,
    697787,
    888777,
    896698,
    798898,
    889689,
    888689,
    898786,
    777787,
    968887,
    878899,
    798888,
    769788,
    877766,
    887888,
    768889,
    778779,
    888877,
    789998,
    797688,
    888987,
    788887,
    788798,
    696978,
    886989,
    788778,
    988777,
    997789,
    768878,
    987788,
    778888,
    778789,
    789988,
    878889,
    787979,
    897878,
    888798,
    698987,
    877998,
    788898,
    887777,
    778879,
    887878,
    878897,
    888988,
    889888,
    698878,
    689787,
    787767,
    877878,
    968786,
    878888,
    877897,
    888886,
    787677,
    887798,
    878687,
    987777,
    898688,
    778779,
    799688,
    787779,
    799689,
    887879,
    688988,
    687768,
    978789,
    889778,
    888788,
    899789,
    798797,
    877987,
    886887,
    678979,
    978768,
    787886,
    988978,
    769787,
    878778,
    898897,
    979978,
    788899,
    899996,
    888888,
    798977,
    997878,
    988789,
    788898,
    789987,
    879687,
    796888,
    797788,
    888887,
    788988,
    877978,
    877887,
    789888,
    789799,
    988778,
    977888,
    778786,
    878788,
    888787,
    768897,
    886877,
    777778,
    978877,
    679766,
    687998,
    887888,
    987769,
    877889,
    878689,
    779888,
    788798,
    888889,
    897768,
    988978,
    899799,
    887887,
    989867,
    998877,
    799678,
    797989,
    989786,
    887888,
    897886,
    988778,
    779778,
    787798,
    986788,
    768988,
    678776,
    889887,
    978786,
    687867,
    998687,
    687868,
    677978,
    879879,
    867879,
    898776,
    887889,
    987786,
    877889,
    888779,
    778786,
    968989,
    879888,
    777999,
    867967,
    898787,
    887788,
    876897,
    698979,
    968898,
    987778,
    989887,
    778887,
    988889,
    878987,
    778988,
    877777,
    898888,
    869889,
    888987,
    878976,
    777688,
    677799,
    988877,
    978978,
    797868,
    998797,
    887788,
    968878,
    778877,
    988799,
    889887,
    688877,
    688887,
    967777,
    968979,
    878888,
    889977,
    887898,
    988788,
    977888,
    989778,
    887977,
    787887,
    978879,
    687897,
    786766,
    889788,
    997787,
    887888,
    787788,
    887796,
    879778,
    977988,
    777688,
    677989,
    799778,
    787988,
    699677,
    777789,
    877889,
    867898,
    989778,
    789987,
    888778,
    888887,
    779867,
    978878,
    888988,
    799887,
    988878,
    889787,
    988799,
    898779,
    779878,
    998799,
    777887,
    889888,
    787999,
    887787,
    788786,
    687887,
    989897,
    897777,
    788877,
    798786,
    888977,
    888877,
    977798,
    877778,
    887888,
    878997,
    778688,
    888888,
    988989,
    797888,
    877898,
    989878,
    778878,
    988888,
    788987,
    898876,
    888776,
    786787,
    987887,
    898888,
    797886,
    889789,
    878988,
    797679,
    776987,
    898988,
    876977,
    789778,
    968888,
    788797,
    986978,
    778889,
    887778,
    887797,
    777789,
    877986,
    778877,
    877797,
    877787,
    898779,
    788688,
    787778,
    778788,
    877978,
    778978,
    788777,
    769877,
    877898,
    977889,
    789889,
    888899,
    788789,
    998889,
    688879,
    688777,
    969779,
    987768,
    879987,
    989889,
    688777,
    867679,
    877688,
    888897,
    788889,
    788777,
    899877,
    798886,
    788878,
    779897,
    897979,
    888977,
    768977,
    888787,
    798987,
    788697,
    779799,
    877879,
    688769,
    986878,
    878877,
    777989,
    899788,
    888878,
    897977,
    888876,
    888889,
    998877,
    886898,
    877879,
    877888,
    878667,
    877888,
    879897,
    986787,
    877889,
    879978,
    869887,
    789977,
    778978,
    798897,
    988889,
    778987,
    888999,
    998779,
    889788,
    977787,
    897788,
    988897,
    768887,
    787867,
    786878,
    877778,
    877977,
    887789,
    778878,
    787779,
    777989,
    779877,
    878788,
    688877,
    886978,
    987787,
    787978,
    898788,
    787889,
    889887,
    998888,
    878878,
    879778,
    889886,
    769778,
    767888,
    978979,
    988788,
    879788,
    787788,
    879797,
    878888,
    889878,
    977787,
    798868,
    777776,
    777898,
    679787,
    987687,
    968878,
    798989,
    797887,
    788877,
    887777,
    798768,
    879989,
    988887,
    778677,
    878887,
    898677,
    998769,
    879778,
    878988,
    787677,
    779789,
    878889,
    977887,
    786889,
    878777,
    977888,
    889887,
    878797,
    697888,
    798878,
    777778,
    798788,
    987888,
    888777,
    788799,
    768898,
    778887,
    968977,
    878768,
    878868,
    978777,
    788788,
    787799,
    978967,
    987789,
    778988,
    897778,
    988987,
    897899,
    986889,
    997888,
    988798,
    888789,
    898988,
    788687,
    788898,
    979688,
    879787,
    877887,
    987788,
    876787,
    788698,
    888887,
    788877,
    788888,
    887799,
    797898,
    988888,
    778978,
    879797,
    969998,
    777687,
    778997,
    868887,
    798797,
    989797,
    977977,
    896878,
    987779,
    796798,
    889778,
    778889,
    887788,
    988799,
    789878,
    899667,
    797898,
    879778,
    898998,
    788777,
    888966,
    877788,
    978988,
    888698,
    899788,
    879779,
    888787,
    868786,
    877879,
    878788,
    877879,
    777879,
    887787,
    787977,
    978787,
    688778,
    789887,
    889878,
    669779,
    777987,
    788987,
    976889,
    898788,
    969998,
    888788,
    887888,
    889788,
    889778,
    997777,
    897688,
    776979,
    887878,
    888878,
    788987,
    788788,
    787797,
    889878,
    889787,
    789977,
    679789,
    777789,
    688966,
    697987,
    787887,
    878677,
    879977,
    669898,
    768998,
    788888,
    989777,
    987788,
    776899,
    778878,
    878878,
    787988,
    767877,
    678878,
    889989,
    878788,
    978877,
    996896,
    997788,
    889987,
    888988,
    798788,
    788867,
    779968,
    897868,
    877999,
    787996,
    787989,
    879777,
    868778,
    787789,
    788888,
    867787,
    698766,
    878768,
    897988,
    799997,
    998868,
    977877,
    788799,
    769888,
    977788,
    867768,
    979798,
    786898,
    778687,
    789668,
    898889,
    898998,
    789888,
    898878,
    776787,
    888778,
    787889,
    878799,
    778889,
    779887,
    897888,
    988779,
    767787,
    889978,
    878798,
    877998,
    788788,
    997797,
    788887,
    889976,
    968889,
    787788,
    776768,
    778788,
    898888,
    887887,
    979887,
    799988,
    889897,
    878888,
    988867,
    887988,
    878998,
    878777,
    888898,
    787787,
    888797,
    897988,
    969877,
    878879,
    878889,
    798879,
    887788,
    788989,
    878898,
    778997,
    677878,
    978877,
    997787,
    898678,
    788888,
    888888,
    899788,
    887987,
    989797,
    777888,
    867887,
    788697,
    788888,
    789778,
    798797,
    879768,
    787789,
    878688,
    878787,
    889889,
    878788,
    888978,
    769979,
    899989,
    699787,
    787999,
    887977,
    779887,
    977879,
    787967,
    887788,
    988788,
    978877,
    788777,
    889899,
    887978,
    988887,
    779788,
    899868,
    878897,
    868878,
    788798,
    778878,
    978889,
    878779,
    787867,
    786788,
    898778,
    877788,
    888897,
    767788,
    887988,
    879978,
    888888,
    787987,
    788978,
    767899,
    778898,
    977887,
    979797,
    768789,
    988877,
    788978,
    987886,
    988876,
    788978,
    787687,
    877878,
    887789,
    889776,
    878787,
    797888,
    988898,
    889997,
    888988,
    767888,
    778886,
    877877,
    988796,
    887888,
    988697,
    978898,
    887977,
    787778,
    787768,
    987788,
    989878,
    788777,
    898978,
    898877,
    879788,
    869789,
    997888,
    896987,
    779787,
    798788,
    979788,
    998978,
    698969,
    889988,
    879898,
    767988,
    799877,
    878798,
    768898,
    897988,
    788687,
    888787,
    797788,
    778989,
    978878,
    879788,
    876788,
    676789,
    787899,
    877788,
    788987,
    898687,
    877888,
    788886,
    788888,
    777787,
    988868,
    997987,
    878878,
    778799,
    898788,
    798979,
    876679,
    977898,
    888798,
    897889,
    788779,
    878778,
    888879,
    888887,
    879778,
    877798,
    688768,
    979888,
    889779,
    879968,
    887778,
    797988,
    699688,
    788779,
    897699,
    787778,
    977878,
    887788,
    977898,
    798877,
    977796,
    776768,
    977779,
    868888,
    689998,
    787878,
    878877,
    787798,
    788877,
    878988,
    787777,
    888779,
    987997,
    878797,
    768689,
    998789,
    997788,
    877777,
    987998,
    889787,
    877778,
    888796,
    988898,
    776769,
    977888,
    987788,
    788968,
    799788,
    998887,
    877786,
    878997,
    786879,
    788976,
    898799,
    788887,
    888977,
    789989,
    877878,
    988978,
    898778,
    988878,
    897888,
    786888,
    786988,
    889777,
    967687,
    777989,
    878797,
    899778,
    868977,
    789787,
    997788,
    997889,
    788887,
    798988,
    987778,
    888798,
    879788,
    888986,
    888877,
    778798,
    888877,
    878867,
    978887,
    977978,
    888889,
    987889,
    778779,
    978977,
    988997,
    968987,
    998986,
    788787,
    888998,
    889868,
    986778,
    897977,
    787988,
    888778,
    778787,
    977979,
    798888,
    878987,
    778878,
    887888,
    878978,
    998979,
    898788,
    887997,
    797878,
    777787,
    879878,
    988877,
    787778,
    899788,
    968878,
    998879,
    679668,
    797798,
    987778,
    779878,
    777678,
    978867,
    778777,
    778878,
    689787,
    788878,
    878898,
    787688,
    888867,
    768888,
    797779,
    878878,
    878898,
    888887,
    977878,
    896777,
    888797,
    988777,
    878998,
    888998,
    898879,
    788887,
    878887,
    888889,
    799988,
    798888,
    887677,
    879878,
    888997,
    768878,
    878787,
    779877,
    889877,
    897977,
    879888,
    898888,
    877787,
    988977,
    868788,
    898778,
    788888,
    789888,
    978997,
    877886,
    786898,
    987786,
    988877,
    989979,
    887897,
    877779,
    888777,
    788879,
    688887,
    988897,
    778789,
    878879,
    887778,
    998778,
    787767,
    688869,
    777886,
    898788,
    898879,
    867877,
    779988,
    888769,
    888887,
    898889,
    797888,
    899879,
    788899,
    878787,
    888788,
    889878,
    887889,
    768897,
    876798,
    777797,
    888898,
    888889,
    769877,
    698789,
    997887,
    787789,
    877877,
    888899,
    688878,
    787888,
    878979,
    789888,
    897888,
    887887,
    977798,
    897879,
    889898,
    677898,
    889677,
    889866,
    798787,
    798977,
    988787,
    798787,
    887887,
    888888,
    697878,
    878798,
    888787,
    967887,
    898988,
    987678,
    877889,
    979887,
    889869,
    878768,
    878868,
    787878,
    787879,
    787887,
    887788,
    898888,
    989899,
    886878,
    898977,
    777789,
    998878,
    888888,
    788799,
    899876,
    997889,
    989888,
    989988,
    879976,
    688778,
    877788,
    879977,
    778977,
    888889,
    887688,
    897687,
    898888,
    879877,
    788787,
    778888,
    778777,
    788898,
    978979,
    798878,
    898879,
    888898,
    789788,
    878967,
    978769,
    787888,
    887888,
    899696,
    887888,
    887777,
    888888,
    878878,
    779977,
    879787,
    798877,
    788877,
    888968,
    677988,
    897888,
    978687,
    878787,
    888988,
    768887,
    888887,
    978689,
    797878,
    887789,
    888789,
    879676,
    677688,
    787789,
    788777,
    876688,
    789879,
    887768,
    777889,
    788878,
    789877,
    788778,
    897888,
    898779,
    899877,
    899898,
    978769,
    788777,
    988979,
    886797,
    888978,
    779889,
    878778,
    898777,
    788777,
    867879,
    888888,
    687979,
    689978,
    888888,
    887879,
    678788,
    778778,
    878879,
    898769,
    987788,
    888988,
    978979,
    897877,
    988788,
    769977,
    889988,
    888779,
    887969,
    998789,
    999988,
    877799,
    787878,
    986888,
    997878,
    889899,
    898889,
    989779,
    988887,
    877977,
    888989,
    778687,
    888878,
    697798,
    788788,
    788878,
    787998,
    888898,
    677998,
    988988,
    678999,
    778778,
    767988,
    677988,
    888899,
    777887,
    898988,
    789899,
    978698,
    779786,
    989788,
    877888,
    887889,
    897699,
    879988,
    877988,
    997768,
    777998,
    877988,
    978977,
    887788,
    778978,
    786777,
    787987,
    877888,
    889788,
    697987,
    897878,
    977797,
    897778,
    997788,
    998987,
    778887,
    798767,
    878989,
    877887,
    777798,
    988977,
    887879,
    888997,
    887886,
    988869,
    876886,
    798888,
    787978,
    688787,
    878887,
    787778,
    777787,
    897786,
    677699,
    796766,
    897789,
    867978,
    967798,
    888877,
    897788,
    888978,
    887788,
    879898,
    887778,
    898878,
    887779,
    887777,
    797878,
    889869,
    899888,
    889887,
    788797,
    776987,
    897887,
    878979,
    989887,
    767797,
    786788,
    899877,
    779688,
    888889,
    879888,
    878887,
    787689,
    898877,
    898888,
    777879,
    888898,
    987878,
    778776,
    768766,
    788789,
    888778,
    879977,
    799786,
    877876,
    789778,
    768888,
    798889,
    668788,
    978888,
    879898,
    887787,
    888989,
    886886,
    998797,
    998779,
    788886,
    787888,
    899878,
    896679,
    676787,
    996787,
    879778,
    878778,
    667978,
    778788,
    888888,
    789899,
    778787,
    977698,
    879887,
    897897,
    788866,
    888998,
    788898,
    777769,
    887899,
    968787,
    898888,
    788778,
    886999,
    797668,
    878878,
    799898,
    799887,
    877989,
    878697,
    778786,
    888998,
    888777,
    777987,
    898769,
    878878,
    878768,
    779996,
    989988,
    699778,
    887878,
    879797,
    778767,
    799889,
    787777,
    799778,
    797787,
    888888,
    888877,
    786978,
    798798,
    888888,
    778796,
    969969,
    688788,
    799987,
    979977,
    898878,
    998987,
    787877,
    888997,
    787988,
    798987,
    878987,
    867887,
    768888,
    888779,
    788779,
    977888,
    898998,
    878888,
    688887,
    896978,
    789897,
    987979,
    789879,
    786878,
    788889,
    887997,
    887888,
    878978,
    688787,
    788788,
    888887,
    887878,
    888887,
    678689,
    869888,
    778779,
    766788,
    899778,
    798878,
    986888,
    878668,
    889888,
    877787,
    877888,
    878888,
    868898,
    997898,
    977878,
    697887,
    889999,
    878798,
    796799,
    778888,
    887799,
    687787,
    778889,
    678978,
    878687,
    888776,
    988978,
    778898,
    889778,
    878889,
    787878,
    769779,
    867789,
    799878,
    987887,
    977996,
    989888,
    689788,
    888787,
    788788,
    978889,
    977877,
    779868,
    878988,
    888986,
    897988,
    789886,
    778867,
    889987,
    898898,
    798877,
    888789,
    886687,
    978879,
    779889,
    788879,
    878888,
    979788,
    877977,
    987988,
    697878,
    789777,
    999787,
    978678,
    888789,
    779788,
    697878,
    987878,
    897988,
    789988,
    778898,
    879777,
    866987,
    888998,
    879878,
    888788,
    798869,
    888789,
    668976,
    998887,
    899779,
    877967,
    798898,
    889899,
    987898,
    788987,
    889799,
    897797,
    797999,
    787688,
    877989,
    868776,
    778789,
    886879,
    976899,
    979689,
    767886,
    778889,
    899887,
    888878,
    878888,
    987886,
    888987,
    788786,
    868987,
    979898,
    766887,
    777787,
    879696,
    668779,
    888898,
    777988,
    798878,
    997877,
    767868,
    888799,
    987888,
    778898,
    878888,
    778778,
    897878,
    889998,
    778977,
    897868,
    998977,
    997787,
    989976,
    867888,
    799879,
    769988,
    967888,
    898889,
    999869,
    877766,
    787888,
    878978,
    877778,
    777776,
    878977,
    878867,
    779897,
    778766,
    996888,
    797887,
    879898,
    878878,
    888796,
    867788,
    688888,
    979778,
    678796,
    987788,
    786778,
    887988,
    788778,
    976887,
    878896,
    896787,
    877876,
    768898,
    978767,
    887777,
    977877,
    998778,
    788897,
    796788,
    689997,
    777877,
    787888,
    798786,
    879886,
    889888,
    988786,
    788896,
    797789,
    996988,
    788987,
    978988,
    778867,
    887789,
    878889,
    877978,
    996969,
    878879,
    798889,
    887788,
    888977,
    799888,
    787886,
    677688,
    779788,
    977869,
    778867,
    887878,
    768689,
    898877,
    887888,
    977897,
    687987,
    877878,
    689877,
    776897,
    886887,
    788898,
    786879,
    797787,
    767867,
    878888,
    897889,
    879688,
    876898,
    789977,
    887998,
    677877,
    887998,
    888998,
    788877,
    988887,
    989888,
    978898,
    798897,
    788777,
    899797,
    687778,
    889889,
    977789,
    776888,
    697788,
    986787,
    889787,
    878879,
    798887,
    898778,
    779698,
    878988,
    898878,
    998887,
    777887,
    688778,
    897789,
    997799,
    988788,
    887868,
    889798,
    687877,
    989778,
    888898,
    978677,
    779788,
    688979,
    868998,
    778989,
    888989,
    878987,
    887786,
    899897,
    987798,
    897897,
    888887,
    899887,
    789777,
    898789,
    888778,
    787998,
    889776,
    699987,
    987798,
    887779,
    777769,
    697879,
    898776,
    878997,
    877796,
    869987,
    987798,
    897896,
    777699,
    878878,
    768987,
    869886,
    878778,
    888877,
    777778,
    887869,
    877787,
    878988,
    788999,
    776779,
    898898,
    778677,
    777878,
    887887,
    788876,
    876786,
    888877,
    797777,
    988876,
    987788,
    788898,
    887777,
    776798,
    987899,
    998888,
    868987,
    779787,
    789768,
    988786,
    897877,
    997868,
    798977,
    879888,
    798777,
    677877,
    787787,
    787977,
    779788,
    797887,
    989679,
    788998,
    887897,
    787879,
    887786,
    888798,
    889777,
    877988,
    887878,
    788887,
    877987,
    787868,
    887767,
    687998,
    776979,
    786888,
    888888,
    877878,
    887879,
    787878,
    988687,
    879779,
    886887,
    777877,
    689988,
    778888,
    888877,
    877879,
    887788,
    889879,
    878887,
    677788,
    887689,
    777887,
    889878,
    878878,
    788778,
    766678,
    687977,
    877778,
    868788,
    887978,
    788989,
    776797,
    786987,
    988787,
    977866,
    788889,
    788787,
    788678,
    769978,
    698797,
    987868,
    988888,
    987776,
    797888,
    897878,
    777868,
    998889,
    789898,
    897978,
    798769,
    778779,
    898779,
    776979,
    889889,
    979688,
    978789,
    788876,
    777878,
    888887,
    678777,
    778987,
    687788,
    669898,
    798888,
    888997,
    878889,
    778798,
    778777,
    877888,
    898788,
    876887,
    678869,
    778977,
    988879,
    978889,
    998887,
    877889,
    798877,
    877787,
    898798,
    787898,
    788778,
    867989,
    988677,
    688788,
    689989,
    978787,
    998668,
    798778,
    898788,
    977788,
    887788,
    788777,
    988787,
    767768,
    778788,
    687988,
    888777,
    887788,
    888868,
    868777,
    777767,
    799979,
    888877,
    887977,
    888969,
    887877,
    889888,
    778887,
    779798,
    787889,
    878887,
    989788,
    878977,
    788867,
    989798,
    779878,
    877898,
    887779,
    866888,
    678898,
    796799,
    766878,
    886878,
    988887,
    887887,
    798889,
    987887,
    896876,
    889787,
    899988,
    778767,
    778898,
    878897,
    977977,
    789878,
    887779,
    898787,
    877898,
    978889,
    796877,
    878987,
    888886,
    887798,
    988979,
    888778,
    889797,
    767998,
    877888,
    978887,
    798888,
    797878,
    789887,
    987868,
    787878,
    777778,
    878779,
    978898,
    797889,
    688898,
    977878,
    887697,
    788888,
    788689,
    788886,
    876799,
    888877,
    777778,
    998897,
    679998,
    789889,
    889777,
    888877,
    989877,
    686777,
    787688,
    888799,
    978988,
    789788,
    687777,
    989778,
    778687,
    898688,
    778798,
    977788,
    797897,
    779798,
    788789,
    869878,
    796777,
    888797,
    968678,
    878897,
    798778,
    788979,
    878877,
    888887,
    769966,
    876888,
    888897,
    797779,
    898897,
    788888,
    788898,
    787897,
    789898,
    887877,
    788987,
    887898,
    788688,
    888889,
    996987,
    998897,
    788677,
    888868,
    897768,
    778878,
    898898,
    899798,
    788788,
    878778,
    778877,
    968887,
    887778,
    888878,
    787788,
    778788,
    788979,
    868787,
    878777,
    888878,
    987787,
    787878,
    867887,
    889876,
    797789,
    788878,
    978797,
    788878,
    787887,
    789877,
    998888,
    998877,
    788869,
    899988,
    777779,
    888898,
    987879,
    889787,
    799898,
    678786,
    777988,
    677999,
    778778,
    798888,
    788797,
    978988,
    888899,
    876877,
    989778,
    887789,
    878966,
    889877,
    877779,
    887779,
    878788,
    789989,
    797889,
    879778,
    978887,
    889878,
    988887,
    887879,
    788798,
    888877,
    787797,
    787868,
    798868,
    867878,
    779788,
    867779,
    988887,
    787879,
    998987,
    887879,
    767889,
    979977,
    898677,
    898779,
    876678,
    879778,
    889798,
    866888,
    797878,
    888788,
    989776,
    886789,
    776979,
    887687,
    688787,
    767868,
    878668,
    888798,
    988968,
    898879,
    688878,
    687798,
    778788,
    878789,
    889889,
    988977,
    878868,
    897787,
    777887,
    888798,
    877989,
    978787,
    788796,
    787799,
    789989,
    767888,
    788778,
    887878,
    869969,
    899797,
    878797,
    988778,
    997788,
    878788,
    879769,
    877888,
    888979,
    888779,
    798898,
    989799,
    898988,
    787778,
    887989,
    988978,
    997879,
    897778,
    798989,
    678999,
    697697,
    989978,
    767987,
    777889,
    977888,
    878888,
    877899,
    777888,
    997899,
    887778,
    899898,
    987767,
    989779,
    688877,
    898798,
    968879,
    887898,
    799778,
    798789,
    898887,
    887779,
    878887,
    878688,
    797787,
    687878,
    888677,
    789668,
    978788,
    677678,
    888898,
    678887,
    879788,
    988888,
    987878,
    889798,
    879987,
    878879,
    888897,
    777888,
    887777,
    889887,
    778698,
    987997,
    788697,
    877988,
    889788,
    797778,
    798898,
    799798,
    788788,
    779798,
    878977,
    789777,
    778876,
    798898,
    989877,
    878988,
    889777,
    788987,
    887989,
    987878,
    877987,
    798897,
    887689,
    889978,
    988778,
    789987,
    698878,
    699888,
    988877,
    897887,
    777778,
    677789,
    978789,
    878988,
    769789,
    779897,
    888786,
    797779,
    896988,
    887888,
    988788,
    697787,
    987888,
    767877,
    887787,
    977877,
    978898,
    889866,
    888689,
    897898,
    978798,
    787888,
    776978,
    887987,
    889998,
    689787,
    778768,
    787778,
    788778,
    968776,
    887688,
    879888,
    977768,
    889978,
    678878,
    977879,
    878797,
    777898,
    877876,
    889988,
    879778,
    897889,
    787888,
    888898,
    787889,
    798868,
    769797,
    888776,
    898778,
    888788,
    786797,
    788876,
    878786,
    787787,
    888897,
    887878,
    877789,
    779797,
    887777,
    987798,
    878798,
    687696,
    899987,
    977888,
    677778,
    887798,
    788787,
    887888,
    877889,
    898887,
    887878,
    888668,
    877896,
    799888,
    989787,
    768787,
    889797,
    797788,
    988687,
    988998,
    788898,
    998778,
    787898,
    678787,
    877979,
    789678,
    877997,
    986979,
    897788,
    888877,
    978899,
    889897,
    888976,
    787896,
    898888,
    778988,
    987887,
    698897,
    998887,
    878878,
    877889,
    989996,
    787788,
    988768,
    878889,
    978878,
    878778,
    888798,
    788688,
    798777,
    898787,
    897797,
    877877,
    788798,
    677888,
    899888,
    898878,
    789887,
    888986,
    776889,
    988887,
    987788,
    678778,
    868787,
    888778,
    788887,
    967798,
    877797,
    868878,
    999788,
    987899,
    998888,
    766868,
    788777,
    789878,
    698979,
    998879,
    788977,
    989878,
    977878,
    888777,
    789879,
    799897,
    887878,
    977987,
    877898,
    877696,
    688887,
    777787,
    888997,
    996788,
    788998,
    797878,
    879878,
    778797,
    998969,
    767888,
    889987,
    887787,
    878898,
    898879,
    878799,
    879779,
    878787,
    977788,
    988767,
    988677,
    989787,
    768897,
    978878,
    876978,
    879879,
    898877,
    878799,
    678789,
    877687,
    979786,
    987978,
    788777,
    787878,
    777797,
    788888,
    888779,
    988878,
    888888,
    787778,
    799977,
    678999,
    979787,
    867778,
    988787,
    877789,
    788788,
    778899,
    778789,
    886988,
    867887,
    878778,
    888897,
    789878,
    797888,
    798897,
    787878,
    889879,
    779898,
    786988,
    988979,
    878777,
    788698,
    868887,
    788877,
    778889,
    978988,
    878896,
    778888,
    787768,
    778778,
    889887,
    897978,
    777766,
    877797,
    987987,
    987877,
    787778,
    988786,
    778788,
    896889,
    899888,
    778887,
    788778,
    778979,
    789877,
    887698,
    888887,
    788887,
    979888,
    687778,
    788778,
    677879,
    777778,
    999877,
    988788,
    898789,
    868866,
    979776,
    888879,
    887886,
    977668,
    787799,
    887789,
    887877,
    678688,
    788966,
    986876,
    788788,
    977788,
    799898,
    797878,
    889889,
    786776,
    878787,
    788797,
    788877,
    888687,
    669798,
    988988,
    887787,
    888887,
    789978,
    878878,
    988887,
    898899,
    878977,
    699877,
    798979,
    878988,
    788776,
    988888,
    788868,
    879877,
    986888,
    797876,
    678979,
    777986,
    778688,
    798986,
    778878,
    678877,
    698787,
    988779,
    779878,
    789777,
    777979,
    688878,
    968968,
    799877,
    998889,
    797798,
    867897,
    877976,
    788867,
    987977,
    777778,
    987977,
    797887,
    788787,
    976978,
    898887,
    788788,
    787778,
    778898,
    878987,
    788779,
    998878,
    887787,
    777877,
    789866,
    988677,
    889999,
    877888,
    787888,
    879988,
    898888,
    878777,
    678888,
    888787,
    787697,
    898788,
    798689,
    668798,
    787898,
    977867,
    888687,
    797899,
    988898,
    886888,
    898889,
    899889,
    788779,
    798777,
    787796,
    878997,
    987877,
    898899,
    898978,
    879787,
    999787,
    978789,
    998778,
    768869,
    789889,
    877876,
    888687,
    787899,
    879889,
    788778,
    896799,
    788778,
    977778,
    878997,
    797787,
    897787,
    887977,
    786897,
    888888,
    887789,
    678697,
    688799,
    977797,
    879797,
    898787,
    878796,
    798878,
    988777,
    878897,
    888789,
    777888,
    777878,
    877876,
    998689,
    788886,
    998888,
    789878,
    777868,
    868979,
    899898,
    779879,
    987879,
    887779,
    868977,
    988799,
    878989,
    887888,
    687779,
    798977,
    788867,
    878777,
    889797,
    678897,
    987778,
    788877,
    888987,
    787988,
    978898,
    798769,
    979678,
    679877,
    798787,
    888989,
    877787,
    788898,
    786788,
    998787,
    897788,
    777978,
    688888,
    687887,
    787988,
    988977,
    986898,
    988669,
    789998,
    967799,
    787867,
    787877,
    887778,
    877887,
    787897,
    787688,
    878988,
    889788,
    889997,
    696878,
    688778,
    789697,
    978787,
    898778,
    978777,
    878888,
    887776,
    897788,
    868867,
    887878,
    978986,
    779766,
    878977,
    878868,
    899689,
    988877,
    968979,
    778777,
    988687,
    888887,
    788998,
    877777,
    886788,
    886898,
    767877,
    778888,
    889776,
    898888,
    887899,
    978898,
    867889,
    988887,
    888779,
    899988,
    887787,
    867967,
    686887,
    788998,
    787799,
    997778,
    788978,
    887787,
    787777,
    798688,
    788789,
    678897,
    789979,
    979877,
    788878,
    877887,
    968777,
    678888,
    779987,
    787978,
    689878,
    788679,
    877678,
    787798,
    799787,
    888787,
    987779,
    899789,
    789887,
    788887,
    887778,
    899778,
    897977,
    788888,
    887887,
    979767,
    888898,
    788876,
    979787,
    987987,
    887978,
    797888,
    677889,
    897897,
    899999,
    969798,
    878788,
    979788,
    879797,
    987988,
    978987,
    888798,
    789877,
    788978,
    787979,
    988698,
    788797,
    777877,
    797878,
    897888,
    977887,
    779879,
    768988,
    898779,
    889698,
    889878,
    888788,
    888898,
    887899,
    776888,
    897988,
    987779,
    897979,
    879787,
    888876,
    888676,
    877978,
    779699,
    788787,
    966788,
    899877,
    778789,
    878867,
    877879,
    768898,
    787888,
    787788,
    886889,
    778977,
    878978,
    788687,
    899777,
    788888,
    898788,
    897769,
    889779,
    777787,
    789779,
    877878,
    769767,
    779978,
    778788,
    788877,
    978677,
    998887,
    778878,
    888787,
    997687,
    967889,
    887798,
    669987,
    786678,
    878777,
    888887,
    877968,
    877987,
    898897,
    798798,
    989697,
    798866,
    788879,
    989879,
    879887,
    888778,
    777796,
    899889,
    798978,
    878988,
    888878,
    887987,
    898876,
    787878,
    788878,
    887777,
    787877,
    887887,
    798899,
    978887,
    979898,
    887888,
    997886,
    779787,
    788788,
    778987,
    878999,
    888787,
    688878,
    888777,
    868989,
    978887,
    988787,
    896978,
    797769,
    896887,
    787778,
    778988,
    987867,
    888788,
    987876,
    986988,
    888888,
    787998,
    888899,
    977788,
    786987,
    878879,
    787898,
    676776,
    887988,
    788786,
    988786,
    778989,
    768888,
    767699,
    988978,
    789877,
    799688,
    778877,
    668798,
    898888,
    998798,
    877788,
    687788,
    777797,
    677787,
    688778,
    779677,
    896879,
    778779,
    889878,
    678888,
    877888,
    788777,
    876868,
    889889,
    978879,
    888889,
    978788,
    896788,
    889888,
    879998,
    788988,
    868878,
    897868,
    898678,
    977899,
    788788,
    788887,
    777799,
    788799,
    878888,
    787987,
    887887,
    889878,
    778777,
    787877,
    787888,
    979878,
    888898,
    888798,
    888787,
    988687,
    877788,
    797998,
    789787,
    767787,
    788777,
    787877,
    888777,
    987896,
    988888,
    867788,
    789787,
    788888,
    866889,
    678789,
    979867,
    778977,
    878777,
    776897,
    788898,
    699788,
    898879,
    798799,
    798878,
    898787,
    888989,
    787789,
    778797,
    887678,
    889877,
    878988,
    788787,
    768999,
    878799,
    888796,
    887777,
    878967,
    887888,
    986978,
    976779,
    888969,
    989787,
    898798,
    887897,
    878678,
    889787,
    979988,
    798786,
    788878,
    778897,
    898788,
    878998,
    889897,
    777999,
    777778,
    889978,
    888777,
    887799,
    978997,
    699888,
    887897,
    887987,
    978899,
    968888,
    778787,
    967877,
    887787,
    997886,
    796987,
    778888,
    989897,
    678988,
    878899,
    789787,
    988989,
    887777,
    789886,
    988898,
    998787,
    787976,
    888778,
    877768,
    879687,
    988699,
    779888,
    779698,
    978888,
    986778,
    887878,
    788978,
    988888,
    879877,
    787987,
    889778,
    889868,
    897979,
    787969,
    797799,
    898798,
    879889,
    788888,
    778898,
    788987,
    998968,
    689798,
    878798,
    897968,
    888779,
    888879,
    897878,
    797997,
    778778,
    687889,
    789978,
    778777,
    868868,
    879868,
    978978,
    689999,
    878879,
    998898,
    978878,
    869878,
    977868,
    879876,
    888787,
    779878,
    887877,
    898878,
    799697,
    786888,
    879998,
    877776,
    877977,
    889898,
    779887,
    998789,
    698799,
    877778,
    978878,
    979887,
    778877,
    788788,
    887799,
    786798,
    888788,
    777778,
    796788,
    768786,
    888799,
    888887,
    787789,
    868879,
    988788,
    788877,
    788798,
    798977,
    876788,
    896988,
    987899,
    978678,
    968977,
    767889,
    788789,
    888776,
    887887,
    989998,
    888898,
    999798,
    788878,
    879788,
    788888,
    689978,
    888887,
    797897,
    888878,
    789887,
    877877,
    869877,
    887788,
    878878,
    668787,
    787889,
    687878,
    799889,
    787677,
    888979,
    889778,
    889788,
    688887,
    798888,
    797998,
    879998,
    899897,
    778989,
    768899,
    788878,
    887888,
    988886,
    688788,
    869888,
    788867,
    677799,
    886866,
    977898,
    967877,
    777896,
    778888,
    889976,
    889888,
    766787,
    887779,
    869799,
    778876,
    988989,
    897899,
    976866,
    787888,
    978778,
    877779,
    777878,
    888777,
    797778,
    878977,
    888787,
    897879,
    678687,
    987887,
    878998,
    887778,
    887899,
    997888,
    868878,
    777878,
    888988,
    887667,
    889998,
    689988,
    887978,
    877977,
    676779,
    898887,
    988878,
    777889,
    897788,
    788879,
    687877,
    868878,
    989979,
    888888,
    788886,
    789887,
    878698,
    787667,
    769888,
    779678,
    789887,
    898977,
    798988,
    879988,
    787976,
    976877,
    887778,
    977887,
    788989,
    786786,
    877889,
    888787,
    789879,
    998988,
    967678,
    777776,
    888888,
    799987,
    787897,
    787897,
    898677,
    968977,
    977767,
    966779,
    787897,
    869878,
    886879,
    999877,
    979888,
    877799,
    977967,
    877879,
    886798,
    889789,
    697886,
    697798,
    767978,
    677878,
    898787,
    788868,
    888999,
    888977,
    889978,
    998897,
    777788,
    879999,
    888978,
    898777,
    978776,
    977889,
    887997,
    977787,
    677877,
    798798,
    787797,
    988987,
    878977,
    898798,
    898868,
    878876,
    987788,
    899889,
    897787,
    888877,
    887788,
    799787,
    787787,
    888868,
    886877,
    887778,
    788888,
    786778,
    887988,
    779798,
    788878,
    889888,
    998886,
    887878,
    878779,
    779768,
    876986,
    897888,
    988769,
    799878,
    878688,
    987688,
    988798,
    898878,
    887887,
    889789,
    778778,
    887978,
    887889,
    988788,
    898798,
    679778,
    788768,
    688977,
    867687,
    679789,
    979978,
    988888,
    877887,
    886887,
    877789,
    877788,
    887886,
    787899,
    779797,
    888889,
    787977,
    887998,
    787888,
    976788,
    788776,
    869868,
    798898,
    887688,
    886978,
    786879,
    888778,
    798778,
    797787,
    879878,
    987787,
    888788,
    778886,
    878976,
    988878,
    798788,
    877887,
    796988,
    876788,
    777898,
    677888,
    768676,
    888789,
    779899,
    779878,
    888687,
    878976,
    786897,
    687778,
    998889,
    999878,
    877978,
    777877,
    888878,
    969777,
    696868,
    887877,
    988786,
    799797,
    779898,
    787787,
    778878,
    878977,
    878879,
    897786,
    989778,
    779677,
    798877,
    888987,
    989876,
    888796,
    979988,
    778888,
    977887,
    788789,
    787879,
    687796,
    898778,
    876888,
    798999,
    887787,
    987787,
    988999,
    687988,
    798789,
    788977,
    999788,
    987989,
    888877,
    787778,
    778889,
    787777,
    786887,
    788969,
    887999,
    786886,
    899778,
    978868,
    869778,
    879788,
    888898,
    898897,
    778788,
    779977,
    786888,
    987988,
    878989,
    878877,
    889787,
    777878,
    677799,
    878876,
    778988,
    987889,
    889879,
    797877,
    987888,
    997878,
    788797,
    977799,
    977877,
    778778,
    898998,
    888789,
    878897,
    989798,
    878878,
    897977,
    989988,
    889887,
    777978,
    787789,
    876897,
    786898,
    888889,
    988878,
    896788,
    789879,
    798979,
    789698,
    779797,
    769778,
    687778,
    797778,
    778797,
    888887,
    788777,
    797898,
    767879,
    768898,
    977987,
    888897,
    788798,
    897778,
    768888,
    989897,
    797778,
    997696,
    879787,
    899869,
    878996,
    789887,
    787799,
    787889,
    778877,
    776978,
    887888,
    786866,
    899879,
    877877,
    688779,
    787688,
    697978,
    887897,
    778699,
    779778,
    889899,
    778899,
    887976,
    878878,
    678767,
    789987,
    999787,
    989889,
    898986,
    687998,
    798889,
    797778,
    777978,
    886798,
    897987,
    887977,
    777988,
    997879,
    789877,
    878687,
    888878,
    877869,
    788776,
    678978,
    789987,
    988768,
    768899,
    779788,
    989978,
    988779,
    889878,
    997978,
    897778,
    898887,
    987798,
    978888,
    778899,
    998879,
    876778,
    888887,
    987767,
    888877,
    677698,
    788887,
    879897,
    878688,
    787878,
    788879,
    887888,
    898887,
    789978,
    977977,
    878978,
    877876,
    878898,
    997788,
    888689,
    877988,
    888878,
    898797,
    987898,
    976888,
    899887,
    887777,
    888687,
    787878,
    797888,
    887788,
    788668,
    888878,
    997998,
    877877,
    877777,
    779788,
    978879,
    778767,
    888989,
    897968,
    767978,
    789879,
    979868,
    988697,
    987788,
    687978,
    897787,
    788687,
    878876,
    976889,
    878887,
    898798,
    878867,
    678787,
    989886,
    898887,
    788688,
    788998,
    777787,
    787789,
    888878,
    897878,
    877988,
    967888,
    788799,
    888769,
    888788,
    688788,
    877887,
    778878,
    998879,
    877898,
    779789,
    799997,
    778898,
    897988,
    778899,
    776688,
    778887,
    898888,
    787777,
    788888,
    988788,
    887779,
    887687,
    889878,
    878777,
    777768,
    787767,
    798688,
    987778,
    798797,
    888877,
    879789,
    989889,
    877889,
    687868,
    687878,
    788777,
    868888,
    897899,
    877887,
    888879,
    798888,
    777977,
    798787,
    879778,
    876779,
    777689,
    778788,
    878798,
    979798,
    888889,
    877999,
    777687,
    796878,
    779977,
    887797,
    788988,
    788878,
    878988,
    878798,
    788996,
    888989,
    797887,
    888778,
    787787,
    978878,
    778867,
    888898,
    878889,
    797779,
    676997,
    788879,
    988878,
    769889,
    898769,
    878977,
    888986,
    787868,
    977787,
    888978,
    997777,
    787896,
    779878,
    789878,
    866778,
    987778,
    788887,
    798878,
    878989,
    887999,
    798979,
    897778,
    787868,
    778879,
    896977,
    778988,
    897886,
    978888,
    789989,
    768899,
    877789,
    879788,
    888879,
    979896,
    897888,
    888778,
    887678,
    677887,
    987998,
    678886,
    777887,
    988797,
    996666,
    877987,
    778888,
    867879,
    888897,
    898776,
    789867,
    877768,
    788779,
    978788,
    888889,
    878788,
    789987,
    787888,
    798777,
    879877,
    799977,
    968777,
    899767,
    979789,
    878889,
    666888,
    788977,
    987879,
    877979,
    779777,
    897779,
    877777,
    888987,
    777767,
    888888,
    879687,
    788987,
    887866,
    798977,
    968788,
    777779,
    898987,
    988799,
    879888,
    797767,
    798899,
    898877,
    888678,
    988989,
    888888,
    978787,
    788978,
    797788,
    798788,
    997789,
    987797,
    869798,
    879789,
    888977,
    778897,
    878787,
    986778,
    998769,
    788888,
    697787,
    888877,
    789887,
    778869,
    998899,
    998797,
    798889,
    897688,
    789888,
    878878,
    888978,
    898798,
    788699,
    777887,
    777887,
    778977,
    878877,
    879877,
    798878,
    676767,
    989887,
    987877,
    787997,
    677797,
    987677,
    898778,
    788877,
    867877,
    898898,
    887888,
    988786,
    779888,
    776778,
    697688,
    787879,
    788876,
    887877,
    788887,
    887877,
    878788,
    898879,
    798878,
    788787,
    867898,
    788987,
    888898,
    899787,
    878798,
    799777,
    677798,
    879887,
    998898,
    989878,
    887787,
    697978,
    788688,
    787887,
    876888,
    786877,
    878778,
    988888,
    898679,
    787987,
    768868,
    777877,
    788796,
    887788,
    777886,
    788969,
    889977,
    879887,
    886889,
    889897,
    778889,
    989988,
    778877,
    779987,
    888877,
    997887,
    878869,
    877987,
    977876,
    788898,
    878878,
    988787,
    779877,
    696778,
    697889,
    898779,
    988978,
    988779,
    888797,
    897788,
    999998,
    897998,
    678867,
    878866,
    897987,
    988698,
    899978,
    879669,
    778997,
    787977,
    989899,
    898676,
    989776,
    788988,
    797687,
    879788,
    897877,
    888888,
    899787,
    899778,
    878877,
    998887,
    888778,
    678997,
    779678,
    788978,
    879867,
    888778,
    887887,
    886788,
    678889,
    777878,
    877777,
    898879,
    988968,
    788988,
    887889,
    967887,
    768867,
    688789,
    877879,
    897878,
    988788,
    787889,
    998979,
    887777,
    767889,
    988878,
    888978,
    978777,
    768787,
    778898,
    878798,
    988898,
    797987,
    896788,
    678678,
    898877,
    888878,
    798997,
    899897,
    868788,
    869778,
    968688,
    988878,
    967789,
    889887,
    889777,
    787897,
    988878,
    787777,
    898778,
    897877,
    677987,
    778878,
    899878,
    769997,
    897778,
    977898,
    889997,
    897887,
    796787,
    778878,
    887789,
    778898,
    888989,
    877897,
    987877,
    878879,
    788797,
    777687,
    979787,
    777779,
    879798,
    787896,
    878877,
    989988,
    988887,
    898878,
    886777,
    966689,
    777888,
    879777,
    878888,
    997788,
    898877,
    888678,
    789897,
    877877,
    887778,
    689978,
    897988,
    779676,
    987788,
    998898,
    878987,
    868979,
    788889,
    778787,
    986888,
    998787,
    777788,
    988898,
    797789,
    878888,
    787788,
    989789,
    889987,
    898886,
    797888,
    768778,
    898886,
    889698,
    979768,
    989888,
    776886,
    788678,
    997798,
    788799,
    887777,
    788878,
    788976,
    887797,
    878888,
    877987,
    767886,
    988889,
    888799,
    667878,
    878777,
    888767,
    788887,
    877988,
    889897,
    889787,
    888888,
    778797,
    778878,
    797767,
    768678,
    977899,
    687877,
    777978,
    888888,
    879779,
    979878,
    788868,
    888788,
    898977,
    878699,
    899777,
    877869,
    677977,
    998788,
    778886,
    877889,
    896878,
    888788,
    977778,
    767867,
    977677,
    869778,
    797969,
    889788,
    888778,
    786777,
    867878,
    878887,
    786778,
    988988,
    798788,
    898887,
    687898,
    899889,
    967878,
    888887,
    669769,
    779687,
    787879,
    778887,
    798797,
    978888,
    888878,
    888878,
    967788,
    888898,
    678888,
    697888,
    778777,
    787887,
    877978,
    877788,
    777988,
    789677,
    888986,
    989797,
    777888,
    787689,
    789779,
    778798,
    879788,
    868778,
    898888,
    889898,
    897788,
    787898,
    787889,
    988879,
    888988,
    898897,
    877886,
    997876,
    988896,
    899776,
    678888,
    896779,
    877978,
    997777,
    999787,
    876688,
    877878,
    778678,
    977788,
    888797,
    779778,
    686776,
    887987,
    878889,
    879877,
    898778,
    877896,
    898896,
    988788,
    967897,
    788879,
    787989,
    778888,
    988677,
    897878,
    798987,
    997787,
    877797,
    978778,
    787977,
    977877,
    788898,
    787887,
    877787,
    879788,
    789879,
    998768,
    878899,
    987897,
    977878,
    788987,
    989788,
    897879,
    888877,
    777888,
    986887,
    887788,
    898896,
    998778,
    777997,
    786687,
    877787,
    788779,
    787889,
    887987,
    988767,
    988986,
    988777,
    677877,
    798989,
    797978,
    988878,
    888878,
    878787,
    787887,
    968987,
    777778,
    879787,
    988789,
    977889,
    698887,
    799878,
    777888,
    777777,
    977878,
    878989,
    888878,
    869888,
    867688,
    798988,
    888878,
    989787,
    878788,
    896867,
    798898,
    777788,
    787788,
    876877,
    988968,
    887998,
    979988,
    887889,
    866878,
    788889,
    996868,
    889678,
    787797,
    879778,
    887998,
    977888,
    997878,
    777899,
    987977,
    877987,
    777978,
    897978,
    888777,
    887868,
    887877,
    877997,
    776977,
    789989,
    977888,
    888876,
    896787,
    878779,
    868899,
    897898,
    879888,
    879876,
    687698,
    878799,
    887997,
    897889,
    898799,
    989898,
    787988,
    786788,
    788787,
    977879,
    867986,
    878869,
    887678,
    788998,
    996878,
    978899,
    878777,
    799687,
    778877,
    878898,
    767878,
    877878,
    779689,
    788788,
    879887,
    788787,
    987776,
    898987,
    788777,
    897887,
    879977,
    986989,
    876876,
    888799,
    997868,
    888878,
    877978,
    777787,
    887887,
    978888,
    987768,
    786888,
    889877,
    898879,
    988978,
    997887,
    788887,
    798777,
    988689,
    787989,
    878776,
    988868,
    789668,
    878787,
    687879,
    986788,
    978788,
    988887,
    777688,
    788887,
    887789,
    888898,
    798778,
    789899,
    776888,
    798699,
    978988,
    879978,
    988797,
    777889,
    979879,
    989888,
    787889,
    788888,
    788988,
    777897,
    889969,
    777888,
    967889,
    788978,
    878898,
    888877,
    877878,
    787889,
    989876,
    877888,
    778989,
    977889,
    867887,
    788889,
    889898,
    877879,
    788988,
    777898,
    798897,
    896797,
    778677,
    788888,
    997887,
    868997,
    966879,
    889687,
    767888,
    878979,
    877878,
    779867,
    878796,
    697898,
    898877,
    778877,
    768978,
    778877,
    788897,
    877897,
    798988,
    888999,
    779787,
    679778,
    877878,
    679798,
    798877,
    786888,
    889977,
    979988,
    797789,
    889788,
    689898,
    888868,
    787778,
    897699,
    787888,
    798877,
    776778,
    788788,
    889989,
    789778,
    887989,
    786979,
    989888,
    889978,
    878898,
    887976,
    878997,
    898878,
    877778,
    779998,
    898778,
    798898,
    666898,
    778976,
    899898,
    878778,
    878888,
    778787,
    998977,
    888888,
    876778,
    878788,
    798788,
    888987,
    887688,
    787877,
    777879,
    898788,
    888798,
    979698,
    799786,
    879988,
    988799,
    978996,
    898889,
    777787,
    868897,
    778978,
    788897,
    788689,
    778798,
    689797,
    888788,
    897998,
    888869,
    786888,
    787877,
    777798,
    869788,
    897778,
    988887,
    868789,
    889978,
    767797,
    888869,
    768979,
    986977,
    898787,
    788978,
    689999,
    779878,
    879798,
    979798,
    869889,
    888776,
    788779,
    899897,
    888977,
    878988,
    887978,
    789878,
    868788,
    787868,
    988768,
    868887,
    998699,
    788777,
    867778,
    678868,
    897678,
    877879,
    998979,
    877778,
    989989,
    888796,
    888797,
    888768,
    797798,
    878787,
    887889,
    868886,
    699888,
    889897,
    897777,
    976988,
    798989,
    877796,
    997977,
    888678,
    876776,
    897878,
    888787,
    977687,
    888878,
    889769,
    877768,
    996877,
    887888,
    898886,
    766878,
    888987,
    868897,
    889788,
    887868,
    787788,
    778888,
    998688,
    888897,
    977878,
    777876,
    888878,
    687898,
    999867,
    878889,
    989776,
    778687,
    878977,
    878888,
    897979,
    987898,
    787787,
    876877,
    788789,
    888897,
    767789,
    698898,
    977978,
    886778,
    699898,
    988898,
    787687,
    888777,
    867789,
    797999,
    898897,
    789797,
    878989,
    786887,
    889887,
    987788,
    987888,
    789887,
    877888,
    897888,
    769867,
    788889,
    697877,
    897778,
    877697,
    678766,
    888878,
    799778,
    898778,
    899879,
    976888,
    979797,
    777978,
    976778,
    889788,
    887968,
    996878,
    988879,
    787788,
    888777,
    988999,
    687898,
    889877,
    788989,
    788889,
    897886,
    997888,
    898888,
    886789,
    979899,
    778988,
    987678,
    987778,
    977878,
    888778,
    797688,
    878889,
    889889,
    689778,
    788987,
    897887,
    878897,
    788879,
    878898,
    877878,
    867998,
    977988,
    887998,
    878879,
    797776,
    998777,
    778888,
    778997,
    799779,
    697979,
    788698,
    777787,
    887888,
    678799,
    889779,
    888778,
    798878,
    778987,
    799897,
    799879,
    889798,
    888798,
    877898,
    788878,
    987887,
    778879,
    677779,
    798787,
    878887,
    667878,
    778979,
    697888,
    877988,
    788887,
    877877,
    977878,
    676878,
    789788,
    878879,
    798778,
    889797,
    798777,
    988787,
    877787,
    888867,
    987968,
    888878,
    787788,
    788777,
    778998,
    788879,
    998987,
    788797,
    878687,
    978696,
    787799,
    889878,
    768868,
    878698,
    797977,
    688889,
    779998,
    798788,
    677889,
    878778,
    887988,
    897999,
    997996,
    789789,
    788877,
    888897,
    889877,
    878888,
    787887,
    799889,
    788787,
    777887,
    799969,
    867887,
    988868,
    897798,
    877868,
    879878,
    877778,
    878889,
    978887,
    898768,
    878898,
    768877,
    678888,
    667789,
    888968,
    878876,
    888999,
    988687,
    778888,
    988988,
    878878,
    979989,
    878879,
    989779,
    968786,
    788898,
    888687,
    899888,
    878788,
    888897,
    899878,
    678868,
    979889,
    888887,
    778896,
    877866,
    879888,
    778866,
    787868,
    789786,
    787788,
    899888,
    897888,
    797789,
    797888,
    878788,
    888789,
    776878,
    886887,
    879777,
    876877,
    978878,
    879677,
    789997,
    778888,
    988879,
    976776,
    876679,
    888877,
    779787,
    779877,
    689777,
    777887,
    897978,
    798986,
    898888,
    879798,
    768787,
    878978,
    888889,
    898887,
    887778,
    887768,
    779777,
    778887,
    788789,
    998787,
    867877,
    877989,
    999778,
    889886,
    888897,
    877877,
    878787,
    788988,
    788878,
    968898,
    987879,
    779868,
    897778,
    797976,
    898889,
    988988,
    869789,
    798988,
    786878,
    889788,
    888987,
    697776,
    998797,
    988887,
    867678,
    689898,
    879988,
    879977,
    989899,
    987887,
    896679,
    889888,
    786777,
    678888,
    877876,
    897987,
    777887,
    986879,
    789987,
    798787,
    779789,
    789978,
    799877,
    778778,
    798977,
    888798,
    786888,
    787778,
    799668,
    888889,
    778898,
    777988,
    898888,
    889988,
    988878,
    987889,
    999998,
    778788,
    888778,
    688789,
    887887,
    879897,
    977987,
    999887,
    989778,
    887668,
    879878,
    789789,
    877878,
    898978,
    887788,
    977887,
    799778,
    878889,
    867976,
    788888,
    987877,
    897887,
    778777,
    888897,
    889876,
    798878,
    687787,
    876678,
    887787,
    888769,
    887777,
    988888,
    889768,
    977777,
    896777,
    988976,
    789987,
    867997,
    778788,
    977887,
    889787,
    777776,
    889897,
    888779,
    887779,
    688777,
    789789,
    798879,
    867787,
    988878,
    788788,
    988878,
    999797,
    778887,
    878888,
    878988,
    778688,
    877889,
    779788,
    879677,
    787799,
    988777,
    887877,
    997886,
    889987,
    888878,
    778889,
    888779,
    878987,
    978797,
    787778,
    887886,
    777888,
    977676,
    899778,
    988978,
    889888,
    987968,
    977878,
    799887,
    797799,
    888778,
    688888,
    799878,
    888787,
    887777,
    779877,
    977888,
    977887,
    876878,
    779788,
    779899,
    898878,
    888988,
    888898,
    888877,
    887699,
    889679,
    888887,
    889778,
    788889,
    887878,
    799788,
    888887,
    798797,
    797769,
    987879,
    888896,
    878689,
    787878,
    897897,
    987877,
    988799,
    997888,
    889777,
    689698,
    797889,
    977677,
    889778,
    869767,
    878887,
    896886,
    879978,
    889988,
    789787,
    777987,
    777798,
    789788,
    798678,
    888887,
    877889,
    967677,
    888878,
    978898,
    769788,
    889789,
    798888,
    689898,
    888887,
    877698,
    899788,
    979887,
    878887,
    777887,
    988678,
    886789,
    886767,
    987798,
    798788,
    868878,
    798668,
    698879,
    898989,
    689787,
    788787,
    898877,
    897988,
    967777,
    777788,
    889989,
    798977,
    767979,
    787699,
    888998,
    798789,
    879888,
    888778,
    978788,
    776888,
    879777,
    798978,
    977777,
    779677,
    789787,
    767788,
    788878,
    987967,
    798677,
    788897,
    879778,
    777879,
    777888,
    998877,
    888977,
    987778,
    877877,
    888879,
    779889,
    978979,
    996986,
    886777,
    889798,
    787989,
    988878,
    878878,
    798668,
    988899,
    888879,
    877878,
    897887,
    878886,
    797887,
    897788,
    877877,
    899898,
    787988,
    989968,
    978799,
    787787,
    978788,
    988879,
    888988,
    778977,
    889896,
    787679,
    898798,
    988687,
    876788,
    887988,
    687998,
    988798,
    776787,
    878877,
    787788,
    899797,
    787877,
    878787,
    987897,
    778798,
    987977,
    998788,
    778888,
    988897,
    887879,
    779898,
    797788,
    986777,
    867988,
    669798,
    898797,
    799688,
    988688,
    778787,
    978877,
    878799,
    777787,
    877778,
    878697,
    877867,
    788778,
    678788,
    887887,
    787996,
    877897,
    889979,
    987889,
    788787,
    897797,
    678789,
    887998,
    786997,
    697898,
    788687,
    987896,
    778898,
    779878,
    879788,
    778988,
    879766,
    879798,
    878877,
    778778,
    886889,
    869887,
    787778,
    887786,
    679788,
    999989,
    878779,
    887789,
    887879,
    988989,
    988797,
    968798,
    978767,
    777999,
    676887,
    788888,
    679798,
    888897,
    878888,
    867878,
    897897,
    778898,
    978788,
    788788,
    787778,
    997678,
    699778,
    888789,
    887878,
    886696,
    898668,
    888887,
    876798,
    889899,
    887888,
    888788,
    678789,
    888898,
    877788,
    877777,
    888887,
    889989,
    877777,
    878877,
    778888,
    898778,
    878977,
    697789,
    978788,
    778878,
    898877,
    797777,
    788897,
    988789,
    687897,
    977896,
    988696,
    788876,
    898678,
    978888,
    978889,
    788888,
    778899,
    998898,
    778779,
    989987,
    788878,
    888888,
    777787,
    888877,
    898697,
    899879,
    869797,
    787887,
    888777,
    688867,
    798888,
    786897,
    698977,
    977888,
    697787,
    879788,
    787897,
    877878,
    788778,
    778888,
    879789,
    997889,
    869777,
    978778,
    888897,
    678776,
    889876,
    978788,
    787977,
    879888,
    888887,
    889977,
    868679,
    898877,
    887988,
    889768,
    887777,
    889888,
    798877,
    889788,
    898878,
    777967,
    978788,
    787878,
    787999,
    777876,
    879899,
    876967,
    888898,
    797676,
    977877,
    798877,
    797898,
    789787,
    798868,
    988888,
    897888,
    877878,
    789878,
    887877,
    877878,
    787877,
    768789,
    797887,
    997977,
    879888,
    797869,
    997887,
    967877,
    896766,
    898988,
    789788,
    878988,
    798989,
    798877,
    898787,
    879787,
    898788,
    777878,
    689778,
    876778,
    888979,
    777778,
    978899,
    798998,
    897887,
    866867,
    987998,
    988879,
    878878,
    998866,
    876878,
    798787,
    987778,
    899798,
    768887,
    798888,
    776778,
    989977,
    867778,
    788788,
    977686,
    978889,
    988788,
    896888,
    687887,
    887877,
    888769,
    989976,
    787897,
    888899,
    786789,
    688777,
    879779,
    869788,
    879779,
    897868,
    678978,
    778888,
    887786,
    978877,
    978997,
    897788,
    979897,
    998688,
    778788,
    897789,
    977887,
    899888,
    799878,
    777898,
    869879,
    899887,
    787988,
    699778,
    688897,
    788868,
    988888,
    787988,
    889888,
    878888,
    787979,
    879768,
    778896,
    888987,
    988886,
    878888,
    997868,
    877987,
    977787,
    687778,
    788876,
    999788,
    688789,
    887877,
    767887,
    769879,
    877688,
    788879,
    797878,
    677787,
    878987,
    996888,
    868797,
    889677,
    878977,
    889886,
    888887,
    886887,
    698778,
    788898,
    788777,
    887687,
    888898,
    977977,
    977869,
    798878,
    797889,
    867888,
    978897,
    787778,
    787776,
    879889,
    787877,
    976777,
    997989,
    889988,
    976779,
    878887,
    888988,
    778978,
    877798,
    697798,
    879796,
    786878,
    878877,
    899878,
    787887,
    788778,
    878788,
    778778,
    868897,
    688887,
    888878,
    897699,
    898887,
    986779,
    786977,
    887877,
    777979,
    889877,
    788777,
    889888,
    988879,
    899897,
    888878,
    889888,
    879788,
    796987,
    788799,
    879776,
    978897,
    878889,
    779778,
    788987,
    878887,
    988886,
    997698,
    877788,
    787887,
    776878,
    678889,
    788987,
    887888,
    886977,
    799998,
    789889,
    899777,
    779897,
    886968,
    787768,
    997788,
    877886,
    777969,
    889889,
    789778,
    987898,
    888789,
    898878,
    878788,
    766897,
    876787,
    999787,
    878878,
    987877,
    786786,
    787888,
    887888,
    789879,
    887866,
    888778,
    798798,
    777876,
    787778,
    778689,
    676888,
    867978,
    778688,
    896778,
    967679,
    878777,
    867897,
    787799,
    679878,
    877877,
    987888,
    888987,
    998869,
    788878,
    788897,
    868697,
    978899,
    878898,
    896897,
    788868,
    878879,
    886887,
    978779,
    778979,
    987778,
    986887,
    887877,
    897887,
    887878,
    978888,
    999997,
    797888,
    878876,
    789878,
    878799,
    888778,
    868778,
    779887,
    887789,
    799787,
    877787,
    889877,
    879798,
    776899,
    779888,
    788779,
    967988,
    786788,
    888788,
    898887,
    988779,
    787888,
    979888,
    786797,
    878878,
    897678,
    887798,
    979787,
    888887,
    886876,
    887787,
    988677,
    877897,
    988889,
    767888,
    878797,
    988989,
    987888,
    968996,
    688987,
    789878,
    788799,
    888789,
    799968,
    778697,
    867788,
    888789,
    777899,
    886899,
    898779,
    876887,
    687887,
    987877,
    877688,
    978789,
    778987,
    898789,
    878877,
    887977,
    978979,
    988898,
    898688,
    998878,
    798887,
    777788,
    787888,
    778868,
    887887,
    788878,
    769769,
    879777,
    798788,
    998898,
    898877,
    776889,
    888988,
    889998,
    878896,
    787878,
    798887,
    888878,
    988887,
    978899,
    787887,
    877898,
    796888,
    988788,
    889888,
    797798,
    897897,
    877878,
    889896,
    889878,
    998788,
    796888,
    879798,
    699978,
    896888,
    678889,
    998977,
    978886,
    778788,
    989789,
    888967,
    897778,
    788777,
    779878,
    887686,
    888867,
    979888,
    789889,
    999687,
    898987,
    988869,
    978797,
    898897,
    888887,
    887897,
    886989,
    877889,
    878978,
    987789,
    777679,
    777997,
    879989,
    978988,
    997898,
    888888,
    887867,
    877879,
    876978,
    888898,
    988778,
    889787,
    778878,
    787678,
    998878,
    688788,
    879878,
    987797,
    798877,
    968787,
    888898,
    969878,
    998878,
    889879,
    887998,
    888878,
    877988,
    987786,
    769888,
    978687,
    878767,
    888787,
    888787,
    878986,
    787988,
    787988,
    877888,
    786787,
    788778,
    888998,
    999898,
    889798,
    987989,
    787779,
    689787,
    977678,
    998989,
    789778,
    798878,
    778986,
    789987,
    778879,
    799996,
    789777,
    899778,
    878788,
    778789,
    978986,
    867989,
    778778,
    888888,
    879698,
    998888,
    868889,
    767878,
    888968,
    697887,
    867688,
    778788,
    887988,
    889778,
    768877,
    779877,
    886787,
    778977,
    797987,
    788977,
    889997,
    788778,
    897777,
    777789,
    877787,
    876878,
    789878,
    878788,
    878898,
    877778,
    776789,
    789789,
    788889,
    788799,
    879799,
    889797,
    876888,
    786789,
    778887,
    976887,
    888877,
    788877,
    798798,
    787877,
    789678,
    887988,
    887897,
    766879,
    688776,
    778777,
    888678,
    887778,
    877788,
    679898,
    877668,
    889868,
    879788,
    788879,
    787889,
    777767,
    979888,
    978886,
    798788,
    888698,
    777779,
    888787,
    877788,
    699877,
    978876,
    887878,
    887787,
    687798,
    689699,
    888767,
    998877,
    877878,
    788887,
    987879,
    888678,
    677898,
    987798,
    789878,
    886988,
    787788,
    797887,
    876878,
    997687,
    978998,
    788876,
    777778,
    988897,
    787877,
    878887,
    778887,
    888887,
    896898,
    877777,
    868798,
    878898,
    798899,
    798889,
    969788,
    898888,
    988977,
    777987,
    778887,
    868898,
    799888,
    886877,
    969888,
    898789,
    688878,
    787886,
    786788,
    879898,
    787878,
    779786,
    879778,
    987877,
    877887,
    877988,
    888897,
    867769,
    887887,
    988988,
    889988,
    877999,
    768989,
    887788,
    777869,
    868998,
    876898,
    887877,
    777877,
    888778,
    787877,
    878798,
    797888,
    878888,
    798877,
    789998,
    887887,
    887977,
    779888,
    999778,
    987898,
    877779,
    788777,
    887768,
    789868,
    777887,
    988896,
    897887,
    797988,
    898889,
    797799,
    888778,
    997989,
    888677,
    787788,
    776888,
    798798,
    788867,
    888788,
    679897,
    988779,
    977878,
    767689,
    778787,
    868787,
    789787,
    788699,
    697687,
    778969,
    888888,
    877978,
    778887,
    689988,
    898789,
    778867,
    777879,
    998868,
    877887,
    789888,
    888887,
    987887,
    789898,
    778888,
    788778,
    888889,
    977778,
    778777,
    997988,
    897779,
    888789,
    899876,
    998887,
    788687,
    898777,
    878878,
    969899,
    879997,
    878869,
    789777,
    868878,
    888889,
    897668,
    888897,
    777997,
    878687,
    778999,
    798976,
    788788,
    779877,
    798879,
    978888,
    877879,
    988988,
    769797,
    986886,
    877888,
    786696,
    966997,
    678887,
    878788,
    868778,
    987988,
    787887,
    887888,
    787678,
    889878,
    986878,
    877788,
    778886,
    899788,
    787787,
    967796,
    879897,
    868789,
    688996,
    778979,
    796786,
    789897,
    887988,
    688878,
    977877,
    798878,
    887789,
    788877,
    788789,
    888868,
    977899,
    788898,
    779898,
    899888,
    768888,
    977778,
    798896,
    898878,
    777688,
    987786,
    978867,
    789778,
    787998,
    787867,
    786799,
    878888,
    878868,
    788988,
    797877,
    687987,
    788897,
    779869,
    787879,
    888899,
    988886,
    886898,
    899868,
    896768,
    867678,
    878889,
    889879,
    877778,
    788687,
    778787,
    889786,
    897778,
    887979,
    888976,
    988897,
    886898,
    877679,
    978888,
    778888,
    779987,
    677788,
    987887,
    886878,
    888897,
    978899,
    789787,
    897787,
    887888,
    988788,
    797999,
    888768,
    899787,
    898787,
    798679,
    988788,
    787988,
    787798,
    797699,
    868877,
    677799,
    978878,
    888777,
    997988,
    887888,
    898776,
    788889,
    888866,
    997979,
    887879,
    797868,
    687877,
    987988,
    989777,
    687687,
    789989,
    987897,
    797769,
    788897,
    787777,
    988897,
    787978,
    797979,
    877767,
    798788,
    887789,
    977777,
    779986,
    787788,
    778979,
    888789,
    777778,
    878888,
    689787,
    697888,
    888768,
    779898,
    877788,
    787877,
    987869,
    777876,
    797897,
    776977,
    887878,
    989876,
    776998,
    777686,
    988777,
    787897,
    998896,
    868779,
    689777,
    798887,
    997998,
    889879,
    788887,
    787877,
    778879,
    779887,
    987677,
    797878,
    878888,
    888887,
    988987,
    798879,
    878979,
    897787,
    887869,
    689797,
    989878,
    796888,
    787788,
    788879,
    897877,
    888787,
    886978,
    878898,
    888789,
    987878,
    989777,
    798887,
    878988,
    778887,
    777977,
    977888,
    879967,
    877779,
    887888,
    978889,
    877787,
    699987,
    768798,
    896799,
    689877,
    888878,
    887888,
    797999,
    687988,
    779788,
    768887,
    877888,
    798988,
    999788,
    788698,
    989869,
    796777,
    888678,
    888697,
    898788,
    888979,
    788888,
    899967,
    789987,
    888899,
    877988,
    888777,
    766776,
    998888,
    788999,
    688676,
    777677,
    967998,
    877886,
    878887,
    676788,
    876988,
    687789,
    977786,
    897679,
    867678,
    898978,
    887887,
    788889,
    778987,
    889878,
    666789,
    788986,
    887999,
    898876,
    889778,
    989787,
    877978,
    899689,
    887789,
    897888,
    788969,
    767787,
    889899,
    678887,
    888987,
    676888,
    899798,
    877797,
    777988,
    989688,
    987867,
    778898,
    788976,
    968688,
    797778,
    888789,
    669789,
    787677,
    799878,
    787798,
    978786,
    897877,
    878886,
    788877,
    787669,
    788787,
    797798,
    789976,
    886789,
    888879,
    698876,
    887979,
    888888,
    797789,
    888987,
    778877,
    788787,
    778968,
    778767,
    788779,
    787889,
    677888,
    867987,
    877779,
    898867,
    878887,
    779789,
    778987,
    777797,
    799798,
    889888,
    787978,
    778777,
    789877,
    787788,
    788689,
    989879,
    788699,
    888887,
    788788,
    797979,
    796978,
    787897,
    888879,
    678987,
    668779,
    898778,
    888777,
    978879,
    898889,
    888978,
    877867,
    799988,
    788898,
    898886,
    977877,
    876988,
    889988,
    987877,
    798878,
    778888,
    777898,
    778987,
    688979,
    788788,
    987789,
    978886,
    978886,
    968688,
    889897,
    898878,
    889788,
    788869,
    968768,
    687978,
    787977,
    967978,
    979887,
    878966,
    878778,
    778977,
    998788,
    778977,
    979679,
    889987,
    887888,
    998888,
    769876,
    788779,
    788979,
    769776,
    987688,
    797689,
    888778,
    888878,
    977998,
    787897,
    789986,
    897666,
    889887,
    878878,
    897787,
    677867,
    877776,
    886778,
    888787,
    767886,
    998877,
    777899,
    777987,
    787699,
    888898,
    778978,
    979888,
    898888,
    788888,
    988767,
    877888,
    879786,
    788778,
    986877,
    878776,
    788887,
    798877,
    787779,
    677878,
    787788,
    898679,
    887777,
    787877,
    897678,
    888797,
    789887,
    697699,
    787898,
    988688,
    887878,
    989789,
    886786,
    978779,
    889787,
    769778,
    787887,
    987787,
    989877,
    798789,
    887878,
    898888,
    888999,
    787768,
    889887,
    877977,
    877968,
    989878,
    879988,
    889999,
    878787,
    886689,
    788899,
    986767,
    798887,
    788886,
    778898,
    788786,
    867887,
    988889,
    688887,
    889776,
    878897,
    779687,
    887879,
    678789,
    788777,
    787969,
    987787,
    789888,
    777977,
    787678,
    667778,
    788878,
    887888,
    889977,
    988786,
    678898,
    887787,
    996978,
    897887,
    887898,
    767867,
    678988,
    887987,
    876798,
    867788,
    788877,
    789898,
    788777,
    869876,
    986788,
    779888,
    988778,
    878997,
    877788,
    886886,
    876886,
    968877,
    977798,
    888887,
    897777,
    897787,
    878688,
    779888,
    898898,
    887768,
    979788,
    876888,
    977888,
    777987,
    888986,
    876789,
    878778,
    977888,
    798886,
    889788,
    888898,
    987799,
    789899,
    797878,
    788898,
    878878,
    886998,
    897986,
    887877,
    987788,
    789889,
    997876,
    876868,
    879879,
    878878,
    677999,
    788878,
    777978,
    986788,
    886876,
    787788,
    989888,
    778989,
    789877,
    999897,
    869878,
    878887,
    867978,
    888888,
    889889,
    997798,
    798878,
    898778,
    887869,
    797798,
    778898,
    988886,
    877889,
    878878,
    978878,
    868796,
    889899,
    788878,
    789987,
    988787,
    877998,
    797788,
    787878,
    989787,
    897889,
    788677,
    698778,
    877979,
    676889,
    766878,
    997897,
    789886,
    988788,
    978888,
    798987,
    988989,
    968788,
    888879,
    879898,
    887787,
    878768,
    977988,
    889897,
    899888,
    869999,
    888898,
    968966,
    888779,
    678888,
    998787,
    788868,
    889897,
    887878,
    988888,
    878798,
    889877,
    889686,
    877776,
    796878,
    878789,
    977798,
    888886,
    788899,
    877888,
    888769,
    877888,
    778777,
    887977,
    789787,
    788788,
    979898,
    768888,
    798699,
    777888,
    977988,
    878989,
    778788,
    998888,
    887778,
    888898,
    888798,
    888887,
    886877,
    888867,
    678877,
    877867,
    876888,
    879877,
    788799,
    877888,
    888787,
    878898,
    778998,
    899978,
    777768,
    798788,
    778897,
    877898,
    777788,
    867789,
    887789,
    797779,
    788777,
    686898,
    987888,
    798887,
    668788,
    879778,
    887867,
    866898,
    699787,
    988886,
    887889,
    786688,
    899898,
    888879,
    898778,
    768778,
    888888,
    888988,
    898896,
    898997,
    988788,
    776988,
    878898,
    886678,
    889877,
    687889,
    799789,
    788998,
    877889,
    896689,
    988987,
    977789,
    677886,
    789796,
    897887,
    899998,
    886777,
    777899,
    869987,
    788978,
    888688,
    887777,
    778777,
    868878,
    898776,
    886876,
    798777,
    787786,
    888889,
    868877,
    878788,
    879889,
    888899,
    897898,
    987988,
    877878,
    877979,
    877787,
    878999,
    888877,
    879987,
    887778,
    979767,
    898777,
    897896,
    687898,
    677688,
    788889,
    869777,
    777777,
    796778,
    967887,
    787888,
    887887,
    988798,
    689968,
    789689,
    778778,
    988897,
    879798,
    796878,
    687689,
    887887,
    887889,
    977878,
    999787,
    988897,
    877888,
    777898,
    976778,
    899989,
    778888,
    778787,
    868777,
    777778,
    788977,
    996987,
    887897,
    788999,
    999898,
    768998,
    889878,
    788788,
    789888,
    987778,
    779688,
    778978,
    777698,
    888978,
    877888,
    887887,
    877788,
    787978,
    789977,
    898979,
    869886,
    778778,
    868798,
    699877,
    888888,
    878897,
    877876,
    887788,
    978889,
    777879,
    779878,
    777787,
    889988,
    887988,
    978878,
    778768,
    797878,
    798788,
    787788,
    778799,
    897978,
    889767,
    889866,
    677978,
    879788,
    997898,
    887789,
    789877,
    797887,
    788976,
    888787,
    797878,
    688778,
    998776,
    788978,
    878978,
    778887,
    898878,
    988877,
    778887,
    999777,
    999878,
    778768,
    987888,
    878987,
    888898,
    897886,
    787778,
    768888,
    889989,
    788899,
    677788,
    879777,
    767787,
    897879,
    888978,
    767876,
    878878,
    788886,
    899988,
    898977,
    889889,
    888789,
    887778,
    877889,
    896789,
    788788,
    788888,
    878877,
    877767,
    899797,
    767777,
    888876,
    889878,
    888779,
    866778,
    789787,
    897977,
    888788,
    888998,
    878797,
    796788,
    797766,
    879888,
    677888,
    777887,
    787887,
    788888,
    877878,
    888787,
    796887,
    988787,
    889777,
    868878,
    789887,
    798987,
    998777,
    769769,
    888889,
    877986,
    978878,
    778887,
    888898,
    888899,
    787789,
    888876,
    977678,
    898877,
    779898,
    777889,
    778987,
    879987,
    898888,
    789988,
    787878,
    877767,
    888787,
    779878,
    687777,
    677899,
    888777,
    797887,
    777787,
    989878,
    687767,
    887787,
    887889,
    677887,
    888867,
    877777,
    796777,
    877889,
    887878,
    879699,
    888978,
    898788,
    688779,
    778888,
    887787,
    688777,
    887897,
    999888,
    868977,
    898886,
    987897,
    889988,
    798997,
    876777,
    797778,
    887779,
    796987,
    787867,
    778878,
    887788,
    777788,
    977878,
    878677,
    879977,
    877797,
    987867,
    688879,
    978899,
    889898,
    877986,
    967787,
    798788,
    888798,
    678788,
    886896,
    787789,
    878979,
    998768,
    777679,
    798888,
    979789,
    889878,
    787888,
    797788,
    887786,
    978988,
    777797,
    698988,
    689877,
    688878,
    978897,
    778989,
    969878,
    789886,
    878787,
    977879,
    878799,
    788878,
    697978,
    797968,
    879878,
    899878,
    898998,
    888778,
    988888,
    888787,
    788788,
    788677,
    878998,
    988667,
    996968,
    988877,
    878878,
    788888,
    776797,
    998887,
    788888,
    777788,
    897798,
    978797,
    898978,
    887797,
    977897,
    879889,
    778786,
    887898,
    999788,
    878898,
    798899,
    788977,
    876878,
    897679,
    699888,
    998786,
    797978,
    777776,
    986789,
    779977,
    769888,
    877787,
    688888,
    886867,
    977899,
    978887,
    969887,
    887778,
    976888,
    878889,
    679967,
    898978,
    869697,
    898687,
    877988,
    788988,
    777878,
    677878,
    899778,
    979877,
    788798,
    899989,
    787988,
    898797,
    878788,
    897987,
    687787,
    696779,
    768677,
    888787,
    688897,
    868887,
    978888,
    787988,
    878897,
    777886,
    778788,
    788788,
    997888,
    988788,
    888889,
    886868,
    779868,
    667998,
    989897,
    777788,
    697876,
    997867,
    898798,
    989877,
    877778,
    887878,
    778888,
    887679,
    997799,
    697788,
    988899,
    798789,
    797877,
    887788,
    797988,
    867789,
    688787,
    777877,
    989797,
    777778,
    767786,
    878777,
    887787,
    778787,
    988788,
    889897,
    978787,
    686788,
    897988,
    877997,
    797887,
    867787,
    878988,
    969788,
    886788,
    888687,
    877889,
    779878,
    778779,
    778789,
    888788,
    798787,
    978889,
    776898,
    697877,
    788968,
    977879,
    887888,
    887997,
    778796,
    979687,
    889988,
    877789,
    988778,
    869898,
    887877,
    767879,
    768889,
    889987,
    868878,
    799778,
    687987,
    889788,
    779889,
    798788,
    967997,
    888879,
    978878,
    788976,
    878788,
    788978,
    669877,
    789887,
    988867,
    898898,
    898888,
    889778,
    876799,
    788789,
    989789,
    766799,
    977888,
    878878,
    787988,
    778887,
    988878,
    788897,
    887688,
    678888,
    978869,
    889877,
    768787,
    887977,
    879876,
    897778,
    788778,
    797888,
    997889,
    768697,
    778698,
    878687,
    898888,
    878777,
    887879,
    989887,
    888878,
    988689,
    779866,
    878878,
    798987,
    787779,
    887997,
    887887,
    776867,
    888986,
    787977,
    797778,
    878986,
    877789,
    888889,
    879877,
    887977,
    797988,
    798989,
    778777,
    899978,
    787888,
    988976,
    897778,
    888788,
    887887,
    877688,
    978797,
    879768,
    977877,
    889788,
    787977,
    878697,
    688889,
    786787,
    879788,
    998889,
    987777,
    888878,
    688668,
    776798,
    988988,
    868887,
    889889,
    677978,
    677788,
    778768,
    787797,
    899897,
    788878,
    797778,
    899776,
    797878,
    996767,
    789787,
    778878,
    879887,
    788888,
    898988,
    787878,
    888878,
    997876,
    788887,
    787889,
    899878,
    678887,
    878778,
    897979,
    877788,
    876699,
    889888,
    788869,
    789989,
    867777,
    899797,
    779797,
    788798,
    989887,
    788987,
    997889,
    897998,
    898888,
    868687,
    877899,
    988779,
    789799,
    878798,
    868878,
    898878,
    778887,
    777877,
    778879,
    997897,
    976988,
    878997,
    777796,
    878776,
    787777,
    778878,
    868869,
    788867,
    887788,
    788876,
    876888,
    789879,
    888788,
    778899,
    888777,
    978778,
    897789,
    888787,
    888789,
    766676,
    788788,
    697889,
    778789,
    876987,
    877767,
    978668,
    676988,
    887997,
    877987,
    888767,
    889787,
    788888,
    666787,
    898898,
    887889,
    786877,
    898788,
    878778,
    897879,
    878888,
    888778,
    887889,
    787878,
    988898,
    879788,
    788879,
    868887,
    897799,
    888888,
    887787,
    889987,
    777679,
    999778,
    778879,
    878988,
    877887,
    978777,
    778888,
    977788,
    886877,
    986788,
    988897,
    866887,
    798897,
    898779,
    997868,
    989898,
    887788,
    897896,
    888867,
    797888,
    799978,
    798778,
    878887,
    877876,
    966777,
    788899,
    789888,
    877887,
    978788,
    967898,
    679798,
    698888,
    987898,
    787868,
    879889,
    888889,
    878779,
    787779,
    999876,
    789988,
    877779,
    786788,
    778877,
    778789,
    678987,
    889799,
    777788,
    987778,
    998888,
    788987,
    877868,
    788889,
    889779,
    886789,
    877987,
    898898,
    878887,
    898977,
    889778,
    889998,
    877687,
    698887,
    988788,
    787888,
    698877,
    788889,
    878797,
    788878,
    897877,
    887977,
    799987,
    878989,
    888988,
    896796,
    789777,
    879778,
    778899,
    877887,
    887879,
    989679,
    878787,
    877779,
    999778,
    798879,
    778978,
    877877,
    797897,
    898888,
    786887,
    978697,
    988788,
    897998,
    687778,
    798888,
    778699,
    989687,
    888877,
    877778,
    788788,
    888679,
    977697,
    797877,
    679778,
    878878,
    777998,
    779688,
    988787,
    888787,
    879787,
    788987,
    869978,
    887877,
    888777,
    878879,
    788776,
    878778,
    678878,
    887679,
    888877,
    897877,
    687887,
    886798,
    978877,
    887977,
    887997,
    998868,
    788897,
    786987,
    788788,
    878777,
    997779,
    877887,
    789869,
    788878,
    777887,
    789777,
    888899,
    669888,
    886796,
    797978,
    888888,
    877888,
    996897,
    789776,
    787679,
    768879,
    777889,
    967868,
    889889,
    877998,
    998778,
    788878,
    899889,
    878788,
    789888,
    888976,
    968779,
    879888,
    877878,
    879987,
    996889,
    688767,
    987768,
    888888,
    778777,
    888877,
    879888,
    777887,
    877888,
    777977,
    787797,
    886898,
    888988,
    997888,
    887988,
    878876,
    788898,
    778797,
    869768,
    888978,
    777888,
    787787,
    989897,
    898889,
    889898,
    777788,
    678777,
    978799,
    788888,
    888889,
    877888,
    878897,
    997798,
    878778,
    867778,
    888788,
    988887,
    687979,
    787977,
    899899,
    797888,
    887678,
    868798,
    897886,
    888788,
    878878,
    978777,
    779888,
    786797,
    897977,
    797688,
    888898,
    797897,
    786777,
    768887,
    887888,
    887777,
    879777,
    889888,
    888778,
    778878,
    977886,
    779877,
    788988,
    987887,
    687788,
    868888,
    888878,
    679778,
    887887,
    787796,
    779989,
    889977,
    898798,
    888998,
    688888,
    999779,
    976866,
    887987,
    879877,
    697799,
    899898,
    786788,
    878889,
    677888,
    789887,
    888797,
    877887,
    688988,
    989878,
    877877,
    778876,
    789888,
    778788,
    677888,
    687977,
    678777,
    898867,
    997887,
    886788,
    989778,
    877786,
    887979,
    897998,
    787888,
    878987,
    987889,
    879789,
    888789,
    878889,
    888897,
    789897,
    786888,
    677898,
    988687,
    997888,
    968989,
    798787,
    987887,
    978898,
    899977,
    687788,
    888897,
    897788,
    776978,
    788778,
    769689,
    967898,
    787996,
    998878,
    888888,
    897798,
    788889,
    896896,
    688876,
    689887,
    898879,
    887987,
    897986,
    878798,
    888887,
    878988,
    887777,
    977769,
    887898,
    786879,
    887777,
    778868,
    777789,
    697888,
    998878,
    887988,
    877999,
    888687,
    778788,
    887978,
    997879,
    787879,
    897887,
    767688,
    788887,
    888788,
    898777,
    777979,
    777988,
    797778,
    888878,
    699798,
    897779,
    877888,
    778877,
    888777,
    877787,
    886878,
    999767,
    877979,
    997888,
    888896,
    877898,
    897889,
    876777,
    988777,
    896879,
    978787,
    779779,
    886898,
    677978,
    898876,
    778787,
    888698,
    788787,
    987987,
    787788,
    788898,
    798698,
    778989,
    889797,
    787698,
    778788,
    987788,
    687799,
    998887,
    878878,
    797986,
    898877,
    978769,
    978987,
    768778,
    689887,
    868778,
    967888,
    878788,
    787988,
    878788,
    877897,
    998978,
    777977,
    877987,
    897888,
    788897,
    788998,
    877898,
    787988,
    887789,
    779878,
    889878,
    889879,
    887878,
    767768,
    997879,
    869778,
    896988,
    788987,
    788888,
    989888,
    688787,
    877896,
    777878,
    887788,
    888868,
    868877,
    878778,
    989877,
    897896,
    888977,
    888787,
    988787,
    788887,
    897879,
    888888,
    798788,
    889879,
    777887,
    898779,
    878878,
    798887,
    998898,
    888868,
    779778,
    788788,
    998888,
    877798,
    869987,
    888688,
    898868,
    678886,
    899777,
    788779,
    889888,
    787767,
    787888,
    768877,
    978978,
    697688,
    968888,
    698776,
    888887,
    887879,
    688898,
    979887,
    887977,
    778987,
    998888,
    776796,
    787988,
    988789,
    998697,
    889887,
    878887,
    787988,
    798889,
    787897,
    878988,
    778796,
    798777,
    798898,
    778798,
    979678,
    787798,
    787788,
    799788,
    979898,
    778877,
    897778,
    977869,
    776867,
    888669,
    877897,
    899788,
    887777,
    987877,
    877877,
    989877,
    888779,
    777778,
    898888,
    977997,
    998797,
    899898,
    778888,
    987999,
    877977,
    777888,
    888997,
    787887,
    987888,
    898888,
    787789,
    978778,
    897888,
    888977,
    976887,
    777777,
    986798,
    877898,
    778878,
    879888,
    887888,
    777879,
    978888,
    977889,
    878788,
    777888,
    889898,
    988678,
    989786,
    787899,
    797688,
    897887,
    888989,
    978989,
    867789,
    998787,
    888887,
    898877,
    777678,
    678787,
    888867,
    778987,
    898978,
    788999,
    898987,
    787987,
    678787,
    987787,
    886779,
    996788,
    768798,
    886788,
    889878,
    888897,
    869887,
    878788,
    788877,
    798977,
    796767,
    776788,
    788688,
    788877,
    979889,
    888987,
    779869,
    888888,
    877868,
    778879,
    868677,
    787887,
    797798,
    877898,
    877869,
    877789,
    969888,
    879888,
    899698,
    897988,
    778888,
    698888,
    868787,
    779887,
    888888,
    679887,
    968779,
    878878,
    888968,
    878979,
    888987,
    888887,
    877787,
    978987,
    897868,
    978886,
    776989,
    889787,
    697778,
    989777,
    799797,
    889778,
    798686,
    766787,
    799987,
    788876,
    877898,
    887798,
    788888,
    889897,
    979789,
    777778,
    878986,
    788798,
    989869,
    889776,
    887778,
    868997,
    789798,
    779888,
    878897,
    877978,
    878888,
    987687,
    988978,
    788787,
    898878,
    878777,
    778897,
    999879,
    687789,
    888887,
    888889,
    778686,
    688988,
    877789,
    977888,
    769777,
    988987,
    879888,
    789869,
    889877,
    887877,
    889687,
    867788,
    987767,
    899778,
    879888,
    698887,
    897689,
    887876,
    877789,
    878888,
    989879,
    897866,
    978888,
    786796,
    997778,
    877988,
    887778,
    786787,
    977999,
    888887,
    779797,
    888977,
    896878,
    787987,
    888888,
    798977,
    889897,
    887868,
    677887,
    888877,
    889866,
    889798,
    888778,
    887998,
    788877,
    798778,
    888877,
    877787,
    887897,
    888879,
    898689,
    888988,
    877678,
    678888,
    878888,
    689989,
    868698,
    787788,
    799987,
    878777,
    889889,
    878999,
    779768,
    897998,
    777778,
    778779,
    888898,
    766798,
    768679,
    778678,
    898867,
    897898,
    778778,
    888678,
    898788,
    776867,
    888878,
    777877,
    676879,
    898978,
    867868,
    887888,
    689877,
    786888,
    898797,
    779778,
    978878,
    876997,
    798788,
    888798,
    887797,
    977777,
    999688,
    678997,
    777877,
    887898,
    798767,
    867888,
    888878,
    878889,
    789888,
    878778,
    889778,
    797888,
    889899,
    887968,
    888877,
    978888,
    788888,
    888899,
    869797,
    789886,
    798979,
    779768,
    788769,
    878768,
    879687,
    888778,
    768888,
    978779,
    778787,
    878998,
    989797,
    977978,
    888899,
    888987,
    988898,
    778789,
    987778,
    878888,
    886787,
    977767,
    878778,
    667877,
    978988,
    787886,
    779978,
    898899,
    888879,
    878786,
    888998,
    799889,
    677987,
    779788,
    888777,
    879987,
    768799,
    999888,
    777778,
    877779,
    988786,
    876867,
    877987,
    889899,
    678689,
    788798,
    687876,
    798888,
    876887,
    779879,
    776787,
    899878,
    798888,
    789779,
    699887,
    878988,
    788877,
    897897,
    987978,
    888999,
    879777,
    789977,
    788877,
    777667,
    888789,
    887677,
    787786,
    699879,
    998988,
    778788,
    787786,
    869687,
    987889,
    778867,
    878978,
    779898,
    767978,
    997778,
    887878,
    788887,
    677897,
    877797,
    699978,
    998887,
    779986,
    688787,
    898977,
    887878,
    767888,
    787999,
    887788,
    787677,
    979877,
    989978,
    799887,
    977889,
    977778,
    988788,
    878877,
    979998,
    789788,
    998886,
    889797,
    897778,
    988898,
    877968,
    777778,
    888897,
    976888,
    777887,
    869897,
    988889,
    798969,
    878777,
    978797,
    798878,
    887898,
    988797,
    887877,
    977777,
    788888,
    699688,
    788878,
    789887,
    879899,
    876996,
    998776,
    888768,
    788779,
    887778,
    997976,
    888877,
    798887,
    778897,
    798877,
    977897,
    877989,
    898997,
    777788,
    989878,
    979897,
    897999,
    799987,
    999788,
    678799,
    888777,
    888889,
    988777,
    988967,
    789988,
    997898,
    787989,
    868887,
    789979,
    978888,
    877879,
    878888,
    979878,
    987987,
    878788,
    779887,
    797788,
    887889,
    788898,
    888788,
    898787,
    889888,
    798688,
    877988,
    877868,
    987988,
    687888,
    878878,
    888979,
    799779,
    988789,
    889799,
    796799,
    987977,
    978787,
    778988,
    878888,
    887888,
    789779,
    988866,
    797788,
    877779,
    887689,
    797998,
    798779,
    778687,
    988869,
    897789,
    677879,
    778888,
    868888,
    779889,
    768888,
    879898,
    987998,
    688787,
    788887,
    887786,
    968788,
    897998,
    786989,
    789688,
    888777,
    789888,
    779788,
    888977,
    888988,
    887987,
    788878,
    786877,
    778788,
    686987,
    977698,
    797978,
    887788,
    789797,
    787898,
    789788,
    998769,
    778888,
    888887,
    899898,
    797677,
    878978,
    887968,
    778779,
    979887,
    877777,
    976777,
    789887,
    877786,
    978976,
    878777,
    989988,
    778898,
    898788,
    976778,
    887799,
    877768,
    898988,
    766687,
    887988,
    878789,
    978887,
    778887,
    979988,
    779888,
    998777,
    778789,
    767788,
    878788,
    789788,
    988669,
    777979,
    978778,
    787888,
    998788,
    889778,
    878879,
    688888,
    887777,
    878788,
    888878,
    889789,
    878798,
    889787,
    789797,
    897989,
    998898,
    888787,
    976779,
    789778,
    887767,
    977869,
    788879,
    898787,
    888678,
    987898,
    778878,
    687888,
    898978,
    978978,
    798888,
    969988,
    888797,
    789778,
    788876,
    888878,
    879777,
    768898,
    797788,
    987787,
    778788,
    767788,
    797679,
    888798,
    878788,
    977976,
    789978,
    979878,
    888778,
    779787,
    777777,
    878888,
    787888,
    888776,
    879878,
    788979,
    888977,
    777988,
    789788,
    788677,
    778869,
    978878,
    887787,
    987796,
    788777,
    989798,
    788878,
    998779,
    899899,
    678977,
    979877,
    868887,
    979678,
    977998,
    967788,
    767778,
    779778,
    879787,
    788899,
    689778,
    689777,
    776768,
    988889,
    788889,
    787788,
    778867,
    878899,
    877898,
    997987,
    678989,
    977897,
    877888,
    888678,
    767877,
    988877,
    877879,
    788788,
    798888,
    898999,
    797799,
    676879,
    887888,
    898778,
    798887,
    996868,
    878897,
    978798,
    777789,
    889777,
    868977,
    679889,
    788998,
    788788,
    787868,
    779787,
    978788,
    889988,
    887988,
    788788,
    967877,
    988987,
    888897,
    797986,
    978899,
    978779,
    788989,
    898877,
    786888,
    978788,
    697788,
    767896,
    988888,
    878879,
    877878,
    987997,
    968798,
    976887,
    888688,
    889898,
    787898,
    788778,
    866878,
    788988,
    889779,
    887888,
    669988,
    788879,
    798878,
    687787,
    978999,
    987886,
    788787,
    878889,
    798887,
    879878,
    899687,
    879988,
    787888,
    877877,
    889798,
    878788,
    888887,
    879987,
    879787,
    878887,
    879988,
    876877,
    768896,
    879987,
    897896,
    797788,
    977678,
    878768,
    786987,
    777889,
    787688,
    979778,
    989898,
    867789,
    888967,
    887787,
    789789,
    868868,
    676788,
    899788,
    798777,
    687789,
    778888,
    898788,
    877999,
    887788,
    697777,
    888777,
    887878,
    678888,
    788879,
    678888,
    897878,
    879788,
    878988,
    787898,
    878678,
    888877,
    768877,
    878878,
    886788,
    898899,
    879778,
    778889,
    886889,
    879786,
    899799,
    979898,
    887778,
    889788,
    768787,
    787687,
    878988,
    798687,
    796777,
    878997,
    889779,
    977877,
    779889,
    897899,
    887688,
    977996,
    788788,
    688798,
    889788,
    877797,
    887769,
    778978,
    889886,
    878868,
    778888,
    777687,
    778888,
    797979,
    887888,
    778876,
    879789,
    798878,
    677888,
    888788,
    898887,
    878878,
    969889,
    877887,
    777867,
    879997,
    778787,
    899888,
    989687,
    877777,
    888778,
    788988,
    889877,
    789877,
    778878,
    887787,
    897898,
    887798,
    877968,
    678789,
    698997,
    987799,
    867879,
    778979,
    788767,
    878889,
    798887,
    689778,
    766979,
    977969,
    978899,
    976768,
    888896,
    897777,
    789998,
    697778,
    968978,
    778878,
    989888,
    889878,
    698978,
    777798,
    698788,
    876987,
    887768,
    789698,
    796877,
    888889,
    897888,
    868997,
    769788,
    899899,
    796888,
    878878,
    788888,
    878887,
    666979,
    788788,
    888978,
    997887,
    978687,
    887898,
    778789,
    777967,
    677777,
    878889,
    898678,
    799888,
    888778,
    888788,
    787998,
    989887,
    878889,
    878887,
    887878,
    977976,
    989888,
    878779,
    987887,
    798898,
    978787,
    867778,
    888979,
    877889,
    889988,
    778988,
    797777,
    787878,
    769787,
    888798,
    878778,
    887979,
    798866,
    887698,
    878787,
    898887,
    898977,
    888868,
    876798,
    987987,
    787687,
    898779,
    887877,
    988897,
    877786,
    898787,
    898879,
    678778,
    977887,
    897887,
    787788,
    888887,
    988999,
    677989,
    778888,
    796988,
    978787,
    878797,
    778778,
    868898,
    997887,
    877887,
    799898,
    889888,
    777678,
    776778,
    999789,
    978687,
    997788,
    888888,
    877987,
    777897,
    897788,
    878698,
    799989,
    779787,
    888978,
    878787,
    997797,
    887977,
    898998,
    777987,
    987887,
    889789,
    889988,
    788888,
    777786,
    888878,
    777679,
    986799,
    698888,
    889768,
    977767,
    688878,
    889898,
    779988,
    788978,
    789879,
    888799,
    988787,
    888887,
    898776,
    878888,
    879887,
    787797,
    887789,
    778688,
    888978,
    778877,
    787878,
    868897,
    889769,
    787887,
    889877,
    977888,
    799778,
    886889,
    876899,
    988977,
    688878,
    779977,
    986889,
    888878,
    877889,
    777878,
    888968,
    976788,
    878787,
    777779,
    887788,
    979787,
    777788,
    678976,
    798878,
    977796,
    797897,
    697987,
    797788,
    889697,
    867988,
    888878,
    968898,
    888998,
    888768,
    897997,
    888787,
    877889,
    878997,
    878879,
    788988,
    887799,
    888888,
    778787,
    888877,
    786987,
    868878,
    879787,
    788889,
    777887,
    799889,
    787788,
    987787,
    867779,
    878888,
    898879,
    888697,
    988888,
    788978,
    869787,
    786978,
    788888,
    788778,
    776778,
    887788,
    887977,
    878887,
    988888,
    888787,
    988987,
    786898,
    989889,
    798887,
    898777,
    889787,
    798987,
    787798,
    888787,
    868778,
    887798,
    787688,
    999869,
    878678,
    998778,
    788989,
    798898,
    988798,
    888788,
    889768,
    698778,
    789898,
    787987,
    777868,
    987777,
    877987,
    888778,
    688888,
    887787,
    899987,
    878798,
    977779,
    798789,
    787999,
    897878,
    986697,
    798977,
    786989,
    998897,
    887687,
    778888,
    978889,
    777697,
    889777,
    988788,
    997988,
    797987,
    897898,
    777986,
    977888,
    868887,
    888777,
    887789,
    887699,
    988887,
    777868,
    899898,
    789889,
    897987,
    789877,
    988886,
    797977,
    999788,
    997876,
    887887,
    777987,
    678779,
    878888,
    877679,
    797798,
    898888,
    899687,
    887987,
    797989,
    888897,
    767877,
    678769,
    878687,
    779887,
    889887,
    788998,
    888798,
    787877,
    676798,
    988887,
    998878,
    887779,
    979999,
    889798,
    779797,
    767788,
    977797,
    897779,
    797888,
    778878,
    889777,
    898677,
    897777,
    879898,
    878798,
    887788,
    986799,
    888887,
    986876,
    887789,
    978899,
    867778,
    899778,
    778878,
    878878,
    778887,
    867887,
    788787,
    979877,
    896777,
    887968,
    889877,
    786988,
    789898,
    798888,
    786687,
    667887,
    888898,
    898777,
    867897,
    898879,
    788877,
    787887,
    887888,
    987969,
    867977,
    788788,
    787998,
    888988,
    789888,
    887787,
    788876,
    987768,
    777877,
    888789,
    798788,
    898778,
    889979,
    779876,
    897777,
    777678,
    797978,
    888687,
    798987,
    888877,
    697778,
    788988,
    886988,
    898798,
    887888,
    777868,
    888768,
    887989,
    687789,
    989787,
    789888,
    889798,
    868787,
    877788,
    779878,
    978777,
    978898,
    888879,
    878876,
    689888,
    878977,
    678789,
    688878,
    878879,
    898686,
    887697,
    968979,
    989778,
    789888,
    887787,
    889997,
    786788,
    988887,
    987878,
    877868,
    886888,
    789798,
    888897,
    887667,
    886867,
    888897,
    887867,
    987788,
    889887,
    878968,
    768877,
    897888,
    888878,
    888896,
    898797,
    888887,
    789977,
    887888,
    887789,
    888779,
    897777,
    887887,
    777979,
    688899,
    986977,
    688778,
    788768,
    888877,
    897788,
    779988,
    788788,
    878869,
    678789,
    888988,
    798886,
    898988,
    877668,
    788896,
    988788,
    788769,
    776779,
    788869,
    777887,
    888788,
    887779,
    788896,
    979878,
    788888,
    799879,
    698868,
    696888,
    788778,
    866779,
    887688,
    688797,
    989778,
    788788,
    887698,
    979888,
    877768,
    997797,
    878878,
    877798,
    868897,
    868897,
    788997,
    999987,
    778877,
    888777,
    987787,
    888877,
    867777,
    887667,
    897786,
    887867,
    777777,
    897869,
    788897,
    999877,
    997897,
    889888,
    978898,
    778988,
    777877,
    977797,
    989877,
    878897,
    897767,
    668888,
    977786,
    777898,
    676778,
    979988,
    776888,
    886777,
    786987,
    898898,
    799778,
    898897,
    898897,
    778989,
    788898,
    988877,
    878688,
    878888,
    977777,
    867788,
    978898,
    687988,
    777888,
    788887,
    987978,
    887697,
    799878,
    878786,
    988777,
    888787,
    769687,
    877987,
    798997,
    798877,
    877778,
    889878,
    988777,
    778977,
    788778,
    988886,
    778868,
    878677,
    788878,
    997896,
    868897,
    968787,
    897788,
    998879,
    898977,
    768888,
    867998,
    979789,
    869878,
    677768,
    878886,
    999988,
    687887,
    867688,
    978879,
    787787,
    898877,
    988788,
    887688,
    887886,
    787888,
    897978,
    778776,
    887776,
    888798,
    878997,
    978788,
    878886,
    679988,
    887787,
    889788,
    896887,
    886898,
    889778,
    987797,
    978886,
    797789,
    777799,
    898968,
    797887,
    777989,
    779689,
    888788,
    877897,
    886996,
    787989,
    877996,
    777998,
    779788,
    979688,
    779877,
    898686,
    798786,
    878787,
    878898,
    868778,
    999888,
    966878,
    889978,
    888797,
    978877,
    988888,
    889788,
    688778,
    887888,
    879877,
    787878,
    898996,
    798786,
    987977,
    988777,
    797887,
    777879,
    797878,
    887778,
    897788,
    798877,
    978797,
    788878,
    888787,
    888776,
    798888,
    876787,
    898878,
    798788,
    877888,
    778777,
    799997,
    988897,
    997997,
    888777,
    797877,
    787678,
    888798,
    988978,
    777797,
    989889,
    888787,
    987888,
    688878,
    879988,
    797888,
    888977,
    797877,
    987878,
    878787,
    888668,
    788777,
    886888,
    878879,
    889788,
    799778,
    889797,
    989977,
    889977,
    767967,
    797878,
    979887,
    979888,
    878767,
    889676,
    879688,
    798798,
    896699,
    988888,
    778787,
    788899,
    968987,
    988978,
    879678,
    689888,
    787677,
    887688,
    888889,
    887788,
    898688,
    988679,
    887778,
    778898,
    787776,
    868677,
    899888,
    899879,
    897879,
    788788,
    997899,
    797878,
    888788,
    788899,
    789786,
    698876,
    867977,
    889797,
    999989,
    996989,
    888978,
    788788,
    687877,
    769777,
    779888,
    988876,
    778689,
    797686,
    897788,
    776878,
    779888,
    788797,
    797989,
    898798,
    878868,
    977977,
    789888,
    887886,
    897897,
    677978,
    977868,
    778788,
    988688,
    888879,
    888788,
    999899,
    998888,
    888877,
    998678,
    977997,
    888868,
    789789,
    889977,
    987787,
    677987,
    888787,
    887888,
    698787,
    877698,
    789978,
    977798,
    786967,
    987789,
    776678,
    688898,
    777987,
    788798,
    787867,
    888688,
    787787,
    896776,
    877979,
    889878,
    798878,
    687776,
    867889,
    777888,
    897776,
    768778,
    779997,
    779887,
    887788,
    787987,
    698778,
    797799,
    877797,
    987888,
    886889,
    978888,
    886778,
    869868,
    887887,
    878897,
    787799,
    888898,
    778887,
    988777,
    998988,
    877897,
    998888,
    787798,
    996968,
    678689,
    878988,
    788978,
    678877,
    779978,
    889878,
    798878,
    787879,
    797787,
    786668,
    886977,
    789978,
    977788,
    878878,
    887896,
    878787,
    778877,
    778998,
    988898,
    787888,
    887898,
    889977,
    987898,
    876678,
    788998,
    987976,
    878778,
    776878,
    876788,
    979689,
    789977,
    878899,
    898686,
    879779,
    868687,
    888888,
    767897,
    898876,
    989777,
    768788,
    788899,
    899887,
    776779,
    778867,
    887877,
    877789,
    889888,
    898996,
    876798,
    789998,
    677877,
    778767,
    787789,
    979897,
    989888,
    777777,
    888888,
    787776,
    798896,
    888898,
    988787,
    778796,
    868787,
    798789,
    779878,
    798688,
    887888,
    899797,
    988997,
    879678,
    798878,
    898888,
    986897,
    798878,
    778678,
    887898,
    788778,
    888979,
    969788,
    877988,
    898778,
    899899,
    978887,
    789878,
    677878,
    698889,
    876787,
    679879,
    877778,
    979879,
    798978,
    886886,
    788869,
    688988,
    898888,
    777897,
    988888,
    988888,
    798886,
    987777,
    777888,
    788788,
    877777,
    888788,
    976998,
    887988,
    897678,
    886678,
    878678,
    677878,
    888989,
    877888,
    898778,
    787777,
    987768,
    778787,
    887778,
    887678,
    888888,
    879869,
    967898,
    988797,
    988777,
    886877,
    678888,
    888798,
    879887,
    779899,
    878879,
    898898,
    778877,
    997899,
    776898,
    967698,
    898999,
    889997,
    897888,
    787979,
    777888,
    887779,
    778799,
    977768,
    788867,
    978888,
    786876,
    799888,
    996786,
    899978,
    999888,
    778878,
    878877,
    999878,
    778776,
    888898,
    888897,
    898998,
    887799,
    787887,
    886798,
    989799,
    788899,
    887987,
    888878,
    896998,
    769986,
    888988,
    989886,
    886899,
    877777,
    869898,
    989798,
    898877,
    687889,
    886788,
    878988,
    798787,
    887878,
    787999,
    778779,
    786777,
    999899,
    988887,
    988688,
    879768,
    778898,
    777787,
    778888,
    678989,
    878898,
    878878,
    778897,
    789777,
    768787,
    798888,
    888889,
    876799,
    788797,
    978976,
    898787,
    897687,
    688977,
    898888,
    787888,
    688796,
    887877,
    789789,
    987787,
    889887,
    988779,
    797887,
    888787,
    686987,
    988798,
    788887,
    888978,
    888777,
    978877,
    689889,
    797896,
    968898,
    778988,
    878888,
    768777,
    789999,
    797888,
    878998,
    877778,
    689779,
    977888,
    787778,
    788778,
    787788,
    888679,
    778877,
    788986,
    888798,
    889778,
    898887,
    889888,
    787888,
    988978,
    768677,
    888989,
    876968,
    889788,
    798987,
    877867,
    687887,
    899877,
    778876,
    888897,
    987899,
    879989,
    987769,
    898967,
    999778,
    868877,
    887777,
    998986,
    988997,
    787879,
    879878,
    777778,
    977889,
    888888,
    998888,
    989787,
    798767,
    788898,
    888778,
    888767,
    986987,
    887788,
    768877,
    989966,
    968879,
    977887,
    898888,
    788979,
    866989,
    887868,
    897878,
    688998,
    688968,
    789887,
    877878,
    886876,
    998978,
    788989,
    776888,
    776868,
    767878,
    799878,
    898778,
    899778,
    779998,
    778686,
    887887,
    887878,
    778788,
    789768,
    888787,
    777887,
    878979,
    786889,
    977879,
    887779,
    888888,
    878987,
    798978,
    777978,
    878777,
    798988,
    999887,
    668889,
    798867,
    678987,
    887896,
    878788,
    888879,
    799777,
    788888,
    987796,
    798878,
    988776,
    887869,
    699788,
    997988,
    678997,
    678878,
    798887,
    686788,
    887787,
    788778,
    869888,
    877788,
    897888,
    789977,
    777777,
    977677,
    878897,
    698888,
    987878,
    787978,
    998886,
    776987,
    897777,
    898889,
    977887,
    987878,
    877876,
    977998,
    788878,
    969888,
    977878,
    869788,
    876887,
    799879,
    879798,
    888887,
    878877,
    778987,
    789798,
    877788,
    896698,
    897987,
    888777,
    887999,
    968867,
    888776,
    786868,
    988776,
    898897,
    887878,
    888786,
    678887,
    676887,
    887887,
    788888,
    889878,
    868897,
    878998,
    997679,
    778878,
    779789,
    898888,
    989996,
    978787,
    887898,
    998769,
    886889,
    888878,
    787787,
    888688,
    878779,
    778876,
    777987,
    988878,
    877977,
    899778,
    788887,
    889989,
    777888,
    786869,
    798878,
    799798,
    878797,
    878887,
    877778,
    797688,
    889798,
    767888,
    887878,
    788878,
    987878,
    986789,
    987966,
    798787,
    879789,
    899898,
    767786,
    878887,
    879878,
    877978,
    979898,
    889998,
    887877,
    889867,
    889989,
    978878,
    677786,
    778898,
    788888,
    779877,
    889887,
    888688,
    897988,
    888988,
    968778,
    888887,
    888888,
    989888,
    998777,
    877779,
    888887,
    888789,
    979866,
    879898,
    876897,
    777878,
    669879,
    978878,
    697877,
    677798,
    688888,
    888788,
    898797,
    888889,
    787878,
    877777,
    788996,
    887979,
    977777,
    688898,
    798977,
    777877,
    698897,
    678897,
    887988,
    788878,
    778777,
    888676,
    877778,
    887987,
    998997,
    888887,
    899988,
    687867,
    967888,
    778787,
    667877,
    898888,
    787889,
    678889,
    888689,
    878988,
    688788,
    888897,
    888897,
    689887,
    888878,
    797778,
    889798,
    677898,
    796897,
    878987,
    866878,
    778869,
    788868,
    887869,
    899878,
    689797,
    787789,
    887678,
    668897,
    877877,
    788999,
    777787,
    988978,
    987667,
    898997,
    667887,
    989997,
    999799,
    888888,
    888776,
    888687,
    888798,
    978779,
    798779,
    789888,
    788988,
    887868,
    877779,
    887989,
    879887,
    988988,
    686989,
    888779,
    988777,
    897788,
    888898,
    788899,
    798888,
    778788,
    878978,
    886789,
    777889,
    766878,
    679877,
    898987,
    889897,
    898787,
    888797,
    798878,
    987797,
    797698,
    887799,
    986878,
    677887,
    988778,
    978888,
    868877,
    977878,
    788778,
    887887,
    988978,
    788978,
    898898,
    977779,
    779889,
    898788,
    989998,
    878877,
    889877,
    877878,
    977799,
    878788,
    698788,
    999787,
    898967,
    877969,
    879876,
    878779,
    887677,
    897988,
    777979,
    787778,
    688789,
    886987,
    999797,
    876777,
    987889,
    778987,
    898887,
    878778,
    676897,
    798997,
    878888,
    987888,
    877887,
    889787,
    787799,
    779979,
    888879,
    788778,
    989778,
    887778,
    877788,
    987878,
    889797,
    789986,
    977897,
    979888,
    887977,
    988868,
    986887,
    879678,
    797787,
    667898,
    788876,
    878877,
    788767,
    798788,
    788679,
    778998,
    998789,
    997978,
    889979,
    776777,
    877798,
    879798,
    796777,
    788767,
    878988,
    889888,
    688777,
    877888,
    788877,
    997887,
    788687,
    888988,
    989998,
    797788,
    888787,
    786788,
    687689,
    898878,
    898887,
    788878,
    787887,
    888888,
    888798,
    888886,
    778877,
    978788,
    977779,
    888697,
    897678,
    988888,
    869888,
    668679,
    687887,
    786777,
    787778,
    966988,
    679887,
    867768,
    888877,
    689877,
    788788,
    887689,
    898877,
    798777,
    878789,
    868769,
    877987,
    887879,
    787898,
    889876,
    797877,
    788889,
    889778,
    888777,
    989887,
    778878,
    786887,
    788888,
    878877,
    986978,
    877879,
    878888,
    977888,
    888879,
    869888,
    898888,
    897778,
    878799,
    867887,
    877879,
    898688,
    867887,
    769799,
    879797,
    767887,
    987879,
    677787,
    967877,
    889897,
    677987,
    887889,
    678888,
    777889,
    668687,
    899787,
    787778,
    878997,
    878887,
    777777,
    887997,
    797698,
    788778,
    889888,
    868798,
    777878,
    997779,
    877886,
    797867,
    899777,
    687787,
    777668,
    878989,
    877799,
    688887,
    888988,
    697977,
    778787,
    788878,
    887788,
    777868,
    886689,
    889897,
    777988,
    798787,
    887979,
    999788,
    878788,
    878879,
    977798,
    777687,
    889988,
    877788,
    887787,
    877788,
    978997,
    897677,
    897789,
    789798,
    877796,
    888988,
    778888,
    878787,
    877987,
    988797,
    887798,
    779877,
    877878,
    879988,
    878776,
    797988,
    879877,
    777788,
    889778,
    886989,
    688998,
    788877,
    678787,
    898788,
    978787,
    968878,
    778798,
    988879,
    786788,
    987888,
    787787,
    887877,
    776988,
    687979,
    878799,
    879888,
    688778,
    778868,
    878778,
    978978,
    987897,
    876869,
    787977,
    888698,
    888788,
    767798,
    898887,
    789868,
    887988,
    679667,
    778878,
    798778,
    878788,
    987887,
    688869,
    987767,
    787877,
    898878,
    779778,
    777777,
    887978,
    896698,
    887877,
    868978,
    788779,
    898786,
    788777,
    988879,
    889979,
    889888,
    877877,
    877678,
    688877,
    778979,
    878898,
    798797,
    986887,
    698989,
    879779,
    879777,
    889877,
    767977,
    789797,
    987788,
    887877,
    676879,
    887977,
    878989,
    798888,
    878768,
    768977,
    877789,
    868788,
    779699,
    886877,
    888779,
    777977,
    687989,
    978987,
    788788,
    798776,
    979797,
    779878,
    989867,
    889698,
    787889,
    789778,
    889678,
    788877,
    778778,
    879797,
    888697,
    887877,
    778887,
    777798,
    686978,
    879898,
    888788,
    879888,
    978997,
    787887,
    987778,
    787866,
    766988,
    776878,
    878979,
    778977,
    797696,
    778778,
    878887,
    889778,
    798898,
    777878,
    779998,
    878887,
    889698,
    777998,
    768998,
    769788,
    877786,
    889878,
    887788,
    876778,
    678787,
    877899,
    967987,
    889887,
    977778,
    887697,
    888888,
    779787,
    988988,
    888979,
    778877,
    988787,
    797888,
    967877,
    677788,
    998987,
    889787,
    888869,
    898879,
    977788,
    898887,
    899969,
    797888,
    987877,
    878969,
    899777,
    889886,
    877878,
    896996,
    679778,
    876777,
    878777,
    979969,
    978778,
    887897,
    779777,
    778878,
    898897,
    889987,
    897779,
    888878,
    979878,
    988899,
    879979,
    787898,
    767986,
    887968,
    877878,
    778866,
    779887,
    887987,
    877989,
    988987,
    887767,
    788667,
    896778,
    887687,
    788779,
    877897,
    988878,
    888688,
    789867,
    788888,
    887887,
    977768,
    788887,
    887787,
    799799,
    768897,
    698878,
    887887,
    997679,
    787877,
    888698,
    978767,
    899879,
    877987,
    888977,
    687868,
    898778,
    878897,
    678786,
    786778,
    877898,
    987889,
    686998,
    887878,
    997887,
    878877,
    887887,
    888797,
    778877,
    778977,
    897879,
    989988,
    897777,
    887689,
    977877,
    788888,
    988888,
    988889,
    897898,
    877986,
    897878,
    897979,
    888987,
    987898,
    797779,
    788787,
    879977,
    887876,
    799978,
    668898,
    677889,
    788878,
    877879,
    698688,
    888878,
    886978,
    798898,
    989877,
    887997,
    888878,
    787688,
    777898,
    778867,
    887889,
    798787,
    898879,
    889888,
    878968,
    778688,
    787778,
    778787,
    967788,
    986869,
    888887,
    888877,
    996888,
    887988,
    888897,
    867878,
    768888,
    797978,
    989887,
    788898,
    897788,
    988889,
    977686,
    868779,
    787778,
    867988,
    799878,
    898878,
    988898,
    776877,
    897986,
    988988,
    868878,
    789877,
    788987,
    777766,
    788978,
    978978,
    787888,
    778667,
    989778,
    879987,
    688887,
    899977,
    678788,
    889899,
    899888,
    787898,
    768876,
    878878,
    877789,
    868898,
    877978,
    868877,
    798768,
    888686,
    878778,
    888798,
    889988,
    889977,
    698878,
    978887,
    869779,
    679678,
    888888,
    889776,
    778889,
    797989,
    788897,
    877887,
    798897,
    989786,
    977789,
    779888,
    788878,
    868878,
    788788,
    788998,
    778887,
    879979,
    788867,
    978787,
    799877,
    888878,
    889887,
    788988,
    778898,
    987978,
    879987,
    678787,
    777779,
    878877,
    898779,
    989898,
    788779,
    879888,
    866798,
    886887,
    877979,
    988887,
    877888,
    879778,
    878879,
    887888,
    889889,
    879788,
    988879,
    989777,
    686778,
    897887,
    878898,
    888899,
    996797,
    887886,
    878988,
    987887,
    697777,
    989788,
    987789,
    788788,
    777988,
    776998,
    997887,
    887887,
    868978,
    877866,
    989999,
    888887,
    989788,
    778788,
    678987,
    788868,
    979877,
    769677,
    787889,
    878887,
    797787,
    879889,
    788978,
    888897,
    886988,
    887789,
    777987,
    878878,
    978868,
    786989,
    888998,
    979988,
    887867,
    988976,
    989977,
    788797,
    888879,
    778978,
    898787,
    897988,
    788776,
    977689,
    987779,
    798667,
    988788,
    688697,
    769889,
    968778,
    899778,
    788768,
    888878,
    869788,
    787999,
    997888,
    788898,
    888887,
    796788,
    988797,
    799789,
    987878,
    898889,
    768877,
    788867,
    887797,
    877867,
    867787,
    987888,
    978778,
    779788,
    678897,
    777678,
    788978,
    888789,
    889779,
    886888,
    788888,
    878788,
    788697,
    977867,
    987888,
    889989,
    878788,
    796888,
    779867,
    879777,
    878878,
    789989,
    797888,
    888899,
    799787,
    897888,
    988887,
    887887,
    888687,
    997887,
    679678,
    876788,
    887898,
    989998,
    979888,
    787798,
    867678,
    787779,
    798787,
    878889,
    798889,
    968888,
    896898,
    778788,
    968778,
    778888,
    889889,
    898788,
    776878,
    799788,
    778677,
    868897,
    786978,
    878788,
    798887,
    787898,
    879698,
    878779,
    679887,
    687778,
    876797,
    686786,
    998778,
    776987,
    768787,
    789887,
    879778,
    799887,
    878898,
    887787,
    897878,
    789789,
    978876,
    878797,
    768788,
    777776,
    877999,
    798987,
    867978,
    897887,
    787997,
    969697,
    777689,
    777977,
    789797,
    788777,
    668867,
    788887,
    868977,
    999779,
    888787,
    887678,
    788888,
    777787,
    887778,
    778888,
    987879,
    668777,
    886779,
    798877,
    789997,
    686877,
    997888,
    898987,
    977778,
    868788,
    788878,
    767787,
    788897,
    779788,
    887788,
    878878,
    797979,
    879997,
    976968,
    677778,
    988888,
    778876,
    888868,
    788768,
    779879,
    898789,
    787768,
    986876,
    778878,
    879877,
    897779,
    898978,
    889788,
    889686,
    688798,
    779777,
    899878,
    999879,
    668769,
    789766,
    778977,
    878998,
    987889,
    787797,
    878778,
    888798,
    898798,
    879988,
    788899,
    699979,
    777898,
    988776,
    888987,
    777988,
    789777,
    779878,
    787986,
    877886,
    969976,
    777968,
    999878,
    999787,
    987889,
    778888,
    978789,
    887877,
    889898,
    987878,
    888898,
    878888,
    867888,
    778687,
    777698,
    897977,
    866788,
    987887,
    767788,
    898969,
    998779,
    789788,
    887778,
    779878,
    879898,
    777778,
    877767,
    776787,
    898779,
    898978,
    787986,
    989887,
    697887,
    888998,
    898887,
    698879,
    788897,
    976798,
    789788,
    798788,
    877877,
    878988,
    788988,
    777887,
    977877,
    776889,
    788889,
    987777,
    788877,
    988788,
    788789,
    779868,
    898697,
    788788,
    787776,
    787888,
    899977,
    898778,
    777987,
    869888,
    778896,
    888778,
    897788,
    867777,
    777899,
    888697,
    778876,
    798678,
    899978,
    777788,
    789798,
    799987,
    898877,
    877788,
    868988,
    777788,
    688887,
    889988,
    998777,
    888877,
    698897,
    989976,
    789888,
    878799,
    778798,
    988667,
    878686,
    767887,
    889877,
    888878,
    887888,
    886886,
    888877,
    877888,
    787898,
    989988,
    999878,
    878677,
    886668,
    977687,
    977888,
    878778,
    878888,
    697878,
    787776,
    878877,
    688879,
    888978,
    988978,
    878888,
    878978,
    789887,
    888797,
    768887,
    899767,
    889788,
    889987,
    879888,
    988778,
    888878,
    888979,
    988797,
    988778,
    699778,
    989889,
    788987,
    988688,
    978988,
    888787,
    898687,
    779887,
    687787,
    987877,
    987888,
    677769,
    989778,
    878798,
    868797,
    878888,
    787779,
    766968,
    888867,
    878789,
    968979,
    877897,
    778998,
    797897,
    879888,
    678788,
    787867,
    788688,
    988888,
    797879,
    878887,
    968898,
    898988,
    878899,
    777888,
    898877,
    877788,
    877866,
    789988,
    879869,
    677887,
    997889,
    989888,
    699887,
    677987,
    788887,
    799989,
    879699,
    888879,
    997779,
    887997,
    888988,
    877889,
    787678,
    777787,
    889888,
    898877,
    877788,
    868988,
    988797,
    878778,
    878888,
    877888,
    788887,
    687899,
    787699,
    888786,
    789886,
    879678,
    887976,
    988988,
    788888,
    889996,
    877698,
    888787,
    887979,
    889788,
    977679,
    887888,
    798799,
    868998,
    777978,
    888799,
    899877,
    987689,
    877888,
    997899,
    878668,
    679878,
    778986,
    877787,
    788898,
    898886,
    798878,
    987797,
    788877,
    998778,
    878777,
    988976,
    868778,
    898779,
    786788,
    888887,
    787788,
    789798,
    878888,
    979978,
    889898,
    676777,
    787888,
    887778,
    888888,
    987987,
    887979,
    787788,
    786767,
    978877,
    798977,
    698687,
    978788,
    797888,
    878787,
    878789,
    889978,
    767988,
    696778,
    868797,
    797879,
    777887,
    978778,
    788967,
    877878,
    988976,
    878779,
    889979,
    789678,
    689887,
    888788,
    777787,
    899987,
    788777,
    878989,
    686888,
    998897,
    878987,
    979788,
    786888,
    867897,
    897878,
    788778,
    977878,
    998889,
    887876,
    978897,
    799996,
    879987,
    899987,
    968797,
    788977,
    887987,
    978896,
    886887,
    686777,
    778698,
    987888,
    777796,
    787997,
    678997,
    888888,
    798886,
    889868,
    988988,
    798778,
    787798,
    878878,
    767987,
    877877,
    797987,
    868788,
    769777,
    777796,
    978877,
    889878,
    678877,
    789786,
    997966,
    988868,
    999878,
    987887,
    788867,
    797887,
    768678,
    896988,
    788889,
    788878,
    678888,
    767879,
    888888,
    778987,
    898797,
    987888,
    878897,
    879898,
    988977,
    988888,
    779788,
    898987,
    787789,
    897988,
    998898,
    787967,
    898668,
    878888,
    888877,
    887797,
    789889,
    989878,
    999877,
    798979,
    877987,
    977979,
    778788,
    878879,
    889878,
    777687,
    889887,
    887788,
    786688,
    777897,
    878877,
    979888,
    787777,
    978886,
    896777,
    989877,
    788778,
    789988,
    788897,
    969797,
    988877,
    777998,
    979878,
    979868,
    778988,
    988889,
    888797,
    889877,
    688978,
    778689,
    788798,
    879989,
    989678,
    886797,
    998997,
    868889,
    997987,
    989787,
    797768,
    979798,
    987877,
    677887,
    688898,
    887988,
    968978,
    899897,
    899999,
    768677,
    777698,
    987889,
    779698,
    887789,
    888889,
    878887,
    768898,
    789789,
    697988,
    797789,
    997878,
    876789,
    778778,
    887879,
    888878,
    789867,
    797967,
    778978,
    878897,
    967978,
    989988,
    887987,
    699687,
    967898,
    689777,
    896877,
    799778,
    887778,
    778868,
    899876,
    788897,
    877678,
    678787,
    878888,
    888978,
    987888,
    868778,
    778787,
    877977,
    887979,
    986877,
    898879,
    789778,
    887777,
    987987,
    978778,
    897888,
    988788,
    668798,
    877998,
    777778,
    988888,
    887789,
    878969,
    688869,
    986988,
    879788,
    887789,
    987988,
    779979,
    978778,
    789868,
    888767,
    897888,
    997888,
    698888,
    789787,
    768786,
    778886,
    887877,
    887787,
    786678,
    798779,
    788998,
    888987,
    798888,
    888787,
    788987,
    898878,
    889677,
    798888,
    888977,
    988798,
    987978,
    798997,
    879899,
    978698,
    896878,
    897878,
    887888,
    797888,
    977879,
    878779,
    878788,
    787878,
    787687,
    979867,
    867698,
    887876,
    886898,
    678978,
    778779,
    788789,
    887688,
    889989,
    996897,
    977987,
    888778,
    887897,
    988987,
    788898,
    897898,
    899777,
    877888,
    988988,
    878888,
    787898,
    876978,
    987798,
    886787,
    998989,
    977986,
    778799,
    687788,
    687768,
    768878,
    887888,
    897687,
    777897,
    877778,
    786898,
    786788,
    888997,
    988977,
    877887,
    978998,
    877789,
    889978,
    888889,
    778789,
    776889,
    798879,
    887988,
    878988,
    867788,
    978787,
    988678,
    997688,
    777877,
    787877,
    788887,
    779887,
    778689,
    789867,
    879779,
    898677,
    887788,
    788779,
    788778,
    887877,
    787678,
    786978,
    968878,
    888888,
    888888,
    978887,
    897777,
    878989,
    968887,
    876887,
    677877,
    887898,
    787789,
    769788,
    797777,
    697678,
    868999,
    877999,
    878787,
    867978,
    778978,
    788878,
    778899,
    889877,
    797786,
    797698,
    878787,
    877888,
    797786,
    878887,
    889998,
    698897,
    869888,
    877799,
    877879,
    878777,
    787999,
    988987,
    977986,
    878778,
    777797,
    978898,
    778686,
    977788,
    697698,
    887988,
    788879,
    688987,
    877988,
    798687,
    799889,
    778877,
    878878,
    998797,
    887687,
    777998,
    879888,
    798988,
    888789,
    888877,
    887698,
    997879,
    879778,
    887989,
    878979,
    786898,
    877898,
    998878,
    987968,
    778887,
    877877,
    886778,
    787988,
    996888,
    877868,
    688899,
    987777,
    778668,
    878888,
    888778,
    988778,
    778888,
    788778,
    887877,
    888777,
    888989,
    777877,
    778778,
    998778,
    896778,
    887799,
    988886,
    867888,
    978898,
    799687,
    777788,
    797789,
    878677,
    787798,
    698897,
    878787,
    678888,
    787988,
    777668,
    878888,
    889877,
    778878,
    879789,
    877888,
    898889,
    788889,
    788897,
    887979,
    788688,
    988767,
    897877,
    778777,
    888867,
    888887,
    698779,
    978976,
    766768,
    796879,
    888797,
    778788,
    899778,
    787797,
    799989,
    999877,
    899887,
    788698,
    797977,
    989887,
    787967,
    887889,
    888779,
    998978,
    978787,
    879779,
    889899,
    788988,
    678987,
    968978,
    888678,
    877777,
    897978,
    786797,
    887688,
    976898,
    889887,
    887787,
    888878,
    799798,
    888887,
    788867,
    888798,
    877878,
    878889,
    788898,
    787878,
    897688,
    797878,
    898778,
    898878,
    767978,
    876888,
    788876,
    878889,
    779889,
    978778,
    788898,
    879778,
    777797,
    767777,
    878888,
    987888,
    686777,
    898798,
    877869,
    898898,
    889887,
    777788,
    878899,
    898897,
    888778,
    799988,
    887778,
    886978,
    998889,
    998877,
    877869,
    876689,
    979888,
    996779,
    997877,
    788988,
    887887,
    798788,
    788778,
    789888,
    868878,
    887989,
    787889,
    887788,
    978779,
    899888,
    768689,
    797988,
    799989,
    878788,
    879788,
    878768,
    889888,
    888887,
    677978,
    887688,
    799797,
    878888,
    977777,
    979788,
    878788,
    978787,
    978888,
    798798,
    877868,
    688887,
    878678,
    878889,
    698887,
    879899,
    689968,
    968987,
    887887,
    889777,
    877899,
    889889,
    877787,
    769888,
    688789,
    878888,
    877878,
    877788,
    877877,
    897888,
    668887,
    788888,
    798997,
    677898,
    877899,
    868898,
    878887,
    877997,
    887888,
    798986,
    978776,
    876888,
    788877,
    878778,
    788898,
    987878,
    888986,
    787896,
    788799,
    777779,
    777787,
    789767,
    877697,
    788987,
    887898,
    879868,
    988798,
    778686,
    887889,
    777888,
    988688,
    987888,
    788877,
    888987,
    779787,
    877877,
    787799,
    898788,
    869797,
    978979,
    887888,
    987898,
    788868,
    877887,
    788999,
    798878,
    788678,
    987798,
    998987,
    877768,
    799798,
    777878,
    868698,
    979888,
    987877,
    977988,
    879977,
    988877,
    987776,
    897778,
    889788,
    887789,
    789887,
    698777,
    887887,
    778897,
    889897,
    988799,
    789889,
    688878,
    878887,
    878876,
    666978,
    787788,
    898786,
    779777,
    799978,
    879787,
    787878,
    799688,
    868769,
    886798,
    977898,
    998897,
    788897,
    777989,
    777777,
    787876,
    988888,
    788878,
    887679,
    987779,
    787687,
    898878,
    988777,
    878888,
    779788,
    787897,
    987799,
    868788,
    898986,
    867899,
    876788,
    688998,
    697978,
    779888,
    889897,
    878997,
    878897,
    788787,
    886788,
    987898,
    877967,
    878779,
    789988,
    697979,
    979888,
    897898,
    878788,
    787988,
    777896,
    998788,
    887997,
    798978,
    776778,
    798787,
    887787,
    988888,
    887988,
    787788,
    978988,
    888776,
    788879,
    888796,
    989888,
    877878,
    768889,
    887987,
    889986,
    998987,
    877878,
    678986,
    878799,
    788888,
    897779,
    988898,
    887689,
    988887,
    878877,
    787888,
    877777,
    888888,
    677978,
    898777,
    787898,
    988786,
    878788,
    989799,
    888766,
    777876,
    886989,
    867887,
    869778,
    877788,
    976887,
    889898,
    689889,
    878678,
    968787,
    788776,
    977988,
    889787,
    777797,
    878789,
    799778,
    897977,
    888788,
    887877,
    989898,
    887887,
    969887,
    999987,
    868687,
    696799,
    789777,
    877786,
    897899,
    878988,
    877798,
    778887,
    788898,
    897878,
    678788,
    877897,
    879888,
    787788,
    668788,
    987877,
    668889,
    686887,
    968876,
    778677,
    777798,
    789999,
    878777,
    889898,
    868898,
    869887,
    897879,
    799887,
    889787,
    877688,
    778798,
    788988,
    788978,
    997868,
    769698,
    877788,
    897778,
    988877,
    788778,
    796798,
    788888,
    898878,
    998978,
    988988,
    679978,
    899876,
    767988,
    969788,
    799889,
    897989,
    788779,
    778886,
    896987,
    897986,
    788667,
    797898,
    888799,
    976888,
    779778,
    888888,
    877786,
    789788,
    868788,
    797789,
    877888,
    899978,
    777777,
    888888,
    786978,
    897888,
    888966,
    788889,
    777889,
    788889,
    777788,
    977879,
    787777,
    778797,
    777879,
    888989,
    799888,
    788968,
    778777,
    787788,
    778889,
    988989,
    887888,
    898777,
    887987,
    787668,
    878878,
    787788,
    797989,
    786977,
    778878,
    988977,
    687988,
    689887,
    688777,
    898797,
    869888,
    799878,
    788968,
    688779,
    887778,
    789788,
    697978,
    878987,
    787878,
    998977,
    778998,
    998698,
    787697,
    889777,
    887888,
    787989,
    778776,
    977798,
    877789,
    797798,
    988968,
    789778,
    978697,
    898779,
    777787,
    789789,
    889768,
    767889,
    877988,
    797778,
    787878,
    877778,
    987778,
    786877,
    778767,
    777788,
    878787,
    678889,
    877987,
    888787,
    788799,
    997798,
    668887,
    888788,
    788977,
    888898,
    868977,
    987889,
    878879,
    988878,
    877877,
    776898,
    997869,
    898987,
    877886,
    788789,
    768797,
    898986,
    887889,
    787889,
    697896,
    878887,
    877879,
    789798,
    778888,
    778797,
    798787,
    897897,
    899878,
    786877,
    887786,
    787887,
    978888,
    677777,
    688788,
    789767,
    898797,
    889778,
    678978,
    788776,
    777768,
    887879,
    978888,
    899888,
    877687,
    798888,
    788877,
    877899,
    887878,
    868788,
    976998,
    888888,
    788877,
    789787,
    878987,
    879879,
    877887,
    988998,
    897868,
    897979,
    878767,
    789879,
    888967,
    997888,
    867879,
    799787,
    788868,
    868798,
    788787,
    789779,
    789778,
    878778,
    976898,
    887998,
    767879,
    887788,
    797877,
    897977,
    976868,
    776799,
    879879,
    787678,
    886788,
    767987,
    888877,
    988777,
    878888,
    977899,
    987789,
    997897,
    877899,
    997879,
    798989,
    888887,
    779887,
    987777,
    686786,
    787889,
    986998,
    878888,
    888986,
    786777,
    967879,
    789787,
    867887,
    869998,
    768978,
    879877,
    878878,
    977888,
    997786,
    977688,
    777998,
    889888,
    888887,
    888787,
    787766,
    789976,
    887869,
    787898,
    887799,
    988878,
    678888,
    898987,
    989877,
    988869,
    888797,
    998977,
    679796,
    787887,
    888888,
    897869,
    799777,
    888897,
    898878,
    799889,
    789787,
    878898,
    778788,
    778878,
    788868,
    777787,
    779678,
    897888,
    888977,
    989987,
    868778,
    979777,
    788888,
    878997,
    877888,
    896786,
    887976,
    777979,
    766978,
    898787,
    688998,
    888887,
    698989,
    777878,
    999778,
    786776,
    786887,
    878888,
    788977,
    787987,
    788677,
    978877,
    678779,
    886867,
    889888,
    898887,
    787779,
    877797,
    988878,
    969799,
    886987,
    877699,
    987798,
    797888,
    788777,
    978889,
    799888,
    887888,
    887869,
    767796,
    876687,
    998978,
    997789,
    688789,
    977788,
    998888,
    998888,
    688787,
    887879,
    899889,
    877899,
    887888,
    889888,
    689989,
    777776,
    877978,
    898888,
    897978,
    778788,
    797898,
    898777,
    798867,
    998898,
    677879,
    796877,
    898786,
    789889,
    797997,
    679967,
    877677,
    868878,
    977889,
    897777,
    887878,
    788888,
    979789,
    766878,
    997787,
    779878,
    879997,
    687879,
    898867,
    898777,
    877777,
    898788,
    788668,
    898876,
    878878,
    889788,
    897887,
    889887,
    788879,
    779777,
    877887,
    877789,
    977887,
    898889,
    888897,
    877797,
    777969,
    769887,
    879889,
    989789,
    789687,
    888978,
    798989,
    879988,
    686887,
    976788,
    887988,
    898888,
    798887,
    898896,
    778898,
    788778,
    887899,
    778896,
    898989,
    887887,
    789988,
    978987,
    777768,
    888898,
    787998,
    877787,
    779877,
    898897,
    998877,
    869967,
    978988,
    888797,
    987788,
    887788,
    976797,
    887978,
    989986,
    987679,
    777898,
    999897,
    898997,
    798888,
    989868,
    968798,
    877889,
    688977,
    997887,
    898778,
    877787,
    877986,
    879888,
    777988,
    687998,
    888889,
    677977,
    776999,
    769986,
    987888,
    887686,
    789999,
    798869,
    877788,
    787887,
    888898,
    978897,
    988779,
    789878,
    877888,
    887877,
    978887,
    986768,
    778687,
    789997,
    979866,
    899897,
    868899,
    879887,
    878888,
    889777,
    788898,
    897898,
    777878,
    897978,
    888899,
    788877,
    869887,
    877879,
    786887,
    777888,
    788987,
    977888,
    868989,
    777779,
    796788,
    877797,
    896677,
    879788,
    989776,
    867777,
    999889,
    678888,
    888978,
    887887,
    897988,
    789989,
    878788,
    878788,
    888897,
    897899,
    888796,
    989878,
    767878,
    979967,
    878799,
    988889,
    678778,
    899977,
    677877,
    897977,
    778898,
    898977,
    967768,
    889787,
    968877,
    788888,
    778779,
    789788,
    686778,
    877798,
    879797,
    868978,
    888887,
    877897,
    877898,
    888998,
    778888,
    797799,
    898697,
    978788,
    878698,
    878878,
    887776,
    778988,
    879989,
    988887,
    989878,
    879988,
    798778,
    779788,
    777897,
    886887,
    897799,
    897978,
    876788,
    878798,
    887988,
    978798,
    777788,
    996887,
    887898,
    978677,
    997898,
    786878,
    887777,
    787788,
    889687,
    786897,
    879898,
    778979,
    768798,
    687888,
    968878,
    878798,
    878878,
    667688,
    798897,
    887977,
    678777,
    898988,
    877778,
    788966,
    977978,
    878777,
    797778,
    877887,
    979899,
    878888,
    778897,
    788879,
    779986,
    978897,
    867876,
    776888,
    877777,
    987779,
    886797,
    887998,
    797987,
    786877,
    877888,
    897888,
    898798,
    867898,
    988778,
    886987,
    898887,
    977987,
    888997,
    987887,
    787888,
    887879,
    878788,
    797897,
    989778,
    767887,
    767898,
    798788,
    777797,
    888786,
    688787,
    777889,
    788787,
    797878,
    779998,
    777776,
    799877,
    889798,
    679788,
    878888,
    887988,
    687998,
    988778,
    788777,
    979879,
    887876,
    986788,
    987779,
    789877,
    989869,
    788776,
    789979,
    679988,
    877787,
    887889,
    887787,
    889887,
    778888,
    787898,
    787889,
    987886,
    778878,
    877979,
    897888,
    987887,
    888867,
    679967,
    969777,
    897887,
    987979,
    767787,
    777877,
    877899,
    868887,
    897989,
    797789,
    998779,
    779988,
    877778,
    789877,
    878988,
    899779,
    898978,
    988687,
    988777,
    779778,
    897888,
    888879,
    777969,
    978878,
    997988,
    778677,
    898787,
    888879,
    878778,
    896898,
    878887,
    888989,
    888898,
    886979,
    787998,
    988786,
    888889,
    688789,
    877887,
    899779,
    967878,
    787787,
    888989,
    688798,
    889879,
    676996,
    798798,
    979889,
    876888,
    787978,
    697877,
    987978,
    988868,
    978977,
    987987,
    968777,
    899878,
    997987,
    778887,
    887787,
    876778,
    998677,
    779788,
    988777,
    888877,
    677876,
    966986,
    987699,
    889979,
    799679,
    789888,
    876677,
    888688,
    887898,
    787788,
    767998,
    897778,
    699797,
    868878,
    788888,
    869898,
    778899,
    877988,
    676876,
    778887,
    989899,
    888887,
    787887,
    887889,
    898777,
    887896,
    986787,
    787888,
    986788,
    977878,
    987777,
    899797,
    869866,
    888689,
    898879,
    998878,
    879798,
    898888,
    798898,
    888988,
    878989,
    968887,
    867788,
    988868,
    898898,
    878888,
    878878,
    878887,
    877888,
    878879,
    989999,
    978878,
    787897,
    878887,
    977678,
    977988,
    886887,
    888966,
    888768,
    797778,
    798788,
    887887,
    777777,
    998876,
    787878,
    978786,
    887787,
    788988,
    978887,
    877787,
    877688,
    889896,
    799788,
    887877,
    876776,
    996787,
    978978,
    997888,
    897979,
    797778,
    869877,
    787778,
    887787,
    889888,
    897888,
    778988,
    788989,
    989888,
    878768,
    687987,
    698888,
    877788,
    787996,
    998777,
    788897,
    996778,
    687979,
    797688,
    877867,
    788987,
    988988,
    878899,
    778987,
    886878,
    777678,
    997789,
    797777,
    788779,
    889787,
    777979,
    699877,
    887688,
    897887,
    777688,
    887777,
    888798,
    867798,
    997887,
    997887,
    887887,
    787779,
    677777,
    967888,
    868979,
    778777,
    898888,
    669798,
    897987,
    687777,
    897978,
    788879,
    888878,
    877898,
    988877,
    987877,
    866789,
    778988,
    778977,
    777879,
    978697,
    797876,
    776878,
    787797,
    786886,
    987787,
    779798,
    977798,
    879789,
    988898,
    889797,
    897888,
    978879,
    876897,
    887889,
    987996,
    878898,
    888987,
    778877,
    879997,
    876888,
    898987,
    778988,
    778877,
    877987,
    977789,
    887998,
    676888,
    997868,
    679788,
    788788,
    797889,
    979798,
    877788,
    788888,
    779878,
    887878,
    876887,
    787876,
    878888,
    887988,
    988888,
    878777,
    787877,
    888798,
    879787,
    879698,
    888997,
    888777,
    887879,
    977878,
    769988,
    888878,
    888889,
    768877,
    789788,
    897887,
    878878,
    788886,
    776887,
    778799,
    877787,
    878988,
    787877,
    897888,
    988888,
    767879,
    688798,
    897988,
    988888,
    977788,
    786769,
    887787,
    897789,
    876768,
    997896,
    696869,
    877897,
    967777,
    788887,
    998889,
    787788,
    769877,
    878897,
    888778,
    886877,
    777787,
    788777,
    988777,
    979877,
    988888,
    887687,
    888977,
    887878,
    869878,
    788878,
    798787,
    799977,
    877878,
    868787,
    888978,
    878777,
    887989,
    867889,
    978788,
    798987,
    797988,
    788877,
    886778,
    778788,
    888967,
    888887,
    888877,
    788879,
    979687,
    788999,
    777898,
    887899,
    798787,
    988898,
    967877,
    688798,
    888897,
    888898,
    996889,
    787867,
    786787,
    877799,
    788778,
    879879,
    678987,
    788788,
    897987,
    778887,
    767798,
    989898,
    897789,
    887777,
    789888,
    879687,
    767877,
    779876,
    889977,
    889978,
    889987,
    887788,
    977777,
    988967,
    888888,
    788778,
    887868,
    876787,
    888999,
    778796,
    798789,
    986697,
    897987,
    678978,
    778678,
    887987,
    798789,
    797778,
    887897,
    989778,
    788896,
    977867,
    967876,
    898978,
    997878,
    979897,
    687877,
    788898,
    967986,
    768878,
    787787,
    868799,
    968888,
    779887,
    976777,
    989887,
    788867,
    797778,
    998978,
    798797,
    887979,
    878788,
    988978,
    788888,
    987978,
    887787,
    677989,
    889786,
    787877,
    688888,
    887889,
    877777,
    888987,
    888777,
    888886,
    767979,
    868897,
    788789,
    867888,
    778888,
    898779,
    776978,
    798778,
    989968,
    887797,
    789888,
    798687,
    978977,
    978786,
    888978,
    688867,
    977889,
    789976,
    889999,
    987886,
    889776,
    889779,
    779789,
    777977,
    898878,
    698887,
    787987,
    886978,
    988878,
    679988,
    887888,
    888888,
    877778,
    989877,
    899978,
    888786,
    898977,
    676896,
    877889,
    789698,
    879878,
    899978,
    899797,
    879978,
    879887,
    877898,
    777877,
    868888,
    888887,
    797969,
    696988,
    887867,
    977887,
    778786,
    998779,
    799879,
    988898,
    888988,
    876886,
    888877,
    778788,
    988978,
    798798,
    888876,
    888879,
    777867,
    778687,
    886987,
    787978,
    788768,
    968887,
    698988,
    978687,
    889778,
    787888,
    677969,
    997987,
    877788,
    888878,
    688977,
    777699,
    977888,
    877786,
    887977,
    768997,
    877877,
    688777,
    878897,
    897788,
    777699,
    887787,
    777888,
    787978,
    779779,
    876697,
    888777,
    788788,
    978887,
    778897,
    778877,
    988787,
    888787,
    786987,
    788797,
    697777,
    978986,
    898878,
    797977,
    868779,
    878886,
    989888,
    787977,
    788798,
    877877,
    976666,
    779989,
    777997,
    688989,
    977998,
    889878,
    788978,
    768887,
    786776,
    768877,
    768788,
    988668,
    778877,
    888789,
    887879,
    789979,
    777888,
    977986,
    798878,
    787788,
    879879,
    879888,
    777788,
    676887,
    789878,
    877997,
    987878,
    868787,
    977779,
    877798,
    779978,
    787767,
    889978,
    868888,
    679887,
    888788,
    887878,
    788877,
    878998,
    778677,
    778888,
    879979,
    979878,
    878889,
    988888,
    887987,
    787887,
    877987,
    878777,
    987977,
    797889,
    886679,
    768797,
    888778,
    778886,
    877787,
    889878,
    889799,
    889988,
    778997,
    888768,
    889888,
    766788,
    896788,
    988997,
    877878,
    777878,
    777888,
    677978,
    788787,
    989987,
    977777,
    867998,
    777779,
    799878,
    787879,
    888796,
    997898,
    887899,
    878799,
    889997,
    778686,
    997778,
    988778,
    878878,
    779877,
    998787,
    788788,
    878787,
    978977,
    877787,
    899777,
    889876,
    888887,
    897778,
    988787,
    888888,
    879777,
    779997,
    878888,
    877887,
    786977,
    889798,
    979788,
    878778,
    987868,
    779966,
    878887,
    797988,
    778777,
    787789,
    978768,
    878988,
    897888,
    678787,
    877888,
    798688,
    868787,
    779787,
    868898,
    887877,
    889799,
    999966,
    886789,
    889869,
    999898,
    788879,
    878979,
    989869,
    786877,
    966997,
    888788,
    799877,
    888878,
    768777,
    898979,
    879888,
    888767,
    986897,
    997767,
    888898,
    987769,
    888977,
    677787,
    878887,
    779887,
    886887,
    887878,
    878887,
    799877,
    878677,
    788987,
    788888,
    899887,
    788777,
    987777,
    887888,
    787777,
    888977,
    786788,
    797887,
    998798,
    888878,
    888879,
    888777,
    788898,
    688789,
    988777,
    887887,
    986789,
    678877,
    887888,
    777998,
    689797,
    887988,
    886989,
    896898,
    798788,
    789988,
    787699,
    986989,
    867678,
    887888,
    868998,
    898779,
    776879,
    799888,
    878778,
    878987,
    798888,
    787789,
    888998,
    788987,
    989879,
    966887,
    988677,
    789677,
    798999,
    996887,
    998887,
    879987,
    779887,
    698979,
    996896,
    888888,
    769888,
    766887,
    797997,
    796977,
    787867,
    778888,
    997678,
    886798,
    878878,
    978996,
    778777,
    889787,
    687878,
    886877,
    788988,
    878888,
    988789,
    978787,
    878898,
    979976,
    897996,
    888787,
    679889,
    989689,
    778877,
    799968,
    888777,
    899888,
    887889,
    779879,
    868869,
    879888,
    778797,
    888787,
    987778,
    797787,
    898888,
    877898,
    888677,
    778778,
    798877,
    988988,
    887887,
    778777,
    898877,
    798788,
    989868,
    766978,
    989878,
    898777,
    787998,
    779868,
    898899,
    898897,
    898878,
    877878,
    978888,
    889898,
    688887,
    987788,
    898988,
    979987,
    778887,
    868897,
    798888,
    789697,
    887789,
    797887,
    977878,
    979988,
    789998,
    889988,
    976867,
    787979,
    986987,
    877787,
    986678,
    777688,
    668889,
    689987,
    786988,
    878677,
    787786,
    996787,
    898888,
    798688,
    778888,
    978968,
    888788,
    877877,
    787988,
    789987,
    978688,
    978778,
    888997,
    997676,
    886979,
    898787,
    978898,
    788988,
    778886,
    888988,
    868788,
    977798,
    987678,
    897898,
    978868,
    968999,
    898788,
    788887,
    768778,
    788897,
    978767,
    977798,
    868787,
    888888,
    878789,
    898897,
    888867,
    877699,
    996887,
    877787,
    978878,
    777798,
    869778,
    989896,
    886768,
    878978,
    899779,
    798768,
    798787,
    878887,
    878787,
    888898,
    888977,
    876997,
    888888,
    997689,
    777878,
    897789,
    787799,
    878688,
    879977,
    786989,
    788988,
    878678,
    889988,
    788977,
    779778,
    767988,
    788677,
    877888,
    887786,
    789878,
    887889,
    988797,
    878886,
    998777,
    978778,
    896677,
    687987,
    787888,
    788877,
    979977,
    897778,
    998677,
    767999,
    879798,
    987989,
    878989,
    888769,
    977779,
    788898,
    799989,
    887788,
    788978,
    879867,
    889788,
    998987,
    867777,
    679989,
    888888,
    887877,
    698898,
    789888,
    767877,
    988978,
    887977,
    887977,
    879888,
    897789,
    877776,
    787787,
    688968,
    789786,
    877898,
    988687,
    888899,
    987788,
    888789,
    898989,
    867887,
    887888,
    898987,
    768777,
    787778,
    786878,
    887888,
    878878,
    769999,
    878788,
    898998,
    978789,
    887889,
    886898,
    988787,
    777986,
    778687,
    789898,
    697788,
    776977,
    888887,
    786878,
    788889,
    978888,
    777778,
    677978,
    886999,
    767797,
    877888,
    778788,
    798788,
    878889,
    788787,
    886899,
    977789,
    787968,
    777789,
    789988,
    777897,
    978788,
    788779,
    889887,
    897788,
    898787,
    987797,
    898778,
    878888,
    976878,
    867777,
    788778,
    878776,
    887788,
    687869,
    898786,
    878878,
    789998,
    788877,
    887998,
    887686,
    787879,
    789778,
    899898,
    899987,
    789777,
    676976,
    888878,
    987797,
    888778,
    887789,
    878787,
    867878,
    988878,
    887898,
    787778,
    887899,
    878677,
    687787,
    988788,
    798887,
    768887,
    797897,
    777788,
    887889,
    969888,
    777777,
    888987,
    788779,
    778988,
    778896,
    978878,
    777897,
    788988,
    987777,
    768788,
    978988,
    988889,
    797678,
    978999,
    788899,
    779788,
    787797,
    778869,
    779687,
    877877,
    878878,
    898789,
    778678,
    776876,
    888777,
    888679,
    878669,
    786788,
    879789,
    998688,
    688887,
    879968,
    789897,
    877778,
    887798,
    897987,
    787789,
    987878,
    879788,
    778789,
    886778,
    877789,
    778686,
    989777,
    898797,
    977989,
    878887,
    888899,
    768897,
    888987,
    677886,
    777987,
    788988,
    989879,
    987898,
    897978,
    778789,
    878778,
    787976,
    789998,
    777788,
    986898,
    888877,
    777888,
    899868,
    798678,
    887998,
    788778,
    888879,
    868889,
    878888,
    788978,
    999798,
    988987,
    889898,
    778688,
    787799,
    977898,
    979886,
    789788,
    876887,
    789886,
    878697,
    988778,
    888989,
    879987,
    879777,
    878878,
    888989,
    866897,
    888977,
    888988,
    888878,
    889668,
    998877,
    778778,
    868868,
    889878,
    888968,
    789768,
    887777,
    798786,
    888986,
    777878,
    987899,
    667888,
    787688,
    789988,
    798887,
    688777,
    777978,
    877878,
    997887,
    798888,
    777786,
    889778,
    887878,
    878976,
    688997,
    977887,
    788897,
    789776,
    789888,
    777698,
    998999,
    677888,
    679688,
    978997,
    986787,
    887899,
    779879,
    987788,
    878887,
    777879,
    688897,
    988867,
    888899,
    787977,
    879789,
    998888,
    897997,
    878788,
    878887,
    988886,
    967899,
    789788,
    987688,
    988799,
    988797,
    878677,
    886787,
    878976,
    977888,
    878798,
    766976,
    888888,
    878878,
    779779,
    888887,
    989897,
    878787,
    688889,
    879998,
    889788,
    978878,
    888887,
    987878,
    887778,
    888979,
    687798,
    867798,
    797787,
    888878,
    776899,
    798998,
    888777,
    889797,
    878888,
    798978,
    768889,
    778889,
    968677,
    788886,
    978977,
    776999,
    788888,
    968878,
    768888,
    978877,
    799778,
    767888,
    877777,
    867888,
    968878,
    999878,
    779797,
    898876,
    777968,
    887888,
    888987,
    976786,
    786977,
    889888,
    787769,
    888886,
    888877,
    987878,
    778878,
    779878,
    878769,
    978879,
    688999,
    887698,
    788798,
    776868,
    979989,
    779888,
    887888,
    689878,
    887888,
    788886,
    777789,
    787988,
    878988,
    789878,
    978976,
    877978,
    798798,
    989878,
    779988,
    889877,
    899686,
    887978,
    777978,
    869968,
    879778,
    878878,
    799979,
    889797,
    998688,
    778799,
    899987,
    888888,
    867989,
    977889,
    788887,
    988888,
    778778,
    697778,
    777876,
    889888,
    697988,
    889797,
    878988,
    797688,
    767799,
    788897,
    997688,
    787767,
    898867,
    888889,
    788689,
    797787,
    898798,
    878778,
    978778,
    988897,
    878888,
    779978,
    979889,
    968877,
    787896,
    887788,
    888876,
    778798,
    888889,
    799789,
    789896,
    888776,
    888788,
    787898,
    786988,
    787888,
    788778,
    877878,
    787868,
    767786,
    878888,
    777987,
    787998,
    789988,
    887788,
    798887,
    978867,
    988978,
    879777,
    896878,
    689887,
    797877,
    898888,
    788799,
    977667,
    787776,
    887799,
    777889,
    877888,
    898677,
    978789,
    977787,
    777979,
    888678,
    787888,
    797878,
    877789,
    988989,
    697777,
    968888,
    989788,
    888779,
    678799,
    978799,
    869887,
    897877,
    897779,
    969998,
    978898,
    987787,
    796879,
    778788,
    889899,
    899787,
    887878,
    787799,
    876988,
    988789,
    887889,
    867886,
    987787,
    887878,
    886996,
    979789,
    897678,
    678988,
    688689,
    889869,
    987877,
    978777,
    898787,
    887787,
    797878,
    998868,
    968888,
    869889,
    788688,
    977897,
    888887,
    687887,
    898778,
    766789,
    799897,
    789798,
    888778,
    798778,
    978877,
    977668,
    877978,
    897787,
    799889,
    798877,
    689798,
    777678,
    799778,
    988987,
    798886,
    877878,
    787787,
    898888,
    878878,
    887888,
    977988,
    769787,
    898969,
    978787,
    786787,
    988788,
    998887,
    888878,
    778977,
    669798,
    888978,
    787988,
    868897,
    789889,
    879977,
    897799,
    787888,
    978788,
    676969,
    997797,
    888979,
    787898,
    787897,
    878877,
    678799,
    768899,
    898888,
    987777,
    898678,
    888987,
    797899,
    878896,
    888888,
    779978,
    886886,
    899889,
    979989,
    898787,
    977877,
    897787,
    897888,
    898998,
    879897,
    889777,
    989888,
    977987,
    779979,
    779988,
    868877,
    898888,
    988986,
    886788,
    886897,
    778778,
    889878,
    888797,
    988867,
    899889,
    878797,
    776778,
    878887,
    988789,
    887788,
    887888,
    887889,
    988778,
    877887,
    888978,
    777988,
    796987,
    897778,
    778887,
    898898,
    987888,
    796788,
    889778,
    788887,
    687788,
    779886,
    877968,
    797878,
    986887,
    899988,
    779888,
    799887,
    989688,
    888897,
    799886,
    978879,
    698868,
    698877,
    778978,
    788789,
    867977,
    799776,
    889888,
    878788,
    897778,
    886779,
    999877,
    898687,
    688888,
    988677,
    878798,
    887977,
    898788,
    789977,
    689787,
    797769,
    887779,
    888878,
    798997,
    889886,
    677887,
    898797,
    896887,
    798897,
    889989,
    987798,
    997798,
    798799,
    878878,
    988778,
    898788,
    887986,
    999879,
    887867,
    879989,
    977879,
    787797,
    876787,
    799789,
    698878,
    779987,
    888998,
    987888,
    886897,
    988998,
    898887,
    877887,
    879889,
    789787,
    988888,
    778888,
    778878,
    778678,
    779888,
    998978,
    888778,
    789887,
    798799,
    787988,
    887888,
    668977,
    789888,
    787778,
    978867,
    887989,
    887788,
    886889,
    878887,
    688877,
    779977,
    889887,
    986787,
    978788,
    799777,
    897777,
    889887,
    869888,
    789988,
    896988,
    988977,
    868978,
    988987,
    888778,
    978899,
    768997,
    767787,
    879768,
    889978,
    988889,
    688878,
    797878,
    777888,
    798989,
    898887,
    988978,
    888977,
    777877,
    899898,
    899886,
    877787,
    898778,
    777899,
    879799,
    869988,
    697788,
    878988,
    988987,
    877778,
    888878,
    898888,
    888989,
    989879,
    879798,
    789877,
    699888,
    689886,
    899877,
    779777,
    677888,
    868898,
    888977,
    767779,
    989978,
    697898,
    899799,
    888988,
    777778,
    986688,
    787868,
    777889,
    889887,
    778877,
    888888,
    877989,
    867788,
    898988,
    878989,
    869698,
    887779,
    887689,
    888877,
    878789,
    787777,
    968888,
    886887,
    676788,
    977788,
    689788,
    877988,
    797797,
    689678,
    767768,
    889968,
    889789,
    788897,
    688876,
    987877,
    868888,
    788799,
    897796,
    887677,
    878778,
    887878,
    777999,
    688897,
    888878,
    887888,
    789888,
    776978,
    699889,
    977988,
    868888,
    987988,
    898698,
    998878,
    866899,
    878797,
    798886,
    796969,
    897798,
    898888,
    868779,
    789879,
    778977,
    886897,
    976977,
    987699,
    998767,
    688889,
    788998,
    977878,
    989979,
    796989,
    878899,
    889878,
    779797,
    679796,
    889977,
    978878,
    798779,
    777997,
    779877,
    889898,
    678989,
    899887,
    878888,
    997797,
    778778,
    887898,
    886797,
    988978,
    977867,
    877988,
    868689,
    978786,
    867877,
    978889,
    776789,
    978889,
    798888,
    888778,
    787898,
    988798,
    888897,
    789789,
    977779,
    787988,
    877888,
    797799,
    689986,
    898887,
    787987,
    798998,
    888996,
    788887,
    876887,
    788977,
    698877,
    899778,
    669788,
    678888,
    777778,
    878878,
    778788,
    797878,
    899778,
    778987,
    977868,
    898967,
    987987,
    999888,
    887989,
    878777,
    978687,
    988888,
    788877,
    798878,
    988787,
    978689,
    768788,
    979888,
    887887,
    999888,
    878987,
    888798,
    997888,
    978787,
    877989,
    787787,
    688799,
    797678,
    897898,
    877779,
    788889,
    987888,
    888878,
    788877,
    977797,
    877868,
    997887,
    896767,
    877988,
    778979,
    667887,
    788978,
    688798,
    898787,
    767787,
    699877,
    888767,
    777878,
    687897,
    877978,
    977877,
    678879,
    977899,
    799889,
    877677,
    877878,
    988788,
    978878,
    878879,
    887687,
    779887,
    878788,
    989889,
    787768,
    789987,
    878878,
    989898,
    899877,
    868977,
    988788,
    898888,
    778778,
    887879,
    988888,
    988787,
    988978,
    797999,
    768797,
    978888,
    889987,
    979879,
    778899,
    889978,
    887888,
    877887,
    976797,
    878886,
    787876,
    779879,
    877898,
    877889,
    797788,
    888779,
    777988,
    877989,
    998898,
    988978,
    677889,
    979778,
    799788,
    978787,
    877788,
    877897,
    787887,
    699778,
    878798,
    967788,
    878788,
    878877,
    799987,
    887989,
    879678,
    897989,
    789796,
    969788,
    888798,
    887798,
    888888,
    789779,
    777878,
    998887,
    999887,
    877897,
    787999,
    786879,
    779798,
    898789,
    979968,
    868797,
    778778,
    777877,
    887788,
    888898,
    889797,
    798877,
    889888,
    868779,
    877787,
    787799,
    877887,
    878788,
    789899,
    878898,
    778888,
    999888,
    787788,
    768787,
    898896,
    777889,
    687887,
    888888,
    788878,
    877987,
    999688,
    986678,
    886988,
    877896,
    789877,
    889778,
    878888,
    779778,
    687998,
    778976,
    877888,
    878899,
    789989,
    897878,
    979969,
    887778,
    879877,
    879887,
    677969,
    967987,
    777978,
    869889,
    997876,
    989788,
    968977,
    778887,
    986878,
    898988,
    787886,
    687788,
    788787,
    887778,
    787878,
    869897,
    978889,
    987877,
    879788,
    969898,
    997969,
    787786,
    688698,
    887778,
    789788,
    778767,
    767877,
    997878,
    988977,
    788778,
    996987,
    789899,
    779768,
    888878,
    776888,
    886877,
    787788,
    787876,
    998777,
    889767,
    776789,
    678988,
    968888,
    987987,
    778978,
    888887,
    797977,
    988876,
    877868,
    777988,
    767888,
    888789,
    889789,
    688879,
    877778,
    788699,
    988788,
    777888,
    968877,
    799888,
    887979,
    678898,
    888989,
    879988,
    887887,
    796787,
    888889,
    768889,
    879768,
    999898,
    787977,
    789799,
    996796,
    777897,
    877789,
    879889,
    879877,
    878898,
    898987,
    888897,
    867889,
    797787,
    889898,
    787788,
    677878,
    888998,
    888886,
    889787,
    677768,
    789999,
    989888,
    978887,
    768897,
    978797,
    886968,
    979888,
    799877,
    988978,
    987686,
    898788,
    886788,
    786676,
    977888,
    778877,
    996788,
    788879,
    789976,
    778799,
    777888,
    879768,
    978786,
    899779,
    888788,
    788888,
    997779,
    689778,
    887889,
    788887,
    878887,
    998789,
    797968,
    888779,
    888788,
    778787,
    877788,
    768786,
    787888,
    768788,
    886889,
    779798,
    776878,
    797787,
    888978,
    887889,
    798888,
    868887,
    779898,
    887788,
    798897,
    988698,
    798878,
    889979,
    787888,
    787967,
    888899,
    787977,
    778789,
    897869,
    897788,
    788889,
    799887,
    888788,
    777889,
    877788,
    889888,
    986887,
    767868,
    868887,
    887887,
    787796,
    898799,
    877879,
    898876,
    987887,
    996877,
    788878,
    678878,
    897988,
    978879,
    767787,
    877787,
    877987,
    897888,
    966678,
    999896,
    688988,
    777687,
    788897,
    897788,
    778788,
    978776,
    977788,
    878889,
    887887,
    899978,
    777898,
    888978,
    987998,
    986778,
    888997,
    988988,
    888788,
    777787,
    787789,
    778797,
    879997,
    779778,
    687968,
    897878,
    998878,
    777679,
    879777,
    767877,
    998898,
    887977,
    788897,
    677887,
    887697,
    988889,
    777989,
    979887,
    789887,
    887987,
    777989,
    788877,
    898987,
    678898,
    887878,
    987989,
    688988,
    878899,
    898788,
    687787,
    779778,
    888769,
    797688,
    777887,
    887777,
    987797,
    898989,
    778788,
    898979,
    789888,
    798798,
    868768,
    898797,
    978898,
    897779,
    888789,
    787879,
    868889,
    886998,
    987886,
    978978,
    788887,
    878977,
    978898,
    888978,
    988878,
    789879,
    878767,
    878867,
    889786,
    889887,
    988888,
    787799,
    979978,
    778797,
    888889,
    697878,
    889688,
    877877,
    789967,
    776878,
    868678,
    798798,
    789798,
    978788,
    777978,
    789878,
    777998,
    879979,
    887888,
    778877,
    989799,
    788787,
    878888,
    988878,
    987878,
    788888,
    788887,
    687989,
    898979,
    997888,
    888788,
    778787,
    997889,
    687887,
    779688,
    889879,
    888979,
    878877,
    998788,
    977788,
    999978,
    769788,
    778678,
    887968,
    888788,
    886777,
    888888,
    868889,
    888878,
    988677,
    787769,
    788788,
    878888,
    888897,
    799789,
    697878,
    998778,
    769887,
    977987,
    787787,
    797778,
    999877,
    889897,
    787888,
    788878,
    898987,
    968978,
    997888,
    877868,
    888887,
    887998,
    899668,
    988876,
    777896,
    997788,
    889888,
    988877,
    879677,
    696877,
    878768,
    897787,
    898777,
    799789,
    988798,
    999898,
    877979,
    977878,
    878877,
    777786,
    679978,
    797886,
    678987,
    879896,
    988977,
    978879,
    877877,
    787897,
    787798,
    788888,
    788987,
    797787,
    988788,
    889787,
    977879,
    869887,
    869778,
    788977,
    778798,
    888978,
    678897,
    788879,
    889886,
    986979,
    977797,
    876989,
    879967,
    888788,
    786887,
    787879,
    877986,
    867897,
    967798,
    867787,
    887767,
    877788,
    898978,
    867889,
    988798,
    987778,
    877688,
    798897,
    869888,
    886888,
    786878,
    887896,
    878688,
    876888,
    887877,
    878799,
    987897,
    787977,
    767898,
    986888,
    978888,
    988888,
    877998,
    988688,
    977678,
    987878,
    886878,
    779877,
    987887,
    988989,
    987779,
    799778,
    898988,
    898887,
    878869,
    777768,
    876698,
    997798,
    888778,
    978888,
    878677,
    979787,
    889778,
    978999,
    887789,
    698887,
    978966,
    789687,
    987978,
    699677,
    888978,
    788887,
    877789,
    997777,
    897887,
    887777,
    799779,
    777898,
    989897,
    987787,
    898689,
    789886,
    897767,
    978877,
    897787,
    876878,
    878777,
    898898,
    777877,
    797798,
    787798,
    789788,
    789886,
    868788,
    888878,
    878988,
    687787,
    777898,
    877789,
    787886,
    887878,
    978797,
    897987,
    777787,
    887877,
    877998,
    887978,
    787879,
    888789,
    878898,
    877888,
    786978,
    988977,
    886688,
    789868,
    887888,
    789798,
    798868,
    977879,
    778987,
    989877,
    978979,
    787878,
    796878,
    878868,
    887887,
    778887,
    878888,
    898877,
    889868,
    877788,
    887877,
    887888,
    977977,
    887987,
    777688,
    878988,
    767798,
    989797,
    887989,
    987788,
    897878,
    777777,
    987878,
    898888,
    878887,
    988777,
    898988,
    899888,
    869888,
    898897,
    896988,
    787887,
    888878,
    789879,
    678888,
    798878,
    788987,
    898888,
    978867,
    978787,
    798878,
    777887,
    788899,
    778867,
    978997,
    898787,
    878989,
    778878,
    777687,
    876978,
    978886,
    877899,
    777976,
    777779,
    787897,
    978788,
    768677,
    968868,
    778899,
    876768,
    698887,
    888887,
    899687,
    877698,
    887787,
    987887,
    897899,
    899997,
    778888,
    787978,
    886967,
    987988,
    799788,
    888767,
    997887,
    888879,
    887779,
    777778,
    788887,
    677978,
    888687,
    877889,
    877787,
    878778,
    898988,
    779886,
    799799,
    888889,
    987888,
    968978,
    777777,
    798777,
    779988,
    898767,
    687987,
    779798,
    888797,
    997866,
    798889,
    888776,
    887888,
    979997,
    978989,
    768888,
    787898,
    978898,
    989888,
    887797,
    778869,
    768899,
    777887,
    888788,
    788889,
    797788,
    877867,
    988787,
    788889,
    768896,
    878979,
    878987,
    888679,
    778878,
    888979,
    977777,
    877798,
    889889,
    898878,
    988877,
    888787,
    879889,
    888978,
    888787,
    897989,
    788697,
    767788,
    897967,
    987879,
    797776,
    998788,
    876967,
    789979,
    687877,
    896887,
    798977,
    897888,
    978989,
    789788,
    777878,
    769979,
    778887,
    888976,
    877889,
    887767,
    889897,
    986787,
    897899,
    898889,
    679878,
    897677,
    986879,
    987877,
    777888,
    878989,
    978899,
    878898,
    789779,
    889988,
    887888,
    888697,
    976789,
    777687,
    888778,
    988787,
    978799,
    777878,
    778977,
    769688,
    899878,
    768967,
    897998,
    998988,
    878888,
    877778,
    687986,
    789888,
    877778,
    978888,
    887899,
    779777,
    997788,
    778788,
    788979,
    888886,
    977878,
    788989,
    688888,
    867787,
    878877,
    689888,
    998798,
    987887,
    988978,
    877877,
    989779,
    778788,
    979967,
    778688,
    797778,
    898888,
    878988,
    778969,
    688879,
    687888,
    686988,
    979679,
    788878,
    888899,
    786877,
    778887,
    879867,
    788878,
    896678,
    789887,
    969886,
    688798,
    899878,
    988689,
    878998,
    989777,
    797897,
    677778,
    768787,
    888766,
    887787,
    767978,
    888789,
    989876,
    777978,
    789778,
    878777,
    789789,
    868688,
    897886,
    798797,
    789879,
    879887,
    778888,
    987878,
    888877,
    787787,
    887897,
    998887,
    876789,
    888799,
    689877,
    878778,
    777778,
    888988,
    897778,
    786889,
    997789,
    788788,
    878788,
    868798,
    788879,
    797887,
    978789,
    889969,
    787897,
    897987,
    878898,
    788899,
    787867,
    777789,
    877699,
    868888,
    878787,
    968888,
    778677,
    886778,
    788889,
    778978,
    778877,
    788879,
    798677,
    787888,
    889799,
    789789,
    998898,
    988788,
    786899,
    977977,
    878787,
    989868,
    887978,
    798978,
    977779,
    996767,
    988787,
    677879,
    879989,
    898878,
    796887,
    887978,
    876877,
    779887,
    896777,
    897878,
    886877,
    799989,
    896898,
    888998,
    899979,
    677888,
    788887,
    788988,
    977896,
    899787,
    797888,
    889888,
    787887,
    988989,
    979977,
    888997,
    668876,
    988789,
    789987,
    887678,
    688679,
    978977,
    688778,
    677799,
    878779,
    978777,
    777777,
    888897,
    989778,
    787798,
    777899,
    898898,
    987778,
    968888,
    978988,
    877878,
    677988,
    787978,
    877888,
    787887,
    787778,
    787978,
    986778,
    878877,
    988777,
    798788,
    697896,
    777987,
    987877,
    888878,
    879687,
    887789,
    879888,
    877899,
    889796,
    897796,
    787889,
    899878,
    889689,
    978868,
    887887,
    877788,
    887887,
    867877,
    988889,
    777998,
    897887,
    877998,
    886797,
    969787,
    977787,
    788789,
    777898,
    878788,
    887978,
    877787,
    998798,
    887778,
    879767,
    888678,
    888668,
    977888,
    998778,
    878978,
    777878,
    787878,
    866899,
    998899,
    677776,
    897888,
    778898,
    878876,
    989868,
    879778,
    888798,
    787997,
    877987,
    779989,
    987878,
    679678,
    888867,
    988678,
    996778,
    778799,
    979977,
    786988,
    777987,
    988988,
    899898,
    766786,
    799778,
    889987,
    987777,
    886978,
    888797,
    867677,
    877889,
    987889,
    797898,
    978677,
    898797,
    897988,
    797988,
    879888,
    888789,
    988976,
    979788,
    897787,
    788789,
    887988,
    786797,
    986887,
    878877,
    797997,
    779877,
    877788,
    778878,
    686678,
    888889,
    688798,
    879887,
    778898,
    877987,
    779776,
    789899,
    888888,
    878988,
    797877,
    787997,
    697868,
    879767,
    786768,
    989887,
    797888,
    787787,
    787797,
    788879,
    879788,
    987877,
    999979,
    789979,
    897778,
    889988,
    989887,
    689869,
    968888,
    888778,
    867788,
    876889,
    877688,
    777777,
    977879,
    768877,
    878967,
    896877,
    768789,
    987887,
    789879,
    898777,
    997788,
    777887,
    798997,
    887888,
    788889,
    787978,
    689786,
    778766,
    897898,
    768778,
    778898,
    789897,
    877797,
    778878,
    977988,
    879898,
    887977,
    878879,
    687898,
    987776,
    878887,
    786887,
    786797,
    779878,
    887887,
    978877,
    887779,
    898878,
    797979,
    867988,
    898698,
    887776,
    988877,
    789788,
    689888,
    688878,
    978778,
    788998,
    799897,
    787788,
    798788,
    788788,
    966877,
    887888,
    887779,
    877787,
    678798,
    887768,
    778778,
    777798,
    886789,
    899888,
    877969,
    777788,
    878877,
    877869,
    878888,
    778778,
    888889,
    877878,
    788799,
    878888,
    887887,
    977967,
    997788,
    987997,
    797988,
    878879,
    887868,
    786887,
    896878,
    787777,
    798898,
    678797,
    797788,
    978887,
    888989,
    777879,
    788798,
    878898,
    999868,
    988978,
    877778,
    877788,
    986897,
    787977,
    987977,
    989988,
    888776,
    879889,
    988877,
    787889,
    777878,
    787868,
    978878,
    878978,
    998888,
    878798,
    897987,
    887776,
    778779,
    888786,
    767886,
    888767,
    877876,
    987788,
    978798,
    967986,
    977668,
    887778,
    988868,
    977887,
    877877,
    987988,
    899897,
    779987,
    789788,
    977888,
    778797,
    897898,
    888778,
    979779,
    997897,
    887878,
    898886,
    786889,
    877978,
    876788,
    788899,
    878877,
    988887,
    888997,
    779898,
    978878,
    887788,
    978888,
    787887,
    768878,
    897889,
    988778,
    887997,
    989899,
    969888,
    797987,
    979778,
    898886,
    888988,
    778989,
    868988,
    876878,
    777789,
    877888,
    997678,
    799887,
    797988,
    678779,
    878787,
    988899,
    977987,
    876979,
    879789,
    886668,
    879778,
    788688,
    688768,
    997869,
    877888,
    768776,
    677867,
    877788,
    999789,
    988698,
    886889,
    889679,
    789778,
    787997,
    886789,
    887988,
    968788,
    667988,
    897888,
    877687,
    787877,
    786887,
    967878,
    978798,
    788798,
    877789,
    889888,
    788878,
    789887,
    777788,
    887799,
    778787,
    889799,
    977777,
    977867,
    768898,
    777979,
    789878,
    897777,
    678789,
    878887,
    767777,
    797778,
    778768,
    888868,
    787777,
    678767,
    788998,
    877797,
    886988,
    777888,
    887789,
    977867,
    776887,
    778787,
    777888,
    867778,
    787898,
    789788,
    779698,
    776889,
    898887,
    886888,
    798988,
    887978,
    767889,
    888787,
    777788,
    787888,
    788877,
    788889,
    797897,
    679898,
    798888,
    879867,
    987888,
    888777,
    787888,
    779778,
    789879,
    778678,
    878788,
    779867,
    788998,
    877887,
    776898,
    787887,
    768788,
    797977,
    888867,
    797989,
    878978,
    888898,
    887888,
    887878,
    888987,
    798877,
    889798,
    789887,
    779678,
    899768,
    787888,
    788988,
    888776,
    878897,
    778886,
    877788,
    898769,
    786877,
    868788,
    877888,
    867888,
    877778,
    989888,
    798877,
    798688,
    677779,
    878777,
    667788,
    887768,
    768997,
    878787,
    887888,
    678776,
    877979,
    878788,
    988878,
    788899,
    888897,
    777777,
    769888,
    898768,
    788977,
    798888,
    779877,
    978797,
    669788,
    889878,
    977877,
    888888,
    778878,
    888989,
    698897,
    877877,
    788886,
    989879,
    888996,
    768877,
    969778,
    789996,
    796886,
    889889,
    888886,
    768988,
    777787,
    988897,
    779889,
    878768,
    977878,
    788677,
    996778,
    879778,
    988978,
    898889,
    988788,
    888787,
    888989,
    878788,
    788878,
    779977,
    977989,
    798778,
    688977,
    877787,
    987887,
    988778,
    777979,
    777879,
    977878,
    798878,
    878786,
    798777,
    878787,
    878799,
    797968,
    787898,
    889987,
    886797,
    887777,
    977898,
    897778,
    999898,
    797888,
    897788,
    678878,
    898878,
    887896,
    887798,
    888998,
    778878,
    887887,
    979788,
    697899,
    777787,
    988877,
    877886,
    868987,
    878879,
    676869,
    889987,
    767777,
    877898,
    889998,
    777878,
    787787,
    878697,
    898889,
    779888,
    787888,
    778879,
    788679,
    978788,
    897988,
    887778,
    687798,
    888998,
    877987,
    888798,
    888777,
    698777,
    796868,
    977866,
    877897,
    977687,
    988798,
    788778,
    898886,
    987688,
    888887,
    778677,
    897787,
    878899,
    798878,
    868986,
    896887,
    778887,
    798886,
    998677,
    867887,
    778788,
    799678,
    899886,
    887688,
    898788,
    888876,
    878798,
    877799,
    899889,
    796788,
    779898,
    798877,
    788767,
    978899,
    897787,
    679678,
    889798,
    889788,
    878787,
    877978,
    788888,
    766688,
    878897,
    797967,
    897997,
    887887,
    788798,
    989777,
    798878,
    789887,
    688778,
    996998,
    876787,
    988787,
    788878,
    988789,
    968888,
    899878,
    789768,
    978788,
    796889,
    888797,
    778887,
    799789,
    787777,
    887787,
    888788,
    778888,
    979898,
    879978,
    998799,
    787868,
    788977,
    977886,
    798868,
    888777,
    878877,
    987897,
    898779,
    888898,
    679689,
    887978,
    686868,
    777887,
    876797,
    888987,
    876888,
    797779,
    789888,
    887887,
    788788,
    787887,
    878696,
    989999,
    898777,
    888977,
    978678,
    898788,
    897986,
    688767,
    788868,
    978987,
    889988,
    777899,
    788787,
    796788,
    887799,
    868896,
    889878,
    877787,
    978896,
    978777,
    978788,
    689888,
    787978,
    788969,
    987977,
    768788,
    867888,
    789877,
    886878,
    787768,
    778889,
    896677,
    799987,
    988887,
    899687,
    867877,
    786988,
    777889,
    898878,
    898998,
    888777,
    786988,
    888797,
    677889,
    888688,
    997999,
    988968,
    798778,
    876878,
    886788,
    776888,
    996888,
    889888,
    888688,
    878877,
    888888,
    678777,
    799678,
    686786,
    877888,
    999778,
    889999,
    898977,
    779779,
    799789,
    998888,
    968789,
    797898,
    879778,
    988877,
    877886,
    669777,
    867797,
    896768,
    876877,
    887796,
    968888,
    877898,
    778898,
    898768,
    899979,
    879798,
    889867,
    677886,
    887979,
    779867,
    879787,
    878768,
    977988,
    778878,
    687967,
    879977,
    688787,
    799788,
    778778,
    798787,
    787777,
    988789,
    979888,
    769877,
    788886,
    889987,
    787768,
    988898,
    877787,
    787878,
    787877,
    889886,
    788778,
    778769,
    787788,
    987988,
    777999,
    878876,
    979888,
    779887,
    988869,
    997877,
    979887,
    687978,
    898688,
    888867,
    787898,
    888897,
    887798,
    789787,
    778788,
    988779,
    679868,
    878888,
    788869,
    898889,
    767789,
    788798,
    867889,
    977977,
    798987,
    887888,
    777768,
    798988,
    788988,
    977899,
    888788,
    787888,
    888766,
    787989,
    769886,
    879867,
    769878,
    688786,
    877888,
    998977,
    997798,
    777888,
    798887,
    898787,
    679787,
    887787,
    778789,
    788989,
    877888,
    887997,
    789788,
    978988,
    789898,
    679878,
    896787,
    799886,
    987789,
    877897,
    988878,
    978698,
    789876,
    867988,
    998896,
    998787,
    877688,
    876878,
    878877,
    778779,
    777888,
    688877,
    987888,
    778777,
    866787,
    897779,
    888998,
    987877,
    989777,
    879977,
    778888,
    878798,
    867878,
    998888,
    888988,
    778778,
    889778,
    787777,
    799889,
    778988,
    797878,
    788977,
    877789,
    989998,
    879898,
    896888,
    879887,
    789887,
    878787,
    887897,
    998887,
    897977,
    698998,
    987888,
    888788,
    788778,
    889979,
    788776,
    988879,
    797887,
    977979,
    778898,
    788998,
    988787,
    789697,
    888898,
    768787,
    989777,
    878899,
    887777,
    989887,
    767988,
    777677,
    787768,
    779978,
    797788,
    999787,
    677887,
    798878,
    997787,
    778888,
    889778,
    787879,
    998997,
    887888,
    987769,
    978877,
    888979,
    798689,
    988768,
    889879,
    778979,
    668988,
    779768,
    788988,
    788888,
    898978,
    978887,
    797797,
    799897,
    888897,
    877987,
    888898,
    879888,
    877779,
    877878,
    888798,
    899799,
    697897,
    787869,
    787889,
    877987,
    899977,
    898778,
    968878,
    978767,
    988988,
    999788,
    898787,
    897778,
    977977,
    797988,
    886888,
    676799,
    787898,
    888887,
    797787,
    788876,
    879789,
    798787,
    677787,
    998788,
    898679,
    887786,
    686788,
    899986,
    677787,
    778888,
    979978,
    799878,
    697779,
    897788,
    886979,
    777879,
    668888,
    777886,
    798778,
    888887,
    768879,
    887898,
    989878,
    887798,
    797978,
    877786,
    788688,
    879887,
    878778,
    897878,
    887788,
    888997,
    788896,
    878877,
    888989,
    888787,
    688898,
    788877,
    897989,
    997778,
    778887,
    888698,
    888788,
    787889,
    889788,
    778688,
    978778,
    977898,
    867798,
    887996,
    987778,
    887876,
    778789,
    878798,
    868889,
    888688,
    868887,
    988887,
    787697,
    776888,
    788988,
    788989,
    898779,
    768889,
    787967,
    987888,
    877797,
    687988,
    979978,
    789887,
    779797,
    777789,
    778787,
    979797,
    887887,
    868789,
    878877,
    779889,
    888789,
    898798,
    887786,
    878767,
    779978,
    887976,
    996987,
    888898,
    989878,
    787788,
    876888,
    878977,
    776897,
    787988,
    798897,
    789877,
    797878,
    879888,
    878669,
    989987,
    866777,
    786888,
    969687,
    868977,
    987778,
    878988,
    888886,
    877797,
    997987,
    878867,
    797878,
    887988,
    987878,
    887786,
    676787,
    888898,
    888888,
    877998,
    799776,
    878988,
    977878,
    988878,
    888989,
    778788,
    687966,
    779887,
    787897,
    786988,
    787878,
    787798,
    878678,
    987887,
    888878,
    988888,
    778898,
    889899,
    876986,
    878787,
    797887,
    897778,
    887789,
    889788,
    987898,
    777967,
    898878,
    879886,
    689688,
    787877,
    778877,
    878998,
    878888,
    898997,
    977898,
    787986,
    799878,
    887878,
    797788,
    887898,
    788779,
    797798,
    878778,
    776787,
    887798,
    978787,
    978998,
    897998,
    698788,
    888797,
    788888,
    977768,
    888878,
    887768,
    886897,
    888888,
    798878,
    887878,
    768888,
    778978,
    888889,
    897688,
    878888,
    787778,
    898896,
    878788,
    988888,
    788976,
    777887,
    877887,
    898786,
    877976,
    788887,
    778789,
    689787,
    879887,
    796788,
    797886,
    888978,
    789999,
    878888,
    989697,
    888776,
    878799,
    789878,
    879677,
    869887,
    868867,
    878997,
    878887,
    897888,
    889998,
    788678,
    888878,
    898776,
    889878,
    888886,
    876987,
    878987,
    996886,
    788878,
    788868,
    887787,
    788888,
    777796,
    777788,
    877999,
    988869,
    779898,
    788687,
    779777,
    887998,
    788888,
    878899,
    886879,
    888978,
    868787,
    777989,
    988898,
    776896,
    988997,
    798878,
    686867,
    879897,
    788779,
    888877,
    879788,
    897777,
    789778,
    889879,
    888877,
    987998,
    788797,
    787888,
    977879,
    878797,
    789889,
    887877,
    777788,
    789887,
    696799,
    788888,
    888899,
    987788,
    899779,
    886887,
    767787,
    899777,
    897989,
    888887,
    897987,
    896889,
    977778,
    789888,
    977889,
    999787,
    877888,
    886987,
    877788,
    789898,
    889987,
    798887,
    977777,
    878787,
    798789,
    878888,
    797988,
    998877,
    997889,
    878769,
    898989,
    867767,
    897898,
    888777,
    788878,
    898777,
    788677,
    887787,
    888787,
    798768,
    788788,
    897878,
    989778,
    779888,
    968786,
    778899,
    787778,
    988786,
    788787,
    896887,
    897787,
    788787,
    977679,
    787788,
    888787,
    698878,
    888978,
    767877,
    798769,
    788976,
    778886,
    876898,
    897878,
    788678,
    888987,
    878876,
    788878,
    898888,
    878799,
    778799,
    777978,
    797778,
    988888,
    898879,
    779876,
    888879,
    978876,
    978789,
    977878,
    697887,
    897897,
    779987,
    878997,
    687987,
    879788,
    888788,
    778888,
    888776,
    788878,
    796889,
    887678,
    988787,
    889878,
    878688,
    788877,
    789788,
    778878,
    877679,
    987889,
    979989,
    678799,
    678878,
    878779,
    877979,
    878789,
    988999,
    889889,
    997887,
    988797,
    788688,
    778888,
    986788,
    977787,
    678878,
    688889,
    867877,
    877887,
    898768,
    998778,
    889979,
    989799,
    767778,
    778777,
    886888,
    778687,
    888788,
    788779,
    689887,
    969886,
    788788,
    777988,
    897899,
    878888,
    676888,
    897997,
    768878,
    787799,
    887866,
    987787,
    877779,
    778888,
    767877,
    788889,
    898888,
    978967,
    889768,
    768688,
    788797,
    898889,
    888878,
    887889,
    799799,
    877787,
    777879,
    779886,
    778888,
    788788,
    787889,
    886778,
    896998,
    878798,
    777789,
    888998,
    889769,
    886978,
    899979,
    778788,
    878677,
    979899,
    899977,
    876696,
    888788,
    888788,
    888878,
    866888,
    779888,
    788888,
    797979,
    898778,
    786788,
    787898,
    978788,
    998877,
    999877,
    797988,
    789768,
    897888,
    798897,
    778879,
    888879,
    986777,
    778878,
    887987,
    888798,
    877996,
    887698,
    887968,
    988898,
    986979,
    878878,
    899879,
    777777,
    767887,
    677876,
    799778,
    878788,
    789789,
    988988,
    778897,
    787888,
    879887,
    866978,
    877968,
    888886,
    887888,
    878977,
    767888,
    778897,
    897777,
    878899,
    988789,
    898877,
    798897,
    879888,
    998889,
    878788,
    788878,
    879979,
    687798,
    997788,
    976967,
    887799,
    689978,
    878788,
    897797,
    788878,
    797998,
    777878,
    778978,
    777778,
    878978,
    878788,
    777788,
    888868,
    789677,
    867778,
    798977,
    879887,
    898878,
    778898,
    789788,
    778777,
    878876,
    888878,
    777878,
    988767,
    976799,
    999887,
    777777,
    988888,
    887898,
    988787,
    788778,
    998888,
    879977,
    697688,
    788877,
    797878,
    977989,
    897787,
    888769,
    777889,
    787778,
    687886,
    888788,
    787888,
    687777,
    899887,
    888887,
    787787,
    877968,
    797688,
    787888,
    897788,
    768778,
    778787,
    776887,
    978998,
    788988,
    878898,
    888778,
    887989,
    989889,
    788887,
    778897,
    788986,
    886798,
    877878,
    868787,
    989998,
    797898,
    887798,
    988878,
    798988,
    678878,
    898868,
    777787,
    997897,
    888678,
    788868,
    787879,
    886896,
    897989,
    979888,
    878888,
    799887,
    776989,
    979786,
    878878,
    877888,
    678778,
    888898,
    789988,
    787889,
    888888,
    786878,
    878879,
    887786,
    887998,
    768877,
    877796,
    878777,
    998777,
    878798,
    976989,
    877768,
    986978,
    988668,
    787789,
    888989,
    899877,
    868787,
    879878,
    789967,
    797888,
    987897,
    899976,
    898678,
    877878,
    878878,
    978888,
    889798,
    888787,
    788876,
    777797,
    889798,
    788777,
    978878,
    897888,
    867787,
    788897,
    789889,
    887777,
    887887,
    896768,
    788899,
    886798,
    799989,
    788967,
    778979,
    778998,
    888877,
    887898,
    986768,
    889876,
    787997,
    978799,
    889797,
    866979,
    988878,
    768786,
    788977,
    888888,
    969788,
    886887,
    876989,
    788789,
    887679,
    878778,
    898787,
    689887,
    898876,
    878878,
    889888,
    778889,
    796679,
    878998,
    798967,
    798887,
    777888,
    997897,
    768988,
    877987,
    897888,
    888799,
    689798,
    788997,
    877779,
    789687,
    897897,
    777877,
    787779,
    789877,
    998877,
    898878,
    889897,
    788968,
    797877,
    878988,
    888889,
    887776,
    788898,
    877887,
    778888,
    787678,
    878799,
    887788,
    788887,
    887678,
    877688,
    767788,
    897988,
    887798,
    787889,
    879878,
    988967,
    888787,
    787787,
    786786,
    687679,
    879968,
    979887,
    998788,
    887977,
    867668,
    688868,
    898899,
    787879,
    787889,
    798788,
    777799,
    868997,
    869887,
    887888,
    789887,
    988888,
    678889,
    986888,
    987797,
    889888,
    888977,
    878879,
    788788,
    887788,
    886978,
    888888,
    789888,
    986976,
    987788,
    797688,
    888878,
    999787,
    979786,
    778888,
    699678,
    987778,
    798787,
    798789,
    998887,
    978888,
    779979,
    968878,
    787998,
    888868,
    786897,
    988988,
    688897,
    886896,
    787889,
    986789,
    777887,
    998768,
    786789,
    798897,
    889788,
    777989,
    688787,
    788878,
    797889,
    798889,
    868988,
    698887,
    779788,
    899889,
    687868,
    778879,
    678878,
    786796,
    997877,
    778888,
    788878,
    897887,
    778878,
    876867,
    977887,
    778697,
    979987,
    889788,
    779776,
    888888,
    878878,
    788978,
    987698,
    778986,
    798969,
    877878,
    787798,
    888787,
    989889,
    777997,
    887879,
    888979,
    988878,
    897688,
    778878,
    898787,
    887887,
    879869,
    897988,
    878887,
    798989,
    898799,
    999789,
    979788,
    777888,
    988887,
    788898,
    787678,
    878877,
    777888,
    888988,
    888699,
    778789,
    888889,
    788888,
    788988,
    887989,
    789877,
    889968,
    997778,
    878987,
    977888,
    878879,
    897878,
    878798,
    879888,
    787968,
    889787,
    889797,
    787899,
    677786,
    897769,
    988978,
    787888,
    988688,
    878987,
    887889,
    889888,
    888788,
    997767,
    988679,
    888889,
    799999,
    688796,
    778677,
    888897,
    897887,
    788888,
    879898,
    778868,
    887776,
    988889,
    787797,
    797887,
    778878,
    888787,
    768989,
    877897,
    888898,
    768777,
    887988,
    897887,
    878799,
    897978,
    788997,
    888777,
    887998,
    979876,
    788799,
    888787,
    777877,
    787877,
    687788,
    887779,
    898887,
    798788,
    899878,
    887887,
    877998,
    996788,
    988777,
    897698,
    787898,
    996798,
    887988,
    887878,
    867888,
    788787,
    698778,
    889987,
    768988,
    687978,
    787878,
    986787,
    878786,
    868988,
    976878,
    989877,
    997888,
    877978,
    979879,
    878888,
    786897,
    687899,
    787787,
    986887,
    796988,
    778788,
    799868,
    887989,
    899779,
    698888,
    879998,
    868779,
    878989,
    777888,
    897698,
    987797,
    879888,
    899789,
    987879,
    798978,
    877789,
    878978,
    888768,
    877886,
    887777,
    789867,
    788889,
    878788,
    778888,
    896778,
    787999,
    788777,
    788797,
    988989,
    888789,
    888878,
    896778,
    989878,
    887777,
    988887,
    899888,
    898779,
    778976,
    887878,
    787898,
    787878,
    878767,
    877976,
    879978,
    977878,
    877797,
    868787,
    788978,
    888888,
    889877,
    798878,
    698788,
    989888,
    986898,
    988689,
    778977,
    898889,
    888867,
    678898,
    997797,
    789788,
    889886,
    897988,
    878889,
    788979,
    777788,
    889878,
    788779,
    887887,
    877886,
    898888,
    978888,
    977889,
    897998,
    789676,
    789778,
    888878,
    987789,
    888877,
    887988,
    887887,
    878878,
    778779,
    898988,
    777997,
    878868,
    987898,
    687867,
    787889,
    777778,
    887998,
    897797,
    898988,
    978888,
    777877,
    989887,
    898878,
    878788,
    887777,
    778878,
    687787,
    787987,
    979787,
    976778,
    876778,
    887876,
    988887,
    888887,
    787787,
    968887,
    898988,
    787777,
    877787,
    977798,
    887888,
    778889,
    987988,
    869997,
    889877,
    788778,
    868767,
    779969,
    789788,
    878869,
    788988,
    876787,
    898888,
    988698,
    888699,
    799679,
    786778,
    967788,
    979979,
    898897,
    877768,
    778889,
    877888,
    888769,
    898769,
    997997,
    888768,
    888878,
    779788,
    789897,
    877778,
    769898,
    988777,
    778897,
    788788,
    699978,
    987997,
    788889,
    999768,
    987887,
    977797,
    889887,
    798877,
    989879,
    889878,
    977899,
    778996,
    979988,
    678888,
    797988,
    898777,
    897778,
    897898,
    988789,
    988788,
    778879,
    897887,
    797897,
    898787,
    897898,
    969778,
    699787,
    768776,
    887889,
    786989,
    768968,
    799798,
    677877,
    766968,
    888878,
    788799,
    888879,
    878788,
    867897,
    787987,
    979889,
    877868,
    887977,
    687788,
    788879,
    976878,
    888898,
    898797,
    888789,
    778989,
    778798,
    778688,
    887677,
    997987,
    799786,
    797878,
    987998,
    898899,
    788788,
    786679,
    776797,
    998787,
    887887,
    879788,
    888977,
    876987,
    988878,
    987676,
    978877,
    976999,
    787877,
    878688,
    877988,
    987898,
    768998,
    787889,
    999779,
    867897,
    877978,
    768787,
    888788,
    996889,
    878886,
    879867,
    779786,
    887889,
    699868,
    778968,
    878698,
    979778,
    997887,
    797788,
    768888,
    779878,
    678876,
    777788,
    687788,
    776887,
    887778,
    788877,
    997897,
    898788,
    788878,
    888897,
    787888,
    869878,
    867787,
    788787,
    888888,
    896988,
    887878,
    779887,
    969688,
    898977,
    878888,
    877779,
    777889,
    877886,
    886897,
    798887,
    879869,
    788787,
    788688,
    877896,
    788878,
    997998,
    788879,
    787768,
    977989,
    897688,
    988878,
    777686,
    989786,
    787978,
    998678,
    998879,
    897787,
    786877,
    979789,
    888879,
    878869,
    888868,
    886987,
    688776,
    978997,
    788798,
    888887,
    876879,
    797769,
    868778,
    896777,
    978788,
    778777,
    988788,
    787877,
    788878,
    889868,
    868988,
    867887,
    796787,
    778999,
    977689,
    888789,
    778788,
    899778,
    787787,
    798888,
    786897,
    787877,
    998878,
    879777,
    897788,
    889987,
    797878,
    688976,
    876889,
    788878,
    788899,
    888788,
    778788,
    869878,
    878788,
    867797,
    798887,
    799677,
    969877,
    788787,
    977977,
    868886,
    767867,
    899778,
    898877,
    777879,
    789876,
    878797,
    788886,
    877789,
    876779,
    798898,
    987899,
    897898,
    888879,
    888788,
    969688,
    967888,
    978878,
    686889,
    798898,
    988887,
    998888,
    798776,
    777988,
    797788,
    887777,
    788887,
    887787,
    898787,
    969898,
    887797,
    767968,
    797699,
    688987,
    978878,
    877867,
    889888,
    667978,
    898876,
    987687,
    878799,
    887979,
    888898,
    868868,
    788989,
    788767,
    887878,
    979877,
    788897,
    798788,
    878888,
    999989,
    787888,
    888978,
    888867,
    988988,
    888887,
    998777,
    988866,
    768788,
    889889,
    777897,
    898989,
    988888,
    897997,
    878778,
    977878,
    868978,
    988887,
    888888,
    787888,
    787778,
    998879,
    867787,
    977778,
    977779,
    798986,
    988788,
    688789,
    789999,
    987877,
    878888,
    797876,
    888877,
    788989,
    899888,
    777898,
    878969,
    998877,
    877778,
    786878,
    687868,
    887778,
    897786,
    886688,
    877778,
    867787,
    778788,
    788689,
    687787,
    878888,
    789779,
    888798,
    988897,
    877788,
    788876,
    878978,
    778879,
    789986,
    789967,
    787796,
    977987,
    779979,
    878689,
    888889,
    997888,
    778888,
    886977,
    898997,
    767887,
    878877,
    789998,
    777787,
    688888,
    886888,
    787878,
    979787,
    877898,
    798688,
    889698,
    787878,
    886987,
    888788,
    877879,
    988699,
    787778,
    888888,
    799776,
    888788,
    978878,
    979788,
    768779,
    797998,
    788767,
    886889,
    877799,
    898797,
    779668,
    678887,
    778978,
    776797,
    677787,
    778788,
    897876,
    867989,
    978876,
    868778,
    677898,
    788769,
    898787,
    697986,
    988878,
    887878,
    976889,
    979978,
    788998,
    987879,
    779777,
    887989,
    679887,
    778779,
    797778,
    888788,
    897677,
    789779,
    899877,
    898778,
    997787,
    888777,
    798876,
    778988,
    976887,
    889888,
    677889,
    867788,
    887878,
    977789,
    777897,
    678978,
    898687,
    979777,
    889887,
    988877,
    979988,
    788888,
    768798,
    888877,
    777887,
    878778,
    887798,
    967967,
    777698,
    988779,
    987979,
    878999,
    998889,
    688899,
    878988,
    879789,
    888887,
    778887,
    998968,
    998879,
    989899,
    688888,
    888887,
    789689,
    888688,
    886887,
    877797,
    977867,
    877889,
    967898,
    697889,
    688987,
    778887,
    778988,
    877888,
    878888,
    988987,
    677976,
    887979,
    978897,
    877878,
    988778,
    888778,
    888886,
    887878,
    698878,
    777778,
    689787,
    778977,
    987888,
    868898,
    788878,
    767989,
    777887,
    878878,
    777889,
    979797,
    799887,
    988887,
    868787,
    888696,
    977889,
    869878,
    769797,
    888788,
    867878,
    799977,
    778977,
    878878,
    787897,
    887788,
    888777,
    969777,
    877787,
    798896,
    877888,
    867989,
    878897,
    878788,
    887887,
    788667,
    878877,
    887987,
    798787,
    887788,
    988989,
    877779,
    888788,
    779887,
    788977,
    879796,
    887887,
    778889,
    988878,
    879887,
    987797,
    888866,
    778787,
    777778,
    788689,
    888878,
    789876,
    997779,
    887797,
    788786,
    898788,
    879677,
    778888,
    889787,
    878787,
    979878,
    977978,
    897988,
    769776,
    687889,
    987879,
    878967,
    689798,
    798978,
    788788,
    678698,
    988889,
    967978,
    967898,
    888699,
    887878,
    898687,
    989696,
    877687,
    869977,
    788888,
    887778,
    778887,
    888777,
    897789,
    888888,
    779788,
    877788,
    789977,
    878888,
    988789,
    787779,
    987786,
    977787,
    879798,
    789688,
    789877,
    768997,
    779897,
    777787,
    788779,
    978686,
    878986,
    769967,
    889776,
    888697,
    789798,
    878978,
    868779,
    676888,
    786897,
    788887,
    788787,
    978877,
    967888,
    786789,
    678797,
    788976,
    787788,
    987869,
    888788,
    887797,
    787879,
    977788,
    899788,
    686896,
    697876,
    968897,
    877787,
    777789,
    798788,
    877777,
    877788,
    797677,
    876698,
    879878,
    888878,
    988779,
    876897,
    887986,
    877778,
    778879,
    977877,
    787778,
    898786,
    887797,
    897699,
    778889,
    968878,
    777889,
    897887,
    997788,
    978887,
    687788,
    878988,
    877798,
    788877,
    798889,
    797798,
    776789,
    797878,
    877879,
    789877,
    787786,
    887988,
    788887,
    877767,
    898787,
    887798,
    999778,
    779887,
    898899,
    788889,
    787877,
    787887,
    889687,
    988787,
    888778,
    777866,
    978888,
    878879,
    799979,
    879679,
    989888,
    798888,
    677999,
    678896,
    899687,
    878878,
    879777,
    878798,
    897789,
    999877,
    779797,
    779887,
    788789,
    886978,
    898888,
    888678,
    787787,
    988777,
    889898,
    888878,
    968877,
    998889,
    777786,
    978697,
    887797,
    798797,
    688977,
    887886,
    888887,
    788979,
    778789,
    798767,
    978778,
    976787,
    889888,
    988796,
    879968,
    988879,
    779788,
    888887,
    887879,
    976888,
    889988,
    967988,
    788788,
    777888,
    987877,
    888777,
    888877,
    788889,
    887796,
    977987,
    698877,
    877987,
    879988,
    878878,
    887796,
    887988,
    887687,
    878689,
    878777,
    787869,
    797987,
    688889,
    877886,
    766789,
    887878,
    897889,
    898889,
    896887,
    686897,
    888887,
    898999,
    789799,
    898898,
    989789,
    987889,
    978887,
    888978,
    887988,
    888777,
    979888,
    877779,
    799887,
    779878,
    978687,
    779978,
    887988,
    789888,
    787978,
    978777,
    898897,
    989778,
    687877,
    867777,
    887887,
    878788,
    777978,
    898887,
    878988,
    797888,
    977778,
    777876,
    877887,
    888887,
    787779,
    888888,
    989777,
    887898,
    989877,
    769787,
    887798,
    898787,
    777777,
    887877,
    677799,
    878879,
    887976,
    897999,
    878986,
    889779,
    688778,
    887788,
    779778,
    879866,
    787877,
    688898,
    877988,
    888887,
    878989,
    887788,
    788978,
    889797,
    887967,
    679888,
    899788,
    777787,
    987986,
    887898,
    799797,
    788887,
    879767,
    978798,
    787988,
    888777,
    878887,
    796777,
    787678,
    997988,
    898787,
    897898,
    997888,
    989777,
    788887,
    889768,
    797779,
    697788,
    878778,
    776778,
    877987,
    778777,
    969887,
    696888,
    987899,
    878778,
    788987,
    897778,
    797889,
    878688,
    887779,
    887887,
    678789,
    899889,
    879887,
    687778,
    797689,
    797987,
    886799,
    987867,
    988878,
    978887,
    977889,
    878888,
    888977,
    779777,
    799787,
    987988,
    787989,
    868888,
    778977,
    997887,
    988888,
    898787,
    868988,
    967897,
    798679,
    878978,
    788778,
    986788,
    798987,
    799988,
    878879,
    798777,
    888898,
    877879,
    677879,
    677778,
    889777,
    777978,
    676877,
    777698,
    679678,
    887879,
    797887,
    887786,
    877887,
    877689,
    767678,
    788898,
    779789,
    977877,
    888879,
    778969,
    887788,
    867889,
    798788,
    887887,
    789788,
    898777,
    899877,
    796799,
    888977,
    988688,
    886977,
    778778,
    699878,
    889887,
    779777,
    797899,
    987788,
    968778,
    687978,
    688987,
    788987,
    998867,
    787778,
    788788,
    779777,
    789988,
    887998,
    777997,
    988978,
    787889,
    887898,
    878689,
    787798,
    888888,
    799879,
    878697,
    877697,
    978897,
    779779,
    787778,
    777888,
    897788,
    987788,
    888887,
    898789,
    989868,
    889868,
    978898,
    896888,
    788889,
    978788,
    788788,
    698889,
    897777,
    699888,
    678878,
    767896,
    878898,
    888878,
    887898,
    799977,
    887888,
    987898,
    789898,
    867889,
    989787,
    777978,
    778778,
    887898,
    878888,
    779868,
    798878,
    788977,
    789778,
    787778,
    677877,
    899787,
    988887,
    777869,
    689898,
    768778,
    898879,
    777778,
    888899,
    997976,
    979899,
    787786,
    788687,
    777889,
    889868,
    887896,
    988898,
    878789,
    877788,
    988986,
    786998,
    887787,
    687786,
    897787,
    898898,
    868788,
    978878,
    979766,
    898687,
    898788,
    778877,
    989887,
    989888,
    889797,
    886878,
    877787,
    778767,
    887777,
    969878,
    897888,
    668878,
    978899,
    889787,
    989987,
    878879,
    789887,
    978987,
    898867,
    769979,
    979986,
    788787,
    787988,
    979787,
    878787,
    899778,
    886897,
    888989,
    887778,
    877879,
    878777,
    998898,
    976777,
    897897,
    786789,
    779788,
    888778,
    989887,
    889997,
    887997,
    887778,
    888879,
    789889,
    899987,
    788887,
    989888,
    778788,
    888966,
    878888,
    897778,
    796786,
    787886,
    888788,
    888898,
    788867,
    879976,
    779897,
    697887,
    877879,
    798878,
    888877,
    769789,
    877997,
    787987,
    777888,
    778768,
    667977,
    697888,
    867978,
    786878,
    988987,
    788787,
    779999,
    889899,
    898888,
    968899,
    877788,
    688878,
    888687,
    988898,
    876888,
    878887,
    667777,
    788797,
    988677,
    976978,
    888977,
    789978,
    888789,
    768889,
    888688,
    889889,
    778687,
    888797,
    778987,
    767789,
    778877,
    797788,
    979888,
    876898,
    777888,
    868967,
    877878,
    779888,
    888979,
    887987,
    778978,
    887888,
    888778,
    978879,
    797987,
    876788,
    788887,
    998897,
    779788,
    877887,
    788778,
    678887,
    879989,
    797778,
    688888,
    679887,
    787779,
    697787,
    996786,
    877968,
    878777,
    897779,
    779797,
    877888,
    788697,
    879987,
    878999,
    878969,
    898787,
    796877,
    777988,
    977787,
    789888,
    878979,
    788986,
    887788,
    988889,
    887688,
    898788,
    878896,
    987678,
    798789,
    998898,
    869786,
    999798,
    889878,
    888987,
    779977,
    787767,
    869998,
    898887,
    777679,
    889778,
    878978,
    977886,
    877879,
    887789,
    889878,
    887789,
    879978,
    889969,
    778878,
    877768,
    778898,
    886789,
    878868,
    778986,
    877888,
    879878,
    697788,
    878777,
    787887,
    668789,
    867887,
    986887,
    868876,
    898977,
    789879,
    789867,
    788897,
    889769,
    778989,
    978998,
    797798,
    768877,
    769888,
    876888,
    787887,
    988878,
    878888,
    888878,
    788797,
    779889,
    788898,
    788869,
    779887,
    797889,
    977786,
    889988,
    888887,
    787888,
    877778,
    998897,
    788877,
    888689,
    698788,
    789878,
    897977,
    977997,
    877887,
    877779,
    788789,
    997777,
    888887,
    777887,
    776777,
    886877,
    778897,
    886878,
    777987,
    778967,
    877799,
    988777,
    877887,
    798887,
    888988,
    776776,
    778789,
    877888,
    779879,
    879777,
    878998,
    877777,
    788988,
    888797,
    877798,
    877878,
    987889,
    889887,
    789778,
    798698,
    888899,
    789889,
    986998,
    886888,
    978867,
    988887,
    978778,
    886798,
    877886,
    667799,
    787869,
    979898,
    787967,
    878799,
    878779,
    787696,
    777778,
    887978,
    878778,
    898779,
    778877,
    888898,
    877999,
    988887,
    888987,
    896879,
    998789,
    888888,
    789898,
    989977,
    769768,
    786788,
    898778,
    988888,
    788788,
    967777,
    678878,
    788899,
    979989,
    778888,
    799977,
    988779,
    788788,
    888878,
    897988,
    699678,
    868979,
    879779,
    899779,
    887779,
    777969,
    887888,
    886789,
    888988,
    777977,
    888876,
    887888,
    788987,
    976887,
    887888,
    869778,
    677788,
    898877,
    687879,
    988888,
    789798,
    888879,
    797669,
    988778,
    877688,
    879787,
    887777,
    779989,
    877798,
    787879,
    788888,
    797788,
    789886,
    898787,
    788887,
    876779,
    779768,
    888778,
    896998,
    777899,
    787779,
    789979,
    898877,
    888888,
    867887,
    978888,
    887799,
    777789,
    987689,
    766869,
    887878,
    778778,
    989988,
    988788,
    797778,
    887888,
    997877,
    988879,
    898869,
    788986,
    798787,
    877778,
    878887,
    899876,
    778898,
    778688,
    679888,
    778977,
    878988,
    998779,
    979778,
    867777,
    978878,
    776869,
    788878,
    877868,
    786687,
    878898,
    688867,
    897897,
    877888,
    898798,
    687888,
    678978,
    788877,
    878987,
    979778,
    998988,
    879897,
    889887,
    879778,
    977887,
    988787,
    788889,
    788878,
    878898,
    878887,
    886798,
    887887,
    886877,
    879878,
    889779,
    887889,
    888769,
    998888,
    899667,
    787888,
    978787,
    788978,
    887779,
    887678,
    779996,
    888787,
    688787,
    886788,
    877888,
    888986,
    888978,
    778887,
    897888,
    786888,
    888988,
    878878,
    787768,
    888988,
    787878,
    876888,
    778966,
    998668,
    889768,
    696877,
    898877,
    886886,
    898779,
    887778,
    887878,
    768977,
    987697,
    797899,
    779888,
    888987,
    888797,
    779887,
    896878,
    877788,
    989879,
    787678,
    998989,
    889999,
    797888,
    987877,
    698668,
    997987,
    878789,
    778989,
    888789,
    787797,
    877888,
    788877,
    988786,
    978777,
    887977,
    889797,
    788998,
    887778,
    798988,
    978777,
    988878,
    777888,
    798998,
    796777,
    998678,
    789779,
    887797,
    897797,
    987779,
    886688,
    886878,
    978699,
    787988,
    898888,
    868987,
    799798,
    967776,
    878978,
    867798,
    878878,
    878887,
    878778,
    798888,
    877878,
    899787,
    887998,
    988688,
    877999,
    779867,
    967788,
    896788,
    888779,
    988977,
    889787,
    886998,
    778898,
    989788,
    898899,
    797978,
    879988,
    796879,
    877987,
    786777,
    886786,
    777988,
    779987,
    789868,
    897788,
    877788,
    998897,
    877788,
    989797,
    896977,
    889878,
    887888,
    687998,
    879888,
    777889,
    676977,
    999998,
    877978,
    988897,
    988879,
    777888,
    887778,
    667888,
    899887,
    869888,
    779876,
    688688,
    898778,
    798678,
    998889,
    878798,
    768878,
    877889,
    986889,
    899797,
    867766,
    888787,
    986788,
    867787,
    888899,
    977979,
    787687,
    867796,
    877869,
    977796,
    987777,
    888998,
    789897,
    888888,
    887978,
    778879,
    788878,
    789788,
    667789,
    777888,
    788867,
    787877,
    899777,
    789879,
    669799,
    777797,
    678788,
    898877,
    979998,
    987887,
    998786,
    979778,
    889778,
    998888,
    897968,
    899896,
    978687,
    986988,
    898888,
    787887,
    889878,
    687679,
    787888,
    778688,
    778888,
    677788,
    977978,
    788988,
    969967,
    987787,
    868779,
    988888,
    998977,
    876997,
    779868,
    787887,
    788787,
    969896,
    877777,
    886779,
    897676,
    776988,
    778887,
    988676,
    889767,
    877966,
    778989,
    768797,
    789878,
    998889,
    869767,
    777696,
    777878,
    688997,
    878888,
    978986,
    777769,
    868877,
    899989,
    988798,
    798988,
    978777,
    778799,
    889877,
    887888,
    788777,
    977687,
    988799,
    886788,
    887978,
    987697,
    889888,
    787997,
    897678,
    889667,
    867878,
    888977,
    897787,
    878899,
    888888,
    886998,
    678888,
    788987,
    888976,
    888876,
    788797,
    788787,
    887879,
    869779,
    778887,
    788886,
    777678,
    788787,
    987977,
    898778,
    967868,
    888788,
    776789,
    978997,
    977968,
    787788,
    898878,
    978878,
    899888,
    786878,
    897877,
    778998,
    879887,
    867877,
    697777,
    977777,
    887996,
    888786,
    978888,
    988879,
    797779,
    989897,
    777778,
    687897,
    886997,
    978986,
    899877,
    878778,
    786987,
    897878,
    798787,
    798889,
    768878,
    778777,
    778787,
    678787,
    888897,
    886799,
    878788,
    999888,
    797798,
    879777,
    879778,
    878779,
    889887,
    889888,
    877877,
    889979,
    777879,
    988987,
    879887,
    777887,
    879889,
    898997,
    888987,
    997998,
    787898,
    788997,
    897789,
    698788,
    777799,
    779777,
    788776,
    987987,
    777778,
    979988,
    786887,
    977697,
    777977,
    987788,
    778787,
    767768,
    898868,
    797988,
    887878,
    668988,
    788998,
    788886,
    798799,
    788879,
    887798,
    999879,
    889876,
    878876,
    897889,
    997798,
    688789,
    768968,
    788867,
    787878,
    877788,
    767888,
    778989,
    978786,
    887898,
    797978,
    788877,
    787788,
    789877,
    988789,
    887887,
    979886,
    879888,
    877898,
    879788,
    788798,
    888767,
    979789,
    877879,
    877878,
    789787,
    798768,
    788877,
    898878,
    797888,
    889787,
    788778,
    889797,
    878978,
    868977,
    888897,
    879898,
    798779,
    877998,
    978888,
    798867,
    976888,
    879798,
    788878,
    778879,
    788688,
    996887,
    878887,
    788889,
    988878,
    988887,
    787797,
    897899,
    877878,
    786798,
    987979,
    979998,
    787789,
    999978,
    896876,
    877987,
    888868,
    688886,
    989798,
    888789,
    789897,
    877798,
    978798,
    787788,
    877787,
    887797,
    777988,
    778799,
    888787,
    877976,
    888788,
    877878,
    796878,
    878789,
    798887,
    797988,
    887788,
    988886,
    968778,
    698869,
    878787,
    898788,
    669878,
    988778,
    997976,
    789887,
    768898,
    798889,
    898987,
    988978,
    868988,
    777889,
    978889,
    887887,
    789977,
    889898,
    889898,
    877769,
    889798,
    777888,
    777779,
    977677,
    669687,
    888877,
    867878,
    867888,
    776979,
    998878,
    776867,
    888687,
    878887,
    877789,
    989988,
    777787,
    887887,
    798799,
    978987,
    868977,
    978979,
    788787,
    989878,
    888878,
    887687,
    789787,
    879687,
    989887,
    987968,
    679897,
    798777,
    797977,
    887987,
    788887,
    867668,
    688787,
    967887,
    778899,
    877888,
    768888,
    897998,
    899988,
    897877,
    879868,
    678788,
    798977,
    887798,
    877878,
    878689,
    779788,
    779687,
    678787,
    888878,
    887788,
    978987,
    898878,
    768889,
    799877,
    777779,
    878688,
    987878,
    789878,
    767798,
    799898,
    799797,
    889769,
    979878,
    869788,
    987897,
    888787,
    888979,
    886978,
    787787,
    778767,
    787897,
    798877,
    687787,
    897889,
    998778,
    778986,
    968888,
    788997,
    887878,
    888889,
    678999,
    777888,
    999887,
    778788,
    789988,
    777979,
    778877,
    898687,
    878799,
    768878,
    888899,
    887789,
    788887,
    797876,
    887778,
    688987,
    869898,
    877779,
    879679,
    888787,
    868996,
    868877,
    997888,
    897879,
    886778,
    868889,
    897889,
    787789,
    898799,
    888878,
    678677,
    987877,
    887887,
    887989,
    877787,
    697887,
    777977,
    787977,
    878987,
    877788,
    977777,
    778879,
    987786,
    868888,
    899887,
    887887,
    888889,
    799996,
    876879,
    778887,
    887778,
    867888,
    777778,
    887886,
    897777,
    868897,
    898786,
    769989,
    699997,
    888979,
    888778,
    799979,
    978678,
    877886,
    888988,
    788877,
    977977,
    689787,
    867897,
    777888,
    888978,
    878778,
    798787,
    888986,
    887798,
    789888,
    897888,
    867687,
    787886,
    988869,
    877777,
    788779,
    787797,
    877987,
    977888,
    896897,
    777987,
    889799,
    878876,
    899686,
    878789,
    987778,
    796878,
    778877,
    876689,
    898888,
    688788,
    679887,
    898978,
    888878,
    898688,
    767998,
    777968,
    887788,
    887777,
    868897,
    879898,
    886798,
    778888,
    987788,
    979878,
    768879,
    778798,
    879878,
    787886,
    768788,
    887888,
    897887,
    887977,
    888768,
    779788,
    788888,
    887778,
    887798,
    888998,
    898988,
    977887,
    888789,
    989778,
    988888,
    977887,
    869899,
    789799,
    887788,
    787786,
    887788,
    878787,
    888679,
    898697,
    877977,
    879889,
    887877,
    887799,
    978978,
    878787,
    888887,
    787798,
    898778,
    889899,
    768886,
    878798,
    887877,
    987777,
    879787,
    867777,
    788888,
    968878,
    899898,
    788777,
    788688,
    977778,
    888877,
    888767,
    776888,
    876878,
    988888,
    889778,
    689788,
    998878,
    869788,
    879978,
    887789,
    999888,
    997877,
    779887,
    787878,
    979886,
    889887,
    978988,
    789777,
    878698,
    788878,
    767887,
    979686,
    687788,
    788897,
    889887,
    787986,
    878896,
    889887,
    898778,
    787898,
    888778,
    687878,
    977986,
    879998,
    998798,
    988986,
    987977,
    877798,
    777879,
    789767,
    777788,
    888979,
    867789,
    887979,
    888788,
    987888,
    787988,
    788868,
    877767,
    878898,
    887789,
    876798,
    869888,
    878776,
    998767,
    798899,
    798989,
    888877,
    878868,
    897787,
    778878,
    898877,
    789779,
    879899,
    888987,
    888799,
    887889,
    678689,
    987978,
    786678,
    677887,
    678999,
    876968,
    988779,
    979766,
    789869,
    867889,
    898888,
    788888,
    678887,
    979898,
    778787,
    986778,
    789889,
    778988,
    877997,
    798888,
    869778,
    787888,
    786778,
    789877,
    977788,
    898898,
    889778,
    889897,
    977879,
    977889,
    878888,
    987887,
    876989,
    888889,
    889878,
    788697,
    869788,
    889777,
    787988,
    989998,
    787998,
    988887,
    778887,
    899889,
    787879,
    799889,
    788798,
    678888,
    877888,
    887787,
    876798,
    787888,
    797878,
    878987,
    767888,
    787888,
    878778,
    888777,
    699797,
    898886,
    988777,
    888988,
    989687,
    877886,
    788797,
    886887,
    888888,
    888798,
    987678,
    888867,
    978988,
    897789,
    767897,
    789796,
    978688,
    877889,
    889988,
    897777,
    689787,
    877779,
    879888,
    788878,
    888876,
    777787,
    899878,
    777787,
    888778,
    798989,
    887779,
    778898,
    987798,
    988768,
    788778,
    988797,
    767888,
    689768,
    879869,
    887878,
    979987,
    787687,
    889989,
    787877,
    786967,
    788788,
    777888,
    789778,
    888789,
    687988,
    779878,
    898889,
    886878,
    899879,
    777978,
    887778,
    688799,
    888897,
    988887,
    778778,
    967887,
    777787,
    889788,
    768677,
    777879,
    978778,
    888799,
    788798,
    887879,
    898686,
    797976,
    897998,
    787787,
    988786,
    797897,
    777777,
    878779,
    789987,
    796887,
    788987,
    688878,
    879897,
    679898,
    898878,
    869979,
    968888,
    888977,
    978888,
    989986,
    776978,
    868887,
    887978,
    788777,
    786899,
    979887,
    788897,
    797989,
    688878,
    877789,
    897778,
    788789,
    878897,
    789688,
    787978,
    888867,
    777887,
    877999,
    998677,
    688777,
    688879,
    799787,
    899778,
    899868,
    897789,
    768787,
    988787,
    889878,
    788877,
    688779,
    797777,
    987788,
    878878,
    889777,
    988797,
    977888,
    779797,
    788688,
    988989,
    888798,
    876688,
    989776,
    877878,
    779788,
    688776,
    699877,
    896867,
    778799,
    697798,
    886796,
    989898,
    888777,
    887687,
    988878,
    877867,
    778789,
    787898,
    978787,
    997888,
    777788,
    988978,
    776887,
    879979,
    867887,
    887988,
    887798,
    878998,
    877897,
    998789,
    877886,
    789878,
    888888,
    887889,
    667779,
    687778,
    778776,
    897788,
    977986,
    998778,
    798788,
    768788,
    888779,
    987878,
    877887,
    878867,
    888778,
    678987,
    898988,
    998977,
    877897,
    889888,
    988997,
    777898,
    977776,
    988878,
    889888,
    988796,
    877887,
    886977,
    987767,
    897976,
    979878,
    789687,
    978888,
    799878,
    896989,
    899888,
    888978,
    777887,
    888879,
    988677,
    789887,
    887769,
    698778,
    888989,
    686899,
    887788,
    777988,
    787788,
    798788,
    879777,
    888888,
    768788,
    678879,
    868787,
    887788,
    897797,
    779778,
    699788,
    979798,
    778787,
    788768,
    878788,
    677977,
    977787,
    978688,
    886779,
    788778,
    867798,
    877887,
    887878,
    776688,
    888877,
    988878,
    776887,
    778988,
    688868,
    888879,
    776788,
    687987,
    689778,
    687878,
    786787,
    779768,
    977887,
    667977,
    878877,
    987787,
    787879,
    698778,
    788887,
    779797,
    879887,
    888688,
    887788,
    687789,
    897977,
    788788,
    886888,
    797998,
    979867,
    879899,
    897997,
    788898,
    887897,
    798786,
    876997,
    977977,
    888789,
    678988,
    878788,
    878877,
    976679,
    676688,
    688877,
    987789,
    877797,
    886978,
    968797,
    778879,
    799888,
    787787,
    878997,
    787669,
    889888,
    797697,
    788978,
    776887,
    788779,
    988998,
    779877,
    868768,
    687978,
    778798,
    788889,
    878888,
    778968,
    897978,
    879876,
    888786,
    886979,
    888797,
    779879,
    797768,
    888897,
    798888,
    788789,
    868886,
    789889,
    789797,
    978767,
    988987,
    889878,
    798988,
    679878,
    798799,
    989898,
    877888,
    899887,
    886989,
    869886,
    889998,
    877879,
    887797,
    888788,
    668868,
    877789,
    678978,
    786787,
    788898,
    887866,
    789687,
    787887,
    888888,
    767686,
    989788,
    977699,
    897888,
    866787,
    788886,
    977887,
    688988,
    789778,
    788788,
    797888,
    769977,
    777879,
    787878,
    789797,
    988786,
    796868,
    968788,
    678978,
    897878,
    787889,
    779988,
    898977,
    877788,
    877877,
    888989,
    987678,
    887877,
    988987,
    997798,
    989888,
    878899,
    898788,
    987967,
    789798,
    898789,
    876877,
    889787,
    876897,
    778888,
    867878,
    788789,
    888868,
    788888,
    888797,
    688799,
    878887,
    967988,
    778988,
    887877,
    888768,
    779889,
    877998,
    997997,
    788979,
    888786,
    987889,
    989976,
    898786,
    976776,
    798887,
    976787,
    886978,
    789797,
    787798,
    978787,
    778797,
    887878,
    888767,
    899777,
    897776,
    799767,
    788999,
    878878,
    869879,
    868887,
    878878,
    889887,
    688677,
    788897,
    968887,
    778878,
    889877,
    698777,
    889767,
    998778,
    788898,
    788776,
    798878,
    787989,
    879778,
    897799,
    898898,
    799879,
    797888,
    887889,
    988989,
    899687,
    879878,
    877788,
    777788,
    887888,
    787887,
    966897,
    888778,
    978876,
    989898,
    779778,
    788887,
    878887,
    788987,
    997776,
    868787,
    977877,
    898788,
    899787,
    877988,
    997669,
    879898,
    888869,
    878997,
    869888,
    989789,
    976778,
    778787,
    977788,
    879787,
    898778,
    797887,
    879899,
    988977,
    987897,
    788787,
    877897,
    978888,
    777787,
    768977,
    889889,
    797777,
    987997,
    768977,
    888787,
    788698,
    889887,
    978677,
    987978,
    797887,
    996897,
    889777,
    878788,
    776878,
    878788,
    878788,
    879988,
    888898,
    778887,
    979979,
    888779,
    789687,
    886888,
    787987,
    878786,
    999887,
    788888,
    869888,
    788879,
    887967,
    768779,
    897988,
    789679,
    888878,
    777898,
    888988,
    877896,
    697787,
    898876,
    898789,
    878887,
    879789,
    988887,
    679788,
    878777,
    888777,
    988796,
    998888,
    799879,
    888889,
    898889,
    878778,
    988697,
    787996,
    778988,
    677866,
    989877,
    788888,
    898877,
    787769,
    869768,
    768676,
    868787,
    888698,
    987788,
    687988,
    779889,
    688799,
    778899,
    778788,
    788999,
    777878,
    768686,
    989796,
    898877,
    888778,
    896988,
    997979,
    987877,
    788878,
    878788,
    797887,
    969987,
    787787,
    987878,
    777778,
    989679,
    877777,
    877887,
    787787,
    689878,
    788778,
    869888,
    678879,
    888977,
    787878,
    898878,
    977877,
    877897,
    888787,
    878777,
    986889,
    888877,
    998798,
    799787,
    979789,
    778888,
    789768,
    888778,
    877887,
    869787,
    797777,
    898897,
    788788,
    789698,
    888887,
    898777,
    988898,
    867877,
    787887,
    777878,
    789888,
    779868,
    779698,
    789877,
    779788,
    866886,
    799879,
    988879,
    777898,
    767776,
    877888,
    787877,
    677797,
    987777,
    877987,
    777968,
    887867,
    877897,
    887787,
    977787,
    987987,
    988989,
    768787,
    789778,
    877798,
    787778,
    889967,
    887898,
    778868,
    788878,
    787679,
    898977,
    869897,
    767786,
    789888,
    987888,
    789788,
    687797,
    778697,
    988778,
    798887,
    778887,
    877787,
    889687,
    878878,
    887989,
    888887,
    898787,
    878987,
    887878,
    778998,
    789788,
    789889,
    888899,
    888897,
    878888,
    787888,
    898887,
    889978,
    869887,
    788878,
    879668,
    978989,
    978788,
    879678,
    777977,
    899987,
    787997,
    789777,
    779988,
    777868,
    797688,
    876889,
    668788,
    789777,
    878979,
    689898,
    879998,
    988768,
    898686,
    788788,
    798888,
    898978,
    868789,
    868687,
    867868,
    877888,
    986999,
    978997,
    888787,
    777789,
    779897,
    786778,
    768979,
    987888,
    787998,
    677787,
    889797,
    988897,
    788798,
    968997,
    787788,
    778798,
    899887,
    787868,
    886797,
    698779,
    888889,
    887868,
    799888,
    988787,
    787997,
    797887,
    987899,
    887789,
    796767,
    877879,
    797789,
    977887,
    999778,
    778977,
    778878,
    887677,
    989888,
    878986,
    988878,
    978789,
    888899,
    787888,
    877887,
    978788,
    878879,
    887788,
    897798,
    887967,
    787797,
    678688,
    788877,
    998887,
    887979,
    898896,
    879789,
    998887,
    789787,
    787786,
    768986,
    877888,
    879977,
    868986,
    987776,
    797889,
    989779,
    879887,
    878879,
    797888,
    779689,
    778977,
    799878,
    988889,
    877766,
    777878,
    877788,
    888767,
    977866,
    776999,
    889779,
    789778,
    978887,
    888799,
    889778,
    797888,
    888799,
    988997,
    987898,
    889997,
    797979,
    788877,
    798687,
    986887,
    986879,
    889878,
    987797,
    878788,
    886678,
    869787,
    978877,
    788677,
    878877,
    777777,
    888788,
    877798,
    687888,
    897869,
    777798,
    788897,
    788968,
    877798,
    888777,
    878778,
    877988,
    988877,
    978788,
    888877,
    879878,
    867878,
    979787,
    977778,
    888898,
    877798,
    888777,
    979797,
    978877,
    987877,
    677787,
    778888,
    788778,
    879799,
    886888,
    788977,
    786897,
    889778,
    976988,
    779979,
    788797,
    898778,
    879787,
    876898,
    888788,
    698799,
    976887,
    677889,
    799689,
    688887,
    788698,
    888878,
    888878,
    898887,
    788789,
    886777,
    896987,
    789977,
    876886,
    986888,
    787968,
    988868,
    878779,
    878769,
    877778,
    889877,
    986888,
    867789,
    889679,
    898987,
    876898,
    967777,
    988878,
    899889,
    676789,
    898878,
    898977,
    788878,
    777668,
    797778,
    889979,
    777788,
    889888,
    988868,
    898786,
    989789,
    977787,
    887896,
    878788,
    879898,
    877987,
    988887,
    789898,
    697778,
    867797,
    989787,
    987987,
    887798,
    987898,
    876877,
    788778,
    878879,
    899887,
    777986,
    787977,
    889677,
    878888,
    787777,
    877988,
    887778,
    889988,
    778797,
    887867,
    888879,
    869689,
    999889,
    776889,
    888887,
    887988,
    799989,
    977887,
    687969,
    868778,
    878777,
    788778,
    779987,
    888678,
    977889,
    868787,
    798977,
    877877,
    969988,
    888888,
    886787,
    978787,
    877787,
    878987,
    888887,
    868978,
    978889,
    887886,
    797988,
    879977,
    898787,
    887886,
    777678,
    877889,
    877888,
    889868,
    777787,
    786888,
    987886,
    798979,
    878879,
    877786,
    978897,
    878878,
    867878,
    777786,
    687777,
    878888,
    888989,
    777997,
    977798,
    788687,
    888788,
    988887,
    877888,
    887799,
    788768,
    879778,
    787888,
    898978,
    778788,
    888887,
    787687,
    899788,
    898989,
    999898,
    888796,
    788888,
    897877,
    978799,
    797787,
    987788,
    787896,
    678699,
    788779,
    998887,
    888898,
    878777,
    679877,
    878677,
    787887,
    898888,
    868889,
    798789,
    877788,
    896888,
    977878,
    997898,
    767888,
    898788,
    987987,
    798887,
    897789,
    889877,
    988887,
    899788,
    979888,
    868997,
    898878,
    789978,
    779979,
    887988,
    897988,
    978768,
    797898,
    889788,
    889776,
    887776,
    788788,
    788877,
    989887,
    899888,
    668868,
    987867,
    876779,
    996997,
    988988,
    779877,
    878789,
    978787,
    888877,
    998986,
    767877,
    798887,
    997887,
    676789,
    877676,
    788676,
    779897,
    987886,
    987788,
    787777,
    787897,
    877897,
    898997,
    887978,
    896787,
    987979,
    888777,
    878888,
    787777,
    976997,
    896668,
    877889,
    778889,
    878988,
    888887,
    997888,
    887988,
    789899,
    888688,
    887897,
    868878,
    768878,
    997879,
    879788,
    888876,
    997679,
    987777,
    787897,
    897977,
    776888,
    877777,
    867777,
    797888,
    887987,
    798888,
    889888,
    878888,
    778987,
    869669,
    987986,
    788986,
    677868,
    779887,
    687997,
    888767,
    888897,
    897788,
    688897,
    888888,
    778777,
    867876,
    887777,
    768689,
    879888,
    779988,
    876879,
    787898,
    787778,
    778887,
    898987,
    788988,
    768878,
    797888,
    988899,
    898888,
    889767,
    889789,
    797989,
    988989,
    887786,
    798878,
    877786,
    788887,
    888689,
    898777,
    778897,
    987899,
    878889,
    778777,
    888778,
    889877,
    797686,
    887989,
    898878,
    797878,
    788897,
    977987,
    898997,
    797887,
    798879,
    986868,
    697877,
    878788,
    988898,
    998797,
    698888,
    977878,
    778797,
    987787,
    787898,
    889777,
    888799,
    768688,
    887988,
    989977,
    897877,
    688787,
    788879,
    787678,
    878788,
    878787,
    787986,
    788797,
    797877,
    879998,
    786878,
    766877,
    797697,
    987787,
    789898,
    777898,
    999788,
    888877,
    776988,
    787899,
    687676,
    689776,
    889797,
    878797,
    789768,
    687779,
    977788,
    876788,
    777887,
    767697,
    897777,
    877877,
    887788,
    877787,
    878697,
    886888,
    789889,
    987796,
    888788,
    798878,
    989887,
    868987,
    797678,
    899778,
    788889,
    897778,
    877888,
    888788,
    886988,
    989877,
    779769,
    789989,
    798978,
    888779,
    887888,
    887999,
    989987,
    898688,
    778999,
    798687,
    888679,
    887687,
    787797,
    797877,
    688868,
    977898,
    877879,
    877877,
    797988,
    797977,
    878787,
    887878,
    988998,
    778889,
    798786,
    877988,
    887787,
    787787,
    867787,
    778788,
    798878,
    979787,
    877988,
    977798,
    887767,
    877897,
    888977,
    899888,
    877897,
    877888,
    897898,
    868798,
    767877,
    888877,
    678887,
    777787,
    788987,
    888977,
    887888,
    689788,
    787777,
    887797,
    869897,
    898876,
    788879,
    787878,
    989869,
    766897,
    897778,
    896797,
    768887,
    688778,
    777769,
    698898,
    888687,
    868677,
    897798,
    899897,
    888797,
    798677,
    877798,
    767788,
    887886,
    778797,
    986988,
    877889,
    779779,
    897798,
    779868,
    888677,
    887988,
    876867,
    877798,
    879678,
    887888,
    877786,
    698788,
    779768,
    978887,
    789787,
    777978,
    867778,
    877788,
    867688,
    778667,
    877899,
    879888,
    879797,
    787879,
    788888,
    878887,
    897788,
    977787,
    787788,
    788989,
    787878,
    977877,
    778777,
    988887,
    986888,
    779878,
    888899,
    889877,
    876967,
    988998,
    877979,
    687788,
    877888,
    888888,
    888789,
    888997,
    979788,
    799987,
    989777,
    887787,
    789668,
    887698,
    898777,
    777878,
    896688,
    787978,
    688867,
    778788,
    778779,
    687778,
    677788,
    878897,
    888887,
    888899,
    978979,
    989778,
    887989,
    988978,
    867788,
    877888,
    788889,
    999778,
    788778,
    777677,
    697796,
    899898,
    788897,
    999868,
    798888,
    898798,
    887787,
    898798,
    987887,
    788988,
    889679,
    989997,
    888898,
    989998,
    988777,
    977888,
    888998,
    778778,
    797978,
    796888,
    687777,
    898797,
    877779,
    788798,
    798887,
    897878,
    889967,
    977697,
    878797,
    877779,
    998787,
    987897,
    777799,
    788899,
    876777,
    668888,
    789987,
    878788,
    767887,
    778888,
    887789,
    689998,
    887998,
    967878,
    977889,
    787768,
    787886,
    867687,
    697899,
    888977,
    888887,
    787868,
    779978,
    789798,
    989988,
    878667,
    768688,
    788788,
    877978,
    978778,
    786998,
    699899,
    888697,
    979887,
    888787,
    789996,
    788787,
    888689,
    768877,
    787677,
    986789,
    878898,
    787867,
    887778,
    998877,
    878778,
    878879,
    888788,
    877878,
    989987,
    798887,
    998868,
    688788,
    777878,
    699698,
    989977,
    878696,
    687886,
    867898,
    887976,
    797896,
    788788,
    766678,
    888778,
    887887,
    877688,
    778977,
    788678,
    678978,
    997798,
    888988,
    998777,
    797898,
    877889,
    777988,
    986988,
    897888,
    877899,
    788678,
    798988,
    788777,
    878868,
    678779,
    877896,
    998988,
    797868,
    897798,
    967889,
    888697,
    888798,
    867798,
    887798,
    776877,
    778787,
    997877,
    888888,
    878688,
    868888,
    888778,
    797797,
    886879,
    897888,
    978887,
    888789,
    688778,
    898778,
    977888,
    968897,
    898777,
    887798,
    898987,
    787786,
    678989,
    888687,
    778878,
    789687,
    988999,
    998898,
    988778,
    778688,
    778678,
    769776,
    787878,
    787787,
    788777,
    989887,
    886767,
    878696,
    888887,
    977777,
    887889,
    879869,
    896669,
    769877,
    889788,
    896767,
    676877,
    968879,
    799988,
    977866,
    878778,
    778777,
    887887,
    796789,
    888778,
    688797,
    777887,
    777978,
    989697,
    779898,
    886996,
    968898,
    897786,
    889677,
    778989,
    987888,
    987866,
    968998,
    778688,
    988789,
    787889,
    888897,
    899789,
    779899,
    898777,
    978889,
    979988,
    988777,
    887797,
    888778,
    897887,
    877888,
    987898,
    799967,
    979987,
    688797,
    877998,
    878887,
    789987,
    789888,
    879878,
    778889,
    889889,
    889888,
    878877,
    989888,
    787767,
    798788,
    898999,
    888977,
    878888,
    688898,
    998879,
    976878,
    888798,
    889789,
    889878,
    877888,
    878797,
    888879,
    789986,
    787877,
    888888,
    888878,
    888788,
    888987,
    776786,
    788698,
    987788,
    988878,
    677978,
    897887,
    886887,
    777988,
    989889,
    878887,
    779889,
    977887,
    788788,
    786888,
    777889,
    877888,
    898787,
    778879,
    896877,
    787899,
    978966,
    888999,
    786878,
    889889,
    877879,
    886797,
    778979,
    789888,
    886869,
    897767,
    889679,
    778988,
    978999,
    877768,
    888799,
    899897,
    787868,
    898786,
    877888,
    798877,
    978778,
    888687,
    896877,
    978886,
    789886,
    887877,
    788887,
    897877,
    776988,
    889698,
    778667,
    696988,
    678878,
    889888,
    888877,
    967766,
    786887,
    888967,
    888987,
    888788,
    678778,
    887987,
    888888,
    889878,
    787698,
    788787,
    876898,
    777799,
    967999,
    887698,
    878678,
    877889,
    878886,
    688798,
    777888,
    887869,
    779788,
    988798,
    787878,
    898878,
    788668,
    987779,
    887778,
    888897,
    677888,
    887778,
    879677,
    888888,
    788888,
    898886,
    898888,
    897788,
    778777,
    898788,
    779697,
    888987,
    788888,
    888887,
    878986,
    798778,
    876777,
    898788,
    999876,
    678878,
    867868,
    888869,
    778896,
    688777,
    998677,
    788678,
    777896,
    787887,
    788988,
    799879,
    786989,
    778897,
    776879,
    967888,
    986877,
    998988,
    897878,
    897968,
    886798,
    878787,
    887886,
    879968,
    887978,
    897897,
    779788,
    979878,
    887778,
    988779,
    789899,
    777878,
    698787,
    897787,
    887977,
    787869,
    996877,
    878788,
    978998,
    867989,
    887878,
    669978,
    898877,
    779889,
    767798,
    887867,
    789787,
    878797,
    679979,
    896879,
    898788,
    886788,
    989888,
    888877,
    788788,
    997888,
    768886,
    788888,
    868678,
    988777,
    987889,
    789778,
    699789,
    887899,
    797687,
    769888,
    877777,
    899787,
    978887,
    876986,
    868788,
    689799,
    779678,
    888889,
    888887,
    878889,
    877888,
    997878,
    789968,
    877787,
    778877,
    988787,
    798878,
    887877,
    787976,
    979799,
    778778,
    868879,
    788987,
    778787,
    778799,
    888797,
    888999,
    998787,
    988879,
    898767,
    998877,
    887888,
    877788,
    999878,
    889787,
    869789,
    877787,
    788888,
    787887,
    788798,
    987888,
    978988,
    878789,
    879797,
    789987,
    878777,
    977988,
    878868,
    787878,
    898679,
    987878,
    997897,
    877868,
    787887,
    786778,
    797887,
    879786,
    777787,
    888789,
    989978,
    888989,
    898797,
    879888,
    788879,
    967866,
    898878,
    878688,
    778897,
    688788,
    866688,
    899998,
    878777,
    888667,
    787889,
    978788,
    878789,
    798998,
    887798,
    778888,
    878877,
    768787,
    789787,
    878889,
    997777,
    887799,
    978998,
    788769,
    767889,
    979878,
    886988,
    667777,
    888888,
    988989,
    788888,
    679978,
    768877,
    779987,
    778979,
    787786,
    797986,
    987877,
    897887,
    788799,
    678777,
    897877,
    887867,
    878796,
    887889,
    888878,
    777887,
    987899,
    767879,
    899988,
    788897,
    777878,
    788996,
    797888,
    888788,
    878887,
    798798,
    888699,
    799876,
    797678,
    788878,
    778978,
    679879,
    977878,
    988978,
    888787,
    688888,
    878896,
    897787,
    889987,
    899988,
    777788,
    888887,
    778867,
    996767,
    786788,
    779989,
    789889,
    698879,
    799788,
    798878,
    889778,
    778777,
    996688,
    798798,
    789898,
    788988,
    888898,
    888788,
    887777,
    887977,
    787876,
    687678,
    877869,
    886978,
    776679,
    988778,
    787776,
    686789,
    787888,
    988897,
    888877,
    789898,
    877878,
    888898,
    789777,
    787989,
    778987,
    788779,
    879886,
    787878,
    877787,
    878878,
    889977,
    688789,
    878788,
    788698,
    888987,
    778779,
    866998,
    988778,
    877876,
    798889,
    887798,
    888977,
    777898,
    799777,
    788888,
    887896,
    888877,
    878888,
    778788,
    887998,
    788788,
    969877,
    878678,
    777988,
    898988,
    777997,
    988899,
    878789,
    778798,
    898798,
    888768,
    887888,
    778887,
    887876,
    688988,
    996689,
    788787,
    888998,
    788777,
    689779,
    787777,
    687879,
    878978,
    887688,
    898687,
    888978,
    788787,
    887888,
    877978,
    799977,
    987769,
    998977,
    678777,
    797777,
    788989,
    798776,
    787788,
    888688,
    877787,
    877889,
    996887,
    979977,
    888888,
    878778,
    978788,
    878877,
    789779,
    997988,
    887898,
    786878,
    898989,
    799688,
    988998,
    887788,
    788889,
    998977,
    888877,
    978876,
    877779,
    889988,
    878778,
    978889,
    988788,
    887877,
    888886,
    977877,
    967878,
    878996,
    989866,
    889898,
    887889,
    899777,
    888888,
    887889,
    679987,
    798798,
    678988,
    777887,
    777788,
    898897,
    969688,
    769868,
    799978,
    777779,
    889968,
    888887,
    778888,
    876777,
    898879,
    878899,
    977897,
    769899,
    788778,
    788888,
    886697,
    877899,
    988778,
    777898,
    888888,
    878789,
    787888,
    878886,
    788977,
    889897,
    768878,
    788969,
    879977,
    787888,
    968797,
    898799,
    788888,
    898787,
    888988,
    886767,
    779778,
    897888,
    788877,
    798887,
    987978,
    999787,
    778787,
    986887,
    688998,
    987878,
    679888,
    777888,
    988888,
    978888,
    877988,
    889689,
    876898,
    779788,
    887778,
    687799,
    779887,
    788997,
    888797,
    879977,
    778787,
    788678,
    788778,
    988797,
    968977,
    797779,
    787898,
    978798,
    778877,
    897977,
    788789,
    788988,
    788878,
    898887,
    897789,
    787787,
    968887,
    877897,
    978887,
    878879,
    798987,
    876767,
    987897,
    786798,
    798688,
    998787,
    987896,
    886797,
    877778,
    987997,
    999887,
    888787,
    767979,
    796868,
    987999,
    988799,
    878779,
    887789,
    889798,
    888898,
    787877,
    877786,
    688778,
    888999,
    797686,
    677677,
    898989,
    788769,
    877887,
    988877,
    897888,
    779876,
    977868,
    789868,
    779779,
    887788,
    678869,
    888988,
    987987,
    769778,
    898978,
    987787,
    887787,
    897789,
    888888,
    789887,
    799889,
    988887,
    997778,
    877779,
    978877,
    887688,
    988788,
    779997,
    987787,
    789889,
    898988,
    878787,
    787876,
    796688,
    997688,
    888887,
    867887,
    768888,
    886898,
    898879,
    779987,
    767789,
    768897,
    788798,
    897778,
    979888,
    978767,
    887777,
    887798,
    888786,
    797888,
    798888,
    988987,
    968779,
    977777,
    877778,
    768988,
    878799,
    989977,
    898878,
    997999,
    887988,
    777878,
    786688,
    878999,
    878676,
    887988,
    879788,
    786788,
    898989,
    987878,
    787887,
    898978,
    979777,
    998978,
    878789,
    689777,
    788789,
    878797,
    888877,
    978787,
    889986,
    878888,
    887888,
    997878,
    878879,
    786889,
    889786,
    989788,
    888898,
    998887,
    877788,
    687966,
    977889,
    778888,
    867887,
    888988,
    988898,
    878887,
    977788,
    898678,
    789988,
    889869,
    787796,
    889788,
    878799,
    798889,
    778879,
    799788,
    777977,
    888987,
    899788,
    677988,
    979878,
    897866,
    987887,
    698889,
    886789,
    768686,
    877687,
    789797,
    887787,
    689879,
    868878,
    997989,
    789887,
    668778,
    896887,
    797877,
    887879,
    988898,
    988787,
    999788,
    887877,
    899878,
    877778,
    887768,
    786899,
    779789,
    777779,
    688787,
    977779,
    988887,
    877779,
    777888,
    998889,
    667877,
    769767,
    797777,
    888788,
    878887,
    798877,
    878977,
    678696,
    978878,
    989888,
    988688,
    888988,
    788988,
    789799,
    697796,
    899778,
    677966,
    878878,
    778888,
    887878,
    998978,
    778677,
    888677,
    878889,
    768778,
    788777,
    797877,
    788887,
    776767,
    978777,
    987788,
    988887,
    778777,
    889888,
    897779,
    989978,
    897986,
    799988,
    888788,
    778887,
    877787,
    986879,
    988878,
    799977,
    889988,
    988778,
    697877,
    878779,
    787887,
    989998,
    879799,
    788798,
    778779,
    798997,
    886789,
    889979,
    788778,
    888998,
    667889,
    777878,
    896899,
    788879,
    677878,
    887977,
    897798,
    779777,
    787897,
    877787,
    976897,
    887888,
    879788,
    898976,
    888768,
    797788,
    877687,
    989987,
    987898,
    797889,
    879878,
    778868,
    868787,
    888878,
    798887,
    777978,
    788767,
    879768,
    789787,
    899787,
    978887,
    888677,
    897887,
    887997,
    888979,
    878868,
    877887,
    777889,
    888988,
    789898,
    898989,
    888799,
    788877,
    687878,
    687888,
    896899,
    788888,
    887887,
    799789,
    888797,
    988877,
    887998,
    768899,
    978886,
    789698,
    897889,
    888979,
    779888,
    788887,
    888988,
    878897,
    798978,
    798878,
    888788,
    879887,
    788887,
    789878,
    898878,
    878878,
    778888,
    787786,
    978878,
    978889,
    888978,
    876887,
    878888,
    688887,
    688898,
    788888,
    677878,
    897888,
    789879,
    788886,
    888888,
    887897,
    687887,
    789977,
    887888,
    898769,
    888789,
    989978,
    978978,
    788699,
    788679,
    889796,
    876879,
    788988,
    789898,
    768798,
    878888,
    866878,
    789978,
    997899,
    777888,
    977688,
    878877,
    869879,
    779889,
    886898,
    889787,
    887688,
    888887,
    988898,
    889887,
    768688,
    778888,
    896987,
    888988,
    878877,
    778787,
    879987,
    788887,
    888798,
    877777,
    797998,
    987877,
    899888,
    999987,
    978998,
    887798,
    887778,
    788888,
    898789,
    688877,
    798889,
    789787,
    887878,
    778989,
    888898,
    878978,
    988778,
    987778,
    798778,
    888798,
    787688,
    768978,
    768779,
    888887,
    778788,
    899787,
    878877,
    787888,
    978887,
    877978,
    968798,
    779787,
    897798,
    977887,
    878898,
    896978,
    677787,
    977877,
    967888,
    687789,
    897998,
    767788,
    998796,
    687677,
    687988,
    798888,
    888888,
    977877,
    777878,
    797899,
    878788,
    687879,
    999887,
    967997,
    878987,
    788788,
    898789,
    988977,
    897687,
    779678,
    987878,
    997988,
    997899,
    978877,
    897889,
    986988,
    787778,
    987878,
    889889,
    887698,
    898888,
    977878,
    778888,
    887778,
    788889,
    698787,
    888887,
    868887,
    799978,
    887878,
    799879,
    879989,
    877988,
    887789,
    998988,
    987788,
    789986,
    798898,
    786887,
    998778,
    887899,
    879799,
    798779,
    779889,
    878878,
    877787,
    798887,
    968878,
    887887,
    888977,
    996987,
    677787,
    688997,
    787787,
    999778,
    788878,
    899987,
    886887,
    686788,
    889976,
    667797,
    877699,
    878888,
    778776,
    897789,
    788887,
    779987,
    897788,
    788777,
    989878,
    778788,
    787888,
    888787,
    889987,
    898898,
    787888,
    999777,
    898887,
    789887,
    787988,
    788979,
    877778,
    788877,
    699779,
    789788,
    896777,
    878878,
    897998,
    889797,
    787887,
    889899,
    889887,
    877877,
    889868,
    888788,
    878868,
    787688,
    887889,
    797789,
    788877,
    989888,
    886788,
    977878,
    888787,
    789877,
    788799,
    979889,
    888778,
    978777,
    879787,
    797988,
    878777,
    987867,
    897887,
    867986,
    787886,
    876886,
    878897,
    889976,
    987797,
    998889,
    899977,
    989989,
    877889,
    778988,
    868787,
    786988,
    978968,
    787778,
    788887,
    987888,
    999888,
    879989,
    677899,
    888877,
    897877,
    878887,
    767878,
    787688,
    787879,
    967797,
    989788,
    969897,
    997887,
    887879,
    887778,
    877887,
    988988,
    896678,
    868889,
    888888,
    778898,
    877878,
    778879,
    886789,
    898878,
    898897,
    797798,
    987897,
    887877,
    779778,
    898878,
    788878,
    978878,
    796878,
    888898,
    787698,
    878998,
    777977,
    998898,
    899688,
    887988,
    878788,
    778797,
    677689,
    899889,
    979889,
    988777,
    689968,
    787978,
    868676,
    897878,
    989878,
    888888,
    876877,
    798788,
    988897,
    798986,
    987788,
    877778,
    799787,
    888887,
    877887,
    989987,
    787868,
    776797,
    987687,
    777777,
    978798,
    688987,
    867889,
    686679,
    887786,
    868668,
    888888,
    888878,
    777777,
    997988,
    677877,
    878889,
    687998,
    887778,
    887797,
    979778,
    888967,
    887787,
    877878,
    878878,
    978877,
    999886,
    779989,
    887787,
    987777,
    889888,
    878898,
    788878,
    787897,
    977788,
    787787,
    697987,
    978876,
    797877,
    877876,
    887878,
    988978,
    986889,
    797879,
    878768,
    878988,
    787988,
    898987,
    887887,
    789789,
    788887,
    798777,
    897877,
    788877,
    688788,
    987968,
    688897,
    897789,
    677868,
    897798,
    898878,
    799889,
    868688,
    687777,
    889878,
    878769,
    877778,
    877888,
    989688,
    888777,
    889678,
    989898,
    787987,
    778878,
    878767,
    989687,
    877787,
    878898,
    887886,
    797898,
    878778,
    877988,
    988787,
    989788,
    786797,
    779897,
    987877,
    997867,
    877988,
    777798,
    799989,
    776887,
    978779,
    887878,
    878988,
    888777,
    887888,
    786887,
    779978,
    878787,
    888899,
    778898,
    888798,
    988888,
    896879,
    788887,
    788989,
    889988,
    787787,
    898879,
    887998,
    877788,
    778779,
    887888,
    687878,
    687878,
    887777,
    889878,
    777897,
    886887,
    789986,
    978877,
    978789,
    698887,
    898899,
    889988,
    798877,
    778987,
    777887,
    877988,
    789686,
    888888,
    969888,
    788879,
    978888,
    787897,
    878668,
    888888,
    998977,
    878798,
    787778,
    789888,
    877788,
    988879,
    997979,
    667788,
    977896,
    798778,
    887878,
    789797,
    977986,
    887698,
    979977,
    889786,
    887898,
    789877,
    797888,
    879977,
    888878,
    877888,
    888789,
    878876,
    977968,
    888886,
    969787,
    767898,
    986789,
    878768,
    879887,
    778887,
    779898,
    878799,
    897788,
    789787,
    978886,
    787988,
    887787,
    888887,
    969897,
    799779,
    877678,
    979988,
    897987,
    776888,
    878777,
    786777,
    788888,
    797868,
    889878,
    887888,
    778878,
    989897,
    888789,
    776897,
    779798,
    877886,
    987998,
    988877,
    898987,
    789878,
    988768,
    776687,
    776779,
    887888,
    788888,
    878888,
    888788,
    877788,
    786778,
    886786,
    898899,
    878877,
    899888,
    787897,
    788888,
    867787,
    888888,
    888987,
    988977,
    878987,
    889878,
    888887,
    779777,
    787868,
    799778,
    899888,
    878897,
    898779,
    999877,
    788888,
    789978,
    887787,
    887887,
    687788,
    888798,
    987898,
    868779,
    886776,
    788778,
    788779,
    788888,
    789678,
    887977,
    788889,
    799888,
    978877,
    888776,
    968778,
    878988,
    777888,
    787887,
    888886,
    887797,
    988787,
    887779,
    898866,
    889869,
    879998,
    788888,
    889898,
    767877,
    887988,
    789787,
    787877,
    889679,
    799899,
    886787,
    867897,
    689788,
    889768,
    888786,
    879778,
    987798,
    877897,
    888877,
    887887,
    778887,
    778888,
    899777,
    889787,
    789888,
    878678,
    877888,
    977886,
    778789,
    887678,
    678888,
    888888,
    888887,
    878878,
    888878,
    987797,
    878797,
    887987,
    879979,
    967787,
    768879,
    778798,
    898798,
    977888,
    878886,
    878888,
    877988,
    877668,
    788888,
    889989,
    997797,
    999877,
    777987,
    896878,
    698888,
    888889,
    797688,
    779797,
    878887,
    887788,
    786798,
    878797,
    988889,
    787777,
    879769,
    868887,
    977888,
    988788,
    879878,
    779788,
    779677,
    978789,
    788876,
    987978,
    877789,
    987797,
    788999,
    897878,
    978686,
    888979,
    878878,
    988968,
    887788,
    679768,
    877777,
    778799,
    877996,
    667988,
    788999,
    688879,
    777887,
    998697,
    777987,
    797986,
    899887,
    777879,
    778688,
    778668,
    996786,
    988888,
    987786,
    889887,
    999788,
    986888,
    778898,
    879879,
    988877,
    798788,
    886878,
    879777,
    878687,
    879878,
    989886,
    888788,
    876887,
    889978,
    788998,
    889879,
    788799,
    989888,
    788798,
    897888,
    797798,
    878777,
    778779,
    798798,
    788687,
    887988,
    788778,
    978878,
    879977,
    897879,
    776877,
    687877,
    777668,
    898878,
    768888,
    779778,
    686867,
    779989,
    786699,
    887797,
    988989,
    678877,
    886878,
    878899,
    877788,
    888787,
    868787,
    788877,
    987877,
    876878,
    879687,
    787879,
    778698,
    786697,
    888788,
    788878,
    787889,
    878997,
    888898,
    788888,
    989979,
    997778,
    878899,
    786899,
    777988,
    987978,
    687688,
    798778,
    988769,
    867976,
    987878,
    887978,
    678887,
    699688,
    788887,
    786969,
    798686,
    788878,
    988979,
    798797,
    698889,
    889677,
    867887,
    786899,
    888788,
    777986,
    678867,
    888778,
    789978,
    988698,
    797876,
    887767,
    786877,
    678877,
    897887,
    877978,
    889777,
    788796,
    888698,
    687989,
    887778,
    788887,
    777787,
    897776,
    878788,
    877767,
    778879,
    778888,
    887898,
    899689,
    969777,
    978899,
    887877,
    878988,
    788879,
    978878,
    888798,
    876987,
    988777,
    888787,
    686888,
    988987,
    777878,
    779778,
    877977,
    679787,
    799988,
    779868,
    989889,
    898887,
    898897,
    797868,
    998788,
    886996,
    879987,
    889676,
    879898,
    789777,
    789789,
    877879,
    868888,
    798967,
    787898,
    877687,
    878998,
    996897,
    977987,
    899788,
    877988,
    988897,
    778786,
    796968,
    988768,
    878877,
    978878,
    687776,
    768778,
    779679,
    998777,
    697888,
    878967,
    888779,
    888887,
    896787,
    878886,
    877989,
    776779,
    887889,
    899888,
    976769,
    888887,
    979988,
    888877,
    889688,
    777997,
    799779,
    898887,
    868987,
    697877,
    776879,
    788988,
    888878,
    978979,
    779869,
    987888,
    898798,
    789887,
    887788,
    977966,
    888777,
    887979,
    868889,
    887889,
    998877,
    889786,
    878879,
    888979,
    887987,
    887787,
    887698,
    888876,
    877899,
    978898,
    878786,
    987886,
    888787,
    798788,
    777897,
    778868,
    889988,
    879879,
    888888,
    897977,
    777788,
    888678,
    788878,
    886889,
    888889,
    886978,
    886998,
    898988,
    978888,
    887888,
    878886,
    868877,
    888888,
    678777,
    698877,
    878878,
    978767,
    788978,
    897886,
    897788,
    788878,
    867799,
    887698,
    977787,
    787787,
    898897,
    688687,
    988998,
    777877,
    768798,
    676869,
    978978,
    879977,
    798897,
    997879,
    989778,
    688896,
    798888,
    786798,
    687777,
    797678,
    877888,
    988988,
    887897,
    987797,
    878887,
    987788,
    886788,
    977877,
    679889,
    879888,
    868998,
    886997,
    777779,
    786778,
    877888,
    779988,
    787988,
    787987,
    876987,
    978878,
    788877,
    877888,
    688787,
    877778,
    888779,
    778899,
    876787,
    878798,
    867989,
    878988,
    877898,
    987798,
    677898,
    879888,
    889877,
    977887,
    887987,
    888977,
    687768,
    987878,
    887688,
    889899,
    698787,
    877888,
    878698,
    778777,
    888877,
    988787,
    989898,
    877788,
    988899,
    879867,
    789789,
    777787,
    967988,
    797886,
    979687,
    888879,
    888877,
    987999,
    777886,
    789878,
    787979,
    886776,
    889987,
    879888,
    889878,
    989778,
    689888,
    898987,
    867887,
    987987,
    789889,
    778787,
    887778,
    988887,
    988869,
    889898,
    787888,
    679887,
    778787,
    799789,
    689988,
    888898,
    768878,
    878778,
    777879,
    869989,
    989888,
    988887,
    989868,
    796688,
    998988,
    878786,
    878987,
    888887,
    778779,
    778988,
    977978,
    978789,
    997879,
    878799,
    888868,
    877987,
    888797,
    989789,
    787886,
    777888,
    877678,
    886798,
    889877,
    777789,
    787887,
    876779,
    786777,
    997887,
    788878,
    889878,
    788877,
    877996,
    788779,
    898887,
    898778,
    998887,
    978798,
    888887,
    788779,
    988778,
    787798,
    787888,
    798688,
    898797,
    788788,
    898769,
    878777,
    888787,
    987876,
    879768,
    797697,
    789887,
    798787,
    989887,
    777888,
    687788,
    798887,
    898877,
    988978,
    668886,
    877788,
    889978,
    877888,
    888879,
    787897,
    888899,
    898887,
    877668,
    997698,
    877877,
    898787,
    788678,
    888887,
    978987,
    988789,
    798678,
    887998,
    988788,
    798689,
    888787,
    988778,
    779967,
    988777,
    869788,
    788988,
    768878,
    697888,
    878799,
    986897,
    897787,
    877678,
    978889,
    988877,
    887877,
    988888,
    767977,
    977889,
    979998,
    787799,
    887877,
    878788,
    987688,
    878897,
    879878,
    788887,
    987878,
    877978,
    898778,
    898898,
    888878,
    878888,
    788789,
    888779,
    988779,
    978897,
    976788,
    668899,
    877898,
    787867,
    788876,
    679899,
    898788,
    887898,
    979898,
    899789,
    979879,
    778789,
    797788,
    878878,
    977777,
    878788,
    789898,
    767897,
    788888,
    878788,
    998887,
    889789,
    788667,
    868888,
    788979,
    889987,
    989776,
    977769,
    679787,
    888978,
    789888,
    899799,
    878788,
    888886,
    866876,
    789778,
    777687,
    978787,
    778987,
    688769,
    887767,
    887786,
    797887,
    788877,
    998898,
    978888,
    897777,
    896888,
    687879,
    898777,
    887879,
    787888,
    898797,
    778687,
    688887,
    877899,
    867998,
    697877,
    988778,
    778887,
    989888,
    768788,
    877888,
    788868,
    677877,
    687898,
    889887,
    888889,
    878798,
    777889,
    788886,
    878989,
    878889,
    788976,
    778868,
    678798,
    978887,
    878978,
    997777,
    797778,
    878887,
    898867,
    768889,
    768887,
    788888,
    777989,
    797878,
    776788,
    889888,
    989787,
    797899,
    797879,
    898687,
    787876,
    986778,
    678879,
    888888,
    888998,
    889878,
    976789,
    889889,
    799778,
    888876,
    788687,
    877877,
    777788,
    779798,
    879989,
    787896,
    887898,
    868787,
    879777,
    788778,
    888879,
    978877,
    998969,
    878888,
    787878,
    778777,
    687787,
    687778,
    979989,
    888888,
    877988,
    787987,
    888788,
    777788,
    997877,
    788889,
    989878,
    878978,
    787797,
    968797,
    777896,
    978888,
    777788,
    887887,
    778677,
    888878,
    777888,
    896887,
    797988,
    789998,
    678878,
    797877,
    878878,
    678987,
    779676,
    789987,
    888778,
    779878,
    888898,
    697997,
    997887,
    697897,
    876788,
    888778,
    867887,
    989797,
    797878,
    877977,
    677989,
    886899,
    876897,
    988996,
    987866,
    888979,
    876897,
    898786,
    797999,
    989878,
    878788,
    777768,
    977698,
    989788,
    988787,
    778797,
    888978,
    776886,
    788777,
    696779,
    886986,
    787978,
    876788,
    998778,
    979998,
    867677,
    897887,
    886977,
    867698,
    877687,
    887886,
    888878,
    777679,
    986786,
    999988,
    978877,
    968787,
    776889,
    889987,
    887887,
    878877,
    877778,
    897779,
    888878,
    989677,
    888889,
    888887,
    888888,
    978888,
    787879,
    787899,
    889987,
    987778,
    978888,
    888888,
    898786,
    777788,
    789797,
    887978,
    788977,
    789888,
    888999,
    786988,
    977898,
    878877,
    966887,
    889988,
    899888,
    789788,
    888777,
    797898,
    779878,
    888887,
    777787,
    779796,
    977778,
    797877,
    878888,
    897988,
    897887,
    889888,
    798868,
    888888,
    778778,
    798989,
    879889,
    997797,
    897897,
    998989,
    998689,
    889979,
    998976,
    777798,
    897988,
    999797,
    887789,
    678777,
    878887,
    798878,
    677777,
    797797,
    789877,
    898987,
    688789,
    777788,
    776996,
    868979,
    696799,
    978989,
    977787,
    777977,
    988889,
    788886,
    887887,
    988797,
    798999,
    788877,
    787886,
    777868,
    877888,
    789877,
    988668,
    797997,
    677989,
    788978,
    877889,
    889879,
    878789,
    799778,
    989988,
    899679,
    897889,
    687787,
    787778,
    899999,
    688977,
    888687,
    786976,
    779877,
    876766,
    877968,
    778898,
    877879,
    987898,
    887878,
    877688,
    899879,
    879788,
    779978,
    788987,
    778679,
    687888,
    899798,
    777788,
    877888,
    799997,
    788798,
    789888,
    898789,
    677878,
    878788,
    977888,
    978896,
    798768,
    797897,
    779697,
    979978,
    999878,
    898887,
    697898,
    789868,
    888886,
    979888,
    888886,
    887867,
    988979,
    798778,
    677787,
    898678,
    788777,
    967888,
    998878,
    778987,
    898898,
    788887,
    987878,
    787787,
    977777,
    798967,
    978877,
    789878,
    978878,
    789888,
    997777,
    887896,
    888899,
    979777,
    876886,
    879798,
    877797,
    867776,
    889888,
    897678,
    886867,
    899898,
    977888,
    778877,
    968678,
    788787,
    879879,
    889887,
    677887,
    887888,
    888998,
    698897,
    888977,
    888888,
    777877,
    787799,
    699889,
    668787,
    767898,
    978697,
    888688,
    787788,
    777898,
    988887,
    779888,
    889787,
    888797,
    978888,
    868878,
    777767,
    787788,
    888887,
    878787,
    788898,
    976798,
    889777,
    889988,
    889867,
    788879,
    888989,
    998989,
    888677,
    778898,
    898767,
    889999,
    888889,
    788778,
    798788,
    887879,
    989888,
    788899,
    768978,
    688898,
    879988,
    766787,
    967888,
    668799,
    779987,
    669887,
    887879,
    898887,
    778987,
    979886,
    878979,
    868888,
    878886,
    788688,
    988799,
    789878,
    776898,
    789899,
    988996,
    678788,
    788866,
    798899,
    779997,
    897868,
    787878,
    868988,
    879898,
    778878,
    899788,
    898897,
    789979,
    787997,
    998897,
    878796,
    886967,
    989888,
    799687,
    888989,
    867779,
    978787,
    868997,
    879867,
    897978,
    768987,
    798888,
    669778,
    787877,
    797878,
    978988,
    789878,
    789897,
    897789,
    887799,
    997886,
    777889,
    976799,
    888786,
    877688,
    878987,
    988888,
    888898,
    668999,
    799978,
    788897,
    677887,
    989777,
    777889,
    777877,
    676788,
    778888,
    897778,
    798776,
    777869,
    997987,
    688887,
    778889,
    776878,
    888876,
    878889,
    887786,
    778897,
    688898,
    776798,
    798878,
    798987,
    688878,
    898788,
    989787,
    788887,
    887888,
    789796,
    898867,
    868788,
    877878,
    987897,
    897788,
    689778,
    898978,
    889896,
    877887,
    688988,
    887797,
    967768,
    998867,
    889767,
    887878,
    898887,
    977898,
    978989,
    897877,
    777789,
    877786,
    888887,
    899898,
    998979,
    878888,
    968689,
    877888,
    897888,
    777876,
    886977,
    988687,
    777686,
    967688,
    768889,
    878688,
    779778,
    699877,
    878888,
    896878,
    989887,
    887779,
    898877,
    897778,
    788978,
    777888,
    788777,
    777867,
    987899,
    877787,
    867878,
    897987,
    976877,
    887777,
    889766,
    888788,
    878967,
    977877,
    698778,
    889876,
    889888,
    787978,
    688878,
    878797,
    889879,
    998889,
    979788,
    778778,
    787898,
    889997,
    888777,
    677698,
    878778,
    787988,
    788788,
    787968,
    698987,
    778888,
    999778,
    878768,
    878777,
    698778,
    989678,
    787898,
    887788,
    778888,
    897987,
    679899,
    767788,
    899787,
    978887,
    978888,
    887777,
    877788,
    877897,
    788888,
    798977,
    778797,
    988988,
    888898,
    778988,
    789788,
    877778,
    898888,
    877778,
    778677,
    778878,
    778889,
    778897,
    878779,
    778877,
    687788,
    877687,
    987778,
    886786,
    799879,
    777897,
    798869,
    887769,
    779999,
    789778,
    968888,
    988977,
    897777,
    887997,
    877789,
    878898,
    887778,
    887887,
    877878,
    997897,
    889979,
    788688,
    888877,
    788989,
    888889,
    789788,
    877898,
    877987,
    898787,
    779878,
    769888,
    887878,
    888878,
    788688,
    997889,
    799787,
    977877,
    688877,
    797898,
    688887,
    778788,
    888989,
    888797,
    778768,
    989788,
    978889,
    868889,
    987779,
    888888,
    787887,
    786779,
    878886,
    889998,
    888787,
    977868,
    889867,
    977979,
    897879,
    788887,
    787768,
    778989,
    786876,
    876888,
    978879,
    888688,
    887887,
    988797,
    988787,
    888887,
    878876,
    989889,
    888787,
    988898,
    778887,
    889888,
    697877,
    788887,
    879788,
    987778,
    777788,
    898879,
    789976,
    768888,
    979988,
    879887,
    777998,
    977786,
    877788,
    878797,
    877878,
    788877,
    779879,
    876888,
    877788,
    778778,
    976878,
    777888,
    799779,
    969998,
    767898,
    987877,
    879898,
    687988,
    788788,
    898797,
    878788,
    888688,
    897798,
    788789,
    878969,
    889976,
    778778,
    879789,
    978799,
    666788,
    697887,
    787888,
    867898,
    798786,
    989777,
    778879,
    999797,
    997777,
    876988,
    687687,
    789877,
    788886,
    688886,
    687898,
    868777,
    887886,
    887977,
    779878,
    987987,
    877888,
    669877,
    897797,
    888889,
    988797,
    897878,
    787989,
    769788,
    888698,
    887778,
    878878,
    787787,
    987887,
    688887,
    869888,
    896976,
    667678,
    998699,
    899878,
    878879,
    777879,
    888986,
    897889,
    887666,
    878788,
    887786,
    889988,
    887786,
    867766,
    778888,
    879899,
    797788,
    689887,
    797788,
    877799,
    777787,
    887677,
    876877,
    869888,
    779778,
    696897,
    798887,
    879897,
    977988,
    798877,
    776776,
    778896,
    877789,
    878888,
    886778,
    889888,
    878888,
    888688,
    978978,
    888877,
    787988,
    868867,
    888696,
    798888,
    988789,
    978878,
    899878,
    878797,
    977887,
    988867,
    788887,
    877987,
    877868,
    888989,
    689978,
    887989,
    887998,
    689767,
    788897,
    787768,
    869888,
    797887,
    786799,
    788889,
    788796,
    987877,
    888888,
    978888,
    888967,
    879789,
    998898,
    977787,
    878788,
    889978,
    878889,
    879867,
    787677,
    877787,
    988799,
    788788,
    687889,
    778978,
    877778,
    877779,
    878988,
    798877,
    777978,
    988869,
    677878,
    867779,
    797898,
    978777,
    697889,
    978776,
    679976,
    997777,
    988788,
    887989,
    987978,
    888888,
    898688,
    877889,
    878878,
    779698,
    887889,
    767888,
    888678,
    788878,
    898898,
    798989,
    767888,
    898878,
    989787,
    899798,
    788779,
    879768,
    889878,
    888979,
    977786,
    887968,
    897878,
    878878,
    787788,
    977866,
    987897,
    788877,
    796988,
    788888,
    779889,
    778979,
    777789,
    798779,
    767887,
    998898,
    797677,
    889997,
    788787,
    698879,
    787888,
    798967,
    868778,
    788687,
    878877,
    776978,
    898979,
    878867,
    798877,
    688686,
    987887,
    878789,
    768779,
    787889,
    878878,
    788898,
    897788,
    676887,
    789888,
    787897,
    998798,
    888979,
    777877,
    777668,
    678787,
    778779,
    867778,
    789898,
    677987,
    887888,
    797778,
    976768,
    686999,
    986787,
    878977,
    879877,
    898876,
    779789,
    898988,
    787968,
    778899,
    978888,
    788798,
    768886,
    778887,
    898688,
    887889,
    769887,
    878988,
    887768,
    798878,
    967878,
    877899,
    787778,
    899898,
    778789,
    867999,
    886877,
    897888,
    888877,
    889897,
    879897,
    797689,
    887886,
    989687,
    898788,
    768898,
    888878,
    988887,
    897878,
    778778,
    687776,
    877787,
    787887,
    888868,
    799979,
    888788,
    878979,
    897876,
    977989,
    987797,
    899878,
    696987,
    986987,
    787879,
    878967,
    879987,
    988888,
    879688,
    888986,
    977689,
    878787,
    888889,
    997977,
    867877,
    879968,
    887867,
    789778,
    878786,
    879787,
    788778,
    677887,
    788788,
    776887,
    877789,
    898897,
    687689,
    779788,
    988779,
    888678,
    788879,
    879877,
    678889,
    877777,
    877979,
    799887,
    779888,
    689798,
    879877,
    888877,
    788898,
    989888,
    886776,
    888889,
    788977,
    887888,
    797778,
    888879,
    987997,
    777897,
    969679,
    977788,
    878878,
    878779,
    686897,
    988986,
    678977,
    987896,
    877877,
    787888,
    886787,
    888877,
    789888,
    887899,
    687877,
    888788,
    977886,
    788878,
    778978,
    978979,
    887778,
    688999,
    889778,
    877786,
    797988,
    788896,
    777896,
    878998,
    778887,
    878978,
    779698,
    789899,
    879887,
    877799,
    988789,
    886879,
    897887,
    768787,
    787887,
    989898,
    769888,
    778978,
    967978,
    888977,
    877878,
    889989,
    979788,
    888888,
    968779,
    778788,
    988989,
    797998,
    878787,
    787787,
    878989,
    778879,
    977877,
    778688,
    778978,
    986788,
    679788,
    878888,
    878979,
    997988,
    879887,
    989878,
    976899,
    889789,
    877676,
    979779,
    888688,
    977768,
    878979,
    788699,
    998767,
    688988,
    988977,
    978798,
    677788,
    996788,
    797777,
    788789,
    798888,
    778868,
    769977,
    867767,
    787796,
    889877,
    689888,
    788898,
    877878,
    699989,
    988786,
    968868,
    688898,
    998798,
    998788,
    878888,
    997978,
    789779,
    977999,
    867879,
    689888,
    798887,
    777768,
    986778,
    788778,
    888887,
    897978,
    777878,
    899989,
    667878,
    779897,
    886778,
    879976,
    887977,
    877798,
    877889,
    689697,
    789787,
    869777,
    896777,
    788689,
    779788,
    989777,
    978879,
    977679,
    776988,
    999868,
    878799,
    988988,
    678889,
    798778,
    889898,
    988899,
    889888,
    878898,
    969879,
    789889,
    877988,
    887687,
    778798,
    878787,
    987986,
    798888,
    896979,
    887867,
    987988,
    787878,
    987887,
    879879,
    997797,
    987677,
    878778,
    768777,
    778788,
    777888,
    787789,
    898788,
    797798,
    979889,
    778798,
    997669,
    967778,
    767688,
    997986,
    987888,
    998778,
    788998,
    999877,
    978878,
    978889,
    979888,
    997898,
    787888,
    888688,
    878878,
    779777,
    987798,
    987788,
    788977,
    789887,
    797778,
    889878,
    977887,
    888888,
    778987,
    978777,
    779789,
    786879,
    777899,
    688878,
    878878,
    977798,
    878898,
    788977,
    877888,
    887887,
    778878,
    788877,
    897877,
    788998,
    698778,
    799897,
    878888,
    779888,
    697686,
    767778,
    978798,
    798899,
    887877,
    678896,
    888797,
    877897,
    887888,
    789778,
    888879,
    887879,
    987877,
    877689,
    787887,
    878969,
    799797,
    788978,
    878688,
    999797,
    879968,
    878778,
    878778,
    987689,
    778798,
    898896,
    778788,
    697877,
    889977,
    779876,
    878676,
    887778,
    779878,
    788897,
    778888,
    888999,
    888877,
    978879,
    988788,
    876698,
    897797,
    776877,
    768777,
    887787,
    769878,
    877888,
    887788,
    787877,
    778879,
    887868,
    787677,
    788787,
    887887,
    867988,
    786899,
    977788,
    886888,
    877887,
    796767,
    977777,
    878898,
    898767,
    788998,
    678887,
    987778,
    778698,
    877888,
    977879,
    889877,
    889888,
    877798,
    789878,
    888886,
    878898,
    887688,
    879796,
    878788,
    798897,
    877767,
    797898,
    978799,
    878877,
    887777,
    987978,
    789888,
    787877,
    986788,
    888887,
    888788,
    788998,
    878888,
    987888,
    879789,
    789878,
    678797,
    876779,
    778766,
    898667,
    897979,
    798878,
    797887,
    898977,
    768878,
    877987,
    897788,
    887888,
    879898,
    797886,
    767878,
    796877,
    889786,
    878779,
    889876,
    978899,
    788786,
    778977,
    688976,
    889898,
    778879,
    787779,
    888877,
    997798,
    689877,
    677879,
    798978,
    898889,
    878887,
    888777,
    888867,
    788677,
    877689,
    798677,
    777779,
    887879,
    887778,
    667796,
    888889,
    887978,
    979777,
    987897,
    988788,
    879997,
    878867,
    868867,
    797888,
    887978,
    687788,
    896679,
    878997,
    889768,
    796768,
    677797,
    887896,
    899886,
    988877,
    889877,
    788878,
    988898,
    787997,
    768997,
    887788,
    787777,
    688788,
    789987,
    778888,
    987877,
    978987,
    887887,
    778797,
    798878,
    998977,
    987979,
    777887,
    688868,
    689798,
    798879,
    897867,
    887888,
    897698,
    799886,
    988878,
    888678,
    788899,
    979689,
    888899,
    789667,
    997898,
    877898,
    878978,
    677787,
    878868,
    698868,
    988768,
    897888,
    978987,
    789888,
    879987,
    888997,
    788988,
    998787,
    877786,
    779889,
    887798,
    878989,
    879789,
    878877,
    787889,
    877788,
    787788,
    887867,
    797798,
    896887,
    878786,
    998978,
    698988,
    877887,
    789987,
    787867,
    887786,
    876887,
    988799,
    877888,
    987878,
    987879,
    898878,
    876877,
    896887,
    688889,
    987878,
    986899,
    779868,
    888886,
    799886,
    799887,
    878778,
    888987,
    979969,
    798897,
    978787,
    778798,
    777988,
    878688,
    768797,
    877788,
    977888,
    877897,
    799788,
    888998,
    778779,
    887798,
    777789,
    778787,
    978667,
    899798,
    798988,
    988879,
    888679,
    888778,
    686988,
    779888,
    887778,
    988987,
    879879,
    878888,
    998798,
    888688,
    897877,
    777698,
    797798,
    867777,
    687788,
    888778,
    868886,
    777987,
    878877,
    878977,
    788798,
    987777,
    877886,
    778776,
    978877,
    887797,
    687978,
    778876,
    888987,
    787868,
    879888,
    888988,
    868887,
    776778,
    888779,
    989988,
    988776,
    788788,
    887886,
    898787,
    886798,
    787987,
    878897,
    778978,
    887688,
    677787,
    887877,
    797798,
    878877,
    798879,
    988887,
    888988,
    789878,
    777889,
    677877,
    877997,
    799887,
    797889,
    997987,
    788777,
    798889,
    878779,
    878888,
    789997,
    796977,
    878778,
    879999,
    887878,
    887896,
    789888,
    886878,
    978897,
    798799,
    788879,
    886978,
    987986,
    888888,
    876787,
    988879,
    988868,
    789978,
    879897,
    788898,
    877677,
    967898,
    878889,
    998878,
    777978,
    877698,
    788877,
    677878,
    868769,
    778687,
    997777,
    898788,
    888797,
    889998,
    777879,
    978989,
    788797,
    677879,
    789979,
    897897,
    787888,
    877778,
    787788,
    967967,
    678897,
    898798,
    886799,
    987987,
    876878,
    768788,
    898787,
    797997,
    787978,
    897689,
    779778,
    878887,
    787977,
    797688,
    778798,
    999876,
    989896,
    978787,
    886877,
    788798,
    987777,
    878878,
    986988,
    987889,
    869868,
    887987,
    878979,
    797679,
    879786,
    887797,
    889788,
    888869,
    777776,
    989776,
    888886,
    979877,
    776898,
    988879,
    778798,
    887878,
    967978,
    786888,
    667788,
    799987,
    887878,
    776786,
    798889,
    878868,
    788877,
    868877,
    878778,
    886978,
    798688,
    778788,
    986898,
    888779,
    888988,
    988789,
    798798,
    979779,
    889887,
    988788,
    786878,
    878877,
    887987,
    777888,
    687986,
    987888,
    768888,
    988786,
    878888,
    887799,
    799878,
    888789,
    978878,
    979777,
    968888,
    789789,
    687787,
    877796,
    887889,
    869788,
    888887,
    798897,
    799787,
    789887,
    978898,
    977889,
    888899,
    988888,
    788788,
    779786,
    968769,
    878899,
    778897,
    888887,
    787899,
    787897,
    877898,
    888778,
    887987,
    678798,
    867787,
    967877,
    778779,
    988778,
    797788,
    798897,
    898888,
    877877,
    776776,
    788777,
    977888,
    788888,
    888988,
    898777,
    897898,
    868867,
    998878,
    778876,
    876797,
    788876,
    986887,
    788888,
    787877,
    886886,
    689888,
    778898,
    797788,
    998987,
    877877,
    878888,
    888797,
    687797,
    888798,
    667789,
    899879,
    796879,
    879677,
    877867,
    798987,
    877688,
    777799,
    797788,
    778897,
    777787,
    798878,
    777898,
    789776,
    869889,
    879888,
    877788,
    777898,
    779789,
    967787,
    788779,
    889899,
    889797,
    877688,
    887879,
    789878,
    988877,
    999896,
    876998,
    997877,
    797887,
    778798,
    887897,
    799897,
    879888,
    888878,
    887999,
    888989,
    789978,
    787879,
    878898,
    777887,
    689989,
    879887,
    977878,
    777778,
    789878,
    877997,
    788789,
    988898,
    797999,
    797889,
    797788,
    666976,
    787888,
    787776,
    897887,
    777888,
    898779,
    766798,
    779688,
    788887,
    977798,
    878979,
    888898,
    779989,
    787888,
    879888,
    878868,
    888777,
    869887,
    778877,
    787689,
    878796,
    878988,
    887787,
    978978,
    669877,
    987788,
    678788,
    988787,
    878989,
    799777,
    799898,
    979887,
    879888,
    879878,
    678868,
    888798,
    798977,
    977967,
    888998,
    977789,
    976878,
    768788,
    888778,
    778688,
    896888,
    999788,
    896776,
    987777,
    988897,
    877788,
    868997,
    978879,
    899898,
    978988,
    777679,
    788788,
    788888,
    788977,
    987797,
    887869,
    786778,
    798887,
    878788,
    887877,
    887886,
    888798,
    786868,
    977788,
    788878,
    888977,
    979989,
    798998,
    886887,
    778797,
    779777,
    787988,
    887898,
    967778,
    878798,
    897778,
    797996,
    769878,
    898786,
    898898,
    788987,
    889899,
    777777,
    898887,
    788777,
    878798,
    788987,
    888778,
    988979,
    877888,
    988888,
    679796,
    978887,
    787777,
    889788,
    788778,
    999888,
    789888,
    878787,
    879786,
    879886,
    777678,
    678888,
    878679,
    888787,
    779889,
    788798,
    898987,
    769798,
    988977,
    787898,
    789887,
    776777,
    897979,
    788989,
    887788,
    689779,
    877789,
    768698,
    687989,
    788878,
    778787,
    897988,
    888976,
    898997,
    799788,
    889988,
    777978,
    978799,
    786868,
    788786,
    778987,
    897798,
    778787,
    997978,
    877798,
    778788,
    888867,
    998687,
    788797,
    788787,
    898778,
    768788,
    877967,
    778977,
    888888,
    787879,
    888998,
    897779,
    768877,
    677878,
    788787,
    986888,
    787878,
    798888,
    878779,
    798798,
    778876,
    777998,
    867879,
    699998,
    887888,
    888776,
    876898,
    768676,
    878997,
    788899,
    788778,
    878888,
    889888,
    887978,
    996897,
    788867,
    877798,
    878688,
    876788,
    688987,
    888988,
    788787,
    977889,
    998688,
    789897,
    986877,
    889879,
    789778,
    978888,
    988887,
    767879,
    899788,
    878788,
    878787,
    878887,
    889889,
    798997,
    989887,
    887786,
    778888,
    898887,
    788779,
    787789,
    999777,
    969889,
    878887,
    779787,
    878799,
    899688,
    989888,
    788798,
    778778,
    788788,
    689887,
    798778,
    887978,
    987798,
    899968,
    789888,
    788778,
    888888,
    787768,
    887689,
    898889,
    987779,
    999878,
    788768,
    878877,
    876789,
    996779,
    787878,
    877789,
    989988,
    987697,
    998698,
    868978,
    977886,
    887889,
    978877,
    888888,
    969779,
    897977,
    788778,
    978978,
    777887,
    877798,
    897897,
    887798,
    877888,
    899797,
    889888,
    887789,
    699769,
    787988,
    797967,
    789787,
    979777,
    788798,
    887898,
    777788,
    896978,
    688889,
    877997,
    899877,
    778799,
    796888,
    788897,
    998878,
    779899,
    888998,
    967786,
    889787,
    878989,
    878887,
    778797,
    789877,
    877879,
    887689,
    896789,
    877778,
    889988,
    787888,
    877777,
    889899,
    879887,
    987996,
    776898,
    787978,
    999788,
    878877,
    888787,
    879788,
    887768,
    989788,
    879987,
    789878,
    868876,
    797777,
    788777,
    898878,
    687897,
    889789,
    677997,
    789897,
    779888,
    877968,
    898898,
    976788,
    889877,
    788786,
    877887,
    798779,
    777887,
    779798,
    897777,
    797788,
    887877,
    878878,
    878886,
    789978,
    898777,
    687889,
    889789,
    788988,
    899896,
    876998,
    897979,
    878988,
    788889,
    888887,
    878979,
    998798,
    788689,
    799776,
    868676,
    878877,
    898897,
    878999,
    888978,
    799789,
    778899,
    798787,
    688888,
    878778,
    697888,
    997697,
    799867,
    878888,
    967878,
    776678,
    889776,
    889878,
    988988,
    998979,
    886879,
    798798,
    868787,
    678997,
    887686,
    778868,
    997887,
    968777,
    887766,
    888768,
    877798,
    777888,
    778899,
    867888,
    886978,
    778787,
    977779,
    877987,
    688679,
    987986,
    789888,
    767977,
    898969,
    888998,
    968778,
    988798,
    888787,
    989777,
    798796,
    768786,
    977788,
    789887,
    689877,
    889888,
    879897,
    878788,
    988777,
    778888,
    987798,
    679778,
    788868,
    888889,
    977789,
    889979,
    776986,
    989888,
    797988,
    998978,
    976979,
    878967,
    979989,
    777797,
    688879,
    989887,
    889898,
    987878,
    788889,
    979699,
    877678,
    787998,
    777876,
    787787,
    876888,
    887899,
    799898,
    778788,
    888778,
    878887,
    897887,
    886887,
    877897,
    878797,
    798797,
    897686,
    779778,
    987788,
    776787,
    989978,
    978888,
    778896,
    788878,
    798698,
    976878,
    787889,
    898888,
    968898,
    878977,
    797776,
    878868,
    988687,
    988688,
    987888,
    778788,
    889977,
    868977,
    898987,
    778778,
    889878,
    788777,
    788968,
    797789,
    797887,
    888977,
    798786,
    777898,
    878987,
    788787,
    878779,
    779989,
    777778,
    778787,
    889898,
    986887,
    767799,
    878688,
    798789,
    688896,
    897888,
    767777,
    888888,
    997888,
    799887,
    878778,
    887977,
    897879,
    887898,
    786877,
    867769,
    989877,
    778777,
    889788,
    978899,
    898797,
    678888,
    787768,
    888979,
    888797,
    898787,
    899968,
    878766,
    796899,
    789869,
    787888,
    898796,
    889868,
    766789,
    879798,
    878697,
    677788,
    778888,
    778888,
    977878,
    888989,
    778778,
    777888,
    888887,
    888778,
    889878,
    888788,
    778886,
    898789,
    786878,
    779788,
    888687,
    977879,
    687788,
    879878,
    988788,
    676876,
    898988,
    988797,
    887998,
    777988,
    787997,
    767789,
    767796,
    798778,
    899787,
    968877,
    889888,
    868869,
    978797,
    878787,
    877897,
    887878,
    889987,
    687687,
    798887,
    677898,
    778788,
    778877,
    978878,
    687998,
    888696,
    878767,
    898888,
    778978,
    777777,
    979988,
    688777,
    787777,
    876778,
    777787,
    897898,
    987889,
    768677,
    879887,
    868888,
    888788,
    688988,
    887876,
    888989,
    879889,
    789788,
    976786,
    998899,
    779867,
    888997,
    887798,
    888979,
    878888,
    887688,
    768779,
    889998,
    767878,
    787887,
    997899,
    788886,
    886888,
    877787,
    787699,
    788889,
    878887,
    678778,
    988798,
    986897,
    887887,
    797878,
    899886,
    689978,
    978978,
    888697,
    997779,
    877778,
    878798,
    887888,
    767798,
    776778,
    888889,
    798886,
    868878,
    898788,
    898688,
    869777,
    678879,
    788779,
    987767,
    997898,
    989897,
    879786,
    789899,
    886977,
    697688,
    898787,
    698887,
    886699,
    788896,
    887878,
    867999,
    988886,
    677797,
    878787,
    979887,
    788978,
    877889,
    898878,
    786788,
    788988,
    788888,
    877899,
    788877,
    776788,
    677979,
    887799,
    877797,
    888889,
    888878,
    789877,
    887876,
    897776,
    788879,
    787877,
    787997,
    898789,
    876789,
    997699,
    869878,
    698777,
    878777,
    788977,
    799888,
    877768,
    778888,
    977879,
    787888,
    779877,
    886776,
    988887,
    877788,
    797997,
    888898,
    787798,
    889788,
    898889,
    777988,
    879788,
    787988,
    797787,
    888898,
    877976,
    888878,
    779897,
    979688,
    988788,
    888879,
    887789,
    878797,
    968997,
    788889,
    788888,
    877797,
    888677,
    877789,
    786887,
    688788,
    997888,
    998787,
    888887,
    678998,
    686889,
    987797,
    788877,
    878777,
    887877,
    797777,
    777987,
    987879,
    777798,
    789888,
    887879,
    877877,
    799777,
    789886,
    889787,
    789869,
    888798,
    767877,
    799767,
    689896,
    888888,
    789998,
    988797,
    778979,
    978888,
    987887,
    878888,
    777788,
    889797,
    688677,
    787887,
    888688,
    688979,
    788887,
    678778,
    898869,
    777897,
    897888,
    987797,
    986797,
    778788,
    778887,
    889888,
    789878,
    887879,
    979899,
    788788,
    797877,
    998778,
    877889,
    796988,
    887787,
    997778,
    687888,
    867788,
    979778,
    778879,
    897976,
    788778,
    769987,
    997778,
    879897,
    987868,
    897778,
    887878,
    687997,
    797777,
    788898,
    778996,
    889777,
    879689,
    897789,
    889887,
    798978,
    788888,
    986798,
    789888,
    798798,
    878768,
    888767,
    878886,
    698868,
    786787,
    897898,
    989976,
    889778,
    798879,
    887887,
    788877,
    797887,
    878989,
    788877,
    788867,
    788889,
    779788,
    777987,
    898997,
    796787,
    788678,
    897868,
    898868,
    967889,
    878898,
    697767,
    788878,
    797999,
    877887,
    788878,
    878887,
    777797,
    878887,
    987797,
    799788,
    879887,
    799787,
    898688,
    788889,
    877989,
    897867,
    977877,
    789878,
    887788,
    978978,
    798788,
    778876,
    788767,
    888876,
    789997,
    777879,
    777778,
    998979,
    878878,
    888869,
    978787,
    789889,
    978878,
    786688,
    887699,
    899797,
    898787,
    898778,
    988789,
    779888,
    798789,
    886897,
    868778,
    788876,
    888768,
    786878,
    787878,
    789988,
    968788,
    889979,
    888998,
    997798,
    987788,
    899677,
    777766,
    889788,
    888998,
    788787,
    798888,
    887989,
    876697,
    989888,
    787789,
    887889,
    887899,
    787997,
    787898,
    987878,
    788996,
    899987,
    898989,
    768978,
    788879,
    878979,
    788877,
    887777,
    897977,
    888688,
    886778,
    889778,
    878988,
    979798,
    888889,
    877888,
    889987,
    679788,
    888879,
    988788,
    897897,
    889777,
    887977,
    789886,
    787886,
    788988,
    978788,
    879878,
    988897,
    879867,
    877986,
    998687,
    786878,
    979868,
    899789,
    878887,
    898878,
    699888,
    799688,
    888798,
    798788,
    778678,
    789888,
    887786,
    977778,
    987877,
    868768,
    887688,
    978869,
    987688,
    777877,
    686789,
    788799,
    778888,
    989896,
    887687,
    879967,
    897779,
    879788,
    777779,
    789897,
    897977,
    889876,
    888877,
    877878,
    797778,
    897898,
    899978,
    989779,
    778977,
    867789,
    767977,
    878799,
    888988,
    898987,
    897787,
    988888,
    977788,
    998778,
    788788,
    878787,
    778868,
    878677,
    779788,
    987678,
    678888,
    978878,
    899897,
    798877,
    898798,
    869878,
    789898,
    897898,
    788877,
    989879,
    798888,
    698868,
    897799,
    898987,
    798879,
    887796,
    777698,
    787988,
    897787,
    778878,
    886677,
    878887,
    778779,
    799777,
    787788,
    788788,
    897797,
    887886,
    866977,
    798879,
    978868,
    789999,
    889799,
    899677,
    987777,
    687869,
    977668,
    798779,
    696889,
    788977,
    787866,
    897777,
    877898,
    979876,
    878988,
    877787,
    866888,
    769888,
    977788,
    878789,
    969879,
    889878,
    989789,
    878877,
    879679,
    777687,
    978898,
    987898,
    788987,
    778789,
    788999,
    898978,
    697777,
    789779,
    888789,
    886899,
    877888,
    887778,
    798777,
    798789,
    788989,
    788868,
    978878,
    978767,
    788799,
    887877,
    899796,
    797788,
    977688,
    877967,
    786888,
    779898,
    787799,
    788877,
    777787,
    889878,
    876889,
    897878,
    998877,
    688877,
    998888,
    788898,
    877687,
    777778,
    788878,
    788978,
    888897,
    889778,
    888877,
    898798,
    779879,
    789878,
    687968,
    887969,
    987999,
    877798,
    777888,
    888787,
    888869,
    898967,
    977887,
    789888,
    897788,
    898778,
    898888,
    778879,
    979797,
    977887,
    777888,
    888868,
    779987,
    797999,
    889867,
    787787,
    889878,
    898987,
    888877,
    696678,
    689698,
    868778,
    977879,
    788877,
    777887,
    979898,
    787688,
    778778,
    899978,
    886999,
    788988,
    777987,
    878976,
    779898,
    788888,
    878887,
    987778,
    887887,
    999899,
    889898,
    889868,
    787799,
    899787,
    799788,
    878767,
    877778,
    889677,
    889798,
    898888,
    789887,
    788788,
    878888,
    887868,
    787887,
    988779,
    888896,
    978988,
    889788,
    878677,
    788688,
    788776,
    877988,
    688788,
    786898,
    886798,
    878677,
    797979,
    798778,
    988798,
    989888,
    788768,
    797878,
    879689,
    879797,
    688887,
    769877,
    986778,
    888789,
    787897,
    798887,
    899868,
    899777,
    798878,
    687989,
    788779,
    879899,
    788888,
    878887,
    998797,
    888777,
    889886,
    988887,
    698888,
    769978,
    788787,
    997789,
    897888,
    899778,
    878998,
    678888,
    887778,
    788798,
    899989,
    778787,
    789877,
    768789,
    787878,
    887787,
    988889,
    767888,
    777777,
    787987,
    877888,
    998878,
    777878,
    877876,
    797778,
    898999,
    788778,
    876769,
    896799,
    887887,
    978888,
    866877,
    887979,
    888788,
    996769,
    788987,
    788787,
    989777,
    878788,
    788979,
    796887,
    778688,
    987888,
    888878,
    887788,
    888778,
    896988,
    988787,
    787988,
    779888,
    878778,
    878688,
    777898,
    687897,
    878897,
    787997,
    777987,
    898977,
    999889,
    666789,
    979887,
    867878,
    787968,
    888878,
    878989,
    897788,
    989888,
    999878,
    787877,
    878889,
    898777,
    867778,
    887886,
    776788,
    887887,
    789778,
    888898,
    887797,
    799788,
    877979,
    898877,
    977878,
    786999,
    878797,
    787788,
    878999,
    877878,
    996787,
    798887,
    788986,
    889768,
    979998,
    787888,
    878778,
    997868,
    899687,
    978776,
    797887,
    867877,
    788789,
    887898,
    887776,
    888998,
    988887,
    986877,
    789889,
    988878,
    977977,
    978878,
    997778,
    768877,
    698987,
    878977,
    797996,
    887988,
    787888,
    889777,
    889889,
    877877,
    877977,
    788789,
    877887,
    688878,
    787898,
    898789,
    778997,
    878967,
    987776,
    799688,
    996677,
    898898,
    887898,
    799788,
    877977,
    869986,
    897788,
    778678,
    798798,
    999897,
    989878,
    979688,
    789878,
    889778,
    697878,
    898988,
    898877,
    789677,
    988798,
    997789,
    879778,
    888797,
    879787,
    687897,
    677797,
    787998,
    787789,
    787889,
    788977,
    998797,
    987787,
    778988,
    879898,
    988888,
    779877,
    788796,
    876677,
    878777,
    986798,
    969889,
    899679,
    877979,
    877898,
    889879,
    878888,
    877777,
    896799,
    878986,
    787978,
    877787,
    868798,
    898878,
    778898,
    679798,
    878869,
    798887,
    688878,
    797879,
    888868,
    867998,
    777878,
    777869,
    897897,
    876888,
    878887,
    878889,
    998686,
    977878,
    797897,
    886677,
    776889,
    878877,
    987798,
    979778,
    987877,
    898667,
    878798,
    766989,
    897997,
    887687,
    899978,
    898797,
    877877,
    989989,
    777899,
    889897,
    777798,
    898978,
    789978,
    887888,
    877997,
    768977,
    989979,
    998879,
    897878,
    877876,
    797979,
    788778,
    897978,
    777978,
    789899,
    878899,
    798797,
    889787,
    987988,
    888888,
    777788,
    877876,
    779867,
    878978,
    877997,
    869779,
    787788,
    888997,
    897788,
    898887,
    899887,
    879898,
    699877,
    786898,
    699879,
    787988,
    788787,
    897998,
    688789,
    979786,
    787878,
    889778,
    787868,
    887788,
    889887,
    876777,
    877887,
    779778,
    998998,
    689986,
    898788,
    877768,
    978988,
    789889,
    787887,
    889789,
    887977,
    969687,
    888988,
    899967,
    978887,
    777989,
    889787,
    898977,
    778989,
    778987,
    688988,
    898978,
    768888,
    998868,
    987779,
    879977,
    877897,
    878877,
    787788,
    778999,
    787768,
    678996,
    887777,
    899898,
    677877,
    877986,
    878889,
    989897,
    788788,
    788799,
    868677,
    888967,
    887879,
    677786,
    787987,
    998977,
    877778,
    968878,
    867778,
    688887,
    889878,
    678988,
    987987,
    768996,
    987978,
    887779,
    788776,
    788987,
    978788,
    889888,
    888867,
    787877,
    698877,
    877878,
    887787,
    789877,
    967787,
    888886,
    787887,
    888787,
    988989,
    886786,
    888669,
    979967,
    788997,
    889787,
    777778,
    786888,
    778878,
    777779,
    779769,
    999897,
    788788,
    797777,
    887678,
    888787,
    787877,
    788798,
    898888,
    798778,
    999887,
    886778,
    778977,
    777767,
    899867,
    898878,
    778868,
    987798,
    887889,
    787898,
    899877,
    888878,
    999799,
    888888,
    878897,
    788887,
    988898,
    979776,
    999998,
    868988,
    788788,
    788776,
    888798,
    998989,
    878888,
    897797,
    879788,
    978987,
    997697,
    976878,
    978789,
    977786,
    889879,
    788678,
    898887,
    869797,
    988776,
    778988,
    877888,
    888877,
    988988,
    777886,
    877978,
    887868,
    888798,
    778867,
    888787,
    979788,
    987877,
    768688,
    788787,
    788889,
    988999,
    789997,
    888968,
    898787,
    888877,
    879888,
    877889,
    789879,
    788869,
    888878,
    798867,
    888787,
    868787,
    788897,
    888898,
    878797,
    899888,
    887788,
    987778,
    778778,
    899678,
    878998,
    978879,
    887998,
    786887,
    987886,
    867888,
    978889,
    989898,
    877978,
    769678,
    889877,
    776877,
    688698,
    787768,
    988867,
    998887,
    888799,
    988778,
    998988,
    997798,
    887787,
    988799,
    767988,
    879787,
    888978,
    898799,
    698888,
    887789,
    898988,
    786999,
    687788,
    987987,
    799798,
    878779,
    877887,
    777886,
    667889,
    877778,
    779898,
    978986,
    777888,
    888888,
    896788,
    888899,
    878689,
    888777,
    777888,
    788878,
    779988,
    877788,
    866978,
    789777,
    977798,
    898767,
    799898,
    989698,
    976886,
    778778,
    898888,
    876989,
    788688,
    878888,
    777887,
    687688,
    798998,
    778999,
    887667,
    889798,
    978788,
    879889,
    898988,
    977889,
    778887,
    777987,
    899868,
    889889,
    997788,
    878877,
    988989,
    898977,
    688777,
    976887,
    798988,
    878789,
    788986,
    787897,
    877898,
    887998,
    688888,
    899778,
    867877,
    888789,
    777898,
    988788,
    797877,
    976779,
    869868,
    688787,
    768976,
    877878,
    778788,
    898698,
    678977,
    796778,
    987878,
    888797,
    989998,
    869878,
    878767,
    977798,
    867888,
    897778,
    888777,
    877789,
    778978,
    778877,
    888777,
    788988,
    988888,
    998888,
    766997,
    867988,
    788987,
    777998,
    788987,
    988876,
    888876,
    798987,
    988989,
    768886,
    768888,
    988887,
    898978,
    977899,
    788987,
    788878,
    986787,
    978877,
    899777,
    787669,
    899999,
    997997,
    668897,
    987987,
    898798,
    778967,
    899898,
    878886,
    779878,
    878997,
    999878,
    788798,
    888868,
    786888,
    897887,
    688978,
    797888,
    899788,
    888879,
    987989,
    789978,
    878887,
    798779,
    878777,
    797987,
    878889,
    697878,
    688788,
    969987,
    887878,
    889789,
    787897,
    967778,
    887897,
    889988,
    889886,
    798878,
    988978,
    877897,
    888968,
    778988,
    788878,
    686878,
    889777,
    788778,
    876878,
    887886,
    977979,
    898778,
    786679,
    999798,
    777898,
    988877,
    778896,
    898978,
    787878,
    887878,
    779888,
    879889,
    777879,
    886789,
    897698,
    796877,
    878798,
    988787,
    777899,
    888788,
    869768,
    976986,
    676779,
    876788,
    789987,
    789888,
    879779,
    978898,
    888876,
    879798,
    777799,
    779778,
    977887,
    896898,
    888898,
    888879,
    877797,
    779788,
    787887,
    787868,
    987888,
    988778,
    878687,
    788879,
    989897,
    877797,
    977778,
    887889,
    989769,
    769867,
    788788,
    998887,
    887777,
    897887,
    789778,
    799797,
    777878,
    989788,
    899787,
    978888,
    977899,
    898787,
    867777,
    878887,
    888888,
    787776,
    677778,
    967798,
    887899,
    997787,
    887888,
    778988,
    797877,
    868778,
    887996,
    989797,
    978788,
    779888,
    778788,
    997779,
    897777,
    889886,
    788777,
    677778,
    769888,
    689878,
    887787,
    988778,
    877878,
    898888,
    778678,
    987877,
    877867,
    878788,
    887767,
    789877,
    788677,
    889899,
    999888,
    989668,
    788988,
    879888,
    788888,
    779778,
    889797,
    899889,
    887887,
    989787,
    888778,
    977887,
    888979,
    987897,
    879789,
    778898,
    878779,
    889878,
    779879,
    778786,
    878787,
    887987,
    988888,
    979978,
    898766,
    878889,
    978899,
    878897,
    799898,
    786779,
    887988,
    888877,
    898978,
    797877,
    787878,
    788797,
    889887,
    888768,
    767877,
    988886,
    779877,
    897798,
    887877,
    999879,
    789887,
    888979,
    988888,
    877778,
    888978,
    978797,
    978887,
    979877,
    888898,
    789887,
    888778,
    897996,
    888698,
    999889,
    778898,
    888778,
    888889,
    877879,
    897889,
    789989,
    996798,
    888688,
    769779,
    898798,
    868797,
    776897,
    779787,
    888878,
    887888,
    787867,
    889988,
    888888,
    887678,
    899799,
    679769,
    888887,
    876877,
    886877,
    898798,
    977969,
    777897,
    878979,
    979687,
    888787,
    879698,
    888889,
    998979,
    986987,
    977779,
    689988,
    877698,
    668768,
    997996,
    779999,
    788987,
    778978,
    897978,
    887886,
    869978,
    789987,
    876678,
    899796,
    788888,
    878888,
    788867,
    888877,
    779788,
    879778,
    887889,
    787888,
    986988,
    787879,
    987778,
    799789,
    767877,
    788978,
    878887,
    898887,
    897787,
    777777,
    877788,
    789897,
    788788,
    787777,
    888898,
    886988,
    987687,
    879888,
    977989,
    698896,
    787797,
    769899,
    887798,
    898778,
    799787,
    989788,
    786889,
    887877,
    778868,
    699887,
    899879,
    986889,
    788789,
    888997,
    989886,
    988987,
    878887,
    977797,
    777787,
    887888,
    897988,
    777679,
    968877,
    796888,
    788768,
    898897,
    878789,
    888699,
    897789,
    886888,
    998799,
    997889,
    898888,
    887987,
    888788,
    877888,
    888778,
    778877,
    988788,
    897878,
    968887,
    777778,
    799978,
    878889,
    878797,
    786899,
    888799,
    877786,
    787898,
    779788,
    988887,
    898988,
    776878,
    988868,
    787989,
    877887,
    769779,
    986877,
    889768,
    989788,
    778878,
    887888,
    989778,
    997868,
    878888,
    787796,
    778887,
    979787,
    889887,
    777888,
    879788,
    789777,
    887788,
    797877,
    998878,
    887978,
    779977,
    888897,
    879779,
    798798,
    888898,
    788778,
    977879,
    788888,
    887877,
    788797,
    787878,
    889789,
    878888,
    877676,
    687787,
    789997,
    888778,
    878789,
    798968,
    988878,
    778669,
    978878,
    877896,
    877887,
    789879,
    899987,
    798988,
    797878,
    778698,
    888879,
    788777,
    877788,
    978999,
    789888,
    786997,
    988678,
    798778,
    787766,
    877989,
    777977,
    988778,
    799788,
    778798,
    797778,
    777889,
    878897,
    898977,
    987888,
    887787,
    868697,
    888798,
    879887,
    898787,
    788778,
    877788,
    987877,
    878678,
    897788,
    987988,
    899889,
    889689,
    987979,
    879887,
    779788,
    787987,
    886978,
    777789,
    778978,
    789898,
    878778,
    877787,
    888978,
    999987,
    888888,
    887886,
    778889,
    878989,
    897788,
    888898,
    778877,
    778879,
    979777,
    898877,
    887999,
    998887,
    888777,
    877878,
    886789,
    878878,
    889989,
    878777,
    987878,
    797789,
    776778,
    967797,
    876987,
    979989,
    767897,
    987878,
    998899,
    898888,
    987897,
    778987,
    987798,
    869899,
    898888,
    779878,
    877987,
    768888,
    778778,
    886698,
    788777,
    776898,
    867788,
    888798,
    987786,
    887879,
    778867,
    898789,
    996988,
    688879,
    877777,
    789897,
    777788,
    987986,
    778898,
    777988,
    996687,
    898896,
    978778,
    897987,
    987689,
    798778,
    978987,
    887898,
    787978,
    788978,
    987888,
    877888,
    888787,
    777878,
    988898,
    987887,
    978778,
    886797,
    988898,
    668877,
    778888,
    888979,
    767888,
    777788,
    988787,
    898788,
    796798,
    768779,
    787687,
    898899,
    878787,
    869777,
    888787,
    788877,
    887867,
    888879,
    786889,
    997887,
    798688,
    987878,
    986888,
    887788,
    888787,
    897778,
    887998,
    779878,
    777979,
    799899,
    786787,
    788897,
    989888,
    979896,
    888777,
    789988,
    888687,
    786788,
    877799,
    787889,
    689678,
    787876,
    786979,
    887788,
    778968,
    788877,
    788889,
    866998,
    989888,
    788797,
    877879,
    998888,
    779877,
    879679,
    789889,
    798687,
    797978,
    787977,
    878787,
    888787,
    977889,
    777899,
    797979,
    688688,
    877888,
    777788,
    887888,
    878888,
    779889,
    689788,
    876779,
    889898,
    878888,
    787877,
    967988,
    889889,
    888797,
    887887,
    886888,
    887989,
    788979,
    898987,
    878887,
    887887,
    877797,
    877778,
    997788,
    888788,
    779678,
    988878,
    787767,
    789877,
    688677,
    698787,
    999797,
    777688,
    879987,
    687988,
    798799,
    978868,
    776787,
    798787,
    988887,
    798879,
    888677,
    889678,
    778998,
    997868,
    887688,
    988789,
    977888,
    887967,
    988778,
    888887,
    888679,
    898899,
    898777,
    667689,
    886878,
    888888,
    987877,
    877687,
    788889,
    978797,
    879897,
    788976,
    877898,
    787977,
    978787,
    878887,
    887987,
    978778,
    777878,
    979898,
    897798,
    877887,
    978789,
    686788,
    788888,
    877887,
    888677,
    798698,
    779889,
    787776,
    798786,
    689896,
    888797,
    988798,
    777678,
    798976,
    879989,
    788789,
    877866,
    787788,
    768888,
    788788,
    988778,
    988997,
    897799,
    886778,
    879868,
    878886,
    987688,
    788879,
    879877,
    687789,
    988979,
    888778,
    898779,
    897889,
    896879,
    777787,
    867778,
    888798,
    896887,
    678898,
    877788,
    988899,
    887997,
    988799,
    879897,
    989787,
    887878,
    987988,
    989789,
    777787,
    878789,
    878988,
    768888,
    789877,
    979786,
    787878,
    787788,
    888878,
    677888,
    878869,
    888698,
    888989,
    977678,
    878897,
    787878,
    869887,
    887879,
    878888,
    878877,
    687888,
    788878,
    789988,
    888888,
    888897,
    678999,
    999777,
    888888,
    786888,
    978967,
    778778,
    777788,
    888868,
    978777,
    877999,
    888699,
    877888,
    778887,
    768697,
    888877,
    887778,
    998777,
    679787,
    698888,
    998989,
    678878,
    899878,
    788688,
    886979,
    888788,
    978877,
    898887,
    879886,
    888788,
    777977,
    879889,
    787776,
    789867,
    976887,
    979877,
    787877,
    679787,
    989987,
    677788,
    897779,
    989899,
    889888,
    898878,
    778888,
    978867,
    869668,
    879878,
    888877,
    888898,
    888889,
    997798,
    778887,
    878897,
    788989,
    679797,
    888879,
    798898,
    877798,
    967789,
    996797,
    879778,
    889778,
    978787,
    888887,
    788777,
    777888,
    988989,
    887887,
    778777,
    887987,
    877686,
    789888,
    777877,
    789889,
    788787,
    877987,
    878888,
    788878,
    877778,
    777776,
    877889,
    796777,
    998887,
    777798,
    798899,
    988778,
    769879,
    787697,
    788777,
    897898,
    877987,
    788866,
    796797,
    788898,
    988787,
    888867,
    888988,
    877889,
    977889,
    987898,
    898876,
    987868,
    897788,
    777788,
    897867,
    878988,
    889796,
    888877,
    878978,
    879878,
    888797,
    898878,
    688987,
    977988,
    678878,
    788867,
    896776,
    889779,
    768996,
    777889,
    798788,
    877788,
    878999,
    779978,
    997877,
    788789,
    689787,
    787888,
    987887,
    788777,
    778988,
    897788,
    888699,
    789997,
    777887,
    878797,
    888877,
    977898,
    778787,
    878878,
    879978,
    878786,
    879987,
    889779,
    879988,
    889776,
    789888,
    788877,
    888779,
    697888,
    778987,
    897798,
    888877,
    898879,
    788898,
    897867,
    677888,
    878886,
    787787,
    798798,
    679868,
    868987,
    887698,
    787677,
    888788,
    787887,
    886878,
    878889,
    967788,
    798987,
    888767,
    879887,
    798689,
    679778,
    888978,
    797787,
    797987,
    977887,
    868776,
    788976,
    989988,
    979697,
    778888,
    787788,
    877988,
    888876,
    897799,
    996986,
    888789,
    879778,
    787888,
    877888,
    879777,
    886769,
    886677,
    787987,
    798899,
    889787,
    888887,
    877878,
    988798,
    788788,
    789987,
    977779,
    888876,
    876888,
    987879,
    888898,
    887777,
    888797,
    978987,
    778887,
    779877,
    988778,
    887977,
    788887,
    789788,
    878977,
    797787,
    877889,
    788799,
    888777,
    878898,
    876967,
    778888,
    687777,
    888888,
    687698,
    988887,
    778886,
    899789,
    776888,
    887779,
    898978,
    897878,
    788866,
    896878,
    786979,
    877789,
    976787,
    889979,
    888878,
    877997,
    899878,
    889776,
    788879,
    877988,
    688777,
    698787,
    888667,
    978899,
    889976,
    798788,
    676678,
    978869,
    689878,
    788877,
    887787,
    789887,
    788886,
    998787,
    877878,
    667887,
    988889,
    887968,
    878878,
    776867,
    967797,
    799988,
    778688,
    987877,
    887897,
    778779,
    778787,
    977788,
    799699,
    976779,
    787688,
    687777,
    979787,
    788879,
    876787,
    897788,
    879768,
    878988,
    888988,
    767777,
    787897,
    798766,
    778888,
    896678,
    889877,
    978898,
    878877,
    978677,
    868886,
    689787,
    989978,
    779779,
    989897,
    869877,
    888887,
    888787,
    787997,
    878889,
    677799,
    888797,
    888789,
    888797,
    878867,
    877898,
    986787,
    778988,
    888689,
    987898,
    768788,
    887787,
    886887,
    777977,
    898687,
    779777,
    879779,
    888677,
    978977,
    788979,
    887888,
    989889,
    887988,
    988988,
    788677,
    787879,
    777897,
    988989,
    898899,
    787988,
    798988,
    888978,
    989889,
    888788,
    788778,
    897787,
    788868,
    898889,
    867688,
    788896,
    697988,
    969788,
    789897,
    788889,
    897887,
    778877,
    786797,
    899897,
    698878,
    987878,
    878987,
    687878,
    678987,
    896796,
    787788,
    988888,
    797679,
    776887,
    899967,
    787778,
    888887,
    888888,
    966878,
    687877,
    887998,
    897788,
    989788,
    778778,
    788879,
    969897,
    997978,
    887888,
    789777,
    889978,
    868787,
    998987,
    997688,
    987896,
    768989,
    889789,
    988788,
    987787,
    779798,
    878989,
    787688,
    767969,
    877777,
    897999,
    898778,
    887786,
    778898,
    687797,
    978889,
    877887,
    777899,
    777687,
    788778,
    886798,
    677878,
    888878,
    879768,
    797887,
    997898,
    887888,
    888679,
    988778,
    888668,
    778779,
    698878,
    868778,
    877777,
    878987,
    887878,
    978889,
    778888,
    787797,
    868786,
    788897,
    988797,
    888886,
    967888,
    689887,
    866788,
    997788,
    797879,
    777787,
    688767,
    889797,
    688876,
    778898,
    887877,
    878888,
    987778,
    777878,
    877877,
    778789,
    998878,
    888878,
    777899,
    899888,
    788977,
    997797,
    898698,
    777969,
    988777,
    789877,
    887787,
    999999,
    798677,
    886888,
    889777,
    879899,
    788779,
    788797,
    888678,
    798987,
    988888,
    878797,
    899978,
    778679,
    878989,
    798798,
    987978,
    887789,
    888787,
    677899,
    887779,
    889877,
    788977,
    887877,
    988878,
    878967,
    878867,
    996887,
    878679,
    887887,
    697878,
    686878,
    687878,
    898798,
    867778,
    779867,
    879868,
    768778,
    777977,
    878898,
    687888,
    766978,
    788896,
    888787,
    787979,
    968778,
    897769,
    787768,
    878889,
    897899,
    987788,
    887798,
    879788,
    787778,
    786888,
    988897,
    979998,
    896878,
    899688,
    899768,
    688789,
    687878,
    888897,
    978797,
    888777,
    789899,
    879999,
    788787,
    988767,
    787868,
    998697,
    887797,
    878778,
    879776,
    688788,
    688879,
    886886,
    877888,
    777899,
    789868,
    888799,
    986989,
    878799,
    688888,
    888798,
    888788,
    889977,
    968998,
    868777,
    777788,
    978887,
    787898,
    789888,
    879896,
    878678,
    677688,
    769788,
    798978,
    779889,
    977678,
    886877,
    899867,
    777876,
    777877,
    888988,
    988886,
    896879,
    878879,
    889776,
    777988,
    779788,
    679777,
    798887,
    987889,
    988889,
    796897,
    697988,
    787896,
    779788,
    989787,
    879787,
    898787,
    788887,
    989788,
    889878,
    889978,
    778897,
    997879,
    897797,
    898998,
    787788,
    899867,
    888779,
    688978,
    879888,
    799797,
    988987,
    788798,
    677877,
    987899,
    887767,
    877777,
    888787,
    779777,
    978777,
    897987,
    679889,
    878778,
    868789,
    979796,
    888798,
    778799,
    898788,
    878698,
    798889,
    897968,
    778878,
    998788,
    879788,
    888987,
    767789,
    877879,
    788786,
    787789,
    788889,
    787699,
    779787,
    788779,
    678888,
    788879,
    878888,
    888887,
    889868,
    978887,
    898899,
    888889,
    879879,
    799978,
    888687,
    898799,
    998887,
    976886,
    888886,
    869898,
    898867,
    999877,
    886798,
    776878,
    777889,
    777987,
    888787,
    897888,
    897787,
    797667,
    968677,
    877977,
    867679,
    988787,
    688889,
    978896,
    987788,
    897887,
    777897,
    888798,
    987888,
    987989,
    879678,
    998887,
    878678,
    887678,
    978998,
    878869,
    887787,
    878878,
    888877,
    989998,
    788878,
    978668,
    897879,
    889888,
    796897,
    878888,
    798889,
    897799,
    879788,
    789977,
    877889,
    878987,
    899786,
    787886,
    887998,
    987679,
    797998,
    897779,
    899768,
    778898,
    887778,
    687888,
    898898,
    978888,
    878778,
    967789,
    876868,
    687877,
    878989,
    777789,
    869798,
    789798,
    778887,
    787778,
    878698,
    788877,
    798787,
    677779,
    898988,
    977888,
    987977,
    877799,
    778897,
    877997,
    987867,
    778877,
    677788,
    878777,
    868768,
    878879,
    877887,
    898789,
    898998,
    886798,
    888797,
    887788,
    987788,
    777877,
    897788,
    898799,
    879867,
    978877,
    777988,
    777778,
    788798,
    786978,
    768889,
    786897,
    977898,
    996789,
    887886,
    788689,
    878877,
    778878,
    788897,
    899698,
    778899,
    978777,
    898788,
    897788,
    788788,
    889767,
    788768,
    877688,
    887989,
    999887,
    788887,
    787868,
    789879,
    887787,
    799767,
    689777,
    897788,
    878989,
    888788,
    888888,
    879777,
    987888,
    788888,
    887878,
    987978,
    687989,
    888889,
    786887,
    977898,
    778789,
    797889,
    778877,
    778787,
    799999,
    676977,
    876769,
    777888,
    878887,
    888777,
    776788,
    787868,
    788787,
    797877,
    786888,
    798877,
    799977,
    977778,
    786887,
    877898,
    886889,
    877788,
    877979,
    778878,
    888788,
    888987,
    877889,
    988888,
    889888,
    878688,
    777878,
    788899,
    796896,
    767797,
    979898,
    688877,
    687787,
    688999,
    877777,
    898968,
    878889,
    786897,
    887679,
    878787,
    689887,
    888866,
    987878,
    787777,
    887867,
    788787,
    777889,
    778786,
    788898,
    988976,
    787888,
    798678,
    887998,
    788788,
    888787,
    877778,
    776687,
    898879,
    876789,
    888778,
    878778,
    797879,
    887988,
    878989,
    879698,
    868786,
    787988,
    787898,
    887677,
    788766,
    777887,
    778889,
    897887,
    989989,
    887887,
    887897,
    778787,
    788789,
    779897,
    676889,
    788878,
    976788,
    889788,
    888978,
    887788,
    798888,
    887889,
    767677,
    998877,
    889778,
    988887,
    889897,
    777877,
    887889,
    777787,
    878879,
    786977,
    877867,
    767799,
    868687,
    788678,
    978877,
    788769,
    988888,
    678888,
    887787,
    877787,
    989777,
    888777,
    788899,
    889787,
    887887,
    889797,
    679879,
    868897,
    767787,
    877997,
    898787,
    797878,
    776897,
    989897,
    878888,
    877788,
    998688,
    986778,
    686878,
    899677,
    788888,
    798888,
    978788,
    798898,
    879689,
    788779,
    878678,
    999879,
    688877,
    979789,
    677887,
    877889,
    887777,
    888989,
    898888,
    688788,
    987888,
    779787,
    987887,
    988979,
    979788,
    868879,
    898889,
    786877,
    778989,
    897777,
    977887,
    969889,
    989878,
    988788,
    997889,
    887867,
    989898,
    897788,
    977787,
    787789,
    988878,
    888887,
    887879,
    987779,
    869786,
    978878,
    796778,
    878987,
    866987,
    887799,
    877777,
    879968,
    887898,
    788696,
    888877,
    677776,
    788978,
    787897,
    777888,
    886887,
    977677,
    798779,
    967878,
    987897,
    778999,
    676777,
    987788,
    878898,
    797969,
    988787,
    878799,
    888797,
    987977,
    777888,
    887787,
    878777,
    887897,
    879889,
    788878,
    978897,
    977878,
    788799,
    877888,
    889788,
    786788,
    878778,
    879879,
    798888,
    888888,
    889989,
    788988,
    889988,
    979977,
    778978,
    888786,
    988787,
    788778,
    778779,
    879787,
    767877,
    688779,
    888778,
    698888,
    987776,
    778668,
    787988,
    787987,
    888869,
    887977,
    878888,
    788797,
    877889,
    988698,
    888788,
    887796,
    897887,
    787986,
    899788,
    897787,
    799787,
    878878,
    788797,
    888787,
    787877,
    879888,
    888787,
    978877,
    878898,
    888878,
    878888,
    787787,
    779787,
    698777,
    768889,
    769887,
    778789,
    877898,
    788888,
    887888,
    897888,
    788988,
    888888,
    777677,
    897797,
    998897,
    888978,
    898878,
    997979,
    988988,
    878799,
    678778,
    887868,
    988678,
    797868,
    787879,
    887887,
    898797,
    877977,
    899897,
    888877,
    797878,
    787889,
    788888,
    887988,
    888798,
    798899,
    889887,
    878887,
    888797,
    886787,
    879787,
    888898,
    788777,
    888878,
    787879,
    887979,
    977688,
    977888,
    778788,
    787888,
    778997,
    789768,
    877788,
    888787,
    888979,
    678877,
    899788,
    888878,
    778968,
    787987,
    898677,
    977898,
    898788,
    898877,
    989778,
    877878,
    898687,
    987888,
    877886,
    888899,
    788998,
    778988,
    887888,
    966777,
    778878,
    789779,
    977677,
    867868,
    979897,
    788888,
    878877,
    888877,
    779888,
    878988,
    797777,
    777788,
    778669,
    888889,
    888888,
    998898,
    878777,
    888998,
    776886,
    988769,
    888777,
    878787,
    678899,
    977868,
    798888,
    788886,
    788778,
    788887,
    888897,
    887888,
    887898,
    788796,
    789887,
    987787,
    878687,
    977787,
    898686,
    888796,
    867788,
    899768,
    778788,
    877878,
    877899,
    876778,
    788977,
    887779,
    998877,
    977768,
    797978,
    867789,
    868877,
    896789,
    889789,
    889798,
    797778,
    797786,
    876978,
    979879,
    779677,
    987779,
    877989,
    888777,
    979777,
    677878,
    889899,
    897788,
    878777,
    877879,
    688886,
    798888,
    789967,
    978897,
    898888,
    787886,
    689688,
    778778,
    889789,
    977778,
    877678,
    888788,
    787988,
    698788,
    888877,
    888778,
    778869,
    788969,
    786886,
    776776,
    898987,
    776877,
    976698,
    887898,
    787877,
    978889,
    989977,
    878688,
    878769,
    687888,
    988866,
    888986,
    887888,
    887878,
    788988,
    788997,
    986676,
    888788,
    898767,
    887877,
    777887,
    887988,
    886888,
    777887,
    678797,
    888789,
    887888,
    888778,
    777887,
    888889,
    877799,
    997977,
    797987,
    778788,
    899877,
    897878,
    989999,
    888879,
    978868,
    788899,
    888877,
    978888,
    889797,
    768888,
    877887,
    897878,
    887777,
    889788,
    779878,
    878786,
    977887,
    778888,
    777998,
    779898,
    878879,
    687888,
    798987,
    888999,
    778787,
    778788,
    887799,
    886776,
    897878,
    777788,
    897888,
    887898,
    887789,
    878998,
    787977,
    977889,
    689888,
    798887,
    879877,
    797889,
    788887,
    778788,
    788887,
    779777,
    776878,
    877878,
    978897,
    878997,
    889988,
    989787,
    797799,
    799778,
    788989,
    887786,
    877677,
    788787,
    997978,
    778798,
    897789,
    779898,
    887887,
    679878,
    878869,
    878787,
    887879,
    778998,
    788778,
    898778,
    877888,
    788888,
    977889,
    988888,
    868878,
    788888,
    778768,
    899898,
    877987,
    887788,
    788888,
    877888,
    778786,
    689788,
    888887,
    979868,
    986788,
    988797,
    978896,
    888779,
    889779,
    787979,
    899786,
    988778,
    777788,
    989897,
    899787,
    868778,
    788787,
    767697,
    899788,
    897777,
    877797,
    878888,
    798879,
    878878,
    779987,
    878898,
    777867,
    788798,
    889969,
    889779,
    976888,
    887988,
    878877,
    798877,
    887977,
    787988,
    998898,
    797888,
    886687,
    887798,
    779888,
    898967,
    876879,
    997887,
    798687,
    887879,
    887897,
    887799,
    888879,
    998879,
    887788,
    978877,
    898899,
    969787,
    878778,
    777988,
    887779,
    888898,
    887987,
    877878,
    677877,
    686889,
    878868,
    779887,
    877968,
    978967,
    889799,
    899888,
    868898,
    786688,
    787887,
    687998,
    668878,
    999779,
    778778,
    877787,
    878888,
    877887,
    879877,
    787878,
    999788,
    888888,
    966678,
    879789,
    879787,
    899788,
    888978,
    887887,
    788896,
    878998,
    988888,
    897787,
    787797,
    898887,
    787787,
    967798,
    989788,
    889778,
    877978,
    889789,
    778788,
    988788,
    778777,
    887887,
    889877,
    788879,
    797788,
    877778,
    777678,
    877899,
    889988,
    698889,
    977878,
    898787,
    897878,
    887787,
    876899,
    878888,
    877878,
    977668,
    988988,
    768889,
    879877,
    878778,
    788886,
    988798,
    688997,
    897899,
    788977,
    767879,
    787678,
    786899,
    878767,
    787789,
    768986,
    779878,
    689988,
    878879,
    888787,
    679787,
    998888,
    887887,
    698887,
    796887,
    897988,
    898889,
    888877,
    888898,
    788997,
    789988,
    788777,
    888878,
    897898,
    777799,
    878778,
    888988,
    879698,
    787868,
    776877,
    979898,
    888678,
    778968,
    997887,
    968876,
    878789,
    778988,
    766896,
    878979,
    877797,
    896889,
    888966,
    898977,
    998889,
    777878,
    778887,
    898879,
    987877,
    888879,
    887786,
    789876,
    978887,
    887798,
    976797,
    787888,
    777787,
    878878,
    798768,
    797698,
    887976,
    787867,
    878888,
    778888,
    789796,
    879887,
    877878,
    886886,
    887787,
    778988,
    998789,
    777989,
    878899,
    787889,
    988987,
    789788,
    988977,
    688889,
    978888,
    697888,
    787878,
    988788,
    779778,
    779798,
    877899,
    887986,
    879989,
    799987,
    897977,
    888998,
    977887,
    878977,
    967977,
    889878,
    987877,
    877898,
    899887,
    888789,
    879889,
    888887,
    786877,
    798888,
    778788,
    779788,
    778877,
    767886,
    878989,
    978887,
    778796,
    978878,
    996778,
    778978,
    989878,
    988897,
    887789,
    889879,
    977777,
    787899,
    869887,
    888887,
    988878,
    788978,
    687768,
    689789,
    897878,
    889779,
    788779,
    787888,
    798786,
    689876,
    799998,
    986888,
    677889,
    888878,
    887778,
    776797,
    889899,
    897887,
    878899,
    778887,
    887788,
    877777,
    877997,
    767787,
    967787,
    798788,
    878876,
    787878,
    778887,
    788887,
    888898,
    676889,
    788678,
    868887,
    787887,
    879879,
    998676,
    878879,
    887776,
    887877,
    888989,
    789778,
    786889,
    978686,
    889978,
    888888,
    877899,
    789779,
    888887,
    898779,
    887778,
    888888,
    798777,
    888888,
    898987,
    888777,
    897767,
    787987,
    968878,
    889797,
    788787,
    798899,
    777789,
    987897,
    878888,
    787887,
    889799,
    898887,
    887878,
    788987,
    678887,
    797788,
    689877,
    888879,
    678797,
    887787,
    888878,
    779676,
    678887,
    889887,
    999868,
    788777,
    767778,
    999987,
    676798,
    998798,
    989878,
    997887,
    886887,
    876777,
    888769,
    679899,
    989977,
    777868,
    888877,
    888978,
    879987,
    887887,
    786798,
    777777,
    888986,
    868866,
    778978,
    868789,
    877766,
    886979,
    796878,
    866678,
    998888,
    777988,
    797788,
    789898,
    879767,
    778977,
    888888,
    778779,
    687686,
    789789,
    888889,
    979987,
    897988,
    898977,
    779988,
    878878,
    988888,
    798889,
    798797,
    878788,
    788879,
    889777,
    869868,
    768888,
    898699,
    887987,
    867878,
    998978,
    797876,
    888977,
    878797,
    888796,
    778888,
    798878,
    999788,
    889987,
    769788,
    787787,
    878878,
    898879,
    868798,
    886867,
    988877,
    876968,
    888786,
    777887,
    899797,
    896888,
    977767,
    896787,
    779887,
    877789,
    886978,
    876787,
    787777,
    778888,
    676776,
    988868,
    866778,
    787788,
    898888,
    987788,
    888897,
    878889,
    867788,
    688778,
    779878,
    888877,
    688797,
    787688,
    888687,
    867877,
    789889,
    788887,
    787889,
    878898,
    886789,
    998878,
    777888,
    896989,
    989767,
    899978,
    888877,
    888688,
    879986,
    788889,
    887899,
    787889,
    877889,
    886778,
    967778,
    777787,
    888996,
    878888,
    779798,
    988788,
    777796,
    978797,
    699899,
    777978,
    767889,
    887898,
    888788,
    867887,
    798788,
    867978,
    886987,
    697779,
    868779,
    986788,
    988898,
    786887,
    988786,
    887888,
    876777,
    778787,
    687777,
    878777,
    878887,
    878778,
    887688,
    988989,
    867987,
    787786,
    988778,
    898889,
    698867,
    788898,
    878897,
    879799,
    797798,
    878898,
    698979,
    767888,
    879898,
    768887,
    779796,
    788676,
    896887,
    689877,
    977766,
    888888,
    787978,
    898698,
    977778,
    978778,
    979778,
    798888,
    988868,
    888897,
    977788,
    779998,
    878887,
    878779,
    897787,
    788778,
    988987,
    786898,
    987798,
    677877,
    988896,
    889798,
    799986,
    788997,
    898878,
    987888,
    887888,
    877787,
    778888,
    777977,
    688779,
    779876,
    867776,
    867998,
    688786,
    889987,
    679877,
    889886,
    897678,
    977778,
    788786,
    799778,
    778987,
    878789,
    898778,
    688787,
    887776,
    887888,
    679779,
    988879,
    877986,
    888898,
    778789,
    877886,
    899789,
    997769,
    787798,
    789788,
    778878,
    779887,
    988787,
    988777,
    788876,
    699999,
    897876,
    888777,
    888879,
    989778,
    888789,
    768878,
    878889,
    998888,
    797976,
    868798,
    787788,
    878789,
    886777,
    989977,
    796798,
    877798,
    788887,
    898998,
    787788,
    888789,
    888868,
    879998,
    778778,
    798879,
    778888,
    678968,
    978888,
    889888,
    887898,
    979978,
    798898,
    896799,
    998898,
    788978,
    787878,
    889888,
    887879,
    777898,
    886797,
    687789,
    889888,
    988878,
    797998,
    787889,
    798778,
    778887,
    789888,
    797979,
    788976,
    889878,
    888977,
    889879,
    779797,
    888679,
    769877,
    778877,
    777878,
    986868,
    878788,
    888887,
    888788,
    898788,
    789898,
    798987,
    888888,
    898788,
    697898,
    798878,
    787886,
    788777,
    679987,
    887988,
    789887,
    888887,
    698777,
    888899,
    999977,
    688989,
    777867,
    887787,
    797779,
    989887,
    877779,
    877787,
    777787,
    779986,
    787887,
    787687,
    788786,
    887799,
    787688,
    887897,
    777897,
    887878,
    678889,
    877888,
    887987,
    977877,
    898988,
    888687,
    887878,
    797788,
    978678,
    687789,
    998887,
    899988,
    867888,
    776899,
    877798,
    988696,
    887778,
    877967,
    888778,
    788789,
    797877,
    777777,
    887797,
    789777,
    886977,
    788888,
    787776,
    788988,
    988897,
    778777,
    798778,
    777899,
    996988,
    887699,
    879788,
    889888,
    877977,
    899988,
    987889,
    887977,
    887897,
    877978,
    978887,
    788877,
    968798,
    877787,
    778887,
    778799,
    887977,
    778987,
    977786,
    886899,
    888977,
    779787,
    879978,
    888789,
    887878,
    878967,
    777787,
    769798,
    899887,
    879777,
    878888,
    788987,
    789997,
    787978,
    988777,
    678877,
    888878,
    887687,
    778988,
    778886,
    798789,
    876867,
    787779,
    788878,
    878998,
    888888,
    897888,
    789898,
    788797,
    979888,
    778789,
    779978,
    978788,
    997867,
    987888,
    976767,
    987898,
    687878,
    989987,
    687988,
    777879,
    888978,
    777879,
    779999,
    879778,
    798687,
    988779,
    968879,
    898698,
    978879,
    788679,
    788877,
    887878,
    788999,
    889988,
    888788,
    898778,
    777888,
    788877,
    896878,
    888899,
    878989,
    876887,
    777897,
    879779,
    876778,
    897878,
    888887,
    689697,
    978979,
    778888,
    888988,
    889878,
    687877,
    888887,
    898886,
    687988,
    897879,
    978898,
    788888,
    889998,
    888897,
    999787,
    978888,
    977787,
    787889,
    778888,
    978889,
    779888,
    767899,
    998789,
    676887,
    998677,
    988977,
    997877,
    977797,
    787798,
    778879,
    888899,
    898987,
    787788,
    989888,
    978788,
    988888,
    788898,
    789788,
    787997,
    968798,
    887787,
    878777,
    787679,
    878887,
    767889,
    878797,
    897989,
    877767,
    877668,
    898888,
    987797,
    777788,
    877888,
    898987,
    778787,
    998887,
    898869,
    699999,
    788887,
    769778,
    887886,
    898678,
    998776,
    998788,
    878788,
    788778,
    888788,
    886777,
    777777,
    997997,
    878678,
    887898,
    677778,
    888978,
    797998,
    879899,
    967978,
    878798,
    888978,
    769889,
    988898,
    789778,
    898777,
    799798,
    798777,
    868887,
    897778,
    879889,
    979787,
    769888,
    988677,
    986887,
    868999,
    677989,
    897789,
    888897,
    887979,
    897887,
    788877,
    968988,
    887987,
    998788,
    786797,
    978978,
    887977,
    888797,
    789879,
    788878,
    777787,
    879989,
    877799,
    798886,
    897888,
    986989,
    989966,
    878778,
    876698,
    899997,
    888989,
    787889,
    697898,
    888889,
    888986,
    768797,
    779778,
    788886,
    997889,
    977798,
    788778,
    778879,
    988879,
    878877,
    898798,
    879898,
    879888,
    777687,
    889787,
    797777,
    887777,
    877877,
    766788,
    787879,
    888777,
    898777,
    989788,
    878879,
    886888,
    797888,
    887788,
    978879,
    978887,
    887778,
    888989,
    889888,
    789877,
    898887,
    886899,
    798887,
    879767,
    887878,
    778769,
    798777,
    987897,
    879869,
    978977,
    978977,
    886779,
    778798,
    988888,
    898778,
    788888,
    887889,
    778999,
    786778,
    778888,
    989777,
    978887,
    978767,
    788789,
    678998,
    899677,
    888988,
    778687,
    769788,
    898688,
    677778,
    887997,
    978968,
    977788,
    988889,
    878798,
    888988,
    679878,
    766877,
    888787,
    768878,
    779786,
    987788,
    797778,
    898798,
    988878,
    899878,
    788879,
    779789,
    978788,
    887798,
    879888,
    889898,
    688887,
    798898,
    868697,
    889798,
    788967,
    776787,
    878778,
    889797,
    897766,
    987877,
    778779,
    688778,
    987788,
    778888,
    879889,
    799878,
    798789,
    778877,
    898786,
    777797,
    787777,
    889778,
    789978,
    989876,
    789879,
    887889,
    788877,
    778897,
    888887,
    888968,
    789778,
    988978,
    887678,
    897987,
    768667,
    667978,
    978777,
    887778,
    889679,
    778888,
    778989,
    888878,
    887979,
    988779,
    888877,
    777897,
    889879,
    988889,
    997787,
    698899,
    879777,
    697897,
    878879,
    977987,
    788879,
    986887,
    777789,
    888788,
    889988,
    777788,
    887887,
    887879,
    897878,
    879789,
    778997,
    979888,
    897898,
    887978,
    888778,
    798799,
    878787,
    987798,
    789776,
    888978,
    788879,
    897768,
    688688,
    798889,
    789987,
    886989,
    987798,
    987778,
    868789,
    776868,
    878868,
    898789,
    698777,
    778878,
    687788,
    788688,
    968887,
    678878,
    777787,
    678888,
    976878,
    878899,
    887788,
    778888,
    887688,
    888777,
    778886,
    978969,
    888698,
    698688,
    978888,
    868877,
    888687,
    698887,
    897667,
    897887,
    788989,
    686879,
    897886,
    698777,
    879878,
    888787,
    889779,
    888777,
    878867,
    778888,
    797887,
    899987,
    798878,
    878868,
    768778,
    978877,
    888887,
    868887,
    877998,
    988888,
    777877,
    787877,
    898998,
    878977,
    777789,
    778896,
    778777,
    898868,
    798778,
    787887,
    877888,
    878768,
    989887,
    887897,
    888897,
    887899,
    797789,
    798779,
    798879,
    776788,
    788798,
    786699,
    889788,
    876789,
    778998,
    897789,
    788878,
    899988,
    898878,
    888977,
    778776,
    788878,
    778887,
    979677,
    977887,
    788888,
    896898,
    886978,
    899887,
    888899,
    976776,
    687789,
    978787,
    878688,
    878797,
    678966,
    987898,
    887778,
    988779,
    787788,
    788887,
    998996,
    878989,
    687788,
    988898,
    967887,
    897898,
    769898,
    869888,
    978789,
    888886,
    778778,
    867778,
    977888,
    788978,
    898688,
    878968,
    879688,
    798797,
    788778,
    877898,
    767899,
    778798,
    878888,
    778788,
    977896,
    988987,
    889877,
    997878,
    769886,
    778789,
    877787,
    897787,
    788977,
    989977,
    676879,
    887888,
    998887,
    698877,
    777889,
    989998,
    897897,
    989787,
    897678,
    788888,
    968778,
    996788,
    876998,
    887677,
    897788,
    887788,
    778878,
    688987,
    989979,
    787888,
    887779,
    987887,
    887777,
    889899,
    977888,
    777968,
    987788,
    998878,
    798776,
    877797,
    797889,
    798888,
    787997,
    979888,
    767689,
    798898,
    988876,
    697898,
    798887,
    788779,
    786786,
    788976,
    878888,
    988898,
    797888,
    687877,
    778988,
    988887,
    898998,
    777979,
    778878,
    778977,
    979789,
    876987,
    888978,
    878898,
    887998,
    768879,
    689888,
    898787,
    688688,
    979887,
    878787,
    788888,
    887887,
    897988,
    687888,
    787686,
    887967,
    788879,
    896878,
    798788,
    779778,
    877898,
    787878,
    976796,
    887879,
    878779,
    878978,
    888788,
    779877,
    996887,
    879867,
    988868,
    877786,
    879888,
    878888,
    797878,
    897788,
    669678,
    768786,
    879789,
    888787,
    697888,
    788788,
    978898,
    878987,
    977889,
    788887,
    898888,
    789788,
    798887,
    979897,
    978699,
    999978,
    787777,
    779778,
    888898,
    986888,
    867999,
    977987,
    887789,
    778689,
    777878,
    897987,
    787777,
    787898,
    977887,
    777897,
    779878,
    786877,
    988776,
    877877,
    899888,
    779978,
    897868,
    898788,
    978877,
    787869,
    887978,
    798987,
    887789,
    976887,
    887787,
    897879,
    897886,
    886978,
    888879,
    887787,
    876887,
    899887,
    986888,
    898897,
    888987,
    898978,
    988789,
    687888,
    778677,
    897778,
    879888,
    887777,
    878788,
    778888,
    688787,
    997888,
    878998,
    987779,
    888879,
    698888,
    897868,
    988967,
    787799,
    898788,
    989887,
    877878,
    788987,
    888988,
    889887,
    767889,
    797888,
    778978,
    787888,
    766788,
    888798,
    886789,
    988888,
    899897,
    887876,
    888777,
    977778,
    678968,
    878778,
    777987,
    798988,
    898788,
    888998,
    999798,
    977788,
    688768,
    788988,
    678989,
    788698,
    987878,
    788867,
    877778,
    888888,
    877886,
    898789,
    788898,
    897779,
    787789,
    979999,
    887778,
    777977,
    798779,
    888888,
    878888,
    788888,
    887888,
    878988,
    978878,
    688988,
    777779,
    788799,
    887887,
    686889,
    889878,
    889899,
    887778,
    978777,
    779868,
    779888,
    977878,
    788777,
    878887,
    988678,
    788887,
    788888,
    879768,
    798678,
    788878,
    787878,
    897888,
    968697,
    879887,
    898888,
    787798,
    778977,
    888787,
    997998,
    876977,
    789877,
    877988,
    877777,
    987798,
    778898,
    899869,
    778987,
    778998,
    878876,
    778767,
    888888,
    788786,
    878988,
    777878,
    797766,
    777987,
    879977,
    987879,
    878888,
    789886,
    888787,
    879969,
    777887,
    787787,
    788788,
    987888,
    887778,
    998789,
    887677,
    988888,
    888877,
    888887,
    787887,
    789888,
    987869,
    876998,
    889887,
    877899,
    979779,
    898987,
    878889,
    988887,
    776788,
    878788,
    878876,
    769788,
    779977,
    677979,
    888969,
    677878,
    876669,
    787989,
    879878,
    997887,
    787998,
    987888,
    776888,
    669978,
    778788,
    687989,
    787779,
    777668,
    978887,
    887988,
    879787,
    687789,
    797767,
    777978,
    887787,
    778889,
    779977,
    876699,
    878878,
    999889,
    768797,
    798877,
    797889,
    987887,
    888968,
    879787,
    788878,
    989777,
    979977,
    997778,
    987978,
    987679,
    988787,
    887899,
    988888,
    788797,
    878988,
    867877,
    887997,
    887797,
    788889,
    988978,
    788998,
    878977,
    778799,
    878778,
    787879,
    998888,
    898677,
    978888,
    877898,
    767897,
    999876,
    778886,
    898768,
    987968,
    877988,
    776876,
    888896,
    898886,
    988778,
    797876,
    789789,
    996897,
    889879,
    988887,
    788779,
    788788,
    988987,
    888898,
    689786,
    789787,
    798789,
    886878,
    777687,
    778886,
    887787,
    778877,
    787786,
    779887,
    777788,
    697669,
    888787,
    988878,
    778996,
    889769,
    787979,
    887877,
    787797,
    986898,
    797878,
    898879,
    789988,
    678789,
    978778,
    997698,
    688887,
    877797,
    878977,
    678889,
    779789,
    887776,
    798877,
    888989,
    867788,
    767797,
    778889,
    887898,
    687978,
    877899,
    998898,
    778998,
    899877,
    798798,
    799787,
    868697,
    969678,
    788986,
    687897,
    887879,
    788887,
    796987,
    889677,
    887899,
    778778,
    886788,
    997777,
    786877,
    787768,
    976796,
    787796,
    799886,
    787888,
    888789,
    878778,
    877879,
    778797,
    887877,
    897877,
    799878,
    878977,
    789778,
    888888,
    978889,
    898887,
    788868,
    676879,
    997887,
    778787,
    778887,
    976787,
    667887,
    878878,
    678878,
    878968,
    878678,
    797887,
    788987,
    777999,
    679977,
    777898,
    679776,
    889768,
    879977,
    678978,
    887688,
    898678,
    698778,
    777888,
    788877,
    688796,
    797886,
    978798,
    688899,
    788898,
    889888,
    877697,
    879676,
    989877,
    788786,
    777688,
    988887,
    889878,
    988797,
    788789,
    887678,
    889897,
    788869,
    689868,
    878898,
    787778,
    777878,
    886988,
    978687,
    879887,
    888999,
    979887,
    889877,
    668898,
    777887,
    979877,
    987889,
    789888,
    787997,
    988777,
    988888,
    887888,
    888886,
    878888,
    777789,
    978887,
    879879,
    779798,
    878788,
    987877,
    778888,
    889878,
    888978,
    798886,
    987877,
    888778,
    868788,
    779797,
    777788,
    777767,
    978767,
    966878,
    987897,
    668878,
    889788,
    878877,
    898777,
    878877,
    777879,
    797768,
    878887,
    786878,
    877777,
    998778,
    897897,
    887786,
    878887,
    878888,
    977797,
    677769,
    677888,
    788779,
    888789,
    877797,
    878777,
    898987,
    789878,
    798987,
    787886,
    887879,
    688877,
    899887,
    986887,
    887898,
    976787,
    799687,
    878787,
    778898,
    798798,
    877688,
    787779,
    888787,
    779889,
    788777,
    777888,
    889777,
    987787,
    797798,
    978878,
    877878,
    897788,
    888868,
    778797,
    867887,
    787897,
    799789,
    798886,
    789877,
    798988,
    878888,
    987889,
    899788,
    878787,
    788998,
    987686,
    877898,
    779776,
    889889,
    887978,
    777988,
    789886,
    877987,
    799788,
    989786,
    997887,
    889886,
    777888,
    879797,
    887887,
    978888,
    778868,
    767898,
    897797,
    988868,
    797867,
    778867,
    986877,
    787778,
    788887,
    887876,
    877678,
    778877,
    697886,
    987788,
    887779,
    788778,
    788777,
    976897,
    997778,
    879789,
    968788,
    988877,
    768988,
    987878,
    989978,
    689789,
    788877,
    887699,
    878877,
    887788,
    667887,
    889797,
    876879,
    798996,
    869999,
    788978,
    878778,
    799778,
    778887,
    878887,
    888787,
    899889,
    898796,
    777899,
    886777,
    777797,
    876878,
    888768,
    877797,
    997787,
    989888,
    787876,
    988988,
    888988,
    879898,
    887797,
    989878,
    989878,
    798978,
    896886,
    888977,
    897789,
    868889,
    788877,
    878896,
    889898,
    986888,
    988888,
    889867,
    877779,
    869888,
    889887,
    898787,
    888888,
    868988,
    899789,
    876889,
    998878,
    877887,
    878787,
    887797,
    788988,
    899787,
    898767,
    876888,
    879896,
    799786,
    688789,
    778788,
    687698,
    778897,
    989887,
    888978,
    878978,
    979978,
    889878,
    878888,
    787887,
    968776,
    787877,
    887778,
    989798,
    887778,
    878769,
    788977,
    977896,
    997898,
    887997,
    978889,
    897987,
    788877,
    888877,
    967886,
    998768,
    887779,
    878987,
    978879,
    788877,
    997788,
    789777,
    887778,
    979978,
    877778,
    689778,
    978889,
    878979,
    787787,
    869887,
    978688,
    888878,
    979777,
    878786,
    797876,
    988988,
    986869,
    898879,
    898977,
    987779,
    787888,
    888898,
    976978,
    798977,
    788877,
    889886,
    888987,
    897788,
    898997,
    767867,
    788888,
    988798,
    888787,
    887788,
    887887,
    789998,
    898978,
    887877,
    799889,
    868998,
    877887,
    867977,
    978979,
    788888,
    988787,
    898888,
    888686,
    779789,
    976789,
    888778,
    877788,
    777999,
    898797,
    687867,
    998767,
    988897,
    679887,
    788798,
    987787,
    878899,
    787976,
    867988,
    777798,
    879877,
    878778,
    988877,
    867876,
    888677,
    689889,
    777987,
    898888,
    679789,
    798877,
    889778,
    878987,
    778776,
    798867,
    878899,
    897899,
    887777,
    888777,
    788996,
    898888,
    989878,
    799787,
    899877,
    897789,
    777878,
    877977,
    889788,
    888877,
    888989,
    787777,
    897888,
    888897,
    887887,
    878786,
    888888,
    899889,
    778987,
    778779,
    996787,
    898797,
    887887,
    778897,
    987888,
    878879,
    777778,
    896998,
    898879,
    868988,
    988988,
    878786,
    878777,
    787889,
    988867,
    888988,
    887888,
    889777,
    699798,
    898887,
    697778,
    889788,
    887788,
    888699,
    887868,
    798979,
    878778,
    787787,
    878886,
    778877,
    879968,
    897778,
    899888,
    887888,
    888787,
    886978,
    797768,
    896879,
    869787,
    876988,
    888797,
    888968,
    698897,
    689878,
    789779,
    778797,
    786996,
    787877,
    878768,
    789778,
    988988,
    787777,
    778797,
    978886,
    978878,
    877886,
    899887,
    887789,
    778888,
    778988,
    789887,
    798888,
    879797,
    988988,
    779887,
    876786,
    779877,
    688779,
    888877,
    889697,
    778986,
    888677,
    888798,
    988788,
    877887,
    878888,
    888988,
    987787,
    889979,
    777968,
    888797,
    996887,
    877787,
    988778,
    698988,
    986798,
    988898,
    689886,
    769787,
    988779,
    888987,
    888677,
    976988,
    887788,
    888677,
    888888,
    789788,
    889878,
    869787,
    977789,
    889778,
    797977,
    796786,
    786777,
    778787,
    778888,
    777787,
    987988,
    867999,
    998987,
    879787,
    788797,
    766777,
    777787,
    798789,
    886787,
    889787,
    679879,
    977999,
    978898,
    976789,
    797788,
    778978,
    768878,
    868778,
    776887,
    988988,
    879787,
    786799,
    888998,
    789899,
    978788,
    788786,
    986967,
    798888,
    788789,
    978989,
    968799,
    968978,
    878996,
    988888,
    887788,
    689979,
    878868,
    797886,
    888879,
    677977,
    688798,
    688779,
    778777,
    787778,
    697687,
    968998,
    788879,
    878888,
    898898,
    986887,
    888786,
    788987,
    678899,
    789778,
    987887,
    897787,
    988798,
    788989,
    888969,
    979799,
    988899,
    887787,
    887887,
    779899,
    998788,
    778898,
    767678,
    887988,
    878877,
    877877,
    787878,
    888897,
    877777,
    979878,
    887967,
    976878,
    789878,
    878889,
    788889,
    988787,
    987988,
    878888,
    997678,
    788888,
    988797,
    878997,
    768887,
    878879,
    888777,
    897889,
    696798,
    978779,
    888888,
    788987,
    889877,
    896768,
    888898,
    798978,
    887786,
    899677,
    889789,
    977877,
    797889,
    887886,
    898888,
    787889,
    887988,
    886777,
    977868,
    978898,
    967787,
    787878,
    879877,
    889786,
    868879,
    688799,
    888889,
    798978,
    977898,
    787798,
    787787,
    687887,
    798777,
    888769,
    968778,
    888878,
    798796,
    888888,
    978796,
    797898,
    787788,
    777789,
    898878,
    879898,
    899787,
    788898,
    788688,
    898867,
    788897,
    987789,
    778987,
    888888,
    779879,
    877796,
    968776,
    868897,
    686669,
    898688,
    778877,
    797987,
    968989,
    978778,
    779877,
    787878,
    778887,
    789767,
    887799,
    878867,
    989778,
    677869,
    777879,
    796887,
    777886,
    789999,
    887868,
    988898,
    987987,
    778877,
    898979,
    786989,
    869787,
    898968,
    979788,
    977786,
    778978,
    787776,
    679888,
    878889,
    788887,
    879699,
    877868,
    887779,
    888887,
    788998,
    897796,
    976778,
    788888,
    896889,
    779988,
    877978,
    788988,
    787987,
    889699,
    778668,
    689788,
    788888,
    778779,
    989979,
    978989,
    998887,
    898978,
    898878,
    897778,
    987777,
    778888,
    867888,
    779888,
    787966,
    887778,
    788777,
    987786,
    897897,
    878876,
    678977,
    777788,
    778897,
    888989,
    788787,
    878977,
    888766,
    878888,
    888886,
    888887,
    888988,
    887877,
    897798,
    788987,
    778888,
    877888,
    789788,
    898877,
    678796,
    877789,
    987888,
    878787,
    888788,
    878888,
    869769,
    878998,
    788888,
    998889,
    777887,
    898989,
    988788,
    798787,
    878878,
    789798,
    779887,
    768878,
    798888,
    888887,
    787788,
    878968,
    978777,
    777879,
    898888,
    788888,
    877889,
    787788,
    789799,
    988988,
    987797,
    888788,
    978988,
    896777,
    989687,
    779889,
    887887,
    868887,
    988987,
    898987,
    978988,
    979877,
    877787,
    787887,
    788869,
    988888,
    889798,
    878887,
    888688,
    798877,
    799887,
    877888,
    899889,
    877797,
    888799,
    878889,
    876766,
    877679,
    997688,
    898778,
    888998,
    988788,
    978698,
    697897,
    779687,
    877788,
    879978,
    897778,
    888878,
    778788,
    888996,
    897778,
    788987,
    677987,
    778789,
    878889,
    887887,
    898988,
    987778,
    788778,
    789967,
    788888,
    778898,
    778788,
    867889,
    888888,
    888898,
    788798,
    998888,
    788876,
    889878,
    878799,
    786797,
    999876,
    888989,
    977896,
    898898,
    988877,
    879777,
    787868,
    787877,
    869877,
    887889,
    987688,
    878887,
    977977,
    879889,
    689898,
    797877,
    799879,
    888888,
    779887,
    877788,
    878889,
    888687,
    888688,
    977786,
    877887,
    978877,
    989868,
    978778,
    879898,
    869898,
    898887,
    889787,
    988787,
    799788,
    999888,
    879887,
    877787,
    789788,
    798777,
    878688,
    777968,
    787898,
    687789,
    777789,
    697688,
    877767,
    896887,
    677797,
    878788,
    876876,
    788889,
    898787,
    887997,
    779997,
    887789,
    788987,
    987677,
    877887,
    788787,
    777768,
    988887,
    778768,
    888767,
    777998,
    878779,
    787988,
    778978,
    798978,
    889986,
    689788,
    779887,
    987887,
    997787,
    897877,
    877788,
    777898,
    878877,
    879978,
    688897,
    799977,
    868889,
    787977,
    889887,
    888789,
    887988,
    878778,
    899778,
    886977,
    778998,
    888987,
    977788,
    797798,
    688887,
    787988,
    889799,
    789896,
    786898,
    869678,
    967877,
    778878,
    777777,
    678879,
    787866,
    987779,
    788878,
    779769,
    888887,
    976777,
    786888,
    879766,
    878789,
    777876,
    797897,
    788689,
    878778,
    889887,
    788888,
    798998,
    697877,
    788788,
    877787,
    788886,
    978888,
    778897,
    788898,
    887878,
    777888,
    979888,
    788987,
    788998,
    967797,
    797888,
    987798,
    978787,
    797878,
    878787,
    888867,
    988986,
    889876,
    888877,
    777988,
    898789,
    867778,
    878878,
    868887,
    699788,
    998978,
    787778,
    887787,
    978997,
    778887,
    777977,
    889978,
    687688,
    778888,
    689988,
    887876,
    868886,
    887898,
    888788,
    778888,
    787887,
    788978,
    889788,
    889886,
    898976,
    879699,
    878777,
    886978,
    867977,
    878888,
    879889,
    886779,
    697897,
    988979,
    688887,
    878877,
    878889,
    987877,
    877878,
    677887,
    888788,
    789877,
    777878,
    976787,
    887777,
    788789,
    698788,
    888797,
    999988,
    787787,
    776768,
    778697,
    779987,
    988986,
    878879,
    888889,
    788778,
    778789,
    989898,
    877789,
    987887,
    998879,
    998998,
    888677,
    876988,
    988668,
    897897,
    799887,
    898888,
    877797,
    997878,
    798787,
    768979,
    787989,
    877898,
    779877,
    787799,
    897878,
    779797,
    877887,
    797998,
    888687,
    789888,
    988886,
    978678,
    989778,
    867879,
    688888,
    796987,
    998796,
    776986,
    888888,
    788877,
    977878,
    877877,
    778688,
    887797,
    768897,
    787886,
    899978,
    778887,
    887788,
    788797,
    898878,
    887778,
    877878,
    788898,
    987776,
    877989,
    777868,
    888879,
    786779,
    777887,
    878676,
    898989,
    787878,
    987888,
    889897,
    787869,
    888778,
    789677,
    799879,
    799886,
    988698,
    788799,
    888789,
    787988,
    789788,
    789679,
    899899,
    888688,
    778987,
    978877,
    987887,
    778767,
    898787,
    697778,
    698689,
    878888,
    967888,
    977887,
    788777,
    887887,
    868798,
    799699,
    877777,
    887798,
    689787,
    698698,
    888988,
    797797,
    987879,
    778887,
    677877,
    699878,
    788768,
    986869,
    868789,
    779678,
    977788,
    879789,
    978998,
    878878,
    777979,
    879888,
    788997,
    676986,
    897977,
    889787,
    889679,
    988778,
    888979,
    778879,
    887898,
    888898,
    788977,
    887679,
    688777,
    988888,
    886788,
    877787,
    888889,
    789987,
    878988,
    898999,
    877787,
    876988,
    878879,
    888878,
    987788,
    996877,
    877788,
    887897,
    788987,
    899989,
    788977,
    888687,
    686778,
    878899,
    888986,
    987697,
    769897,
    978877,
    988878,
    998887,
    678898,
    779888,
    898888,
    898898,
    787797,
    798698,
    898887,
    789887,
    887797,
    687787,
    877886,
    779888,
    979888,
    888876,
    888897,
    778877,
    787897,
    887887,
    778898,
    898878,
    979698,
    888878,
    878888,
    997777,
    988877,
    979779,
    986886,
    998879,
    869989,
    797766,
    779998,
    887778,
    778997,
    878788,
    988697,
    888887,
    788797,
    777976,
    787888,
    987799,
    988888,
    878789,
    788787,
    688787,
    888779,
    899698,
    788989,
    899898,
    778689,
    879897,
    988779,
    867877,
    888888,
    778888,
    988897,
    978888,
    877897,
    989788,
    886889,
    978989,
    788779,
    877797,
    979888,
    787886,
    898787,
    888969,
    887887,
    898897,
    789788,
    789787,
    987687,
    788987,
    797987,
    898998,
    797897,
    787787,
    889886,
    896787,
    787868,
    699887,
    788868,
    677778,
    898889,
    898989,
    868689,
    797898,
    679787,
    779788,
    777888,
    989787,
    767889,
    888787,
    788787,
    778898,
    976898,
    888799,
    668687,
    977977,
    798879,
    978887,
    887977,
    976787,
    887789,
    876778,
    877897,
    687988,
    787776,
    777778,
    798887,
    777688,
    966889,
    878868,
    797788,
    888788,
    888879,
    997886,
    799778,
    787888,
    897888,
    788979,
    799878,
    878889,
    887878,
    887879,
    769777,
    778899,
    787888,
    988877,
    789778,
    897986,
    878899,
    788887,
    799977,
    977697,
    786999,
    777977,
    879877,
    987979,
    688898,
    899778,
    998787,
    967877,
    897988,
    969898,
    988986,
    679797,
    978779,
    887999,
    967968,
    787788,
    878788,
    788988,
    977898,
    977898,
    789969,
    788789,
    896787,
    776977,
    879779,
    886998,
    798868,
    768878,
    989777,
    977778,
    899788,
    689887,
    968778,
    777888,
    888968,
    888987,
    777888,
    889988,
    889779,
    888887,
    877778,
    998888,
    886877,
    799888,
    786789,
    869767,
    897888,
    999777,
    987886,
    878777,
    978887,
    978798,
    867677,
    878877,
    968887,
    798877,
    998997,
    687968,
    788998,
    798697,
    898878,
    878988,
    868897,
    889889,
    899999,
    778978,
    898779,
    786787,
    789978,
    778887,
    988887,
    778789,
    878778,
    887979,
    688978,
    997889,
    787987,
    888787,
    897787,
    797869,
    787888,
    878887,
    897888,
    898978,
    796788,
    789878,
    777888,
    778887,
    867788,
    688998,
    776768,
    977986,
    979789,
    697888,
    778878,
    778798,
    788868,
    887887,
    988888,
    789898,
    878986,
    798978,
    778998,
    877887,
    877798,
    887776,
    788888,
    787978,
    668778,
    897868,
    799887,
    888979,
    677887,
    868687,
    898987,
    877977,
    886766,
    988969,
    788987,
    879788,
    786879,
    779889,
    687898,
    797878,
    898888,
    889799,
    789788,
    899898,
    888888,
    878868,
    797798,
    788898,
    998988,
    786778,
    777787,
    768767,
    686788,
    987788,
    998689,
    889887,
    899786,
    878878,
    996767,
    886897,
    968768,
    788866,
    979886,
    797988,
    778977,
    786788,
    897787,
    788887,
    778768,
    887888,
    787779,
    978797,
    889898,
    989689,
    787778,
    777978,
    988989,
    767976,
    797688,
    788788,
    898968,
    769788,
    779887,
    887778,
    767878,
    977787,
    799887,
    878887,
    988789,
    968789,
    876797,
    787788,
    898968,
    978878,
    788878,
    986968,
    987869,
    878779,
    779889,
    778788,
    797886,
    989878,
    886878,
    977888,
    767689,
    778788,
    989988,
    796798,
    977988,
    898889,
    786997,
    977679,
    988888,
    698877,
    897887,
    886779,
    789898,
    876678,
    888867,
    877989,
    869788,
    777887,
    988887,
    887968,
    788778,
    789887,
    877877,
    777687,
    876878,
    799869,
    788789,
    987897,
    887889,
    778689,
    779988,
    899779,
    799988,
    889976,
    797768,
    979877,
    877987,
    897777,
    789998,
    876867,
    888898,
    778888,
    897877,
    989777,
    987888,
    897887,
    688899,
    777868,
    888897,
    676887,
    888778,
    888988,
    897788,
    668888,
    688787,
    787889,
    788788,
    887988,
    888686,
    778888,
    877868,
    888979,
    899987,
    798788,
    797788,
    787887,
    889787,
    697888,
    887968,
    898867,
    889778,
    987888,
    997888,
    886877,
    886878,
    798796,
    797877,
    879778,
    789888,
    678778,
    869978,
    787778,
    887878,
    977889,
    767798,
    678777,
    987798,
    779888,
    889788,
    889796,
    688779,
    878768,
    888888,
    888797,
    888797,
    889886,
    879678,
    898877,
    878789,
    889888,
    877887,
    899688,
    787798,
    777788,
    687788,
    788987,
    767688,
    878879,
    887878,
    978887,
    998677,
    697678,
    778887,
    897799,
    788989,
    877887,
    987987,
    888789,
    877898,
    978888,
    788988,
    788978,
    888787,
    898987,
    888798,
    688887,
    996678,
    988786,
    697778,
    779988,
    888978,
    779877,
    889898,
    897867,
    897897,
    997788,
    678868,
    687987,
    877788,
    797887,
    788887,
    897788,
    987788,
    988797,
    898899,
    879688,
    778678,
    876678,
    979879,
    987889,
    779879,
    789889,
    998779,
    897977,
    978987,
    888997,
    888777,
    998887,
    888987,
    999979,
    799677,
    679968,
    879988,
    778778,
    788788,
    898768,
    688889,
    778978,
    979799,
    888977,
    977966,
    998688,
    899988,
    798767,
    988688,
    877798,
    878888,
    678688,
    888877,
    798988,
    787997,
    689889,
    798778,
    778778,
    878988,
    878778,
    996879,
    896889,
    798898,
    887788,
    799989,
    898878,
    897869,
    766778,
    887777,
    788887,
    998888,
    888779,
    898877,
    887988,
    877889,
    877878,
    886789,
    789878,
    888978,
    888978,
    888888,
    777778,
    868876,
    778888,
    898788,
    788777,
    778787,
    787778,
    789886,
    787879,
    778879,
    998879,
    887888,
    687786,
    789987,
    787768,
    877879,
    778988,
    888987,
    897878,
    889778,
    678879,
    788989,
    896787,
    888777,
    787788,
    878979,
    877888,
    897787,
    778998,
    888987,
    788897,
    796989,
    797898,
    777997,
    797988,
    787689,
    987878,
    788688,
    888777,
    887878,
    886987,
    886887,
    878867,
    877878,
    887799,
    978889,
    878789,
    898978,
    897769,
    777889,
    898877,
    977967,
    888869,
    968689,
    878878,
    798998,
    788888,
    788787,
    789887,
    989877,
    779787,
    987886,
    786698,
    767898,
    779788,
    778969,
    876889,
    669879,
    988789,
    876879,
    988878,
    887786,
    889887,
    879778,
    969988,
    879998,
    788997,
    767769,
    889798,
    888898,
    788778,
    877897,
    876889,
    888788,
    778778,
    878888,
    877778,
    987787,
    879789,
    778868,
    889999,
    868888,
    778889,
    898787,
    889786,
    877888,
    877987,
    878988,
    787897,
    888887,
    888788,
    789787,
    889868,
    788889,
    877697,
    698876,
    677968,
    888879,
    698878,
    887788,
    896687,
    878779,
    988787,
    697888,
    897989,
    779766,
    777978,
    768877,
    897877,
    786788,
    798998,
    878799,
    998777,
    888879,
    678787,
    889777,
    987776,
    878887,
    788698,
    787896,
    978878,
    897778,
    888987,
    889987,
    878988,
    788787,
    798997,
    798978,
    788989,
    888769,
    779888,
    899677,
    878797,
    769797,
    987788,
    877888,
    887798,
    877777,
    777979,
    968997,
    789987,
    797877,
    798987,
    978777,
    887897,
    988799,
    888788,
    777887,
    778677,
    798878,
    767887,
    787687,
    779787,
    788966,
    778888,
    887788,
    787778,
    878777,
    778877,
    788787,
    788978,
    788686,
    998888,
    997898,
    887887,
    768688,
    887887,
    786887,
    778789,
    997888,
    889898,
    978777,
    889989,
    988888,
    787877,
    688797,
    788888,
    788977,
    768698,
    887899,
    989698,
    799789,
    997778,
    878897,
    798777,
    788697,
    798888,
    867899,
    988868,
    887898,
    888888,
    889978,
    888878,
    988778,
    779777,
    998898,
    788678,
    868987,
    689888,
    888678,
    676868,
    777888,
    987897,
    797889,
    886888,
    887889,
    899887,
    778697,
    888977,
    989879,
    777778,
    887898,
    788878,
    788887,
    877888,
    978788,
    688998,
    897879,
    887977,
    788968,
    677988,
    687897,
    878996,
    888697,
    878787,
    698868,
    887879,
    987897,
    878868,
    879787,
    968689,
    978777,
    868989,
    898898,
    886897,
    877787,
    887877,
    788989,
    788687,
    887979,
    787989,
    899889,
    786978,
    988887,
    877878,
    886888,
    698888,
    877889,
    796888,
    788979,
    878697,
    877788,
    876898,
    888896,
    878887,
    896866,
    689968,
    889887,
    889887,
    888887,
    776978,
    979777,
    788988,
    788697,
    977898,
    887888,
    878797,
    797978,
    788797,
    778778,
    768968,
    879788,
    998987,
    977889,
    778978,
    798688,
    787878,
    877878,
    678899,
    998878,
    788979,
    887998,
    899779,
    887887,
    896996,
    888788,
    887788,
    889977,
    778787,
    788888,
    998788,
    979879,
    897798,
    877779,
    888677,
    887988,
    779778,
    679787,
    879879,
    778877,
    878788,
    877799,
    698899,
    868888,
    797998,
    978887,
    799889,
    978888,
    678987,
    678787,
    968777,
    897799,
    689798,
    886789,
    878787,
    789787,
    878788,
    967768,
    888976,
    877777,
    888988,
    788686,
    898688,
    786988,
    896878,
    798788,
    779899,
    787788,
    799988,
    988779,
    788888,
    979788,
    867977,
    777878,
    898889,
    877889,
    879779,
    897777,
    898889,
    889868,
    788876,
    987887,
    886787,
    887788,
    977988,
    878776,
    888877,
    787997,
    799777,
    988877,
    998886,
    878779,
    879888,
    877797,
    798888,
    978788,
    988787,
    889877,
    786977,
    978899,
    797968,
    778899,
    879878,
    788797,
    987987,
    887769,
    987987,
    878867,
    788889,
    888998,
    888688,
    868768,
    979978,
    788879,
    889667,
    879978,
    878898,
    678897,
    888898,
    787986,
    898878,
    878977,
    798799,
    799988,
    787889,
    879898,
    886798,
    799988,
    877798,
    688988,
    798777,
    889979,
    787977,
    798888,
    778888,
    788888,
    688886,
    878787,
    788787,
    878798,
    888969,
    878897,
    767889,
    887889,
    669778,
    788777,
    778888,
    889787,
    979887,
    888778,
    778779,
    798877,
    797977,
    879868,
    677897,
    786989,
    879898,
    698788,
    888899,
    878977,
    778877,
    866878,
    888779,
    868986,
    779889,
    887888,
    778687,
    978987,
    998778,
    778988,
    687788,
    878879,
    888877,
    789668,
    986788,
    787987,
    798888,
    778987,
    969979,
    877977,
    886778,
    778889,
    777888,
    987787,
    887887,
    788888,
    988867,
    878797,
    877879,
    876879,
    988989,
    778877,
    877878,
    878778,
    987988,
    788989,
    878898,
    798767,
    789776,
    998796,
    979888,
    788868,
    988988,
    677977,
    886686,
    888978,
    978876,
    988777,
    888667,
    686878,
    687789,
    877977,
    787787,
    987777,
    777888,
    778888,
    878778,
    887978,
    988789,
    989978,
    788877,
    988878,
    777787,
    978797,
    978877,
    869899,
    777698,
    777798,
    878889,
    777788,
    888978,
    896886,
    677778,
    889779,
    999897,
    888768,
    688888,
    977898,
    878898,
    886988,
    789789,
    789979,
    777897,
    777789,
    899788,
    888989,
    887887,
    689877,
    898689,
    877877,
    896697,
    796788,
    888987,
    686686,
    778897,
    797789,
    788889,
    887789,
    999978,
    998977,
    777897,
    978886,
    797877,
    887968,
    877788,
    888999,
    777978,
    998889,
    788988,
    778998,
    787866,
    778898,
    789898,
    888987,
    788987,
    788868,
    788997,
    978898,
    889788,
    888887,
    789778,
    767876,
    978788,
    787887,
    778988,
    888788,
    878787,
    896786,
    899677,
    887798,
    878696,
    888779,
    889888,
    987778,
    887787,
    877788,
    888988,
    978898,
    879898,
    977798,
    777677,
    889888,
    787877,
    878686,
    999787,
    987999,
    887897,
    887698,
    768786,
    867797,
    898798,
    789888,
    786987,
    786889,
    978979,
    898888,
    679688,
    878987,
    798878,
    888986,
    988787,
    678877,
    779676,
    776787,
    888898,
    977897,
    899888,
    698787,
    979786,
    778789,
    767888,
    889977,
    887798,
    887889,
    887867,
    988878,
    888688,
    698789,
    778987,
    868867,
    868778,
    997878,
    898897,
    788789,
    798887,
    987867,
    778788,
    779787,
    887788,
    968777,
    778888,
    888888,
    798988,
    879777,
    887979,
    777877,
    797678,
    969888,
    779777,
    887986,
    997779,
    887997,
    967969,
    777688,
    687688,
    768688,
    889987,
    888788,
    888877,
    777989,
    887978,
    778897,
    887886,
    767869,
    698878,
    888887,
    899787,
    878879,
    889788,
    898888,
    888777,
    897888,
    778879,
    888777,
    778877,
    788788,
    998778,
    988887,
    878678,
    767879,
    887987,
    898867,
    999797,
    887977,
    778779,
    887788,
    888877,
    698777,
    879988,
    887799,
    789987,
    878898,
    778876,
    778878,
    787797,
    768996,
    786887,
    778878,
    998787,
    886978,
    888888,
    797768,
    768879,
    798999,
    899788,
    776888,
    797777,
    778887,
    988888,
    766887,
    788867,
    879988,
    977788,
    997898,
    789776,
    888787,
    978888,
    866797,
    989988,
    988978,
    867877,
    798889,
    888888,
    878987,
    889987,
    888886,
    898988,
    778887,
    978877,
    898878,
    889777,
    878988,
    898977,
    788878,
    877788,
    867779,
    787998,
    899889,
    698787,
    789787,
    798778,
    797888,
    977987,
    876778,
    968787,
    787889,
    788798,
    887878,
    877767,
    887888,
    978888,
    798978,
    888689,
    887887,
    779789,
    977769,
    787888,
    998888,
    988999,
    779787,
    789878,
    687796,
    788878,
    978879,
    787898,
    898787,
    977898,
    877897,
    778778,
    687898,
    767967,
    888878,
    797998,
    879978,
    898977,
    778888,
    778888,
    887667,
    976977,
    788889,
    798977,
    779888,
    777777,
    798767,
    778876,
    887878,
    988887,
    688877,
    988798,
    987797,
    897889,
    978868,
    889998,
    798887,
    897878,
    896888,
    887867,
    877899,
    889887,
    778779,
    888778,
    878877,
    898998,
    788776,
    879778,
    897788,
    999887,
    898877,
    787878,
    788889,
    877788,
    888798,
    968888,
    788798,
    897897,
    678788,
    887988,
    878878,
    988677,
    889978,
    888897,
    879889,
    897789,
    697877,
    977889,
    889687,
    699878,
    878879,
    877977,
    868779,
    968798,
    688898,
    988898,
    786997,
    787697,
    898888,
    787898,
    896889,
    889678,
    987887,
    888878,
    989779,
    788979,
    989878,
    788897,
    868778,
    888777,
    798989,
    786888,
    777787,
    888778,
    777898,
    768879,
    888878,
    889867,
    988888,
    879878,
    878897,
    878989,
    779889,
    798789,
    787788,
    877998,
    786888,
    788876,
    788876,
    776788,
    886899,
    877969,
    689787,
    977987,
    898987,
    886797,
    878787,
    899766,
    876786,
    877898,
    889788,
    898887,
    867788,
    887978,
    879889,
    877787,
    889887,
    787986,
    988778,
    898788,
    777998,
    778897,
    779887,
    798798,
    688867,
    978778,
    888967,
    979789,
    769787,
    869679,
    877777,
    988798,
    669788,
    877778,
    788987,
    977797,
    878677,
    988877,
    877889,
    888888,
    777888,
    777867,
    888877,
    979778,
    878888,
    888878,
    879798,
    877878,
    877968,
    878877,
    878799,
    768778,
    898769,
    798886,
    798869,
    876978,
    777878,
    787979,
    888778,
    778868,
    878777,
    687988,
    877897,
    798787,
    889879,
    898899,
    977898,
    778797,
    698998,
    887677,
    788787,
    797878,
    788877,
    787768,
    779797,
    879988,
    798867,
    776897,
    867799,
    779878,
    787797,
    888876,
    988897,
    789886,
    776787,
    788879,
    667766,
    888877,
    879889,
    867897,
    866879,
    879879,
    687887,
    899789,
    888978,
    887978,
    989678,
    689899,
    887697,
    777678,
    776878,
    788878,
    887887,
    778798,
    878898,
    779879,
    788787,
    768898,
    788997,
    988878,
    898877,
    876888,
    989789,
    787777,
    989777,
    789798,
    887978,
    797887,
    788788,
    879887,
    887779,
    878887,
    876777,
    786878,
    787879,
    988687,
    876788,
    787889,
    898799,
    777887,
    878866,
    789888,
    777889,
    977897,
    789887,
    788797,
    788679,
    779789,
    898888,
    888788,
    978977,
    679988,
    778788,
    887967,
    898888,
    797787,
    798889,
    978998,
    867877,
    888987,
    897767,
    887878,
    787777,
    997877,
    887897,
    878777,
    988979,
    888889,
    787878,
    888887,
    898879,
    886789,
    778797,
    969697,
    898797,
    777878,
    778977,
    888787,
    788889,
    796798,
    967797,
    688888,
    787979,
    878788,
    889887,
    786999,
    776798,
    879968,
    789879,
    789967,
    887779,
    787878,
    989896,
    777767,
    887988,
    698887,
    898888,
    877896,
    978787,
    797877,
    878787,
    898878,
    889977,
    976778,
    999699,
    978979,
    878877,
    788797,
    889789,
    878778,
    887688,
    988889,
    978878,
    889768,
    789788,
    778898,
    777877,
    778879,
    799668,
    888888,
    888778,
    877898,
    768868,
    986899,
    989997,
    779876,
    998897,
    887888,
    787887,
    889979,
    888788,
    989788,
    878988,
    888888,
    899786,
    896878,
    879898,
    878887,
    879978,
    887879,
    787877,
    888678,
    978978,
    869698,
    878877,
    999898,
    878989,
    897888,
    888876,
    797697,
    877788,
    787877,
    878878,
    789777,
    878878,
    899879,
    897889,
    798787,
    877698,
    778877,
    779878,
    799789,
    987977,
    787968,
    676888,
    897889,
    789788,
    788766,
    688977,
    867677,
    887976,
    877778,
    879888,
    867778,
    787766,
    786988,
    889797,
    898678,
    779767,
    787898,
    888779,
    878777,
    978889,
    788687,
    978778,
    879888,
    796779,
    888896,
    868788,
    868999,
    878979,
    697888,
    988998,
    778977,
    777778,
    878898,
    979778,
    879778,
    897786,
    678978,
    688886,
    797877,
    899788,
    879987,
    769877,
    898988,
    887976,
    997877,
    798777,
    778877,
    898978,
    887769,
    979778,
    888777,
    986787,
    888897,
    977799,
    878888,
    988778,
    889787,
    888978,
    879788,
    888889,
    898898,
    766888,
    979898,
    989778,
    768697,
    778887,
    787787,
    879888,
    777787,
    878986,
    788878,
    889879,
    898878,
    687896,
    878787,
    899888,
    798788,
    777988,
    976797,
    877786,
    866798,
    787788,
    768786,
    897877,
    797898,
    879998,
    797697,
    686788,
    986789,
    878997,
    986988,
    878777,
    687878,
    788997,
    979788,
    878978,
    898898,
    998778,
    777769,
    787779,
    887877,
    977888,
    879787,
    998888,
    978898,
    776977,
    887877,
    778698,
    888889,
    977888,
    787797,
    887888,
    888788,
    689889,
    797978,
    888879,
    789989,
    888788,
    968888,
    988798,
    796878,
    989787,
    897988,
    789798,
    776988,
    888676,
    878898,
    798988,
    897888,
    969987,
    986889,
    978877,
    887898,
    799879,
    796888,
    777788,
    778797,
    768767,
    879777,
    878689,
    897977,
    788888,
    778889,
    897777,
    878898,
    889996,
    789786,
    979687,
    697879,
    779888,
    978779,
    688967,
    896988,
    889989,
    877777,
    788688,
    987877,
    799788,
    779787,
    887977,
    888988,
    888879,
    798986,
    878889,
    978788,
    988968,
    778878,
    796787,
    798898,
    788868,
    989887,
    977889,
    788789,
    788888,
    978888,
    868997,
    876886,
    788877,
    986896,
    788887,
    887868,
    988889,
    877778,
    987997,
    788888,
    888697,
    887978,
    999868,
    887799,
    997868,
    786977,
    878788,
    867778,
    787879,
    788888,
    888887,
    879878,
    687877,
    798969,
    788779,
    787877,
    987889,
    877989,
    777877,
    799788,
    979988,
    768687,
    888767,
    668878,
    898768,
    878767,
    878989,
    868798,
    878778,
    997878,
    888797,
    797887,
    788888,
    867878,
    866788,
    886778,
    887899,
    888899,
    889989,
    786788,
    998798,
    799888,
    876778,
    778877,
    988768,
    979898,
    877877,
    878987,
    878888,
    889787,
    788888,
    876887,
    989996,
    776887,
    897877,
    978897,
    788878,
    888788,
    788779,
    987888,
    888877,
    888777,
    987887,
    978889,
    876789,
    887987,
    798879,
    897796,
    979777,
    777888,
    888977,
    878887,
    877989,
    769887,
    886787,
    878897,
    887889,
    899788,
    886788,
    688878,
    676878,
    778889,
    788879,
    769899,
    867887,
    967997,
    887868,
    889897,
    776789,
    789867,
    867797,
    988887,
    678778,
    789877,
    998889,
    988889,
    987778,
    887776,
    887787,
    789877,
    889868,
    879789,
    977897,
    898768,
    879799,
    688888,
    898777,
    887889,
    898887,
    787886,
    986698,
    697789,
    777878,
    898988,
    867777,
    887878,
    798897,
    669978,
    788778,
    887998,
    799799,
    889777,
    888677,
    878888,
    889889,
    879979,
    777898,
    678877,
    788778,
    988868,
    868877,
    878798,
    898888,
    778897,
    978968,
    986877,
    897877,
    787879,
    669887,
    896887,
    989988,
    888889,
    978988,
    877887,
    888787,
    798688,
    779788,
    787887,
    878887,
    788687,
    787887,
    878777,
    788798,
    688879,
    668889,
    788778,
    988978,
    878788,
    777787,
    767677,
    896888,
    788887,
    887879,
    788887,
    798889,
    787877,
    777789,
    687778,
    889798,
    777898,
    978768,
    777698,
    989898,
    988878,
    977877,
    787798,
    687889,
    898788,
    789897,
    897787,
    887897,
    898887,
    897886,
    867878,
    887787,
    979878,
    687897,
    878789,
    799799,
    799867,
    788886,
    779778,
    787788,
    867896,
    788877,
    778778,
    878987,
    877788,
    897798,
    779987,
    887678,
    888898,
    887878,
    998788,
    798978,
    989787,
    889786,
    877888,
    887978,
    888798,
    777899,
    779797,
    778877,
    988878,
    778779,
    878778,
    878999,
    967889,
    878688,
    878988,
    777779,
    787878,
    868988,
    669778,
    868978,
    797787,
    787967,
    779797,
    798987,
    788889,
    988768,
    868888,
    878888,
    778797,
    878878,
    887777,
    688868,
    898786,
    899797,
    899778,
    987777,
    786697,
    797897,
    898889,
    778878,
    987777,
    779887,
    898767,
    889788,
    898778,
    879789,
    877698,
    797879,
    778887,
    978787,
    978867,
    779878,
    977887,
    889888,
    889787,
    979787,
    888788,
    787789,
    876788,
    768878,
    799998,
    786877,
    898886,
    887789,
    689797,
    878969,
    778787,
    987997,
    887888,
    867987,
    888877,
    967888,
    989898,
    788777,
    677869,
    987796,
    887788,
    997796,
    767768,
    997778,
    878887,
    879878,
    787879,
    788889,
    789877,
    987777,
    889779,
    888878,
    888776,
    887968,
    678888,
    787899,
    898788,
    786988,
    877668,
    777878,
    688779,
    789788,
    878889,
    779877,
    888878,
    787789,
    988988,
    889789,
    897787,
    868776,
    789986,
    867877,
    888888,
    887688,
    887668,
    998887,
    788688,
    888788,
    789787,
    778887,
    688798,
    889988,
    878868,
    767799,
    787797,
    888877,
    898897,
    888787,
    767898,
    776768,
    897789,
    977977,
    787987,
    886997,
    886988,
    799777,
    798977,
    868789,
    887887,
    877778,
    887797,
    879888,
    877878,
    777878,
    888787,
    787888,
    877798,
    787887,
    888878,
    797887,
    987898,
    988778,
    797688,
    879999,
    866786,
    678986,
    886987,
    978997,
    777879,
    787887,
    687887,
    888899,
    798988,
    887799,
    878888,
    877997,
    787997,
    868978,
    777789,
    886878,
    988798,
    878786,
    987888,
    798877,
    879888,
    977888,
    877786,
    786967,
    978998,
    878777,
    897897,
    987877,
    888787,
    968888,
    876978,
    677876,
    896877,
    789797,
    879979,
    678787,
    976887,
    878877,
    888889,
    777877,
    788867,
    898886,
    889797,
    768787,
    778988,
    778986,
    867699,
    877776,
    779877,
    899888,
    798978,
    678897,
    867888,
    788878,
    777888,
    978798,
    796887,
    767788,
    879887,
    878899,
    789888,
    878988,
    779899,
    789777,
    897788,
    868688,
    878789,
    897777,
    888898,
    899968,
    797788,
    877878,
    787798,
    979887,
    988988,
    787896,
    787987,
    879788,
    787889,
    878999,
    787788,
    978978,
    888979,
    879877,
    889788,
    886789,
    788888,
    868998,
    768898,
    777777,
    777887,
    899797,
    778768,
    779878,
    967678,
    987798,
    776989,
    877987,
    797779,
    868897,
    977987,
    888698,
    788876,
    777889,
    889977,
    877688,
    767787,
    699898,
    789978,
    878899,
    988878,
    988868,
    887878,
    898897,
    978878,
    987788,
    679788,
    878878,
    878869,
    688899,
    979878,
    868898,
    688897,
    788898,
    999778,
    787799,
    788788,
    889888,
    798997,
    978878,
    899698,
    787988,
    888867,
    789677,
    898869,
    789797,
    889887,
    888787,
    777878,
    888897,
    768689,
    787787,
    988778,
    978869,
    798869,
    878797,
    788877,
    688887,
    997788,
    789689,
    868778,
    869978,
    897887,
    778787,
    897788,
    778787,
    787687,
    868868,
    889778,
    778888,
    788888,
    799898,
    887789,
    888977,
    688888,
    776787,
    777798,
    798787,
    986679,
    988887,
    877869,
    877768,
    778888,
    889887,
    887988,
    788899,
    779898,
    886889,
    977999,
    888877,
    798799,
    878876,
    788777,
    789868,
    897999,
    897788,
    887877,
    696798,
    688986,
    898798,
    778897,
    788889,
    979898,
    778898,
    898888,
    877778,
    867876,
    788788,
    788867,
    788698,
    878787,
    789877,
    878798,
    897977,
    889877,
    998876,
    777978,
    687878,
    988997,
    877876,
    789977,
    888787,
    778688,
    888787,
    788897,
    989789,
    887878,
    897897,
    986788,
    797879,
    889887,
    978689,
    687899,
    888998,
    777798,
    878787,
    987878,
    978788,
    987989,
    987678,
    787987,
    889898,
    997788,
    778889,
    677897,
    887897,
    899898,
    897768,
    889888,
    876887,
    889799,
    777688,
    886788,
    877877,
    887797,
    778877,
    678887,
    776777,
    978888,
    888997,
    797988,
    979797,
    878788,
    886989,
    978887,
    886968,
    768779,
    888778,
    687878,
    797878,
    988677,
    888798,
    788879,
    687898,
    778899,
    878877,
    867678,
    877998,
    797787,
    787887,
    787867,
    978878,
    878869,
    888878,
    978878,
    696887,
    768878,
    989988,
    678887,
    678976,
    798787,
    877688,
    799778,
    878787,
    886997,
    977787,
    899978,
    877898,
    878988,
    797898,
    788778,
    689779,
    888787,
    787879,
    898877,
    897987,
    798897,
    889777,
    888889,
    788879,
    788886,
    987888,
    898889,
    988899,
    788797,
    889778,
    998889,
    989998,
    878867,
    888779,
    888689,
    978978,
    777888,
    767779,
    868887,
    668877,
    878888,
    886888,
    798898,
    777999,
    888898,
    967897,
    788878,
    686776,
    878767,
    887867,
    898899,
    897966,
    888777,
    877877,
    878788,
    888888,
    789788,
    888988,
    889887,
    877788,
    766798,
    888786,
    888779,
    798789,
    687977,
    886889,
    898798,
    798878,
    876678,
    888987,
    988889,
    887787,
    898788,
    886977,
    878769,
    797978,
    787978,
    888878,
    898778,
    989979,
    777688,
    789698,
    988869,
    769798,
    896798,
    978777,
    897999,
    877887,
    687989,
    888978,
    689777,
    977689,
    878989,
    779897,
    687878,
    778888,
    678788,
    677677,
    886777,
    888789,
    777777,
    898869,
    678988,
    878878,
    878868,
    888887,
    987697,
    797887,
    987787,
    778979,
    987788,
    867787,
    789779,
    877789,
    788878,
    898788,
    989979,
    987888,
    998788,
    787877,
    889977,
    787889,
    799788,
    877797,
    977888,
    778777,
    789779,
    878787,
    888689,
    888779,
    877799,
    799697,
    987766,
    887797,
    878797,
    977878,
    888879,
    688987,
    698677,
    877978,
    987778,
    799997,
    986788,
    876888,
    986699,
    878778,
    979878,
    868877,
    868888,
    986868,
    779997,
    767689,
    878898,
    787878,
    887778,
    779878,
    687879,
    887877,
    989898,
    979779,
    777978,
    888798,
    888787,
    898779,
    788887,
    797788,
    899877,
    769897,
    868797,
    988667,
    986986,
    689779,
    777877,
    886878,
    879868,
    988776,
    887988,
    977778,
    789788,
    789988,
    897788,
    997777,
    788887,
    887887,
    899987,
    888698,
    976777,
    788798,
    777768,
    789779,
    888888,
    886888,
    998888,
    978789,
    889987,
    878886,
    879887,
    678878,
    777887,
    789979,
    896688,
    689879,
    698697,
    887988,
    777898,
    768787,
    879998,
    789799,
    888897,
    786976,
    797986,
    889888,
    797978,
    788978,
    879888,
    788786,
    888777,
    688888,
    788678,
    789688,
    787776,
    879787,
    787887,
    789977,
    878879,
    997888,
    699679,
    786876,
    879778,
    998878,
    698779,
    878887,
    887889,
    887879,
    977878,
    888878,
    878797,
    998878,
    777988,
    787988,
    886878,
    978878,
    879887,
    878797,
    788789,
    797979,
    978978,
    997777,
    679888,
    888797,
    889886,
    788889,
    689998,
    786988,
    897779,
    797878,
    688769,
    767889,
    779888,
    888988,
    877889,
    889879,
    777987,
    977979,
    998888,
    877899,
    788788,
    977797,
    889888,
    777877,
    676878,
    798877,
    778677,
    688877,
    788987,
    778879,
    786789,
    888888,
    888788,
    678888,
    688887,
    877788,
    997898,
    797887,
    889798,
    879867,
    788877,
    888866,
    778878,
    898987,
    888897,
    898887,
    766988,
    879977,
    887887,
    889887,
    988887,
    798699,
    978796,
    897889,
    797879,
    778798,
    888799,
    899777,
    777889,
    888798,
    789879,
    897978,
    887977,
    899869,
    776789,
    798988,
    887788,
    778777,
    788788,
    777997,
    876788,
    877987,
    888777,
    988889,
    878889,
    787879,
    788787,
    897877,
    979889,
    888787,
    867879,
    898876,
    888776,
    797888,
    988878,
    779776,
    988888,
    878989,
    877877,
    868777,
    879897,
    798788,
    778978,
    866689,
    777698,
    877889,
    878789,
    999887,
    888778,
    798898,
    778788,
    888767,
    977879,
    878889,
    888787,
    787879,
    789968,
    988887,
    878887,
    878879,
    779877,
    777787,
    899878,
    987887,
    987899,
    887888,
    697878,
    877887,
    876768,
    776888,
    987778,
    879787,
    888867,
    887989,
    999797,
    898887,
    799888,
    777888,
    788877,
    899888,
    889787,
    798877,
    787778,
    877977,
    988778,
    997787,
    988888,
    778788,
    788888,
    698789,
    979886,
    896899,
    888687,
    888797,
    989778,
    879879,
    976979,
    777787,
    989778,
    898878,
    868978,
    877676,
    997968,
    798787,
    988778,
    878886,
    867879,
    987687,
    776788,
    777778,
    789889,
    878889,
    879798,
    997778,
    779997,
    898797,
    877888,
    977898,
    998779,
    888789,
    878889,
    878889,
    687989,
    978879,
    778788,
    888889,
    887689,
    788776,
    979987,
    879778,
    787767,
    988887,
    798697,
    777798,
    896878,
    977877,
    998798,
    687888,
    898778,
    988799,
    887788,
    798797,
    878786,
    877887,
    788878,
    797887,
    687796,
    888799,
    788879,
    897897,
    888988,
    788789,
    798898,
    998878,
    778688,
    689887,
    778689,
    978878,
    789778,
    797977,
    788787,
    888779,
    878879,
    877778,
    887898,
    797878,
    887878,
    799996,
    978788,
    899877,
    787889,
    787787,
    988789,
    789786,
    977989,
    886888,
    997887,
    977887,
    986878,
    889877,
    688796,
    787787,
    887787,
    788789,
    778778,
    998796,
    789879,
    777987,
    888987,
    877778,
    779778,
    978889,
    888778,
    778999,
    868897,
    687789,
    888688,
    978899,
    797778,
    888876,
    888867,
    897789,
    898799,
    969997,
    987869,
    679897,
    777897,
    888887,
    788798,
    788888,
    797888,
    768887,
    799778,
    877879,
    677787,
    888778,
    787778,
    777777,
    877889,
    987777,
    776788,
    777787,
    877879,
    886989,
    688787,
    888888,
    977778,
    898788,
    866888,
    878868,
    977897,
    777687,
    889688,
    988977,
    777788,
    888789,
    798879,
    888699,
    987778,
    889878,
    989878,
    887888,
    779878,
    998877,
    778979,
    678777,
    787779,
    887888,
    897898,
    797898,
    677787,
    888777,
    787878,
    887888,
    896997,
    878786,
    777888,
    878788,
    967787,
    989798,
    887868,
    978877,
    787797,
    787779,
    798778,
    979988,
    789979,
    698987,
    789789,
    789898,
    997867,
    878887,
    877677,
    898798,
    976876,
    977897,
    767978,
    879688,
    888876,
    887888,
    987878,
    786787,
    888776,
    789876,
    877777,
    869787,
    878877,
    797867,
    777678,
    686888,
    788789,
    788968,
    777887,
    788878,
    787898,
    889889,
    788988,
    788777,
    976898,
    788989,
    899699,
    878986,
    997877,
    878768,
    788777,
    677987,
    779786,
    798889,
    887978,
    888797,
    788698,
    688989,
    887889,
    787787,
    887877,
    798988,
    888688,
    688768,
    889789,
    889788,
    767787,
    898788,
    887978,
    889788,
    879888,
    878877,
    977886,
    889889,
    776786,
    986878,
    987778,
    778878,
    997777,
    676789,
    987687,
    779788,
    787877,
    987898,
    988788,
    898889,
    898799,
    988969,
    986989,
    778889,
    797767,
    899779,
    978878,
    778886,
    888987,
    777878,
    887869,
    867877,
    898888,
    878889,
    888999,
    889898,
    888878,
    987879,
    778688,
    789887,
    789877,
    888778,
    877879,
    998887,
    898888,
    788878,
    877898,
    887879,
    867888,
    789897,
    978898,
    889687,
    987978,
    798978,
    787867,
    978879,
    778888,
    888868,
    987787,
    889887,
    969878,
    699879,
    789878,
    877997,
    898877,
    798776,
    678897,
    878897,
    887798,
    976889,
    779987,
    878967,
    889888,
    787877,
    888788,
    887899,
    898878,
    968898,
    878878,
    877799,
    977886,
    687879,
    977787,
    877886,
    879867,
    767778,
    896788,
    879878,
    887898,
    988899,
    879878,
    977987,
    799977,
    889798,
    768887,
    878797,
    797788,
    888887,
    766778,
    867979,
    797788,
    976787,
    878889,
    998897,
    889877,
    988797,
    778668,
    797989,
    887887,
    767978,
    877997,
    988977,
    769988,
    878997,
    878688,
    898888,
    967887,
    796886,
    868868,
    796989,
    888778,
    786789,
    868778,
    798977,
    897888,
    778889,
    897776,
    889878,
    887987,
    777777,
    897788,
    888787,
    787888,
    797987,
    898887,
    878798,
    779688,
    789667,
    688797,
    899889,
    988786,
    688788,
    879788,
    689976,
    888776,
    688877,
    888797,
    998769,
    797788,
    977777,
    888888,
    778788,
    978887,
    878878,
    889796,
    898767,
    979866,
    789799,
    879878,
    876999,
    677798,
    889879,
    898878,
    968878,
    877977,
    887876,
    887977,
    789987,
    779999,
    779988,
    778798,
    899898,
    999878,
    877787,
    989789,
    799777,
    789887,
    788979,
    989899,
    688799,
    798987,
    987888,
    867988,
    777767,
    897888,
    966887,
    887777,
    798898,
    768777,
    778868,
    899977,
    788867,
    877887,
    899779,
    787988,
    887888,
    797868,
    788888,
    788889,
    886699,
    887899,
    779978,
    698889,
    778878,
    888898,
    686877,
    888888,
    689787,
    868788,
    877788,
    979778,
    888799,
    769977,
    878788,
    878898,
    887788,
    988867,
    897888,
    789878,
    788878,
    788899,
    989867,
    889778,
    879988,
    878679,
    688687,
    879667,
    799887,
    788888,
    988998,
    878978,
    878978,
    778878,
    779698,
    898777,
    887877,
    887787,
    987986,
    689888,
    887778,
    788678,
    889969,
    699897,
    897677,
    789788,
    799887,
    888888,
    879897,
    897778,
    778677,
    697878,
    897896,
    698698,
    768988,
    887788,
    788896,
    989987,
    777889,
    799877,
    778989,
    987878,
    787777,
    897887,
    979697,
    799888,
    778886,
    977798,
    766678,
    767788,
    866988,
    777987,
    878877,
    897978,
    787877,
    788787,
    778887,
    788986,
    796788,
    979899,
    988968,
    777887,
    889868,
    897997,
    678888,
    877989,
    779778,
    799777,
    778788,
    897797,
    898686,
    888898,
    787877,
    896899,
    897789,
    787878,
    776788,
    878878,
    868877,
    898688,
    898979,
    698887,
    888889,
    877987,
    978786,
    976789,
    898688,
    887786,
    778987,
    988998,
    897887,
    899687,
    879798,
    887789,
    887689,
    868978,
    887978,
    877878,
    877677,
    887667,
    777777,
    779787,
    778777,
    789787,
    886988,
    779789,
    898889,
    877988,
    788767,
    789879,
    768768,
    898899,
    869667,
    987688,
    897776,
    788988,
    779978,
    878887,
    777899,
    878899,
    898888,
    988877,
    897997,
    778869,
    687888,
    787878,
    898776,
    897777,
    798777,
    877979,
    889778,
    987888,
    987698,
    789888,
    877777,
    878997,
    879877,
    877789,
    878977,
    769887,
    897799,
    877777,
    779898,
    898899,
    677868,
    888688,
    887798,
    887788,
    887677,
    788788,
    877888,
    788867,
    998797,
    889888,
    888778,
    777787,
    687779,
    897787,
    787767,
    787978,
    878779,
    778797,
    688988,
    898876,
    978988,
    988868,
    887888,
    879989,
    788878,
    997768,
    987888,
    877778,
    987889,
    877788,
    767977,
    778799,
    698877,
    887788,
    778786,
    779879,
    978797,
    778888,
    988887,
    898667,
    789897,
    877877,
    878888,
    979898,
    778778,
    897878,
    888898,
    878687,
    879797,
    889679,
    888878,
    877688,
    997878,
    779777,
    788888,
    889798,
    888878,
    789897,
    788798,
    689669,
    987787,
    788778,
    977789,
    678999,
    988888,
    989887,
    877887,
    788879,
    997687,
    788788,
    887887,
    978768,
    779778,
    868787,
    878799,
    967889,
    778997,
    898988,
    788679,
    998798,
    879888,
    767877,
    878889,
    897879,
    888988,
    897887,
    997687,
    879788,
    888878,
    879988,
    878977,
    777888,
    778677,
    787887,
    698989,
    888878,
    887868,
    888898,
    888696,
    778888,
    877777,
    677877,
    797878,
    998899,
    687787,
    787988,
    876878,
    677878,
    877886,
    787768,
    777778,
    888767,
    788888,
    786877,
    888978,
    989888,
    687888,
    798779,
    677777,
    879776,
    678889,
    989978,
    878888,
    777878,
    897877,
    999978,
    888887,
    886877,
    889688,
    967779,
    888996,
    887787,
    888787,
    788879,
    997687,
    899887,
    978787,
    878988,
    879798,
    667687,
    798778,
    778878,
    788778,
    986788,
    887879,
    988989,
    776888,
    989888,
    867976,
    788978,
    987877,
    968799,
    777977,
    886677,
    976778,
    788789,
    789868,
    889867,
    968777,
    788878,
    796777,
    989878,
    787887,
    887787,
    879977,
    788866,
    878777,
    868876,
    877888,
    888878,
    778868,
    987968,
    989888,
    889796,
    687988,
    767899,
    888888,
    889678,
    977788,
    788978,
    788998,
    889988,
    999788,
    878879,
    898769,
    679798,
    787877,
    896968,
    777988,
    797779,
    978979,
    788796,
    787988,
    988889,
    777979,
    799689,
    878889,
    968877,
    988788,
    799889,
    789878,
    898787,
    997987,
    867867,
    888797,
    898787,
    788878,
    688899,
    687878,
    789797,
    789998,
    769988,
    778778,
    898789,
    988776,
    867777,
    786768,
    777877,
    777878,
    888988,
    879989,
    798789,
    976779,
    897777,
    786788,
    798687,
    787797,
    889978,
    967789,
    889979,
    787899,
    977878,
    788778,
    878899,
    987898,
    888779,
    777979,
    778787,
    878777,
    887887,
    876888,
    977898,
    887986,
    897979,
    768878,
    988978,
    787787,
    788999,
    687778,
    978887,
    697779,
    898788,
    978796,
    997787,
    768888,
    898877,
    878888,
    687877,
    798868,
    776777,
    869888,
    887897,
    779888,
    798987,
    997887,
    778778,
    987877,
    988879,
    697877,
    987897,
    876799,
    797878,
    878898,
    877886,
    787988,
    879688,
    898788,
    886879,
    878878,
    877687,
    877998,
    888998,
    878998,
    969866,
    797898,
    767978,
    887787,
    898997,
    988978,
    888997,
    889798,
    687878,
    977788,
    978889,
    999998,
    778788,
    787789,
    889878,
    666768,
    898888,
    997888,
    778899,
    888678,
    988978,
    787788,
    888979,
    867888,
    898888,
    777897,
    887887,
    878768,
    888798,
    989877,
    877877,
    888788,
    778888,
    878888,
    978867,
    897798,
    689998,
    888989,
    898766,
    888977,
    887788,
    989878,
    787976,
    877797,
    888869,
    777788,
    979898,
    788767,
    897877,
    777878,
    778979,
    998988,
    887879,
    688676,
    788887,
    678878,
    967678,
    997898,
    998888,
    988787,
    878877,
    788688,
    888878,
    978777,
    879879,
    987978,
    799878,
    789768,
    788898,
    887787,
    889977,
    876877,
    776988,
    898787,
    888868,
    767868,
    887677,
    887697,
    799888,
    897887,
    898879,
    978788,
    788788,
    879978,
    887878,
    778876,
    799878,
    879999,
    998778,
    799886,
    878688,
    887989,
    779787,
    877978,
    887779,
    988897,
    787988,
    778867,
    788978,
    889897,
    978679,
    777788,
    687698,
    786887,
    696777,
    779787,
    888888,
    787888,
    878877,
    889887,
    789888,
    977887,
    789777,
    777778,
    778898,
    768678,
    887978,
    677776,
    878788,
    889779,
    876968,
    788787,
    787898,
    698877,
    878869,
    787877,
    788789,
    987888,
    887999,
    988977,
    978678,
    988879,
    776788,
    888698,
    688878,
    868869,
    877998,
    889898,
    897879,
    798887,
    887687,
    887979,
    888897,
    987877,
    887868,
    878777,
    977877,
    878878,
    877887,
    788897,
    887777,
    898886,
    979987,
    779867,
    787677,
    887788,
    767877,
    886888,
    989978,
    788778,
    989979,
    778878,
    987787,
    778879,
    887789,
    777987,
    977877,
    796789,
    777778,
    887788,
    967888,
    887887,
    779888,
    797989,
    999898,
    789678,
    797979,
    897797,
    786887,
    978898,
    776778,
    988767,
    899788,
    767987,
    877887,
    888798,
    787999,
    678887,
    787777,
    787779,
    787987,
    878778,
    887897,
    867787,
    989989,
    989788,
    889876,
    688788,
    989788,
    797987,
    888877,
    789978,
    787778,
    797799,
    787886,
    787979,
    878788,
    788878,
    798678,
    897787,
    668889,
    889786,
    897786,
    877698,
    888788,
    887877,
    688979,
    988887,
    987889,
    898888,
    788989,
    677978,
    797876,
    679787,
    788788,
    887878,
    778779,
    879698,
    877899,
    878888,
    987877,
    798798,
    998778,
    877989,
    887978,
    888989,
    898797,
    899887,
    897877,
    897789,
    987989,
    877878,
    869878,
    786789,
    777987,
    787788,
    978897,
    887788,
    987986,
    777788,
    978889,
    888767,
    977897,
    877988,
    788679,
    887897,
    899887,
    968878,
    878879,
    778898,
    987987,
    879878,
    787699,
    989877,
    878888,
    977888,
    798798,
    967897,
    776679,
    889798,
    699777,
    789899,
    766997,
    678888,
    987687,
    778888,
    978879,
    788787,
    767779,
    877888,
    977769,
    878878,
    876689,
    779968,
    877687,
    796877,
    988886,
    776878,
    788878,
    888687,
    978777,
    787899,
    698877,
    887888,
    987797,
    798988,
    777887,
    878897,
    888986,
    687979,
    988877,
    978688,
    888978,
    789777,
    697977,
    688778,
    999777,
    878967,
    778688,
    678766,
    898797,
    889877,
    789679,
    979888,
    997887,
    789777,
    887776,
    897778,
    787879,
    979878,
    989697,
    978866,
    996988,
    888788,
    888896,
    787969,
    888988,
    878886,
    887798,
    687999,
    988998,
    967787,
    978789,
    877887,
    698769,
    789787,
    777888,
    979879,
    977888,
    888979,
    788888,
    699787,
    778887,
    787797,
    787977,
    989889,
    778788,
    787877,
    787889,
    788978,
    797879,
    868878,
    778789,
    988888,
    866968,
    899767,
    778798,
    878966,
    889767,
    789789,
    796787,
    877699,
    997978,
    876888,
    777788,
    787798,
    688988,
    778788,
    789888,
    986687,
    787987,
    896878,
    887898,
    878678,
    686888,
    788789,
    888689,
    988787,
    897777,
    798777,
    778698,
    798877,
    888877,
    797787,
    878789,
    988888,
    979688,
    878997,
    867879,
    787878,
    686899,
    796997,
    879877,
    797886,
    878879,
    778899,
    888978,
    869879,
    968978,
    877879,
    977896,
    777877,
    878788,
    988777,
    987879,
    788887,
    966688,
    977879,
    986787,
    878677,
    978688,
    888788,
    977688,
    796878,
    867767,
    887887,
    988777,
    898877,
    888787,
    779986,
    688789,
    897878,
    898878,
    789796,
    669989,
    888798,
    988889,
    786696,
    897876,
    887877,
    979887,
    788888,
    898798,
    898789,
    797887,
    778998,
    988687,
    776988,
    879778,
    898978,
    868987,
    897999,
    888789,
    986778,
    777988,
    988768,
    976987,
    879698,
    778789,
    797788,
    788889,
    889898,
    698887,
    877777,
    878887,
    788867,
    898797,
    897988,
    977967,
    777778,
    777888,
    997967,
    878777,
    979698,
    788767,
    677888,
    887897,
    878897,
    879978,
    786897,
    788987,
    886987,
    688988,
    688788,
    786877,
    977868,
    897887,
    877887,
    888878,
    688987,
    687888,
    878888,
    878777,
    877778,
    997987,
    877788,
    878988,
    787886,
    876988,
    688689,
    888988,
    799777,
    978988,
    798978,
    997999,
    777787,
    778779,
    899898,
    888688,
    669898,
    888887,
    769788,
    888888,
    798787,
    676887,
    889966,
    869877,
    889778,
    888998,
    798889,
    878999,
    688789,
    879987,
    777988,
    876798,
    887789,
    787777,
    988998,
    978788,
    978886,
    799877,
    887788,
    876897,
    898799,
    899887,
    789887,
    899889,
    887878,
    878899,
    788897,
    888777,
    888888,
    879768,
    787888,
    778999,
    868789,
    977879,
    887887,
    687879,
    978877,
    897878,
    798679,
    798978,
    879887,
    988888,
    986788,
    776888,
    799878,
    879996,
    887787,
    788788,
    877789,
    789899,
    878998,
    887688,
    878789,
    788887,
    788898,
    686877,
    767876,
    888978,
    797898,
    967878,
    787887,
    888777,
    988678,
    897786,
    989698,
    787988,
    878897,
    898997,
    779878,
    869778,
    789898,
    879877,
    976777,
    889888,
    787788,
    889889,
    878978,
    878978,
    777777,
    878987,
    978978,
    888778,
    998798,
    676877,
    868889,
    887988,
    878967,
    787978,
    898886,
    787979,
    788878,
    887977,
    988778,
    788886,
    786787,
    899767,
    777977,
    788897,
    888677,
    787897,
    789798,
    889897,
    697778,
    999889,
    777868,
    798789,
    877886,
    887989,
    987786,
    988877,
    888888,
    989878,
    787996,
    997888,
    789788,
    788687,
    886788,
    897877,
    768688,
    889987,
    978888,
    769879,
    869888,
    797996,
    878777,
    788887,
    987887,
    886887,
    877878,
    787888,
    987887,
    787979,
    987897,
    988987,
    788788,
    788887,
    898897,
    888989,
    878698,
    898797,
    879788,
    987788,
    788876,
    977779,
    997978,
    776898,
    697677,
    777798,
    697898,
    897787,
    887799,
    698879,
    776877,
    787898,
    789779,
    777887,
    977878,
    788877,
    788787,
    888777,
    677787,
    787897,
    878978,
    887987,
    987778,
    979898,
    876976,
    787878,
    986879,
    978787,
    898998,
    977789,
    869887,
    798789,
    769668,
    778876,
    797788,
    877998,
    878777,
    787788,
    789787,
    876899,
    889987,
    867877,
    778798,
    998977,
    878877,
    986789,
    688879,
    768888,
    788878,
    776898,
    897788,
    888888,
    796989,
    698869,
    978798,
    878888,
    788877,
    798888,
    889787,
    889669,
    788877,
    879887,
    968879,
    798779,
    887889,
    887978,
    868888,
    988777,
    878899,
    777879,
    988978,
    898799,
    967887,
    887889,
    778778,
    779888,
    888878,
    987898,
    878778,
    788877,
    887899,
    687986,
    968789,
    978976,
    778877,
    877988,
    887669,
    878789,
    897876,
    797989,
    878988,
    988898,
    888996,
    798878,
    797787,
    767787,
    688776,
    778979,
    888898,
    878877,
    878787,
    787878,
    878886,
    689998,
    689778,
    788868,
    868877,
    998677,
    998688,
    899886,
    787887,
    977876,
    797887,
    888888,
    889778,
    778898,
    988768,
    687886,
    978887,
    887777,
    798878,
    888978,
    778978,
    889777,
    787889,
    778878,
    787778,
    698677,
    799877,
    878967,
    788978,
    687688,
    788887,
    978898,
    887969,
    786888,
    798789,
    777887,
    876778,
    688978,
    789867,
    778788,
    777888,
    777868,
    898786,
    877889,
    689776,
    778877,
    977789,
    867878,
    978778,
    978978,
    887776,
    889888,
    898889,
    888777,
    897897,
    998779,
    798778,
    988996,
    877886,
    877887,
    699878,
    667788,
    779788,
    787966,
    789868,
    866789,
    887889,
    787787,
    977888,
    788678,
    978888,
    776987,
    997787,
    878788,
    988889,
    788778,
    889878,
    788999,
    876788,
    878877,
    877868,
    988787,
    868797,
    789887,
    888797,
    779878,
    789987,
    888868,
    788888,
    878988,
    876687,
    878987,
    878987,
    997887,
    798877,
    888899,
    978977,
    899787,
    878986,
    676767,
    877778,
    988988,
    969768,
    977688,
    688788,
    878786,
    678888,
    687987,
    888888,
    888688,
    878998,
    876986,
    887788,
    786878,
    777898,
    689877,
    876887,
    997898,
    999888,
    778976,
    998977,
    887986,
    988898,
    879988,
    898877,
    868788,
    898678,
    899688,
    896788,
    797876,
    998878,
    779888,
    897987,
    779888,
    989988,
    899977,
    877788,
    878778,
    768788,
    877787,
    888887,
    799878,
    966878,
    798888,
    776799,
    777787,
    789877,
    878977,
    789988,
    968787,
    888999,
    998789,
    888787,
    876868,
    888688,
    779777,
    899897,
    887868,
    898887,
    688667,
    887778,
    988878,
    887798,
    888788,
    789779,
    888969,
    888787,
    678878,
    887778,
    897777,
    889978,
    886989,
    899888,
    888879,
    898698,
    999878,
    888888,
    788878,
    979878,
    778899,
    989788,
    877879,
    788989,
    778879,
    978987,
    767977,
    867888,
    779766,
    796887,
    689998,
    897987,
    977698,
    779878,
    977978,
    688888,
    876777,
    889798,
    898799,
    887877,
    879976,
    789988,
    888879,
    889998,
    877789,
    768877,
    878887,
    888878,
    877889,
    897978,
    789978,
    788988,
    787789,
    888877,
    897877,
    888886,
    888988,
    787998,
    789888,
    788897,
    777789,
    788767,
    879779,
    877967,
    977897,
    886879,
    878879,
    778879,
    778899,
    988788,
    878798,
    778888,
    787787,
    898877,
    789768,
    978877,
    889888,
    998987,
    987888,
    988786,
    787889,
    776687,
    788788,
    979898,
    777878,
    778979,
    778667,
    978978,
    977999,
    989878,
    788888,
    977979,
    687887,
    879868,
    789777,
    869997,
    787786,
    889777,
    978866,
    798987,
    897778,
    787889,
    878877,
    999879,
    788787,
    889887,
    789887,
    879787,
    998787,
    898888,
    787969,
    987897,
    787789,
    889868,
    887879,
    667887,
    989997,
    799776,
    797876,
    889787,
    888789,
    787978,
    989777,
    687787,
    988879,
    767987,
    888788,
    889877,
    788678,
    978786,
    689899,
    879789,
    888767,
    877788,
    787877,
    878877,
    979888,
    888878,
    889769,
    778888,
    889778,
    888786,
    788978,
    899878,
    898887,
    788897,
    896978,
    779777,
    879786,
    777898,
    877778,
    888898,
    788779,
    989769,
    777769,
    797778,
    779967,
    977878,
    688989,
    888967,
    777797,
    887787,
    877787,
    798879,
    878668,
    769779,
    988888,
    888896,
    688978,
    788787,
    797997,
    888797,
    887799,
    879879,
    797796,
    969889,
    977888,
    879877,
    998899,
    977987,
    887989,
    989787,
    899788,
    788978,
    888797,
    788688,
    767878,
    997897,
    877889,
    988787,
    878977,
    977967,
    887988,
    877989,
    899788,
    887988,
    889878,
    796988,
    896887,
    898879,
    898987,
    788777,
    688987,
    787867,
    877888,
    886778,
    768686,
    988777,
    978888,
    886797,
    777988,
    898779,
    888788,
    869878,
    887688,
    998868,
    797868,
    989977,
    988788,
    778877,
    977887,
    798868,
    887668,
    898798,
    888888,
    877768,
    989879,
    787878,
    877878,
    677888,
    878887,
    777997,
    887998,
    898789,
    778788,
    888987,
    886898,
    897788,
    777968,
    877977,
    898698,
    787877,
    987777,
    877987,
    998988,
    878777,
    979878,
    798889,
    978898,
    968798,
    776877,
    877988,
    787787,
    778768,
    889788,
    869778,
    878978,
    787898,
    877798,
    987978,
    978999,
    799798,
    898988,
    877888,
    979689,
    888789,
    876888,
    878898,
    878868,
    987899,
    878796,
    897797,
    887888,
    987788,
    878898,
    977778,
    978778,
    776688,
    778987,
    677866,
    889869,
    887897,
    787678,
    977888,
    799887,
    888977,
    799779,
    688878,
    988988,
    987877,
    889988,
    788887,
    897888,
    797989,
    979676,
    869897,
    688877,
    888787,
    788788,
    777887,
    888766,
    888768,
    989799,
    676797,
    869689,
    988968,
    777678,
    789777,
    987777,
    989887,
    777788,
    888968,
    879978,
    888777,
    668997,
    788888,
    989868,
    787888,
    889887,
    899888,
    798977,
    979978,
    878788,
    788877,
    798798,
    878987,
    776899,
    777987,
    787987,
    977889,
    799997,
    999978,
    889997,
    989777,
    977788,
    977798,
    797788,
    878788,
    887979,
    987878,
    899897,
    788897,
    997788,
    887998,
    888798,
    886799,
    997878,
    888788,
    697776,
    979768,
    888986,
    879788,
    977878,
    998778,
    897888,
    889788,
    998787,
    797778,
    789787,
    888977,
    796798,
    787888,
    687878,
    898878,
    889787,
    887797,
    799777,
    678778,
    898889,
    797878,
    978887,
    977887,
    779977,
    888777,
    877878,
    878797,
    887787,
    778778,
    877788,
    778677,
    787788,
    678687,
    798978,
    988887,
    679888,
    978697,
    788879,
    887777,
    898888,
    777879,
    798878,
    887778,
    787768,
    877897,
    878777,
    878788,
    888899,
    777898,
    879877,
    789897,
    679897,
    977878,
    878688,
    886777,
    897878,
    888787,
    998888,
    888988,
    888697,
    798986,
    989766,
    887797,
    987888,
    877689,
    897789,
    768888,
    888877,
    876778,
    877878,
    899888,
    776798,
    798779,
    989778,
    798877,
    888898,
    787969,
    877787,
    988996,
    878889,
    786899,
    978787,
    888888,
    878877,
    778778,
    767777,
    687989,
    977888,
    767888,
    878786,
    887778,
    778887,
    997867,
    887886,
    979777,
    978887,
    988888,
    788988,
    987779,
    996687,
    888869,
    897878,
    787679,
    989787,
    697789,
    888778,
    886888,
    788977,
    898868,
    888788,
    798998,
    878677,
    888789,
    789688,
    977878,
    997978,
    887999,
    797889,
    777878,
    867879,
    898778,
    769887,
    878879,
    889898,
    888888,
    789788,
    889988,
    777777,
    988877,
    678899,
    888767,
    676879,
    689787,
    878988,
    877779,
    987798,
    788787,
    788778,
    777779,
    688988,
    788769,
    777878,
    988988,
    778898,
    988889,
    988888,
    878778,
    699878,
    969797,
    979798,
    769698,
    987788,
    678988,
    989768,
    887987,
    889898,
    889877,
    789889,
    787888,
    778888,
    997789,
    778788,
    779788,
    889787,
    997888,
    898687,
    889668,
    779867,
    986798,
    776888,
    677688,
    778978,
    887888,
    768679,
    797987,
    888667,
    788889,
    887988,
    888777,
    897887,
    989897,
    977877,
    898788,
    898868,
    787899,
    766887,
    998868,
    888888,
    888778,
    779768,
    799888,
    799889,
    778678,
    789898,
    887789,
    778798,
    887987,
    679888,
    988898,
    788799,
    896788,
    798768,
    897899,
    886777,
    779798,
    987799,
    868788,
    987788,
    788877,
    898889,
    878988,
    888698,
    688888,
    968898,
    697887,
    887989,
    977776,
    878888,
    897897,
    889897,
    898789,
    888887,
    798777,
    768787,
    997778,
    798887,
    888877,
    987888,
    979878,
    987888,
    879889,
    678989,
    869778,
    888898,
    897877,
    876989,
    999989,
    886689,
    779888,
    878776,
    988888,
    897797,
    979897,
    989787,
    877797,
    898889,
    878878,
    688877,
    897778,
    887689,
    888987,
    988699,
    887798,
    778876,
    988877,
    777888,
    897878,
    888989,
    769799,
    889677,
    878789,
    778879,
    877788,
    898878,
    777888,
    878888,
    777777,
    778878,
    897978,
    879988,
    878988,
    787788,
    777698,
    788968,
    986688,
    888887,
    897778,
    698779,
    897878,
    877887,
    877687,
    769879,
    988987,
    877797,
    998787,
    788887,
    779777,
    878788,
    898788,
    877878,
    887787,
    676888,
    978887,
    687879,
    778887,
    768678,
    997679,
    898978,
    777777,
    877779,
    988777,
    789798,
    987899,
    967889,
    878779,
    787897,
    768796,
    889898,
    678878,
    879898,
    778897,
    799999,
    996999,
    797898,
    789898,
    877899,
    777879,
    988878,
    878799,
    779698,
    878987,
    878897,
    869877,
    896997,
    888879,
    788878,
    778878,
    677896,
    778677,
    887988,
    978787,
    688878,
    879778,
    787987,
    877777,
    866788,
    888898,
    896778,
    998897,
    978998,
    787777,
    978896,
    886867,
    787887,
    977798,
    789897,
    898778,
    888777,
    897978,
    787886,
    779978,
    998976,
    786878,
    887898,
    789788,
    686798,
    869777,
    978768,
    989887,
    888778,
    797798,
    867888,
    776888,
    796788,
    889779,
    778889,
    886766,
    878888,
    977997,
    968788,
    987888,
    887868,
    787887,
    987889,
    877778,
    788778,
    978788,
    788777,
    787996,
    777999,
    788797,
    787769,
    876777,
    889778,
    788898,
    767699,
    778788,
    979878,
    998977,
    888968,
    898787,
    697897,
    878979,
    877889,
    887778,
    989878,
    798788,
    778976,
    788879,
    789898,
    867777,
    787787,
    777779,
    788878,
    887776,
    798886,
    887877,
    998777,
    789676,
    786787,
    869688,
    767777,
    787697,
    677877,
    888887,
    697978,
    867998,
    996798,
    989778,
    896788,
    878869,
    676998,
    778789,
    968987,
    867786,
    688877,
    889899,
    889788,
    977789,
    888787,
    887979,
    888797,
    897678,
    978788,
    899788,
    888888,
    979788,
    777888,
    967888,
    787898,
    987878,
    687888,
    888888,
    979878,
    778799,
    789968,
    777969,
    988878,
    896879,
    976768,
    798787,
    777887,
    979867,
    877768,
    787987,
    679888,
    878898,
    798869,
    777988,
    898978,
    789877,
    798889,
    869798,
    788898,
    789687,
    869887,
    877898,
    667798,
    996687,
    788787,
    788976,
    768879,
    977888,
    779778,
    788679,
    876789,
    999867,
    988898,
    989877,
    879788,
    888887,
    989789,
    879888,
    868788,
    787688,
    878777,
    997989,
    887968,
    878899,
    888878,
    889889,
    889898,
    796888,
    778887,
    798897,
    878877,
    887789,
    899897,
    879987,
    798878,
    788888,
    879688,
    887979,
    898867,
    879887,
    779789,
    978786,
    668778,
    889778,
    768998,
    878889,
    777788,
    888898,
    788789,
    897888,
    987888,
    887778,
    788888,
    868698,
    888986,
    977878,
    878898,
    877687,
    797898,
    866787,
    788967,
    879897,
    987877,
    889798,
    898988,
    999987,
    887888,
    877876,
    988897,
    898898,
    778988,
    778777,
    878779,
    789997,
    887788,
    878988,
    696897,
    868898,
    687768,
    699887,
    897788,
    878777,
    687889,
    778788,
    889678,
    887987,
    977898,
    889877,
    998787,
    878998,
    877787,
    676796,
    788977,
    998788,
    979787,
    888887,
    779796,
    878877,
    877887,
    977898,
    898778,
    778787,
    897887,
    788788,
    887777,
    789987,
    788778,
    977989,
    798888,
    788968,
    779988,
    887879,
    889897,
    878888,
    977988,
    776789,
    787887,
    899778,
    688876,
    789699,
    798878,
    986896,
    988767,
    687889,
    889787,
    899789,
    888879,
    798987,
    869687,
    787789,
    878789,
    787788,
    798888,
    779889,
    988788,
    788989,
    878797,
    998777,
    777988,
    887876,
    899877,
    777889,
    898788,
    677887,
    888777,
    898888,
    777788,
    789988,
    788867,
    878689,
    698789,
    787788,
    888789,
    669868,
    886998,
    977889,
    796888,
    898988,
    898989,
    686688,
    788977,
    888798,
    979797,
    887889,
    879678,
    979787,
    688887,
    988886,
    778777,
    988878,
    677779,
    789988,
    989898,
    978887,
    769887,
    987879,
    977888,
    899868,
    686868,
    786798,
    887887,
    889768,
    788878,
    879987,
    788777,
    777789,
    788888,
    998787,
    887899,
    778868,
    787778,
    976887,
    889868,
    788888,
    879879,
    787968,
    798888,
    879878,
    898878,
    679979,
    878796,
    887999,
    887998,
    788887,
    879778,
    687879,
    879887,
    797768,
    777888,
    777878,
    799978,
    889889,
    798768,
    977988,
    998887,
    888887,
    987988,
    897898,
    897888,
    777888,
    877787,
    988669,
    778798,
    777888,
    886768,
    898889,
    798987,
    876768,
    788877,
    799777,
    779989,
    987788,
    878788,
    787878,
    997776,
    968879,
    799878,
    677878,
    986789,
    888787,
    877788,
    877886,
    786787,
    977779,
    798897,
    787889,
    788987,
    787777,
    898779,
    988878,
    976967,
    778886,
    978977,
    887787,
    887887,
    777987,
    777887,
    887787,
    789866,
    879789,
    879678,
    777779,
    877786,
    767888,
    798777,
    789768,
    988889,
    878877,
    876797,
    878986,
    887898,
    896797,
    978899,
    777999,
    877888,
    879877,
    777696,
    678899,
    987978,
    877869,
    969787,
    877989,
    879887,
    868886,
    797778,
    877979,
    789799,
    798899,
    897989,
    968987,
    788777,
    979888,
    988788,
    977777,
    888877,
    886788,
    889878,
    778987,
    787879,
    977779,
    896768,
    877988,
    788797,
    878789,
    886898,
    878979,
    768789,
    789988,
    888889,
    999799,
    787877,
    998788,
    888687,
    878876,
    797879,
    877688,
    689777,
    767787,
    987979,
    877797,
    787787,
    778897,
    787988,
    877979,
    878988,
    977879,
    867898,
    878789,
    997988,
    887889,
    798988,
    778898,
    797767,
    766998,
    887888,
    889889,
    788978,
    889987,
    877978,
    879898,
    787998,
    778787,
    978778,
    889778,
    766788,
    788886,
    879779,
    877889,
    788877,
    878989,
    967679,
    788988,
    887789,
    879889,
    787898,
    976888,
    798789,
    888887,
    888888,
    769789,
    897978,
    989889,
    877778,
    977887,
    797789,
    798888,
    897786,
    897868,
    979777,
    887798,
    877789,
    977888,
    978988,
    999988,
    776878,
    787979,
    887778,
    977778,
    878986,
    877777,
    878888,
    968889,
    688877,
    797787,
    887978,
    799788,
    879997,
    976897,
    788888,
    878897,
    779876,
    886888,
    997777,
    778789,
    788888,
    988986,
    897889,
    988789,
    777887,
    888887,
    787798,
    777978,
    888878,
    979877,
    788797,
    887889,
    798977,
    897799,
    688678,
    898767,
    778876,
    778787,
    887978,
    787779,
    679868,
    888767,
    978978,
    686877,
    889797,
    998978,
    787787,
    796777,
    787888,
    787788,
    898789,
    778988,
    989797,
    878978,
    888998,
    988877,
    987688,
    797879,
    979888,
    767897,
    888777,
    976768,
    887887,
    878889,
    778778,
    888778,
    778889,
    788688,
    878778,
    878878,
    789988,
    778888,
    889779,
    867888,
    777778,
    888789,
    878897,
    988888,
    979989,
    889688,
    778796,
    698788,
    887786,
    778977,
    878888,
    787998,
    988889,
    797889,
    887799,
    889787,
    788788,
    988887,
    888778,
    898778,
    788878,
    879896,
    889978,
    879879,
    878888,
    988898,
    768798,
    887889,
    867978,
    778788,
    679887,
    797678,
    879877,
    897978,
    989878,
    979888,
    778788,
    969889,
    887797,
    998687,
    887997,
    988977,
    968888,
    987778,
    888877,
    879777,
    777798,
    778797,
    988788,
    778887,
    887878,
    879988,
    878678,
    877878,
    988798,
    887898,
    698886,
    878878,
    779786,
    798896,
    897889,
    687776,
    797797,
    998777,
    888688,
    878677,
    778977,
    877998,
    979878,
    887988,
    897777,
    997877,
    676788,
    788789,
    897779,
    878977,
    697898,
    979878,
    797799,
    786678,
    886787,
    779788,
    889778,
    877989,
    998798,
    789787,
    998878,
    777887,
    798896,
    899976,
    668796,
    887979,
    897796,
    887868,
    978669,
    788978,
    878986,
    788887,
    878977,
    788989,
    879988,
    777777,
    767888,
    888776,
    877898,
    978778,
    988777,
    787887,
    788869,
    879797,
    988788,
    689888,
    769897,
    777778,
    998978,
    887879,
    868678,
    898777,
    777877,
    988888,
    988797,
    777687,
    898678,
    886898,
    797878,
    868967,
    889999,
    896689,
    797889,
    898978,
    787888,
    989986,
    886787,
    878677,
    868977,
    688878,
    777899,
    887887,
    888779,
    897889,
    878888,
    979877,
    897888,
    778877,
    888989,
    998988,
    777778,
    868898,
    986779,
    989677,
    877878,
    886888,
    898768,
    777787,
    788879,
    777987,
    778798,
    897889,
    877889,
    889877,
    889977,
    877878,
    998988,
    877898,
    978788,
    888799,
    878788,
    778889,
    787888,
    888878,
    779977,
    878879,
    787967,
    977786,
    878887,
    677988,
    787767,
    888888,
    877787,
    988887,
    988799,
    967777,
    897888,
    978888,
    788878,
    899877,
    898978,
    887988,
    778878,
    788877,
    989998,
    887887,
    889989,
    897997,
    889887,
    988987,
    887786,
    788777,
    778688,
    787787,
    878887,
    787886,
    789699,
    889877,
    798688,
    788998,
    887887,
    878787,
    878877,
    777896,
    798778,
    977676,
    867886,
    878898,
    877888,
    877776,
    677779,
    788887,
    987888,
    988878,
    887978,
    788877,
    776877,
    788789,
    898886,
    887788,
    977787,
    899777,
    798887,
    787786,
    788898,
    888788,
    898878,
    778988,
    779879,
    768978,
    888887,
    778879,
    789788,
    887798,
    998787,
    877787,
    878786,
    786976,
    888989,
    969788,
    877887,
    779878,
    799788,
    778878,
    778787,
    688798,
    898898,
    888989,
    987677,
    777698,
    877887,
    777778,
    877887,
    989687,
    799867,
    897779,
    799998,
    986986,
    877887,
    787788,
    998788,
    899989,
    679789,
    788779,
    777787,
    887988,
    778887,
    989987,
    968878,
    897876,
    769897,
    779888,
    798886,
    779888,
    998878,
    888787,
    987788,
    889688,
    888877,
    877879,
    987877,
    878788,
    988699,
    988788,
    986788,
    867768,
    978777,
    787888,
    778668,
    897789,
    778788,
    898887,
    788777,
    989898,
    889977,
    986679,
    688787,
    979788,
    987889,
    688877,
    778878,
    987978,
    688867,
    888899,
    898789,
    797788,
    897788,
    877877,
    888788,
    789878,
    678877,
    978688,
    688798,
    778978,
    987888,
    888778,
    988888,
    897987,
    887798,
    768888,
    888897,
    786896,
    698897,
    897988,
    877877,
    868776,
    887778,
    797978,
    899988,
    877989,
    777697,
    987879,
    677887,
    978899,
    778977,
    878677,
    887978,
    789789,
    798777,
    767687,
    877788,
    789988,
    768787,
    989797,
    996886,
    776787,
    688898,
    978777,
    887888,
    678896,
    888889,
    786698,
    788988,
    887897,
    879899,
    797879,
    888788,
    788886,
    868788,
    797879,
    777889,
    898886,
    968789,
    876798,
    877977,
    887898,
    997798,
    787898,
    978887,
    777787,
    798778,
    898997,
    778787,
    869989,
    786889,
    788678,
    889898,
    897787,
    968879,
    878978,
    778897,
    898878,
    898698,
    787698,
    878878,
    887898,
    978987,
    888998,
    998889,
    887887,
    969888,
    879978,
    988767,
    988977,
    889898,
    779688,
    876887,
    998897,
    868877,
    879879,
    878878,
    777878,
    777896,
    686898,
    987889,
    968887,
    798889,
    887678,
    788987,
    988998,
    788888,
    889987,
    997888,
    977868,
    799766,
    787789,
    897799,
    888788,
    799887,
    896998,
    777977,
    877878,
    788889,
    877877,
    778798,
    788797,
    989879,
    998878,
    777887,
    888877,
    888876,
    668878,
    888889,
    778978,
    897878,
    678866,
    988967,
    977888,
    887877,
    797788,
    789789,
    889999,
    797977,
    997677,
    988887,
    789697,
    988697,
    898889,
    878868,
    878778,
    878798,
    897878,
    788787,
    798779,
    879786,
    988887,
    789889,
    887888,
    787777,
    677787,
    686668,
    677889,
    787988,
    888799,
    868888,
    888778,
    888977,
    978888,
    778777,
    888878,
    899768,
    798998,
    768797,
    867778,
    787679,
    786987,
    987888,
    867786,
    878889,
    886776,
    899879,
    676887,
    778877,
    778887,
    797779,
    877786,
    877788,
    898678,
    887987,
    869887,
    779898,
    769867,
    968867,
    887889,
    789788,
    898778,
    868888,
    888768,
    898898,
    987879,
    887978,
    788897,
    887778,
    888798,
    789778,
    687887,
    787877,
    788878,
    878878,
    668997,
    888779,
    997886,
    878898,
    888987,
    988977,
    888887,
    889868,
    887868,
    877987,
    768888,
    887896,
    778777,
    887788,
    799678,
    788889,
    789798,
    888899,
    997769,
    767887,
    789798,
    889877,
    898989,
    989888,
    778899,
    978977,
    966888,
    889788,
    888878,
    866666,
    988977,
    687798,
    789798,
    678877,
    878888,
    887797,
    887868,
    888789,
    888888,
    868688,
    889689,
    788978,
    979879,
    888788,
    977787,
    789887,
    988999,
    776979,
    997879,
    787788,
    898876,
    986667,
    898887,
    887787,
    988787,
    997988,
    887788,
    688778,
    888787,
    789778,
    878988,
    878778,
    797878,
    787887,
    789887,
    878978,
    877797,
    788766,
    778788,
    798887,
    887987,
    888978,
    997878,
    888797,
    668779,
    788878,
    678688,
    867898,
    889877,
    778888,
    896789,
    869878,
    888787,
    788899,
    887987,
    879796,
    888779,
    887886,
    878668,
    799677,
    878689,
    868878,
    798898,
    979766,
    788798,
    988777,
    798979,
    877787,
    999888,
    898988,
    888878,
    779778,
    787879,
    688878,
    878787,
    889787,
    878887,
    887679,
    778798,
    689879,
    888787,
    789888,
    788777,
    789876,
    888887,
    898798,
    998889,
    877798,
    898899,
    987888,
    687878,
    798996,
    897887,
    868897,
    866788,
    877877,
    879777,
    688777,
    878889,
    888897,
    787877,
    978687,
    887787,
    898798,
    796998,
    878679,
    877968,
    897896,
    789869,
    668897,
    869868,
    998787,
    687987,
    868888,
    886788,
    978788,
    878778,
    878868,
    876878,
    688898,
    787877,
    897788,
    878898,
    869899,
    979778,
    886978,
    976877,
    677988,
    799898,
    787798,
    877889,
    879888,
    788978,
    788987,
    888878,
    888888,
    877787,
    979999,
    788998,
    887778,
    788799,
    978777,
    777897,
    787897,
    887877,
    779787,
    987778,
    976876,
    778998,
    788877,
    889887,
    887878,
    897888,
    988788,
    788777,
    888887,
    878788,
    868878,
    688787,
    887879,
    788968,
    987798,
    788867,
    889888,
    789987,
    888889,
    886766,
    889778,
    867788,
    888886,
    889987,
    977887,
    977799,
    997778,
    877867,
    887977,
    988887,
    977889,
    888887,
    877867,
    898897,
    787777,
    899687,
    988778,
    889877,
    768888,
    796698,
    877798,
    998687,
    898979,
    878788,
    768978,
    678777,
    768768,
    878788,
    698878,
    798897,
    879969,
    989867,
    776988,
    898887,
    779978,
    788778,
    888879,
    787988,
    888699,
    869988,
    776889,
    986798,
    797778,
    986878,
    978987,
    778978,
    768799,
    879878,
    978878,
    878888,
    787787,
    777988,
    887898,
    786977,
    788878,
    969688,
    989896,
    778977,
    877778,
    999997,
    877887,
    868898,
    878777,
    898987,
    889987,
    988878,
    988887,
    988888,
    788689,
    787888,
    878888,
    878787,
    967787,
    889867,
    888979,
    787879,
    888887,
    789897,
    776679,
    777877,
    887778,
    998888,
    687898,
    887879,
    687968,
    877788,
    898779,
    987888,
    778999,
    778988,
    688778,
    978899,
    879688,
    977898,
    876888,
    887687,
    767897,
    788899,
    976877,
    988989,
    878788,
    978877,
    888767,
    878678,
    767998,
    788777,
    888887,
    767897,
    966889,
    778977,
    878977,
    777777,
    878889,
    977789,
    987787,
    687878,
    879877,
    898768,
    787888,
    888997,
    686787,
    988997,
    878886,
    877788,
    787898,
    877778,
    976976,
    878889,
    878989,
    878887,
    787987,
    979796,
    898887,
    977877,
    877988,
    897777,
    787877,
    887787,
    888876,
    789778,
    898779,
    898888,
    888897,
    898786,
    866888,
    987797,
    779978,
    789877,
    989886,
    989777,
    877987,
    788777,
    789887,
    777978,
    897788,
    789889,
    987688,
    989979,
    977799,
    699887,
    989888,
    788778,
    878987,
    789879,
    687897,
    778798,
    898887,
    788677,
    898789,
    876877,
    687988,
    897878,
    997686,
    878876,
    877898,
    768998,
    887877,
    767789,
    897989,
    778787,
    788877,
    686899,
    889687,
    778787,
    777888,
    888688,
    877797,
    887778,
    878978,
    888777,
    777698,
    788988,
    987798,
    987977,
    986987,
    868878,
    978898,
    888768,
    888888,
    799889,
    778697,
    787878,
    989889,
    688777,
    789888,
    888998,
    888677,
    897988,
    877888,
    968688,
    886889,
    866889,
    988877,
    888896,
    978787,
    677888,
    887688,
    877888,
    887789,
    978769,
    798878,
    786789,
    878777,
    869888,
    887788,
    878887,
    879687,
    888868,
    796899,
    978999,
    898887,
    889687,
    889888,
    979987,
    787788,
    797898,
    987787,
    888978,
    879797,
    898968,
    976978,
    978978,
    997967,
    789899,
    788897,
    888899,
    879799,
    788688,
    877778,
    878878,
    978978,
    987778,
    789988,
    898797,
    897987,
    989878,
    899688,
    777777,
    888889,
    878977,
    778778,
    977877,
    888797,
    887888,
    988899,
    797898,
    887888,
    688986,
    889778,
    787777,
    887889,
    678798,
    896888,
    787987,
    788788,
    878897,
    888777,
    898688,
    888878,
    778786,
    777978,
    769887,
    688798,
    787788,
    887797,
    668968,
    878779,
    786788,
    877778,
    797887,
    897778,
    987667,
    789879,
    896878,
    887788,
    988897,
    877997,
    998869,
    967978,
    787998,
    668879,
    888977,
    867798,
    768989,
    877686,
    897777,
    878778,
    887887,
    896888,
    867877,
    877987,
    778689,
    977867,
    777788,
    687877,
    899797,
    788797,
    789677,
    878788,
    798777,
    987669,
    798688,
    997988,
    898779,
    877988,
    799999,
    897898,
    997898,
    779888,
    778979,
    998987,
    877788,
    899878,
    998787,
    766786,
    777887,
    778779,
    889777,
    879899,
    988897,
    678878,
    988898,
    876888,
    778787,
    787889,
    988997,
    898878,
    889679,
    777798,
    778887,
    888799,
    878888,
    788889,
    978697,
    897898,
    887889,
    888678,
    788798,
    999876,
    778887,
    688889,
    897897,
    988877,
    989879,
    887677,
    778889,
    779789,
    877989,
    788888,
    686877,
    877766,
    878788,
    788899,
    977787,
    767888,
    978997,
    776978,
    877877,
    679888,
    898787,
    977888,
    899686,
    778778,
    779888,
    977897,
    879797,
    787877,
    888767,
    778778,
    987978,
    777889,
    898889,
    878798,
    998696,
    978877,
    797767,
    887989,
    878787,
    699887,
    777867,
    797887,
    899776,
    879987,
    788668,
    788998,
    998888,
    779788,
    787789,
    977876,
    767787,
    977878,
    987789,
    797786,
    878787,
    878788,
    878987,
    888968,
    997897,
    778879,
    888888,
    887888,
    878888,
    777888,
    779878,
    987878,
    888886,
    899698,
    987879,
    977877,
    678699,
    877987,
    968888,
    788788,
    796688,
    887999,
    787988,
    867887,
    797888,
    778787,
    888778,
    787998,
    888988,
    987788,
    988788,
    879787,
    877778,
    966888,
    788987,
    878978,
    999887,
    878877,
    889878,
    797887,
    879778,
    889888,
    999886,
    897897,
    779887,
    788868,
    889897,
    879976,
    877899,
    966887,
    899789,
    898776,
    887788,
    879789,
    986776,
    797788,
    898877,
    678787,
    968976,
    777879,
    678888,
    768877,
    777787,
    777788,
    897987,
    867876,
    789797,
    888987,
    776789,
    888877,
    998788,
    887888,
    997987,
    889766,
    798877,
    978787,
    879967,
    798878,
    788876,
    997786,
    978896,
    878798,
    878677,
    778988,
    798877,
    878788,
    788778,
    879877,
    878889,
    878977,
    886877,
    968888,
    978789,
    677878,
    779778,
    877767,
    776879,
    786799,
    778778,
    788998,
    899989,
    897989,
    888887,
    778688,
    777896,
    898877,
    778776,
    888787,
    988788,
    797988,
    788988,
    886888,
    887887,
    999897,
    968777,
    787777,
    989879,
    887898,
    698989,
    898888,
    996977,
    799888,
    986768,
    778879,
    788886,
    878977,
    899789,
    778778,
    786887,
    888987,
    687698,
    878977,
    897987,
    788789,
    897788,
    788779,
    898876,
    687798,
    878887,
    778877,
    777988,
    987888,
    868777,
    987999,
    787888,
    676789,
    888778,
    888986,
    898787,
    878789,
    878786,
    898778,
    779889,
    769888,
    997886,
    798887,
    998986,
    887978,
    899778,
    686778,
    989888,
    677798,
    788787,
    778877,
    877688,
    988687,
    788787,
    879776,
    777967,
    878787,
    787996,
    989898,
    789667,
    787788,
    877789,
    787889,
    797878,
    888989,
    897869,
    899988,
    888778,
    697887,
    989668,
    798899,
    997999,
    788777,
    878889,
    788789,
    978788,
    967688,
    789888,
    877877,
    677869,
    878778,
    797878,
    878987,
    778989,
    798767,
    978789,
    777896,
    778888,
    998779,
    878888,
    887988,
    666879,
    889777,
    887898,
    977679,
    898997,
    888888,
    887788,
    788987,
    677877,
    989798,
    787688,
    968778,
    978699,
    798788,
    787988,
    997888,
    896997,
    888988,
    868679,
    988887,
    798778,
    888798,
    789986,
    878867,
    778779,
    889788,
    878977,
    878798,
    877898,
    988878,
    778879,
    878889,
    877887,
    877979,
    889888,
    787978,
    889999,
    998787,
    779787,
    698998,
    988776,
    878988,
    788677,
    898789,
    879788,
    886688,
    898887,
    788898,
    687778,
    968788,
    878989,
    888777,
    788778,
    988787,
    998978,
    678778,
    988889,
    887788,
    987787,
    988879,
    978689,
    788878,
    887788,
    779888,
    887677,
    888779,
    888886,
    788688,
    788887,
    789886,
    788989,
    987788,
    898767,
    878887,
    977888,
    887878,
    987898,
    689977,
    978778,
    887899,
    787797,
    997988,
    887877,
    788888,
    796888,
    777869,
    888777,
    979866,
    678989,
    977788,
    799796,
    887897,
    879896,
    888989,
    878886,
    887977,
    988888,
    799898,
    687679,
    887897,
    798786,
    767798,
    878778,
    779889,
    798678,
    878878,
    887978,
    989998,
    888778,
    787788,
    778887,
    896798,
    987889,
    897878,
    977777,
    688879,
    788777,
    886787,
    877887,
    996878,
    889988,
    787776,
    998788,
    797788,
    887887,
    988879,
    778998,
    796777,
    777867,
    967778,
    888787,
    887777,
    888889,
    878778,
    888799,
    876777,
    777869,
    787989,
    687899,
    968978,
    777989,
    788888,
    878987,
    778779,
    888888,
    979799,
    899997,
    788988,
    979798,
    697887,
    889788,
    878878,
    888786,
    786888,
    677888,
    777878,
    999987,
    989998,
    987978,
    797977,
    778779,
    668888,
    789768,
    889879,
    777789,
    979789,
    889798,
    879898,
    888878,
    987888,
    889899,
    877799,
    788986,
    778998,
    999789,
    888768,
    897878,
    767979,
    796889,
    888888,
    888689,
    887788,
    867888,
    788888,
    887688,
    977988,
    769888,
    689778,
    897797,
    769779,
    779797,
    988888,
    888877,
    777889,
    888869,
    889778,
    889987,
    888888,
    879898,
    887897,
    878978,
    888887,
    789787,
    797977,
    877998,
    897997,
    968888,
    877977,
    988777,
    888887,
    779888,
    997878,
    877999,
    798889,
    879788,
    987887,
    789679,
    877777,
    988997,
    789998,
    987697,
    877897,
    898878,
    898898,
    798797,
    677899,
    879987,
    798968,
    778678,
    877876,
    777977,
    877878,
    987869,
    888979,
    669886,
    879998,
    777798,
    897688,
    879898,
    688777,
    888899,
    788798,
    887777,
    887779,
    778877,
    787877,
    998867,
    887888,
    878878,
    787787,
    988978,
    898789,
    768777,
    779876,
    788978,
    889879,
    898968,
    798888,
    867798,
    888879,
    886788,
    777978,
    976877,
    779877,
    788787,
    687787,
    899689,
    786889,
    888888,
    989879,
    789777,
    888988,
    678779,
    877898,
    986897,
    877887,
    878786,
    978977,
    778977,
    789879,
    798768,
    889887,
    797698,
    977797,
    878788,
    798787,
    789989,
    779778,
    786798,
    898987,
    987988,
    787889,
    677787,
    978788,
    787897,
    667897,
    687889,
    979898,
    878788,
    787887,
    887877,
    778977,
    798888,
    878777,
    878898,
    889779,
    887869,
    689888,
    898878,
    898898,
    978897,
    789878,
    878987,
    788777,
    779987,
    897887,
    889888,
    787778,
    777987,
    887888,
    978877,
    698787,
    778898,
    988998,
    888887,
    787987,
    798796,
    888786,
    798798,
    878886,
    877686,
    889789,
    787976,
    788777,
    788876,
    879978,
    779878,
    877887,
    878677,
    898977,
    898988,
    877877,
    897678,
    788787,
    696878,
    898788,
    867869,
    777766,
    878878,
    787886,
    778787,
    977898,
    978769,
    988876,
    887888,
    788778,
    888888,
    678787,
    989887,
    788887,
    888877,
    767778,
    969978,
    779889,
    978977,
    877878,
    778889,
    788867,
    777867,
    878869,
    888898,
    976898,
    778887,
    887987,
    887787,
    798796,
    788978,
    967897,
    989767,
    878899,
    987976,
    869998,
    778898,
    888777,
    788777,
    777789,
    899877,
    878787,
    787979,
    787888,
    787898,
    779898,
    978789,
    899788,
    877888,
    698987,
    878887,
    687878,
    896878,
    879987,
    777888,
    789778,
    779699,
    777866,
    878888,
    787888,
    788888,
    777877,
    798878,
    889689,
    789779,
    898899,
    788879,
    799987,
    876889,
    877986,
    986877,
    878787,
    679867,
    987687,
    989688,
    788888,
    779888,
    687787,
    888798,
    786888,
    977779,
    978788,
    867878,
    888978,
    787878,
    697899,
    987987,
    987876,
    878798,
    976978,
    898878,
    697998,
    898878,
    996879,
    998888,
    687677,
    899898,
    799898,
    788677,
    776878,
    988687,
    898877,
    888778,
    778797,
    778888,
    978678,
    879788,
    797889,
    867687,
    777878,
    877897,
    987978,
    988787,
    979778,
    978778,
    888898,
    888788,
    998778,
    779979,
    898978,
    999787,
    678888,
    986978,
    988899,
    999898,
    777789,
    889878,
    778887,
    897967,
    787696,
    877889,
    787777,
    978767,
    777869,
    778898,
    869889,
    788998,
    876878,
    687897,
    877889,
    888887,
    786878,
    988887,
    787978,
    977877,
    887897,
    998777,
    779888,
    788968,
    967778,
    869889,
    987789,
    768897,
    899677,
    767889,
    797788,
    889787,
    878888,
    878888,
    778997,
    979889,
    889888,
    778798,
    787897,
    889777,
    987887,
    787888,
    888978,
    688769,
    777697,
    898887,
    779897,
    886897,
    887977,
    788779,
    989787,
    778987,
    888689,
    888798,
    888779,
    878877,
    878788,
    887789,
    886987,
    889779,
    888788,
    867878,
    878778,
    999889,
    899878,
    978787,
    889789,
    877898,
    878789,
    778798,
    887888,
    978798,
    897977,
    869977,
    979879,
    687899,
    778788,
    898879,
    888688,
    877787,
    897999,
    788889,
    888787,
    887887,
    887797,
    878997,
    887876,
    787888,
    896876,
    879798,
    886989,
    777978,
    888987,
    999777,
    967779,
    787987,
    786779,
    877876,
    676879,
    687787,
    887887,
    778988,
    789787,
    879798,
    788887,
    979896,
    687898,
    987868,
    878679,
    897877,
    876778,
    788889,
    978688,
    879887,
    778887,
    688776,
    889887,
    889998,
    788877,
    798768,
    888887,
    787979,
    798878,
    877787,
    879887,
    779777,
    898777,
    777796,
    787887,
    997787,
    997889,
    898968,
    796898,
    888888,
    679889,
    778767,
    878997,
    888868,
    767798,
    978788,
    888889,
    998868,
    697787,
    988978,
    889897,
    888879,
    779778,
    979798,
    877989,
    898899,
    789878,
    877897,
    888887,
    989897,
    888877,
    888887,
    887767,
    887866,
    877688,
    788788,
    996897,
    979976,
    888789,
    888687,
    788886,
    877878,
    989889,
    798678,
    989867,
    887677,
    877787,
    778798,
    878897,
    698887,
    877777,
    887878,
    978989,
    878879,
    878676,
    878888,
    777887,
    997888,
    888877,
    988688,
    787997,
    887776,
    977779,
    888889,
    898887,
    898799,
    978777,
    888988,
    897879,
    777788,
    887787,
    678779,
    899779,
    789788,
    677778,
    789979,
    778889,
    878797,
    787789,
    776878,
    988887,
    977788,
    796878,
    787797,
    888899,
    789989,
    888877,
    978878,
    898787,
    878689,
    897779,
    989897,
    879876,
    878897,
    886898,
    878888,
    899787,
    868798,
    878788,
    888888,
    898887,
    867877,
    999888,
    768777,
    787888,
    777889,
    788988,
    876786,
    897788,
    988778,
    689789,
    778998,
    869887,
    778787,
    898888,
    879789,
    887898,
    788788,
    678898,
    787697,
    878788,
    877677,
    898788,
    986877,
    888897,
    889888,
    788988,
    798868,
    788977,
    879887,
    879986,
    798898,
    868787,
    777888,
    878887,
    977878,
    988877,
    778969,
    698789,
    787676,
    968678,
    789968,
    977788,
    778979,
    877897,
    879888,
    899778,
    767998,
    889697,
    776997,
    787769,
    887977,
    979787,
    887878,
    988778,
    878898,
    887699,
    778887,
    898888,
    777789,
    886979,
    887778,
    867888,
    789878,
    888798,
    888878,
    867887,
    978886,
    977889,
    789688,
    887889,
    987997,
    777789,
    968687,
    798897,
    878897,
    777978,
    878878,
    897789,
    886879,
    879878,
    798887,
    887879,
    888887,
    887887,
    888888,
    988989,
    878986,
    988878,
    798788,
    899996,
    988869,
    897989,
    778799,
    888898,
    896888,
    877876,
    878879,
    877887,
    888888,
    666779,
    888879,
    676887,
    788877,
    897879,
    887797,
    797687,
    987889,
    978777,
    677879,
    986788,
    889978,
    888687,
    888988,
    987889,
    769879,
    877867,
    887887,
    988888,
    886777,
    797879,
    867777,
    888897,
    798898,
    888689,
    887768,
    878699,
    887769,
    779878,
    787897,
    877777,
    789989,
    879987,
    879767,
    689679,
    879798,
    877777,
    887998,
    888988,
    887897,
    978968,
    788977,
    877789,
    799987,
    887778,
    978798,
    788788,
    888777,
    697888,
    779877,
    889998,
    777968,
    878787,
    787867,
    888878,
    898769,
    888788,
    888876,
    777788,
    887888,
    978777,
    878869,
    887977,
    887878,
    779777,
    769887,
    797889,
    887889,
    778977,
    896777,
    898898,
    889877,
    888788,
    867879,
    778978,
    897998,
    888879,
    978778,
    798878,
    897787,
    877876,
    789898,
    867797,
    879998,
    889778,
    978798,
    987798,
    889997,
    788688,
    787778,
    897978,
    988877,
    967878,
    876879,
    879897,
    878877,
    978789,
    786988,
    788879,
    797798,
    967897,
    788797,
    988698,
    897797,
    877797,
    876768,
    988879,
    788787,
    997988,
    887778,
    978787,
    897967,
    979779,
    889797,
    888798,
    979789,
    879897,
    798777,
    889977,
    779979,
    777877,
    888979,
    989978,
    987888,
    886788,
    797778,
    887887,
    997989,
    978888,
    897787,
    998797,
    976778,
    987767,
    788977,
    787987,
    997779,
    888798,
    879886,
    787889,
    897896,
    889797,
    988779,
    997888,
    888868,
    688699,
    778986,
    879889,
    788897,
    798898,
    899777,
    798789,
    777776,
    788988,
    889888,
    877796,
    788697,
    887978,
    898879,
    888968,
    888888,
    878879,
    887989,
    978797,
    797898,
    879777,
    766789,
    887777,
    897776,
    799777,
    778788,
    798888,
    888778,
    988886,
    798988,
    978786,
    778787,
    886876,
    898868,
    788886,
    976787,
    977778,
    778797,
    788879,
    879868,
    978778,
    678888,
    797889,
    789998,
    769878,
    877798,
    897879,
    778878,
    987789,
    988799,
    687787,
    989977,
    799797,
    978877,
    889788,
    989888,
    889987,
    789776,
    888889,
    778878,
    888978,
    978778,
    669897,
    887967,
    767779,
    986879,
    769879,
    878898,
    787787,
    767988,
    989888,
    767888,
    877788,
    787878,
    778779,
    798999,
    688988,
    879778,
    778888,
    787876,
    977888,
    887878,
    798898,
    686889,
    878877,
    789968,
    898977,
    789787,
    897877,
    867898,
    887888,
    889898,
    799887,
    888896,
    888798,
    889989,
    767888,
    798868,
    667989,
    779688,
    787878,
    867767,
    877888,
    877898,
    968688,
    978898,
    688788,
    879777,
    787787,
    877897,
    878987,
    979788,
    877897,
    868786,
    779888,
    879897,
    689888,
    978878,
    897878,
    897689,
    969887,
    768799,
    869777,
    999899,
    687896,
    798796,
    987888,
    899878,
    778796,
    788989,
    979888,
    978778,
    777976,
    787888,
    878888,
    878798,
    977888,
    668898,
    778998,
    788887,
    688988,
    998778,
    998798,
    899778,
    896768,
    787777,
    697888,
    777787,
    788789,
    778688,
    868879,
    788687,
    677887,
    787887,
    877977,
    879798,
    888877,
    788867,
    879677,
    877969,
    887879,
    689897,
    888968,
    889888,
    797789,
    999888,
    979877,
    977767,
    898878,
    898778,
    877869,
    988877,
    998887,
    768788,
    888988,
    779878,
    888788,
    996778,
    977788,
    779878,
    687878,
    767988,
    877897,
    788799,
    787688,
    787877,
    878766,
    877799,
    887778,
    897788,
    879778,
    897787,
    888879,
    997786,
    889897,
    887876,
    988789,
    788997,
    887689,
    888887,
    897778,
    877877,
    899777,
    898798,
    877777,
    998798,
    889867,
    978988,
    877887,
    978878,
    899899,
    787998,
    878987,
    788789,
    878968,
    888787,
    787878,
    689879,
    879788,
    888888,
    899798,
    886886,
    778968,
    686789,
    898987,
    886988,
    697889,
    887898,
    877797,
    789898,
    898798,
    878887,
    877887,
    788797,
    878778,
    886776,
    788787,
    878777,
    768988,
    778877,
    788788,
    878889,
    889778,
    877888,
    688986,
    868788,
    778788,
    977777,
    977768,
    988767,
    889798,
    788767,
    798978,
    887786,
    978767,
    789888,
    878879,
    977777,
    799787,
    989779,
    989778,
    799767,
    886678,
    897869,
    887888,
    889898,
    866978,
    879768,
    888779,
    798878,
    798687,
    989996,
    888898,
    788878,
    786989,
    787786,
    989789,
    977888,
    899967,
    898778,
    798888,
    787876,
    779797,
    869878,
    888688,
    878988,
    686888,
    989768,
    877878,
    888798,
    787777,
    876888,
    788988,
    887868,
    698889,
    888879,
    898898,
    988988,
    779777,
    988787,
    877788,
    989886,
    977778,
    978888,
    988778,
    779698,
    887898,
    897689,
    877888,
    878796,
    798767,
    787699,
    887889,
    787788,
    988797,
    797988,
    877797,
    886899,
    898989,
    898787,
    898887,
    769978,
    888978,
    778978,
    887887,
    898878,
    787989,
    787797,
    777899,
    679777,
    889989,
    897887,
    787799,
    976889,
    887798,
    887977,
    888978,
    889888,
    979778,
    868877,
    888987,
    779778,
    778788,
    878778,
    778898,
    879886,
    778889,
    797699,
    787788,
    787989,
    887987,
    977678,
    988977,
    778998,
    987878,
    788789,
    887787,
    797888,
    778988,
    678777,
    797878,
    789878,
    788888,
    999878,
    679679,
    886887,
    767877,
    768777,
    877887,
    679878,
    787887,
    886988,
    979988,
    886797,
    867688,
    778888,
    887897,
    896769,
    887888,
    669778,
    877778,
    778888,
    769977,
    787988,
    878768,
    869788,
    967688,
    798788,
    788868,
    796887,
    888788,
    888888,
    688879,
    888978,
    877786,
    798878,
    887699,
    876887,
    777987,
    778778,
    879778,
    787687,
    788769,
    997787,
    889867,
    988679,
    888698,
    968897,
    788887,
    869776,
    797798,
    877876,
    988798,
    978988,
    888897,
    899979,
    877877,
    888889,
    899989,
    888789,
    777878,
    787778,
    798888,
    887889,
    797899,
    978878,
    878876,
    888789,
    869899,
    877997,
    768867,
    688689,
    989887,
    877887,
    788879,
    988787,
    776976,
    788887,
    877988,
    686877,
    978887,
    778888,
    897797,
    688867,
    888888,
    779788,
    799677,
    778999,
    887989,
    896878,
    688979,
    868977,
    777978,
    787889,
    767888,
    878788,
    789777,
    878688,
    877977,
    789788,
    767878,
    988887,
    889977,
    798977,
    878877,
    988988,
    778797,
    988989,
    797887,
    787779,
    889787,
    669796,
    768788,
    889777,
    887778,
    989878,
    777988,
    878887,
    797778,
    788787,
    977869,
    797888,
    787799,
    888689,
    787988,
    977798,
    887687,
    997888,
    878967,
    878867,
    787697,
    889798,
    888897,
    988987,
    878878,
    868888,
    778797,
    786897,
    889977,
    877677,
    877967,
    886888,
    768797,
    897787,
    777987,
    887889,
    887997,
    978868,
    787868,
    977787,
    699887,
    987998,
    789789,
    997986,
    779898,
    877897,
    997968,
    977888,
    777687,
    778887,
    878886,
    787999,
    887789,
    888788,
    877678,
    899877,
    887798,
    868778,
    887997,
    777778,
    879879,
    866978,
    778798,
    998997,
    778878,
    887787,
    878879,
    978798,
    888787,
    888977,
    777899,
    998987,
    778877,
    788867,
    977779,
    777887,
    777698,
    988798,
    687779,
    778887,
    788979,
    778968,
    898887,
    887898,
    987886,
    888888,
    878778,
    778997,
    968798,
    877878,
    878777,
    777888,
    977788,
    689898,
    868996,
    987899,
    888987,
    877987,
    877987,
    997789,
    888877,
    879977,
    897888,
    777877,
    887978,
    889788,
    687877,
    688868,
    996696,
    887887,
    788977,
    778888,
    678897,
    796897,
    988978,
    797687,
    878887,
    788797,
    987888,
    889889,
    786878,
    898787,
    988789,
    897888,
    888789,
    887768,
    788887,
    897978,
    788879,
    878788,
    888677,
    778876,
    898878,
    979898,
    778778,
    897877,
    798888,
    688878,
    687767,
    978786,
    798977,
    878988,
    787898,
    898987,
    997778,
    787787,
    897788,
    887799,
    867877,
    889766,
    877888,
    787688,
    997778,
    988877,
    878789,
    788987,
    888877,
    987888,
    878888,
    867697,
    878879,
    788887,
    878978,
    889879,
    769786,
    687977,
    887989,
    777878,
    879789,
    777778,
    796888,
    887879,
    878687,
    878988,
    798798,
    887889,
    889988,
    987888,
    988768,
    978778,
    688998,
    767978,
    788977,
    987899,
    878797,
    887987,
    777897,
    886888,
    799889,
    886787,
    878878,
    697978,
    888989,
    887778,
    879777,
    998887,
    878888,
    797888,
    789868,
    778898,
    878778,
    788688,
    888797,
    987688,
    978798,
    887889,
    878778,
    789896,
    888987,
    889787,
    977666,
    689788,
    988699,
    779878,
    978888,
    886778,
    697988,
    787787,
    866788,
    788787,
    698778,
    887987,
    768868,
    979988,
    878997,
    888796,
    788887,
    978789,
    877987,
    777878,
    966688,
    788887,
    698977,
    797987,
    978868,
    777987,
    988896,
    988868,
    777988,
    787798,
    788878,
    787788,
    887888,
    897898,
    988888,
    986869,
    988897,
    788777,
    998779,
    879889,
    987897,
    887796,
    788888,
    967787,
    788887,
    878777,
    888888,
    897898,
    798777,
    777788,
    797997,
    978887,
    787878,
    988988,
    788788,
    878777,
    788876,
    889897,
    788679,
    979789,
    897897,
    888888,
    788788,
    897878,
    877787,
    688778,
    798777,
    897697,
    788887,
    877888,
    978788,
    888888,
    988788,
    898777,
    778878,
    797998,
    888888,
    878777,
    998878,
    978888,
    988788,
    888787,
    878886,
    878778,
    877788,
    898878,
    987898,
    778888,
    979887,
    877869,
    888786,
    778877,
    978888,
    786898,
    868777,
    889688,
    987869,
    976898,
    767878,
    778877,
    877678,
    867878,
    799889,
    988797,
    767787,
    788988,
    977878,
    878887,
    789787,
    888887,
    798878,
    777987,
    686997,
    877787,
    788778,
    786978,
    787888,
    898878,
    898869,
    787887,
    887778,
    988888,
    886888,
    898996,
    967686,
    898798,
    898887,
    678788,
    789777,
    888977,
    789888,
    888887,
    789778,
    787688,
    788887,
    977778,
    867789,
    889777,
    898788,
    897877,
    786888,
    878786,
    889888,
    888887,
    797887,
    787889,
    687896,
    897797,
    889798,
    887777,
    788897,
    798796,
    978678,
    798887,
    777687,
    868977,
    798878,
    777888,
    878788,
    978897,
    979787,
    869688,
    776788,
    888888,
    978779,
    878987,
    889879,
    788888,
    798898,
    788987,
    867777,
    987778,
    879789,
    787677,
    799777,
    789888,
    968879,
    689888,
    798797,
    778786,
    888766,
    879878,
    987987,
    778768,
    779798,
    679897,
    888887,
    877787,
    878897,
    787887,
    779667,
    988798,
    878886,
    897788,
    898987,
    898889,
    977788,
    986978,
    878977,
    888888,
    889988,
    987788,
    879778,
    796878,
    888988,
    889876,
    879798,
    888888,
    868888,
    898999,
    878867,
    987699,
    987867,
    878877,
    799898,
    878988,
    877797,
    799786,
    789897,
    878878,
    889888,
    797768,
    887869,
    888867,
    987878,
    877898,
    978888,
    679887,
    776879,
    889978,
    779887,
    889778,
    879989,
    788887,
    967988,
    898897,
    778797,
    778788,
    999798,
    888889,
    788879,
    889877,
    878797,
    887788,
    697767,
    878877,
    987788,
    787787,
    798777,
    797778,
    686697,
    889787,
    877789,
    879787,
    988787,
    797788,
    979678,
    779887,
    687978,
    998769,
    777987,
    878999,
    878688,
    778898,
    888888,
    867977,
    778888,
    788878,
    986888,
    777677,
    888789,
    988779,
    788877,
    777978,
    768889,
    898888,
    898888,
    889987,
    677968,
    887978,
    888788,
    997978,
    898878,
    898978,
    889687,
    888798,
    977776,
    777779,
    789897,
    677888,
    888897,
    996787,
    897897,
    887898,
    978998,
    986889,
    898877,
    787977,
    878878,
    688778,
    897886,
    887887,
    787886,
    887987,
    897979,
    978878,
    888777,
    888788,
    688889,
    877878,
    898989,
    877668,
    789878,
    778879,
    878886,
    989877,
    887978,
    987989,
    979987,
    889688,
    788778,
    768878,
    887778,
    886878,
    676779,
    778886,
    789788,
    878688,
    877787,
    987897,
    988778,
    896988,
    887987,
    789887,
    697978,
    887887,
    887888,
    887787,
    876877,
    777989,
    887868,
    789888,
    899878,
    887889,
    789877,
    788888,
    999979,
    988977,
    897988,
    888788,
    987988,
    798787,
    867898,
    887777,
    996878,
    787777,
    788987,
    678777,
    987797,
    898787,
    777888,
    777698,
    888869,
    967699,
    989877,
    978997,
    978978,
    988888,
    988899,
    978888,
    899897,
    889886,
    899798,
    888876,
    787888,
    799977,
    787678,
    889987,
    888779,
    788877,
    777989,
    777888,
    888778,
    878888,
    888676,
    978976,
    867997,
    887888,
    789987,
    779979,
    787788,
    678879,
    968886,
    878888,
    978896,
    778878,
    688779,
    767898,
    888877,
    797898,
    968788,
    798788,
    989968,
    888888,
    898978,
    987898,
    787887,
    777888,
    687787,
    897899,
    876888,
    878877,
    788888,
    768778,
    688799,
    887887,
    776879,
    778886,
    779898,
    868789,
    789878,
    888869,
    788988,
    898889,
    788987,
    888887,
    888779,
    978887,
    679789,
    898788,
    787687,
    778699,
    687888,
    878778,
    787887,
    897868,
    987868,
    888899,
    898788,
    898988,
    878787,
    678888,
    878897,
    887787,
    787979,
    898888,
    899986,
    799886,
    878878,
    987869,
    987778,
    898886,
    788899,
    676786,
    878779,
    897777,
    788879,
    888789,
    896786,
    888898,
    888778,
    879889,
    868878,
    888789,
    888877,
    789787,
    777879,
    788988,
    878778,
    898986,
    788898,
    787887,
    987888,
    868779,
    878777,
    988877,
    678789,
    887798,
    788898,
    789787,
    878797,
    779887,
    886778,
    868677,
    789897,
    797787,
    777998,
    788777,
    977778,
    877688,
    789987,
    878987,
    779769,
    887678,
    878787,
    787786,
    897798,
    778778,
    897887,
    977877,
    778877,
    798897,
    687887,
    879978,
    789976,
    878978,
    988888,
    788889,
    987789,
    988787,
    986889,
    978788,
    897689,
    889998,
    878987,
    888877,
    887879,
    878798,
    687887,
    787799,
    978778,
    788898,
    788879,
    999868,
    788688,
    787897,
    877879,
    888978,
    888777,
    898769,
    879888,
    898798,
    896889,
    866888,
    977786,
    766878,
    888768,
    899776,
    788788,
    768888,
    977788,
    776878,
    887888,
    768887,
    788889,
    877779,
    877788,
    788866,
    897889,
    997879,
    898776,
    898888,
    897888,
    779797,
    798887,
    878787,
    877787,
    978888,
    899978,
    998889,
    887878,
    787996,
    778988,
    897878,
    888897,
    787888,
    776688,
    999987,
    778779,
    887879,
    878877,
    899797,
    897788,
    878787,
    887888,
    778969,
    977978,
    877889,
    988888,
    799899,
    988867,
    879988,
    887779,
    797788,
    897787,
    978978,
    798888,
    899779,
    787787,
    798888,
    878789,
    778799,
    978789,
    777889,
    988878,
    877989,
    898877,
    789877,
    988788,
    876788,
    978778,
    989898,
    887978,
    998869,
    877678,
    988869,
    878777,
    786868,
    788778,
    877788,
    797788,
    889999,
    878678,
    868877,
    889777,
    889988,
    986779,
    987887,
    787899,
    877889,
    988898,
    888888,
    887797,
    888887,
    789888,
    888889,
    788798,
    787777,
    998997,
    687888,
    888777,
    888787,
    977687,
    989897,
    778878,
    787778,
    797989,
    678889,
    889867,
    877678,
    767898,
    797878,
    889989,
    888799,
    777798,
    679988,
    868979,
    989867,
    887888,
    787977,
    789688,
    787877,
    678879,
    768876,
    898888,
    788887,
    977798,
    978987,
    888879,
    797878,
    879798,
    897777,
    777997,
    879978,
    877887,
    777769,
    997879,
    888788,
    779779,
    677867,
    798876,
    689878,
    698789,
    889978,
    688878,
    679889,
    777679,
    988978,
    878978,
    988787,
    978888,
    889788,
    877888,
    788979,
    769887,
    897977,
    888687,
    978889,
    777888,
    987688,
    997897,
    778887,
    879988,
    978788,
    988889,
    789999,
    889887,
    877887,
    889896,
    787988,
    686888,
    878888,
    889897,
    788888,
    687789,
    768787,
    898888,
    866987,
    798878,
    798887,
    988687,
    898789,
    688887,
    978778,
    968897,
    977869,
    988779,
    979888,
    768899,
    779988,
    899777,
    799988,
    788677,
    779768,
    778887,
    789887,
    998867,
    689779,
    787888,
    868877,
    978878,
    877789,
    777888,
    968678,
    877788,
    987978,
    988989,
    887999,
    797996,
    768798,
    777887,
    687678,
    887988,
    898877,
    788889,
    867687,
    888898,
    888789,
    897888,
    778768,
    886787,
    788788,
    897779,
    986998,
    888788,
    788887,
    776888,
    968896,
    989789,
    988688,
    887998,
    878878,
    878797,
    977888,
    988889,
    776798,
    887987,
    879877,
    777768,
    887988,
    989887,
    988879,
    887778,
    888887,
    889798,
    987888,
    997788,
    887768,
    878977,
    878889,
    988779,
    788886,
    699888,
    797888,
    789987,
    888897,
    778987,
    698889,
    889887,
    776668,
    877978,
    789889,
    888998,
    787997,
    877678,
    988987,
    787997,
    787977,
    888799,
    777889,
    788796,
    788779,
    698777,
    986797,
    978788,
    879877,
    889889,
    778979,
    778896,
    797788,
    987879,
    699978,
    888898,
    986887,
    997889,
    989887,
    997877,
    988879,
    777979,
    777988,
    987996,
    788889,
    988888,
    879889,
    998979,
    797777,
    879979,
    887967,
    879688,
    887788,
    779888,
    987898,
    778979,
    988787,
    878886,
    697878,
    869869,
    688997,
    779897,
    877777,
    788978,
    788688,
    789898,
    888879,
    988787,
    877789,
    898898,
    777887,
    688798,
    898889,
    778789,
    789798,
    868898,
    687898,
    789797,
    888987,
    777697,
    888878,
    878787,
    888766,
    889789,
    989997,
    779689,
    986877,
    788978,
    778988,
    888989,
    899879,
    777776,
    978876,
    888898,
    679788,
    777777,
    878879,
    897898,
    877887,
    778878,
    787967,
    886787,
    997997,
    977787,
    788897,
    767798,
    777888,
    787878,
    688978,
    997897,
    987797,
    878998,
    889968,
    979988,
    788878,
    998987,
    787888,
    888786,
    787888,
    878777,
    879698,
    877889,
    888777,
    868788,
    888877,
    979789,
    878898,
    878988,
    887788,
    768687,
    787878,
    787768,
    887787,
    778788,
    977988,
    886989,
    879898,
    889777,
    887769,
    997767,
    788777,
    996879,
    997798,
    797977,
    888687,
    787797,
    677787,
    876877,
    888978,
    889769,
    798778,
    798988,
    889878,
    977877,
    889989,
    978879,
    898768,
    887877,
    777767,
    798988,
    798889,
    886877,
    978787,
    979887,
    788877,
    888887,
    888878,
    879896,
    889998,
    888889,
    899778,
    879877,
    686977,
    888977,
    797877,
    887878,
    788777,
    788878,
    789997,
    897888,
    977877,
    777769,
    878898,
    976789,
    878778,
    789889,
    968868,
    889968,
    879978,
    987969,
    776887,
    887677,
    886888,
    979787,
    988979,
    777987,
    889798,
    879888,
    877887,
    888997,
    878887,
    878889,
    678778,
    779868,
    899768,
    887788,
    679877,
    877787,
    787777,
    796787,
    777798,
    768787,
    887778,
    877999,
    868697,
    768788,
    787778,
    688998,
    887988,
    898778,
    886876,
    877877,
    778789,
    768788,
    978787,
    978898,
    987878,
    888879,
    896777,
    898778,
    888878,
    776769,
    877877,
    879678,
    777989,
    987888,
    898778,
    878778,
    667897,
    987977,
    988889,
    699979,
    778787,
    988686,
    798887,
    998878,
    886877,
    797779,
    679768,
    779767,
    678797,
    889997,
    889887,
    788789,
    777778,
    889868,
    799899,
    777787,
    897797,
    798879,
    988889,
    879889,
    888878,
    797988,
    987778,
    868687,
    987978,
    898787,
    879887,
    888768,
    786887,
    877797,
    788879,
    878879,
    998889,
    898899,
    988688,
    677789,
    888977,
    998787,
    687899,
    878796,
    878997,
    888878,
    877788,
    988887,
    887788,
    897678,
    689887,
    788988,
    997797,
    888878,
    887978,
    887977,
    887899,
    888787,
    877867,
    888777,
    878788,
    878888,
    769899,
    988988,
    878979,
    788797,
    989877,
    798877,
    877987,
    989798,
    798879,
    788997,
    988789,
    887768,
    878789,
    888888,
    777777,
    697977,
    997777,
    977789,
    677878,
    787989,
    866977,
    889778,
    888789,
    978789,
    897877,
    879779,
    977878,
    878898,
    999987,
    888768,
    869878,
    878886,
    998788,
    898678,
    987887,
    986797,
    878877,
    869776,
    899767,
    877878,
    678777,
    888888,
    797877,
    868989,
    888878,
    788879,
    879888,
    988679,
    887876,
    989878,
    787978,
    877887,
    678977,
    788787,
    889999,
    988897,
    889987,
    898877,
    788787,
    668877,
    878798,
    997896,
    898976,
    889886,
    867877,
    898687,
    898788,
    987779,
    888887,
    888898,
    787697,
    887778,
    887998,
    789888,
    677887,
    777899,
    779799,
    988898,
    787889,
    889878,
    676878,
    887786,
    688777,
    887689,
    889888,
    699878,
    877887,
    788997,
    888868,
    887777,
    888778,
    898987,
    867877,
    888987,
    867787,
    797978,
    989878,
    898888,
    968888,
    688869,
    898787,
    688788,
    786777,
    798897,
    887988,
    976887,
    987987,
    879888,
    989887,
    877787,
    778979,
    977787,
    878796,
    889799,
    988877,
    897678,
    788888,
    768777,
    768688,
    877998,
    878766,
    886698,
    778877,
    797988,
    879878,
    788878,
    778779,
    978767,
    888866,
    778897,
    877697,
    897798,
    787898,
    798797,
    798798,
    677887,
    787877,
    777889,
    777888,
    888987,
    798989,
    886987,
    987878,
    687878,
    987877,
    878777,
    877968,
    898876,
    787978,
    779777,
    787877,
    888899,
    777878,
    887967,
    989989,
    887888,
    886887,
    977797,
    877877,
    888777,
    788787,
    876878,
    988788,
    678788,
    788779,
    789877,
    896888,
    686977,
    977987,
    768897,
    788678,
    778897,
    797687,
    777879,
    878687,
    888877,
    688787,
    878779,
    789678,
    977866,
    778989,
    778967,
    979888,
    796787,
    698988,
    777899,
    798788,
    687889,
    888877,
    778887,
    988978,
    999986,
    777888,
    979779,
    777878,
    889788,
    777799,
    967799,
    987977,
    887868,
    779888,
    979789,
    998988,
    889788,
    789986,
    877879,
    988978,
    979789,
    799876,
    976889,
    787889,
    789898,
    877678,
    787967,
    787978,
    899788,
    897798,
    798879,
    889878,
    788878,
    798897,
    769789,
    888987,
    968788,
    889997,
    988779,
    779877,
    797898,
    877887,
    678978,
    999799,
    887877,
    896878,
    767986,
    898978,
    779787,
    888778,
    877987,
    888887,
    786886,
    898999,
    879978,
    766878,
    788978,
    889889,
    897898,
    788678,
    987796,
    888777,
    878987,
    997787,
    788897,
    779987,
    789887,
    699899,
    879789,
    889889,
    878897,
    888787,
    888888,
    678979,
    977797,
    787688,
    789989,
    797787,
    968967,
    786978,
    788687,
    879688,
    888898,
    787888,
    888697,
    768887,
    878787,
    887979,
    788879,
    879968,
    788889,
    788778,
    978889,
    798778,
    888987,
    687797,
    899788,
    788877,
    788878,
    869878,
    767888,
    787799,
    787779,
    989688,
    797799,
    889777,
    776887,
    788778,
    878777,
    988887,
    768898,
    877877,
    878769,
    878898,
    998798,
    988996,
    978988,
    887877,
    789797,
    787778,
    788878,
    897887,
    767878,
    877987,
    888877,
    878887,
    789768,
    889787,
    788988,
    798679,
    888777,
    979877,
    789898,
    778867,
    687788,
    877878,
    887777,
    798789,
    877879,
    777879,
    899878,
    979878,
    898668,
    777788,
    888897,
    888887,
    878887,
    778877,
    788778,
    879788,
    699798,
    889777,
    999987,
    877897,
    897887,
    797897,
    687787,
    777778,
    868897,
    898887,
    877799,
    998789,
    788787,
    769788,
    887689,
    887967,
    777879,
    676887,
    878897,
    778888,
    877778,
    879887,
    778898,
    788989,
    687888,
    978688,
    989989,
    889787,
    898898,
    899888,
    977889,
    778976,
    989887,
    787787,
    897888,
    788887,
    998879,
    797899,
    788799,
    888678,
    898778,
    978988,
    687887,
    998798,
    678777,
    787887,
    877977,
    889878,
    898878,
    777888,
    877888,
    778788,
    967797,
    887888,
    878888,
    887889,
    898879,
    887888,
    789777,
    979768,
    687888,
    787789,
    779979,
    979889,
    788887,
    977887,
    989789,
    889788,
    887977,
    887886,
    787777,
    787988,
    887897,
    978878,
    877876,
    798877,
    897998,
    978888,
    878879,
    999697,
    888797,
    987787,
    977879,
    789877,
    878887,
    897788,
    998888,
    988889,
    998789,
    687778,
    878769,
    688997,
    888878,
    988887,
    888989,
    789789,
    779798,
    788887,
    777789,
    988798,
    779787,
    877988,
    788888,
    879787,
    868888,
    978989,
    997789,
    878797,
    678988,
    897977,
    888876,
    789887,
    677979,
    787799,
    788898,
    899899,
    777988,
    869887,
    678789,
    886987,
    888888,
    789887,
    988988,
    989898,
    989987,
    978889,
    788778,
    787677,
    878788,
    886878,
    798986,
    779988,
    779676,
    786777,
    886888,
    776887,
    686897,
    788888,
    768987,
    887976,
    896898,
    797878,
    897778,
    887888,
    969888,
    878896,
    897887,
    888777,
    778799,
    888988,
    789879,
    776887,
    789988,
    888877,
    869886,
    888887,
    888877,
    997879,
    787889,
    998888,
    988789,
    797777,
    769978,
    897978,
    887878,
    888787,
    898687,
    787687,
    899788,
    978877,
    878977,
    887779,
    789779,
    976877,
    778787,
    769788,
    898777,
    777877,
    789669,
    899887,
    789888,
    887878,
    986788,
    978878,
    677787,
    998887,
    777899,
    876967,
    877888,
    778887,
    978867,
    899778,
    877788,
    788798,
    988869,
    898889,
    887978,
    887979,
    778797,
    887986,
    887897,
    889799,
    798878,
    798889,
    689888,
    789876,
    887898,
    878879,
    787788,
    767987,
    777868,
    888788,
    797798,
    888796,
    887878,
    989787,
    887897,
    886776,
    797898,
    789888,
    998877,
    899776,
    789998,
    989778,
    677977,
    988889,
    878888,
    777787,
    789789,
    887798,
    787888,
    768777,
    879869,
    797887,
    897879,
    788878,
    788898,
    988887,
    787889,
    978787,
    778898,
    777989,
    887789,
    888996,
    776677,
    889896,
    778798,
    877867,
    678878,
    867888,
    987888,
    778887,
    777887,
    777687,
    989979,
    978987,
    898787,
    868978,
    878676,
    887778,
    696987,
    878998,
    978787,
    878889,
    888878,
    997878,
    868897,
    877788,
    898877,
    879996,
    887788,
    888888,
    767878,
    988889,
    887888,
    788787,
    776877,
    878888,
    878778,
    977879,
    888787,
    798787,
    788878,
    989899,
    898798,
    889779,
    989968,
    777997,
    887979,
    887887,
    978778,
    776776,
    897888,
    787778,
    878898,
    967778,
    787888,
    877898,
    877878,
    967989,
    778878,
    878979,
    877887,
    688977,
    778887,
    879697,
    988877,
    898986,
    889869,
    986778,
    878879,
    879898,
    977779,
    776968,
    898979,
    868678,
    679879,
    897786,
    687998,
    686878,
    796876,
    878879,
    798787,
    887869,
    779876,
    889787,
    786878,
    798687,
    887887,
    688888,
    987877,
    878887,
    868878,
    688879,
    687778,
    778887,
    879698,
    988777,
    778987,
    798878,
    787999,
    897889,
    798787,
    978878,
    889899,
    997987,
    799777,
    687788,
    878878,
    967988,
    998899,
    887999,
    888869,
    787888,
    788778,
    867778,
    779897,
    778798,
    799699,
    897788,
    899887,
    978787,
    898877,
    789898,
    778878,
    879988,
    898978,
    899777,
    888888,
    679887,
    978787,
    688876,
    898898,
    687877,
    787999,
    797889,
    787797,
    787877,
    887777,
    797976,
    779888,
    877677,
    788988,
    868867,
    797789,
    888679,
    787798,
    888679,
    687866,
    888879,
    789988,
    777898,
    887888,
    977777,
    677877,
    776868,
    787877,
    878998,
    877887,
    779778,
    888878,
    898896,
    788878,
    797788,
    778768,
    787877,
    888788,
    869979,
    777767,
    888677,
    888778,
    879778,
    977887,
    797887,
    878978,
    977798,
    878766,
    888868,
    688777,
    879689,
    788897,
    888989,
    798788,
    978897,
    797787,
    768899,
    787878,
    787788,
    787988,
    997779,
    797877,
    778898,
    878877,
    796887,
    886687,
    898999,
    789777,
    798877,
    678776,
    798979,
    999779,
    898776,
    887797,
    777888,
    888988,
    897878,
    887967,
    988879,
    888887,
    888888,
    876699,
    997776,
    977688,
    877867,
    997787,
    876989,
    787778,
    887888,
    797787,
    977896,
    888787,
    778778,
    787898,
    879978,
    887978,
    986778,
    788889,
    788879,
    676888,
    798888,
    798688,
    878787,
    898789,
    977777,
    967888,
    698887,
    898977,
    887788,
    786878,
    989787,
    988768,
    788888,
    987889,
    878789,
    688698,
    887887,
    779898,
    897887,
    888678,
    788779,
    897889,
    788796,
    878779,
    798897,
    899876,
    787879,
    798988,
    887887,
    797878,
    988878,
    778988,
    877778,
    797789,
    888999,
    798879,
    676888,
    767789,
    767888,
    789788,
    988799,
    778886,
    898888,
    988889,
    999887,
    898787,
    887878,
    987878,
    688878,
    878778,
    868778,
    868887,
    778677,
    888867,
    977879,
    788878,
    987887,
    778789,
    877797,
    779988,
    887787,
    688788,
    887787,
    888777,
    998887,
    879887,
    897867,
    889887,
    898978,
    779868,
    777877,
    877889,
    887877,
    888887,
    878778,
    886797,
    979879,
    778879,
    777877,
    979788,
    789869,
    867877,
    998888,
    888788,
    798688,
    788769,
    998788,
    979777,
    877888,
    787888,
    889998,
    887789,
    867878,
    769788,
    898888,
    978888,
    867878,
    789899,
    887687,
    869899,
    698697,
    898886,
    879888,
    797898,
    789888,
    898877,
    878777,
    897986,
    969898,
    897976,
    776796,
    776867,
    778888,
    778888,
    799887,
    878777,
    776888,
    988799,
    777988,
    878887,
    677988,
    879987,
    987978,
    787879,
    889799,
    878978,
    688889,
    998788,
    788786,
    879888,
    776888,
    896787,
    678988,
    987878,
    788778,
    788887,
    778989,
    876897,
    788988,
    778999,
    988898,
    977987,
    786797,
    676879,
    688688,
    787799,
    867777,
    788678,
    976789,
    898888,
    779889,
    978787,
    898888,
    797688,
    678999,
    897697,
    688779,
    688888,
    999698,
    889987,
    878777,
    987788,
    989777,
    868679,
    867786,
    889888,
    877888,
    797898,
    776676,
    898786,
    678787,
    889899,
    887787,
    888888,
    887889,
    977877,
    778778,
    878888,
    866868,
    867788,
    889887,
    878678,
    797988,
    777989,
    799879,
    788869,
    887868,
    878888,
    778877,
    778787,
    786897,
    878788,
    879887,
    877968,
    888799,
    787978,
    897887,
    886778,
    988878,
    898687,
    898797,
    999899,
    877889,
    889897,
    776867,
    888777,
    887678,
    777887,
    897787,
    898888,
    788797,
    887788,
    876768,
    969788,
    877878,
    798997,
    879697,
    789978,
    998788,
    899889,
    978799,
    889878,
    887797,
    889989,
    868988,
    688787,
    778877,
    798988,
    897887,
    887888,
    897887,
    878779,
    888876,
    787697,
    967678,
    777878,
    968998,
    879798,
    898969,
    887888,
    897788,
    888788,
    888896,
    986976,
    988988,
    878688,
    787799,
    988786,
    968797,
    987879,
    978897,
    877799,
    797677,
    877997,
    987977,
    788987,
    878987,
    777798,
    777787,
    876887,
    889887,
    797998,
    878687,
    788798,
    779999,
    788789,
    887989,
    889878,
    788869,
    689877,
    678777,
    788987,
    688978,
    978798,
    888898,
    887798,
    889799,
    998887,
    877977,
    798877,
    687777,
    888878,
    899778,
    786889,
    799788,
    887888,
    698988,
    877968,
    889788,
    878887,
    798788,
    778787,
    898888,
    878877,
    797877,
    788967,
    987698,
    688989,
    879889,
    878899,
    798888,
    897978,
    788877,
    996788,
    878997,
    998967,
    879679,
    888888,
    888987,
    788799,
    889787,
    888987,
    798778,
    997977,
    878877,
    899888,
    998978,
    888767,
    788799,
    778898,
    879876,
    977977,
    977697,
    789986,
    788989,
    997867,
    887788,
    678798,
    888899,
    967889,
    878879,
    888987,
    898877,
    777779,
    989978,
    888977,
    888889,
    888887,
    797897,
    886988,
    899788,
    686888,
    987778,
    788878,
    678799,
    878796,
    879989,
    878687,
    988988,
    888878,
    777987,
    788987,
    999877,
    886878,
    977878,
    977978,
    898898,
    769999,
    887778,
    799788,
    878788,
    796997,
    777787,
    988868,
    877779,
    989788,
    887899,
    777797,
    878797,
    897988,
    669878,
    887777,
    797788,
    897879,
    887889,
    686989,
    797997,
    889778,
    877889,
    877777,
    799676,
    987989,
    968887,
    788897,
    789877,
    889878,
    787798,
    787889,
    879987,
    788878,
    687898,
    899887,
    777769,
    697897,
    988799,
    887877,
    776788,
    678698,
    977988,
    899878,
    977987,
    786778,
    998897,
    988879,
    878888,
    887788,
    979987,
    878788,
    888987,
    878987,
    778897,
    876887,
    998888,
    887789,
    988888,
    898877,
    988898,
    687897,
    878768,
    889777,
    678878,
    789989,
    979898,
    879788,
    986787,
    876998,
    878798,
    989688,
    898788,
    987889,
    897889,
    889786,
    787889,
    977868,
    989778,
    877888,
    687788,
    788868,
    787799,
    888988,
    976778,
    887787,
    778979,
    797978,
    777988,
    788788,
    898888,
    879888,
    889887,
    977887,
    867699,
    979886,
    889788,
    877888,
    889889,
    988779,
    977888,
    778898,
    787898,
    798797,
    889877,
    897777,
    786688,
    868977,
    798988,
    879888,
    697777,
    678788,
    988886,
    887888,
    989897,
    788788,
    898988,
    888789,
    887688,
    788778,
    898976,
    787777,
    887788,
    878777,
    978879,
    788799,
    799888,
    867797,
    886889,
    899888,
    888888,
    877977,
    779898,
    968878,
    679888,
    867789,
    967778,
    988888,
    788987,
    988988,
    989898,
    787798,
    789698,
    778787,
    887887,
    878997,
    776897,
    878888,
    986878,
    798798,
    779998,
    897798,
    878988,
    788788,
    899767,
    697779,
    887898,
    798988,
    888878,
    778889,
    877977,
    668897,
    976777,
    877986,
    889787,
    787787,
    986788,
    988688,
    798777,
    888979,
    788896,
    877778,
    887787,
    887787,
    777966,
    798788,
    866778,
    879977,
    789788,
    898887,
    989889,
    888788,
    787888,
    797797,
    777888,
    878878,
    989789,
    787768,
    989988,
    878799,
    789678,
    898797,
    888978,
    878878,
    898889,
    799779,
    788888,
    668978,
    688887,
    977877,
    888898,
    688797,
    789979,
    888787,
    787966,
    787897,
    979988,
    888978,
    888886,
    688887,
    879887,
    877779,
    876889,
    988687,
    976979,
    979888,
    888877,
    788878,
    777879,
    987889,
    788878,
    869888,
    788786,
    987788,
    886778,
    876788,
    998868,
    677687,
    887896,
    797687,
    787888,
    989966,
    867778,
    777987,
    887788,
    686978,
    978678,
    778887,
    987889,
    888879,
    777877,
    888977,
    898866,
    886988,
    789898,
    786777,
    976967,
    986868,
    889898,
    996879,
    879889,
    878776,
    787888,
    988768,
    899988,
    878789,
    878788,
    998897,
    878978,
    877887,
    978888,
    888977,
    887779,
    878779,
    968978,
    977887,
    779888,
    897777,
    778888,
    879767,
    977968,
    998888,
    968788,
    867987,
    788897,
    788796,
    998888,
    777879,
    778687,
    978867,
    986987,
    868877,
    778889,
    887799,
    766889,
    877777,
    788886,
    888897,
    899788,
    798898,
    889778,
    888786,
    788778,
    988898,
    887678,
    788789,
    889997,
    878987,
    987988,
    798887,
    888788,
    678878,
    788877,
    878997,
    677687,
    788877,
    789788,
    677788,
    868789,
    869977,
    788687,
    989889,
    899787,
    796888,
    786988,
    677967,
    887978,
    677787,
    788988,
    979789,
    887897,
    788899,
    999788,
    887988,
    888778,
    989879,
    777888,
    787898,
    897876,
    879788,
    868787,
    886788,
    787797,
    778679,
    778968,
    877767,
    777798,
    898969,
    887877,
    889897,
    977798,
    997877,
    876877,
    897897,
    878887,
    888768,
    787778,
    767897,
    787997,
    777888,
    998877,
    797977,
    886688,
    889886,
    989787,
    779988,
    777888,
    889898,
    887877,
    869789,
    878998,
    867898,
    879877,
    977797,
    787789,
    888699,
    889678,
    687897,
    866788,
    976887,
    768687,
    797776,
    886887,
    899787,
    989866,
    787888,
    697988,
    868898,
    878987,
    777787,
    767868,
    897777,
    677887,
    797978,
    878697,
    798898,
    888788,
    798889,
    788778,
    879779,
    888889,
    878777,
    889787,
    887977,
    888779,
    787798,
    788799,
    787788,
    989879,
    879988,
    787789,
    868788,
    878887,
    878979,
    886779,
    888687,
    988997,
    687887,
    897977,
    798997,
    999888,
    879779,
    878778,
    868877,
    887789,
    878978,
    788878,
    876998,
    889889,
    888677,
    797788,
    889889,
    788987,
    879969,
    778867,
    886687,
    779878,
    777878,
    889897,
    976887,
    889886,
    777966,
    979869,
    888787,
    698888,
    798868,
    777988,
    897987,
    897997,
    878987,
    778778,
    877686,
    889787,
    678678,
    978798,
    987767,
    988768,
    878888,
    786787,
    778768,
    788889,
    789988,
    787878,
    778977,
    798976,
    887886,
    898876,
    988878,
    987878,
    879868,
    687798,
    789886,
    777878,
    979886,
    687798,
    867788,
    778778,
    869998,
    987888,
    877978,
    798887,
    998767,
    689989,
    877889,
    888879,
    898788,
    687897,
    888897,
    897886,
    877778,
    777788,
    998879,
    889789,
    869878,
    698888,
    877988,
    769887,
    777988,
    897896,
    788889,
    777888,
    788987,
    779877,
    678886,
    797679,
    879886,
    878788,
    777896,
    986778,
    999878,
    786899,
    876877,
    997778,
    989788,
    878898,
    978978,
    786798,
    778879,
    889788,
    898899,
    878687,
    798778,
    877889,
    677789,
    887878,
    889889,
    999899,
    879987,
    888978,
    798797,
    867878,
    878779,
    778788,
    778688,
    998967,
    897879,
    878778,
    787977,
    986987,
    898787,
    798987,
    897899,
    766799,
    888797,
    887987,
    997877,
    889977,
    686767,
    988997,
    887788,
    776869,
    897888,
    868887,
    788898,
    789888,
    878877,
    768878,
    878998,
    988868,
    768887,
    887888,
    886787,
    688668,
    777897,
    778987,
    789867,
    886887,
    676887,
    789877,
    887797,
    878979,
    677797,
    788877,
    766897,
    688798,
    887878,
    788698,
    777887,
    788879,
    978887,
    789888,
    797788,
    868997,
    787798,
    888788,
    789787,
    887877,
    787887,
    889878,
    887879,
    887988,
    886887,
    877867,
    898787,
    778978,
    988697,
    798877,
    776797,
    787898,
    879869,
    787787,
    778796,
    779888,
    997777,
    968887,
    868978,
    888988,
    877797,
    877977,
    787987,
    888968,
    877888,
    788888,
    877689,
    888888,
    886788,
    986978,
    889878,
    878878,
    779789,
    787897,
    798988,
    879878,
    987876,
    996887,
    887877,
    888888,
    788778,
    877898,
    888788,
    787788,
    888777,
    886888,
    888988,
    987986,
    997798,
    799778,
    788879,
    789887,
    787878,
    887888,
    979687,
    779987,
    776878,
    978787,
    786878,
    877899,
    888797,
    786777,
    797798,
    786878,
    778878,
    779968,
    677798,
    789887,
    978997,
    897898,
    978888,
    787999,
    898978,
    879888,
    889687,
    888868,
    888989,
    878797,
    779787,
    979887,
    879698,
    868898,
    977687,
    786879,
    787878,
    887877,
    968888,
    788879,
    979988,
    798897,
    778789,
    888788,
    788988,
    877978,
    788869,
    977878,
    878888,
    896778,
    897688,
    788688,
    889888,
    767888,
    788899,
    878868,
    898797,
    898987,
    798799,
    899887,
    887797,
    778779,
    789877,
    988977,
    786978,
    779988,
    999788,
    688778,
    878799,
    877778,
    678697,
    879798,
    777778,
    989878,
    789899,
    889889,
    877896,
    787867,
    797898,
    868878,
    889979,
    887877,
    988887,
    697787,
    777798,
    778788,
    798998,
    788798,
    988789,
    679998,
    879899,
    787778,
    667978,
    877888,
    897978,
    898777,
    888977,
    987786,
    988899,
    778986,
    779878,
    886798,
    979697,
    997768,
    888789,
    977889,
    798967,
    887888,
    977887,
    888988,
    687689,
    788978,
    877868,
    787778,
    787967,
    688978,
    778687,
    898788,
    888889,
    889989,
    797888,
    878998,
    878898,
    887876,
    969787,
    787689,
    877787,
    788988,
    788898,
    678788,
    887778,
    888678,
    779888,
    768989,
    888969,
    998889,
    898779,
    978979,
    769999,
    988678,
    787997,
    798688,
    888777,
    976888,
    876797,
    878898,
    779867,
    887886,
    978878,
    797788,
    886798,
    789898,
    688986,
    879979,
    977887,
    987877,
    877777,
    677988,
    777997,
    788878,
    876887,
    779878,
    777788,
    987698,
    978977,
    788798,
    788789,
    778797,
    888777,
    878798,
    878897,
    979788,
    777988,
    688886,
    798989,
    978887,
    778888,
    678779,
    998779,
    777778,
    888767,
    878778,
    868897,
    798778,
    888889,
    988887,
    789887,
    978799,
    789788,
    878787,
    798887,
    876779,
    777867,
    998868,
    876888,
    787866,
    777779,
    688898,
    987799,
    879889,
    877888,
    968877,
    898898,
    877876,
    997797,
    798778,
    768987,
    779998,
    987987,
    887978,
    877898,
    888979,
    768889,
    887987,
    796998,
    788888,
    799868,
    888888,
    888868,
    877687,
    988987,
    686888,
    978797,
    778788,
    878879,
    888989,
    888867,
    997987,
    889989,
    676888,
    889887,
    879977,
    877989,
    989787,
    888797,
    897878,
    878878,
    788879,
    887887,
    798988,
    987878,
    788987,
    888986,
    988877,
    889998,
    979977,
    798776,
    897988,
    787887,
    889978,
    878988,
    788868,
    978889,
    689869,
    778987,
    787868,
    886797,
    887899,
    979688,
    896887,
    867788,
    977887,
    886877,
    876667,
    779789,
    898888,
    877796,
    888788,
    778787,
    897887,
    768888,
    766887,
    996888,
    977778,
    799887,
    778788,
    677888,
    888999,
    877779,
    987987,
    897798,
    898887,
    987797,
    988888,
    769999,
    877778,
    799798,
    789798,
    788677,
    779887,
    887977,
    888877,
    877869,
    878977,
    789788,
    977887,
    788798,
    877897,
    878988,
    987868,
    888878,
    799777,
    898769,
    887678,
    788899,
    988967,
    979997,
    787778,
    789777,
    879998,
    797888,
    788888,
    789897,
    887888,
    789888,
    798788,
    789889,
    789998,
    988768,
    688977,
    889887,
    877888,
    779889,
    788778,
    896787,
    787898,
    888787,
    789898,
    798888,
    998678,
    886886,
    989897,
    886887,
    787798,
    788789,
    997889,
    878766,
    788788,
    876776,
    776977,
    877876,
    787887,
    877788,
    779796,
    898887,
    798797,
    878878,
    798897,
    798987,
    998888,
    876779,
    786788,
    878878,
    796779,
    777887,
    888988,
    887787,
    897778,
    888898,
    687787,
    688978,
    979878,
    687788,
    977977,
    777878,
    998976,
    877789,
    888888,
    798899,
    788889,
    987877,
    787888,
    878777,
    788887,
    898776,
    668987,
    789786,
    988888,
    886897,
    898889,
    897789,
    778888,
    679778,
    789896,
    796788,
    888878,
    888889,
    888769,
    868978,
    886797,
    888898,
    977798,
    898888,
    889887,
    889979,
    989778,
    868898,
    678778,
    769798,
    789778,
    887976,
    789898,
    986797,
    887888,
    776768,
    799787,
    878697,
    877787,
    887787,
    888989,
    887878,
    988988,
    797798,
    889787,
    678788,
    889986,
    888789,
    776866,
    877997,
    788988,
    989878,
    798778,
    797797,
    768788,
    969687,
    768987,
    788797,
    878898,
    678868,
    678879,
    887886,
    967778,
    799978,
    997978,
    877787,
    789888,
    878767,
    778787,
    898797,
    888878,
    868887,
    889788,
    879888,
    899886,
    887988,
    968878,
    889968,
    968877,
    898887,
    768688,
    898677,
    976788,
    699786,
    777878,
    779789,
    767887,
    889888,
    887699,
    878979,
    978899,
    888866,
    698779,
    788898,
    888876,
    769789,
    977987,
    778988,
    888688,
    778688,
    989978,
    889688,
    998777,
    988789,
    788798,
    978889,
    868679,
    986678,
    988878,
    889898,
    778899,
    788878,
    987877,
    788877,
    877798,
    898987,
    987877,
    878787,
    777997,
    889777,
    888788,
    888898,
    687798,
    888877,
    686887,
    789886,
    988876,
    878777,
    777888,
    977888,
    787767,
    876977,
    978799,
    678978,
    878788,
    987878,
    987788,
    786788,
    786989,
    887788,
    877898,
    768967,
    788887,
    888886,
    887878,
    778867,
    777879,
    888877,
    678988,
    879788,
    977686,
    778898,
    877698,
    888887,
    987877,
    879778,
    989878,
    977877,
    786889,
    788878,
    988888,
    888878,
    778778,
    898876,
    887977,
    877879,
    776787,
    899889,
    788977,
    888888,
    879998,
    788887,
    877988,
    698887,
    896997,
    779777,
    988868,
    867788,
    789978,
    889879,
    888769,
    888967,
    798786,
    789768,
    877998,
    997888,
    867787,
    698877,
    798988,
    688799,
    887777,
    789897,
    999997,
    777768,
    788877,
    887898,
    887778,
    788899,
    878779,
    788789,
    797889,
    968897,
    878979,
    978969,
    878889,
    787998,
    887889,
    988777,
    687879,
    668888,
    979769,
    889799,
    688877,
    878998,
    776768,
    879687,
    978878,
    788879,
    878988,
    877897,
    887888,
    787878,
    888778,
    799878,
    888877,
    876688,
    877868,
    886769,
    879899,
    898987,
    888788,
    987988,
    877797,
    988777,
    988888,
    888899,
    988887,
    697888,
    787887,
    997988,
    896769,
    799898,
    878689,
    697998,
    897888,
    998878,
    978898,
    799988,
    878987,
    889878,
    788797,
    788798,
    778898,
    997778,
    888778,
    787898,
    997888,
    887877,
    788787,
    789877,
    878779,
    899786,
    867998,
    878888,
    787898,
    998688,
    888888,
    898888,
    788788,
    678798,
    778788,
    988777,
    889997,
    887877,
    789777,
    988787,
    899888,
    987898,
    887787,
    989778,
    786888,
    987877,
    878769,
    889988,
    788987,
    676887,
    868968,
    797787,
    688798,
    888889,
    877876,
    878888,
    888877,
    779788,
    788878,
    879988,
    788777,
    887877,
    887669,
    899879,
    799697,
    778788,
    788767,
    989778,
    788889,
    788779,
    878799,
    798976,
    878988,
    779787,
    678787,
    867888,
    898977,
    987787,
    676879,
    667687,
    879888,
    788787,
    878888,
    686897,
    878889,
    788888,
    778689,
    778988,
    888788,
    979887,
    777698,
    878788,
    887679,
    678989,
    898799,
    788886,
    887766,
    897679,
    786988,
    988868,
    988787,
    989778,
    989778,
    788988,
    779889,
    787789,
    676889,
    887868,
    899789,
    898787,
    997889,
    887798,
    767777,
    987786,
    887787,
    789879,
    978799,
    978888,
    897987,
    977788,
    797777,
    888788,
    988879,
    898879,
    968888,
    869888,
    897969,
    676688,
    777888,
    988798,
    987879,
    888877,
    787877,
    699688,
    898888,
    887788,
    778979,
    787799,
    968988,
    987988,
    789978,
    898899,
    798787,
    678777,
    678879,
    787987,
    788799,
    777786,
    777988,
    888789,
    888889,
    987897,
    868888,
    688886,
    776987,
    898887,
    988879,
    989699,
    798689,
    877788,
    987797,
    879988,
    797899,
    888878,
    779777,
    869889,
    688879,
    877778,
    789778,
    798989,
    988797,
    899998,
    888797,
    889977,
    768789,
    778667,
    789796,
    899777,
    887989,
    887969,
    698998,
    899987,
    797677,
    878787,
    767877,
    878999,
    777899,
    989898,
    988887,
    888989,
    768898,
    777988,
    787888,
    897678,
    689779,
    989997,
    788889,
    778788,
    797899,
    986987,
    888686,
    887897,
    788788,
    898887,
    678788,
    887788,
    797889,
    889678,
    787888,
    789788,
    889877,
    777868,
    897687,
    988787,
    789979,
    886878,
    678889,
    889887,
    769898,
    888898,
    888978,
    979887,
    789977,
    898898,
    898987,
    798788,
    977887,
    888698,
    988787,
    788867,
    888899,
    789787,
    878688,
    879777,
    978978,
    888768,
    986988,
    799787,
    699997,
    878898,
    888687,
    877887,
    788888,
    996998,
    799888,
    688798,
    887878,
    897777,
    778768,
    778889,
    668879,
    786786,
    787887,
    788987,
    778787,
    888868,
    877669,
    988967,
    777978,
    798997,
    778798,
    788867,
    898789,
    987776,
    787876,
    876786,
    798678,
    967777,
    868769,
    887789,
    878866,
    799788,
    898877,
    799798,
    778877,
    777798,
    799777,
    799867,
    887877,
    777778,
    889789,
    897788,
    988879,
    887867,
    776778,
    888879,
    787678,
    787988,
    797788,
    888766,
    878888,
    788986,
    686787,
    987988,
    898779,
    999786,
    797887,
    977977,
    679969,
    989887,
    877898,
    878798,
    997788,
    888777,
    878887,
    778997,
    889987,
    798789,
    878988,
    878888,
    799877,
    976789,
    997778,
    879897,
    788997,
    899878,
    688788,
    777888,
    887787,
    898776,
    886887,
    888788,
    989778,
    777979,
    888788,
    799888,
    789889,
    787978,
    867887,
    698987,
    777867,
    898888,
    788898,
    887979,
    787788,
    788889,
    888968,
    897977,
    887797,
    798987,
    797999,
    877897,
    888988,
    797768,
    778987,
    698977,
    889887,
    778988,
    688887,
    888979,
    987897,
    698898,
    979889,
    779877,
    876876,
    898769,
    787887,
    776676,
    787988,
    777788,
    877788,
    876878,
    879786,
    667889,
    688778,
    768968,
    798788,
    887878,
    879686,
    898988,
    868877,
    778898,
    888786,
    888888,
    888866,
    888687,
    778777,
    998878,
    889889,
    879886,
    889978,
    888896,
    978877,
    788976,
    788876,
    998979,
    788977,
    898887,
    798787,
    878778,
    788798,
    987978,
    789687,
    798898,
    887889,
    887877,
    679976,
    887988,
    797897,
    877988,
    778879,
    868768,
    877999,
    888877,
    867997,
    977888,
    878988,
    886878,
    778778,
    898887,
    888778,
    776788,
    688778,
    778968,
    867889,
    788788,
    888988,
    988788,
    879886,
    888789,
    878978,
    889888,
    979898,
    888997,
    898997,
    898867,
    898978,
    768888,
    889888,
    778998,
    698788,
    787777,
    778877,
    799988,
    797877,
    787898,
    779787,
    798887,
    779786,
    888898,
    798878,
    789898,
    889877,
    867788,
    777789,
    979787,
    879888,
    689898,
    989879,
    868867,
    879987,
    779789,
    677888,
    777788,
    687867,
    788889,
    678777,
    986978,
    786878,
    888879,
    889899,
    888988,
    979686,
    778967,
    989678,
    798898,
    878978,
    787887,
    788887,
    987787,
    786888,
    778878,
    898776,
    887787,
    769796,
    787978,
    869886,
    778988,
    799886,
    779987,
    988899,
    797988,
    879887,
    777989,
    697777,
    879886,
    898787,
    887899,
    797778,
    798789,
    777869,
    977888,
    887788,
    987898,
    888788,
    799877,
    777788,
    697687,
    987977,
    898879,
    887778,
    797969,
    687689,
    978879,
    878878,
    889779,
    978798,
    798997,
    897887,
    778778,
    969978,
    888897,
    898988,
    998896,
    886887,
    688878,
    787889,
    888887,
    868788,
    888798,
    887889,
    767877,
    997888,
    889887,
    888989,
    787778,
    988888,
    978767,
    887689,
    787889,
    899969,
    788788,
    789878,
    988988,
    779797,
    788897,
    888869,
    998899,
    788996,
    879997,
    887787,
    896688,
    768967,
    897897,
    868788,
    878979,
    889887,
    788968,
    987777,
    788899,
    888688,
    778878,
    878788,
    887889,
    976898,
    798868,
    798899,
    899868,
    898987,
    698869,
    889877,
    888988,
    789968,
    688879,
    798988,
    877688,
    779887,
    988698,
    778867,
    898898,
    887987,
    998789,
    887887,
    998887,
    889788,
    887798,
    887777,
    898897,
    889786,
    887887,
    988778,
    876888,
    688778,
    879687,
    789879,
    888678,
    787878,
    688987,
    898998,
    988889,
    997979,
    897898,
    889777,
    898767,
    889788,
    887777,
    888787,
    887997,
    799798,
    888877,
    788778,
    887786,
    778878,
    878867,
    897778,
    967987,
    787798,
    867879,
    887887,
    877897,
    889777,
    799678,
    678989,
    677878,
    788777,
    897789,
    878878,
    877777,
    778979,
    887987,
    886789,
    988778,
    677797,
    798799,
    896877,
    778688,
    788678,
    798976,
    979687,
    888776,
    677779,
    888887,
    788787,
    789979,
    989878,
    889799,
    786989,
    978878,
    978887,
    677798,
    888887,
    786897,
    899697,
    898887,
    868896,
    778777,
    899788,
    698877,
    999968,
    988988,
    778978,
    678987,
    767777,
    778998,
    776788,
    778877,
    677678,
    778788,
    788878,
    878878,
    799989,
    888887,
    897897,
    788887,
    788787,
    978978,
    969777,
    788788,
    968788,
    977877,
    787987,
    979787,
    978877,
    987977,
    799998,
    878876,
    898988,
    677999,
    888877,
    987979,
    988779,
    878777,
    866778,
    988887,
    987796,
    679768,
    768778,
    878789,
    868779,
    889788,
    898878,
    886997,
    698766,
    767878,
    677869,
    877798,
    789787,
    898997,
    698878,
    877787,
    887689,
    889977,
    776978,
    978787,
    797799,
    777989,
    788888,
    987799,
    797887,
    877898,
    778967,
    787877,
    878898,
    999789,
    887677,
    967868,
    988988,
    787888,
    698788,
    897899,
    886897,
    898788,
    789766,
    978877,
    998978,
    868788,
    777879,
    877687,
    789878,
    976778,
    988867,
    997696,
    787988,
    897888,
    887688,
    768786,
    788887,
    778799,
    977868,
    968968,
    878888,
    678888,
    879778,
    778888,
    678669,
    787789,
    878988,
    987897,
    786897,
    898888,
    787779,
    988997,
    887989,
    888879,
    987977,
    888788,
    877779,
    666867,
    878787,
    786866,
    878898,
    887797,
    788888,
    787798,
    779997,
    886677,
    987787,
    887789,
    887768,
    778887,
    888887,
    878879,
    796878,
    888897,
    688889,
    789878,
    677887,
    778878,
    898987,
    798998,
    788887,
    889888,
    898977,
    788987,
    799877,
    977876,
    687689,
    888689,
    888887,
    788978,
    899988,
    997698,
    997987,
    888788,
    678888,
    988899,
    777698,
    986788,
    688886,
    677778,
    898698,
    789877,
    899788,
    878896,
    899878,
    877987,
    976876,
    887888,
    787777,
    887787,
    999788,
    687888,
    897788,
    887796,
    877886,
    877898,
    898787,
    887997,
    878886,
    777887,
    978897,
    778988,
    668889,
    897786,
    889789,
    788789,
    798977,
    796697,
    878698,
    998798,
    878898,
    776988,
    977886,
    897977,
    888778,
    798778,
    869887,
    879889,
    878887,
    798889,
    869987,
    886897,
    876789,
    797878,
    878868,
    877699,
    978787,
    969879,
    888977,
    788769,
    979989,
    789668,
    868888,
    779787,
    779777,
    978979,
    797897,
    787889,
    967898,
    897898,
    888877,
    888898,
    789879,
    889978,
    868888,
    787797,
    977877,
    979897,
    788767,
    978777,
    998877,
    888888,
    789777,
    787997,
    789787,
    777889,
    798878,
    876798,
    989788,
    698888,
    688777,
    888888,
    898887,
    797898,
    878788,
    987766,
    988888,
    797778,
    797787,
    778888,
    888989,
    899778,
    689878,
    767889,
    988888,
    978877,
    977887,
    789788,
    786868,
    977998,
    889888,
    677989,
    866788,
    877898,
    878978,
    787888,
    787787,
    869687,
    888879,
    677777,
    867888,
    878978,
    877978,
    789987,
    879778,
    887789,
    779788,
    767877,
    878778,
    866697,
    897987,
    997787,
    977889,
    788877,
    878777,
    876868,
    879798,
    898898,
    688879,
    878877,
    888889,
    767989,
    877978,
    777977,
    887897,
    778877,
    867787,
    978887,
    977887,
    889978,
    898977,
    876697,
    877868,
    789789,
    768988,
    878788,
    977777,
    698787,
    979979,
    988988,
    888787,
    976987,
    987878,
    789977,
    888877,
    987878,
    877897,
    789879,
    778978,
    888978,
    897888,
    888778,
    677878,
    788888,
    878787,
    786877,
    788888,
    897897,
    978879,
    886878,
    877888,
    888788,
    688797,
    878879,
    888879,
    887687,
    979787,
    888878,
    899888,
    887987,
    678896,
    677688,
    988797,
    977777,
    879788,
    878689,
    678778,
    778879,
    886787,
    889988,
    797887,
    878788,
    778879,
    879998,
    897999,
    778888,
    898997,
    889877,
    878789,
    879996,
    988987,
    797888,
    877778,
    696877,
    877889,
    787888,
    897897,
    887779,
    768787,
    797979,
    887997,
    689897,
    788877,
    898768,
    787787,
    787877,
    867877,
    876887,
    878978,
    989778,
    679787,
    788868,
    896777,
    788787,
    987787,
    778697,
    886888,
    887788,
    887778,
    887898,
    896968,
    788878,
    877878,
    998777,
    799787,
    978988,
    899898,
    798788,
    979878,
    788897,
    787888,
    696987,
    878897,
    778878,
    897798,
    988878,
    669888,
    786888,
    877887,
    879697,
    886778,
    986788,
    897777,
    878879,
    797867,
    778879,
    978899,
    877887,
    979769,
    689778,
    997877,
    779889,
    778877,
    697987,
    786888,
    677977,
    887898,
    779898,
    978896,
    898878,
    878798,
    778788,
    886997,
    888888,
    678787,
    787877,
    889878,
    898679,
    777888,
    789778,
    888777,
    978888,
    878879,
    888969,
    888887,
    898878,
    878777,
    987778,
    879797,
    678789,
    897778,
    788988,
    876877,
    788887,
    979888,
    897787,
    799778,
    767799,
    877878,
    688887,
    768797,
    797797,
    769768,
    696878,
    889979,
    889777,
    689878,
    787676,
    898987,
    876977,
    999887,
    889889,
    777888,
    997778,
    778888,
    787878,
    888798,
    878876,
    898787,
    887888,
    778879,
    878778,
    679799,
    978966,
    687889,
    897879,
    878987,
    988878,
    879966,
    988997,
    789689,
    877976,
    688898,
    878988,
    887977,
    876887,
    977887,
    997778,
    997888,
    899877,
    878798,
    898898,
    868877,
    998889,
    789688,
    878988,
    898998,
    988878,
    887686,
    887787,
    979877,
    879787,
    888787,
    996889,
    977789,
    677898,
    787888,
    877787,
    878778,
    987887,
    887897,
    888878,
    986888,
    887677,
    787776,
    799887,
    887787,
    898767,
    897887,
    889868,
    978788,
    778679,
    787778,
    876889,
    788777,
    896898,
    889897,
    987877,
    878688,
    988889,
    779887,
    888887,
    897868,
    977868,
    788898,
    779977,
    869798,
    678768,
    988878,
    686788,
    779887,
    888887,
    887987,
    998979,
    778878,
    978878,
    788997,
    889879,
    789877,
    878987,
    888998,
    877887,
    877787,
    778778,
    888978,
    886978,
    777998,
    787898,
    979987,
    866788,
    889778,
    787987,
    866878,
    889786,
    767887,
    798889,
    899899,
    997989,
    987878,
    977878,
    989989,
    779989,
    897889,
    989797,
    977778,
    698786,
    787987,
    977878,
    798888,
    787879,
    877986,
    988869,
    778788,
    678688,
    897798,
    798978,
    786779,
    779888,
    897779,
    788987,
    977889,
    977876,
    788789,
    768867,
    878877,
    986886,
    879869,
    876978,
    978887,
    788888,
    886878,
    978878,
    779788,
    789979,
    778897,
    888977,
    886987,
    968898,
    876789,
    888688,
    877888,
    887887,
    878786,
    878788,
    878979,
    888897,
    779978,
    877878,
    788767,
    778897,
    777897,
    998878,
    786988,
    888689,
    689777,
    777887,
    886788,
    768766,
    868679,
    868897,
    787879,
    777688,
    788899,
    867999,
    878689,
    898787,
    898889,
    688689,
    889888,
    779767,
    678887,
    996787,
    788877,
    887778,
    778787,
    779897,
    988778,
    786878,
    986788,
    878688,
    778987,
    879898,
    678877,
    879869,
    788998,
    887888,
    978897,
    979687,
    889888,
    878887,
    877777,
    789898,
    677778,
    697897,
    788767,
    879778,
    699879,
    899798,
    878778,
    876879,
    798667,
    876978,
    888889,
    879799,
    997789,
    998788,
    787988,
    887778,
    898879,
    879688,
    877799,
    878988,
    798878,
    888977,
    797776,
    769888,
    878979,
    998888,
    788877,
    869889,
    876887,
    889878,
    878678,
    888987,
    797977,
    879777,
    769899,
    777798,
    989778,
    878698,
    798888,
    787776,
    878889,
    986998,
    697889,
    888888,
    989669,
    887978,
    879798,
    879989,
    978887,
    698988,
    898879,
    698977,
    778778,
    988787,
    778888,
    688788,
    888789,
    888788,
    778677,
    688788,
    879687,
    888776,
    878869,
    799889,
    899777,
    867989,
    887788,
    888787,
    788878,
    787877,
    887897,
    978888,
    888888,
    988789,
    988778,
    998887,
    878799,
    899877,
    797988,
    777977,
    987889,
    788878,
    887887,
    976876,
    976978,
    888788,
    899778,
    788899,
    779898,
    977888,
    997779,
    788779,
    888987,
    788879,
    768887,
    899979,
    888798,
    996988,
    889798,
    778888,
    789998,
    966978,
    887888,
    787878,
    988777,
    799888,
    978787,
    886877,
    979799,
    988778,
    777888,
    878888,
    798877,
    788778,
    799876,
    987869,
    779798,
    979889,
    798976,
    689988,
    888887,
    769989,
    897997,
    867887,
    887777,
    887867,
    898667,
    878878,
    977778,
    887889,
    878888,
    777878,
    899887,
    779778,
    697977,
    987878,
    978867,
    988878,
    887888,
    898889,
    797687,
    888787,
    878988,
    987787,
    877889,
    987798,
    889888,
    977887,
    888888,
    888677,
    988878,
    878879,
    987897,
    787767,
    786988,
    788878,
    788798,
    878777,
    678887,
    987878,
    787987,
    888767,
    779868,
    897886,
    887968,
    978886,
    889688,
    788889,
    778897,
    888987,
    797879,
    797789,
    887877,
    897798,
    879896,
    689899,
    977887,
    888789,
    887779,
    788987,
    788977,
    777888,
    889678,
    788788,
    787788,
    776878,
    877988,
    988888,
    679787,
    888887,
    998677,
    889787,
    779676,
    789777,
    977878,
    867789,
    788788,
    778878,
    897888,
    668897,
    797988,
    778878,
    778887,
    778886,
    769878,
    886888,
    897889,
    879687,
    878997,
    878988,
    966789,
    997889,
    868788,
    977897,
    989788,
    786697,
    977889,
    898888,
    688798,
    886898,
    789888,
    796999,
    878787,
    787778,
    867988,
    988998,
    778887,
    887777,
    777767,
    888787,
    898777,
    888887,
    778987,
    789897,
    689969,
    788968,
    787888,
    778867,
    877788,
    979887,
    798988,
    788888,
    888676,
    888779,
    788968,
    896878,
    878777,
    877978,
    888998,
    788776,
    679886,
    988878,
    787887,
    868988,
    977878,
    876679,
    788877,
    897788,
    698897,
    897889,
    878868,
    867877,
    887876,
    788678,
    898678,
    787788,
    888987,
    898876,
    897778,
    998789,
    679897,
    988688,
    988887,
    788989,
    878887,
    877789,
    879787,
    768877,
    878988,
    889878,
    987878,
    988889,
    878788,
    779889,
    789897,
    789777,
    797878,
    898888,
    788799,
    888998,
    887878,
    778887,
    878878,
    699778,
    987987,
    897867,
    888788,
    889798,
    977878,
    797978,
    768798,
    898989,
    988889,
    989767,
    868987,
    877877,
    798878,
    688888,
    887889,
    988978,
    988978,
    888887,
    898677,
    879888,
    687779,
    997777,
    896677,
    877787,
    888889,
    897788,
    798778,
    897887,
    788887,
    896989,
    898978,
    888976,
    777987,
    999987,
    767897,
    887779,
    887796,
    877777,
    889888,
    779787,
    689778,
    897869,
    879886,
    897889,
    976786,
    969987,
    778789,
    899877,
    789688,
    888896,
    977887,
    888978,
    989888,
    777888,
    777889,
    799888,
    968879,
    978976,
    867977,
    888877,
    888789,
    898989,
    887678,
    698898,
    878978,
    988979,
    776777,
    778879,
    988887,
    888978,
    988878,
    977887,
    788878,
    887788,
    777879,
    788988,
    988887,
    977888,
    888879,
    889979,
    777687,
    989877,
    789779,
    777887,
    878878,
    967688,
    798899,
    688887,
    787798,
    787767,
    877797,
    779968,
    888979,
    877878,
    897877,
    788868,
    877877,
    998987,
    898888,
    979777,
    778978,
    997978,
    878897,
    998878,
    898687,
    988788,
    998887,
    967868,
    978796,
    899777,
    886869,
    787788,
    787887,
    888878,
    776889,
    888878,
    797988,
    779787,
    998787,
    788877,
    997788,
    889968,
    979799,
    968888,
    788798,
    787989,
    788897,
    798777,
    878987,
    987977,
    688888,
    977787,
    988789,
    787868,
    888888,
    778889,
    779688,
    776778,
    687787,
    887799,
    978888,
    688966,
    798787,
    887887,
    988797,
    789976,
    788978,
    787868,
    787788,
    779787,
    988898,
    667888,
    876878,
    988877,
    897679,
    887878,
    887888,
    887789,
    889798,
    678879,
    798897,
    877797,
    897967,
    997787,
    797688,
    879788,
    878898,
    779876,
    877777,
    889788,
    879887,
    898788,
    888866,
    777898,
    878798,
    896877,
    978788,
    987877,
    887878,
    878978,
    888997,
    889898,
    887898,
    798787,
    678888,
    798989,
    988878,
    878678,
    797988,
    878877,
    888799,
    689798,
    788978,
    777777,
    888697,
    887779,
    888788,
    979988,
    787876,
    997788,
    977777,
    978989,
    678988,
    988877,
    788879,
    977886,
    978888,
    888889,
    798687,
    688886,
    879798,
    788787,
    989787,
    799877,
    897888,
    977998,
    988877,
    887879,
    889787,
    878889,
    879877,
    797967,
    867869,
    697879,
    897878,
    776977,
    979877,
    789879,
    788889,
    777778,
    778977,
    799787,
    988786,
    878888,
    888898,
    797897,
    798989,
    888977,
    787868,
    989778,
    768877,
    898777,
    787877,
    777778,
    898877,
    697976,
    797876,
    778777,
    889888,
    888798,
    787969,
    988778,
    868779,
    799777,
    779998,
    899898,
    997898,
    887798,
    778897,
    787679,
    878879,
    887889,
    798887,
    878698,
    877789,
    897788,
    788868,
    886888,
    788788,
    877899,
    687888,
    778887,
    687768,
    877898,
    987898,
    987867,
    798788,
    688767,
    887789,
    878888,
    877898,
    996788,
    977978,
    789979,
    877778,
    887978,
    998897,
    797778,
    889989,
    778879,
    877878,
    888788,
    678887,
    987987,
    787877,
    788898,
    786887,
    888877,
    986878,
    889997,
    787878,
    888977,
    778887,
    888787,
    688788,
    788988,
    978889,
    787987,
    778897,
    686977,
    889878,
    898896,
    989797,
    888879,
    889778,
    768888,
    789977,
    979878,
    978888,
    998677,
    898778,
    778979,
    778877,
    687889,
    888888,
    788889,
    997786,
    888679,
    987777,
    788888,
    898877,
    799889,
    786778,
    889878,
    788889,
    879878,
    877779,
    777978,
    788897,
    887897,
    877798,
    878787,
    888979,
    777887,
    778787,
    987789,
    879797,
    898878,
    769778,
    796798,
    778868,
    877798,
    869889,
    888678,
    889888,
    777989,
    977978,
    899788,
    977987,
    888989,
    898877,
    777798,
    788788,
    678797,
    878977,
    879777,
    779778,
    778876,
    877797,
    888777,
    678898,
    778788,
    888879,
    778899,
    789866,
    889887,
    987889,
    969789,
    987887,
    867789,
    777879,
    989887,
    987989,
    868779,
    787979,
    988799,
    788798,
    898887,
    688979,
    878977,
    668789,
    888787,
    887979,
    978799,
    687679,
    987888,
    777889,
    768888,
    789787,
    878878,
    877988,
    787896,
    787888,
    888779,
    788788,
    889876,
    978998,
    888867,
    678968,
    888987,
    788888,
    978879,
    879887,
    688896,
    777878,
    887677,
    787878,
    788799,
    887888,
    878988,
    898978,
    989777,
    789778,
    868878,
    788789,
    977888,
    878899,
    899987,
    788896,
    997768,
    766878,
    769787,
    877689,
    887988,
    869896,
    878989,
    888877,
    887787,
    786868,
    777688,
    977788,
    878987,
    788887,
    876877,
    977886,
    779988,
    899877,
    998899,
    878978,
    979888,
    878878,
    889878,
    978978,
    689799,
    787788,
    778889,
    778888,
    788868,
    978887,
    977878,
    787788,
    988868,
    988887,
    888988,
    878897,
    978878,
    667879,
    977768,
    888899,
    778777,
    887989,
    878777,
    788888,
    887777,
    778788,
    888889,
    789879,
    888797,
    988778,
    689798,
    878978,
    788678,
    797979,
    988889,
    797897,
    988788,
    678888,
    989978,
    676878,
    869977,
    788977,
    769887,
    798889,
    877887,
    999788,
    778868,
    868887,
    969779,
    999877,
    888796,
    879789,
    987888,
    766687,
    978787,
    868869,
    787877,
    878788,
    878988,
    797887,
    888878,
    889767,
    879887,
    787777,
    878977,
    886877,
    789697,
    779887,
    977788,
    688798,
    787886,
    977998,
    888887,
    898776,
    897888,
    988778,
    788987,
    789887,
    767878,
    897978,
    889888,
    777978,
    797996,
    887786,
    897778,
    788888,
    988787,
    778888,
    697787,
    787888,
    878988,
    886697,
    779988,
    878798,
    788878,
    877697,
    898888,
    876878,
    888978,
    978989,
    779888,
    698888,
    767778,
    889886,
    888798,
    888898,
    969969,
    887979,
    887878,
    798778,
    887888,
    789998,
    976698,
    877887,
    787877,
    777887,
    976798,
    888899,
    889977,
    779788,
    797787,
    677778,
    768788,
    988986,
    878687,
    887989,
    877798,
    779789,
    877878,
    888787,
    879878,
    789787,
    987787,
    878767,
    978778,
    697767,
    888778,
    898897,
    878977,
    898989,
    898898,
    688798,
    678697,
    768899,
    798888,
    888797,
    986997,
    678777,
    787888,
    787898,
    687789,
    777679,
    998887,
    798968,
    788778,
    977896,
    869698,
    787798,
    987988,
    899997,
    979999,
    897887,
    886977,
    777778,
    879977,
    678787,
    769897,
    877898,
    887889,
    699879,
    686886,
    897677,
    878898,
    689968,
    866878,
    897998,
    889886,
    667987,
    888798,
    968896,
    867888,
    889888,
    776878,
    788878,
    878987,
    679697,
    786778,
    888888,
    777779,
    689787,
    789876,
    988779,
    879879,
    778798,
    898887,
    787987,
    989878,
    886877,
    888889,
    789986,
    799798,
    679887,
    799888,
    779887,
    878887,
    997779,
    788869,
    777899,
    778779,
    988889,
    867877,
    799898,
    876986,
    799677,
    989797,
    779789,
    878879,
    698879,
    897898,
    988888,
    788778,
    767669,
    897988,
    797888,
    988876,
    788876,
    898896,
    888987,
    788799,
    877787,
    997767,
    867986,
    887779,
    988978,
    788788,
    888898,
    988887,
    898887,
    979877,
    878789,
    698888,
    879897,
    797888,
    878877,
    987888,
    987977,
    787889,
    887878,
    667678,
    788887,
    988877,
    766998,
    687997,
    887678,
    978777,
    887887,
    787779,
    887988,
    997989,
    879979,
    777887,
    877888,
    878769,
    989877,
    976779,
    689996,
    887898,
    989696,
    688879,
    686898,
    887797,
    788787,
    979986,
    878889,
    777887,
    898977,
    889897,
    768778,
    988776,
    987888,
    789888,
    876978,
    779788,
    887879,
    996786,
    789888,
    878778,
    888978,
    887668,
    889877,
    787789,
    879787,
    888778,
    889888,
    779988,
    899897,
    787878,
    897888,
    888997,
    888878,
    878986,
    686787,
    887886,
    886989,
    877888,
    879888,
    798878,
    988798,
    887878,
    888789,
    878887,
    888897,
    878999,
    788887,
    777887,
    877987,
    988789,
    787978,
    868897,
    787789,
    988977,
    788869,
    878887,
    788677,
    888787,
    777987,
    778886,
    778787,
    769777,
    787788,
    777889,
    878877,
    789888,
    866788,
    988978,
    678888,
    796969,
    677897,
    888879,
    979888,
    789877,
    877877,
    776888,
    688798,
    987897,
    868779,
    688877,
    767869,
    978778,
    788788,
    778988,
    887879,
    787878,
    888897,
    988889,
    787899,
    786778,
    798888,
    987778,
    987978,
    887697,
    787988,
    899989,
    986877,
    689788,
    798888,
    888898,
    967776,
    889888,
    779779,
    977989,
    888798,
    776788,
    899788,
    998879,
    787888,
    978789,
    978886,
    777897,
    768897,
    688788,
    879788,
    688687,
    898787,
    798867,
    978777,
    978897,
    888787,
    998878,
    979889,
    787897,
    877877,
    797887,
    977788,
    778767,
    888889,
    888777,
    898888,
    679887,
    877787,
    798788,
    797779,
    779888,
    888778,
    787898,
    886989,
    888888,
    988687,
    999889,
    889887,
    878787,
    889886,
    877968,
    888877,
    898878,
    689987,
    976698,
    788888,
    898988,
    987987,
    898799,
    899797,
    788887,
    779799,
    778886,
    899799,
    788868,
    888878,
    888878,
    789898,
    887776,
    876777,
    787897,
    877978,
    996677,
    797987,
    887787,
    887987,
    787878,
    897899,
    978799,
    777887,
    787887,
    879977,
    998877,
    889897,
    687898,
    887898,
    797788,
    999898,
    777776,
    869667,
    778977,
    888869,
    796868,
    889886,
    989887,
    888689,
    968888,
    778889,
    787689,
    776777,
    887878,
    889778,
    877897,
    788988,
    877897,
    879888,
    778999,
    899789,
    777968,
    988897,
    888878,
    987877,
    878677,
    777888,
    878789,
    888876,
    967789,
    998898,
    889898,
    898889,
    778787,
    897888,
    977778,
    798878,
    879789,
    779779,
    878797,
    988878,
    799878,
    989889,
    887798,
    777668,
    798879,
    879898,
    878796,
    988777,
    778979,
    977798,
    899887,
    998977,
    787889,
    978788,
    888878,
    798988,
    789868,
    797878,
    886786,
    779677,
    788878,
    677887,
    897878,
    898789,
    788988,
    988878,
    867887,
    886977,
    887767,
    787877,
    978877,
    878788,
    967877,
    788777,
    988897,
    879978,
    768997,
    787868,
    978797,
    687888,
    687777,
    867887,
    887888,
    798799,
    677888,
    987778,
    788878,
    786996,
    996787,
    888976,
    886986,
    888889,
    888788,
    788898,
    997988,
    687768,
    697886,
    968777,
    788887,
    887888,
    889999,
    898876,
    697897,
    767997,
    778779,
    889878,
    979787,
    777778,
    988878,
    787868,
    878989,
    868898,
    888888,
    788888,
    889776,
    888797,
    887888,
    876887,
    888778,
    788798,
    987797,
    688777,
    998788,
    788978,
    688798,
    879787,
    988888,
    877889,
    787686,
    877978,
    797877,
    887889,
    688779,
    889888,
    788878,
    789789,
    787988,
    788879,
    778878,
    786889,
    787677,
    778879,
    778879,
    778788,
    787787,
    878799,
    787878,
    898788,
    888799,
    798787,
    888777,
    777987,
    886988,
    898899,
    888877,
    877997,
    799997,
    767867,
    987988,
    886789,
    768787,
    987988,
    977686,
    798898,
    967897,
    888788,
    877887,
    787898,
    989787,
    787789,
    798979,
    798679,
    699788,
    777677,
    888977,
    878889,
    899689,
    989879,
    896898,
    897789,
    787989,
    897886,
    978877,
    788788,
    797777,
    786888,
    788688,
    868888,
    789698,
    789767,
    878977,
    887778,
    979887,
    789687,
    896797,
    799977,
    878888,
    879698,
    877787,
    988787,
    786778,
    777898,
    887778,
    778879,
    878789,
    678888,
    798978,
    868779,
    889786,
    789877,
    778878,
    877797,
    977788,
    876878,
    887778,
    889788,
    998768,
    877986,
    868699,
    997988,
    878867,
    787767,
    777777,
    898898,
    968989,
    878888,
    889988,
    797688,
    988978,
    897978,
    876767,
    777887,
    879887,
    788688,
    877879,
    787888,
    787988,
    879987,
    777887,
    988898,
    889777,
    888799,
    789797,
    878788,
    888877,
    888767,
    878689,
    897789,
    677896,
    967897,
    787688,
    788976,
    787997,
    788898,
    877888,
    889687,
    888688,
    687799,
    769889,
    897767,
    899867,
    789888,
    688798,
    779897,
    898897,
    989798,
    886787,
    888878,
    787776,
    899878,
    978788,
    879889,
    987788,
    877889,
    888988,
    887879,
    989888,
    887797,
    887877,
    687876,
    788769,
    889799,
    898879,
    887868,
    889787,
    788778,
    877787,
    988876,
    987878,
    879977,
    887878,
    878898,
    997678,
    988788,
    887889,
    786778,
    899787,
    879789,
    698998,
    879889,
    688778,
    878977,
    888888,
    989777,
    877688,
    988668,
    999799,
    799879,
    878977,
    689877,
    897878,
    898777,
    998988,
    888889,
    977877,
    677787,
    878879,
    787897,
    787878,
    879778,
    876968,
    777978,
    879767,
    998888,
    688876,
    677889,
    879888,
    787678,
    989886,
    897778,
    898988,
    788789,
    688888,
    878877,
    887888,
    779777,
    877967,
    787889,
    887889,
    877878,
    776688,
    889778,
    899897,
    778987,
    789797,
    898987,
    886887,
    886887,
    978769,
    768868,
    689977,
    978698,
    788788,
    798877,
    796797,
    978878,
    887998,
    888777,
    868868,
    879898,
    798888,
    798677,
    898988,
    978878,
    666778,
    687887,
    788999,
    768796,
    886787,
    888798,
    777988,
    888687,
    996778,
    876888,
    886987,
    987878,
    688888,
    988678,
    888888,
    999869,
    786798,
    899777,
    869779,
    788777,
    788769,
    879878,
    978988,
    789787,
    777988,
    888888,
    789888,
    699978,
    787896,
    869878,
    799978,
    878788,
    888887,
    978978,
    879878,
    777877,
    898868,
    987877,
    786788,
    876878,
    899677,
    779778,
    898878,
    788988,
    967987,
    668677,
    879898,
    787978,
    889898,
    779868,
    788877,
    887787,
    778778,
    888976,
    967887,
    869887,
    888879,
    877686,
    978777,
    879978,
    787878,
    778998,
    967789,
    889788,
    787667,
    878787,
    877896,
    897678,
    788867,
    768788,
    777979,
    787898,
    776988,
    887967,
    988778,
    778788,
    879888,
    988978,
    789789,
    898688,
    778788,
    887788,
    787787,
    869768,
    997877,
    899888,
    868798,
    778877,
    879977,
    898979,
    878788,
    866768,
    879679,
    978788,
    788879,
    787687,
    996778,
    697889,
    897887,
    889789,
    886998,
    778677,
    977798,
    697777,
    797998,
    779876,
    877799,
    887767,
    979978,
    888798,
    779886,
    989897,
    778798,
    767688,
    797888,
    877787,
    667888,
    777788,
    988787,
    888778,
    978877,
    897779,
    698878,
    888798,
    778988,
    767788,
    899788,
    867767,
    678778,
    888787,
    698778,
    898897,
    978688,
    989798,
    977887,
    778887,
    879987,
    877779,
    987788,
    778799,
    787769,
    876878,
    788977,
    878898,
    878868,
    878776,
    887988,
    878999,
    788789,
    788779,
    698988,
    879878,
    789777,
    897797,
    899978,
    797788,
    878867,
    888786,
    997979,
    768987,
    887878,
    989788,
    879788,
    779878,
    877796,
    787887,
    868877,
    978997,
    886888,
    687866,
    779767,
    997879,
    887787,
    779789,
    788878,
    897898,
    877888,
    888887,
    768689,
    799888,
    886789,
    889978,
    978666,
    878798,
    677889,
    888896,
    787887,
    798978,
    987778,
    978978,
    788688,
    998798,
    788888,
    778868,
    686887,
    689988,
    797788,
    887979,
    887787,
    887677,
    788889,
    798788,
    878978,
    888877,
    887667,
    789888,
    877887,
    888888,
    889887,
    878968,
    998878,
    798777,
    988777,
    767887,
    978966,
    889887,
    888779,
    997778,
    797997,
    987888,
    798887,
    987988,
    988867,
    888788,
    878777,
    978688,
    887889,
    798876,
    788898,
    798887,
    987977,
    867697,
    987888,
    897788,
    987887,
    797786,
    998778,
    768988,
    876768,
    768689,
    778989,
    888898,
    798788,
    978878,
    977987,
    979897,
    889878,
    968777,
    898889,
    869778,
    788877,
    877798,
    778678,
    989879,
    777887,
    788786,
    997797,
    888797,
    888988,
    887877,
    779789,
    878988,
    987989,
    878777,
    876978,
    879987,
    877888,
    879778,
    877667,
    989887,
    999877,
    987988,
    889789,
    878878,
    897797,
    879777,
    889996,
    688877,
    998777,
    869689,
    878899,
    787887,
    988787,
    787776,
    968779,
    688788,
    788798,
    878989,
    889797,
    797887,
    998788,
    789778,
    887889,
    987787,
    988877,
    788898,
    787887,
    887979,
    777878,
    887999,
    777778,
    877788,
    988788,
    698778,
    789889,
    688988,
    688878,
    888698,
    878789,
    868888,
    996788,
    778888,
    788697,
    979998,
    776878,
    798988,
    877987,
    888767,
    877978,
    888867,
    769988,
    888899,
    799877,
    988789,
    988897,
    989788,
    997798,
    899988,
    997887,
    788887,
    887879,
    887788,
    887698,
    767989,
    778689,
    777888,
    898898,
    788889,
    788787,
    778778,
    888888,
    886688,
    799789,
    687888,
    788778,
    989767,
    977796,
    898787,
    798987,
    789888,
    789877,
    788686,
    878887,
    979899,
    987768,
    877988,
    777887,
    799989,
    776978,
    789967,
    877797,
    889987,
    798888,
    878787,
    887987,
    798778,
    988877,
    889888,
    788798,
    989979,
    788777,
    887877,
    867888,
    888989,
    887797,
    889877,
    976788,
    878889,
    778779,
    888779,
    887798,
    987788,
    997878,
    967767,
    998768,
    778888,
    789888,
    988987,
    788877,
    797788,
    788988,
    878788,
    987897,
    997799,
    887977,
    687978,
    788778,
    677988,
    878997,
    898977,
    887768,
    898876,
    977898,
    989886,
    879789,
    897887,
    877977,
    879978,
    988887,
    777776,
    789887,
    888788,
    778779,
    889887,
    898899,
    868888,
    867777,
    777977,
    877887,
    889988,
    979887,
    886998,
    788677,
    978978,
    967787,
    988987,
    878988,
    687869,
    998887,
    988877,
    978989,
    889788,
    898999,
    899799,
    898879,
    787977,
    778889,
    887778,
    897988,
    776679,
    779876,
    888898,
    787887,
    878897,
    787988,
    878788,
    896688,
    877777,
    997887,
    787888,
    789878,
    989986,
    868678,
    978888,
    777878,
    899799,
    689798,
    878687,
    888777,
    977877,
    789999,
    897878,
    787788,
    878889,
    977989,
    898897,
    888997,
    777678,
    997878,
    978778,
    786888,
    888887,
    988788,
    878997,
    787688,
    988778,
    788877,
    897789,
    988977,
    788798,
    878877,
    988778,
    899878,
    786799,
    877889,
    979897,
    677886,
    888978,
    798888,
    787777,
    998897,
    878978,
    788788,
    888698,
    887788,
    986967,
    978878,
    778998,
    887989,
    797997,
    687777,
    899898,
    988768,
    988887,
    777798,
    987788,
    798877,
    797779,
    897778,
    699787,
    797797,
    687988,
    887897,
    788778,
    897779,
    867788,
    988888,
    878798,
    678888,
    977987,
    788787,
    878768,
    888987,
    978878,
    887788,
    788689,
    887979,
    688778,
    978888,
    899898,
    988887,
    886887,
    898899,
    988899,
    787687,
    789988,
    797786,
    688688,
    787888,
    789789,
    997878,
    688878,
    888887,
    798779,
    898886,
    796687,
    998678,
    978887,
    786988,
    888777,
    988869,
    688868,
    867778,
    878878,
    787989,
    787787,
    987767,
    778779,
    967888,
    798978,
    887788,
    688899,
    788788,
    979788,
    987798,
    898988,
    978778,
    898897,
    887889,
    877788,
    779688,
    887878,
    779887,
    798997,
    878697,
    687797,
    788887,
    679889,
    798788,
    897787,
    787988,
    688977,
    767888,
    787798,
    877676,
    888878,
    868898,
    768998,
    987987,
    877976,
    878898,
    888878,
    986787,
    877869,
    797988,
    989989,
    878979,
    987888,
    898777,
    697897,
    888977,
    778977,
    888697,
    779787,
    778968,
    887787,
    987898,
    777977,
    889798,
    778888,
    879788,
    887699,
    887777,
    786988,
    977789,
    779977,
    797776,
    987797,
    789988,
    788979,
    888977,
    987888,
    898987,
    897787,
    796978,
    889798,
    888679,
    988888,
    978877,
    677787,
    999877,
    788888,
    787778,
    787887,
    778888,
    778997,
    797969,
    898767,
    899889,
    878899,
    687689,
    878788,
    787888,
    698878,
    978887,
    769678,
    889978,
    987897,
    988897,
    887889,
    777787,
    868887,
    787886,
    798788,
    879778,
    777878,
    899889,
    687897,
    898778,
    777778,
    778887,
    877787,
    886878,
    987879,
    968879,
    888898,
    787778,
    678698,
    888796,
    879779,
    788699,
    778889,
    888897,
    698788,
    888898,
    888987,
    887777,
    997779,
    998776,
    767789,
    797868,
    878788,
    899986,
    897778,
    879897,
    798977,
    876787,
    788768,
    698989,
    789788,
    898788,
    767888,
    878887,
    877887,
    879777,
    799987,
    989788,
    788788,
    888967,
    777978,
    787997,
    887889,
    776878,
    788989,
    877797,
    778887,
    898797,
    796887,
    988977,
    888797,
    987779,
    879887,
    988788,
    779768,
    788789,
    778877,
    889888,
    788796,
    989886,
    988976,
    877867,
    778889,
    778788,
    788788,
    988786,
    979877,
    888879,
    977799,
    878777,
    788888,
    687888,
    997968,
    896888,
    777878,
    899788,
    898877,
    799788,
    779987,
    779678,
    696769,
    879978,
    998788,
    799988,
    896887,
    788878,
    876888,
    988798,
    887788,
    787977,
    788678,
    968887,
    798887,
    889788,
    767787,
    878877,
    978687,
    678788,
    778998,
    878879,
    887877,
    978788,
    999868,
    897879,
    987779,
    786788,
    688988,
    878788,
    888787,
    778888,
    777887,
    788978,
    878788,
    987978,
    878877,
    787799,
    799897,
    877697,
    988988,
    879888,
    967868,
    986968,
    999987,
    788768,
    787898,
    988986,
    888886,
    897778,
    887676,
    779787,
    878798,
    798889,
    877979,
    887878,
    977789,
    797897,
    977797,
    886678,
    787897,
    878998,
    987778,
    778977,
    788888,
    696996,
    889887,
    787787,
    889986,
    776887,
    878878,
    798996,
    877788,
    879878,
    878988,
    788987,
    899798,
    978878,
    888897,
    777988,
    877697,
    868689,
    787799,
    787996,
    887876,
    887788,
    769986,
    979789,
    779788,
    887988,
    998799,
    888887,
    879797,
    888898,
    879987,
    779789,
    789878,
    697888,
    897788,
    687797,
    889887,
    788887,
    888898,
    798667,
    979798,
    887897,
    887878,
    778787,
    788896,
    788889,
    989997,
    887877,
    998876,
    778887,
    898966,
    678887,
    898787,
    886786,
    778678,
    889788,
    988897,
    989899,
    978678,
    776878,
    988887,
    888888,
    878887,
    688879,
    779967,
    799767,
    877787,
    777779,
    797788,
    797988,
    998786,
    789887,
    787968,
    887699,
    686889,
    767879,
    888988,
    787889,
    877878,
    898887,
    788788,
    898877,
    778878,
    987887,
    888788,
    687889,
    979879,
    997788,
    779787,
    986897,
    898989,
    787888,
    766788,
    977889,
    868898,
    899768,
    986888,
    887787,
    877976,
    888778,
    669887,
    787778,
    797898,
    797777,
    899888,
    887779,
    777987,
    788896,
    877878,
    977698,
    767879,
    878888,
    988887,
    687789,
    897878,
    898788,
    878897,
    979887,
    887887,
    788887,
    868688,
    978998,
    687898,
    888876,
    888788,
    778898,
    988998,
    877778,
    888878,
    998799,
    788887,
    777798,
    977997,
    978987,
    889988,
    888888,
    988668,
    877988,
    998877,
    888799,
    889897,
    877887,
    788788,
    887778,
    778898,
    886978,
    979799,
    778788,
    786888,
    978777,
    779888,
    888798,
    888688,
    978979,
    688679,
    887888,
    789888,
    978988,
    899988,
    798787,
    889987,
    998777,
    787887,
    887686,
    889887,
    778789,
    978888,
    886799,
    788878,
    687798,
    877887,
    976877,
    977699,
    868778,
    877788,
    978898,
    877778,
    767789,
    987987,
    689787,
    878888,
    787889,
    777988,
    888887,
    898988,
    878997,
    788877,
    888878,
    887887,
    889979,
    788876,
    779777,
    787888,
    787789,
    799778,
    878688,
    869878,
    878786,
    877887,
    789888,
    879887,
    689787,
    877777,
    677988,
    878887,
    887788,
    878798,
    987789,
    879889,
    778789,
    889888,
    988987,
    887887,
    887769,
    877688,
    978787,
    988889,
    878787,
    988888,
    778778,
    887879,
    787868,
    778887,
    877777,
    868886,
    887888,
    776788,
    987886,
    887887,
    977887,
    898688,
    887887,
    878997,
    788698,
    787888,
    888776,
    877788,
    678888,
    788879,
    769998,
    798888,
    989798,
    797786,
    787867,
    879787,
    877769,
    898777,
    988888,
    788798,
    888877,
    866888,
    788887,
    789997,
    889786,
    787788,
    889899,
    778879,
    877788,
    878887,
    798987,
    878987,
    887977,
    888998,
    889887,
    888878,
    888878,
    787787,
    897777,
    788997,
    778898,
    988877,
    978898,
    777688,
    878788,
    987788,
    796788,
    988878,
    888778,
    678869,
    878888,
    888798,
    797887,
    877677,
    687888,
    888678,
    898898,
    898878,
    879788,
    966877,
    779886,
    887788,
    779977,
    887798,
    789998,
    899988,
    887888,
    988788,
    786698,
    887878,
    887876,
    689789,
    898788,
    898897,
    778889,
    777988,
    887788,
    888998,
    877688,
    789989,
    787988,
    789889,
    777778,
    889888,
    978887,
    689877,
    668797,
    978769,
    878988,
    788896,
    788887,
    999869,
    988868,
    887979,
    899887,
    788798,
    868778,
    888878,
    788988,
    777896,
    979788,
    788778,
    879888,
    877799,
    889788,
    697898,
    878878,
    988789,
    889897,
    887677,
    698898,
    777988,
    888978,
    788778,
    978868,
    967988,
    766998,
    868799,
    787798,
    787788,
    877778,
    777698,
    889878,
    887987,
    887678,
    787776,
    889978,
    888888,
    679778,
    876979,
    687779,
    888887,
    977978,
    879678,
    798779,
    887778,
    898888,
    877879,
    769878,
    778787,
    888777,
    888767,
    696988,
    977888,
    996798,
    688797,
    789897,
    888787,
    888788,
    888979,
    788887,
    788979,
    788799,
    988868,
    889997,
    989786,
    898878,
    899989,
    878988,
    887778,
    897779,
    886778,
    978777,
    888878,
    869877,
    768887,
    988687,
    789778,
    998989,
    896867,
    678677,
    988888,
    888777,
    777889,
    898987,
    998887,
    787798,
    786797,
    788887,
    987899,
    886787,
    888888,
    879789,
    987867,
    977777,
    777968,
    768677,
    798977,
    779997,
    988986,
    787787,
    778887,
    697878,
    867899,
    678887,
    886997,
    787977,
    978898,
    868886,
    988797,
    796788,
    989878,
    798888,
    787988,
    878987,
    869889,
    897899,
    787787,
    797789,
    767987,
    977878,
    967878,
    876799,
    898879,
    788897,
    767778,
    888778,
    897887,
    998877,
    777777,
    679987,
    978867,
    868876,
    977788,
    968978,
    896898,
    799878,
    788888,
    978778,
    789879,
    779788,
    788888,
    788898,
    887889,
    878977,
    897997,
    786687,
    969668,
    877677,
    768978,
    897789,
    788688,
    779986,
    688888,
    898868,
    778888,
    897798,
    789888,
    887887,
    866968,
    797888,
    787977,
    987688,
    778787,
    788798,
    889789,
    888889,
    888788,
    878896,
    878886,
    787978,
    989988,
    879787,
    987788,
    676889,
    798867,
    997978,
    896787,
    879977,
    978867,
    779979,
    877877,
    969879,
    779897,
    888988,
    878877,
    877778,
    998979,
    888787,
    888999,
    868787,
    976777,
    788887,
    987797,
    877878,
    779887,
    978797,
    877789,
    889788,
    787987,
    987898,
    986888,
    887787,
    879788,
    878987,
    787897,
    797988,
    788898,
    878876,
    779888,
    889878,
    887978,
    797778,
    778777,
    778777,
    789789,
    689989,
    899787,
    877868,
    889888,
    879889,
    899767,
    898978,
    786887,
    887676,
    898788,
    788988,
    877777,
    788789,
    787877,
    888788,
    887777,
    789967,
    777888,
    877789,
    978987,
    897788,
    888988,
    788868,
    897977,
    677898,
    877878,
    877876,
    987779,
    689987,
    778798,
    887878,
    987897,
    789878,
    778779,
    886797,
    976988,
    988988,
    796888,
    887988,
    769778,
    787977,
    878777,
    877687,
    896789,
    887879,
    989878,
    687787,
    687887,
    988898,
    678889,
    787988,
    889876,
    887888,
    879768,
    877777,
    798887,
    869878,
    876787,
    788898,
    786778,
    796688,
    988877,
    987889,
    876798,
    778977,
    777787,
    797887,
    997778,
    987779,
    777987,
    989877,
    899668,
    778798,
    897878,
    798878,
    788898,
    988888,
    788888,
    988788,
    879887,
    779898,
    887889,
    869788,
    797897,
    886888,
    867779,
    989879,
    798997,
    797976,
    799787,
    877978,
    898899,
    878877,
    787989,
    877777,
    998877,
    868877,
    988878,
    887878,
    887878,
    888888,
    888779,
    888697,
    667889,
    877989,
    888797,
    898886,
    889898,
    987878,
    978998,
    887887,
    888778,
    888898,
    897999,
    989888,
    876887,
    977888,
    798876,
    978868,
    988877,
    798997,
    878778,
    878897,
    877889,
    688988,
    877888,
    979796,
    778977,
    788787,
    888898,
    687888,
    889968,
    787677,
    777987,
    987767,
    886789,
    788988,
    779887,
    687768,
    889788,
    988887,
    898677,
    878888,
    787778,
    887688,
    877789,
    787799,
    897778,
    989888,
    998787,
    978888,
    677869,
    988788,
    799779,
    799789,
    977687,
    877897,
    796799,
    997787,
    778777,
    887978,
    988878,
    887978,
    978888,
    898898,
    798888,
    678698,
    688688,
    798968,
    787787,
    788789,
    889877,
    796888,
    799787,
    898989,
    797698,
    789988,
    898887,
    878799,
    897787,
    798978,
    868997,
    888998,
    888987,
    787787,
    678878,
    899777,
    889878,
    778767,
    989887,
    887796,
    888787,
    788898,
    888879,
    788877,
    889989,
    888987,
    878978,
    887787,
    967776,
    798797,
    889988,
    798877,
    788886,
    788787,
    779886,
    799878,
    787878,
    888798,
    977878,
    779688,
    778987,
    898889,
    777787,
    678798,
    989877,
    888797,
    688887,
    878778,
    897978,
    878798,
    889778,
    887977,
    787877,
    798888,
    887887,
    876887,
    878878,
    699778,
    799797,
    997878,
    878888,
    778887,
    886888,
    897888,
    767787,
    996788,
    897878,
    797988,
    888777,
    778897,
    687988,
    879978,
    778988,
    998778,
    878988,
    789777,
    879897,
    878788,
    686888,
    777779,
    988888,
    888689,
    889889,
    788767,
    887988,
    879778,
    998777,
    786779,
    888788,
    778788,
    788887,
    799899,
    996997,
    887877,
    898778,
    698888,
    778778,
    878987,
    688898,
    789767,
    878769,
    878977,
    878678,
    897969,
    788898,
    877777,
    777887,
    787787,
    768778,
    878979,
    877779,
    887988,
    888988,
    777978,
    978998,
    878788,
    788786,
    898889,
    867777,
    788888,
    787788,
    977977,
    788888,
    978897,
    798777,
    779889,
    878887,
    897897,
    788989,
    767787,
    889888,
    979788,
    888886,
    797778,
    879777,
    879878,
    878778,
    876778,
    978878,
    986998,
    897897,
    677898,
    888897,
    778899,
    868778,
    987878,
    968788,
    877888,
    788797,
    867887,
    879878,
    797897,
    878998,
    986878,
    678767,
    877786,
    677887,
    987877,
    798888,
    676997,
    997768,
    769689,
    688886,
    869887,
    787888,
    888969,
    887799,
    877687,
    798889,
    997868,
    976889,
    787787,
    798687,
    677989,
    778978,
    878777,
    997797,
    979789,
    878896,
    878788,
    877886,
    887889,
    879697,
    788777,
    689877,
    879677,
    799697,
    888878,
    898886,
    878899,
    788867,
    989768,
    876799,
    798768,
    979777,
    868898,
    888887,
    798888,
    979898,
    898798,
    888986,
    677897,
    898797,
    988668,
    888688,
    988787,
    786888,
    868778,
    788787,
    688797,
    786899,
    788889,
    778878,
    888888,
    788988,
    877998,
    797987,
    889778,
    889877,
    888788,
    878887,
    869977,
    878799,
    797798,
    988777,
    986767,
    987786,
    977779,
    698887,
    888988,
    787678,
    987979,
    689878,
    888867,
    777977,
    686877,
    888697,
    888897,
    968887,
    778968,
    978788,
    878987,
    986878,
    779878,
    988776,
    787878,
    888779,
    978888,
    799888,
    988979,
    778788,
    789787,
    879887,
    787777,
    677878,
    879778,
    869887,
    788777,
    887868,
    799878,
    978767,
    899879,
    787998,
    997767,
    787898,
    888788,
    877986,
    788688,
    986797,
    867778,
    979889,
    897777,
    878997,
    878988,
    687888,
    897678,
    769876,
    789777,
    987778,
    877789,
    688887,
    998776,
    866698,
    889878,
    788778,
    977789,
    687767,
    978897,
    979778,
    877677,
    968788,
    797899,
    877898,
    798798,
    888786,
    788888,
    787787,
    789878,
    868887,
    878868,
    998977,
    787977,
    987889,
    997779,
    779888,
    777798,
    988887,
    689999,
    978779,
    789878,
    888777,
    788987,
    889798,
    679779,
    777898,
    778779,
    888897,
    879897,
    887997,
    779797,
    679697,
    889788,
    767779,
    987778,
    888888,
    688998,
    877886,
    887878,
    888889,
    687777,
    689766,
    887688,
    788877,
    898987,
    897987,
    867787,
    787876,
    886888,
    878788,
    789777,
    887777,
    888799,
    878887,
    898877,
    988778,
    987778,
    888689,
    889686,
    888888,
    886888,
    777979,
    978887,
    797897,
    998888,
    968798,
    788988,
    788766,
    998979,
    987779,
    879787,
    997879,
    767876,
    787689,
    768778,
    787679,
    879878,
    789888,
    788887,
    887978,
    878878,
    898797,
    879887,
    778798,
    986887,
    878788,
    788777,
    988687,
    678887,
    887769,
    779888,
    789798,
    789777,
    879876,
    887887,
    988788,
    898888,
    777699,
    979778,
    897987,
    787978,
    888977,
    888879,
    888987,
    897898,
    878779,
    886898,
    877797,
    778787,
    898877,
    787878,
    978787,
    997899,
    987789,
    799778,
    878887,
    988898,
    888777,
    798789,
    878788,
    768788,
    787797,
    698877,
    877879,
    787868,
    888768,
    877879,
    978877,
    799868,
    797767,
    867687,
    897797,
    787788,
    888878,
    888968,
    977879,
    786889,
    987968,
    778898,
    888879,
    877778,
    878777,
    768797,
    797789,
    988978,
    888897,
    998878,
    887897,
    888797,
    788897,
    788778,
    878887,
    797867,
    799969,
    998788,
    778887,
    789887,
    777888,
    987999,
    877898,
    889888,
    898977,
    688877,
    978768,
    778978,
    977899,
    889789,
    888778,
    789797,
    786897,
    888889,
    877796,
    998668,
    688879,
    888987,
    778889,
    777797,
    779988,
    987987,
    797767,
    887798,
    988888,
    989777,
    777889,
    787899,
    989777,
    978977,
    777878,
    877879,
    787787,
    999777,
    876787,
    888988,
    779787,
    679798,
    988966,
    778876,
    897887,
    768788,
    978787,
    678779,
    667798,
    999777,
    768988,
    879869,
    989887,
    797867,
    788878,
    878678,
    898889,
    787688,
    887887,
    778788,
    787788,
    898767,
    868888,
    977877,
    988987,
    888877,
    877787,
    997796,
    778887,
    888997,
    999678,
    779788,
    799677,
    887879,
    898888,
    767788,
    877797,
    778877,
    989878,
    888778,
    988996,
    998887,
    878888,
    998998,
    879679,
    688897,
    978978,
    687777,
    887878,
    788787,
    888788,
    787769,
    787788,
    769877,
    878878,
    867977,
    967778,
    887789,
    788776,
    868698,
    988897,
    778787,
    789997,
    967987,
    788888,
    888687,
    889967,
    898878,
    799789,
    977887,
    797677,
    998889,
    798777,
    798788,
    668889,
    867789,
    889997,
    778988,
    778779,
    867997,
    887878,
    887996,
    777877,
    677997,
    888877,
    788887,
    889867,
    788778,
    887977,
    886898,
    787879,
    788888,
    789688,
    768887,
    987996,
    788778,
    798888,
    788978,
    888897,
    799898,
    978887,
    887889,
    887968,
    989998,
    899988,
    878778,
    788997,
    668877,
    878988,
    987888,
    797968,
    778888,
    987989,
    877777,
    688968,
    778776,
    788887,
    878677,
    776888,
    799789,
    797979,
    897867,
    886777,
    887878,
    888878,
    887969,
    888878,
    779787,
    788797,
    777988,
    889888,
    788967,
    988999,
    789887,
    788967,
    778897,
    877889,
    767678,
    887778,
    788878,
    777777,
    977788,
    988787,
    978879,
    787877,
    886787,
    787878,
    888898,
    779978,
    987888,
    898898,
    778768,
    788879,
    788868,
    779986,
    888988,
    788898,
    778879,
    888878,
    678778,
    869778,
    868798,
    689797,
    888878,
    678777,
    878879,
    866786,
    887888,
    779697,
    798987,
    888987,
    787898,
    887968,
    779799,
    897878,
    677989,
    686777,
    888797,
    798977,
    888888,
    886787,
    788986,
    976987,
    789979,
    987897,
    989778,
    899997,
    787689,
    877788,
    989787,
    868768,
    998878,
    998798,
    898788,
    978998,
    787688,
    777798,
    868778,
    776887,
    887787,
    887697,
    788898,
    997898,
    877788,
    877877,
    876788,
    886676,
    798787,
    689877,
    877987,
    777889,
    977878,
    887768,
    798789,
    888898,
    797788,
    979879,
    669788,
    787898,
    787878,
    698778,
    887987,
    878867,
    868788,
    688987,
    988887,
    769778,
    787898,
    788897,
    878878,
    979677,
    987798,
    898978,
    898986,
    878886,
    777768,
    878677,
    989879,
    797798,
    788787,
    886888,
    787788,
    988799,
    777966,
    888779,
    987888,
    978898,
    786978,
    988876,
    778876,
    977798,
    888788,
    787979,
    787688,
    898688,
    989988,
    889789,
    887787,
    787687,
    979878,
    777778,
    778787,
    767887,
    787977,
    767787,
    688788,
    979878,
    787889,
    688987,
    879997,
    787896,
    798886,
    887879,
    888786,
    788988,
    888878,
    977789,
    886978,
    978878,
    777898,
    777967,
    878878,
    878898,
    876787,
    887976,
    778779,
    787787,
    988877,
    877688,
    877878,
    887897,
    787878,
    996787,
    888879,
    986898,
    897968,
    887977,
    988899,
    788987,
    988888,
    897778,
    898899,
    889997,
    787876,
    976987,
    996997,
    777878,
    887888,
    997788,
    798778,
    899886,
    877997,
    776787,
    989787,
    878878,
    777878,
    778789,
    898778,
    877788,
    877997,
    887789,
    876867,
    788697,
    977998,
    888888,
    888888,
    989898,
    779787,
    979997,
    867978,
    778867,
    779989,
    697778,
    888789,
    988979,
    878897,
    878878,
    889667,
    878979,
    876776,
    878866,
    888777,
    788988,
    877877,
    988979,
    789999,
    979877,
    887788,
    887976,
    989887,
    788677,
    976887,
    888789,
    878787,
    978888,
    787887,
    777787,
    688788,
    878987,
    798987,
    987788,
    769899,
    789779,
    878798,
    899787,
    766687,
    797989,
    797897,
    888788,
    969777,
    889988,
    998769,
    899888,
    888879,
    788978,
    988988,
    998878,
    888789,
    877778,
    698988,
    977878,
    878888,
    888977,
    987767,
    778897,
    889969,
    888897,
    889799,
    988999,
    798778,
    889888,
    878988,
    788988,
    878677,
    878886,
    987787,
    977797,
    888787,
    777879,
    887777,
    788988,
    699978,
    898689,
    768888,
    889697,
    889867,
    898788,
    788887,
    999899,
    887778,
    777878,
    878977,
    988768,
    868798,
    989778,
    767889,
    879887,
    897788,
    997798,
    879798,
    887989,
    778898,
    879898,
    776877,
    887887,
    997789,
    898898,
    876789,
    789888,
    769698,
    877779,
    997679,
    877779,
    899899,
    697679,
    997888,
    979878,
    897687,
    968888,
    788888,
    878897,
    789997,
    669788,
    887888,
    888878,
    798886,
    887888,
    899767,
    779978,
    788987,
    797797,
    897887,
    978777,
    888997,
    888788,
    787997,
    798888,
    889787,
    778978,
    879697,
    887877,
    988877,
    779677,
    779897,
    776998,
    979787,
    779777,
    888788,
    788978,
    798898,
    778787,
    877868,
    887987,
    886777,
    777998,
    887878,
    889877,
    679878,
    879887,
    887877,
    788899,
    878787,
    888887,
    688868,
    787687,
    687878,
    879886,
    989878,
    898797,
    797876,
    888888,
    987787,
    878879,
    888879,
    788688,
    887888,
    897988,
    798888,
    778898,
    879876,
    787899,
    877777,
    888988,
    878888,
    786877,
    789899,
    979888,
    888878,
    778997,
    997978,
    988787,
    999779,
    797887,
    687878,
    777897,
    977777,
    787989,
    887687,
    778777,
    988688,
    788787,
    868899,
    787786,
    878988,
    968979,
    778868,
    979897,
    878798,
    788898,
    767999,
    897688,
    778867,
    878876,
    977876,
    798877,
    878869,
    867789,
    699879,
    879766,
    698688,
    799977,
    879788,
    879798,
    788878,
    867898,
    798986,
    898788,
    887778,
    679988,
    997889,
    977888,
    789777,
    889798,
    797788,
    977869,
    878869,
    798688,
    876868,
    789778,
    779768,
    969867,
    788778,
    788987,
    689879,
    977967,
    898897,
    888798,
    886968,
    977888,
    787798,
    879788,
    868979,
    786778,
    888798,
    887889,
    888786,
    997979,
    776889,
    798888,
    897998,
    878878,
    879776,
    887776,
    788998,
    898798,
    889888,
    967779,
    797777,
    798888,
    888887,
    778979,
    889777,
    798887,
    768688,
    887779,
    878888,
    887788,
    876878,
    788798,
    967887,
    887767,
    898778,
    898898,
    988888,
    688878,
    877977,
    788898,
    788978,
    786887,
    799877,
    787879,
    987687,
    888979,
    867777,
    788887,
    887978,
    978988,
    877798,
    989977,
    888877,
    798988,
    888898,
    989898,
    888697,
    878677,
    887978,
    696877,
    877778,
    986788,
    897888,
    877889,
    887877,
    978879,
    878798,
    698888,
    889877,
    778888,
    968889,
    787689,
    878877,
    898799,
    786878,
    999868,
    986676,
    897899,
    987788,
    778997,
    789777,
    978787,
    987997,
    887888,
    977898,
    779988,
    888698,
    689787,
    789889,
    987978,
    689789,
    888897,
    998779,
    869989,
    886878,
    899798,
    789887,
    878897,
    888977,
    767888,
    988789,
    797878,
    698869,
    988776,
    878967,
    777896,
    788898,
    987887,
    988788,
    987877,
    989788,
    979988,
    879889,
    797878,
    768689,
    899787,
    888887,
    877769,
    788976,
    787888,
    889797,
    989897,
    877687,
    877787,
    877997,
    887788,
    879899,
    887898,
    987787,
    787788,
    876889,
    887989,
    997888,
    779988,
    877888,
    887777,
    878888,
    777899,
    886689,
    797799,
    868879,
    876888,
    877899,
    678788,
    879776,
    998787,
    877977,
    996896,
    888887,
    677798,
    887896,
    898887,
    887877,
    879889,
    887879,
    896677,
    778778,
    888798,
    999787,
    886778,
    887987,
    879898,
    777799,
    979787,
    888877,
    767778,
    777789,
    799889,
    788899,
    878889,
    998978,
    678889,
    898799,
    898886,
    888987,
    678897,
    888878,
    878798,
    988878,
    999798,
    879998,
    778978,
    998777,
    978797,
    777788,
    788779,
    788878,
    999889,
    888967,
    888778,
    878878,
    889988,
    787879,
    988877,
    888778,
    778778,
    899789,
    788788,
    877787,
    877896,
    879978,
    997877,
    888977,
    898779,
    986878,
    987668,
    978977,
    877889,
    777788,
    797779,
    898788,
    878788,
    888888,
    989799,
    689799,
    879897,
    777868,
    697878,
    797887,
    987888,
    787978,
    789789,
    878878,
    888897,
    887888,
    777797,
    788878,
    879888,
    868898,
    878788,
    878887,
    776779,
    887976,
    777788,
    978777,
    978667,
    788887,
    997777,
    689787,
    676878,
    988987,
    898888,
    877897,
    988887,
    877888,
    867897,
    778998,
    989896,
    977798,
    798798,
    788779,
    889987,
    797777,
    988789,
    797887,
    997786,
    888787,
    879896,
    987879,
    887777,
    887778,
    969879,
    777778,
    797878,
    778987,
    878889,
    777879,
    777899,
    869987,
    897687,
    889676,
    997697,
    886997,
    889776,
    888878,
    789788,
    888899,
    888887,
    888998,
    777878,
    878787,
    789798,
    887897,
    888889,
    889969,
    888678,
    788989,
    988777,
    699688,
    778778,
    869796,
    798786,
    889766,
    889889,
    978787,
    868987,
    989886,
    988788,
    777666,
    979777,
    787998,
    897887,
    876777,
    977887,
    878679,
    779779,
    788789,
    997789,
    797778,
    888877,
    988798,
    799778,
    899888,
    888978,
    678778,
    899887,
    978889,
    798878,
    798869,
    979988,
    898889,
    768887,
    978878,
    898778,
    768888,
    678989,
    887768,
    799896,
    787777,
    777889,
    769688,
    898988,
    879897,
    677788,
    787977,
    888788,
    798679,
    797977,
    778777,
    867778,
    886888,
    787888,
    988787,
    878787,
    777778,
    888867,
    878898,
    878877,
    986898,
    788779,
    977787,
    787988,
    788998,
    878788,
    896878,
    987787,
    868887,
    877788,
    798867,
    789787,
    977887,
    787777,
    887999,
    687878,
    789888,
    887867,
    987898,
    789787,
    898879,
    898986,
    897689,
    887988,
    779886,
    877787,
    787877,
    787987,
    877798,
    899898,
    988777,
    887997,
    689878,
    687989,
    787878,
    886988,
    687869,
    887897,
    869778,
    798888,
    789878,
    898689,
    888888,
    888787,
    887887,
    779887,
    988877,
    978788,
    897896,
    988979,
    879669,
    688877,
    789877,
    878678,
    887788,
    879797,
    898898,
    868799,
    897778,
    988767,
    977888,
    798678,
    798798,
    799878,
    988798,
    676868,
    698788,
    877878,
    788777,
    897798,
    799798,
    988688,
    896786,
    889987,
    778968,
    989888,
    886798,
    798768,
    789998,
    897888,
    888798,
    787877,
    877878,
    888778,
    787987,
    768988,
    777989,
    999887,
    779869,
    897977,
    987888,
    879889,
    897777,
    897778,
    788978,
    988687,
    778786,
    988968,
    678769,
    968798,
    968878,
    786887,
    787977,
    876898,
    898878,
    888997,
    798697,
    989777,
    797898,
    888878,
    977777,
    987878,
    777887,
    887777,
    789887,
    788778,
    886986,
    777789,
    778787,
    887997,
    987797,
    979687,
    778978,
    788977,
    777978,
    778987,
    898877,
    877798,
    786887,
    988878,
    988799,
    867888,
    888788,
    779887,
    788887,
    878976,
    788787,
    888777,
    789889,
    996787,
    888788,
    888898,
    977967,
    779868,
    977787,
    888898,
    987789,
    879889,
    898788,
    868978,
    898888,
    778878,
    997788,
    887997,
    988788,
    997786,
    987977,
    897789,
    867888,
    798987,
    788888,
    887788,
    889778,
    779777,
    797878,
    979788,
    887767,
    888788,
    789899,
    879789,
    698877,
    887978,
    878897,
    887876,
    888798,
    897678,
    888796,
    987777,
    788888,
    899987,
    889888,
    896898,
    789788,
    878968,
    877767,
    769787,
    686798,
    679687,
    799887,
    887978,
    778789,
    868888,
    976878,
    878778,
    888978,
    888897,
    989899,
    789989,
    787898,
    888998,
    787899,
    778688,
    779996,
    788968,
    779778,
    798786,
    779788,
    886877,
    878788,
    897787,
    878789,
    878888,
    879787,
    798888,
    878777,
    776988,
    798978,
    877898,
    888788,
    789778,
    878968,
    977797,
    778888,
    778987,
    888896,
    889977,
    868978,
    689898,
    897689,
    889777,
    987798,
    877788,
    897789,
    897897,
    777888,
    898879,
    867878,
    877976,
    997897,
    898988,
    777788,
    888778,
    988787,
    887887,
    887778,
    898788,
    868888,
    788788,
    878897,
    787989,
    978789,
    889877,
    887888,
    998978,
    978977,
    997787,
    768777,
    878798,
    798898,
    768888,
    876799,
    888889,
    887887,
    887797,
    789987,
    877988,
    788779,
    889778,
    788977,
    889898,
    978888,
    889997,
    797896,
    978898,
    777687,
    777889,
    888887,
    798886,
    778679,
    887868,
    677889,
    977797,
    788888,
    988887,
    877878,
    988788,
    777779,
    778787,
    879877,
    879899,
    989879,
    777889,
    777789,
    876898,
    778888,
    878788,
    887878,
    788878,
    887988,
    677888,
    899968,
    967898,
    987988,
    978868,
    788889,
    889878,
    889888,
    796898,
    779868,
    788987,
    877879,
    768878,
    787888,
    987896,
    878879,
    998888,
    777777,
    878896,
    888978,
    778689,
    888989,
    989898,
    989777,
    866779,
    878867,
    889898,
    798879,
    889778,
    776886,
    789988,
    898988,
    877677,
    778879,
    888868,
    788886,
    779888,
    786799,
    679976,
    887897,
    779998,
    888888,
    877787,
    767897,
    797798,
    779889,
    888778,
    897697,
    898886,
    788977,
    777786,
    678777,
    978767,
    877777,
    987886,
    876778,
    887887,
    998977,
    687887,
    788888,
    679868,
    677878,
    887667,
    979787,
    778998,
    987789,
    798777,
    887877,
    979878,
    887868,
    877898,
    797898,
    777877,
    788887,
    777767,
    788988,
    988887,
    788867,
    697786,
    888778,
    789867,
    769998,
    778687,
    788779,
    799878,
    888986,
    768688,
    678988,
    878789,
    998889,
    989867,
    898687,
    797788,
    877868,
    797898,
    989978,
    678788,
    888677,
    887867,
    978897,
    886887,
    788778,
    878999,
    887997,
    779798,
    888888,
    888888,
    796979,
    879778,
    879787,
    898686,
    667877,
    977897,
    798888,
    978889,
    878779,
    977688,
    798676,
    787887,
    777878,
    987887,
    987979,
    878797,
    869878,
    889778,
    877797,
    687878,
    698888,
    789787,
    888869,
    877777,
    697879,
    688897,
    876888,
    889989,
    887777,
    976789,
    797789,
    798889,
    878998,
    877898,
    778978,
    878988,
    788887,
    987798,
    688888,
    999979,
    869697,
    789887,
    877868,
    888887,
    778879,
    997888,
    889888,
    689878,
    886787,
    878898,
    789796,
    787769,
    888988,
    896887,
    989788,
    887788,
    986897,
    779989,
    887788,
    888977,
    998779,
    788697,
    879788,
    777877,
    689787,
    789887,
    987797,
    788778,
    887878,
    899888,
    977877,
    779698,
    797888,
    697799,
    887887,
    887879,
    898887,
    787987,
    778898,
    887768,
    779878,
    787979,
    887999,
    878997,
    788787,
    987777,
    877789,
    788787,
    778888,
    788978,
    789778,
    778788,
    897787,
    888877,
    979678,
    777878,
    788886,
    877889,
    788787,
    887888,
    888788,
    888788,
    898988,
    999787,
    887888,
    697968,
    778978,
    887788,
    979888,
    768687,
    888977,
    778786,
    867788,
    978899,
    777789,
    987768,
    899887,
    777978,
    769977,
    968876,
    787987,
    788886,
    788778,
    788879,
    898876,
    789888,
    799889,
    878788,
    788786,
    788778,
    788998,
    797887,
    879996,
    877878,
    776877,
    868887,
    788898,
    887868,
    977987,
    877878,
    879987,
    978878,
    878877,
    778887,
    768988,
    867779,
    896688,
    888878,
    988668,
    798988,
    898887,
    879886,
    787877,
    899878,
    988897,
    978677,
    897878,
    797778,
    678779,
    879787,
    878878,
    989868,
    788877,
    778988,
    797987,
    987777,
    677899,
    988889,
    768676,
    879987,
    777878,
    886988,
    687977,
    799789,
    778978,
    987787,
    888876,
    878877,
    797888,
    898989,
    979789,
    889777,
    988788,
    898878,
    888798,
    888777,
    678778,
    889887,
    878778,
    988878,
    998686,
    887778,
    777698,
    888887,
    987977,
    788888,
    899887,
    889688,
    887998,
    798786,
    799978,
    886877,
    889887,
    878886,
    978787,
    667878,
    789787,
    868878,
    788798,
    898968,
    698879,
    889778,
    989889,
    787786,
    877768,
    897988,
    698978,
    789778,
    897767,
    789798,
    688787,
    888877,
    986967,
    887887,
    688998,
    789979,
    668789,
    987789,
    878798,
    887878,
    787989,
    778888,
    999987,
    889887,
    886987,
    797787,
    789799,
    979988,
    896989,
    779898,
    777787,
    799899,
    868799,
    899878,
    787899,
    778887,
    878898,
    988868,
    888868,
    877777,
    776889,
    678889,
    779898,
    986688,
    969788,
    788887,
    787997,
    768788,
    877879,
    886886,
    889778,
    897968,
    877879,
    788878,
    887878,
    888787,
    869888,
    787977,
    988788,
    867787,
    677978,
    677687,
    888778,
    987987,
    888888,
    877888,
    997889,
    787897,
    799786,
    988867,
    689897,
    888888,
    778777,
    788797,
    976886,
    997888,
    798888,
    798878,
    777798,
    978678,
    797988,
    899889,
    988786,
    778888,
    979888,
    887898,
    877779,
    787987,
    899868,
    978997,
    878878,
    887998,
    788886,
    888888,
    797888,
    988878,
    778988,
    887988,
    789777,
    988887,
    879867,
    897987,
    886987,
    889888,
    898688,
    997677,
    889888,
    879787,
    786777,
    866888,
    687687,
    879688,
    897788,
    897778,
    869987,
    777988,
    868888,
    777877,
    877877,
    898788,
    787897,
    887977,
    699988,
    878888,
    978668,
    978887,
    887798,
    988778,
    788777,
    899778,
    978798,
    779878,
    867888,
    879867,
    797877,
    889999,
    767876,
    878879,
    798979,
    789677,
    897998,
    776888,
    979896,
    878887,
    989898,
    787767,
    778988,
    878978,
    988799,
    788787,
    797786,
    977967,
    888888,
    777887,
    787888,
    997888,
    867778,
    788897,
    778888,
    997779,
    878789,
    888768,
    787899,
    888978,
    877878,
    889879,
    868877,
    688977,
    889788,
    878776,
    696888,
    778868,
    777888,
    776987,
    887868,
    989778,
    876769,
    889989,
    877689,
    998979,
    888877,
    998688,
    989879,
    778888,
    787998,
    677997,
    787887,
    788798,
    876889,
    797687,
    978877,
    787788,
    988887,
    968988,
    877887,
    888878,
    777988,
    888676,
    989788,
    777887,
    978778,
    888869,
    889977,
    778987,
    798886,
    988868,
    878987,
    767879,
    899769,
    888988,
    898898,
    988878,
    978788,
    788887,
    676896,
    797898,
    788877,
    667888,
    878887,
    889879,
    778768,
    897989,
    878889,
    878779,
    687788,
    887878,
    896888,
    798779,
    887799,
    889777,
    997979,
    787889,
    887768,
    878898,
    998896,
    879867,
    876889,
    688697,
    787787,
    889777,
    899768,
    997986,
    687778,
    678878,
    977888,
    989688,
    988888,
    778898,
    789787,
    789778,
    878997,
    788798,
    777788,
    988679,
    899878,
    888879,
    977867,
    878779,
    879887,
    878876,
    797789,
    879688,
    978966,
    898797,
    779779,
    788678,
    877778,
    879968,
    977887,
    997888,
    988678,
    897878,
    798777,
    788777,
    897787,
    978879,
    698776,
    778678,
    978678,
    797897,
    779787,
    886788,
    888998,
    789887,
    789987,
    788887,
    897977,
    788889,
    789887,
    879997,
    978877,
    999786,
    778877,
    987989,
    788977,
    879887,
    787877,
    777888,
    788988,
    899768,
    987898,
    776878,
    788988,
    697879,
    887878,
    878877,
    878789,
    987998,
    987788,
    776898,
    778778,
    678877,
    878977,
    897688,
    898897,
    789999,
    887698,
    986888,
    988789,
    777789,
    979898,
    778878,
    979888,
    898899,
    978777,
    798898,
    898879,
    988869,
    997988,
    988798,
    787877,
    887779,
    768868,
    688888,
    788888,
    899888,
    888788,
    777988,
    876778,
    878889,
    877788,
    867877,
    799789,
    889867,
    888988,
    877867,
    888886,
    989877,
    798878,
    878887,
    977779,
    878887,
    888777,
    978787,
    887789,
    886877,
    878887,
    987888,
    889977,
    887667,
    999787,
    687786,
    788879,
    978866,
    898789,
    789978,
    988878,
    988777,
    877697,
    767897,
    888889,
    898889,
    778887,
    797877,
    779778,
    988768,
    979878,
    888778,
    988888,
    788779,
    798877,
    787978,
    898887,
    787788,
    968777,
    787979,
    778887,
    996878,
    889877,
    796888,
    888788,
    796978,
    999878,
    978788,
    789689,
    879889,
    787879,
    777898,
    788777,
    779789,
    777779,
    989887,
    978776,
    678998,
    989987,
    777877,
    888877,
    986879,
    767888,
    778788,
    776887,
    877889,
    897799,
    877977,
    899787,
    887888,
    996788,
    888887,
    779868,
    768779,
    688879,
    867778,
    889787,
    968979,
    898889,
    889998,
    867887,
    777687,
    987887,
    889698,
    788687,
    989798,
    888887,
    688887,
    889867,
    878887,
    978797,
    797878,
    788988,
    767797,
    896869,
    876877,
    889878,
    887989,
    989888,
    888789,
    789888,
    868779,
    898898,
    879998,
    998887,
    867879,
    878987,
    788789,
    879977,
    679878,
    778887,
    797899,
    979897,
    898998,
    888788,
    887997,
    697899,
    779888,
    888789,
    977988,
    878898,
    867798,
    886777,
    788879,
    989988,
    889888,
    799687,
    886777,
    879899,
    977878,
    768869,
    888977,
    888668,
    887877,
    877778,
    887987,
    978788,
    878888,
    787976,
    887988,
    997888,
    889887,
    889778,
    877878,
    878689,
    886797,
    877789,
    878878,
    788989,
    977868,
    788888,
    877797,
    887776,
    777977,
    688688,
    788786,
    687877,
    968997,
    987887,
    789698,
    778879,
    889788,
    779887,
    787779,
    777867,
    988897,
    998678,
    779786,
    887767,
    787788,
    887688,
    778678,
    886788,
    968789,
    886787,
    877679,
    677988,
    999888,
    788978,
    767889,
    876888,
    789889,
    889867,
    787798,
    887868,
    788889,
    977887,
    977767,
    788779,
    897877,
    878987,
    879799,
    996887,
    978878,
    986887,
    887987,
    797678,
    898787,
    977788,
    878888,
    899986,
    998788,
    798889,
    986897,
    787868,
    679878,
    988877,
    986776,
    887887,
    888797,
    768878,
    978889,
    998877,
    988877,
    889897,
    787787,
    798887,
    897886,
    868777,
    788889,
    788788,
    887878,
    978977,
    787889,
    877898,
    777798,
    769898,
    998777,
    878987,
    797787,
    879788,
    988878,
    787886,
    777769,
    877878,
    788988,
    997897,
    876888,
    987689,
    787898,
    778786,
    778788,
    898877,
    777888,
    886878,
    697676,
    678886,
    968787,
    888768,
    787788,
    878978,
    778987,
    979788,
    887778,
    888878,
    789897,
    778877,
    888987,
    887678,
    768788,
    886897,
    888798,
    698878,
    778789,
    887997,
    989886,
    788878,
    897869,
    887979,
    789987,
    877968,
    698878,
    889977,
    879877,
    778887,
    878778,
    788879,
    878987,
    787976,
    888787,
    887888,
    798888,
    797889,
    688897,
    787978,
    779868,
    789888,
    779987,
    967867,
    788887,
    977886,
    888877,
    888968,
    887897,
    778677,
    789788,
    878789,
    888989,
    886999,
    879887,
    897878,
    787778,
    887796,
    978789,
    977688,
    878888,
    767998,
    878997,
    787787,
    977787,
    798878,
    788787,
    887798,
    789878,
    988998,
    989898,
    789977,
    787778,
    878767,
    798787,
    987886,
    889996,
    778878,
    878978,
    977978,
    787787,
    787987,
    777889,
    888898,
    778789,
    879889,
    889977,
    898999,
    789787,
    867897,
    768889,
    967788,
    796787,
    798887,
    898798,
    798886,
    888897,
    977979,
    898978,
    786979,
    798887,
    769997,
    888787,
    879988,
    799888,
    788888,
    888788,
    877869,
    778778,
    968878,
    888988,
    887766,
    889877,
    688978,
    988788,
    787897,
    988878,
    778787,
    897899,
    677897,
    968787,
    978688,
    888899,
    779788,
    888999,
    778978,
    797868,
    998988,
    888977,
    799778,
    887778,
    998989,
    977889,
    879687,
    677997,
    888789,
    687788,
    778997,
    678789,
    788787,
    998977,
    688998,
    997989,
    888889,
    989989,
    787979,
    798898,
    687877,
    898689,
    777888,
    979878,
    888778,
    898797,
    888998,
    769878,
    897888,
    788898,
    777798,
    876897,
    897777,
    987698,
    887889,
    788887,
    887898,
    988777,
    877987,
    887977,
    898779,
    777889,
    689878,
    877887,
    787788,
    797688,
    688798,
    788787,
    888778,
    787878,
    879678,
    788788,
    889889,
    778987,
    788679,
    789868,
    897988,
    979676,
    887876,
    899686,
    799697,
    788898,
    888887,
    786978,
    779687,
    787997,
    888878,
    887787,
    877777,
    997898,
    989887,
    787977,
    997978,
    778896,
    888889,
    987989,
    768777,
    788687,
    977988,
    897796,
    789788,
    778788,
    879887,
    877879,
    877789,
    879688,
    689898,
    778978,
    779698,
    887979,
    798798,
    798886,
    797888,
    668988,
    789879,
    788888,
    877888,
    786698,
    888868,
    778989,
    877689,
    878977,
    887897,
    887987,
    898868,
    988888,
    888978,
    898886,
    778769,
    877798,
    878979,
    887879,
    797888,
    678787,
    899887,
    889988,
    897977,
    868897,
    988798,
    888887,
    887978,
    878879,
    688888,
    989888,
    887888,
    787999,
    798778,
    988888,
    987867,
    779878,
    798788,
    698777,
    779987,
    978878,
    887787,
    997698,
    798987,
    687879,
    887896,
    879988,
    867889,
    798887,
    768897,
    988888,
    888878,
    889879,
    879778,
    897888,
    787886,
    769778,
    878887,
    867878,
    687678,
    899978,
    787877,
    897868,
    787889,
    788997,
    867788,
    877878,
    887977,
    878788,
    788897,
    879988,
    877778,
    688987,
    877767,
    766979,
    878987,
    789777,
    897877,
    898879,
    779776,
    999777,
    886787,
    887879,
    878787,
    789799,
    977986,
    766788,
    868888,
    988887,
    796888,
    899878,
    878766,
    989898,
    887878,
    687877,
    988878,
    868798,
    887896,
    978788,
    798977,
    788788,
    789887,
    888888,
    786888,
    787677,
    898799,
    986987,
    888788,
    787788,
    897888,
    788978,
    888778,
    989888,
    678778,
    978978,
    877878,
    899878,
    688768,
    887887,
    878797,
    888897,
    879798,
    988998,
    787878,
    877787,
    788779,
    887788,
    897797,
    796887,
    888799,
    797978,
    987797,
    867877,
    976999,
    878786,
    877897,
    868989,
    898788,
    886768,
    778889,
    789888,
    887897,
    876898,
    779898,
    789788,
    997898,
    897798,
    777876,
    999988,
    888986,
    797999,
    798788,
    988877,
    777986,
    997788,
    898788,
    687887,
    888888,
    888878,
    678788,
    978877,
    878888,
    887878,
    798978,
    788887,
    988887,
    888788,
    777779,
    988978,
    877887,
    887877,
    789998,
    867778,
    997696,
    869878,
    778967,
    786888,
    989879,
    878778,
    787787,
    978879,
    987876,
    987878,
    878987,
    688889,
    977789,
    798878,
    888978,
    989868,
    897989,
    877778,
    769788,
    879898,
    877799,
    988878,
    788798,
    798688,
    977698,
    899697,
    799798,
    797869,
    989788,
    777787,
    788789,
    787988,
    788989,
    888877,
    887897,
    988888,
    887989,
    796788,
    987978,
    988787,
    787887,
    889888,
    876778,
    889977,
    998877,
    888968,
    787978,
    887898,
    788888,
    788788,
    797897,
    889797,
    678897,
    787897,
    888888,
    768988,
    898798,
    969786,
    888779,
    778898,
    878878,
    888777,
    888788,
    788676,
    897868,
    888689,
    798887,
    997789,
    779998,
    788869,
    887877,
    787779,
    788789,
    977687,
    899668,
    887976,
    697889,
    867897,
    998798,
    799788,
    877687,
    788788,
    879968,
    777888,
    779789,
    798879,
    788897,
    788888,
    789888,
    778777,
    789878,
    787887,
    777779,
    868879,
    689888,
    997688,
    978879,
    889897,
    696778,
    997888,
    987986,
    788779,
    776886,
    878877,
    877687,
    777988,
    786788,
    878898,
    877798,
    899798,
    988888,
    887677,
    888777,
    798897,
    878789,
    777777,
    777789,
    987777,
    779777,
    777988,
    878898,
    888967,
    888876,
    899999,
    887988,
    787898,
    978877,
    897868,
    877868,
    767988,
    778888,
    789778,
    878988,
    877888,
    777698,
    887798,
    788989,
    888877,
    687987,
    977786,
    877688,
    877798,
    778888,
    879877,
    878777,
    978988,
    676798,
    967978,
    989877,
    876899,
    878889,
    788787,
    998788,
    997888,
    987889,
    976787,
    868787,
    697997,
    878788,
    778787,
    877887,
    797776,
    788878,
    979888,
    788986,
    898787,
    988887,
    777978,
    997977,
    788789,
    867898,
    987967,
    788868,
    787877,
    888778,
    797887,
    978877,
    789987,
    878769,
    888678,
    888777,
    897888,
    878887,
    777878,
    989887,
    878787,
    877887,
    877888,
    877967,
    987778,
    977867,
    899888,
    868979,
    898977,
    878878,
    688797,
    899878,
    978888,
    788877,
    989888,
    877897,
    887878,
    889677,
    687879,
    897778,
    888787,
    689788,
    998978,
    996787,
    797878,
    787798,
    777867,
    877788,
    878768,
    797987,
    877788,
    877887,
    888998,
    888879,
    879986,
    888888,
    789888,
    897978,
    877887,
    878767,
    667978,
    997778,
    877788,
    888899,
    689987,
    878887,
    688686,
    788678,
    886898,
    788769,
    988887,
    897679,
    888697,
    978879,
    779777,
    789987,
    888777,
    797787,
    798768,
    899777,
    999897,
    789777,
    877888,
    877869,
    897987,
    888889,
    979778,
    978888,
    888798,
    778876,
    669979,
    777777,
    876978,
    897997,
    899878,
    988797,
    888679,
    888779,
    788998,
    789886,
    987888,
    888887,
    779787,
    878889,
    889887,
    987898,
    798797,
    787789,
    787888,
    789779,
    978777,
    798888,
    899778,
    787797,
    877898,
    887999,
    777887,
    777698,
    777896,
    877888,
    888697,
    979878,
    887897,
    978879,
    877788,
    989888,
    979886,
    798789,
    888887,
    797888,
    877687,
    888888,
    888888,
    866898,
    888788,
    787877,
    768987,
    878788,
    798877,
    889787,
    888778,
    778776,
    868877,
    797978,
    878887,
    797988,
    698979,
    999887,
    766888,
    789887,
    978798,
    888888,
    889986,
    889887,
    779877,
    789976,
    978878,
    997879,
    888787,
    989878,
    887998,
    889667,
    897898,
    677768,
    887887,
    677777,
    777789,
    798777,
    877788,
    977786,
    889889,
    878978,
    887788,
    968887,
    889998,
    888889,
    988787,
    686989,
    989969,
    899799,
    878988,
    777779,
    888787,
    888798,
    688789,
    886899,
    987889,
    788888,
    888778,
    997788,
    679879,
    897787,
    888798,
    778698,
    777878,
    788778,
    867977,
    786798,
    888877,
    877777,
    897987,
    999878,
    787877,
    768889,
    977897,
    778797,
    898799,
    687878,
    878778,
    888986,
    777878,
    877888,
    888867,
    866989,
    687877,
    878797,
    778897,
    988786,
    878887,
    876889,
    877777,
    789787,
    987997,
    878767,
    999878,
    878997,
    788878,
    886778,
    797779,
    888787,
    699888,
    888879,
    887988,
    689777,
    786787,
    988887,
    878979,
    778899,
    777878,
    778886,
    997778,
    789798,
    886877,
    679888,
    798899,
    789888,
    797897,
    887888,
    788898,
    877877,
    988777,
    989877,
    897689,
    778798,
    887878,
    888888,
    886889,
    877987,
    878879,
    987767,
    788878,
    997789,
    789979,
    897888,
    998998,
    888797,
    887878,
    977978,
    998989,
    778777,
    687888,
    687988,
    897878,
    788887,
    978879,
    889688,
    688886,
    887777,
    868887,
    798797,
    767776,
    886778,
    769868,
    888878,
    888788,
    988878,
    778787,
    877786,
    776888,
    787797,
    888888,
    878889,
    679988,
    998787,
    887799,
    888689,
    787778,
    689788,
    877988,
    889887,
    688988,
    867888,
    787778,
    986768,
    978679,
    867889,
    788788,
    787886,
    967888,
    888979,
    977876,
    899887,
    777978,
    777987,
    867879,
    777989,
    989887,
    999788,
    898779,
    878778,
    888989,
    888869,
    696879,
    877878,
    789977,
    886688,
    986798,
    788877,
    787998,
    788777,
    876798,
    877888,
    788788,
    998989,
    878878,
    978998,
    797869,
    887887,
    898887,
    778878,
    776878,
    887979,
    789986,
    798998,
    797898,
    978897,
    887768,
    877989,
    879787,
    788787,
    788878,
    998797,
    787898,
    778987,
    687887,
    779778,
    697688,
    787889,
    789767,
    886679,
    979977,
    767998,
    778797,
    998797,
    788897,
    699877,
    787899,
    879878,
    788778,
    687879,
    979989,
    867888,
    878798,
    868966,
    879879,
    887998,
    688889,
    777769,
    987779,
    898887,
    899998,
    877898,
    888888,
    778887,
    887787,
    779777,
    878878,
    788788,
    798877,
    788889,
    877887,
    878978,
    878888,
    697776,
    778776,
    869897,
    888887,
    778896,
    867887,
    788687,
    878888,
    888787,
    999897,
    886989,
    988787,
    777778,
    889778,
    898888,
    999777,
    886788,
    987887,
    987978,
    888879,
    978987,
    687778,
    796787,
    898877,
    878688,
    688898,
    698987,
    877898,
    668789,
    888899,
    878788,
    787777,
    788789,
    889797,
    898888,
    878878,
    889877,
    796887,
    688788,
    978788,
    878776,
    798697,
    997878,
    876987,
    788666,
    868786,
    899789,
    796779,
    878878,
    869778,
    977896,
    986878,
    978676,
    877699,
    887778,
    977888,
    698879,
    878888,
    878798,
    877886,
    887999,
    777888,
    789878,
    999778,
    878789,
    797787,
    898878,
    978777,
    796988,
    889888,
    768877,
    978888,
    889987,
    878888,
    899877,
    888888,
    887888,
    878888,
    887968,
    877898,
    987879,
    988778,
    779678,
    778888,
    878888,
    888876,
    797888,
    868889,
    787679,
    788787,
    887888,
    797789,
    777897,
    788787,
    877888,
    987897,
    787887,
    888877,
    788886,
    798889,
    788888,
    887997,
    789878,
    788889,
    877898,
    877877,
    787977,
    788888,
    867868,
    987887,
    888777,
    798887,
    878899,
    799788,
    889998,
    889888,
    777787,
    778878,
    689879,
    988977,
    897888,
    899799,
    888987,
    898997,
    879888,
    999767,
    798687,
    776688,
    886799,
    877779,
    788877,
    788887,
    787878,
    877877,
    767687,
    879887,
    978887,
    788987,
    777977,
    878878,
    897777,
    798788,
    989897,
    678788,
    999889,
    878668,
    697778,
    878879,
    866998,
    977979,
    986779,
    898898,
    877699,
    879687,
    769987,
    787788,
    797787,
    888789,
    989897,
    769878,
    878897,
    889789,
    778797,
    798976,
    889777,
    987789,
    788889,
    888977,
    989686,
    878887,
    798878,
    779886,
    789788,
    888868,
    788988,
    888896,
    877878,
    898888,
    786888,
    989988,
    776877,
    887889,
    777787,
    879887,
    798977,
    967967,
    878788,
    799787,
    878787,
    968897,
    778779,
    789788,
    968789,
    789878,
    787878,
    989967,
    889798,
    787698,
    768988,
    878797,
    787977,
    888778,
    888887,
    779878,
    888678,
    998987,
    889878,
    878777,
    778897,
    786867,
    776798,
    886777,
    898899,
    997896,
    687978,
    988797,
    987767,
    887998,
    769776,
    878887,
    888878,
    877887,
    888768,
    788798,
    977888,
    979897,
    888778,
    888977,
    978989,
    877788,
    678797,
    788778,
    688968,
    787777,
    887898,
    897777,
    789989,
    988797,
    777767,
    987878,
    867787,
    798977,
    786999,
    889768,
    987876,
    876897,
    889778,
    898997,
    779697,
    778979,
    768878,
    776987,
    797897,
    888997,
    869897,
    887789,
    878888,
    987888,
    966778,
    899888,
    898787,
    886889,
    899888,
    777768,
    987887,
    788878,
    778877,
    798777,
    767897,
    888876,
    888688,
    897789,
    789788,
    878777,
    799777,
    886787,
    888697,
    998888,
    898888,
    877897,
    888989,
    777878,
    778897,
    899787,
    998877,
    987887,
    899977,
    669986,
    997877,
    787968,
    779897,
    778996,
    887898,
    788779,
    778679,
    888789,
    888888,
    877868,
    888987,
    788977,
    986788,
    677887,
    988777,
    798898,
    868898,
    798667,
    688787,
    868788,
    887787,
    897778,
    797897,
    878788,
    678887,
    877988,
    768788,
    887788,
    688898,
    897778,
    797787,
    778996,
    789899,
    897888,
    987888,
    878889,
    897767,
    898788,
    797778,
    887799,
    887877,
    997869,
    788898,
    979887,
    797987,
    997897,
    887989,
    797869,
    788888,
    797788,
    888778,
    768767,
    678887,
    899967,
    997979,
    888888,
    667869,
    698788,
    668777,
    889788,
    889789,
    888989,
    797788,
    887888,
    888888,
    887787,
    789788,
    896867,
    777787,
    788777,
    779788,
    877998,
    867878,
    778777,
    898787,
    878998,
    878998,
    888788,
    789987,
    788968,
    988898,
    887998,
    877888,
    878877,
    888887,
    878888,
    988888,
    878788,
    789978,
    697778,
    786978,
    886788,
    779977,
    968788,
    787987,
    899798,
    888777,
    979978,
    898779,
    979897,
    987678,
    887788,
    878988,
    787878,
    699897,
    899977,
    889967,
    787987,
    777776,
    878878,
    789779,
    788879,
    788798,
    777878,
    887878,
    878776,
    977888,
    896897,
    787679,
    678779,
    779787,
    899878,
    878687,
    889698,
    979886,
    779786,
    898889,
    897778,
    977878,
    888888,
    978786,
    888678,
    988699,
    998987,
    878797,
    987978,
    788879,
    678787,
    888688,
    789878,
    776779,
    778897,
    887696,
    978988,
    887787,
    788898,
    786988,
    879798,
    786997,
    777977,
    887889,
    878778,
    788887,
    787798,
    778778,
    868779,
    787878,
    979879,
    877896,
    778779,
    697988,
    977778,
    979788,
    987887,
    888776,
    987878,
    877968,
    988998,
    698879,
    997897,
    787797,
    887999,
    799877,
    989788,
    679779,
    788677,
    688799,
    977878,
    877787,
    897799,
    878888,
    676876,
    677876,
    888778,
    777886,
    879988,
    897788,
    777879,
    987778,
    988878,
    777878,
    778989,
    887768,
    777867,
    979999,
    887888,
    787878,
    878877,
    879878,
    979887,
    779788,
    999688,
    888697,
    699889,
    777787,
    988797,
    888996,
    789868,
    887798,
    979877,
    979787,
    877797,
    677689,
    988789,
    788788,
    788968,
    887989,
    979768,
    978979,
    767898,
    996977,
    778789,
    768878,
    988787,
    777888,
    788878,
    987797,
    879898,
    797877,
    877886,
    887788,
    878878,
    898779,
    678697,
    886789,
    998988,
    787788,
    779787,
    688879,
    798979,
    778797,
    887996,
    979877,
    978989,
    767888,
    887886,
    978888,
    777787,
    777777,
    888679,
    777778,
    898697,
    878688,
    979887,
    789899,
    988889,
    867968,
    889788,
    887897,
    788989,
    787976,
    888786,
    978689,
    986889,
    878877,
    869886,
    787987,
    978888,
    899888,
    898978,
    889977,
    997898,
    887776,
    778888,
    778897,
    888878,
    897898,
    779787,
    779777,
    888977,
    888786,
    788787,
    877798,
    889877,
    898679,
    789799,
    978769,
    778779,
    987878,
    888787,
    788787,
    878987,
    878868,
    898687,
    866799,
    896989,
    698778,
    999877,
    898788,
    769888,
    886998,
    788798,
    888777,
    878887,
    999799,
    686978,
    767788,
    997889,
    898888,
    878986,
    988787,
    999998,
    697788,
    887778,
    878778,
    887777,
    887887,
    878888,
    797789,
    779887,
    788688,
    888878,
    988988,
    898897,
    888777,
    898897,
    887776,
    989887,
    868798,
    879987,
    797887,
    797879,
    779798,
    897689,
    787788,
    789997,
    988779,
    878888,
    879987,
    778978,
    789888,
    988887,
    688868,
    878988,
    897878,
    988878,
    677868,
    797778,
    779898,
    898879,
    897977,
    777889,
    797978,
    888898,
    898797,
    878889,
    977889,
    888798,
    778867,
    698777,
    878787,
    778788,
    898778,
    896787,
    787868,
    786889,
    688687,
    777998,
    788877,
    787887,
    988688,
    787887,
    679878,
    777877,
    688888,
    987688,
    768877,
    776888,
    878887,
    988887,
    886777,
    787887,
    888978,
    789888,
    787887,
    968787,
    787798,
    987889,
    898678,
    797789,
    867789,
    777888,
    779897,
    787989,
    777987,
    888997,
    888887,
    779996,
    977887,
    798888,
    888767,
    788779,
    988868,
    778979,
    888777,
    888889,
    789868,
    788779,
    787778,
    879779,
    788797,
    898977,
    877787,
    897896,
    888888,
    888777,
    888778,
    778887,
    879869,
    778778,
    898889,
    778887,
    898878,
    677698,
    978887,
    877887,
    877898,
    887789,
    888677,
    896878,
    787786,
    986796,
    798797,
    968888,
    878878,
    987688,
    778798,
    989889,
    888879,
    998788,
    978977,
    677978,
    697798,
    986888,
    988879,
    788976,
    888887,
    997789,
    867878,
    898999,
    777789,
    788978,
    897988,
    679987,
    898777,
    888888,
    797777,
    688798,
    788968,
    777888,
    789987,
    886888,
    898889,
    898999,
    978887,
    796877,
    878988,
    987878,
    788977,
    887997,
    887876,
    868699,
    698888,
    888898,
    886787,
    787988,
    889877,
    888977,
    977877,
    868879,
    798777,
    897896,
    967887,
    768879,
    767877,
    888998,
    987877,
    988869,
    998887,
    888888,
    889988,
    988987,
    998978,
    978787,
    787687,
    778779,
    889898,
    878879,
    787887,
    888799,
    879778,
    876797,
    867887,
    987867,
    889869,
    879976,
    888898,
    798888,
    789889,
    697679,
    989776,
    679997,
    779888,
    798878,
    778877,
    898778,
    677788,
    889987,
    766787,
    798889,
    987978,
    798988,
    768889,
    667888,
    788778,
    798878,
    888788,
    898777,
    899899,
    788887,
    888897,
    679768,
    788887,
    798878,
    889777,
    997897,
    888899,
    988988,
    987787,
    897789,
    787887,
    798888,
    888788,
    887977,
    798886,
    879887,
    899768,
    787786,
    887777,
    688998,
    999888,
    977779,
    787788,
    777788,
    878977,
    789878,
    888788,
    987778,
    787988,
    887987,
    689886,
    778898,
    876977,
    977887,
    887778,
    978888,
    787887,
    787877,
    888889,
    988797,
    787867,
    879876,
    789898,
    888889,
    787788,
    888989,
    897666,
    988789,
    687688,
    888778,
    968867,
    787968,
    886987,
    798887,
    878789,
    988888,
    778887,
    868898,
    997687,
    799789,
    878887,
    878887,
    787887,
    976779,
    797887,
    689888,
    779987,
    897777,
    788888,
    768967,
    779778,
    788986,
    778898,
    888987,
    987898,
    778876,
    976879,
    888869,
    787786,
    788878,
    898788,
    678888,
    887887,
    898889,
    977687,
    777797,
    667888,
    867887,
    888898,
    787788,
    798988,
    887888,
    988789,
    679887,
    888887,
    877689,
    788767,
    889788,
    878789,
    777778,
    778887,
    687867,
    868797,
    799777,
    899786,
    868988,
    987878,
    889897,
    769767,
    799877,
    697778,
    777889,
    897798,
    888978,
    778878,
    688899,
    867898,
    869778,
    887989,
    988867,
    898977,
    778987,
    887788,
    877777,
    787889,
    877969,
    779868,
    777688,
    998888,
    878879,
    777778,
    888688,
    779789,
    798888,
    768896,
    768886,
    778978,
    888788,
    888977,
    879889,
    888977,
    887789,
    787797,
    778888,
    888677,
    798879,
    989888,
    887797,
    888887,
    898888,
    987867,
    778779,
    979786,
    899788,
    978798,
    867767,
    878868,
    879978,
    799687,
    788878,
    878877,
    878787,
    777788,
    979997,
    676878,
    789799,
    678889,
    977689,
    779887,
    987897,
    877689,
    987978,
    798768,
    788789,
    798898,
    878877,
    989977,
    989787,
    798788,
    988877,
    889898,
    799987,
    778779,
    788887,
    786888,
    889787,
    787799,
    978678,
    789788,
    879897,
    979887,
    779888,
    868687,
    888878,
    988898,
    878898,
    889879,
    989977,
    798997,
    797789,
    976878,
    878798,
    998878,
    797888,
    879897,
    989767,
    987786,
    778889,
    987797,
    766797,
    977779,
    988887,
    888669,
    778887,
    868799,
    889698,
    887878,
    788887,
    887877,
    987687,
    879998,
    778787,
    787787,
    787788,
    887889,
    879988,
    898867,
    876888,
    798788,
    896968,
    898877,
    778887,
    777787,
    878887,
    687977,
    988898,
    898867,
    978787,
    796789,
    788997,
    867887,
    987788,
    797888,
    879986,
    768778,
    779888,
    877887,
    988779,
    776989,
    778887,
    987889,
    866878,
    678878,
    677878,
    898779,
    787779,
    887978,
    987888,
    788898,
    969888,
    888988,
    878978,
    987678,
    799888,
    989897,
    769888,
    788896,
    988888,
    998897,
    878878,
    788968,
    679787,
    767968,
    877988,
    777679,
    878889,
    987889,
    867797,
    878876,
    877897,
    767889,
    888887,
    878877,
    978998,
    787977,
    899779,
    869978,
    698878,
    888788,
    899977,
    898788,
    888898,
    897787,
    877979,
    889867,
    888888,
    789689,
    898776,
    989997,
    896786,
    867887,
    979797,
    887767,
    798768,
    868787,
    896989,
    788967,
    978889,
    788777,
    979887,
    777779,
    878889,
    878889,
    786888,
    798998,
    889888,
    888878,
    797888,
    878878,
    779888,
    877786,
    787988,
    876688,
    689988,
    899798,
    877778,
    878868,
    888787,
    789877,
    798788,
    797889,
    888869,
    869787,
    888988,
    877888,
    878876,
    889897,
    778887,
    887779,
    888777,
    988788,
    897898,
    988897,
    798877,
    988787,
    787878,
    887877,
    897887,
    798787,
    987769,
    777798,
    879888,
    897988,
    898788,
    869877,
    788877,
    798988,
    788997,
    799887,
    987887,
    687977,
    787787,
    998788,
    788878,
    888888,
    989778,
    878877,
    878878,
    987798,
    777897,
    887777,
    888687,
    778787,
    899988,
    888778,
    888988,
    898888,
    998987,
    889778,
    687878,
    978979,
    878888,
    798888,
    888888,
    787788,
    789867,
    787868,
    788897,
    779877,
    897888,
    989888,
    788899,
    777877,
    987788,
    788888,
    888879,
    688878,
    787988,
    687887,
    888797,
    698877,
    889767,
    788778,
    967789,
    799889,
    879887,
    878889,
    779778,
    887777,
    789777,
    888778,
    888978,
    989796,
    788898,
    679899,
    888989,
    789878,
    887788,
    788888,
    787886,
    878888,
    688977,
    887879,
    879878,
    879979,
    778878,
    777888,
    867887,
    879997,
    997688,
    767889,
    988887,
    789778,
    798889,
    767787,
    969688,
    878788,
    686888,
    898998,
    879878,
    998778,
    798868,
    887888,
    788989,
    978868,
    997888,
    998777,
    888888,
    888787,
    977886,
    798667,
    868799,
    897879,
    997987,
    887778,
    698978,
    789887,
    987978,
    877898,
    978798,
    798777,
    797897,
    889979,
    897988,
    687867,
    978897,
    778796,
    778869,
    978987,
    899897,
    676798,
    788886,
    788888,
    887788,
    989886,
    898999,
    877878,
    878888,
    878788,
    898898,
    687786,
    787769,
    888698,
    878776,
    769788,
    778777,
    887896,
    789777,
    998897,
    979978,
    899899,
    687988,
    888797,
    789867,
    899796,
    988878,
    878788,
    877879,
    779879,
    886897,
    688988,
    898788,
    888766,
    677878,
    779797,
    888887,
    889878,
    798777,
    878767,
    887876,
    788699,
    788998,
    887987,
    977978,
    779679,
    889879,
    779788,
    878978,
    787877,
    878777,
    879786,
    898789,
    998697,
    789988,
    688798,
    887878,
    777677,
    788889,
    876888,
    968798,
    898876,
    777766,
    886678,
    778777,
    987878,
    977988,
    887987,
    987897,
    878978,
    887878,
    788878,
    799887,
    876788,
    788898,
    888899,
    889797,
    787888,
    888878,
    788898,
    778788,
    789898,
    878788,
    686887,
    897878,
    778988,
    778989,
    997986,
    878797,
    787667,
    888889,
    797797,
    878787,
    978887,
    788778,
    689787,
    777877,
    687999,
    886887,
    799878,
    779987,
    986878,
    899878,
    689898,
    778787,
    779878,
    876778,
    778768,
    879778,
    878688,
    878688,
    978778,
    779777,
    989877,
    777988,
    889898,
    977886,
    886889,
    866788,
    778777,
    778789,
    988877,
    768678,
    888886,
    888798,
    898899,
    888788,
    886797,
    789878,
    888789,
    697878,
    989768,
    887878,
    787978,
    789787,
    768679,
    777868,
    977687,
    668768,
    898787,
    887778,
    888877,
    888886,
    779979,
    988778,
    967878,
    888888,
    988787,
    887787,
    787888,
    878999,
    778888,
    897798,
    787789,
    778798,
    888899,
    999878,
    776988,
    978897,
    989889,
    879779,
    787989,
    878877,
    898889,
    899787,
    978978,
    797999,
    998887,
    998777,
    887888,
    888787,
    777798,
    797898,
    789888,
    968678,
    879879,
    988889,
    888989,
    798979,
    889878,
    799888,
    997787,
    777697,
    778888,
    888787,
    677677,
    789888,
    897888,
    897778,
    787777,
    786888,
    997888,
    779898,
    789889,
    888799,
    897899,
    789877,
    897887,
    788878,
    888987,
    698778,
    888888,
    887787,
    889778,
    888788,
    987886,
    778878,
    978777,
    888779,
    879876,
    889988,
    676788,
    867778,
    787967,
    977878,
    868878,
    887787,
    987878,
    989898,
    888778,
    789769,
    778996,
    769998,
    798887,
    788786,
    987988,
    887898,
    889778,
    868887,
    698867,
    879767,
    868888,
    787977,
    778877,
    889888,
    977768,
    776988,
    787888,
    797778,
    879797,
    686787,
    967979,
    789777,
    989887,
    887879,
    898878,
    889776,
    798889,
    988688,
    886979,
    767879,
    876789,
    877778,
    888788,
    788996,
    997898,
    869778,
    788779,
    988888,
    687878,
    768698,
    788878,
    988789,
    877878,
    996788,
    877787,
    978797,
    887898,
    989897,
    776798,
    877997,
    898787,
    778887,
    978777,
    879869,
    797878,
    889777,
    778768,
    877897,
    797878,
    798877,
    777678,
    788979,
    788678,
    998889,
    898977,
    788979,
    779878,
    997798,
    887878,
    796978,
    776798,
    778679,
    687877,
    978877,
    888798,
    778688,
    977889,
    879878,
    967879,
    896879,
    787887,
    987888,
    777887,
    787688,
    888687,
    788878,
    886787,
    777876,
    787896,
    988978,
    677867,
    987988,
    869999,
    688788,
    777797,
    797878,
    789988,
    888888,
    788778,
    787897,
    898786,
    887778,
    887786,
    798887,
    797788,
    866998,
    978887,
    798868,
    889897,
    788887,
    788887,
    978798,
    878878,
    977887,
    888888,
    879787,
    887889,
    998797,
    977887,
    877777,
    698878,
    889869,
    798889,
    788866,
    798868,
    677969,
    888979,
    989767,
    887978,
    889879,
    867979,
    979979,
    999896,
    988887,
    868988,
    866886,
    798889,
    777898,
    877889,
    889876,
    996868,
    889878,
    798996,
    787899,
    978989,
    798788,
    678898,
    777987,
    987787,
    778697,
    788669,
    887777,
    797878,
    989887,
    878998,
    987787,
    886887,
    898768,
    887787,
    697786,
    896999,
    888677,
    877788,
    779899,
    799787,
    777887,
    979899,
    788797,
    777777,
    788876,
    877887,
    797899,
    987888,
    867889,
    997886,
    899888,
    877798,
    888789,
    887998,
    889998,
    889989,
    987697,
    978788,
    879988,
    888877,
    887769,
    898779,
    788899,
    878878,
    886887,
    879878,
    778886,
    899778,
    778798,
    788778,
    887787,
    778876,
    866888,
    789988,
    889869,
    977888,
    777777,
    877978,
    898897,
    887989,
    867688,
    777986,
    897888,
    787787,
    877899,
    879868,
    798878,
    687877,
    889766,
    988978,
    968999,
    798798,
    788987,
    787977,
    899786,
    777888,
    987667,
    887968,
    887977,
    889889,
    879787,
    787788,
    878988,
    779987,
    778777,
    787887,
    688879,
    777887,
    877778,
    786787,
    797668,
    997997,
    888878,
    869878,
    687778,
    966888,
    797888,
    887788,
    869787,
    989788,
    868887,
    887799,
    787679,
    987687,
    788767,
    878979,
    987899,
    877988,
    988778,
    988897,
    789898,
    788867,
    897879,
    787887,
    667988,
    886878,
    978788,
    778977,
    877799,
    797887,
    767889,
    887678,
    778877,
    897789,
    998987,
    988988,
    878788,
    788996,
    866877,
    787787,
    878978,
    878778,
    879887,
    776876,
    779879,
    689789,
    887677,
    899888,
    677777,
    687888,
    897778,
    898969,
    697978,
    889868,
    988978,
    789868,
    877889,
    797788,
    897888,
    888877,
    776678,
    979698,
    777887,
    789978,
    888886,
    888887,
    988897,
    867689,
    878988,
    888978,
    987988,
    887788,
    998788,
    796976,
    797687,
    987887,
    988997,
    867877,
    899879,
    887777,
    798987,
    898887,
    878797,
    987998,
    999978,
    977978,
    779788,
    789797,
    778698,
    999787,
    977689,
    899897,
    687888,
    788779,
    778787,
    889989,
    779888,
    788789,
    778877,
    777999,
    888798,
    799768,
    986898,
    797897,
    779776,
    889777,
    787989,
    898978,
    899886,
    767787,
    798888,
    778768,
    677878,
    978789,
    897979,
    778879,
    878888,
    877987,
    889878,
    876879,
    878789,
    687887,
    898877,
    687989,
    777789,
    886779,
    787776,
    879688,
    789878,
    889888,
    889887,
    878979,
    798868,
    988698,
    988687,
    877787,
    977988,
    998888,
    888697,
    787787,
    897879,
    787878,
    777887,
    868779,
    967998,
    886877,
    887988,
    878789,
    786789,
    876888,
    986898,
    698898,
    688878,
    888786,
    987687,
    887788,
    767788,
    689788,
    977898,
    879987,
    889898,
    788778,
    878987,
    797787,
    778776,
    787799,
    999887,
    887968,
    886878,
    987897,
    878887,
    878997,
    777888,
    878898,
    888688,
    788989,
    798778,
    797768,
    887878,
    779988,
    889787,
    866888,
    867867,
    888778,
    988777,
    787787,
    988879,
    968779,
    787898,
    689787,
    879798,
    886988,
    899887,
    779788,
    888879,
    867898,
    878887,
    988788,
    699789,
    888879,
    878868,
    987898,
    668898,
    897778,
    669877,
    899998,
    777787,
    877978,
    798788,
    877778,
    889886,
    878897,
    788976,
    768888,
    877879,
    798888,
    888898,
    976897,
    788877,
    867899,
    788888,
    988868,
    988888,
    898777,
    878896,
    766788,
    967788,
    877888,
    896897,
    867778,
    788777,
    888779,
    877777,
    887879,
    788877,
    978779,
    887787,
    679897,
    788987,
    888886,
    786788,
    989788,
    978989,
    986888,
    878879,
    968878,
    888878,
    767799,
    687689,
    879796,
    888878,
    788787,
    779776,
    888887,
    986787,
    998979,
    696987,
    889996,
    888987,
    678888,
    878787,
    678887,
    999787,
    877878,
    778898,
    897887,
    889788,
    888979,
    899778,
    989788,
    888888,
    898878,
    879989,
    789988,
    797788,
    879888,
    879887,
    778769,
    868979,
    787797,
    887798,
    897789,
    787898,
    888977,
    888798,
    878878,
    678979,
    778788,
    898999,
    876878,
    677797,
    787789,
    797989,
    898678,
    897978,
    798898,
    798898,
    977699,
    788877,
    988988,
    878788,
    877789,
    889889,
    999898,
    787898,
    878887,
    787898,
    879789,
    979698,
    978879,
    887778,
    888879,
    798888,
    898987,
    887987,
    898777,
    998888,
    797879,
    887999,
    677799,
    788879,
    876777,
    878897,
    886789,
    678878,
    788877,
    877879,
    877888,
    987888,
    887798,
    978788,
    977877,
    897789,
    777867,
    687787,
    889778,
    879687,
    896968,
    778887,
    879878,
    787898,
    788887,
    886988,
    798888,
    798787,
    787788,
    898877,
    877877,
    878788,
    767888,
    878978,
    868777,
    889887,
    878788,
    889879,
    988877,
    768789,
    987898,
    979788,
    988896,
    788888,
    787888,
    789779,
    978788,
    867887,
    677887,
    889877,
    778779,
    789999,
    789977,
    899787,
    698778,
    699677,
    878778,
    887988,
    887787,
    779999,
    888897,
    887997,
    788797,
    989977,
    886688,
    977878,
    969799,
    889887,
    788798,
    988898,
    886888,
    889889,
    777788,
    797789,
    998887,
    888888,
    887978,
    899697,
    976999,
    878889,
    789867,
    968877,
    787998,
    887888,
    887887,
    878998,
    888787,
    798876,
    777787,
    878878,
    798988,
    898878,
    886788,
    698788,
    977878,
    997797,
    998887,
    868778,
    977778,
    777678,
    877889,
    988787,
    888888,
    877789,
    798987,
    889889,
    877788,
    788987,
    978898,
    869797,
    978987,
    986787,
    687877,
    787888,
    766887,
    798689,
    877778,
    887788,
    778889,
    999878,
    779797,
    967778,
    789869,
    898898,
    877888,
    987787,
    788888,
    987788,
    877676,
    879887,
    967978,
    899787,
    698876,
    897888,
    788798,
    988977,
    976897,
    987788,
    778877,
    878887,
    868877,
    889969,
    788867,
    777877,
    978687,
    879678,
    687878,
    788877,
    777798,
    797989,
    888887,
    887778,
    778977,
    896777,
    887798,
    988888,
    877896,
    788968,
    778886,
    888989,
    688767,
    979789,
    776788,
    888899,
    789779,
    797888,
    876867,
    878867,
    797898,
    889986,
    677987,
    777787,
    888798,
    687777,
    878888,
    778688,
    988778,
    779687,
    787787,
    778898,
    777789,
    789889,
    889777,
    877888,
    878789,
    787887,
    778688,
    788899,
    989778,
    988999,
    897886,
    787879,
    998887,
    789997,
    797788,
    978799,
    789786,
    777889,
    797877,
    887897,
    778797,
    887886,
    878869,
    998698,
    798878,
    877687,
    888878,
    788877,
    788698,
    998789,
    879987,
    878778,
    777788,
    887979,
    988989,
    779899,
    779878,
    897979,
    797998,
    977898,
    888868,
    988778,
    787897,
    879797,
    889798,
    679898,
    678779,
    786978,
    787886,
    888878,
    977889,
    768999,
    997768,
    778789,
    889778,
    786988,
    888976,
    879777,
    677787,
    998887,
    996779,
    968886,
    989787,
    988976,
    978687,
    887779,
    978897,
    878777,
    877788,
    778787,
    898779,
    986797,
    779977,
    888788,
    987889,
    887888,
    798767,
    978787,
    768678,
    877877,
    988888,
    778998,
    888879,
    778999,
    878779,
    876797,
    978879,
    878987,
    899788,
    888899,
    877799,
    878889,
    798888,
    977779,
    977688,
    998799,
    778778,
    877879,
    987979,
    989786,
    688867,
    886886,
    988988,
    886979,
    889868,
    768999,
    987887,
    877998,
    979879,
    877797,
    898798,
    798778,
    776777,
    897986,
    889878,
    888887,
    768978,
    779889,
    989898,
    877877,
    789767,
    686779,
    788988,
    788798,
    888878,
    998999,
    898887,
    978876,
    796898,
    899798,
    897898,
    789988,
    998897,
    777799,
    778987,
    897978,
    877987,
    777777,
    778887,
    778898,
    897889,
    987688,
    999977,
    799888,
    888778,
    898787,
    868779,
    978678,
    887687,
    778998,
    878878,
    877797,
    769888,
    797888,
    977878,
    998898,
    777777,
    997786,
    799987,
    889899,
    889887,
    878787,
    788878,
    988778,
    888978,
    797886,
    798888,
    787778,
    886796,
    787888,
    689977,
    789798,
    887788,
    779877,
    878877,
    798887,
    978777,
    779878,
    798687,
    777997,
    889979,
    977777,
    877679,
    888798,
    996878,
    879989,
    979798,
    778776,
    878976,
    887888,
    887798,
    889977,
    897767,
    889998,
    787998,
    877788,
    878888,
    888898,
    787987,
    977887,
    887989,
    897777,
    878678,
    787698,
    787879,
    688777,
    678787,
    788778,
    778879,
    976888,
    976888,
    887888,
    687978,
    898769,
    878878,
    877879,
    768778,
    788687,
    878888,
    789976,
    789888,
    887668,
    898897,
    887898,
    789888,
    879779,
    977798,
    788888,
    789898,
    998788,
    887967,
    788788,
    678887,
    979897,
    869999,
    897887,
    987988,
    787978,
    788777,
    988787,
    988876,
    787977,
    698888,
    887888,
    888887,
    977789,
    789978,
    988997,
    968877,
    878778,
    678989,
    878888,
    788898,
    889886,
    688879,
    966998,
    997778,
    798687,
    989788,
    988868,
    897799,
    978998,
    879877,
    869788,
    779988,
    789787,
    778788,
    798789,
    878878,
    799768,
    787877,
    768886,
    889897,
    776876,
    887787,
    888797,
    879787,
    788988,
    788987,
    889787,
    779887,
    788887,
    888678,
    997989,
    888796,
    898688,
    698799,
    787899,
    797778,
    879788,
    788768,
    887679,
    897899,
    998878,
    787778,
    988866,
    978787,
    889887,
    886987,
    898898,
    887678,
    787869,
    887988,
    788789,
    887799,
    888767,
    796777,
    688777,
    688787,
    878688,
    769889,
    998779,
    999788,
    777877,
    979779,
    889877,
    889798,
    887879,
    887888,
    777779,
    988788,
    788888,
    679986,
    778987,
    788978,
    779888,
    898788,
    878977,
    778788,
    887987,
    787897,
    799788,
    878888,
    879767,
    779788,
    887897,
    889878,
    777798,
    687889,
    798777,
    998798,
    887788,
    888989,
    788778,
    887887,
    879788,
    797787,
    999868,
    888886,
    879877,
    899687,
    898988,
    978778,
    778888,
    778777,
    688887,
    998786,
    978877,
    978898,
    797777,
    796686,
    797889,
    977888,
    987778,
    887979,
    898677,
    788988,
    786879,
    989889,
    778778,
    987777,
    979888,
    678699,
    886777,
    877989,
    878778,
    767877,
    799889,
    689887,
    978988,
    997787,
    878889,
    868778,
    798888,
    879779,
    888789,
    889878,
    788877,
    889897,
    978896,
    886788,
    879788,
    878898,
    878778,
    879878,
    888777,
    979797,
    779989,
    868878,
    997878,
    777676,
    986769,
    787978,
    889678,
    989677,
    898888,
    977886,
    888787,
    997988,
    777888,
    878987,
    788987,
    878779,
    797889,
    787899,
    979897,
    978788,
    888666,
    898777,
    898898,
    988989,
    978989,
    788778,
    888888,
    767798,
    887788,
    777886,
    988999,
    988798,
    668879,
    979768,
    678788,
    779877,
    897787,
    988988,
    788869,
    978978,
    878898,
    889779,
    786887,
    789777,
    776797,
    876789,
    878977,
    868878,
    688888,
    788878,
    887888,
    888699,
    979898,
    777789,
    888777,
    889887,
    989779,
    787788,
    898878,
    988988,
    967876,
    778778,
    869776,
    778899,
    687878,
    788967,
    879777,
    768669,
    788888,
    786769,
    777888,
    868997,
    999677,
    778779,
    897868,
    887979,
    879988,
    788778,
    776887,
    789888,
    987888,
    987666,
    787888,
    678889,
    867788,
    888787,
    788888,
    889878,
    887789,
    899888,
    878779,
    899769,
    877987,
    888987,
    687888,
    787998,
    798789,
    778788,
    777887,
    786788,
    977878,
    686798,
    797988,
    896868,
    889788,
    798898,
    887978,
    688898,
    789787,
    877989,
    999687,
    687888,
    899879,
    787778,
    886897,
    999778,
    888886,
    986797,
    887889,
    976678,
    768897,
    887878,
    997998,
    998878,
    688777,
    797698,
    988878,
    998878,
    788878,
    768777,
    877997,
    787886,
    676879,
    788987,
    998787,
    697797,
    788777,
    988799,
    798778,
    787779,
    677967,
    897798,
    878997,
    987889,
    788887,
    798879,
    888788,
    778887,
    787778,
    898889,
    869879,
    976798,
    888887,
    978879,
    789868,
    788778,
    878787,
    677778,
    768788,
    886877,
    878889,
    768988,
    878979,
    998777,
    988788,
    788787,
    989776,
    778768,
    779776,
    679798,
    887797,
    778879,
    897788,
    776887,
    777697,
    878897,
    998889,
    899797,
    697698,
    779688,
    788788,
    767887,
    898986,
    788978,
    897898,
    867889,
    687798,
    778799,
    778877,
    877798,
    899777,
    889697,
    899989,
    888889,
    878877,
    977877,
    788899,
    788878,
    887976,
    978769,
    998987,
    788979,
    877787,
    987778,
    777887,
    869879,
    899788,
    888767,
    778868,
    977979,
    777788,
    899696,
    877879,
    888776,
    888888,
    788878,
    988777,
    778677,
    879878,
    877696,
    888889,
    798788,
    796887,
    878879,
    787967,
    886898,
    778889,
    777689,
    888778,
    898897,
    978788,
    978879,
    799887,
    878976,
    887888,
    797988,
    778687,
    878898,
    787877,
    887866,
    997997,
    898887,
    879898,
    878898,
    887798,
    988877,
    987787,
    869978,
    877878,
    988667,
    799798,
    887987,
    779887,
    779796,
    978786,
    798889,
    898788,
    897777,
    778877,
    787989,
    878887,
    687887,
    798778,
    689877,
    889898,
    879888,
    996688,
    888788,
    896676,
    998788,
    997778,
    869888,
    779789,
    788898,
    888687,
    788878,
    886768,
    887979,
    979788,
    888878,
    799979,
    888898,
    888977,
    788779,
    778989,
    888778,
    898866,
    787679,
    777878,
    788886,
    867769,
    877889,
    888896,
    989778,
    887978,
    778777,
    989887,
    977678,
    998878,
    799878,
    868787,
    787889,
    978978,
    896787,
    887787,
    787998,
    789867,
    867788,
    787697,
    798867,
    788778,
    877898,
    887889,
    796778,
    887797,
    889788,
    777876,
    787887,
    768779,
    887987,
    887778,
    798978,
    788777,
    887889,
    797987,
    988977,
    889778,
    697899,
    787887,
    889888,
    887878,
    796997,
    797987,
    897987,
    798889,
    798877,
    878787,
    898789,
    787879,
    986876,
    798897,
    877688,
    787988,
    978787,
    889689,
    887777,
    888699,
    696899,
    989988,
    797788,
    879787,
    888777,
    689877,
    867888,
    889888,
    778977,
    877898,
    888877,
    887697,
    777998,
    777798,
    978879,
    877996,
    877988,
    978887,
    798978,
    798678,
    778696,
    878987,
    987889,
    997898,
    877967,
    797978,
    897777,
    888787,
    779987,
    768778,
    798988,
    778799,
    798788,
    689988,
    787777,
    888879,
    887886,
    798689,
    667886,
    887787,
    986888,
    788888,
    788877,
    987888,
    988788,
    778788,
    887989,
    888897,
    878878,
    799887,
    889898,
    987877,
    779769,
    779778,
    678888,
    977987,
    877897,
    797877,
    789676,
    787787,
    999798,
    778879,
    787787,
    888999,
    887779,
    786878,
    789877,
    888898,
    887998,
    679888,
    988988,
    788888,
    889789,
    689797,
    988798,
    787686,
    899887,
    989998,
    877679,
    897789,
    787778,
    768678,
    879898,
    877987,
    888687,
    678898,
    767997,
    878878,
    787798,
    997889,
    688778,
    779787,
    778866,
    887887,
    988977,
    977899,
    786667,
    877787,
    899968,
    997798,
    778896,
    887677,
    988898,
    888888,
    788988,
    778888,
    876986,
    879889,
    888987,
    788879,
    688778,
    989977,
    787888,
    797886,
    889887,
    788888,
    788969,
    978888,
    778777,
    778677,
    989877,
    889977,
    877988,
    887797,
    978877,
    878778,
    887786,
    877887,
    996778,
    779786,
    798788,
    778988,
    888787,
    788889,
    788998,
    677987,
    798688,
    767979,
    678678,
    978788,
    788788,
    878899,
    998896,
    888798,
    888989,
    989878,
    888787,
    987887,
    799888,
    898868,
    889888,
    868889,
    888887,
    879977,
    978788,
    789987,
    778878,
    677868,
    787888,
    777877,
    777888,
    787788,
    877987,
    798777,
    897878,
    779899,
    887888,
    787789,
    997997,
    889778,
    677778,
    688877,
    898777,
    988888,
    896888,
    877877,
    889788,
    898888,
    788876,
    697898,
    898888,
    889779,
    876867,
    678898,
    887977,
    968868,
    778886,
    888777,
    877776,
    968897,
    676989,
    888876,
    986787,
    777889,
    779987,
    888878,
    787998,
    888997,
    878889,
    688987,
    979879,
    887779,
    889876,
    877798,
    666987,
    887688,
    697788,
    786978,
    998787,
    887887,
    978888,
    987879,
    788797,
    988868,
    778867,
    988777,
    778888,
    679977,
    788868,
    988788,
    799677,
    867679,
    979977,
    678768,
    778697,
    787888,
    988888,
    887898,
    988877,
    698878,
    778877,
    797878,
    788899,
    777788,
    978999,
    977879,
    888788,
    889867,
    699997,
    897796,
    789988,
    968889,
    779888,
    699898,
    989989,
    788989,
    967889,
    886677,
    887877,
    877778,
    798788,
    887788,
    886868,
    888787,
    899998,
    689798,
    897786,
    799789,
    769888,
    798987,
    696888,
    968888,
    788799,
    798876,
    987779,
    688778,
    787788,
    988697,
    886889,
    877898,
    778988,
    777998,
    988888,
    787878,
    768686,
    778979,
    899879,
    989887,
    798867,
    888797,
    879899,
    899777,
    768878,
    697778,
    877997,
    876797,
    899887,
    987797,
    888787,
    889876,
    878978,
    888887,
    989967,
    777768,
    869869,
    799988,
    687998,
    887778,
    886979,
    778888,
    897766,
    677887,
    888987,
    698867,
    878887,
    767898,
    876787,
    977888,
    868788,
    687778,
    787876,
    898797,
    768688,
    878878,
    688687,
    788987,
    877778,
    798798,
    977888,
    966688,
    977989,
    787988,
    888979,
    887878,
    877698,
    897889,
    787878,
    987996,
    778878,
    989887,
    798787,
    977788,
    988978,
    788968,
    878888,
    888997,
    968878,
    878777,
    888778,
    888876,
    887898,
    888879,
    987888,
    898888,
    897888,
    898779,
    889878,
    889778,
    978898,
    886987,
    798789,
    988687,
    998869,
    867898,
    888987,
    878788,
    798789,
    888889,
    888778,
    899899,
    886976,
    896898,
    879787,
    889879,
    988889,
    777999,
    888787,
    878788,
    697999,
    888877,
    879979,
    786777,
    789668,
    788797,
    887886,
    877799,
    687876,
    897987,
    877797,
    779798,
    798776,
    897887,
    879798,
    867787,
    998988,
    888888,
    987688,
    879879,
    887887,
    977979,
    888898,
    996789,
    789799,
    888886,
    778799,
    798787,
    797998,
    789788,
    987778,
    888988,
    786799,
    889988,
    877796,
    678977,
    888978,
    888678,
    898887,
    877799,
    778878,
    788988,
    778788,
    787877,
    778988,
    876888,
    797878,
    798977,
    977888,
    897779,
    779678,
    878899,
    877788,
    877978,
    798778,
    787768,
    889888,
    689989,
    797889,
    787977,
    787779,
    886889,
    988879,
    898887,
    888779,
    879788,
    888977,
    887987,
    988787,
    977888,
    777979,
    868877,
    798688,
    888878,
    798889,
    897697,
    879898,
    887898,
    879986,
    789779,
    888889,
    797697,
    788989,
    886998,
    677898,
    788979,
    868788,
    787978,
    989767,
    877788,
    878988,
    798977,
    788798,
    999799,
    877887,
    879897,
    668787,
    878777,
    798889,
    787778,
    787989,
    886887,
    778989,
    778797,
    699679,
    777987,
    898978,
    978987,
    879897,
    898889,
    889678,
    798779,
    888986,
    976887,
    688988,
    987887,
    878987,
    968887,
    878898,
    987788,
    867878,
    878886,
    978788,
    888777,
    897787,
    877767,
    786979,
    888788,
    998778,
    889877,
    987887,
    678977,
    887777,
    899789,
    688777,
    877679,
    787887,
    998979,
    868887,
    879787,
    788877,
    768989,
    776888,
    877797,
    786878,
    867978,
    978877,
    778788,
    897887,
    866987,
    878798,
    988677,
    899787,
    876777,
    777778,
    888788,
    787796,
    878777,
    779879,
    697788,
    798877,
    797889,
    778788,
    897889,
    988779,
    887977,
    769989,
    997998,
    877868,
    887688,
    879889,
    787898,
    888896,
    987888,
    877978,
    988779,
    879997,
    979997,
    889888,
    899898,
    977799,
    879897,
    987887,
    888867,
    976888,
    969778,
    888788,
    886969,
    977988,
    997788,
    968969,
    978898,
    799788,
    799996,
    887887,
    878777,
    877987,
    888877,
    988778,
    899878,
    777999,
    887887,
    788897,
    889996,
    698877,
    798678,
    768779,
    898787,
    987988,
    899878,
    778987,
    878886,
    879878,
    999768,
    887777,
    797778,
    878888,
    778999,
    888789,
    978879,
    878978,
    879889,
    877797,
    889879,
    897969,
    687988,
    877997,
    768779,
    997799,
    988889,
    887787,
    787799,
    888768,
    988967,
    988877,
    787888,
    887888,
    799898,
    788788,
    898798,
    778878,
    787986,
    977997,
    878896,
    787767,
    887989,
    888898,
    978878,
    889788,
    878788,
    988888,
    798899,
    687899,
    788877,
    977989,
    788787,
    667788,
    988889,
    786898,
    797778,
    787888,
    796888,
    797977,
    777777,
    887797,
    887767,
    767686,
    889787,
    978886,
    967788,
    888988,
    888768,
    888788,
    978997,
    987889,
    978779,
    767888,
    779889,
    688878,
    778888,
    899878,
    877878,
    876889,
    899779,
    889798,
    688867,
    897796,
    988788,
    988999,
    888878,
    889988,
    678786,
    889879,
    779877,
    797877,
    896977,
    788796,
    879797,
    897987,
    989999,
    798887,
    888988,
    888789,
    879999,
    799888,
    686888,
    789679,
    987999,
    987689,
    778797,
    988799,
    988988,
    786878,
    897887,
    787998,
    777867,
    687768,
    867887,
    688978,
    897979,
    799787,
    886887,
    869769,
    888989,
    788788,
    786778,
    887677,
    888888,
    779788,
    888868,
    978887,
    789878,
    888989,
    977788,
    898877,
    999799,
    887697,
    878887,
    777867,
    788997,
    799789,
    788798,
    988978,
    988779,
    779988,
    977998,
    787687,
    788888,
    989777,
    787978,
    878798,
    888979,
    987887,
    788988,
    788888,
    799978,
    787868,
    777777,
    778777,
    888887,
    778888,
    988977,
    678877,
    778879,
    888769,
    998679,
    878898,
    978678,
    777878,
    878878,
    977787,
    797998,
    778887,
    778977,
    769798,
    978877,
    978978,
    977778,
    788888,
    988877,
    688878,
    998988,
    778988,
    978777,
    988797,
    776898,
    879676,
    887697,
    877877,
    988877,
    877879,
    976999,
    988878,
    778899,
    889979,
    997777,
    888797,
    798888,
    677779,
    899889,
    789987,
    688769,
    877798,
    987988,
    889998,
    979888,
    878887,
    877788,
    777678,
    897898,
    979787,
    887877,
    779977,
    889988,
    889978,
    777788,
    897979,
    899869,
    867887,
    688896,
    788787,
    877878,
    787888,
    877968,
    897878,
    896888,
    889987,
    767698,
    988897,
    788898,
    788797,
    887878,
    888897,
    987868,
    889788,
    868889,
    787887,
    776877,
    876888,
    888797,
    987788,
    977997,
    868978,
    869787,
    977878,
    887977,
    887888,
    768677,
    867689,
    887688,
    777778,
    779778,
    787967,
    996788,
    889888,
    788688,
    797788,
    697878,
    887797,
    797989,
    768968,
    878887,
    877777,
    897888,
    679878,
    898788,
    799887,
    787988,
    898799,
    878867,
    778788,
    877787,
    988887,
    989789,
    867878,
    878787,
    888877,
    986769,
    887898,
    888699,
    979988,
    877989,
    889878,
    899877,
    898887,
    787888,
    879878,
    998877,
    796977,
    787997,
    879887,
    788667,
    889878,
    867997,
    999778,
    788798,
    997787,
    976878,
    699877,
    777798,
    696889,
    889788,
    677777,
    977787,
    768798,
    887778,
    769787,
    897879,
    877798,
    888897,
    888789,
    877789,
    987899,
    978887,
    998789,
    767897,
    877879,
    776878,
    887879,
    769887,
    887898,
    789999,
    887687,
    897677,
    769788,
    779798,
    998878,
    778778,
    777886,
    799778,
    887897,
    788887,
    777798,
    888987,
    787889,
    789888,
    786987,
    888777,
    879889,
    896697,
    987898,
    787888,
    988978,
    877988,
    879798,
    789888,
    869878,
    889867,
    888989,
    777876,
    779968,
    697887,
    997677,
    789778,
    897887,
    986887,
    778777,
    897977,
    777997,
    887887,
    978888,
    788778,
    888987,
    888778,
    888898,
    787896,
    789967,
    778887,
    786877,
    977878,
    798777,
    898887,
    768977,
    868778,
    987776,
    978787,
    878779,
    887889,
    968888,
    888787,
    888779,
    888876,
    799768,
    797879,
    878779,
    796877,
    878978,
    767796,
    989887,
    799799,
    976899,
    898888,
    987998,
    878887,
    897888,
    788889,
    878789,
    988979,
    879887,
    876768,
    899787,
    777768,
    777999,
    787879,
    887898,
    778768,
    977878,
    776997,
    879997,
    988988,
    777799,
    778788,
    897988,
    898989,
    798888,
    777877,
    799876,
    879977,
    787866,
    888898,
    977897,
    779989,
    987898,
    786778,
    887997,
    787788,
    787887,
    786788,
    799868,
    887878,
    887887,
    697777,
    777888,
    678868,
    888888,
    998878,
    898788,
    867777,
    987787,
    888777,
    886888,
    678877,
    778877,
    978989,
    778788,
    887888,
    778787,
    988887,
    797977,
    677897,
    868887,
    778789,
    888898,
    798878,
    987897,
    777797,
    798977,
    788977,
    788887,
    767866,
    877788,
    977879,
    877887,
    777978,
    877889,
    789786,
    878888,
    998799,
    889677,
    979897,
    998688,
    978778,
    879897,
    889878,
    887989,
    689897,
    778789,
    686998,
    978698,
    878877,
    688887,
    798878,
    888887,
    899887,
    768998,
    687878,
    969878,
    778888,
    878797,
    797887,
    797689,
    878679,
    687778,
    887966,
    778898,
    797889,
    778979,
    678879,
    686789,
    797898,
    899987,
    886788,
    988768,
    688977,
    789889,
    788777,
    779887,
    988878,
    767787,
    988897,
    687677,
    777989,
    878886,
    979797,
    889876,
    877887,
    888889,
    798988,
    997968,
    778877,
    687877,
    878688,
    788868,
    888978,
    878799,
    888787,
    776879,
    999789,
    788977,
    987877,
    797989,
    888978,
    787888,
    788878,
    877787,
    777878,
    777989,
    798796,
    899798,
    677788,
    876887,
    898888,
    889877,
    898678,
    788898,
    987677,
    787678,
    989878,
    868878,
    788877,
    777888,
    787887,
    876778,
    997897,
    988877,
    776788,
    888887,
    898778,
    989687,
    897767,
    887798,
    877897,
    786879,
    968879,
    889777,
    688789,
    999888,
    886989,
    997987,
    987867,
    789667,
    888788,
    798986,
    888779,
    998778,
    786787,
    898978,
    867798,
    888889,
    888777,
    988888,
    768767,
    877879,
    799789,
    988877,
    888799,
    986688,
    798877,
    878997,
    877897,
    687887,
    779868,
    868877,
    888779,
    977878,
    788787,
    677678,
    978888,
    798877,
    977887,
    988886,
    889877,
    878896,
    998887,
    889899,
    978988,
    978788,
    887988,
    897878,
    989986,
    888787,
    779888,
    887789,
    877899,
    687888,
    897888,
    688878,
    778998,
    888887,
    897888,
    878887,
    899897,
    767879,
    878878,
    779987,
    889989,
    978888,
    887789,
    779687,
    788698,
    797788,
    898988,
    799887,
    787978,
    897887,
    986968,
    887888,
    788798,
    876999,
    978779,
    887888,
    988789,
    687877,
    879788,
    798897,
    779769,
    998779,
    778787,
    787978,
    788778,
    878899,
    799776,
    788777,
    877779,
    878988,
    687966,
    778888,
    768877,
    878977,
    988887,
    778778,
    877879,
    878998,
    999988,
    879787,
    897989,
    897886,
    878788,
    887788,
    787879,
    987888,
    878977,
    888898,
    898779,
    988888,
    868878,
    997878,
    778877,
    779878,
    867968,
    897788,
    876797,
    896888,
    897778,
    788888,
    888888,
    987977,
    797788,
    798767,
    677997,
    798788,
    977888,
    986889,
    997888,
    887797,
    877697,
    898888,
    788877,
    788899,
    678867,
    789777,
    898889,
    878877,
    889778,
    877786,
    988879,
    877779,
    888898,
    869878,
    779778,
    988878,
    877789,
    979787,
    798878,
    787968,
    868787,
    798778,
    879977,
    877787,
    868897,
    698787,
    787688,
    777879,
    778867,
    789889,
    879788,
    897778,
    879788,
    787878,
    897788,
    986888,
    678887,
    989898,
    987887,
    767997,
    988797,
    968789,
    878999,
    788988,
    789888,
    877977,
    688887,
    767878,
    967896,
    687988,
    887798,
    788887,
    997876,
    779888,
    888878,
    779797,
    677887,
    779899,
    889879,
    788987,
    786788,
    897778,
    798889,
    886879,
    868988,
    778788,
    787886,
    886877,
    987878,
    778779,
    877888,
    879987,
    978889,
    978879,
    888988,
    989987,
    778888,
    878797,
    788969,
    878788,
    798787,
    797978,
    878889,
    888888,
    878877,
    988886,
    867878,
    898888,
    898887,
    979778,
    787889,
    978888,
    799889,
    788777,
    897879,
    789887,
    789777,
    878798,
    788769,
    779876,
    788978,
    878897,
    887799,
    877669,
    998998,
    888787,
    977978,
    988788,
    698767,
    897789,
    987878,
    789899,
    889979,
    887897,
    888768,
    779988,
    799888,
    996879,
    977689,
    989767,
    878876,
    867787,
    986879,
    887779,
    877977,
    888878,
    987968,
    887878,
    978997,
    778799,
    888878,
    887789,
    888889,
    896788,
    679867,
    897678,
    787777,
    888776,
    888798,
    877789,
    898788,
    797789,
    988799,
    987878,
    798998,
    988678,
    888778,
    888888,
    697986,
    776879,
    787788,
    988767,
    888988,
    888788,
    799878,
    869788,
    978787,
    887977,
    888988,
    899789,
    989778,
    968877,
    878878,
    777887,
    787888,
    679768,
    798889,
    787887,
    779887,
    867788,
    777678,
    888889,
    989778,
    878999,
    986988,
    988788,
    877788,
    977979,
    878867,
    788787,
    768988,
    797777,
    889777,
    978888,
    779987,
    988779,
    897998,
    699877,
    777688,
    789778,
    696997,
    678788,
    797697,
    887877,
    698678,
    867788,
    878878,
    787879,
    878788,
    778897,
    797779,
    889797,
    888698,
    887898,
    888999,
    878778,
    679998,
    878888,
    878887,
    787797,
    797889,
    778767,
    778978,
    989677,
    878979,
    979879,
    988689,
    987798,
    888787,
    997898,
    797887,
    687978,
    887978,
    698987,
    879868,
    888878,
    778778,
    977788,
    977778,
    797778,
    799777,
    769979,
    798877,
    887789,
    878777,
    777788,
    877998,
    898887,
    888777,
    787898,
    688777,
    988896,
    998788,
    986788,
    888898,
    978789,
    888878,
    888897,
    787778,
    878889,
    878898,
    897778,
    789887,
    867787,
    888887,
    998779,
    987988,
    977888,
    878867,
    788988,
    988799,
    978888,
    898787,
    787968,
    789878,
    886888,
    889797,
    898777,
    799797,
    988987,
    688897,
    699796,
    898899,
    999888,
    889897,
    898898,
    677677,
    887788,
    788867,
    888897,
    778798,
    788887,
    887778,
    788889,
    979887,
    886988,
    789887,
    788688,
    987987,
    779878,
    778799,
    898888,
    897898,
    767677,
    996979,
    896879,
    798989,
    888977,
    778778,
    877877,
    897898,
    978878,
    878988,
    887789,
    887996,
    778879,
    967989,
    878788,
    778678,
    977886,
    789887,
    887979,
    988697,
    798796,
    789887,
    899777,
    877989,
    888989,
    989888,
    988777,
    876887,
    887988,
    899876,
    789798,
    978778,
    988888,
    997878,
    888778,
    788777,
    778888,
    788979,
    668887,
    887878,
    787869,
    978768,
    888976,
    897877,
    876977,
    867887,
    878887,
    687988,
    888897,
    688777,
    889799,
    898978,
    779978,
    897898,
    789798,
    898788,
    888778,
    788877,
    789767,
    876688,
    788879,
    897888,
    878889,
    898888,
    989987,
    776899,
    977888,
    887998,
    887977,
    879977,
    888669,
    869988,
    887778,
    776779,
    868767,
    688888,
    798867,
    779777,
    897689,
    899788,
    978879,
    887989,
    776887,
    797988,
    888888,
    767889,
    999788,
    797899,
    788887,
    878898,
    887787,
    787979,
    776977,
    987788,
    887787,
    887787,
    679889,
    877888,
    789887,
    887977,
    887978,
    887886,
    979888,
    889888,
    887798,
    898768,
    687889,
    777686,
    999779,
    888887,
    788978,
    888889,
    887777,
    887977,
    989777,
    699879,
    788778,
    778988,
    978778,
    977879,
    778788,
    866799,
    888787,
    888979,
    787887,
    867887,
    777978,
    888886,
    888978,
    978879,
    788887,
    797877,
    778789,
    898887,
    789889,
    978788,
    978987,
    977889,
    778899,
    878787,
    877799,
    986889,
    867876,
    877868,
    687779,
    788878,
    888969,
    868799,
    778798,
    897978,
    878769,
    777877,
    687978,
    886787,
    787898,
    897798,
    878788,
    699788,
    898888,
    789878,
    788797,
    989878,
    877788,
    798888,
    988679,
    788877,
    798789,
    997777,
    968998,
    778997,
    998789,
    887878,
    877769,
    888778,
    879787,
    977887,
    877978,
    798877,
    879786,
    776798,
    867889,
    686988,
    888978,
    787798,
    887789,
    898778,
    998787,
    888777,
    968887,
    897778,
    989778,
    678688,
    797888,
    768877,
    787777,
    777777,
    899898,
    987776,
    988877,
    978778,
    977777,
    798887,
    779788,
    877798,
    788878,
    988879,
    988877,
    788777,
    788788,
    888687,
    877879,
    797888,
    978778,
    868887,
    898797,
    787887,
    778887,
    799878,
    668877,
    977789,
    887699,
    878877,
    777887,
    789897,
    776877,
    767786,
    979787,
    987878,
    887887,
    878977,
    879786,
    798798,
    766777,
    888777,
    677868,
    886898,
    877976,
    878886,
    778778,
    797788,
    788787,
    878888,
    798778,
    889879,
    987988,
    978877,
    777887,
    887889,
    789887,
    899978,
    878879,
    777787,
    988987,
    697898,
    887787,
    988788,
    877986,
    978798,
    898879,
    877678,
    886989,
    988799,
    788777,
    899879,
    877777,
    786879,
    787768,
    798898,
    877878,
    988889,
    787878,
    789989,
    977778,
    778878,
    877888,
    888887,
    768788,
    777887,
    888969,
    887977,
    877878,
    777687,
    779998,
    988678,
    779788,
    789989,
    688969,
    897998,
    768986,
    797778,
    797977,
    867677,
    888778,
    977988,
    888896,
    778878,
    787679,
    898777,
    887678,
    868989,
    978887,
    988779,
    886777,
    869978,
    879877,
    797888,
    787978,
    878888,
    798777,
    787968,
    879877,
    888898,
    797877,
    788778,
    777898,
    878797,
    888988,
    877897,
    887788,
    978877,
    888878,
    887889,
    788789,
    868888,
    787787,
    888888,
    789699,
    978789,
    778968,
    778986,
    798788,
    787877,
    887897,
    899788,
    978797,
    897897,
    878768,
    878877,
    987788,
    787979,
    887888,
    967787,
    888969,
    788788,
    879788,
    687987,
    989898,
    898988,
    898987,
    989888,
    878787,
    878879,
    789888,
    986889,
    898978,
    688689,
    988897,
    897989,
    886887,
    777987,
    786779,
    788896,
    777888,
    998777,
    786988,
    898887,
    876788,
    686887,
    788898,
    798878,
    798888,
    798776,
    787988,
    788878,
    798988,
    787878,
    878987,
    797988,
    879998,
    997788,
    779788,
    888888,
    779787,
    777896,
    878698,
    887788,
    889687,
    787788,
    988888,
    978876,
    777868,
    886779,
    799888,
    768788,
    787678,
    777988,
    787797,
    788887,
    698889,
    677898,
    976978,
    878877,
    797788,
    788788,
    998888,
    887778,
    977898,
    877878,
    877799,
    776687,
    888887,
    898888,
    888978,
    787889,
    688868,
    889898,
    887876,
    798987,
    787877,
    978867,
    687788,
    778768,
    978878,
    889879,
    887976,
    789968,
    987899,
    988888,
    987978,
    788889,
    779777,
    988877,
    877879,
    877878,
    779997,
    888897,
    888668,
    889886,
    877766,
    997988,
    788888,
    878888,
    869778,
    889987,
    898778,
    899987,
    889787,
    787789,
    787876,
    789768,
    887977,
    887997,
    787998,
    976787,
    887797,
    897866,
    989797,
    987989,
    779777,
    678678,
    978769,
    977988,
    787798,
    889689,
    768888,
    789897,
    878779,
    787888,
    768888,
    778898,
    888889,
    778898,
    679988,
    777777,
    888788,
    888997,
    988877,
    888788,
    768777,
    889987,
    978998,
    898888,
    997778,
    887879,
    889877,
    786789,
    887877,
    787798,
    978896,
    777868,
    678978,
    696877,
    887887,
    899898,
    888787,
    888767,
    988779,
    887789,
    779898,
    877988,
    788789,
    998789,
    878887,
    878778,
    977768,
    788787,
    789888,
    868778,
    786787,
    798898,
    877888,
    878898,
    889888,
    767778,
    888777,
    879978,
    798897,
    779887,
    787777,
    789897,
    897888,
    887887,
    889778,
    897888,
    897977,
    999878,
    889887,
    877889,
    767888,
    888787,
    888788,
    799777,
    876889,
    789797,
    788786,
    798687,
    878687,
    786678,
    878887,
    997788,
    887778,
    876989,
    988976,
    768778,
    877878,
    787768,
    897998,
    779687,
    768968,
    977888,
    989888,
    788879,
    998669,
    898889,
    998777,
    977887,
    998888,
    778988,
    898789,
    797788,
    798798,
    788879,
    898887,
    879777,
    988878,
    889989,
    999779,
    899889,
    798788,
    888899,
    888689,
    788877,
    778787,
    888788,
    868879,
    987889,
    886878,
    778887,
    778778,
    989896,
    897788,
    889768,
    898988,
    878877,
    889889,
    978777,
    868968,
    897868,
    887889,
    877887,
    879878,
    987777,
    987776,
    878988,
    776888,
    788887,
    889877,
    978888,
    977779,
    788888,
    788887,
    879879,
    979979,
    988688,
    878888,
    986777,
    888877,
    777768,
    888989,
    867888,
    799777,
    778689,
    788898,
    877787,
    889988,
    798687,
    777988,
    979888,
    897776,
    798879,
    888898,
    888787,
    867889,
    878787,
    887998,
    977889,
    697877,
    866987,
    988896,
    989878,
    778777,
    887798,
    798789,
    899788,
    886787,
    987787,
    977788,
    788896,
    987867,
    989777,
    897788,
    978867,
    698778,
    878977,
    879688,
    798788,
    976887,
    679977,
    789977,
    988879,
    798888,
    879888,
    877878,
    977967,
    878878,
    779798,
    879888,
    789897,
    777896,
    789778,
    877788,
    887898,
    798778,
    989787,
    687878,
    887787,
    977787,
    888767,
    997878,
    897697,
    798789,
    988888,
    678878,
    788888,
    888988,
    876788,
    998998,
    887888,
    988787,
    777898,
    787768,
    988798,
    788899,
    888788,
    889786,
    789988,
    788887,
    898888,
    868789,
    977797,
    777878,
    778777,
    888997,
    878986,
    979778,
    888878,
    789877,
    799787,
    788878,
    798896,
    788878,
    777897,
    889787,
    977767,
    787877,
    888878,
    897967,
    986877,
    969897,
    867887,
    688788,
    799878,
    786777,
    877989,
    899877,
    877778,
    877989,
    888879,
    687789,
    887998,
    777799,
    889689,
    778787,
    799887,
    899879,
    777997,
    887778,
    967978,
    997878,
    877778,
    967787,
    987788,
    897797,
    888788,
    788988,
    989888,
    786788,
    688778,
    989888,
    698787,
    688989,
    776789,
    878699,
    868997,
    777778,
    778779,
    689978,
    889988,
    888788,
    967778,
    878798,
    777877,
    798869,
    978989,
    997778,
    777867,
    878787,
    996787,
    987878,
    977778,
    989887,
    878888,
    889768,
    798898,
    897879,
    898798,
    898887,
    777789,
    879898,
    889878,
    788876,
    979788,
    679886,
    988898,
    878887,
    887767,
    978689,
    787979,
    678878,
    969878,
    879767,
    877788,
    988887,
    789877,
    977789,
    888678,
    776769,
    788989,
    888886,
    877799,
    799878,
    776779,
    778798,
    878878,
    877888,
    896878,
    998878,
    878968,
    998897,
    999898,
    878887,
    678876,
    798778,
    887899,
    667777,
    878797,
    787868,
    678877,
    988887,
    778978,
    889788,
    677778,
    989888,
    898987,
    676786,
    877986,
    798888,
    778878,
    787778,
    878767,
    888799,
    786979,
    888899,
    786887,
    788867,
    999878,
    868778,
    998888,
    888788,
    977787,
    788987,
    877868,
    697689,
    789797,
    987998,
    877778,
    878988,
    788788,
    778888,
    898878,
    778878,
    778887,
    987879,
    887898,
    898888,
    776988,
    766788,
    768898,
    878887,
    878999,
    788898,
    798777,
    789987,
    887888,
    977997,
    877887,
    788878,
    887698,
    987889,
    898789,
    787877,
    799888,
    887888,
    988888,
    999799,
    788889,
    889989,
    988798,
    676887,
    799787,
    888776,
    888879,
    777997,
    878776,
    868988,
    997798,
    999888,
    789786,
    879788,
    887788,
    787788,
    869898,
    887787,
    988879,
    897887,
    788787,
    877688,
    899777,
    777796,
    777868,
    767887,
    977878,
    787888,
    778898,
    677868,
    987988,
    888788,
    778887,
    978797,
    777888,
    768878,
    888787,
    898877,
    878869,
    797888,
    788879,
    888798,
    877787,
    889878,
    879877,
    997766,
    898777,
    767788,
    897779,
    798787,
    788886,
    768779,
    986879,
    877977,
    779887,
    789777,
    899868,
    888789,
    888767,
    978786,
    678898,
    978987,
    878789,
    988988,
    988768,
    777998,
    887767,
    888677,
    878787,
    768977,
    798777,
    898787,
    977788,
    787788,
    879787,
    889997,
    798888,
    799998,
    887988,
    888877,
    769797,
    689999,
    987788,
    976888,
    688897,
    888887,
    689869,
    798779,
    798988,
    977798,
    888899,
    887787,
    787896,
    988897,
    787889,
    788897,
    777998,
    866988,
    897897,
    979887,
    878888,
    778778,
    796879,
    988689,
    978899,
    876777,
    778798,
    987788,
    886988,
    779778,
    888888,
    788777,
    888888,
    888878,
    887889,
    879968,
    797998,
    888878,
    777789,
    998898,
    868898,
    898878,
    887998,
    777769,
    999986,
    777867,
    797888,
    788869,
    789788,
    798688,
    786777,
    886879,
    798886,
    868987,
    878878,
    989987,
    897768,
    998789,
    889888,
    687888,
    988878,
    887899,
    897779,
    888888,
    877998,
    687998,
    788898,
    996778,
    888989,
    877988,
    888778,
    879897,
    887678,
    688889,
    888868,
    779998,
    899798,
    878988,
    997867,
    896788,
    788998,
    799799,
    787687,
    977778,
    787769,
    696887,
    888878,
    886878,
    887976,
    989978,
    786788,
    888799,
    898876,
    987768,
    798699,
    779777,
    788787,
    877789,
    776778,
    798887,
    988888,
    889887,
    798798,
    776787,
    688978,
    887878,
    688879,
    979987,
    998769,
    977889,
    888789,
    879688,
    998978,
    899988,
    877879,
    787977,
    778988,
    878979,
    988786,
    989788,
    778989,
    887878,
    896877,
    788767,
    788888,
    688898,
    787688,
    778878,
    988788,
    866878,
    998779,
    877788,
    978878,
    869778,
    888886,
    999898,
    869798,
    778997,
    899987,
    799877,
    887788,
    877788,
    889778,
    898777,
    766877,
    888799,
    778878,
    989798,
    687888,
    988888,
    978888,
    688887,
    788788,
    879779,
    897979,
    689899,
    879867,
    878877,
    868787,
    879888,
    888887,
    778877,
    868768,
    668988,
    768899,
    887698,
    888878,
    878888,
    978998,
    886789,
    888988,
    787777,
    899888,
    797787,
    989799,
    788787,
    968788,
    869896,
    888977,
    986978,
    876796,
    778889,
    888897,
    976898,
    877886,
    788787,
    889888,
    877788,
    796698,
    977997,
    778778,
    778778,
    797878,
    897898,
    888897,
    788888,
    777887,
    688788,
    897989,
    789668,
    777777,
    868888,
    679778,
    978888,
    777887,
    767768,
    788777,
    879888,
    888868,
    798789,
    778888,
    988777,
    888789,
    897677,
    998878,
    879988,
    989789,
    779888,
    898887,
    867767,
    988787,
    977888,
    789968,
    896779,
    779898,
    887879,
    797998,
    898889,
    788799,
    796887,
    889878,
    878987,
    779878,
    988788,
    996779,
    968777,
    998887,
    888788,
    888978,
    879676,
    896878,
    887697,
    868888,
    687988,
    768877,
    877898,
    799697,
    998877,
    877898,
    878887,
    886778,
    877878,
    678886,
    779987,
    877688,
    688769,
    898988,
    888898,
    797898,
    979778,
    778988,
    988888,
    678767,
    898987,
    976779,
    788898,
    788787,
    977977,
    789887,
    679686,
    776868,
    877878,
    888877,
    777786,
    687879,
    977888,
    787789,
    878778,
    787878,
    788778,
    966898,
    988887,
    798787,
    867778,
    888799,
    876698,
    888778,
    978889,
    799878,
    878778,
    978968,
    787788,
    988987,
    788888,
    776887,
    797877,
    897698,
    788888,
    877777,
    779897,
    896887,
    888879,
    887877,
    988877,
    988879,
    779988,
    899696,
    787798,
    978779,
    798879,
    777697,
    776877,
    879868,
    888889,
    886787,
    989998,
    887977,
    898787,
    987878,
    879777,
    788797,
    997899,
    787787,
    686878,
    789769,
    788896,
    767699,
    787787,
    978988,
    887878,
    899888,
    887869,
    888889,
    978889,
    977778,
    878987,
    679779,
    769889,
    977878,
    888988,
    989888,
    688888,
    789997,
    978788,
    887889,
    777796,
    789678,
    777887,
    887987,
    987798,
    977889,
    887887,
    877788,
    878679,
    778776,
    967988,
    988977,
    977887,
    886768,
    978877,
    898699,
    978797,
    988879,
    778897,
    888987,
    888978,
    967867,
    989787,
    999768,
    778789,
    998879,
    897888,
    887887,
    677777,
    668779,
    886897,
    887878,
    878878,
    977878,
    998879,
    766987,
    798877,
    878787,
    878787,
    777977,
    678888,
    977898,
    988778,
    987687,
    779977,
    899867,
    787798,
    886876,
    797877,
    877688,
    878998,
    788798,
    878888,
    698899,
    778897,
    889978,
    898889,
    799797,
    779778,
    778787,
    987876,
    787978,
    798788,
    769879,
    687887,
    868678,
    787888,
    697788,
    788997,
    887778,
    988688,
    876789,
    878676,
    789769,
    898869,
    887989,
    788788,
    778987,
    788888,
    887889,
    878688,
    779888,
    978897,
    767888,
    787787,
    879876,
    987997,
    888878,
    987988,
    687778,
    879988,
    888877,
    866678,
    798698,
    896786,
    879888,
    878688,
    977897,
    877888,
    887878,
    787887,
    897897,
    776688,
    878896,
    887888,
    976799,
    789978,
    977787,
    886887,
    797678,
    777887,
    986797,
    887887,
    779886,
    788788,
    777876,
    877967,
    878868,
    987988,
    988878,
    888968,
    888898,
    897887,
    799888,
    987987,
    778878,
    977868,
    887988,
    977988,
    988779,
    877879,
    768877,
    798678,
    986799,
    888987,
    788888,
    877797,
    899897,
    787979,
    787879,
    888798,
    877879,
    787788,
    788788,
    798899,
    887888,
    878878,
    888888,
    877789,
    988889,
    779878,
    787978,
    877879,
    786888,
    888977,
    976888,
    787888,
    879786,
    778788,
    977989,
    788877,
    887888,
    998698,
    889897,
    888768,
    887888,
    788978,
    889679,
    776778,
    768879,
    889777,
    788877,
    878988,
    889778,
    878777,
    989988,
    977789,
    978777,
    777769,
    886987,
    878878,
    999888,
    977988,
    788868,
    797789,
    878789,
    877679,
    797898,
    988688,
    787978,
    788988,
    687878,
    789889,
    776868,
    899878,
    888778,
    897878,
    796778,
    777877,
    998988,
    888777,
    787877,
    699887,
    879788,
    767998,
    997897,
    879788,
    788787,
    999887,
    987897,
    997977,
    887897,
    878988,
    898789,
    778989,
    698988,
    886887,
    697778,
    788867,
    797788,
    878888,
    667688,
    897777,
    896787,
    779788,
    777899,
    988989,
    786778,
    779888,
    999678,
    898888,
    898887,
    777899,
    977888,
    777788,
    888878,
    978787,
    978778,
    877699,
    888888,
    887977,
    798779,
    897868,
    799898,
    698897,
    789889,
    799987,
    888897,
    988888,
    888889,
    868878,
    977998,
    678777,
    889898,
    799888,
    888776,
    989898,
    698788,
    878978,
    878778,
    898998,
    989889,
    787797,
    977777,
    877687,
    878989,
    878879,
    999986,
    677798,
    998997,
    988787,
    688986,
    778697,
    888787,
    897789,
    878778,
    989977,
    997987,
    889988,
    999789,
    698898,
    878788,
    998787,
    778798,
    888887,
    769898,
    789788,
    898697,
    999869,
    688777,
    887689,
    888789,
    687678,
    769889,
    879887,
    877877,
    888899,
    888889,
    978796,
    877888,
    766678,
    888777,
    889989,
    797777,
    898977,
    968868,
    889779,
    879698,
    897898,
    977868,
    899788,
    778678,
    879887,
    978989,
    898988,
    787798,
    887898,
    887997,
    987887,
    786969,
    887787,
    798789,
    989887,
    766787,
    888788,
    787778,
    888768,
    778988,
    798898,
    788789,
    888987,
    977798,
    889779,
    998889,
    779888,
    679898,
    787898,
    997878,
    997989,
    898888,
    998788,
    778787,
    678798,
    777887,
    779888,
    778888,
    967899,
    879887,
    887878,
    677889,
    887889,
    979798,
    897878,
    977868,
    888788,
    768788,
    786988,
    898797,
    789877,
    887787,
    787778,
    877787,
    888989,
    788988,
    887879,
    797879,
    798979,
    977878,
    899779,
    678978,
    787898,
    888988,
    777868,
    889788,
    677888,
    778878,
    787799,
    688978,
    787688,
    876887,
    877868,
    889899,
    868769,
    898788,
    697888,
    886898,
    888878,
    786887,
    898889,
    789898,
    986888,
    888888,
    788967,
    978888,
    987868,
    988788,
    767798,
    887767,
    887879,
    789977,
    878987,
    798898,
    788988,
    977788,
    787978,
    888888,
    888889,
    887887,
    788878,
    797888,
    696788,
    788877,
    977879,
    887988,
    889699,
    677988,
    978798,
    998787,
    779978,
    878778,
    877786,
    768886,
    889687,
    788888,
    789778,
    868787,
    968888,
    877899,
    687887,
    878698,
    878988,
    878898,
    787887,
    976789,
    897888,
    879887,
    797777,
    887768,
    888789,
    887786,
    987977,
    777877,
    877778,
    876787,
    868896,
    898888,
    988888,
    897777,
    987868,
    788878,
    877889,
    779778,
    988889,
    797879,
    989777,
    977898,
    777888,
    988898,
    878967,
    688887,
    897677,
    879897,
    679888,
    887888,
    789868,
    787878,
    698898,
    677987,
    778878,
    997799,
    988978,
    997797,
    996899,
    887696,
    996989,
    787789,
    998889,
    898998,
    978989,
    787887,
    787877,
    879879,
    797887,
    788879,
    798877,
    798788,
    788786,
    789788,
    978779,
    898988,
    888788,
    877888,
    676797,
    888778,
    898888,
    869878,
    788987,
    678877,
    879997,
    986977,
    988778,
    887688,
    886787,
    989879,
    879878,
    779778,
    886887,
    668879,
    789966,
    898877,
    997978,
    998889,
    888687,
    987888,
    779987,
    776687,
    779798,
    977977,
    878978,
    877778,
    879889,
    888789,
    698689,
    878988,
    978778,
    899777,
    877999,
    788877,
    897887,
    797889,
    888878,
    878887,
    977689,
    778777,
    969888,
    878887,
    777697,
    677878,
    869787,
    788888,
    778888,
    978898,
    888878,
    768877,
    889877,
    779877,
    867788,
    988878,
    777888,
    988888,
    688897,
    778998,
    786888,
    687788,
    989888,
    987877,
    689878,
    876868,
    887878,
    888668,
    888987,
    877696,
    988798,
    987989,
    877798,
    777779,
    987888,
    768898,
    988997,
    887798,
    877887,
    798889,
    866678,
    788778,
    778788,
    887789,
    877698,
    787888,
    887888,
    887898,
    867788,
    888968,
    886877,
    888879,
    778988,
    878786,
    877988,
    987888,
    899778,
    678977,
    787888,
    998779,
    987867,
    999877,
    789897,
    779987,
    999798,
    789788,
    888798,
    887887,
    788869,
    778779,
    888886,
    898988,
    789777,
    878787,
    768789,
    886887,
    878878,
    998879,
    787767,
    776797,
    798767,
    978877,
    887898,
    668798,
    868866,
    997878,
    789878,
    888977,
    777877,
    988799,
    798977,
    888878,
    777897,
    777888,
    887978,
    978797,
    787789,
    888989,
    777889,
    888888,
    688788,
    978868,
    798889,
    987988,
    887898,
    988867,
    968887,
    986878,
    786877,
    776788,
    688977,
    777897,
    888797,
    888889,
    787878,
    687889,
    897799,
    886787,
    887899,
    779878,
    798779,
    898778,
    898889,
    897897,
    787769,
    698887,
    967797,
    779898,
    887887,
    789987,
    779776,
    787788,
    778788,
    678998,
    898998,
    978798,
    788878,
    667897,
    878799,
    898986,
    877678,
    887788,
    888697,
    788789,
    797887,
    868677,
    788797,
    788778,
    797987,
    797779,
    698887,
    789787,
    989988,
    778797,
    888978,
    898979,
    886789,
    887899,
    898797,
    789987,
    787887,
    968788,
    888887,
    987697,
    779968,
    868668,
    876777,
    778897,
    898988,
    888978,
    799788,
    888876,
    677777,
    779898,
    887878,
    768878,
    787878,
    877887,
    887798,
    777978,
    899797,
    798989,
    798898,
    887788,
    887779,
    778898,
    988888,
    878999,
    787898,
    797879,
    978696,
    787987,
    796877,
    888879,
    999778,
    877979,
    779788,
    888869,
    797677,
    988768,
    888978,
    689778,
    887789,
    988998,
    788789,
    768967,
    687988,
    778887,
    767797,
    889878,
    976697,
    878787,
    889878,
    889887,
    877887,
    898898,
    778979,
    788788,
    867778,
    799688,
    789988,
    867697,
    786979,
    799888,
    867988,
    988878,
    789787,
    979977,
    678899,
    997888,
    889889,
    988988,
    997779,
    779787,
    778689,
    887788,
    789886,
    787888,
    996798,
    986978,
    878798,
    778977,
    989877,
    798788,
    786887,
    888776,
    788988,
    989887,
    888878,
    887787,
    897699,
    888898,
    877987,
    886986,
    887989,
    867887,
    987897,
    888879,
    778898,
    777779,
    778887,
    787798,
    978888,
    989888,
    788878,
    879877,
    699888,
    878887,
    878877,
    787877,
    898978,
    986777,
    886999,
    979688,
    896889,
    978779,
    786779,
    897879,
    788896,
    877899,
    977989,
    886877,
    867787,
    888879,
    876878,
    879889,
    989877,
    878887,
    888876,
    687876,
    688898,
    787987,
    897786,
    998788,
    778988,
    888988,
    878988,
    788898,
    899877,
    787889,
    888888,
    788788,
    887976,
    789887,
    878777,
    778986,
    798887,
    877868,
    788977,
    898769,
    686988,
    796878,
    878887,
    788799,
    878998,
    896998,
    987877,
    888768,
    888889,
    799777,
    698898,
    888887,
    889886,
    668798,
    688688,
    778998,
    879776,
    786989,
    879887,
    987978,
    887777,
    887777,
    878889,
    879978,
    968887,
    879787,
    777877,
    887787,
    789788,
    778678,
    988979,
    786869,
    888898,
    888887,
    687887,
    879989,
    787877,
    988888,
    877997,
    797998,
    888879,
    889987,
    997788,
    877899,
    778768,
    798878,
    778888,
    968878,
    889897,
    898797,
    878787,
    788998,
    877889,
    788888,
    877788,
    769887,
    898788,
    878786,
    888877,
    697777,
    878789,
    778788,
    886877,
    887877,
    888877,
    877879,
    888797,
    899898,
    879769,
    878779,
    976886,
    878789,
    886778,
    688868,
    897777,
    778788,
    887797,
    887778,
    889998,
    777888,
    788998,
    877897,
    979897,
    697887,
    898887,
    879788,
    996869,
    788778,
    879787,
    688697,
    997788,
    867988,
    887798,
    779997,
    788786,
    879979,
    887897,
    789877,
    786997,
    778887,
    888878,
    868879,
    688887,
    877998,
    878789,
    897798,
    877987,
    978879,
    768788,
    987788,
    998977,
    787889,
    779788,
    997877,
    888897,
    777988,
    898889,
    998877,
    799898,
    878687,
    798787,
    797889,
    897889,
    887697,
    796776,
    877797,
    788899,
    788778,
    689998,
    898777,
    887878,
    979688,
    778777,
    789878,
    877887,
    878997,
    997988,
    788888,
    778876,
    788876,
    878878,
    797888,
    898878,
    779988,
    788877,
    887987,
    896778,
    987888,
    788988,
    787887,
    989997,
    888878,
    799788,
    888889,
    899878,
    786788,
    896786,
    698878,
    898897,
    887878,
    888877,
    879888,
    878789,
    888898,
    778887,
    877777,
    779886,
    787898,
    876978,
    778877,
    787898,
    887878,
    898787,
    887788,
    689988,
    898988,
    789988,
    899878,
    998987,
    888868,
    798789,
    889988,
    978878,
    679777,
    878877,
    788889,
    988977,
    887789,
    989889,
    778889,
    889687,
    786688,
    689898,
    788888,
    887876,
    889889,
    778787,
    787789,
    887777,
    979777,
    878679,
    788868,
    978778,
    778988,
    878878,
    898887,
    787779,
    989799,
    777898,
    797689,
    877788,
    898878,
    798987,
    877888,
    869678,
    797678,
    878888,
    888886,
    778898,
    977887,
    889898,
    888897,
    898878,
    786878,
    789878,
    697778,
    687967,
    968888,
    997978,
    878887,
    887898,
    887888,
    787798,
    897887,
    777798,
    988788,
    788798,
    876698,
    977679,
    888798,
    788878,
    788786,
    778778,
    898788,
    878879,
    879889,
    997997,
    889789,
    889968,
    897878,
    787998,
    879887,
    778788,
    877777,
    777767,
    877888,
    867887,
    789889,
    888679,
    999777,
    788888,
    777987,
    979876,
    988698,
    778887,
    888788,
    987898,
    999887,
    889888,
    877878,
    797787,
    887877,
    797798,
    898987,
    686777,
    778889,
    877798,
    788887,
    778887,
    878778,
    898798,
    898898,
    896887,
    789978,
    778787,
    998888,
    789768,
    797797,
    798878,
    788999,
    888889,
    987889,
    996788,
    866977,
    779987,
    788978,
    696777,
    778969,
    787688,
    689868,
    888779,
    768868,
    787987,
    788778,
    878788,
    688878,
    988896,
    967768,
    978689,
    887787,
    778877,
    878787,
    889889,
    897777,
    877987,
    889978,
    889987,
    888799,
    776887,
    987878,
    887877,
    877798,
    787887,
    987868,
    778889,
    879877,
    698788,
    789888,
    877887,
    787968,
    698887,
    886798,
    967888,
    879897,
    668978,
    899788,
    878879,
    889789,
    879999,
    897798,
    679888,
    897778,
    867788,
    879867,
    899788,
    687779,
    868899,
    798988,
    679786,
    878878,
    878797,
    988687,
    797888,
    878988,
    989997,
    687888,
    989788,
    787887,
    898988,
    888886,
    869787,
    877787,
    899988,
    898878,
    787798,
    886977,
    888779,
    798797,
    977976,
    897898,
    878677,
    888797,
    778898,
    896888,
    888777,
    888868,
    978766,
    787678,
    889879,
    798798,
    878987,
    898779,
    977868,
    998978,
    869897,
    797978,
    898769,
    778698,
    887868,
    978998,
    788787,
    878678,
    989788,
    876978,
    688788,
    888879,
    968887,
    878896,
    778896,
    898987,
    888979,
    776778,
    687988,
    898867,
    877998,
    888797,
    897879,
    779978,
    778898,
    987999,
    877887,
    877879,
    798989,
    799977,
    887789,
    887977,
    887788,
    798888,
    798879,
    987776,
    889979,
    697889,
    979888,
    879788,
    787898,
    987767,
    987988,
    878799,
    888789,
    869877,
    898879,
    687887,
    978778,
    888688,
    988789,
    879868,
    679799,
    789879,
    879888,
    787869,
    878777,
    879777,
    877889,
    898787,
    897989,
    888768,
    899887,
    878878,
    978887,
    878769,
    978998,
    988977,
    878887,
    787778,
    878888,
    897787,
    897778,
    987999,
    888898,
    788788,
    877787,
    878788,
    879789,
    899966,
    896798,
    878978,
    777898,
    789869,
    877787,
    979996,
    979898,
    889888,
    876996,
    879876,
    988888,
    878997,
    878788,
    778887,
    877887,
    789888,
    886976,
    876888,
    898876,
    888888,
    888777,
    798679,
    686988,
    676799,
    877977,
    688988,
    896897,
    778798,
    988989,
    788887,
    777788,
    878976,
    689879,
    879698,
    888867,
    898977,
    999879,
    998788,
    786796,
    679968,
    788898,
    688987,
    897898,
    887989,
    887977,
    879887,
    897887,
    887787,
    889889,
    787787,
    988877,
    777787,
    778967,
    987978,
    898879,
    788878,
    777989,
    988999,
    776889,
    987879,
    878877,
    877678,
    987877,
    888989,
    977767,
    978778,
    878867,
    788889,
    867878,
    897777,
    898989,
    777997,
    979887,
    989786,
    788887,
    778899,
    878786,
    887789,
    878777,
    878788,
    999887,
    788999,
    888879,
    887977,
    776778,
    887768,
    978879,
    778988,
    897798,
    797887,
    699788,
    978988,
    987678,
    777997,
    898887,
    988768,
    787987,
    867788,
    867878,
    798687,
    798878,
    998777,
    677778,
    898988,
    887876,
    777877,
    888889,
    678989,
    888877,
    789778,
    887889,
    897788,
    888879,
    778897,
    987777,
    878779,
    798888,
    897989,
    878887,
    788678,
    878888,
    687788,
    778977,
    788787,
    887768,
    988988,
    887788,
    778787,
    988988,
    877988,
    888878,
    977887,
    778887,
    687788,
    899899,
    876787,
    977887,
    776788,
    898876,
    787777,
    787888,
    787888,
    797888,
    888678,
    888967,
    867887,
    888697,
    798798,
    778778,
    787888,
    887786,
    798788,
    979997,
    888998,
    799978,
    787789,
    778766,
    977876,
    988888,
    798987,
    797877,
    888788,
    888697,
    787779,
    988868,
    788888,
    888978,
    787776,
    977999,
    788777,
    889877,
    888689,
    867787,
    899897,
    788778,
    778879,
    988978,
    897866,
    779897,
    879778,
    986778,
    999878,
    767899,
    887987,
    887878,
    888686,
    888778,
    989699,
    978778,
    789776,
    888898,
    998876,
    878998,
    878868,
    987887,
    888867,
    899878,
    998799,
    887888,
    867867,
    688989,
    787898,
    888788,
    786777,
    888887,
    997697,
    866868,
    877888,
    787787,
    887989,
    789898,
    999899,
    777778,
    797997,
    888899,
    888889,
    887677,
    777779,
    797877,
    886887,
    878978,
    877877,
    779987,
    799887,
    887777,
    997977,
    877877,
    998988,
    878768,
    877897,
    777897,
    889977,
    889788,
    868698,
    788998,
    877788,
    899789,
    788888,
    797879,
    788879,
    888897,
    887887,
    678996,
    788777,
    677888,
    889998,
    889877,
    789898,
    778779,
    687877,
    767778,
    987877,
    778977,
    887789,
    898798,
    998978,
    999877,
    878877,
    788888,
    788778,
    789877,
    788899,
    978779,
    768898,
    688899,
    988978,
    677887,
    878798,
    899989,
    678889,
    877778,
    998778,
    877788,
    887978,
    788897,
    778888,
    888897,
    978897,
    778887,
    789787,
    887877,
    888789,
    798788,
    788888,
    977678,
    877878,
    878686,
    777878,
    788778,
    998989,
    997878,
    688768,
    887897,
    987997,
    787898,
    887878,
    879777,
    977967,
    878779,
    878988,
    978978,
    877998,
    687788,
    897787,
    798897,
    899868,
    878799,
    878888,
    878866,
    978978,
    879897,
    888888,
    888778,
    778989,
    978878,
    878787,
    789787,
    998779,
    767878,
    878887,
    789897,
    998877,
    787879,
    877889,
    989888,
    988787,
    787769,
    687788,
    787877,
    878897,
    887887,
    888879,
    888789,
    897777,
    969988,
    786788,
    978888,
    769787,
    998777,
    768768,
    787889,
    988798,
    889878,
    768888,
    977879,
    698898,
    898787,
    987787,
    878777,
    879898,
    889787,
    889879,
    798888,
    898998,
    898989,
    698777,
    678866,
    988999,
    789897,
    898887,
    979887,
    896878,
    777968,
    787776,
    887877,
    889899,
    868867,
    896879,
    787879,
    888997,
    888787,
    876788,
    799888,
    978778,
    898788,
    789788,
    788779,
    788887,
    789898,
    888787,
    796778,
    788889,
    689778,
    887888,
    898788,
    888798,
    788688,
    987898,
    787777,
    789976,
    897888,
    788898,
    687996,
    687788,
    887798,
    888889,
    879887,
    787787,
    888778,
    977968,
    989788,
    988888,
    779997,
    977778,
    788888,
    879787,
    777887,
    778889,
    878797,
    779877,
    878789,
    978888,
    798887,
    887877,
    778887,
    987896,
    887888,
    989888,
    887878,
    878889,
    996876,
    898878,
    788778,
    798979,
    989788,
    979878,
    698978,
    777988,
    897967,
    887877,
    979878,
    888698,
    777888,
    979677,
    777777,
    979889,
    897979,
    788888,
    778989,
    888887,
    877998,
    887798,
    777876,
    987997,
    898788,
    786898,
    888898,
    868788,
    779787,
    876898,
    798977,
    977779,
    786988,
    798688,
    988888,
    787876,
    877998,
    787979,
    787788,
    988988,
    667877,
    787897,
    777879,
    697777,
    866787,
    888779,
    898998,
    778698,
    888779,
    998779,
    888768,
    698897,
    789887,
    788888,
    789978,
    997789,
    878897,
    988689,
    779798,
    977879,
    798897,
    878778,
    766777,
    877897,
    888777,
    776878,
    777697,
    778988,
    978988,
    788987,
    987888,
    798678,
    788788,
    776799,
    979677,
    989768,
    888898,
    788898,
    878787,
    778888,
    768887,
    777976,
    877877,
    887777,
    989788,
    897787,
    778788,
    978767,
    796897,
    976787,
    897778,
    897888,
    877787,
    679687,
    878888,
    877798,
    887777,
    878989,
    998898,
    869989,
    888788,
    998888,
    997988,
    788888,
    977777,
    897886,
    797699,
    677777,
    689689,
    777787,
    878788,
    799777,
    987888,
    798776,
    877897,
    887777,
    798877,
    798676,
    788667,
    886778,
    878879,
    899667,
    678877,
    978788,
    879888,
    889986,
    788898,
    997877,
    888987,
    879898,
    678878,
    788787,
    778689,
    787898,
    989899,
    866799,
    788778,
    887898,
    996799,
    777886,
    898867,
    788688,
    988887,
    889879,
    788799,
    776779,
    877888,
    787697,
    888989,
    799777,
    989798,
    889688,
    996898,
    969786,
    987988,
    878886,
    998789,
    897878,
    798877,
    888898,
    978899,
    769877,
    788778,
    977888,
    767888,
    978687,
    787786,
    878777,
    777978,
    868998,
    798987,
    787787,
    877898,
    686987,
    988988,
    898886,
    869877,
    778989,
    888769,
    867779,
    978788,
    688867,
    899787,
    778768,
    979799,
    886878,
    799889,
    777989,
    788878,
    986787,
    888788,
    689776,
    787789,
    988897,
    687787,
    798977,
    788898,
    878778,
    878987,
    878887,
    999986,
    798688,
    877977,
    788897,
    878799,
    897876,
    689997,
    889877,
    878888,
    888877,
    878777,
    898887,
    998878,
    777879,
    878888,
    778888,
    778879,
    788977,
    786978,
    977877,
    867889,
    997878,
    768787,
    889778,
    878887,
    897898,
    878787,
    998778,
    798787,
    786799,
    777888,
    878989,
    799788,
    888888,
    776887,
    769778,
    988887,
    788977,
    887977,
    999867,
    777769,
    688778,
    978887,
    689777,
    889898,
    978879,
    796899,
    896888,
    878889,
    887877,
    969766,
    989777,
    677979,
    777877,
    796868,
    887776,
    877888,
    997889,
    989977,
    787788,
    777886,
    777798,
    796788,
    777767,
    898687,
    986976,
    787898,
    788798,
    988989,
    878778,
    767788,
    786887,
    987768,
    877888,
    777777,
    888798,
    778799,
    789778,
    889988,
    887978,
    988777,
    788778,
    988798,
    889668,
    878888,
    979778,
    888779,
    888878,
    977988,
    688689,
    877899,
    779969,
    979788,
    778788,
    878797,
    778787,
    798788,
    887887,
    888877,
    888897,
    788787,
    787789,
    898878,
    778888,
    897677,
    978777,
    789777,
    899677,
    888767,
    888898,
    796876,
    767869,
    797987,
    897898,
    978988,
    877768,
    877876,
    987786,
    888788,
    869888,
    788888,
    986867,
    789689,
    889788,
    887867,
    877797,
    799789,
    888787,
    788798,
    879788,
    879888,
    887888,
    879978,
    799887,
    888888,
    686888,
    776798,
    888888,
    888789,
    778779,
    888988,
    798879,
    799798,
    989997,
    777887,
    889978,
    878778,
    987898,
    979868,
    998778,
    789888,
    889887,
    888786,
    888988,
    778777,
    887987,
    787788,
    888888,
    898788,
    996889,
    777888,
    878977,
    777786,
    787998,
    879888,
    888889,
    897977,
    887998,
    897786,
    876789,
    887888,
    789877,
    888798,
    688897,
    887878,
    777787,
    986798,
    769779,
    788876,
    899878,
    878878,
    768868,
    788879,
    877788,
    888788,
    989777,
    877877,
    888966,
    898877,
    878879,
    887778,
    777889,
    787778,
    787789,
    899889,
    769778,
    878987,
    887868,
    777878,
    797669,
    888788,
    887898,
    888786,
    889899,
    776797,
    878898,
    787978,
    787789,
    887787,
    799889,
    867698,
    868878,
    978998,
    787878,
    988887,
    779687,
    878899,
    978779,
    898797,
    998887,
    878889,
    888797,
    897679,
    878798,
    999996,
    878886,
    797787,
    897988,
    878888,
    996786,
    887688,
    877888,
    778877,
    878889,
    786977,
    888879,
    678976,
    788798,
    898889,
    788777,
    777777,
    796788,
    889778,
    687787,
    997788,
    897697,
    787788,
    787678,
    878989,
    698787,
    788997,
    887788,
    889989,
    998788,
    888796,
    778979,
    898878,
    878989,
    999877,
    768787,
    878779,
    887786,
    899978,
    977799,
    886899,
    998797,
    899988,
    888878,
    678998,
    968968,
    788767,
    878878,
    779879,
    787787,
    788777,
    978887,
    889979,
    988888,
    687878,
    888878,
    696797,
    789887,
    887978,
    987897,
    978878,
    798877,
    878789,
    877977,
    678787,
    889987,
    889689,
    998977,
    877877,
    687888,
    978778,
    898897,
    867787,
    777889,
    889998,
    888787,
    778778,
    876788,
    987789,
    786797,
    889988,
    986787,
    789887,
    878887,
    798988,
    769977,
    977768,
    987898,
    978899,
    877787,
    887887,
    679878,
    878976,
    979788,
    879977,
    777979,
    898767,
    777788,
    778989,
    788897,
    788689,
    876887,
    786678,
    988898,
    977769,
    989878,
    879898,
    787878,
    787788,
    899967,
    787878,
    887777,
    876788,
    868877,
    969788,
    987878,
    787798,
    877787,
    888898,
    797868,
    879898,
    777979,
    988888,
    877878,
    797888,
    988888,
    889888,
    799789,
    789887,
    878777,
    789897,
    778778,
    899887,
    798779,
    778796,
    799798,
    889968,
    988689,
    896689,
    678999,
    789999,
    796987,
    887898,
    767778,
    698798,
    778787,
    879987,
    899897,
    888878,
    978687,
    869697,
    767788,
    888778,
    978878,
    777886,
    869878,
    888977,
    877868,
    687778,
    878888,
    889977,
    977888,
    787896,
    898889,
    777778,
    788878,
    786877,
    979879,
    879788,
    789887,
    987899,
    987979,
    777987,
    879888,
    878969,
    787778,
    788878,
    988789,
    997789,
    888788,
    987787,
    988776,
    898978,
    987687,
    866778,
    778778,
    888797,
    976879,
    777888,
    888888,
    788688,
    789897,
    997888,
    768678,
    897887,
    679887,
    899988,
    889688,
    789877,
    788898,
    787877,
    778777,
    987987,
    877798,
    967886,
    889788,
    888879,
    988778,
    888878,
    878689,
    789788,
    878878,
    988886,
    897887,
    977887,
    878868,
    877888,
    889988,
    768878,
    787788,
    997897,
    968889,
    979879,
    887878,
    888979,
    868898,
    799898,
    878988,
    887667,
    796888,
    878878,
    878777,
    799679,
    889889,
    767686,
    899886,
    876888,
    787878,
    787777,
    798899,
    777778,
    888887,
    788678,
    887989,
    887778,
    769776,
    888978,
    677887,
    877879,
    988998,
    888868,
    788878,
    997788,
    787887,
    779889,
    878779,
    898967,
    988798,
    776896,
    997866,
    898879,
    869688,
    978977,
    968897,
    799878,
    888769,
    887887,
    978788,
    997788,
    876888,
    789787,
    997679,
    877888,
    989787,
    899889,
    978889,
    876878,
    889888,
    889978,
    868788,
    978777,
    788687,
    878989,
    999878,
    897988,
    786879,
    777878,
    778897,
    899898,
    887787,
    878798,
    777878,
    887898,
    677889,
    987879,
    868878,
    887886,
    679867,
    897798,
    978889,
    987888,
    987787,
    687898,
    689798,
    898989,
    777998,
    898989,
    889698,
    788878,
    987897,
    777778,
    687789,
    968787,
    968777,
    786877,
    789789,
    777989,
    778778,
    887898,
    988887,
    878686,
    877778,
    878989,
    888789,
    787888,
    979767,
    776867,
    887778,
    878887,
    899888,
    888789,
    889978,
    767899,
    886877,
    879886,
    778878,
    878979,
    888877,
    888778,
    878789,
    887988,
    888888,
    798787,
    898976,
    989778,
    798978,
    789798,
    687989,
    987786,
    976867,
    889788,
    869787,
    897977,
    869786,
    986788,
    877787,
    776988,
    868799,
    986878,
    998768,
    996776,
    777798,
    787877,
    889888,
    897779,
    897978,
    778977,
    878969,
    888889,
    988888,
    777789,
    798997,
    979996,
    878787,
    799878,
    967999,
    797887,
    777897,
    869777,
    879689,
    778777,
    788978,
    887777,
    768877,
    878977,
    997687,
    887788,
    999677,
    898789,
    877788,
    788987,
    978686,
    776887,
    998878,
    978788,
    887997,
    797888,
    688788,
    798997,
    988888,
    788788,
    878877,
    897797,
    787897,
    997897,
    777786,
    778967,
    787798,
    888777,
    878687,
    686876,
    877887,
    798978,
    988878,
    997987,
    878878,
    878677,
    899988,
    888887,
    787678,
    989887,
    698888,
    887978,
    788687,
    889978,
    979888,
    786888,
    878967,
    899887,
    967877,
    967878,
    887989,
    787888,
    987789,
    977878,
    887877,
    789879,
    879778,
    798898,
    777788,
    687999,
    878886,
    878799,
    878788,
    779788,
    988798,
    778777,
    896888,
    789876,
    968988,
    887798,
    998988,
    879888,
    788898,
    869777,
    787777,
    977877,
    868899,
    787987,
    797988,
    887877,
    887778,
    889988,
    798878,
    788778,
    789878,
    886789,
    797797,
    887787,
    888798,
    898889,
    879889,
    898878,
    788777,
    889778,
    967867,
    887976,
    779887,
    777878,
    787878,
    899787,
    887788,
    888778,
    898979,
    877978,
    887887,
    877877,
    886779,
    889789,
    768978,
    878878,
    788988,
    898777,
    767978,
    789778,
    799978,
    989989,
    778888,
    899778,
    888799,
    689789,
    889797,
    898879,
    888877,
    979897,
    977798,
    868798,
    889888,
    897889,
    877886,
    888868,
    878897,
    998899,
    979788,
    978898,
    788787,
    899769,
    788787,
    867899,
    877798,
    887867,
    788886,
    787777,
    688878,
    789777,
    898888,
    788868,
    788767,
    898788,
    788898,
    887998,
    899988,
    887888,
    698888,
    988888,
    768888,
    987878,
    878777,
    877788,
    667768,
    887887,
    988869,
    789877,
    789689,
    688788,
    686797,
    787777,
    779889,
    788887,
    798788,
    887787,
    888789,
    877897,
    969887,
    687787,
    788668,
    989877,
    788887,
    888798,
    899789,
    879666,
    777777,
    777889,
    888777,
    979879,
    787877,
    887897,
    798797,
    999888,
    777878,
    786777,
    787778,
    777798,
    878797,
    879787,
    999888,
    789989,
    887778,
    798788,
    778798,
    889967,
    987778,
    767878,
    867898,
    979888,
    868778,
    788898,
    788888,
    987787,
    789977,
    777788,
    787888,
    977798,
    777967,
    788887,
    777789,
    779789,
    998988,
    887789,
    888767,
    898897,
    989889,
    866796,
    787778,
    787878,
    897877,
    888988,
    986988,
    887899,
    887878,
    888897,
    888667,
    879988,
    777798,
    977987,
    788787,
    876697,
    778877,
    887888,
    898888,
    976898,
    879898,
    988887,
    687898,
    978887,
    899867,
    797877,
    797877,
    979789,
    797989,
    796898,
    788787,
    778796,
    976878,
    887877,
    888788,
    778977,
    887877,
    889988,
    787877,
    987688,
    899998,
    887879,
    678778,
    769679,
    989977,
    777696,
    987997,
    777878,
    887988,
    888889,
    788877,
    968776,
    987677,
    878799,
    878788,
    798988,
    789787,
    899977,
    888888,
    798787,
    867888,
    776678,
    897777,
    887798,
    899798,
    698789,
    788788,
    988799,
    769866,
    878687,
    798878,
    878889,
    888777,
    787978,
    877886,
    778887,
    997888,
    888898,
    878977,
    678887,
    889879,
    688787,
    879887,
    887998,
    897888,
    989877,
    878787,
    878976,
    797889,
    886888,
    887878,
    888878,
    998889,
    978677,
    666988,
    988996,
    877779,
    778796,
    799997,
    887989,
    889888,
    978789,
    786798,
    997678,
    987869,
    779888,
    879997,
    888878,
    778889,
    888899,
    978989,
    878888,
    989887,
    877798,
    897777,
    888778,
    977899,
    669886,
    787787,
    798998,
    798777,
    887789,
    678779,
    779778,
    888787,
    889787,
    876878,
    879798,
    877789,
    896887,
    878889,
    779987,
    777987,
    987689,
    798678,
    896868,
    977888,
    888889,
    776897,
    987888,
    978768,
    889888,
    868789,
    888787,
    878876,
    888886,
    778887,
    797888,
    699887,
    877687,
    787876,
    867878,
    979888,
    879876,
    878887,
    778888,
    789878,
    797989,
    778886,
    888888,
    777887,
    876987,
    978987,
    787768,
    869787,
    777888,
    788788,
    889777,
    768778,
    886887,
    878687,
    887888,
    678878,
    787787,
    779688,
    986789,
    677888,
    798799,
    877778,
    868978,
    887887,
    789888,
    989876,
    878888,
    878988,
    788887,
    976879,
    877988,
    787787,
    889877,
    977888,
    988898,
    687887,
    688688,
    897787,
    788887,
    877778,
    787878,
    898878,
    969788,
    967899,
    886887,
    679997,
    789788,
    688799,
    978878,
    786878,
    778888,
    888787,
    798888,
    888878,
    788888,
    878677,
    767998,
    788897,
    776898,
    799796,
    786799,
    786788,
    767897,
    796887,
    887888,
    677777,
    888887,
    786878,
    787988,
    878679,
    978777,
    899999,
    878787,
    777988,
    778789,
    878978,
    789887,
    897888,
    987789,
    898898,
    678977,
    788687,
    777688,
    899778,
    787789,
    686877,
    897687,
    788898,
    777898,
    888887,
    888978,
    986878,
    878978,
    877789,
    877788,
    987898,
    788977,
    886789,
    887978,
    788789,
    888889,
    788898,
    799967,
    778887,
    877877,
    776789,
    878888,
    888887,
    988899,
    878876,
    898788,
    987888,
    979887,
    789798,
    888887,
    978878,
    877988,
    798898,
    788889,
    889778,
    789888,
    778779,
    888677,
    877687,
    977787,
    797787,
    889989,
    799778,
    897999,
    787867,
    889778,
    687697,
    788779,
    877887,
    999688,
    887877,
    879787,
    677789,
    778788,
    898777,
    887898,
    978878,
    898886,
    788898,
    887797,
    867878,
    798978,
    977688,
    969878,
    788978,
    779868,
    789779,
    977888,
    898979,
    899776,
    777888,
    887978,
    877878,
    678879,
    876887,
    988978,
    887999,
    988878,
    788887,
    987988,
    878787,
    888877,
    786887,
    886876,
    898986,
    887988,
    787997,
    889978,
    778779,
    879796,
    788777,
    887777,
    888768,
    998778,
    797888,
    888787,
    878887,
    687888,
    899988,
    879778,
    788887,
    878787,
    887789,
    789796,
    788989,
    679878,
    888877,
    797988,
    979888,
    997879,
    779799,
    899887,
    899678,
    888688,
    787778,
    878887,
    767788,
    777787,
    789978,
    787799,
    997797,
    889777,
    787788,
    788978,
    977877,
    789877,
    779867,
    886867,
    897897,
    888988,
    798787,
    798988,
    897998,
    767678,
    787687,
    777978,
    876777,
    997987,
    788879,
    888896,
    879976,
    899668,
    888887,
    788787,
    787788,
    689787,
    789888,
    998877,
    998868,
    778978,
    788878,
    767987,
    887789,
    987876,
    987979,
    999888,
    787788,
    766978,
    988887,
    787877,
    989777,
    888868,
    787698,
    777777,
    997789,
    787788,
    867988,
    898887,
    687987,
    877877,
    789888,
    679876,
    888887,
    878888,
    987788,
    867778,
    987877,
    898976,
    887988,
    787988,
    778977,
    987988,
    888798,
    896897,
    988788,
    799867,
    868988,
    677878,
    997777,
    788688,
    888787,
    886887,
    978888,
    787778,
    879877,
    878999,
    987777,
    897876,
    897789,
    887999,
    877898,
    987987,
    787688,
    878898,
    888877,
    988797,
    986888,
    879787,
    888988,
    867988,
    977868,
    788887,
    677887,
    888788,
    787886,
    879797,
    887887,
    788789,
    867978,
    778686,
    989888,
    898878,
    789887,
    887988,
    889988,
    886787,
    888978,
    778797,
    899878,
    868768,
    878778,
    977986,
    797778,
    877878,
    889887,
    889787,
    889898,
    787887,
    788888,
    787688,
    889898,
    877879,
    887698,
    799988,
    897987,
    788897,
    887998,
    688887,
    889788,
    899778,
    777787,
    788877,
    778676,
    987877,
    869888,
    797888,
    878877,
    886969,
    987888,
    777878,
    787877,
    789877,
    878997,
    776998,
    889888,
    879878,
    777877,
    889879,
    889898,
    997778,
    778787,
    788768,
    898888,
    889887,
    687887,
    998778,
    799888,
    989867,
    778889,
    988979,
    989768,
    687787,
    778898,
    889678,
    789888,
    777788,
    777777,
    977878,
    787878,
    989878,
    878897,
    676888,
    889978,
    998877,
    887887,
    777889,
    768778,
    887977,
    786879,
    879877,
    798876,
    888789,
    887877,
    987898,
    988986,
    888876,
    779788,
    889779,
    779878,
    787877,
    997888,
    988787,
    887888,
    797888,
    978779,
    969988,
    878989,
    878868,
    887878,
    879988,
    787887,
    977878,
    
    

];
